webpackJsonp([117],Array(30).concat([
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getCurrentLocaleOnInit;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return i18nLocale; });
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeLocaleMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isbot__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_locales__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cookies_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__ = __webpack_require__(47);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(559));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a, { expire: '7d' });

var navigatorLanguage = (navigator.language || navigator.userLanguage).split('-')[0].toLowerCase();

function normalizeLocale(locale) {
	return __WEBPACK_IMPORTED_MODULE_4__constants_locales__["e" /* SUPPORTED_LOCALES */].includes(locale) ? locale : __WEBPACK_IMPORTED_MODULE_4__constants_locales__["a" /* EN_LOCALE */];
}

function defaultLanguage() {
	return navigatorLanguage === __WEBPACK_IMPORTED_MODULE_4__constants_locales__["b" /* ES_LOCALE */] ? window.location.hostname.includes('opensalud.mx') ? __WEBPACK_IMPORTED_MODULE_4__constants_locales__["c" /* MX_LOCALE */] : __WEBPACK_IMPORTED_MODULE_4__constants_locales__["b" /* ES_LOCALE */] : normalizeLocale(navigatorLanguage);
}

function getRawLocale() {
	// Get locale from URI
	var locale = window.location.pathname.split('/')[1];
	// If locale is not valid, get default locale
	if (!__WEBPACK_IMPORTED_MODULE_4__constants_locales__["e" /* SUPPORTED_LOCALES */].includes(locale)) {
		locale = defaultLanguage();
	}
	return locale;
}

function normalizeLangpref(langpref) {
	if (!langpref) {
		return null;
	} else {
		return langpref.match(__WEBPACK_IMPORTED_MODULE_5__helpers_cookies_helpers__["a" /* LANG_PREF_REGEX */]) ? langpref.replace('%2F', '/') : null;
	}
}

function getCurrentLocaleOnInit() {
	var params = new Proxy(new URLSearchParams(window.location.search), {
		get: function get(searchParams, prop) {
			return searchParams.get(prop);
		}
	});
	var langPrefQueryParam = params.langpref ? params.langpref.match(__WEBPACK_IMPORTED_MODULE_5__helpers_cookies_helpers__["a" /* LANG_PREF_REGEX */]) : null;
	var langprefCookie = langPrefQueryParam ? langPrefQueryParam[1] + '/' + langPrefQueryParam[2] : normalizeLangpref(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cookies_helpers__["b" /* getCookie */])('langpref'));
	if (!langprefCookie) {
		langprefCookie = __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["a" /* country */] + '/' + defaultLanguage();
	}
	Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cookies_helpers__["d" /* saveLangPrefCookie */])(langprefCookie);
	return langprefCookie != null ? langprefCookie.split('/')[1] : defaultLanguage();
}

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
	locale: Object(__WEBPACK_IMPORTED_MODULE_3_isbot__["a" /* default */])(navigator.userAgent) ? getRawLocale() : getCurrentLocaleOnInit() || __WEBPACK_IMPORTED_MODULE_4__constants_locales__["a" /* EN_LOCALE */],
	fallbackLocale: __WEBPACK_IMPORTED_MODULE_4__constants_locales__["b" /* ES_LOCALE */]
});

var i18nLocale = i18n.locale;
function mergeLocaleMessage(locale, message) {
	i18n.mergeLocaleMessage(locale, message);
}

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BLUE_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GRAY_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GRAY_400_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RED_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return WHITE_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GREEN_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return YELLOW_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ORANGE_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BLUE_UNIPROMEL_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACKGROUND_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BLACK_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ORANGE_MID_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GREEN_LIGHT_COLOUR; });
/* harmony export (immutable) */ __webpack_exports__["o"] = getPrimaryColour;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(200);


var BLUE_COLOUR = '#3238C4';
var GRAY_COLOUR = '#8A8A8A';
var GRAY_400_COLOUR = '#979797';
var RED_COLOUR = '#FF7061';
var WHITE_COLOUR = '#EEEEEE';
var GREEN_COLOUR = '#6AEF89';
var YELLOW_COLOUR = '#E8F053';
var ORANGE_COLOUR = '#434B61';
var BLUE_UNIPROMEL_COLOUR = '#0A3D62';
var BACKGROUND_COLOUR = '#E4E4E4';
var BLACK_COLOUR = '#212529';
var SECONDARY = '#FFFFFF';
var ORANGE_MID_COLOUR = '#F4B05A';
var GREEN_LIGHT_COLOUR = '#A9F06E';
function getPrimaryColour() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__themes__["c" /* getThemeName */])() === __WEBPACK_IMPORTED_MODULE_0__themes__["b" /* UNIPROMEL_THEME */] ? BLUE_UNIPROMEL_COLOUR : Object(__WEBPACK_IMPORTED_MODULE_0__themes__["c" /* getThemeName */])() === __WEBPACK_IMPORTED_MODULE_0__themes__["a" /* OPENLEGAL_THEME */] ? ORANGE_COLOUR : BLUE_COLOUR;
}

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getEnvironmentName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCountry;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBaseDomain;
/* harmony export (immutable) */ __webpack_exports__["o"] = outerOpensaludMainDomain;
/* harmony export (immutable) */ __webpack_exports__["h"] = getPortal;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return environment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return inLocalEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return inDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return inStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return inProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return country; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return inEs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return inMx; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getDefaultPhonePrefix;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDefaultCountryId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environments__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_countries__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_domainExtensions__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_domains__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_domains_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_domains_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_domains_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_db_countries__ = __webpack_require__(283);










function getEnvironmentName() {
	var environment = void 0;
	if ("production" !== __WEBPACK_IMPORTED_MODULE_1__constants_environments__["c" /* PROD_ENV */]) {
		environment = Object({"PACKAGE_VERSION":"022025"}).LOCAL_ENVIRONMENT;
	} else if (__WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["h" /* DEV_KEYWORDS */].some(function (keyword) {
		return window.location.href.includes(keyword);
	})) {
		environment = __WEBPACK_IMPORTED_MODULE_1__constants_environments__["a" /* DEV_ENV */];
	} else if (__WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["p" /* TEST_KEYWORDS */].some(function (keyword) {
		return window.location.href.includes(keyword);
	})) {
		environment = __WEBPACK_IMPORTED_MODULE_1__constants_environments__["d" /* TEST_ENV */];
	} else {
		environment = __WEBPACK_IMPORTED_MODULE_1__constants_environments__["c" /* PROD_ENV */];
	}
	return environment;
}

function getCountry() {
	return window.location.href.includes(__WEBPACK_IMPORTED_MODULE_3__constants_domainExtensions__["b" /* MX_DOMAIN_EXTENSION */]) ? __WEBPACK_IMPORTED_MODULE_2__constants_countries__["c" /* MX_COUNTRY */] : __WEBPACK_IMPORTED_MODULE_2__constants_countries__["a" /* ES_COUNTRY */];
}

function getBaseDomain() {
	var host = window.location.hostname;
	var subdomains = host.split(".");
	var length = subdomains.length;

	if (length >= 2) {
		return "." + subdomains[length - 2] + "." + subdomains[length - 1];
	} else {
		return __WEBPACK_IMPORTED_MODULE_4__constants_domains__["b" /* LOCALHOST_DOMAIN */];
	}
}

function outerOpensaludMainDomain() {
	var url = window.location.href.toLowerCase();
	return url.indexOf(__WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["n" /* OPENSALUD_SUBDOMAIN */]) === -1 && url.indexOf(__WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["o" /* OPENSALUD_TEST_SUBDOMAIN */]) === -1;
}

function getPortal() {
	if (window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_4__constants_domains__["b" /* LOCALHOST_DOMAIN */])) {
		return __WEBPACK_IMPORTED_MODULE_6__static_domains_json___default.a.app.local;
	}
	var url = window.location.hostname.split('.');
	var envSubdomain = __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["h" /* DEV_KEYWORDS */].some(function (keyword) {
		return url[0].includes(keyword);
	}) ? __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["a" /* APP_DEV_SUBDOMAIN */] : __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["p" /* TEST_KEYWORDS */].some(function (keyword) {
		return url[0].includes(keyword);
	}) ? __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["c" /* APP_TEST_SUBDOMAIN */] : __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["b" /* APP_SUBDOMAIN */];
	if (window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_4__constants_domains__["f" /* OPENSALUD_DOMAIN */])) {
		var opensalud360suffix = Object(__WEBPACK_IMPORTED_MODULE_5__constants_platformNames__["k" /* inOpensalud360 */])() ? '-' + __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["m" /* OPENSALUD360_SUBDOMAIN */] : '';
		return '' + envSubdomain + opensalud360suffix + '.' + __WEBPACK_IMPORTED_MODULE_4__constants_domains__["f" /* OPENSALUD_DOMAIN */] + '.' + (url[2] ? url[2] : __WEBPACK_IMPORTED_MODULE_3__constants_domainExtensions__["a" /* ES_DOMAIN_EXTENSION */]);
	} else if (Object(__WEBPACK_IMPORTED_MODULE_5__constants_platformNames__["j" /* inOpenlegal */])()) {
		return envSubdomain + '.' + __WEBPACK_IMPORTED_MODULE_4__constants_domains__["d" /* OPENLEGAL_DOMAIN */] + '.' + (url[2] ? url[2] : __WEBPACK_IMPORTED_MODULE_3__constants_domainExtensions__["a" /* ES_DOMAIN_EXTENSION */]);
	} else if (Object(__WEBPACK_IMPORTED_MODULE_5__constants_platformNames__["i" /* inMenttum */])()) {
		return envSubdomain + '-' + __WEBPACK_IMPORTED_MODULE_0__constants_subdomains__["m" /* OPENSALUD360_SUBDOMAIN */] + '.' + __WEBPACK_IMPORTED_MODULE_4__constants_domains__["f" /* OPENSALUD_DOMAIN */] + '.' + __WEBPACK_IMPORTED_MODULE_3__constants_domainExtensions__["a" /* ES_DOMAIN_EXTENSION */];
	}
	return envSubdomain + '.' + __WEBPACK_IMPORTED_MODULE_4__constants_domains__["f" /* OPENSALUD_DOMAIN */] + '.' + (url[2] ? url[2] : __WEBPACK_IMPORTED_MODULE_3__constants_domainExtensions__["a" /* ES_DOMAIN_EXTENSION */]);
}

var environment = getEnvironmentName();

var inLocalEnv = environment === __WEBPACK_IMPORTED_MODULE_1__constants_environments__["b" /* LOCAL_ENV */];
var inDevelopmentEnv = environment === __WEBPACK_IMPORTED_MODULE_1__constants_environments__["a" /* DEV_ENV */];
var inStagingEnv = environment === __WEBPACK_IMPORTED_MODULE_1__constants_environments__["d" /* TEST_ENV */];
var inProductionEnv = environment === __WEBPACK_IMPORTED_MODULE_1__constants_environments__["c" /* PROD_ENV */];

var country = getCountry();
var inEs = window.location.href.includes(__WEBPACK_IMPORTED_MODULE_3__constants_domainExtensions__["a" /* ES_DOMAIN_EXTENSION */]) || window.location.href.includes(__WEBPACK_IMPORTED_MODULE_4__constants_domains__["c" /* MENTTUM_DOMAIN */] + '.com');
var inMx = country === __WEBPACK_IMPORTED_MODULE_2__constants_countries__["c" /* MX_COUNTRY */];

function getDefaultPhonePrefix() {
	return !inMx ? __WEBPACK_IMPORTED_MODULE_2__constants_countries__["b" /* ES_PREFIX */] : __WEBPACK_IMPORTED_MODULE_2__constants_countries__["d" /* MX_PREFIX */];
}

function getDefaultCountryId() {
	return !inMx ? __WEBPACK_IMPORTED_MODULE_7__constants_db_countries__["b" /* SPAIN_COUNTRY_ID */] : __WEBPACK_IMPORTED_MODULE_7__constants_db_countries__["a" /* MX_COUNTRY_ID */];
}

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OPENSALUD_PLATFORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OPENSALUD360_PLATFORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OPENSALUD_PROFESIONALES_PLATFORM_NAME; });
/* unused harmony export OPENSALUD_PACIENTES_PLATFORM_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRIMESALUD_PLATFORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPENLEGAL_PLATFORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABOGALITYPRO_PLATFORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNIPROMEL_PLATFORM_NAME; });
/* unused harmony export MENTTUM_PLATFORM_NAME */
/* harmony export (immutable) */ __webpack_exports__["h"] = getPlatformName;
/* unused harmony export inOpensalud */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return inOpensalud360; });
/* unused harmony export inOpensaludProfesionales */
/* unused harmony export inOpensaludPacientes */
/* unused harmony export inPrimesalud */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return inOpenlegal; });
/* unused harmony export inAbogalitypro */
/* unused harmony export inUnipromel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return inMenttum; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domains__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subdomains__ = __webpack_require__(158);



var OPENSALUD_PLATFORM_NAME = 'opensalud';
var OPENSALUD360_PLATFORM_NAME = 'opensalud360';
var OPENSALUD_PROFESIONALES_PLATFORM_NAME = 'Opensalud Profesionales';
var OPENSALUD_PACIENTES_PLATFORM_NAME = 'Opensalud Pacientes';
var PRIMESALUD_PLATFORM_NAME = 'Opensaludprime';
var OPENLEGAL_PLATFORM_NAME = 'openlegal';
var ABOGALITYPRO_PLATFORM_NAME = 'openlegal';
var UNIPROMEL_PLATFORM_NAME = 'Unipromel';
var MENTTUM_PLATFORM_NAME = 'Menttum';

function getPlatformName() {
  return window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_0__domains__["j" /* UNIPROMEL_DOMAIN */]) ? UNIPROMEL_PLATFORM_NAME : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_0__domains__["c" /* MENTTUM_DOMAIN */]) ? MENTTUM_PLATFORM_NAME : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_0__domains__["i" /* PRIMESALUD_DOMAIN */]) ? PRIMESALUD_PLATFORM_NAME : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_0__domains__["d" /* OPENLEGAL_DOMAIN */]) ? OPENLEGAL_PLATFORM_NAME : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_1__subdomains__["m" /* OPENSALUD360_SUBDOMAIN */] + '.') ? OPENSALUD360_PLATFORM_NAME : OPENSALUD_PLATFORM_NAME;
}

var inOpensalud = function inOpensalud() {
  return getPlatformName() === OPENSALUD_PLATFORM_NAME;
};
var inOpensalud360 = function inOpensalud360() {
  return getPlatformName() === OPENSALUD360_PLATFORM_NAME || getPlatformName() === MENTTUM_PLATFORM_NAME;
};
var inOpensaludProfesionales = function inOpensaludProfesionales() {
  return getPlatformName() === OPENSALUD_PROFESIONALES_PLATFORM_NAME;
};
var inOpensaludPacientes = function inOpensaludPacientes() {
  return getPlatformName() === OPENSALUD_PACIENTES_PLATFORM_NAME;
};
var inPrimesalud = function inPrimesalud() {
  return getPlatformName() === PRIMESALUD_PLATFORM_NAME;
};
var inOpenlegal = function inOpenlegal() {
  return getPlatformName() === OPENLEGAL_PLATFORM_NAME;
};
var inAbogalitypro = function inAbogalitypro() {
  return getPlatformName() === ABOGALITYPRO_PLATFORM_NAME;
};
var inUnipromel = function inUnipromel() {
  return getPlatformName() === UNIPROMEL_PLATFORM_NAME;
};
var inMenttum = function inMenttum() {
  return getPlatformName() === MENTTUM_PLATFORM_NAME;
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PUBLIC_REDUCED_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PUBLIC_REDUCED_LAYOUT_DYNAMIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PUBLIC_EXTENDED_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PUBLIC_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PUBLIC_MENU_LAYOUT; });
/* unused harmony export PUBLIC_MOBILE_MENU_LAYOUT */
/* unused harmony export BASE_LAYOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORUM_NAVBAR_LAYOUT; });
/* unused harmony export INTERNAL_REDUCED_LAYOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HEALTHY_HABITS_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PRIVATE_LAYOUT; });
/* unused harmony export PUBLIC_MENU_LAYOUT_V2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OPENSALUD_EMPRESAS_LAYOUT; });
/* unused harmony export OPENSALUD_LAYOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OPENSALUD_360_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OPENSALUD_PACIENTES_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPENSALUD_PROFESIONALES_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACK_BTN_LAYOUT; });
var PUBLIC_REDUCED_LAYOUT = 'PublicReducedLayout';
var PUBLIC_REDUCED_LAYOUT_DYNAMIC = 'PublicReducedLayoutDynamic';
var PUBLIC_EXTENDED_LAYOUT = 'PublicExtendedLayout';
var PUBLIC_LAYOUT = 'PublicLayout';
var PUBLIC_MENU_LAYOUT = 'PublicMenuLayout';
var PUBLIC_MOBILE_MENU_LAYOUT = 'PublicMobileMenuLayout';
var BASE_LAYOUT = 'BaseLayout';
var FORUM_NAVBAR_LAYOUT = 'ForumNavbar';
var INTERNAL_REDUCED_LAYOUT = 'InternalReducedLayout';
var HEALTHY_HABITS_LAYOUT = 'HealthyHabitsLayout';
var PRIVATE_LAYOUT = 'PrivateLayout';
var PUBLIC_MENU_LAYOUT_V2 = 'PublicMenuLayoutV2';
var OPENSALUD_EMPRESAS_LAYOUT = 'OpensaludEmpresasLayout';
var OPENSALUD_LAYOUT = 'OpensaludLayout';
var OPENSALUD_360_LAYOUT = 'Opensalud360Layout';
var OPENSALUD_PACIENTES_LAYOUT = 'OpensaludPacientesLayout';
var OPENSALUD_PROFESIONALES_LAYOUT = 'OpensaludProfesionalesLayout';
var BACK_BTN_LAYOUT = 'BackBtnLayout';

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseModal_vue__ = __webpack_require__(967);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5948e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseModal_vue__ = __webpack_require__(1567);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1565)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5948e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/BaseModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9c5948e4", Component.options)
  } else {
    hotAPI.reload("data-v-9c5948e4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_domains__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_subdomains__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_cookies__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_vendorKeys__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_transitions_CollapseTransition__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_colours__ = __webpack_require__(42);










/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    return this.$helpers.buildMetaInfo({ appName: this.getFavicon(), appTagLine: this.$route.meta.tagLine });
  },

  components: {
    CollapseTransition: __WEBPACK_IMPORTED_MODULE_7__components_base_transitions_CollapseTransition__["a" /* default */]
  },
  data: function data() {
    return {
      WHITE_COLOUR: __WEBPACK_IMPORTED_MODULE_8__constants_colours__["m" /* WHITE_COLOUR */],
      logo: null,
      showServicesMenu: false
    };
  },

  methods: {
    getFavicon: function getFavicon() {
      var platformName = Object(__WEBPACK_IMPORTED_MODULE_6__constants_platformNames__["h" /* getPlatformName */])();
      switch (platformName) {
        case __WEBPACK_IMPORTED_MODULE_6__constants_platformNames__["d" /* OPENSALUD_PLATFORM_NAME */]:
          return 'opensalud';
        case __WEBPACK_IMPORTED_MODULE_6__constants_platformNames__["b" /* OPENLEGAL_PLATFORM_NAME */]:
          return 'openlegal';
        default:
          return 'opensalud';
      }
    },

    loadScriptAsync: function loadScriptAsync(uri, id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!document.getElementById(id)) {
          var tag = document.createElement('script');
          tag.text = 'var _smartsupp = _smartsupp || {}; _smartsupp.key = \'' + Object(__WEBPACK_IMPORTED_MODULE_5__constants_vendorKeys__["c" /* getSmartsuppKey */])() + '\';          window.smartsupp||(function(d) {            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];            s=d.getElementsByTagName(\'script\')[0];c=d.createElement(\'script\');            c.type=\'text/javascript\';c.charset=\'utf-8\';c.async=true;            c.src=\'https://www.smartsuppchat.com/loader.js?\';s.parentNode.insertBefore(c,s);          })(document);';
          /*           tag.src = uri */
          tag.type = 'text/javascript';
          /* tag.async = true
          tag.defer = true */
          tag.setAttribute('id', id);
          tag.onload = function () {
            resolve();
          };
          document.head.appendChild(tag);
        } else {
          resolve();
        }
      });
    },
    getLogoFileName: function getLogoFileName() {
      return window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_1__constants_domains__["j" /* UNIPROMEL_DOMAIN */]) ? __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["o" /* UNIPROMEL_LOGO */] : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_2__constants_subdomains__["m" /* OPENSALUD360_SUBDOMAIN */] + '.') ? __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["e" /* OPENSALUD360_LOGO */] : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_1__constants_domains__["d" /* OPENLEGAL_DOMAIN */]) ? __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["d" /* OPENLEGAL_LOGO */] : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_1__constants_domains__["h" /* OPENSALUD_MX_DOMAIN */]) ? __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["j" /* OPENSALUD_MX_LOGO */] : __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["i" /* OPENSALUD_LOGO */];
    },
    onTabClick: function onTabClick(tab) {
      if (tab.href) {
        this.$helpers.goToWebApp(tab.href, this.$apiToken);
      } else if (tab.action) {
        tab.action();
      } else {
        this.$router.push('/patient/' + tab.path);
      }
    },
    toggleShowServicesMenu: function toggleShowServicesMenu() {
      this.showServicesMenu = !this.showServicesMenu;
    },
    goPatientMenu: function goPatientMenu() {
      location.href = this.$store.getters['session/userHasCompanies'] ? this.$helpers.get360AppUrl('patient') : this.$helpers.getV2AppUrl('patient');
    },
    getLogoFileNameByUser: function getLogoFileNameByUser() {
      return this.$store.getters['session/userHasCompanies'] ? __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["e" /* OPENSALUD360_LOGO */] : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_1__constants_domains__["h" /* OPENSALUD_MX_DOMAIN */]) ? __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["j" /* OPENSALUD_MX_LOGO */] : __WEBPACK_IMPORTED_MODULE_4__constants_logosFileNames__["i" /* OPENSALUD_LOGO */];
    },
    inPatientsLikeYouOrHealthyHabitsDomain: function inPatientsLikeYouOrHealthyHabitsDomain() {
      return window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_2__constants_subdomains__["g" /* COMUNIDAD_SALUDABLE_SUBDOMAIN */]) || window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_2__constants_subdomains__["i" /* HEALTHY_HABITS_SUBDOMAIN */]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Load only if any of acceptance cookies are enabled
    if (!!this.$cookies.get(__WEBPACK_IMPORTED_MODULE_3__constants_cookies__["a" /* ACCEPTANCE_COOKIE_NAME */]) || !!this.$cookies.get(__WEBPACK_IMPORTED_MODULE_3__constants_cookies__["g" /* MINIMUM_COOKIE_NAME */])) {
      this.loadScriptAsync('../plugins/smartsuppChat.js', 'smartsupp-chat').then(function () {
        _this.loading = false;
        _this.$store.state.smartsuppChatLoaded = true;
      });
    }

    // Logo load
    this.logo = this.$route.meta.logo && this.$route.meta.logo.src ? __webpack_require__(1003)("./" + this.$route.meta.logo.src) : __webpack_require__(1003)("./" + (this.inPatientsLikeYouOrHealthyHabitsDomain() ? this.getLogoFileNameByUser() : this.getLogoFileName()));
  },

  computed: {
    getLogo: function getLogo() {
      return this.logo;
    },
    getLogoClasses: function getLogoClasses() {
      return 'navbar-brand-img ' + (this.$route.meta.logo && this.$route.meta.logo.styleClasses ? this.$route.meta.logo.styleClasses : '');
    },
    getLogoStyles: function getLogoStyles() {
      return this.$route.meta.logo ? this.$route.meta.logo.styles : [] || [];
    },
    getMetaTitle: function getMetaTitle() {
      return this.$helpers.getMetaTitleText(this.$route);
    },
    inPanel: function inPanel() {
      return this.$route.name === 'Panel';
    },
    showBackButton: function showBackButton() {
      // Check if there is a previous route inside opensalud
      return !this.inPanel && window.history.length > 1;
    },
    caretSubMenuClass: function caretSubMenuClass() {
      return 'caret-icon ' + (!this.showServicesMenu ? 'rotate-90' : 'rotate-270');
    }
  }
});

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnim_vue__ = __webpack_require__(943);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317e5d8f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingAnim_vue__ = __webpack_require__(1512);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1509)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317e5d8f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingAnim_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/LoadingAnim.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-317e5d8f", Component.options)
  } else {
    hotAPI.reload("data-v-317e5d8f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_gtags_json__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_gtags_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_gtags_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_cookies__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__ = __webpack_require__(47);







/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        // Load only if all cookies are enabled
        if (!!__WEBPACK_IMPORTED_MODULE_4_vue__["default"].$cookies.get(__WEBPACK_IMPORTED_MODULE_2__constants_cookies__["a" /* ACCEPTANCE_COOKIE_NAME */]) && !__WEBPACK_IMPORTED_MODULE_4_vue__["default"].$cookies.get(__WEBPACK_IMPORTED_MODULE_2__constants_cookies__["g" /* MINIMUM_COOKIE_NAME */])) {
            var platform = this.$route.meta && this.$route.meta.gtag || this.$route.meta.tagLine ? this.$route.meta.gtag || this.$route.meta.tagLine : __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["d" /* OPENSALUD_PLATFORM_NAME */];
            if (platform) {
                var keyName = __WEBPACK_IMPORTED_MODULE_1__static_gtags_json___default.a[platform] ? __WEBPACK_IMPORTED_MODULE_1__static_gtags_json___default.a[platform] : __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["d" /* OPENSALUD_PLATFORM_NAME */];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keyName), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var script = _step.value;

                        var htmlScript = document.createElement('script');
                        htmlScript.setAttribute('src', script);
                        document.head.appendChild(htmlScript);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            // Add hotjar
            if (__WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__["m" /* inProductionEnv */]) {
                var hjScript = document.createElement('script');
                hjScript.setAttribute('src', '/static-appopensalud/hotjar.js');
                document.head.appendChild(hjScript);
            }
        }
    }
});

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOOTER_COMPONENT_NAMES", function() { return FOOTER_COMPONENT_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "footerHelpers", function() { return footerHelpers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__ = __webpack_require__(49);


var FOOTER_COMPONENT_NAMES = {
  OPENSALUD: 'FooterOpensalud',
  PRIMESALUD: 'FooterPrimesalud',
  OPENSALUD360: 'Footer360',
  OPENLEGAL: 'FooterOpenlegal',
  OPENLEGALHOME: 'FooterOpenlegalHome',
  ABOGALITYPRO: 'FooterAbogalityPro',
  UNIPROMEL: 'FooterUnipromel',
  OPENLEGAL360: 'FooterOpenlegal360'
};

var footerHelpers = {
  getFooterComponentName: function getFooterComponentName() {
    var platformName = Object(__WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["h" /* getPlatformName */])();
    switch (platformName) {
      case __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["c" /* OPENSALUD360_PLATFORM_NAME */]:
        return FOOTER_COMPONENT_NAMES.OPENSALUD360;
      case __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["d" /* OPENSALUD_PLATFORM_NAME */]:
        return FOOTER_COMPONENT_NAMES.OPENSALUD;
      case __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["f" /* PRIMESALUD_PLATFORM_NAME */]:
        return FOOTER_COMPONENT_NAMES.PRIMESALUD;
      case __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["b" /* OPENLEGAL_PLATFORM_NAME */]:
        return FOOTER_COMPONENT_NAMES.OPENLEGALHOME;
      case __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["a" /* ABOGALITYPRO_PLATFORM_NAME */]:
        return FOOTER_COMPONENT_NAMES.ABOGALITYPRO;
      case __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["g" /* UNIPROMEL_PLATFORM_NAME */]:
        return FOOTER_COMPONENT_NAMES.UNIPROMEL;
      default:
        return null;
    }
  }
};

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ADMIN_ROLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROFESSIONAL_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PATIENT_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CENTER_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ANONYMOUS_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_CLIENT_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PATIENT_ROLE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROFESSIONAL_ROLE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN_ROLE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_RESTRICTED_ROLE_ID; });
var ADMIN_ROLE = 'Admin';
var PROFESSIONAL_ROLE = 'Profesional';
var PATIENT_ROLE = 'Paciente';
var CENTER_ROLE = 'Centro';
var ANONYMOUS_ROLE = 'Anonimo';
var API_CLIENT_ROLE = 'ApiClient';

var PATIENT_ROLE_ID = 'c8f59a92-fa8a-4506-b4cc-c5360028d2ee';
var PROFESSIONAL_ROLE_ID = 'd7723d71-be50-4ea0-b1e5-81d86a16504b';
var ADMIN_ROLE_ID = 'fa4fb7cc-daa0-4b7e-8126-31d0b5b2f972';
var ADMIN_RESTRICTED_ROLE_ID = 'cb7fb7cc-daa0-4b7e-4135-98d0b5b2f964';

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseDialog_vue__ = __webpack_require__(965);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e26acf92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseDialog_vue__ = __webpack_require__(1564);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1559)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e26acf92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e26acf92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/BaseDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e26acf92", Component.options)
  } else {
    hotAPI.reload("data-v-e26acf92", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_locales__ = __webpack_require__(152);



/* harmony default export */ __webpack_exports__["a"] = (function (file) {
	var messages = {};
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1__constants_locales__["e" /* SUPPORTED_LOCALES */]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var locale = _step.value;

			try {
				var msgs = __webpack_require__(1558)("./" + locale + '/' + file + '.json');
				messages[locale] = msgs;
			} catch (error) {
				messages[locale] = {};
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return {
		i18n: {
			messages: messages
		}
	};
});

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPTANCE_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MINIMUM_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TRACKING_COOKIES_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_TOKEN_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ASPNET_APPLICATION_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PWA_INSTALLED_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EVALUATE_YOUR_HEALTH_WARNING_COOKIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPANY_CODE_INFO_MESSAGES_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRIME_BY_OPENSALUD_WARNING_COOKIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FOODS_DISCLAIMER_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SIMPLE_MICROHABIT_BLOCK_CLICK_DISCLAIMER_COOKIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OPENSALUD_SCORECARD_COLOR_DISCLAIMER_COOKIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TEST_WORK_ENVIRONMENT_DISCLAIMER_COOKIE; });
var ACCEPTANCE_COOKIE_NAME = 'aceptacionCookie';
var MINIMUM_COOKIE_NAME = 'essentialCookies';
var TRACKING_COOKIES_KEYS = ['_ga', '_gid', '_gat', '_gcl', '_fbp', '_fb'];
var API_TOKEN_COOKIE_NAME = 'api_token';
var ASPNET_APPLICATION_COOKIE_NAME = '.AspNet.ApplicationCookie';
var PWA_INSTALLED_COOKIE_NAME = 'pwa_installed';
var EVALUATE_YOUR_HEALTH_WARNING_COOKIE = 'evaluateYourHealthWarning';
var COMPANY_CODE_INFO_MESSAGES_COOKIE_NAME = 'companyCodeInfoMessagesDismiss';
var PRIME_BY_OPENSALUD_WARNING_COOKIE = 'primeByOpensaludWarning';
var FOODS_DISCLAIMER_COOKIE_NAME = 'foodsDisclaimer';
var SIMPLE_MICROHABIT_BLOCK_CLICK_DISCLAIMER_COOKIE = 'simpleMicrohabitBlockClickDisclaimer';
var OPENSALUD_SCORECARD_COLOR_DISCLAIMER_COOKIE = 'opensaludScorecardColorDisclaimer';
var TEST_WORK_ENVIRONMENT_DISCLAIMER_COOKIE = 'testWorkEnvironmentDisclaimer';

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseButton_vue__ = __webpack_require__(963);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ca6f122_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseButton_vue__ = __webpack_require__(1549);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1547)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ca6f122"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ca6f122_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/BaseButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8ca6f122", Component.options)
  } else {
    hotAPI.reload("data-v-8ca6f122", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LangSelector_vue__ = __webpack_require__(1075);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abd792b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LangSelector_vue__ = __webpack_require__(1658);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1656)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1abd792b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LangSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abd792b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LangSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/LangSelector.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1abd792b", Component.options)
  } else {
    hotAPI.reload("data-v-1abd792b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ES_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MX_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EN_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PT_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SUPPORTED_LOCALES; });
var ES_LOCALE = 'es';
var MX_LOCALE = 'mx';
var EN_LOCALE = 'en';
var PT_LOCALE = 'pt';
var SUPPORTED_LOCALES = [ES_LOCALE, MX_LOCALE, EN_LOCALE, PT_LOCALE];

/***/ }),
/* 153 */,
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOS_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OPENSALUD_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OPENSALUD_WHITE_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return OPENSALUD_MX_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OPENSALUD_MX_WHITE_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OPENSALUD360_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPENSALUD360_WHITE_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OPENSALUD360_MX_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OPENSALUD360_WHITE_MX_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OPENLEGAL_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABOGALITYPRO_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OPENLEGAL360_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UNIPROMEL_LOGO; });
/* unused harmony export NEOM_LOGO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PRIME_BY_OPENSALUD_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PRIME_BY_OPENSALUD_LOGO_WHITE; });
/* harmony export (immutable) */ __webpack_exports__["p"] = getLogoFullPath;
var LOGOS_PATH = '/static-appopensalud/img/logos/';

var OPENSALUD_LOGO = 'opensalud_healthierlives_color.svg';
var OPENSALUD_WHITE_LOGO = 'opensalud_healthierlives_white.svg';
var OPENSALUD_MX_LOGO = 'opensaludmx_healthierlives_color.svg';
var OPENSALUD_MX_WHITE_LOGO = 'opensalud_mx_healthierlives_white.svg';
var OPENSALUD360_LOGO = 'opensalud360_healthierlives_color.svg';
var OPENSALUD360_WHITE_LOGO = 'opensalud360_healthierlives_white.svg';
var OPENSALUD360_MX_LOGO = 'opensalud360_mx_healthierlives_color.svg';
var OPENSALUD360_WHITE_MX_LOGO = 'opensalud360_mx_healthierlives_white.svg';
var OPENLEGAL_LOGO = 'openlegal_blue.svg';
var ABOGALITYPRO_LOGO = 'openlegalpro_orange.svg';
var OPENLEGAL360_LOGO = 'openlegal360_orange.svg';
var UNIPROMEL_LOGO = 'unihealth_blue_unipromel.svg';
var NEOM_LOGO = 'RGB_Neom_positivo.svg';
var PRIME_BY_OPENSALUD_LOGO = 'primebyopensalud-healthierlives-color';
var PRIME_BY_OPENSALUD_LOGO_WHITE = 'primebyopensalud-healthierlives-white';

function getLogoFullPath(logoFileName) {
	return '' + LOGOS_PATH + logoFileName;
}

/***/ }),
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getNormalizedLocale;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalize;
/* unused harmony export normalizeProp */
/* unused harmony export changeLang */
/* unused harmony export getCulture */
/* unused harmony export loadCommonTranslations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_locales__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cookies_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__ = __webpack_require__(47);








var loadedTranslations = [];

function getNormalizedLocale() {
	return __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["c" /* i18nLocale */] === __WEBPACK_IMPORTED_MODULE_3__constants_locales__["c" /* MX_LOCALE */] ? __WEBPACK_IMPORTED_MODULE_3__constants_locales__["b" /* ES_LOCALE */] : __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["c" /* i18nLocale */];
}

function normalize(translation) {
	return translation[getNormalizedLocale()] ? translation[getNormalizedLocale()] : translation['es'];
}

function normalizeProp(prop) {
	return prop + '.' + getNormalizedLocale();
}

function changeLang(lang) {
	Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cookies_helpers__["d" /* saveLangPrefCookie */])(__WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["a" /* country */] + '/' + lang);
	window.location.reload();
}

function getCulture() {
	return __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["c" /* i18nLocale */] === __WEBPACK_IMPORTED_MODULE_3__constants_locales__["c" /* MX_LOCALE */] ? 'es-MX' : __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["c" /* i18nLocale */] === __WEBPACK_IMPORTED_MODULE_3__constants_locales__["a" /* EN_LOCALE */] ? 'en-US' : __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["c" /* i18nLocale */] === __WEBPACK_IMPORTED_MODULE_3__constants_locales__["d" /* PT_LOCALE */] ? 'pt-PT' : 'es-ES';
}

var loadCommonTranslations = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(lang) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (!((lang === 'pt' || lang === 'mx') && !loadedTranslations.includes('@/lang/es/common.json'))) {
							_context.next = 4;
							break;
						}

						_context.next = 3;
						return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 189)).then(function (msgs) {
							return Object(__WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["d" /* mergeLocaleMessage */])(lang, msgs.default || msgs);
						});

					case 3:
						loadedTranslations.push('@/lang/es/common.json');

					case 4:
						if (loadedTranslations.includes('@/lang/' + lang + '/common.json')) {
							_context.next = 11;
							break;
						}

						_context.next = 7;
						return __webpack_require__(1338)("./" + lang + '/global-variables.json').then(function (msgs) {
							return Object(__WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["d" /* mergeLocaleMessage */])(lang, msgs.default || msgs);
						});

					case 7:
						loadedTranslations.push('@/lang/' + lang + '/global-variables.json');
						_context.next = 10;
						return __webpack_require__(1339)("./" + lang + '/common.json').then(function (msgs) {
							return Object(__WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["d" /* mergeLocaleMessage */])(lang, msgs.default || msgs);
						});

					case 10:
						loadedTranslations.push('@/lang/' + lang + '/common.json');

					case 11:
						return _context.abrupt('return', loadedTranslations);

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadCommonTranslations(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadTranslations = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(lang, files) {
		var _this = this;

		var _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						if (!lang) {
							lang = 'es';
						}
						_context3.next = 3;
						return loadCommonTranslations(lang);

					case 3:
						loadedTranslations = _context3.sent;

						if (!(files && files.length > 0)) {
							_context3.next = 31;
							break;
						}

						_loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop(_file) {
							return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context2) {
								while (1) {
									switch (_context2.prev = _context2.next) {
										case 0:
											if (!_file) {
												_context2.next = 14;
												break;
											}

											_file = _file.split('.json')[0];

											if (!(lang === __WEBPACK_IMPORTED_MODULE_3__constants_locales__["c" /* MX_LOCALE */] && !loadedTranslations.includes('@/lang/es/' + _file + '.json'))) {
												_context2.next = 6;
												break;
											}

											_context2.next = 5;
											return __webpack_require__(1340)("./" + _file + '.json').then(function (msgs) {
												return Object(__WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["d" /* mergeLocaleMessage */])(lang, msgs.default || msgs);
											});

										case 5:
											loadedTranslations.push('@/lang/es/' + _file + '.json');

										case 6:
											if (!(loadedTranslations.filter(function (item) {
												return new RegExp('@/lang/' + lang + '/' + _file + '.json').test(item);
											}).length == 0)) {
												_context2.next = 14;
												break;
											}

											_context2.prev = 7;
											_context2.next = 10;
											return __webpack_require__(1341)("./" + lang + '/' + _file + '.json').then(function (msgs) {
												if (msgs) {
													Object(__WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["d" /* mergeLocaleMessage */])(lang, msgs.default || msgs);
													loadedTranslations.push('@/lang/' + lang + '/' + _file + '.json');
												}
											});

										case 10:
											_context2.next = 14;
											break;

										case 12:
											_context2.prev = 12;
											_context2.t0 = _context2['catch'](7);

										case 14:
											file = _file;

										case 15:
										case 'end':
											return _context2.stop();
									}
								}
							}, _loop, _this, [[7, 12]]);
						});
						_iteratorNormalCompletion = true;
						_didIteratorError = false;
						_iteratorError = undefined;
						_context3.prev = 9;
						_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files);

					case 11:
						if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
							_context3.next = 17;
							break;
						}

						file = _step.value;
						return _context3.delegateYield(_loop(file), 't0', 14);

					case 14:
						_iteratorNormalCompletion = true;
						_context3.next = 11;
						break;

					case 17:
						_context3.next = 23;
						break;

					case 19:
						_context3.prev = 19;
						_context3.t1 = _context3['catch'](9);
						_didIteratorError = true;
						_iteratorError = _context3.t1;

					case 23:
						_context3.prev = 23;
						_context3.prev = 24;

						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}

					case 26:
						_context3.prev = 26;

						if (!_didIteratorError) {
							_context3.next = 29;
							break;
						}

						throw _iteratorError;

					case 29:
						return _context3.finish(26);

					case 30:
						return _context3.finish(23);

					case 31:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee2, this, [[9, 19, 23, 31], [24,, 26, 30]]);
	}));

	return function loadTranslations(_x2, _x3) {
		return _ref2.apply(this, arguments);
	};
}();

/* harmony default export */ __webpack_exports__["a"] = ({
	getNormalizedLocale: getNormalizedLocale,
	normalize: normalize,
	normalizeProp: normalizeProp,
	changeLang: changeLang,
	getCulture: getCulture,
	loadCommonTranslations: loadCommonTranslations,
	loadTranslations: loadTranslations
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_locales__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_string_helpers__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_AccountRepository__ = __webpack_require__(180);







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    basePathForumName: function basePathForumName() {
      return location.href.indexOf('comunidadsaludable') > -1 ? 'comunidadsaludable' : 'foro';
    },
    inWhoInSection: function inWhoInSection() {
      return this.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */];
    }
  },
  methods: {
    getTimeAgoFromDate: function getTimeAgoFromDate(date) {
      var diff = Math.abs(new Date() - new Date(date)) / 1000;
      var result = diff < 60 ? Math.floor(diff) + ' ' + this.$t('seconds') : diff / 60 < 60 ? Math.floor(diff / 60) + ' ' + this.$t('minutes') : diff / 60 / 60 < 24 ? Math.floor(diff / 60 / 60) + ' ' + this.$t('hours') : diff / 60 / 60 / 24 < 30 ? Math.floor(diff / 60 / 60 / 24) + ' ' + this.$t('days') : diff / 60 / 60 / 24 / 30 < 12 ? Math.floor(diff / 60 / 60 / 24 / 30) + ' ' + this.$t('months') : Math.floor(diff / 60 / 60 / 24 / 30 / 12) + ' ' + this.$t('years');
      if (result.split(' ')[0] === '1') {
        if (result.split(' ')[1].indexOf(this.$t('months')) > -1) {
          result = result.slice(0, -2);
        } else {
          result = result.slice(0, -1);
        }
      }
      var lang = this.$i18n.locale;
      if (lang === 'en') {
        return result + ' ' + this.$t('ago');
      } else {
        return this.$t('ago') + ' ' + result;
      }
    },
    getUserBasicInfo: function getUserBasicInfo() {
      var _this2 = this;

      var _this = this;
      this.$api.get('/Forum/GetUserBasicInfo').then(function (response) {
        if (response.response && (response.response.status === 401 || response.response.status === 500)) {
          _this2.logOff(true);
          return;
        }
        if (response.data) {
          if (response.data.error) {
            switch (response.data.error) {
              case 'forbiddenMinorUser':
                _this2.$store.dispatch('showDangerAlert', _this2.$t('forbiddenMinorUser'));
                setTimeout(function () {
                  _this.logOff();
                }, 5000);
            }
            return;
          }
          _this2.getUserLoginInfo();
          _this2.$store.state.forum.userBasicInfo = response.data;
          if (response.data.pushNotificationsSectionId && response.data.pushNotificationsSectionId.length > 0) {
            _this2.$store.state.forum.numberPushNotifications = response.data.pushNotificationsSectionId.length;
          }
          if (response.data.companyCode && response.data.companiesAccessRestricted && location.href.indexOf('comunidadsaludable') > -1) {
            _this2.$store.dispatch('showDangerAlert', _this2.$t('companiesAccessRestrictedMessage'));
            setTimeout(function () {
              location.href = _this2.$helpers.getHealthyCommunityUrl('pacientescomotu');
            }, 5000);
          }
        } else {
          _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
        }
      });
    },
    getUserLoginInfo: function getUserLoginInfo() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__repositories_AccountRepository__["a" /* default */].getSession().then(function (response) {
        _this3.$store.dispatch('session/set', response.data);
      });
    },
    loadForumEntries: function loadForumEntries() {
      var _this4 = this;

      if (this.$store.state.forum.showingSearch) {
        this.$api.get('/Forum/SearchEntry', { params: { id: this.$store.state.forum.searchId, type: this.$store.state.forum.searchType, sectionId: this.$store.state.forum.sectionId, page: this.$store.state.forum.entriesPageNumber, itemsPerPage: this.$store.state.forum.entriesPerPage, sortId: this.$store.state.forum.searchSort } }).then(function (response) {
          _this4.processForumEntry(response.data);
        });
      } else {
        this.$api.get('/Forum/GetEntry', { params: { pageNumber: this.$store.state.forum.entriesPageNumber, itemsPerPage: this.$store.state.forum.entriesPerPage, sortId: this.$store.state.forum.searchSort, sectionId: this.$store.state.forum.sectionId } }).then(function (response) {
          _this4.processForumEntry(response.data);
        });
      }
    },
    processForumEntry: function processForumEntry(data) {
      if (data) {
        this.$store.state.forum.articleData = this.$store.state.forum.entriesPageNumber ? this.$store.state.forum.articleData.concat(data.entryData) : data.entryData;
        this.$store.state.forum.numEntries = data.numEntries;
        this.$store.state.forum.entriesCreatedByUser = data.entriesCreatedByUser;
      } else {
        this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'));
      }
    },
    getForumMessages: function getForumMessages(entryId) {
      var _this5 = this;

      var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.$api.get('/Forum/GetEntryMessage', { params: { entryId: entryId, pageNumber: pageNumber, itemsPerPage: this.$store.state.forum.messagesPerPage } }).then(function (response) {
        if (response.data) {
          _this5.$store.state.forum.entryMessagesCreatedByUser = response.data.entryMessagesCreatedByUser;
          if (pageNumber > 0) {
            var _$store$state$forum$m;

            (_$store$state$forum$m = _this5.$store.state.forum.messages).splice.apply(_$store$state$forum$m, [_this5.$store.state.forum.messages.length, 0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data.entryMessageData)));
          } else {
            _this5.$store.commit('forum/resetMessagesValues');
            _this5.$store.state.forum.messages = response.data.entryMessageData;
          }
        } else {
          _this5.$store.dispatch('showDangerAlert', _this5.$t('defaultErrorMessage'));
        }
      });
    },
    showPushNotifications: function showPushNotifications(sectionId) {
      var _this6 = this;

      this.$api.get('/Forum/GetPushNotifications').then(function (response) {
        if (response.data && response.data.length > 0) {
          _this6.$store.state.forum.pushNotifications = response.data;
          if (response.data.some(function (x) {
            return x.readed !== true;
          })) {
            _this6.pushNotificationsReaded();
          }
        }
        if (sectionId) {
          _this6.$store.state.forum.pushNotifications.filter(function (x) {
            return x.sectionId === sectionId;
          }).forEach(function (x) {
            return x.markedSectionId = sectionId;
          });
        }
        _this6.$store.state.forum.showPushNotificationsModal = true;
      });
    },
    pushNotificationsReaded: function pushNotificationsReaded(sectionId) {
      var _this7 = this;

      this.$api.put('/Forum/PushNotificationsReaded', null, { params: { sectionId: sectionId } }).then(function (response) {
        if (!sectionId) {
          _this7.$store.state.forum.numberPushNotifications = 0;
        }
      });
    },
    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      this.$helpers.uploadFile('/Forum/ResizeImageToBase64', null, file, this).then(function (response) {
        Editor.insertEmbed(cursorLocation, 'image', response.data);
        resetUploader();
      });
    },
    getPathUrl: function getPathUrl(path, section, goRoot) {
      path = path ? path : '';
      if (location.href.includes('comunidadsaludable')) {
        var forumSection = goRoot ? '' : section ? section + '/' : this.$route.params.forumSection ? this.$route.params.forumSection + '/' : '';
        return '/' + (location.href.includes('localdesarrollo') ? 'comunidadsaludable/' : '') + forumSection + path;
      } else if (location.href.includes('localdesarrollo')) {
        return '/foro/' + path;
      } else {
        return '/' + path;
      }
    },
    getHealthyCommunityPathUrl: function getHealthyCommunityPathUrl(path) {
      path = path ? path : '';
      if (location.href.includes('localdesarrollo')) {
        return '/comunidadsaludable/' + path;
      } else {
        return '/' + path;
      }
    },
    createNewPost: function createNewPost(data) {
      this.$store.commit('forum/toggleCreateNewPost', data);
      this.$router.push(this.getHealthyCommunityPathUrl('new'));
    },
    inHealthyCommunity: function inHealthyCommunity() {
      return location.href.indexOf('comunidadsaludable') > -1;
    },
    logIn: function logIn(healthyCommunityPath) {
      var _this = this;
      this.$store.commit('session/setLoginCallback', function () {
        if (healthyCommunityPath) {
          _this.$router.push(healthyCommunityPath).catch(function () {});
        } else {
          _this.$router.push(_this.getPathUrl()).catch(function () {});
        }
      });
      this.$router.push('/inicio-sesion');
    },
    logOff: function logOff() {
      var _this8 = this;

      this.$api.get('/Forum/LogOff').then(function (response) {
        window.$cookies.remove('api_token', null, Object(__WEBPACK_IMPORTED_MODULE_2__helpers_global_helpers__["c" /* getBaseDomain */])());
        location.href = _this8.getPathUrl(null, null, true);
      });
    },
    goRoot: function goRoot() {
      this.$router.push(this.getPathUrl()).catch(function () {});
    },
    normalizeForumProp: function normalizeForumProp(prop) {
      if (this.$i18nHelpers.getNormalizedLocale() === __WEBPACK_IMPORTED_MODULE_3__constants_locales__["b" /* ES_LOCALE */]) return prop;
      return '' + prop + Object(__WEBPACK_IMPORTED_MODULE_4__helpers_string_helpers__["c" /* firstLetterUppercase */])(this.$i18nHelpers.getNormalizedLocale());
    },
    getForumSectionByPath: function getForumSectionByPath(pathName) {
      switch (pathName) {
        case 'quienseapunta':
          return __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */];
        case 'informacionsalud':
          return __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */];
        case 'pacientescomotu':
          return __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */];
      }
    },
    getForumPathBySectionId: function getForumPathBySectionId(sectionId) {
      switch (sectionId) {
        case __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */]:
          return 'quienseapunta';
        case __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */]:
          return 'informacionsalud';
        case __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */]:
          return 'pacientescomotu';
      }
    },
    getForumSectionTitle: function getForumSectionTitle(sectionId, includeArticle) {
      switch (sectionId) {
        case __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["d" /* WHO_IN_HEALTH_COMMUNITY_SECTION */]:
          return '' + (includeArticle ? this.$t('in') + ' ' : '') + this.$t('whoIn');
        case __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */]:
          return '' + (includeArticle ? this.$t('in') + ' ' : '') + this.$t('healthyInformation');
        case __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */]:
          return '' + (includeArticle ? this.$t('in') + ' ' : '') + this.$t('patientsLikeYou');
        default:
          return '' + (includeArticle ? this.$t('in') + ' ' : '') + this.$t('patientsLikeYou');
      }
    },
    canModifyForumEntry: function canModifyForumEntry(entryId) {
      return this.$store.state.forum.entriesCreatedByUser.includes(entryId) || this.$store.getters['forum/forumUserIsAdminRole'] || this.$store.getters['forum/forumUserIsAdminRestrictedRole'];
    },
    canModifyForumMessage: function canModifyForumMessage(messageId) {
      return this.$store.state.forum.entryMessagesCreatedByUser.includes(messageId) || this.$store.getters['forum/forumUserIsAdminRole'] || this.$store.getters['forum/forumUserIsAdminRestrictedRole'];
    },
    canEditForumMessage: function canEditForumMessage(messageId) {
      return this.$store.state.forum.entryMessagesCreatedByUser.includes(messageId);
    },
    canEditForumEntry: function canEditForumEntry(entryId) {
      return this.$store.state.forum.entriesCreatedByUser.includes(entryId);
    },
    updateLastInteractionDate: function updateLastInteractionDate(entryId) {
      this.$store.state.forum.articleData.find(function (item) {
        return item.id === entryId;
      }).lastInteractionDate = new Date();
    }
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return OPENSALUD360_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return OPENSALUD_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return OPENSALUD_TEST_SUBDOMAIN; });
/* unused harmony export OPENSALUD_DEV_SUBDOMAIN */
/* unused harmony export OPENSALUD360_TEST_SUBDOMAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMUNIDAD_SALUDABLE_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VIDEO_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HEALTHY_HABITS_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BARCELO_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IBEROSTAR_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WAMOS_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ASSEGUR_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NAUTALIA_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CARREFOUR_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MSM_SUBDOMAIN; });
/* unused harmony export DEV_PREFIX */
/* unused harmony export DEV_SUFFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEV_KEYWORDS; });
/* unused harmony export TEST_PREFIX */
/* unused harmony export TEST_SUFFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TEST_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APP_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_DEV_SUBDOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_TEST_SUBDOMAIN; });
var OPENSALUD360_SUBDOMAIN = '360';
var OPENSALUD_SUBDOMAIN = 'www.opensalud';
var OPENSALUD_TEST_SUBDOMAIN = 'pruebas.opensalud';
var OPENSALUD_DEV_SUBDOMAIN = 'desarrollo.opensalud';
var OPENSALUD360_TEST_SUBDOMAIN = 'pruebas-360';
var COMUNIDAD_SALUDABLE_SUBDOMAIN = 'comunidadsaludable';
var VIDEO_SUBDOMAIN = 'video';
var HEALTHY_HABITS_SUBDOMAIN = 'habitossaludables';
var BARCELO_SUBDOMAIN = 'barcelo';
var IBEROSTAR_SUBDOMAIN = 'iberostar';
var WAMOS_SUBDOMAIN = 'wamos';
var ASSEGUR_SUBDOMAIN = 'assegur';
var NAUTALIA_SUBDOMAIN = 'nautalia';
var CARREFOUR_SUBDOMAIN = 'carrefour';
var MSM_SUBDOMAIN = 'msm';

// Subdomains and prefixes for specific environments
var DEV_PREFIX = 'desarrollo';
var DEV_SUFFIX = '-dev';
var DEV_KEYWORDS = [DEV_PREFIX, DEV_SUFFIX];
var TEST_PREFIX = 'pruebas';
var TEST_SUFFIX = '-test';
var TEST_KEYWORDS = [TEST_PREFIX, TEST_SUFFIX];
var APP_SUBDOMAIN = 'app';
var APP_DEV_SUBDOMAIN = '' + APP_SUBDOMAIN + DEV_SUFFIX;
var APP_TEST_SUBDOMAIN = '' + APP_SUBDOMAIN + TEST_SUFFIX;

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

module.exports = {"360":{"es":{"production":"https://360.opensalud.es","staging":"https://pruebas-360.opensalud.es","development":"https://desarrollo-360.opensalud.es"},"mx":{"production":"https://360.opensalud.mx","staging":"https://pruebas-360.opensalud.mx","development":"https://desarrollo-360.opensalud.mx"},"local":"https://localhost:44381"},"apiDomainES":"https://api.openhealthcare.eu","apiDomainMX":"https://api.opensalud.com","apiTestDomainES":"https://api-test.openhealthcare.eu","apiTestDomainMX":"https://api-test.opensalud.com","appV2DomainES":"https://www.opensalud.es","appV2DomainMX":"https://www.opensalud.mx","appTestV2DomainES":"https://pruebas.opensalud.es","appTestV2DomainMX":"https://pruebas.opensalud.mx","appDevV2DomainES":"https://desarrollo.opensalud.es","appDevV2DomainMX":"https://desarrollo.opensalud.mx","apiLocalDomain":"https://api-dev.openhealthcare.eu","appV2LocalDomain":"https://localhost:8080","landingTestSubdomain":"segundaopinion.me","appSubdomainES":"opensalud.es","appSubdomainMX":"opensalud.mx","appOHSubdomainES":"openhealth.opensalud.es","appOHSubdomainMX":"openhealth.opensalud.mx","landingTestUrl":"https://menttum.opensalud.es","testSubdomain":"msm","apiGw":{"apis":["ohc","ouicare","tmc","user","center","notifications","account"],"es":{"production":"https://api-gateway.openhealthcare.eu","staging":"https://api-gateway.openhealthcare.eu/staging","development":"https://api-gateway.openhealthcare.eu/development"},"mx":{"production":"https://api-gateway.openhealthcare.eu/mx","staging":"https://api-gateway.openhealthcare.eu/mx/staging","development":"https://api-gateway.openhealthcare.eu/mx/development"},"local":"https://localhost:44330/api"},"apis":{"api":{"es":{"production":"https://api.openhealthcare.eu","staging":"https://api-test.openhealthcare.eu","development":"https://api-dev.openhealthcare.eu"},"mx":{"production":"https://api.opensalud.com","staging":"https://api-test.opensalud.com","development":"https://api-test.opensalud.com"},"local":"https://api-test.openhealthcare.eu"},"nodofarma":{"es":{"production":"https://nodofarma-api.openhealthcare.eu","staging":"https://nodofarma-api.openhealthcare.eu"},"mx":{"production":"https://nodofarma-api.opensalud.com","staging":"https://nodofarma-api.opensalud.com"},"local":"https://api-dev.openhealthcare.eu"},"ouicareos":{"es":{"production":"https://www.opensalud.es/api/","staging":"https://pruebas.opensalud.es/api/"},"mx":{"production":"https://www.opensalud.mx/api/","staging":"https://pruebas.opensalud.mx/api/"}},"accountos":{"es":{"production":"https://www.opensalud.es/Account/","staging":"https://pruebas.opensalud.es/Account/","development":"https://desarrollo.opensalud.es/Account/"},"mx":{"production":"https://www.opensalud.mx/Account/","staging":"https://pruebas.opensalud.mx/Account/","development":"https://desarrollo.opensalud.mx/Account/"},"local":"https://localhost:44330/es/Account/"}},"app":{"es":{"development":"app-dev.opensalud.es","staging":"app-test.opensalud.es","production":"app.opensalud.es"},"mx":{"development":"app-test.opensalud.mx","staging":"app-test.opensalud.mx","production":"app.opensalud.mx"},"local":"localhost:44330"},"tarjetaACA":{"production":"https://aca-login.openlegal.es/","staging":"https://aca-login-test.openlegal.es/","development":"https://aca-login-test.openlegal.es/","local":"https://localhost:7231/"},"healthy-community":{"es":{"development":"https://comunidadsaludable-dev.opensalud.es","staging":" https://comunidadsaludable-test.opensalud.es","production":" https://comunidadsaludable.opensalud.es"},"mx":{"development":" https://comunidadsaludable-dev.opensalud.mx","staging":" https://comunidadsaludable-test.opensalud.mx","production":" https://comunidadsaludable.opensalud.mx"},"local":"https://comunidadsaludable-dev.opensalud.es"},"habits":{"es":{"development":"https://habitossaludables-dev.opensalud.es","staging":" https://habitossaludables-test.opensalud.es","production":" https://habitossaludables.opensalud.es"},"mx":{"development":" https://habitossaludables-dev.opensalud.mx","staging":" https://habitossaludables-test.opensalud.mx","production":" https://habitossaludables.opensalud.mx"},"local":"https://habitossaludables-dev.opensalud.es"},"patients-like-you":{"es":{"development":"https://comunidadsaludable-dev.opensalud.es/pacientescomotu","staging":" https://comunidadsaludable-test.opensalud.es/pacientescomotu","production":" https://comunidadsaludable.opensalud.es/pacientescomotu"},"mx":{"development":" https://comunidadsaludable-dev.opensalud.mx/pacientescomotu","staging":" https://comunidadsaludable-test.opensalud.mx/pacientescomotu","production":" https://comunidadsaludable.opensalud.mx/pacientescomotu"},"local":"https://comunidadsaludable-dev.opensalud.es/pacientescomotu"},"blog":"https://prime.opensalud.es/blog"}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isMobile; });
/* unused harmony export isTablet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isDesktop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isPortrait; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isMobileOrTablet; });
/* unused harmony export isXlDevice */
/* unused harmony export isMobileAgent */
/* unused harmony export isFullMobile */
/* unused harmony export isPwa */
/* harmony export (immutable) */ __webpack_exports__["h"] = scrollBottom;
/* harmony export (immutable) */ __webpack_exports__["a"] = centerScreen;
/* harmony export (immutable) */ __webpack_exports__["c"] = hideSmartsuppChat;
var MOBILE_WIDTH_LIMIT = 711;
var DESKTOP_WIDTH_START = 1024;
var DESKTOP_HEIGHT_START = 1024;

var isMobile = window.innerWidth < MOBILE_WIDTH_LIMIT && window.innerHeight < DESKTOP_HEIGHT_START;
var isTablet = window.innerWidth < DESKTOP_WIDTH_START && window.innerWidth > MOBILE_WIDTH_LIMIT && window.innerHeight >= DESKTOP_HEIGHT_START;
var isDesktop = window.innerWidth >= DESKTOP_WIDTH_START && (window.screen && window.screen.orientation && window.screen.orientation.type.includes('landscape') || window.matchMedia("(orientation: landscape)").matches);
var isPortrait = window.screen && window.screen.orientation && window.screen.orientation.type.includes('portrait') || window.matchMedia("(orientation: portrait)").matches;
var isMobileOrTablet = isMobile || isTablet;
var isXlDevice = !isMobile && !isTablet;

var isMobileAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var isFullMobile = isMobile && isMobileAgent;

var isPwa = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

function scrollBottom(ref) {
	var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	if (ref) {
		if (smooth) {
			ref.scrollTo({
				top: ref.scrollHeight,
				behavior: 'smooth'
			});
		} else {
			ref.scrollTop = ref.scrollHeight;
		}
	}
}

function centerScreen(ref) {
	if (ref) {
		ref.scrollIntoView({
			block: 'end',
			behavior: 'smooth'
		});
	}
}

function hideSmartsuppChat() {
	var smartsuppElem = document.querySelector('#smartsupp-widget-container > div');
	if (smartsuppElem) {
		smartsuppElem.style.display = 'none';
	}
}

/* harmony default export */ __webpack_exports__["b"] = ({
	isMobile: isMobile,
	isTablet: isTablet,
	isDesktop: isDesktop,
	isPortrait: isPortrait,
	isMobileOrTablet: isMobileOrTablet,
	isXlDevice: isXlDevice,
	isMobileAgent: isMobileAgent,
	isFullMobile: isFullMobile,
	isPwa: isPwa,
	scrollBottom: scrollBottom,
	centerScreen: centerScreen,
	hideSmartsuppChat: hideSmartsuppChat
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OPENSALUD_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPENSALUD_ES_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OPENSALUD_MX_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRIMESALUD_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OPENLEGAL_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABOGALITYPRO_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UNIPROMEL_DOMAIN; });
/* unused harmony export NEOM_DOMAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OPENSALUD4ALL_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MENTTUM_DOMAIN; });
/* unused harmony export getDomain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCALHOST_DOMAIN; });
var OPENSALUD_DOMAIN = 'opensalud';
var OPENSALUD_ES_DOMAIN = 'opensalud.es';
var OPENSALUD_MX_DOMAIN = 'opensalud.mx';
var PRIMESALUD_DOMAIN = 'opensaludprime';
var OPENLEGAL_DOMAIN = 'openlegal';
var ABOGALITYPRO_DOMAIN = 'abogalitypro';
var UNIPROMEL_DOMAIN = 'unihealth';
var NEOM_DOMAIN = 'neom';
var OPENSALUD4ALL_DOMAIN = 'opensalud4all';
var MENTTUM_DOMAIN = 'menttum';
function getDomain() {
    return window.location.hostname.includes(UNIPROMEL_DOMAIN) ? UNIPROMEL_DOMAIN : window.location.hostname.includes(OPENSALUD_MX_DOMAIN) ? OPENSALUD_MX_DOMAIN : window.location.hostname.includes(PRIMESALUD_DOMAIN) ? PRIMESALUD_DOMAIN : window.location.hostname.includes(OPENLEGAL_DOMAIN) ? OPENLEGAL_DOMAIN : window.location.hostname.includes(ABOGALITYPRO_DOMAIN) ? ABOGALITYPRO_DOMAIN : window.location.hostname.includes(NEOM_DOMAIN) ? NEOM_DOMAIN : window.location.hostname.includes(OPENSALUD_ES_DOMAIN) ? OPENSALUD_ES_DOMAIN : window.location.hostname.includes(OPENSALUD4ALL_DOMAIN) ? OPENSALUD4ALL_DOMAIN : window.location.hostname.includes(MENTTUM_DOMAIN) ? MENTTUM_DOMAIN : OPENSALUD_DOMAIN;
}

var LOCALHOST_DOMAIN = 'localhost';

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMenuLayoutV2_vue__ = __webpack_require__(1166);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235e2044_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMenuLayoutV2_vue__ = __webpack_require__(2022);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2020)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-235e2044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMenuLayoutV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235e2044_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMenuLayoutV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PublicMenuLayoutV2.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-235e2044", Component.options)
  } else {
    hotAPI.reload("data-v-235e2044", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = formatDate;
/* unused harmony export localeDate */
/* harmony export (immutable) */ __webpack_exports__["g"] = formatDateForGraphAxis;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatDateByMonth;
/* harmony export (immutable) */ __webpack_exports__["f"] = formatDateByMonthLong;
/* harmony export (immutable) */ __webpack_exports__["m"] = getMonthName;
/* harmony export (immutable) */ __webpack_exports__["p"] = getWeekDaysNames;
/* harmony export (immutable) */ __webpack_exports__["q"] = getWeekDaysNamesWithValue;
/* harmony export (immutable) */ __webpack_exports__["n"] = getMonthShortName;
/* harmony export (immutable) */ __webpack_exports__["o"] = getWeekDayShortName;
/* harmony export (immutable) */ __webpack_exports__["r"] = getWeekDaysShortNames;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDDMMYYYY;
/* harmony export (immutable) */ __webpack_exports__["k"] = getDateFromDateAndHour;
/* harmony export (immutable) */ __webpack_exports__["i"] = getCurrentDateFromHour;
/* harmony export (immutable) */ __webpack_exports__["h"] = formatSearchDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = appointmentDateFormat;
/* harmony export (immutable) */ __webpack_exports__["s"] = longDateFormat;
/* harmony export (immutable) */ __webpack_exports__["t"] = utcDateToUtcFormat;
/* unused harmony export getTime */
/* harmony export (immutable) */ __webpack_exports__["l"] = getLocalHourFromDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateAge;
/* harmony export (immutable) */ __webpack_exports__["c"] = dateIsBeforeToday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_string_helpers__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_i18n_helpers__ = __webpack_require__(156);





function formatDate(date, format, englishVersion) {
	return date.toLocaleDateString(englishVersion ? 'en' : Object(__WEBPACK_IMPORTED_MODULE_3__helpers_i18n_helpers__["b" /* getNormalizedLocale */])(), format);
}

function localeDate(date) {
	return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).locale(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_i18n_helpers__["b" /* getNormalizedLocale */])());
}

function formatDateForGraphAxis(date) {
	var result = formatDate(date, { month: 'short', day: 'numeric' });
	return result;
}

function formatDateByMonth(date) {
	var result = formatDate(date, { month: 'short', year: '2-digit' });
	return result;
}

function formatDateByMonthLong(date) {
	var result = formatDate(date, { month: 'long', year: 'numeric' });
	return result;
}

function getMonthName(date) {
	var month = formatDate(date, { month: 'long' });
	return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_string_helpers__["c" /* firstLetterUppercase */])(month);
}

function getWeekDaysNames() {
	var startsOnSunday = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	var englishVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	var weekDays = [];
	var date = new Date();
	date.setDate(date.getDate() - (date.getDay() - (startsOnSunday ? 0 : 1)));
	for (var i = 0; i < 7; i++) {
		weekDays.push(formatDate(date, { weekday: 'long' }, englishVersion));
		date.setDate(date.getDate() + 1);
	}
	return weekDays;
}

function getWeekDaysNamesWithValue() {
	var startsOnSunday = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	var englishVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	var weekDays = [];
	var date = new Date();
	date.setDate(date.getDate() - (date.getDay() - (startsOnSunday ? 0 : 1)));
	for (var i = 0; i < 7; i++) {
		weekDays.push({ name: formatDate(date, { weekday: 'long' }, englishVersion), value: i });
		date.setDate(date.getDate() + 1);
	}
	return weekDays;
}

function getMonthShortName(date) {
	var month = formatDate(date, { month: 'short' });
	return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_string_helpers__["c" /* firstLetterUppercase */])(month);
}

function getWeekDayShortName(date) {
	var weekday = formatDate(date, { weekday: 'short' });
	return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_string_helpers__["c" /* firstLetterUppercase */])(weekday);
}

function getWeekDaysShortNames() {
	var startsOnSunday = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	// Get week days short names ordered in week
	var weekDays = [];
	var date = new Date();
	date.setDate(date.getDate() - (date.getDay() - (startsOnSunday ? 0 : 1)));
	for (var i = 0; i < 7; i++) {
		weekDays.push(getWeekDayShortName(date));
		date.setDate(date.getDate() + 1);
	}
	return weekDays;
}

function getDDMMYYYY(date) {
	return formatDate(date, { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function getDateFromDateAndHour(date, hour) {
	var dateObj = new Date(date);
	return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), hour.split(':')[0], hour.split(':')[1]);
}

function getCurrentDateFromHour(hour) {
	return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), hour.split(':')[0], hour.split(':')[1]);
}

function formatSearchDate(date) {
	if (!date) return '';
	var utcDate = utcDateToUtcFormat(date);
	var dateWithLocale = localeDate(utcDate);
	var daysDifference = Math.round((dateWithLocale - new Date()) / (1000 * 3600 * 24));
	return '' + (daysDifference < 7 ? dateWithLocale.calendar() : dateWithLocale.format('DD MMM HH:mm'));
}
function appointmentDateFormat(date, reduced) {
	var noHours = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	if (!date) return '';
	var dateWithLocale = localeDate(typeof date === 'string' ? utcDateToUtcFormat(date) : date);
	var formattedDate = dateWithLocale.format((reduced ? '' : 'dddd, ') + 'DD [' + (reduced ? '' : __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('ofLabel')) + '] MMMM [' + (reduced ? '' : __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('ofLabel')) + '] YYYY');
	if (!noHours) {
		formattedDate += ' ' + (reduced ? '' : __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('at-time')) + ' ' + dateWithLocale.format('LT');
	}
	return formattedDate;
}

function longDateFormat(date, withoutHour) {
	if (!date) return '';
	var dateWithLocale = localeDate(date);
	return '' + dateWithLocale.format('dddd, ' + 'DD [' + __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('ofLabel') + '] MMMM [' + __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('ofLabel') + '] YYYY') + (' ' + (withoutHour ? '' : __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('at-time') + ' ' + dateWithLocale.format('LT')));
}
function utcDateToUtcFormat(date) {
	if (!date) return '';
	// Check if date is already a Date object
	// If so, return it as is
	if (date instanceof Date) return date;
	return new Date(date.indexOf('Z') > -1 ? date : date + 'Z');
}
function getTime(date) {
	if (!date) return '';
	return localeDate(date).format('LT');
}
function getLocalHourFromDate(date) {
	return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('HH:mm');
}
function calculateAge(date) {
	var today = new Date();
	var age = today.getFullYear() - date.getFullYear();
	if (today.getMonth() < date.getMonth() || today.getMonth() === date.getMonth() && today.getDate() < date.getDate()) {
		age -= 1;
	}
	return age;
}
function dateIsBeforeToday(date) {
	return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()));
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);



var api = function api() {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$api;
};

function accountPath(resource) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* path */])('/webapp/account/' + resource);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getSession: function getSession() {
    return api().get(accountPath('sessions'));
  },
  login: function login(username, password) {
    var mfaCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return api().post(accountPath('sessions'), {
      username: username,
      password: password,
      twoFactorCode: mfaCode
    });
  },
  sendPasswordUpdateEmail: function sendPasswordUpdateEmail(email) {
    return api().get(accountPath('passwords'), {
      params: {
        email: email
      }
    });
  },
  setEmail: function setEmail(email, updatePwdToken) {
    return api().put(accountPath('setemail'), {
      email: email
    }, {
      headers: {
        'Authorization': 'Bearer ' + updatePwdToken
      }
    });
  },
  updatePassword: function updatePassword(password, updatePwdToken) {
    return api().put(accountPath('passwords'), {
      password: password
    }, {
      headers: {
        'Authorization': 'Bearer ' + updatePwdToken
      }
    });
  },
  confirmEmail: function confirmEmail(code, updatePwdToken) {
    return api().post(accountPath('confirm'), {
      code: code
    }, {
      headers: {
        'Authorization': 'Bearer ' + updatePwdToken
      }
    });
  },
  reenableAccount: function reenableAccount(token) {
    return api().get(accountPath('reenable'), { params: {
        token: token
      }
    });
  },
  loginAssociatedPatient: function loginAssociatedPatient(patientId) {
    return api().post(accountPath('sessions/' + patientId));
  },
  isntMultiUser: function isntMultiUser() {
    return api().get('account/isntMultiUser');
  }
});

/***/ }),
/* 181 */,
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LANG_PREF_REGEX; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["e"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeCookie;
/* harmony export (immutable) */ __webpack_exports__["d"] = saveLangPrefCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_locales__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_global_helpers__ = __webpack_require__(47);



var LANG_PREF_REGEX = /^(\w{2})(?:\/|(?:\%2F)){0,1}(\w{2})$/;

function getCookie(name) {
	var value = '; ' + document.cookie;
	var parts = value.split('; ' + name + '=');
	if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(cname, cvalue) {
	var expirationDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;

	var d = new Date();
	d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
	var expires = 'expires=' + d.toUTCString();
	var domain = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_global_helpers__["c" /* getBaseDomain */])();
	document.cookie = cname + '=' + cvalue + ';domain=' + domain + ';' + expires + ';path=/';
}

function removeCookie(name) {
	var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object(__WEBPACK_IMPORTED_MODULE_1__helpers_global_helpers__["c" /* getBaseDomain */])();

	window.$cookies.remove(name, '/', domain);
}

function saveLangPrefCookie(langpref) {
	var matches = langpref.match(LANG_PREF_REGEX);
	var country = matches[1];
	var lang = matches[2];
	if (country === __WEBPACK_IMPORTED_MODULE_0__constants_locales__["c" /* MX_LOCALE */] && lang === __WEBPACK_IMPORTED_MODULE_0__constants_locales__["b" /* ES_LOCALE */]) {
		lang = __WEBPACK_IMPORTED_MODULE_0__constants_locales__["c" /* MX_LOCALE */];
	} else if (country === __WEBPACK_IMPORTED_MODULE_0__constants_locales__["b" /* ES_LOCALE */] && lang === __WEBPACK_IMPORTED_MODULE_0__constants_locales__["c" /* MX_LOCALE */]) {
		lang = __WEBPACK_IMPORTED_MODULE_0__constants_locales__["b" /* ES_LOCALE */];
	}
	langpref = setCookie('langpref', country + '/' + lang);
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
	getCookie: getCookie,
	setCookie: setCookie,
	removeCookie: removeCookie,
	saveLangPrefCookie: saveLangPrefCookie
});

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

module.exports = {"welcome_message":"Bienvenido","pages":{"about":"Acerca de"},"menu-label-patient":"Paciente","professionals":"Profesionales","menu-health-information":"Historial clínico","menu-notes":"Notas","menu-share-files":"Compartir archivos","menu-end-session":"Terminar sesión","menu-chat":"Chat","menu-audio":"Audio","menu-video":"Video","menu-help":"Ayuda","menu-language":"Idioma","general-close":"Cerrar","waitingProfessionalHeader":"Sala de espera virtual","waitingProfessionalBody":"El profesional le atenderá en unos instantes. Tenga paciencia, puede demorarse hasta 15 minutos.","menu-video-quality-low":"Calidad baja","menu-mute-video":"Pausar video","menu-video-quality-medium":"Calidad media","menu-video-quality-high":"Calidad máxima","menu-title-video-quality":"Calidad de video","menu-title-video-advanced":"Avanzado","menu-language-es":"Espa?ol","menu-language-en":"English","menu-share-screen":"Compartir la pantalla","menu-mute-audio":"Pausar sonido","sessionNotValid":"La sesión a la intenta acceder ha caducado o no es válida","chat-placeholder":"Escriba su mensaje...","needValidToken":"Necesita una sesión válida para iniciar la consulta.","dialog-title-error":"Error","errorServerConnection":"Ha ocurrido un error en la conexión con servidor.","errorTokenNotValid":"La sesión que ha introducido no es correcta.","errorInvalidDate":"Puede entrar en la sala con un maximo de 30 minutos de antelación. Revise la fecha y la hora de su cita.","errorVideoConnection":"Ha ocurrido un error con la sesión de video. Póngase en contacto con el servicio técnico.","errorShareDevices":"Es necesario que conceda permisos a la aplicación para utilizar su cámara y su micrófono para poder llevar a cabo la sesión.","dialog-title-videoTest":"Test de video","sessionEnded":"Sesión de video finalizada","sessionEndedBody":"Su sesión de videoconsulta ha finalizado. Según lo acordado con el profesional recibirá su informe y/o receta en la mayor brevedad de tiempo.","videoSession":"Sesión de vídeo","retry":"Volver a intentar","returnToApp":"Volver a Opensalud","menu":{"clinical_documents":"Documentos clínicos","history":"Historia clínica","devices":"Dispositivos","appointment-info":"Información de la consulta","summary":"Información de la consulta","notes":"Notas","change-user":"Cambiar usuario","change-user-placeholder":"Seleccione un usuario...","change-user-no-patients":"No tiene ningun usuario asociado a su cuenta principal. Puede registrar uno desde su perfil haciendo click en el botón que aparece a continuación.","change-user-create":"Registrar paciente asociado","history-access":"Conceder acceso historia"},"enable-stethoscope":"Estetoscopio","enable-lamp":"Lámpara de exploración","cancel":"Cancelar","continue":"Continuar","stethoscope1":"Antes de continuar, asegúrese de que ha conectado el estetoscopio a su equipo y que está encendido.","manualteleexploracion-href":"http://docs.opensalud.es/ManualTeleExploracion","stethoscope2":"nuestra guía.","stethoscope3":"Una vez pulse en 'Continuar' el profesional dejará de escucharle por su micrófono principal y pasará a oir la señal del estetoscopio.","stethoscope4":"Puede volver a activar su micrófono principal cuando lo desee, simplemente desconectando el estetoscopio de su equipo.","stethoscope5":"Antes de continuar asegúrese de que ha desconectado el estetoscopio de su equipo.","stethoscope6":"Una vez pulse en 'Continuar' el profesional dejará de escuchar la señal del estetoscopio y pasará a oir su micrófono principal.","stethoscope7":"Puede volver a activar el estetoscopio cuando desee.","lamp1":"Antes de continuar, asegúrese de que ha conectado la lámpara de exploración a su equipo y que está encendida. <br><br>Una vez pulse en 'Continuar' el profesional dejará de verle por la cámara y se activará la imagen de la lámpara.<br><br>Puede volver a activar su cámara cuando lo desee, simplemente poniendo en posición de apagado la lámpara y extrayéndola.<br><br>Si el médico le indica que no puede verle, pulse en el botón de actualizar (cómo el que puede ver a continuación) que encontrará en la parte inferior de la pantalla.<br><br>¡No extraiga la lámpara sin seleccionar previamente la posición de apagado!","lamp2":"¡No extraiga la lámpara aún! Pulse en 'Continuar' y después extraiga la lámpara de exploración de su equipo.","itemsPerPage":"Elementos por página","ofLabel":"de","page":"página","all":"Todos","next-label":"Siguiente","prev-label":"Anterior","file-name":"Documento","preview-file":"Ver","share-screen":"Compartir pantalla","stop-share-screen":"Dejar de compartir pantalla","enable-mic":"Activar micrófono","mute-mic":"Silenciar micrófono","enable-cam":"Habilitar cámara","disable-cam":"Deshabilitar cámara","introduce-token":"Introduzca su identificador de sesión","go-to-session":"Continuar","need-help":"¿Necesitas ayuda?","try-refresh":"Si no ves o escuchas al profesional, o el profesional no puede verte o escucharte, prueba a <u><a href=\"#\" onclick=\"window.location.reload()\">recargar la página</a></u>","faq":"Preguntas frecuentes","chat-attention":"Te atendemos en nuestro <u>chat de soporte</u>","camera":"Cámara","microphone":"Micrófono","errors":{"SESSION_INVALID":"El identificador de la sesión que ha introducido no es válido.","OT_HARDWARE_UNAVAILABLE":"No podemos acceder a su cámara o micrófono. Compruebe que no están siendo usados en otra aplicación.","OT_NO_DEVICES_FOUND":"No se ha encontrado ningún dispositivo válido para comenzar la videoconsulta. Compruebe que su cámara y/o micrófono funcionan correctamente.","OT_MEDIA_ERR_NETWORK":"Se ha producido un error de conexión. Compruebe su actual conexión a Internet.","OT_AUTHENTICATION_ERROR":"Se ha producido un error de conexión a su videoconsulta. Compruebe el código de 6 caracteres de su sesión.","OT_USER_MEDIA_ACCESS_DENIED":"Es necesario que conceda permisos a la aplicación para utilizar su cámara y/o micrófono y poder llevar a cabo la sesión.","PaymentNotFoundException":{"title":"Videoconsulta no pagada","title_professional":"Videoconsulta no pagada","msg":"Su videoconsulta aún no ha sido pagada.","msg_professional":"La videoconsulta aún no ha sido pagada."},"VideoSessionNotYetAccessibleException":{"title":"Videoconsulta programada","msg":"Lo sentimos pero su videoconsulta está programada para el {date}. Recuerde que podrá acceder a la sesión hasta 30 minutos antes de la hora especificada.","title_professional":"Videoconsulta programada","msg_professional":"Lo sentimos pero la videoconsulta está programada para el {date}. Recuerde que podrá acceder a la sesión una vez el paciente haya comenzado la misma."},"VideoSessionNoLongerAccessibleException":{"title":"Videoconsulta pasada","msg":"Lo sentimos pero su videoconsulta estaba programada para el {date}. Recuerde que puede acceder a la sesión hasta 30 minutos antes de la hora especificada.","title_professional":"Videoconsulta pasada","msg_professional":"Lo sentimos pero su videoconsulta estaba programada para el {date}. Recuerde que podrá acceder a la sesión una vez el paciente haya comenzado la misma."},"VideoSessionFinishedException":{"title":"Videoconsulta finalizada","msg":"Su videoconsulta ha finalizado. Si está esperando informe y/o receta puede acceder a la información de su consulta en Opensalud.","title_professional":"Videoconsulta finalizada","msg_professional":"La videoconsulta ha finalizado. Recuerde rellenar el informe y/o receta si así lo especificó al finalizar la sesión."},"VideoSessionExpiredException":{"title":"Videoconsulta caducada/cancelada","msg":"Lo sentimos pero su videoconsulta ha caducado o sido cancelada antes de llevarse a cabo.<br> Si necesita más información contacte con nosotros.","title_professional":"Videoconsulta caducada/cancelada","msg_professional":"Lo sentimos pero la videoconsulta ha caducado o sido cancelada antes de llevarse a cabo.<br> Si necesita más información contacte con nosotros."},"VideoSessionFinishedWithReportException":{"title":"Videoconsulta finalizada","msg":"Su videoconsulta ha finalizado y el profesional ya ha emitido el informe y/o receta. Puede acceder a esta información en Opensalud.","title_professional":"Videoconsulta finalizada","msg_professional":"La videoconsulta ya ha finalizado. Puede revisar toda la información de esta consulta en Opensalud."},"VideoSessionWaitingReportException":{"title":"A espera de información del profesional","msg":"Su videoconsulta ha finalizado. Será notificado en las próximas horas cuando el profesional complete su informe y/o receta.","title_professional":"Videoconsulta finalizada","msg_professional":"La videoconsulta ya ha finalizado. Recuerde rellenar el informe y/o receta en Opensalud."},"error-has-ocurred":"Ha ocurrido un error. Por favor, inténtelo de nuevo en unos minutos o contacte con soporte si el error persiste."},"show-detailed-error":"Mostrar más información","hide-detailed-error":"Ocultar más información","contact-by-chat-tech-problems":"¿Necesitas soporte técnico? Te atendemos en nuestro chat","back":"Volver","dialog-title-pressToInitVideoTest":"Pulse para iniciar el test","dialog-title-resultVideoTest":"Resultado del test","dialog-title-presentation":"Esta prueba te permitirá saber si tienes los medios adecuados para realizar una video consulta.","dialog-title-minimumRequisitesVideoTest":"Lo sentimos pero no cumple los requisitos mínimos.","dialog_title_tabOneVideoTest":"1. Permisos","retry-init":"Volver a iniciar","needValidTokenVideoTest":"Necesita una sesión válida para iniciar el test.","no-documents-found":"No se han encontrado documentos disponibles en esta consulta.","select-or-drag-drop-file":"Subir archivo...","drag-drop-file":"Arrastra un archivo aquí","browse":"Buscar","upload-files":"Subir archivos","select-file-type":"Seleccione el tipo de archivo","file-type":"Tipo","go-to-consultation":"Ir a mi consulta","pay-consultation":"Pagar consulta","at-time":"a las","dialog-text1-tab1-VdeoTest":"Es necesario que conceda permisos a la aplicación para utilizar su cámara y su micrófono para poder llevar a cabo la sesión. Estos permisos pueden ser revocados en cualquier momento.","dialog-text2-tab1-VideoTest":"Al no permitir el uso de la cámara y el microfono no podrá realizar video consultas. Reinicie el test si desea conceder los permisos.","grant-permissions":"Conceder permisos","request-permissions":"Solicitar permisos","devices":"2. Dispositivos","network":"3. Conexión","dialog-title-waitingSession":"Por favor espere, comprobando la sesión","checkingDevices":"Comprobando dispositivos","dialog-button-waitingTest":"Por favor, espere a que finalice el test","dialog-button-go-to-session":"Ir a la video consulta","video-quality":"Calidad de video","audio-quality":"Calidad de audio","dialog-title-overalRatingVideoTest":"Resultado general","test-result":{"Bad":"Mala","Poor":"Pobre","Fair":"Justa","Good":"Buena","Excellent":"Excelente"},"dialog-title-speedTest":"Test de red","test-center-image-and-audio":"Asegurese que su imagen aparece centrada y que el indicador del microfono se desplaza al hablar.","video-device":"Dispositivo de video","audio-device":"Dispositivo de audio","title-result-test-ok":"Su sistema puede realizar video consultas.","tittle-resulta-test-ko":"Se recomienda no realizar video consulta con este sistema","subtitle-result-test-ko":"Por favor, compruebe su conexión a Internet. Si está conectado por wifi, asegúrese de estar cerca de él y de no tener otros dispositivos conectados.","test-requisites":"Revise que tiene la cámara y el microfono activo. Si su sistema es IOS compruebe que su versión es superior a la 12.1.","page-not-found":"Página no encontrada","videosession-end-caption":"Su videoconsulta está programada para finalizar apróximadamente a las {date}. Esta duración es orientativa y podrá diferir del tiempo que finalmente dure su sesión.","timer-end":"Fin: {date}","loading-videosession":"Cargando Videoconsulta...","support-chat":"Chat de soporte","login":{"server-error":"Ha ocurrido un error. Por favor, inténtelo de nuevo mas tarde.","email":"Email","errors":{"email":"Email no válido.","password":"Contraseña incorrecta","password-different":"Ups! Parece que las contraseñas no coinciden","password-constraints":"Su contraseña debe ser de al menos 8 caracteres y contener una mayúscula, minúscula, algún número, así como algún carácter especial","Disabled":"Su usuario está deshabilitado. Contacte con nosotros si considera que se trata de un error.","Inactive":"Han pasado mas de seis meses sin que hayamos registrado actividad en su usuario. Por motivos de seguridad hemos enviado un correo a la dirección de email asociada a su cuenta para que habilite de nuevo su cuenta.","PasswordUpdateNeeded":"Por motivos de seguridad su contraseña necesita ser actualizada. Hemos enviado un correo a la dirección de email asociada a su cuenta para que cambie su contraseña.","PasswordMaxAttemptsExceeded":"Debido a que ha iniciado varias veces la sesión de forma fallida, la cuenta se bloqueará ahora durante unos instantes.<br>Vuelva a iniciar sesión pasados unos minutos.","twoFACode":"Código de verificación inválido. Revíselo.","UserLockedException":"Lo sentimos, pero su cuenta ha sido bloqueada.<br>Si considera que se trata de un error, por favor envíe un correo electrónico a info@opensalud.es.","AuthenticationException":"Email y/o contraseña incorrecto/s","EmailConfirmationException":"Su cuenta aún no ha sido confirmada. Por favor, compruebe su correo electrónico y confirme su cuenta.","ConfirmationEmailExpiredException":"Su cuenta aún no ha sido confirmada. Hemos vuelto a enviarle un correo de confirmación a su dirección de email.","TwoFactorCodeCommunicationException":"Ha ocurrido un error durante el envío de su código de doble factor. Por favor, inténtelo de nuevo en unos segundos."},"password":"Contraseña","sign-in":"Iniciar sesión","forget-password":"¿Has olvidado tu contraseña?","with-dnie":"Iniciar sesión con certificado digital","password-repeat":"Repita su nueva contraseña","twoFACode":"Introduzca el código que ha recibido","already-signed-in":"¿Ya estás registrado?","new-user":"¿Eres un usuario nuevo?","register-now":"¡Créate ya una cuenta para disfrutar de todas nuestras ventajas!","iam-professional":"Soy Profesional","iam-patient":"Soy Paciente","iam-centre":"Soy Centro","iam-lawyer":"Soy Abogado","iam-client":"Soy Cliente","iam-lawfirm":"Soy Bufete","aca-sign-in":"Iniciar sesión con tarjeta ACA","dialog-lawyer":"Actualmente sólo es posible el registro mediante invitación, para lo cual necesitarás incluir el código recibido."},"invalid-credentials":"Usuario o contraseña incorrectos","reenable-account":"Reactivar cuenta","account-reenable-success":"Su cuenta ha sido reactivada. Pulse en el siguiente enlace para iniciar sesión:","account-reenable-fail":"Su cuenta no ha podido ser reactivada. Por favor, compruebe de nuevo el enlace o, si lo desea, vuelva a iniciar sesión para recibir un nuevo correo de recuperación de cuenta.","send":"Enviar","error":{"try-again":"Ha ocurrido un error. Inténtelo de nuevo más tarde."},"resend-account-enable-email-success":"Por motivos de seguridad su cuenta ha sido desactivada. Hemos enviado un correo de reactivación de su cuenta a {email}.","log-in":"Iniciar sesión","newpassword-success":"Su contraseña ha sido actualizada correctamente. Para iniciar sesión haga click aquí:","change-password":"Cambiar contraseña","new-password":{"constraints":"Para que su contraseña sea segura, es imprescindible que tenga mas de 8 caracteres y contenga al menos una mayúscula, una minúscula, un número y algún carácter especial"},"recover-password":{"instructions":"Si ha olvidado su contraseña le enviaremos un correo electrónico a la dirección de email introducida con un enlace para recuperarla.","title":"Recuperar contraseña","success":"Hemos enviado un correo electrónico a la dirección introducida donde encontrará un enlace para poder reestablecer su contraseña."},"name":"Nombre","surname":"Apellidos","phone":"Número de teléfono","national-identity-document":"Nº doc. de identidad","signup-success":"Se ha registrado con éxito en Opensalud. Recibirá en su email las instrucciones para confirmar su cuenta y acceder a la plataforma.","signup-unsuccessful":"Ha ocurrido un error durante su registro. Inténtelo de nuevo mas tarde.","sign-up":"Registro","professional":"Profesional","patient":"Paciente","center":"Centro","select-an-option":"Tipo de usuario","telemedcare-account-association":"Su cuenta en Telemedcare","telemedcare":{"association":{"step-1":"<b>Paso 1.</b> Descargue la aplicación 'TMC Blue' en su dispositivo móvil:","step-2":"<b>Paso {step}.</b> Inicie la aplicación que acaba de descargarse y escanee el código QR que aparece a continuación.","step-3":"<b>Paso {step}.</b> Active Bluetooth y habilite el reconocimiento de ubicación.","step-4":"<b>Paso {step}.</b> Encienda el/los dispositivos médicos que necesite para las mediciones que vaya a realizar y compruebe que aparecen habilitados en su dispositivo móvil.","step-5":"<b>Paso {step}.</b> Tómese las mediciones que necesite cuantas veces necesite.","step-2-installed":"<b>Paso {step}.</b> Inicie la aplicación.","clinic-history":"Recuerde que puede consultar todas las mediciones desde la aplicación de Telemedcare o desde su historial clínico en Opensalud."},"access-portal":"Ir a historia clínica","no-tmc-token-found":"No tiene permisos para acceder a esta página. Por favor, inicie sesión de nuevo.","is-first-access":"¿Es la primera vez que accede al servicio de telemonitorización o necesita vincular de nuevo su dispositivo?"},"button":{"get-on-google-play":"/static-appopensalud/img/disponible-play-store.png","get-on-app-store":"/static-appopensalud/img/descargar-app-store.png"},"continue-with-certificate":"Continuar con certificado digital","yes":"Sí","hang-up-video":"Finalizar videoconsulta","dialog":{"ok-button":"Aceptar","cancel-button":"Cancelar"},"base":{"errors":{"unauthorized":{"title":"Acceso no autorizado","message":"No tiene permisos suficientes para acceder a esta página.","sign-in-again":"Puede iniciar sesión de nuevo para acceder a esta página.","message360":"Lo sentimos pero su perfil no puede acceder a las condiciones de opensalud360. Si lo desea, puede solicitar los servicios con el profesional de su elección al precio que este tenga fijado."},"basic-error":"Ha oocurrido un error","unauthorized-360-error-page":{"go-to-opensalud":"Iniciar sesión en Opensalud"},"unauthozed-travel-error-page":{"new-code":"Nuevo número de certificado/reserva o código","new-reservation-number":"Nuevo número de certificado/reserva","new-start-date":"Fecha de entrada","new-end-date":"Fecha de salida","code-required":"Introduce un número de certificado/reserva o código","reservation-number-required":"Introduce un número de certificado/reserva","start-date-required":"Intervalo de estancia inválido","server-error":"Ha ocurrido un error. Por favor, comprueba tu número de reserva/certificado y/o código o inténtalo de nuevo más tarde. Si necesitas ayuda, puedes contactar con nosotros mediante el chat de soporte."}}},"video":{"connecting":"Conectando con el paciente","wait-connecting-patient":"Espere mientras le conectamos con su paciente. Este proceso no tardará más de 1 minuto.","hang-up-are-you-sure-question":"¿Está seguro de que desea finalizar la consulta?","on-client-disconnected":"La conexión se ha perdido, espere unos instantes a que el sistema intente recuperar de manera automática la sesión.","new-device-connected":"Se ha conectado/desconectado un dispositivo de audio o vídeo. Para cambiar de dispositivo use los selectores/interruptores del menú lateral."},"consolidate-modal":{"title":"La consulta ha finalizado","charge-with-data":"Cobrar consulta con los siguientes datos:"},"no":"No","consolidate-appointment-modal":{"select-billable-entity":"Seleccione entidad de facturación","no-charge":"No cobrar esta consulta","select-no-charge-reason":"Seleccione el motivo","must-select-billable-entity":"Debe seleccionar entidad de facturación","must-specify-not-charge-reason":"Debe seleccionar un motivo para no cobrar esta consulta"},"base-select":{"select-option":"Seleccione una opción...","noOptions":"No se han encontrado resultados","errorMsg":"Seleccione una opción"},"menttum-proxy-view":{"title":{"question":"Hola {name}, ¿qué necesitas?"}},"menttum":{"request-consultation-title":"Pedir una consulta...","video-consultation":"Solicitar sesión de terapia por vídeo","chat-consultation":"Contactar con el psicólogo con chat","wellness-services":"Acceder a plataforma de bienestar","wellness":"Wellness","webapp":"Acceder a mi perfil","appointment-dialog-msg":"A continuación podrás seleccionar al psicólogo que te atenderá.<br>Los psicólogos se ordenan de acuerdo con tus necesidades o preferencias. ","webapp-dialog-msg":"En esta pantalla podrás acceder a tus sesiones y consultas tanto en Menttum como en opensalud.","hire-package":"Contratar paquete","hire":"Contratar","included-services":"Servicios incluidos","hire-package-msg":"No tiene ningún paquete activo. Para solicitar video o chat con un psicólogo necesita contratar primero uno de los siguientes paquetes.","self-evaluation":"Evalúa tu salud"},"signup-title":"Regístrate","login-wrd":"Acceder","login-wrd-session":"Inicia sesión","welcomeOH":"Bienvenido a","profConditions-link":"Condiciones para profesionales","patConditions-link":"Condiciones para pacientes","telemedicineCompanies-link":"Salud y bienestar para empresas","contact-link":"Contacto","legalNotice-link":"Aviso legal y cookies","questions-link":"Preguntas frecuentes","lastUpdate":"Última actualización","signupOH":{"joinUsers":"Alta de usuarios","registerCodeEnt":"CÓDIGO INDICADO POR SU EMPRESA","registerCodeEntInfo":"(Sólo si se lo han proporcionado)","selectLanguageTxt":"SELECCIONA LOS IDIOMAS QUE HABLA","registerName":"NOMBRE","registerSurname1":"PRIMER APELLIDO","registerSurname2":"SEGUNDO APELLIDO","genderSex":"SEXO","man":"Hombre","woman":"Mujer","country":"PAÍS","registerYourProvince":"Provincia/Estado/Región","registerNIF":"NIF (DNI/NIE/CIF)","registerEmail":"CORREO ELECTRÓNICO","confirmEmail":"CONFIRMAR CORREO ELECTRÓNICO","birthdate":"FECHA DE NACIMIENTO (dd/mm/aaaa)","registerPhonePrefix":"PREFIJO","registerPhoneNumber":"TELÉFONO MÓVIL","readAccept":"He leído y acepto","alreadyRegistered":"Si ya estás registrado,","loginn":"inicia sesión","signup-submit":"Registrarse","errors":{"enterCode":"Por favor, introduzca un código válido","enterLang":"Por favor, seleccione al menos un idioma","enterName":"Introduzca un nombre","enterSurname1":"Introduzca el primer apellido","enterSurname2":"Introduzca el segundo apellido","enterSex":"Seleccione el género","enterCountry":"Seleccione el país","enterProvince":"Introduzca Provincia/Estado/Región","enterNIF":"Introduzca un NIF (DNI/NIE/CIF)","enterEmail":"Introduzca un email","enterConfirmEmail":"Confirme el email","enterBirthdate":"Introduzca una fecha de nacimiento","enterPhonePrefix":"Selecciona un prefijo","enterPhoneNumber":"Introduzca un teléfono móvil","reservation-number":"Introduce un número de reserva","certificate-number":"Introduce un número de certificado","client-number":"Introduce un número de cliente","center-or-business-unit":"Seleccione un centro o unidad de negocio","employee-number":"Introduzca su código interno (número de empleado)","general-code":"Los datos introducidos no son válidos. Por favor, revíselos e inténtelo de nuevo. Si necesita ayuda puede contactarnos mediante el chat de soporte.","sameEmails":"Los emails deben de ser idénticos","enterSpeciality":"Seleccione especialidad","enterCollegeNumber":"Introduzca su Número de Colegiado","enterSanitaryRegister":"Introduzca el número de registro sanitario","enterNameEducativeCenter":"Por favor introduzca un nombre de un centro educativo","enterCollegeNumberMaxValue":"Ha seleccionado una especialidad médica, el número de colegiado debe ser de 9 dígitos","captcha":"El captcha no fue completado correctamente","termsAccepted":"Debe aceptar los términos y condiciones legales para poder registrarse en la plataforma.","privacyAccepted":"Debe aceptar la política de privacidad para poder registrarse en la plataforma.","dataVerification":"Debe aceptar la verificacion de sus datos con el colegio oficial para poder registrarse en la plataforma.","enterCentreName":"Por favor rellene el nombre del centro","enterDiscoveryType":"Por favor seleccione cómo nos conoció","enterUrlBlog":"Por favor introduzca la URL de su web o blog","enterExperienceProf":"Introduzca su experiencia profesional","enterProvinceCollegiate":"Introduzca su provincia de colegiación","birthdateMore18":"Debe de ser mayor de edad para poder registrarse","urlProf":"Debe introducir una URL válida","enterDay":"Introduzca un día de nacimiento","enterMonth":"Introduzca un mes de nacimiento","enterYear":"Introduzca una fecha de nacimiento","birthdateReal":"Debe de introducir una fecha real","birthdateMustBeReal":"Debe de introducir una fecha real","enterCollegeNumberMaxValueMx":"Las cédulas profesionales de médicos son desde los 5 caracteres","enterIdentity":"Por favor introduzca un documento de identidad válido","enterIdentityChoice":"Debe de seleccionar una de las opciones","employeeLocation":"Debe introducir una ubicación","enterCURP":"Introduzca un CURP","enterID":"Introduzca un Id Personal","duplicatedNIF":"Ya existe un usuario registrado con ese documento de identidad","internal-code":"Introduzca su código interno","dni":"Introduzca un ","required-employee-number":"Por favor, rellene el numero de empleado"},"accept-terms":"He leído y acepto los <a target=\"_blank\" href='/terminos-condiciones-profesional'>términos y las condiciones legales.</a>","accept-privacy":"He leído y acepto la <a target=\"_blank\" href='/politica-privacidad-profesional'>política de privacidad.</a>","accept-privacy-patient":"He leído y acepto la <a target=\"_blank\" href='/politica-privacidad'>política de privacidad.</a>","reservation-number":"Número de reserva","reservation-number-or-code":"Número de reserva o código","certificate-number-or-code":"Número de certificado o código","certificate-number":"Número de certificado","generic-code":"Código genérico","checkin-date":"Fecha de entrada (dd/mm/aaaa)","checkout-date":"Fecha de salida (dd/mm/aaaa)","code-provided-by-msm":"Código facilitado por RRHH de MSM","client-number":"Número de cliente","code-provided-by-company-or-entity":"Código indicado por su empresa o entidad","center-or-business-unit":"Centro o unidad de negocio","employee-number":"Número de empleado","info":{"reservationNumber":{"ConectaTSalud":"Hola, para darte de alta en el servicio de salud debes introducir tu código CNTxxxxxxxx que ConectaT te ha facilitado. Si no dispones de él, debes solicitarlo a través del correo info@conecta-t.es"}},"account-confirmation":"Se ha enviado un correo electrónico a {email} para verificar su identidad. Por favor consulte su buzón y siga las instrucciones. <br><br>Si pasados unos minutos no lo ha recibido, compruebe su bandeja de correo no deseado/spam.<br><br>Recuerde que dispone de <u>72 horas</u> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b>info@opensalud.es</b>","account-confirmation-openlegal":"Se ha enviado un correo electrónico a {email} para verificar su identidad. Por favor consulte su buzón y siga las instrucciones. <br><br>Si pasados unos minutos no lo ha recibido, compruebe su bandeja de correo no deseado/spam.<br><br>Recuerde que dispone de <u>72 horas</u> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b>hola@openlegal.com</b>","birthDate":"Fecha de nacimiento","selectDiscovery":"¿Cómo nos ha conocido?","modalSuccessull":"Información de registro","modal1":"Se ha enviado un correo electrónico a","modal2":"para verificar su identidad, además de un Whatsapp si ha introducido número de teléfono. <br>Por favor consulte su buzón y siga las instrucciones.","modal3":"Si pasados unos minutos no lo ha recibido, compruebe su bandeja de correo no deseado / spam.","modal4":"Recuerde que dispone de <b>72 horas</b> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b> info@opensalud.es</b> \n","modal4-openlegal":"Recuerde que dispone de <b>72 horas</b> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b> hola@openlegal.com</b> \n","agree":"De acuerdo","specialty":"ESPECIALIDAD","collegeProvince":"Provincia de colegiación","registerCollegeNumber":"Número de colegiado","experienceProfessional":"Experiencia (min. 5 años)","urlProfessional":"URL web/blog (https://..)","withoutLocation":"Sin ubicación física","registerNameCenter":"Nombre del Centro","registerSanitaryRegister":"Número del Registro Sanitario","registerNameEducativeCenter":"Nombre del Centro Educativo","modalBusiness":"El código que ha utilizado corresponde al servicio opensalud360.","modalBusiness2":"Pulse en continuar para registrarse en opensalud360.","continue":"Continuar","cancel":"Cancelar","registerCodeEntProf":"Código (solo si se lo han proporcionado)","accept-terms-patient":"He leído y acepto los <a target=\"_blank\" href='/terminos-condiciones-paciente'>términos y las condiciones legales.</a>","data-verefication":"Autorizo la verificación de mis datos con el colegio oficial.","no-options":"Lo siento, no hay ninguna opción que coincida","dayBirth":"Día","monthBirth":"Mes","yearBirth":"Año","indentitydocument":"DOC. IDENTIDAD","university":"Universidad emisora de su título","invalidDate":"Por favor, introduzca una fecha de nacimiento válida","justIndicatedByBusiness":"Sólo si se lo ha proporcionado su empresa","registerNameCenterResidence":"nombre del centro/residencia","employeeLocation":"Ubicación","internal-code":"Código Interno (número de empleado)","enterCURP":"CURP","enterId":"Id Personal"},"genderMale":"H","genderFemale":"M","wellness":"Wellness","webapp":"Acceder a mi perfil y consultas","stethoscope-refresh":"Si el médico le indica que no puede oir su estetoscopio, pulse el botón de actualizar (como el que puede ver a continuación) que encontrará en la parte inferior de la pantalla.","refresh-label":"Actualizar página","reconnectingProfessional":"Espere mientras reconectamos con el profesional...","swap-cameras-mobile-rear":"Cambiar a cámara trasera","swap-cameras-mobile-front":"Cambiar a cámara delantera","appointment-info":{"date":"Fecha y hora","disease":"Enfermedad o síntoma","reason":"Motivo de la consulta"},"appointment-notes":{"notes":"Notas de la consulta","patientNotes":"Notas sobre el paciente","invisible-for-patient":"Recuerde que esta información permanecerá oculta para el paciente","write-here":"Escriba aquí...","last-update":"Última modificación:"},"table":{"no-results":"No se han encontrado resultados","pagination":{"label":"Elem. mostrados {firstOfPage}-{lastOfPage} de {totalItems}"}},"date":"Fecha","history":{"variables":"Variables de salud"},"base-input":{"placeholder":"Escriba aquí...","errorMsg":"Compruebe los datos introducidos"},"payments-gateway":{"title":"Pasarela de pago"},"selectMonth":"Seleccione mes","selectYear":"Seleccione año","month":"Mes","year":"Año","5MinutesAdvice":"Le informamos que en 5 minutos expirará la sesión y no podra realizar ninguna transacción.","add-btn":"Añadir","select-birthdate":"Seleccione su fecha de nacimiento","signUp":{"already-registered":"Si ya estás registrado"},"sign-up-href":"inicia sesión","terms-and-conditions":"Términos y condiciones","report":{"reason":"Motivo de la consulta","history":"Historia actual","treatment":"Tratamiento","diagnosis":"Diagnóstico"},"uploaded-successfully":"Archivo subido con éxito","nodofarma":{"treatment":{"observations":"Observaciones"}},"legal-services":"legales","more-info":"Más información","form":{"disclaimers":{"communications":"Acepto recibir otras comunicaciones de {platform}.<br> Para poder proporcionarte el contenido solicitado, debemos almacenar y procesar tus datos."}},"signupDiscovery":{"title1":"Recomendación de profesional","title2":"Recomendación de paciente","title3":"Recomendación de centro","title4":"Web/Búsqueda en Internet","title5":"Redes sociales","title7":"Prensa","title8":"Radio","title9":"Televisión","title10":"Otros","title11":"Llamada telefónica","title2-openlegal":"Recomendación de cliente","title3-openlegal":"Recomendación de despacho/bufete","title1-openlegal":"Recomendación de abogado"},"emailRegistered":"Email ya registrado","insurances":"Aseguradoras","linkCopiedClipboard":"El enlace se ha copiado correctamente","saved":"Guardado","changesPerformedCorrectly":"Cambios realizados correctamente","logOff":"Cerrar sesión","logIn":"Iniciar sesión","search":"Buscar","ago":"hace","hours":"horas","days":"días","months":"meses","years":"años","minutes":"minutos","seconds":"segundos","answer":"Responder","loginTitle":"Iniciar sesión","defaultErrorMessage":"Se ha producido un error. Contacte con opensalud.","video-test":{"adblock-error":"Se ha detectado en su navegador un bloqueador de publicidad. Por favor, para asegurar que la videoconsulta se desarrolle correctamente desactívelo y pulse en el botón que encontrará a continuación."},"openlegal":{"title":"Estamos aquí para ayudarte","title1":"Estamos aquí para ayudarte"},"specialties":"Especialidades","services":"Servicios","sign-up-professional":"Registro para profesionales","sign-up-patient":"Registro para pacientes ","sign-up-centre":"Registro para centros","terms-and-conditions-patient":"Términos y condiciones legales para pacientes","terms-and-conditions-professional":"Términos y condiciones legales para profesionales","legal-warning":"Aviso legal","contact-title":"Contacto","faqs-title":"Centro de ayuda","terms-conditions":"Términos y condiciones","contact":"Contacto","legal-notice":"Aviso legal","cookies-policy":"Política de cookies","faqs":"Preguntas frecuentes","show":"mostrar","myProfile":"Mi perfil","close":"Cerrar","loginError":"El email o la contraseña son incorrectos","pregunta-1":"Pregunta de prueba","price":"Precio","patient-title":"Consulta médica online, videoconsulta y segunda opinión médica","business-title":"Salud y bienestar para empresas","invalidPromotionCode":"El código que ha introducido no es válido","error-required":"Debe de seleccionar una opción","services-title":{"type-one":"Consulta Presencial","type-two":"Videoconsulta Programada","type-three":"Chat","type-four":"Consulta Escrita","type-five":"Videoconsulta Inmediata","type-six":"Consulta a domicilio","type-seven":"Segunda Opinión","type-eight":"Paquetes de Servicio","type-nine":"Tarifa Plana Consulta Escrita y Chat","type-eleven":"Consulta por aseguradora","type-ten":"Un profesional te llama"},"label-specialties":"label","invalid-2facode":"El código no es válido","account":{"register-ok":"Registro realizado con éxito","set-email":"Establecer email"},"access":"Acceso","menu-opt":"Menú","edit":"Editar","doubts":"Dudas","videoTest":"Test de vídeo","signupMonth":{"january":"Enero","february":"Febrero","march":"Marzo","april":"Abril","may":"Mayo","june":"Junio","july":"Julio","august":"Agosto","september":"Septiembre","october":"Octubre","november":"Noviembre","december":"Diciembre"},"sign-up-customer":"Registro de cliente","sign-up-lawyer":"Registro de abogados","save":"Guardar","question":"Pregunta","unit":"Unidad","goal":"Objetivo","reminder":"Recordatorio","notes":"Notas","optional":"(opcional)","edited":"Editado","setting":"Configuración","orderBy":"Ordenar por...","chronological":"Cronológico","color":"Color","score":"Puntuación","ascending":"Ascendente","descending":"Descendente","description":"Descripción","calendar":"Calendario","notificationsEmail":"Email de notificaciones","notificationsPhone":"Teléfono de notificaciones","between":"entre","and":"y","error-alreadyregister":"Ha ocurrido un error en su registro, por favor revise sus campos.<br> Recuerde que si se encuentra registrado en openlegal podrá acceder a opensalud utilizando las mismas credenciales.","error-alreadyregister-openlegal":"Ha ocurrido un error en su registro, por favor revise sus campos.<br> Recuerde que si se encuentra registrado en opensalud podrá acceder a openlegal utilizando las mismas credenciales.","aca-error-title-page":"Ha ocurrido un error con su tarjeta ACA","aca-error-detail-page":"Parece haber un problema con el certificado de su tarjeta ACA, por favor, inténtelo de nuevo más tarde o póngase en contacto con nuestro soporte técnico.","access-verb":"Acceder","update":"Actualizar","error-checkextension":"Compruebe que el email y el código introducidos son correctos. Si el error persiste contacte al chat de soporte ubicado en la esquina inferior derecha.","error-checkemployeenumber":"Los datos introducidos no son válidos. Por favor, revíse el número de empleado introducido.","a2hs":{"modal-message":"¿Desea instalar la aplicación de {platform}?","modal-install-btn":"Instalar","safari-tooltip":"Para instalar esta webapp en tu iPhone/iPad, haz click en el icono {shareIconImg} en el menú del navegador de tu dispositivo y selecciona la opción 'Añadir a pantalla de inicio'"},"error-checkinternalcode":"Los datos introducidos no son válidos. Por favor, revíse el código interno introducido.","error-checkemployeenumber2":"Los datos introducidos no son válidos. Por favor, revíse el código interno introducido y asegúrese que su cónyuge se encuentra registrado/a en la plataforma.","bnpMSG":"Le informamos que únicamente se informará a su empresa del registro en la plataforma y nunca del uso que haga de la misma.","bnpMSG2":"Si continua con el registro entendemos que otorga su conformidad.","dontShowAgain":"No volver a mostrar","enterValue":"Introduzca un valor","finish":"Finalizar","value":"Valor","httpRequestDefaultError":"Ha ocurrido un error al procesar su solitud. Por favor, contacte con nuestro equipo técnico a través del chat de asistencia","soon":"próximamente","watch":"Ver","create":"Crear","undefined":"Indefinido","floor":"planta","changeUser":"Cambiar de usuario","complete":"Completar","datepicker-ph":"Seleccione una fecha","labelNoDateSelected":"No ha seleccionado ninguna fecha","current-month":"Mes actual","next-year":"Próximo año","next-month":"Próximo mes","prev-year":"Anterior año","prev-month":"Anterior mes","next-decade":"Próxima década","prev-decade":"Anterior década","date-picker":{"must-select-date-before-now":"Debe seleccionar una fecha anterior a la actual"},"selected-date":"Fecha seleccionada","reset":"Restablecer","noMatchingElements":"No hay elementos que cumplan el filtro seleccionado","recipients":"Destinatarios","weeks":"semanas","chart":{"moreRecent":"Más reciente","lessRecent":"Menos reciente","defaultChartTitle":"Gráfico","accesibility":{"announceNewData":{"newDataAnnounce":"Datos actualizados para el gráfico {chartTitle}.","newPointAnnounceMultiple":"Nuevo punto de datos en el gráfico {chartTitle}: {pointDesc}.","newPointAnnounceSingle":"Nuevo punto de datos: {pointDesc}.","newSeriesAnnounceMultiple":"Nueva serie de datos en el gráfico {chartTitle}: {seriesDesc}.","newSeriesAnnounceSingle":"Nueva serie de datos: {seriesDesc}."},"axis":{"rangeCategories":"Rango de datos: {numCategories} categorías.","rangeFromTo":"Los datos van desde {rangeFrom} a {rangeTo}.","timeRangeDays":"Rango de datos: {rango} días.","timeRangeHours":"Data range: {range} hours.","timeRangeMinutes":"Rango de datos: {rango} minutos.","timeRangeSeconds":"Rango de datos: {rango} segundos.","xAxisDescriptionPlural":"El gráfico tiene {numAxes} ejes X que muestran {#each(names, -1), }y {names[-1]}.","xAxisDescriptionSingular":"El gráfico tiene 1 eje X que muestra {names[0]}. {rangos[0]}","yAxisDescriptionPlural":"El gráfico tiene {numAxes} ejes Y que muestran {#each(names, -1), }y {names[-1]}.","yAxisDescriptionSingular":"El gráfico tiene 1 eje Y que muestra {names[0]}. {rangos[0]}"},"exporting":{"chartMenuLabel":"Menú de gráfico","menuButtonLabel":"Ver menú de gráfico, {chartTitle}"},"legend":{"legendItem":"Mostrar {nombre del elemento}","legendLabel":"Chart legend: {legendTitle}","legendLabelNoTitle":"Alternar la visibilidad de la serie, {chartTitle}"},"rangeSelector":{"clickButtonAnnouncement":"Viendo {axisRangeDescription}","dropdownLabel":"{rangeTitle}","maxInputLabel":"Seleccione la fecha de finalización.","minInputLabel":"Select start date."},"series":{"description":"{description}","nullPointValue":"Sin valor","pointAnnotationsDescription":"{Anotación: #each(annotations). }","xAxisDescription":"Eje X, {name}","yAxisDescription":"Eje Y, {name}"},"seriesTypeDescriptions":{"arearange":"Los gráficos de rango de áreas son gráficos de líneas que muestran un rango entre un valor más bajo y más alto para cada punto.","areasplinerange":"Estos gráficos son gráficos de líneas que muestran un rango entre un valor inferior y superior para cada punto.","columnrange":"Los gráficos de rango de columnas son gráficos de columnas que muestran un rango entre un valor inferior y superior para cada punto."},"table":{"tableSummary":"Representación en tabla del gráfico.","viewAsDataTableButtonText":"Ver como tabla de datos, {chartTitle}"},"zoom":{"mapZoomIn":"Zomm al gráfico","mapZoomOut":"Reducir zoom al gráfico","resetZoomButton":"Restablecer zoom"}},"navigaton":{"popup":{"addButton":"Añadir","algorithm":"Algoritmo","arrowInfinityLine":"Línea de flecha","arrowRay":"Rayo de flecha","arrowSegment":"Segmento de flecha","average":"Promedio","background":"Fondo","backgroundColor":"Color de fondo","backgroundColors":"Colores de fondo","borderColor":"Color del borde","borderRadius":"Radio del borde","borderWidth":"Anchura del borde","bottomBand":"Banda inferior","circle":"Círculo","clearFilter":"✕ limpiar filtro","color":"Color","connector":"Conetor","crooked3":"Línea 3 torcida","crooked5":"Línea 5 torcida","crosshairX":"Punto de mira X","crosshairY":"Punto de mira Y","decimals":"Decimales","deviation":"Desviación","editButton":"Editar","ellipse":"Elipse","factor":"Factor","fastAvgPeriod":"Período promedio rápido","fibonacciTimeZones":"Zonas horarias de Fibonacci","fill":"Llenar","flags":"Banderas","fontSize":"Tamaño de fuente","format":"Texto","height":"Altura","highIndex":"Índice alto","horizontalLine":"Línea horizontal","increment":"Incremento","index":"Índice","infinityLine":"Línea infinita","initialAccelerationFactor":"Factor de aceleración inicial","innerBackground":"Fondo interior","label":"Etiqueta","labelOptions":"Opciones de etiqueta","labels":"Etiquetas","line":"Línea","lines":"Líneas","longPeriod":"Período largo","lowIndex":"Índice bajo","maxAccelerationFactor":"Factor de aceleración máxima","measure":"Medida","measureX":"Medida X","measureXY":"Medida XY","measureY":"Medida Y","multiplier":"Multiplicador","multiplierATR":"Multiplicador ATR","name":"Nombre","noFilterMatch":"Sin coincidencia","outerBackground":"Fondo exterior","padding":"Relleno","parallelChannel":"Canal paralelo","period":"Período","periodATR":"Período ATR","periods":"Periodos","periodSenkouSpanB":"Período Senkou Span B","periodTenkan":"Período Tenkan","ranges":"Rangos","ray":"Rayo","rectangle":"Rectángulo","removeButton":"Eliminar","saveButton":"Guardar","searchIndicators":"Indicadores de búsqueda","segment":"Segmento","series":"Serie","shapeOptions":"Opciones de forma","shapes":"Opciones de forma","shortPeriod":"Periodo corto","signalPeriod":"Período de señal","simpleShapes":"Formas simples","slowAvgPeriod":"Periodo medio lento","standardDeviation":"Desviación Estándar","stroke":"Color de linea","strokeWidth":"Anchura del trazo","style":"Estilo","timeCycles":"Ciclos de tiempo","title":"Título","topBand":"Banda superior","tunnel":"Túnel","typeOptions":"Detalles","verticalArrow":"Flecha vertical","verticalCounter":"Contador vertical","verticalLabel":"Etiqueta vertical","verticalLine":"Línea vertical","volume":"Volumen","xAxisUnit":"Unidad del eje x"}},"weekdays":["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],"months":["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],"shortMonths":["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],"viewFullScreen":"Ver en pantalla completa","viewData":"Ver los datos de tabla","resetZoom":"Restablecer zoom","resetZoomTitle":"Resteblecer nivel de zoom 1:1","printChart":"Imprimir gráfico","noData":"Sin datos para mostrar","loading":"Cargando...","hideData":"Ocultar tabla de datos","exitFullScreen":"Salir de pantalla completa","donwloadXLS":"Descargar XLS","donwloadSVG":"Descargar SVG","downloadPNG":"Descargar PNG","downloadPDF":"Descargar PDF","downloadJPEG":"Descargar JPEG","downloadCSV":"Descargar CSV","contextButtonTitle":"Menú"},"day":"Día","change-user":{"select-user":"Seleccione un usuario...","error-select-user":"Por favor, seleccione el usuario al que desea cambiar"},"hide":"Ocultar","details":"Detalles","remove":"Eliminar","select":"Seleccionar","type":"Tipo","gender":"Sexo","frequency":"Frecuencia","next":"Próxima","insurance":"Aseguradora","single":"Particular","text-code-group":"De acuerdo con los compromisos firmados entre Open Healthcare/opensalud y Unipromel e Irelegal, al estar ya incluido en la base de datos de opensalud, si lo desea, puede acceder a los diversos servicios prestados por opensalud (software clínico, cuadro médico, directorio…) en condiciones preferentes. Le recordamos que Open Healthcare/ opensalud tiene certificado mediante la ISO27001 su sistema de gestión de seguridad de la información y ha sido asimismo validado por la Organización Médica Colegial.","text-code-group-main":"Autorizo la verificación de mi pertenencia a Unipromel y la comunicación a Unipromel de los datos relativos al registro en el cuadro médico y directorio","errorMessages":{"only-subscribed-users":"Servicio sólo para suscriptores."},"appointmentState":{"noConfirmed":"No confirmada","scheduled":"Programada"},"hideLowercase":"ocultar","modify":"Modificar","review":"Valorar","invoice":"Factura","from":"desde","to":"hasta","confirm":"Confirmar","defaultSuccessMessage":"La operación se ha realizado con éxito","see":"Ver","showMoreOptions":"Más opciones...","lang":"Idioma","centers":"Centros","notifications":{"appointmentCanceledByProf":"El profesional {profName} {title} {appointmentType} del {date}","hasCanceled":"ha cancelado su","hasScheduled":"le ha agendado una"},"soon-label":"Próximamente","know-more":"Conoce más","showOptions":"Opciones...","prescriptions":"Prescripciones","hour":"Hora","address":"Dirección","country":"País","state":"Provincia","city":"Municipio","startDate":"Fecha inicio","endDate":"Fecha fin","schedule":"Horario","filtersTitle":"Filtros","completed":"Completado","newMedicationReminder":"Nuevo recordatorio de medicamento","error-professionalregistered":"Ha ocurrido un error en su registro, por favor revise sus campos.","forMe":"Para mí","forMinor":"Para paciente menor","forPet":"Para mascota","understood":"Entendido","prefix":"Prefijo","phoneShort":"Teléfono","package":"Paquete","duration":"Duración","hire":"Contratar","open":"Abierto","closed":"Cerrado"}

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OPENSALUD_THEME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPENLEGAL_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNIPROMEL_THEME; });
/* unused harmony export HEALTHY_HABITS_THEME */
/* harmony export (immutable) */ __webpack_exports__["c"] = getThemeName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domains__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subdomains__ = __webpack_require__(158);



var OPENSALUD_THEME = 'opensalud';
var OPENLEGAL_THEME = 'openlegal';
var UNIPROMEL_THEME = 'unipromel';
var HEALTHY_HABITS_THEME = 'healthy-habits';

function getThemeName() {
    return window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_0__domains__["j" /* UNIPROMEL_DOMAIN */]) ? UNIPROMEL_THEME : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_1__subdomains__["i" /* HEALTHY_HABITS_SUBDOMAIN */]) ? HEALTHY_HABITS_THEME : window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_0__domains__["d" /* OPENLEGAL_DOMAIN */]) ? OPENLEGAL_THEME : OPENSALUD_THEME;
}

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_AccountRepository__ = __webpack_require__(180);






/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    defaultLoginCallback: function defaultLoginCallback() {
      var _this = this;

      var loginInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loginInfo = loginInfo || _this.$store.state.session.loginInfo;
                if (!loginInfo) {
                  _this.goLogin();
                }
                _context.next = 4;
                return _this.$store.dispatch('session/create', { token: loginInfo.apiToken, loginInfo: loginInfo, reload: false });

              case 4:
                if (!(loginInfo.user.roles && loginInfo.user.roles.includes(__WEBPACK_IMPORTED_MODULE_3__constants_roles__["f" /* PATIENT_ROLE */]) && !Object(__WEBPACK_IMPORTED_MODULE_2__constants_platformNames__["j" /* inOpenlegal */])())) {
                  _context.next = 18;
                  break;
                }

                if (!(loginInfo.user && Object(__WEBPACK_IMPORTED_MODULE_2__constants_platformNames__["k" /* inOpensalud360 */])() && !loginInfo.user.companyCode)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return _this.$router.push('/error/unauthorized/360');

              case 8:
                _context.next = 16;
                break;

              case 10:
                if (!((_this.$route.query.returnUrl || _this.$route.query.ReturnUrl) && loginInfo.returnUrl && loginInfo.ssoUri)) {
                  _context.next = 14;
                  break;
                }

                window.location.href = loginInfo.ssoUri;
                _context.next = 16;
                break;

              case 14:
                _context.next = 16;
                return _this.$router.push('/patient');

              case 16:
                _context.next = 19;
                break;

              case 18:
                window.location.href = loginInfo.ssoUri;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goLogin: function goLogin() {
      if (this.$route.query.returnUrl || this.$route.query.ReturnUrl) {
        this.$router.push({ path: '/inicio-sesion', query: { returnUrl: this.$route.query.returnUrl || this.$route.query.ReturnUrl } });
      } else {
        this.$router.push('/inicio-sesion');
      }
    },
    logOff: function logOff() {
      var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.$store.dispatch('session/remove');
      if (redirect) {
        this.$router.push('/');
      }
    },
    goProfile: function goProfile() {
      var profilePath = 'profile';
      switch (this.$store.state.session.user.userType) {
        case __WEBPACK_IMPORTED_MODULE_3__constants_roles__["f" /* PATIENT_ROLE */]:
          this.$helpers.goToPatientWebApp('' + profilePath, this.$apiToken);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__constants_roles__["h" /* PROFESSIONAL_ROLE */]:
          this.$helpers.goToWebApp('/HomeProfessional/#/' + profilePath);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__constants_roles__["e" /* CENTER_ROLE */]:
          this.$helpers.goToWebApp('/HomeCenter/#/' + profilePath);
          break;
      }
    },
    goToSessionRoot: function goToSessionRoot() {
      switch (this.$store.state.session.user.userType) {
        case __WEBPACK_IMPORTED_MODULE_3__constants_roles__["f" /* PATIENT_ROLE */]:
          this.$router.push('/patient');
          break;
        case __WEBPACK_IMPORTED_MODULE_3__constants_roles__["h" /* PROFESSIONAL_ROLE */]:
          this.$helpers.goToWebApp('/HomeProfessional/#/');
          break;
        case __WEBPACK_IMPORTED_MODULE_3__constants_roles__["e" /* CENTER_ROLE */]:
          this.$helpers.goToWebApp('/HomeCenter/#/');
          break;
      }
    },
    goHealthData: function goHealthData() {
      this.$helpers.goToPatientWebApp('history', this.$apiToken);
    },
    goAppointments: function goAppointments() {
      this.$helpers.goToPatientWebApp('appointments', this.$apiToken);
    },
    redirectIfAuthenticated: function redirectIfAuthenticated() {
      var forceAnyRedirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // Avoid redirecting to the same page
      var token = this.$apiToken;
      if (!token) {
        this.$store.dispatch('session/remove');
      } else if (this.$store.getters['session/userIsPatient']) {
        this.$router.push('/patient');
      } else if (this.$store.getters['session/userIsProfessional']) {
        this.$helpers.goToProfessionalWebApp('appointments', token);
      } else if (this.$store.getters['session/userIsCenter']) {
        this.$helpers.goToCenterWebApp('appointments', token);
      } else if (this.$store.getters.userIsAdmin) {
        this.$helpers.goToAdminWebApp('', token);
      } else if (forceAnyRedirect) {
        this.$router.push('/');
      } else {
        return;
      }
    },
    changeUser: function changeUser(patientId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4__repositories_AccountRepository__["a" /* default */].loginAssociatedPatient(patientId).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
                    var responseData, token;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this2.logOff(false);
                            responseData = response.data || (response.response ? response.response.data : null);
                            token = responseData.apiToken;

                            _this2.loginInfo = responseData;
                            _this2.$store.dispatch('session/set', responseData);
                            _context2.next = 7;
                            return _this2.$store.dispatch('session/create', { token: token, loginInfo: responseData, reload: false });

                          case 7:
                            _context2.next = 9;
                            return _this2.processRequiredFields(responseData.user, responseData.requiredFields, token);

                          case 9:
                            if (_context2.sent) {
                              _context2.next = 11;
                              break;
                            }

                            window.location.reload();

                          case 11:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    processRequiredFields: function processRequiredFields(user, requiredFields, token) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!requiredFields || requiredFields.length === 0)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return', false);

              case 2:
                _this3.$store.commit('session/setRequiredLoginFields', requiredFields);
                _this3.$store.commit('session/setUser', user);
                _context4.next = 6;
                return _this3.$router.push({ path: '/cuenta/actualizar-datos', query: { token: token } });

              case 6:
                return _context4.abrupt('return', true);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseInput_vue__ = __webpack_require__(1071);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac300cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseInput_vue__ = __webpack_require__(1639);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1637)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ac300cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac300cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ac300cb", Component.options)
  } else {
    hotAPI.reload("data-v-4ac300cb", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_layouts__ = __webpack_require__(50);







/* harmony default export */ __webpack_exports__["a"] = ({
	routerViewTemplate: '<router-view></router-view>',
	buildRoutes: function buildRoutes(path, children) {
		var layout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		var _this = this;
		return {
			path: path,
			component: layout || {
				template: _this.routerViewTemplate
			},
			children: children
		};
	},
	routeHasReducedLayout: function routeHasReducedLayout(route) {
		return (route || __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$route).meta.layout === __WEBPACK_IMPORTED_MODULE_5__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */];
	},
	completeRoutesMeta: function completeRoutesMeta(routes, roles) {
		var _this2 = this;

		var layout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__constants_layouts__["h" /* PRIVATE_LAYOUT */];
		var inheritedMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

		return routes.map(function (route) {
			route.meta = route.meta || {};
			route.meta.layout = route.meta.layout || layout;

			// Inherit meta attributes if they exist
			route.meta = _this2.buildInheritedMeta(route.meta, inheritedMeta);

			if (typeof roles === 'string') {
				roles = [roles];
			}
			route.meta.roles = route.meta.roles || [];
			// Check if any of the roles are missing in route.meta.roles
			roles.forEach(function (role) {
				if (!route.meta.roles.includes(role)) {
					route.meta.roles.push(role);
				}
			});

			// Complete children meta
			if (route.children) {
				route.children = _this2.completeRoutesMeta(route.children, roles, route.meta.layout, _this2.buildBequeathedMeta(route.meta));
			}
			return route;
		});
	},
	buildBequeathedMeta: function buildBequeathedMeta(meta) {
		var metaToBequeath = meta.bequeath === true ? meta : {};
		if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(meta.bequeath) === Array && meta.bequeath.length > 0) {
			// Inherit only the specified meta attributes in route.meta.bequeath
			metaToBequeath = meta.bequeath.map(function (prop) {
				var obj = {};
				obj[prop] = meta[key];
				return obj;
			});
		}
		return metaToBequeath;
	},
	buildInheritedMeta: function buildInheritedMeta(meta) {
		var inheritedMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(inheritedMeta).length > 0) {
			if (inheritedMeta.i18n && meta.i18n) {
				if (!Array.isArray(inheritedMeta.i18n)) inheritedMeta.i18n = [inheritedMeta.i18n];
				if (!Array.isArray(meta.i18n)) meta.i18n = [meta.i18n];
				meta.i18n = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(inheritedMeta.i18n), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(meta.i18n));
			}
			meta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, inheritedMeta, meta);
		}
		return meta;
	}
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAppUrl */
/* unused harmony export getPatientAppUrl */
/* unused harmony export getCustomPageUrl */
/* unused harmony export getMenttumUrl */
/* unused harmony export getV2AppUrl */
/* unused harmony export getApiUrl */
/* unused harmony export getDomainsJsonUrl */
/* unused harmony export get360AppUrl */
/* unused harmony export getHealthyCommunityUrl */
/* unused harmony export getHabitsUrl */
/* unused harmony export getPatientsLikeYouUrl */
/* unused harmony export getSubdomain */
/* unused harmony export getRelativeHref */
/* unused harmony export goToWebApp */
/* unused harmony export goToPatientWebApp */
/* unused harmony export goToProfessionalWebApp */
/* unused harmony export goToCenterWebApp */
/* unused harmony export goToAdminWebApp */
/* unused harmony export getApiLoginToUrl */
/* unused harmony export goToHabits */
/* unused harmony export goToForum */
/* unused harmony export goToACAUrl */
/* unused harmony export goToBlog */
/* unused harmony export getProfessionalsLandingUrl */
/* unused harmony export goToProfessionalsLanding */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_domains_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_domains_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_cookies__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__ = __webpack_require__(47);






function getAppUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var portal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return 'https://' + (portal || Object(__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["h" /* getPortal */])()) + (!(path.indexOf('api/') > -1) ? '/' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].locale : '') + '/' + path;
}

function getPatientAppUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		return this.getAppUrl('HomePaciente/#/' + path);
}

function getCustomPageUrl(url, path) {
		if (!url) {
				return '';
		}
		var apiToken = window.$cookies.get(__WEBPACK_IMPORTED_MODULE_2__constants_cookies__["b" /* API_TOKEN_COOKIE_NAME */]);
		return url + '/' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].locale + (path || '') + '?host=' + encodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["h" /* getPortal */])()) + (apiToken ? '&token=' + apiToken : '') + (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? '&mx=1' : '');
}

function getMenttumUrl() {
		return (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["i" /* inDevelopmentEnv */] || __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["n" /* inStagingEnv */] ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appV2DomainMX : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appTestV2DomainMX : __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["i" /* inDevelopmentEnv */] || __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["n" /* inStagingEnv */] ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appV2DomainES : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appTestV2DomainES) + '/patient/menttum';
}

function getV2AppUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var forceEs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		var forceMx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		var v2AppDomain = void 0;
		var isMxLink = (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] || forceMx) && !forceEs;
		if (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["k" /* inLocalEnv */]) {
				v2AppDomain = __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appV2LocalDomain;
		} else if (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["i" /* inDevelopmentEnv */]) {
				v2AppDomain = isMxLink ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appDevV2DomainMX : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appDevV2DomainES;
		} else if (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["n" /* inStagingEnv */]) {
				v2AppDomain = isMxLink ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appTestV2DomainMX : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appTestV2DomainES;
		} else {
				v2AppDomain = isMxLink ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appV2DomainMX : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.appV2DomainES;
		}
		return v2AppDomain + '/' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].locale + '/' + path;
}

function getApiUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		var v2AppDomain = __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["k" /* inLocalEnv */] ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.apis.api.local : __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["i" /* inDevelopmentEnv */] ? __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.apis.api.mx.development : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.apis.api.es.development : __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["n" /* inStagingEnv */] ? __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.apiTestDomainMX : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.apiTestDomainES : __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.apiDomainMX : __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.apiDomainES;
		return v2AppDomain + '/' + path;
}

function getDomainsJsonUrl(key) {
		var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		var domain = void 0;
		if (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["k" /* inLocalEnv */]) {
				domain = __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a[key].local;
		} else {
				domain = __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a[key][__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["a" /* country */]][__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["b" /* environment */]];
		}
		return domain + '/' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].locale + '/' + path;
}

function get360AppUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		return this.getDomainsJsonUrl('360', path);
}

function getHealthyCommunityUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		return this.getDomainsJsonUrl('healthy-community', path);
}

function getHabitsUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		return this.getDomainsJsonUrl('habits', path);
}

function getPatientsLikeYouUrl() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		return this.getDomainsJsonUrl('patients-like-you', path);
}

function getSubdomain() {
		return __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["i" /* inDevelopmentEnv */] ? __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a['testSubdomain'] : window.location.hostname.split('.')[0];
}

function getRelativeHref(path, relativePath) {
		if (__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["m" /* inProductionEnv */]) {
				return path;
		} else {
				return '/' + relativePath + '/' + path;
		}
}

function goToWebApp() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var portal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		var url = this.getAppUrl(path, portal);
		window.location.href = !window.$cookies.get(__WEBPACK_IMPORTED_MODULE_2__constants_cookies__["c" /* ASPNET_APPLICATION_COOKIE_NAME */]) && token ? this.getApiLoginToUrl(token, url, portal) : url;
}

function goToPatientWebApp() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		this.goToWebApp('Home' + (Object(__WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["j" /* inOpenlegal */])() ? 'Cliente' : 'Paciente') + '/#/' + path, token);
}

function goToProfessionalWebApp() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		this.goToWebApp('Home' + (Object(__WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["j" /* inOpenlegal */])() ? 'Abogado' : 'Profesional') + '/#/' + path, token);
}

function goToCenterWebApp() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		this.goToWebApp('Home' + (Object(__WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["j" /* inOpenlegal */])() ? 'Bufete' : 'Centro') + '/#/' + path, token);
}

function goToAdminWebApp() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		this.goToWebApp('HomeAdmin/' + path, token);
}

function getApiLoginToUrl(token, url) {
		var portal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return '' + this.getAppUrl('Account/ApiLoginToUrl?token=' + token + '&url=' + encodeURIComponent(url) + '&referer=' + encodeURIComponent(window.location.host), portal);
}

function goToHabits() {
		window.open(this.getHabitsUrl(), '_blank');
}

function goToForum() {
		window.open(this.getHealthyCommunityUrl('pacientescomotu'), '_blank');
}

function goToACAUrl() {
		window.location.href = __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.tarjetaACA[__WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["b" /* environment */]];
}

function goToBlog() {
		window.location.href = __WEBPACK_IMPORTED_MODULE_0__static_domains_json___default.a.blog;
}

function getProfessionalsLandingUrl() {
		return __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? '/profesionales' : 'https://prime.opensalud.es/' + __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].locale + '/profesionales';
}

function goToProfessionalsLanding() {
		window.location = getProfessionalsLandingUrl();
}

/* harmony default export */ __webpack_exports__["a"] = ({
		getAppUrl: getAppUrl,
		getPatientAppUrl: getPatientAppUrl,
		getV2AppUrl: getV2AppUrl,
		getApiUrl: getApiUrl,
		getDomainsJsonUrl: getDomainsJsonUrl,
		get360AppUrl: get360AppUrl,
		getHealthyCommunityUrl: getHealthyCommunityUrl,
		getHabitsUrl: getHabitsUrl,
		getPatientsLikeYouUrl: getPatientsLikeYouUrl,
		getMenttumUrl: getMenttumUrl,
		getSubdomain: getSubdomain,
		getRelativeHref: getRelativeHref,
		goToWebApp: goToWebApp,
		goToPatientWebApp: goToPatientWebApp,
		goToProfessionalWebApp: goToProfessionalWebApp,
		goToCenterWebApp: goToCenterWebApp,
		goToAdminWebApp: goToAdminWebApp,
		getApiLoginToUrl: getApiLoginToUrl,
		goToHabits: goToHabits,
		goToForum: goToForum,
		getCustomPageUrl: getCustomPageUrl,
		goToACAUrl: goToACAUrl,
		goToBlog: goToBlog,
		getProfessionalsLandingUrl: getProfessionalsLandingUrl,
		goToProfessionalsLanding: goToProfessionalsLanding
});

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MESSAGE_SEEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return KICKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOG_OFF; });
/* unused harmony export NEW_DOCUMENT */
/* unused harmony export REFRESH_CHAT_CONTACT_STATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NEW_APPOINTMENT; });
/* unused harmony export INMEDIATA_ERROR */
/* unused harmony export VIDEO_CANCELED */
/* unused harmony export ACCEPT */
/* unused harmony export CHAT_CANCELED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPOINTMENT_CANCELED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NEW_CHAT_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EDIT_CHAT_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_CHAT_MESSAGE; });
/* unused harmony export REJECTED */
/* unused harmony export NEW_CONSOLIDATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INMEDIATA_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return WRITTEN_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHAT_NOTIFICATION; });
/* unused harmony export CHAT_CREATED_BY_DOCTOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALL_NOTIFICATION; });
/* unused harmony export ACTIVE_CHAT_ALERT */
/* unused harmony export ACTIVE_WRITTEN_ALERT */
/* unused harmony export ACTIVE_CALL_ALERT */
/* unused harmony export CHAT_CONSOLIDATED */
/* unused harmony export REFRESH_TAB_COMPANIES */
/* unused harmony export APPOINTMENT_ASSIGNED_CENTER */
/* unused harmony export NEW_INSTANT_APPOINTMENT */
/* unused harmony export VIDEO_NOTIFICATION */
/* unused harmony export RESET_VIDEO_NOTIFICATION */
/* unused harmony export ENABLE_QUEUE_BUTTON */
/* unused harmony export DISABLE_QUEUE_BUTTON */
/* unused harmony export ENABLE_WRITTEN_BUTTON */
/* unused harmony export DISABLE_WRITTEN_BUTTON */
/* unused harmony export ALERT_WAITING */
/* unused harmony export ALERT_IONMEDIATE */
/* unused harmony export APPOINTMENT_RECEIVED */
/* unused harmony export CHAT_RECEIVED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NOTIFICATION_TYPE_COMMANDS; });
// Common

var MESSAGE_SEEN = 'MessageSeen';
var KICKOUT = 'Kickout';
var LOG_OFF = 'LogOff';
var NEW_DOCUMENT = 'NewDocument';
var REFRESH_CHAT_CONTACT_STATE = 'RefreshChatContactsState';
var NEW_APPOINTMENT = 'NewAppointment';
var INMEDIATA_ERROR = 'InmediataError';
var VIDEO_CANCELED = 'VideoCanceled';
var ACCEPT = 'Accept';
var CHAT_CANCELED = 'ChatCanceled';
var APPOINTMENT_CANCELED = 'AppointmentCanceled';
var NEW_CHAT_MESSAGE = 'NewChatMessage';
var EDIT_CHAT_MESSAGE = 'EditChatMessage';
var DELETE_CHAT_MESSAGE = 'DeleteChatMessage';

// Patient

var REJECTED = 'Rejected';
var NEW_CONSOLIDATION = 'NewConsolidation';
var INMEDIATA_NOTIFICATION = 'InmediataNotification';
var WRITTEN_NOTIFICATION = 'WrittenNotification';
var CHAT_NOTIFICATION = 'ChatNotification';
var CHAT_CREATED_BY_DOCTOR = 'ChatCreatedByDoctor';
var CALL_NOTIFICATION = 'CallNotification';
var ACTIVE_CHAT_ALERT = 'ActiveChatAlert';
var ACTIVE_WRITTEN_ALERT = 'ActiveWrittenAlert';
var ACTIVE_CALL_ALERT = 'ActivecCallAlert';
var CHAT_CONSOLIDATED = 'ChatConsolidated';
var REFRESH_TAB_COMPANIES = 'RefreshTabCompanies';
var APPOINTMENT_ASSIGNED_CENTER = 'AppointmentAssignedCenter';

// Professional
var NEW_INSTANT_APPOINTMENT = 'NewInstantAppointment';
var VIDEO_NOTIFICATION = 'VideoNotification';
var RESET_VIDEO_NOTIFICATION = 'ResetVideoNotification';
var ENABLE_QUEUE_BUTTON = 'EnableQueueButton';
var DISABLE_QUEUE_BUTTON = 'DisableQueueButton';
var ENABLE_WRITTEN_BUTTON = 'EnableWrittenButton';
var DISABLE_WRITTEN_BUTTON = 'DisableWrittenButton';
var ALERT_WAITING = 'AlertWaiting';
var ALERT_IONMEDIATE = 'AlertImmediate';
var APPOINTMENT_RECEIVED = 'AppointmentReceived';
var CHAT_RECEIVED = 'ChatReceived';

// Center


var NOTIFICATION_TYPE_COMMANDS = [NEW_CONSOLIDATION, INMEDIATA_NOTIFICATION, WRITTEN_NOTIFICATION, CHAT_NOTIFICATION, CALL_NOTIFICATION, NEW_CHAT_MESSAGE, EDIT_CHAT_MESSAGE, DELETE_CHAT_MESSAGE, CHAT_CONSOLIDATED, CHAT_CREATED_BY_DOCTOR, ACTIVE_CHAT_ALERT, ACTIVE_WRITTEN_ALERT, ACTIVE_CALL_ALERT, NEW_APPOINTMENT, NEW_DOCUMENT, CHAT_CANCELED, VIDEO_CANCELED];

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_ui_BaseAlert_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_microhabits__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_survey__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_session__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_video__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_forum__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_healthyHabits__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_signalr__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_tests__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_notifications__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_modules_layout__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_modules_chat__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_vuex_persistence__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_i18n__ = __webpack_require__(30);



















__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
/* 
const MODULES_TO_PERSIST = ['session', 'video', 'food'] */

// In video module for example we don't want to persist the whole state
var STATE_REDUCER_FN = function STATE_REDUCER_FN(state) {
  // MODULES_NOT_TO_PERSIST: ['healthyHabits', 'forum', 'tests', 'signalR', 'layout'], foods is in ...rest object
  var session = state.session,
      video = state.video,
      healthyHabits = state.healthyHabits,
      forum = state.forum,
      tests = state.tests,
      signalr = state.signalr,
      notifications = state.notifications,
      layout = state.layout,
      rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(state, ['session', 'video', 'healthyHabits', 'forum', 'tests', 'signalr', 'notifications', 'layout']);
  // Only persist useLamp and useStethoscope from video module


  var useLamp = video.useLamp,
      useStethoscope = video.useStethoscope;
  // Exclude sharedDialog and loading from global state

  var sharedDialog = rest.sharedDialog,
      cookiesBannerVisible = rest.cookiesBannerVisible,
      loading = rest.loading,
      clinicHistory = rest.clinicHistory,
      restGlobal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(rest, ['sharedDialog', 'cookiesBannerVisible', 'loading', 'clinicHistory']);
  // Exclude logged from session module


  var logged = session.logged,
      loginCallback = session.loginCallback,
      restSession = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(session, ['logged', 'loginCallback']);
  // Exclude retrievedLiveStates, summary from notifications module


  var retrievedLiveStates = notifications.retrievedLiveStates,
      summary = notifications.summary,
      restNotifications = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(notifications, ['retrievedLiveStates', 'summary']);

  var reducedState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ session: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restSession), video: { useLamp: useLamp, useStethoscope: useStethoscope }, notifications: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restNotifications) }, restGlobal);
  return reducedState;
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  modules: {
    microhabits: __WEBPACK_IMPORTED_MODULE_5__store_modules_microhabits__["a" /* default */],
    survey: __WEBPACK_IMPORTED_MODULE_6__store_modules_survey__["a" /* default */],
    session: __WEBPACK_IMPORTED_MODULE_7__store_modules_session__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_8__store_modules_video__["a" /* default */],
    forum: __WEBPACK_IMPORTED_MODULE_9__store_modules_forum__["a" /* default */],
    healthyHabits: __WEBPACK_IMPORTED_MODULE_10__store_modules_healthyHabits__["a" /* default */],
    tests: __WEBPACK_IMPORTED_MODULE_12__store_modules_tests__["a" /* default */],
    signalr: __WEBPACK_IMPORTED_MODULE_11__store_modules_signalr__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_13__store_modules_notifications__["a" /* default */],
    layout: __WEBPACK_IMPORTED_MODULE_14__store_modules_layout__["a" /* default */],
    chat: __WEBPACK_IMPORTED_MODULE_15__store_modules_chat__["a" /* default */]
  },
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_16__plugins_vuex_persistence__["a" /* default */])(STATE_REDUCER_FN).plugin],
  state: function state() {
    return {
      loading: false,
      sharedDialog: {
        visible: false,
        title: null,
        content: '',
        okFn: function okFn() {}
      },
      cookiesBannerVisible: true,
      errorPageMessage: null,
      clinicHistory: {
        sidebarHidden: true
      },
      smartsuppChatLoaded: false
    };
  },

  mutations: {
    setLoading: function setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setSharedDialog: function setSharedDialog(state, _ref) {
      var content = _ref.content,
          _ref$okFn = _ref.okFn,
          okFn = _ref$okFn === undefined ? null : _ref$okFn,
          _ref$okBtnText = _ref.okBtnText,
          okBtnText = _ref$okBtnText === undefined ? null : _ref$okBtnText,
          _ref$size = _ref.size,
          size = _ref$size === undefined ? 'md' : _ref$size;

      state.sharedDialog.content = content;
      state.sharedDialog.okFn = okFn || function () {
        state.sharedDialog.visible = false;
      };
      state.sharedDialog.okBtnText = okBtnText;
      state.sharedDialog.visible = true;
      state.sharedDialog.size = size;
    },
    hideSharedDialog: function hideSharedDialog(state) {
      state.sharedDialog.visible = false;
    },
    setSharedDialogVisible: function setSharedDialogVisible(state, visible) {
      state.sharedDialog.visible = visible;
    },
    setCookiesBannerVisible: function setCookiesBannerVisible(state, visible) {
      state.cookiesBannerVisible = visible;
    },
    setErrorPageMessage: function setErrorPageMessage(state, msg) {
      state.errorPageMessage = msg;
    }
  },
  actions: {
    showSharedDialog: function showSharedDialog(_ref2, _ref3) {
      var commit = _ref2.commit;
      var content = _ref3.content,
          _ref3$okFn = _ref3.okFn,
          okFn = _ref3$okFn === undefined ? null : _ref3$okFn,
          _ref3$okBtnText = _ref3.okBtnText,
          okBtnText = _ref3$okBtnText === undefined ? null : _ref3$okBtnText,
          _ref3$size = _ref3.size,
          size = _ref3$size === undefined ? 'md' : _ref3$size;

      commit('setSharedDialog', { content: content, okFn: okFn, okBtnText: okBtnText, size: size });
    },
    showAlert: function showAlert(state, _ref4) {
      var text = _ref4.text,
          variant = _ref4.variant;

      variant = variant || 'success';
      var BaseAlertClass = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4__components_base_ui_BaseAlert_vue__["a" /* default */]);
      var baseAlertInstance = new BaseAlertClass({
        propsData: {
          value: true,
          variant: variant
        }
      });
      baseAlertInstance.$slots.default = [text];
      baseAlertInstance.$mount();
      document.getElementById('app').prepend(baseAlertInstance.$el);
    },
    showDangerAlert: function showDangerAlert(_ref5, text) {
      var dispatch = _ref5.dispatch;

      dispatch('showAlert', { text: text || __WEBPACK_IMPORTED_MODULE_17__plugins_i18n__["a" /* default */].t('errors.error-has-ocurred'), variant: 'danger' });
    },
    showSuccessAlert: function showSuccessAlert(_ref6, text) {
      var dispatch = _ref6.dispatch;

      dispatch('showAlert', { text: text, variant: 'success' });
    },
    showInfoAlert: function showInfoAlert(_ref7, text) {
      var dispatch = _ref7.dispatch;

      dispatch('showAlert', { text: text, variant: 'info' });
    },
    showOnlySubscriptorsDialog: function showOnlySubscriptorsDialog(_ref8) {
      var dispatch = _ref8.dispatch;

      dispatch('showSharedDialog', {
        content: __WEBPACK_IMPORTED_MODULE_17__plugins_i18n__["a" /* default */].t('patient-panel.only-subscriptors-warning'),
        okBtnText: __WEBPACK_IMPORTED_MODULE_17__plugins_i18n__["a" /* default */].t('know-more'),
        size: 'sm'
      });
    }
  }
}));

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowButton_vue__ = __webpack_require__(1090);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac5e33f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowButton_vue__ = __webpack_require__(1708);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1706)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac5e33f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/ArrowButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ac5e33f", Component.options)
  } else {
    hotAPI.reload("data-v-4ac5e33f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */,
/* 224 */
/***/ (function(module, exports) {

module.exports = {"global":{"absentismo":"absentismo","factura":"la factura","contact-email":"soporte@openhealth.es"}}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = {"openlegal":{"derecho-fiscal-tributario":{"title":"Derecho fiscal y tributario","description":"El Derecho Fiscal y Tributario regula la obtención de recursos por parte de las Administraciones públicas, sobre todo, en cuanto a impuestos, tasas y tributos se refiere. En materia fiscal y tributaria en Openlegal proporcionamos a nuestros clientes servicios de planificación y estrategia fiscal, asesoramiento sobre el cumplimiento de las obligaciones fiscales, liquidación y presentación de impuestos, gestión de inspecciones, escritos de alegaciones, recursos ante resoluciones desestimatorias así como cuantas actuaciones y necesidades se generen a nuestros clientes.<br><br>Si necesitas un especialista en derecho fiscal y tributario, no dudes en consultarnos a Openlegal, encontraremos tu mejor solución."},"derecho-constitucional":{"title":"Derecho constitucional","description":"El Derecho Constitucional integra las normas de Derecho Público que establecen las fuentes, reglas y principios fundamentales por los que se rige nuestro Ordenamiento Jurídico.<br><br>El Derecho Constitucional protege los derechos de los ciudadanos consagrados en la Constitución Española, siendo esta la norma fundamental de nuestro Estado de Derecho.<br><br>La prestación de servicios en esta materia en Openlegal se centra, por experiencia en la presentación de recursos de amparo (en los que se solicita la protección constitucional ante la vulneración de derechos fundamentales), y procedimientos para la defensa de derechos constitucionales como el honor, la intimidad y la propia imagen.<br><br>Si crees que tus derechos fundamentales han sido vulnerados, confía en Openlegal, te ayudaremos a conseguir la compensación y el resarcimiento de los mismos."},"derecho-laboral":{"title":"Derecho laboral","description":"El Derecho Laboral o derecho del trabajo es el conjunto de normas que regulan la relación entre empresarios y trabajadores. Este conjunto de leyes aborda aspectos fundamentales de la relación laboral como modalidades de contratación, horarios, salarios, permisos, indemnizaciones, despidos, subvenciones, entre otros aspectos.<br><br>En Openlegal contamos con un equipo especializado en la prestación de todo tidpo de servicios laborales, ya sea de asesoría: elaboración de nóminas, seguros sociales, cotizaciones, etc. como desde el punto de vista jurídico, juicios ante la jurisdicción social, despidos, reclamaciones de cantidad por impago de salarios…"},"derecho-administrativo":{"title":"Derecho administrativo","description":"El Derecho Administrativo es la rama del Derecho público que regula la organización, funcionamiento, poderes y deberes de la Administración Pública y su relación jurídica con los ciudadanos. Todo acto llevado a cabo por una Administración (Estatal, autonómica, local o foral) es un acto administrativo regulado por esta rama del Derecho.<br><br>La prestación de servicios en esta materia se centra en la solicitud de determinadas prestaciones y Derechos a la Administración y en la realización de alegaciones, impugnaciones y recursos ante la misma.<br><br>Si necesitas interponer algún procedimiento administrativo o realizar cualquier gestión ante la Administración competente, en Openlegal satisfacemos tus necesidades."},"derecho-familia":{"title":"Derecho de familia","description":"El Derecho de Familia es el conjunto de normas jurídicas que regulan los asuntos que afectan a los miembros de una familia, entendida como una institución natural y social. El Derecho de Familia se enmarca dentro del ámbito del Derecho Civil, que regula los principales aspectos de esta especialidad, y se complementa con una serie de leyes específicas que se han promulgado para adaptar la regulación de esta institución a la realidad social.<br><br>El Derecho de Familia regula, entre otros, los siguientes aspectos:<ul><li>El matrimonio: la ley establece tanto las formas válidas de celebración como los efectos personales y económicos que implica este vínculo legal. También aborda las situaciones de crisis que derivan en su nulidad, en la separación de la pareja o la disolución del vínculo, o en el divorcio.</li><li>Las figuras asemejadas al matrimonio, tales como parejas de hecho o simplemente uniones de las cuales, aunque de forma no reglada, surgen derechos y obligaciones.</li><li>Los matrimonios y uniones internacionales: hablamos de parejas formadas por miembros de distintas nacionalidades y culturas, que conforman un sector dentro del Derecho de Familia con una normativa específica cuya casuística—cada día más frecuente por el aumento exponencial de la inmigración—es preciso que dominen los profesionales de Derecho.</li><li>La filiación: es el vínculo entre padres e hijos, bien matrimoniales, bien extramatrimoniales o adoptivos, y abarca también la patria potestad (relación con los hijos no emancipados).</li><li>La tutela: conjunto de normas referentes a la guarda y protección de menores o personas incapacitadas que no están sujetas a la patria potestad.</li><li>El patrimonio familiar: conformado por el conjunto de bienes, derechos y obligaciones que es necesario gestionar y/o en su caso poder liquidar y adjudicar en caso de muerte o disolución del vínculo matrimonial o separación de la pareja de hecho.</li></ul><br>¿Quieres separarte o divorciarte y no conoces que debes hacer o cuáles son tus derechos e intereses? ¿Y los de tu hijo? ¿Necesitas liquidar la sociedad de gananciales? ¿Quieres reconocer o impugnar la filiación de tu hijo? Si tienes estas y otras preguntas relacionadas con el Derecho de Familia, cuenta con Openlegal, resolveremos todas tus dudas y te ayudaremos a conseguir lo que deseas."},"derecho-sucesiones-herencias":{"title":"Derecho de sucesiones y herencias","description":"El derecho de sucesiones es aquella parte del derecho privado que regula la sucesión mortis causa y determina el destino de las titularidades (bienes y derechos) y relaciones jurídicas tanto activas como pasivas (obligaciones) de una persona después de su muerte.<br><br>En la regulación de las sucesiones, se contemplan importantes aspectos, tales como:<ul><li>Destino que se le van a dar a los bienes del difunto o causante. Se determina el ámbito de actuación de la autonomía de la voluntad, las normas imperativas que sean necesarias y las normas dispositivas que suplirán la voluntad del causante, en caso de no existir testamento.</li><li>Requisitos de validez del testamento, con la finalidad de asegurar que lo que aparezca en él sea realmente la voluntad del testador.</li><li>Los trámites necesarios para el reparto del caudal relicto.</li></ul><br>Si deseas asesorarte para hacer testamento, si has resultado heredero y tienes algunas dudas sobre la herencia o necesitas impugnar un testamento porque crees que tus derechos han sido vulnerados, cuenta con Openlegal , tenemos los mejores expertos en Derecho de sucesiones."},"derecho-mercantil":{"title":"Derecho mercantil","description":"El Derecho Mercantil, es la rama del derecho privado que regula los actos de comercio, el estatuto de los empresarios y las actividades que desempeñan en el mercado. Se regulan igualmente los actos de comercio en general, independientemente de que se realicen o no por medio de comerciantes y de que sean o no comerciales en su sentido económico. También se incluyen en esta materia instituciones de lo que se conoce como Derecho de la competencia; Son instituciones que surgieron de forma autónoma pero que se fueron sumando a la doctrina y a la evolución legislativa en la propiedad industrial, formado por patentes, marcas, nombres comerciales, y diseño industrial. Igualmente, en el derecho mercantil se incluye la defensa de la competencia y la competencia desleal así como la regulación del concurso de acreedores cuando un empresario se encuentra en situación de insolvencia o “quiebra”.<br><br>Si necesitas registrar alguna patente o marca o crees que la tuya ha sido copiada o tienes cualquier otra necesidad mercantil, no dudes en contactar, con Openlegal estaremos encantados de ayudarte."},"derecho-internacional-privado":{"title":"Derecho internacional privado","description":"El Derecho Internacional Privado es aquella rama del derecho que tiene como objeto los conflictos de competencia internacionales, los conflictos de leyes internacionales, la cooperación procesal y determinar la condición jurídica de los extranjeros.<br><br>Esta rama del derecho analiza las relaciones jurídicas internacionales ya sea entre privados, o donde existe un interés privado. Esta relación jurídica tiene la particularidad de solventar conflictos de jurisdicción o de ley aplicable, teniendo como objeto determinar quién puede conocer sobre el tema y qué derecho debe ser aplicado.<br><br>Si te hallas ante una situación que requiere la resolución de un conflicto internacional privado, Openlegal, contamos con los mejores profesionales para que te asesoren sobre la mejor forma de resolverlo."},"derecho-urbano":{"title":"Derecho urbanístico","description":"El concepto de Derecho urbanístico atiende a un conjunto de normas que regulan los procesos de ordenación del territorio y la transformación física que se da debido a la urbanización y edificación. Por lo tanto, entre sus competencias está la de organizar el conjunto del territorio, los procesos que supone la urbanización y el control de la edificación que se da a consecuencia de esta urbanización.<br><br>Actualmente, esta actividad legislativa deriva en las Comunidades Autónomas, quedando la regulación estatal en un segundo plano y limitándose a la fijación de un conjunto de postulados básicos y genéricos.<br><br>¿Qué materias comprende el derecho urbanístico?<ul><li>La regulación del régimen del suelo, siendo competencia del Estado que se cumplan las condiciones básicas garantizando la igualdad en el ejercicio de los derechos y obedeciendo a los deberes constitucionales relacionados con el suelo.</li><li>La ordenación del territorio.</li><li>Todos aquellos aspectos relacionados con la materia urbanística, ya sea su planeamiento, la ejecución de este planeamiento y su disciplina.</li><li>Materia administrativa vinculada al mercado del suelo y la vivienda.</li><li>Disciplina jurídica en relación a las valoraciones del suelo y las instalaciones, construcciones y edificaciones que se llevan a cabo.</li><li>La expropiación forzosa por razón de urbanismo.</li><li>La responsabilidad patrimonial por razón de urbanismo.</li></ul><br>¿Tienes algún problema con la obtención de licencia urbanística, crees que tu vecina ha realizado obras ilegales? Si tienes estas u otras preguntas de tipo urbanístico, en Openlegal estamos para ayudarte, contamos con los mejores expertos en urbanismo para que te pongas en sus manos y resolver tus problemas."},"derecho-bancario":{"title":"Derecho bancario","description":"El derecho bancario es la rama del derecho que estudia las normas que regulan el funcionamiento de los bancos y actividades bancarias y, en general, todas las entidades financieras.<br><br>Muchas entidades financieras han sido homologadas como bancos para someterlas a la normativa bancaria, por eso se suele hablar conjuntamente de derecho bancario y financiero. Sin embargo, dentro de este campo existen también reglas específicas para cada tipo de entidad, ya sean bancos, cajas de ahorro, cooperativas de crédito, entidades de financiación, etc.<br><br>También se incluyen en esta denominación los asuntos relativos a los mercados financieros, y las relaciones entre entidades bancarias y clientes. Así, entendemos la actividad bancaria tanto desde el punto de vista de las relaciones de negocio o contractuales como del sistema organizativo de las entidades.<br><br>Si necesitas asesoramiento sobre Derecho Bancario o si crees que alguno de los contratos o cláusulas que has firmado con tu Banco puede ser abusiva, no dudes en contactar con Openlegal, resolveremos tus dudas y te ayudaremos con lo que necesites."},"corporate-compliance":{"title":"Corporate compliance","description":"El Corporate Compliance es un conjunto de procedimientos y buenas prácticas adoptados por las organizaciones para identificar y clasificar los riesgos operativos y legales a los que se enfrentan y establecer mecanismos internos de prevención, gestión y control de los mismos.<br><br>El corporate compliance se ha convertido en uno de los requisitos con más influencia para una gestión óptima de las empresas. Aunque el término comenzó a imponerse con la finalidad de cumplir con las legislaciones internacionales, nacionales y locales, su relevancia va más allá. Prevención de delitos y sanciones, organización, ética, imagen social y con ello mayor rentabilidad, son las principales consecuencias de una estrategia de compliance corporativo.<br><br>Quieres asesorarte sobre la implantación de un plan de prevención de delitos en tu empresa, necesitas instaurar una política de compliance en tu compañía como el Canal de denuncias, Código Ética, Política de Anticorrupción, Plan de igualdad o Protocolo frente al acoso sexual y acoso por razón de sexo en el trabajo, en Openlegal contamos con profesionales especializados en la materia y con una dilatada experiencia en el sector, los cuáles escucharan tus necesidades y desarrollarán las políticas necesarias totalmente adaptadas a la realidad de tu organización."},"derecho-transporte":{"title":"Derecho de transporte","description":"El Derecho del Transporte es el sector del Derecho que se ocupa de regular todos los aspectos y conflictos que nacen del contrato de transporte, entendido este al transporte terrestre de mercancías.<br><br>Este contrato supone un acuerdo de voluntades por el que un empresario se compromete, a llevar de un lugar a otro una mercancía o persona por el medio de transportes que se pacte, a cambio de una remuneración.<br><br>¿Has tenido algún problema con un transporte privado o comercial? ¡cuéntanoslo! En Openlegal haremos todo lo que esté en nuestras manos para ayudarte a solucionarlo."},"derecho-privacidad":{"title":"Derecho de la privacidad o protección de datos","description":"El derecho a la protección de datos es aquel derecho fundamental de toda persona física que la faculta para disponer y controlar sus datos de carácter personal, pudiendo decidir cuáles proporcionar a terceros, así como conocer quien posee esos datos y para qué, y oponerse a esa posesión o tratamiento de datos.<br><br>A su vez, la Ley Orgánica de Protección de Datos, establece que todas y cada una de las empresas que traten datos de carácter personal para el normal desarrollo de su actividad comercial, así como para otros fines, tienen la obligación de cumplir con el Reglamento (UE) 2016/679 y Ley Orgánica de Protección de Datos y Garantía de los Derechos Digitales (LOPDGDD 3/2018). Así, cualquier entidad, autónomo o profesional que maneje datos de clientes, empleados, proveedores, asociados o cualquier otra figura para el desarrollo de su actividad, deberá cumplir de manera obligatoria con la LOPDGDD y el RGPD.<br><br>Si crees que la protección de tus datos personales ha sido vulnerada o eres un profesional que necesite asesoramiento para la elaboración de documentos profesionales de acuerdo con la normativa de protección de datos de carácter personal, contacta Openlegal."},"derecho-consumo":{"title":"Derecho del consumo","description":"El Derecho de consumo, es la rama del derecho que se encarga de proteger a los consumidores o usuarios, ya sean personas físicas o personas jurídicas que actúen con un propósito ajeno a su actividad comercial o empresarial, cuando adquieren o contratan bienes o servicios.<br><br>Por lo tanto, el derecho de consumo se compone por las normas que regulan los derechos y obligaciones en las relaciones jurídicas entre estos consumidores o usuarios y las empresas que ofrecen los bienes o servicios adquiridos.<br><br>El derecho del consumo y varios aspectos fundamentales de las relaciones entre los productores y los consumidores:<ul><li>Los contratos por adhesión: prohíbe las cláusulas abusivas que desequilibren la relación entre el contractual en favor del proveedor de bienes y servicios y trata de asegurar que el consumidor conozca por anticipado todas las condiciones generales de la contratación que el empresario pretende utilizar.</li><li>Calidad de los bienes y servicios ofrecidos: requisitos mínimos.</li><li>Regulación de la publicidad y de las ofertas dirigidas al público.</li><li>Establece procedimientos especiales para que los consumidores, las asociaciones y organismos públicos creados puedan defenderse y prohibir ciertas prácticas abusivas.</li><li>Enumera un elenco de infracciones por parte de los empresarios y las correspondientes sanciones que pueden imponer las autoridades competentes en materia de consumo.</li></ul><br>Si necesitas asesoramiento sobre Derecho de consumo o si crees que necesitas protección como consumidor y/o usuario de algún producto, no dudes en contactar con Openlegal, resolveremos tus dudas y te ayudaremos con lo que necesites."},"propiedad-intelectual":{"title":"Propiedad intelectual","description":"La Propiedad intelectual y la propiedad industrial están formadas por un conjunto de normas que regulan la adquisición y el uso de derechos sobre bienes intangibles susceptibles de uso comercial. Según la legislación española, propiedad intelectual y propiedad industrial quedan claramente diferenciadas de la siguiente manera:<ul><li>Propiedad industrial: patentes, marcas, modelos de utilidad, signos distintivos, nombres comerciales, dibujos industriales, etc.</li><li>Propiedad intelectual: derechos de autor, obras literarias y artísticas, obras de arte, diseños arquitectónicos…</li></ul><br>Cuando se habla de propiedad industrial se está haciendo referencia a un tipo de derechos que protegen a los creadores de invenciones para que puedan desarrollar su actividad en el mercado frente a los competidores y cuenten con una protección suficiente frente a terceros.<br><br>Los derechos de propiedad industrial tienen carácter patrimonial y, por ello, pueden ser cedidos o gravados, siendo transmisibles por todos los medios admitidos en derecho. Uno de los contratos más usuales en esta materia es el de licencia. Los derechos de propiedad intelectual pueden tener carácter económico o “moral”. Los derechos de carácter económico pueden ser objeto de explotación.<br><br>Si necesitas proteger tus derechos de autor o la explotación, registro o imagen de tu nombre comercial, marca o patente, en Openlegal  estaremos encantados de ayudarte."},"derecho-seguridad-social":{"title":"Derecho de la seguridad social","description":"El Derecho de la Seguridad Social es el conjunto de leyes y principios que regula la rama de la política social y económica del país, que a través de determinadas instituciones, busca proteger a sus miembros cuando sufren estados de necesidad, producidos por determinadas contingencias sociales, asegurándoles condiciones de vida, salud, y trabajo socialmente suficientes, implementando así los derechos humanos a la seguridad social y a un nivel de vida adecuado.<br><br>El derecho a la seguridad social es de importancia fundamental para garantizar a todas las personas su dignidad humana cuando hacen frente a circunstancias que les privan de su capacidad para ejercer plenamente los derechos humanos.<br><br>El derecho a la seguridad social incluye el derecho a obtener y mantener prestaciones sociales, sin discriminación, con el fin de obtener protección, en particular contra:<ol><li>la falta de ingresos procedentes del trabajo debido a enfermedad, invalidez, maternidad, accidente laboral, vejez o muerte de un familiar;</li><li>gastos excesivos de atención de salud; y</li><li>un apoyo familiar insuficiente, en particular para los hijos y los familiares a cargo.</li></ol><br>La seguridad social desempeña un papel importante para reducir y mitigar la pobreza, prevenir la exclusión social y promover la inclusión social.<br><br>Si necesitas a un profesional experto en seguridad social, no dudes en contactar con Openlegal."},"derecho-extranjeria":{"title":"Derecho extranjería","description":"El derecho de extranjería es el derecho a la libre circulación y residencia de los ciudadanos que el ordenamiento jurídico internacional subordina su ejercicio al hecho de que la persona, sea cual sea su nacionalidad, nacional o extranjero, se halle legalmente en el territorio de un Estado. Las exigencias legales para los extranjeros en España precisan consejo y defensa en múltiples situaciones ante la Administración.<br><br>En Openlegal somos conscientes de la trascendencia para cualquier extranjero o inmigrante de obtener o mantener la correspondiente autorización de residencia o la nacionalidad española. Aunque muchos extranjeros suelen conocer los procedimientos como la solicitud de un permiso de residencia o una renovación de tarjeta, confiando la realización de los trámites a abogados especialistas en materia de extranjería evitará incurrir en errores, resolverá cualquier duda y evitará problemas.<br><br>Servicios de extranjería:<ul><li>Permisos de residencia</li><li>Renovación de permiso de residencia</li><li>Obtención de residencia por cuenta propia</li><li>Obtención de residencia por cuenta ajena</li><li>Tramitación para obtención del N.I.E.</li><li>Tramitación para obtención de nacionalidad</li><li>Obtención de visado</li><li>Reagrupación familiar</li></ul><br>Necesitas que te ayudes en la obtención o renovación de tu permiso de residencia, visado, NIE o reagrupación familiar, en Openlegal te ayudamos con todos los trámites para conseguirlo."},"derecho-militar":{"title":"Derecho militar","description":"El Derecho Militar es un conjunto de normas y leyes que regulan la conducta y organización de las fuerzas armadas de un país. Estas normas pueden incluir reglas para el servicio activo, el castigo por infracciones militares, y la protección legal para los miembros de las fuerzas armadas. También puede tratar sobre la relación entre las fuerzas armadas y el gobierno, así como la relación entre las fuerzas armadas y la sociedad en general.<br><br>El artículo 117.5 de la Constitución española establece que la ley regulará el ejercicio de la jurisdicción militar en el ámbito estrictamente castrense y en los supuestos de estado de sitio, de acuerdo con los principios de la Constitución.<br><br>La jurisdicción militar una jurisdicción dependiente del Poder Judicial con competencia específica en el ámbito militar. Sin embargo, la Ley Orgánica 4/1987, de 15 de julio, de la Competencia y Organización de la Jurisdicción Militar le fija dos tipos de competencia: una en tiempos de paz y otra en situaciones de conflicto armado. Sin embargo, siempre con sujeción a los preceptos constitucionales.<br><br>El Derecho Militar regula las relaciones entre el Estado y los estamentos militares, la organización y el funcionamiento de los mismos, la situación jurídica de los militares, los derechos y deberes de los mismos, la formación y el servicio militar, así como la disciplina militar.<br><br>En España, existen varias instituciones que se encargan de velar por el cumplimiento de las normas y la aplicación del Derecho Militar, como el Consejo de Estado, el Consejo de Estado Militar, la Audiencia Nacional, el Tribunal Supremo o el Tribunal de Justicia Militar. Estas instituciones tienen el poder de controlar el cumplimiento de las leyes y de imponer sanciones en caso de incumplimiento.<br><br>Si necesitas asesoramiento sobre Derecho militar, en Openlegal te ayudamos."},"derecho-aeronautico":{"title":"Derecho aéreo o aeronáutico","description":"El derecho aeronáutico es el conjunto de normas, nacionales e internacionales, que regulan la navegación aérea, el desarrollo y utilización de infraestructuras y las relaciones jurídicas que pueden derivar del uso del espacio aéreo. Dada la transversalidad de materias e intereses a las que afecta —desde el comercio hasta el transporte de pasajeros—, este marco legislativo está compuesto por principios y normas de ámbito público y privado, tratando de dar respuesta a todas las situaciones derivadas de las relaciones que se producen entre la Administración y los ciudadanos de un país, entre distintos Estados y entre particulares.<br><br>¿Has tenido algún problema con un transporte aéreo?, ¡cuéntanoslo! En Openlegal haremos todo lo que esté en nuestras manos para ayudarte a solucionarlo."},"derecho-deporte":{"title":"Derecho deportivo","description":"El derecho deportivo es una especialidad del derecho que se encarga de regular todos los conflictos y cuestiones jurídicas relacionados con el deporte. Su origen se remonta a la antigua Grecia, donde se establecieron las primeras reglas y normas para organizar y llevar a cabo los Juegos Olímpicos. Con el paso del tiempo, estas normas fueron evolucionando y adaptándose a las necesidades de cada época, lo que ha dado lugar a la creación de una nueva disciplina del derecho específica para el deporte moderno, que ha alcanzado una gran popularidad durante el siglo XXI.<br><br>El derecho deportivo tiene ciertas características que lo diferencian del derecho común. En primer lugar, se trata de un derecho especializado que se aplica exclusivamente a los asuntos relacionados con el deporte. Esto significa que las normas y principios de esta especialidad no son aplicables a situaciones que no tengan nada que ver con las actividades deportivas.<br><br>Por otro lado, se caracteriza por ser una rama del derecho muy dinámica, ya que está en constante evolución y adaptación a las necesidades del mundo del deporte. Además, es un ámbito que abarca una gran variedad de materias, desde la regulación de las competiciones deportivas hasta la protección de los derechos de los atletas.<br><br>En Openlegal somos expertos en Derecho Deportivo, si necesitas asesoramiento sobre un contrato de deportistas, derechos de imagen, retransmisión, como convertir un club en una sociedad anónima deportiva u otras cuestiones relacionadas con el ámbito jurídico del deporte, llámanos!"},"derecho-menores":{"title":"Jurisdicción de menores","description":"Los derechos de los menores están fuertemente protegidos, pero si estos, cometen algún delito, también son investigados y pueden ser sancionados. Los delitos cometidos por personas mayores de catorce años y menores de dieciocho son investigados en los Juzgados de Menores, los cuales son también competentes para conocer, ejecutar y resolver sobre la responsabilidad civil, de la cual son responsables los padres.<br><br>Son, por lo tanto, los encargados por las leyes sobre los menores que hayan incurrido en conductas tipificadas por la ley como delito. El juez de menores también recibe el expediente instruido por el fiscal para adoptar la decisión correspondiente respecto a los mismos la cual puede conllevar trabajos en beneficios de la comunidad, sometimiento a algún tratamiento, o internamiento en un centro hasta libertad vigilada. Corresponde a estos Jueces resolver estos asuntos y vigilar las medidas correctoras que se les impongan, vigilancia que puede perdurar hasta los 23 años de edad.<br><br>Si tu hijo menor de edad se encuentra inmerso en un procedimiento judicial ante la jurisdicción de menores, si ha resultado denunciado y necesitas asesoramiento, no dudes en contactar con Openlegal."},"derecho-ambiental":{"title":"Derecho ambiental","description":"El Derecho Ambiental es el conjunto de normas jurídicas que regula las actividades y comportamientos humanos que pueden dañar directa o indirectamente el medio ambiente. Su finalidad es tanto prevenir esos daños como poner los medios para repararlos en caso de que se produzcan y determinar los responsables de esas acciones lesivas.<br><br>El Derecho Ambiental es un conjunto normativo amplio y transversal al afectar a distintas áreas y sectores de la sociedad. Para su desarrollo, los legisladores se apoyan en principios clave:<ul><li>Acción preventiva y cautelar: busca evitar un daño medioambiental.</li><li>Desarrollo sostenible: los poderes públicos tienen la obligación de velar por el uso de los recursos.</li><li>“Quien contamina, paga”: este principio pone el foco en quienes con sus acciones dañan el medio ambiente y, por ello, han de pagar una sanción.</li></ul><br>La raíz de esta rama jurídica nace en el reconocimiento del medio ambiente como bien jurídico del que depende no sólo el desarrollo económico, sino el bienestar y la salud de la ciudadanía: desde la utilización del agua para generar electricidad, para la industria o para el suministro a los hogares, hasta la protección de los bosques y el control de las emisiones contaminantes para garantizar la calidad del aire que se respira.<br><br>En Openlegal contamos con expertos en Derecho medioambiental para asesorarte en lo que necesites."},"derecho-arrendamientos":{"title":"Derecho arrendamientos","description":"El derecho de arrendamientos es aquel que regula la relación jurídica de existente (derechos y obligaciones) entre un propietario (arrendador) y un inquilino (arrendatario) en cuanto a un alquiler de una vivienda o un local se refiere.<br><br>Por medio del arrendamiento un propietario cede la posesión de su bien (mueble o inmueble). Dicho de otro modo, limita su derecho de propiedad.<br><br>Aunque el arrendador sigue siendo el titular del bien arrendado, será el arrendatario quien tenga el derecho de uso del mismo. Por eso, jurídicamente se contempla esta operación entre los derechos reales, que son los que recaen sobre una cosa y no sobre una persona.<br><br>Cabe señalar que, en ocasiones, el arrendador podría no ser el propietario del bien alquilado, sino un mero gestor. Y también que existe la posibilidad de arrendar servicios u obras, como se explicará más adelante.<br><br>Los arrendamientos se encuentran regulados en el Título VI (Del contrato de arrendamiento), del Código Civil español.<br><br>Si tienes que elaborar un contrato de arrendamiento, si necesitas asesoramiento sobre la firma de un contrato de arrendamiento como propietario, inquilino, de vivienda o local de negocio; si te van a desahuciar y crees que es injusto o si necesitas reclamar el impago de las rentas de tu contrato de alquiler, contacta con Openlegal, tenemos los mejores expertos en arrendamientos para que te asesoren y defiendan."},"derecho-civil":{"title":"Derecho civil","description":"El Derecho Civil es la rama del derecho que, en general, regula las relaciones civiles o privadas de las personas. El derecho civil se ocupa del estado civil de las personas, sus derechos y deberes familiares, la propiedad y los demás derechos reales y servidumbres sobre las cosas, el régimen de las obligaciones y contratos y las sucesiones y herencias.<br><br>El derecho civil se divide en cuatro grandes ramas: la parte general (el derecho subjetivo en general, la nacionalidad, el domicilio, la adquisición y extinción de la personalidad civil), el derecho de obligaciones y contratos (responsabilidad contractual y extra contractual y régimen jurídico general y especial de las obligaciones y los contratos), los derechos reales (propiedad y posesión, derechos reales de goce, de adquisición preferente y de garantía, con especial atención al derecho hipotecario) y el derecho de familia y las sucesiones (regulación del matrimonio, relaciones entre los progenitores y los hijos, derecho de alimentos, herencias y distintos modos de suceder).<br><br>En Openlegal somos expertos civilistas, cuéntanos tus necesidades, nosotros velaremos porque se cumplan, mediante la interposición de la acción o procedimiento extrajudicial o judicial que sea necesario."},"derecho-penal":{"title":"Derecho penal","description":"El Derecho Penal es la rama del derecho público que regula la actividad criminal dentro de un Estado. El derecho penal engloba todos aquellos procedimientos por los que una persona puede ser investigada si ha cometido un delito, o en los que puede ejercer como Acusación Particular si ha resultado perjudicada por la conducta delictiva de un tercero.<br><br>Los delitos se engloban en diferentes categorías, desde aquellos que atentan contra el patrimonio (Robo, Hurto, Estafa, Apropiación Indebida, blanqueo de capitales…), aquellos que vulneran derechos de las personas (Homicidio, Asesinato, Lesiones, Violación, Violencia de género) a otros de tipo sectorial como los socio económicos (falsedad de cuentas, acuerdos lesivos, contabilidad falsa), urbanismo, medio ambiente y aquellos que tienen que ver con los poderes públicos (Tráfico de influencias, cohecho, corrupción pública y privada, prevaricación, malversación…).<br><br>Si necesitas interponer un procedimiento penal, o eres parte de un proceso ya iniciado y necesitas un Abogado como Acusación o Defensa, en Openlegal, contamos con los mejores penalistas, los cuáles te acompañarán en todo el procedimiento hasta conseguir tu absolución o la defensa de tus derechos e intereses si has resultado perjudicado por un delito cometido por un tercero."},"derecho-internacional-publico":{"title":"Derecho internacional público","description":"​​El Derecho Internacional Público es el conjunto de normas aplicables a los Estados y a las organizaciones internacionales en sus actuaciones. Sus sujetos de derecho son los Estados y las organizaciones internacionales y aborda aspectos de interés público a nivel supranacional.<br><br>El derecho internacional público se compone de normas, costumbres y principios jurídicos que resultan aplicables a dos niveles diferentes. De un lado, se aplica a las relaciones entre los Estados, y de otro, a las relaciones entre ciudadanos que tengan carácter jurídico e internacional.<br><br>En Openlegal contamos con expertos en Derecho Internacional público."},"derecho-contratos":{"title":"Derecho de contratos","description":"El derecho de los contratos se refiere al conjunto de normas que regulan los derechos y las obligaciones que nacen por la celebración de un contrato.<br><br>Un contrato puede ser definido como un acto privado que dos o más personas llevan a cabo y del que surgen derechos y obligaciones para ellos. En palabras del propio Código Civil, se puede entender como el acto por el que “una o varias personas consienten en obligarse, respecto de otra u otras, a dar alguna cosa o prestar algún servicio”.<br><br>El derecho de los contratos es una parte del derecho civil y, como tal, sus normas se encuentran en el Código Civil. Ahora bien, existen leyes complementarias que regulan algunos contratos específicos, como sucede con la Ley de Arrendamientos Urbanos y la Ley de Arrendamientos Rústicos, para el caso de los contratos de arrendamiento de fincas urbanas y rústicas, respectivamente.<br><br>No hay que confundir el derecho de los contratos con el derecho de las obligaciones. Las obligaciones pueden derivar tanto de relaciones contractuales (un contrato) como de relaciones extracontractuales (un accidente automovilístico). Por lo tanto, un contrato implica una obligación, pero no siempre una obligación implica un contrato.<br><br>¿Necesitas elaborar o revisar un contrato? ¿Precisas que te asesoremos sobre la interpretación de un contrato o que defendamos tus intereses ante el incumplimiento de un contrato? Cuenta con  Openlegal."},"pension-alimentos":{"title":"Pensión de alimentos","description":"¿Estas divorciado y tu ex no paga la pensión de alimentos de tus hijos? ¿Te has quedado sin trabajo o se han reducido tus ingresos y no puedes pagar tanta pensión de alimentos? ¿Estas pensando en separarte del padre/madre de sus hijos y necesitas asesoramiento sobre cuáles son tus derechos o que te correspondería pagar/recibir por pensión de alimentos? Si tienes estas u otras dudas relacionadas con la pensión de alimentos que se genera o se ha generado en favor de tus hijos al haberse separado o divorciado de tu pareja, no dudes en contactar con Openlegal."},"pension-compensatoria":{"title":"Pension compensatoria","description":"Si tienes reconocido el derecho a recibir una pensión compensatoria en resolución judicial y tu ex pareja no la ha cumplido, si estas pensando en separarte o divorciarte o necesitas asesoramiento sobre los requisitos y posibilidades para poder pedir una pensión compensatoria a tu ex pareja por desequilibrio económico en la separación, en Openlegal contamos con los mejores profesionales para atenderte y darte soluciones."},"derecho-hipotecario":{"title":"Derecho hipotecario","description":"Es la rama del Derecho Civil que estudia el contenido de la Ley Hipotecaria, sus fundamentos, principios y aplicación.<br><br>Por un lado, como rama jurídica que regula los inmuebles, podríamos denominar al Derecho Hipotecario como Derecho Inmobiliario. Por otro, como rama jurídica que regula los derechos sobre los inmuebles reflejados en el registro, podríamos denominar al Derecho Hipotecario como Derecho Registral. Aglutinar los dos conceptos en uno, daría denominar al Derecho Hipotecario como Derecho Inmobiliario Registral.<br><br>Así pues, podemos decir que el Derecho Hipotecario es el conjunto de normas que regulan la inscripción en el Registro de la Propiedad el reconocimiento, transmisión, constitución, modificación, gravamen y extinción del dominio de los bienes inmuebles y derechos reales sobre los mismos.<br><br>¿Necesitas inscribir en el Registro de la Propiedad alguna operación hipotecaria? No te preocupes, en Openlegal nos encargamos de todos los trámites y te acompañamos en el proceso!"},"asistencia-detenido":{"title":"Asistencia al detenido","description":"La Asistencia letrada al detenido (en sede policial o judicial) es configurado como un derecho irrenunciable del ciudadano a ser asistido por un Abogado experto en derecho penal.<br><br>La asistencia letrada al detenido del art. 17.3 CE es un instrumento de salvaguarda del derecho a la libertad del detenido y no investigado y una garantía constitucional, para que la persona privada de libertad deambulatoria no vea restringidos otros derechos diferentes a ésta. Si la persona ha sido detenida ilícitamente se podrá ejercitar un procedimiento de habeas corpus donde el juez de guardia deberá decidir sobre la libertad o detención del ciudadano.<br><br>También constituye una extensión del derecho de defensa, el cual conlleva la potestad de elegir un Abogado experto en derecho penal, convirtiéndose al tiempo en un requisito de validez de las actuaciones procesales.<br><br>Si te han detenido y necesitas asistencia letrada, contacta con Openlegal, contamos con abogados expertos en asistencia al detenido 24 horas."},"derecho-sanitario":{"title":"Derecho sanitario","description":"El derecho sanitario es una de la rama de las ciencias jurídicas que se encarga de gestionar y regular todos los procesos relacionados con la protección de la salud, los datos vinculados con la salud de las personas y las negligencias médicas.<br><br>El marco legal del derecho sanitario está regulado y amparado por la Constitución Española y la Ley de la Salud, los cuales integran un conjunto de normas y procedimientos jurídicos que servirán para cumplir las tareas médicas.<br><br>El derecho sanitario se ocupa de una gran cantidad de temas relacionados con la salud. A continuación, te presentamos algunas de las áreas que estudia este tipo de derecho:<ul><li>Derecho médico: es el encargado de gestionar todas las normas y responsabilidades de los médicos y de los derechos del paciente.</li><li>Derecho de la salud pública: regula los programas de la salud pública, junto con la protección de la salud ambiental y la promoción de la salud.</li><li>Derecho de la investigación médica: gestiona los temas legales de la investigación, incluyendo la protección de los derechos de los participantes en ensayos clínicos.</li><li>Derecho farmacéutico: regula todos los aspectos relacionados con la elaboración, el uso y la distribución de los medicamentos.</li></ul><br>Si crees que han incurrido en una negligencia sanitaria contigo o tienes alguna duda en relación con el consentimiento informado u otras condiciones y contratos del sector sanitario, contacta con Openlegal nuestros abogados especialistas resolverán tus dudas y defenderán tus derechos e intereses."},"derecho-digital-imagen":{"title":"Derecho digital y de la imagen","description":"Los derechos digitales, muy ligados a la libertad de expresión y la privacidad, son aquellos que permiten a las personas acceder, usar, crear y publicar medios digitales, así como acceder y utilizar ordenadores, otros dispositivos electrónicos y redes de comunicaciones. Los ciber derechos reconocen el derecho de las personas a acceder, usar, crear y publicar medios digitales, y el derecho de acceso a los ordenadores, dispositivos electrónicos y redes de telecomunicaciones necesarios para ejercerlos.<br><br>El derecho a la propia imagen es un derecho consagrado en la Constitución y hace referencia al amparo que puede exigir cualquier persona frente a una captación, reproducción o difusión ilegítima de su apariencia en cualquier lugar y momento de su vida privada. Esta garantía aplica independientemente del medio utilizado, ya sea televisión, Internet, fotografías, etc.<br><br>¿Tienes alguna duda relacionada con los derechos digitales, quieres defender o hacer valer tus derechos frente a una vulneración o simplemente necesitas asesoramiento? Contacta con Openlegal haremos todo lo que esté en nuestras manos para ayudarte."},"derechos-humanos":{"title":"Derechos humanos","description":"Los Derechos Humanos son normas que reconocen y protegen la dignidad de todos los seres humanos. Estos derechos rigen la manera en que los individuos viven en sociedad y se relacionan entre sí, al igual que sus relaciones con el Estado y las obligaciones del Estado hacia ellos. Los derechos humanos son aquellos que toda persona tiene por el hecho de existir, sin importar su raza, color, sexo, idioma, religión o cualquier otra condición. Se basan en los valores de dignidad humana, justicia, paz y libertad, y son los mismos para todas las personas, no pueden eliminarse y no pueden conseguirse unos sin otros.<br><br>Los derechos humanos se dividen en dos categorías: civiles y políticos, y económicos, sociales y culturales. Los civiles y políticos garantizan que todas las personas participen libres e iguales en la vida civil y política de su país. Algunos de estos son el derecho a la vida, a la igualdad o a la libertad de expresión y de conciencia. Los derechos económicos, sociales y culturales, por su parte, buscan que las personas tengan una vida digna. El derecho al trabajo, a la alimentación o a la vivienda son algunos ejemplos.<br><br>En España, los derechos fundamentales están consagrados y protegidos por la Constitución Española, debiendo el Estado, y los particulares, respetarlos. Cuando no lo hacen, los titulares de derechos que han resultado perjudicados tienen derecho a entablar un proceso ante el Tribunal Constitucional mediante el Recurso de Amparo.<br><br>Si crees que tus derechos fundamentales han sido vulnerados, confía en Openlegal, te ayudaremos a conseguir el amparo, compensación y el resarcimiento de los mismos."},"juicio-delito-leve":{"title":"Juicio por delito leve","description":"El juicio por delito leve es aquel procedimiento que se lleva a cabo para enjuiciar determinados delitos considerados de menor gravedad. Normalmente estos delitos, cuando el perjuicio se pueda valorar económicamente son aquellos que están por debajo de los 400€ y suelen conllevar penas de multa. En este procedimiento, una vez interpuesta la denuncia, citan al denunciante y denunciado al acto del juicio al que podrán acudir con todas las pruebas documentales y testificales que quieran utilizar para defender sus derechos e intereses. Ej: delito leve de hurto, delito leve de estafa, delito leve de defraudación de fluido eléctrico, delito leve de lesiones…"},"juicio-rapido":{"title":"Juicio rápido","description":"El juicio rápido es aquel procedimiento que se sigue para enjuiciar determinados delitos que la ley recoge, siendo el más común el delito de alcoholemia.Su especialidad se basa en que, una vez interpuesta la denuncia o detenido el denunciado, se puede dilucidar el mismo día que el denunciado acude al Juzgado de Guardia, de forma que, si se conforma con los hechos imputados obtiene un beneficio en la reducción de un tercio de la pena que solicite el Ministerio Fiscal. En caso de no conformarse, se le citará para celebrar juicio en los días posteriores sin la posibilidad de aplicar dicho beneficio."},"derecho-penitenciario":{"title":"Derecho penitenciario","description":"El derecho penitenciario constituye un conjunto de normas jurídicas orientadas a regular y determinar la ejecución de penas y medidas privativas y no privativas de libertad. Este derecho es el que se encarga de regular la situación de aquellas personas que se hallan privadas de libertad en Centros Penitenciarios, tanto el régimen de entrada en los mismos, como el de revisión, permisos y beneficios, recursos y libertad provisional.<br><br>¿Tienes un familiar interno en un procedimiento judicial? ¿Quieres revisar su clasificación de grado, solicitar o recurrir la denegación de algún permiso o beneficio penitenciario? En Openlegal te ayudamos a conseguirlo."},"derecho-maritimo":{"title":"Derecho marítimo","description":"El Derecho marítimo es un cuerpo normativo que rige los problemas que puedan surgir a raíz de las relaciones entre entidades de Derecho privado dedicadas al tráfico marítimo. El Derecho marítimo ha de ser diferenciado del Derecho del mar, constituido por un cuerpo de normas de Derecho internacional que regula las relaciones jurídicas entre Estados, y no entre particulares.<br><br>El Derecho marítimo ha tenido una gran importancia histórica que se mantiene hasta nuestros días, siendo una rama muy importante del Derecho mercantil. Esto se debe a que el transporte por mar es muy utilizado para transportar las mercancías objeto de compraventas internacionales.<br><br>¿Has tenido algún problema con un transporte marítimo?, ¡cuéntanoslo! En Openlegal haremos todo lo que esté en nuestras manos para ayudarte a solucionarlo."}}}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy-professional":{"title":"Política de privacidad para profesionales","text":"<p><b>Privacidad</b></p>\n\n<p><b>A. General</b></p>\n<p>¿Quién es el responsable del tratamiento de sus datos?</p>\n<p>{companyName} (En adelante {platformName})</p>\n<p>Dirección Postal: {address}}.</p>\n<p>Correo electrónico: soporte@openhealth.es</p>\n<p>DPO: GRUPO INGERTEC privacidad@openhealthcare.eu</p>\n<p>Para posibilitar la navegación a través de la web es imprescindible ser usuario registrado y aceptar las reglas de privacidad que a continuación se detallan. Con el registro aceptas que {platformName} almacene y trate los datos personales que nos facilitas de acuerdo con la política de privacidad.</p>\n\n<p>La base legal para el tratamiento de sus datos es el consentimiento del interesado.</p>\n\n<p>El tratamiento de los datos se realiza con las siguientes finalidades:</p>\n<ul>\n  <li><p>Realización de las consultas médicas y gestión de citas y servicios objeto de la actividad de la plataforma.</p></li>  <li><p>Realización de estudios estadísticos e históricos por parte de {platformName}. Los informes generados serán siempre desagregados y anónimos.</p></li>\n  <li><p>Realización de comunicaciones de interés para los usuarios relativas al funcionamiento de la plataforma (sugerencias de utilización, mejoras introducidas…).</p></li>\n  <li><p>Envio de comunicaciones electrónicas a las que previamente se haya suscrito el usuario, dando cumplimiento a Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSICE).</p></li>\n\n</ul>\n\n<p>Nuestra política con respecto al envío de nuestros propios correos electrónicos se centra en remitir únicamente comunicaciones que usted haya solicitado recibir. Si prefiere no recibir estos mensajes por correo electrónico le ofreceremos a través de los mismos la posibilidad de ejercer su derecho de supresión y renuncia a la recepción de estos mensajes.</p>\n\n<p>Todos los usuarios que establezcan algún tipo de comunicación, bien a través de los formularios ubicados la Web, bien a través de vías alternativas, deben conocer que sus datos podrán ser recogidos para su tratamiento por parte de la presente plataforma.</p>\n\n<p>{platformName} trata los datos de forma confidencial y adopta las medidas técnicas y organizativas apropiadas para garantizar el nivel de seguridad adecuado al tratamiento, en cumplimiento de lo requerido en la normativa aplicable en materia de Protección de Datos. Open Health cuenta con la certificación en ISO 27001.</p>\n\n<p>No obstante, ningún sistema puede garantizar la absoluta invulnerabilidad de los sistemas, por tanto, {platformName} no asume ninguna responsabilidad por los daños y perjuicios derivados de alteraciones que terceros puedan causar en los sistemas informáticos, documentos electrónicos o ficheros del usuario.</p>\n\n<p><b>¿Cuál es el tiempo de conservación de los datos?</b></p>\n\n<p>Los datos personales proporcionados se conservarán mientras el usuario permanezca activo en la plataforma (no haya solicitado su baja) y durante los plazos necesarios para dar cumplimiento a las obligaciones legales relativas a la custodia de Información clínica y administrativa.</p>\n\n<p>Los datos recabados para dar respuesta a su solicitud, petición o consulta de nuestros productos y servicios, serán conservados indefinidamente hasta que, en su caso, nos manifieste tu voluntad de suprimirlos.</p>\n\n<p><b>B. Cesión de datos y transferencias internacionales</b></p>\n\n<p>Cualquier dato que sea recogido por {platformName} bajo ningún concepto, será cedido a terceras empresas, salvo las excepciones que a continuación se desglosan:</p>\n<ul>\n  <li><p>Medie solicitud previa por parte del portal al interesado y éste exprese su conformidad ya sea dicha solicitud con carácter individual o genérico. En todo caso {platformName} nunca cederá ningún dato con fines publicitarios.</p></li>\n  <li><p>Cuando se refieran a las excepciones contempladas por la normativa aplicable.</p></li>\n  <li><p>A través de la contratación con empresas terceras, para servicios de análisis, con fines exclusivamente estadísticos y de mejora del Servicio y nunca publicitarios.</p></li>\n  <li><p>A los profesionales y centros de la salud registrados en la plataforma a los efectos de la concertación y realización de las citas médicas, durante el plazo de un año desde el último consentimiento explícito, ya sea mediante la solicitud de una cita o la autorización a un profesional. A estos efectos, los profesionales y centros registrados que accedan a los datos de pacientes en la plataforma, asumen en su caso las obligaciones determinadas por la normativa sobre protección de datos aplicable, asumiendo toda la responsabilidad en caso de incumplimiento de dicha norma. Conforme a dicha normativa, los profesionales y centros, aceptan la relación como encargado del tratamiento con respecto a los datos personales que los usuarios registrados facilitan a {platformName} a los efectos de realizar las citas y consultas, manteniendo en todo caso el nivel de datos especialmente protegidos para dicha información.</p></li>\n\n<em><p>En relación a cualquier información extraída de la plataforma, por lo medios legalmente habilitados, el profesional/centro debe conocer que los datos de salud están catalogados como información muy sensible y de nivel alto de seguridad; y consecuentemente deberán tratarse siguiendo las directrices marcadas por el Reglamento (UE) 2016/679 Del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (RGPD), la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, y demás normativa vigente en materia de protección de datos de carácter personal y seguridad de la información. Únicamente podrá acceder o descargar aquella información a la que esté autorizado de acuerdo a la normativa vigente.</p>\n<p>En ningún caso la información extraída se puede almacenar en el disco duro de los equipos (local). En caso de impresión de la información en papel, ésta deberá estar custodiada en todo momento por la persona responsable de la misma, y almacenarse bajo llave cuando no se esté haciendo uso de ella.</p>\n<p>Igualmente, no se debe hacer uso de dispositivos móviles externos para el almacenamiento y traslado de la información, tipo pendrive, smartphone, ordenadores portátiles, etc. En ningún caso se utilizará correo electrónico externo para el envío o recepción de este tipo de información. Asimismo, independientemente del soporte en que se encuentre, la información extraída, deberá de ser borrada o destruida fehacientemente una vez que haya dejado de ser necesaria para los fines que motivaron su extracción.</p>\n<p>El profesional/centro debe utilizar los datos personales objeto de tratamiento, o los que recoja para su inclusión, sólo para la finalidad objeto del Contrato. En ningún caso podrá utilizar los datos para fines propios. En el caso de que el Encargado del tratamiento destine los datos a otras finalidades de las estipuladas, los comunique o los utilice incumpliendo las condiciones del presente documento, será considerado responsable del fichero a todos los efectos, respondiendo personalmente de las infracciones en las que hubiese incurrido.</p>\n<p>El profesional/centro no comunicará los datos a terceros no autorizados, salvo que cuente con la autorización expresa y por escrito del Responsable del tratamiento, en los supuestos legalmente admisibles. A estos efectos, se entenderán autorizadas las comunicaciones de datos entre las empresas pertenecientes al grupo de cada una de las Partes, respectivamente, con la finalidad de atender las obligaciones y derechos derivados de la ejecución del contrato. Así como mantener el deber de secreto respecto de los datos de carácter personal a los que haya tenido acceso en virtud del Contrato, incluso después de que finalice su objeto, respondiendo ante el Responsable del tratamiento en caso de incumplimiento, sin perjuicio de las responsabilidades que se puedan derivar ante la Agencia Española de Protección de Datos o ante el interesado.</p>\n<p>El profesional/centro debe implantar las medidas de seguridad que apliquen de acuerdo con las evaluaciones de riesgos que, en su caso, deba realizar el Responsable del tratamiento.</p></em>\n  <li><p>A las empresas que son utilizadas como soporte para el correcto funcionamiento de la plataforma (cloud) y colaboradores.</p></li>\n  <li><p>En el caso de los servicios de telemedicina para empresas, para generar informes agregados de utilización de la plataforma por parte de sus empleados. Estos informes agregados serán anónimos y únicamente contendrán la siguiente Información: número total de usuarios, número total de servicios utilizados y principales motivos de consulta. Los datos se agregaran por sexo y tramos de edad.</p></li>\n</ul>\n\n<p><u>No realizamos transferencias internacionales</u></p>\n\n<p><b>C. Calidad de los datos</b></p>\n<p>La Web comunica a los usuarios la obligación de la correcta actualización de los datos facilitados y tratados en el fichero denominado Usuarios. Dichos datos deberán ser adecuados, pertinentes, actuales, exactos y verdaderos. Quedando excluido {platformName} de todas aquellas consecuencias negativas derivadas de inexactitudes en los mismos.</p>\n<p>A su vez, se comunica a los usuarios, la imposibilidad de inscribir y/o comunicar datos de terceros en su nombre, por medio de las formas de comunicación estipuladas, salvo que exista una representación legalmente constituida. En el supuesto de menores, podrá requerirse la acreditación expresa de dicha condición.</p>\n\n<span><p><b>D. Derechos</b></p>Derechos de acceso, oposición, rectificación y cancelación de datos, supresión y portabilidad.</p> <p>Cualquier persona tiene derecho a obtener información sobre si en Open Salud estamos tratando sus datos personales. </p> <p>Las personas legitimadas tienen derecho a acceder a sus datos personales, a solicitar la rectificación de los datos inexactos o, en su caso, solicitar su eliminación cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.</p> <p>Cuando las circunstancias así lo requieran, los interesados podrán solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.</p> <p>Cuando precisemos obtener información por su parte, siempre le solicitaremos su consentimiento expreso a través de los medios habilitados para ello.</p><p>El ejercicio de estos derechos deberá llevarse a cabo mediante comunicación dirigida a Open Salud, ya sea a su dirección postal, indicada más arriba, o a la dirección electrónica dispuesta a estos efectos (soporte@openhealth.es) , sin perjuicio del uso de cualquier otro medio válido en derecho, que permita cumplimentar de forma legalmente válida, los requisitos para ello.</p><p>Los requisitos de contenido para el ejercicio de los derechos son:</p></span> <span><ul><li><p>Nombre y apellidos del interesado.</p></li><li><p>Objeto de la petición.</p></li><li><p>Dirección a efectos de notificaciones, fecha y firma del solicitante.</p></li><li><p>Documentos acreditativos de la petición formulada en el caso de que se estimen convenientes o necesarios.</p></li> </ul></p> </span>\n\n<p><b>E. Agencia Española de Protección de Datos</b></p>\n<p>La AEPD es la encargada de velar por el cumplimiento de las leyes sobre privacidad y protección de datos y de garantizar la seguridad y privacidad de tus datos en general y especialmente en Internet.</p>\n<p>En caso de que sienta vulnerados sus derechos en lo concerniente a la protección de sus datos personales, especialmente cuando no haya obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia de Protección de Datos competente a través de su sitio web: <a href=\"http://www.agpd.es\">www.agpd.es</a></p>\n\n<p><b>F. Enlaces de Interés</b></p>\n<p>Si queréis saber más acerca de Internet y vuestra privacidad desde {platformName} os recomendamos que visitéis los siguientes enlaces para saber más sobre la misma:</p>\n<p>Oficina Seguridad Internet: <a href=\"http://www.osi.es\">http://www.osi.es</a></p>\n<p>Agencia Española de Protección de Datos: <a href=\"http://www.agpd.es\">http://www.agpd.es</a></p>"}}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy":{"title":"Política de privacidad para pacientes","text":"<p><b>Privacidad</b></p>\n\n<p><b>A. General</b></p>\n<p>¿Quién es el responsable del tratamiento de sus datos?</p>\n<p>{companyName} (En adelante {platformName})</p>\n<p>Dirección Postal: {address}</p>\n<p>Correo electrónico: soporte@openhealth.es</p>\n<p>DPO: GRUPO INGERTEC privacidad@openhealthcare.eu</p>\n<p>Para posibilitar la navegación a través de la web es imprescindible ser usuario registrado y aceptar las reglas de privacidad que a continuación se detallan. Con el registro aceptas que {platformName} almacene y trate los datos personales que nos facilitas de acuerdo con la política de privacidad.</p>\n<p>Datos objeto de tratamiento:</p>\n<ul>\n<p>En la plataforma Opensalud se tratarán los siguientes tipos de datos de los usuarios:</p>\n  <li><p>Datos identificativos: DNI; Dirección electrónica; Dirección postal; Nombre y Apellidos; Teléfono; Foto identificativa de perfil (dato opcional).</p></li>\n  <li><p>Características personales: Idioma; Fecha de nacimiento; Sexo.</p></li>\n  <li><p>Categorías especiales de datos: Salud.</p></li>\n</ul>\n\n<p>La base legal para el tratamiento de sus datos es el consentimiento del interesado.</p>\n\n<p>El tratamiento de los datos se realiza con las siguientes finalidades:</p>\n<ul>\n  <li><p>Realización de las consultas médicas y gestión de citas y servicios objeto de la actividad de la plataforma.</p></li>\n <li><p>Realización de estudios estadísticos e históricos por parte de {platformName}. Los informes generados serán siempre desagregados y anónimos.</p></li>\n  <li><p>Realización de comunicaciones de interés para los usuarios relativas al funcionamiento de la plataforma (sugerencias de utilización, mejoras introducidas…).</p></li>\n  <li><p>Envío de comunicaciones electrónicas a las que previamente se haya suscrito el usuario, dando cumplimiento a Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSICE).</p></li>\n  </ul>\n\n<p>Nuestra política con respecto al envío de nuestros propios correos electrónicos se centra en remitir únicamente comunicaciones que usted haya solicitado recibir. Si prefiere no recibir estos mensajes por correo electrónico le ofreceremos a través de los mismos la posibilidad de ejercer su derecho de supresión y renuncia a la recepción de estos mensajes.</p>\n\n<p>Todos los usuarios que establezcan algún tipo de comunicación, bien a través de los formularios ubicados la Web, bien a través de vías alternativas, deben conocer que sus datos podrán ser recogidos para su tratamiento por parte de la presente plataforma.</p>\n\n<p>{platformName} trata los datos de forma confidencial y adopta las medidas técnicas y organizativas apropiadas para garantizar el nivel de seguridad adecuado al tratamiento, en cumplimiento de lo requerido en la normativa aplicable en materia de Protección de Datos. Open Health cuenta con la certificación en ISO 27001.</p>\n\n<p>No obstante, ningún sistema puede garantizar la absoluta invulnerabilidad de los sistemas, por tanto, {platformName} no asume ninguna responsabilidad por los daños y perjuicios derivados de alteraciones que terceros puedan causar en los sistemas informáticos, documentos electrónicos o ficheros del usuario.</p>\n\n<p><b>¿Cuál es el tiempo de conservación de los datos?</b></p>\n\n<p>Los datos para llevar a cabo la prestación contratada por el cliente serán conservados durante el tiempo en que el contrato esté vigente. Cuando finalice dicha relación, los datos podrán ser conservados durante el tiempo exigido por la legislación aplicable y hasta que prescriban las eventuales responsabilidades derivadas del contrato.</p>\n\n<p>Los datos personales proporcionados se conservarán mientras el usuario permanezca activo en la plataforma (no haya solicitado su baja) y durante los plazos necesarios para dar cumplimiento a las obligaciones legales relativas a la custodia de Información clínica y administrativa.</p>\n\n<p>Los datos recabados para dar respuesta a su solicitud, petición o consulta de nuestros productos y servicios, serán conservados indefinidamente hasta que, en su caso, nos manifieste tu voluntad de suprimirlos.</p>\n\n<p><b>B. Cesión de datos y transferencias internacionales</b></p>\n<p>Cualquier dato que sea recogido por {platformName} bajo ningún concepto, será cedido a terceras empresas, salvo las excepciones que a continuación se desglosan:</p>\n<ul>\n  <li><p>Medie solicitud previa por parte del portal al interesado y éste exprese su conformidad ya sea dicha solicitud con carácter individual o genérico. En todo caso {platformName} nunca cederá ningún dato con fines publicitarios.</p></li>\n  <li><p>Cuando se refieran a las excepciones contempladas por la normativa aplicable.</p></li>\n  <li><p>A través de la contratación con empresas terceras, para servicios de análisis, con fines exclusivamente estadísticos y de mejora del Servicio y nunca publicitarios.</p></li>\n  <li><p>A los profesionales y centros de la salud registrados en la plataforma a los efectos de la concertación y realización de las citas médicas, durante el plazo de un año desde el último consentimiento explícito, ya sea mediante la solicitud de una cita o la autorización a un profesional. A estos efectos, los profesionales y centros registrados que accedan a los datos de pacientes en la plataforma, asumen en su caso las obligaciones determinadas por la normativa sobre protección de datos aplicable, asumiendo toda la responsabilidad en caso de incumplimiento de dicha norma. Conforme a dicha normativa, los profesionales y centros, aceptan la relación como encargado del tratamiento con respecto a los datos personales que los usuarios registrados facilitan a {platformName} a los efectos de realizar las citas y consultas, manteniendo en todo caso el nivel de datos especialmente protegidos para dicha información.</p></li>\n  <li><p>A las empresas que son utilizadas como soporte para el correcto funcionamiento de la plataforma (cloud) y colaboradores.</p></li>\n  <li><p>En el caso de los servicios de telemedicina para empresas, para generar informes agregados de utilización de la plataforma por parte de sus empleados. Estos informes agregados serán anónimos y únicamente contendrán la siguiente Información: número total de usuarios, número total de servicios utilizados y principales motivos de consulta. Los datos se desglosan por sexo y tramos de edad (empleado registrado y número de consultas).</p></li>\n\n<p><u>No realizamos transferencias internacionales</u></p>\n</ul>\n\n<p><b>C. Calidad de los datos</b></p>\n<p>La Web comunica a los usuarios la obligación de la correcta actualización de los datos facilitados y tratados en el fichero denominado Usuarios. Dichos datos deberán ser adecuados, pertinentes, actuales, exactos y verdaderos. Quedando excluido {platformName} de todas aquellas consecuencias negativas derivadas de inexactitudes en los mismos.</p>\n<p>A su vez, se comunica a los usuarios, la imposibilidad de inscribir y/o comunicar datos de terceros en su nombre, por medio de las formas de comunicación estipuladas, salvo que exista una representación legalmente constituida. En el supuesto de menores, podrá requerirse la acreditación expresa de dicha condición.</p>\n\n<span><p><b>D. Derechos</b></p>Derechos de acceso, oposición, rectificación y cancelación de datos, supresión y portabilidad.</p> <p>Cualquier persona tiene derecho a obtener información sobre si en Open Salud estamos tratando sus datos personales. </p> <p>Las personas legitimadas tienen derecho a acceder a sus datos personales, a solicitar la rectificación de los datos inexactos o, en su caso, solicitar su eliminación cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.</p> <p>Cuando las circunstancias así lo requieran, los interesados podrán solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.</p> <p>Cuando precisemos obtener información por su parte, siempre le solicitaremos su consentimiento expreso a través de los medios habilitados para ello.</p><p>Asimismo, podrá solicitar la entrega en un formato exportable, de un fichero con sus datos en la plataforma. A partir del momento en que descargue o imprima la documentación o información almacenada en opensalud, la custodia sobre la misma pasará a ser de su exclusiva responsabilidad, recomendándole que haga un uso responsable en base a la sensibilidad de la información que contiene, y que la conserve de forma confidencial y con acceso restringido.</p><p>El ejercicio de estos derechos deberá llevarse a cabo mediante comunicación dirigida a Open Salud, ya sea a su dirección postal, indicada más arriba, o a la dirección electrónica dispuesta a estos efectos (soporte@openhealth.es) , sin perjuicio del uso de cualquier otro medio válido en derecho, que permita cumplimentar de forma legalmente válida, los requisitos para ello.</p><p>Los requisitos de contenido para el ejercicio de los derechos son:</p></span> <span><ul><li><p>Nombre y apellidos del interesado.</p></li><li><p>Objeto de la petición.</p></li><li><p>Dirección a efectos de notificaciones, fecha y firma del solicitante.</p></li><li><p>Documentos acreditativos de la petición formulada en el caso de que se estimen convenientes o necesarios.</p></li> </ul></p> </span>\n\n<p><b>E. Agencia Española de Protección de Datos</b></p>\n<p>La AEPD es la encargada de velar por el cumplimiento de las leyes sobre privacidad y protección de datos y de garantizar la seguridad y privacidad de tus datos en general y especialmente en Internet.</p>\n<p>En caso de que sienta vulnerados sus derechos en lo concerniente a la protección de sus datos personales, especialmente cuando no haya obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia de Protección de Datos competente a través de su sitio web: <a href=\"http://www.agpd.es\">www.agpd.es</a></p>\n\n<p><b>F. Enlaces de Interés</b></p>\n<p>Si queréis saber más acerca de Internet y vuestra privacidad desde {platformName} os recomendamos que visitéis los siguientes enlaces para saber más sobre la misma:</p>\n<p>Oficina Seguridad Internet: <a href=\"http://www.osi.es\">http://www.osi.es</a></p>\n<p>Agencia Española de Protección de Datos: <a href=\"http://www.agpd.es\">http://www.agpd.es</a></p>"}}

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCard_vue__ = __webpack_require__(946);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe4198e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCard_vue__ = __webpack_require__(1521);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1519)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fe4198e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe4198e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/ui/BaseCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1fe4198e", Component.options)
  } else {
    hotAPI.reload("data-v-1fe4198e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = path;
function path(path) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return '' + path + (param ? '/' + param : '');
}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = {"companies-contact-form":{"contact-us":"Contáctanos","subtitle":"Si quieres que tu familia acceda a los mejores servicios de salud digital, contáctanos.","form":{"company":"Nombre de la empresa","name":"Nombre","surnames":"Apellidos","employees-number":"Nº empleados (opcional)","phone-number":"Número de teléfono (opcional)","province":"Seleccione su provincia","email":"Correo electrónico","disclaimers":{"personal":"{platform} protege y respeta tu privacidad, solo usaremos tu información para administrar tu cuenta y proporcionar servicios que nos solicitaste.","communications":"Acepto recibir otras comunicaciones de {platform}.<br> Para poder proporcionarte el contenido solicitado, debemos almacenar y procesar tus datos.","privacy":"Acepto la <a href='/politica-privacidad'>Política de privacidad.</a>"},"errors":{"required-fields":"Por favor, rellene los campos","required-consent":"Por favor, antes de continuar debe aceptar recibir comunicaciones y la política de privacidad","required-entity-type":"Por favor, seleccione si es profesional, empresa o usuario","required-entity-ong-type":"Por favor seleccione si es un Profesional, una ONG, o bien indíquenos el tipo de su entidad"},"success":"En breve plazo de tiempo, el equipo de opensalud se podrá en contacto con usted.","website":"Sitio web de la empresa","select-single-or-business":"Seleccione si es particular o empresa","entity-type":{"company":"Empresa","individual":"Usuario particular","health-professional":"Profesional de la salud","company-user":"Usuario empresa","others":"Otros"},"form-reason":"¿En qué podemos ayudarte? (opcional)","collegiateNumber":"Provincia de colegiación","speciality":"Especialidad","error-firstname":"Introduzca su nombre","errors-lastname":"Introduzca sus Apellidos","errors-email":"Introduzca un Email","errors-country":"Introduzca un país de residencia","explain-case":"Descripción","selectUser":"Seleccione Entidad","country":"País de residencia","thank-you":"Muchas gracias"},"want-more-btn":"Quiero más información","service-type":{"digital-health":"de salud digital"},"subtitle2":"Si eres un profesional interesado en colaborar con la iniciativa o una ONG, contáctanos.\n\n","countries":{"spain":"España","mexico":"México","portugal":"Portugal","brazil":"Brasil","colombia":"Colombia","italy":"Italia","other":"Otros"},"select-entity-type":"Seleccione el tipo de usuario..."}}

/***/ }),
/* 280 */,
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return READ_ONLY_TOKEN_SESSION_STORAGE_KEY; });
var READ_ONLY_TOKEN_SESSION_STORAGE_KEY = 'readOnlyToken';

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = {"professional-conditions":"Condiciones para profesionales","patient-conditions":"Condiciones para pacientes","companies-telemedicine":"Salud y bienestar para empresas","contact":"Contacto","legal-notice":"Aviso legal","faqs":"Preguntas frecuentes","all-rights":"Todos los derechos reservados.","lawyer-conditions":"Condiciones para abogados","client-conditions":"Condiciones para clientes","cookies-policy":"Política de cookies","privacy-policy":"Política de privacidad para pacientes","privacy-policy-professional":"Política de privacidad para profesionales","sgsi-policy":"Política SGSI"}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SPAIN_COUNTRY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MX_COUNTRY_ID; });
var SPAIN_COUNTRY_ID = 28;
var MX_COUNTRY_ID = 42;

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = {"clinichistory":"Historia clínica","weight":"Peso","kg":"kg","kg-ph":"Peso en kg","save-btn":"Guardar","cancel-btn":"Cancelar","height":"Altura","height-ph":"Altura en cm","temperature-ph":"Temperatura en °C","cm":"cm","cm-ph":"Altura en cm","age":"Edad","habits":"Hábitos","selectoptions-ph":"Seleccione una o más opciones","presure":"Tensión arterial","mmhg":"mmHg","systolic":"Sistólica","diastolic":"Diastólica","hdl-cholesterol":"Colesterol HDL","mgdl":"mg/dl","hdl":"Colesterol HDL","ldl-cholesterol":"Colesterol LDL","ldl":"Colesterol LDL","cholesterol":"Colesterol","glucose":"Glucosa","glucoselevel":"Nivel de glucosa","triglycerides":"Triglicéridos","blood":"Grupo sanguíneo","select-ph":"Seleccionar","bmi":"Índice de masa corporal","waist":"Cintura","waist-ph":"Cintura en cm","hip":"Cadera","hip-ph":"Hip en cm","heartRate":"Frecuencia cardíaca","bpm":"ppm","breathingFrequency":"Frecuencia respiratoria","rpm":"rpm","oxygenSaturation":"Saturación oxígeno","measureUnits":{"weight":"kg","height":"cm","age":"años","temperature":"ºC","presure":"mmHg","hdl":"mg/dl","ldl":"mg/dl","cholesterol":"mg/dl","glucose":"mg/dl","triglycerides":"mg/dl","hip":"cm","waist":"cm","heartRate":"ppm","breathingFrequency":"rpm","oxygenSaturation":"%","fatMass":"kg","fatFreeMass":"kg","vitaminD":"UI","calories":"kcal"},"adddeletevariables":"Agregar/Eliminar variables","hide-btn":"Ocultar","healthvariables":"Variables de salud","othervariables":"Otras variables de salud","healthcondition":"Estado de salud","feeding":"¿Cómo ha sido tu alimentación?","sleep":"¿Cómo has dormido?","exercise":"¿Cuál ha sido tu nivel de ejercicio?","stress":"¿Cuál ha sido tu nivel de estrés?","telemonitorization":"Telemonitorización y aplicaciones externas","noservices":"Aún no ha añadido ningún servicio.","go-btn":"Ir","delete-btn":"Eliminar","selectservice":"Selecciones el servicio que desee añadir:","servicesoon":"Este servicio estará disponible próximamente","accept-btn":"Aceptar","observations":"Observaciones","edit-btn":"Editar","experiences":"Acontecimientos y experiencias significativas","authorizedpeople":"Personas autorizadas","createauthorizedpeople":"Crear persona autorizada","show-btn":"Mostrar","diseases":"Enfermedades","diseases-ph":"Introduzca el nombre de la enfermedad","diseasedate-ph":"Fecha (dd/MM/aaaa) (opcional)","allergies":"Alergias","allergy-ph":"Introduzca el nombre de la alergia","gravity-ph":"Gravedad","medication":"Medicación","medication-ph":"Introduzca el nombre de la medicación","currentmedication":"Actualmente tomo la medicación","medicationstart-ph":"Inicio (dd/MM/aaaa) (opcional)","medicationend-ph":"Fin (dd/MM/aaaa) (opcional)","vaccines":"Vacunas","vaccine-ph":"Introduzca el nombre de la vacuna","familyhistory":"Antecedentes familiares","familyhistory-ph":"Introduzca el antecedente","relationship":"Parentesco","genogram":"Genograma","selectimage":"Selecciona una imagen:","seegenogram":"Ver genograma","hidegenogram":"Ocultar genograma","clinicdocuments":"Documentos clínicos y formularios","recommendedApps":"Aplicaciones e información de interés","filterdocuments":"Filtrar por tipo de documento","filterapps":"Filtrar por tipo de aplicación","addfile":"Adjuntar archivos/documentos","addfile-ph":"Añadir archivo/documentos","addapp-ph":"Añadir aplicacion/información de interés","appointments":"Consultas","years-text":"años","nointroduced":"No introducida","name-column":"Nombre","surname-column":"Apellidos","dni-column":"Dni","email-column":"Email","relationship-column":"Parentesco","phone-column":"Teléfono","description-column":"Descripción","date-column":"Fecha","gravity-column":"Gravedad","start-column":"Inicio","end-column":"Fin","notmedicines":"Actualmente no tomo la medicación","title18chtvaccine":"Vacuna","code-column":"Código","filetype-column":"Tipo fichero","uploadedby-column":"Subido por","see-btn":"Ver","download-btn":"Descargar","disease-del":"La enfermedad ha sido eliminada de su historia clínica","link-del":"El enlace de interés ha sido eliminado de su historia clínica","doc-del":"El documento ha sido eliminado de su historia clínica","allergy-del":"La alergia ha sido eliminada de su historia clínica","drug-del":"El medicamento ha sido eliminado de su historia clínica","vaccine-del":"La vacuna ha sido eliminada de su historia clínica","familyhistory-del":"El antecedente familiar ha sido eliminado de su historia clínica","drug-del-error":"Se ha producido un error al eliminar su medicamento","nodisease":"No padece ninguna enfermedad","noallergy":"No padece ninguna alergia","nolinks":"No tiene ningún enlace de interés","nodrug":"Aún no ha añadido ningún medicamento","novaccine":"Aún no ha añadido ninguna vacuna","nofamilyhistory":"No posee antecedentes familiares","successchanges":"Cambios realizados con éxito","health-qst":"¿Cómo te encuentras de salud?","stress-qst":"Actualmente dirías que tu nivel de estrés es...","feeding-qst":"¿Cómo has comido esta semana?","sleep-qst":"¿Cómo has dormido?","exercise-qst":"¿Has hecho ejercicio?","history":"Historial","savesuccesshistory":"Se han guardado sus observaciones correctamente","savedanger":"Se ha producido un error. Inténtelo de nuevo, más tarde","savesuccesshabits":"Se han guardado sus hábitos saludables correctamente.","valuenumericerror":"Por favor, introduzca un valor entre 1 y 10","actualdata":"Se han actualizado los datos correctamente","errordata":"Error actualizando los datos. Inténtelo otra vez, más tarde.","documentspatient":"Ficheros Pacientes","dataopensalud":"Informe Opensalud","Name":"Nombre","HabitsTypes":"Tipos Hábitos","BloodTypes":"Grupos Sanguíneos","selectarchive":"Seleccionar un archivo","selectarchive2":"Seleccionar o arrastrar un archivo aquí para subir","savedarchive":"Su archivo ha sido guardado. <br> Puede eliminarlo cuando lo desee en 'Mis datos de salud' > 'Documentos clínicos'","owarchive":"Su archivo ha sido sobreescrito con éxito","selectimage-js":"Seleccionar una imagen","selectimage2":"Seleccionar o arrastrar una imagen aquí para subir","savesuccess":"Guardado completado con éxito.","errorhistory":"Error solicitando la historia clínica. Inténtelo otra vez, más tarde","healthcondition-min":"Muy mal","healthcondition-max":"Perfecto!","stress-min":"Ninguno","stress-max":"Mucho","feeding-min":"Muy mal","feeding-max":"Muy bien","sleep-min":"Muy mal","sleep-max":"Excelente","exercise-min":"Nada","exercise-max":"En exceso!","activeservice":"Ya tiene activado el servicio de ","errorservice":"Se ha producido un error, por favor, inténtelo de nuevo más tarde","serviceof":"El servicio de ","beendeleted":" ha sido eliminado.","serviceerrordelete":"El servicio no ha podido ser eliminado. Inténtelo de nuevo más tarde.","diseaseselecterror":"Debe seleccionar una enfermedad.","dangerdisease":"No puede asignar una enfermedad ya agregada","mustdeleteallergies":"Debe borrar las alergias registradas","selectallergy":"Debe seleccionar una alergia","selectseverity":"Debe seleccionar una gravedad para la alergia.","notassignedallergy":"No puede asignar una alergia ya agregada.","selectdrug":"Debe seleccionar una medicación","dateinfodrugs":"Por favor, especifique la fecha en la que terminó de tomar la medicación, o bien, marque la casilla Actualmente tomo la medicación, si está tomando el medicamento.","notassigneddrug":"No puede asignar una medicación ya agregada.","selectvaccine":"Debe seleccionar una vacuna.","selectdisease":"Debe seleccionar una enfermedad","selectrelationship":"Debe seleccionar un parentesco.","norepeatdisease":"No puede repetir una enfermedad para el mismo parentesco.","disease-column":"Síntoma/Enfermedad","speciality-column":"Especialidad","appointmenttype-column":"Tipo de consulta","seeappointment-btn":"Ver consulta","appointmentsHistory":"Historial de consultas","invalidDate":"Debe introducir una fecha válida","addReminderMedication":"¿Desea añadir un recordatorio para el medicamento?","yes":"Sí","no":"No","visit":"Visitar","fromURLComplete":"Si aún no está marcado como completado este documento, se le enviará un email al profesional que creó el mismo notificándole dicha acción.<br><br> ¿Desea continuar?","completeSuccess":"Operación realizada con éxito","fromFileComplete1":"A continuación va a subir un archivo, previamente descargado y completado, el cual sustituirá al anterior.<br><br> El/la profesional será notificado/a de que ha completado este documento si aún no está marcado como tal.<br>","fromFileComplete2":"¿Desea sobreescribir el archivo en cuestión?","clearUpload":"Limpiar","speciality":"Especialidad","filterSpe":"Filtrar por especialidad","fillStartDate":"Introduzca una fecha de inicio","fillEndDate":"Introduzca una fecha de fin","selectReminderInterval":"Introduzca el intervalo del recordatorio","selectReminderFrequency":"Introduzca la frecuencia del recordatorio","introduceCorrectDates":"Introduzca un intervalo de tiempo correcto","reminderSuccess":"Su recordatorio ha sido creado con éxito","reminderDeleteSuccess":"Su recordatorio ha sido eliminado con éxito","reminderDeleteSure":"¿Estás seguro de que quieres eliminar el recordatorio?","datePlaceholder":"dd/mm/aaaa","unlockFilesQuestion":"¿Está seguro de que desea desbloquear este archivo? <br><br> Si usted desbloquea este archivo podrá ser visualizado por todos los profesionales/centros con los que interactúe.","unlockFilesAnswer":"El archivo ha sido desbloqueado con éxito","lockFilesQuestion":"¿Está seguro de que desea bloquear este archivo? <br><br> Si usted bloquea este archivo solo podrá ser visualizado por usted y por el profesional/centro que haya generado dicho documento, si es el caso.","lockFilesAnswer":"El archivo ha sido bloqueado con éxito","accept":"Aceptar","fileIsLocked":"El paciente ha bloqueado el archivo","temperature":"Temperatura","alarms":"Alarmas","alarms.info":"Habilitando las alarmas para las variables de salud de este paciente, recibirá un whatsapp y un email cada vez que el paciente se tome una medida fuera de los límites establecidos.","alarms.enable.success":"Se han activado las alarmas para todas las variables de salud","alarms.disable.success":"Se han desactivado las alarmas para todos las variables de salud","fatMass":"Masa de grasa","fatMass-ph":"Masa grasa (Kg)","fatFreeMass":"Masa libre de grasa","fatFreeMass-ph":"Masa sin grasa (Kg)","homa":"Homa","homa-ph":"Homa","vitaminD":"Vitamina D","vitaminD-ph":"Vitamina D en UI","steps":"Pasos","steps-ph":"Pasos","calories":"Calorias","calories-ph":"Calorias en Kcal","mood":"Estado anímico","confirm-save-slider":"¿Está seguro que desea guardar los cambios?","additional-health-variables":"Otras variables de salud","appointment-history":{"not-found":"No se han encontrado consultas"},"observations-ph":"Escriba aquí...","signupDiscovery":{"title2":"Recomendación de paciente"},"healthmind":{"pricing":"2,95€"},"medallergies":"Alergias a medicamentos","chrondiseases":"Enfermedades crónicas","dateStart":"Fecha inicio","dateEnd":"Fecha fin","nofiles":"No ha añadido documentos clínicos","healthyVars":"Variables de salud","feedingHabits":"Hábitos de alimentación","moodAndHabits":"Hábitos y estado anímico","historyAndDiseases":"Antecedentes y enfermedades","medicalEvaluation":"Evaluación médica","historyAndDiseasesReduced":"Antecedentes/Enferme.","dontKnow":"No lo sé","mustFillAllData":"Rellene los datos del formulario. En caso de no conocer el valor, pulse en \"No lo sé\" o en \"Ninguna de las anteriores\"","dontKnowOrDontAnswer":"No lo sé/No responder","quizDialog":{"completeMedicalEvaluation":"Estás a punto de completar tu perfil básico de salud. Añade algunos valores de tu última revisión para sacar todo el partido a opensalud.<br><br>¿Desea rellenar estos datos?"},"completeYourHealthProfile":"Complete su perfil de salud","fillQuizAdvice":"Esta información le facilitará el cuidado y la mejora de la atención recibida cuando la necesite, dentro o fuera de opensalud.","remindLater":"Recordar más adelante","clinicHistory":"Historia clínica","clinicDocuments":"Documentos clínicos","applicationsAndInformationOfInterest":"Aplicaciones e información de interés","bloodMonitor":"Monitorizar tensión","glycemiaMonitor":"Monitorizar glucemia","otherMoment":"En otro momento","searchOrSelectOptions":"Busque o seleccione una o varias opciones","pressEnterToSelect":"Pulse enter para seleccionar","pressEnterToRemove":"Pulse enter para deseleccionar","selected":"Seleccionado","healthyHabits":"Mis objetivos y hábitos","significantEventsAndExperiences":"Acontecimientos y experiencias significativas","file-type-column":"Tipo fichero","selectOneOption":"Seleccione una opción","clinic-history":{"wellbeing-score":"Wellbeing score","concede-access":"Conceder acceso a mi historia clínica","professionals-and-centers-authorizated":"Profesionales y centros autorizados","select-patient":"Seleccione un paciente","select-pet":"Seleccione una mascota","select-prof-center":"seleccione un profesional/centro","back-history":"Volver a mi historia","grant-access":"Conceder acceso historia","access-authorizated":"Accesos autorizados","already-saved-today-variable":"Ya ha guardado datos hoy en esta variable. Vuelva mañana para introducirlos de nuevo.","in-last-7-days":"En los últimos 7 días...","selectPet":"Seleccionar mascota"},"currentlyTakeMed":"Actualmente tomo la medicación","selectStartDate":"Seleccione fecha de inicio","selectEndDate":"Seleccione fecha de fin","currentlyNoTakeMed":"Actualmente no tomo la medicación","medicationSelectError":"Debe seleccionar una medicación","medicationEndDateMinorStartDate":"La fecha de fin de la medicación no puede ser inferior a la fecha de inicio","allergySelectError":"Debe seleccionar una alergia","allergySeveritySelectError":"Debe seleccionar la gravedad de la alergia","vaccineSelectError":"Debe seleccionar una vacuna","familyHistorySelectError":"Debe seleccionar un antecedente","relationshipSelectError":"Debe seleccionar un parentesco","noMedAllergies":"No tengo alergias a medicamentos","applicationsAndInformationOfInterestReduced":"Apli./info interés","document":{"url":"URL (http://...)","uploadFromThisDevice":" Subir desde este dispositivo","insertLink":"Introducir una URL (Enlace)"},"link":{"nameError":"Debe introducir un nombre para el enlace","linkError":"Debe introducir una url válida"},"filterByType":"Filtrar por tipo","revokeAccess":"Revocar acceso","revokeAccessClinic":{"error":"Error realizando la revocación. Inténtelo de nuevo","owner":"No puede revocar el acceso a quien creó su usuario","withAppointment":"No puede revocar el acceso a un profesional con el que ha tenido cita","center":"No puede revocar el acceso al centro de un profesional con el que ha accedido a compartir su historial con sus centros asociados","success":"Revocación realizada con éxito"},"grantAccessClinicHistory":"Conceder acceso a mi historia clínica","historyGrantAccessText":"Puede compartir su historia clínica con un profesional/centro de la plataforma o generar un enlace de solo lectura para compartir con quien decida.","shareInternally":"Compartir internamente","generateLink":"Generar enlace","grantAccessSelectProfOrCenter":"Debe seleccioanar un profesional o centro","historyShare":"Compartir","validityInDays":"Validez en días","sharelinkError":{"days":"Debe introducir una validez de 1 a 30 días","emails":"Debe introducir al menos 1 email","wrongEmail":"Debe corregir los siguientes emails:","validity":"Debe introducir una validez entre 1 y 180 días"},"linkSendedSuccessfully":"Enlace enviado correctamente","later":"Más tarde","significantEventsAndExperiencesReduce":"Aconte. y expe. significativas","vaccine-commercial-name":"Nombre comercial (opcional)","dateBeforeNowError":"La fecha seleccionada debe ser inferior a la actual","commercial-name-column":"Nombre comercial","completedQuiz":"completado","completedHistory":"Completado","history-files-overwrite-content":"A continuación va a subir un archivo, previamente descargado y completado, el cual sustituirá al anterior.<br><br>El/la profesional será notificado/a de que ha completado este documento si aún no está marcado como tal.","history-files-overwrite-question":" ¿Desea sobreescribir el archivo en cuestión?","mark-as-complete-text":"Si marca como completado este documento, se le enviará un email al profesional que creó el mismo notificándole dicha acción.<br><br>¿Desea continuar?","lock-file-advice":"¿Está seguro de que desea bloquear este archivo? <br><br> Si usted bloquea este archivo solo podrá ser visualizado por usted y por el profesional/centro que haya generado dicho documento, si es el caso.","unlock-file-advice":"¿Está seguro de que desea desbloquear este archivo? <br><br> Si usted desbloquea este archivo podrá ser visualizado por todos los profesionales/centros con los que interactúe.","wantAddReminderMed":"¿Desea añadir un recordatorio para el medicamento?","medicationReminder":"Recordatorio de medicamentos","reminderMedicationForm":{"alias":"Alias para el medicamento","aliasInput":"Introduzca un nombre corto para identificar el medicamento en la agenda","startDate":"Fecha de inicio","endDate":"Fecha fin","color":"Color para hueco de agenda","interval":"Intervalo del recordatorio","selectInterval":"Seleccione un intervalo","hour":"Seleccione una hora","reminderEach":"Recordar cada...","repeatEach":"Repetir cada","error":{"alias":"Debe introducir un alias para el medicamento","endDate":"Debe introducir la fecha de fin para el recordatorio","dateBefore":"La fecha de inicio debe ser mayor a la actual","color":"Debe seleccionar un color para el hueco de la agenda","startGreater":"La fecha de fin debe ser mayor que la de inicio","startGreaterThanNow":"La fecha de fin del recordatorio debe ser mayor que la fecha actual","medicine":"Debe seleccionar un medicamento","interval":"Debe seleccionar un intervalo de repetición mayor a 1 día/semana","tabletsLessThan1":"Debe introducir un número deunidades mayor o igual a 1","tabletsFromHour":"Debe seleccionar la hora de inicio de la medicación","tabletsToHour":"Debe seleccionar la hora de fin de la medicación","frequencyOption":"Debe seleccionar la frecuencia de tomas para el medicamento","intakesDay":"Debe seleccionar al menos 2 tomas al día","weekDays":"Debe seleccionar, al menos, 1 día de la semana","cylicStartDate":"Debe seleccionar la fecha de inicio del ciclo","notifications":"Debe seleccionar, al menos, un medio para las notificaciones","tabletsReminder":"Las tomas por envase del recordatorio de existencias debe ser menor al límite de envases","tabletsReminderFill":"Debe introducir un número válido de tomas por envases para el recordatorio de reposición"},"option":"Seleccione una opción","sucess":"Recordatorio creado correctamente","frequencyTitle":"¿Con qué frecuencia toma este medicamento?","frequency":{"interval":"Intervalo","severalTimesDay":"Varias veces al día","weekDays":"Días de la semana","cyclic":"Cíclico"},"tablets":"Unidades","fromHour":"Desde","toHour":"Hasta","selectWeekDays":"Seleccione los días:","tabletsDay":"tomas al día","pause":"pausa","intakes":"tomas","pauses":"pausas","hourTitle":"Hora","intakesPerContainer":"tomas por envase","reminder":"Recordatorio","reminderFillQuestion":"¿Recibir recordatorio para rellenar existencias?","reminderMedicineTitle":"tomas por envase, recordar cuando falten","notificationsQuestion":"Seleccione dónde recibirá la notificaciones:","units":"unidades","startHour":"Hora inicio","endHour":"Hora fin"},"theDay":"El día","other":"Otro...","maximum":"Máxima","minimum":"Mínima","file":{"select":"Debe seleccionar un archivo"},"noEvaluationTests":"No hay tests completados por el paciente","relvantsExperiences":"Acontecimientos relevantes","healthProfile":"Perfil de salud","removeReminder":"Eliminar recordatorio","removeMedication":"Eliminar medicación","seeReminder":"Ver recordatorio","createReminder":"Crear recordatorio","options":"Opciones","canNotAccessReadOnly":"No puede acceder a esta sección en modo solo lectura","documentsAndInformation":"Documentos e información","healthData":"Variables de salud","healthQuiz":"Cuestionario de salud","reason-column":"Motivo","pastMedication":"Medicación pasada","currentMedication":"Medicación actual","noPastDrug":"No hay medicamentos pasados","addOrDeleteHealthvar":"Agregar/eliminar variables","otherAllergies":"Otras alergias","locked":"Bloqueado","unlocked":"Desbloqueado","pets":"Mascotas","clinic-history-variable-slider":{"stress":{"min":"Muy elevado","max":"Cero estrés!"},"feeding":{"min":"Nada saludable","max":"Super saludable!"},"sleep":{"min":"Realmente mal","max":"Perfectamente!"},"exercise":{"min":"Nada","max":"En exceso!"},"healthcondition":{"min":"Realmente mal","max":"Perfectamente!"},"healthconditiontoday":{"min":"Realmente mal","max":"Perfectamente!"}},"howDoYouFeel":"Tus hábitos en la última semana","healthMonitoring":"Seguimiento de salud","reminderFrequency":"Frecuencia del recordatorio","noDataProfAndCenterAuthorized":"Aún no ha concedido acceso a profesionales o centros","shareHistoryAccessLinkPlaceholder":"Introduzca los emails de los destinatarios (sin incluir el suyo) separados por saltos de línea, comas, espacios en blanco ó puntos y comas","noneOfTheAbove":"Ninguna de las anteriores","mustFillQuizPressureData":"Si introduce la tensión arterial sistólica o diastólica, debe completar ambos campos en el cuestionario","presureVarSaveError":"Debe introducir la presión arterial con el formato: Sistólica/Diastólica","isNanError":"Debe introducir un número válido","bloodPressureReduced":"Sis/Dia","healthconditiontoday":"¿Cómo te sientes hoy?","shareLinkValidity":"Introduzca un valor entre 1 y 180 días","reportOrPrescripcion":"Receta/Prescripción","menstrual-calendar":"Calendario menstrual","fileLockedByPatient":"El paciente ha bloqueado el archivo","menstrualCycle":"Control de ciclos","cycleStartDate":"FECHA DE INICIO DEL CICLO","periodDuration":"Duración del período (días):","cycleDuration":"Duración del ciclo (días):","addCycle":"Agregar ciclo","historyCycle":"Historial de ciclos","cycleDuration2":"Duración del ciclo","periodDuration2":"Duración del período","ovulationDuration":"Días de ovulación","cycle":"Ciclo","delete":"Eliminar","cycleControl":"Control de ciclos","noControl":"No hay ciclos registrados","startCycle":"comenzar ciclo","setPeriodDuration":"Establecer duración del periodo","current":"EN CURSO desde","confirmEndCurrentCycle":"¿Desea finalizar el ciclo actual?","until":"hasta","add-txt":"Añadir","mustSetPeriod":"Debe de establecer el periodo del ciclo actual antes de poder añadir uno nuevo","error-cycles-get":"No se pudieron obtener los ciclos. Por favor inténtelo de nuevo más tarde","error-cycles-delete":"No se pudo eliminar el ciclo. Por favor, inténtelo de nuevo más tarde","error-cycles-set":"No se pudo establecer la duración del periodo. Por favor, inténtelo de nuevo más tarde","error-cycles-start":"No se pudo comenzar el ciclo. Por favor, inténtelo de nuevo más tarde","error-cycles-set2":"No se pudo actualizar el ciclo actual. Por favor, inténtelo de nuevo más tarde","ovulationDurationPrediction":"Predicción días de ovulación","new-cycle":"Nuevo ciclo","newCyclePredictionDate":"Predicción inicio próximo ciclo","enterMedicineName":"Introduzca el nombre del medicamento","addNewMedicationReminder":"Añadir recordatorio","tabletsLeft":"Unidades restantes","medicationReminderEachXTime":"Cada {time} {interval}","timesToDay":"veces al día","confirmRemoveMedicationReminder":"¿Desea borrar este recordatorio?","resetTabletsReminder":"Restablecer unidades","editMedicationReminder":"Editar recordatorio medicamento"}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_date_helpers__ = __webpack_require__(179);















var DEFAULT_PROMISE = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function () {});

/* harmony default export */ __webpack_exports__["a"] = ({
	computed: {
		historyPatientId: function historyPatientId() {
			return this.$route.params.historyPatientId || sessionStorage.getItem('healthyHabitsPatientId') || this.$store.state.healthyHabits.historyPatientId;
		}
	},
	methods: {
		// Repository wrapper methods
		logOffNotAuthorized: function logOffNotAuthorized() {
			window.$cookies.remove('api_token', null, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_global_helpers__["c" /* getBaseDomain */])());
			this.$store.state.session.loginCallback = function () {
				this.$router.push('/').catch(function () {});
			};
			this.$router.push('/inicio-sesion');
		},
		sessionCookieIsValid: function sessionCookieIsValid(serverData) {
			var _this2 = this;

			if (serverData.response && serverData.response.status === 401 || serverData.data && serverData.data.errorId) {
				this.$store.dispatch('showInfoAlert', serverData.data && serverData.data.errorId === '403' ? this.$t('professionalNotAllowed') : this.$t('sessionExpired'));
				setTimeout(function () {
					_this2.logOffNotAuthorized();
				}, 4000);
				return false;
			}
			return true;
		},
		processPromise: function processPromise(promise) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.t0 = _this3;
								_context.next = 3;
								return promise;

							case 3:
								_context.t1 = _context.sent;

								if (!_context.t0.sessionCookieIsValid.call(_context.t0, _context.t1)) {
									_context.next = 8;
									break;
								}

								return _context.abrupt('return', promise);

							case 8:
								return _context.abrupt('return', DEFAULT_PROMISE);

							case 9:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3);
			}))();
		},
		getTableData: function getTableData(allData) {
			var limitDate = this.$store.state.healthyHabits.table.limitDate;
			var date = limitDate.getFullYear() + '-' + ('0' + (limitDate.getMonth() + 1)).slice(-2) + '-' + ('0' + limitDate.getDate()).slice(-2) + 'T00:00:00';
			var promise = __WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].getTableData(date, this.$store.state.healthyHabits.table.prevDates, allData, this.historyPatientId);
			return this.processPromise(promise);
		},
		updateTableData: function updateTableData(data) {
			return this.processPromise(__WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].updateTableData(data));
		},
		removeTableData: function removeTableData(data) {
			return this.processPromise(__WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].removeTableData(data));
		},
		getStatistics: function getStatistics() {
			var promise = __WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].getStatistics(this.$store.state.healthyHabits.table.itemSelectedId, this.historyPatientId);
			return this.processPromise(promise);
		},
		getUserSetting: function getUserSetting() {
			var _this4 = this;

			this.processPromise(__WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].getUserSetting()).then(function (serverData) {
				if (serverData.data) {
					_this4.processHealthyHabitsSetting(serverData.data);
				}
			});
		},
		updateFormData: function updateFormData(data) {
			return this.processPromise(__WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].updateFormData(data));
		},
		createDataForm: function createDataForm(data) {
			return this.processPromise(__WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].createDataForm(data));
		},
		getHealthyHabitsStatistics: function getHealthyHabitsStatistics(id) {
			var _this5 = this;

			this.$store.state.healthyHabits.table.itemSelectedId = id;
			this.getStatistics().then(function (serverData) {
				_this5.processHealthyHabitsDataForStatistics(serverData.data);
			});
		},
		getHealthyHabitsData: function getHealthyHabitsData(allData, partialData) {
			var _this6 = this;

			this.getMaxMinDate(!partialData);
			this.$store.state.healthyHabits.table.limitDate = partialData ? this.$store.state.healthyHabits.table.limitDate : this.getCurrentDateUtc();
			this.getTableData(allData).then(function (serverData) {
				_this6.$store.state.healthyHabits.hideLoadingIcon = false;
				_this6.$store.state.healthyHabits.table.minDateServer = new Date(serverData.data.minDate);
				_this6.$store.state.healthyHabits.table.maxDateServer = new Date(serverData.data.maxDate);
				if (partialData) {
					_this6.processHealthyHabitsPartialData(serverData.data);
				} else {
					_this6.$store.state.healthyHabits.table.data = _this6.processHealthyHabitsDataForTable(serverData.data);
				}
			});
		},
		processHealthyHabitsSetting: function processHealthyHabitsSetting(settingData) {
			if (settingData.isProfessional) {
				if (this.$route.params.historyPatientId) sessionStorage.setItem("healthyHabitsPatientId", this.$route.params.historyPatientId);
				this.$store.state.healthyHabits.setting.isProfessional = true;
				this.$store.state.healthyHabits.isReadOnlyView = true;
				return;
			}
			this.$store.state.healthyHabits.setting.nick = settingData.nick;
			this.$store.state.healthyHabits.setting.habitUserId = settingData.habitUserId;
			this.$store.state.healthyHabits.setting.notifications.email = settingData.notificationsEmail;
			this.$store.state.healthyHabits.setting.notifications.phone = settingData.notificationsPhone;
			this.$store.state.healthyHabits.setting.showStoredHabits = settingData.showStoredHabits;
			this.$store.state.healthyHabits.setting.originalShowStoredHabits = settingData.showStoredHabits;
			this.$store.state.healthyHabits.setting.originalShowGoalCompletedHabits = settingData.showGoalCompletedHabits;
			this.$store.state.healthyHabits.setting.showGoalCompletedHabits = settingData.showGoalCompletedHabits;
			this.$store.state.healthyHabits.setting.allowFreeDays = settingData.allowFreeDays;
			this.$store.state.healthyHabits.setting.originalAllowFreeDays = settingData.allowFreeDays;
			this.$store.state.healthyHabits.setting.invertedCalendarDays = settingData.invertedCalendarDays;
		},
		processHealthyHabitsDataForStatistics: function processHealthyHabitsDataForStatistics(chartData) {
			var _this7 = this;

			if (chartData) {
				this.$store.state.healthyHabits.chart.data = [];
				this.$store.state.healthyHabits.chart.title = chartData.description;
				this.$store.state.healthyHabits.chart.question = chartData.question;
				this.$store.state.healthyHabits.chart.notes = chartData.notes;
				this.$store.state.healthyHabits.chart.reminder = chartData.reminder;
				this.$store.state.healthyHabits.chart.reminderDays = chartData.reminderDays;
				this.$store.state.healthyHabits.chart.goalFrequencyId = chartData.goalFrequencyId;
				this.$store.state.healthyHabits.chart.goal = chartData.goal;
				this.$store.state.healthyHabits.chart.goalCompleted = chartData.goalCompleted;
				this.$store.state.healthyHabits.chart.measurable = chartData.measurable;
				this.$store.state.healthyHabits.chart.measureUnit = chartData.measureUnit;
				this.$store.state.healthyHabits.chart.color = chartData.color;
				this.$store.state.healthyHabits.chart.total = chartData.totalDays;
				this.$store.state.healthyHabits.chart.bestStreak = chartData.bestStreakDays;
				this.$store.state.healthyHabits.chart.currentStreak = chartData.currentStreakDays;
				for (var item in chartData.data) {
					var currentItem = chartData.data[item];
					this.$store.state.healthyHabits.chart.data.push({ date: new Date(currentItem.date), value: parseFloat(currentItem.value) >= 0 ? parseFloat(currentItem.value) : currentItem.value === 'true' ? 1 : currentItem.value === 'false' ? 0 : null });
				}
				this.$store.state.healthyHabits.chart.dataMapped = this.processHealthyHabitsDataMapped(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.$store.state.healthyHabits.chart));
			} else {
				var newValue = this.$store.state.healthyHabits.itemSelected.newValue;
				var newValueFormatted = parseFloat(newValue) >= 0 ? parseFloat(newValue) : newValue === true ? 1 : newValue === false ? 0 : null;
				if (parseFloat(newValue) === 0 || newValue === false) {
					this.$store.state.healthyHabits.chart.data = this.$store.state.healthyHabits.chart.data.filter(function (data) {
						return _this7.getDateOnlyFormatted(data.date) !== _this7.$store.state.healthyHabits.itemSelected.date;
					});
					delete this.$store.state.healthyHabits.chart.dataMapped[this.$store.state.healthyHabits.itemSelected.date];
				} else {
					var dataExists = this.$store.state.healthyHabits.chart.data.some(function (data) {
						return _this7.getDateOnlyFormatted(data.date) === _this7.$store.state.healthyHabits.itemSelected.date;
					});
					if (dataExists) {
						this.$store.state.healthyHabits.chart.data.find(function (data) {
							return _this7.getDateOnlyFormatted(data.date) === _this7.$store.state.healthyHabits.itemSelected.date;
						}).value = newValueFormatted;
					} else {
						this.$store.state.healthyHabits.chart.data.push({ date: new Date(this.$store.state.healthyHabits.itemSelected.date), value: newValueFormatted });
					}
					this.$store.state.healthyHabits.chart.dataMapped[this.$store.state.healthyHabits.itemSelected.date] = parseFloat(newValue) >= 0 ? parseFloat(newValue) : newValue;
				}
			}
			this.$store.state.healthyHabits.chart.data.sort(function (a, b) {
				return a.date - b.date;
			});
			if (this.$store.state.healthyHabits.chart.data.length > 0 && this.$store.state.healthyHabits.chart.data.some(function (h) {
				return h.value !== null;
			})) {
				this.getHistoryOptions(!chartData);
				this.getFrequencyOptions(!chartData);
				this.getScoreOptions(!chartData);
			} else {
				this.$store.state.healthyHabits.chart.history.options = {};
				this.$store.state.healthyHabits.chart.frequency.options = {};
				this.$store.state.healthyHabits.chart.score.options = {};
				this.$store.state.healthyHabits.chart.score.currentValue = 0;
			}
			if (this.$store.state.healthyHabits.itemSelected.fromCalendar) {
				this.generateCalendar(true);
			}
			this.$store.state.healthyHabits.chart.showChart = true;
		},
		processHealthyHabitsDataForTable: function processHealthyHabitsDataForTable(tableData) {
			var _this8 = this;

			var habitsIdToResetCurrentStreak = [];
			var fields = [{ key: 'description', label: '' }, { key: 'nextDates', label: '' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.getHeaderDatesInIntervalFormatted(this.$store.state.healthyHabits.table.minDate, this.$store.state.healthyHabits.table.maxDate)), [{ key: 'prevDates', label: '' }, { key: 'actions', label: '' }]);
			// if (!this.mobileVersion()) fields = [...fields, { key: 'sliderSection1', label: '' }, { key: 'sliderSection2', label: '' }, { key: 'sliderSection3', label: '' }]
			var items = tableData.data.length === 0 ? [] : tableData.data.map(function (item) {
				var result = {};
				result.id = item.id;
				result.description = item.description;
				result.question = item.question;
				result.reminder = item.reminder;
				result.reminderDays = item.reminderDays;
				result.notes = item.notes;
				result.measurable = item.measurable;
				result.measureUnit = item.measureUnit;
				result.goal = item.goal || 1;
				result.goalFrequencyId = item.goalFrequencyId;
				result.bestStreak = item.bestStreakDays;
				result.total = item.totalDays;
				result.color = item.color;
				result.createdAt = item.createdAt;
				result.stored = item.stored;
				result.isMultiUser = item.isMultiUser;
				result.position = item.position;
				result.goalCompleted = item.goalCompleted;
				result.showActionButtons = false; //only for client
				result.multiUserData = [];
				result.multiUserInfo = [];
				if (item.data.length > 0) {
					item.data.map(function (itemData) {
						if (result.measurable) {
							result[_this8.getDateOnlyFormatted(itemData.date)] = parseFloat(itemData.value);
						} else {
							result[_this8.getDateOnlyFormatted(itemData.date)] = itemData.value === 'true' ? true : itemData.value === 'false' || itemData.value === 0 ? false : null;
						}
					});
				}
				if (item.multiUserInfo && item.multiUserInfo.length > 0) {
					var multiUserMapped = [];
					if (item.multiUserData.length > 0) {
						var _loop = function _loop(index) {
							var multiUserSingle = {};
							var healthyHabitsUserId = item.multiUserInfo[index].healthyHabitsUserId;
							item.multiUserData.filter(function (x) {
								return x.healthyHabitsUserId === healthyHabitsUserId;
							}).map(function (itemData) {
								if (result.measurable) {
									multiUserSingle[_this8.getDateOnlyFormatted(itemData.date)] = parseFloat(itemData.value);
								} else {
									multiUserSingle[_this8.getDateOnlyFormatted(itemData.date)] = itemData.value === 'true' ? true : itemData.value === 'false' || itemData.value === 0 ? false : null;
								}
							});
							multiUserSingle.goal = result.goal;
							multiUserSingle.goalFrequencyId = result.goalFrequencyId;
							multiUserSingle.healthyHabitsUserId = item.multiUserInfo[index].healthyHabitsUserId;
							if (!result.measurable) {
								_this8.fillPartialGoalCompleted(multiUserSingle);
							}
							multiUserMapped.push(multiUserSingle);
						};

						for (var index in item.multiUserInfo) {
							_loop(index);
						}
						result.multiUserData = multiUserMapped;
					}
					result.multiUserInfo = item.multiUserInfo;
				}
				result.accumulatedGoal = !_this8.$store.state.healthyHabits.table.data.items || !_this8.$store.state.healthyHabits.table.data.items.find(function (h) {
					return h.id === item.id;
				}) ? _this8.lastGoalAccumulated(result) : _this8.$store.state.healthyHabits.table.data.items.find(function (h) {
					return h.id === item.id;
				}).accumulatedGoal;
				if (!result.measurable) {
					_this8.fillPartialGoalCompleted(result);
				}
				result.currentStreak = item.data.length > 0 ? _this8.getCurrentStreakOnStart(result.measurable ? _this8.fillMeasurablePartialGoalCompleted(result) : result, item.currentStreakDays) : item.currentStreakDays;
				if (item.currentStreakDays !== result.currentStreak) {
					habitsIdToResetCurrentStreak.push(item.id);
				}
				return result;
			});
			this.$store.state.healthyHabits.itemSelected.fromCalendar = false;
			this.$store.state.healthyHabits.chart.showChart = false;
			this.$store.state.healthyHabits.bestStreak = items.length > 0 ? Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(items.map(function (item) {
				return item.bestStreak;
			}))) : 0;
			items.sort(function (a, b) {
				return a.position - b.position;
			});
			if (habitsIdToResetCurrentStreak.length > 0) {
				this.$store.state.healthyHabits.hideLoadingIcon = true;
				this.updateTableData({ habitsResetCurrentStreak: habitsIdToResetCurrentStreak }).then(function (data) {
					_this8.$store.state.healthyHabits.hideLoadingIcon = false;
				});
			}
			return { fields: fields, items: items };
		},
		processHealthyHabitsPartialData: function processHealthyHabitsPartialData(tableData) {
			var _this9 = this;

			var currentData = this.$store.state.healthyHabits.table.data.items;

			var _loop2 = function _loop2(index) {
				var item = tableData.data[index];
				var itemData = item.data;
				var currentItem = currentData.find(function (h) {
					return h.id === item.id;
				});
				var anyData = itemData && itemData.length > 0;
				var minDate = anyData ? new Date(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(itemData.map(function (h) {
					return new Date(h.date);
				})))) : null;
				for (var y in itemData) {
					var data = itemData[y];
					currentItem[_this9.getDateOnlyFormatted(data.date)] = currentItem[_this9.getDateOnlyFormatted(data.date)] !== undefined ? currentItem[_this9.getDateOnlyFormatted(data.date)] : item.measurable ? parseFloat(data.value) : data.value === 'true' ? true : data.value === 'false' || emptyData || data.value === 0 ? false : null;
				}
				if (!item.measurable && anyData) {
					_this9.fillPartialGoalCompleted(currentItem, minDate);
				}
				if (item.multiUserInfo.length > 0 && item.multiUserData.length > 0) {
					var _loop3 = function _loop3(_index) {
						var healthyHabitsUserId = item.multiUserInfo[_index].healthyHabitsUserId;
						var multiUserDataExits = false;
						var currentMultiUserData = [];
						if (currentItem.multiUserData.find(function (h) {
							return h.healthyHabitsUserId === healthyHabitsUserId;
						})) {
							currentMultiUserData = currentItem.multiUserData.find(function (h) {
								return h.healthyHabitsUserId === healthyHabitsUserId;
							});
							multiUserDataExits = true;
						}
						item.multiUserData.filter(function (x) {
							return x.healthyHabitsUserId === healthyHabitsUserId;
						}).map(function (itemData) {
							if (item.measurable) {
								currentMultiUserData[_this9.getDateOnlyFormatted(itemData.date)] = parseFloat(itemData.value);
							} else {
								currentMultiUserData[_this9.getDateOnlyFormatted(itemData.date)] = itemData.value === 'true' ? true : itemData.value === 'false' || itemData.value === 0 ? false : null;
							}
						});
						if (!item.measurable) {
							_this9.fillPartialGoalCompleted(currentMultiUserData);
						}
						if (!multiUserDataExits) {
							currentMultiUserData.healthyHabitsUserId = healthyHabitsUserId;
							currentMultiUserData.goal = currentItem.goal;
							currentMultiUserData.goalFrequencyId = currentItem.goalFrequencyId;
							currentItem.multiUserData = currentMultiUserData;
						}
					};

					for (var _index in item.multiUserInfo) {
						_loop3(_index);
					}
					_this9.$store.state.healthyHabits.table.key++;
				}
			};

			for (var index in tableData.data) {
				_loop2(index);
			}
		},
		computeNativeValue: function computeNativeValue(item) {
			if (!item) {
				return undefined;
			}
			return parseFloat(item.value) ? parseFloat(item.value) : item.value === 'true' ? true : item.value === 'false' || item.value === 0 ? false : null;
		},
		processHealthyHabitsDataMapped: function processHealthyHabitsDataMapped(data) {
			var result = {};
			result.measurable = data.measurable;
			result.measureUnit = data.measureUnit;
			result.goal = data.goal || 1;
			result.goalFrequencyId = data.goalFrequencyId;
			result.goalCompleted = data.goalCompleted;
			result.total = data.total;
			result.bestStreak = data.bestStreak;
			for (var _item in data.data) {
				var _currentItem = data.data[_item];
				if (result.measurable) {
					result[this.getDateOnlyFormatted(_currentItem.date)] = parseFloat(_currentItem.value);
				} else {
					result[this.getDateOnlyFormatted(_currentItem.date)] = _currentItem.value === 1 ? true : _currentItem.value === 0 ? false : null;
				}
			}
			result.currentStreak = data.data.length > 0 ? this.getCurrentStreakOnStart(result.measurable ? this.fillMeasurablePartialGoalCompleted(result) : result, data.currentStreak) : data.currentStreak;

			return result;
		},
		getMaxMinDate: function getMaxMinDate(reset) {
			this.$store.state.healthyHabits.table.minDate = this.$store.state.healthyHabits.table.minDate && !reset ? this.$store.state.healthyHabits.table.minDate : new Date(new Date(new Date().setDate(new Date().getDate() - (this.tableNumberDaysVisible() - 1))).setHours(0, 0, 0, 0));
			this.$store.state.healthyHabits.table.maxDate = this.$store.state.healthyHabits.table.maxDate && !reset ? this.$store.state.healthyHabits.table.maxDate : this.getCurrentDateUtc();
		},
		getSummaryOptions: function getSummaryOptions(percentage) {
			var _$store$state$healthy;

			this.$store.state.healthyHabits.chart.summary.options = (_$store$state$healthy = {
				title: { text: this.$t('summary'), style: { color: this.$store.state.healthyHabits.chart.color } },
				chart: { backgroundColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["a" /* BACKGROUND_COLOUR */], width: 200, height: 200 },
				tooltip: { enabled: false }
			}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_$store$state$healthy, 'title', {
				text: percentage + '%',
				verticalAlign: 'middle'
			}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_$store$state$healthy, 'plotOptions', {
				pie: {
					size: '45%'
				}
			}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_$store$state$healthy, 'credits', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_$store$state$healthy, 'series', [{
				type: 'pie',
				enableMouseTracking: false,
				innerSize: '65%',
				dataLabels: [{ enabled: false }],
				data: [{ y: percentage, color: this.$store.state.healthyHabits.chart.color }, percentage === 100 ? {} : { y: 100 - percentage, color: 'white' }]
			}]), _$store$state$healthy);
		},
		getHistoryOptions: function getHistoryOptions(refresh) {
			var _this = this;
			var isEmpty = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.state.healthyHabits.chart.history.options).length === 0;
			if (refresh && !isEmpty) {
				this.historyIntervalSelected(this.$store.state.healthyHabits.chart.history.interval);
			} else {
				this.$store.state.healthyHabits.chart.history.options = {
					id: 'history-chart',
					title: { text: this.$t('historyTitle'), style: { color: this.$store.state.healthyHabits.chart.color } },
					xAxis: { type: 'datetime', title: { text: this.$t('week') }, lineColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["e" /* GRAY_400_COLOUR */], labels: { formatter: function formatter(item) {
								var date = new Date(item.value);return date.getDate() + '-' + Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["n" /* getMonthShortName */])(date);
							}, style: { color: 'black' } } },
					yAxis: { title: { text: this.$t('total') + ' ' + this.$t('weeks') }, gridLineColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["e" /* GRAY_400_COLOUR */], labels: { style: { color: 'black' } }, min: 0 },
					credits: false,
					chart: { backgroundColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["a" /* BACKGROUND_COLOUR */] },
					series: [{
						type: 'column',
						color: this.$store.state.healthyHabits.chart.color,
						dataLabels: [{ color: 'white', enabled: true, inside: true }],
						data: this.getAccumulatedByWeeks(),
						name: this.$store.state.healthyHabits.chart.title,
						tooltip: { headerFormat: '', pointFormatter: function pointFormatter() {
								return '' + _this.getHistoryHeader(this);
							} }
					}]
				};
			}
		},
		getFrequencyOptions: function getFrequencyOptions(refresh) {
			var isEmpty = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.state.healthyHabits.chart.frequency.options).length === 0;
			if (refresh && !isEmpty) {
				this.$store.state.healthyHabits.chart.frequency.options.series[0].data = this.getFrequencyData();
			} else {
				this.$store.state.healthyHabits.chart.frequency.options = {
					title: { text: this.$t('frequency'), style: { color: this.$store.state.healthyHabits.chart.color } },
					xAxis: { categories: this.getLastYearMonthNamesShort(), lineColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["e" /* GRAY_400_COLOUR */] },
					yAxis: { categories: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["r" /* getWeekDaysShortNames */])().reverse(), gridLineColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["e" /* GRAY_400_COLOUR */], max: 6, min: 0, opposite: true, title: { text: null } },
					credits: false,
					plotOptions: { bubble: { displayNegative: false } },
					chart: { backgroundColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["a" /* BACKGROUND_COLOUR */] },
					series: [{
						type: 'bubble',
						color: this.$store.state.healthyHabits.chart.color,
						sizeByAbsoluteValue: true,
						dataLabels: [{ enabled: false }],
						data: this.getFrequencyData(),
						name: this.$store.state.healthyHabits.chart.title,
						maxSize: '9%',
						tooltip: { headerFormat: '', pointFormatter: function pointFormatter() {
								return this.dayAccumulated;
							} }
					}]
				};
			}
		},
		getScoreOptions: function getScoreOptions(refresh) {
			var scoreData = this.getScoreData();
			this.$store.state.healthyHabits.chart.score.dataCache = scoreData;
			var isEmpty = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.state.healthyHabits.chart.score.options).length === 0;
			if (refresh && !isEmpty) {
				this.scoreIntervalSelected(this.$store.state.healthyHabits.chart.score.interval);
			} else {
				this.$store.state.healthyHabits.chart.score.options = {
					id: 'score-chart',
					title: { text: this.$t('score'), style: { color: this.$store.state.healthyHabits.chart.color } },
					xAxis: { title: { text: this.$t('day') }, tickInterval: 24 * 3600 * 1000, tickPositions: scoreData.map(function (item) {
							return item.x;
						}), lineColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["e" /* GRAY_400_COLOUR */], labels: { formatter: function formatter(item) {
								return '' + Object(__WEBPACK_IMPORTED_MODULE_13__helpers_date_helpers__["g" /* formatDateForGraphAxis */])(new Date(item.value));
							}, style: { color: 'black' } } },
					yAxis: { title: { text: this.$t('percentage') }, gridLineColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["e" /* GRAY_400_COLOUR */], labels: { style: { color: 'black' }, format: '{value}%' }, max: 100, min: 0, tickInterval: 10 },
					credits: false,
					plotOptions: {
						scatter: {
							lineWidth: 2
						}
					},
					chart: { backgroundColor: __WEBPACK_IMPORTED_MODULE_10__constants_colours__["a" /* BACKGROUND_COLOUR */] },
					series: [{
						type: 'scatter',
						color: this.$store.state.healthyHabits.chart.color,
						data: scoreData,
						name: this.$store.state.healthyHabits.chart.title,
						tooltip: { headerFormat: '', pointFormatter: function pointFormatter() {
								return this.y + '%';
							} }
					}]
				};
			}
			this.$store.state.healthyHabits.chart.score.currentValue = scoreData[scoreData.length - 1].y;
		},
		historyIntervalSelected: function historyIntervalSelected(value) {
			switch (value) {
				case 1:
					this.$store.state.healthyHabits.chart.history.options.xAxis.title.text = this.$t('week');
					this.$store.state.healthyHabits.chart.history.options.xAxis.labels.formatter = function (item) {
						return Object(__WEBPACK_IMPORTED_MODULE_13__helpers_date_helpers__["g" /* formatDateForGraphAxis */])(new Date(item.value));
					};
					this.$store.state.healthyHabits.chart.history.options.yAxis.title.text = this.$t('total') + ' ' + this.$t('weeks');
					this.$store.state.healthyHabits.chart.history.options.series[0].data = this.getAccumulatedByWeeks();
					break;
				case 2:
					this.$store.state.healthyHabits.chart.history.options.xAxis.title.text = this.$t('month');
					this.$store.state.healthyHabits.chart.history.options.xAxis.labels.formatter = function (item) {
						return Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["m" /* getMonthName */])(new Date(item.value));
					};
					this.$store.state.healthyHabits.chart.history.options.yAxis.title.text = this.$t('total') + ' ' + this.$t('monthsTitle');
					this.$store.state.healthyHabits.chart.history.options.series[0].data = this.getAccumulatedByMonths();
					break;
				case 3:
					this.$store.state.healthyHabits.chart.history.options.xAxis.title.text = this.$t('year');
					this.$store.state.healthyHabits.chart.history.options.xAxis.labels.formatter = function (item) {
						var date = new Date(item.value);return date.getFullYear();
					};
					this.$store.state.healthyHabits.chart.history.options.yAxis.title.text = this.$t('total') + ' ' + this.$t('yearsTitle');
					this.$store.state.healthyHabits.chart.history.options.series[0].data = this.getAccumulatedByYears();
					break;
			}
			this.updateChartKey('history');
		},
		scoreIntervalSelected: function scoreIntervalSelected(value) {
			switch (value) {
				case 0:
					this.$store.state.healthyHabits.chart.score.options.xAxis.title.text = this.$t('day');
					this.$store.state.healthyHabits.chart.score.options.xAxis.labels.formatter = function (item) {
						return Object(__WEBPACK_IMPORTED_MODULE_13__helpers_date_helpers__["g" /* formatDateForGraphAxis */])(new Date(item.value));
					};
					this.$store.state.healthyHabits.chart.score.options.series[0].data = this.getScoreData();
					this.$store.state.healthyHabits.chart.score.options.xAxis.tickPositions = this.$store.state.healthyHabits.chart.score.options.series[0].data.map(function (item) {
						return item.x;
					});
					break;
				case 1:
					this.$store.state.healthyHabits.chart.score.options.xAxis.title.text = this.$t('week');
					this.$store.state.healthyHabits.chart.score.options.xAxis.labels.formatter = function (item) {
						return Object(__WEBPACK_IMPORTED_MODULE_13__helpers_date_helpers__["g" /* formatDateForGraphAxis */])(new Date(item.value));
					};
					this.$store.state.healthyHabits.chart.score.options.series[0].data = this.getScoreDataByWeeks();
					this.$store.state.healthyHabits.chart.score.options.xAxis.tickPositions = this.$store.state.healthyHabits.chart.score.options.series[0].data.map(function (item) {
						return item.x;
					});
					break;
				case 2:
					this.$store.state.healthyHabits.chart.score.options.xAxis.title.text = this.$t('month');
					this.$store.state.healthyHabits.chart.score.options.xAxis.labels.formatter = function (item) {
						return Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["m" /* getMonthName */])(new Date(item.value));
					};
					this.$store.state.healthyHabits.chart.score.options.series[0].data = this.getScoreDataByMonths();
					this.$store.state.healthyHabits.chart.score.options.xAxis.tickPositions = this.$store.state.healthyHabits.chart.score.options.series[0].data.map(function (item) {
						return item.x;
					});
					break;
				case 3:
					this.$store.state.healthyHabits.chart.score.options.xAxis.title.text = this.$t('year');
					this.$store.state.healthyHabits.chart.score.options.xAxis.labels.formatter = function (item) {
						var date = new Date(item.value);return date.getFullYear();
					};
					this.$store.state.healthyHabits.chart.score.options.series[0].data = this.getScoreDataByYears();
					this.$store.state.healthyHabits.chart.score.options.xAxis.tickPositions = this.$store.state.healthyHabits.chart.score.options.series[0].data.map(function (item) {
						return item.x;
					});
					break;
			}
			this.updateChartKey('score');
		},
		updateChartKey: function updateChartKey(id) {
			this.$store.state.healthyHabits.chart[id].key++;
		},
		getHistoryHeader: function getHistoryHeader(data) {
			var date = new Date(data.x);
			switch (this.$store.state.healthyHabits.chart.history.interval) {
				case 1:
					var startDate = this.getDateOnlySpanishFormat(date);
					date.setDate(date.getDate() + 6);
					var finishDate = this.getDateOnlySpanishFormat(date);
					return startDate + ' ' + this.$t('to') + ' ' + finishDate;
				case 2:
					return Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["m" /* getMonthName */])(date);
				case 3:
					return date.getFullYear();
			}
		},
		resetItemSelected: function resetItemSelected() {
			this.$store.state.healthyHabits.itemSelected.date = null;
			this.$store.state.healthyHabits.itemSelected.currentValue = null;
			this.$store.state.healthyHabits.itemSelected.newValue = null;
			this.$store.state.healthyHabits.itemSelected.measureUnit = null;
		},
		updateGoalStreak: function updateGoalStreak(fromCalendar, refreshData) {
			var _this10 = this;

			var itemModified = fromCalendar ? this.$store.state.healthyHabits.chart.dataMapped : this.$store.state.healthyHabits.table.data.items.find(function (item) {
				return item.id === _this10.$store.state.healthyHabits.table.itemSelectedId;
			});
			if (!refreshData) {
				itemModified.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(itemModified).filter(function (key) {
					return _this10.checkValidDate(key) && (!itemModified.measurable && itemModified[key] === true || itemModified.measurable && itemModified[key] > 0);
				}).length;
			}
			itemModified.currentStreak = this.getCurrentStreak(itemModified.measurable ? this.fillMeasurablePartialGoalCompleted(itemModified) : itemModified);
			itemModified.bestStreak = this.getBestStreak(itemModified.measurable ? this.fillMeasurablePartialGoalCompleted(itemModified) : itemModified, itemModified.currentStreak);
			var currentScore = 0;
			if (!fromCalendar) {
				this.$store.state.healthyHabits.bestStreak = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.healthyHabits.table.data.items.map(function (item) {
					return item.bestStreak;
				})));
				var scoreData = this.getScoreData(itemModified);
				currentScore = scoreData[scoreData.length - 1].y;
			} else {
				this.$store.state.healthyHabits.chart.total = itemModified.total;
				currentScore = this.$store.state.healthyHabits.chart.score.currentValue;
			}
			var goalCompleted = null;
			if (refreshData) {
				goalCompleted = currentScore === 100;
				this.$store.state.healthyHabits.showGoalCompletedModal = goalCompleted;
				itemModified.goalCompleted = goalCompleted;
			} else if (currentScore === 100 && !itemModified.goalCompleted) {
				this.$store.state.healthyHabits.showGoalCompletedModal = true;
				goalCompleted = true;
				itemModified.goalCompleted = true;
				if (!fromCalendar) {
					this.$store.state.healthyHabits.table.data.items = this.$store.state.healthyHabits.table.data.items.filter(function (h) {
						return h.id !== itemModified.id;
					});
				}
			}
			return this.updateTableData({ itemId: this.$store.state.healthyHabits.table.itemSelectedId, bestStreak: itemModified.bestStreak, currentStreak: itemModified.currentStreak, total: itemModified.total, goalCompleted: goalCompleted }).then(function (response) {
				_this10.$store.state.healthyHabits.hideLoadingIcon = false;
				_this10.resetItemSelected();
				if (refreshData) {
					_this10.getHealthyHabitsData();
				}
			});
		},
		fillMeasurablePartialGoalCompleted: function fillMeasurablePartialGoalCompleted(dataInput) {
			var _this11 = this;

			var data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, dataInput);
			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var dateNow = this.getCurrentDateUtc();
			var minDateInput = new Date(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(dataKeys.filter(function (key) {
				return _this11.checkValidDate(key);
			}).map(function (date) {
				return new Date(date);
			}))));
			var clearPartialValues = dataKeys.filter(function (key) {
				return _this11.checkValidDate(key) && (data[key] === -1 || new Date(key) > _this11.getCurrentDateUtc());
			});
			if (clearPartialValues.length > 0) {
				for (var index in clearPartialValues) {
					var key = clearPartialValues[index];
					delete data[key];
				}
			}
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["c" /* WEEKLY_GOAL */]) {
				(function () {
					var maxDate = dateNow;
					var minDate = minDateInput;
					var weekDateLimit = new Date(_this11.getFirstWeekDate(minDate));
					var lastDate = maxDate < _this11.getCurrentDateUtc() ? _this11.getLastDateInWeek(maxDate) : maxDate;
					var maxDateWeek = new Date(new Date(weekDateLimit).setDate(weekDateLimit.getDate() + 6));
					while (weekDateLimit <= lastDate) {
						var datesFilteredCurrentWeek = dataKeys.filter(function (key) {
							return _this11.checkValidDate(key) && maxDateWeek >= new Date(key) && new Date(key) >= weekDateLimit;
						}).sort(function (a, b) {
							return new Date(a) - new Date(b);
						});
						if (datesFilteredCurrentWeek.length > 0) {
							var datesFilteredCompleted = datesFilteredCurrentWeek.reduce(function (acc, date) {
								return acc + data[date];
							}, 0);
							var goalCompleted = datesFilteredCompleted >= data.goal;
							while (weekDateLimit <= maxDateWeek) {
								var currentDateFormatted = _this11.getDateOnlyFormatted(weekDateLimit);
								if ((data[currentDateFormatted] < data.goal || !data[currentDateFormatted]) && goalCompleted) {
									data[currentDateFormatted] = -1;
								}
								weekDateLimit.setDate(weekDateLimit.getDate() + 1);
							}
						} else {
							weekDateLimit.setDate(weekDateLimit.getDate() + 7);
						}
						maxDateWeek = new Date(new Date(maxDateWeek).setDate(maxDateWeek.getDate() + 7));
					}
				})();
			} else if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["b" /* MONTHLY_GOAL */]) {
				(function () {
					var maxDate = dateNow;
					maxDate = maxDate > dateNow ? dateNow : maxDate;
					var limitDate = new Date(new Date(minDateInput.getFullYear(), minDateInput.getMonth(), 1).setHours(0, 0, 0, 0));

					var _loop4 = function _loop4() {
						var lastMonth = _this11.getDateOnlyFormatted(limitDate).split('-')[1];
						var lastYear = _this11.getDateOnlyFormatted(limitDate).split('-')[0];
						var lastMonthDate = new Date(new Date(lastYear, lastMonth, 0).setHours(0, 0, 0, 0));
						var datesFiltered = dataKeys.filter(function (key) {
							return _this11.checkValidDate(key) && lastMonthDate >= new Date(key) && new Date(key) >= limitDate;
						}).sort(function (a, b) {
							return new Date(a) - new Date(b);
						});
						if (datesFiltered.length > 0) {
							var datesFilteredCompleted = datesFiltered.reduce(function (acc, date) {
								return acc + data[date];
							}, 0);
							var goalCompleted = datesFilteredCompleted >= data.goal;
							while (limitDate <= lastMonthDate) {
								var currentDateFormatted = _this11.getDateOnlyFormatted(limitDate);
								if ((data[currentDateFormatted] < data.goal || !data[currentDateFormatted]) && goalCompleted) {
									data[currentDateFormatted] = -1;
								}
								limitDate.setDate(limitDate.getDate() + 1);
							}
						} else {
							limitDate = new Date(new Date(limitDate.getFullYear(), limitDate.getMonth() + 1, 1).setHours(0, 0, 0, 0));
						}
					};

					while (limitDate <= maxDate) {
						_loop4();
					}
				})();
			}
			return data;
		},
		getCurrentStreak: function getCurrentStreak(data) {
			var _this12 = this;

			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var dates = dataKeys.filter(function (key) {
				return _this12.checkValidDate(key) && new Date(key) <= _this12.getCurrentDateUtc() && (data[key] === true || data[key] === null || data[key] === -1 || data.measurable && (data[key] > 0 || data[key] === -1));
			}).map(function (date) {
				return { 'date': new Date(date), value: data[date] || data[date] === -1 ? 1 : 0 };
			}).sort(function (a, b) {
				return b.date - a.date;
			});
			var currentDate = this.getCurrentDateUtc();
			var currentConsecutiveDays = 0;
			for (var index in dates) {
				var date = dates[index].date;
				var value = dates[index].value;
				if (this.getDateOnlyFormatted(date) === this.getDateOnlyFormatted(currentDate)) {
					currentConsecutiveDays = value ? ++currentConsecutiveDays : currentConsecutiveDays;
					currentDate.setDate(currentDate.getDate() - 1);
				} else if (index == 0) {
					currentDate.setDate(currentDate.getDate() - 1);
					if (this.getDateOnlyFormatted(currentDate) === this.getDateOnlyFormatted(date)) {
						currentConsecutiveDays = value ? ++currentConsecutiveDays : currentConsecutiveDays;
						currentDate.setDate(currentDate.getDate() - 1);
					}
				} else {
					if (index > 0) {
						return currentConsecutiveDays;
					}
					currentDate.setDate(currentDate.getDate() - 1);
				}
			}
			return currentConsecutiveDays;
		},
		getBestStreak: function getBestStreak(data, currentStreak) {
			var _this13 = this;

			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var dates = dataKeys.filter(function (key) {
				return _this13.checkValidDate(key) && (data[key] === true || data[key] === null || data[key] === -1 || data.measurable && (data[key] > 0 || data[key] === -1));
			}).map(function (date) {
				return { 'date': new Date(date), value: data[date] || data[date] === -1 ? 1 : 0 };
			}).sort(function (a, b) {
				return b.date - a.date;
			});
			var maxConsecutiveDays = 0;
			var currentConsecutiveDays = 0;
			for (var i = 1; i < dates.length; i++) {
				var prevDate = dates[i - 1].date;
				var prevDateValue = dates[i - 1].value;
				var date = dates[i].date;
				var dateValue = dates[i].value;
				var diffTime = Math.abs(date - prevDate);
				var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
				if (diffDays === 1) {
					currentConsecutiveDays += currentConsecutiveDays == 0 ? prevDateValue + dateValue : dateValue;
					maxConsecutiveDays = Math.max(maxConsecutiveDays, currentConsecutiveDays);
				} else {
					currentConsecutiveDays = 0;
				}
			}
			if (maxConsecutiveDays === 0 && dataKeys.some(function (key) {
				return _this13.checkValidDate(key) && (data[key] === true || data[key] > 0);
			})) {
				return 1;
			}
			return maxConsecutiveDays > currentStreak ? maxConsecutiveDays : currentStreak;
		},
		getCurrentStreakOnStart: function getCurrentStreakOnStart(data, savedStreak) {
			var _this14 = this;

			var now = this.getDateOnlyFormatted(new Date());
			var yesterday = this.getDateOnlyFormatted(new Date().setDate(new Date().getDate() - 1));
			var lastTwoDatesUnfilled = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).some(function (key) {
				return _this14.checkValidDate(key) && (data[now] == 0 || data[now] === undefined || data[now] === false) && (data[yesterday] == 0 || data[yesterday] === undefined || data[yesterday] === false);
			});
			if (lastTwoDatesUnfilled) {
				return 0;
			}
			return savedStreak;
		},
		getTotalCountWeek: function getTotalCountWeek(data, percentage) {
			var _this15 = this;

			data = data || this.$store.state.healthyHabits.chart.dataMapped;
			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var inputDate = this.getCurrentDateUtc();
			var inputDateDay = inputDate.getDay() == 0 ? 6 : inputDate.getDay() - 1;
			var endDate = new Date(inputDate).setDate(inputDate.getDate() + (6 - inputDateDay));
			if (endDate > inputDate) {
				endDate = new Date(inputDate);
			}
			var currentDate = new Date(inputDate.setDate(inputDate.getDate() - inputDateDay));
			var count = dataKeys.reduce(function (acc, date) {
				if (_this15.checkValidDate(date) && data[date] && currentDate <= new Date(date) && new Date(date) <= endDate) {
					return data.measurable && !percentage ? acc += data[date] : acc += 1;
				} else {
					return acc;
				}
			}, 0);
			if (percentage) {
				return Math.round(count / 7 * 100) > 100 ? 100 : Math.round(count / 7 * 100);
			} else {
				return count;
			}
		},
		getTotalCountMonth: function getTotalCountMonth(data, percentage) {
			var _this16 = this;

			data = data || this.$store.state.healthyHabits.chart.dataMapped;
			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var firstMonthDate = new Date(new Date().setDate(1)).setHours(0, 0, 0, 0);
			var currentMonth = this.getDateOnlyFormatted(firstMonthDate).split('-')[1];
			var currentYear = this.getDateOnlyFormatted(firstMonthDate).split('-')[0];
			var lastMonthDate = new Date(new Date(currentYear, currentMonth, 0).setHours(0, 0, 0, 0));
			var count = dataKeys.reduce(function (acc, date) {
				if (_this16.checkValidDate(date) && data[date] && firstMonthDate <= new Date(date) && new Date(date) <= lastMonthDate) {
					return data.measurable && !percentage ? acc += data[date] : acc += 1;
				} else {
					return acc;
				}
			}, 0);
			if (percentage) {
				return Math.round(count / lastMonthDate.getDate() * 100) > 100 ? 100 : Math.round(count / lastMonthDate.getDate() * 100);
			} else {
				return count;
			}
		},
		getTotalCountYear: function getTotalCountYear(data, percentage) {
			var _this17 = this;

			data = data || this.$store.state.healthyHabits.chart.dataMapped;
			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var firstYearDate = new Date(new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0));
			var lastYearDate = new Date(new Date(new Date().getFullYear(), 11, 31).setHours(0, 0, 0, 0));
			var count = dataKeys.reduce(function (acc, date) {
				if (_this17.checkValidDate(date) && data[date] && firstYearDate <= new Date(date) && new Date(date) <= lastYearDate) {
					return data.measurable && !percentage ? acc += data[date] : acc += 1;
				} else {
					return acc;
				}
			}, 0);
			if (percentage) {
				return Math.round(count / this.daysInYear(firstYearDate.getFullYear()) * 100) > 100 ? 100 : Math.round(count / this.daysInYear(firstYearDate.getFullYear()) * 100);
			} else {
				return count;
			}
		},
		sendModifiedData: function sendModifiedData() {
			var _this18 = this;

			this.$store.state.healthyHabits.table.updatingItem = true;
			this.$store.state.healthyHabits.hideLoadingIcon = true;
			var itemModified = !this.$store.state.healthyHabits.itemSelected.fromCalendar ? this.$store.state.healthyHabits.table.data.items.find(function (item) {
				return item.id === _this18.$store.state.healthyHabits.table.itemSelectedId;
			}) : null;
			this.updateTableData({ itemId: this.$store.state.healthyHabits.table.itemSelectedId, date: this.$store.state.healthyHabits.itemSelected.date, value: this.$store.state.healthyHabits.itemSelected.newValue, returnAllData: !this.$store.state.healthyHabits.itemSelected.fromCalendar }).then(function (response) {
				if (response.data) {
					if (_this18.$store.state.healthyHabits.itemSelected.fromCalendar) {
						_this18.processHealthyHabitsDataForStatistics();
					} else {
						itemModified[_this18.$store.state.healthyHabits.itemSelected.date] = itemModified.measurable ? parseFloat(_this18.$store.state.healthyHabits.itemSelected.newValue) : _this18.$store.state.healthyHabits.itemSelected.newValue;
						var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(itemModified);
						if (response.data.data) {
							var serverData = response.data.data.filter(function (item) {
								return !dataKeys.some(function (key) {
									return key === _this18.getDateOnlyFormatted(item.date);
								});
							});
							for (var index in serverData) {
								var _item2 = serverData[index];
								if (itemModified.measurable) {
									itemModified[_this18.getDateOnlyFormatted(_item2.date)] = parseFloat(_item2.value);
								} else {
									itemModified[_this18.getDateOnlyFormatted(_item2.date)] = _item2.value === 'true' ? true : _item2.value === 'false' || _item2.value === 0 ? false : null;
								}
							}
							dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(itemModified);
						}
						var dataMapped = dataKeys.filter(function (key) {
							return _this18.checkValidDate(key);
						}).map(function (date) {
							return new Date(date);
						});
						if (!itemModified.measurable) {
							_this18.fillPartialGoalCompleted(itemModified, new Date(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(dataMapped))));
						}
						itemModified.accumulatedGoal = _this18.lastGoalAccumulated(itemModified);
						_this18.updateGoalStreak().then(function () {
							_this18.$store.state.healthyHabits.table.key++;
							_this18.$store.state.healthyHabits.table.updatingItem = false;
						});
					}
				} else {
					_this18.$store.dispatch('showDangerAlert', _this18.$t('defaultErrorMessage'));
					_this18.$store.state.healthyHabits.table.updatingItem = false;
					_this18.$store.state.healthyHabits.hideLoadingIcon = false;
				}
			});
		},
		updateSetting: function updateSetting() {
			var _this19 = this;

			if (this.$validators.validate(this.$store.state.healthyHabits.setting.notifications.email, ['email'], true) === false) {
				this.$store.dispatch('showInfoAlert', this.$t('insertValidEmail'));
				return;
			} else if (this.$store.state.healthyHabits.setting.notifications.phone && this.$validators.validate(this.$store.state.healthyHabits.setting.notifications.phone, ['phone'], true) === false) {
				this.$store.dispatch('showInfoAlert', this.$t('insertValidPhone'));
				return;
			}
			var data = {
				nick: this.$store.state.healthyHabits.setting.nick,
				notificationsEmail: this.$store.state.healthyHabits.setting.notifications.email,
				notificationsPhone: this.$store.state.healthyHabits.setting.notifications.phone,
				showStoredHabits: this.$store.state.healthyHabits.setting.showStoredHabits,
				showGoalCompletedHabits: this.$store.state.healthyHabits.setting.showGoalCompletedHabits,
				allowFreeDays: this.$store.state.healthyHabits.setting.allowFreeDays,
				invertedCalendarDays: this.$store.state.healthyHabits.setting.invertedCalendarDays
			};
			this.processPromise(__WEBPACK_IMPORTED_MODULE_8__repositories_HealthyHabitsRepository__["a" /* default */].updateSetting(data.nick, data.notificationsEmail, data.notificationsPhone, data.showStoredHabits, data.showGoalCompletedHabits, data.allowFreeDays, data.invertedCalendarDays)).then(function (response) {
				if (response.data) {
					_this19.$store.state.healthyHabits.setting.showModal = false;
					if (_this19.$route.params.id && _this19.$store.state.healthyHabits.setting.originalAllowFreeDays !== _this19.$store.state.healthyHabits.setting.allowFreeDays) {
						_this19.$store.state.healthyHabits.itemSelected.fromCalendar = true;
						_this19.getHealthyHabitsStatistics(_this19.$route.params.id);
					} else if (!_this19.$route.params.id && (_this19.$store.state.healthyHabits.setting.originalAllowFreeDays !== _this19.$store.state.healthyHabits.setting.allowFreeDays || _this19.$store.state.healthyHabits.setting.originalShowStoredHabits !== _this19.$store.state.healthyHabits.setting.showStoredHabits || _this19.$store.state.healthyHabits.setting.originalShowGoalCompletedHabits !== _this19.$store.state.healthyHabits.setting.showGoalCompletedHabits)) {
						_this19.getHealthyHabitsData(_this19.$store.state.healthyHabits.setting.originalAllowFreeDays !== _this19.$store.state.healthyHabits.setting.allowFreeDays);
					}
					_this19.$store.state.healthyHabits.setting.originalAllowFreeDays = _this19.$store.state.healthyHabits.setting.allowFreeDays;
					_this19.$store.state.healthyHabits.setting.originalShowStoredHabits = _this19.$store.state.healthyHabits.setting.showStoredHabits;
					_this19.$store.state.healthyHabits.setting.originalShowGoalCompletedHabits = _this19.$store.state.healthyHabits.setting.showGoalCompletedHabits;
					_this19.updateHeaderFields();
					_this19.$store.dispatch('showSuccessAlert', _this19.$t('changesPerformedCorrectly'));
				} else {
					_this19.$store.dispatch('showDangerAlert', _this19.$t('defaultErrorMessage'));
				}
			});
		},
		updateHeaderFields: function updateHeaderFields() {
			var fields = this.$store.state.healthyHabits.table.data.fields = [{ key: 'description', label: '' }, { key: 'nextDates', label: '' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.getHeaderDatesInIntervalFormatted(this.$store.state.healthyHabits.table.minDate, this.$store.state.healthyHabits.table.maxDate)), [{ key: 'prevDates', label: '' }, { key: 'actions', label: '' }]);
			// if (!this.mobileVersion()) fields = [...fields, { key: 'sliderSection1', label: '' }, { key: 'sliderSection2', label: '' }, { key: 'sliderSection3', label: '' }]
			this.$store.state.healthyHabits.table.data.fields = fields;
		},
		mobileVersion: function mobileVersion() {
			return window.screen.width <= this.$store.state.healthyHabits.mobileSizeLimit;
		},
		getDateNameFieldFormatted: function getDateNameFieldFormatted(date) {
			return Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["o" /* getWeekDayShortName */])(new Date(date));
		},
		getDateFieldFormatted: function getDateFieldFormatted(date) {
			return new Date(date).getDate();
		},
		tableNumberDaysVisible: function tableNumberDaysVisible() {
			return this.mobileVersion() ? 2 : 5;
		},
		fillDatesDefaultValue: function fillDatesDefaultValue(data) {
			var _this20 = this;

			var currentDate = new Date(data[0].date);
			var result = [];
			while (currentDate <= this.getCurrentDateUtc()) {
				if (!data.some(function (item) {
					return _this20.getDateOnlyFormatted(item.date) === _this20.getDateOnlyFormatted(currentDate);
				})) {
					result.push({ date: new Date(currentDate), value: 0 });
				}
				currentDate.setDate(currentDate.getDate() + 1);
			}
			data = data.concat(result);
			data.sort(function (a, b) {
				return b.date - a.date;
			});
			return data;
		},
		lastGoalAccumulated: function lastGoalAccumulated(data) {
			var _this21 = this;

			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var dates = [];
			// measurable: daily, weekly and monthy; not measurable: each x days, x times at week or month
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["a" /* DAILY_GOAL */]) {
				var finishDate = this.getCurrentDateUtc();
				var startDate = this.getCurrentDateUtc().setDate(new Date().getDate() - data.goal);
				dates = dataKeys.filter(function (key) {
					return _this21.checkValidDate(key) && new Date(key) <= finishDate && (data.measurable ? new Date(key) >= _this21.getCurrentDateUtc() : new Date(key) > startDate);
				});
			}
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["c" /* WEEKLY_GOAL */]) {
				dates = dataKeys.filter(function (key) {
					return _this21.checkValidDate(key) && _this21.getActualWeekDatesFormatted().some(function (item) {
						return item === key;
					});
				});
			}
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["b" /* MONTHLY_GOAL */]) {
				var currentMonth = new Date().getMonth() + 1;
				dates = dataKeys.filter(function (key) {
					return _this21.checkValidDate(key) && currentMonth == parseFloat(key.split('-')[1]);
				});
			}
			var result = data.measurable ? dates.reduce(function (acc, date) {
				return acc + data[date];
			}, 0) : data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["a" /* DAILY_GOAL */] ? dates.some(function (date) {
				return data[date] === true;
			}) ? data.goal : 0 : dates.filter(function (date) {
				return data[date] === true;
			}).length;
			return result;
		},
		fillPartialGoalCompleted: function fillPartialGoalCompleted(data, minDateInput) {
			var _this22 = this;

			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var dateNow = this.getCurrentDateUtc();
			var clearPartialValues = dataKeys.filter(function (key) {
				return _this22.checkValidDate(key) && (data[key] === -1 || new Date(key) > _this22.getCurrentDateUtc());
			});
			if (clearPartialValues.length > 0) {
				for (var index in clearPartialValues) {
					var key = clearPartialValues[index];
					delete data[key];
				}
			}
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["a" /* DAILY_GOAL */]) {
				if (data.goal > 1) {
					var maxDate = dateNow;
					var _minDate = minDateInput ? new Date(minDateInput) : new Date(this.$store.state.healthyHabits.table.minDateServer);
					_minDate.setDate(_minDate.getDate() - data.goal);
					var _datesFiltered = dataKeys.filter(function (key) {
						return _this22.checkValidDate(key) && maxDate >= new Date(key) && new Date(key) >= _minDate && data[key] === true;
					}).sort(function (a, b) {
						return new Date(b) - new Date(a);
					});
					if (_datesFiltered.length > 0) {
						for (var _item3 in _datesFiltered) {
							var _currentItem2 = _datesFiltered[_item3];
							var currentDate = new Date(new Date(_currentItem2).setDate(new Date(_currentItem2).getDate() + 1));
							var finishDate = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + (data.goal - 2)));
							var goalCount = 0;
							var fillInverse = false;
							while (currentDate <= finishDate) {
								var _key = this.getDateOnlyFormatted(currentDate);
								if (data[_key] === true || data[_key] === -1) {
									fillInverse = true;
									break;
								}
								if (data[_key] !== null) {
									data[_key] = -1;
								}
								goalCount++;
								currentDate.setDate(currentDate.getDate() + 1);
							}
							if (fillInverse) {
								var prevDates = data.goal - goalCount - 1;
								currentDate = new Date(new Date(_currentItem2).setDate(new Date(_currentItem2).getDate() - 1));
								while (prevDates > 0) {
									var _key2 = this.getDateOnlyFormatted(currentDate);
									if (data[_key2] === true || data[_key2] === -1) {
										break;
									}
									data[_key2] = data[_key2] === false || data[_key2] === undefined ? -1 : data[_key2];
									prevDates--;
									currentDate.setDate(currentDate.getDate() - 1);
								}
							}
						}
					}
				}
			} else if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["c" /* WEEKLY_GOAL */]) {
				(function () {
					var maxDate = dateNow;
					var minDate = minDateInput ? new Date(minDateInput) : _this22.$store.state.healthyHabits.table.minDateServer;
					var weekDateLimit = new Date(_this22.getFirstWeekDate(minDate));
					var lastDate = maxDate < _this22.getCurrentDateUtc() ? _this22.getLastDateInWeek(maxDate) : maxDate;
					var maxDateWeek = new Date(new Date(weekDateLimit).setDate(weekDateLimit.getDate() + 6));
					while (weekDateLimit <= lastDate) {
						var datesFilteredCurrentWeek = dataKeys.filter(function (key) {
							return _this22.checkValidDate(key) && maxDateWeek >= new Date(key) && new Date(key) >= weekDateLimit;
						}).sort(function (a, b) {
							return new Date(a) - new Date(b);
						});
						if (datesFilteredCurrentWeek.length > 0) {
							var datesFilteredCompleted = datesFilteredCurrentWeek.filter(function (key) {
								return data[key] === true;
							});
							var goalCompleted = datesFilteredCompleted.length >= data.goal;

							var _loop5 = function _loop5() {
								var currentDateFormatted = _this22.getDateOnlyFormatted(weekDateLimit);
								data[currentDateFormatted] = datesFilteredCompleted.some(function (item) {
									return item === currentDateFormatted;
								}) ? true : data[currentDateFormatted] === null ? null : goalCompleted ? -1 : false;
								weekDateLimit.setDate(weekDateLimit.getDate() + 1);
							};

							while (weekDateLimit <= maxDateWeek) {
								_loop5();
							}
						} else {
							weekDateLimit.setDate(weekDateLimit.getDate() + 7);
						}
						maxDateWeek = new Date(new Date(maxDateWeek).setDate(maxDateWeek.getDate() + 7));
					}
				})();
			} else if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["b" /* MONTHLY_GOAL */]) {
				(function () {
					var maxDate = dateNow;
					maxDate = maxDate > dateNow ? dateNow : maxDate;
					var limitDate = minDateInput ? new Date(new Date(minDateInput.getFullYear(), minDateInput.getMonth(), 1).setHours(0, 0, 0, 0)) : new Date(new Date(_this22.$store.state.healthyHabits.table.minDateServer.getFullYear(), _this22.$store.state.healthyHabits.table.minDateServer.getMonth(), 1).setHours(0, 0, 0, 0));

					var _loop6 = function _loop6() {
						var lastMonth = _this22.getDateOnlyFormatted(limitDate).split('-')[1];
						var lastYear = _this22.getDateOnlyFormatted(limitDate).split('-')[0];
						var lastMonthDate = new Date(new Date(lastYear, lastMonth, 0).setHours(0, 0, 0, 0));
						var datesFiltered = dataKeys.filter(function (key) {
							return _this22.checkValidDate(key) && lastMonthDate >= new Date(key) && new Date(key) >= limitDate;
						}).sort(function (a, b) {
							return new Date(a) - new Date(b);
						});
						if (datesFiltered.length > 0) {
							var datesFilteredCompleted = datesFiltered.filter(function (key) {
								return data[key] === true;
							});
							var goalCompleted = datesFilteredCompleted.length >= data.goal;

							var _loop7 = function _loop7() {
								var currentDateFormatted = _this22.getDateOnlyFormatted(limitDate);
								data[currentDateFormatted] = datesFilteredCompleted.some(function (item) {
									return item === currentDateFormatted;
								}) ? true : data[currentDateFormatted] === null ? null : goalCompleted ? -1 : false;
								limitDate.setDate(limitDate.getDate() + 1);
							};

							while (limitDate <= lastMonthDate) {
								_loop7();
							}
						} else {
							limitDate = new Date(new Date(limitDate.getFullYear(), limitDate.getMonth() + 1, 1).setHours(0, 0, 0, 0));
						}
					};

					while (limitDate <= maxDate) {
						_loop6();
					}
				})();
			}
		},
		fillPartialGoalCompletedCalendar: function fillPartialGoalCompletedCalendar(data, minDateInput) {
			var _this23 = this;

			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["a" /* DAILY_GOAL */]) {
				var maxDate = this.getCurrentDateUtc();
				var _minDate2 = new Date(new Date(minDateInput).setHours(0, 0, 0, 0));
				var limitDate = new Date(_minDate2);
				_minDate2.setDate(minDateInput.getDate() - data.goal);
				var _datesFiltered2 = dataKeys.filter(function (key) {
					return _this23.checkValidDate(key) && maxDate >= new Date(key) && new Date(key) >= _minDate2 && data[key] === true;
				}).sort(function (a, b) {
					return new Date(b) - new Date(a);
				});
				if (_datesFiltered2.length > 0) {
					for (var _item4 in _datesFiltered2) {
						var _currentItem3 = _datesFiltered2[_item4];
						var currentDate = new Date(new Date(_currentItem3).setDate(new Date(_currentItem3).getDate() + 1));
						var finishDate = new Date(currentDate).setDate(new Date(currentDate).getDate() + (data.goal - 2));
						var goalCount = 0;
						var fillInverse = false;
						while (currentDate <= finishDate) {
							var key = this.getDateOnlyFormatted(currentDate);
							if (data[key] === true || data[key] === -1) {
								fillInverse = true;
								break;
							}
							data[key] = data[key] !== true && data[key] !== null ? -1 : data[key];
							goalCount++;
							currentDate.setDate(currentDate.getDate() + 1);
						}
						if (fillInverse) {
							var iterations = data.goal - goalCount - 1;
							currentDate = new Date(new Date(_currentItem3).setDate(new Date(_currentItem3).getDate() - 1));
							while (iterations > 0) {
								var _key3 = this.getDateOnlyFormatted(currentDate);
								data[_key3] = data[_key3] === false || data[_key3] === undefined ? -1 : data[_key3];
								iterations--;
								currentDate.setDate(currentDate.getDate() - 1);
							}
						}
					}
				} else {
					while (limitDate <= maxDate) {
						var _key4 = this.getDateOnlyFormatted(limitDate);
						data[_key4] = data[_key4] === -1 ? false : data[_key4];
						limitDate.setDate(limitDate.getDate() + 1);
					}
				}
			} else if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["c" /* WEEKLY_GOAL */]) {
				(function () {
					var maxDate = _this23.getCurrentDateUtc();
					var lastDayOfWeek = _this23.getLastDateInWeek(maxDate);
					maxDate = lastDayOfWeek;
					var minDate = new Date(minDateInput.setHours(0, 0, 0, 0));
					var limitDate = _this23.getFirstWeekDate(minDate);
					var weekDateLimit = new Date(limitDate);
					weekDateLimit = new Date(weekDateLimit.setDate(weekDateLimit.getDate() + 6));
					while (weekDateLimit <= maxDate) {
						var datesFilteredFirstWeek = dataKeys.filter(function (key) {
							return _this23.checkValidDate(key) && weekDateLimit >= new Date(key) && new Date(key) >= limitDate;
						}).sort(function (a, b) {
							return new Date(a) - new Date(b);
						});
						if (datesFilteredFirstWeek.length > 0) {
							var datesFilteredCompleted = datesFilteredFirstWeek.filter(function (key) {
								return data[key] === true;
							});
							var goalCompleted = datesFilteredCompleted.length >= data.goal;
							var _currentDate = new Date(limitDate);

							var _loop8 = function _loop8() {
								var currentDateFormatted = _this23.getDateOnlyFormatted(_currentDate);
								data[currentDateFormatted] = datesFilteredCompleted.some(function (item) {
									return item === currentDateFormatted;
								}) ? true : data[currentDateFormatted] === null ? null : goalCompleted ? -1 : false;
								_currentDate.setDate(_currentDate.getDate() + 1);
							};

							while (_currentDate <= weekDateLimit) {
								_loop8();
							}
						}
						limitDate = new Date(weekDateLimit);
						limitDate.setDate(limitDate.getDate() + 1);
						weekDateLimit.setDate(weekDateLimit.getDate() + 7);
					}
				})();
			} else if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["b" /* MONTHLY_GOAL */]) {
				var _maxDate = this.getCurrentDateUtc();
				var _limitDate = new Date(minDateInput.setHours(0, 0, 0, 0));

				var _loop9 = function _loop9() {
					var firstMonthDate = new Date(new Date(_limitDate).setDate(1)).setHours(0, 0, 0, 0);
					var lastMonth = _this23.getDateOnlyFormatted(_limitDate).split('-')[1];
					var lastYear = _this23.getDateOnlyFormatted(_limitDate).split('-')[0];
					var lastMonthDate = new Date(new Date(lastYear, lastMonth, 0).setHours(0, 0, 0, 0));
					var datesFilteredFirstMonth = dataKeys.filter(function (key) {
						return _this23.checkValidDate(key) && lastMonthDate >= new Date(key) && new Date(key) >= firstMonthDate;
					}).sort(function (a, b) {
						return new Date(a) - new Date(b);
					});
					if (datesFilteredFirstMonth.length > 0) {
						var datesFilteredCompleted = datesFilteredFirstMonth.filter(function (key) {
							return data[key] === true;
						});
						var goalCompleted = datesFilteredCompleted.length >= data.goal;

						var _loop10 = function _loop10() {
							var currentDateFormatted = _this23.getDateOnlyFormatted(_limitDate);
							data[currentDateFormatted] = datesFilteredCompleted.some(function (item) {
								return item === currentDateFormatted;
							}) ? true : data[currentDateFormatted] === null ? null : goalCompleted ? -1 : false;
							_limitDate.setDate(_limitDate.getDate() + 1);
						};

						while (_limitDate <= lastMonthDate) {
							_loop10();
						}
					} else {
						_limitDate = new Date(lastMonthDate.setDate(lastMonthDate.getDate() + 1));
					}
				};

				while (_limitDate <= _maxDate) {
					_loop9();
				}
			}
		},
		getAccumulatedByWeeks: function getAccumulatedByWeeks(data) {
			data = data || this.$store.state.healthyHabits.chart.data;
			var result = [];
			var firstDate = data[0].date;
			var lastDate = data[data.length - 1].date;
			var pivotDate = this.getFirstWeekDate(firstDate);
			var lastWeekDay = this.getFirstWeekDate(lastDate);

			var _loop11 = function _loop11() {
				var weekFirstDate = new Date(pivotDate);
				pivotDate.setDate(pivotDate.getDate() + 7);
				var partialAccumulated = data.reduce(function (acc, item) {
					if (item.date >= weekFirstDate && item.date < pivotDate) {
						return acc + item.value;
					} else {
						return acc;
					}
				}, 0);
				if (partialAccumulated > 0) {
					result.push({ x: weekFirstDate, y: partialAccumulated });
				}
			};

			while (pivotDate <= lastWeekDay) {
				_loop11();
			}
			return result;
		},
		getAccumulatedByMonths: function getAccumulatedByMonths(data) {
			data = data || this.$store.state.healthyHabits.chart.data;
			var result = [];
			var currentDate = data[0].date;
			var lastDate = data[data.length - 1].date;
			var currentMonthDate = currentDate.getMonth();
			var lastMonthDate = lastDate.getMonth();
			while (currentMonthDate <= lastMonthDate) {
				var _partialAccumulated = data.reduce(function (acc, item) {
					if (item.date.getMonth() === currentMonthDate) {
						return acc + item.value;
					} else {
						return acc;
					}
				}, 0);
				result.push({ x: new Date(currentDate.getFullYear(), currentMonthDate, 1), y: _partialAccumulated });
				currentMonthDate += 1;
			}
			return result;
		},
		getAccumulatedByYears: function getAccumulatedByYears(data) {
			data = data || this.$store.state.healthyHabits.chart.data;
			var result = [];
			var currentDate = data[0].date;
			var lastDate = data[data.length - 1].date;
			var currentYearDate = currentDate.getFullYear();
			var lastYearDate = lastDate.getFullYear();
			while (currentYearDate <= lastYearDate) {
				var _partialAccumulated2 = data.reduce(function (acc, item) {
					if (item.date.getFullYear() === currentYearDate) {
						return acc + item.value;
					} else {
						return acc;
					}
				}, 0);
				result.push({ x: new Date(currentDate.getFullYear(), 1, 1), y: _partialAccumulated2 });
				currentYearDate += 1;
			}
			return result;
		},
		getAccumulatedOfMonthByWeekDays: function getAccumulatedOfMonthByWeekDays(data, monthIndex) {
			var _this24 = this;

			var result = [];

			var _loop12 = function _loop12(day) {
				var dayAccumulated = '';
				var accumulatedValuesByDay = data.filter(function (item) {
					var daySpanishFormat = item.date.getDay() === 0 ? 6 : item.date.getDay() - 1;if (daySpanishFormat === day) {
						dayAccumulated += _this24.getDateOnlySpanishFormat(item.date) + ':<b>' + item.value + '</b><br>';return true;
					} else {
						return false;
					}
				}).map(function (item) {
					return item.value;
				}).reduce(function (acc, value) {
					return acc + value;
				}, 0);
				if (accumulatedValuesByDay > 0) {
					result.push({ x: monthIndex, y: 6 - day, z: accumulatedValuesByDay, dayAccumulated: dayAccumulated });
				}
			};

			for (var day = 6; day >= 0; day--) {
				_loop12(day);
			}
			return result;
		},
		getScoreData: function getScoreData(item) {
			var _this25 = this;

			var data = item ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item).filter(function (key) {
				return _this25.checkValidDate(key) && item[key] !== null;
			}).map(function (key) {
				return { date: new Date(key), value: !item.measurable ? item[key] === true ? 1 : 0 : item[key] };
			}) : this.$store.state.healthyHabits.chart.data.filter(function (key) {
				return key.value !== null;
			}).map(function (key) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, key);
			});
			if (data.length === 0) {
				return [{ y: 0 }];
			}
			data = this.fillDatesDefaultValue(data);
			data.sort(function (a, b) {
				return b.date - a.date;
			});
			var goalFrequencyId = item ? item.goalFrequencyId : this.$store.state.healthyHabits.chart.goalFrequencyId;
			var goal = item ? item.goal : this.$store.state.healthyHabits.chart.goal;
			var measurable = item ? item.measurable : this.$store.state.healthyHabits.chart.measurable;
			var result = [];
			var rollingSum = 0.0;
			var dailyGoal = goalFrequencyId === __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["a" /* DAILY_GOAL */];
			var frequencyInterval = dailyGoal ? 1 : goalFrequencyId === __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["c" /* WEEKLY_GOAL */] ? 7 : 30;
			var numerator = measurable ? 1 : dailyGoal ? frequencyInterval : goal;
			var denominator = dailyGoal && !measurable ? goal : frequencyInterval;
			var frequency = numerator / denominator;
			if (!measurable && frequency < 1.0) {
				numerator *= 2;
				denominator *= 2;
			}
			var previousValue = 0;
			for (var index in data) {
				var offset = data.length - index - 1;
				var _item5 = data[offset];
				if (measurable) {
					rollingSum += Math.max(0, _item5.value);
					if (offset + denominator < data.length) {
						rollingSum -= Math.max(0, data[offset + denominator].value);
					}
					if (_item5.value >= 0) {
						var percentageCompleted = goal > 0 ? Math.min(1.0, rollingSum / goal) : 1.0;
						previousValue = this.computeScore(frequency, previousValue, percentageCompleted);
						result.push({ x: _item5.date.getTime(), y: Math.round(previousValue * 100) });
					}
				} else {
					if (_item5.value === 1) {
						rollingSum += 1.0;
					}
					if (offset + denominator < data.length) {
						if (data[offset + denominator].value === 1) {
							rollingSum -= 1.0;
						}
					}
					if (_item5.value !== null) {
						var _percentageCompleted = Math.min(1.0, rollingSum / numerator);
						previousValue = this.computeScore(frequency, previousValue, _percentageCompleted);
					}
					result.push({ x: _item5.date.getTime(), y: Math.round(previousValue * 100) });
				}
			}
			return result;
		},
		computeScore: function computeScore(frequency, previousScore, checkmarkValue) {
			var multiplier = Math.pow(0.5, Math.sqrt(frequency) / 13.0);
			var score = previousScore * multiplier;
			score += checkmarkValue * (1 - multiplier);
			return score;
		},
		getScoreDataByWeeks: function getScoreDataByWeeks() {
			var result = [];
			var data = this.$store.state.healthyHabits.chart.score.dataCache;
			var limitDate = this.getFirstWeekDate(data[0].x);
			var currentDate = new Date(data[data.length - 1].x);

			var _loop13 = function _loop13() {
				var limitWeek = new Date(currentDate).setDate(currentDate.getDate() - 7);
				var newValue = data.filter(function (item) {
					return new Date(item.x) <= currentDate && new Date(item.x) > limitWeek;
				}).sort(function (a, b) {
					return new Date(b.x) - new Date(a.x);
				})[0];
				if (newValue) {
					result.unshift(newValue);
				}
				currentDate.setDate(currentDate.getDate() - 7);
			};

			while (limitDate <= currentDate) {
				_loop13();
			}
			return result;
		},
		getScoreDataByMonths: function getScoreDataByMonths() {
			var result = [];
			var data = this.$store.state.healthyHabits.chart.score.dataCache;
			var limitDate = new Date(new Date(new Date(data[0].x).getFullYear(), new Date(data[0].x).getMonth(), 1).setHours(0, 0, 0, 0));
			var currentDate = new Date(new Date(new Date(data[data.length - 1].x).getFullYear(), new Date(data[data.length - 1].x).getMonth() + 1, 0).setHours(0, 0, 0, 0));

			var _loop14 = function _loop14() {
				var limitWeek = new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).setHours(0, 0, 0, 0));
				var newValue = data.filter(function (item) {
					return new Date(item.x) <= currentDate && new Date(item.x) > limitWeek;
				}).sort(function (a, b) {
					return new Date(b.x) - new Date(a.x);
				})[0];
				if (newValue) {
					result.unshift(newValue);
				}
				currentDate = new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).setHours(0, 0, 0, 0));
			};

			while (limitDate <= currentDate) {
				_loop14();
			}
			return result;
		},
		getScoreDataByYears: function getScoreDataByYears() {
			var result = [];
			var data = this.$store.state.healthyHabits.chart.score.dataCache;
			var limitDate = new Date(new Date(new Date(data[0].x).getFullYear(), 0, 1).setHours(0, 0, 0, 0));
			var currentDate = new Date(new Date(new Date(data[data.length - 1].x).getFullYear(), 11, 31).setHours(0, 0, 0, 0));

			var _loop15 = function _loop15() {
				var limitWeek = new Date(new Date(currentDate.getFullYear(), 0, 1).setHours(0, 0, 0, 0));
				var newValue = data.filter(function (item) {
					return new Date(item.x) <= currentDate && new Date(item.x) > limitWeek;
				}).sort(function (a, b) {
					return new Date(b.x) - new Date(a.x);
				})[0];
				if (newValue) {
					result.unshift(newValue);
				}
				currentDate = new Date(new Date(currentDate.getFullYear() - 1, 11, 31).setHours(0, 0, 0, 0));
			};

			while (limitDate <= currentDate) {
				_loop15();
			}
			return result;
		},
		getFrequencyData: function getFrequencyData(data) {
			data = data || this.$store.state.healthyHabits.chart.data;
			var result = [];
			var currentDate = new Date();
			var months = 12;
			var currentMonthIndex = 11;
			while (months > 0) {
				var dataFiltered = data.filter(function (item) {
					return item.date.getMonth() === currentDate.getMonth() && item.date.getFullYear() === currentDate.getFullYear() && item.value > 0;
				});
				if (dataFiltered.length > 0) {
					var _result;

					var accumulated = this.getAccumulatedOfMonthByWeekDays(dataFiltered, currentMonthIndex);
					(_result = result).push.apply(_result, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(accumulated));
				} else {
					result.push({ x: currentMonthIndex });
				}
				months--;
				currentMonthIndex--;
				currentDate.setMonth(currentDate.getMonth() - 1);
			}
			var maxValue = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(result.filter(function (item) {
				return item.z;
			}).map(function (item) {
				return item.z;
			})));
			result = result.map(function (item) {
				return { x: item.x, y: item.y, z: Math.round(item.z * 10 / maxValue), originalValue: item.z, dayAccumulated: item.dayAccumulated };
			});
			return result;
		},
		getHeaderDatesInIntervalFormatted: function getHeaderDatesInIntervalFormatted(startDate, endDate) {
			var result = [];
			var currentDate = new Date(startDate);
			while (currentDate <= new Date(endDate)) {
				result.push({ key: this.getDateOnlyFormatted(currentDate) });
				currentDate.setDate(currentDate.getDate() + 1);
			}
			return this.$store.state.healthyHabits.setting.invertedCalendarDays ? result.reverse() : result;
		},
		getCurrentDateUtc: function getCurrentDateUtc() {
			return new Date(new Date().setHours(0, 0, 0, 0));
		},
		getDateOnlyFormatted: function getDateOnlyFormatted(date) {
			var currentDate = new Date(date);
			return currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-' + ('0' + currentDate.getDate()).slice(-2) + 'T00:00:00';
		},
		getDateOnlySpanishFormat: function getDateOnlySpanishFormat(date) {
			var currentDate = new Date(date);
			return ('0' + currentDate.getDate()).slice(-2) + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-' + currentDate.getFullYear();
		},
		getDatesOfWeekFromDate: function getDatesOfWeekFromDate(date) {
			var result = [];
			var inputDate = new Date(date);
			var inputDateDay = inputDate.getDay() == 0 ? 6 : inputDate.getDay() - 1;
			var endDate = new Date(inputDate).setDate(inputDate.getDate() + (6 - inputDateDay));
			var currentDate = new Date(inputDate.setDate(inputDate.getDate() - inputDateDay));
			while (currentDate <= endDate) {
				result.push(this.getDateOnlyFormatted(new Date(currentDate)));
				currentDate.setDate(currentDate.getDate() + 1);
			}
			return result;
		},
		getActualWeekDatesFormatted: function getActualWeekDatesFormatted() {
			var result = [];
			var endDate = new Date();
			var endDateDay = endDate.getDay() == 0 ? 6 : endDate.getDay() - 1;
			var currentDate = new Date(new Date().setDate(new Date().getDate() - endDateDay));
			while (currentDate <= endDate) {
				result.push(this.getDateOnlyFormatted(new Date(currentDate)));
				currentDate.setDate(currentDate.getDate() + 1);
			}
			return result;
		},
		getLastDateInWeek: function getLastDateInWeek(date) {
			var currentDate = new Date(date);
			var currentDateDay = currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1;
			currentDate.setDate(currentDate.getDate() + (6 - currentDateDay));
			return new Date(currentDate.setHours(0, 0, 0, 0));
		},
		getFirstWeekDate: function getFirstWeekDate(date) {
			var currentDate = new Date(date);
			var currentDateDay = currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1;
			currentDate.setDate(currentDate.getDate() - currentDateDay);
			return new Date(currentDate.setHours(0, 0, 0, 0));
		},
		checkValidDate: function checkValidDate(date) {
			var pattern = /^(?!0000)[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])T([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])Z?$/;
			return pattern.test(date);
		},
		logOff: function logOff() {
			window.$cookies.remove('api_token', null, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_global_helpers__["c" /* getBaseDomain */])());
			location.href = this.getHealthyHabitsPath();
		},
		logIn: function logIn() {
			var _this = this;
			this.$store.commit('session/setLoginCallback', function () {
				_this.$router.push(_this.getHealthyHabitsPath()).catch(function () {});
			});
			this.$router.push('/inicio-sesion');
		},
		getHealthyHabitsPath: function getHealthyHabitsPath(path) {
			path = path ? path : '';
			if (location.href.includes('localdesarrollo')) {
				return '/habitossaludables' + (path ? '/' + path : '');
			} else {
				return '/' + path;
			}
		},
		goHealthyHabitsPath: function goHealthyHabitsPath(path) {
			path = path ? path : '';
			if (location.href.includes('localdesarrollo')) {
				this.$router.push('/habitossaludables' + (path ? '/' + path : '')).catch(function () {});
			} else {
				this.$router.push('/' + path).catch(function () {});
			}
		},
		getLastYearMonthNamesShort: function getLastYearMonthNamesShort() {
			var result = [];
			var currentDate = new Date();
			var currentMonth = new Date().getMonth();
			result.push(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["n" /* getMonthShortName */])(currentDate));
			var currentIndex = currentMonth === 0 ? 11 : currentMonth - 1;
			while (currentIndex != currentMonth) {
				result.push(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["n" /* getMonthShortName */])(currentDate));
				currentIndex = currentIndex - 1 === -1 ? 11 : currentIndex - 1;
			}
			return result.reverse();
		},
		daysInYear: function daysInYear(year) {
			year = year || new Date().getFullYear();
			return year % 4 === 0 && year % 100 > 0 || year % 400 == 0 ? 366 : 365;
		},
		measurableDataIsPartialCompleted: function measurableDataIsPartialCompleted(data, keyInput) {
			var _this26 = this;

			var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
			var dates = [];
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["a" /* DAILY_GOAL */]) {
				return data.goal <= data[keyInput];
			}
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["c" /* WEEKLY_GOAL */]) {
				dates = dataKeys.filter(function (key) {
					return _this26.checkValidDate(key) && _this26.getDatesOfWeekFromDate(keyInput).some(function (item) {
						return item === key;
					});
				});
				return dates.reduce(function (acc, date) {
					return acc + data[date];
				}, 0) >= data.goal;
			}
			if (data.goalFrequencyId == __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["b" /* MONTHLY_GOAL */]) {
				var currentMonth = new Date(keyInput).getMonth() + 1;
				dates = dataKeys.filter(function (key) {
					return _this26.checkValidDate(key) && currentMonth == parseFloat(key.split('-')[1]);
				});
				return dates.reduce(function (acc, date) {
					return acc + data[date];
				}, 0) >= data.goal;
			}
		},
		getFrequencyName: function getFrequencyName(goalFrequency) {
			if (goalFrequency === __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["a" /* DAILY_GOAL */]) {
				return this.$t('dailyShort');
			} else if (goalFrequency === __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["c" /* WEEKLY_GOAL */]) {
				return this.$t('weeklyShort');
			} else if (goalFrequency === __WEBPACK_IMPORTED_MODULE_9__constants_healthyHabits__["b" /* MONTHLY_GOAL */]) {
				return this.$t('monthlyShort');
			}
		},
		generateCalendar: function generateCalendar(dateModified) {
			var _this27 = this;

			var _this = this;
			var result = '<table id="healthyHabitsCalendar">';
			var today = new Date();
			var rowColumns = 0;
			var rowColumnsMax = 0;
			var firstDate = new Date(new Date().setMonth(new Date().getMonth() - 4));
			var goalStreakUpdated = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function () {});
			if (firstDate.getDay() != 1) {
				var dayOfWeek = firstDate.getDay() == 0 ? 6 : firstDate.getDay() - 1;
				firstDate = new Date(firstDate.setDate(firstDate.getDate() - dayOfWeek));
			}
			var pivotDate = new Date(firstDate);
			var lastMonth = null;
			var item = this.$store.state.healthyHabits.chart.dataMapped;
			if (dateModified) {
				if (!item.measurable) {
					var dataMapped = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item).filter(function (key) {
						return _this27.checkValidDate(key);
					}).map(function (date) {
						return new Date(date);
					});
					this.fillPartialGoalCompleted(item, new Date(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(dataMapped))));
				}
				goalStreakUpdated = this.updateGoalStreak(true);
			} else if (!item.measurable) {
				this.fillPartialGoalCompletedCalendar(item, firstDate);
			}
			for (var i = 0; i <= 7; i++) {
				result += '<tr>';
				rowColumns = 0;
				while (pivotDate <= today) {
					if (i === 0) {
						result += '<th class="cell-header">' + (pivotDate.getMonth() !== lastMonth ? Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["n" /* getMonthShortName */])(pivotDate) : '') + '</th>';
						lastMonth = pivotDate.getMonth();
						pivotDate.setDate(pivotDate.getDate() + 7);
					} else {
						result += '<td style="background-color: ' + this.getCellBackgroundColor(item, pivotDate) + '" id="calendar;' + this.getDateOnlyFormatted(pivotDate) + '" title="' + this.getCellTitle(item, pivotDate) + '" class="cell-style ' + this.getCellOpacityClass(item, pivotDate) + '">' + pivotDate.getDate() + '</td>';
						pivotDate.setDate(pivotDate.getDate() + 7);
						++rowColumns;
					}
				}
				if (i > 0) {
					if (rowColumns > rowColumnsMax) {
						rowColumnsMax = rowColumns;
					}
					result += (rowColumnsMax > rowColumns ? '<td></td>' : '') + '<td class="cell-week-day">' + Object(__WEBPACK_IMPORTED_MODULE_12__helpers_date_helpers__["o" /* getWeekDayShortName */])(pivotDate) + '</td></tr>';
					pivotDate = new Date(firstDate.setDate(firstDate.getDate() + 1));
				} else {
					result += '</tr>';
					pivotDate = new Date(firstDate);
				}
			}
			result += '</table>';
			document.getElementById('healthyHabitsCalendarContainer').innerHTML = result;
			document.getElementById('healthyHabitsCalendar').removeEventListener('click');
			document.getElementById('healthyHabitsCalendar').addEventListener('click', function (event) {
				if (_this.$store.state.healthyHabits.table.updatingItem) {
					return;
				}
				var targetId = event.target.id;
				if (targetId) {
					targetId = targetId.split(';')[1];
					var _item6 = _this.$store.state.healthyHabits.chart.dataMapped;
					_this.$store.state.healthyHabits.itemSelected.date = targetId;
					_this.$store.state.healthyHabits.itemSelected.fromCalendar = true;
					var itemValue = _item6[targetId];
					if (_item6.measurable) {
						_this.$store.state.healthyHabits.itemSelected.measureUnit = _item6.measureUnit;
						_this.$store.state.healthyHabits.itemSelected.currentValue = itemValue;
						_this.$store.state.healthyHabits.itemSelected.newValue = itemValue;
						_this.$store.state.healthyHabits.showMeasurableInputModal = true;
					} else {
						var _itemValue = _item6[targetId];
						if (_this.$store.state.healthyHabits.setting.allowFreeDays) {
							_this.$store.state.healthyHabits.itemSelected.newValue = _itemValue === true ? null : _itemValue === null ? false : true;
						} else {
							_this.$store.state.healthyHabits.itemSelected.newValue = !_itemValue || _itemValue === -1 ? true : false;
						}
						_this.sendModifiedData();
					}
				}
			});
			if (dateModified) {
				goalStreakUpdated.then(function () {
					_this27.$store.state.healthyHabits.itemSelected.fromCalendar = false;
					_this27.$store.state.healthyHabits.table.updatingItem = false;
				});
			}
		},
		getCellBackgroundColor: function getCellBackgroundColor(item, date) {
			var itemValue = item[this.getDateOnlyFormatted(date)];
			return !item.measurable && (itemValue === true || itemValue === null || itemValue === -1) || item.measurable && this.measurableDataIsPartialCompleted(item, this.getDateOnlyFormatted(date)) ? this.$store.state.healthyHabits.chart.color : __WEBPACK_IMPORTED_MODULE_10__constants_colours__["e" /* GRAY_400_COLOUR */];
		},
		getCellOpacityClass: function getCellOpacityClass(item, date) {
			var itemValue = item[this.getDateOnlyFormatted(date)];
			return item.measurable && itemValue >= item.goal ? '' : !item.measurable && itemValue === null || item.measurable && itemValue > 0 && itemValue < item.goal ? 'linear-gradient' : !item.measurable && itemValue === -1 || item.measurable && this.measurableDataIsPartialCompleted(item, this.getDateOnlyFormatted(date)) ? 'partial-fill-opacity' : '';
		},
		getCellTitle: function getCellTitle(item, date) {
			var itemValue = item[this.getDateOnlyFormatted(date)];
			return item.measurable && itemValue > 0 ? itemValue : '';
		},
		isRouteFromClinicHistory: function isRouteFromClinicHistory() {
			return this.$route.params.historyVarName || this.$route.params.historyGroupId;
		}
	}
});

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más información","learn-more-btn":"Saber más","upper-header-subtitle":"Fomenta la capacidad de concentración, combate el estrés, la ansiedad, incrementa la autoestima, mejora la calidad del sueño y mucho más.","header-title":"Clases y sesiones de meditación, yoga mindfulness, pilates y sueño","subtitle-list-1":"Acceso ilimitado a consulta médica y pediátrica online.","subtitle-list-2":"Plataforma integral de salud y bienestar incluida.","subtitle-list-3":"Acceso premium a servicios de salud privados.","hire-now":"Contratar ahora","hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños","price-cards":{"title":"Consultas online incluidas","subtitle":"Sin coste adicional los mejores especialistas los 7 días de la semana.","content":"Los mejores servicios clínicos de más de 25.000 profesionales y centros, con un precio muy reducido.","subcontent":"Gimnasio online, meditación, programas de salud y mucho más.","monthly":"Mensual**","per-family":"por familia*","hire":"Contratar","family-label":"*Familia: Cónyuge/pareja e hijos menores de edad.","monthly-label":"**Compromiso de permanencia  mínimo de 3 meses.","medic-services-discount":"Descuento en servicios médicos","wellness-services":"Servicios de bienestar","medic-services":"Servicios médicos","tooth-services":"Servicios dentales","pediatry-services":"Servicios de pediatría","dermatology-services":"Servicios de dermatología","traumatology-services":"Servicios de traumatología","endocrinology-services":"Servicios de endocrinología","permanency":"Compromiso de permanencia de 3 meses","family":"Familia: Cónyuge/pareja e hijos menores de edad","soon":"Próximamente","table":{"title":"Nuestros planes","subtitle":"Tenemos planes ajustados a todas las necesidades familiares","wellness":"Plataforma de bienestar y salud","service-discounts":"Descuentos en servicios médicos privados","online-family-medic":"Médico de familia online","online-pediatrics":"Pediatría online","online-dermatology":"Dermatología online","online-traumatology":"Traumatología online","online-endocrinology":"Endocrinología online","title1":"El plan mas completo con todas nuestras especialidades","per-month":"por mes*","header":"Opción más popular","title2":"La tranquilidad de tener a un médico general y un pediatra disponible los 7 días de la semana","title3":"Disfruta de servicios clínicos privados con descuentos y accede a nuestra plataforma de salud y bienestar"}},"cards":{"1":{"title":"Los mejores","subtitle":"Cuida tu salud y la de los tuyos con los mejores médicos y la mejor tecnología disponible"},"2":{"title":"Precio a tu medida","subtitle":"Planes accesibles con la mayor calidad y tranquilidad en nuestros servicios de telemedicina"},"3":{"title":"Cuadro médico","subtitle":"Tendrás un extenso cuadro de especialistas, clínicas y centros médicos para asegurarte la mejor atención médica"},"title":"Consulta online a los mejores profesionales de medicina general y pediatría"},"medical-assistance":{"title":"Asistencia médica online","subtitle":"Disponible los 365 días del año con libre elección de médico de familia y pediatra por video, teléfono o chat con receta electrónica, agenda de salud, historia clínica, recordatorios…","content":"Incluye dos adultos y dos niños con consultas ilimitadas todos los días del año.","available-consultations":"Tipos de consulta disponibles:","video":"Videoconsulta","phone-attention":"Atención telefónica","written-consultation":"Consulta escrita","chat":"Chat","electronic-prescription":"Receta electrónica","safe-coms":"La seguridad de las comunicaciones y la privacidad de los datos son nuestra prioridad."},"discounts":{"title":"Descuentos en servicios clínicos privados","subtitle":"Si necesitas una prueba y no quieres esperar<br /><br />Acceso al mayor cuadro de servicios de salud de España con más de 25.000 profesionales y centros con descuentos de hasta el 60% en consultas, intervenciones, pruebas, tratamientos, productos y servicios de salud:","clinic-services":"Servicios clínicos","clinic-services-description":"Permite el acceso a facultativos y centros médicos que conforman el Cuadro Médico del Servicio 'AVANTSALUD':","close":"Cerrar","teeth-services-description":"Este servicio comprende determinados servicios dentales gratuitos y el acceso a un Cuadro de Facultativos a precio baremado. Los servicios dentales gratuitos son:","health-services-description":"Comprende determinados servicios relacionados con el bienestar y la salud en especialidades no incluidas habitualmente en seguros de salud tales como:","medical-services-list":"Consultas de medicina primaria (medicina general y pediatría)<br> Consulta de especialistas<br> Médicos de diagnóstico<br> Tratamientos médicos<br> Hospitalización e intervenciones quirúrgicas<br> Servicios médicos<br> Alergología<br> Anatomía patológica<br> Angiología y cirugía vascular<br> Aparato digestivo<br> Cardiología<br> Cirugía cardiovascular<br> Cirugía general y Aparato digestivo<br> Cirugía mamaria<br> Cirugía maxilofacial<br> Cirugía oncológica<br> Cirugía pedríatica<br> Cirugía plástica y reparadora<br> Cirugía torácica<br> Cirugía vascular<br> Dermatología y venereología<br> Endocrinología y nutrición<br> Enfermería<br> Hematología y hemoterapia<br> Nefrología<br> Neumología<br> Neurocirugía<br> Neurofisiología clínica<br> Neurología<br> Obstetricia y ginecología<br> Oftalmología<br> Oncología médica<br> Oncología radioterápica<br> Otorrinolaringología<br> Rehabilitación<br> Reumatología<br> Traumatología y Ortopedia<br> Urología<br> Medicina general<br> Pediatría<br> Pediatría-Puericultura<br> Clínicas y Hospitales<br> Policlínicas<br> Campimetrías<br> Panorámica/Ortopantomografía<br> Ecografías<br> Mamografías<br> T.A.C.<br> Analísis clínicos<br> Diagnóstico por la imagen<br> Medicina nuclear","teeth-services-list":"Primera vista y entrega de presupuesto<br> Visita de revisón<br> Educación bucodental<br> Enseñanza de técnicas de cepillado<br> Fluorizaciones<br> Limpieza de boca anual. Tartrectomía<br> Radiografías odontológicas (periapical, aleta, oclusal)<br> Diagnóstico y sondaje<br> Ajustes oclusales<br> Retirar puntos<br> Estudio implantológico<br> Falso muñón de titanio<br> Tornillo de cicatrización y de cementación<br>","health-services-list":"Acupuntura/Homeopatía/Naturopatía<br> Avantsalud en forma<br> Balnearios<br> Centros de reconocimiento<br> Cirugía refractiva oftalmológica láser<br> Concepto Bobath<br> Conservación de Células Madre-Cordón<br> Dermatoscopia Digital<br> Dietética<br> Ecografías 3D y 4D<br> Estética<br> Fisioterapia y fisioterapia infantil<br> Hidroterapia de colon<br> Medicina Preventiva y Test Genéticos<br> Ópticas y Audífonos<br> Ortopedia<br> Osteopatía<br> Planes con niños<br> Podología y Estudio de la pisada<br> Prestaciones asistenciales a domicilio (atención postparto)<br> Procedimientos mínimamente invasivos<br> Psicología, pedagogía y logofoniatría<br> Quiropráctica<br> Rehabilitación cardiaca<br> Terapia asistida con animales<br> Tratamientos de deshabituación tabáquica<br> Tratamientos de infertilidad<br> Tratamiento ondas de choque (disfunción eréctil)<br> Veterinarios<br> Láser miopía, astigmatismo, hipermetropía<br> Podología a domicilio<br> Analítica a domicilio<br> Fisioterapia a domicilio<br> Prevención Cáncer cuello de útero/HPV<br> Test genético cardiológico<br> Cribado Cáncer de colon en sangre<br> Test genético de la obesidad<br> Test genético Cáncer pulmonar<br> Chequeo oncológico<br> Test genético Alzhéimer<br> Test genético tromboembolismo<br> Test genético Diabetes Tipo II<br> Test genético Cáncer de mama<br> Test prenatal no invasivo<br> Preeclampsia<br> Test de paternidad<br> Huella genética<br> Test de intolerancia alimentaria<br> Test degeneración macular<br> Sexo fetal en sangre materna<br> Test melisa<br> Test migraña<br> Test intolerancia a la lactosa - fructosa<br> Balón gástrico<br> Cápsula endoscópica<br> Láser verde próstata<br> Láser en dermatología<br> Láser en vascular/endoláser<br> Cirugía percutánea del pie<br> Vasectomía sin bisturí<br> Blefaroplastia<br> Abdominoplastia<br> Rinoplastia<br> Lifting<br> Microinjertos capilares<br> Mamoplastia de aumento<br> Mamoplastia de reducción<br> Cirugía íntima<br> Liposucción<br>"},"wellness":{"title":"Plataforma de Salud y Bienestar","subtitle":"Con clases diarias en directo y en diferido de mindfulness, pilates, yoga, programas de salud, talleres, nutrición y mucho más.","mindfulness":"Mindfulness","pilates":"Pilates","healthy-back":"Espalda Sana","cardio":"Gimnasio Online","nutrition":"Nutrición","vitality":"Dosis de Vitalidad"},"unipromel":{"become-partner":"¡Hazte socio ya!"},"hire-now-with-price-2":"Contratar por 2,95 euros/mes\n\nSin permanencia","healthappyrest":{"title":"Suma salud mental, felicidad y descanso a tu vida","psico":"Masterclass de psicología, programas mindfulness y sueño","yoga":"Clases de yoga y pilates","relax":"Audios relajantes, consejos y curiosidades","premium":"Acceso premium a servicio de salud privados"},"buy-btn":"MÁS INFORMACIÓN","familiar":{"title":"FAMILIAR","text":"3 meses de permanencia","subtitle":"Consultas médicas y pediátricas online para dos adultos y dos niños","subtitle1":"Plataforma integral de salud y bienestar","subtitle2":"Acceso premium a servicios de salud privados"},"healthmind":{"title":"SALUD Y BIENESTAR","pricing":"2,95€","text":"Sin permanencia","subtitle":"Plataforma integral de salud y bienestar","subtitle1":"Acceso premium a servicios de salud privados"},"pricing":{"title":"Nuestros planes"},"video-corporative":"Vídeo que hacemos","hire-now-with-price-2-2":"Contratar por 2,95 euros/mes\n\nSin permanencia","upper-header-thirdtitle":"Además podrás acceder con importantes descuentos, al mayor cuadro de servicios de salud y bienestar privados, includos terapias presenciales, psicólogos...","carementalhealth":{"title":"Comienza a cuidar tu salud mental","yoga":"Yoga y meditación","mindfulness":"Programa de Mindfulness","dream":"Sueño y audios de relajación","pilates":"Pilates","yogatext":"Sentirse bien empieza por conocerse uno mismo.","mindfulnesstext":"Aprende a estar presente en el <<aquí y ahora>>.","dreamtext":"Reduce el estrés y la ansiedad para encontrar la calma.","pilatestext":"Disfruta del acceso ilimitado de la práctica y los beneficios de Pilates..."},"menttum":{"title":"Conoce a nuestros psicólogos","subtitle":"El bienestar mental y emocional que mereces en manos de expertos.","subtitle2":"Si necesitas terapia online accede a nuestros psicólogos en Menttum. Tus sesiones online en cualquier momento y desde cualquier lugar."},"discounts-mindfulness":{"title":"Acceso premium a servicios de salud y bienestar privados","subtitle":"Sin listas de esperas. Reserva una prueba y no esperes.","subtitle2":"<b>Descuentos</b> de hasta el 60% en más de 25.000 profesionales y centros de reconocido prestigio en intervenciones, pruebas, trataminetos, productos y servicios de salud.","subtitle3":"Accederás a <b>precios especiales</b> en tratamientos de bienestar, balnearios, centross estéticos, fisioterapeutas, ópticas..."}}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más info","learn-more-btn":"Saber más","upper-header-subtitle":"TELEMEDICINA","header-title":"Cuida de ti. Siempre","subtitle-list-1":"Acceso ilimitado a consulta médica y pediátrica online.","subtitle-list-2":"Plataforma integral de salud y bienestar incluida.","subtitle-list-3":"Acceso premium a servicios de salud privados.","hire-now":"Contratar ahora","hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños","price-cards":{"title":"Consultas online incluidas","subtitle":"Sin coste adicional los mejores especialistas los 7 días de la semana.","content":"Los mejores servicios clínicos de más de 25.000 profesionales y centros, con un precio muy reducido.","subcontent":"Gimnasio online, meditación, programas de salud y mucho más.","monthly":"Mensual**","per-family":"por familia*","hire":"Contratar","family-label":"*Familia: Cónyuge/pareja e hijos menores de edad.","monthly-label":"**Compromiso de permanencia  mínimo de 3 meses.","medic-services-discount":"Descuento en servicios médicos","wellness-services":"Servicios de bienestar","medic-services":"Servicios médicos","tooth-services":"Servicios dentales","pediatry-services":"Servicios de pediatría","dermatology-services":"Servicios de dermatología","traumatology-services":"Servicios de traumatología","endocrinology-services":"Servicios de endocrinología","permanency":"Compromiso de permanencia de 3 meses","family":"Familia: Cónyuge/pareja e hijos menores de edad","soon":"Próximamente","table":{"title":"Nuestros planes","subtitle":"Tenemos planes ajustados a todas las necesidades familiares","wellness":"Plataforma de bienestar y salud","service-discounts":"Descuentos en servicios médicos privados","online-family-medic":"Médico de familia online","online-pediatrics":"Pediatría online","online-dermatology":"Dermatología online","online-traumatology":"Traumatología online","online-endocrinology":"Endocrinología online","title1":"El plan mas completo con todas nuestras especialidades","per-month":"por mes*","header":"Opción más popular","title2":"La tranquilidad de tener a un médico general y un pediatra disponible los 7 días de la semana","title3":"Disfruta de servicios clínicos privados con descuentos y accede a nuestra plataforma de salud y bienestar"}},"cards":{"1":{"title":"Los mejores","subtitle":"Cuida tu salud y la de los tuyos con los mejores médicos y la mejor tecnología disponible"},"2":{"title":"Precio a tu medida","subtitle":"Planes accesibles con la mayor calidad y tranquilidad en nuestros servicios de telemedicina"},"3":{"title":"Cuadro médico","subtitle":"Tendrás un extenso cuadro de especialistas, clínicas y centros médicos para asegurarte la mejor atención médica"},"title":"Consulta online a los mejores profesionales de medicina general y pediatría"},"medical-assistance":{"title":"Asistencia médica online","subtitle":"Disponible los 365 días del año con libre elección de médico de familia y pediatra por video, teléfono o chat con receta electrónica, agenda de salud, historia clínica, recordatorios…","content":"Incluye dos adultos y dos niños con consultas ilimitadas todos los días del año.","available-consultations":"Tipos de consulta disponibles:","video":"Videoconsulta","phone-attention":"Atención telefónica","written-consultation":"Consulta escrita","chat":"Chat","electronic-prescription":"Receta electrónica","safe-coms":"La seguridad de las comunicaciones y la privacidad de los datos son nuestra prioridad."},"discounts":{"title":"Descuentos en servicios clínicos privados","subtitle":"Si necesitas una prueba y no quieres esperar<br /><br />Acceso al mayor cuadro de servicios de salud de España con más de 25.000 profesionales y centros con descuentos de hasta el 60% en consultas, intervenciones, pruebas, tratamientos, productos y servicios de salud:","clinic-services":"Servicios clínicos","clinic-services-description":"Permite el acceso a facultativos y centros médicos que conforman el Cuadro Médico del Servicio 'AVANTSALUD':","close":"Cerrar","teeth-services-description":"Este servicio comprende determinados servicios dentales gratuitos y el acceso a un Cuadro de Facultativos a precio baremado. Los servicios dentales gratuitos son:","health-services-description":"Comprende determinados servicios relacionados con el bienestar y la salud en especialidades no incluidas habitualmente en seguros de salud tales como:","medical-services-list":"Consultas de medicina primaria (medicina general y pediatría)<br> Consulta de especialistas<br> Médicos de diagnóstico<br> Tratamientos médicos<br> Hospitalización e intervenciones quirúrgicas<br> Servicios médicos<br> Alergología<br> Anatomía patológica<br> Angiología y cirugía vascular<br> Aparato digestivo<br> Cardiología<br> Cirugía cardiovascular<br> Cirugía general y Aparato digestivo<br> Cirugía mamaria<br> Cirugía maxilofacial<br> Cirugía oncológica<br> Cirugía pedríatica<br> Cirugía plástica y reparadora<br> Cirugía torácica<br> Cirugía vascular<br> Dermatología y venereología<br> Endocrinología y nutrición<br> Enfermería<br> Hematología y hemoterapia<br> Nefrología<br> Neumología<br> Neurocirugía<br> Neurofisiología clínica<br> Neurología<br> Obstetricia y ginecología<br> Oftalmología<br> Oncología médica<br> Oncología radioterápica<br> Otorrinolaringología<br> Rehabilitación<br> Reumatología<br> Traumatología y Ortopedia<br> Urología<br> Medicina general<br> Pediatría<br> Pediatría-Puericultura<br> Clínicas y Hospitales<br> Policlínicas<br> Campimetrías<br> Panorámica/Ortopantomografía<br> Ecografías<br> Mamografías<br> T.A.C.<br> Analísis clínicos<br> Diagnóstico por la imagen<br> Medicina nuclear","teeth-services-list":"Primera vista y entrega de presupuesto<br> Visita de revisón<br> Educación bucodental<br> Enseñanza de técnicas de cepillado<br> Fluorizaciones<br> Limpieza de boca anual. Tartrectomía<br> Radiografías odontológicas (periapical, aleta, oclusal)<br> Diagnóstico y sondaje<br> Ajustes oclusales<br> Retirar puntos<br> Estudio implantológico<br> Falso muñón de titanio<br> Tornillo de cicatrización y de cementación<br>","health-services-list":"Acupuntura/Homeopatía/Naturopatía<br> Avantsalud en forma<br> Balnearios<br> Centros de reconocimiento<br> Cirugía refractiva oftalmológica láser<br> Concepto Bobath<br> Conservación de Células Madre-Cordón<br> Dermatoscopia Digital<br> Dietética<br> Ecografías 3D y 4D<br> Estética<br> Fisioterapia y fisioterapia infantil<br> Hidroterapia de colon<br> Medicina Preventiva y Test Genéticos<br> Ópticas y Audífonos<br> Ortopedia<br> Osteopatía<br> Planes con niños<br> Podología y Estudio de la pisada<br> Prestaciones asistenciales a domicilio (atención postparto)<br> Procedimientos mínimamente invasivos<br> Psicología, pedagogía y logofoniatría<br> Quiropráctica<br> Rehabilitación cardiaca<br> Terapia asistida con animales<br> Tratamientos de deshabituación tabáquica<br> Tratamientos de infertilidad<br> Tratamiento ondas de choque (disfunción eréctil)<br> Veterinarios<br> Láser miopía, astigmatismo, hipermetropía<br> Podología a domicilio<br> Analítica a domicilio<br> Fisioterapia a domicilio<br> Prevención Cáncer cuello de útero/HPV<br> Test genético cardiológico<br> Cribado Cáncer de colon en sangre<br> Test genético de la obesidad<br> Test genético Cáncer pulmonar<br> Chequeo oncológico<br> Test genético Alzhéimer<br> Test genético tromboembolismo<br> Test genético Diabetes Tipo II<br> Test genético Cáncer de mama<br> Test prenatal no invasivo<br> Preeclampsia<br> Test de paternidad<br> Huella genética<br> Test de intolerancia alimentaria<br> Test degeneración macular<br> Sexo fetal en sangre materna<br> Test melisa<br> Test migraña<br> Test intolerancia a la lactosa - fructosa<br> Balón gástrico<br> Cápsula endoscópica<br> Láser verde próstata<br> Láser en dermatología<br> Láser en vascular/endoláser<br> Cirugía percutánea del pie<br> Vasectomía sin bisturí<br> Blefaroplastia<br> Abdominoplastia<br> Rinoplastia<br> Lifting<br> Microinjertos capilares<br> Mamoplastia de aumento<br> Mamoplastia de reducción<br> Cirugía íntima<br> Liposucción<br>"},"wellness":{"title":"Plataforma de Salud y Bienestar","subtitle":"Con clases diarias en directo y en diferido de mindfulness, pilates, yoga, programas de salud, talleres, nutrición y mucho más.","mindfulness":"Mindfulness","pilates":"Pilates","healthy-back":"Espalda Sana","cardio":"Gimnasio Online","nutrition":"Nutrición","vitality":"Dosis de Vitalidad"},"unipromel":{"become-partner":"¡Hazte socio ya!"},"hire-now-with-price-2":"Contratar por 2,95 euros/mes\n\nSin telemedicina, ni permanencia","healthappyrest":{"title":"Suma salud mental, felicidad y descanso a tu vida","psico":"Masterclass de psicología, programas mindfulness y sueño","yoga":"Clases de yoga y pilates","relax":"Audios relajantes, consejos y curiosidades","premium":"Acceso premium a servicio de salud privados"},"buy-btn":"MÁS INFORMACIÓN","familiar":{"title":"FAMILIAR","text":"3 meses de permanencia","subtitle":"<b>Médico y pediatra online gratuito (2 adultos + 2 niños)</b>","subtitle1":"Plataforma integral de salud y bienestar","subtitle2":"Acceso premium a servicios de salud privados","subtitlesingle":"<b>Médico y pediatra online gratuito</b>"},"healthmind":{"title":"SALUD Y BIENESTAR","pricing":"2,95€","text":"Sin permanencia","subtitle":"Plataforma integral de salud y bienestar","subtitle1":"Acceso premium a servicios de salud privados"},"pricing":{"title":"Nuestros planes"},"video-corporative":"Vídeo que hacemos","hire-now-with-price-2-2":"Contratar por 2,95 euros/mes\n\nSin permanencia","see-plans":"Ver planes","rent":"contratar"}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = {"sign-in-btn":"Acceder","sign-up-btn":"Registro","centre":"Centro","professional":"Profesional","patient":"Paciente","opensaludprime":{"subtitle":"Si no tienes seguro de salud, opensalud prime es lo que buscas.","text1":"Acceso gratuito a consultas online con un médico de familia o un pedriatra de tu elección.","text2":"Descuento en consultas online en el resto de especialidades en opensalud.","text3":"Plataforma integral de salud y bienestar con clases en directo, meditación, gimnasio online...","text4":"Acceso gratuito a consultas online con un médico de familia o un pedriatra de tu elección."},"learn-more-btn":"Saber más","title-big-1":"Todo lo que necesitas para cuidarte.","title-big-2":"Disfruta de manera gratuita de la mejor aplicación para cuidar tu salud.","title-big-3":"¿Cómo funciona?","title-big-4":"Contáctanos","title-small-1":"La plataforma de salud 360","title-small-2":"Los mejores profesionales","title-small-3":"Accede a servicios gratuitos","title-small-4":"Seguridad y privacidad","title-small-5":"Regístrate en openhealth","title-small-6":"Inicia sesión y elige el servicio","title-small-7":"Indica el motivo de tu consulta","title-small-8":"Accede al profesional","text-1":"Accede a los mejores médicos y a la aplicación más avanzada para cuidar de tu salud.","text-1-sm":"opensalud 360 es una plataforma de salud para personas,empresas y colectivos, que permite a sus usuarios acceder a los mejores profesionales de la salud, en cualquier momento y desde cualquier lugar.","text-2":"Seleccionamos los mejores centros y especialistas individualmente, para que puedas acceder a la mejor atención con el mejor precio.","text-3":"Evaluador de síntomas, contenidos de salud, historia clínica digital, agenda de salud, recordatorio de medicamentoss... y muchos más servicios sin coste.","text-4":"Ponemos a tu disposición la mejor tecnología con la máxima seguridad en las comunicaciones y total privacidad de tus datos.","text-5":"Incluye el código, número de póliza o reserva facilitado","text-6":"Selecciona el servicio y el profesional que necesitas utilizando el buscador","text-7":"Añade algunos datos de salud, adjuntando si lo deseas imágenes o informes","text-8":"Recibe tu informe y prescripción. Al finalizar podrás valorar el servicio","text-9":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","text-9-sm":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","specialty":"Especialidad","specialties":"Especialidades","services":"Servicios","appointment-type":"Tipo de consulta","error-specialty-required":"Debe seleccionar al menos la especialidad","consultations-btn":"Consultas","other-services":"Otros servicios","block-6":{"title":"El secreto para una atención online excelente es contar con excelentes profesionales digitales.","subtitle":"Consulta a los mejores médicos, psicólogos y nutricionistas, de manera fácil y segura, con el mejor precio, estés donde estés."},"prime":{"blackTitle":"opensalud prime.","title":"Si no tienes seguro de salud, opensalud prime es lo que buscas.","text":"Acceso gratuito a consultas online con un médico de familia o un pedriatra de tu elección.","text2":"Descuento en consultas online en el resto de especialidades en opensalud.","text3":"Plataforma integral de salud y bienestar con claes en directo, meditación, gimnasio online...","text4":"Acceso premium al mayor cuadro de España de servicios de salud privados con descuentos de hasta el 70%."},"hire-now-with-price":"Contratar por 12,95€/mes 2 adultos + niños incluidos","testimony1":"'La respuesta y la atención fueron rápidas y claras. Le estoy muy agradecido.'","testimony2":"'La Dra. Montserrat ha sido muy amable, el diagnóstico ha sido rápido tras una valoración y unas preguntas, servicio muy bueno y además dando soluciones rápidas. Todo 10.'","testimony3":"'Es un servicio muy rápido y muy útil. Muy contenta. Gracias.'","testimony4":"'La doctora me trató con gran atención y me recomendó y recetó la solución a mi problema capilar.'","testimonyEduard":"'El servicio ha sido magnífico, rápido y efectivo. Me proporcionó la información que necesitaba sin salir de casa y a un precio realmente económico.'","testimonyJesus":"'Su segunda opinión me sirve para evaluar un nuevo enfoque de mi problema de salud. Muy recomendable.'","testimonyMJesus":"'Me ha dado una serie de valoraciones diagnósticas que me hacen recuperar la esperanza y las ganas de superar mi problema de salud. Una información clara y directa.'","testimonyEugenia":"'La doctora nos proporcionó un diagnóstico claro y bien explicado, con recomendaciones a seguir y enlaces a artículos muy útiles..'","urologist":"Urólogo","internist":"Internista","psychology":"Psicología","pediatrics":"Pediatría","clinicalpsychology":"Psicología clínica","familymedicine":"Medicina familiar","internalmedicine":"Medicina interna","psychiatry":"Psiquiatría","sports":"Medicina del deporte","geriatrics":"Geriatría","oncology":"Oncología","neurologist":"Neurólogo","digestiveSurgeon":"Cirujano Digestivo","block-review":{"title":"Qué opinan nuestros pacientes","title2":"¿Qué te sucede?","text":"Indica tus síntomas y accede a una evaluación inicial. Al finalizar podrás acceder a los mejores especialistas.","button":"Me duele la cabeza, me duele el pecho..."},"find-prof":"Encuentra el profesional adecuado","block-security":{"blackTitle":"Todo lo que necesitas, con el máximo nivel de protección.\n","text2":"Ponemos a tu disposición la mejor tecnología con la máxima seguridad en las comunicaciones y total privacidad de tus datos. Nuestro sistema de gestión de seguridad de los datos, cuenta con la certificación ISO 27001 y está auditado por la Organización Médica Colegial."},"title-small-9":"Llevar siempre contigo tu historia clínica accesible desde el móvil y poderla compartir con quien tú desees, puede ser esencial para una correcta atención (urgente o no).","text-12":"Evaluador de Síntomas - Foro de Pacientes - Seguimiento de Hábitos - Historia clínica en la nube – Test de autoevaluación - Agenda de Salud - Recordatorio de Medicamentos – Conexión con Dispositivos (smartwatch…) – Promociones Exclusivas","title-card-1":"Evaluador de Síntomas","title-card-2":"Pacientes Como Tú","title-card-3":"Seguimiento de Hábitos","title-card-4":"Evalúa tu salud","title-card-5":"Agenda de Salud","title-card-6":"Avisos y Recordatorios","title-card-7":"Conexión con Dispositivos (smartwatch...)","title-card-8":"Promociones Exclusivas","title-card-9":"Historia clínica en la nube","subtitle-big-2":"Llevar siempre contigo tu historia clínica accesible desde el móvil y poderla compartir con quien tú desees, puede ser esencial para una correcta atención (urgente o no).","subtitle-big-functions":"Llevar siempre contigo tu historia clínica accesible desde el móvil y poderla compartir con quien tú desees, puede ser esencial para una correcta atención (urgente o no).","foro":"Foro de pacientes","registerfor-free":"¡Regístrate gratis!","title-card-2-linkeable":"<router-link to=\"/Foro\" tag=\"a\">Pacientes Como Tú</router-link>\n","rev":"valoraciones","professionals":"Profesionales","accesss":"Acceder","online-consultation":"Consulta online","title-card-10":"Blog saludable","mustSelectAnSpecialty":"Debe seleccionar una especialidad","error-specialty-or-prof-required":"Debe seleccionar una especialidad o un profesional","patients-swiper":{"care-your-health":"Consultas, pruebas y la mejor aplicación de bienestar","sign-up-free":"REGÍSTRATE GRATIS","online-consultation-inplace":"Consultas online y presencial","security-and-privacy":"Seguridad y privacidad","health-blog":"Información saludable","healthy-foods":"Alimentos que cuidan","patients-like-you":"Pacientes como tú","habit-tracker":"Objetivos y retos","cloud-clinic-history":"Historia clínica en la nube","rate-your-health":"Evalúa tu salud","health-agenda":"Agenda de salud","reminders":"Avisos y recordatorios","device-connection":"Monitorización de variables","exclusive-promotions":"Promociones exclusivas","menstrual-cycle":"Calendario menstrual","habits-that-care":"Hábitos que cuidan"},"patients-landing":{"independent-professionals":"La plataforma de los profesionales independientes","quality-medicine":"Medicina de calidad, sin prisas","sign-up-banner":"Regístrate si te preocupa la calidad de la atención, si quieres mejorar la rentabilidad de tu consulta, colaborar con tus colegas y unirte al mayor cuadro de medicina privada en España.","try-it-free":"PRUÉBALO GRATIS","access-psychologist":"¿Y si quiero acceder a un psicólogo?","online-inplace-attention":"Atención online y presencial","menttum-banner":"En <span style='text-decoration: underline; font-weight: bold;'>MENTTUM by opensalud</span> podrás acceder a los mejores psicólogos de una forma fácil y segura. Podrás solicitar una consulta presencial o acceder por video. También podrás disfrutar de nuestra aplicación de salud y bienestar.","go-menttum":"IR A MENTTUM","request-appointment":"Solicitar cita","mobile-title":"Los mejores <br class=\"d-lg-none\"> médicos y profesionales de la salud","sign-up-free":"Regístrate gratis","opensalud360-title":"¿Necesitas un servicio de salud y bienestar para tus empleados que realmente funcione? ","opensalud360-subtitle":"Líderes en servicios de atención psicológica, prevención, salud integral y bienestar para empleados.","opensalud360-text":"opensalud360 permite acceder a los mejores médicos, psicólogos o nutricionistas, los mejores talleres y programas de bienestar y a la aplicación de salud y mejora de hábitos más exitosa del mercado.","know-more":"Conoce más","different-health":"La salud hoy es diferente","mobile-title-2":"La mejor aplicación para cuidarte","mobile-title-lg":"Los mejores médicos y profesionales de la salud y la mejor aplicación para cuidarte","swiper":{"title":"Consultas y la mejor aplicación de salud y bienestar"},"why-opensalud-different":"¿Por qué opensalud es diferente?"},"patients-layout":{"companies":"Empresas"},"services-consultation":"Consultas y servicios","request-consultation":"Consultas","request-service":"Pruebas médicas","service":"Pruebas y servicios médicos","error-service-required":"Debe seleccionar un servicio","location":"Provincia/Localidad","telemedicine":"Telemedicina","patient-title":"opensalud: consultas y aplicación de salud y bienestar","patient-panel":{"my-apps":"Mis aplicaciones"},"patients-landing-different-health-description":"Queremos facilitarte el acceso a profesionales cualificados, centros y soluciones de referencia y a la aplicación de salud<br class=\"d-none d-block-lg\"/>\ny bienestar que utilizan las empresas lideres, para ayudarte a vivir más y vivir mejor.","solutions":{"qualityMedicine":{"title":"Medicina de calidad","description":"Todos los profesionales son evaluados antes de permitir su alta en opensalud"},"agileAppointment":{"title":"Agilidad en la cita","description":"95% citas en menos de 10 días (menos de 3 días para usuarios empresas excepto atención urgente)"},"privateConsultations":{"title":"Consultas privadas","description":"No se ofrecen consultas financiadas por seguros de salud, sólo citas privadas"},"medicineWellbeing":{"title":"Medicina y bienestar","description":"Especialistas en prevención de enfermedades y envejecimiento saludable"}}}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = {"discounts":{"meta-title":"Descuentos"},"more-info-btn":"Más información","firstblock":{"title":"La mejor calidad y precio para tu bienestar y salud","subtitle":"Mas de 25.000 profesionales y centros de reconocido prestigio","subtitle2":"Tratamientos de bienestar: balnearios, centros estéticos…","title-offer-1":"Consulta alergología","price-before-1":"60€","price-after-1":"25€","subtitle-offer-1-1":"Precio mercado","subtitle-offer-1-2":"Precio con opensaludprime","subtitle-offer-1-3":"Ahorras 35€","title-offer-2":"Ecografía ginecológica","price-before-2":"70€","price-after-2":"30€","subtitle-offer-2-1":"Precio mercado","subtitle-offer-2-2":"Precio con opensaludprime","subtitle-offer-2-3":"Ahorras 40€","asterisk-text":"*Precios medios por provincia. Pueden variar de unas localidades a otras.","titleInvert":"Sin listas de espera","subtitleInvert":"Su funcionamiento es muy sencillo, y recuerda que... ¡No tienes que pagar nada hasta que acudas al centro clínico!","iconTitle1":"Encuentra el servicio que necesitas","iconTitle2":"Pide cita en el centro o especialista que elijas","iconTitle3":"Descarga tu tarjeta virtual con el descuento aplicado","iconTitle4":"Acude a la cita y realiza el pago en el centro"},"secondblock":{"title":"¿Piensas que la medicina privada es demasiado cara si no tienes seguro de salud? <b>Tú decides</b>","title-offer-1":"Sesión de psicología","price-before-1":"55€","price-after-1":"30€","subtitle-offer-1-1":"Precio mercado","subtitle-offer-1-2":"Precio con opensaludprime","subtitle-offer-1-3":"Ahorras {price}","title-offer-2":"Resonancia Magnética","price-before-2":"220€","price-after-2":"120€","subtitle-offer-2-1":"Precio mercado","subtitle-offer-2-2":"Precio con opensaludprime","subtitle-offer-2-3":"Ahorras 100€","title-offer-3":"Sesión de rehabilitación o fisioterapia","price-before-3":"45€","price-after-3":"15€","subtitle-offer-3-1":"Precio mercado","subtitle-offer-3-2":"Precio con opensaludprime","subtitle-offer-3-3":"Ahorras 30€","title-offer-4":"Endodoncia birradicular","price-before-4":"200€","price-after-4":"105€","subtitle-offer-4-1":"Precio mercado","subtitle-offer-4-2":"Precio con opensaludprime","subtitle-offer-4-3":"Ahorras 95€","title-offer-5":"Consulta alergología","price-before-5":"60€","price-after-5":"25€","subtitle-offer-5-1":"Precio mercado","subtitle-offer-5-2":"Precio con opensaludprime","subtitle-offer-5-3":"Ahorras 35€","title-offer-6":"Ecografía ginecológica","price-before-6":"70€","price-after-6":"30€","subtitle-offer-6-1":"Precio mercado","subtitle-offer-6-2":"Precio con opensaludprime","subtitle-offer-6-3":"Ahorras 40€","title-offer-7":"Ácido Hialurónico","subtitle-offer-7-3":"Hasta un 30% de descuento con opensaludprime","title-offer-8":"Densitometría ósea","price-before-8":"150€","price-after-8":"25€","subtitle-offer-8-1":"Precio mercado","subtitle-offer-8-2":"Precio con opensaludprime","subtitle-offer-8-3":"Ahorras 100€","asterisk-text":"*Precios medios por provincia. Pueden variar de unas localidades a otras.","titleInvert":"Ventajas opensalud prime","subtitleInvert":"La mejor calidad y precio para tu bienestar y salud","iconTitle1":"Accede al mejor servicio de bienestar y salud a precio reducidos","iconTitle2":"Mas de 25.000 profesionales, centros de reconocido prestigio","iconTitle3":"No hay limitaciones por edad ni exclusiones","iconTitle4":"La tecnologia médica mas puntera y avanzada","iconTitle5":"Cobertura desde el primer dia, sin periodos de carencia","iconTitle6":"Tratamientos de bienestar alternativos: balnearios, centros estéticos…","from":"Desde"},"bgheart":{"hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños incluídos","more-info-btn":"Más información"},"hire-now-with-price-2-disc":"Contratar por 2,95 euros/mes\n\nSin permanencia"}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = {"wellness":{"meta-title":"Programa de Bienestar"},"firstblock":{"title":"¿Te imaginas tener un <b> entrenador personal o un profesor de meditación 24/7</b>?","titleInvert":"¡Clases en directo todos los días!","subtitleInvert":"A solo un click, tendrás a tu disposición múltiples disciplinas basadas en tus preferencias y objetivos.  Todas las clases quedarán grabadas por si prefieres verlas en otro momento.","titleInvert2":"¡Y además los mejores programas de salud!","subtitleInvert2":"Gimnasia para embarazadas, programas de espalda sana, salud activa, stretching, mindfulness, cardiovascular o antiestrés.","videoquantity":"","videodetails":"+800 Programas, clases en Directo y en diferido","icontitle1":"","iconsubtitle1":"SALUD FÍSICA: GAP, HIIT, TBC, Spinning, Step Tono, Tono Dance, Abdominales...","icontitle2":"","iconsubtitle2":"SALUD MENTAL: Yoga, Pilates, Mindfulness, Psicología..."},"secondblock":{"titleInvert":"Además, tendrás programas de nutrición personalizables","iconTitle1":"Selecciona tu objetivo","firstlistitem1":"Antiestrés","firstlistitem2":"Cardiovascular","firstlistitem3":"Fortalecer","iconTitle2":"Elige el tipo de dieta","secondlistitem1":"Mediterránea","secondlistitem2":"Vegana","secondlistitem3":"Vegetariana","iconTitle3":"¡Listo para descargarla!","title-diet-1":"Antiestrés","subtitle-diet-1":"Rebaja los niveles de ansiedad y ayuda a conciliar el sueño","title-week-1":"Semana 1 - Lunes","diet-1":"<b>DESAYUNO</b> <br> · 250ml Leche desnatada<br>· 50g pan<br>· Tomate<br> <br> <b>MEDIA MAÑANA</b><br>· 25g Cornflakes<br>· Kéfir<br>· 1 cda mermelada sin azúcar<br><br> <b>COMIDA</b><br>· 50g Ensalada<br>· 1 Palmito<br>· 150g salmón al horno con albahaca, <br> orégano y tomillo<br>· 1 Patata mediana<br>· Melocotón<br><br> <b>MERIENDA</b><br>· 200ml leche desnatada<br>· 3 Tortitas de maíz o arroz<br>· ¼ aguacate<br> <br> <b>CENA</b><br>· 50g Ensalada: Remolacha + zanahoria<br>· 150g Pollo a la plancha<br>· 40g Quinoa<br>· 1 Naranja<br><br> <b>RESOPÓN</b><br>· 200ml leche desnatada<br>· 20g Avena<br>· 1 cda Semillas de Chía","diet-subtitle-1":"Grasas  40 gr<br>Proteínas  120 gr<br>Carbohidratos  270 gr<br><br><b>Calorías  1.700 Kcal</b>","asteriskdiet-1":"*Dieta Antiestrés - mediterránea","title-diet-2":"Cardiovascular","subtitle-diet-2":"Mejora tu salud, elimina grasa y ayuda a perder peso","title-week-2":"Semana 2 - Lunes","diet-2":"<b>DESAYUNO</b><br>· Bol de Batido de Frambuesa: 100ml Leche de Coco + 2 Tazas Frambuesas congeladas + 1 Plátano congelado + 10g Semillas de Chía + Coco rallado + Chocolate 75% rallado + Avellanas trituradas<br><br><b>MEDIA MAÑANA</b><br>· Té verde<br>· 1 Puñado de Bayas de Goji<br>· 2 Tortitas de arroz<br><br><b>COMIDA</b><br>· 1 Berenjena rellena: Salsa de Tomate + Cebolla + Soja texturizada + Queso vegetal rallado + Aceite de oliva, sal y perejil + Semillas de Sésamo<br>· 2 Patatas pequeñas asadas<br>· 1 Manzana<br><br><b>MERIENDA</b><br>· 1 Yogur vegetal + Miel de caña + 10g Semillas de Chía<br>· 1 Plátano<br><br><b>CENA</b><br>· 1 Plato de Arroz al horno:<br>· 130g Arroz<br>· Media bandeja de Champiñones<br>· 500ml Caldo de Verduras<br>· Media Cebolla<br>· 2 Dientes de Ajo<br>· 1 Hoja de Laurel<br>· Queso vegetal en polvo<br>· 1 kiwi<br>","diet-subtitle-2":"Grasas  65 gr<br>Proteínas  120 gr<br>Carbohidratos  250 gr<br><br><b>Calorías  2.100 Kcal</b>","asteriskdiet-2":"*Dieta Cardiovascular - vegana","title-diet-3":"Fortalecer","subtitle-diet-3":"Ayuda a incrementar la masa muscular y fortalecer tu cuerpo","title-week-3":"Semana 3 - Lunes","diet-3":"<b>DESAYUNO</b><br>· 1 Milkshake: 150ml Leche desnatada + 50ml Agua + 40g Avena + 1 Plátano + 1 Puñado de Arándanos + 10g Levadura de cerveza +10g Semillas de Lino<br><br><b>MEDIA MAÑANA</b><br>· 2 Tortitas de arroz<br>· 1 Puñado de almendras<br><br><b>COMIDA</b><br>· 75g Macarrones integrales<br>· Sofrito: Tomate + Cebolla + Aceite de oliva + Soja texturizada + Champiñones<br>· 1 Pera<br><br><b>MERIENDA</b><br>· 1 Puñado de Anacardos<br>· 1 Yogur proteico<br>· Macedonia: 5 Fresas o 10 Cerezas + 1 Plátano + Media naranja<br><br><b>CENA</b><br>· 1 Tortita o crepe integral: Tofu + Lechuga + Tomate + Maíz + Aceitunas negras + Aguacate + Mayonesa light (opcional)<br>· 2 Huevos duros + Pimienta + Orégano<br>· 1 Vasito de Kéfir + Miel de caña + 10g Semillas de Chía","diet-subtitle-3":"Grasas  65 gr<br>Proteínas  120 gr<br>Carbohidratos  250 gr<br><br><b>Calorías  2.100 Kcal</b>","asteriskdiet-3":"*Dieta Fortalecer - vegetariana"},"bgheart":{"hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños incluídos","more-info-btn":"Más información"},"hire-now-with-price-2-2":"Contratar por 2,95 euros/mes\nSin permanencia"}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WHO_IN_HEALTH_COMMUNITY_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORUM_HEALTH_COMMUNITY_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WHO_IN_SECTION_NAME; });
/* unused harmony export HEALTHY_INFORMATION_SECTION_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PATIENTS_LIKE_YOU_IN_SECTION_NAME; });
var WHO_IN_HEALTH_COMMUNITY_SECTION = '63a45f15d7ae57c097eadac3';
var HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION = '63a45f08d7ae57c097eadac2';
var FORUM_HEALTH_COMMUNITY_SECTION = '63a45dfdd7ae57c097eadac1';

var WHO_IN_SECTION_NAME = 'quienseapunta';
var HEALTHY_INFORMATION_SECTION_NAME = 'informacionsaludable';
var PATIENTS_LIKE_YOU_IN_SECTION_NAME = 'pacientescomotu';

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export currentRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_i18n_helpers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_routes_video_routes__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_routes_webapp_routes__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_video_launcher_VideoLayout__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_errors_NotFoundErrorPage__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router_routes_opensaludprime_routes__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router_routes_opensalud4all_routes__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router_routes_openlegal_routes__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router_routes_abogalitypro_routes__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router_routes_webapp_healthycommunity_routes__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__router_routes_webapp_healthyhabits_routes__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__router_routes_unipromel_routes__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__router_routes_public_routes__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__router_routes_account_routes__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__router_routeHelpers__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__router_routes_opensalud360_routes__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__constants_domains__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__constants_subdomains__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__constants_themes__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__constants_sessionStorage__ = __webpack_require__(281);





var _this = this;





























/* import OpensaludLanding from '@/components/public/OpensaludLanding' */

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);

function getRoutesFromSubdomain() {
  var _$exec = /:\/\/(?:((?:\w|-)+)\.)?([^./]+)(?:(?:\.|:)(?:(?:\w|\d){2,4}))/.exec(window.location.href),
      _$exec2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_$exec, 3),
      match = _$exec2[0],
      subdomain = _$exec2[1],
      domain = _$exec2[2];

  if (domain === 'es' || domain === 'mx' || domain === 'com') {
    domain = subdomain;
  }
  // Always check for full domain name or it could generate infinite loops

  var routes = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__router_routes_public_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__router_routes_webapp_routes__["a" /* default */]), [__WEBPACK_IMPORTED_MODULE_23__router_routeHelpers__["a" /* default */].buildRoutes('cuenta', __WEBPACK_IMPORTED_MODULE_22__router_routes_account_routes__["a" /* default */])]);

  if (subdomain && subdomain.includes(__WEBPACK_IMPORTED_MODULE_26__constants_subdomains__["q" /* VIDEO_SUBDOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_10__components_video_launcher_VideoLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__router_routes_video_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routes)) };
  }
  if (domain.includes(__WEBPACK_IMPORTED_MODULE_25__constants_domains__["j" /* UNIPROMEL_DOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__router_routes_unipromel_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routes)) };
  }
  if (domain.includes(__WEBPACK_IMPORTED_MODULE_25__constants_domains__["i" /* PRIMESALUD_DOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__router_routes_opensaludprime_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routes)) };
  }
  if (domain.includes(__WEBPACK_IMPORTED_MODULE_25__constants_domains__["e" /* OPENSALUD4ALL_DOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__router_routes_opensalud4all_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routes)) };
  }
  if (domain.includes(__WEBPACK_IMPORTED_MODULE_25__constants_domains__["d" /* OPENLEGAL_DOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__router_routes_openlegal_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routes)) };
  }
  if (domain.includes(__WEBPACK_IMPORTED_MODULE_25__constants_domains__["a" /* ABOGALITYPRO_DOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__router_routes_abogalitypro_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routes)) };
  }
  if (subdomain && subdomain && subdomain.includes(__WEBPACK_IMPORTED_MODULE_26__constants_subdomains__["m" /* OPENSALUD360_SUBDOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_24__router_routes_opensalud360_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routes)) };
  }
  if (subdomain && subdomain.includes(__WEBPACK_IMPORTED_MODULE_26__constants_subdomains__["g" /* COMUNIDAD_SALUDABLE_SUBDOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__router_routes_public_routes__["a" /* default */]), [__WEBPACK_IMPORTED_MODULE_23__router_routeHelpers__["a" /* default */].buildRoutes('cuenta', __WEBPACK_IMPORTED_MODULE_22__router_routes_account_routes__["a" /* default */])], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__router_routes_webapp_healthycommunity_routes__["a" /* default */])) };
  }
  if (subdomain && subdomain && subdomain.includes(__WEBPACK_IMPORTED_MODULE_26__constants_subdomains__["i" /* HEALTHY_HABITS_SUBDOMAIN */])) {
    return { layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"], routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__router_routes_public_routes__["a" /* default */]), [__WEBPACK_IMPORTED_MODULE_23__router_routeHelpers__["a" /* default */].buildRoutes('cuenta', __WEBPACK_IMPORTED_MODULE_22__router_routes_account_routes__["a" /* default */])], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__router_routes_webapp_healthyhabits_routes__["a" /* default */])) };
  }
  return {
    layout: __WEBPACK_IMPORTED_MODULE_11__components_layouts_BaseLayout__["default"],
    routes: __WEBPACK_IMPORTED_MODULE_9__router_routes_webapp_routes__["a" /* default */]
  };
}

function removeParamsFromUrl() {
  var url = window.location.href;
  window.location.href = url.substring(0, url.indexOf('?'));
}

var baseRoute = {
  path: '/',
  redirect: function redirect(to) {
    return __WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__["a" /* default */].locale;
  }
};

var routesFromSubdomain = getRoutesFromSubdomain();

var langBasedRoutes = {
  path: '/:lang(es|en|mx|pt)',
  component: routesFromSubdomain.layout,
  beforeEnter: function beforeEnter(to, from, next) {
    var lang = Object(__WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__["b" /* getCurrentLocaleOnInit */])();
    if (lang !== to.params.lang) {
      return next(to.fullPath.replace('/' + to.params.lang, '/' + lang));
    }
    return next();
  },
  children: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(routesFromSubdomain.routes), [{
    name: 'NotFound',
    path: '(.*)',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_errors_NotFoundErrorPage__["default"]
  }])
};

var Router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [baseRoute, langBasedRoutes, {
    path: '/(.*)',
    redirect: function redirect(to) {
      return '/' + __WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__["a" /* default */].locale + to.path;
    }
  }]
});

function goToUnauthorizedPage(to, next) {
  __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].commit('setErrorPageMessage', null);
  var returnUrl = encodeURIComponent('' + window.location.origin + to.fullPath);
  next('/error/unauthorized?returnUrl=' + returnUrl);
}

Router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var token;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].restored;

          case 2:
            if (!to.path.endsWith('/')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return', next({ path: to.path.slice(0, -1), query: to.query }));

          case 4:
            // Compute theme name based on hostname
            to.meta.theme = Object(__WEBPACK_IMPORTED_MODULE_28__constants_themes__["c" /* getThemeName */])();

            _context.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_7__helpers_i18n_helpers__["c" /* loadTranslations */])(__WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__["a" /* default */].locale, typeof to.meta.i18n === 'string' ? [to.meta.i18n] : to.meta.i18n);

          case 7:

            if (!to.name || to.name.includes('Error')) {
              next();
            } else {
              if (!__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$apiToken && __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].state.session.user) {
                __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('session/remove');
              }
              if (to.meta.roles ? to.meta.roles.length > 0 : null) {
                token = to.query.token || to.query.t || to.query.api_token || sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_30__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */]) || __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$apiToken;

                if (to.meta.roles.includes(__WEBPACK_IMPORTED_MODULE_29__constants_roles__["c" /* ANONYMOUS_ROLE */]) && !token || !to.meta.roles.includes(__WEBPACK_IMPORTED_MODULE_29__constants_roles__["c" /* ANONYMOUS_ROLE */]) && !__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$apiToken) {
                  goToUnauthorizedPage(to, next);
                } else {
                  if (sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_30__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */]) || to.query.t && to.query.h === '1') {
                    if (to.query.t) {
                      sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_30__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */], to.query.t);
                      removeParamsFromUrl();
                    }
                    next();
                  } else {
                    __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('session/create', { token: token }).then(function (response) {
                      if (!!response && to.meta.roles.includes(__WEBPACK_IMPORTED_MODULE_29__constants_roles__["c" /* ANONYMOUS_ROLE */]) && (to.query.t || to.query.token || to.query.api_token)) {
                        // Remove query params from URLS
                        removeParamsFromUrl();
                      } else if (to.meta.only360Users && !__WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters['session/userHasCompanies']) {
                        __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].commit('setErrorPageMessage', __WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__["a" /* default */].t('errorMessages.only-subscribed-users'));
                        goToUnauthorizedPage(to, next);
                      } else if (!!response && to.meta.roles.includes(__WEBPACK_IMPORTED_MODULE_29__constants_roles__["c" /* ANONYMOUS_ROLE */]) || __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters['session/isSessionRoleAllowed'](to.meta.roles)) {
                        next();
                      } else {
                        goToUnauthorizedPage(to, next);
                      }
                    });
                  }
                }
              } else {
                next();
              }
            }

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

Router.afterEach(function (to, from) {
  // Set document.title from route meta
  if (to.meta.title && to.meta.title.text) {
    var titleText = to.meta.title.text instanceof Function ? to.meta.title.text(to) : to.meta.title.text;
    document.title = (__WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__["a" /* default */].t(titleText) ? __WEBPACK_IMPORTED_MODULE_6__plugins_i18n_js__["a" /* default */].t(titleText) : titleText) + ' | ' + (to.meta.tagLine || Object(__WEBPACK_IMPORTED_MODULE_27__constants_platformNames__["h" /* getPlatformName */])());
  }

  // Encode URI after hash if return URL is present
  var returnUrl = to.query.returnUrl || to.query.ReturnUrl;
  if (returnUrl && to.hash) {
    var returnUrlEncoded = encodeURIComponent('' + to.hash);
    Router.replace({ query: { returnUrl: '' + returnUrl + returnUrlEncoded } });
  }
});

// Fix for chunk loading error
Router.onError(function (error) {
  if (error.message.includes('Loading chunk') && !location.href.includes('localhost')) {
    window.location.reload();
  }
});

var push = __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */].prototype.push;
var isNavigationFailure = __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */].isNavigationFailure,
    NavigationFailureType = __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */].NavigationFailureType;

// Avoid duplicated navigation error

__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */].prototype.push = function (location) {
  return push.call(this, location).catch(function (error) {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
      throw Error(error);
    }
  });
};

var currentRoute = function currentRoute() {
  return Router.currentRoute;
};

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports) {

module.exports = {"payments":{"holdername":"Titular de la tarjeta","cardnumber":"Número de la tarjeta","cvv":"CVV","3digits":"(3 últimos dígitos)","accept":"Aceptar pago","expiration":"Fecha de caducidad","errorTitle":"Error procesando su método de pago","errorTxt":"Se ha producido un error procesando su método de pago.<br> Contacte con su banco para obtener más información o inténtelo de nuevo con otra tarjeta.","retry":"Reintentar","enterHolderName":"Debe introducir el titular de la tarjeta","enterCardNumber":"Debe introducir el número de la tarjeta","selectMonth":"Debe seleccionar el mes de caducidad de la tarjeta","selectYear":"Debe seleccionar el año de caducidad de la tarjeta","enterCvv":"Debe introducir el CVV de la tarjeta","weInform1":"Le informamos que en","weInform2":"minutos expirará la sesión y no podra realizar ninguna transacción.","expiredTitle":"Sesión expirada","expiredTxt":"Le informamos de que la sesión ha expirado y por consiguiente no puede completar la transacción.<br><br> Cierre esta pestaña y repita la acción de nuevo.","year":"Año","acceptTerms":"Debe aceptar los términos y condiciones","billingData":"Datos de facturación","billingEntity":"Entidad de facturación","billingAddress":"Dirección","billingCountry":"País","billingNif":"NIF/NIE","billingProvince":"Provincia","billingVillage":"Municipio","billingPostalCode":"Código postal","billingInfo":"Para completar su compra y generar la factura es necesario que complete los siguientes campos:","buySummary":"Resumen de compra","price":"Precio","product":"Producto","appointmentPendingPayment":"Consulta pendiente de pago","flatRate":"Tarifa plana consulta escrita y chat","teleconsultationBono":"Bono de teleconsultas","errorPayment":"Cambio de método de pago debido a fallo en el cobro","plusRate":"Tarifa Plus","authorizePayment":"Autorizar pago","payment":"Pago","paymentAdvice1":"En el caso de transacciones que se realicen en una divisa diferente al euro, pueden existir cargos adicionales por cambio de moneda.","fiscalData1":"Open Healthcare S.L.    CIF: B90209081","fiscalData2":"Avda. República Argentina 25 9ª planta","fiscalData3":"(Sevilla, España) CP 41011","fiscalData4":"info@opensalud.es      656383230","priceWithDiscount":"Precio con descuento","couponQuestion":"Canjear código de descuento","discountCoupon":"Cupón de descuento","verify":"Verificar","selectPaymentMethod":"Seleccione un método de pago","bizum":"Bizum","debitCreditCard":"Tarjeta de crédito/débito","confirmPayment":"Confirmar pago","bizumBanner":"A continuación deberá introducir su número de teléfono para realizar el pago por bizum. Debe tener habilitada dicha funcionalidad en su banco.","bizumDirectBanner":"Para realizar el pago al profesional, deberá enviar un bizum al número que le aparecerá en pantalla, tras pulsar en el botón verde que aparece a continuación. Indique en el asunto el tipo de consulta y su nombre completo. <br><br><b>En el caso de que no podamos verificar el cobro, la consulta será cancelada.</b>","bizumDirectDialog":"Debe realizar el bizum al teléfono que se muestra en pantalla.<br><br><b>Si el profesional no confirma la recepción del mismo, la consulta será cancelada.</b><br><br><b>Teléfono:</b> {phone}","invalidCode":"El código no es válido","appliedDiscount":"Se ha aplicado un descuento del {discount} %","discount":"Descuento","mustInsertCode":"Debe introducir un código de descuento válido","free":"GRATIS","ePrescriptionTax":"Se van a preautorizar 0,5 € adicionales (50 céntimos) correspondientes al coste de una receta en formato electrónico (no necesita imprimirse).<br><br> Si finalmente el médico no realiza la receta en formato electrónico, no se le cobrará dicho importe.","confirmPendingPayment":"Su consulta pendiente de pago ha sido autorizada con éxito.","confirmErrorPayment":"Su método de pago ha sido actualizado correctamente.","successPayment":"Su consulta ha sido confirmada.","confirmChangePaymentMethod":"Su método de pago ha sido cambiado con éxito","confirmGiftPayment":"Su cupón de regalo ha sido tramitado y enviado con éxito.","confirmFlatRatePayment":"Su suscripción ha sido contratada con éxito","confirmServicesPackagesPayment":"Su paquete de servicios ha sido contratado con éxito"}}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = {"terms-conditions":"Términos y condiciones","contact":"Contacto","legal-notice":"Aviso legal","cookies-policy":"Política de cookies","privacy-policy":"Política de privacidad","faqs":"Preguntas frecuentes","sgsi-policy":"Política SGSI"}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = {"medical-assistance":{"meta-title":"Asistencia médica online"},"title":"Libre elección de los mejores profesionales, en cualquier momento y desde cualquier lugar","general":"Medicina general y familiar","pediatrics":"Pediatría","alert":"¡Recibe la receta en tu móvil!","hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños incluídos","more-info-btn":"Más información"}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = {"openlegal":{"home-footer":{"derecho-penal":"Derecho penal","derecho-fiscal-tributario":"Derecho fiscal y tributario","derecho-constitucional":"Derecho constitucional","procesal-civil-penal":"Procesal civil y penal","derecho-laboral":"Derecho laboral","derecho-administrativo":"Derecho administrativo","derecho-civil":"Derecho civil","derecho-familia":"Derecho de familia","derecho-sucesiones-herencias":"Derecho de sucesiones y herencias","derecho-mercantil":"Derecho mercantil","derecho-internacional-privado":"Derecho internacional privado","derecho-navegacion-maritima-aerea":"Derecho de la navegación marítima y aerea","derecho-urbano":"Derecho urbanístico","derecho-bancario":"Derecho bancario","corporate-compliance":"Corporate compliance","derecho-transporte":"Derecho de transporte","derecho-privacy":"Derecho de la privacidad o protección de datos","derecho-consumo":"Derecho del consumo","derecho-farmaceutico":"Derecho farmaceutico y biomedicina","propiedad-intelectual":"Propiedad intelectual","derecho-agrario":"Derecho agrario","derecho-seguridad-social":"Derecho de la seguridad social","derecho-agua":"Derecho del agua","derecho-extranjeria":"Derecho extranjeria","derecho-militar":"Derecho militar","derecho-europeo":"Derecho europeo","derecho-deporte":"Derecho deportivo","comercio-exterior":"Comercio exterior","derecho-aeronautico":"Derecho aéreo o aeronáutico","derecho-menores":"Jurisdicción de menores","derecho-ambiental":"Derecho ambiental","division-bienes":"División de bienes","arrendamientos-propiedad-horizontal":"Derecho arrendamientos","defectos-construccion":"Defectos de la construcción","concurso-acreedores":"Concurso de acreedores","derecho-hipotecario":"Derecho hipotecario","derecho-marcas":"Derecho de marcas","derecho-autor":"Derecho de autor","derechos-editoriales":"Derechos editoriales","derecho-eclesiastico":"Derecho eclesiastico","empredimiento-startups":"Emprendimiento & Startups","asistencia-testigos":"Asistencia a testigos","asistencia-detenido":"Asistencia al detenido","especialistas-franquicias":"Especialistas en franquicias","derecho-sanitario":"Derecho sanitario","derecho-tercer-sector":"Derecho del tercer sector","licencia-actividad":"Licencia de actividad","recurso-casacion":"Recurso de casación","derecho-digital-imagen":"Derecho digital y de la imagen","derechos-humanos":"Derechos humanos","client-conditions":"Condiciones para clientes","derecho-internacional-publico":"Derecho internacional público","derecho-contratos":"Derecho de contratos","pension-alimentos":"Pensión de alimentos","pension-compensatoria":"Pensión compensatoria","juicio-delito-leve":"Juicio por delito leve","juicio-rapido":"Juicio rápido","derecho-penitenciario":"Derecho penitenciario","derecho-maritimo":"Derecho marítimo"}}}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más información","learn-more-btn":"Saber más","main-block-h1":"Colaboramos con ONGs para ofrecer telemedicina a comunidades vulnerables en cualquier lugar del mundo.","section-one":{"title":"Opensalud4all es una iniciativa que surge para canalizar las actividades solidarias de los \nprofesionales de la salud que desean ofrecer sus servicios a ONGs que trabajan en zonas con \nlimitado acceso a servicios de salud, utilizando la telemedicina.","subtitle":"Sin necesidad de desplazamientos, en cualquier momento y desde cualquier lugar, los médicos \ny psicólogos que utilizan opensalud, pueden atender pacientes o prestar apoyo a los \nprofesionales de la salud locales, través de la telemedicina.\n"},"how-work-btn":"Cómo funciona","section-two":{"title":"¿Eres médico o psicólogo?","list":{"1":"Opensalud4all trabaja con profesionales de la salud que \ndonan su tiempo y conocimientos para proveer asistencia \nclínica de calidad en comunidades vulnerables con limitados \naccesos a servicios de salud en cualquier lugar del mundo.","2":"Todo el soporte clínico es mediante telemedicina a través \nde la plataforma opensalud, que sirve de canal para atender \ndirectamente a pacientes o para dar soporte a través de \ninterconsultas con los equipos clínicos locales. Este soporte \nclínico es extensible al personal sobre el terreno de las \nONGs.","3":"Al ser profesiones vocacionales motivadas por el deseo de \ncuidar la salud de los demás, existe una gran \npredisposición de los profesionales de la salud para \ncolaborar con comunidades desfavorecidas, pero las \nbarreras geográficas o funcionales lo dificultaban.","4":"Para agradecer a los voluntarios su colaboración y eliminar \ncualquier atisbo de interés económico, los profesionales \nque colaboren con la iniciativa podrán utilizar la plataforma \nopensalud para su práctica clínica habitual sin pagar \nninguna cuota.\n"}},"colaborate-btn":"Si quieres saber cómo puedes colaborar, contáctanos","section-cero":{"subtitle":"Si quieres aportar una pequeña parte de tu tiempo para atender de manera remota a \npacientes en zonas vulnerables, solicita información.","subtitle-2":"Si eres una ONG que trabajas en comunidades con limitado acceso a recursos de salud \ncontáctanos.","ong":"Soy ONG","medicpsico":"Soy médico o psicólogo"},"form":{"contry":"País de residencia","specialities":"Especialidad","languages":"Idiomas"},"user":{"prof":"Profesional de la salud","ong":"ONG","another":"Otros"},"formHelp":{"selectUser":"Seleccione Entidad","ongName":"Nombre de la ong"}}

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = {"global":{"absentismo":"ausentismo","factura":"el recibo","contact-email":"contactomx@opensalud.es"}}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = {"global":{}}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = {"welcome_message":"Welcome","pages":{"about":"About Page"},"professionals":"Professionals","menu-label-patient":"Patient","menu-health-information":"Health information","menu-notes":"Notes","menu-share-files":"Share files","menu-end-session":"End session","menu-chat":"Chat","menu-audio":"Audio","menu-video":"Video","menu-help":"Help","menu-language":"Language","general-close":"Close","waitingProfessionalHeader":"Virtual waiting room","waitingProfessionalBody":"The professional will connect in a few moments. Please be patient, this process can take up to 15 minutes.","menu-mute-video":"Pause video","menu-video-quality-low":"Low quality","menu-video-quality-medium":"Medium quality","menu-video-quality-high":"High quality","menu-title-video-quality":"Video quality","menu-title-video-advanced":"Advanced","menu-language-es":"Espa�ol","menu-language-en":"English","menu-share-screen":"Share screen","menu-mute-audio":"Mute audio","sessionNotValid":"The session you are trying to access has expired or is invalid","chat-placeholder":"Write a message...","needValidToken":"You need a valid session to start the consultation.","dialog-title-error":"Error","errorServerConnection":"An error has occurred in the connection to the server.","errorTokenNotValid":"The session you entered is not correct.","errorInvalidDate":"You can enter the waiting room with a maximum of 30 minutes in advance. Check the date and time of your appointment.","errorVideoConnection":"An error has occurred with the video session. Contact with the technical service.","errorShareDevices":"You need to grant permissions to use your camera and microphone in order to access the session.","dialog-title-videoTest":"Video test","sessionEnded":"Video session ended","sessionEndedBody":"Your video consultation session has ended. As agreed with the professional, you will receive your report and/or prescription as soon as possible.","videoSession":"Video session","retry":"Try again","returnToApp":"Return to Opensalud","menu":{"clinical_documents":"Clinical documents","history":"Clinic history","devices":"Devices","appointment-info":"Appointment information","summary":"Query information","notes":"Notes","change-user":"Change user","change-user-placeholder":"Select a user...","change-user-no-patients":"You do not have any user associated with your main account. \nYou can register one from your profile by clicking the button below.","change-user-create":"Register associated patient","history-access":"Grant history access"},"enable-stethoscope":"Stethoscope","enable-lamp":"Exploration lamp","cancel":"Cancel","continue":"Continue","stethoscope1":"Before proceeding, make sure you have connected the stethoscope to your computer and that it is turned on.","manualteleexploracion-href":"http://docs.opensalud.es/ManualTeleExploracion_en","stethoscope2":"our guide.","stethoscope3":"Once you click on 'Continue', the professional will stop listening to you through your main microphone and will start to hear the signal from the stethoscope. \nIf the professional does not hear the signal from the stethoscope try updating this page.","stethoscope4":"You can re-enable your main microphone at any time.","stethoscope5":"Before proceeding, make sure that you have disconnected the stethoscope from your computer.","stethoscope6":"Once you click on 'Continue' the professional will stop listening to the stethoscope signal and will hear your main microphone.","stethoscope7":"You can re-enable the stethoscope at any time.","lamp1":"Before you continue, make sure that you have connected the examination light to your computer and that it is turned on. \n<br><br>Once you click on 'Continue', the professional will stop seeing you through the camera and the image of the lamp will be activated.<br><br>You can reactivate your camera whenever you want, simply putting it in position turning off the lamp and extracting it.<br><br>If the doctor tells you that he cannot see you, click on the update button (like the one you can see below) that you will find at the bottom of the screen.<br <br>Do not remove the lamp without first selecting the off position!","lamp2":"Do not remove the lamp yet! \nClick 'Continue' and then remove the examination light from your computer.","itemsPerPage":"Rows per page","ofLabel":"of","page":"page","all":"All","next-label":"Next step","prev-label":"Previous step","file-name":"Document","preview-file":"View","share-screen":"Share screen","stop-share-screen":"Stop screen sharing","enable-mic":"Enable microphone","mute-mic":"Mute microphone","enable-cam":"Enable camera","disable-cam":"Disable camera","introduce-token":"Enter your session identifier","go-to-session":"Continue","need-help":"Need help?","try-refresh":"If you can't see or hear the professional, or the professional can't see or hear you, try <u><a href=\"#\" onclick=\"window.location.reload()\">reload the page</a></u>","faq":"FAQ","chat-attention":"We help you in our <u>support chat</u>","camera":"Camera","microphone":"Microphone","back":"Back","contact-by-chat-tech-problems":"Do you need technical support? \nWe serve you in our chat","errors":{"SESSION_INVALID":"The session identifier is not valid.","OT_AUTHENTICATION_ERROR":"There has been an error connecting to your video consultation. \nCheck the 6 character code for your session.","OT_HARDWARE_UNAVAILABLE":"We cannot access your camera or microphone. \nCheck that they are not being used in another application.","OT_MEDIA_ERR_NETWORK":"A connection error has occurred. \nCheck your current internet connection.","OT_NO_DEVICES_FOUND":"No valid device found to start video consultation. \nCheck that your camera and / or microphone are working properly.","OT_USER_MEDIA_ACCESS_DENIED":"You need to grant permissions to the application to use your camera and / or microphone and be able to carry out the session.","VideoSessionNoLongerAccessibleException":{"msg":"We are sorry but your video consultation was scheduled for {date}. \nRemember that you can access the session up to 30 minutes before the specified time.","title":"Past video consultation","msg_professional":"We are sorry but your video consultation was scheduled for {date}. \nRemember that you will be able to access the session once the patient has started it.","title_professional":"Past video consultation"},"VideoSessionFinishedException":{"msg":"Your video consultation has ended. \nIf you are waiting for a report and / or prescription, you can access the information of your query in Opensalud.","title":"Video consultation finished","msg_professional":"The video consultation has ended. \nRemember to fill in the report and / or recipe if you specified it at the end of the session.","title_professional":"Video consultation finished"},"PaymentNotFoundException":{"msg":"Your video consultation has not been paid yet.","title":"Unpaid video consultation","msg_professional":"The video consultation has not yet been paid.","title_professional":"Unpaid video consultation"},"VideoSessionExpiredException":{"msg":"We are sorry, but your video consultation has expired or was canceled before taking place. \nIf you need more information, contact us.","title":"Video consultation expired / canceled","msg_professional":"We are sorry but the video consultation has expired or was canceled before taking place. <br> If you need more information contact us.","title_professional":"Video consultation expired / canceled"},"VideoSessionFinishedWithReportException":{"msg":"Your video consultation has ended and the professional has already issued the report and / or prescription. \nYou can access this information at Opensalud.","title":"Video consultation finished","msg_professional":"The video consultation has now ended. \nYou can review all the information of this consultation in Opensalud.","title_professional":"Video consultation finished"},"VideoSessionNotYetAccessibleException":{"msg":"We are sorry but your video consultation is scheduled for {date}. \nRemember that you can access the session up to 30 minutes before the specified time.","title":"Scheduled video consultation","msg_professional":"We are sorry but the video consultation is scheduled for {date}. \nRemember that you will be able to access the session once the patient has started it.","title_professional":"Scheduled video consultation"},"VideoSessionWaitingReportException":{"msg":"Your video consultation has ended. \nYou will be notified in the next few hours when the professional completes your report and / or prescription.","title":"Awaiting information from the professional","msg_professional":"The video consultation has now ended. \nRemember to fill in the report and / or prescription in Opensalud.","title_professional":"Video consultation finished"},"error-has-ocurred":"An error has occurred. \nPlease try again in a few minutes or contact support if the error persists."},"hide-detailed-error":"Hide more information","show-detailed-error":"Show more information","dialog-title-pressToInitVideoTest":"Press to start the test","dialog-title-resultVideoTest":"Test result","dialog-title-presentation":"This test will let you know if you have the right devices to make a video consultation.","dialog-title-minimumRequisitesVideoTest":"Sorry, but you have not the minimum requirements.","dialog_title_tabOneVideoTest":"1. Permissions","retry-init":"Start again","needValidTokenVideoTest":"You need a valid session to start the test.","no-documents-found":"No available documents were found in this consultation.","select-or-drag-drop-file":"Choose a file or drop it here...","drag-drop-file":"Drop file here...","browse":"Browse","upload-files":"Upload files","select-file-type":"Select file type","file-type":"Type","go-to-consultation":"Go to my query","pay-consultation":"Pay consultation","at-time":"at","dialog-text1-tab1-VdeoTest":"You need grant permission to the application to use your camera and microphone in order to perform the session. These permissions can be revoked at any time.","dialog-text2-tab1-VideoTest":"Not allowing the use of the camera and microphone you will not be able to perform video consultations. Restart the test if you want to grant permissions.","grant-permissions":"Grant permissions","request-permissions":"Request permissions","devices":"2. Devices","network":"3. Network","dialog-title-waitingSession":"Please wait, checking the session","checkingDevices":"Checking devices","dialog-button-waitingTest":"Please, wait until test is done","dialog-button-go-to-session":"Go to the video consultation","video-quality":"Video quality","audio-quality":"Audio quality","dialog-title-overalRatingVideoTest":"Overal rating","test-result":{"Bad":"Bad","Poor":"Poor","Fair":"Fair","Good":"Good","Excellent":"Excellent"},"dialog-title-speedTest":"Network test","test-center-image-and-audio":"Make sure that your image is centered and that the microphone indicator moves when you speak.","video-device":"Video device","audio-device":"Audio device","title-result-test-ok":"Your system can perform video consultations","tittle-resulta-test-ko":"It is recommended not to make video consultations with this system","subtitle-result-test-ko":"Please check your internet connection. If you are connected by wifi, make sure you are close to it and have no other devices connected.","test-requisites":"Check that your camera and microphone are active. If your system is IOS check that your version is higher than 12.1.","page-not-found":"Page not found","videosession-end-caption":"Your video consultation is scheduled to end on about {date}. \nThis duration is indicative and may differ from the time that your session finally lasts.","timer-end":"End: {date}","loading-videosession":"Loading Video Session ...","support-chat":"Support Chat","login":{"server-error":"An error has occurred. \nPlease try again later.","email":"E-mail","errors":{"email":"Invalid email.","password":"Incorrect password","password-different":"Oops! \nPasswords don't seem to match","password-constraints":"Your password must be at least 8 characters long and contain an uppercase, lowercase, some number, as well as some special character","Disabled":"Your account is disabled. \nContact us if you think this is an error.","Inactive":"More than six months have passed without us having registered activity on your user. \nFor security reasons we have sent an email to the email address associated with your account so that you can re-enable your account.","PasswordMaxAttemptsExceeded":"Because you have logged in several times unsuccessfully, the account will now be locked for a few moments.<br>Please log in again after a few minutes.","PasswordUpdateNeeded":"For security reasons your password needs to be updated. \nWe have sent an email to the email address associated with your account to change your password.","twoFACode":"Invalid verification code. \nCheck it out.","UserLockedException":"We're sorry, but your account has been locked.<br>If you think it is a mistake, please send an email to info@opensalud.es","AuthenticationException":"Incorrect email and/or password","EmailConfirmationException":"Your account has not yet been activated. Please check your email and follow the instructions to activate your account.","ConfirmationEmailExpiredException":"Your account has not yet been activated. We have sent a confirmation email to your email address again.","TwoFactorCodeCommunicationException":"We have not been able to send you the verification code. Please try again later."},"password":"Password","sign-in":"Log in","forget-password":"Forgot your password?","with-dnie":"Login with digital certificate","password-repeat":"Repeat your new password","twoFACode":"Enter the code you received by email and/or WhatsApp","already-signed-in":"Already registered?","new-user":"Are you a new user?","register-now":"Create an account now to enjoy all our advantages!","iam-professional":"I am a professional","iam-patient":"I am a patient","iam-centre":"I am a center","iam-lawyer":"I am a lawyer","iam-client":"I am a client","iam-lawfirm":"I am a law firm","aca-sign-in":"Log in with ACA card","dialog-lawyer":"Currently, registration is only possible by invitation, for which you will need to include the code received."},"invalid-credentials":"Incorrect username or password","reenable-account":"Enable account","account-reenable-success":"Your account has been reactivated. \nClick on the following link to log in:","account-reenable-fail":"Your account could not be reactivated. \nPlease check the link again or, if you wish, log in again to receive a new account recovery email.","send":"Send","error":{"try-again":"An error has occurred. \nTry it again later."},"resend-account-enable-email-success":"For security reasons your account has been deactivated. \nWe have sent an email to reactivate your account to {email}.","log-in":"Log in","newpassword-success":"Your password has been successfully updated. \nClick here to log in:","change-password":"Change Password","new-password":{"constraints":"For your password to be secure, it is essential that it has more than 8 characters and contains at least one uppercase, one lowercase, a number and some special character"},"recover-password":{"title":"Recover password","instructions":"If you have forgotten your password, we will send you an email to the email address entered with a link to retrieve it.","success":"We have sent an email to the address entered where you will find a link to reset your password."},"name":"Name","surname":"Surnames","phone":"Phone number","national-identity-document":"No. doc. \nof identity","signup-success":"You have been successfully registered in Opensalud. \nYou will receive in your email the instructions to confirm your account and access the platform.","signup-unsuccessful":"An error has occurred during your registration. \nTry it again later.","sign-up":"Sign up","professional":"Professional","patient":"Patient","center":"Center","select-an-option":"Type of user","telemedcare-account-association":"Your account at Telemedcare","telemedcare":{"association":{"step-1":"<b>Step 1.</b> Download the 'TMC Blue' app on your smartphone or tablet:","step-2":"<b>Step {step}.</b> Launch the app you just downloaded and scan the QR code below.","step-4":"<b>Step {step}.</b> Turn on the medical device(s) you need for the measurements you are going to take and check that they are enabled on your smartphone/tablet.","step-5":"<b>Step {step}.</b> Take the measurements you need as many times as you need.","step-3":"<b> Step {step}. </b> Activate Bluetooth and enable location.","step-2-installed":"<b>Step {step}.</b> Start the application.","clinic-history":"Remember that you can consult all the measurements from the Telemedcare application or from your clinical history in Opensalud."},"access-portal":"Go to clinic history","no-tmc-token-found":"You do not have permission to access this page. \nPlease log in again.","is-first-access":"Is this the first time you are accessing the telemonitoring service or do you need to pair your device again?"},"button":{"get-on-google-play":"/static-appopensalud/img/get-on-play-store.png","get-on-app-store":"/static-appopensalud/img/available-app-store.png"},"continue-with-certificate":"Continue with digital certificate","yes":"Yes","hang-up-video":"End video consultation","dialog":{"ok-button":"Accept","cancel-button":"Cancel"},"base":{"errors":{"unauthorized":{"title":"Unauthorized access","message":"You do not have permission to access this page.","sign-in-again":"You can log in again to access this page.","message360":"We are sorry but your profile cannot access the conditions of opensalud360. \nIf you wish, you can request the services with the professional of your choice at the price set by the professional."},"basic-error":"An error has occurred","unauthorized-360-error-page":{"go-to-opensalud":"Log in to Opensalud"},"unauthozed-travel-error-page":{"new-code":"New certificate/reservation number or code","new-reservation-number":"New certificate/reservation number","new-start-date":"Entry date","new-end-date":"Departure date","code-required":"Enter a certificate/reservation number or code","reservation-number-required":"Enter a certificate/reservation number","start-date-required":"Invalid stay interval","server-error":"An error has occurred. \nPlease check your reservation/certificate number and/or code or try again later. \nIf you need help, you can contact us through the support chat."}}},"video":{"connecting":"Connecting with the patient","wait-connecting-patient":"Please wait while we connect you with your patient. \nThis process will not take more than 1 minute.","hang-up-are-you-sure-question":"Are you sure you want to end the consultation?","on-client-disconnected":"The connection has been lost, wait a few moments for the system to try to automatically recover the session.","new-device-connected":"An audio or video device has been connected/disconnected. \nTo change devices use the selectors/switches on the side menu."},"consolidate-modal":{"title":"The consultation has ended","charge-with-data":"Charge for consultation with the following data:"},"no":"No","consolidate-appointment-modal":{"select-billable-entity":"Select invoicing entity","no-charge":"Do not charge for this consultation","select-no-charge-reason":"Select a reason","must-select-billable-entity":"You must select Billing Entity","must-specify-not-charge-reason":"You must select a reason for not charging this consultation"},"base-select":{"select-option":"Please select an option ...","noOptions":"No results found","errorMsg":"Select an option"},"menttum-proxy-view":{"title":{"question":"Hi {name}, what do you need?"}},"menttum":{"request-consultation-title":"Request a consultation ...","video-consultation":"Request video therapy session","chat-consultation":"Contact the psychologist with chat","wellness-services":"Access wellness platform","wellness":"Wellness","webapp":"Access my profile","appointment-dialog-msg":"You can then select the psychologist who will attend you. <br> Psychologists are ordered according to your needs or preferences.","webapp-dialog-msg":"In this screen you will be able to access your sessions and consultations both in Menttum and in opensalud.","hire-package":"Hire package","hire":"Contract","included-services":"Included services","hire-package-msg":"You do not have any active packages. \nTo request video or chat with a psychologist you need to first hire one of the following packages.","self-evaluation":"Evaluate your health"},"signup-title":"Sign up","login-wrd":"Log in","login-wrd-session":"Start session","welcomeOH":"Welcome to","profConditions-link":"Conditions for professionals","patConditions-link":"Conditions for patients","telemedicineCompanies-link":"Health and well-being for companies","contact-link":"Contact","legalNotice-link":"Legal notice and Cookies","questions-link":"Frequently asked questions","lastUpdate":"Latest update","signupOH":{"joinUsers":"User subscription","registerCodeEnt":"CODE INDICATED BY YOUR COMPANY","registerCodeEntInfo":"(ONLY IF IT HAS BEEN PROVIDED TO YOU)","selectLanguageTxt":"Select the languages you speak","registerName":"Name","registerSurname1":"FIRST SURNAME","registerSurname2":"SECOND SURNAME","genderSex":"SEX","man":"Man","woman":"Woman","country":"COUNTRY","registerYourProvince":"Province/State/Region","registerNIF":"NIF (DNI/NIE/CIF)","registerEmail":"email address","confirmEmail":"confirm email address","birthdate":"date of birth (mm/dd/yyyy)","registerPhoneNumber":"phone number","registerPhonePrefix":"Prefix","readAccept":"I have read and accept","alreadyRegistered":"If you are already registered,","loginn":"log in","signup-submit":"Register","errors":{"enterCode":"Please enter a valid code","enterLang":"Please select at least one language","enterName":"Please enter a first name","enterSurname1":"Please enter a first surname","enterSurname2":"Please enter a second surname","enterSex":"Please select a gender","enterCountry":"Select the country","enterProvince":"Enter Province/State/Region","enterNIF":"Enter a NIF (DNI/NIE/CIF)","enterEmail":"Enter the email address","enterConfirmEmail":"Confirm the email","enterBirthdate":"Enter a birthdate","enterPhonePrefix":"Select a prefix","enterPhoneNumber":"Enter a phone number","reservation-number":"Enter a reservation number","certificate-number":"Enter a certificate number","client-number":"Enter a client number","center-or-business-unit":"Select a center or business unit","employee-number":"Enter your internal code (employee number)","general-code":"The data entered is not valid. \nPlease review them and try again. \nIf you need help, you can contact us through the support chat.","sameEmails":"The emails must be identical","enterSpeciality":"Select specialty","enterCollegeNumber":"Enter your Colleagiate Number","enterSanitaryRegister":"Enter the health registration number","enterNameEducativeCenter":"Please enter a name of an educational center","enterCollegeNumberMaxValue":"You have selected a medical specialty, the membership number must be 9 digits","captcha":"The captcha was not completed correctly","termsAccepted":"You must accept the legal terms and conditions in order to register on the platform.","privacyAccepted":"You must accept the privacy politic in order to register on the platform.","dataVerification":"You must accept the verification of your data with the official school in order to register on the platform.","enterCentreName":"Please fill in the name of the center","enterDiscoveryType":"Please select how you heard about us","enterUrlBlog":"Please enter the URL of your website or blog","enterExperienceProf":"Enter your professional experience","enterProvinceCollegiate":"Enter your province of collegiate","birthdateMore18":"You must be of legal age to register","urlProf":"You must enter a valid URL","enterDay":"Enter a day of birth","enterMonth":"Enter a month of birth","enterYear":"Enter a year of birth","birthdateMustBeReal":"You must type a real date","enterCollegeNumberMaxValueMx":"The professional certificates of doctors are from 5 characters","enterIdentity":"Please enter a valid ID","enterIdentityChoice":"You must select one of the options","employeeLocation":"You must enter a location","internal-code":"Enter your internal code","duplicatedNIF":"There is already a registered user with that identity document","enterCURP":"Enter an CURP","enterID":"Enter a Personal ID","required-employee-number":"Please fill employee number"},"accept-terms":"I have read and accept the <a target=\"_blank\" href='/terminos-condiciones-profesional'>terms and legal conditions.</a>","accept-privacy":"I have read and accept the <a target=\"_blank\" href='/politica-privacidad-profesional'>privacy politic.</a>","accept-privacy-patient":"I have read and accept the <a target=\"_blank\" href='/politica-privacidad'>privacy politic.</a>","reservation-number":"Reservation number","reservation-number-or-code":"Reservation number or code","certificate-number-or-code":"Certificate number or code","certificate-number":"Certificate number","generic-code":"Generic code","checkin-date":"Check-in date (mm/dd/yyyy)","checkout-date":"Check-out date (mm/dd/yyyy)","code-provided-by-msm":"Code provided by MSM HR","client-number":"Client number","center-or-business-unit":"Business center or unit","employee-number":"Employee number","info":{"reservationNumber":{"ConectaTSalud":"Hello, to sign up for the health service you must enter your code CNTxxxxxxxx that ConectaT has provided. If you do not have it, you must request it through the email info@conecta-t.es"}},"account-confirmation":"An email has been sent to {email} to verify your identity. Please check your mailbox and follow the instructions. \n<br><br>If after a few minutes you haven't received it, check your junk/spam folder.<br><br>Remember that you have 72 hours to confirm this email. \nIf you have any problems, you can contact us at <b>info@opensalud.es</b>","account-confirmation-openlegal":"An email has been sent to {email} to verify your identity. Please check your mailbox and follow the instructions. \n<br><br>If after a few minutes you haven't received it, check your junk/spam folder.<br><br>Remember that you have 72 hours to confirm this email. \nIf you have any problems, you can contact us at <b>hola@openlegal.com</b>","birthDate":"Birthdate","selectDiscovery":"How did you meet us?","modalSuccessull":"Registration information","modal1":"An email has been sent to","modal2":"to verify your identity, in addition to a Whatsapp if you have entered a phone number. <br>Please check your mailbox and follow the instructions.","modal3":"If after a few minutes you haven't received it, check your spam/junk mail folder.","modal4":"Remember that you have <b>72 hours</b> to confirm this email. If you have any problems you can contact us through <b>info@opensalud.es</b> \n","modal4-openlegal":"Remember that you have <b>72 hours</b> to confirm this email. If you have any problems you can contact us through <b>hola@openlegal.com</b> \n","agree":"In agreement","specialty":"SPECIALTY","collegeProvince":"Province of collegiate","registerCollegeNumber":"Collegiate number","experienceProfessional":"Experience (min. 5 years)","urlProfessional":"Web/blog URL (https://..)","withoutLocation":"No physical location","registerNameCenter":"Name of the centre","registerSanitaryRegister":"Health registration number","registerNameEducativeCenter":"Name of the Educational Center","modalBusiness":"The code you have used corresponds to the opensalud360 service.","modalBusiness2":"Click on continue to register in opensalud360.","continue":"Continue","cancel":"Cancel","registerCodeEntProf":"Code (only if provided)","accept-terms-patient":"I have read and accept the <a target=\"_blank\" href='/terminos-condiciones-paciente'>terms and legal conditions.</a>","data-verefication":"I authorize the verification of my data with the official school.","no-options":"Sorry, there is no matching option","dayBirth":"Day","monthBirth":"Month","yearBirth":"Year","indentitydocument":"IDENTITY DOC.","university":"University issuing your degree","invalidDate":"Please enter a valid date of birth","justIndicatedByBusiness":"Only if it has been provided by your company","registerNameCenterResidence":"name of the center/residence","employeeLocation":"Location","internal-code":"Internal Code (employee number)","enterCURP":"CURP","enterId":"Personal ID"},"genderMale":"M","genderFemale":"F","wellness":"Wellness","webapp":"Access my profile and appointments","refresh-label":"Refresh page","reconnectingProfessional":"Please wait while we reconnect with the professional ...","swap-cameras-mobile-rear":"Switch to rear camera","swap-cameras-mobile-front":"Switch to front camera","stethoscope-refresh":"If your doctor tells you that you can't hear your stethoscope, tap the update button (like the one below) at the bottom of the screen.","appointment-info":{"date":"Date and Time","disease":"Illness or symptom","reason":"Reason for consultation"},"appointment-notes":{"notes":"Appointment notes","patientNotes":"Notes about the patient","invisible-for-patient":"Remember that this information will remain hidden from the patient","write-here":"Type here...","last-update":"Last modification:"},"table":{"no-results":"No results found","pagination":{"label":"Items displayed {firstOfPage} - {lastOfPage} of {totalItems}"}},"date":"Date","history":{"variables":"Health variables"},"base-input":{"placeholder":"Type here...","errorMsg":"Check the data entered"},"payments-gateway":{"title":"Payments gateway"},"selectMonth":"Select month","selectYear":"Select year","month":"Month","year":"Year","5MinutesAdvice":"We inform you that in 5 minutes the session will expire and you will not be able to carry out any transaction.","add-btn":"Add","select-birthdate":"select your date of birth","signUp":{"already-registered":"If you are already registered"},"sign-up-href":"log in","terms-and-conditions":"Terms and Conditions","report":{"reason":"Reason for consultation","history":"Current history","treatment":"Treatment","diagnosis":"Diagnosis"},"uploaded-successfully":"File uploaded successfully","nodofarma":{"treatment":{"observations":"Comments"}},"legal-services":"legal","more-info":"More info","signupDiscovery":{"title1":"Professional recommendation","title2":"Patient recommendation","title3":"Center recommendation","title4":"Web/Internet search","title5":"Social networks","title7":"Press","title8":"Radio","title9":"TV","title10":"Others","title11":"Phone call","title2-openlegal":"Client recommendation","title3-openlegal":"Office/law firm recommendation","title1-openlegal":"Lawyer recommendation"},"emailRegistered":"Email already registered","insurances":"Insurers","linkCopiedClipboard":"The link has been copied successfully","saved":"Saved","changesPerformedCorrectly":"Changes made successfully","logOff":"Log off","logIn":"Log in","search":"Search","ago":"ago","hours":"hours","days":"days","months":"months","years":"years","minutes":"minutes","seconds":"seconds","answer":"Answer","loginTitle":"Log in","defaultErrorMessage":"An error has occurred. \nContact opensalud.","video-test":{"adblock-error":"An ad blocker has been detected in your browser. \nTo ensure that the video consultation takes place correctly, please deactivate it and click on the button below."},"openlegal":{"title":"We are here to help you.","title1":"We are here to help you"},"specialties":"Specialties","services":"Services","sign-up-professional":"Registration for professionals","sign-up-patient":"Patient Registration","sign-up-centre":"Registration for centers","terms-and-conditions-patient":"Patient Terms and Conditions","terms-and-conditions-professional":"Professional Terms and Conditions","legal-warning":"Legal warning","contact-title":"Contact","faqs-title":"Help Center","terms-conditions":"terms and conditions","contact":"Contact","legal-notice":"Legal notice and cookies","faqs":"Frequently asked questions","cookies-policy":"Cookies policy","show":"show","myProfile":"My profile","myFavourites":"My favourites","close":"Close","loginError":"Email or password are incorrect","pregunta-1":"Test question","price":"Price","patient-title":"OpenSalud: Medical consultations and the most complete health and well -being application","business-title":"Digital Health for Companies","invalidPromotionCode":"The code you have entered is not valid","error-required":"You must select an option","services-title":{"type-one":"Consultation","type-two":"Scheduled Video Consultation","type-three":"Chat","type-four":"Written Consultation","type-five":"Immediate Video Consultation","type-six":"Home Visit","type-seven":"Second Opinion","type-eight":"Service Packages","type-nine":"Flat Rate Written Consultation and Chat","type-eleven":"Consultation by insurer","type-ten":"A professional calls you"},"label-specialties":"labelEn","invalid-2facode":"The code is invalid","account":{"register-ok":"Registration successful","set-email":"Set email"},"access":"To access","menu-opt":"Menu","edit":"Edit","doubts":"Doubts","videoTest":"Video test","signupMonth":{"january":"January","february":"February","march":"March","april":"April","may":"May","june":"June","july":"July","august":"August","september":"September","october":"October","november":"November","december":"December"},"sign-up-customer":"Client registration","sign-up-lawyer":"Lawyer registration","save":"Keep","question":"Ask","unit":"Unit","goal":"Goal","reminder":"Reminder","notes":"Notes","optional":"(optional)","edited":"Edited","setting":"Setting","orderBy":"Sort by...","chronological":"Chronological","color":"Color","score":"Score","ascending":"Upward","descending":"Falling","description":"Description","calendar":"Calendar","notificationsEmail":"Email notifications","notificationsPhone":"notification phone","between":"between","and":"and","error-alreadyregister":"An error has occurred in your registration, please check your fields.<br> \nRemember that if you are registered in openlegal you will be able to access opensalud using the same credentials.","error-alreadyregister-openlegal":"An error has occurred in your registration, please check your fields.<br> \nRemember that if you are registered in opensalud you will be able to access openlegal using the same credentials.","aca-error-title-page":"An error has occurred with your ACA card","aca-error-detail-page":"There seems to be a problem with your ACA card certificate, please try again later or contact our technical support.","access-verb":"To access","update":"Update","error-checkextension":"Check that the email and code entered are correct. \nIf the error persists contact the support chat located in the lower right corner.","error-checkemployeenumber":"The data entered is invalid. \nPlease check the entered employee number.","a2hs":{"modal-message":"Do you want to install the {platform} application?","modal-install-btn":"Install","safari-tooltip":"To install this webapp on your iPhone/iPad, click on the {shareIconImg} icon in your device's browser menu and select the 'Add to home screen' option."},"error-checkinternalcode":"The data entered is not valid. \nPlease review the internal code entered.","error-checkemployeenumber2":"The data entered is not valid. \nPlease review the internal code entered and make sure that your spouse is registered on the platform.","bnpMSG":"We inform you that your company will only be informed of your registration on the platform and never of your use of it.","bnpMSG2":"If you continue with the registration we understand that you grant your consent.","dontShowAgain":"Do not show again","enterValue":"Enter a value","finish":"Finish","value":"Value","httpRequestDefaultError":"An error occurred while processing your request. \nPlease contact our technical team via support chat","soon":"soon","create":"Create","undefined":"Indefinite","floor":"floor","changeUser":"Change user","complete":"Complete","datepicker-ph":"Select a date","labelNoDateSelected":"You have not selected any date","current-month":"Current month","next-year":"Next year","next-month":"Next month","prev-year":"Last year","prev-month":"Last month","next-decade":"Next decade","prev-decade":"Previous decade","date-picker":{"must-select-date-before-now":"You must select a date before the current one"},"selected-date":"Selected date","reset":"Restore","noMatchingElements":"There are no elements that match the selected filter","recipients":"Recipients","chart":{"moreRecent":"More recent","lessRecent":"Less recent"},"day":"Day","change-user":{"select-user":"Select a user...","error-select-user":"Please select the user you want to change to"},"hide":"Hide","details":"Details","remove":"Remove","select":"Select","type":"type","frequency":"Frequency","next":"Next","insurance":"Insurance carrier","single":"Particular","text-code-group":"In accordance with the commitments signed between Open Healthcare/opensalud and Unipromel and Irelegal, as it is already included in the opensalud database, if you wish, you can access the various services provided by opensalud (clinical software, medical chart, directory... ) under preferential conditions. \nWe remind you that Open Healthcare/ opensalud has its information security management system certified by ISO27001 and has also been validated by the Collegiate Medical Organization.","text-code-group-main":"I authorize the verification of my membership in Unipromel and the communication to Unipromel of the data related to registration in the medical chart and directory.","errorMessages":{"only-subscribed-users":"Service for subscribers only."},"appointmentState":{"noConfirmed":"Not confirmed","scheduled":"Scheduled"},"hideLowercase":"hide","modify":"Modify","review":"Review","invoice":"Bill","from":"from","to":"to","confirm":"Confirm","defaultSuccessMessage":"The operation has been carried out successfully","see":"See","showMoreOptions":"More options...","lang":"Language","centers":"Centers","notifications":{"appointmentCanceledByProf":"The professional {profName} {title} {appointmentType} of {date}","hasCanceled":"has canceled his","hasScheduled":"has scheduled one"},"soon-label":"Soon","know-more":"Learn more","location":"City","showOptions":"Options...","prescriptions":"Prescriptions","hour":"Hour","address":"Address","country":"Country","state":"Province","city":"City","startDate":"Start date","endDate":"End date","schedule":"Schedule","filtersTitle":"Filters","completed":"Filled","error-professionalregistered":"An error has occurred in your registration, please check your fields.","forMe":"For me","forMinor":"For minor patient","forPet":"For pet","understood":"Understood","prefix":"Prefix","phoneShort":"Phone","package":"Package","duration":"Duration","hire":"Hire","open":"Open","closed":"Closed"}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = {"continue-with-certificate":"Continuar con certificado digital","dialog":{"ok-button":"Aceptar","cancel-button":"Cancelar"},"base":{"errors":{"unauthorized":{"title":"Acceso no autorizado","message":"No tiene permisos suficientes para acceder a esta página."},"basic-error":"Ha oocurrido un error"}},"video":{"connecting":"Conectando con el paciente","wait-connecting-patient":"Espere mientras le conectamos con su paciente. Este proceso no tardará más de 1 minuto.","hang-up-are-you-sure-question":"¿Está seguro de que desea finalizar la consulta?"},"consolidate-modal":{"title":"La consulta ha finalizado","charge-with-data":"Cobrar consulta con los siguientes datos:"},"no":"No","consolidate-appointment-modal":{"select-billable-entity":"Seleccione entidad de facturación","no-charge":"No cobrar esta consulta","select-no-charge-reason":"Seleccione el motivo"},"base-select":{"select-option":"Seleccione una opción..."},"menttum-proxy-view":{"title":{"question":"Hola {name}, ¿qué necesitas?"}},"menttum":{"request-consultation-title":"Pedir una consulta...","video-consultation":"Solicitar sesión de terapia por vídeo","chat-consultation":"Contactar con el psicólogo por chat","wellness-services":"Acceder a plataforma de bienestar","wellness":"Wellness"},"signup":"Regístrate","login-wrd":"Acceder","login-wrd-session":"Inicia sesión","welcomeOH":"Bienvenido a","landing-openhealth":{"title-big-1":"Queremos cuidar<br>de ti, siempre","title-big-2":"¿Qué ventajas ofrece opensalud 360?","title-big-3":"¿Cómo<br>funciona?","title-big-3-sm":"¿Cómo funciona?","title-big-4":"Contáctanos","title-small-1":"Una plataforma de salud","title-small-2":"Sin esperas,<br>estés donde estés","title-small-3":"Comodidad y<br>seguridad","title-small-4":"Cuidar tu salud y la de<br>tu familia","title-small-5":"Regístrate en openhealth","title-small-6":"Inicia sesión y elige el servicio","title-small-7":"Indica el motivo de tu consulta","title-small-8":"Accede al profesional","text-1":"opensalud 360 es una plataforma de salud para personas,<br>empresas y colectivos, que permite a sus usuarios acceder<br>a los mejores profesionales de la salud, en cualquier<br>momento y desde cualquier lugar.","text-1-sm":"opensalud 360 es una plataforma de salud para personas,empresas y colectivos, que permite a sus usuarios acceder a los mejores profesionales de la salud, en cualquier momento y desde cualquier lugar.","text-2":"En tu hogar, lugar de trabajo o incluso<br>un hotel, accede por video, teléfono o<br>chat a algunos de los mejores<br>especialistas de España.","text-3":"Evita riesgos y molestias, limitando los<br>desplazamientos a centros médicos,<br>urgencias... Podrás recibir incluso tu<br>receta en formato digital.","text-4":"Posponer visitas al médico o no realizar<br>un adecuado seguimiento por falta de<br>tiempo... Puede producir un grave<br>deterioro de tu salud.","text-5":"Incluye el código, número de póliza o reserva facilitado","text-6":"Selecciona el servicio y el profesional que necesitas utilizando el buscador","text-7":"Añade algunos datos de salud, adjuntando si lo deseas imágenes o informes","text-8":"Recibe tu informe y prescripción. Al finalizar podrás valorar el servicio","text-9":"Si quieres que tus empleados o clientes accedan a los mejores<br>servicios de salud digital (40 especialidades médicas, psicología<br>y nutrición) contáctanos.","text-9-sm":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos."},"profConditions-link":"Condiciones para profesionales","patConditions-link":"Condiciones para pacientes","telemedicineCompanies-link":"Salud y bienestar para empresas","contact-link":"Contacto","legal-warning":"Aviso legal y cookies","legal-notice":"Aviso legal y cookies","questions-link":"Preguntas frecuentes","lastUpdate":"Última actualización","signupOH":{"joinUsers":"Alta de usuarios","registerCodeEnt":"CÓDIGO INDICADO POR SU EMPRESA","registerCodeEntInfo":"(Sólo si se lo han proporcionado)","selectLanguageTxt":"Selecciona los idiomas que habla","registerName":"nombre","registerSurname1":"primer apellido","registerSurname2":"segundo apellido","genderSex":"Sexo","man":"Hombre","woman":"Mujer","country":"PAÍS","registerYourProvince":"Provincia/Estado/Región","registerNIF":"NIF (DNI/NIE/CIF)","registerEmail":"correo electrónico","confirmEmail":"confirmar correo electrónico","birthdate":"fecha de nacimiento (dd/mm/aaaa)","registerPhoneNumber":"teléfono móvil","registerPhonePrefix":"Prefijo","readAccept":"He leído y acepto","alreadyRegistered":"Si ya estás registrado,","loginn":"inicia sesión","signup-submit":"Registrarse","errors":{"enterCode":"Por favor, introduzca su código","enterLang":"Por favor, seleccione al menos un idioma","enterName":"Introduzca un nombre","enterSurname1":"Introduzca el primer apellido","enterSurname2":"Introduzca el segundo apellido","enterSex":"Selecciona el género","enterCountry":"Selecciona el país","enterProvince":"Introduzca Provincia/Estado/Región","enterNIF":"Introduzca un NIF (DNI/NIE/CIF)","enterEmail":"Introduzca un email","enterConfirmEmail":"Confirma el email","enterBirthdate":"Introduzca una fecha de nacimiento","enterPhonePrefix":"Selecciona un prefijo","enterPhoneNumber":"Introduzca un teléfono móvil","sameEmails":"Los emails deben de ser idénticos","enterSpeciality":"Seleccione especialidad","enterCollegeNumber":"Introduzca su Número de Colegiado","enterSanitaryRegister":"Introduzca el número de registro sanitario","enterNameEducativeCenter":"Por favor introduzca un nombre de un centro educativo","enterCURP":"Introduzca su CURP","enterID":"Introduzca un Id personal"},"birthDate":"Fecha de nacimiento","selectDiscovery":"¿Cómo nos ha conocido?","modalSuccessull":"Información de registro\n","modal1":"Se ha enviado un correo electrónico a","modal2":"para verificar su identidad, además de un Whatsapp si ha introducido número de teléfono. <br> Por favor consulte su buzón y siga las instrucciones.","modal3":"Si pasados unos minutos no lo ha recibido, compruebe su bandeja de correo no deseado / spam.","modal4":"Recuerde que dispone de <b>72 horas</b> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b>contactomx@opensalud.es</b> \n","modal4-openlegal":"Recuerde que dispone de <b>72 horas</b> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b>info@openlegal.com</b> \n","agree":"De acuerdo","specialty":"ESPECIALIDAD","collegeProvince":"Provincia de colegiación","registerCollegeNumber":"Número de colegiado","experienceProfessional":"Experiencia (min. 5 años)","urlProfessional":"URL web/blog (https://..)","withoutLocation":"Sin ubicación física","registerNameCenter":"Nombre del Centro","registerSanitaryRegister":"Número del Registro Sanitario","registerNameEducativeCenter":"Nombre del Centro Educativo","modalBusiness":"El código que ha utilizado corresponde al servicio opensalud360.","modalBusiness2":"Pulse en continuar para registrarse en opensalud360.","continue":"Continuar","cancel":"Cancelar","enterCURP":"CURP","enterId":"Personal ID"},"genderMale":"H","genderFemale":"M","wellness":"Wellness","webapp":"Acceder a mi perfil y consultas","appointment-dialog-msg":"A continuación podrás seleccionar al psicólogo que te atenderá.<br>Los psicólogos se ordenan de acuerdo con tus necesidades o preferencias. ","webapp-dialog-msg":"En esta pantalla podrás acceder a tus sesiones y consultas tanto en Menttum como en opensalud.","nodofarma":{"treatment":{"observations":"Observaciones"}},"signupDiscovery":{"title1":"Recomendación de profesional","title2":"Recomendación de paciente","title3":"Recomendación de centro","title4":"Web/Búsqueda en Internet","title5":"Redes sociales","title7":"Prensa","title8":"Radio","title9":"Televisión","title10":"Otros","title11":"Llamada telefónica"},"emailRegistered":"Email ya registrado","subtitle":"Si quieres que tu familia acceda a los mejores servicios de salud digiral, contáctanos.","specialties":"Especialidades","services":"Services"}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = {"welcome_message":"Bem vindo","pages":{"about":"Cerca de"},"menu-label-patient":"Paciente","professionals":"Profissionais","menu-health-information":"Histórico clínico","menu-notes":"Notas","menu-share-files":"Compartilhar arquivos","menu-end-session":"Terminar sessão","menu-chat":"Chats","menu-audio":"Áudio","menu-video":"Vídeo","menu-help":"Ajuda","menu-language":"Idioma","general-close":"Cerrar","waitingProfessionalHeader":"Sala de espera virtual","waitingProfessionalBody":"O profissional atenderá em alguns instantes. ","menu-video-quality-low":"Baixa qualidade","menu-mute-video":"Vídeo pausar","menu-video-quality-medium":"Mídia de qualidade","menu-video-quality-high":"Qualidade máxima","menu-title-video-quality":"Qualidade do vídeo","menu-title-video-advanced":"Avançado","menu-language-es":"Español","menu-language-en":"Inglês","menu-share-screen":"Compartir a tela","menu-mute-audio":"Pausar sonido","sessionNotValid":"A sessão de tentativa de acesso foi caducada ou não é válida","chat-placeholder":"Escrever sua mensagem...","needValidToken":"Necessita de uma sessão válida para iniciar a consulta.","dialog-title-error":"Erro","errorServerConnection":"Ocorreu um erro na conexão com o servidor.","errorTokenNotValid":"A sessão introduzida não está correta.","errorInvalidDate":"Você pode entrar na sala com no máximo 30 minutos de antecedência. ","errorVideoConnection":"Ocorreu um erro na sessão de vídeo. ","errorShareDevices":"É necessário que você conceda permissões ao aplicativo para usar sua câmera e seu microfone para poder levar a cabo a sessão.","dialog-title-videoTest":"Teste de vídeo","sessionEnded":"Sessão de vídeo finalizada","sessionEndedBody":"Sua sessão de videoconsulta foi finalizada. ","videoSession":"Sessão de vídeo","retry":"Voltar a tentar","returnToApp":"Voltar para Opensalud","menu":{"clinical_documents":"Documentos clínicos","history":"História clínica","devices":"Dispositivos","appointment-info":"Informações da consulta","summary":"Informações da consulta","notes":"Notas","change-user":"Mudar usuário","change-user-placeholder":"Selecione um usuário...","change-user-no-patients":"Você não tem nenhum usuário associado à sua conta principal. \nVocê pode registrar um em seu perfil clicando no botão abaixo.","change-user-create":"Cadastrar paciente associado","history-access":"Conceder acesso ao histórico"},"enable-stethoscope":"Estetoscópio","enable-lamp":"Lâmpada de exploração","cancel":"Cancelar","continue":"Continuar","stethoscope1":"Antes de continuar, certifique-se de que o estetoscópio esteja conectado ao seu equipamento e que esteja ligado.","manualteleexploracion-href":"http://docs.opensalud.es/ManualTeleExploracion","stethoscope2":"nossa guia.","stethoscope3":"Uma vez pressione em 'Continuar' o profissional deixará de ouvir pelo microfone principal e passará ao sinal do estetoscópio.","stethoscope4":"Você pode ativar o microfone principal quando quiser, simplesmente desconectando o estetoscópio do seu equipamento.","stethoscope5":"Antes de continuar, certifique-se de que você desconectou o estetoscópio do seu equipamento.","stethoscope6":"Uma vez, pressione 'Continuar' e o profissional deixará de ouvir o sinal do estetoscópio e passará para o microfone principal.","stethoscope7":"Você pode voltar a ativar o estetoscópio quando desejar.","lamp1":"Antes de continuar, certifique-se de que a lâmpada de exploração esteja conectada ao seu equipamento e que ela esteja acesa. <br><br>Uma vez, pressione 'Continuar' e o profissional deixará o verde da câmera e ativará a imagem da lâmpada.<br><br>Você pode ativar sua câmera quando desejar, simplesmente colocando a lâmpada na posição desligada e extraindo-a.<br><br>Se o médico indicar que não pode ser verdade, pressione o botão de atualização (como o que pode ser visto a seguir) que você encontra na parte inferior da tela.<br><br>Não extraia a lâmpada sem selecionar previamente a posição de apagado!","lamp2":"¡No extraiga la lamparina aún! ","itemsPerPage":"Elementos por página","ofLabel":"de","page":"página","all":"Todos","next-label":"Próximo","prev-label":"Anterior","file-name":"Documento","preview-file":"Ver","share-screen":"Compartilhar tela","stop-share-screen":"Deixe de compartilhar a tela","enable-mic":"Ativar microfone","mute-mic":"Silenciar microfone","enable-cam":"Habilitar câmera","disable-cam":"Desabilitar câmera","introduce-token":"Apresentando seu identificador de sessão","go-to-session":"Continuar","need-help":"Você precisa de ajuda?","try-refresh":"Se você não é um professor profissional, ou o profissional não pode ouvir ou ouvir, experimente <u><a href=\"#\" onclick=\"window.location.reload()\">recarregar a página</a></u>","faq":"Perguntas frequentes","chat-attention":"Te atendemos em nosso <u>bate-papo de suporte</u>","camera":"Câmara","microphone":"Microfone","errors":{"SESSION_INVALID":"O identificador da sessão introduzido não é válido.","OT_HARDWARE_UNAVAILABLE":"Não podemos acessar sua câmera ou microfone. ","OT_NO_DEVICES_FOUND":"Não foi encontrado nenhum dispositivo válido para iniciar a videoconsulta. ","OT_MEDIA_ERR_NETWORK":"Houve um erro de conexão. ","OT_AUTHENTICATION_ERROR":"Houve um erro de conexão em sua videoconsulta. ","OT_USER_MEDIA_ACCESS_DENIED":"É necessário que você conceda permissões ao aplicativo para usar sua câmera e/ou microfone e poder levar a cabo a sessão.","PaymentNotFoundException":{"title":"Videoconsulta não pagada","title_professional":"Videoconsulta não pagada","msg":"Sua videoconsulta ainda não foi paga.","msg_professional":"A videoconsulta ainda não foi paga."},"VideoSessionNotYetAccessibleException":{"title":"Videoconsulta programada","msg":"Lamentamos, mas sua videoconsulta está programada para {data}. ","title_professional":"Videoconsulta programada","msg_professional":"Lamentamos, mas a videoconsulta está programada para {data}. "},"VideoSessionNoLongerAccessibleException":{"title":"Videoconsulta passada","msg":"Lamentamos, mas sua videoconsulta foi programada para {data}. ","title_professional":"Videoconsulta passada","msg_professional":"Lamentamos, mas sua videoconsulta foi programada para {data}. "},"VideoSessionFinishedException":{"title":"Videoconsulta finalizada","msg":"Sua videoconsulta foi finalizada. ","title_professional":"Videoconsulta finalizada","msg_professional":"A videoconsulta foi finalizada. "},"VideoSessionExpiredException":{"title":"Videoconsulta caducada/cancelada","msg":"Lamentamos, mas sua videoconsulta foi caducada ou cancelada antes de voltar ao cabo.<br> Se precisar de mais informações, entre em contato conosco.","title_professional":"Videoconsulta caducada/cancelada","msg_professional":"Lamentamos, mas a videoconsulta foi caducada ou cancelada antes de voltar ao cabo.<br> Se precisar de mais informações, entre em contato conosco."},"VideoSessionFinishedWithReportException":{"title":"Videoconsulta finalizada","msg":"Sua videoconsulta foi finalizada e o profissional emitiu o relatório e/ou a receita. ","title_professional":"Videoconsulta finalizada","msg_professional":"A videoconsulta já foi finalizada. "},"VideoSessionWaitingReportException":{"title":"Espera de informações do profissional","msg":"Sua videoconsulta foi finalizada. ","title_professional":"Videoconsulta finalizada","msg_professional":"A videoconsulta já foi finalizada. "},"error-has-ocurred":"Ocorreu um erro. \nTente novamente em alguns minutos ou entre em contato com o suporte se o erro persistir."},"show-detailed-error":"Mostrar mais informações","hide-detailed-error":"Ocultar mais informações","contact-by-chat-tech-problems":"Você precisa de suporte técnico? ","back":"Voltar","dialog-title-pressToInitVideoTest":"Pulso para iniciar o teste","dialog-title-resultVideoTest":"Resultado do teste","dialog-title-presentation":"Esta tentativa permitirá que você saiba se possui as medidas adequadas para realizar uma videoconsulta.","dialog-title-minimumRequisitesVideoTest":"Sentimos, mas não cumprimos os requisitos mínimos.","dialog_title_tabOneVideoTest":"1. Permissões","retry-init":"Voltar a iniciar","needValidTokenVideoTest":"Necessita de uma sessão válida para iniciar o teste.","no-documents-found":"Não foram encontrados documentos disponíveis nesta consulta.","select-or-drag-drop-file":"Subir arquivo...","drag-drop-file":"Arraste um arquivo aqui","browse":"Buscar","upload-files":"Subir arquivos","select-file-type":"Selecione o tipo de arquivo","file-type":"Tipo","go-to-consultation":"Ir a minha consulta","pay-consultation":"Consulta de pagamento","at-time":"uma vez","dialog-text1-tab1-VdeoTest":"É necessário que você conceda permissões ao aplicativo para usar sua câmera e seu microfone para poder levar a cabo a sessão. ","dialog-text2-tab1-VideoTest":"Se não permitir o uso da câmera e do microfone, você não poderá realizar consultas de vídeo. ","grant-permissions":"Conceder permissões","request-permissions":"Solicitar permissões","devices":"2. Dispositivos","network":"3. Conexão","dialog-title-waitingSession":"Por favor, espere, comprovando a sessão","checkingDevices":"Testando dispositivos","dialog-button-waitingTest":"Por favor, espere até que finalize o teste","dialog-button-go-to-session":"Ir à la videoconsulta","video-quality":"Qualidade do vídeo","audio-quality":"Qualidade de áudio","dialog-title-overalRatingVideoTest":"geral","test-result":{"Bad":"mala","Poor":"Pobre","Fair":"Justa","Good":"Boa","Excellent":"Excelente"},"dialog-title-speedTest":"Teste de vermelho","test-center-image-and-audio":"Certifique-se de que sua imagem pareça centrada e que o indicador do microfone se mova para o canto.","video-device":"Dispositivo de vídeo","audio-device":"Dispositivo de áudio","title-result-test-ok":"Seu sistema pode realizar consultas de vídeo.","tittle-resulta-test-ko":"É recomendado não realizar consulta de vídeo com este sistema","subtitle-result-test-ko":"Por favor, verifique sua conexão com a Internet. ","test-requisites":"Verifique se a câmera e o microfone estão ativos. ","page-not-found":"Página não encontrada","videosession-end-caption":"Sua videoconsulta está programada para encerrar aproximadamente em {data}. ","timer-end":"Fin: {data}","loading-videosession":"Cargando Videoconsulta...","support-chat":"Bate-papo de suporte","login":{"server-error":"Corrigi um erro.\n","email":"E-mail","errors":{"email":"E-mail não válido.","password":"Contrasenha incorreta","password-different":"Ups! ","password-constraints":"Sua senha deve ter pelo menos 8 caracteres e conter uma letra minúscula, minúscula, algum número, assim como algum caractere especial","Disabled":"Seu usuário está debilitado. ","Inactive":"Ele passou mais de seis meses sem registrar atividades em seu usuário. ","PasswordUpdateNeeded":"Por motivos de segurança, sua senha precisa ser atualizada. ","PasswordMaxAttemptsExceeded":"Por motivos de segurança, bloqueamos sua conta devido a várias intenções de início de sessão que falharam. ","twoFACode":"Código de verificação inválido. ","AuthenticationException":"E-mail e/ou senha incorreta","UserLockedException":"Lamentamos, mas sua conta foi bloqueada.<br>Se você acha que isso é um erro, envie um e-mail para info@opensalud.es.","EmailConfirmationException":"Sua conta ainda não foi confirmada. Verifique seu e-mail e confirme sua conta.","ConfirmationEmailExpiredException":"Sua conta ainda não foi confirmada. Enviamos novamente um e-mail de confirmação para o seu endereço de e-mail.","TwoFactorCodeCommunicationException":"Ocorreu um erro ao enviar seu código de dois fatores. Tente novamente em alguns segundos."},"password":"Contrasenha","sign-in":"Iniciar sessão","forget-password":"Esqueceu sua senha?","with-dnie":"Login com certificado digital","password-repeat":"Repita sua nova senha","twoFACode":"Digite o código que você recebeu por e-mail e/ou WhatsApp","already-signed-in":"Já registrado?","new-user":"Você é um novo usuário?","register-now":"Crie uma conta agora para desfrutar de todas as nossas vantagens!","iam-professional":"Eu sou profissional","iam-patient":"Eu sou paciente","iam-centre":"Eu sou um centro","UserLockedException":"","aca-sign-in":"Iniciar sessão com cartão ACA"},"invalid-credentials":"Usuário ou senha incorreta","reenable-account":"Reativar conta","account-reenable-success":"Sua conta foi reativada. ","account-reenable-fail":"Não foi possível reativar sua conta.\n","send":"Enviar","error":{"try-again":"Corrigi um erro. "},"resend-account-enable-email-success":"Por motivos de segurança sua conta foi desativada. \nEnviamos um e-mail para reativar sua conta para {email}.","log-in":"Iniciar sessão","newpassword-success":"Sua senha foi atualizada com sucesso. ","change-password":"Alterar a senha","new-password":{"constraints":"Para que sua senha seja segura, é fundamental que ela tenha mais de 8 caracteres e contenha pelo menos uma letra confidencial, uma letra minúscula, um número e algum caractere especial."},"recover-password":{"instructions":"Se você esquecer sua senha, enviaremos um e-mail para o endereço de e-mail inserido em um link para recuperá-lo.","title":"Recuperar senha","success":"Nós lhe enviaremos um e-mail para a direção introduzida, onde encontraremos um link para podermos restabelecer sua senha."},"name":"Nome","surname":"Apelidos","phone":"Número de telefone","national-identity-document":"Nº doc. ","signup-success":"Foi registrado com sucesso no Opensalud. ","signup-unsuccessful":"Ocorreu um erro durante seu registro. ","sign-up":"Registro","professional":"Profissional","patient":"Paciente","center":"Centro","select-an-option":"Tipo de usuário","telemedcare-account-association":"Sua conta na Telemedcare","telemedcare":{"association":{"step-1":"<b>Passo 1.</b> Baixe o aplicativo 'TMC Blue' em seu dispositivo móvel:","step-2":"<b>Passo {passo}.</b> Inicie o aplicativo que acaba de baixar e escane o código QR que aparece a seguir.","step-3":"<b>Passo {passo}.</b> Bluetooth ativo e habilite o reconhecimento de localização.","step-4":"<b>Passo {passo}.</b> Informe os dispositivos médicos necessários para os medicamentos que você está realizando e verifique se aparecem habilitados em seu dispositivo móvel.","step-5":"<b>Passo {passo}.</b> Tome os medicamentos que você precisa quantas vezes precisar.","step-2-installed":"<b>Passo {passo}.</b> Inicie o aplicativo.","clinic-history":"Lembre-se de que você pode consultar todos os medicamentos no aplicativo Telemedcare ou no histórico clínico do Opensalud."},"access-portal":"É uma história clínica","no-tmc-token-found":"Não há permissão para acessar esta página. ","is-first-access":"Qual é a primeira vez que você acessa o serviço de telemonitorização ou precisa vincular um novo dispositivo?"},"button":{"get-on-google-play":"/static-appopensalud/img/disponible-play-store.png","get-on-app-store":"/static-appopensalud/img/descargar-app-store.png"},"continue-with-certificate":"Continuar com certificado digital","yes":"Si","hang-up-video":"Finalizar videoconsulta","dialog":{"ok-button":"Aceitar","cancel-button":"Cancelar"},"base":{"errors":{"unauthorized":{"title":"Acesso não autorizado","message":"Não há permissões suficientes para acessar esta página.","message360":"Lamentamos, mas seu perfil não pode acessar as condições do opensalud360.\n"},"basic-error":"Ha ocurrido um erro","unauthorized-360-error-page":{"go-to-opensalud":"Entrar no Opensalud"},"unauthozed-travel-error-page":{"new-code":"Novo certificado/número ou código de reserva","new-reservation-number":"Novo certificado/número de reserva","new-start-date":"Dados de entrada","new-end-date":"Dados de saída","code-required":"Insira um número ou código de certificado/reserva","reservation-number-required":"Insira um número de certificado/reserva","start-date-required":"Intervalo de permanência inválido","server-error":"Corrigi um erro.\n"}}},"video":{"connecting":"Conectando-se com o paciente","wait-connecting-patient":"Espere enquanto nos conectamos com seu paciente. ","hang-up-are-you-sure-question":"Você tem certeza de que deseja encerrar a consulta?","on-client-disconnected":"Se a conexão for perdida, aguarde alguns instantes até que o sistema tente recuperar a sessão automaticamente.","new-device-connected":"Um dispositivo de áudio ou vídeo foi conectado/desconectado.\n"},"consolidate-modal":{"title":"A consulta foi finalizada","charge-with-data":"Cobrar consulte os seguintes dados:"},"no":"Não","consolidate-appointment-modal":{"select-billable-entity":"Selecione o valor da fatura","no-charge":"Não cobrar esta consulta","select-no-charge-reason":"Selecione o motivo","must-select-billable-entity":"Você deve selecionar a entidade de cobrança","must-specify-not-charge-reason":"Você deve selecionar um motivo para não cobrar esta consulta"},"base-select":{"select-option":"Selecione uma opção...","errorMsg":"Selecione uma opção"},"menttum-proxy-view":{"title":{"question":"Olá {nome}, o que você precisa?"}},"menttum":{"request-consultation-title":"Peça uma consulta...","video-consultation":"Pedir uma videoconsulta","chat-consultation":"Pedir um bate-papo","wellness-services":"Acessar a plataforma de bem estar","wellness":"Bem-estar","webapp":"Acesse meu perfil","appointment-dialog-msg":"A seguir você poderá selecionar o psicólogo que você atenderá.<br>Os psicólogos se ordenam a atender suas necessidades ou preferências. ","webapp-dialog-msg":"Nesta tela você poderá acessar suas sessões e consultas tanto no Menttum quanto no OpenSalud.","hire-package":"Contratar pacote","hire":"Contrato","included-services":"Serviços incluídos","hire-package-msg":"Você não tem nenhum pacote ativo.\n","self-evaluation":"Avalie sua saúde"},"signup-title":"Cadastre-se","login-wrd":"Acessar","login-wrd-session":"Inicia sessão","welcomeOH":"bem vindo a","profConditions-link":"Condições para profissionais","patConditions-link":"Condições para pacientes","telemedicineCompanies-link":"Saúde e bem-estar para empresas","contact-link":"Contato","legalNotice-link":"Aviso legal e cookies","questions-link":"Perguntas frequentes","lastUpdate":"Última atualização","signupOH":{"joinUsers":"Alta de usuários","registerCodeEnt":"CÓDIGO INDICADO PELA SUA EMPRESA","registerCodeEntInfo":"(SOMENTE SE FOR FORNECIDO A VOCÊ)","selectLanguageTxt":"SELECIONE OS IDIOMAS QUE VOCÊ FALA","registerName":"NOME","registerSurname1":"PRIMEIRO APELIDO","registerSurname2":"SEGUNDO SOBRENOME","genderSex":"SEXO","man":"Homem","woman":"Mulher","country":"PAÍS","registerYourProvince":"Província/Estado/Região","registerNIF":"NIF (DNI/NIE/CIF)","registerEmail":"CORREIO ELETRÔNICO","confirmEmail":"CONFIRMAR E-MAIL","birthdate":"FECHA DE NACIMIENTO (dd/mm/aaaa)","registerPhonePrefix":"PREFIXO","registerPhoneNumber":"TELEFONE CELULAR","readAccept":"Ele leu e aceitou","alreadyRegistered":"Se você está registrado,","loginn":"sessão de início","signup-submit":"Registrador-se","errors":{"enterCode":"Por favor insira um código válido","enterLang":"Selecione pelo menos um idioma","enterName":"Insira o nome","enterSurname1":"Digite o primeiro sobrenome","enterSurname2":"Digite o segundo sobrenome","enterSex":"Selecione gênero","enterCountry":"Selecione o país","enterProvince":"Insira Província/Estado/Região","enterNIF":"Insira um NIF (DNI/NIE/CIF)","enterEmail":"Digite um e-mail","enterConfirmEmail":"Confirmar e-mail","enterBirthdate":"Insira uma data de nascimento","enterPhonePrefix":"Selecione um prefixo","enterPhoneNumber":"Digite um celular","reservation-number":"Insira um número de reserva","certificate-number":"Digite um número de certificado","client-number":"Insira um número de cliente","center-or-business-unit":"Selecione um centro ou unidade de negócios","employee-number":"Digite seu código interno (número do funcionário)","general-code":"Os dados inseridos são inválidos.\n","sameEmails":"Os e-mails devem ser idênticos","enterSpeciality":"Selecionar especialidade","enterCollegeNumber":"Digite seu número de associado","enterSanitaryRegister":"Digite o número do registro de saúde","enterNameEducativeCenter":"Insira o nome de um centro educacional","enterCollegeNumberMaxValue":"Você selecionou uma especialidade médica, o número de membro deve ter 9 dígitos","captcha":"O captcha não foi preenchido corretamente","termsAccepted":"Você deve aceitar os termos e condições legais para se registrar na plataforma.","privacyAccepted":"Você deve aceitar a política de privacidade para se registrar na plataforma.","dataVerification":"Você deve aceitar a verificação de seus dados com a escola oficial para se registrar na plataforma.","enterCentreName":"Por favor, preencha o nome do centro","enterDiscoveryType":"Por favor, consulte como você ficou sabendo sobre nós","enterUrlBlog":"Insira a URL do seu site ou blog","enterExperienceProf":"Insira sua experiência profissional","enterProvinceCollegiate":"Digite sua província de registro","birthdateMore18":"Você deve ser maior de idade para se registrar","urlProf":"Você deve inserir um URL válido","enterDay":"Insira um dia de nascimento","enterMonth":"Digite um mês de nascimento","enterYear":"Insira uma data de nascimento","birthdateMustBeReal":"Você deve inserir um dado real","enterCollegeNumberMaxValueMx":"Os certificados profissionais dos médicos têm 5 caracteres","enterIdentity":"Insira um ID válido","enterIdentityChoice":"Você deve selecionar uma das opções","employeeLocation":"Você deve inserir um local","enterCURP":"Insira uma CURP","enterID":"Insira um ID pessoal","internal-code":"Digite seu código interno","duplicatedNIF":"Já existe um usuário cadastrado com esse documento de identidade","required-employee-number":"Por favor preencha o número do funcionário"},"accept-terms":"Li e aceito os <a target=\"_blank\" href='/terminos-condiciones-profesional'>termos e condições legais.</a>","accept-privacy":"Li e aceito a <a target=\"_blank\" href='/politica-privacidad-profesional'>política de privacidade.</a>","accept-privacy-patient":"Li e aceito a <a target=\"_blank\" href='/politica-privacidad'>política de privacidade.</a>","reservation-number":"Número da reserva","reservation-number-or-code":"Número ou código da reserva","certificate-number-or-code":"Número ou código do certificado","certificate-number":"Número do certificado","generic-code":"Código genérico","checkin-date":"Dados de entrada (dd/mm/aaaa)","checkout-date":"Data de partida (dd/mm/aaaa)","code-provided-by-msm":"Código fornecido pelo RH MSM","client-number":"Número de cliente","code-provided-by-company-or-entity":"Código indicado pela sua empresa ou entidade","center-or-business-unit":"Centro de negócios ou unidade","employee-number":"Número de funcionário","info":{"reservationNumber":{"ConectaTSalud":"Olá, para dar alta no serviço de saúde, você deve inserir seu código CNTxxxxxxxx que o ConectaT te facilitou. "}},"account-confirmation":"Um e-mail foi enviado para {email} para verificar sua identidade.\n \n<br><br>Se depois de alguns minutos você não receber, verifique sua pasta de spam/lixo eletrônico.<br><br>Lembre-se que você tem <u>72 horas</u> para confirmar este e-mail.\n <b>info@opensalud.es</b>","account-confirmation-openlegal":"Um e-mail foi enviado para {email} para verificar sua identidade.  <br><br>Se você passar alguns minutos sem recebê-lo, verifique sua bandeja de correio não desejada/spam.<br><br>Lembre-se de que você tem <u>72 horas</u> para confirmar este e-mail.  <b>hola@openlegal.com</b>","birthDate":"Data de nascimento","selectDiscovery":"Como você nos conheceu?","modalSuccessull":"Informações de registro","modal1":"Um e-mail foi enviado para","modal2":"para verificar sua identidade, além de um Whatsapp se você digitar um número de telefone. <br>\nPor favor, verifique sua caixa postal e siga as instruções.","modal3":"Se depois de alguns minutos você não receber, verifique sua pasta de lixo eletrônico/spam.","modal4":"Lembre-se de que você tem <b>72 horas</b> para confirmar este e-mail.\n <b>info@opensalud.es</b> \n","agree":"De acordo","specialty":"ESPECIALIDADE","collegeProvince":"Província de colegiado","registerCollegeNumber":"Número do colegiado","experienceProfessional":"Experiência (mín. 5 anos)","urlProfessional":"URL da Web/blog (https://..)","withoutLocation":"Sem localização física","registerNameCenter":"Nome do centro","registerSanitaryRegister":"Número do Registro Sanitário","registerNameEducativeCenter":"Nome do Centro Educacional","modalBusiness":"O código que você usou corresponde ao serviço opensalud360.","modalBusiness2":"Clique em continuar para se registrar no opensalud360.","continue":"Continuar","cancel":"Cancelar","registerCodeEntProf":"Código (somente fornecido)","accept-terms-patient":"Li e aceito os <a target=\"_blank\" href='/terminos-condiciones-paciente'>termos e condições legais.</a>","data-verefication":"Autorizo ​​​​a verificação dos meus dados junto à escola oficial.","no-options":"Desculpe, não há opção correspondente","dayBirth":"Diâmetro","monthBirth":"Mes","yearBirth":"Ano","indentitydocument":"IDENTIDADE DO DOCUMENTO","university":"Universidade que emite seu diploma","invalidDate":"Por favor, insira uma data de nascimento válida","justIndicatedByBusiness":"Somente se você tiver sido fornecido pela sua empresa","registerNameCenterResidence":"nome do centro/residência","employeeLocation":"Localização","enterId":"ID pessoal","enterCURP":"CURP","internal-code":"Código Interno (número do funcionário)"},"genderMale":"H","genderFemale":"M","wellness":"Bem-estar","webapp":"Acesse meu perfil e consultas","stethoscope-refresh":"Se o médico indicar que não é possível usar seu estetoscópio, pressione o botão de atualização (como o que pode ser visto a seguir) que você encontra na parte inferior da tela.","refresh-label":"Atualizar página","reconnectingProfessional":"Espere enquanto nos reconectamos com o profissional...","swap-cameras-mobile-rear":"Mudar para câmera traseira","swap-cameras-mobile-front":"Mudar para câmera lateral","appointment-info":{"date":"Data e hora","disease":"Enfermidade ou sintoma","reason":"Motivo da consulta"},"appointment-notes":{"notes":"Notas da consulta","patientNotes":"Notas sobre o paciente","invisible-for-patient":"Lembre-se de que esta informação permanecerá oculta para o paciente","write-here":"Escreva aqui...","last-update":"Última modificação:"},"table":{"no-results":"Não foram encontrados resultados","pagination":{"label":"Elem. "}},"date":"Data","history":{"variables":"Variáveis ​​de saúde"},"base-input":{"placeholder":"Escreva aqui...","errorMsg":"Verifique os dados inseridos"},"payments-gateway":{"title":"Passarela de pago"},"selectMonth":"Selecione meu horário","selectYear":"Selecione ano","month":"Mes","year":"Ano","5MinutesAdvice":"Le informamos que em 5 minutos expirará a sessão e não será possível realizar nenhuma transação.","add-btn":"Adicionar","select-birthdate":"Selecione a data de nascimento","signUp":{"already-registered":"Se você já está cadastrado"},"sign-up-href":"sessão de início","terms-and-conditions":"Termos e condições","report":{"reason":"Motivo da consulta","history":"História real","treatment":"Tratamento","diagnosis":"Diagnóstico"},"uploaded-successfully":"Arquivo subido com sucesso","nodofarma":{"treatment":{"observations":"Observações"}},"legal-services":"legais","more-info":"Mais informações","abogalitypro":{"meta-title":"Os advogados mais destacados"},"signupDiscovery":{"title1":"Recomendação profissional","title2":"Recomendação do paciente","title3":"Recomendação do centro","title4":"Pesquisa na Web/Internet","title5":"Meios de comunicação social","title7":"Imprensa","title8":"Rádio","title9":"Televisão","title10":"Outros","title11":"Chamada telefónica","title2-openlegal":"Recomendação do cliente","title3-openlegal":"Recomendação de escritório/escritório de advocacia","title1-openlegal":"Recomendação de advogado"},"emailRegistered":"E-mail já cadastrado","insurances":"Seguradoras","linkCopiedClipboard":"O link foi copiado com sucesso","saved":"Salvo","changesPerformedCorrectly":"Alterações feitas com sucesso","logOff":"Sessão Fechar","logIn":"Iniciar sessão","search":"Procurar","ago":"faz","hours":"horas","days":"dias","months":"meses","years":"anos","minutes":"minutos","seconds":"segundos","answer":"Responde","loginTitle":"Iniciar sessão","defaultErrorMessage":"Corrigi um erro.\n","video-test":{"adblock-error":"Um bloqueador de anúncios foi detectado em seu navegador.\n"},"openlegal":{"title1":"Estamos aqui para ajudá-lo"},"sign-up-professional":"Cadastro para profissionais","sign-up-patient":"Registro do paciente","sign-up-centre":"Cadastro para centros","terms-and-conditions-patient":"Termos e Condições do Paciente","terms-and-conditions-professional":"Termos e condições profissionais","legal-warning":"Aviso legal","contact-title":"Contato","faqs-title":"Centro de ajuda","terms-conditions":"Termos e condições","contact":"Contato","legal-notice":"Aviso legal","cookies-policy":"Política de cookies","faqs":"Perguntas frequentes","show":"mostrar","myProfile":"Meu perfil","close":"Fechar","loginError":"e-mail ou senha estão incorretos","pregunta-1":"Pergunta de teste","price":"Preço","patient-title":"OpenSalud: consultas médicas e o aplicativo de saúde e bem -estar mais completo","business-title":"Saúde digital para empresas","invalidPromotionCode":"O código inserido não é válido","error-required":"Você deve selecionar uma opção","services-title":{"type-one":"Consulta presencial","type-two":"Videoconsulta agendada","type-three":"Chat","type-four":"Consulta por texto","type-five":"Vídeoconsulta instantânea","type-six":"Consulta ao domicílio","type-seven":"Segunda Opinião","type-eight":"Pacotes de serviço","type-nine":"Consulta por escrito de taxa fixa e bate-papo","type-eleven":"Consulta pelo seguro","type-ten":"Um profissional entra em contato"},"label-specialties":"labelPt","invalid-2facode":"O código é inválido","account":{"register-ok":"Registro bem-sucedido","set-email":"Definir e-mail"},"access":"Acessar","menu-opt":"Cardápio","edit":"Editar","doubts":"dúvidas","videoTest":"Teste de vídeo","signupMonth":{"january":"janeiro","february":"Fevereiro","march":"Marchar","april":"abril","may":"Poderia","june":"Junho","july":"julho","august":"agosto","september":"Setembro","october":"Outubro","november":"novembro","december":"dezembro"},"sign-up-customer":"Registro de cliente","sign-up-lawyer":"registro de advogado","save":"Manter","question":"Perguntar","unit":"Unidade","goal":"Mirar","reminder":"Lembrete","notes":"Notas","optional":"(opcional)","edited":"Editado","setting":"Contexto","orderBy":"Organizar por...","chronological":"cronológico","color":"Cor","score":"Pontuação","ascending":"Para cima","descending":"Caindo","description":"Descrição","calendar":"Calendário","notificationsEmail":"Notificações por e-mail","notificationsPhone":"telefone de notificação","between":"entre","and":"e","error-alreadyregister":"Ocorreu um erro no seu cadastro, verifique seus campos.<br> \nLembre-se de que se você estiver registrado no openlegal, poderá acessar o opensalud usando as mesmas credenciais.","error-alreadyregister-openlegal":"Ocorreu um erro no seu cadastro, verifique seus campos.<br> \nLembre-se de que se você estiver registrado no opensalud, poderá acessar o openlegal usando as mesmas credenciais.","aca-error-title-page":"Corrija um erro com seu cartão ACA","aca-error-detail-page":"Parece haver um problema com seu certificado de cartão ACA, por favor tente novamente mais tarde ou entre em contato com nosso suporte técnico.","access-verb":"Acessar","update":"Atualizar","error-checkextension":"Verifique se o e-mail e o código inserido estão corretos.\n","error-checkemployeenumber":"Os dados inseridos são inválidos.\n","a2hs":{"modal-message":"Deseja instalar o aplicativo {plataforma}?","modal-install-btn":"Instalar","safari-tooltip":"Para instalar este webapp em seu iPhone/iPad, clique no ícone {shareIconImg} no menu do navegador do seu dispositivo e selecione a opção 'Adicionar à tela inicial'."},"error-checkinternalcode":"Os dados inseridos não são válidos. \nRevise o código interno inserido.","error-checkemployeenumber2":"Os dados inseridos não são válidos. \nRevise o código interno inserido e certifique-se de que seu cônjuge esteja cadastrado na plataforma.","bnpMSG":"Informamos que a sua empresa apenas será informada do seu registo na plataforma e nunca da sua utilização da mesma.","bnpMSG2":"Se continuar com o registo entendemos que concedemos a sua autorização.","dontShowAgain":"Não mostre novamente","enterValue":"Insira um valor","finish":"Terminar","value":"Valor","httpRequestDefaultError":"Um erro ocorreu durante o processamento do seu pedido. \nEntre em contato com nossa equipe técnica através do chat de suporte","create":"Criar","undefined":"Indefinido","floor":"andar","accept":"Aceitar","changeUser":"Alterar usuário","complete":"Completar","datepicker-ph":"Selecione uma data","labelNoDateSelected":"Você não selecionou nenhuma data","current-month":"Mês atual","next-year":"Próximo ano","next-month":"Próximo mês","prev-year":"Ano anterior","prev-month":"Mês anterior","next-decade":"Próxima década","prev-decade":"Década anterior","date-picker":{"must-select-date-before-now":"Você deve selecionar uma data anterior à atual"},"selected-date":"Data selecionada","reset":"Restaurar","noMatchingElements":"Não há elementos que correspondam ao filtro selecionado","recipients":"Destinatários","weeks":"semanas","chart":{"moreRecent":"Mais recente","lessRecent":"Menos recente","defaultChartTitle":"Gráfico padrão","accesibility":{"announceNewData":{"newDataAnnounce":"Dados atualizados para o gráfico {chartTitle}.","newPointAnnounceMultiple":"Novo ponto de dados no gráfico {chartTitle}: {pointDesc}.","newPointAnnounceSingle":"Novo ponto de dados: {pointDesc}.","newSeriesAnnounceMultiple":"Nova série de dados no gráfico {chartTitle}: {seriesDesc}.","newSeriesAnnounceSingle":"Nova série de dados: {seriesDesc}."},"axis":{"rangeCategories":"Intervalo de dados: {numCategories} categorias.","rangeFromTo":"Os dados variam de {rangeFrom} a {rangeTo}.","timeRangeDays":"Intervalo de dados: {rango} dias.","timeRangeHours":"Intervalo de dados: {range} horas.","timeRangeMinutes":"Intervalo de dados: {rango} minutos.","timeRangeSeconds":"Intervalo de dados: {rango} segundos.","xAxisDescriptionPlural":"O gráfico tem {numAxes} eixos X que mostram {#each(names, -1), }e {names[-1]}.","xAxisDescriptionSingular":"O gráfico tem 1 eixo X que mostra {names[0]}. {rangos[0]}","yAxisDescriptionPlural":"O gráfico tem {numAxes} eixos Y que mostram {#each(names, -1), }e {names[-1]}.","yAxisDescriptionSingular":"O gráfico tem 1 eixo Y que mostra {names[0]}. {rangos[0]}"},"exporting":{"chartMenuLabel":"Menu do gráfico","menuButtonLabel":"Ver menu do gráfico, {chartTitle}"},"legend":{"legendItem":"Mostrar {nome do elemento}","legendLabel":"Legenda do gráfico: {legendTitle}","legendLabelNoTitle":"Alternar a visibilidade da série, {chartTitle}"},"rangeSelector":{"clickButtonAnnouncement":"Visualizando {axisRangeDescription}","dropdownLabel":"{rangeTitle}","maxInputLabel":"Selecione a data de término.","minInputLabel":"Selecione a data de início."},"series":{"description":"{description}","nullPointValue":"Sem valor","pointAnnotationsDescription":"{Anotação: #each(annotations). }","xAxisDescription":"Eixo X, {name}","yAxisDescription":"Eixo Y, {name}"},"seriesTypeDescriptions":{"arearange":"Os gráficos de intervalo de área são gráficos de linha que mostram um intervalo entre um valor mais baixo e mais alto para cada ponto.","areasplinerange":"Esses gráficos são gráficos de linha que mostram um intervalo entre um valor inferior e superior para cada ponto.","columnrange":"Os gráficos de intervalo de colunas são gráficos de colunas que mostram um intervalo entre um valor inferior e superior para cada ponto."},"table":{"tableSummary":"Representação em tabela do gráfico.","viewAsDataTableButtonText":"Ver como tabela de dados, {chartTitle}"},"zoom":{"mapZoomIn":"Zoom no gráfico","mapZoomOut":"Reduzir zoom no gráfico","resetZoomButton":"Restaurar zoom"}},"navigaton":{"popup":{"addButton":"Adicionar","algorithm":"Algoritmo","arrowInfinityLine":"Linha de flecha","arrowRay":"Raio de flecha","arrowSegment":"Segmento de flecha","average":"Média","background":"Fundo","backgroundColor":"Cor de fundo","backgroundColors":"Cores de fundo","borderColor":"Cor da borda","borderRadius":"Raio da borda","borderWidth":"Largura da borda","bottomBand":"Banda inferior","circle":"Círculo","clearFilter":"✕ limpar filtro","color":"Cor","connector":"Conector","crooked3":"Linha 3 torta","crooked5":"Linha 5 torta","crosshairX":"Ponto de mira X","crosshairY":"Ponto de mira Y","decimals":"Decimais","deviation":"Desvio","editButton":"Editar","ellipse":"Elipse","factor":"Fator","fastAvgPeriod":"Período médio rápido","fibonacciTimeZones":"Zonas de tempo de Fibonacci","fill":"Preencher","flags":"Bandeiras","fontSize":"Tamanho da fonte","format":"Texto","height":"Altura","highIndex":"Índice alto","horizontalLine":"Linha horizontal","increment":"Incremento","index":"Índice","infinityLine":"Linha infinita","initialAccelerationFactor":"Fator de aceleração inicial","innerBackground":"Fundo interno","label":"Etiqueta","labelOptions":"Opções de etiqueta","labels":"Etiquetas","line":"Linha","lines":"Linhas","longPeriod":"Período longo","lowIndex":"Índice baixo","maxAccelerationFactor":"Fator de aceleração máximo","measure":"Medida","measureX":"Medida X","measureXY":"Medida XY","measureY":"Medida Y","multiplier":"Multiplicador","multiplierATR":"Multiplicador ATR","name":"Nome","noFilterMatch":"Sem correspondência","outerBackground":"Fundo externo","padding":"Preenchimento","parallelChannel":"Canal paralelo","period":"Período","periodATR":"Período ATR","periods":"Períodos","periodSenkouSpanB":"Período Senkou Span B","periodTenkan":"Período Tenkan","ranges":"Intervalos","ray":"Raio","rectangle":"Retângulo","removeButton":"Remover","saveButton":"Salvar","searchIndicators":"Indicadores de busca","segment":"Segmento","series":"Série","shapeOptions":"Opções de forma","shapes":"Formas","shortPeriod":"Período curto","signalPeriod":"Período de sinal","simpleShapes":"Formas simples","slowAvgPeriod":"Período médio lento","standardDeviation":"Desvio padrão","stroke":"Cor da linha","strokeWidth":"Largura do traço","style":"Estilo","timeCycles":"Ciclos de tempo","title":"Título","topBand":"Banda superior","tunnel":"Túnel","typeOptions":"Detalhes","verticalArrow":"Seta vertical","verticalCounter":"Contador vertical","verticalLabel":"Etiqueta vertical","verticalLine":"Linha vertical","volume":"Volume","xAxisUnit":"Unidade do eixo x"}},"weekdays":["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],"months":["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],"shortMonths":["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],"viewFullScreen":"Ver em tela cheia","viewData":"Ver dados da tabela","resetZoom":"Redefinir zoom","resetZoomTitle":"Restaurar nível de zoom 1:1","printChart":"Imprimir gráfico","noData":"Sem dados para exibir","loading":"Carregando...","hideData":"Ocultar tabela de dados","exitFullScreen":"Sair da tela cheia","downloadXLS":"Baixar XLS","downloadSVG":"Baixar SVG","downloadPNG":"Baixar PNG","downloadPDF":"Baixar PDF","downloadJPEG":"Baixar JPEG","downloadCSV":"Baixar CSV","contextButtonTitle":"Menu"},"day":"Dia","change-user":{"select-user":"Selecione um usuário...","error-select-user":"Selecione o usuário para o qual deseja alterar"},"hide":"Disfarce","details":"Detalhes","remove":"Remover","select":"Selecione","type":"Cara","frequency":"Frequência","next":"Próximo","insurance":"Seguradora","single":"Especial","text-code-group":"De acordo com os compromissos firmados entre Open Healthcare/opensalud e Unipromel e Irelegal, por já estar incluído na base de dados do opensalud, se desejar, você pode acessar os diversos serviços prestados pelo opensalud (software clínico, prontuário médico, diretório... ) em condições preferenciais. \nLembramos que a Open Healthcare/opensalud possui seu sistema de gestão de segurança da informação certificado pela ISO27001 e também validado pela Collegiate Medical Organization.","text-code-group-main":"Autorizo ​​a verificação da minha adesão à Unipromel e a comunicação à Unipromel dos dados relativos ao registo no prontuário e diretório médico.","errorMessages":{"only-subscribed-users":"Serviço apenas para assinantes."},"appointmentState":{"noConfirmed":"Não confirmado","scheduled":"Agendado"},"hideLowercase":"disfarce","modify":"Modificar","review":"Análise","invoice":"Fatura","from":"de","to":"até","confirm":"Confirmar","defaultSuccessMessage":"A operação foi realizada com sucesso","see":"Ver","showMoreOptions":"Mais opções...","centers":"Centros","notifications":{"appointmentCanceledByProf":"O profissional {profName} {title} {appointmentType} de {date}","hasCanceled":"cancelou o seu","hasScheduled":"agendou um"},"soon-label":"Breve","know-more":"Saber mais","showOptions":"Opções...","prescriptions":"Prescrições","hour":"Hora","address":"Endereço","country":"País","state":"Província","city":"Município","startDate":"Data de início","endDate":"Data final","schedule":"Agendar","filtersTitle":"Filtros","completed":"Preenchido","error-professionalregistered":"Ocorreu um erro no seu registro, verifique seus campos.","forMe":"Para mim","forMinor":"Para paciente menor","forPet":"Para animal de estimação","understood":"Entendido","prefix":"Prefixo","phoneShort":"Telefone","package":"Pacote","duration":"Duração","hire":"Contratar","open":"Abrir","closed":"Fechado"}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = {"private-layout":{"my-profile":"Mi perfil","health-data":"Datos de salud","chats":"Chats","my-consultations":"Mis consultas","my-agenda":"Mi agenda","my-professionals":"Mi equipo","search":"Pedir cita","change-user":"Cambiar de usuario","questions":"Dudas","logout":"Cerrar sesión","evaluate-your-health":"Evalúa tu salud","habits-challenges":"Mis objetivos y hábitos","healthy-community":"Comunidad saludable","log-off":"Cerrar sesión","my-services":"Mis servicios","chats-interconsultation":"Chats-Interconsultas","appointment-request":"Solicitudes y presupuestos","my-patients":"Mis pacientes","my-invoices":"Mis facturas","my-requests":"Mis solicitudes","dashboard":"Cuadro de mando","telemonitoring":"Telemonitorización","my-profile-services":"Mi perfil","patients-like-you":"Pacientes como tú","activeChats":"Chats activos","home":"Inicio","healthy-foods":"Alimentación saludable","services":"Mis servicios","physiotherapy":"Fisioterapia digital","my-apps":"Mis aplicaciones","who-signs-up":"¿Quién se apunta","idle-time-warning":"Le informamos de que en 5 minutos se cerrará su sesión por inactividad.\nPor favor, interactúe con esta ventana si sigue estando activo."}}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = {"simple-search":{"in-person-visit":"Visita presencial","online":"Online","appointment-type":"","search":"Buscar","private-appointment":"CONSULTA PRIVADA","insurance-appointment":"CONSULTA ASEGURADORA","select-specialty-professional-or-service":"Debe seleccionar una especialidad, profesional o servicio.","location":"Provincia/Localidad","select-specialty-or-service":"Debe seleccionar primero una especialidad o prueba.","inplace-without-location-warning":"Ha seleccionado consulta presencial, si desea una videoconsulta debe seleccionar consulta online.","no-locations-dialog-warning":"El profesional seleccionado no tiene servicio de Consulta Presencial. ¿Desea solicitar alguno de los servicios online?","select-location":"Dado que ha seleccionado cita presencial debe indicar la provincia/localidad. Si desea una consulta online seleccione el botón <img width=\"17\" height=\"17\" src=\"/static-appopensalud/img/icons/services/video.svg\"/> <span style=\"color: #3238C4\">ONLINE</span>"}}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = {"learn-more-btn":"Saber más","title-big-1":"Queremos cuidar de ti. Siempre.","title-big-2":"¿Qué ventajas ofrece opensalud 360?","title-big-3":"¿Cómo funciona?","title-big-4":"Contáctanos","title-small-1":"La plataforma de salud y bienestar integral","title-small-2":"Sin esperas, estés donde estés","title-small-3":"Comodidad y seguridad","title-small-4":"Los mejores programas de salud","title-small-5":"Regístrate en openhealth","title-small-6":"Inicia sesión y elige el servicio","title-small-7":"Indica el motivo de tu consulta","title-small-8":"Accede al profesional","text-1":"Accede a los mejores profesionales y programas de salud y bienestar, en cualquier momento y desde cualquier lugar.","text-1-sm":"opensalud 360 es una plataforma de salud para personas,empresas y colectivos, que permite a sus usuarios acceder a los mejores profesionales de la salud, en cualquier momento y desde cualquier lugar.","text-2":"En tu hogar, lugar de trabajo o incluso un hotel, accede por video, teléfono o chat a algunos de los mejores especialistas. Podrás recibir tu receta directamente en el móvil.","text-3":"Evita riesgos, molestias y costes para ti y tu familia, limitando los desplazamientos a centros médicos, urgencias... nos pospongas el cuidado de salud por falta de tiempo.","text-4":"Contenidos a medida, gimnasio online, clases en directo de mindfulness, pilates, cardiovascular, embarazadas, espalda sana… entre otros muchos servicios.","text-5":"Incluye el código, número de póliza o reserva facilitado","text-6":"Selecciona el servicio y el profesional que necesitas utilizando el buscador","text-7":"Añade algunos datos de salud, adjuntando si lo deseas imágenes o informes","text-8":"Recibe tu informe y prescripción. Al finalizar podrás valorar el servicio","text-9":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","text-9-sm":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","specialty":"Especialidad","appointment-type":"Tipo de consulta","welcome":"Bienvenido a {platform}","what-do-you-need":"¿Qué necesitas?","teleconsultation":"Consultas y Teleconsultas","teleconsultation-description":"Médicos, psicólogos, nutricionistas y otras especialidades.","health-wealth":"Plataforma de bienestar","health-wealth-description":"Clases en directo, gimnasio online, meditación, programas y mucho más..","bonified-services":"Otros servicios de salud bonificados","bonified-services-description":"Consultas, pruebas diagnósticas y tratamientos a precio reducido.","wellbeing-score":"Wellbeing score<br><small>by freedom and flow</small>","wellbeing-score-description":"Evalúa tu nivel de bienestar personal y accede a tu programa de mejora.","telemonitoring":"Telemonitorización","telemonitoring-description":"Podrás sincronizar dispositivos para controlar tu estado de salud.","healthy-community":"Comunidad Saludable","healthy-community-description":"Organiza planes, comparte experiencias y accede a información de salud","health-data":"Datos de salud","health-data-description":"Consulta los datos de tu historia clínica (enfermedades, alergias, medicamentos, etc)","habits-description":"Te ayudamos a crear retos para mejorar tus hábitos","healthy-habits":"Hábitos saludables","self-evaluation-tests":"Evalúa tu salud","self-evaluation-tests-description":"Salud mental y emocional, riesgos psicosociales, riesgo diabetes, etc","reminders":"Recordatorios","reminders-description":"Agenda, tareas y recordatorio de medicamentos"}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = {"abogalitypro":{"title":"Los abogados más destacados.","subtitle":"Si eres uno de ellos y te interesa el entorno digital, te ofrecemos todo lo que necesitas para atender a tus clientes, en una única aplicación web, con las máximas garantías de seguridad y privacidad.","request-demo":"Solicitar demo","cards":{"1":{"title":"Tu propia Web personalizada","subtitle":"Tendrás tu propia url para que tus clientes puedan encontrarte."},"2":{"title":"Plataforma de vídeo segura","subtitle":"Evita el uso de plataforma de elevado coste, poco funcionales o inseguras."},"3":{"title":"Chat legal","subtitle":"Permite que te contacten tus clientes mediante un chat seguro y funcional"},"4":{"title":"Historia legal y documentación","subtitle":"Accede, edita y comparte documentos y el historial legal con tus clientes."},"5":{"title":"Pasarela de pago segura","subtitle":"Tus clientes deberán garantizar el pago con tarjeta o bizum antes de acceder a tus servicios."},"6":{"title":"Agenda online","subtitle":"Gestiona tus citas presenciales u online de forma fácil y automática."},"7":{"title":"Facturación online","subtitle":"Realiza tus cobros y emite tus facturas de forma automática."},"8":{"title":"Tareas y recordatorios","subtitle":"Puedes crear tareas y recordatorios para ti y para tus clientes:"},"9":{"title":"Suscripciones y precios personalizables","subtitle":"Podrás establecer diferentes precios en función del motivo de consulta o el colectivo"},"10":{"subtitle":"Contacta con otros abogados a través de mensajería interna"},"19":{"title":"Interconsultas"},"title":"Tú decides.","subtitle":"Accede a tus clientes cuando y como quieras.","video":{"title":"Aplicación profesional de vídeo","subtitle":"Segura y privada. No requiere que los usuarios estén registrados (Teams, Zoom…)"}},"register-for-free":"Regístrate gratis","security-privacity":{"blackTitle":"Seguridad y privacidad.","title":"Todo lo que necesitas con el máximo nivel de protección.","text":"La seguridad de las comunicaciones y privacidad de los datos son nuestra prioridad.","text2":"Ponemos a tu disposición la mejor tecnología con la máxima seguridad en las comunicaciones y total privacidad de tus datos. Nuestra plataforma cuenta con la certificación ISO27001 y está auditada por la OMC."},"professional-platform":{"orange-title":"Sólo necesitas 10 minutos para configurarla.","title":"Bienvenido a tu plataforma de servicios legales.","text1":"<b>Aumenta tu visibilidad y reputación</b><br>Capta nuevos clientes gracias a tu perfil online","text2":"<b>Cobra todos tus servicios</b><br>Dispondrás de tu propia pasarela de pago","text3":"<b>Simplifica tareas</b><br>Recordamos al cliente sus citas o tareas, emitimos de manera automática @:global.factura en tu nombre","text4":"<b>Mejora la atención</b><br>Ordena tus comunicaciones reduciendo el uso del email, whatsapp o teléfono","orange-title-final":"Podrás conectarla con tu web corporativa, RRSS, blog..."},"block-8":{"iva":"(IVA No incluido)"},"subscriptions":{"title":"Tarifas","professional-rate":"Abogado","law-firm-rate":"Bufete","monthly-payment":"Cuota mensual","try-free":"Prueba gratis por 3 meses","law-firm-text":"Hasta 5 abogados. Consultar tarifa para mas de 10 profesionales.","price-text":"+ 1.5% de los servicios cobrados a través de la pasarela de pagos de legalPRO."},"contact-form":{"text":"Si quieres acceder a la mejor plataforma para abogados, contáctanos."},"form":{"collegiateNumber":"Provincia de colegiación"}},"iva-not-included":"(IVA No incluido)"}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = {"account":{"login":{"title":"Iniciar sesión"}},"login":{"mfaCode":"Código","invalid-credentials":"Email y/o contraseña incorrectos","already-sign-in":"¿Ya estás registrado?","errors":{"passwordMaxAttempts":"Debido a que ha iniciado varias veces la sesión de forma fallida, tu cuenta permanecerá bloqueada durante unos instantes.<br>Vuelva a iniciar sesión pasados unos minutos.","zaraExpired":"El programa piloto de acceso a opensalud360 para empleados de Zara ha finalizado con fecha 28 de febrero. Zara España le comunicará en su caso la posible continuidad o no del servicio. No obstante, le comunicamos que puede seguir utilizando su cuenta como usuario particular, podrá seguir accediendo tanto a sus datos como a sus consultas a través del portal de: <a style='font-weight: bold;' href='https://opensalud.es/'>https://opensalud.es/ </a>.<br><br>Le agradecemos su confianza.","deniedAccess":"Lo sentimos pero su usuario no puede acceder a este servicio para empresas.<br/> Si considera que puede tratarse de un error, contacte con nosotros utilizando el chat de asistencia técnica o envíenos un email a @:global.contact-email .","zaraPilotEnd":"El programa piloto de acceso a opensalud360 para empleados de Zara ha finalizado con fecha 28 de febrero. Zara España le comunicará en el futuro la posible continuidad o no del servicio. Le agradecemos su confianza. Si está interesado en continuar con el servicio una vez finalizado el programa piloto, puede hacerlo abonando el precio de las consultas.","copaymentEnabled":"Su paquete de servicios disponibles ha sido modificado, por lo que determinados servicios pasaran a no estar disponibles o tener un copago. Si tiene alguna duda contacte con nosotros en el chat de soporte.","santanderPaidService":"Le recordamos que el programa se ha ampliado hasta el 31 de enero de 2023. Si con posterioridad a esa fecha desea continuar en el mismo, deberá asumir el coste bonificado de 36 euros por consulta.","travelExpired":"El servicio médico relativo a su reserva con {travelCompany} finalizó el {endDate}.<br>Si desea acceder a sus datos puede seguir haciéndolo en <a href='{domain}'>{domain}</a>.<br>No obstante, si tiene un nuevo número de reserva, rellene el formulario para poder seguir disfrutando del servicio.</b>","travelNotStartedYet":"El servicio médico relativo a su reserva con {travelCompany} comienza el día {startDate}.<br>Este servicio solo estará disponible durante su estancia en nuestros hoteles.","expired":"El servicio que su entidad había contratado con <b>Open Health</b> ha finalizado. Si necesita más información contacte con su empresa o entidad.<br><br>No obstante, sus datos siguen disponibles en <a href='{domain}'>{domain}</a> donde, si lo desea, puede solicitar los servicios con el profesional de su elección, aunque recuerde que éstos ya no serán sufragados por su empresa. Si desea acceder a cualquier profesional de los disponibles, podrá hacerlo a los precios que dicho profesional tenga establecidos para usuarios de opensalud 360."},"terms-and-conditions":"Debe aceptar nuestros términos y condiciones antes de continuar:","terms-and-conditions-accept":"He leído y acepto los términos y condiciones legales.","privacy-policy":"Debe aceptar nuestra política de privacidad antes de continuar:","privacy-policy-accept":"He leído y acepto la política de privacidad.","twoFACode":"Introduzca el código que ha recibido por email y/o whatsapp","twoFACode-ph":"Código"}}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = {"account":{"password-update":{"update-password":"Actualizar contraseña","password":"Contraseña","success2":"Su contraseña se ha establecido correctamente.","success":"Su contraseña se ha restablecido correctamente.","reset-password":"Te enviaremos un correo con las instrucciones para recuperar tu contraseña a la dirección de correo electrónico con la que te registraste.","expired-password":"Su contraseña ha caducado tras 12 meses.","send-password-email":"Enviar correo de recuperación","email-sent":"Ya te hemos enviado un email con instrucciones a {email}.","check-email":"Comprueba tu correo electrónico para recuperar tu contraseña.","check-spam":"Si no lo encuentras en tu bandeja de entrada, recuerda que puede haber llegado a la bandeja de correo no deseado o spam.","security-requirements":"Por exigencias de seguridad, la contraseña debe tener un mínimo de 8 caracteres y contener al menos una letra mayúscula, otra minúscula, un carácter especial y un número.","click-login":"Haga click aquí para iniciar sesión","repeat-password":"Repita su contraseña","error":"Su enlace ha caducado. Por favor, haga <a href=\"/cuenta/peticion-actualizar-contrasena\">click aquí</a> para volver a pedir uno.","set-password":"Establecer contraseña","error-found":"Se ha producido un error intentando resetear su contraseña. Por favor, contacte con soporte.","error-requisites":"No hemos podido modificar su contraseña. Por favor, recuerde que no puede haber usado la misma contraseña anteriormente.","email-required":"Introduzca un email"},"confirm-email":"Confirmar cuenta","confirm-account-h1":"Su email ha sido validado. Para completar su registro, debe de establecer una contraseña para su usuario.","confirm-account-error":"Ha ocurrido un error","confirm":{"error":"El email de confirmación de cuenta ha caducado."},"set-email-title":"Especifique un correo electrónico válido","set-email":{"error01":"Introduzca un email válido por favor","error02":"El email introducido ya se encuentra registrado en el sistema"},"setEmail":"Establecer email","confirm-account-message":"Por favor revise su bandeja de entrada o su WhatsApp para confirmar el registro en la plataforma","confirm-account":{"steps-reenable":"Por favor, introduzca el email con el que se registró y pulse en el botón a continuación y le volveremos a enviar el correo de confirmación de cuenta.","resend-enable-account":"Reenviar correo de confirmación","email-required":"Por favor, introduzca el email con el que se registró"},"register":{"confirmation-title":"Registro correcto"}},"signup":{"ok":"Se ha enviado un correo electrónico a {email} para verificar su identidad, además de un Whatsapp si ha introducido número de teléfono. <br>Por favor consulte su buzón y siga las instrucciones.","ok2":"para verificar su identidad, además de un Whatsapp si ha introducido número de teléfono. <br>Por favor consulte su buzón y siga las instrucciones.","titleok":"Registro realizado con éxito","modal3":"Si pasados unos minutos no lo ha recibido, compruebe su bandeja de correo no deseado / spam.","modal4":"Recuerde que dispone de <b>72 horas</b> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b> info@opensalud.es</b> ","modal4-openlegal":"Recuerde que dispone de <b>72 horas</b> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b> hola@openlegal.com</b> "},"kickout":{"title":"Desconexión automática","explain":"Se ha desconectado esta sesión al no detectar actividad en la última hora o al haber sido iniciada otra sesión con el mismo usuario en una pestaña, navegador o dispositivo diferente al actual.","explain2":"Utilizamos este sistema como medida de seguridad para garantizar el acceso único a la plataforma.","contact":"Si se muestra esta pantalla sin que usted crea que está en el supuesto anterior, puede ponerse en contacto con nosotros mediante nuestro chat de asistencia, situado en la esquina inferior derecha."},"private-layout":{"habits-challenges":"Mis objetivos y hábitos"}}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = {"update-required-data":{"text":"Antes de continuar, por favor, rellene los siguientes datos:","contact-chat":"Si no conoce su número de empleado, por favor contacte con el chat de asistencia técnica para recibir ayuda.","save":"Actualizar datos","messages":{"dni-already-exists":"Ya existe un usuario registrado con ese documento de identidad","user-is-underage":"Debe de ser mayor de edad para poder registrarse"}}}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = {"cookies-title":"<div class='type-intro-title'>Política de cookies</div><br/>","cookies-1":"<h4>1. INFORMACIÓN SOBRE COOKIES</h4><br>","cookies-1txt":"<p>Debido a la entrada en vigor de la referente modificación de la “Ley de Servicios de la Sociedad de la Información” (LSSICE) establecida por el Real Decreto 13/2012, es de obligación obtener el consentimiento expreso del usuario de todas las páginas web que usan cookies prescindibles, antes de que éste navegue por ellas.</p><br>","cookies-2":"<h4>2. ¿QUÉ SON LAS COOKIES?</h4><br>","cookies-2txt":"<p>Las cookies y otras tecnologías similares tales como local “shared objects”, “flash cookies” o píxeles, son herramientas empleadas por los servidores Web para almacenar y recuperar información acerca de sus visitantes, así como para ofrecer un correcto funcionamiento del sitio.</p><br><p>Mediante el uso de estos dispositivos se permite al servidor Web recordar algunos datos concernientes al usuario, como sus preferencias para la visualización de las páginas de ese servidor, nombre y contraseña, productos que más le interesan, etc.</p><br>","cookies-3":"<h4>3. COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS</h4><br>","cookies-3txt":"<p>Según la directiva de la UE, las cookies que requieren el consentimiento informado por parte del usuario son las cookies de analítica y las de publicidad y afiliación, quedando exceptuadas las de carácter técnico y las necesarias para el funcionamiento del sitio web o la prestación de servicios expresamente solicitados por el usuario.</p><br>","cookies-4":"<h4>4. ¿QUÉ TIPOS DE COOKIES EXISTEN?</h4><br>","cookies-4txt":"<p>Sobre los tipos de cookies, existen cinco grandes grupos:</p><br><ul><li>Cookies analíticas: recogen información del uso que se realiza del sitio web.</li><li>Cookies sociales: son aquellas necesarias para redes sociales externas.</li><li>Cookies de afiliados: permiten hacer un seguimiento de las visitas procedentes de otras webs, con las que el sitio web establece un contrato de afiliación (empresas de afiliación).</li><li>Cookies de publicidad y comportamentales: recogen información sobre las preferencias y elecciones personales del usuario (retargeting).</li><li>Cookies técnicas y funcionales: son las estrictamente necesarias para el uso del sitio web y para la prestación del servicio contratado.</li></ul><br>","cookies-5":"<h4>5. RELACIÓN Y DESCRIPCIÓN DE LAS COOKIES QUE UTILIZAMOS EN LA PÁGINA WEB</h4><br>","cookies-5txt":"<p>La tabla que publicamos a continuación recoge de forma esquematizada las cookies que utilizamos en nuestra página web:</p><br>","cookies-5table":"<table><tr><th>Tipo</th><th>Nombre</th><th>Info</th><th>Caducidad</th><th>Propiedad</th><th>Link</th></tr><tr><td>Funcional</td><td>ASP.NET_SessionId</td><td>Sesión del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>__RequestVerificationToken</td><td>Prevención de ataques CSRF</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>raw_country</td><td>País del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>raw_continent</td><td>Continente del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>langpref</td><td>Lenguaje del usuario</td><td>19/01/2038</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>lang_established</td><td>Establecimiento del lenguaje del usuario</td><td>19/01/2038</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>pwa_installed</td><td>Acceso escritorio instalado</td><td>30 (No) - 365 (Sí) días</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>.AspNet.ApplicationCookie</td><td>Identidad del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>api_token</td><td>Conexión con APIs</td><td>24 horas</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>tmc_token</td><td>Conexión con TMC</td><td>24 horas</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>Sentry cookies</td><td>Gestión de errores</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Funcional</td><td>Cloudflare cookies</td><td>Seguridad</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Funcional</td><td>Smartsupp cookies</td><td>Chat de soporte</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Analítica</td><td>Google cookies</td><td>Seguimiento</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Analítica</td><td>Facebook cookies</td><td>Seguimiento</td><td>-</td><td>Terceros</td><td></td></tr></table><br>","cookies-6":"<h4>6. COOKIES DE REDES SOCIALES</h4><br>","cookies-6txt":"<p>Algunas páginas de nuestros sitios web le permiten compartir nuestros contenidos en redes sociales como Facebook, Twitter, Google, etc. Algunas veces colgamos vídeos de sitios como YouTube. Estos sitios web depositan sus propias cookies, que nosotros no controlamos. Quizás quiera comprobar sus sitios web para saber más acerca de su política de cookies.</p><br><p>MÁS INFORMACIÓN SOBRE COOKIES DE REDES SOCIALES:</p><ul><li><a href='https://es-es.facebook.com/about/privacy/cookies'>Facebook</a></li><li><a href='https://twitter.com/privacy'>Twitter</a></li><li><a href='https://www.youtube.com/howyoutubeworks/policies/community-guidelines/'>Youtube</a></li><li><a href='https://www.linkedin.com/legal/privacy-policy'>Linkedin</a></li></ul><br>","cookies-7":"<h4>7. DESDE SU NAVEGADOR PUEDE:</h4><br>","cookies-7txt":"<p>Evitar el uso de Cookies, deshabilitando en su navegador el uso de Cookies y eliminando las Cookies guardadas en su navegador asociadas a este sitio web. Esta posibilidad de evitar el uso de Cookies puede ser llevada a cabo por usted en cualquier momento.</p><br><p>Evitar la descarga de cookies en tu navegación, seleccionando la opción “Navegación de incógnito” o similar, (aunque la siguiente ocasión que quiera acceder a tu cuenta personal tendrá que loguearte) debiendo renunciar además a la memorización de otras variables de sesión.</p><br><p>Borrar cookies, Para borrar las cookies vinculadas con tu cuenta personal en OPENHEALTHCARE S.L deberás hacerlo desde el dominio https: www.openhealthcare.es.</p><br>","cookies-8":"<h4>8. REVOCACIÓN DEL CONSENTIMIENTO PARA INSTALAR COOKIES COMO ELIMINAR LAS COOKIES DEL NAVEGADOR</h4><br>","cookies-8txt":"<p><b><u>Chrome</b></u></p><ol><li>Selecciona el icono de Herramientas</li><li>Haz clic en Configuración.</li><li>Haz clic en Mostrar Opciones Avanzadas.</li><li>En la sección «Privacidad» haz clic en Configuración de contenido. • Eliminar cookies: Haz clic en Todas las cookies y los datos de sitios… • No permitir que se almacenen cookies.</li><li>Haz clic en Eliminar datos de navegación (vaciar la Caché).</li><li>Cierra y reinicia el navegador.</li></ol><p style='font-weight:bold;'>Para más información sobre Chrome pulse <a href='https://support.google.com/chrome/answer/95647?hl=es'>aquí</a>.</p><br>","cookies-8txt2":"<p><b><u>Internet Explorer. Versión 11</b></u></p><ol><li>Selecciona Herramientas | Opciones de Internet.</li><li>Haz clic en la ficha General.</li><li>En la sección «Historial de exploración», haz clic en Eliminar el historial de exploración al salir.</li><li>Seleccionar Eliminar archivos.</li><li>Seleccionar Eliminar cookies.</li><li>Haz clic en Eliminar.</li><li>Haz clic en Aceptar.</li><li>Cierra y reinicia el navegador.</li></ol><p style='font-weight:bold;'>Para más información sobre Internet Explorer pulse <a href='http://windows.microsoft.com/es-419/windows7/how-to-manage-cookies-in-internet-explorer-9'>aquí</a>.</p><br>","cookies-8txt3":"<p><b><u>Firefox. Versión 18</b></u></p><ol><li>Selecciona Firefox | Historial | Limpiar el historial reciente.</li><li>Al lado de «Detalles», haz clic en la flecha hacia abajo.</li><li>Selecciona las siguientes casillas de verificación: Cookies, Caché, Inicios de sesión activos</li><li>Usando el «Intervalo de tiempo para borrar» en el menú desplegable, selecciona Todo.</li><li>Haz clic en Borrar ahora.</li><li>Cierra y reinicia el navegador. Puede aceptar o rechazar las cookies individualmente en las Preferencias de Firefox, en la sección Historial disponible en Herramientas > Opciones > Privacidad.</li></ol><p style='font-weight:bold;'>Para más información sobre Mozilla Firefox pulse <a href='https://www.mozilla.org/es-ES/privacy/websites/#cookies'>aquí</a>.</p><br>","cookies-8txt4":"<p><b><u>Safari Versión 5.1</b></u></p><ol><li>Selecciona el icono de Safari / Editar | Restaurar Safari.</li><li>Selecciona las siguientes casillas de verificación: Borrar el historial, Eliminar todos los datos de sitio web.</li><li>Haz clic en Restablecer.</li><li>Cierra y reinicia el navegador.</li></ol><p style='font-weight:bold;'>Para más información sobre Safari pulse <a href='http://support.apple.com/kb/PH5042'>aquí</a>.</p><br>","cookies-8txt5":"<p><b><u>Opera</b></u></p><ol><li>Opciones – Avanzado – Cookies. Las opciones de cookies controlan el modo en que Opera los maneja y por lo tanto su aceptación o rechazo.</li></ol><p style='font-weight:bold;'>Para más información sobre Ópera pulse <a href='http://help.opera.com/Linux/10.60/es-ES/cookies.html'>aquí</a>.</p><br><p><b><u>Otros navegadores</b></u>: Consulte la documentación del navegador que tenga instalado.</p><br>","cookies-9":"<h4>9. INFORMACIÓN SOBRE LAS TRANSFERENCIAS DE DATOS A TERCEROS PAÍSES REALIZADAS POR OPENHEALTHCARE:</h4><br>","cookies-9txt":"<p>OPENHEALTHCARE no realiza transferencias internacionales a terceros países.<br>En el caso de terceros, puedes informarte de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies en sus correspondientes políticas (ver link política cookies de terceros en la tabla).</p><br>","cookies-10":"<h4>10. ELABORACIÓN DE PERFILES </h4><br>","cookies-10txt":"<p>OPENHEALTHCARE no realiza elaboración de perfiles.</p><br>","cookies-11":"<h4>11. EN RELACIÓN CON EL RESTO DE INFORMACIÓN EXIGIDA POR EL ARTÍCULO 13 DEL RGPD</h4><br>","cookies-11txt":"<p>Les remitimos a la <a href='/politica-privacidad'>Política de Privacidad de OPENHEALTHCARE</a>.</p><br>"}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = {"groups":{"common-questions":"Preguntas comunes"},"faqs":{"existe-algun-tipo-de-publicidad-directa-o-indirecta":"For us, security and transparency are essential elements when we talk about the field of health. For this reason:<br><br>- We do NOT offer professionals the possibility of appearing prominently in search results by contracting a premium account.<br><br>- We do NOT include any type of third-party advertising on our platform or in communications with our users.<br><br>- We do NOT transfer data to third parties for advertising purposes."}}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = {"no-chats-found":"No se han encontrado chats abiertos.","no-forums-found":"No se han encontrado foros abiertos.\t","no-events-found":"No se han encontrado eventos abiertos.\t","newEvent":"Añadir nuevo evento","topic":"Tema","expirationDate":"Fecha de caducidad","healthyCommunityTitle":"Comunidad Saludable","forumSectionDescription":"Comenta tus dudas, pide consejos o comparte tus experiencias con otros pacientes","forumTitle":"Pacientes como tú","newPostTitle":"Nueva entrada {0}","enterPostTitle":"Introduzca un título para la entrada","createNewPost":"Crear nueva entrada","getPostNotifications":"Enviarme notificaciones de respuestas en la entrada","commentaries":"Comentarios","share":"Compartir","save":"Guardar","articleSavedCorrectly":"Artículo guardado correctamente","createNewEntry":"Crear nueva entrada","controlPanel":"Panel de control","publishedBy":"Publicado por","accessBtn":"Acceder","postPublishedCorrectly":"Entrada publicada correctamente","selectImageForEntry":"Seleccione un archivo para la entrada (opcional)","emptyMessageError":"Debe escribir un mensaje","messagePublishedCorrectly":"Mensaje publicado correctamente","emptyTitleError":"Debe introducir un título para la entrada","emptyForumContentError":"Debe introducir un contenido para la entrada","showMoreReplies":"ver más respuestas","moreReplies":"respuestas más","hideMessages":"ocultar mensajes","moreReply":"respuesta más","showMoreEntries":"ver más entradas","userAlias":"Alias de usuario","entries":"Entradas","messages":"Mensajes","emptyForumTagError":"Debe seleccionar una categoría para la entrada","mustEnterEntryCategory":"Debe seleccionar una categoría para la entrada","noEntriesSaved":"No tiene entradas guardadas","noMessagesSaved":"No tiene mensajes guardados","messagePendingValidation":"Su mensaje ha sido publicado correctamente. Será visible una vez se valide.","validations":"Validaciones","validate":"Validar","noMessagesPendingValidation":"No hay mensajes pendientes de validar","myNotifications":"Mis notificaciones","reject":"Rechazar","getNotificactionsOf":"Recibir notificaciones de:","answersOfFavouritesMessages":"Respuestas de mensajes guardados","answersOfFavouritesEntries":"Respuestas de entradas guardadas","newEntries":"Nuevas entradas publicadas","fieldEmpty":"No puede haber campos vacíos en el formulario","messagesReply":"Respuestas a mis mensajes","emptyEntries":"No hay entradas publicadas para esta sección","emptyEntriesSearch":"No hay resultados para su búsqueda.","dateMustBeGreaterThanNow":"La fecha de expiración debe ser mayor que la fecha actual","proposeNewPost":"Proponer nueva entrada","postPublishedCorrectlyPending":"Su entrada ha sido enviada correctamente. Nuestro equipo revisará y valorará su publicación","messagePublishedSuccessfully":"Mensaje publicado correctamente","searchPlaceholder":"Buscar por categoría, título o descripción","noEntriesPendingValidation":"No hay entradas pendientes de validar","shareInSocialMedia":"Comparte en tus redes sociales","link":"Enlace","3monthsDefault":"(3 meses por defecto)","mustEnterEntryTags":"Seleccione una o varias etiquetas para la entrada (opcional)","noTagsAvailables":"No se han encontrado etiquetas para su búsqueda","entryCategoryNotSelected":"Debe seleccionar una categoría para la entrada","like":"Me gusta","moreRecent":"Más reciente","featured":"Destacados","sharingSocialsTitle":"Te recomiendo esta entrada {0} ","sharingSocialsDescription":"Mediante este link podrás acceder a la publicación","searcher":"Buscador","noResults":"Sin resultados","categories":"Categorías","tags":"Etiquetas","forumHeaderText":"Comenta tus dudas, pide consejo o comparte tus experiencias con otros pacientes.","enterOrSearchDiseases":"Seleccione o introduzca una enfermedad para la entrada","mustSelectDisease":"Debe seleccionar o introducir una enfermedad para la entrada","diseasesForum":"Enfermedades","specialistIn":"Especialista en","healthyInformation":"Información saludable","whoIn":"¿Quién se apunta?","consultationIn":"consulta en","mustEnterEntrySection":"Seleccione una sección para la entrada","entrySectionNotSelected":"Debe seleccionar una sección para la entrada","infoNick":"En este campo puede modificar el nombre de usuario que será visible por el resto de usuarios de la plataforma","infoEmail":"En este campo puede modificar el email de notificaciones de la plataforma","patientsLikeYou":"Pacientes como tú","whoInSectionDescription":"Organiza planes saludables con tus compañer@s","healthyInformationSectionDescription":"Mantente informado de las últimas noticias de salud y bienestar","removePostAdvice":"¿Desea eliminar esta entrada?","healthyCommunityHeaderText":"¡Organiza planes y comparte experiencias e información de salud y bienestar con tus compañer@s!","noPendingPushNotifications":"No tiene notificaciones pendientes","notifications":"Notificaciones","removePushNotifications":"¿Desea borrar su historial de notificaciones?","newPushNotifications":"Tiene {numberNotifications} mensaje{plural}/entrada{plural} sin leer","favourite":"Favorito","saveds":"Guardados","removeHistory":"Borrar notificaciones","settingNotifications":"Configurar notificaciones","panelEntryTags":"Seleccione una o varias etiquetas","panelEntryCategory":"Seleccione una o varias categorias","mustSelectCategory":"Debe seleccionar al menos una categoría","mustSelectTags":"Debe seleccionar al menos una etiqueta","notReceiveEmails":"No recibir emails","receiveEmails":"Recibir emails","in":"en","selectImage":"Seleccione una imagen (opcional)","newPostDescription":"Descripción de la entrada","whoInNewPostDescription":"Deporte/actividad, Fecha, Hora, Nº personas, Ubicación, etc...","firstAccessForum":"Para mantenerse informado sobre el contenido que guarde y configurar sus notificaciones, no olvide activar las notificaciones en su \"Panel de control\", situado al hacer click en sus iniciales en la esquina superior derecha.","welcomeTo":"Bienvenido a {0}","healthyCommunityFirstAccessTitle":"la Comunidad Saludable","whoInNewPost":"<p>Actividad: {activityName}</p><p>Nivel: {activityLevelName}</p><p>Fecha: {date}</p><p>Hora inicio: {startHour}</p><p>Hora fin: {endHour}</p><p>Ubicación: {address}, {stateName}, {cityName}, {countryName}</p><p>Comentarios: {commentaries}</p>","removeMessageAdvice":"¿Desea elimininar este mensaje?","messageDeleted":"Mensaje eliminado","goOpenhealth":"Ir a Opensalud360","edited":"Editado","loginFromArticle":"Si desea ver los comentarios y participar en esta entrada, debe iniciar sesión haciendo click aquí: ","panelEmailInterval":"Seleccione intervalo de notificaciones","eachDay":"Cada día","eachWeek":"Cada semana","eachMonth":"Cada mes","mustSelectEmailsInterval":"Debe seleccionar un intervalo de notificaciones para los emails","lastMessage":"Último mensaje","lastInteraction":"Última interacción","companiesAccessRestrictedMessage":"Su código de empresa tiene acceso restringido a comunidad saludable, por lo que será redirigido a pacientes como tú","forbiddenMinorUser":"El acceso está restringido para los pacientes menores de edad.","reportMessage":"Reportar","reportMessageTitle":"Indique el motivo del reporte:","reportmessageSendConfirmation":"El reporte ha sido enviado con éxito.","mustIntroduceReportReasons":"Debe introducir el motivo del reporte","reports":"Reportes","noMessagesReported":"No hay mensajes reportados","noRemove":"No eliminar","firstAccessNickForum":"A continuación, puede establecer el nombre que aparecerá en sus publicaciones. Puede introducir simplemente unas iniciales, un apodo… Recuerde que este nombre es visible para el resto de usuarios registrados. ","firstAccessFooterForum":"Le recordamos que no es posible enviar mensaje privados entre usuarios a través de la plataforma.","emptyNick":"Debe introducir el nombre que aparecerá en sus publicaciones","monthlyAccessAdvice":"¡Tu experiencia puede ayudar a otros usuarios! Recuerda que tu perfil es anónimo y que nadie puede contactar contigo directamente.","infoName":"Nombre de registro","selectActivity":"Seleccione una actividad","selectActivityLevel":"Seleccione un nivel","selectState":"Seleccione una provincia","selectCountry":"Seleccione un país","selectCity":"Seleccione un municipio","activityTitle":"Introduzca un título para la actividad","newActivity":"Nueva actividad","insertActivityName":"Introduzca el nombre de la actividad","otherActivity":"Otra actividad...","activityDuration":"Duración (en minutos)","startHour":"Hora inicio","endHour":"Hora fin","level":"Nivel","activity":"Actividad","hourEndGreaterThanStart":"La hora de inicio debe ser inferior a la de fin","mustSelectActivity":"Debe seleccionar una actividad","mustSelectActivityLevel":"Debe seleccionar un nivel","mustSelectState":"Debe seleccionar una provincia","mustSelectCity":"Debe seleccionar un municipio","mustSelectAddress":"Debe introducir una dirección","mustInsertOtherActivity":"Debe introducir el nombre de la actividad","dateEndGreaterThanStart":"La fecha de inicio debe ser inferior a la de fin","dateEndGreaterThanToday":"La fecha de fin debe ser superior a la actual","dateStartGreaterThanToday":"La fecha de inicio debe ser superior a la actual","proposeNewActivity":"Proponer nueva actividad","participantsLimit":"Límite de participantes","participantsLimitGreaterThan2":"El número de participantes debe ser mayor que 2","whoInDataTitles":{"activity":"Actividad","activityLevel":"Nivel","country":"País","state":"Provincia","city":"Municipio","startDate":"Inicio","endDate":"Fin","commentaries":"Comentarios","address":"Dirección","otherActivity":"Actividad","participants":"Participantes"},"signUpWhoIn":"Me apunto","noAssistWhoInActivity":"No asistir","activityUpdatedCorrectly":"La actividad ha sido actualizada","participantsLimitLowerThenCurrentParticipants":"El límite de parcitipantes debe ser superior a los participantes actuales ({participants})","searchWhoInPlaceholder":"Buscar una actividad","timeOfDay":{"morning":"Mañana (6:00-12:00)","afternoon":"Tarde (12:00-18:00)","night":"Noche (18:00-24:00)"},"participantsLimitsReached":"Se ha alcanzado el número máximo de participantes para esta actividad","noActivitiesToSearch":"No hay actividades disponibles en este momento","emptyActivitiesSearch":"No se han encontrado actividades para su búsqueda.","resetFilters":"Eliminar filtros","endDateNotSelected":"Si selecciona la hora de fin, debe seleccionar la fecha de fin de la actividad","startDateNotSelected":"Si selecciona la hora de inicio, debe seleccionar la fecha de inicio de la actividad","only-subscriptors-warning":"Este contenido es sólo para suscriptores.","only-subscriptors":"Solo suscriptores","showMoreDetails":"Ver más detalles","comment":"Comentar","showDetails":"Ver detalles","hideDetails":"Ocultar detalles"}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = {"healthyHabitsTitle":"Mis objetivos y hábitos","of":"de","doubleClickChangeValue":"Haga doble click en un valor para cambiarlo","enterNewValue":"Introduzca un valor","tableInfoTitle":"Información sobre la tabla","tableInfo":"- Para modificar sus mediciones o introducir nuevos valores, puede hacerlo directamente sobre la tabla, haciendo click en el valor correspondiente.","tableInfo2":"- Si desea realizar cambios en la configuración del objetivo, haga click en el lápiz que aparece a la izquierda de su descripción.","enterValidNumber":"Introduzca un número válido","noDataFound":"No se han encontrado resultados para su búsqueda","clear":"Limpiar","week":"Semana","total":"Total","historyTitle":"Historial","to":"a","weeks":"Semanas","monthsTitle":"Meses","yearsTitle":"Años","frequency":"Frecuencia","day":"Día","daily":"Diariamente","each":"Cada","weekly":"Semanalmente","monthly":"Mensualmente","timesToWeek":"veces a la semana","timesToMonth":"veces al mes","selectAnOption":"Seleccione una opción","selectAnHour":"Seleccione una hora","checkInvalidFormData":"Compruebe los campos marcados en rojo","mustSelectOption":"Debe seleccionar una opción","mustEnterValidNumber":"Debe introducir un número válido","valuesBetween":"valores entre","notmeasurable":"No cuantificable","measurable":"Cuantificable","measurableExamples":"(pasos, kilos...)","notMeasurableExamples":"(Sí/No)","selectHabitType":"Seleccione un objetivo:","hideCompletedHabits":"Ocultar completados","clickChangeValue":"Haga click en un valor para cambiarlo","newHabit":"Nuevo objetivo","currentStreak":"Racha actual","bestStreak":"Mejor racha","totalWeek":"Total semana","totalMonth":"Total mes","totalYear":"Total año","add":"Añadir","mustInsertValue":"Debe introducir un valor válido","extra":"extra","tableInfo3":"- Puede visualizar su progreso con gráficos detallados por intervalos de tiempo haciendo click en el icono del gráfico.","firstNewHabit":"¡Añada su primer objetivo!","tableInfo4":"- Para eliminar un objetivo o marcarlo como archivado, pulse en la papelera y seleccione la acción correspondiente.","maxhealthyHabitsReached":"El número máximo de objetivos simultáneos es 10. Si desea agregar un nuevo objetivo, debe borrar o archivar uno actual.","reminderDays":"Días recordatorio","selectOneMoreOption":"Seleccione una o varias opciones","mustSelectColor":"Debe seleccionar un color","whatWantToDo":"¿Qué desea hacer?","showStoredHabits":"Mostrar objetivos archivados","insertValidPhone":"Introduzca un número de teléfono válido","insertValidEmail":"Introduzca un email válido","allowFreeDays":"Permitir días libres","allowFreeDaysAdvice":"Al deshabilita esta opción, sus días libres se tratarán como días no completados.<br><br>¿Desea continuar?","atHour":"a las","off":"Apagado","tableInfo6":"- Si desea ordenar los objetivos, mantenga pulsado y arrastre el objetivo a la nueva posición.","sessionExpired":"Su sesión ha expirado. Será redirigido para volver a iniciar sesión.","store":"Archivar","remove":"Eliminar","notificationsPhoneTooltip":"Teléfono de notificaciones (Si no desea recibir notificaciones por whatsapp, deje en blanco este campo)","mustEnterValidInteger":"Debe introducir un número entero","percentage":"Porcentaje","weekShort":"Sem","totalWeekShort":"Total sem","summary":"Resumen","remaining":"Restante","showGoalCompletedHabits":"Mostrar objetivos completados","congratulations":"¡Enhorabuena!","goalCompletedText":"Ha completado su objetivo al 100%. Recuerde que puede mostrar en la tabla sus objetivos completados habilitando la opción \"Mostrar objetivos completados\" en su configuración.","tableInfo7":"- Puede modificar la configuración de la tabla y otros valores como su email/teléfono de notificaciones pulsando en \"Configuración\".","nameFormPlaceholder":"Descripción (Ej. Andar)","questionFormPlaceholder":"Pregunta (Ej. ¿He andado hoy?)","UnitFormPlaceholder":"Unidad (Ej. Páginas)","nameFormMeasurablePlaceholder":"Descripción (Ej. Leer)","questionFormMeasurablePlaceholder":"Pregunta (Ej. ¿Cuántas páginas he leído?)","goalFormPlaceholder":"Objetivo (Ej. 15)","showMore":"ver más","showMoreAdvice":"Haga click en las flechas laterales para ver más estadísticas","invertCalendarDays":"Invertir orden días calendario","newChallenge":"Nuevo reto","firstNewChallenge":"¡Añada su primer reto saludable!","reset":"Restablecer","predefined-walk-question":"¿Cuánto he andado?","predefined-walk":"Andar","predefined-run":"Correr","predefined-run-question":"¿Cuántos kilómetros he corrido hoy?","predefined-bike":"Bicicleta","predefined-bike-question":"¿Cuántos kilómetros he hecho esta semana?","predefined-swim":"Nadar","predefined-swim-question":"¿He nadado?","predefined-lose-weight":"Perder peso","predefined-lose-weight-question":"¿Cuánto peso he perdido esta semana?","predefined-smoke":"Dejar de fumar","predefined-smoke-question":"¿He dejado de fumar hoy?","predefined-sleep-better":"Horas de sueño","predefined-sleep-better-question":"¿He dormido mejor?","predefined-week-exercise":"Ejercicio semanal","predefined-week-exercise-question":"¿He hecho ejercicio?","predefined-drink-alcohol":"Consumo alcohol","predefined-meditation":"Meditar","predefined-meditation-question":"¿He hecho meditación?","predefined-go-gym":"Ir al gimnasio","predefined-go-gym-question":"¿He ido al gimnasio?","predefined-drink-alcohol-question":"¿He dejado de consumir alcohol?","predefined-read":"Leer","predefined-read-question":"¿Cuántas páginas he leído hoy?","createOwnHabit":"O cree su propio objetivo:","pagesHabit":"Páginas","doubts":"Dudas","faq-table":"Tabla","question-table-1":"¿Cómo puedo añadir nuevos objetivos?","answer-table-1":"Existen dos formas de añadir nuevos objetivos:<br><br>1) Seleccionando un objetivo predefinido: los cuales aparecerán encima de la tabla si aún no ha registrado ningún objetivo o en la ventana destinada a agregar nuevos objetivos.<br>2) Creando un objetivo personalizado: Puede crearlos haciendo click en el botón \"Nuevo objetivo\" en la tabla y configurarlo a su gusto.","question-table-2":"¿Puedo editar un objetivo creado?","answer-table-2":"Sí. Puede editar cualquier objetivo que haya creado haciendo click en el lápiz que aparece a la izquierda de la descripción del mismo.","question-table-3":"¿Cómo puedo ver las estadísticas de un objetivo?","answer-table-3":"Para ver las estadísticas de un objetivo, puede hacer click en el gráfico de barras que aparece a la izquierda de la descripción del mismo.","question-table-4":"¿Puedo eliminar o archivar un objetivo ya creado?","answer-table-4":"Claro. Para eliminar o archivar un objetivo, debe pulsar en el botón de la papelera que aparece a la izquierda del objetivo. Allí se le preguntará cuál es la acción que desea ejecutar.","question-table-5":"¿Cómo puedo ver los días de la semana anteriores?","answer-table-5":"Para ver más días en la tabla, puede hacer click en la flecha que aparece en la parte superior de la misma. Si está en un dispositivo móvil, también puede hacer un gesto hacia la dirección en la que desee ver más fechas.","question-table-6":"¿Qué significa la barra que aparece debajo de la descripción del objetivo?","answer-table-6":"En esa barra se mide el porcentaje de <b>progreso actual</b> del objetivo.<br>Por ejemplo, para un objetivo no cuantificable, si está configurado para 3 días a la semana, se completará al 100% si en la semana actual se han marcado al menos 3 días.<br>Para un objetivo que esté configurado mensualmente y sea cuantificable, se marcará al 100% cuando se supere el objetivo establecido en el mes actual.","question-table-7":"¿Qué significan los símbolos que aparecen debajo de cada fecha?","answer-table-7":"Para los objetivos cuantificables, aparecerá un valor junto con la unidad de medida que haya establecido.<br><br>Para los objetivos no cuantificables, existen 3 tipos de símbolos:<br><br><b>Tick:</b> Indica que ese día se ha compleado el objetivo.<br><b>Guión:</b> Indica que ese día se ha marcado como libre.<br><b>X:</b> Indica que ese día no se ha completado el objetivo.<br><br>Por defecto los días libres están habilitados, pero puede deshabilitarlos haciendo click en el botón de configuración en la parte superior de la pantalla.","question-table-8":"¿Cómo puedo marcar un día como completado o introducir un valor?","answer-table-8":"Para marcar un día como completado o cambiar entre los diferentes estados (no completado o día libre), debe hacer click en el símbolo que aparece debajo de cada fecha.<br><br> En el caso de los objetivos cuantificables, podrá introducir un valor determinado.","question-table-9":"¿Qué indican las tres últimas columnas de la tabla?","answer-table-9":"Existen 3 grupos diferentes de 3 columnas cada uno, en el que se reflejan diferentes estadísticas básicas del objetivo.<br><br>Primer grupo:<br><br><b>Racha actual:</b> Indica el número de días consecutivos que ha completado el objetivo desde la fecha actual. Si algún día es marcado como libre en esa racha, no se contabilizará y, por lo tanto, no romperá la racha.<br><b>Mejor Racha:</b> Indica la mayor racha de días consecutivos completados a lo largo del objetivo.<br><b>Total:</b> Muestra el total de días en los que se ha rellenado algún dato del objetivo.<br><br>Segundo grupo:<br><br>Muestra la suma semanal/mensual/anual de los objetivos rellenados en esos intervalos de tiempo.<br><br>Tercer grupo:<br><br>Indica los porcentajes de días semanales/mensuales/anuales en los que se ha rellenado algún dato.<br><br>Puede alternar los diferentes bloques haciendo click en 'ver más' debajo de los mismos o en las flechas.","question-table-10":"¿Por qué aparecen datos semitransparentes de colores?","answer-table-10":"Los datos semitransparentes mostrados en la tabla indican que se ha completado el objetivo en ese periodo de tiempo.<br><br>Por ejemplo, si un objetivo se completa cada 3 días y marca el día actual como completado, los siguientes 2 días estarán semi-completados. Igualmente, puede marcar esos días como completados, pero no es necesario.","faq-config":"Configuración","question-config-1":"¿Qué puedo configurar?","answer-config-1":"Haciendo click en el botón de configuración que aparece en la esquina superior derecha puede configurar los siguiente elementos:<br><br><b>Mostrar objetivos archivados:</b> Permite mostrar/ocultar los objetivos archivados en la tabla.<br><b>Mostrar objetivos completados:</b> Permite mostrar/ocultar los objetivos completados en la tabla.<br><b>Permitir días libres:</b> Le permite marcar los días como libres y que no cuenten para las rachas.<br><b>Invertir orden de los días  del calendario</b>: Alterna el orden en el que se muestran los días en el calendario, es decir, decreciendo hacia la derecha o hacia la izquierda.<br><b>Email:</b> Puede establecer el email en el que recibirá las notificaciones de los recordatorios que configure.<br><b>Teléfono:</b> Puede establecer el teléfono en el que recibirá las notificaciones de los recordatorios que configure.","faq-statistics":"Estadísticas","question-table-11":"¿Cuándo se completa un objetivo?","answer-table-11":"Para determinar si un objetivo ha sido completado, se usa un algoritmo de suavizado exponencial, en el que se calcula el promedio ponderado desde el primer día del objetivo hasta el día actual, dando más importancia a los días actuales.<br><br>Por ejemplo, para un objetivo diario, se alcanzaría un 80% el primer mes, un 96% a los dos meses y un 100% a los 100 días.","question-statistics-1":"¿Qué información aparece en la parte superior?","answer-statistics-1":"En la parte superior aparecen los siguientes datos:<br><br>- La pregunta que haya establecido al crear el formulario.<br>- El intervalo de repetición del objetivo<br>- El recordatorio, en caso de que lo haya configurado al crear el objetivo.","question-statistics-2":"¿Qué indica la sección de Objetivo?","answer-statistics-2":"Esta sección solo está disponible para los objetivos cuantificables e indica la suma semanal/mensual/anual de los valores establecidos en esos intervalos.","question-statistics-3":"¿Qué es el calendario?","answer-statistics-3":"En el calendario se indica la misma información que puede ver en la tabla, pero en un rango de 4 meses desde la fecha actual.<br>Puede interaccionar con el calendario de la misma forma que con la tabla.","question-statistics-4":"¿Que información se muestra en las tablas de estadísticas?","answer-statistics-4":"Existen 3 tablas estadísticas:<br><br><b>Puntuación:</b> Refleja la puntuación calculada por el algoritmo de suavizado exponencial. Puede ver las puntuaciones agrupadas por días/semanas/meses/años.<br><br><b>Historial:</b> Muestra la suma de los valores registrados para el objetivo en intervalos de semana/mes/año.<br><br><b>Frecuencia:</b> Indica la frecuencia con la que se han completado los días de cada mes en el último año. Puede ver los valores agrupados en ese intervalo haciendo click en el círculo.","tableInfo8-1":"- Para más información, puede acceder a la sección de preguntas frecuentes haciendo","tableInfo8-2":"pulse aquí.","question-table-12":"¿Qué indica el trofeo que aparece en la parte superior de la pantalla?","answer-table-12":"Muestra la mejor racha conseguida, teniendo en cuenta todos sus objetivos.","mustInsertPositiveValue":"Debe introducir un valor positivo","dailyShort":"Diario","weeklyShort":"Semanal","calendarInfo":"Puede interaccionar con el calendario de la misma forma que en la tabla principal de objetivos. De esta forma, puede añadir nuevos datos haciendo click en alguna fecha del calendario.","monthlyShort":"Mensual","showLess":"ver menos","lessRecent":"menos reciente","moreRecentHabit":"más reciente","freeDay":"Día libre","healthyHabitsTable":"Tabla","partialCompleted":"Completado parcialmente","uncompleted":"No completado","nonMeasurable":"No cuantificable","measurableInfo":"- Completado: Si el valor está relleno con el color seleccionado para el objetivo.","measurableInfo2":"- Completado parcialmente: Si el valor está semitransparente.","tableInfo8":"- Para más información sobre los símbolos de la tabla, haga","healthyHabitsGeneral":"General","stadistics":"Estadísticas","removeOrStore":"Borrar o archivar","restore":"Restaurar","stored":"Archivado","progressBar":"Barra de progreso actual","legend":"Leyenda","completedDay":"Día completado","calendarLegendColorInfo":"El color del relleno de los días del calendario dependerá del color seleccionado al crear el objetivo.","notCompletedDay":"Día no completado","filled":"Valor introducido","predefined-drink-water":"Beber agua","predefined-drink-water-question":"¿Cúantos litros he bebido?","liters":"Litros","meters":"Metros","typeUserNames":"Escriba el nombre de los usuarios","typeUserEmails":"Introduzca los emails de los pacientes","typePatientEmailAdvice":"Escriba el email del paciente a retar y pulse intro","checkInvalidMultiUserEmail":"Revise que los emails/teléfonos de pacientes introducidos sean correctos","multiUserUncompleted":"no ha completado el objetivo este día.","multiUserCompleted":"ha completado el objetivo este día.","multiUserDayFree":"ha marcado el día como libre.","multiUserMeasurableCompleted":"ha completado el objetivo este día con {value} {unit}.","multiUserMeasurablePartialCompleted":"ha completado el objetivo este día parcialmente con {value} {unit} de {goal} {unit}.","invitePatientsMultiUser":"Invitar a usuarios a realizar el objetivo","typeUserEmailsOrPhones":"Introduzca los emails/teléfonos de los usuarios registrados","typePatientEmailOrPhoneAdvice":"Escriba el email/teléfono del usuario registrado y pulse intro","multiUserInviteLimitExceeded":"El número máximo de invitaciones es 9","inviteMultiUserInfo":"Puede invitar a otros usuarios registrados en la plataforma, para ver los resultados de cada uno en su tabla de forma conjunta. Recuerde que los usuarios invitados deben estar registrados con el email/teléfono al que envíe la invitación.","multiUserPartialCompleted":"ha completado el objetivo este día parcialmente.","professionalNotAllowed":"Actualmente solo puede acceder a los objetivos a través de la historia clínica de sus pacientes, en la cual puede agregar nuevos objetivos a los mismos.","predefined-more-time-in-family-question":"¿Has pasado más tiempo en familia?","predefined-more-time-in-family":"Tiempo familiar","predefined-ultra-processed-foods":"Alimentos ultraprocesados","predefined-ultra-processed-foods-question":"¿Has consumido menos alimentos ultraprocesados?","predefined-argue-less":"Discutir menos","predefined-argue-less-question":"¿Has discutido menos?"}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = {"legal-title":"<div class='type-intro-title'>Aviso Legal</div><br/>","legal-intro":"<p>OPENHEALTHCARE S.L., sociedad española responsable del sitio www.openhealthcare.es, en adelante RESPONSABLE, pone a disposición de los usuarios el presente documento, con el que pretende dar cumplimiento a las obligaciones dispuestas en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSICE), así como informar a todos los usuarios del sitio web respecto a cuáles son las condiciones de uso.</p><br><p>Toda persona que acceda a este sitio web asume el papel de usuario, comprometiéndose a la observancia y cumplimiento riguroso de las disposiciones aquí dispuestas, así como a cualquier otra disposición legal que fuera de aplicación.</p><br><p>OPENHEALTHCARE S.L., se reserva el derecho de modificar cualquier tipo de información que pudiera aparecer en el sitio web, sin que exista obligación de preavisar o poner en conocimiento de los usuarios dichas obligaciones, entendiéndose como suficiente con la publicación en este sitio web.</p><br>","legal-1":"<h4>1. DATOS IDENTIFICATIVOS</h4><br>","legal-1txt":"<p>Nombre de dominio: www.openhealthcare.es</p><p>Denominación social: OPENHEALTHCARE S.L</p><p>CIF: B90209081</p><p>Dir. Postal: Avda. República Argentina 25 9ª planta, 41011 Sevilla</p><p>Teléfono: +34 656 383 230</p><p>Email: info@openhealthcare.eu</p><p>Inscrita en el Registro Mercantil de Sevilla en el tomo 6043, folio 101 inscripción 1 con hoja SE-105834</p><br>","legal-2":"<h4>2. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL</h4><br>","legal-2txt":"<p>El sitio web, incluyendo a título enunciativo pero no limitativo su programación, edición, compilación y demás elementos necesarios para su funcionamiento, los diseños, logotipos, texto y/o gráficos, son propiedad del RESPONSABLE o, si es el caso, dispone de licencia o autorización expresa por parte de los autores. Todos los contenidos del sitio web se encuentran debidamente protegidos por la normativa de propiedad intelectual e industrial, así como inscritos en los registros públicos correspondientes. Independientemente de la finalidad para la que fueran destinados, la reproducción total o parcial, uso, explotación, distribución y comercialización, requiere en todo caso de la autorización escrita previa por parte del RESPONSABLE. Cualquier uso no autorizado previamente se considera un incumplimiento grave de los derechos de propiedad intelectual o industrial del autor.</p><br>","legal-3":"<h4>3. EXENCIÓN DE RESPONSABILIDADES</h4><br>","legal-3txt":"<p>El RESPONSABLE se exime de cualquier tipo de responsabilidad derivada de la información publicada en su sitio web siempre que esta información haya sido manipulada o introducida por un tercero ajeno al mismo.</p><br>","legal-4":"<h4>4. POLÍTICA DE ENLACES</h4><br>","legal-4txt":"<p>Desde el sitio web, es posible que se redirija a contenidos de terceros sitios web. Dado que el RESPONSABLE no puede controlar siempre los contenidos introducidos por los terceros en sus respectivos sitios web, no asume ningún tipo de responsabilidad respecto a dichos contenidos. En todo caso, procederá a la retirada inmediata de cualquier contenido que pudiera contravenir la legislación nacional o internacional, la moral o el orden público, procediendo a la retirada inmediata de la redirección a dicho sitio web, poniendo en conocimiento de las autoridades competentes el contenido en cuestión.</p><br><p>El RESPONSABLE no se hace responsable de la información y contenidos almacenados, a título enunciativo pero no limitativo, en foros, chats, generadores de blogs, comentarios, redes sociales o cualquier otro medio que permita a terceros publicar contenidos de forma independiente en la página web del RESPONSABLE. Sin embargo, y en cumplimiento de lo dispuesto en los artículos 11 y 16 de la LSSICE, se pone a disposición de todos los usuarios, autoridades y fuerzas de seguridad, colaborando de forma activa en la retirada o, en su caso, bloqueo de todos aquellos contenidos que puedan afectar o contravenir la legislación nacional o internacional, los derechos de terceros o la moral y el orden público. En caso de que el usuario considere que existe en el sitio web algún contenido que pudiera ser susceptible de esta clasificación, se ruega lo notifique de forma inmediata al administrador del sitio web.</p><br><p>Este sitio web ha sido revisado y probado para que funcione correctamente. En principio, puede garantizarse el correcto funcionamiento los 365 días del año, 24 horas al día. Sin embargo, el RESPONSABLE no descarta la posibilidad de que existan ciertos errores de programación, o que acontezcan causas de fuerza mayor, catástrofes naturales, huelgas o circunstancias semejantes que hagan imposible el acceso a la página web.</p><br>","legal-5":"<h4>5.DIRECCIONES IP</h4><br>","legal-5txt":"<p>Los servidores del sitio web podrán detectar de manera automática la dirección IP y el nombre de dominio utilizados por el usuario. Una dirección IP es un número asignado automáticamente a un ordenador cuando éste se conecta a Internet. Toda esta información es registrada en un fichero de actividad del servidor debidamente inscrito que permite el posterior procesamiento de los datos con el fin de obtener mediciones únicamente estadísticas que permitan conocer el número de impresiones de páginas, el número de visitas realizadas a los servidores web, el orden de visitas, el punto de acceso, etc.</p><br>","legal-6":"<h4>6. LEY APLICABLE Y JURISDICCIÓN</h4><br>","legal-6txt":"<p>Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los Juzgados y Tribunales de Sevilla.</p><br>","legal-7":"<h4>7. RECLAMACIONES</h4>","legal-7txt":"<p>Si usted desea presentar una reclamación ante OPENHEALTHCARE S.L. puede realizarla en el correo quejas@opensalud.es</p>"}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = {"openlegal":{"menu":{"for-you-and-your-family":"Para ti y tu familia","for-business":"Para Empresas","for-freelancers":"Autónomos","sign-in":"Acceder","are-you-lawyer":"¿Eres abogado?","business":"Empresas"},"title":"Estamos aquí para ayudarte","subtitle":"El mejor asesoramiento legal para ti y tú familia, en cualquier momento y desde cualquier lugar.","home-subtitle":"Accede a los mejores abogados de una forma fácil y segura.","more-info":"Más información","cards":{"first":{"title":"Cuando lo necesitas","description":"En tu hogar, de viaje, en vacaciones estés donde estés, accede por video, teléfono, mensajería o chat al abogado que necesitas."},"second":{"title":"Cómodo y seguro","description":"Podrás en cualquier momento y desde cualquier lugar, acceder de manera presencial, vídeo, teléfono o chat a tú abogado."},"third":{"title":"Cuida de ti y tú familia","description":"Desconocer tus derechos, o tomar decisiones sin un adecuado asesoramiento, puede tener graves consecuencias para ti  o para tu familia."},"fourth":{"title":"Especialistas en tus derechos","description":"Consumo, vivienda, impagos, laboral, multas, fiscal, seguros, familia… encuentra el abogado adecuado a tus necesidades."}},"advantages":"Ventajas de openlegal","best-legal-services":"El mejor servicio legal para empresas y particulares","for-freelancers":"openlegal para autónomos","contact-form":{"text":"Si quieres contarnos tu caso o solicitar información sobre el servicio, contáctanos"},"find-lawyer":"Encontrar un abogado","explain-case":"Contacta con nosotros","home-cards":{"first":{"title":"El profesional adecuado","description":"Evaluamos individualmente a cada profesional, para que puedas acceder al mejor asesoramiento legal, tanto presencial como online, con el mejor precio."},"second":{"description":"Podrás en cualquier momento y desde cualquier lugar, acceder por vídeo, teléfono o chat al abogado que necesitas, en un entorno de máxima seguridad."},"fourth":{"title":"Plataforma profesional de video","description":"Segura y privada. No requiere que los usuarios estén registrados (Teams, Zoom…)"}},"search-ph":"¿En qué podemos ayudarte?","search":"Buscar","are-you-lawyer":"¿Eres un abogado destacado?, ¿te interesa el mundo digital?,\n\n¿quieres ganar visibilidad para acceder a nuevos clientes?","sign-up-in":"Regístrate en","security-privacity":"Seguridad y privacidad.","security-subtitle":"Todo lo que necesitas con el máximo nivel de protección.","security-text1":"La seguridad de las comunicaciones y privacidad de los datos son nuestra prioridad.","security-text2":"Ponemos a tu disposición la mejor tecnología con la máxima seguridad en las comunicaciones y total privacidad de tus datos. Nuestra plataforma cuenta con la certificación ISO 27001.","lawyer-block-description":"Web propia, agenda online, video y chat profesional, máxima seguridad, facturación, pasarela de pago…\n\nen sólo 20 minutos puedes digitalizar tu despacho y acceder a clientes de cualquier lugar.","form-reason":"Motivo de contacto","companies":"Algunos clientes de opensalud y openlegal"},"card":{"title-video":"Plataforma profesional de vídeo"}}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = {"os360-empresas":{"more-info-btn":"Más info","know-more-btn":"Saber más","main-block":{"title":"La plataforma de salud y bienestar 360 para empresas.","subtitle":"Expertos en cuidar a tus equipos.","paragraph":"opensalud360 permite a tus empleados, clientes o asegurados, acceder a los mejores médicos, psicólogos o nutricionistas, los mejores programas de bienestar y la aplicación de salud más completa, en cualquier momento y desde cualquier lugar.","more-info":"+ Info"},"more-information-btn":"Más información","big-companies":{"request-info":"Solicitar información"},"blocks":{"teleconsultation":{"title":"Consultas online","description":"Médicos, psicólogos, nutricionistas y otras especialidades con libre elección"},"wellness":{"title":"opensaludWellness","description":"Clases diarias en directo, talleres, gimnasio online, meditación, programas y mucho más..."},"evaluate-your-health":{"title":"Evalúa tu salud","description":"Evaluación bienestar emocional, alimentación, riesgo enfermedades y mucho más"},"healthy-habits":{"title":"Alimentos y Hábitos saludables","description":"Alimentos que te cuidan, retos e información para mejorar tus hábitos"},"opensaludpass":{"title":"opensaludPass","description":"Consultas, pruebas diagnósticas y tratamientos presenciales a precio reducido","soon":"Próximamente"},"healthy-community":{"title":"Comunidad saludable","description":"Comparte tu experiencia de salud y bienestar y haz propuestas de planes saludables a tus compañeros"},"digital-phisiotherapy":{"title":"Fisioterapia digital","description":"Guiado por Inteligencia Artificial y monitorizado por fisioterapeutas"},"title":"Bienvenido a","more-info-question":"¿Necesitas más información?","what-do-you-need":"¿Qué necesitas?"},"wellness-services":{"title":"<b>Wellbeing Score®</b><br>Conoce el estado de salud y bienestar de tu plantilla.","subtitle":"Ofrece a tus empleados un autodiagnóstico de salud y bienestar con planes de acción individuales.","cards":{"1":{"title":"Bienestar físico","subtitle":"Hábitos de movimiento, alimentación, descanso y sueño y vigilancia de la salud."},"2":{"title":"Bienestar emocional","subtitle":"Índice de felicidad y desconexión, gestión de incertidumbre y estrés y capacidad de trabajo."},"3":{"title":"Bienestar entorno","subtitle":"Entorno personal, profesional y digital, hábitos de sostenibilidad y medioambiente y riesgos psicosociales."},"4":{"title":"Bienestar social","subtitle":"Nivel de apoyo social, bienestar financiero, nivel de conciliación, apertura a diversidad, talento y habilidades interpersonales."}}},"social-benefit":{"title":"Cuidamos lo más importante de tu empresa, tus empleados","subtitle":"Proporcionamos un beneficio muy valorado por los empleados y de gran impacto para la empresa.","list":{"1":"Empleados física y mentalmente, más sanos","2":"Menores tasas de @:global.absentismo","3":"Mejora la conciliación","4":"Empleados más felices y comprometidos","5":"Aumenta el rendimiento de tus equipos","6":"Mejora la retención y la atracción"},"security-description":"Y lo hacemos con la máxima seguridad en las comunicaciones y total privacidad de tus datos. Nuestra plataforma cuenta con la certificación ISO 27001 y está auditada por la Organización Médica Colegial."},"companies":"30 empleados o 30.000, tenemos una solución adaptada a tus necesidades y presupuesto.","companies2":"Con más de 1.000 profesionales de la salud disponibles y más de 50 programas de salud y bienestar, grandes compañías e instituciones confían en nosotros para cuidar la salud y el bienestar de sus empleados y clientes en <b> España, Portugal, México y Brasil. </b>","opensalud-empresas":{"form-subtitle":"Si quieres que tus empleados accedan a los mejores servicios de salud y bienestar digital, contáctanos."},"psychological-attention":{"title":"El reto de la salud mental y emocional en las empresas","subtitle":"La salud mental y emocional como motor de bienestar y productividad","text":"Partíamos de un estado general de salud mental y emocional frágil, que la actual situación ha terminado por desbordar y que va a tener un enorme impacto en el presente y en el futuro las organizaciones.","quote":"El trabajo más productivo es el que sale<br> de las manos de una persona contenta","title-2":"La importancia de la detección temprana y la prevención","text-2":"Estos problemas no suelen ser fáciles de detectar externamente hasta que el deterioro es más evidente y las soluciones costosas. Por eso es clave proporcionar a los empleados soluciones de calidad y muy accesibles, que les permitan gestionar el problema en las fases iniciales.","subtitle-2":"Ansiedad, estrés, depresión, problemas familiares y de pareja, gestión del cambio… son situaciones que podemos superar si contamos con las herramientas y el apoyo profesional adecuado."}}}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más info","main-block-h1":"Bienvenido al futuro de los servicios de salud y bienestar para empresas","more-information-btn":"Más información","know-more-btn":"Saber más","discounts":{"title":"Descuentos en servicios clínicos privados","subtitle":"Si necesitas una prueba y no quieres esperar<br /><br />Acceso al mayor cuadro de servicios de salud de España con más de 25.000 profesionales y centros con descuentos de hasta el 60% en consultas, intervenciones, pruebas, tratamientos, productos y servicios de salud:","clinic-services":"Servicios clínicos","clinic-services-description":"Permite el acceso a facultativos y centros médicos que conforman el Cuadro Médico del Servicio 'AVANTSALUD':","close":"Cerrar","teeth-services-description":"Este servicio comprende determinados servicios dentales gratuitos y el acceso a un Cuadro de Facultativos a precio baremado. Los servicios dentales gratuitos son:","health-services-description":"Comprende determinados servicios relacionados con el bienestar y la salud en especialidades no incluidas habitualmente en seguros de salud tales como:","medical-services-list":"Consultas de medicina primaria (medicina general y pediatría)<br> Consulta de especialistas<br> Médicos de diagnóstico<br> Tratamientos médicos<br> Hospitalización e intervenciones quirúrgicas<br> Servicios médicos<br> Alergología<br> Anatomía patológica<br> Angiología y cirugía vascular<br> Aparato digestivo<br> Cardiología<br> Cirugía cardiovascular<br> Cirugía general y Aparato digestivo<br> Cirugía mamaria<br> Cirugía maxilofacial<br> Cirugía oncológica<br> Cirugía pedríatica<br> Cirugía plástica y reparadora<br> Cirugía torácica<br> Cirugía vascular<br> Dermatología y venereología<br> Endocrinología y nutrición<br> Enfermería<br> Hematología y hemoterapia<br> Nefrología<br> Neumología<br> Neurocirugía<br> Neurofisiología clínica<br> Neurología<br> Obstetricia y ginecología<br> Oftalmología<br> Oncología médica<br> Oncología radioterápica<br> Otorrinolaringología<br> Rehabilitación<br> Reumatología<br> Traumatología y Ortopedia<br> Urología<br> Medicina general<br> Pediatría<br> Pediatría-Puericultura<br> Clínicas y Hospitales<br> Policlínicas<br> Campimetrías<br> Panorámica/Ortopantomografía<br> Ecografías<br> Mamografías<br> T.A.C.<br> Analísis clínicos<br> Diagnóstico por la imagen<br> Medicina nuclear","teeth-services-list":"Primera vista y entrega de presupuesto<br> Visita de revisón<br> Educación bucodental<br> Enseñanza de técnicas de cepillado<br> Fluorizaciones<br> Limpieza de boca anual. Tartrectomía<br> Radiografías odontológicas (periapical, aleta, oclusal)<br> Diagnóstico y sondaje<br> Ajustes oclusales<br> Retirar puntos<br> Estudio implantológico<br> Falso muñón de titanio<br> Tornillo de cicatrización y de cementación<br>","health-services-list":"Acupuntura/Homeopatía/Naturopatía<br> Avantsalud en forma<br> Balnearios<br> Centros de reconocimiento<br> Cirugía refractiva oftalmológica láser<br> Concepto Bobath<br> Conservación de Células Madre-Cordón<br> Dermatoscopia Digital<br> Dietética<br> Ecografías 3D y 4D<br> Estética<br> Fisioterapia y fisioterapia infantil<br> Hidroterapia de colon<br> Medicina Preventiva y Test Genéticos<br> Ópticas y Audífonos<br> Ortopedia<br> Osteopatía<br> Planes con niños<br> Podología y Estudio de la pisada<br> Prestaciones asistenciales a domicilio (atención postparto)<br> Procedimientos mínimamente invasivos<br> Psicología, pedagogía y logofoniatría<br> Quiropráctica<br> Rehabilitación cardiaca<br> Terapia asistida con animales<br> Tratamientos de deshabituación tabáquica<br> Tratamientos de infertilidad<br> Tratamiento ondas de choque (disfunción eréctil)<br> Veterinarios<br> Láser miopía, astigmatismo, hipermetropía<br> Podología a domicilio<br> Analítica a domicilio<br> Fisioterapia a domicilio<br> Prevención Cáncer cuello de útero/HPV<br> Test genético cardiológico<br> Cribado Cáncer de colon en sangre<br> Test genético de la obesidad<br> Test genético Cáncer pulmonar<br> Chequeo oncológico<br> Test genético Alzhéimer<br> Test genético tromboembolismo<br> Test genético Diabetes Tipo II<br> Test genético Cáncer de mama<br> Test prenatal no invasivo<br> Preeclampsia<br> Test de paternidad<br> Huella genética<br> Test de intolerancia alimentaria<br> Test degeneración macular<br> Sexo fetal en sangre materna<br> Test melisa<br> Test migraña<br> Test intolerancia a la lactosa - fructosa<br> Balón gástrico<br> Cápsula endoscópica<br> Láser verde próstata<br> Láser en dermatología<br> Láser en vascular/endoláser<br> Cirugía percutánea del pie<br> Vasectomía sin bisturí<br> Blefaroplastia<br> Abdominoplastia<br> Rinoplastia<br> Lifting<br> Microinjertos capilares<br> Mamoplastia de aumento<br> Mamoplastia de reducción<br> Cirugía íntima<br> Liposucción<br>","wellness-services":"Servicios de bienestar","medic-services":"Servicios médicos","tooth-services":"Servicios dentales"},"block-5":{"blackTitle":"Seguridad y privacidad.","title":"Todo lo que necesitas con el máximo nivel de protección.","text":"La seguridad de las comunicaciones y privacidad de los datos son nuestra prioridad.","text2":"Ponemos a tu disposición la mejor tecnología con la máxima seguridad en las comunicaciones y total privacidad de tus datos. Nuestra plataforma cuenta con la certificación ISO 27001 y está auditada por la Organización Médica Colegial."},"integral-solution":{"title":"Solución integral","subtitle":"La única plataforma de salud y bienestar 360","text":"Ahora más que nunca, queremos ayudar a mejorar la salud física, mental y emocional de personas y organizaciones en todo el mundo. Opensalud 360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores médicos, psicólogos o nutricionistas, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"social-benefit":{"title":"Cuidamos lo más importante de tu empresa, tus empleados","subtitle":"Proporcionamos un beneficio social muy valorado y de gran impacto.","list":{"1":"Menores tasas de @:global.absentismo","2":"Empleados más felices y comprometidos","3":"Aumenta la motivación y la retención","4":"Y sobre todo... ¡mejora la salud y el bienestar!"},"list-1":"Menores tasas de @:global.absentismo","list-2":"Empleados más felices y comprometidos","list-3":"Mejora la conciliación","list-4":"Aumenta el rendimiento de tu equipo","list-5":"Aumenta la retención y la atracción","list-6":"Empleados física y mentalmente, más sanos"},"psychological-attention":{"title":"Expertos en Salud mental y emocional en la empresa","subtitle":"La salud mental y emocional como motor de bienestar y productividad","text":"Partíamos de un estado general de salud mental y emocional frágil (especialmente en los países desarrollados), que la actual situación ha terminado por desbordar y que va a tener un enorme impacto en el presente y en el futuro las organizaciones. <br><br> Ansiedad, estrés, depresión, problemas familiares y de pareja, gestión del cambio… son situaciones que podemos superar si contamos con las herramientas adecuadas y sobre todo con el apoyo de un profesional cualificado de libre elección, accesible en cualquier momento y desde cualquier lugar.","quote":"El trabajo más productivo es el que sale<br> de las manos de una persona contenta","title-2":"La importancia de la detección temprana y la prevención","subtitle-2":"Ansiedad, estrés, problemas emocionales... no suelen ser fáciles de detectar externamente hasta que el deterioso es muy evidente y las soluciones costosas. Por eso es clave proporcionar a las personas soluciones de calidad y muy accesibles, que les permitan hacerse cargo del problema en las fases iniciales."},"wellness":{"title":"Programas de salud y bienestar","list":{"1":{"title":"¡Contenidos personalizados para que recibas tu dosis de vitalidad!","text":"Salud física, mental y nutricional."},"2":{"title":"Planes de entrenamiento online","text":"Espalda sana - Cardiovascular - Salud Activa - Pilates - Embarazadas - Mindfulness - Estrés"},"3":{"title":"Clases y sesiones diarias en directo: ¡No tendrás excusa con tu gimnasio online!","text":"Emitimos contenido de calidad a diario y en 'directo' de diferentes disciplinas deportivas."},"4":{"title":"Talleres online","text":"Inscríbete a nuestros talleres sobre alimentación, gestión del estrés y otros muchos temas de interés."}}},"telemedicine-services":{"title":"Tele exploración y telemonitorización","subtitle":"Convierte cualquier espacio en un punto de salud","text":"opensalud360 ofrece servicios de telemedicina avanzados. Dentro de un servicio de teleconsulta incorporamos dispositivos de tele exploración (estetoscopio digital...) y tele monitorización (temperatura, presión arterial, electro cardio...) que permiten desarrollar todo el potencial de la telemedicina, permitiendo llevar la atención médica allí donde se encuentre el paciente. <br><br> Los usuarios pueden controlar sus variables de salud y en caso necesario, compartir sus datos con un profesional durante la teleconsulta. Asimismo, el médico durante la videoconsulta puede auscultar (corazón y pulmón) al paciente y explorarle de manera remota (orificios, piel, etc.)."},"health-platform":{"title":"¿Te gustaría tener tu propia plataforma personalizada de salud digital?","subtitle":"Posibilidad de personalizar la plataforma para tus empleados o clientes, con tu propio look and feel."},"wellness-services":{"title":"<b>Wellbeing Score®</b><br>Conoce el estado de salud y bienestar de tu plantilla.","subtitle":"Ofrece a tus empleados un autodiagnóstico de salud y bienestar con planes de acción individuales.","cards":{"1":{"title":"Bienestar físico","subtitle":"Hábitos de movimiento, alimentación, descanso y sueño y vigilancia de la salud."},"2":{"title":"Bienestar emocional","subtitle":"Índice de felicidad y desconexión, gestión de incertidumbre y estrés y capacidad de trabajo."},"3":{"title":"Bienestar entorno","subtitle":"Entorno personal, profesional y digital, hábitos de sostenibilidad y medioambiente y riesgos psicosociales."},"4":{"title":"Bienestar social","subtitle":"Nivel de apoyo social, bienestar financiero, nivel de conciliación, apertura a diversidad, talento y habilidades interpersonales."}}},"discountssect":{"title":"Acceso premium a servicios clínicos privados.","subtitle":"Como complemento de las consultas online,  podrás acceder a más de 25.000 profesionales y centros, en toda España, con un precio muy reducido. Intervenciones, pruebas, tratamientos, consultas, deporte, productos de salud, óptica, dental…","text":"Acceso al mayor cuadro de servicios de salud de España con más de 25.000 profesionales y centros con descuentos de hasta el 60% de consultas, intervenciones, pruebas, tratamientos, productos y servicios de salud:"},"companies":"30 empleados o 30.000, tenemos una solución adaptada a tus necesidades y presupuesto.","opensalud-empresas":{"form-subtitle":"Si quieres que tus empleados accedan a los mejores servicios de salud y bienestar digital, contáctanos."},"main-block-h1-new":"Plataforma de salud y bienestar para empresas.","main-bussiness-block-h2":"Cuidamos la salud y bienestar de las empresas, cuidando de las personas que trabajan en ellas.","companies2":"Con más de 1.000 profesionales de la salud disponibles y más de 50 programas de salud y bienestar, grandes compañías e instituciones confían en nosotros para cuidar la salud y el bienestar de sus empleados y clientes en <b> España, Portugal, México y Brasil. </b>","ask-demo-btn":"solicitar demo"}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más info","sign-in-btn":"Iniciar sesión","access-btn":"Acceder","access-patient":"Acceso Pacientes","sign-up-btn":"Registro","patients":"Paciente","business":"Empresas","prove-free":"SOLICITAR DEMO","main-block-h2":"Siempre.","main-block-h3":"Tu plataforma profesional de consulta","main-block-h4":"y bienestar.","more-information-btn":"Más información","ask-for-demo":"Solicitar demo","ask-for-demo-title":"Recomienda opensalud a tus pacientes","register-free":"¡Regístrate y pruébalo gratis durante 6 meses sin compromiso!","register-free-openlegal":"¡Regístrate y pruébalo gratis durante 6 meses sin compromiso!","registerfor-free":"¡Regístrate gratis!","know-more-btn":"Saber más","block-2":{"blackTitle":"Diseñado por médicos.","title":"Cuida de tus pacientes cuándo y cómo quieras."},"block-3":{"blackTitle":"Presencial y online.","title":"Ofrece un servicio innovador a tus pacientes.","text":"Los pacientes podrán contactar contigo de una manera fácil y segura, para que decidas que consultas quieres hacer de manera presencial y cuáles online.\n","text2":"Además, podrás gestionar toda la información de tus pacientes: su historial clínico, citas, facturación, indicarles tareas, programar seguimientos o recetar online bajo el sistema homologado de prescripción de la OMC.","text3":"Tus pacientes podrán además utilizar la aplicación de seguimiento de hábitos, recordatorio de medicamentos, la agenda de salud, o conectar su smartwatch entre otras soluciones."},"block-4":{"blackTitle":"Optimiza tu consulta.","title":"Aumenta tus ingresos y mejora la atención.","text":"Aumenta tu visibilidad y reputación. Capta nuevos pacientes gracias a tu perfil online.","text2":"Dispondrás de una pasarela de pago segura para que tus pacientes puedan realizar el pago de forma segura.","text3":"Nos encargamos de recordar al paciente su cita y emitir de manera automática @:global.factura en tu nombre.","text4":"Ordena y monetiza las comunicaciones con tus pacientes evitando el móvil, email, whatsapp o llamadas por teléfono."},"block-5":{"blackTitle":"Todo lo que necesitas, con el máximo nivel de protección.","title":"Evita el uso de aplicaciones de mensajería o vídeo no aptas para la práctica clínica.","text":"La seguridad de las comunicaciones y privacidad de los datos son nuestra prioridad.","text2":"Ponemos a tu disposición la mejor tecnología con la máxima seguridad en las comunicaciones y total privacidad de tus datos. Nuestro sistema de gestión de seguridad de los datos, cuenta con la certificación ISO 27001 y está auditado por la Organización Médica Colegial."},"block-6":{"title":"El secreto para una atención online excelente es contar con excelentes profesionales digitales.","subtitle":"Consulta a los mejores médicos, psicólogos y nutricionistas, de manera fácil y segura, con el mejor precio, estés donde estés."},"block-8":{"title":"Tarifas profesionales ","iva":"(IVA No incluido)"},"block-7":{"text1":"es una iniciativa que surge para canalizar las actividades solidarias de los profesionales de la salud que desean ofrecer sus servicios a ONGs que trabajan en zonas con limitado acceso a servicios de salud, utilizando la telemedicina.","text2":"Si quieres aportar una pequeña parte de tu tiempo para atender de manera remota a pacientes en zonas vulnerables, solicita información.","text3":"Los profesionales que colaboren con la iniciativa, podrán utilizar la plataforma opensalud para su práctica clínica habitual, sin pagar ninguna cuota.","blackTitle":"Telemedicina para comunidades vulnerables"},"block-end":{"title":"Accede online a los mejores. Medicina de calidad sin prisas.","subtitle":"Accede a los mejores profesionales y servicios en cualquier momento y desde cualquier lugar de una forma fácil y segura."},"integral-solution":{"title":"Solución integral","subtitle":"La única plataforma de salud y bienestar 360","text":"Ahora más que nunca, queremos ayudar a mejorar la salud física, mental y emocional de personas y organizaciones en todo el mundo. Opensalud 360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores médicos, psicólogos o nutricionistas, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"social-benefit":{"title":"Cuidamos lo más importante de tu empresa, tus empleados","subtitle":"Proporcionamos un beneficio social muy valorado y de gran impacto.","list":{"1":"Reduce el absentismo y mejora la conciliación","2":"Potencia el rendimiento","3":"Aumenta la motivación y la retención","4":"Y sobre todo... ¡mejora la salud y el bienestar!"}},"block-360":{"title":"opensalud360","subtitle":"El nuevo servicio de salud y bienestar para empresas.","text":"opensalud360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores profesionales y programas de salud y bienestar, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"psychological-attention":{"title":"Expertos en Salud mental y emocional en la empresa","subtitle":"La salud mental y emocional como motor de bienestar y productividad","text":"Partíamos de un estado general de salud mental y emocional frágil (especialmente en los países desarrollados), que la actual situación ha terminado por desbordar y que va a tener un enorme impacto en el presente y en el futuro las organizaciones. <br><br> Ansiedad, estrés, depresión, problemas familiares y de pareja, gestión del cambio… son situaciones que podemos superar si contamos con las herramientas adecuadas y sobre todo con el apoyo de un profesional cualificado de libre elección, accesible en cualquier momento y desde cualquier lugar.","quote":"El trabajo más productivo es el que sale<br> de las manos de una persona contenta"},"wellness":{"title":"Programas de salud y bienestar","list":{"1":{"title":"¡Contenidos personalizados para que recibas tu dosis de vitalidad!","text":"Salud física, mental y nutricional."},"2":{"title":"Planes de entrenamiento online","text":"Espalda sana - Cardiovascular - Salud Activa - Pilates - Embarazadas - Mindfulness - Estrés"},"3":{"title":"Clases y sesiones diarias en directo: ¡No tendrás excusa con tu gimnasio online!","text":"Emitimos contenido de calidad a diario y en 'directo' de diferentes disciplinas deportivas."},"4":{"title":"Talleres online","text":"Inscríbete a nuestros talleres sobre alimentación, gestión del estrés y otros muchos temas de interés."}}},"telemedicine-services":{"title":"Tele exploración y telemonitorización","subtitle":"Convierte cualquier espacio en un punto de salud","text":"opensalud360 ofrece servicios de telemedicina avanzados. Dentro de un servicio de teleconsulta incorporamos dispositivos de tele exploración (estetoscopio digital...) y tele monitorización (temperatura, presión arterial, electro cardio...) que permiten desarrollar todo el potencial de la telemedicina, permitiendo llevar la atención médica allí donde se encuentre el paciente. <br><br> Los usuarios pueden controlar sus variables de salud y en caso necesario, compartir sus datos con un profesional durante la teleconsulta. Asimismo, el médico durante la videoconsulta puede auscultar (corazón y pulmón) al paciente y explorarle de manera remota (orificios, piel, etc.)."},"health-platform":{"title":"¿Te gustaría tener tu propia plataforma personalizada de salud digital?","subtitle":"Posibilidad de personalizar la plataforma para tus empleados o clientes, con tu propio look and feel."},"card":{"title1":"Consulta online","subtitle1":"Videoconsulta, Consulta escrita, Chat, Segunda opinión...","title2":"Receta electrónica","subtitle2":" Recetas homologadas por la Organización Médico Colegial.","title3":"Historial clínico","subtitle3":"Accede, edita y comparte el historial clínico con tus pacientes.","title4":"Consulta presencial","subtitle4":"Consulta a domicilio. Consulta en clínica.","title5":"Suscripciones y packs","subtitle5":"Diseña tus propios packs de servicios y suscripciones.","title6":"Agenda online","subtitle6":"Gestiona tus citas online de forma fácil automática.","title7":"Facturación online","subtitle7":"Realiza tus cobros y emite tus facturas de forma automática.","title8":"Monitorización y exploración remota","subtitle8":"Incorpora dispositivos para facilitar la consulta online y el seguimiento.","title9":"Precios personalizables","subtitle9":"Podrás establecer diferentes precios en función del motivo de consulta o el colectivo.","title10":"Interconsultas","subtitle10":"Contacta con otros colegas a través de mensajería interna","title-video":"Plataforma profesional de vídeosubtitle-1subtitle-1","subtitle-video":"Segura y privada. No requiere que los usuarios estén registrados (Teams, Zoom…)","src-price":"/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg","title-1":"Particulares","subtitle-1":"Los mejores médicos y la mejor aplicación de salud.","title-2":"Profesionales","subtitle-2":"Cuadro médico para profesionales independientes","title-3":"Empresas","subtitle-3":"Cuidamos la salud y el bienestar de los empleados."},"cardsPricing":{"title1":"Profesionales","text1":"5 profesionales incluidos. 5€/mes por profesional adicional (máx. 260€/mes)","subtitle":"Comisión sobre consulta cobrada en opensalud","title2":"Centros clínicos","text2":"5 profesionales incluidos. <br /> 5€/mes por profesional adicional (máx. 190€/mes)"},"openlegal":{"menu":{"for-you-and-your-family":"For you and your family","for-business":"For Businesses","for-freelancers":"Freelancers","sign-in":"Sign in"},"title":"We are here to help you","more-info":"More information","cards":{"first":{"title":"No waiting wherever you are","description":"At home, on the road, on vacation wherever you are, access the lawyer you need by video, phone, messaging or chat."},"second":{"title":"Comfort and Security","description":"Avoid inconvenience by limiting travel. You will be able to receive the documentation in digital format and in a highly secure environment."},"third":{"title":"Take care of your life and that of your family","description":"Ignoring your rights, or making decisions without adequate advice, can have serious consequences for you or your family."},"fourth":{"title":"Specialists in your rights","description":"Consumption, housing, defaults, labor, fines, tax, insurance, family... find the right lawyer for your needs."}},"advantages":"Advantages of openlegal","best-legal-services":"The best legal service for companies and individuals","for-freelancers":"openlegal for freelancers","professional":"Profesional","patient":"Paciente","companies":"Con mas de 1000 médicos, psicólogos y nutricionistas disponibles, grandes compañías e instituciones confían en nosotros para cuidar la salud y el bienestar de sus empleados y clientes en España y México."},"centre":"Centro","patients-like-you":"Pacientes Como Tú","main-h1":"Simplemente cuidar tu salud","main-h1-title":"Simplemente cuidar tu salud y bienestar.","block":{"title":"Nuestros perfiles","blackTitle":"Te presentamos"}}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más info","main-professional-block-h1":"La plataforma de los profesionales independientes.","sign-in-btn":"Iniciar sesión","access-btn":"Acceder","access-patient":"Acceso Pacientes","sign-up-btn":"Registro","patients":"Pacientes","business":"Empresas","prove-free":"SOLICITAR DEMO","main-professional-block-h2":"Si quieres digitalizar tu consulta, te ofrecemos todo lo que necesitas para atender a tus pacientes (presencial y online) de una forma fácil y segura.","main-professional-block-h3":"Tu plataforma profesional de consulta","main-professional-block-h4":"Medicina de calidad, sin prisas.","more-information-btn":"Más información","ask-for-demo":"Solicitar demo","ask-for-demo-title":"Recomienda opensalud a tus pacientes","register-free":"¡Regístrate y pruébalo gratis durante 6 meses sin compromiso!","register-free-openlegal":"¡Regístrate y pruébalo gratis durante 6 meses sin compromiso!","registerfor-free":"¡Regístrate gratis!","know-more-btn":"Saber más","block-2":{"blackTitle":"Diseñado por médicos.","title":"Cuida de tus pacientes cuándo y cómo quieras."},"block-3":{"blackTitle":"Presencial y online.","title":"Ofrece un servicio innovador a tus pacientes.","text":"Los pacientes podrán contactar contigo de una manera fácil y segura, para que decidas que consultas quieres hacer de manera presencial y cuáles online.\n","text2":"Además, podrás gestionar toda la información de tus pacientes: su historial clínico, citas, facturación, indicarles tareas, programar seguimientos o recetar online bajo el sistema homologado de prescripción de la OMC.","text3":"Tus pacientes podrán además utilizar la aplicación de seguimiento de hábitos, recordatorio de medicamentos, la agenda de salud, o conectar su smartwatch entre otras soluciones."},"block-4":{"blackTitle":"Optimiza tu consulta.","title":"Aumenta tus ingresos y mejora la atención.","text":"Aumenta tu visibilidad y reputación. Capta nuevos pacientes gracias a tu perfil online.","text2":"Dispondrás de una pasarela de pago segura para que tus pacientes puedan realizar el pago de forma segura.","text3":"Nos encargamos de recordar al paciente su cita y emitir de manera automática @:global.factura en tu nombre.","text4":"Ordena y monetiza las comunicaciones con tus pacientes evitando el móvil, email, whatsapp o llamadas por teléfono."},"block-5":{"blackTitle":"Todo lo que necesitas, con el máximo nivel de protección.","title":"Evita el uso de aplicaciones de mensajería o vídeo no aptas para la práctica clínica.","text":"La seguridad de las comunicaciones y privacidad de los datos son nuestra prioridad.","text2":"Ponemos a tu disposición la mejor tecnología con la máxima seguridad en las comunicaciones y total privacidad de tus datos. Nuestro sistema de gestión de seguridad de los datos, cuenta con la certificación ISO 27001 y está auditado por la Organización Médica Colegial."},"block-6":{"title":"El secreto para una atención online excelente es contar con excelentes profesionales digitales.","subtitle":"Consulta a los mejores médicos, psicólogos y nutricionistas, de manera fácil y segura, con el mejor precio, estés donde estés."},"block-8":{"title":"Tarifas profesionales ","iva":"(IVA No incluido)"},"block-7":{"text1":"es una iniciativa que surge para canalizar las actividades solidarias de los profesionales de la salud que desean ofrecer sus servicios a ONGs que trabajan en zonas con limitado acceso a servicios de salud, utilizando la telemedicina.","text2":"Si quieres aportar una pequeña parte de tu tiempo para atender de manera remota a pacientes en zonas vulnerables, solicita información.","text3":"Los profesionales que colaboren con la iniciativa, podrán utilizar la plataforma opensalud para su práctica clínica habitual, sin pagar ninguna cuota.","blackTitle":"Telemedicina para comunidades vulnerables"},"block-end":{"title":"Accede online a los mejores. Medicina de calidad sin prisas.","subtitle":"Accede a los mejores profesionales y servicios en cualquier momento y desde cualquier lugar de una forma fácil y segura."},"integral-solution":{"title":"Solución integral","subtitle":"La única plataforma de salud y bienestar 360","text":"Ahora más que nunca, queremos ayudar a mejorar la salud física, mental y emocional de personas y organizaciones en todo el mundo. Opensalud 360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores médicos, psicólogos o nutricionistas, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"social-benefit":{"title":"Cuidamos lo más importante de tu empresa, tus empleados","subtitle":"Proporcionamos un beneficio social muy valorado y de gran impacto.","list":{"1":"Reduce el absentismo y mejora la conciliación","2":"Potencia el rendimiento","3":"Aumenta la motivación y la retención","4":"Y sobre todo... ¡mejora la salud y el bienestar!"}},"block-360":{"title":"opensalud360","subtitle":"El nuevo servicio de salud y bienestar para empresas.","text":"opensalud360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores profesionales y programas de salud y bienestar, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"psychological-attention":{"title":"Expertos en Salud mental y emocional en la empresa","subtitle":"La salud mental y emocional como motor de bienestar y productividad","text":"Partíamos de un estado general de salud mental y emocional frágil (especialmente en los países desarrollados), que la actual situación ha terminado por desbordar y que va a tener un enorme impacto en el presente y en el futuro las organizaciones. <br><br> Ansiedad, estrés, depresión, problemas familiares y de pareja, gestión del cambio… son situaciones que podemos superar si contamos con las herramientas adecuadas y sobre todo con el apoyo de un profesional cualificado de libre elección, accesible en cualquier momento y desde cualquier lugar.","quote":"El trabajo más productivo es el que sale<br> de las manos de una persona contenta"},"wellness":{"title":"Programas de salud y bienestar","list":{"1":{"title":"¡Contenidos personalizados para que recibas tu dosis de vitalidad!","text":"Salud física, mental y nutricional."},"2":{"title":"Planes de entrenamiento online","text":"Espalda sana - Cardiovascular - Salud Activa - Pilates - Embarazadas - Mindfulness - Estrés"},"3":{"title":"Clases y sesiones diarias en directo: ¡No tendrás excusa con tu gimnasio online!","text":"Emitimos contenido de calidad a diario y en 'directo' de diferentes disciplinas deportivas."},"4":{"title":"Talleres online","text":"Inscríbete a nuestros talleres sobre alimentación, gestión del estrés y otros muchos temas de interés."}}},"telemedicine-services":{"title":"Tele exploración y telemonitorización","subtitle":"Convierte cualquier espacio en un punto de salud","text":"opensalud360 ofrece servicios de telemedicina avanzados. Dentro de un servicio de teleconsulta incorporamos dispositivos de tele exploración (estetoscopio digital...) y tele monitorización (temperatura, presión arterial, electro cardio...) que permiten desarrollar todo el potencial de la telemedicina, permitiendo llevar la atención médica allí donde se encuentre el paciente. <br><br> Los usuarios pueden controlar sus variables de salud y en caso necesario, compartir sus datos con un profesional durante la teleconsulta. Asimismo, el médico durante la videoconsulta puede auscultar (corazón y pulmón) al paciente y explorarle de manera remota (orificios, piel, etc.)."},"health-platform":{"title":"¿Te gustaría tener tu propia plataforma personalizada de salud digital?","subtitle":"Posibilidad de personalizar la plataforma para tus empleados o clientes, con tu propio look and feel."},"card":{"title1":"Consulta online","subtitle1":"Videoconsulta, Consulta escrita, Chat, Segunda opinión...","title2":"Receta electrónica","subtitle2":" Recetas homologadas por la Organización Médico Colegial.","title3":"Historial clínico","subtitle3":"Accede, edita y comparte el historial clínico con tus pacientes.","title4":"Consulta presencial","subtitle4":"Consulta a domicilio. Consulta en clínica.","title5":"Suscripciones y packs","subtitle5":"Diseña tus propios packs de servicios y suscripciones.","title6":"Agenda online","subtitle6":"Gestiona tus citas online de forma fácil automática.","title7":"Facturación online","subtitle7":"Realiza tus cobros y emite tus facturas de forma automática.","title8":"Monitorización y exploración remota","subtitle8":"Incorpora dispositivos para facilitar la consulta online y el seguimiento.","title9":"Precios personalizables","subtitle9":"Podrás establecer diferentes precios en función del motivo de consulta o el colectivo.","title10":"Interconsultas","subtitle10":"Contacta con otros colegas a través de mensajería interna","title-video":"Plataforma profesional de vídeo","subtitle-video":"Segura y privada. No requiere que los usuarios estén registrados (Teams, Zoom…)","src-price":"/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg"},"cardsPricing":{"title1":"Profesionales","text1":"5 profesionales incluidos. 5€/mes por profesional adicional (máx. 260€/mes)","subtitle":"Comisión sobre consulta cobrada en opensalud","title2":"Centros clínicos","text2":"5 profesionales incluidos. <br /> 5€/mes por profesional adicional (máx. 190€/mes)","electronicrecipe":"Módulo adicional de receta electrónica","electronicrecipeprice":"5,90€/profesional","subtitle1":"<b>3,5%</b> hasta <b>2.500€</b> de facturación mensual","subtitle2":"<b>2,5%</b> hasta <b>2500€</b> de facturación mensual","subtitle3":"<b>1,5%</b> a partir de <b>2.500€</b>"},"openlegal":{"menu":{"for-you-and-your-family":"For you and your family","for-business":"For Businesses","for-freelancers":"Freelancers","sign-in":"Sign in"},"title":"We are here to help you","more-info":"More information","cards":{"first":{"title":"No waiting wherever you are","description":"At home, on the road, on vacation wherever you are, access the lawyer you need by video, phone, messaging or chat."},"second":{"title":"Comfort and Security","description":"Avoid inconvenience by limiting travel. You will be able to receive the documentation in digital format and in a highly secure environment."},"third":{"title":"Take care of your life and that of your family","description":"Ignoring your rights, or making decisions without adequate advice, can have serious consequences for you or your family."},"fourth":{"title":"Specialists in your rights","description":"Consumption, housing, defaults, labor, fines, tax, insurance, family... find the right lawyer for your needs."}},"advantages":"Advantages of openlegal","best-legal-services":"The best legal service for companies and individuals","for-freelancers":"openlegal for freelancers","professional":"Profesional","patient":"Paciente","companies":"Con mas de 1000 médicos, psicólogos y nutricionistas disponibles, grandes compañías e instituciones confían en nosotros para cuidar la salud y el bienestar de sus empleados y clientes en España y México."},"centre":"Centro","patients-like-you":"Pacientes Como Tú","access":"Acceder","primeByOpensaludWarning":"A partir del 15 septiembre opensalud se transformará en el <b>cuadro médico prime by opensalud</b>, un nuevo concepto centrado en las necesidades de los médicos y otros profesionales que ejercen la medicina privada. Regístrate o síguenos en nuestras redes sociales para mantenerte informado."}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = {"appointmentsTitle":"Consultas","unassigned":"Sin asignar","appointmentsSearchBanner":"Indique el intervalo si no encuentra su consulta (por defecto mostramos las citas comprendidas desde hace 60 días).","nextAppointmentsTitle":"Próximas consultas","writtenAppointmentsTitle":"Consulta Escrita/Segunda Opinión","pastChatsAppointmentsTitle":"Chats finalizados","pastAppointmentsTitle":"Consultas pasadas","emptyNextAppointments":"No hay ninguna consulta/videoconsulta próxima","emptyWrittenAppointments":"No ha realizado ninguna Consulta Escrita/Segunda Opinión","emptypastAppointments":"Todavía no se ha realizado ninguna consulta/videoconsulta","emptypastChatsAppointments":"Todavía no ha realizado ningún chat","webmailStates":{"additionalInfoCompleted":"Información adicional completada","pendingConfirm":"Pendiente de aceptar","additionalInfoRequested":"Información adicional solicitada","profReviewingCase":"El profesional está estudiando su caso"},"nextAppointmentsStates":{"waitingCall":"Esperando llamada","postponedCall":"Llamada aplazada"},"appointmentStates":{"expired":"Caducado","cancelledPatient":"Cancelado paciente","cancelledProfessional":"Cancelado profesional","finishedWithPrescription":"Finalizado con receta","finished":"Finalizado","finishedWithoutReport":"Finalizada sin informe","attendedOutsidePlatform":"Atendida fuera de la plataforma","chargedByProfessional":"Cobrada por profesional","finishedWithReport":"Finalizada con informe","expiredRequest":"Solicitud caducada","patientDoesntShowUp":"Paciente no presentado","rejectedRequest":"Solicitud no aceptada","stillNoReported":"A la espera de informe","appointmentCancelledProfessional":"Cancelada por profesional","appointmentCancelledPatient":"Cancelada por paciente"},"historySharedWithProfessional":"Su historial clínico ha sido compartido con este profesional","changePaymentMethod":"Cambiar método de pago","showAppointment":"Ver consulta","payAppointment":"Pagar consulta","goVideoAppointment":"Ir a videoconsulta","showChat":"Ver chat","appointmentReport":"Informe","appointmentPrescription":"Prescripción","showFilters":"Mostrar filtros","appointmentType":"Tipo de consulta","profName":"Nombre del profesional","filterAppointments":"Buscar","confirmAppointment":"Confirmar consulta","changeUserAdvice":"A continuación será dirigido al perfil de este paciente.<br><br>¿Desea continuar?","payment":{"selectState":"Seleccione una provincia"},"appointmentCancel":{"cancel":"Cancelar","cancelationReason":"Razón de la cancelación","patientData":"Datos del paciente","appointmentSummary":"Resumen de la consulta","wantToCancel":"Sí, quiero cancelar la consulta","writeAReason":"Escribe un motivo...","noCancelReason":"Debe añadir un motivo de cancelación de consulta","cancel-success":"Consulta cancelada con éxito","cancel-error":"No se ha podido cancelar la consulta"},"duration":"Duración"}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = {"foods":{"categories":{"title":"¿Qué te preocupa?"},"disclaimer":"Aunque el consumo de determinados alimentos no puede por sí mismo prevenir o curar enfermedades, existen evidencias de que determinados hábitos nutricionales ayudan a reducir los riesgos de contraer determinadas enfermedades.\n<br><br>\nNuestro objetivo es ofrecer información actualizada y procedente de fuentes acreditadas (organismos públicos, sociedades científicas, asociaciones médicas, estudios validados…), no obstante, si tuviese intención de realizar algún cambio en sus hábitos basándose en la información que le proporciona este apartado, es necesario que consulte previamente a su médico o nutricionista. Esta recomendación es aún más imperiosa, en el caso de existir patologías previas."},"patient":{"foods":{"add-to-my-foods":"Añadir a Mis alimentos","diet-question":"Añadir a mi dieta actual","habits-question":"Añadir recordatorio","delete-food":"Eliminar de Mis alimentos","remove-from-diet":"Eliminar solo de mi dieta actual","remove-from-my-foods-warning":"¿Está seguro de que desea eliminar este alimento?","remove-from-my-foods":"Eliminar de 'Mis alimentos'","patient-food-add-success":"El alimento se ha añadido correctamente a 'Mis alimentos'","patient-food-delete-success":"El alimento se ha eliminado correctamente de 'Mis alimentos'","patient-food-remove-diet-success":"El alimento se ha eliminado de tu dieta correctamente","in-diet":"En mi dieta","remove-habit":"Eliminar recordatorio","create-habit":"Añadir recordatorio","go-to-habit":"Ver recordatorio","remove-from-habits":"Eliminar también recordatorio asociado","habit-created-success":"El hábito ha sido creado correctamente. Para finalizar el proceso pulse en el botón que encuentra a continuación para añadir el alimento a 'Mis alimentos'.","patient-food-add-diet-success":"El alimento se ha marcado como añadido correctamente a tu dieta.","select-category":"Selecciona una categoría","go-to-category":"Ir a {category}","habit-created-success-on-modify":"El hábito ha sido creado y asociado correctamente","no-foods-with-filters":"No tienes alimentos añadidos que cumplan con los filtros establecidos.","no-foods":"No has añadido aún ningún alimento a esta sección.","show-only-in-diet":"Mostrar solo incluidos en mi dieta","add-to-diet":"Marcar como ya añadido en mi dieta","see-associated-habit":"Recordatorio","add-food":"Empezar a añadir alimentos","food-detail-dialog-info":"Puedes seleccionar los alimentos que te interesen haciendo click en el corazón e incorporándolos al apartado de Mis alimentos, donde podrás crear una tarea o recordatorio para cada alimento.","added-to-favourites":"Añadido a 'Mis alimentos'","go-to-my-foods":"Ir a Mis alimentos"},"microhabits":{"patient-microhabit-remove-diet-success":"Se ha eliminado este hábito de tus hábitos completados."}},"patient-panel":{"no-foods":"Aún no has añadido ningún alimento a esta sección"}}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = {"patient":{"menu-banners":{"queue-instant-video":"Su solicitud de Videoconsulta Inmediata está a la espera de ser atendida. Recibirá una notificación cuando el profesional esté disponible.","queue-written":"Su solicitud de Consulta Escrita está a la espera de ser atendida. Recibirá una notificación cuando el profesional haya aceptado su consulta.","queue-chat":"Su solicitud de Chat está a la espera de ser atendida. Recibirá una notificación cuando el profesional haya aceptado su consulta.","queue-call":"Su solicitud de llamada está a la espera de ser atendida. Un profesional le llamará pronto.","new-chat-messages":"Tiene nuevos mensajes de chat. Acceda a la pestaña 'Chats'."}}}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = {"microhabits":{"simple":{"categories-menu":{"title":"Pequeños cambios. Grandes resultados.","subtitle":"El objetivo es ayudarte a adoptar hábitos sencillos en apariencia, pero que pueden tener un impacto significativo en tu salud y bienestar a corto, medio y largo plazo."},"panel-menu":{"on-block-click-disclaimer":"Puedes seleccionar los hábitos que te interesen haciendo click en el corazón e incorporándolos al apartado de Mis hábitos, donde podrás crear una tarea o recordatorio para cada hábito.","add-to-my-habits":"Añadir a Mis hábitos","max-favourites-reached":"Tienes demasiados hábitos que aún no has completado. Antes de añadir un nuevo hábito completa o elimina alguno.","added-to-favourites":"¡Hábito añadido a Mis hábitos con éxito!"}}},"patient":{"microhabits":{"remove-from-favourites":"Eliminar de Mis hábitos","added-to-favourites":"Eliminar de Mis {habitType}","remove-from-achieved":"Marcar como 'No conseguido'","add-to-achieved":"Marcar como conseguido","added-to-achieved":"Conseguido","create-habit":"Añadir recordatorio","patient-microhabit-achieved-success":"¡Enhorabuena! Has conseguido completar este hábito.","patient-microhabit-remove-diet-success":"Se ha eliminado este hábito de tus hábitos completados.","removed-from-favourites":"{typeName} eliminado con éxito.","no-microhabits":"No has añadido aún ningún {typeName} a esta sección.","add-microhabit":"Empezar a añadir {typeName}","no-microhabits-with-filters":"No tienes {typeName} añadidos que cumplan con los filtros establecidos.","reminder":"Recordatorio"}},"patients":{"microhabits":{"selected":"Añadidos","achieved":"Conseguidos"}}}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = {"patient-panel":{"welcome":"Bienvenido a {platform}","what-do-you-need":"¿Qué necesitas?","teleconsultation":"Consultas","teleconsultation-description":"Médicos, psicólogos y otras especialidades.","health-wealth":"opensaludWellness","health-wealth-description":"Clases diarias, mindfulness, gimnasio online…","bonified-services":"opensaludPass","bonified-services-description":"Servicios de salud y bienestar a precio reducido","wellbeing-score":"Wellbeing score<br><small>by freedom and flow</small>","wellbeing-score-description":"Evalúa tu nivel de bienestar personal y accede a tu programa de mejora.","telemonitoring":"Telemonitorización","telemonitoring-description":"Podrás sincronizar dispositivos para controlar tu estado de salud.","healthy-community":"Comunidad Saludable","healthy-community-description":"Comenta tus dudas, pide consejos o comparte tus experiencias","health-data":"Datos de salud","health-data-description":"Historia clínica, variables de salud{param}...","habits-description":"Establece objetivos. Mejora tus hábitos","healthy-habits":"Mis objetivos y hábitos","self-evaluation-tests":"Evalúa tu salud","self-evaluation-tests-description":"Salud emocional, sueño, riesgo diabetes…","reminders":"Agenda","reminders-description":"Comunicaciones útiles para tu salud y bienestar","title":"Panel","appointment-type":"Tipo de consulta","specialty":"Especialidad","error-specialty-required":"Debe seleccionar especialidad","patients-like-you":"Pacientes como tú","show-more":"Ver más...","go-360-decision":"Hemos detectado que está accediendo con un usuario de opensalud360 u opensaludPrime.<br><br>Los servicios incluidos en su suscripción de opensalud360 u opensaludPrime se mostrarán sin coste alguno en opensalud.<br><br>¿Qué desea hacer?","go-360":"Ir a opensalud360","stay-opensalud":"Continuar en opensalud","evaluateYourHealthWarning":"El objetivo del módulo evalúa tu salud es ayudarte a conocer mejor algunos aspectos de tu salud y de tus hábitos de vida. Los resultados de las evaluaciones, son asimismo útiles para los profesionales que en su caso, pudieran atenderte en consulta.<br><br>En ningún caso se pretende emitir un diagnóstico o recomendación terapéutica alguna y por tanto, cualquier decisión que tomes derivada del resultado de los distintas herramientas de autoevaluación, debe ser validada previamente por un profesional de la salud (médico, psicólogo o nutricionista generalmente).<br><br>Todos los resultados son confidenciales y sólo tú y en su caso, aquellos profesionales de la salud a los que des acceso, podrán acceder a los mismos.","go-to-my-consultations":"Acceder a 'Mis consultas'","get-new-consultation":"Solicitar una nueva consulta","food-healthy-habits":"Alimentos y Hábitos","healthy-blog":"Blog saludable","foods":"Alimentación saludable","soon-label":"Próximamente","habits-challenges":"Mis objetivos y hábitos","physiotherapy":"Fisioterapia digital","physiotherapy-description":"Guiado por Inteligencia Artificial y monitorizado por fisioterapeutas","my-foods":"Mis alimentos","how-do-you-feel-today":"¿Cómo te sientes hoy, {name}?","today-health-condition-saved-nice":"¡Nos alegramos de que te sientas bien y te deseamos que sigas así el resto del día!","today-health-condition-saved-ok":"Recuerda que si no te sientes hoy como te gustaría, opensalud pone a tu disposición diferentes recursos para ayudarte a sentirte mejor.","today-health-condition-saved-bad":"Sentimos que hoy no te sientas del todo bien. Recuerda que opensalud pone a tu disposición diferentes recursos que pueden ayudarte a sentirte mejor.","get-new-consultation-or-service":"Solicitar una consulta o servicio","consultations":"Consultas","services":"Mis servicios","consultation-or-service":"Consulta o servicio","professionalsOrCenters":"Profesionales/Centros","service":"Servicio","location":"Provincia/Localidad","error-service-required":"Debe seleccionar un servicio","medicalTests":"Pruebas médicas","health-condition-graph-label":"¿Cómo te sientes hoy?","specialtyOrName":"Especialidad o nombre","error-specialty-or-prof-required":"Debe seleccionar una especialidad o un profesional","notifications":"Agenda de salud y notificaciones","caring-foods":"Alimentos que cuidan","foods-description":"Alimentos que ayudan a cuidar tu salud","diets-recipes":"Talleres y recetas","go-to-next-consultations":"Próximas consultas","go-to-past-consultation":"Consultas pasadas","reminders-notifications":"Avisos y notificaciones","health-agenda":"Mi agenda de salud","menstrual-calendar":"Calendario menstrual","menstrual-calendar-description":"Duración, próximo período, ovulación…","healthy-blog-description":"Consejos y artítulos sobre nutrición, ejercicio y bienestar.","habits-that-care":"Hábitos que cuidan","habits-that-care-description":"Pequeños cambios que mejoran tu vida","my-goals":"Mis objetivos","micro-habits":"Micro hábitos","my-microhabits":"Mis hábitos","microhabits-keyword":"hábito | hábitos","foods-keyword":"alimento | alimentos","my-apps":"Mis aplicaciones","my-apps-description":"Herramientas para gestionar tu salud y bienestar","medication-reminder":"Recordatorio de medicamentos","menstrual-calendar-male-warning":"Lo sentimos pero esta herramienta solo está disponible para mujeres.","blood-monitor":"Aplicación de tensión","not-available":"No disponible","only-subscriptors":"Solo suscriptores","only-subscriptors-warning":"Este contenido es sólo para suscriptores.","healthProfile":"Perfil de salud","surveyAvailable":"Tiene una encuesta disponible para ser rellenada","clickHere":"Click aquí para ir a la encuesta","who-signs-up":"¿Quién se apunta?","who-signs-up-description":"Organiza planes saludables con tu compañer@s"},"menu":{"change-user-no-patients":"No tiene ningun usuario asociado a su cuenta principal. Puede registrar uno desde su perfil haciendo click en el botón a continuación."},"private-layout":{"habits-challenges":"Mis objetivos y hábitos","who-signs-up":"¿Quién se apunta?"}}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = {"filters":{"professionals":"Profesionales","centers":"Centros","speciality":"Especialidad","subscriptionIncluded":"Solo profesionales incluidos en mi suscripción","discountedPrice":"Profesionales con precio bonificado","consultationType":"Tipo de consulta","location":"Provincia/Localidad","name":"Nombre","coupon":"Cupón","showResults":"Mostrar resultados","removeFilters":"Eliminar filtros","showMoreFilters":"Más filtros","hideFilters":"Ocultar filtros","insurance":"Aseguradora (Presencial)","subspeciality":"Subespecialidad","services":"Servicios","disease":"Enfermedad","service":"Servicio","consultationsType":"Tipo de consulta","morning":"Mañana","afternoon":"Tarde","indifferent":"Indiferente","language":"Idioma","priceMinorTo":"Precio menor a","surname":"Primer apellido","secondSurname":"Segundo apellido","surnames":"Apellidos","selectFilter":"Seleccione algún filtro para realizar la búsqueda","servicesPackages":"Paquetes de servicios","flatRate":"Tarifa plana Cons. Escrita y Chat","emptySearch":"No se han encontrado resultados. Utilice otros criterios de búsqueda","specialityNotFoundCompanies":"¿No encuentras la especialidad que buscas?","selectSpecialty":"Debe seleccionar una especialidad","tests":"Pruebas médicas","analysis":"Análisis","clinicalAnalysis":"Análisis clínicos","specialityOrName":"Especialidad o nombre","insuranceAdvice":"Servicio disponible sólo para consulta presencial","enterWord":"Introduzca una palabra","insurers":"Aseguradoras","showProfsNotIncludedSubscription":"Profesionales no incluidos en mi suscripción","anyInsurer":"Con aseguradoras"},"ratings":"valoraciones","addToMyTeam":"Añadir a mi equipo","removeOfMyTeam":"Eliminar de mi equipo","unipromelPopover":"Médico asociado a www.unipromel.es","request-appointment":"Solicitar cita","serviceName":{"inplace":"Consulta","video":"Videoconsulta Programada","written":"Consulta Escrita","secondOpinion":"Segunda Opinión","immediate":"Videoconsulta inmediata","atHome":"Consulta a Domicilio","chat":"Chat","call":"Un profesional te llama","insurance":"Consulta por aseguradora","servicesPackages":"Paquetes de servicios","flatRate":"Tarifa plana Cons. Escrita y Chat"},"firstAppointment":"Primera consulta","sendConsultation":"Enviar consulta","makeConsultation":"Realizar consulta","requestCall":"Solicitar llamada","hire":"Contratar","requestAppointment":"Solicitar cita","otherConsultations":"Otras consultas","requestConsultation":"Solicitar consulta","availableOnOpensaludPrime":"Disponible en opensalud prime","availableOnCompanies":"Disponible en opensalud empresas","includedInSubscription":"Incluido en su suscripción","onlyUnderSubscription":"Solo bajo suscripción","specialPrice":"Precio especial","minorRestricted":"Lo sentimos pero esta especialidad está dirigida únicamente a menores de edad. Si dispone de algún paciente menor vinculado que reúna dichas condiciones, cambie de usuario y repita los pasos.","tarifaPlusDisabled":{"title":"Acceso Inactivo","description":"Actualmente el acceso a este servicio se encuentra inactivo. Si desea que le avisemos cuando esté nuevamente disponible indíquenos su email.","email":"Correo electrónico","error":{"email":"Debe introducir un email válido","terms":"Debe aceptar los términos y condiciones","captcha":"Debe completar el captcha"},"success":"Su solicitud ha sido enviada"},"professionalPrevalidated":{"title":"Solicitud de consulta o servicio","description":"En estos momentos estamos validando al profesional que ha seleccionado. Si lo desea, puede introducir su email y le informaremos cuando este procedimiento haya finalizado.","email":"Correo electrónico","error":{"email":"Debe introducir un email válido","terms":"Debe aceptar los términos y condiciones","captcha":"Debe completar el captcha"},"success":"Su solicitud ha sido enviada"},"availabilityRequest":{"title":"Solicitud de consulta o servicio","note":"Nota: el profesional no tiene actualmente disponible su agenda online. Para solicitar una cita complete el siguiente formulario.","englishPrescription":"Receta en inglés","form":{"appointmentType":"Tipo de cita","center":"Centro","selectAService":"Seleccione un servicio","firstAppointment":"¿Es su primera consulta?","availabilityDescription":"Franja horaria (p.e Lunes, miércoles y jueves de 18 a 21, Cualquier día de la semana a partir de las 16)","haveInsurance":"¿Particular o con aseguradora?","insurance":"Seleccione una aseguradora","forWho":"Seleccione para quién es la consulta","pet":"Seleccione una mascota para la consulta","minorPatient":"Seleccione un paciente para la consulta","phone":"Teléfono","description":"Motivo de la consulta/comentarios","service":"Seleccione un servicio"},"error":{"mustSelectPet":"Solo es posible solicitar una cita de esta especialidad para una mascota","typeAppointment":"Debe seleccioanr el tipo de cita","firstAppointment":"Debe seleccionar si es primera cita","selectInsurance":"Debe seleccionar si asiste como particular o mediante aseguradora","insurance":"Debe seleccionar su aseguradora","forWho":"Debe indicar para quién es la consulta","selectPet":"Seleccione una mascota para la consulta","phonePrefix":"Debe seleccionar el prefijo de su teléfono","phone":"Debe introducir su número de teléfono","description":"Debe introducir su consulta/comentarios","captcha":"Debe verificar el captcha","terms":"Debe aceptar los términos y condiciones legales","service":"Debe seleccionar un servicio"},"success":"Su solicitud ha sido enviada"},"forMe":"Para mí","forMinor":"Para paciente menor","forPet":"Para mascota","showInsurances":"Ver aseguradoras","firstAppointmentWithNumber":"1ª consulta","moreCenters":"centros más","specialistInSearh":"Especialista en:","notAllowFirstAppointmentChat":"Le informamos que este profesional no tiene permitido el chat como primera consulta. En cambio, puede solicitar cualquier otro servicio disponible","free":"Gratis","consultationsAndServices":"Consultas y servicios","request":"Solicitar","otherConsultationsAndServices":"Otras consultas y servicios","specialtyNotFoundAdvice":"Le recordamos que el acceso a profesionales para consultas online es un servicio de pago por uso con precios bonificados","noPhysicalLocation":"Sin ubicación física","showProfessionals":"Ver Profesionales","servicesSearch":"Servicios","search-banner":"No incluimos publicidad. No cedemos datos a terceros. No ofrecemos “cuentas premium”.","our-policy":"Nuestra política","searcherTitle":"Buscador","professionalServices":{"sendMessage":"Enviar mensaje","interconsultation":"Interconsultas","facilityRent":"Instalaciones en alquiler"},"soon-label":"Próximamente","requestBudget":"Solicitar presupuesto","budget":"Presupuesto","subscriptorsAdviceSearch":"A continuación se mostrarán todos los profesionales de opensalud relativos a su criterio de búsqueda. Si sólo quiere acceder a profesionales incluidos en su suscripción (particular o empresa), puede marcar la casilla <b>Solo profesionales incluidos en mi suscripción</b> o iniciar sesión en 360.opensalud.es"}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = {"pyme":{"title":"Programa PYME","text":"<p>OPEN HEALTHCARE, S.L. ha sido beneficiaria de Fondos Europeos, cuyo objetivo es la mejora de la competitividad de las PYMES, y gracias al cual ha puesto en marcha un Plan de Acción con el objetivo de impulsar el uso seguro y fiable del ciberespacio y la competitividad de las pymes durante el año 2024. Para ello ha contado con el apoyo del Programa Pyme Cibersegura de la Cámara de Comercio de Sevilla. #EuropaSeSiente</p>"}}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = {"tests":{"finishTest":"Ver resultados","section":"Apartado","previousResults":"Ver resultados anteriores","psychosocial-risks":{"title":"Riesgos psicosociales","questions":{"q1":"¿Tienes que trabajar muy rápido?","q2":"¿La distribución de tareas es irregular y provoca que se te acumule el trabajo?","q3":"¿Tienes tiempo de llevar al día tu trabajo?","q4":"¿Te cuesta olvidar los problemas del trabajo?","q5":"¿Tu trabajo, en general, es desgastador emocionalmente?","q6":"¿Tu trabajo requiere que escondas tus emociones?","q7":"¿Tienes influencia sobre la cantidad de trabajo que se te asigna?","q8":"¿Se tiene en cuenta tu opinión cuando se te asignan tareas?","q9":"¿Tienes influencia sobre el orden en el que realizas las tareas?","q10":" ¿Puedes decidir cuándo haces un descanso?","q11":"Si tienes algún asunto personal o familiar ¿puedes dejar tu puesto de trabajo al menos una hora sin tener que pedir un permiso especial?","q12":"¿Tu trabajo requiere que tengas iniciativa?","q13":"¿Tu trabajo permite que aprendas cosas nuevas? ","q14":"¿Te sientes comprometido con tu profesión? ","q15":"¿Tienen sentido tus tareas? ","q16":"¿Hablas con entusiasmo de tu empresa a otras personas? ","q17":"En estos momentos, ¿estás preocupado/a por lo difícil que sería encontrar otro trabajo en el caso de que te quedaras en paro?","q18":"En estos momentos, ¿estás preocupado/a por si te cambian de tareas contra tu voluntad? ","q19":"En estos momentos, ¿estás preocupado/a por si te cambian el horario (turno, días de la semana, horas de entrada y salida) contra tu voluntad? ","q20":"En estos momentos, ¿estás preocupado/a por si te varían el salario (que no te lo actualicen, que te lo bajen, que introduzcan el salario variable, que te paguen en especie, etc.)? ","q21":"¿Sabes exactamente qué margen de autonomía tienes en tu trabajo?","q22":"¿Sabes exactamente qué tareas son de tu responsabilidad?","q23":"¿En esta empresa se te informa con suficiente antelación de los cambios que pueden afectar tu futuro?","q24":"¿Recibes toda la información que necesitas para realizar bien tu trabajo?","q25":"¿Recibes ayuda y apoyo de tus compañeras o compañeros?","q26":"¿Recibes ayuda y apoyo de tu inmediato o inmediata superior?","q27":"¿Tu puesto de trabajo se encuentra aislado del de tus compañeros/as?","q28":"En el trabajo, ¿sientes que formas parte de un grupo?","q29":"¿Tus actuales jefes inmediatos planifican bien el trabajo?","q30":"¿Tus actuales jefes inmediatos se comunican bien con los trabajadores y trabajadoras?","q31":"¿Qué parte del trabajo familiar y doméstico haces tú?","q32":"Si faltas algún día en casa, ¿las tareas domésticas que realizas se quedan sin hacer?","q33":"Cuando estás en la empresa ¿piensas en las tareas domésticas y familiares?","q34":"¿Hay momentos en los que necesitarías estar en la empresa y en la casa a la vez?","q35":"Mis superiores me dan el reconocimiento que me merezco","q36":"En las situaciones difíciles en el trabajo recibo el apoyo necesario","q37":"En mi trabajo me tratan injustamente","q38":"Si pienso en todo el trabajo y esfuerzo que he realizado, el reconocimiento que recibo en mi trabajo me parece adecuado"},"dimensions":{"ap1":"Exigencias psicológicas","ap2":"Control sobre el trabajo","ap3":"Inseguridad sobre el futuro","ap4":"Apoyo social y calidad de liderazgo","ap5":"Doble presencia","ap6":"Estima"},"scores":{"psicoDemandsLow":"Existe un exceso de exigencias psicológicas del trabajo: hay que trabajar rápido o de forma irregular, el trabajo requiere que escondamos los sentimientos…","controlOverWorkLow":"Existe una cierta falta de control sobre los contenidos y las condiciones de trabajo o las posibilidades de desarrollo: no tenemos influencia ni margen de autonomía en la forma de realizar nuestro trabajo, el trabajo no da posibilidades para aplicar nuestras habilidades y conocimientos o no tiene sentido, no podemos adaptar el horario a las necesidades familiares.","insecuritiesLow":"Se considera que existen insuficientes compensaciones por el trabajo como por ejemplo: falta de respeto, inseguridad contractual, cambio de puesto o servicio contra nuestra voluntad, trato injusto…","leadershipLow":"Existe una cierta falta de apoyo social, de calidad de liderazgo, de previsibilidad o de claridad de rol en el trabajo: cuando hay que trabajar aisladamente, sin apoyo de los superiores o compañeros, con las tareas mal definidas o sin la información adecuada y a tiempo…","doublePresenceLow":"El trabajo familiar y doméstico implica exigencias que deben asumirse de forma simultánea a las del trabajo remunerado lo que implica una doble carga de trabajo, y la organización de éste puede dificultar la compatibilización de ambos.","esteemLow":"Se considera que existen insuficientes compensaciones por el trabajo como por ejemplo: falta de respeto, inseguridad contractual, cambio de puesto o servicio contra nuestra voluntad, trato injusto…"},"description":"El test que va a responder servirá para realizar la evaluación de riesgos psicosociales. Su objetivo es identificar y medir las condiciones de trabajo relacionadas con la organización del trabajo y que pueden representar un riesgo para la salud.","positive":"Favorable","middle":"Intermedia","negative":"Desfavorable","finalCompletedMessage":"Gracias por completar el test de riesgos psicosociales. <br><br>Los resultados, como cualquier otra información personal de la plataforma, son confidenciales y sólo son accesibles en su caso por el profesional de la salud que le esté atendiendo, si así lo decide. Le recordamos que su empresa sólo recibe datos agregados de uso de la plataforma y nunca recibe información personal.","finalCompletedMessageAccessAgain":"Ya ha completado el test de riesgos psicosociales este mes. Podrá volver a realizar una evaluación transcurridos 30 días.  <br><br>Los resultados, como cualquier otra información personal de la plataforma son confidenciales y sólo son accesibles en su caso por el profesional de la salud que le esté atendiendo, si así lo decide. Le recordamos que su empresa sólo recibe datos agregados de uso de la plataforma y nunca recibe información personal."},"ryff-scale":{"title":"Bienestar psicólogico","questions":{"q1":"No tengo miedo a expresar mis opiniones, incluso cuando son contrarias a las de la mayoría de la gente","q2":"Para mí, la vida ha sido un proceso continuo de aprendizaje, cambio y crecimiento","q3":"En general, siento que tengo el control de la situación en la que vivo","q4":"La gente me describiría como una persona generosa, dispuesta a compartir mi tiempo con los demás","q5":"No estoy interesado en actividades que amplíen mis horizontes","q6":"Disfruto haciendo planes para el futuro y trabajando para hacerlos realidad","q7":"La mayoría de la gente me ve como cariñoso y afectuoso","q8":"En muchos aspectos me siento decepcionado por mis logros en la vida","q9":"Vivo la vida día a día y no pienso en el futuro","q10":"Tiendo a preocuparme por lo que los demás piensan de mí","q11":"Cuando miro la historia de mi vida, me alegro de cómo han ido las cosas","q12":"Tengo dificultades para organizar mi vida de forma que me resulte satisfactoria","q13":"Mis decisiones no suelen estar influidas por lo que hacen los demás","q14":"Hace tiempo que dejé de intentar hacer grandes mejoras o cambios en mi vida","q15":"Las exigencias de la vida cotidiana a menudo me deprimen","q16":"No he experimentado muchas relaciones afectuosas y de confianza con los demás","q17":"Creo que es importante vivir nuevas experiencias que desafíen tu forma de pensar sobre ti mismo y sobre el mundo","q18":"Mantener relaciones estrechas me ha resultado difícil y frustrante","q19":"Mi actitud hacia mí mismo probablemente no sea tan positiva como la de la mayoría de la gente hacia ellos mismos","q20":"Tengo un sentido de dirección y propósito en la vida","q21":"Me juzgo por lo que creo que es importante, no por los valores de lo que otros creen que es importante","q22":"En general, me siento seguro y positivo conmigo mismo","q23":"He podido construirme un entorno y un estilo de vida que me gustan mucho","q24":"Tiendo a dejarme influenciar por personas con opiniones firmes","q25":"No me gusta encontrarme en situaciones nuevas que me obliguen a cambiar mi forma habitual de hacer las cosas","q26":"No encajo muy bien con la gente y la comunidad que me rodea","q27":"Sé que puedo confiar en mis amigos, y ellos saben que pueden confiar en mí","q28":"Cuando pienso en ello, no he mejorado mucho como persona a lo largo de los años","q29":"Algunas personas vagan sin rumbo por la vida, pero yo no soy una de ellas","q30":"A menudo me siento solo porque tengo pocos amigos íntimos con los que compartir mis preocupaciones","q31":"Cuando me comparo con amigos y conocidos, me siento bien con lo que soy","q32":"No tengo del todo claro lo que estoy tratando de lograr en la vida","q33":"A veces me siento como si hubiera hecho todo lo que hay que hacer en la vida","q34":"Siento que muchas de las personas que conozco han sacado más provecho de la vida que yo","q35":"Confío en mis opiniones, aunque sean contrarias al consenso general","q36":"Soy bastante bueno gestionando las muchas responsabilidades de mi vida diaria","q37":"Tengo la sensación de que me he desarrollado mucho como persona con el tiempo","q38":"Disfruto de las conversaciones personales y mutuas con familiares y amigos","q39":"Mis actividades diarias a menudo me parecen triviales y sin importancia","q40":"Me gusta la mayor parte de mi personalidad","q41":"Me cuesta expresar mis opiniones sobre temas controvertidos","q42":"A menudo me siento abrumado por mis responsabilidades"},"dimensions":{"self-acceptance":"Autoaceptación","life-purposes":"Propósitos en la vida","environmental-control":"Dominio del entorno","positive-relationships":"Relaciones positivas","personal-growth":"Crecimiento personal","autonomy":"Autonomía"},"scores":{"selfAcceptanceHigh":"No siempre es fácil pero es muy importante sentirse bien tal y como uno es, asumiendo también los defectos que todos tenemos y aquellas cosas que no nos gustan tanto de nosotros mismos.<br /><br />No olvides seguir cuidándote y manteniendo un buen nivel de autoestima en las diferentes situaciones de la vida. Una de las cosas más importantes que podemos hacer en nuestra vida es aceptar nuestra imagen, nuestro pasado, la forma en que actuamos, las cosas que sentimos y los pensamientos que tenemos.","selfAcceptanceLow":"Puede llegar a ser complicado tener una imagen positiva de nosotros mismos si nos exigimos demasiado. Apóyate en las cosas que más te gusten de ti y analiza aquellas que menos te convencen pero que pueden mejorarse con tu esfuerzo. Siempre nos quedaran aspectos que nos gustaría mejorar pero que debemos aceptar, especialmente cuando quedan fuera de nuestras posibilidades.","lifePurposesHigh":"Bien hecho. Muchas veces sabemos que hay cosas que queremos hacer en la vida, pero no sabemos cómo empezar. Tener propósitos y conseguir dirigir nuestra vida hacía ellos nos permite sentirnos motivados y vivir una vida más saludable y gratificante.<br /><br />Todo el mundo tiene sus buenos y sus malos días, pero el tener un propósito, nos ayuda a tener perspectiva incluso cuando las cosas no van bien.","lifePurposesLow":"En lugar de enfocarte en tener un 'gran' propósito, busca disfrutar de las pequeñas cosas del día a día, y trata de priorizar en tu vida esas situaciones. Si no encuentras un camino claro, deja que sean los momentos que vives cada día los que te guíen hacia lo que puede ser que estés buscando pero no terminas de ver con claridad. No tengas prisa.","environmentalControlHigh":"La capacidad de dominar el entorno es imprescindible para gestionar de manera adecuada las diferentes situaciones que ocurren en la vida, muchas de las cuales no tienen que ver con nosotros ni con nuestras acciones.<br /><br />Un adecuado control de las circunstancias que nos rodean, pueden ser un apoyo fundamental en situaciones adversas.","environmentalControlLow":"En muchas ocasiones buscamos controlar algo que ha sucedido a nuestro alrededor, cuando en la mayoría de los casos estas situaciones están fuera de nuestro control. Trata de no obsesionarte con las cosas que no dependen de ti, y concéntrate en aquello que esté en tu mano cambiar.","positiveRelationshipsHigh":"Eres capaz de mantener relaciones de calidad con otras personas. Te preocupas por el bienestar de los demás y tienes la capacidad de mostrar empatía, cariño y respeto por otras personas. Si tienes buenas relaciones, ¡trabaja para mantenerlas! y no tengas miedo en hablar cuando surge algún problema.","positiveRelationshipsLow":"Para construir buenas relaciones es importante realizar pequeños esfuerzos para ser por ejemplo algo más abierto y empático. Si tienes dificultad para mantener relaciones de calidad (cariño, confianza…) con otras personas a veces es aconsejable analizar nuestras actitudes hacia ellas.<br /><br />Si sientes que estás haciendo todo lo que está en tu mano y no recibes una respuesta acorde, recuerda que no tienes porqué mantener una relación estrecha con todo el mundo. Si por el contrario crees que podrías hacer algo más, trabaja en ello poco a poco, realizando pequeños esfuerzos que puedan ayudarte a construir una relación más positiva, a veces, algo aparentemente tan simple como una sonrisa o un comentario amable, producen grandes efectos","personalGrowthHigh":"El crecimiento personal es básico para vivir una vida plena. No se manifiesta de manera inmediata, sino que es algo que se ve en el día a día. Nos ayuda a cambiar, a mejorar y a superarnos.<br /><br />Todos tenemos el potencial de crecer a lo largo de nuestra vida, aprovecha el buen momento para seguir dando pasos grandes o pequeños. Se realizan pequeños cambios a diario, aunque te pueda parecer lo contrario.","personalGrowthLow":"El crecimiento personal no es algo que se pueda forzar para obtener resultados inmediatos. Si sientes que te has estancado, piensa que el crecimiento se produce con pequeñas acciones.<br /><br />Puede llegar a ser muy frustrante pensar que no se están realizando progresos, pero la realidad es que incluso sin ser consciente, puedes estar haciendo pequeños avances. Todo suma. Céntrate en los aspectos que deseas mejorar y ve marcándote objetivos fáciles de completar a corto plazo. El crecimiento personal no solo tiene que ver con grandes cambios, disfruta del proceso de conocerte.","autonomyHigh":"La autonomía es una de las características esenciales de las personas felices. Significa que tienes el poder de gestionar tu vida y seguir tu propio camino sin dejar que te afecte en exceso lo que otros puedan pensar.","autonomyLow":"Si te cuesta decir que no, o expresar tus opiniones libremente, empieza por trabajar en ello con personas de tu círculo de confianza para desarrollar poco a poco tu autonomía. Asimismo, es importante aprender a distinguir aquellas personas a las que merece la pena escuchar de las que no te aportan mucho."},"description":"La escala de Ryff es un test de autoevaluación multidimensional que mide el nivel general de bienestar psicológico de la persona en base a las respuestas proporcionadas a preguntas pertenecientes a 6 dimensiones diferentes.","resultsAnalysisGood":"Bien hecho. Has conseguido mejorar tu nivel de bienestar emocional respecto a la última vez. No olvides seguir trabajando día a día en tu salud emocional, teniendo en cuenta que habrá situaciones sencillas de resolver y otras que cuesten algo más, pero siempre con la buena actitud que muestras.<br /><br />A continuación tienes un resumen de los resultados que te permitirá saber si hay margen de mejora en alguna de las dimensiones analizadas.","resultsAnalysisMedium":"Tu nivel de bienestar emocional se mantiene a un nivel similar al mostrado la última vez que completaste el test. Cada día nos depara una aventura diferente, y es probable que se hayan producido cambios en alguna de las dimensiones.<br /><br />A continuación tienes un resumen de los resultados que te permitirá saber si hay margen de mejora en alguna de las dimensiones analizadas.","resultsAnalysisBad":"El nivel de bienestar emocional que muestra el resultado del test es algo inferior a lo obtenido la última vez, pero un tropiezo lo tiene cualquiera. Es posible que se hayan acumulado algunas cosas en tu día a día durante este periodo que hayan dificultado tu evolución. En todo caso no te desanimes, el simple hecho de hacer el test demuestra que quieres poner de tu parte para mejorar y eso es lo importante.<br /><br />A continuación, tienes un pequeño resumen de tu bienestar emocional. Aprovecha para analizar aquellas áreas que te están costando más mejorar.","resultsAnalysisFirstTime":"Enhorabuena por completar nuestro test de bienestar emocional. Recuerda hacerlo todos los meses para poder hacer un seguimiento de tu evolución.<br /><br />A continuación tienes un resumen de los resultados que te permitirá saber si hay margen de mejora en alguna de las dimensiones analizadas."},"findrisk":{"title":"Findrisk (Riesgo diabetes)","diabetesRisk":"Riesgo diabetes","questions":{"q1":"Edad","q2":"IMC (Índice de masa corporal)","q3":"Perímetro de la cintura","q4":"¿Realiza habitualmente al menos 30 minutos de actividad física diaria o 4 horas semanales, en el trabajo y/o en el tiempo libre?","q5":"¿Come a diario frutas o verduras?","q6":"¿Toma medicación para la hipertensión arterial?","q7":"¿Le han encontrado alguna vez niveles de glucosa altos, por ejemplo, en una revisión médica, en el embarazo o durante una enfermedad?","q8":"¿Se le ha diagnosticado diabetes (tipo 1 o 2) a algún familiar o pariente suyo?"},"scores":{"lowRisk":"Riesgo bajo","lightRisk":"Riesgo ligero","moderateRisk":"Riesgo moderado","highRisk":"Riesgo alto","veryHighRisk":"Riesgo muy alto","maxRisk":"Riesgo máximo"},"weightPH":"Peso","weightUnit":"kg","heightUnit":"cm","heightPH":"Altura","description":"El test Findrisk es un cuestionario que evalúa el riesgo de una persona de padecer diabetes en los próximos 10 años.","IMC":"IMC","cantReplaceDiagnosis":"El test FINDRISK <b>no puede reemplazar un diagnóstico facultativo</b>. Por este motivo, debe consultar con su médico el resultado obtenido. Es esencial que consulte con un especialista si el riesgo es alto o muy alto.","tips":{"highRiskTip":"Según los resultados, el riesgo de padecer diabetes en los próximos 10 años es alto o muy alto. Aunque el profesional le precisará en su caso las pautas concretas de actuación, debe saber que aún puede estar a tiempo de prevenirla, manteniendo un estilo de vida saludable.","tip1":"<strong>Reduzca su peso</strong> si está en sobrepeso (IMC igual o superior a 25) u obesidad (IMC igual o superior a 30)","tip2":"Practique <strong>actividad física regular</strong> al menos 30min (andar a un ritmo elevado, por ejemplo) y al menos 5 días a la semana.","tip3":"<strong>Mejore su alimentación</strong>, aumentando la ingesta de frutas y verduras, disminuyendo el consumo de grasas y aumentando el consumo de fibra natural entre otros."}},"nicotine-dependency":{"title":"Dependencia nicotina","questions":{"q1":"Mi hábito de fumar es muy importante para mí","q2":"Juego y manipulo el cigarrillo como parte del ritual de fumar","q3":"¿Suele ponerse algo en la boca para evitar fumar?","q4":"¿Se recompensa a sí mismo con un cigarrillo tras realizar cualquier tarea?","q5":"¿Cuándo no tiene tabaco le resulta difícil concentrarse y realizar cualquier tarea?","q6":"¿Cuándo se encuentra en un lugar en el que está prohibido fumar, juega con su cigarrillo o paquete de tabaco?","q7":"¿Algunos lugares o circunstancias le incitan a fumar: su sillón favorito, habitación, coche, bebida (alcohol, café, etc.)?","q8":"¿Se encuentra a menudo encendiendo un cigarrillo por rutina, sin desearlo realmente?","q9":"¿A menudo se coloca cigarrillos sin encender u otros objetos en la boca (bolígrafos, palillos, etc.) y los chupa para relajarse del estrés, tensión, frustración, etc.?","q10":"¿Parte de su placer de fumar procede del ritual que supone encender un cigarrillo?","q11":"Cuándo está solo en un restaurante, parada de autobús, etc. ¿Se siente más seguro, a salvo o más confiado con un cigarrillo en las manos?"},"scores":{"depLevel":"Tu nivel de dependencia","noDependency":{"name":"No tienes dependencia","description":"¡Felicidades por tu determinación y fuerza de voluntad! Mantener un estilo de vida libre de nicotina es una decisión admirable y valiente. Estás optando por una vida más saludable y energética, demostrando tu compromiso con el cuidado de tu bienestar. Este camino que estás siguiendo es una inspiración para muchos. Tu elección de vivir libre de humo es un testimonio de tu dedicación para cuidar de ti mismo y de aquellos que te rodean. Sigue adelante en este viaje positivo y continúa cuidándote."},"lowDependency":{"name":"Dependencia leve","description":"Los fumadores con una dependencia leve pueden experimentar una necesidad ocasional de fumar, pero no tienen una necesidad constante o fuerte de nicotina. Pueden fumar de forma intermitente o social, y pueden ser capaces de dejar de fumar sin experimentar síntomas graves de abstinencia."},"midDependency":{"name":"Dependencia moderada","description":"Los fumadores con una dependencia moderada pueden sentir una necesidad constante de nicotina y pueden fumar regularmente durante el día. Pueden experimentar síntomas de abstinencia cuando intentan dejar de fumar, pero estos síntomas no son tan graves como los de la dependencia fuerte o muy fuerte."},"highDependency":{"name":"Dependencia fuerte","description":"Los fumadores con una dependencia fuerte experimentan una necesidad intensa y constante de nicotina. Pueden fumar numerosos cigarrillos al día y pueden experimentar síntomas graves de abstinencia cuando intentan dejar de fumar. Pueden sentir que su vida diaria gira en torno al fumar, y pueden tener dificultades para realizar actividades que no involucren fumar."},"veryHighDependency":{"name":"Dependencia muy fuerte","description":"Los fumadores con una dependencia muy fuerte experimentan una necesidad extrema y constante de nicotina. Pueden fumar una gran cantidad de cigarrillos al día y pueden experimentar síntomas graves de abstinencia cuando intentan dejar de fumar. La dependencia muy fuerte puede afectar su capacidad para realizar actividades diarias, trabajar y socializar. Pueden sentir que no pueden controlar su comportamiento de fumar y pueden tener una gran dificultad para dejar de fumar."}},"tips":{"general":"Dejar de fumar puede ser un proceso difícil, pero es una de las decisiones más saludables que puedes tomar para mejorar tu salud. Si necesita más ayuda, consulte a un profesional de la salud o un especialista en dejar de fumar. Aún así, a continuación encontrará una serie de consejos que le pueden servir de ayuda en el proceso.","motivation":{"name":"Busca apoyo y motivación","description":"Comparte tus planes para dejar de fumar con amigos, familiares y profesionales de la salud. Busca grupos de apoyo y programas de tratamiento para dejar de fumar."},"causes":{"name":"Identifica tus desencadenantes y evítalos","description":"Identifica los desencadenantes que te hacen fumar, como el estrés, el aburrimiento o la ansiedad. Trata de evitarlos o de encontrar formas saludables de manejarlos."},"endDate":{"name":"Establece una fecha para dejar de fumar","description":"Establece una fecha límite para dejar de fumar y trabaja para alcanzar ese objetivo."},"forgetTheHabit":{"name":"Intenta reemplazar el hábito de fumar con otras actividades","description":"Encuentra actividades que disfrutes y que no involucren fumar, como hacer ejercicio, leer o escuchar música, pasar tiempo con tus amigos o tu familia, etc."},"relaxTechniques":{"name":"Practica técnicas de relajación y manejo del estrés","description":"El estrés y la ansiedad pueden ser desencadenantes comunes para fumar. Pruebas técnicas como la meditación, la respiración profunda o el yoga para reducir el estrés."},"rewards":{"name":"Establece recompensas para alcanzar tus objetivos","description":"Establece recompensas para ti mismo por alcanzar tus objetivos, como ahorrar dinero o comprar algo que hayas estado deseando."},"conscious":{"name":"Toma conciencia de tu hábito de fumar","description":"Una vez que tengas una idea clara de cuándo, dónde y por qué fumas, será más fácil trabajar para reducir la dependencia."},"reduceDaily":{"name":"Reduce la cantidad de cigarrillos que fumas diariamente","description":"Si no estás listo para dejar de fumar por completo, reducir la cantidad de cigarrillos que fumas cada día puede ser un primer paso importante."},"lookForSupport":{"name":"Busque apoyo","description":"Comparte tus planes de dejar de fumar con amigos, familiares o grupos de apoyo. Buscar ayuda y motivación puede hacer que sea más fácil dejar de fumar."},"rememberBenefits":{"name":"Recuerda los beneficios","description":"Los beneficios de dejar de fumar son muchos, entre ellos, recuerda que te sentirás mejor físicamente y tendrás una mejor salud, consiguiendo prevenir enfermedades como problemas respiratorios o algún tipo de cáncer."},"healthyLifestyle":{"name":"Mantén un estilo de vida saludable","description":"Mantener un estilo de vida saludable puede ayudarte a lidiar con los síntomas de abstinencia y reducir la tentación de fumar. Trata de hacer ejercicio regularmente, comer una dieta equilibrada y dormir lo suficiente."}},"description":"Estás a punto de realizar el test de dependencia de la nicotina de Glover-Nilsson, que se utiliza para evaluar el nivel de dependencia física y psicológica a la nicotina en fumadores. Este test, clasifica la dependencia en cuatro niveles: leve, moderada, fuerte y muy fuerte."},"completed":"completado","testResults":"RESULTADOS DEL TEST","dimensions":"Dimensiones","results":"Resultados","tips":"Consejos","well-being":"Bienestar psicológico","alreadyCompletedMessage":"Ya ha realizado el test este mes, por lo que se mostrarán los resultados. Vuelva el mes que viene para volver a completarlo.","wannaStart":"Empleará alrededor de unos 8 minutos. ¿Desea comenzar?","wannaStartShort":"Empleará alrededor de unos 5 minutos. ¿Desea comenzar?","startTest":"Comenzar test","downloadResults":"Descargar resultados","testCompleted":"Has invertido tiempo en ti para completar la autoevaluación. No olvides completarlo periódicamente para que puedas ver tu progresión. <br><br>Si lo deseas, podrás compartir los resultados con un profesional al solicitar una consulta.","psicosocialRisks":"Riesgos psicosociales","self-evaluation-tests":{"title":"Evalúa tu salud"},"hello":"Hola","answers":{"nothingAtAll":"Nada en absoluto","something":"Algo","yes":"Sí","aLot":"Mucho","lotsOf":"Muchísimo","always":"Siempre","alot":"A menudo","sometimes":"A veces","justsometimes":"Raramente","never":"Nunca","total-agreement":"Totalmente de acuerdo","some-agreement":"Bastante de acuerdo","bit-agreement":"Un poco de acuerdo","agreement-disagreement":"Ni de acuerdo ni en desacuerdo","bit-disagreement":"Un poco en desacuerdo","some-disagreement":"Bastante en desacuerdo","total-disagreement":"Totalmente en desacuerdo","worried":"Muy preocupado","prettyWorried":"Bastante preocupado","moreorlessWorried":"Más o menos preocupado","littleWorried":"Poco preocupado","notWorried":"Nada preocupado","mainResponsible":"Soy la/el principal responsable y hago la mayor parte de las tareas familiares y domésticas","halfResponsible":"Hago aproximadamente la mitad de las tareas familiares y domésticas","quarterResponsible":"Hago más o menos una cuarta parte de las tareas familiares y domésticas","punctuallyResponsible":"Sólo hago tareas muy puntuales","notResponsible":"No hago ninguna o casi ninguna de estas tareas","no":"No","yesCloseFamily":"Sí (Padres, hermanos o hijos)","yesNotCloseFamily":"Sí (Abuelos, tíos, primos hermanos)","lessThan45":"Menos de 45 años","45to54":"45-54 años","55to64":"55-64 años","moreThan64":"Más de 64 años","lessThan94":"Menos de 94 cm","94to102":"Entre 94 y 102 cm","moreThan102":"Más de 102 cm","lessThan80":"Menos de 80 cm","80to88":"Entre 80 y 88 cm","moreThan88":"Más de 88 cm","man":"Hombre","woman":"Mujer","none":"Ninguna","orMore":"o más","lessThan":"Menos de","almostNever":"Casi nunca","alot2":"Muy a menudo","notInTheLastMonth":"Ninguna vez en el último mes","lessThanOnceAWeek":"Menos de una vez a la semana","onceAWeek":"Una o dos veces a la semana","moreThanOnceAWeek":"Tres o más veces a la semana","veryGood":"Muy buena","prettyGood":"Bastante buena","prettyBad":"Bastante mala","veryBad":"Muy mala","alone":"Solo en casa","someoneOtherRoom":"Con alguien en otra habitación","someoneSameRoom":"Con alguien en la misma habitación, pero en otra cama","someoneSameBed":"Con alguien en la misma cama","noProblem":"Ningún problema","lightProblem":"Sólo un leve problema","problem":"Un problema","seriousProblem":"Un grave problema","lessThan15minutes":"Menos de 15 minutos","15to30minutes":"Entre 15 y 30 minutos","30to60minutes":"Entre 30 y 60 minutos","moreThan60minutes":"Más de 60 minutos","veryHigh":"Muy alta","high":"Alta","low":"Baja","veryLow":"Muy baja","slightly":"Levemente","moderately":"Moderadamente","severely":"Severamente","limitALot":"Sí, me limita mucho","limitABit":"Sí, me limita un poco","limitNone":"No, no me limita nada","noneMasculine":"Ninguno","verySlight":"Muy leve","slight":"Leve","moderate":"Moderado","severe":"Severo","verySevere":"Muy severo","veryLittle":"Muy poco","prettyMuch":"Bastante","extremately":"Extremadamente","excelent":"Excelente","good":"Buena","regular":"Regular","bad":"Mala","muchBetterNow":"Mucho mejor ahora","someBetterNow":"Algo mejor ahora","moreOrLessTheSame":"Más o menos igual","someWorseNow":"Algo peor ahora","muchWorseNow":"Mucho peor ahora","agreement":"De acuerdo","disagreement":"En desacuerdo"},"mediterranean-diet":{"title":"Dieta mediterránea","description":"La Dieta Mediterránea es una forma de alimentación que se caracteriza por el consumo de alimentos frescos, naturales y variados, como frutas, verduras, legumbres, pescado, aceite de oliva y frutos secos. Esta dieta ha sido ampliamente estudiada y se ha demostrado que tiene muchos beneficios para la salud.","questions":{"q1":"¿Usa usted aceite de oliva como principal grasa para cocinar?","q2":"¿Cuántas cucharadas de aceite de oliva consume usted en total al día? (incluyendo el usado para freír, el de las comidas fuera de casa, las ensaladas, etc.)","q3":"¿Cuántas raciones de verdura u hortalizas consume al día? (las guarniciones o acompañamientos contabilizan como media ración)","q4":"¿Cuántas piezas de fruta consume al día?","q5":"¿Cuántas raciones de carnes rojas, hamburguesas, salchichas o embutidos consume al día? (una ración equivale a 100-150 gr.)","q6":"¿Cuántas raciones de mantequilla, margarina o nata consume al día? (una porción individual equivale a 12 gr.)","q7":"¿Cuántas bebidas carbonatadas y/o azucaradas (refrescos, colas, tónicas, bitter) consume al día?","q8":"¿Cuántas raciones de legumbres consume a la semana? (una ración o plato equivale a 150 gr.)","q9":"¿Cuántas raciones de pescado o mariscos consume a la semana? (un plato, pieza o ración equivale a 100-150 gr de pescado ó 4-5 piezas de marisco)","q10":"¿Cuántas veces consume repostería comercial (no casera) como galletas, flanes, dulces o pasteles a la semana?","q11":"¿Cuántas veces consume frutos secos a la semana? (una ración equivale a 30 gr.)","q12":"¿Consume preferentemente carne de pollo, pavo o conejo en vez de ternera, cerdo, hamburguesas o salchichas? (carne de pollo: una pieza o ración equivale a 100-150 gr.)","q13":"¿Cuántas veces a la semana consume los vegetales cocinados, la pasta, el arroz u otros platos aderezados con una salsa de tomate, ajo, cebolla o puerro elaborada a fuego lento con aceite de oliva (sofrito)?"},"scores":{"lowAdherence":{"name":"Baja adherencia","description":"No llevas una dieta saludable, lo que puede tener numerosas consecuencias negativas para tu salud. Una dieta saludable es fundamental para proporcionar al cuerpo los nutrientes necesarios para mantener una buena salud, prevenir enfermedades y mantener un peso saludable."},"goodAdherence":{"name":"Buena adherencia","description":"¡Llevas una dieta saludable lo que tiene numerosos beneficios para tu salud, tanto a corto como a largo plazo!"},"description":"La Dieta Mediterránea es una forma de alimentación que se caracteriza por el consumo de alimentos frescos, naturales y variados, como frutas, verduras, legumbres, pescado, aceite de oliva y frutos secos. Esta dieta ha sido ampliamente estudiada y se ha demostrado que tiene muchos beneficios para la salud."},"consequences":{"consequences":"Consecuencias de una baja adherencia a la dieta mediterránea","heartDiseasesRisk":{"name":"Mayor riesgo de enfermedades cardiovasculares","description":"La Dieta Mediterránea se ha asociado con una reducción significativa del riesgo de enfermedades del corazón. Por lo tanto, la baja adherencia a esta dieta puede aumentar el riesgo de padecer problemas cardiovasculares."},"diabetesRisk":{"name":"Mayor riesgo de diabetes","description":"Se ha demostrado que la Dieta Mediterránea puede reducir el riesgo de diabetes tipo 2, y una baja adherencia a esta dieta puede aumentar el riesgo de desarrollar esta enfermedad, además de otras enfermedades crónicas."},"cancerRisk":{"name":"Mayor riesgo de cáncer","description":"Algunos estudios han encontrado que la Dieta Mediterránea puede reducir el riesgo de ciertos tipos de cáncer, como el cáncer de mama y el cáncer colorrectal. Por lo tanto, la baja adherencia a esta dieta puede aumentar el riesgo de desarrollar estos tipos de cáncer."},"cognitiveFunction":{"name":"Aumento de peso","description":"La Dieta Mediterránea es rica en alimentos saludables y bajos en calorías, lo que puede ayudar a controlar el peso. La baja adherencia a esta dieta puede conducir a un aumento de peso y, en última instancia, a la obesidad, provocada principalmente por la ingesta de alimentos procesados, alimentos altos en grasas saturadas y azúcares añadidos, y un bajo consumo de frutas, verduras y granos enteros."},"mentalHealth":{"name":"Mayor riesgo de depresión","description":"La Dieta Mediterránea ayuda a mejorar la salud mental ya que puede reducir el riesgo de depresión, ansiedad y mejorar el estado de ánimo. Por lo tanto, la baja adherencia a esta dieta puede aumentar el riesgo de depresión y otros problemas de salud mental."}},"benefits":{"benefits":"Beneficios de una alta adherencia a la dieta mediterránea","heartDiseasesRisk":{"name":"Reducción del riesgo de enfermedades cardiovasculares","description":"La Dieta Mediterránea se ha asociado con una reducción del riesgo de enfermedades cardiovasculares, como la hipertensión arterial, la enfermedad coronaria y el accidente cerebrovascular. Esto se debe en parte a la alta ingesta de grasas monoinsaturadas y ácidos grasos omega-3, presentes en alimentos como el aceite de oliva y el pescado, que ayudan a reducir la inflamación y el colesterol LDL o 'malo'."},"diabetesRisk":{"name":"Reducción del riesgo de diabetes","description":"La Dieta Mediterránea puede reducir el riesgo de diabetes tipo 2 debido a su alta ingesta de fibra, que ayuda a regular los niveles de glucosa en sangre, y su bajo consumo de alimentos procesados y carnes rojas."},"cancerRisk":{"name":"Reducción del riesgo de cáncer","description":"La Dieta Mediterránea se ha asociado con una reducción del riesgo de ciertos tipos de cáncer, como el cáncer de mama y el cáncer colorrectal. Esto se debe en parte a la alta ingesta de antioxidantes y fibra presentes en frutas y verduras, así como al bajo consumo de carnes procesadas y alimentos ricos en grasas saturadas."},"cognitiveFunction":{"name":"Mejora la función cognitiva","description":"La Dieta Mediterránea se ha relacionado con una mejora en la función cognitiva y la memoria. Esto se debe en parte a la alta ingesta de ácidos grasos omega-3 presentes en el pescado, que están involucrados en la salud del cerebro."},"mentalHealth":{"name":"Mejora la salud mental","description":"La Dieta Mediterránea se ha asociado con una reducción del riesgo de depresión y ansiedad debido a su alta ingesta de antioxidantes y ácidos grasos omega-3."},"keepGoing":"Por ello, ¡sigue adoptando hábitos alimentarios saludables y lleva una dieta equilibrada para mantener una buena salud y prevenir enfermedades!"},"tips":{"description":"Consejos para mejorar tus hábitos alimenticios y aumentar la adherencia la Dieta Mediterránea","tip1":{"title":"Incluye una variedad de alimentos saludables","description":"Es importante incluir en la dieta una variedad de alimentos saludables, como frutas, verduras, granos enteros, proteínas magras y grasas saludables. Esto asegurará que se están recibiendo todos los nutrientes necesarios."},"tip2":{"title":"Reduce el consumo de alimentos procesados","description":"Los alimentos procesados suelen ser ricos en grasas saturadas, sodio y azúcares añadidos, y pobres en nutrientes. Trata de reducir su consumo y opta por alimentos frescos y naturales."},"tip3":{"title":"Come despacio y disfruta de la comida","description":"Come despacio y disfruta de la comida. Esto te ayudará a sentirte satisfecho más rápido y evitar comer en exceso."},"tip4":{"title":"Reduce el consumo de alcohol","description":"El alcohol contiene muchas calorías vacías y puede afectar negativamente la salud en general. Trata de reducir su consumo y bebe con moderación."},"tip5":{"title":"Mantén el cuerpo hidratado","description":"Bebe suficiente agua para mantener el cuerpo hidratado. Además, trata de reducir el consumo de bebidas azucaradas y refrescos."},"tip6":{"title":"Planifica las comidas","description":"Planifica las comidas de antemano para asegurarte de que estás comiendo una dieta equilibrada y evitar comer en exceso."},"tip7":{"title":"Cocina en casa","description":"Cocinar en casa te permite tener un mayor control sobre los ingredientes que se utilizan en las comidas y asegura que se están comiendo alimentos frescos y saludables."},"general":"En resumen, adoptar hábitos alimentarios saludables y mantener una dieta equilibrada puede ser fácil si se hacen algunos cambios sencillos en la alimentación y en el estilo de vida.<br><br>¡Con estos cambios, podrás mantener una buena salud y prevenir enfermedades!"}},"stress":{"title":"Escala de estrés percibido","description":"Este test de autoevaluación sobre el estrés te ayudará a identificar tus niveles actuales de estrés y cómo estos pueden estar afectando tu bienestar.","stressPerceived":"Estrés percibido","questions":{"q1":"En el último mes, ¿con qué frecuencia ha estado afectado por algo que ha ocurrido inesperadamente?","q2":"En el último mes, ¿con qué frecuencia se ha sentido incapaz de controlar las cosas importantes en su vida?","q3":"En el último mes, ¿con qué frecuencia se ha sentido nervioso o estresado?","q4":"En el último mes, ¿con qué frecuencia ha manejado con éxito los pequeños problemas irritantes de la vida?","q5":"En el último mes, ¿con qué frecuencia ha sentido que ha afrontado efectivamente los cambios importantes que han estado ocurriendo en su vida?","q6":"En el último mes, ¿con qué frecuencia ha estado seguro sobre su capacidad para manejar sus problemas personales?","q7":"En el último mes, ¿con qué frecuencia ha sentido que las cosas le van bien?","q8":"En el último mes, ¿con qué frecuencia ha sentido que no podía afrontar todas las cosas que tenía que hacer?","q9":"En el último mes, ¿con qué frecuencia ha podido controlar las dificultades de su vida?","q10":"En el último mes, ¿con qué frecuencia se ha sentido que tenía todo bajo control?","q11":"En el último mes, ¿con qué frecuencia ha estado enfadado porque  las cosas que le han ocurrido estaban fuera de su control?","q12":"En el último mes, ¿con qué frecuencia ha pensado sobre las cosas que le quedan por hacer?","q13":"En el último mes, ¿con qué frecuencia ha podido controlar la forma de pasar el tiempo?","q14":"En el último mes, ¿con qué frecuencia ha sentido que las dificultades se acumulan tanto que no puede superarlas?"}},"sleep-quality":{"title":"Calidad de sueño","pittsburg":"Cuestionario de calidad de sueño","description":"Las siguientes cuestiones solo tienen que ver con sus hábitos de sueño durante el último mes. En sus respuestas debe reflejar cual ha sido su comportamiento durante la mayoría de los días y noches del pasado mes. Por favor, conteste a todas las cuestiones.","questions":{"q1":"Durante el último mes, ¿cuál ha sido, normalmente, su hora de acostarse?","q2":"¿Cuánto tiempo habrá tardado en dormirse, normalmente, las noches del último mes?","q3":"Durante el último mes, ¿a qué hora se ha levantado habitualmente por la mañana?","q4":"¿Cuántas horas calcula que habrá dormido verdaderamente cada noche durante el último mes?","q5":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de no poder conciliar el sueño en la primera media hora?","q6":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de despertarse durante la noche o de madrugada?","q7":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de tener que levantarse para ir al servicio?","q8":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de no poder respirar bien?","q9":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de toser o roncar ruidosamente?","q10":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de sentir frío?","q11":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de sentir demasiado calor?","q12":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de tener pesadillas o malos sueños?","q13":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de sufrir dolores?","q14":"Durante el último mes, ¿cuántas veces ha tenido usted problemas para dormir a causa de otras razones?","q15":"Durante el último mes, ¿cómo valoraría en conjunto, la calidad de su sueño?","q16":"Durante el último mes, ¿cuántas veces habrá tomado medicinas (por su cuenta o recetadas por el médico) para dormir?","q17":"Durante el último mes, ¿cuántas veces ha sentido somnolencia mientras conducía, comía o desarrollaba alguna otra actividad?","q18":"Durante el último mes, ¿ha representado para usted mucho problema el tener ánimos para realizar alguna de las actividades detalladas en la pregunta anterior?","q19":"¿Duerme usted solo o acompañado?"},"dimensions":{"subjectiveQuality":"Calidad subjetiva de sueño","sleepLatency":"Latencia de sueño","sleepDuration":"Duración del sueño","sleepEfficiency":"Eficiencia habitual de sueño","sleepPerturbations":"Perturbaciones del sueño","medicationToSleep":"Utilización de medicación para dormir","dayDisfunction":"Disfunción durante el día"},"dimensionsDescriptions":{"apartado-1":"La calidad subjetiva del sueño se refiere a la evaluación personal y subjetiva que una persona hace de la satisfacción o el nivel de descanso que experimenta durante su período de sueño. Esta evaluación se basa en la percepción individual de la persona sobre la duración, profundidad y eficacia de su sueño, así como en su sensación de descanso y bienestar al despertar.</br></br>Algunos factores que pueden influir en la calidad subjetiva del sueño incluyen la comodidad del entorno de descanso, la duración del sueño, la presencia de interrupciones durante la noche, la sensación de frescura al despertar y la satisfacción general con la experiencia de dormir. Esta evaluación subjetiva es importante para comprender cómo una persona se siente con respecto a su sueño y puede ser útil para identificar problemas de sueño o mejorar la calidad de este.</br></br>Es importante destacar que la calidad subjetiva del sueño puede variar de una noche a otra y de una persona a otra, por lo que lo que para una persona puede considerarse una buena calidad de sueño, para otra puede ser diferente. También es relevante tener en cuenta que, aunque es subjetiva, la calidad del sueño puede tener un impacto significativo en la salud y el bienestar general de una persona.","apartado-2":"La latencia de sueño se refiere al período de tiempo que transcurre desde el momento en que una persona se acuesta e intenta conciliar el sueño hasta el momento en el que logra quedarse dormida. En otras palabras, es el tiempo que se tarda en quedarse dormido desde que uno se acuesta en la cama y apaga las luces hasta que finalmente entra en un estado de sueño.</br></br>La latencia de sueño puede variar ampliamente de una persona a otra y de una noche a otra. Algunas personas pueden conciliar el sueño rápidamente, en cuestión de minutos, mientras que otras pueden experimentar una peor latencia de sueño, que puede extenderse a periodos más largos, incluso horas.</br></br>La medición de la latencia de sueño es relevante en el estudio de los trastornos del sueño y puede ayudar a los profesionales de la salud a evaluar la calidad del sueño de una persona. Una latencia de sueño prolongada o problemas persistentes para conciliar el sueño pueden indicar la presencia de problemas como el insomnio. Por lo tanto, la latencia de sueño es un parámetro importante a considerar al evaluar la calidad del sueño de una persona.","apartado-3":"La duración del sueño se refiere al período de tiempo total durante el cual una persona permanece dormida durante una noche de sueño. En otras palabras, es la cantidad de tiempo que una persona pasa en un estado de sueño continuo y reparador desde el momento en que se queda dormida hasta el momento en que se despierta por la mañana.</br></br>La duración del sueño puede variar considerablemente de una persona a otra y a lo largo de diferentes etapas de la vida. Las recomendaciones de duración de sueño pueden variar según la edad y las necesidades individuales, pero en general, se considera que los adultos sanos suelen necesitar entre 7 y 9 horas de sueño por noche para sentirse descansados y alerta al día siguiente. Sin embargo, algunas personas pueden necesitar más o menos tiempo de sueño para funcionar de manera óptima.</br></br>La duración del sueño es un componente importante para evaluar la calidad del sueño y puede estar relacionada con la salud general y el bienestar de una persona. Tanto la falta crónica de sueño como el exceso de sueño pueden tener efectos negativos en la salud, por lo que encontrar un equilibrio adecuado en la duración del sueño es esencial para mantener un estilo de vida saludable.","apartado-4":"La eficiencia del sueño es el porcentaje de tiempo que una persona pasa durmiendo en relación con el tiempo total que pasa en la cama.","apartado-5":"Las perturbaciones del sueño se refieren a cualquier interrupción o alteración en el patrón normal de sueño de una persona que afecta negativamente su calidad de descanso y su capacidad para dormir adecuadamente durante la noche. Estas perturbaciones pueden manifestarse de diversas formas y tener diferentes causas, y pueden ser temporales o crónicas.</br></br>Las perturbaciones del sueño pueden tener un impacto significativo en la calidad de vida de una persona, ya que pueden provocar fatiga, somnolencia diurna, irritabilidad y problemas de salud a largo plazo si no se abordan adecuadamente. La identificación de la causa subyacente de las perturbaciones del sueño es importante para poder aplicar estrategias de manejo y tratamiento efectivas. En muchos casos, es recomendable buscar la atención de un profesional de la salud especializado en trastornos del sueño para obtener un diagnóstico y un plan de tratamiento adecuados.","apartado-6":"Las medicaciones para dormir, también conocidas como hipnóticos o somníferos, son medicamentos diseñados para ayudar a las personas a conciliar el sueño o mantenerlo durante la noche. Estos medicamentos se utilizan típicamente para tratar trastornos del sueño como el insomnio, que pueden provocar dificultades para quedarse dormido o despertares frecuentes durante la noche.</br></br>Las medicaciones para dormir suelen ejercer su efecto en el sistema nervioso central y pueden tener diferentes mecanismos de acción, dependiendo del tipo de medicamento.</br></br>Es importante destacar que el uso de medicaciones para dormir debe hacerse bajo la supervisión de un profesional de la salud y de acuerdo con las indicaciones específicas del médico. Estos medicamentos no deben utilizarse de manera indiscriminada, ya que pueden tener efectos secundarios, crear dependencia y no abordar las causas subyacentes de los trastornos del sueño.</br></br>Además, se recomienda que las medicaciones para dormir se utilicen como parte de un plan de tratamiento integral que incluya cambios en el estilo de vida y la higiene del sueño, así como terapias cognitivo-conductuales para abordar los trastornos del sueño de manera más efectiva a largo plazo. A mayor dependencia de medicación para dormir, peor será la puntuación en este apartado.","apartado-7":"La disfunción durante el día se refiere a la incapacidad o dificultad que una persona experimenta para funcionar de manera adecuada y eficaz en sus actividades diarias debido a problemas relacionados con el sueño o trastornos del sueño. Esta disfunción puede manifestarse en diversos aspectos de la vida cotidiana, como el trabajo, las relaciones personales, la concentración, el estado de ánimo y la salud en general."},"hours":"Horas","minutes":"Minutos"},"seeResuts":"Ver resultados","anxiety-beck":{"title":"Test de ansiedad","description":"El Inventario de Ansiedad de Beck es una herramienta útil que consta de 21 preguntas para valorar los síntomas somáticos de ansiedad, tanto en desórdenes de ansiedad como en cuadros depresivos.<br><br>Responda este cuestionario sobre síntomas comunes de la ansiedad considerando sus dificultades actuales. Indique cuánto le han afectado este último mes.","questions":{"q1":"Torpe o entumecido","q2":"Acalorado","q3":"Con temblor en las piernas","q4":"Incapaz de relajarse","q5":"Con temor a que ocurra lo peor","q6":"Mareado, o que se le va la cabeza","q7":"Con latidos del corazón fuertes y acelerados","q8":"Inestable","q9":"Atemorizado o asustado","q10":"Nervioso","q11":"Con sensación de bloqueo","q12":"Con temblores en las manos","q13":"Inquieto, inseguro","q14":"Con miedo a perder el control","q15":"Con sensación de ahogo","q16":"Con temor a morir","q17":"Con miedo","q18":"Con problemas digestivos","q19":"Con desvanecimientos","q20":"Con rubor facial","q21":"Con sudores, fríos o calientes"},"lowAnxiety":"Ansiedad muy baja","moderateAnxiety":"Ansiedad moderada","severeAnxiety":"Ansiedad severa"},"physical-activity":{"title":"Test de actividad física","description":"El siguiente cuestionario mide el nivel de actividad física en adultos según los criterios establecidos pro el Cuestionario Internacional de Actividad Física (IPAQ)","intensity":{"intense":"Actividad física intensa","moderate":"Actividad física moderada","walking":"Caminar","sitting":"Sentado"},"questions":{"q1":"Durante la última semana, ¿cuántos días realizó actividades físicas intensas tales como correr, rutinas de musculación en el gimnasio o bicicleta a un ritmo alto?","q2":"¿Cuánto tiempo en total le dedicó a una actividad física <b>intensa</b> en uno de esos días?","q3":"Durante la última semana, ¿cuántos días realizó actividades físicas moderadas tales como montar en bicicleta a ritmo de paseo, dobles de tenis, pilates o cualquier otro ejercicio de intensidad moderada?<br><br><b>Atención,</b> no incluya caminar, salvo que lo haga a un ritmo muy intenso y durante más de 30 minutos sin interrupcciones","q4":"¿Cuánto tiempo en total le dedicó a una actividad física <b>moderada</b> en uno de esos días?","q5":"Durante la última semana, ¿cuántos días caminó por lo menos 10 minutos seguidos?","q6":"¿Cuánto tiempo en total le dedicó a <b>caminar</b> en uno de esos días?","q7":"Durante la última semana ¿cuánto tiempo de media pasó sentado en un día?"},"levels":{"name":"Nivel de actividad","highLevel":"Nivel alto de actividad","moderateLevel":"Nivel moderado de actividad","lowLevel":"Nivel bajo de actividad"},"percentPopulationResult":{"high":"Está entre el 27.8% de la población de entre 18 y 69 años que se encuentra en la categoría alta de actividad física.","moderate":"Está entre el 38.6% de la población de entre 18 y 69 años que se encuentra en la categoría media de actividad física.","low":"Está entre el 33.6% de la población de entre 18 y 69 años que se encuentra en la categoría baja de actividad física."},"metsExplanation":"*Los METS son la unidad de referencia utilizada en este test. El resultado se obtiene de multiplicar el número de horas semanales totales por un valor constante para cada nivel de intensidad."},"cardiovascular-risk":{"title":"Riesgo cardiovascular","description":"El siguiente test calcula, a través de factores como la edad, el sexo, la herencia genética y los hábitos, el riesgo estimado de sufrir una enfermedad cardiovascular en los próximos 10 años. Está basado en la ecuación de Framingham.","questions":{"q1":"Edad","q2":"¿Ha sido diagnosticado de diabetes?","q3":"¿Fuma habitualmente?","q4":"Colesterol total","q5":"Colesterol HDL 'Bueno'","q6":"Presión arterial"},"scores":{"lowRisk":{"name":"¡Tu riesgo es bajo!","description":"Enhorabuena, tu riesgo cardiovascular es bajo. No te descuides y mantén tus buenos hábitos de vida, haz deporte, sigue una alimentación saludable y evita el tabaco."},"midRisk":{"name":"¡Tu riesgo es medio!","description":"Tu riesgo de desarrollar en los próximos 10 años una enfermedad cardiovascular es medio, por lo que es importante asegurar que sigues unas pautas de hábitos de vida saludables.","tips":{"tip1":"Come sano. Limita el alcohol, los alimentos grasos o salados, el azúcar, la bollería, así como los productos precocinados. Incluye en tu dieta diaria frutas, verduras y legumbres.","tip2":"Evita el sedentarismo. Gimnasio, subir escaleras, jugar con los niños, evitar el coche... todo cuenta. Deberías realizar al menos 45 minutos de actividad física moderada durante 5 días a la semana.","tip3":"Evita el tabaco.","tip4":"Mantén el estrés (especialmente si es continuado), bajo control."}},"highRisk":{"name":"¡Tu riesgo es alto!","description":"Tu riesgo de desarrollar en los próximos 10 años una enfermedad cardiovascular es alto, por lo que es importante asegurar que sigues unas pautas relativas a tus hábitos de vida. Y no olvides periódicamente pedir una cita con tu médico. Es posible que sea aconsejable algún tipo de tratamiento.","tips":{"tip1":"Asegura una alimentación saludable. Limita el alcohol, los alimentos grasos o salados, el azúcar, la bollería, así como los productos precocinados. Incluye en tu dieta diaria frutas, verduras y legumbres. Acude a un profesional de la nutrición si necesitas ayuda para mejorar tus hábitos de alimentación.","tip2":"Hay que moverse todos los días. Gimnasio, subir escaleras, jugar con los niños, evitar el coche… todo cuenta. Deberías realizar al menos 45 minutos de actividad física moderada durante 5 días a la semana. Si lo necesitas, un profesional te puede aconsejar ejercicios adecuados a tu edad y condición.","tip3":"Evita el tabaco.","tip4":"Mantén el estrés (especialmente si es continuado), bajo control."}}}},"testNamesForResultsDiagram":{"Test ryff scale":"Bienestar psicológico","Test findrisk":"Riesgo de diabetes","Test mediterranean diet":"Dieta mediterránea","Test nicotine dependency":"Dependencia nicotina","Test stress":"Estrés percibido","Test sleep quality":"Calidad de sueño","Test anxiety beck":"Nivel de ansiedad","Test physical activity":"Actividad física","Test cardiovascular risk":"Riesgo cardiovascular","Test interpersonal relationships":"Relaciones interpersonales","Test social skills":"Habilidades sociales","Test general health":"Salud general"},"resultsDiagram":"Diagrama de resultados","notCompleted":"No completado","general-health":{"title":"Salud general","description":"El SF-36 es un cuestionario diseñado para evaluar la percepción del estado de salud y bienestar. Analiza ocho áreas fundamentales, como la capacidad física, el dolor, la vitalidad y el estado emocional, ofreciendo una visión completa de la calidad de vida de una persona.","dimensions":{"physical-function":"Función física","physical-limitations":"Limitaciones físicas","body-pain":"Dolor corporal","general-health":"Salud general","vitality":"Vitalidad","social-function":"Función social","emotional-limitations":"Limitaciones emocionales","mental-health":"Salud mental"},"questions":{"q1":"En general, usted diría que su salud es:","q2":"¿Cómo diría que es su salud actual, comparada con la de hace un año?","q3":"Su salud actual, ¿le limita para hacer esfuerzos intensos, tales como correr, levantar objetos pesados, o participar en deportes agotadores?","q4":"Su salud actual, ¿le limita para hacer esfuerzos moderados, como mover una mesa, pasar la aspiradora, jugar a los bolos o caminar más de una hora?","q5":"Su salud actual, ¿le limita para coger o llevar la bolsa de la compra?","q6":"Su salud actual, ¿le limita para subir varios pisos por la escalera?","q7":"Su salud actual, ¿le limita para subir un solo piso por la escalera?","q8":"Su salud actual, ¿le limita para agacharse o arrodillarse?","q9":"Su salud actual, ¿le limita para caminar un kilómetro o más?","q10":"Su salud actual, ¿le limita para caminar varias manzanas (varios centenares de metros)?","q11":"Su salud actual, ¿le limita para caminar una sola manzana (unos 100 metros)?","q12":"Su salud actual, ¿le limita para bañarse o vestirse por sí mismo?","q13":"Durante las últimas 4 semanas, ¿tuvo que reducir el tiempo dedicado al trabajo o a sus actividades cotidianas a causa de su salud física?","q14":"Durante las últimas 4 semanas, ¿hizo menos de lo que hubiera querido hacer, a causa de su salud física?","q15":"Durante las últimas 4 semanas, ¿tuvo que dejar de hacer algunas tareas en su trabajo o en sus actividades cotidianas, a causa de su salud física?","q16":"Durante las últimas 4 semanas, ¿tuvo dificultad para hacer su trabajo o sus actividades cotidianas (por ejemplo, le costó más de lo normal), a causa de su salud física?","q17":"Durante las últimas 4 semanas, ¿tuvo que reducir el tiempo dedicado al trabajo o a sus actividades cotidianas a causa de algún problema emocional (como estar triste, deprimido, o nervioso)?","q18":"Durante las últimas 4 semanas, ¿hizo menos de lo que hubiera querido hacer a causa de algún problema emocional (como estar triste, deprimido, o nervioso)?","q19":"Durante las últimas 4 semanas, ¿no hizo su trabajo o sus actividades cotidianas tan cuidadosamente como de costumbre, a causa de algún problema emocional (como estar triste, deprimido, o nervioso)?","q20":"Durante las últimas 4 semanas, ¿hasta qué punto su salud física o los problemas emocionales han dificultado sus actividades sociales habituales con la familia, los amigos, los vecinos u otras personas?","q21":"¿Tuvo dolor en alguna parte del cuerpo durante las 4 últimas semanas?","q22":"Durante las últimas 4 semanas, ¿hasta qué punto el dolor le ha dificultado su trabajo habitual (incluido el trabajo fuera de casa y las tareas domésticas?","q23":"Durante las 4 últimas semanas, ¿Cuánto tiempo se sintió lleno de vitalidad?","q24":"Durante las 4 últimas semanas, ¿Cuánto tiempo estuvo muy nervioso?","q25":"Durante las 4 últimas semanas, ¿Cuánto tiempo se sintió tan bajo de moral que nada podía animarle?","q26":"Durante las 4 últimas semanas, ¿Cuánto tiempo se sintió calmado y tranquilo?","q27":"Durante las 4 últimas semanas, ¿Cuánto tiempo tuvo mucha energía?","q28":"Durante las 4 últimas semanas, ¿Cuánto tiempo se sintió desanimado y triste?","q29":"Durante las 4 últimas semanas, ¿Cuánto tiempo se sintió agotado?","q30":"Durante las 4 últimas semanas, ¿Cuánto tiempo se sintió feliz?","q31":"Durante las 4 últimas semanas, ¿Cuánto tiempo se sintió cansado?","q32":"Durante las 4 últimas semanas, ¿con qué recurrencia la salud física o los problemas emocionales le han dificultado sus actividades sociales (como visitar a amigos o familiares)?","q33":"Creo que me pongo enfermo más fácilmente que otras personas","q34":"Estoy tan sano como cualquiera","q35":"Creo que mi salud va a empeorar","q36":"Mi salud es excelente"}},"interpersonal-relationships":{"title":"Relaciones interpersonales","description":"Este test de autoevaluación te invita a explorar cómo gestionas tus relaciones interpersonales, evaluando aspectos clave como la comunicación, la empatía, la confianza y la resolución de conflictos. Su objetivo es ayudarte a identificar fortalezas y áreas de mejora en tus interacciones sociales.","questions":{"q1":"Me siento apoyado por las personas cercanas a mí","q2":"Disfruto de pasar tiempo con mis amigos y familiares","q3":"Me resulta fácil compartir mis pensamientos y sentimientos con los demás","q4":"Puedo confiar en las personas que me rodean","q5":"Siento que las personas con las que me relaciono valoran mi opinión","q6":"Me siento comprendido en mis relaciones personales","q7":"Sé cómo resolver conflictos sin que dañen mis relaciones","q8":"Me siento cómodo pidiendo ayuda cuando la necesito","q9":"Tengo relaciones saludables en mi entorno laboral","q10":"Disfruto de las interacciones sociales, incluso con personas nuevas","q11":"Me siento valorado por mis compañeros de trabajo","q12":"Es fácil para mí establecer relaciones nuevas","q13":"Soy capaz de mantener relaciones largas y satisfactorias","q14":"Siento que puedo ser yo mismo con las personas cercanas a mí","q15":"Soy capaz de perdonar los errores de los demás en mis relaciones","q16":"Tengo la capacidad de escuchar y apoyar a los demás cuando lo necesitan","q17":"Me siento cómodo al expresar mis necesidades en una relación","q18":"Tengo confianza en mí mismo cuando interactúo con los demás","q19":"Las personas en mi vida respetan mis límites personales","q20":"Mantengo un equilibrio saludable entre mi vida personal y profesional","q21":"Me siento aceptado tal como soy por las personas con las que me relaciono","q22":"Cuando discuto con alguien, puedo resolver la situación de manera constructiva","q23":"Siento que mis relaciones me aportan felicidad y satisfacción","q24":"No tengo problemas para pedir disculpas si he cometido un error","q25":"Me resulta fácil manejar la frustración en situaciones sociales difíciles","q26":"Las personas cercanas a mí son afectuosas y comprensivas","q27":"Puedo expresar mi frustración sin lastimar a los demás","q28":"Aprecio los pequeños gestos de los demás en mis relaciones","q29":"Sé cómo manejar el rechazo de manera saludable","q30":"Siento que puedo expresar libremente mis pensamientos en el trabajo sin miedo a ser juzgado","q31":"Me esfuerzo por mantener una buena comunicación con las personas importantes en mi vida","q32":"Tengo confianza en las decisiones que tomo en mis relaciones personales","q33":"Puedo lidiar con los cambios en mis relaciones sin sentirme abrumado","q34":"Siento que tengo apoyo emocional cuando atravieso dificultades personales","q35":"Me resulta sencillo integrar nuevas personas a mi círculo social"},"scores":{"lowScore":{"score":"Puntuación baja","description":"Tus relaciones interpersonales parecen estar limitadas o insatisfactorias. Puedes estar experimentando dificultades en la comunicación, la confianza o el apoyo emocional. Reflexionar sobre cómo mejorar estas áreas puede ser útil."},"mid-lowScore":{"score":"Puntuación media-baja","description":"Tus relaciones son funcionales, pero hay aspectos que podrían mejorarse. A veces te cuesta expresar tus emociones o manejar conflictos, lo que afecta la calidad de algunas de tus relaciones."},"midScore":{"score":"Puntuación media","description":"Tienes relaciones interpersonales satisfactorias en general, aunque podrías mejorar en aspectos como la resolución de conflictos o la expresión de tus necesidades emocionales. En líneas generales, tus relaciones son equilibradas."},"mid-highScore":{"score":"Puntuación media-alta","description":"Tus relaciones son bastante buenas. Te sientes valorado y apoyado por los demás, y manejas bien los conflictos. Sin embargo, puede haber pequeñas áreas en las que podrías trabajar para mejorar la calidad de tus relaciones."},"highScore":{"score":"Puntuación alta","description":"Tienes relaciones interpersonales excelentes. Te sientes completamente satisfecho y apoyado en tus relaciones, y tienes la habilidad de manejar los conflictos y expresar tus necesidades de manera asertiva. Tu entorno social y emocional es saludable y equilibrado."}}},"social-skills":{"title":"Habilidades sociales","description":"El Inventario de Habilidades Sociales (IHS) está diseñado para analizar cómo te desenvuelves en situaciones sociales y qué tan bien gestionas aspectos como la comunicación, la resolución de conflictos y la expresión emocional.","questions":{"q1":"¿Te resulta fácil iniciar una conversación con personas desconocidas?","q2":"¿Puedes expresar tu opinión cuando no estás de acuerdo con alguien en una discusión?","q3":"¿Te resulta sencillo pedir ayuda cuando la necesitas?","q4":"¿Puedes decir 'no' cuando no deseas hacer algo, sin sentirte culpable?","q5":"¿Te sientes cómodo hablando en público o frente a un grupo de personas?","q6":"¿Sabes cómo mostrar tu desacuerdo sin generar conflicto?","q7":"¿Sueles elogiar a otras personas por su buen trabajo o actitud?","q8":"¿Te resulta fácil expresar tus sentimientos positivos hacia los demás?","q9":"¿Puedes hacer frente a críticas de manera calmada y sin reaccionar de forma defensiva?","q10":"¿Tienes confianza para resolver desacuerdos de manera respetuosa?","q11":"¿Te sientes cómodo pidiendo una mejora o un aumento de sueldo en el trabajo?","q12":"¿Sueles tomar la iniciativa para hablar con personas con las que te gustaría colaborar?","q13":"¿Te resulta fácil expresar frustración sin herir los sentimientos de los demás?","q14":"¿Puedes resolver conflictos interpersonales sin necesidad de recurrir a terceras personas?","q15":"¿Te sientes cómodo solicitando retroalimentación sobre tu rendimiento en el trabajo?","q16":"¿Sueles expresar gratitud a tus compañeros de trabajo o conocidos?","q17":"¿Te sientes cómodo estableciendo límites cuando otras personas invaden tu espacio o tiempo?","q18":"¿Puedes manejar las diferencias de opinión sin alterarte emocionalmente?","q19":"¿Te resulta sencillo ofrecer apoyo emocional a otros cuando lo necesitan?","q20":"¿Te sientes cómodo hablando sobre tus necesidades o preocupaciones personales?","q21":"¿Puedes aceptar cumplidos sin sentir incomodidad?","q22":"¿Tomas decisiones rápidamente en situaciones sociales incómodas?","q23":"¿Te sientes capaz de resolver malentendidos sin evitar la confrontación?","q24":"¿Sueles involucrarte activamente en conversaciones grupales?","q25":"¿Te resulta fácil iniciar conversaciones con tus superiores o jefes?","q26":"¿Puedes pedir perdón cuando te das cuenta de que has cometido un error?","q27":"¿Tienes confianza en expresar tu desacuerdo con un amigo cercano o familiar?","q28":"¿Sabes cómo manejar el rechazo en situaciones sociales?","q29":"¿Te resulta sencillo expresar preocupación cuando ves que alguien está teniendo dificultades?","q30":"¿Sueles actuar de manera calmada y constructiva en situaciones sociales estresantes?","q31":"¿Puedes enfrentar situaciones en las que otros te contradicen sin perder la calma?","q32":"¿Sueles reconocer y expresar las contribuciones positivas de otros en grupo?","q33":"¿Te sientes capaz de disculparte cuando piensas que tus palabras o acciones pueden haber ofendido a alguien?"},"scores":{"lowScore":{"score":"Puntuación baja","description":"Tus habilidades sociales están por debajo de lo deseable. Es posible que te cueste trabajo relacionarte de manera efectiva en diversas situaciones cotidianas. Podría ser útil desarrollar estrategias para mejorar tus habilidades sociales, como la asertividad, la empatía y la gestión de conflictos."},"mid-lowScore":{"score":"Puntuación media-baja","description":"Tienes algunas habilidades sociales, pero en ciertos contextos puedes sentirte incómodo o tener dificultades. Sería beneficioso trabajar en aspectos clave."},"midScore":{"score":"Puntuación media","description":"Tus habilidades sociales son adecuadas, y eres capaz de manejar las relaciones interpersonales en la mayoría de las situaciones. Aunque manejas bien las interacciones sociales, todavía hay áreas en las que podrías mejorar."},"mid-highScore":{"score":"Puntuación media-alta","description":"Tus habilidades sociales son bastante buenas. Te desenvuelves bien en la mayoría de las situaciones sociales y manejas interacciones complejas con eficacia. Sin embargo, puedes trabajar en refinar detalles en algunas áreas específicas."},"highScore":{"score":"Puntuación alta","description":"Tienes excelentes habilidades sociales. Te sientes cómodo en una amplia variedad de situaciones y manejas las relaciones interpersonales de manera efectiva y asertiva. Eres capaz de resolver conflictos, comunicarte claramente y empatizar con los demás."}}},"health-data-agerestriction":"Sólo disponible para usuarios entre 18 y 67 años","health-data-colorwarning":"Los colores son meramente orientativos y en ningún caso deben tomarse como una evaluación clínica o una opinión profesional. Sólo un médico puede determinar si sus valores están o no dentro de la normalidad o indicarle en su caso un tratamiento.","work-environment":{"title":"Clima laboral","description":"Este test de clima laboral evalúa la percepción de los empleados sobre diversos aspectos del ambiente de trabajo, como comunicación, liderazgo, condiciones laborales y motivación. A través de 91 preguntas, permite identificar fortalezas y áreas de mejora en la organización","finalCompletedMessage":"Gracias por completar el test de clima laboral. <br><br>Los resultados, como cualquier otra información personal de la plataforma, son confidenciales y sólo son accesibles en su caso por el profesional de la salud que le esté atendiendo, si así lo decide. Le recordamos que su empresa sólo recibe datos agregados de uso de la plataforma y nunca recibe información personal.","finalCompletedMessageAccessAgain":"Ya ha completado el test de clima laboral este mes. Podrá volver a realizar una evaluación transcurridos 4 meses.  <br><br>Los resultados, como cualquier otra información personal de la plataforma son confidenciales y sólo son accesibles en su caso por el profesional de la salud que le esté atendiendo, si así lo decide. Le recordamos que su empresa sólo recibe datos agregados de uso de la plataforma y nunca recibe información personal.","confidentialityWarning":"El clima laboral es un elemento cada vez más relevante para el bienestar de las personas. Le recordamos que sus respuestas son confidenciales y que la encuesta sólo podrá completarse un máximo de 4 veces al año.","dimensions":{"social-interaction":"Interacción social","communication":"Comunicación","work-conditions":"Condiciones de trabajo","risk-prevention":"Prevención de riesgos laborales","satisfaction":"Reconocimiento, satisfacción y pertenencia","wage":"Remuneración","promotion":"Promoción","formation":"Formación","leadership":"Liderazgo","autonomy":"Autonomía e innovación","client-orientation":"Orientación al cliente (externo e interno)","organization":"Organización","motivation":"Motivación"},"questions":{"q1":"Considero que existe un buen ambiente de trabajo","q2":"Cuento con la colaboración de las personas de otros departamentos","q3":"Cuento con la colaboración de mis compañeros de departamento","q4":"Las personas con las que me relaciono en la organización actúan con respeto y de manera ética","q5":"La relación entre mi jefe y yo es buena","q6":"Existe mucha movilidad y cambios de puesto de trabajo entre mis compañeros","q7":"Tengo disponible información sobre el catálogo de productos y servicios que ofrece la organización","q8":"La comunicación sobre los resultados y marcha de la Compañía es clara y transparente","q9":"La comunicación interna en organización es una actividad permanente y planificada","q10":"Conozco el Código Ético y de Conducta de la organización","q11":"Tengo disponible información sobre la organización y su evolución de todos los lugares en los que se encuentra","q12":"Los comunicados internos me proporcionan información útil","q13":"Resulta fácil comunicarme con directivos o personal de otras áreas administrativas","q14":"Dispongo de los materiales y recursos necesarios para realizar mi trabajo","q15":"Las condiciones de espacio, comodidad, ruido, temperatura, iluminación..., y mi silla, el filtro de la pantalla del ordenador y la altura de ésta me permiten desempeñar mi trabajo con normalidad","q16":"Las áreas de trabajo se conservan limpias y en orden, permitiendo el desarrollo de las actividades para lo que fueron destinadas","q17":"Se dispone de suficientes instalaciones sanitarias y áreas de descanso","q18":"Está definido un protocolo de primeros auxilios y se disponen de medios para llevarlo a cabo","q19":"La organización se preocupa por mi grado de estrés y me facilita medios y herramientas para gestionarlo","q20":"La carga mental del trabajo y el estrés es un problema para mí","q21":"Dispongo de espacios, aparte de la cafetería, habilitados para relajarme y recuperar mis capacidades para seguir rindiendo","q22":"Me siento orgulloso/a de trabajar para la organización","q23":"Considero adecuados e importantes los proyectos de Responsabilidad Social implementados en mi país","q24":"Me siento partícipe del proyecto de la organización","q25":"Pienso que la organización es un buen lugar para trabajar y me gustaría continuar trabajando aquí","q26":"Comprendo y comparto los valores de la compañía","q27":"Siento que la organización me valora","q28":"Recibo información sobre los elementos que componen mi salario (salario base más beneficios)","q29":"Estoy satisfecho con los beneficios sociales que me ofrece la organización","q30":"Considero que mi trabajo está bien remunerado","q31":"Creo que mi sueldo está en consonancia con los sueldos que hay en la organización","q32":"Creo que mi sueldo está en consonancia con la situación y marcha económica de la organización","q33":"Pienso que si desempeño bien mi trabajo, tengo posibilidad de promocionar en la organización","q34":"Creo que tengo la oportunidad de desarrollarme profesionalmente en la organización","q35":"Al asumir una nueva posición en la organización, mi responsable me informa de manera clara sobre las funciones y responsabilidades del puesto de trabajo","q36":"Tengo autonomía para llevar a cabo mi trabajo","q37":"Tengo disponible información sobre los puestos vacantes en la Compañía","q38":"Las promociones internas se realizan de manera justa","q39":"Considero adecuados los criterios de evaluación de mi desempeño en la organización","q40":"Recibo formación para actualizar los conocimientos de mi trabajo","q41":"Los planes de formación de la organización se adecuan a mis necesidades de desarrollo profesional en la compañía","q42":"La organización provee al personal de cursos de gestión del estrés y de la carga mental del trabajo","q43":"Recibo formación para el desarrollo personal y la gestión del talento","q44":"Mi responsable se preocupa por mantener un buen clima en el equipo","q45":"La dirección alienta a que se trabaje en equipo","q46":"Mi responsable me felicita cuando realizo bien mi trabajo","q47":"Mi responsable escucha mis opiniones y me hace partícipe de las decisiones","q48":"Mi responsable se preocupa por transmitir los valores, misión y objetivos de la organización","q49":"Mantengo una buena relación con mi responsable","q50":"Mi responsable hace un seguimiento de mi Plan de Desarrollo Individual","q51":"Mi responsable me trata justamente y evita cualquier tipo de favoritismos","q52":"Mi responsable respeta las diferencias de cultura, sexo, religión…","q53":"Mi responsable me proporciona periódicamente información sobre mi desempeño","q54":"Mi responsable se preocupa por conocer mis necesidades e intereses","q55":"Mi responsable es un referente en la compañía","q56":"Mi responsable es claro y específico cuando define mis objetivos de trabajo o los del departamento","q57":"La dirección tiene expectativas realistas con respecto a los resultados del trabajo","q58":"Los empleados confían en cualquier decisión tomada por la dirección","q59":"El nivel de exigencia por parte de mi jefe es adecuado","q60":"Considero que trabajo en equipo con mi jefe","q61":"Puedo tomar decisiones propias sin necesidad de consultar con mi jefe","q62":"La organización innova y mejora continuamente para ser el líder de su sector","q63":"Se alienta a los empleados a buscar nuevas formas de resolver problemas","q64":"La dirección está abierta a las sugerencias y consejos de los empleados","q65":"La compañía aprecia y valora las ideas","q66":"La compañía está buscando hacer cambios para mantener su competitividad","q67":"Mi trabajo es lo suficientemente variado","q68":"Los procesos y procedimientos de trabajo en la organización me orientan hacia el cliente interno/externo","q69":"He hablado a familiares y amigos sobre las ventajas de contratar servicios de la organización","q70":"Estoy dispuesto/a a realizar un esfuerzo extra para satisfacer a mi cliente interno o externo","q71":"La documentación (procedimientos, instructivos y formatos) incluida en el Sistema de Gestión de Calidad es útil y apropiada para realizar mi trabajo","q72":"Recibo la ayuda que necesito del departamento Jurídico","q73":"Recibo la ayuda que necesito del departamento de Compras","q74":"Recibo la ayuda que necesito del departamento de RR.HH. de la organización","q75":"Recibo la ayuda que necesito del departamento Comercial / Marketing","q76":"Recibo la ayuda que necesito del departamento Financiero","q77":"Recibo la ayuda que necesito del departamento de Informática","q78":"Considero que los valores de la organización reflejan el estilo de trabajo que existe en la compañía","q79":"Desde mi entrada en la compañía, pienso que la organización se ha ido transformando en un lugar mejor para trabajar","q80":"Considero que planes de acción derivados de la anterior encuesta de satisfacción se han cumplido en su mayoría","q81":"Conozco cómo mi trabajo contribuye a conseguir los resultados de mi departamento","q82":"Mi capacidad profesional está de acuerdo a las tareas y responsabilidades asignadas","q83":"Tengo la oportunidad de proponer nuevos proyectos o nuevas formas de realizar el trabajo","q84":"Tengo la información que necesito para realizar mi trabajo con excelencia","q85":"La organización me da/ofrece la oportunidad de trabajar en proyectos/actividades que suponen nuevos retos","q86":"Tengo claro cuáles son mis tareas y responsabilidades","q87":"Mi trabajo me ofrece retos y la oportunidad de seguir mejorando","q88":"Mi trabajo es reconocido y valorado","q89":"Actualmente estoy satisfecho/a con mi trabajo en la organización","q90":"En el desempeño de mis labores habitualmente utilizo la documentación incluida en el Sistema de Gestión de Calidad","q91":"He recibido el entrenamiento necesario para realizar las funciones que actualmente desempeño"}},"physical-health":"Salud física","mental-health":"Salud mental","congratulations":"Felicidades"}}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = {"sgsi-policy":{"title":"Política SGSI","text":"<p>Open HealthCare S.L. es consciente de la importancia de la seguridad de la información,\nespecialmente la relativa a empleados, clientes y procesos de negocio, ha implantado\nun sistema de gestión de la información basado en la norma ISO 27001:</p>\n\n<p>Para poder desarrollar el compromiso expreso de la Organización en la mejora continua\ndel sistema de gestión, la Dirección establece los siguientes principios de gestión de\nseguridad de la información:</p>\n\n<ul>\n  <li>\n    <p>Conocimiento y aplicación por parte de todos los empleados y colaboradores, según\n    su función dentro de la Compañía, de las políticas y procedimientos de seguridad, tanto\n    las generales como las que puedan aplicar a grupos específicos, incluyendo:</p>\n    <span>\n      <ul>\n          <li><p>Control de accesos, apertura y cierre de las instalaciones.</p></li>\n          <li><p>Información y tratamiento de las visitas a las instalaciones.</p></li>\n          <li><p>Formación, concienciación y motivación en seguridad.</p></li>\n          <li><p>Conocimiento de roles y responsabilidades.</p></li>\n          <li><p>Gestión de la continuidad del negocio.</p></li>\n          <li><p>Consecuencias de la falta de cumplimiento de las políticas de seguridad.</p></li>\n          <li><p>Apoyo en la gestión de la seguridad de la información.</p></li>\n          <li><p>Cumplimiento con la legislación.</p></li>\n          <li><p>Manual de Buenas prácticas del usuario.</p></li>\n      </ul>\n    </span>\n  </li>\n  <li>\n    <p>Diligencia por parte de todos los empleados y colaboradores en la comunicación de\n    posibles incidentes de seguridad.</p>\n  </li>\n  <li>\n    <p>Hay que asegurar que se cumplen los procedimientos donde se determina la\n    confidencialidad, integridad, disponibilidad, trazabilidad y autenticidad de la\n    información.</p>\n  </li>\n  <li>\n    <p>Apoyo a la estructura organizativa de seguridad establecida para cumplir los objetivos\n    de control de la seguridad de la información y gestión continua de los riesgos.</p>\n  </li>\n  <li>\n    <p>Garantizar el correcto uso de las instalaciones y el equipamiento de forma tal que\n    estén en correspondencia con la actividad y objetivos de la organización.</p>\n  </li>\n  <li>\n    <p>Compromiso de proteger la seguridad y salud de sus trabajadores, así como de\n    implantar un adecuado ambiente de trabajo.</p>\n  </li>\n  <li>\n    <p>Estructurar nuestro sistema de gestión de forma que sea fácil de comprender.</p>\n  </li>\n</ul>\n    <p>La gestión de nuestro sistema se encomienda al responsable de Gestión y el sistema\n    estará disponible en nuestro sistema de información en un repositorio, al cual se puede\n    acceder según los perfiles de acceso concedidos según nuestro procedimiento en vigor\n    de gestión de los accesos.</p>\n\n    <p>Esta política se complementa con el resto de las políticas, procedimientos y\n    documentos en vigor para desarrollar nuestro sistema de gestión.</p>\n\n    <p>Estos principios son asumidos por la Dirección, quien dispone de los medios necesarios\n    para su implantación y se comunican para su cumplimiento por todos los empleados y\n    colaboradores de la empresa a través de la presente Política de Seguridad de la\n    Información.</p>\n"}}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = {"chats":{"chat":"Chat","patients":"Pacientes","professionals":"Profesionales","contact-patient":"Contactar paciente","contact-prof":"Contactar profesional | Interconsulta","new-message":"Escribe un mensaje...","delete-message":"¿Desea borrar el mensaje?","delete-message-success":"Mensaje eliminado con éxito","edit-message-success":"Mensaje editado con éxito","cant-upload-file":"No se ha podido enviar el archivo","delete":"Eliminar","select-patient":"Selecciona un paciente","attach-file":"Adjuntar archivo/documento","select-file-type":"Selecciona tipo de archivo","administrative-chat":"Chat administrativo (No consulta)","select-prof":"Selecciona un profesional","finish-chat":"Finalizar chat","finish-chat-message":"¿Desea finalizar la consulta?","finish-chat-message-success":"Consulta finalizada con éxito","finished-chats":"Chats finalizados","cancel-chat":"Cancelar chat","cancel-chat-message":"¿Desea cancelar la consulta?","emit-eprescription":"Emitir receta electrónica","emit-eprescription-message":"A continuación será redirigido a la plataforma de receta electrónica.<br><br><strong>Recuerde que antes de consolidar la consulta debe emitir la prescripción en dicha plataforma, dado que no se podrá realizar a posteriori.</strong>","unread-messages":"mensajes no leídos","unread-message":"mensaje no leído","view-all":"Ver todos","select-file":"Selecciona un archivo","ask-for-new-chat":"Solicitar nuevo chat","no-active-chat":"No dispone de ningún chat activo"}}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = {"survey":"Encuesta","surveys":{"not-avaliable":"Encuesta no disponible","not-allowed":"No tienes permiso para acceder a esta encuesta.","loading":"Cargando encuesta...","completed":"Encuesta completada","percentage-completed":"% completado","mandatory":"La valoración es obligatoria","comment-review":"Añade un comentario... (opcional)","finish":"Finalizar","following":"Siguiente","error":{"error-loading":"Error al cargar encuesta. Por favor, inténtelo de nuevo más tarde.","error-send":"Error al enviar la encuesta. Por favor, inténtelo de nuevo más tarde."},"info":{"error-finish":"Debes responder todas las preguntas antes de finalizar."},"congratulations":"Felicidades","finishText":"Pulsa el botón 'Finalizar' para enviar los resultados de la encuesta","completed2":"Gracias por completar la encuesta","opensalud-go":"Ir a opensalud","close-dialog":"Esta ventana se cerrará automáticamente en 5 segundos","start":"Comenzar encuesta"}}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = {"unipromel":{"title":"La plataforma de los médicos independientes","subtitle":"Medicina de calidad,<br>sin prisas.","text":"UNIPROMEL fue constituida en 2020, para agrupar a los médicos que ejercen en el sector sanitario privado español con el fin de defender sus intereses y garantizar la calidad de la atención al paciente.","learn-more":"Saber más","card":{"title1":"Consulta online","subtitle1":"Videoconsulta, Consulta escrita, Chat, Segunda opinión...","title2":"Receta electrónica","subtitle2":" Recetas homologadas por la Organización Médico Colegial.","title3":"Historial clínico","subtitle3":"Accede, edita y comparte el historial clínico con tus pacientes.","title4":"Consulta presencial","subtitle4":"Consulta a domicilio. Consulta en clínica.","title5":"Suscripciones y packs","subtitle5":"Diseña tus propios packs de servicios y suscripciones.","title6":"Agenda online","subtitle6":"Gestiona tus citas online de forma fácil automática.","title7":"Facturación online","subtitle7":"Realiza tus cobros y emite tus facturas de forma automática.","title8":"Monitorización y exploración remota","subtitle8":"Incorpora dispositivos para facilitar la consulta online y el seguimiento.","title9":"Precios personalizables","subtitle9":"Podrás establecer diferentes precios en función del motivo de consulta o el colectivo."},"block-2":{"blackTitle":"Tú decides.","title":"Cuida de tus pacientes cuándo y cómo quieras."},"insurance-appointments":"Consulta seguros salud","private-appointments":"Consultas privadas premium","insurance-appointments-subtitle":"Sólo consulta presencial.<br>Consulta de duración limitada.<br>Demora en agenda sujeta a disponibilidad.<br>","private-appointments-subtitle":"Consulta presencial y consulta online.<br>La consulta no tiene limitada la duración.<br>La demora en agenda máxima de 15 días.<br>Precio mínimo garantizado en unihealth.","more-information":"(*) Las consultas privadas premium están disponibles para todos los médicos, no tienen limitada la duración y tienen una baja demora en cita.","patients":"Pacientes","medics-together":"Médicos unidos.","free-professionals":"Profesionales libres.","become-partner":"¡Hazte socio ya!","block-patients":{"title":"Medicina de calidad sin prisas\ny con la garantía de Unipromel.","subtitle":"Accede a los mejores médicos de España en \ncualquier momento y desde cualquier lugar de \nuna forma fácil y segura y con el mejor precio garantizado.","access-btn":"Regístrate gratis"},"paragraph":"Unihealth es la plataforma de UNIPROMEL, asociación que agrupa a médicos que ejercen en el sector privado en España."}}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy-professional":{"title":"Privacy Policy for Professionals","text":"<p><b>Privacy</b></p>\n\n<p><b>A. General</b></p>\n<p>Who is responsible for processing your data?</p>\n<p>{companyName} (Hereinafter {platformName})</p>\n<p>Postal Address: {address}}.</p>\n<p>Email: soporte@openhealth.es</p>\n<p>DPO: GRUPO INGERTEC privacidad@openhealthcare.eu</p>\n<p>To enable browsing through the website, it is mandatory to be a registered user and accept the privacy rules detailed below. By registering, you agree that {platformName} stores and processes the personal data you provide us in accordance with the privacy policy.</p>\n\n<p>The legal basis for processing your data is the consent of the data subject.</p>\n\n<p>Data processing is carried out for the following purposes:</p>\n<ul>\n  <li><p>Handling medical consultations and managing appointments and services related to the platform's activity.</p></li> <li><p>Conducting statistical and historical studies by {platformName}. The reports generated will always be disaggregated and anonymous.</p></li>\n  <li><p>Communicating matters of interest to users related to platform operation (usage suggestions, introduced improvements, etc.).</p></li>\n  <li><p>Sending electronic communications to which the user has previously subscribed, in compliance with Law 34/2002 of July 11, on Information Society Services and Electronic Commerce (LSSICE).</p></li>\n</ul>\n\n<p>Our policy regarding the sending of emails focuses on sending only communications that you have requested to receive. If you prefer not to receive these messages via email, we will offer you the option to exercise your right to deletion and withdrawal from receiving these messages through them.</p>\n\n<p>All users who establish any type of communication, either through forms on the website or via alternative means, should know that their data may be collected for processing by this platform.</p>\n\n<p>{platformName} processes data confidentially and adopts appropriate technical and organizational measures to ensure the level of security required for processing, in compliance with applicable data protection regulations. Open Health is ISO 27001 certified.</p>\n\n<p>However, no system can guarantee absolute invulnerability; therefore, {platformName} assumes no liability for damages caused by alterations third parties may make to users' computer systems, electronic documents, or files.</p>\n\n<p><b>How long are the data retained?</b></p>\n\n<p>The personal data provided will be retained as long as the user remains active on the platform (has not requested deactivation) and during the periods required to fulfill legal obligations related to the custody of clinical and administrative information.</p>\n\n<p>Data collected to respond to requests, inquiries, or consultations about our products and services will be retained indefinitely unless you express your desire to have them deleted.</p>\n\n<p><b>B. Data Transfers and International Transfers</b></p>\n\n<p>Any data collected by {platformName} will not be transferred to third-party companies under any circumstances, except as outlined below:</p>\n<ul>\n  <li><p>With prior request from the portal to the data subject, and express consent from the latter, either individually or generally. In any case, {platformName} will never transfer any data for advertising purposes.</p></li>\n  <li><p>When exceptions stipulated by applicable regulations apply.</p></li>\n  <li><p>Through agreements with third-party companies for analytical services, exclusively for statistical purposes and service improvement, never for advertising.</p></li>\n  <li><p>To healthcare professionals and centers registered on the platform for scheduling and conducting medical appointments, for a period of one year from the last explicit consent, either by requesting an appointment or authorizing a professional. These professionals and centers, when accessing patient data on the platform, assume obligations determined by applicable data protection regulations and are fully responsible in case of non-compliance. According to these regulations, professionals and centers agree to a data processor relationship concerning personal data provided by registered users for appointments and consultations, maintaining the required level of protection for such information.</p></li>\n\n<em><p>Regarding any information extracted from the platform through legally enabled means, professionals/centers should know that health data is categorized as highly sensitive information and must be handled according to the guidelines set by Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 (GDPR), Organic Law 3/2018 of 5 December on the Protection of Personal Data, and other applicable regulations.</p>\n<p>Information must not be stored locally on devices. Printed information should always be kept secure and under lock when not in use. External storage devices and non-authorized emails must not be used for storing or transferring this information.</p></em>\n\n<li><p>To companies used to support platform functionality (cloud) and collaborators..</p></li>\n<li><p>For corporate telemedicine services, to generate anonymous aggregate reports on platform usage by employees. These reports will only include aggregated data such as total users and usage statistics.</p></li>\n</ul>\n\n<p><u>No international transfers are made.</u></p>\n\n<p><b>C. Data Quality</b></p>\n<p>The website informs users of the obligation to correctly update data provided and processed. The data must be appropriate, relevant, accurate, and truthful. {platformName} is not responsible for negative consequences arising from inaccuracies.</p>\n<p>Users are also informed of the inability to register and/or communicate third-party data unless legally authorized.</p>\n\n<span><p><b>D. Rights</b></p>Rights to access, object, rectify, and delete data, as well as data portability.</p> <p>Individuals are entitled to obtain information about whether Open Health is processing their personal data.</p> <p>Authorized individuals can access their data, request rectification of inaccurate data, or request its deletion when it is no longer necessary for its intended purpose.</p> <p>Under certain circumstances, individuals can request limitations on processing their data, in which case the data will only be retained for legal claims or defenses.</p> <p>Consent will be explicitly sought for any required data collection.</p><p>Requests to exercise these rights must be addressed to Open Health at the postal address or email provided above.</p><p>Requests should include:</p></span> <span><ul><li><p>Name and surname of the requester.</p></li><li><p>Details of the request.</p></li><li><p>Contact information for notifications, date, and signature of the requester.</p></li><li><p>Supporting documents if necessary.</p></li> </ul></p> </span>\n\n<p><b>E. Spanish Data Protection Agency</b></p>\n<p>The AEPD is responsible for ensuring compliance with privacy and data protection laws. If you feel your rights have been violated, you can file a complaint at <a href=\"http://www.agpd.es\">www.agpd.es</a>.</p>\n\n<p><b>F. Links of Interest</b></p>\n<p>For more information about online privacy, we recommend visiting:</p>\n<p>Internet Security Office: <a href=\"http://www.osi.es\">http://www.osi.es</a></p>\n<p>Spanish Data Protection Agency: <a href=\"http://www.agpd.es\">http://www.agpd.es</a></p>"}}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy":{"title":"Privacy Policy","text":"<p><b>Privacy</b></p>\n\n\n<p><b>A. \nGeneral</b></p>\n\n<p>Who is responsible for the processing of your data?</p>\n\n<p>{companyName} (hereinafter {platformName})</p>\n\n<p>Postal Address: {address}</p>\n\n<p>Email: support@openhealth.es</p>\n\n<p>DPO: INGERTEC GROUP privacy@openhealthcare.eu</p>\n\n<p>To enable navigation through the website, it is essential to be a registered user and accept the privacy rules detailed below. \nBy registering you agree that {platformName} stores and processes the personal data you provide us in accordance with the privacy policy.</p>\n\n<p>Data subject to processing:</p>\n\n<ul>\n\n<p>The following types of user data will be processed on the Opensalud platform:</p>\n  \n<li><p>Identifying data: DNI; \nElectronic address; \nPostal address; \nName and surname; \nPhone; \nIdentification profile photo (optional data).</p></li>\n  \n<li><p>Personal characteristics: Language; \nBirthdate; \nSex.</p></li>\n  \n<li><p>Special data categories: Health.</p></li>\n\n</ul>\n\n\n<p>The legal basis for the processing of your data is the consent of the interested party.</p>\n\n\n<p>The processing of data is carried out for the following purposes:</p>\n\n<ul>\n  <li><p>Conducting medical consultations and managing appointments and services that are the object of the platform's activity.</p></li>\n  \n<li><p>Conducting statistical and historical studies by {platformName}. \nThe reports generated will always be disaggregated and anonymous.</p></li>\n  \n<li><p>Production of communications of interest to users related to the operation of the platform (suggestions for use, improvements introduced...).</p></li>\n  \n<li><p>Sending of electronic communications to which the user has previously subscribed, in compliance with Law 34/2002, of July 11, on Information Society Services and Electronic Commerce (LSSICE).</p></li>\n\n</ul>\n\n\n<p>Our policy regarding sending our own emails is to only send communications that you have requested to receive. \nIf you prefer not to receive these messages by email, we will offer you through them the possibility of exercising your right to delete and waive the receipt of these messages.</p>\n\n\n<p>All users who establish some type of communication, either through the forms located on the Web or through alternative means, must know that their data may be collected for processing by this platform.</ \np>\n\n\n<p>{platformName} treats the data confidentially and adopts the appropriate technical and organizational measures to guarantee the appropriate level of security for the processing, in compliance with the requirements of the applicable regulations on Data Protection. \nOpen Health is certified in ISO 27001.</p>\n\n\n<p>However, no system can guarantee the absolute invulnerability of the systems, therefore, {platformName} does not assume any responsibility for damages derived from alterations that third parties may cause in the user's computer systems, electronic documents or files. \n.</p>\n\n\n<p><b>What is the data retention period?</b></p>\n\n\n<p>The data to carry out the service contracted by the client will be kept for as long as the contract is in force. \nWhen said relationship ends, the data may be kept for the time required by applicable legislation and until any responsibilities arising from the contract expire.</p>\n\n\n<p>The personal data provided will be kept as long as the user remains active on the platform (has not requested cancellation) and for the periods necessary to comply with legal obligations related to the custody of clinical and administrative information.</p>\n\n\n<p>The data collected to respond to your request, request or query about our products and services will be kept indefinitely until, where appropriate, you express your desire to delete them.</p>\n\n\n<p><b>B. \nData transfer and international transfers</b></p>\n\n<p>Any data collected by {platformName} will under no circumstances be transferred to third parties, except for the exceptions detailed below:</p>\n\n<ul>\n  \n<li><p>Previous request is made by the portal to the interested party and the interested party expresses his or her agreement, whether said request is individual or generic. \nIn any case {platformName} will never transfer any data for advertising purposes.</p></li>\n  \n<li><p>When they refer to the exceptions contemplated by the applicable regulations.</p></li>\n  \n<li><p>Through contracting with third-party companies, for analysis services, for exclusively statistical purposes and to improve the Service and never for advertising.</p></li>\n  \n<li><p>To health professionals and centers registered on the platform for the purposes of making and carrying out medical appointments, for a period of one year from the last explicit consent, either by requesting an appointment or authorizing a professional. \nFor these purposes, professionals and registered centers that access patient data on the platform assume, where appropriate, the obligations determined by the applicable data protection regulations, assuming full responsibility in the event of non-compliance with said regulation. In accordance with said regulations, professionals and centers accept the relationship as data processor with respect to the personal data that registered users provide to {platformName} for the purposes of making appointments and consultations, maintaining in \nin any case the level of data specially protected for said information.</p></li>\n  \n<li><p>To the companies that are used as support for the correct functioning of the platform (cloud) and collaborators.</p></li>\n  \n<li><p>In the case of telemedicine services for companies, to generate aggregate reports on the use of the platform by its employees. \nThese aggregated reports will be anonymous and will only contain the following information: total number of users, total number of services used and main reasons for consultation. \nThe data is broken down by sex and age groups (registered employee and number of consultations).</p></li>\n\n\n<p><u>We do not make international transfers</u></p>\n\n</ul>\n\n\n<p><b>C. \nData quality</b></p>\n\n<p>The Website informs users of the obligation to correctly update the data provided and processed in the file called Users. \nSaid data must be adequate, relevant, current, accurate and true. \n{platformName} is excluded from all negative consequences derived from inaccuracies in them.</p>\n\n<p>At the same time, users are informed of the impossibility of registering and/or communicating third party data on their behalf, through the stipulated forms of communication, unless there is a legally constituted representation. \nIn the case of minors, express accreditation of said condition may be required.</p>\n\n\n<span><p><b>D. \nRights</b></p>Rights of access, opposition, rectification and cancellation of data, deletion and portability.</p> <p>Any person has the right to obtain information about whether at Open Salud we are processing their personal data. \n</p> <p>Legitimated persons have the right to access their personal data, to request the rectification of inaccurate data or, where appropriate, request its deletion when, among other reasons, the data is no longer necessary for the \npurposes for which they were collected.</p> <p>When circumstances so require, interested parties may request the limitation of the processing of their data, in which case we will only keep them for the exercise or defense of claims.</p> \n<p>When we need to obtain information for your \nOn the other hand, we will always request your express consent through the means enabled for this purpose.</p><p>Likewise, you may request the delivery, in an exportable format, of a file with your data on the platform. \nFrom the moment you download or print the documentation or information stored in opensalud, custody of it will become your exclusive responsibility, recommending that you make responsible use based on the sensitivity of the information it contains, and that \nkeep confidential and with restricted access.</p><p>The exercise of these rights must be carried out by means of communication addressed to Open Salud, either to its postal address, indicated above, or to the electronic address provided to them. \neffects \n(soporte@openhealth.es), without prejudice to the use of any other legally valid means, which allows the requirements for this to be completed in a legally valid manner.</p><p>The content requirements for the exercise of rights \nThey are:</p></span> <span><ul><li><p>Name and surname of the interested party.</p></li><li><p>Object of the request.</p \n></li><li><p>Address for notification purposes, date and signature of the \napplicant.</p></li><li><p>Documents accrediting the request made in the event that they are deemed convenient or necessary.</p></li> </ul></p> </span>\n\n\n<p><b>E. \nSpanish Data Protection Agency</b></p>\n\n<p>The AEPD is responsible for ensuring compliance with laws on privacy and data protection and guaranteeing the security and privacy of your data in general and especially on the Internet.</p>\n\n<p>In the event that you feel your rights have been violated regarding the protection of your personal data, especially when you have not obtained satisfaction in the exercise of your rights, you can file a claim with the Data Protection Control Authority. \ncompetent through its website: <a href=\"http://www.agpd.es\">www.agpd.es</a></p>\n\n\n<p><b>F. \nLinks of Interest</b></p>\n\n<p>If you want to know more about the Internet and your privacy from {platformName}, we recommend that you visit the following links to learn more about it:</p>\n\n<p>Internet Security Office: <a href=\"http://www.osi.es\">http://www.osi.es</a></p>\n\n<p>Spanish Data Protection Agency: <a href=\"http://www.agpd.es\">http://www.agpd.es</a></p>"}}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy-professional":{"title":"Política de Privacidad","text":"<span><p>bluMEDICA LATAM, S.A. DE C.V. como responsable del tratamiento de sus datos, en cumplimiento de lo establecido en el REGLAMENTO UE 2016/679 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos, y en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, se le informa:</p><br></span> <span><h4>DATOS DEL RESPONSABLE DE TRATAMIENTO</h4><br></span> <span><p>bluMEDICA LATAM, S.A. DE C.V.</p><p>DIRECCIÓN: Fujiyama número 74, Colonia Las Águilas, Delegación Álvaro Obregón, código postal 01710, Ciudad de México.</p><p>TELÉFONO: (55) 5920 9768</p><p>CORREO ELECTRÓNICO: rambrosi@blumedica.mx el cual le solicitamos confirme vía telefónica para garantizar su correcta recepción.</p><br></span> <span><p><b><u>Origen de los datos</u></b>: los datos recabados han sido facilitados directamente por Ud., a través de la cumplimentación del formulario anterior, y no se han recabado de ninguna otra fuente.</p><br></span> <span><p><b><u>Datos y finalidad</u></b>: Los datos personales recabados se corresponden con datos identificativos (Nombre, teléfono y correo electrónico) y datos profesionales, con el fin de:</p><br></span> <span><ol><li>Responder a las solicitudes de contacto.</li><br><li>Llevar a cabo la presstación contratada por el cliente.</li></ol><br></span> <span><p><b><u>Legitimación</u></b>:</p><br></span> <span><p>La Base Jurídica del Tratamiento del <b>punto 1</b> es el consentimiento otorgado por el interesado, pudiendo ser revocado en cualquier momento.</p><p>La Base Jurídica del Tratamiento del <b>punto 2</b> está basada en la ejecución de la prestación del servicio correspondiente.</p><br></span> <span><p><b><u>Conservación de los datos</u></b>:</p><br></span> <span><p>Los datos recabados para dar respuesta a su solicitud, petición o consulta de nuestros productos y servicios, serán conservados indefinidamente hasta que, en su caso, nos manifieste tu voluntad de suprimirlos.</p><p>Los datos para llevar a cabo la prestación contratada por el cliente serán conservados durante el tiempo en que el contrato esté vigente. Cuando finalice dicha relación, los datos podrán ser conservados durante el tiempo exigido por la legislación aplicable y hasta que prescriban las eventuales responsabilidades derivadas del contrato.</p><br></span> <span><p><b><u>Destinatarios de los datos</u></b>: No se realizarán cesiones de datos.</p><br></span> <span><p><b><u>Transferencias Internacionales</u></b>: No vamos a realizar transferencias internacionales.</p><br></span> <span><p><b><u>Decisiones automatizadas</u></b>: No hay decisiones automatizadas relativas a sus datos.</p><br></span> <span><p><b><u>Derechos</u></b>: Ud. puede ejercer los derechos que se relacionan a continuación en Fujiyama número 74, Colonia Las Águilas, Delegación Álvaro Obregón, código postal 01710, Ciudad de México y en el correo electrónico rambrosi@blumedica.mx, comunicándolo por escrito, junto con una copia de un documento acreditativo de tu identidad: </p><br></span> <span><ul><li>A <u>obtener confirmación</u> sobre si estamos tratando datos personales que les conciernan, o no.</li><li>A acceder a sus datos personales, así como a solicitar la <u>rectificación</u> de los datos inexactos o, en su caso, solicitar su <u>supresión</u> cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.</li><li>En determinadas circunstancias, los interesados podrán solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.</li><li>En determinadas circunstancias y por motivos relacionados con su situación particular, los interesados podrán oponerse al tratamiento de sus datos. Dejaremos de tratar los datos, salvo por motivos legítimos imperiosos, o el ejercicio o la defensa de posibles reclamaciones.</li><li>A la portabilidad, que implica que los datos personales del interesado se transmitan directamente de un responsable a otro, sin necesidad de que sean transmitidos previamente al propio interesado, siempre que ello sea técnicamente posible.</li><li>A retirar el consentimiento prestado.</li><li>A reclamar ante la <b>Autoridad de Control</b>: si considera que no se han respetado sus derechos, puede presentar una reclamación dirigiéndose por escrito a la Agencia Española de Protección de Datos sita en la Calle Jorge Juan, 6, 28001 Madrid o utilizar la sede electrónica: <a href='https://sedeagpd.gob.es'>https://sedeagpd.gob.es</a>. En ambos casos, deberá acompañar la documentación pertinente.</li></ul><br></span> <span><p><b><u>Política SGSI - Datos</u></b>: Si desea verla o descargarla, haga clic <a href='https://opensaludes.sharepoint.com/:b:/s/General2/EVxds_7iSPhDhE093t2GiPgBSGsRVwiRABfTHhRSfOr39g?e=oi7aDp'>aquí</a>.</p><br></span></div>"}}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy":{"title":"Política de Privacidad","text":"<span><p>bluMEDICA LATAM, S.A. DE C.V. como responsable del tratamiento de sus datos, en cumplimiento de lo establecido en el REGLAMENTO UE 2016/679 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos, y en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, se le informa:</p><br></span> <span><h4>DATOS DEL RESPONSABLE DE TRATAMIENTO</h4><br></span> <span><p>bluMEDICA LATAM, S.A. DE C.V.</p><p>DIRECCIÓN: Fujiyama número 74, Colonia Las Águilas, Delegación Álvaro Obregón, código postal 01710, Ciudad de México.</p><p>TELÉFONO: (55) 5920 9768</p><p>CORREO ELECTRÓNICO: rambrosi@blumedica.mx el cual le solicitamos confirme vía telefónica para garantizar su correcta recepción.</p><br></span> <span><p><b><u>Origen de los datos</u></b>: los datos recabados han sido facilitados directamente por Ud., a través de la cumplimentación del formulario anterior, y no se han recabado de ninguna otra fuente.</p><br></span> <span><p><b><u>Datos y finalidad</u></b>: Los datos personales recabados se corresponden con datos identificativos (Nombre, teléfono y correo electrónico) y datos profesionales, con el fin de:</p><br></span> <span><ol><li>Responder a las solicitudes de contacto.</li><br><li>Llevar a cabo la presstación contratada por el cliente.</li></ol><br></span> <span><p><b><u>Legitimación</u></b>:</p><br></span> <span><p>La Base Jurídica del Tratamiento del <b>punto 1</b> es el consentimiento otorgado por el interesado, pudiendo ser revocado en cualquier momento.</p><p>La Base Jurídica del Tratamiento del <b>punto 2</b> está basada en la ejecución de la prestación del servicio correspondiente.</p><br></span> <span><p><b><u>Conservación de los datos</u></b>:</p><br></span> <span><p>Los datos recabados para dar respuesta a su solicitud, petición o consulta de nuestros productos y servicios, serán conservados indefinidamente hasta que, en su caso, nos manifieste tu voluntad de suprimirlos.</p><p>Los datos para llevar a cabo la prestación contratada por el cliente serán conservados durante el tiempo en que el contrato esté vigente. Cuando finalice dicha relación, los datos podrán ser conservados durante el tiempo exigido por la legislación aplicable y hasta que prescriban las eventuales responsabilidades derivadas del contrato.</p><br></span> <span><p><b><u>Destinatarios de los datos</u></b>: No se realizarán cesiones de datos.</p><br></span> <span><p><b><u>Transferencias Internacionales</u></b>: No vamos a realizar transferencias internacionales.</p><br></span> <span><p><b><u>Decisiones automatizadas</u></b>: No hay decisiones automatizadas relativas a sus datos.</p><br></span> <span><p><b><u>Derechos</u></b>: Ud. puede ejercer los derechos que se relacionan a continuación en Fujiyama número 74, Colonia Las Águilas, Delegación Álvaro Obregón, código postal 01710, Ciudad de México y en el correo electrónico rambrosi@blumedica.mx, comunicándolo por escrito, junto con una copia de un documento acreditativo de tu identidad: </p><br></span> <span><ul><li>A <u>obtener confirmación</u> sobre si estamos tratando datos personales que les conciernan, o no.</li><li>A acceder a sus datos personales, así como a solicitar la <u>rectificación</u> de los datos inexactos o, en su caso, solicitar su <u>supresión</u> cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.</li><li>En determinadas circunstancias, los interesados podrán solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.</li><li>En determinadas circunstancias y por motivos relacionados con su situación particular, los interesados podrán oponerse al tratamiento de sus datos. Dejaremos de tratar los datos, salvo por motivos legítimos imperiosos, o el ejercicio o la defensa de posibles reclamaciones.</li><li>A la portabilidad, que implica que los datos personales del interesado se transmitan directamente de un responsable a otro, sin necesidad de que sean transmitidos previamente al propio interesado, siempre que ello sea técnicamente posible.</li><li>A retirar el consentimiento prestado.</li><li>A reclamar ante la <b>Autoridad de Control</b>: si considera que no se han respetado sus derechos, puede presentar una reclamación dirigiéndose por escrito a la Agencia Española de Protección de Datos sita en la Calle Jorge Juan, 6, 28001 Madrid o utilizar la sede electrónica: <a href='https://sedeagpd.gob.es'>https://sedeagpd.gob.es</a>. En ambos casos, deberá acompañar la documentación pertinente.</li></ul><br></span> <span><p><b><u>Política SGSI - Datos</u></b>: Si desea verla o descargarla, haga clic <a href='https://opensaludes.sharepoint.com/:b:/s/General2/EVxds_7iSPhDhE093t2GiPgBSGsRVwiRABfTHhRSfOr39g?e=oi7aDp'>aquí</a>.</p><br></span></div>"}}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy-professional":{"title":"Política de Privacidade para Profissionais","text":"<p><b>Privacidade</b></p>\n\n<p><b>A. Geral</b></p>\n<p>Quem é o responsável pelo tratamento dos seus dados?</p>\n<p>{companyName} (Doravante {platformName})</p>\n<p>Endereço Postal: {address}}.</p>\n<p>Email: suporte@openhealth.es</p>\n<p>DPO: GRUPO INGERTEC privacidad@openhealthcare.eu</p>\n<p>Para possibilitar a navegação através do site, é imprescindível ser um usuário registrado e aceitar as regras de privacidade detalhadas a seguir. Com o registro, você concorda que {platformName} armazene e trate os dados pessoais que você nos fornece de acordo com a política de privacidade.</p>\n\n<p>A base legal para o tratamento dos seus dados é o consentimento do titular dos dados.</p>\n\n<p>O tratamento dos dados é realizado com as seguintes finalidades:</p>\n<ul>\n  <li><p>Realização de consultas médicas e gestão de consultas e serviços objeto da atividade da plataforma.</p></li> \n  <li><p>Realização de estudos estatísticos e históricos por parte de {platformName}. Os relatórios gerados serão sempre desagregados e anônimos.</p></li>\n  <li><p>Realização de comunicações de interesse para os usuários relativas ao funcionamento da plataforma (sugestões de utilização, melhorias introduzidas, etc.).</p></li>\n  <li><p>Envio de comunicações eletrônicas às quais o usuário tenha previamente se inscrito, em conformidade com a Lei 34/2002, de 11 de julho, de Serviços da Sociedade da Informação e de Comércio Eletrônico (LSSICE).</p></li>\n\n</ul>\n\n<p>Nossa política em relação ao envio de nossos próprios emails se concentra em enviar apenas comunicações que você tenha solicitado receber. Se preferir não receber essas mensagens por email, ofereceremos através delas a possibilidade de exercer seu direito de exclusão e renúncia à recepção dessas mensagens.</p>\n\n<p>Todos os usuários que estabeleçam algum tipo de comunicação, seja através dos formulários localizados no site, seja através de vias alternativas, devem saber que seus dados poderão ser coletados para tratamento por parte desta plataforma.</p>\n\n<p>{platformName} trata os dados de forma confidencial e adota as medidas técnicas e organizativas apropriadas para garantir o nível de segurança adequado ao tratamento, em conformidade com o exigido na legislação aplicável em matéria de Proteção de Dados. A Open Health possui certificação ISO 27001.</p>\n\n<p>No entanto, nenhum sistema pode garantir a absoluta invulnerabilidade dos sistemas; portanto, {platformName} não assume nenhuma responsabilidade por danos e prejuízos decorrentes de alterações que terceiros possam causar nos sistemas informáticos, documentos eletrônicos ou arquivos do usuário.</p>\n\n<p><b>Qual é o tempo de conservação dos dados?</b></p>\n\n<p>Os dados pessoais fornecidos serão conservados enquanto o usuário permanecer ativo na plataforma (não tiver solicitado a desativação) e durante os prazos necessários para cumprir as obrigações legais relativas à custódia de Informações clínicas e administrativas.</p>\n\n<p>Os dados coletados para responder à sua solicitação, pedido ou consulta sobre nossos produtos e serviços serão conservados indefinidamente até que, se for o caso, você manifeste a vontade de excluí-los.</p>\n\n<p><b>B. Cessão de Dados e Transferências Internacionais</b></p>\n\n<p>Qualquer dado coletado pela {platformName} sob nenhuma circunstância será cedido a empresas terceiras, salvo as exceções detalhadas a seguir:</p>\n<ul>\n  <li><p>Com solicitação prévia por parte do portal ao titular dos dados e com a expressa concordância deste, seja a solicitação de caráter individual ou genérico. Em qualquer caso, {platformName} nunca cederá nenhum dado para fins publicitários.</p></li>\n  <li><p>Quando se referirem às exceções contempladas pela legislação aplicável.</p></li>\n  <li><p>Através da contratação com empresas terceiras para serviços de análise, com fins exclusivamente estatísticos e de melhoria do Serviço e nunca publicitários.</p></li>\n  <li><p>Aos profissionais e centros de saúde registrados na plataforma para efeitos de agendamento e realização de consultas médicas, , pelo período de um ano a contar do último consentimento expresso, seja por solicitação de agendamento ou autorização de profissional. Para esses fins, os profissionais e centros registrados que acessarem os dados dos pacientes na plataforma assumem, se for o caso, as obrigações determinadas pela legislação sobre proteção de dados aplicável, assumindo total responsabilidade em caso de descumprimento dessa norma. De acordo com essa legislação, os profissionais e centros aceitam a relação como responsáveis pelo tratamento em relação aos dados pessoais que os usuários registrados fornecem à {platformName} para realizar consultas e agendamentos, mantendo em todo caso o nível de dados especialmente protegidos para tais informações.</p></li>\n\n<em><p>Em relação a qualquer informação extraída da plataforma, pelos meios legalmente habilitados, o profissional/centro deve saber que os dados de saúde estão catalogados como informações muito sensíveis e de alto nível de segurança; e, consequentemente, devem ser tratados seguindo as diretrizes estabelecidas pelo Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho de 27 de abril de 2016 relativo à proteção das pessoas físicas no que diz respeito ao tratamento de dados pessoais e à livre circulação desses dados e pelo qual se revoga a Diretiva 95/46/CE (RGPD), a Lei Orgânica 3/2018, de 5 de dezembro, de Proteção de Dados Pessoais e garantia dos direitos digitais, e demais legislações vigentes em matéria de proteção de dados de caráter pessoal e segurança da informação. Apenas será permitido acessar ou baixar aquelas informações às quais esteja autorizado de acordo com a legislação vigente.</p>\n<p>Em nenhum caso a informação extraída pode ser armazenada no disco rígido dos equipamentos (local). No caso de impressão da informação em papel, esta deverá estar sempre sob custódia da pessoa responsável por ela e ser armazenada trancada quando não estiver em uso.</p>\n<p>Igualmente, não se deve fazer uso de dispositivos móveis externos para o armazenamento e transporte da informação, como pendrives, smartphones, notebooks, etc. Em nenhum caso será utilizado email externo para o envio ou recebimento desse tipo de informação. Além disso, independentemente do suporte em que se encontre, a informação extraída deverá ser apagada ou destruída de forma irrefutável assim que deixar de ser necessária para os fins que motivaram sua extração.</p>\n<p>O profissional/centro deve utilizar os dados pessoais objeto de tratamento, ou os que coletar para sua inclusão, apenas para a finalidade objeto do Contrato. Em nenhum caso poderá utilizar os dados para fins próprios. Caso o Responsável pelo tratamento destine os dados a outras finalidades das estipuladas, comunique-os ou os utilize descumprindo as condições deste documento, será considerado responsável pelo arquivo para todos os efeitos, respondendo pessoalmente pelas infrações em que tiver incorrido.</p>\n<p>O profissional/centro não comunicará os dados a terceiros não autorizados, salvo que possua autorização expressa e por escrito do Responsável pelo tratamento, nos casos legalmente admissíveis. Para esses fins, entender-se-ão autorizadas as comunicações de dados entre as empresas pertencentes ao grupo de cada uma das Partes, respectivamente, com a finalidade de atender às obrigações e direitos decorrentes da execução do contrato. Assim como manter o dever de sigilo em relação aos dados de caráter pessoal aos quais teve acesso em virtude do Contrato, mesmo após o término de seu objeto, respondendo perante o Responsável pelo tratamento em caso de descumprimento, sem prejuízo das responsabilidades que possam derivar perante a Agência Espanhola de Proteção de Dados ou perante o titular dos dados.</p>\n<p>O profissional/centro deve implementar as medidas de segurança que se apliquem de acordo com as avaliações de risco que, se for o caso, deva realizar o Responsável pelo tratamento.</p></em>\n  <li><p>A empresas que são utilizadas como suporte para o correto funcionamento da plataforma (cloud) e colaboradores.</p></li>\n  <li><p>No caso dos serviços de telemedicina para empresas, para gerar relatórios agregados de utilização da plataforma por parte de seus funcionários. Esses relatórios agregados serão anônimos e conterão apenas as seguintes Informações: número total de usuários, número total de serviços utilizados e principais motivos de consulta. Os dados serão agregados por sexo e faixas etárias.</p></li>\n\n</ul>\n\n<p><u>Não realizamos transferências internacionais</u></p>\n\n<p><b>C. Qualidade dos Dados</b></p>\n<p>O site informa aos usuários sobre a obrigação de atualizar corretamente os dados fornecidos e tratados no arquivo denominado Usuários. Esses dados devem ser adequados, pertinentes, atuais, exatos e verdadeiros, ficando {platformName} isento de todas as consequências negativas decorrentes de imprecisões nos mesmos.</p>\n<p>Além disso, informa aos usuários a impossibilidade de registrar e/ou comunicar dados de terceiros em seu nome, através das formas de comunicação estipuladas, salvo se houver uma representação legalmente constituída. No caso de menores, poderá ser exigida a comprovação expressa dessa condição.</p>\n\n<span><p><b>D. Direitos</b></p>Direitos de acesso, oposição, retificação e cancelamento de dados, exclusão e portabilidade.</p> <p>Qualquer pessoa tem o direito de obter informações sobre se na Open Health estamos tratando seus dados pessoais.</p> <p>As pessoas legitimadas têm o direito de acessar seus dados pessoais, solicitar a retificação de dados inexatos ou, se for o caso, solicitar sua eliminação quando, entre outros motivos, os dados já não forem necessários para os fins para os quais foram coletados.</p> <p>Quando as circunstâncias assim o exigirem, os interessados poderão solicitar a limitação do tratamento de seus dados, caso em que apenas os conservaremos para o exercício ou a defesa de reivindicações.</p> <p>Quando precisarmos obter informações de sua parte, sempre solicitaremos seu consentimento expresso através dos meios habilitados para isso.</p><p>O exercício desses direitos deve ser realizado mediante comunicação dirigida à Open Health, seja ao seu endereço postal, indicado acima, ou ao endereço eletrônico disponibilizado para esses fins (suporte@openhealth.es), sem prejuízo do uso de qualquer outro meio válido em direito, que permita cumprir de forma legalmente válida os requisitos para isso.</p><p>Os requisitos de conteúdo para o exercício dos direitos são:</p></span> <span><ul><li><p>Nome e sobrenome do interessado.</p></li><li><p>Objeto da solicitação.</p></li><li><p>Endereço para efeitos de notificações, data e assinatura do solicitante.</p></li><li><p>Documentos comprobatórios da solicitação formulada no caso de serem considerados convenientes ou necessários.</p></li> </ul></p> </span>\n\n<p><b>E. Agência Espanhola de Proteção de Dados</b></p>\n<p>A AEPD é responsável por zelar pelo cumprimento das leis sobre privacidade e proteção de dados e garantir a segurança e privacidade dos seus dados em geral e especialmente na Internet.</p>\n<p>No caso de você sentir que seus direitos em relação à proteção dos seus dados pessoais foram violados, especialmente quando não obteve satisfação no exercício de seus direitos, pode apresentar uma reclamação à Autoridade de Controle em matéria de Proteção de Dados competente através do seu site: <a href=\"http://www.agpd.es\">www.agpd.es</a></p>\n\n<p><b>F. Links de Interesse</b></p>\n<p>Se você quiser saber mais sobre a Internet e sua privacidade, recomendamos que visite os seguintes links para saber mais sobre o assunto:</p>\n<p>Escritório de Segurança na Internet: <a href=\"http://www.osi.es\">http://www.osi.es</a></p>\n<p>Agência Espanhola de Proteção de Dados: <a href=\"http://www.agpd.es\">http://www.agpd.es</a></p>"}}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = {"privacy-policy":{"title":"Política de Privacidade","text":"<p><b>Privacidade</b></p>\n\n\n<p><b>A. \nGeral</b></p>\n\n<p>Quem é responsável pelo processamento dos seus dados?</p>\n\n<p>{companyName} (doravante {platformName})</p>\n\n<p>Endereço postal: {endereço}</p>\n\n<p>E-mail: support@openhealth.es</p>\n\n<p>RPD: GRUPO INGERTEC privacidade@openhealthcare.eu</p>\n\n<p>Para permitir a navegação pelo site é imprescindível ser usuário cadastrado e aceitar as regras de privacidade detalhadas a seguir. \nAo se registrar, você concorda que {platformName} armazena e processa os dados pessoais que você nos fornece de acordo com a política de privacidade.</p>\n\n<p>Dados sujeitos a tratamento:</p>\n\n<ul>\n\n<p>Os seguintes tipos de dados de usuários serão processados ​​na plataforma Opensalud:</p>\n  \n<li><p>Dados de identificação: DNI; \nEndereço eletrônico; \nEndereço postal; \nNome e sobrenome; \nTelefone; \nFoto de perfil de identificação (dados opcionais).</p></li>\n  \n<li><p>Características pessoais: Idioma; \nData de nascimento; \nSexo.</p></li>\n  \n<li><p>Categorias especiais de dados: Saúde.</p></li>\n\n</ul>\n\n\n<p>A base legal para o tratamento dos seus dados é o consentimento do interessado.</p>\n\n\n<p>O tratamento de dados é realizado para as seguintes finalidades:</p>\n\n<ul>\n <li><p>Realização de consultas médicas e gestão de consultas e serviços objeto da atividade da plataforma.</p></li>\n \n<li><p>Realização de estudos estatísticos e históricos por {platformName}. \nOs relatórios gerados serão sempre desagregados e anônimos.</p></li>\n  \n<li><p>Produção de comunicações de interesse dos utilizadores relacionadas com o funcionamento da plataforma (sugestões de utilização, melhorias introduzidas...).</p></li>\n  \n<li><p>Envio de comunicações eletrónicas que o utilizador tenha previamente subscrito, em cumprimento da Lei 34/2002, de 11 de julho, de Serviços da Sociedade da Informação e Comércio Eletrónico (LSSICE).</p></li>\n  \n</ul>\n\n\n<p>Nossa política em relação ao envio de nossos próprios e-mails é enviar apenas comunicações que você solicitou receber. \nCaso prefira não receber estas mensagens por e-mail, ofereceremos através deles a possibilidade de exercer o seu direito de exclusão e renunciar ao recebimento dessas mensagens.</p>\n\n\n<p>Todos os usuários que estabelecerem algum tipo de comunicação, seja através dos formulários localizados na Web ou através de meios alternativos, devem saber que seus dados poderão ser coletados para processamento por esta plataforma.</ p>\n\n\n<p>{platformName} trata os dados de forma confidencial e adota as medidas técnicas e organizacionais adequadas para garantir o nível de segurança adequado para o tratamento, em conformidade com os requisitos da regulamentação aplicável em matéria de Proteção de Dados. \nOpen Health é certificado na ISO 27001.</p>\n\n\n<p>No entanto, nenhum sistema pode garantir a invulnerabilidade absoluta dos sistemas, portanto, {platformName} não assume qualquer responsabilidade por danos derivados de alterações que terceiros possam causar nos sistemas informáticos, documentos eletrônicos ou arquivos do usuário.</ p>\n\n\n<p><b>Qual ​​é o período de retenção de dados?</b></p>\n\n\n<p>Os dados para a execução do serviço contratado pelo cliente serão mantidos enquanto o contrato estiver em vigor. \nTerminada a referida relação, os dados poderão ser conservados pelo tempo exigido pela legislação aplicável e até que expirem quaisquer responsabilidades decorrentes do contrato.</p>\n\n\n<p>Os dados pessoais fornecidos serão mantidos enquanto o usuário permanecer ativo na plataforma (não tiver solicitado o cancelamento) e pelos períodos necessários ao cumprimento das obrigações legais relacionadas à guarda de informações clínicas e administrativas.</p>\n\n\n<p>Os dados coletados para responder à sua solicitação, solicitação ou consulta sobre nossos produtos e serviços serão mantidos por tempo indeterminado até que, se for o caso, você manifeste seu desejo de excluí-los.</p>\n\n\n<p><b>B. \nTransferência de dados e transferências internacionais</b></p>\n\n<p>Quaisquer dados coletados por {platformName} não serão, em hipótese alguma, transferidos a terceiros, exceto pelas exceções detalhadas abaixo:</p>\n\n<ul>\n  \n<li><p>A solicitação prévia é feita pelo portal ao interessado e o interessado manifesta sua concordância, seja a solicitação individual ou genérica. \nEm qualquer caso, {platformName} nunca transferirá quaisquer dados para fins publicitários.</p></li>\n  \n<li><p>Quando se referem às exceções contempladas pela regulamentação aplicável.</p></li>\n  \n<li><p>Através de contratação com empresas terceiras, para serviços de análise, para fins exclusivamente estatísticos e para melhoria do Serviço e nunca para fins publicitários.</p></li>\n  \n<li><p>Aos profissionais e centros de saúde registados na plataforma para efeitos de marcação e realização de consultas médicas, pelo período de um ano a contar do último consentimento expresso, seja por solicitação de agendamento ou autorização de profissional. Para estes efeitos, os profissionais e centros registados que acedem aos dados dos pacientes na plataforma assumem, se for caso disso, as obrigações determinadas pela regulamentação de proteção de dados aplicável, assumindo total responsabilidade em caso de incumprimento da referida regulamentação. De acordo com os referidos regulamentos, os profissionais e centros aceitam a relação como subcontratantes no que diz respeito aos dados pessoais que os utilizadores registados fornecem a {platformName} para efeitos de marcação de consultas e consultas, mantendo em qualquer caso o nível de dados especialmente protegidos para essas informações.</p></li>\n  \n<li><p>Às empresas que servem de suporte para o correto funcionamento da plataforma (nuvem) e colaboradores.</p></li>\n  \n<li><p>No caso de serviços de telemedicina para empresas, gerar relatórios agregados sobre a utilização da plataforma pelos seus colaboradores. \nEstes relatórios agregados serão anónimos e conterão apenas a seguinte informação: número total de utilizadores, número total de serviços utilizados e principais motivos de consulta. \nOs dados são discriminados por sexo e faixa etária (funcionário cadastrado e número de consultas).</p></li>\n\n\n<p><u>Não fazemos transferências internacionais</u></p>\n\n</ul>\n\n\n<p><b>C. \nQualidade dos dados</b></p>\n\n<p>O Site informa aos usuários a obrigação de atualizar corretamente os dados fornecidos e processados ​​no arquivo denominado Usuários. \nEsses dados deverão ser adequados, relevantes, atuais, exatos e verdadeiros. \n{platformName} está excluído de todas as consequências negativas derivadas de imprecisões neles.</p>\n\n<p>Paralelamente, os utilizadores são informados da impossibilidade de registo e/ou comunicação de dados de terceiros em seu nome, através das formas de comunicação estipuladas, salvo representação legalmente constituída. \nNo caso de menores, poderá ser necessária a acreditação expressa dessa condição.</p>\n\n\n<span><p><b>D. \nDireitos</b></p>Direitos de acesso, oposição, retificação e cancelamento de dados, eliminação e portabilidade.</p> <p>Qualquer pessoa tem o direito de obter informação sobre se na Open Salud estamos processando seus dados pessoais. dados. \n</p> <p>As pessoas legítimas têm o direito de aceder aos seus dados pessoais, de solicitar a retificação dos dados inexatos ou, se for caso disso, de solicitar a sua eliminação quando, entre outros motivos, os dados já não sejam necessários para os fins para os quais foram recolhidos.</p> <p>Quando as circunstâncias o exigirem, os interessados ​​poderão solicitar a limitação do tratamento dos seus dados, caso em que apenas os conservaremos para o exercício ou defesa de reclamações.</p> <p>Quando precisarmos obter informações para o seu \nPor outro lado, solicitaremos sempre o seu consentimento expresso através dos meios habilitados para o efeito.</p><p>Da mesma forma, poderá solicitar a entrega, em formato exportável, de um ficheiro com os seus dados na plataforma. \nA partir do momento em que você baixar ou imprimir a documentação ou informação armazenada no opensalud, a custódia da mesma passará a ser de sua exclusiva responsabilidade, recomendando-se que você faça um uso responsável com base na sensibilidade das informações nela contidas, e que as mantenha confidenciais e com acesso restrito.</p><p>O exercício destes direitos deverá ser realizado por meio de comunicação dirigida à Open Salud, seja para o seu endereço postal, indicado acima, ou para o endereço eletrônico que lhe for fornecido. \n(soporte@openhealth.es), sem prejuízo da utilização de qualquer outro meio juridicamente válido, que permita preencher de forma juridicamente válida os requisitos para o efeito.</p><p>Os requisitos de conteúdo para o exercício de direitos São eles:</p></span> <span><ul><li><p>Nome e sobrenome do interessado.</p></li><li><p>Objeto da solicitação. </p ></li><li><p>Endereço para fins de notificação, data e assinatura do \nsolicitante.</p></li><li><p>Documentos que comprovem a solicitação realizada caso sejam considerados convenientes ou necessários.</p></li> </ul></p> </ período>\n\n\n<p><b>E. \nAgência Espanhola de Proteção de Dados</b></p>\n\n<p>A AEPD é responsável por garantir o cumprimento das leis sobre privacidade e proteção de dados e garantir a segurança e privacidade dos seus dados em geral e especialmente na Internet.</p>\n\n<p>Caso sinta que os seus direitos foram violados relativamente à proteção dos seus dados pessoais, especialmente quando não obteve satisfação no exercício dos seus direitos, poderá apresentar uma reclamação junto da Autoridade de Controlo de Proteção de Dados competente. seu site: <a href=\"http://www.agpd.es\">www.agpd.es</a></p>\n\n\n<p><b>F. \nLinks de interesse</b></p>\n\n<p>Se você quiser saber mais sobre a Internet e sua privacidade em {platformName}, recomendamos que você visite os seguintes links para saber mais:</p>\n\n<p>Escritório de Segurança da Internet: <a href=\"http://www.osi.es\">http://www.osi.es</a></p>\n\n<p>Agência Espanhola de Proteção de Dados: <a href=\"http://www.agpd.es\">http://www.agpd.es</a></p>"}}

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  cognitoInfo: {},
  loggedIn: false,
  loadingState: true,
  errorLoadingState: false
};

function setLoggedIn(newValue) {
  state.session.loggedIn = newValue;
}

function setLoggedOut() {
  state.session.loggedIn = false;
  state.cognitoInfo = {};
}

function setCognitoInfo(newValue) {
  state.cognitoInfo = newValue;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  setLoggedIn: setLoggedIn,
  setLoggedOut: setLoggedOut,
  setCognitoInfo: setCognitoInfo
});

/***/ }),
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/RGB_OPENSALUD_AZUL.8f3135f.png";

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegal_white.e8eeebe.png";

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_healthierlives_color.fd1cf0c.png";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensaludmx_healthierlives_color.3b41236.png";

/***/ }),
/* 446 */,
/* 447 */,
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumControlPanel_vue__ = __webpack_require__(1103);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad40e27a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumControlPanel_vue__ = __webpack_require__(1733);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1728)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumControlPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad40e27a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumControlPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/ForumControlPanel.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ad40e27a", Component.options)
  } else {
    hotAPI.reload("data-v-ad40e27a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(1113);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa39410_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(1743);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1740)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3aa39410"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa39410_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/public/footers/Footer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3aa39410", Component.options)
  } else {
    hotAPI.reload("data-v-3aa39410", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.observable({ editMessage: null });

/***/ }),
/* 468 */,
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdleTracker_vue__ = __webpack_require__(1162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03af8d34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdleTracker_vue__ = __webpack_require__(2006);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdleTracker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03af8d34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdleTracker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/IdleTracker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03af8d34", Component.options)
  } else {
    hotAPI.reload("data-v-03af8d34", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);





var client = function client() {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$api;
};

var TOKEN_QUERY_PARAM = 't';
var PATIENT_ID_QUERY_PARAM = 'patientId';
var PET_ID_QUERY_PARAM = 'petId';
var REQUIRED_PARAMS = [TOKEN_QUERY_PARAM, PATIENT_ID_QUERY_PARAM, PET_ID_QUERY_PARAM];

function getRequiredQueryParams() {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    // Return key value object with required query params
    return REQUIRED_PARAMS.reduce(function (acc, param) {
        acc[param] = urlParams.get(param);
        return acc;
    }, {});
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _getRequiredQueryPara = getRequiredQueryParams(),
        t = _getRequiredQueryPara.t,
        patientId = _getRequiredQueryPara.patientId,
        petId = _getRequiredQueryPara.petId;

    if (t) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$readOnlyToken = t;
    }
    return {
        // Variables
        getAllVariables: function getAllVariables() {
            return client().get('/history/variables', { params: { patientId: patientId, petId: petId } });
        },
        getVariableValues: function getVariableValues(name) {
            return client().get('/history/variables/' + name, { params: { patientId: patientId, petId: petId } });
        },
        saveVariableValue: function saveVariableValue(data) {
            includeParamsToBody(data);
            return client().post('/history/variables', data);
        },
        updateActiveVars: function updateActiveVars(vars) {
            return client().put('/history/variables/updateActiveVars', null, { params: { patientId: patientId, petId: petId, activeVars: vars } });
        },
        saveVariableTracking: function saveVariableTracking(data) {
            includeParamsToBody(data);
            return client().post('/history/variables/tracking', data);
        },
        getVariableTracking: function getVariableTracking(varName) {
            return client().get('/history/variables/tracking', { params: { varName: varName, patientId: patientId, petId: petId } });
        },
        removeVariableTracking: function removeVariableTracking(varName) {
            return client().delete('/history/variables/tracking', { params: { varName: varName, patientId: patientId, petId: petId } });
        },

        // Appointments
        getAppointments: function getAppointments() {
            var specialtyId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return client().get('/history/appointments', { params: { specialtyId: specialtyId, patientId: patientId, petId: petId } });
        },

        // Observations
        getObservations: function getObservations() {
            return client().get('/history/observations', { params: { patientId: patientId, petId: petId } });
        },
        saveObservations: function saveObservations(data) {
            includeParamsToBody(data);
            return client().post('/history/observations', data);
        },

        // Events
        getEvents: function getEvents() {
            return client().get('/history/events', { params: { patientId: patientId } });
        },
        saveEvents: function saveEvents(data) {
            includeParamsToBody(data);
            return client().post('/history/events', data);
        },

        // Allergies
        getHistoryAllergies: function getHistoryAllergies() {
            return client().get('/history/allergies', { params: { patientId: patientId, petId: petId } });
        },
        getAllergiesByName: function getAllergiesByName(name) {
            return client().get('allergies', { params: { name: name } });
        },
        saveHistoryAllergy: function saveHistoryAllergy(data) {
            includeParamsToBody(data);
            return client().post('/history/allergies', data);
        },
        deleteHistoryAllergy: function deleteHistoryAllergy(id) {
            return client().delete('/history/allergies', { params: { historyAllergyId: id, patientId: patientId } });
        },
        getSeverities: function getSeverities() {
            return client().get('severities');
        },

        // Medication Allergies
        getHistoryMedAllergies: function getHistoryMedAllergies() {
            return client().get('/history/medallergies', { params: { patientId: patientId, petId: petId } });
        },
        getMedAllergiesByName: function getMedAllergiesByName(name) {
            return client().get('/medicines/allergies', { params: { name: name } });
        },
        saveHistoryMedAllergies: function saveHistoryMedAllergies(data) {
            includeParamsToBody(data);
            return client().post('/history/medallergies', data);
        },
        deleteHistoryMedAllergy: function deleteHistoryMedAllergy(id) {
            return client().delete('/history/medallergies', { params: { historyAllergyId: id, patientId: patientId } });
        },

        // Diseases
        getHistoryDiseases: function getHistoryDiseases() {
            return client().get('/history/diseases', { params: { patientId: patientId, petId: petId } });
        },
        getDiseasesByName: function getDiseasesByName(name) {
            return client().get('diseases', { params: { name: name } });
        },
        saveHistoryDisease: function saveHistoryDisease(data) {
            includeParamsToBody(data);
            return client().post('history/diseases', data);
        },
        deleteHistoryDisease: function deleteHistoryDisease(disease) {
            return client().delete('history/diseases', { params: { historyDiseaseId: disease, patientId: patientId } });
        },

        // Chronic diseases
        getHistoryChrondiseases: function getHistoryChrondiseases() {
            return client().get('/history/chrondiseases', { params: { patientId: patientId } });
        },
        getChronDiseasesByName: function getChronDiseasesByName(name) {
            return client().get('chronicdiseases', { params: { name: name } });
        },
        saveHistoryChronDisease: function saveHistoryChronDisease(data) {
            includeParamsToBody(data);
            return client().post('history/chrondiseases', data);
        },
        deleteHistoryChronDisease: function deleteHistoryChronDisease(disease) {
            return client().delete('history/chrondiseases', { params: { historyDiseaseId: disease, patientId: patientId } });
        },

        // Medications
        getHistoryMedications: function getHistoryMedications() {
            return client().get('/history/medications', { params: { patientId: patientId, petId: petId } });
        },
        getMedicinesByName: function getMedicinesByName(name) {
            return client().get('medicines', { params: { name: name } });
        },
        getMedicinesById: function getMedicinesById(id) {
            return client().get('medicines', { params: { id: id } });
        },
        saveHistoryMedication: function saveHistoryMedication(data) {
            includeParamsToBody(data);
            return client().post('/history/medications', data);
        },
        deleteHistoryMedication: function deleteHistoryMedication(historyMedicationId) {
            return client().delete('history/medications', { params: { historyMedicationId: historyMedicationId, patientId: patientId } });
        },
        stopHistoryMedication: function stopHistoryMedication(data) {
            includeParamsToBody(data);
            return client().post('history/medications/stop', data);
        },
        getMedicationReminder: function getMedicationReminder(id) {
            return client().get('history/medications/reminder', { params: { id: id, patientId: patientId } });
        },
        saveMedicationReminder: function saveMedicationReminder(data) {
            includeParamsToBody(data);
            return client().post('history/medications/reminder', data);
        },
        deleteMedicationReminder: function deleteMedicationReminder(id) {
            return client().delete('history/medications/reminder', { params: { id: id, patientId: patientId } });
        },

        // Vaccinations
        getHistoryVaccinations: function getHistoryVaccinations() {
            return client().get('/history/vaccinations', { params: { patientId: patientId, petId: petId } });
        },
        getAllVaccines: function getAllVaccines() {
            return client().get('vaccines');
        },
        getVaccineLabs: function getVaccineLabs(vaccineId) {
            return client().get('vaccines/labs', { params: { vaccineId: vaccineId } });
        },
        saveHistoryVaccination: function saveHistoryVaccination(data) {
            includeParamsToBody(data);
            return client().post('/history/vaccinations', data);
        },
        deleteHistoryVaccination: function deleteHistoryVaccination(disease) {
            return client().delete('history/vaccinations', { params: { historyVaccinationId: disease, patientId: patientId } });
        },

        // Family backgrounds
        getHistoryFamilyBackgrounds: function getHistoryFamilyBackgrounds() {
            return client().get('/history/backgrounds', { params: { patientId: patientId } });
        },
        saveHistoryFamilyBackgrounds: function saveHistoryFamilyBackgrounds(data) {
            includeParamsToBody(data);
            return client().post('/history/backgrounds', data);
        },
        deleteHistoryFamilyBackgrounds: function deleteHistoryFamilyBackgrounds(id) {
            return client().delete('history/backgrounds', { params: { historyFamilyBackgroundId: id, patientId: patientId } });
        },
        getHistoryFamilyRelationships: function getHistoryFamilyRelationships() {
            return client().get('familyRelationships');
        },

        // Files
        getHistoryFiles: function getHistoryFiles() {
            return client().get('/history/files', { params: { patientId: patientId, petId: petId } });
        },
        deleteHistoryFile: function deleteHistoryFile(id) {
            return client().delete('history/files', { params: { id: id, patientId: patientId } });
        },
        getFiles: function getFiles(fileId) {
            return client().get('/files/urlAuth', { params: { id: fileId, patientId: patientId } });
        },
        lockFile: function lockFile(id) {
            return client().put('/history/files/lock', null, { params: { id: id } });
        },
        unlockFile: function unlockFile(id) {
            return client().put('/history/files/unlock', null, { params: { id: id } });
        },

        // Blood
        getBloodTypes: function getBloodTypes() {
            return client().get('/v1/BloodTypes');
        },

        // Habits
        getHabits: function getHabits() {
            return client().get('/history/habits', { params: { patientId: patientId } });
        },
        saveHabits: function saveHabits(data) {
            includeParamsToBody(data);
            return client().post('/history/habits', data);
        },
        getAllHabits: function getAllHabits() {
            return client().get('/habits', { params: { patientId: patientId } });
        },

        // Moods
        getMoods: function getMoods() {
            return client().get('/history/moods', { params: { patientId: patientId } });
        },
        saveMoods: function saveMoods(data) {
            includeParamsToBody(data);
            return client().post('/history/moods', data);
        },
        getAllMoods: function getAllMoods() {
            return client().get('/moods', { params: { patientId: patientId } });
        },

        // Healthy habits
        getHealthyHabits: function getHealthyHabits() {
            return client().get('/history/healthyHabits', { params: { patientId: patientId } });
        },

        // Quiz
        getQuiz: function getQuiz(quizType) {
            return client().get('/history/quiz', { params: { quizType: quizType, patientId: patientId } });
        },
        getCompletedQuizIds: function getCompletedQuizIds() {
            return client().get('/history/quiz/completed', { params: { patientId: patientId } });
        },
        saveQuiz: function saveQuiz(quizData) {
            return client().post('/history/quiz', quizData);
        },

        // Apps
        getApps: function getApps() {
            return client().get('/history/apps', { params: { patientId: patientId } });
        },
        saveApps: function saveApps(data) {
            includeParamsToBody(data);
            return client().post('/history/apps', data);
        },
        deleteApps: function deleteApps(id) {
            return client().delete('history/apps', { params: { appId: id, patientId: patientId } });
        },

        // ProfessionalsAndCentersSharedClinic
        getProfsAndCentersGrantAccessHistory: function getProfsAndCentersGrantAccessHistory(name) {
            return client().get('history/profsAndCentersGrantAccessHistory', { params: { name: name } });
        },
        grantAccessHistory: function grantAccessHistory(data) {
            return client().post('history/profsAndCentersGrantAccessHistory', data);
        },
        shareHistoryLink: function shareHistoryLink(data) {
            return client().post('history/shareHistoryLink', data);
        },

        // GrantAccessClinicHistory
        getProfessionalsAndCentersSharedClinic: function getProfessionalsAndCentersSharedClinic() {
            return client().get('history/professionalsAndCentersSharedClinic');
        },
        deleteProfessionalsAndCentersSharedClinic: function deleteProfessionalsAndCentersSharedClinic(id) {
            return client().delete('history/professionalsAndCentersSharedClinic', { params: { idDoctorCenter: id } });
        },

        // Chart
        getHistoryChart: function getHistoryChart(varName) {
            return client().get('history/chart', { params: { varName: varName, patientId: patientId, petId: petId } });
        },

        // Documents
        markFileAsCompleted: function markFileAsCompleted(data) {
            includeParamsToBody(data);
            return client().post('history/files/markAsCompleted', data);
        },

        uploadFileToClinicHistory: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file, fileTagId, ctx) {
                var toBase64, promise;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (file instanceof Array) {
                                    file = file[0];
                                }

                                toBase64 = function toBase64(file) {
                                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                        var reader = new FileReader();
                                        reader.readAsDataURL(file);
                                        reader.onload = function () {
                                            var encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                                            if (encoded.length % 4 > 0) {
                                                encoded += '='.repeat(4 - encoded.length % 4);
                                            }
                                            resolve(encoded);
                                        };
                                        reader.onerror = function (error) {
                                            return reject(error);
                                        };
                                    });
                                };

                                _context.t0 = ctx.$api;
                                _context.t1 = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$apiToken;
                                _context.t2 = patientId;
                                _context.t3 = petId;
                                _context.next = 8;
                                return toBase64(file);

                            case 8:
                                _context.t4 = _context.sent;
                                _context.t5 = file.name;
                                _context.t6 = file.type;
                                _context.t7 = fileTagId;
                                _context.t8 = {
                                    base64: _context.t4,
                                    name: _context.t5,
                                    contentType: _context.t6,
                                    idFileTag: _context.t7
                                };
                                _context.t9 = {
                                    token: _context.t1,
                                    id: _context.t2,
                                    petId: _context.t3,
                                    file: _context.t8
                                };
                                promise = _context.t0.post.call(_context.t0, 'PatientsClinicalDocument', _context.t9);
                                return _context.abrupt('return', promise);

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function uploadFileToClinicHistory(_x2, _x3, _x4) {
                return _ref.apply(this, arguments);
            }

            return uploadFileToClinicHistory;
        }(),
        overwriteFileClinicHistory: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(file, fileId, ctx) {
                var toBase64, promise;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (file instanceof Array) {
                                    file = file[0];
                                }

                                toBase64 = function toBase64(file) {
                                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                        var reader = new FileReader();
                                        reader.readAsDataURL(file);
                                        reader.onload = function () {
                                            var encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                                            if (encoded.length % 4 > 0) {
                                                encoded += '='.repeat(4 - encoded.length % 4);
                                            }
                                            resolve(encoded);
                                        };
                                        reader.onerror = function (error) {
                                            return reject(error);
                                        };
                                    });
                                };

                                _context2.t0 = ctx.$api;
                                _context2.t1 = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$apiToken;
                                _context2.t2 = fileId;
                                _context2.t3 = patientId;
                                _context2.t4 = petId;
                                _context2.next = 9;
                                return toBase64(file);

                            case 9:
                                _context2.t5 = _context2.sent;
                                _context2.t6 = file.name;
                                _context2.t7 = file.type;
                                _context2.t8 = {
                                    base64: _context2.t5,
                                    name: _context2.t6,
                                    contentType: _context2.t7
                                };
                                _context2.t9 = {
                                    token: _context2.t1,
                                    id: _context2.t2,
                                    patientId: _context2.t3,
                                    petId: _context2.t4,
                                    file: _context2.t8
                                };
                                promise = _context2.t0.post.call(_context2.t0, 'history/files/markAsCompleted', _context2.t9);
                                return _context2.abrupt('return', promise);

                            case 16:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function overwriteFileClinicHistory(_x5, _x6, _x7) {
                return _ref2.apply(this, arguments);
            }

            return overwriteFileClinicHistory;
        }()
    };

    function includeParamsToBody(data) {
        if (patientId && !data.patientId) {
            data.patientId = patientId;
        }
        if (petId && !data.petId) {
            data.petId = petId;
        }
    }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CARTERIZATION_SERVICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FREEDOM_AND_FLOW_SERVICE; });
/* unused harmony export OPENHEALTHCARE_API_SERVICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPENSALUD_PRIME_SERVICE; });
/* unused harmony export PRESCRYPTO_SERVICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TELEMEDCARE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return WELLWO_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HEALTHY_COMMUNITY_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SEARCH_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TEST_PSYCHOSOCIAL_RISKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TEST_RYFF_SCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TEST_FINDRISK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TEST_MEDITERRANEAN_DIET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TEST_NICOTINE_DEPENDENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TEST_STRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TEST_SLEEP_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TEST_ANXIETY_BECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TEST_PHYSICAL_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TEST_CARDIOVASCULAR_RISK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TEST_GENERAL_HEALTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TEST_INTERPERSONAL_RELATIONSHIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TEST_SOCIAL_SKILLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TEST_WORK_ENVIRONMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REHANDREBODY_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EVALUATE_HEALTH_TESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANIES_TESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ONLY_360_USERS_TESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return POSITIVE_IMPACT_TESTS; });
/* unused harmony export NEGATIVE_IMPACT_TESTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOT_IN_MX_TESTS; });
var CARTERIZATION_SERVICE = 'CARTERIZACION';
var FREEDOM_AND_FLOW_SERVICE = 'Freedom';
var OPENHEALTHCARE_API_SERVICE = 'OpenhealthcareApi';
var OPENSALUD_PRIME_SERVICE = 'Opensalud prime';
var PRESCRYPTO_SERVICE = 'Prescrypto';
var TELEMEDCARE_SERVICE = 'Telemedcare';
var WELLWO_SERVICE = 'Wellwo';
var HEALTHY_COMMUNITY_SERVICE = 'Comunidad';
var SEARCH_SERVICE = 'Search';
var TEST_PSYCHOSOCIAL_RISKS = "Test psychosocial risks";
var TEST_RYFF_SCALE = "Test ryff scale";
var TEST_FINDRISK = "Test findrisk";
var TEST_MEDITERRANEAN_DIET = "Test mediterranean diet";
var TEST_NICOTINE_DEPENDENCY = "Test nicotine dependency";
var TEST_STRESS = "Test stress";
var TEST_SLEEP_QUALITY = "Test sleep quality";
var TEST_ANXIETY_BECK = "Test anxiety beck";
var TEST_PHYSICAL_ACTIVITY = "Test physical activity";
var TEST_CARDIOVASCULAR_RISK = "Test cardiovascular risk";
var TEST_GENERAL_HEALTH = "Test general health";
var TEST_INTERPERSONAL_RELATIONSHIPS = "Test interpersonal relationships";
var TEST_SOCIAL_SKILLS = "Test social skills";
var TEST_WORK_ENVIRONMENT = "Test work environment";
var REHANDREBODY_SERVICE = 'RehBody';

var EVALUATE_HEALTH_TESTS = [TEST_PSYCHOSOCIAL_RISKS, TEST_RYFF_SCALE, TEST_FINDRISK, TEST_ANXIETY_BECK, TEST_CARDIOVASCULAR_RISK, TEST_STRESS, TEST_GENERAL_HEALTH, TEST_SLEEP_QUALITY, TEST_MEDITERRANEAN_DIET, TEST_PHYSICAL_ACTIVITY, TEST_NICOTINE_DEPENDENCY, TEST_INTERPERSONAL_RELATIONSHIPS, TEST_SOCIAL_SKILLS, TEST_WORK_ENVIRONMENT];

var COMPANIES_TESTS = [TEST_PSYCHOSOCIAL_RISKS, TEST_RYFF_SCALE, TEST_WORK_ENVIRONMENT, FREEDOM_AND_FLOW_SERVICE];
var ONLY_360_USERS_TESTS = [TEST_PHYSICAL_ACTIVITY, TEST_STRESS, TEST_INTERPERSONAL_RELATIONSHIPS];

var POSITIVE_IMPACT_TESTS = [TEST_RYFF_SCALE, TEST_MEDITERRANEAN_DIET, TEST_SLEEP_QUALITY, TEST_PHYSICAL_ACTIVITY, TEST_GENERAL_HEALTH, TEST_INTERPERSONAL_RELATIONSHIPS, TEST_SOCIAL_SKILLS, TEST_WORK_ENVIRONMENT];

var NEGATIVE_IMPACT_TESTS = [TEST_FINDRISK, TEST_NICOTINE_DEPENDENCY, TEST_STRESS, TEST_ANXIETY_BECK, TEST_CARDIOVASCULAR_RISK];

var NOT_IN_MX_TESTS = [TEST_MEDITERRANEAN_DIET];

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSelect_vue__ = __webpack_require__(947);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae28b4b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSelect_vue__ = __webpack_require__(1546);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1522)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae28b4b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseSelect.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ae28b4b", Component.options)
  } else {
    hotAPI.reload("data-v-5ae28b4b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);



var client = function client() {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    getPreviousMonthsResults: function getPreviousMonthsResults(id) {
        var patientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var testId = arguments[2];

        return client().get('/patients/SelfEvaluationTest', { params: { userId: id, patientId: patientId, testId: testId } });
    },
    getMenstruations: function getMenstruations() {
        return client().get('/patients/menstruations');
    },
    postMenstruation: function postMenstruation(cycleData) {
        return client().post('/patients/menstruations', cycleData);
    },
    deleteMenstruation: function deleteMenstruation(cycleId) {
        return client().delete('/patients/menstruations/' + cycleId);
    },
    putMenstruation: function putMenstruation(updatedCycleData) {
        return client().put('/patients/menstruations', updatedCycleData);
    },
    fillSelfEvaluationTest: function fillSelfEvaluationTest(form) {
        return client().post('/patients/SelfEvaluationTest', form);
    },
    checkCompletedTestsThisMonth: function checkCompletedTestsThisMonth() {
        var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        return client().get('/patients/SelfEvaluationTest/CheckTestsAlreadyCompletedThisMonth', { params: { patientId: patientId } });
    },
    getAssociatedPatients: function getAssociatedPatients() {
        return client().get('/patients/associated-patients');
    },
    updatePatientPersonalData: function updatePatientPersonalData(fields, userId) {
        return client().put('/PatientPersonalDataController', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'idAspNetUser': userId }, fields));
    },
    GetLastCompletedFromEachTest: function GetLastCompletedFromEachTest(id, patientId) {
        return client().get('/patients/SelfEvaluationTest/GetLastCompletedFromEachTest', { params: { userId: id, patientId: patientId } });
    },
    updatePatient: function updatePatient(updateRequest) {
        return client().put('/patients', updateRequest);
    },
    getAssociatedPatientsForRequest: function getAssociatedPatientsForRequest() {
        return client().get('/patients/associated-patients/GetAssociatedPatientsForRequest');
    },
    getPatientInfo: function getPatientInfo() {
        return client().get('/patients/GetPatientInfo');
    },
    toggleFavouriteDoctor: function toggleFavouriteDoctor(profId) {
        return client().put('/FavouriteProfessionals/ToggleFavourite', null, { params: { profId: profId } });
    }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseAlert_vue__ = __webpack_require__(914);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2a09264_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseAlert_vue__ = __webpack_require__(1386);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1384)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2a09264_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/ui/BaseAlert.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d2a09264", Component.options)
  } else {
    hotAPI.reload("data-v-d2a09264", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseIcon_vue__ = __webpack_require__(1076);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71129cfd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseIcon_vue__ = __webpack_require__(1661);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1659)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71129cfd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/icons/BaseIcon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71129cfd", Component.options)
  } else {
    hotAPI.reload("data-v-71129cfd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = {"companies-contact-form":{"contact-us":"Contact us","subtitle":"If you want your family to access the best digital health services, contact us.","form":{"company":"Company name","name":"Name","surnames":"Last name","employees-number":"No. employees (optional)","phone-number":"Phone number (optional)","province":"Select your province","email":"Email address","disclaimers":{"personal":"{platform} protects and respects your privacy, we will only use your information to manage your account and provide services you requested us to provide.","communications":"I agree to receive other communications from {platform}.<br> In order to provide you with the requested content, we must store and process your data.","privacy":"I accept the <a href='/politica-privacidad'>Privacy Policy.</a>"},"errors":{"required-fields":"Please fill in the fields","required-consent":"Please, before continuing you must agree to receive communications and the privacy policy","required-entity-type":"Please select if you are a professional, company or user","required-entity-ong-type":"Please select if you are a Professional, an NGO, or indicate the type of your entity"},"success":"In a short period of time, the opensalud team will be able to contact you.","website":"Company website","select-single-or-business":"Select if you are an individual or company","entity-type":{"company":"Business","individual":"Private user","health-professional":"Health professional","company-user":"Company user","others":"Others"},"form-reason":"How can we help you? \n(optional)","collegiateNumber":"Province of collegiate","speciality":"Specialty","error-firstname":"Enter your name","errors-lastname":"Enter your Surname","errors-email":"Enter an Email","errors-country":"Enter a country of residence","explain-case":"Description","selectUser":"Select Entity","country":"country of residence","thank-you":"Thank you so much"},"want-more-btn":"I want more information.","signupOH":{"code-provided-by-company-or-entity":"Code indicated by your company or entity"},"service-type":{"digital-health":"digital health"},"subtitle2":"If you are a professional interested in collaborating with the initiative or an NGO, contact us.","companies-contact-form":{"contact-us":"Contact us","form":{"company":"Company","disclaimers":{"communications":"","personal":"{platform} protects and respects your privacy, we will only use your information to manage your account and provide services you have requested from us.","privacy":"I accept the <a href='/politica-privacidad'>Privacy Policy.</a>"},"email":"Email","errors":{"required-consent":"Please, before continuing you must agree to receive communications and the privacy policy","required-entity-ong-type":"Please select if you are a Professional, an NGO, or indicate the type of your entity","required-entity-type":"Please select if you are a person or a company","required-fields":"Please fill in the fields"},"name":"Name","province":"Select your province","success":"In a short period of time, the opensalud team will be able to contact you.","surnames":"Surnames"},"service-type":{"digital-health":"digital health"},"want-more-btn":"I want more information"},"countries":{"spain":"Spain","mexico":"Mexico","portugal":"Portugal","brazil":"Brazil","colombia":"Colombia","italy":"Italy","other":"Others"},"select-entity-type":"Select the type of user..."}}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = {"companies-contact-form":{"subtitle":"Se você deseja que sua família tenha acesso aos melhores serviços digitais de saúde, entre em contato conosco.","form":{"employees-number":"Nº funcionários (opcional)","phone-number":"Número de telefone (opcional)","website":"Site da companhia","entity-type":{"company":"O negócio","individual":"Usuário privado","health-professional":"Profissional de saúde","company-user":"Usuário da empresa","others":"Outros"},"select-single-or-business":"Selecione se você é um indivíduo ou uma empresa","form-reason":"Como podemos te ajudar? \n(opcional)","collegiateNumber":"Província de colegiado","speciality":"Especialidade","error-firstname":"Digite seu nome","errors-lastname":"Digite seu sobrenome","errors-email":"Digite um e-mail","errors-country":"Insira um país de residência","explain-case":"Descrição","selectUser":"Selecionar Entidade","country":"País de residência","thank-you":"Muito obrigado","company":"Nome da empresa","disclaimers":{"communications":"Eu concordo em receber outras comunicações de {platform}.<br> Para fornecer a você o conteúdo solicitado, devemos armazenar e processar seus dados.","personal":"{platform} protege e respeita sua privacidade, usaremos suas informações apenas para gerenciar sua conta e fornecer os serviços que você nos solicitou.","privacy":"Aceito a <a href='/politica-privacidad'>Política de Privacidade.</a>"},"email":"Correio eletrônico","errors":{"required-consent":"Por favor, antes de continuar você deve concordar em receber comunicações e a política de privacidade","required-entity-ong-type":"Selecione se é um Profissional, uma ONG, ou indique o tipo da sua entidade","required-entity-type":"Selecione se você é profissional, empresa ou usuário","required-fields":"Por favor, preencha os campos"},"name":"Nome","province":"Selecione sua província","success":"Em um curto período de tempo, a equipe do opensalud poderá entrar em contato com você.","surnames":"Sobrenomes"},"subtitle2":"Se você é um profissional interessado em colaborar com a iniciativa ou uma ONG, entre em contato conosco.","contact-us":"Contate-nos","service-type":{"digital-health":"saúde digital"},"want-more-btn":"quero mais informações","countries":{"spain":"Espanha","mexico":"México","portugal":"Portugal","brazil":"Brasil","colombia":"Colômbia","italy":"Itália","other":"Outros"},"select-entity-type":"Selecione o tipo de usuário..."},"bodymass":""}

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCheckbox_vue__ = __webpack_require__(966);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e193b65c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCheckbox_vue__ = __webpack_require__(1563);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1561)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e193b65c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseCheckbox.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e193b65c", Component.options)
  } else {
    hotAPI.reload("data-v-e193b65c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTextarea_vue__ = __webpack_require__(964);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a962cc9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTextarea_vue__ = __webpack_require__(1552);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1550)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a962cc9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseTextarea.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a962cc9", Component.options)
  } else {
    hotAPI.reload("data-v-7a962cc9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ES_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MX_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ES_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MX_PREFIX; });
var ES_COUNTRY = 'es';
var MX_COUNTRY = 'mx';
var ES_PREFIX = 34;
var MX_PREFIX = 521;

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToHomeScreen_vue__ = __webpack_require__(1074);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d0a069_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToHomeScreen_vue__ = __webpack_require__(1655);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1653)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToHomeScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d0a069_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToHomeScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/AddToHomeScreen.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48d0a069", Component.options)
  } else {
    hotAPI.reload("data-v-48d0a069", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (valueType) {
  return {
    props: {
      value: valueType
    },
    data: function data() {
      return {
        id: null,
        localValue: null
      };
    },
    mounted: function mounted() {
      this.id = this._uid.toString();
    },
    created: function created() {
      var _this = this;

      this.localValue = this.value;
      this.$watch('value', function (value) {
        _this.localValue = value;
      });
      this.$watch('localValue', function (value) {
        _this.$emit('input', value);
        _this.$emit('change', value);
      });
    }
  };
});

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = {"professional-conditions":"Conditions for professionals","patient-conditions":"Conditions for patients","companies-telemedicine":"Health and well-being for companies","contact":"Contact","legal-notice":"Legal notice","faqs":"Frequently asked questions","all-rights":"All rights reserved.","lawyer-conditions":"Conditions for lawyers","client-conditions":"Conditions for clients","cookies-policy":"Cookies policy","privacy-policy":"Patient privacy policy","privacy-policy-professional":"Professional privacy policy","sgsi-policy":"SGSI Policy"}

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = firstLetterUppercase;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkIgnoringNonRelevantCharactersFromOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkIgnoringNonRelevantCharacters;
function firstLetterUppercase(s) {
	return s.charAt(0).toUpperCase() + s.slice(1);
}

function checkIgnoringNonRelevantCharactersFromOptionLabel(option, query) {
	return checkIgnoringNonRelevantCharacters(option, query, 'label');
}

function checkIgnoringNonRelevantCharacters(option, query, prop) {
	var baseProp = prop ? option[prop] : option;
	return baseProp.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = {"clinichistory":"Medical history","weight":"Weight","kg":"kg","kg-ph":"Weight in kg","save-btn":"Save","cancel-btn":"Cancel","height":"Height","height-ph":"Height in cm","temperature-ph":"Temperature in °C","cm":"cm","cm-ph":"Height in cm","age":"Age","habits":"Habits","selectoptions-ph":"Select one or more options","presure":"Blood pressure","mmhg":"mmHg","systolic":"Systolic","diastolic":"Diastolic","hdl-cholesterol":"HDL cholesterol","mgdl":"mg/dL","hdl":"HDL Cholesterol","ldl-cholesterol":"LDL cholesterol","ldl":"LDL Cholesterol","cholesterol":"Cholesterol","glucose":"Glucose","glucoselevel":"Glucose level","triglycerides":"Triglycerides","blood":"Blood group","select-ph":"Select","bodymass":"Body mass index","waist":"Waist","waist-ph":"Waist in cm","hip":"Hip","hip-ph":"Hip in cm","heartRate":"Heart rate","bpm":"ppm","breathingFrequency":"Respiratory rate","rpm":"rpm","oxygenSaturation":"Oxygen saturation","measureUnits":{"weight":"kg","height":"cm","age":"years","temperature":"ºC","presure":"mmHg","hdl":"mg/dl","ldl":"mg/dl","cholesterol":"mg/dl","glucose":"mg/dl","triglycerides":"mg/dl","hip":"cm","waist":"cm","heartRate":"bpm","breathingFrequency":"rpm","oxygenSaturation":"%","fatMass":"kg","fatFreeMass":"kg","vitaminD":"UI","calories":"kcal"},"adddeletevariables":"Add/Remove Variables","hide-btn":"Hide","healthvariables":"Health variables","othervariables":"Other health variables","healthcondition":"Health condition","feeding":"Nutrition","sleep":"Sleep","exercise":"Exercise","stress":"Stress level","telemonitorization":"Telemonitoring and external applications","noservices":"You have not added any services yet.","go-btn":"Go","delete-btn":"Delete","selectservice":"Select the service you want to add:","servicesoon":"This service will be available soon","accept-btn":"Confirm","observations":"Observations","edit-btn":"Edit","experiences":"Significant events and experiences","authorizedpeople":"Authorised persons","createauthorizedpeople":"Create authorised person","show-btn":"Show","diseases":"Diseases","diseases-ph":"Enter the name of the illness or disease","diseasedate-ph":"Date (MM/dd/yyyy) (optional)","allergies":"Allergies","allergy-ph":"Enter the name of the allergy","gravity-ph":"Severity","medication":"Medication","medication-ph":"Enter the name of the medicine","currentmedication":"I am currently taking the medicine","medicationstart-ph":"Start (MM/dd/yyyy) (optional)","medicationend-ph":"End (MM/dd/yyyy) (optional)","vaccines":"Vaccines","vaccine-ph":"Enter the name of the vaccine","familyhistory":"Family history","familyhistory-ph":"Enter the history","relationship":"Kinship","genogram":"Genogram","selectimage":"Select an image:","seegenogram":"View genogram","hidegenogram":"Hide genogram","clinicdocuments":"Clinical documents and forms","recommendedApps":"Applications and information of interest","filterdocuments":"Filter by document type","filterapps":"Filter by application type","addfile":"Attach files/documents","addfile-ph":"Add file/documents","addapp-ph":"Add application/information of interest","appointments":"Consultations","years-text":"years","nointroduced":"Not entered","name-column":"Name","surname-column":"Surname","dni-column":"ID number","email-column":"Email address","relationship-column":"Kinship","phone-column":"Telephone","description-column":"Description","date-column":"Date","gravity-column":"Severity","start-column":"Home","end-column":"End","notmedicines":"I am not currently taking the medicine","title18chtvaccine":"Vaccine","code-column":"Code","filetype-column":"File type","uploadedby-column":"Uploaded by","see-btn":"View","download-btn":"Download","disease-del":"The illness or disease has been removed from your medical history","link-del":"The useful link has been removed from your medical history","doc-del":"The document has been removed from your medical history","allergy-del":"The allergy has been removed from your medical history","drug-del":"The medicine has been removed from your medical history","vaccine-del":"The vaccine has been removed from your medical history","familyhistory-del":"The family history has been removed from your medical history","drug-del-error":"An error has occurred while deleting your medicine","nodisease":"Does not suffer from any illness or disease","noallergy":"Does not suffer from any allergies","nolinks":"Does not have any useful link","nodrug":"You have not added any medicine yet","novaccine":"You have not added any vaccines yet","nofamilyhistory":"No family history","successchanges":"Changes have been successfully made","health-qst":"How is your health?","stress-qst":"Currently, you would say that your stress level is...","feeding-qst":"How did you eat this week?","sleep-qst":"How did you sleep?","exercise-qst":"Have you done any physical exercise?","history":"History","savesuccesshistory":"Your observations have been saved correctly","savedanger":"An error has occurred. Please try again later.","savesuccesshabits":"Your healthy habits have been kept correctly.","valuenumericerror":"Please enter a value between 1 and 10","actualdata":"The information has been updated correctly","errordata":"Error updating the information. Please try again later.","documentspatient":"Patient Files","dataopensalud":"Opensalud Report","Name":"Name","HabitsTypes":"Types of Habits","BloodTypes":"Blood Groups","selectarchive":"Select a file","selectarchive2":"Select or drag a file here to upload","savedarchive":"Your file has been saved. <br> You can delete it at any time under 'My health information' > 'Clinical documents'","owarchive":"Your file has been overwrited successfully","selectimage-js":"Select an image","selectimage2":"Select or drag an image here to upload","savesuccess":"Saved successfully.","errorhistory":"Error requesting medical history. Please try again later.","healthcondition-min":"Really bad","healthcondition-max":"Perfect!","stress-min":"None","stress-max":"A lot","feeding-min":"Very bad","feeding-max":"Very good","sleep-min":"Very bad","sleep-max":"Excellent","exercise-min":"Nothing","exercise-max":"Too much!","activeservice":"You have already enabled the service of ","errorservice":"An error has occurred. Please try again later.","serviceof":"The service of ","beendeleted":" has been deleted.","serviceerrordelete":"The service could not be deleted. Please try again later.","diseaseselecterror":"You must select an illness or disease.","dangerdisease":"You cannot assign an already added illness or disease","mustdeleteallergies":"You must erase the recorded allergies","selectallergy":"You must select an allergy","selectseverity":"You must select a severity for the allergy.","notassignedallergy":"You cannot assign an already added allergy.","selectdrug":"You must select a medicine","dateinfodrugs":"Please specify the date you stopped taking the medicine or check the box ‘I am currently taking the medicine’ if you are taking the medicine.","notassigneddrug":"You cannot assign an already added medicine.","selectvaccine":"You must select a vaccine.","selectdisease":"You must select an illness or disease","selectrelationship":"You must select a kinship:","norepeatdisease":"You cannot repeat an illness or disease for the same kinship.","disease-column":"Symptom/Illness","speciality-column":"Specialty","appointmenttype-column":"Type of consultation","seeappointment-btn":"View consultation","appointmentsHistory":"Appointments history","invalidDate":"You must enter a valid date","addReminderMedication":"Do you want to add a reminder for the medication?","yes":"Yes","no":"No","visit":"Visit","fromURLComplete":"If this document is not yet marked as complete, an email will be sent to the practitioner who created the document notifying him/her of this action.<br><br> Do you wish to continue?","completeSuccess":"Operation successful","fromFileComplete1":"You will then need to upload a file, previously downloaded and filled in, which will replace the previous one.<br><br> The practitioner will be notified that you have filled in this document if it is not already marked as such.<br>","fromFileComplete2":"Do you want to overwrite the previously mentioned file?","clearUpload":"Clean","speciality":"Speciality","filterSpe":"Filter by specialty","fillStartDate":"Please enter a start date","fillEndDate":"Please enter an end date","selectReminderInterval":"Enter the reminder interval","selectReminderFrequency":"Enter the frequency of the reminder","introduceCorrectDates":"Enter a correct time interval","reminderSuccess":"Your reminder has been created successfully","reminderDeleteSuccess":"Your reminder has been deleted successfully","reminderDeleteSure":"Your reminder has been deleted successfully","datePlaceholder":"mm/dd/yyyy","unlockFilesQuestion":"Are you sure you want to unlock this file? <br><br> If you unlock this file, it can be viewed by all professionals / centers with whom you interact.","unlockFilesAnswer":"The file has been successfully unlocked","lockFilesQuestion":"Are you sure you want to lock this file? <br><br> If you block this file, it can only be viewed by you and by the professional / center that generated the document, if it is the case.","lockFilesAnswer":"The file has been locked successfully","accept":"Accept","fileIsLocked":"The patient has locked the file","alarms":"Alarms","alarms.info":"Enabling the alarms for the health variables of this patient, a whatsapp and an email every time the patient takes a measure outside the established limits.","alarms.enable.success":"Alarms have been activated for all health variables","alarms.disable.success":"Alarms have been disabled for all health variables","temperature":"Temperature","fatMass":"Fat mass","fatMass-ph":"Fat mass (Kg)","fatFreeMass":"Fat-free dough","fatFreeMass-ph":"Fat-free dough Kg","homa":"Homa","homa-ph":"Homa","vitaminD":"Vitamine D","vitaminD-ph":"Vitamine D in IU","steps":"Steps","steps-ph":"Steps","calories":"Calories","calories-ph":"Calories in Kcal","mood":"Mood","confirm-save-slider":"Are you sure you want to save the changes?","additional-health-variables":"Other health variables","appointment-history":{"not-found":"No appointments found"},"observations-ph":"Type here...","bmi":"body mass index","signupDiscovery":{"title1":"Professional recommendation"},"terms-and-conditions-professional":"Professional terms and conditions","medallergies":"Allergies to medications","chrondiseases":"Chronic diseases","dateStart":"Start date","dateEnd":"End date","nofiles":"You have not added clinical documents","healthyVars":"Health variables","feedingHabits":"Eating habits","moodAndHabits":"Habits and mood","historyAndDiseases":"History and illnesses","medicalEvaluation":"Medical evaluation","historyAndDiseasesReduced":"History/Illnesses","dontKnow":"Don't know","mustFillAllData":"Fill out the form data. \nIf you do not know the value, click on \"I don't know\" or \"None of the above\"","dontKnowOrDontAnswer":"I don't know/Do not answer","quizDialog":{"completeMedicalEvaluation":"You are about to complete your basic health profile. \nAdd some values ​​from your last review to get the most out of opensalud.<br><br>Do you want to fill in this information?"},"completeYourHealthProfile":"Complete your health profile","fillQuizAdvice":"This information will make it easier for you to care for and improve the care received when you need it, inside or outside of opensalud.","remindLater":"Remember later","clinicHistory":"Clinic history","clinicDocuments":"Clinical documents","applicationsAndInformationOfInterest":"Applications and information of interest","bloodMonitor":"Monitor blood pressure","glycemiaMonitor":"Monitor blood glucose","otherMoment":"At another time","searchOrSelectOptions":"Search or select one or more options","pressEnterToSelect":"Press enter to select","pressEnterToRemove":"Press enter to deselect","selected":"Selected","healthyHabits":"My goals and challenges","watch":"See","significantEventsAndExperiences":"Significant events and experiences","file-type-column":"File type","selectOneOption":"Select an option","clinic-history":{"wellbeing-score":"Wellbeing score","concede-access":"Grant access to my medical history","professionals-and-centers-authorizated":"Professionals and authorized centers","select-patient":"Select a patient","select-pet":"Select a pet","select-prof-center":"select a professional/center","back-history":"Back to my story","grant-access":"Grant history access","access-authorizated":"Authorized access","already-saved-today-variable":"You have already saved data today in this variable. \nCome back tomorrow to enter them again.","in-last-7-days":"In the last 7 days...","selectPet":"Select pet"},"currentlyTakeMed":"I am currently taking medication","selectStartDate":"Select start date","selectEndDate":"Select end date","currentlyNoTakeMed":"I am not currently taking the medication.","medicationSelectError":"You must select a medication","medicationEndDateMinorStartDate":"The end date of the medication cannot be less than the start date","allergySelectError":"You must select an allergy","allergySeveritySelectError":"You must select the severity of the allergy","vaccineSelectError":"You must select a vaccine","familyHistorySelectError":"You must select a background","relationshipSelectError":"You must select a relationship","noMedAllergies":"I have no allergies to medications","applicationsAndInformationOfInterestReduced":"Appli./info interest","document":{"url":"URL (http://...)","uploadFromThisDevice":"Upload from this device","insertLink":"Enter a URL (Link)"},"link":{"nameError":"You must enter a name for the link","linkError":"You must enter a valid url"},"filterByType":"Filter by type","revokeAccess":"Revoke access","revokeAccessClinic":{"error":"Error performing the revocation. \nTry again","owner":"You cannot revoke access to whoever created your user","withAppointment":"You cannot revoke access to a professional with whom you have had an appointment","center":"You cannot revoke access to the center of a professional with whom you have agreed to share your history with their partner centers","success":"Revocation completed successfully"},"grantAccessClinicHistory":"Grant access to my medical history","historyGrantAccessText":"You can share your medical history with a professional/center on the platform or generate a read-only link to share with whoever you decide.","shareInternally":"Share internally","generateLink":"Generate link","grantAccessSelectProfOrCenter":"You must select a professional or center","historyShare":"Share","validityInDays":"Validity in days","sharelinkError":{"days":"You must enter a validity of 1 to 30 days","emails":"You must enter at least 1 email","wrongEmail":"You must correct the following emails:","validity":"You must enter a validity between 1 and 180 days"},"linkSendedSuccessfully":"Link sent successfully","later":"Later","significantEventsAndExperiencesReduce":"Signi. and expe. significant","vaccine-commercial-name":"Trade name (optional)","dateBeforeNowError":"The selected date must be less than the current date","commercial-name-column":"Tradename","completedQuiz":"filled","completedHistory":"Filled","history-files-overwrite-content":"You will then upload a file, previously downloaded and completed, which will replace the previous one.<br><br>The professional will be notified that they have completed this document if it is not already marked as such.","history-files-overwrite-question":"Do you want to overwrite the file in question?","mark-as-complete-text":"If you mark this document as completed, an email will be sent to the professional who created it notifying them of this action.<br><br>Do you want to continue?","lock-file-advice":"Are you sure you want to lock this file? \n<br><br> If you block this file, it can only be viewed by you and by the professional/center that generated said document, if applicable.","unlock-file-advice":"Are you sure you want to unlock this file? \n<br><br> If you unlock this file it can be viewed by all the professionals/centers with which you interact.","wantAddReminderMed":"Do you want to add a reminder for your medication?","medicationReminder":"Medication reminder","reminderMedicationForm":{"alias":"Aliases for the medication","aliasInput":"Enter a short name to identify the medication in the phonebook","startDate":"Start date","endDate":"End date","color":"Color for agenda space","interval":"Reminder interval","selectInterval":"Select an interval","hour":"Select a time","reminderEach":"Remember every...","repeatEach":"Repeat each","error":{"alias":"You must enter an alias for the medication","endDate":"You must enter the end date for the reminder","dateBefore":"The start date must be greater than the current date","color":"You must select a color for the agenda space","startGreater":"The end date must be greater than the start date","startGreaterThanNow":"The end date of the reminder must be greater than the current date","medicine":"You must select a medication","interval":"You must select a repeat interval greater than 1 day/week","tabletsLessThan1":"You must introduce a number of units greater than or equal to 1","tabletsFromHour":"You must select the start time of the medication","tabletsToHour":"You must select the end time of the medication","frequencyOption":"You must select the frequency of taking the medication","intakesDay":"You must select at least 2 shots a day","weekDays":"You must select at least 1 day of the week","cylicStartDate":"You must select the cycle start date","notifications":"You must select at least one means for notifications","tabletsReminder":"Tomas per packaging of the stock reminder should be less than the packaging limit","tabletsReminderFill":"You must enter a valid number of shots by containers for the replacement reminder"},"option":"Select an option","sucess":"Reminder created successfully","frequencyTitle":"How often do you take this medication?","frequency":{"interval":"Interval","severalTimesDay":"Several times a day","weekDays":"days of the week","cyclic":"Cyclic"},"tablets":"Units","fromHour":"From","toHour":"Until","selectWeekDays":"Select the days:","tabletsDay":"intakes a day","pause":"pause","intakes":"Tomas","pauses":"pauses","hourTitle":"Hour","intakesPerContainer":"intakes per container","reminder":"Reminder","reminderFillQuestion":"Receive reminder to refill stock?","reminderMedicineTitle":"shots per container, remember when they are missing","notificationsQuestion":"Select where you will receive notifications:","units":"units","startHour":"Start time","endHour":"End time"},"theDay":"The day","other":"Other...","weeks":"weeks","maximum":"Maximum","minimum":"Minimum","file":{"select":"You must select a file"},"noEvaluationTests":"There are no tests completed by the patient","relvantsExperiences":"Relevant events","healthProfile":"Health profile","removeReminder":"Delete reminder","removeMedication":"Remove medication","seeReminder":"See reminder","createReminder":"Create reminder","options":"Options","canNotAccessReadOnly":"You cannot access this section in read-only mode","documentsAndInformation":"Documents and information","healthData":"Health variables","healthQuiz":"Health questionnaire","reason-column":"Reason","pastMedication":"Past medication","currentMedication":"Current Medication","noPastDrug":"No past medications","addOrDeleteHealthvar":"Add/remove variables","otherAllergies":"Other allergies","locked":"locked","unlocked":"Unlocked","pets":"Pets","clinic-history-variable-slider":{"stress":{"min":"Very high","max":"Zero stress!"},"feeding":{"min":"Very unhealthy","max":"Super healthy!"},"sleep":{"min":"really bad","max":"Perfectly!"},"exercise":{"min":"Nothing","max":"Too much!"},"healthcondition":{"min":"Really bad","max":"Perfectly!"},"healthconditiontoday":{"min":"Really bad","max":"Perfectly!"}},"howDoYouFeel":"Your habits in the last week","healthMonitoring":"Health Tracking","reminderFrequency":"Reminder frequency","noDataProfAndCenterAuthorized":"Has not yet granted access to professionals or centers","shareHistoryAccessLinkPlaceholder":"Enter recipients' emails (not including your own) separated by line breaks, commas, blank spaces, or semi-colons","noneOfTheAbove":"None of the above","mustFillQuizPressureData":"If you enter systolic or diastolic blood pressure, you must complete both fields in the questionnaire","presureVarSaveError":"You must enter the blood pressure in the format: Systolic/Diastolic","isNanError":"You must enter a valid number","bloodPressureReduced":"Sys/Dia","healthconditiontoday":"How do you feel today?","shareLinkValidity":"Enter a value between 1 and 180 days","reportOrPrescripcion":"Recipe/Prescription","menstrual-calendar":"Menstrual calendar","fileLockedByPatient":"The patient has locked the file","menstrualCycle":"Cycle control","cycleStartDate":"CYCLE START DATE","periodDuration":"Duration of period (days):","cycleDuration":"Cycle length (days):","addCycle":"Add cycle","historyCycle":"Cycle history","cycleDuration2":"Cycle duration","periodDuration2":"Period length","ovulationDuration":"Ovulation days","cycle":"Cycle","delete":"Delete","cycleControl":"Cycle control","noControl":"No cycles recorded","startCycle":"start cycle","setPeriodDuration":"Set period duration","current":"IN PROGRESS since","confirmEndCurrentCycle":"Do you want to end the current cycle?","until":"until","add-txt":"Add","mustSetPeriod":"You must set the current cycle period before you can add a new one.","error-cycles-get":"Cycles could not be obtained. \nPlease try again later","error-cycles-delete":"No se pudo eliminar el ciclo. Por favor, inténtelo de nuevo más tarde","error-cycles-set":"The length of the period could not be established. \nPlease try again later","error-cycles-start":"Could not start cycle. \nPlease try again later","error-cycles-set2":"The current cycle could not be updated. \nPlease try again later","ovulationDurationPrediction":"Ovulation day prediction","new-cycle":"New cycle","newCyclePredictionDate":"Next cycle start prediction","enterMedicineName":"Enter the name of the medication","addNewMedicationReminder":"Add reminder","tabletsLeft":"Remaining units","medicationReminderEachXTime":"Every {time} {interval}","timesToDay":"times a day","confirmRemoveMedicationReminder":"Do you want to erase this reminder?","resetTabletsReminder":"Reset units","editMedicationReminder":"Edit medicine reminder"}

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_app_helpers__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_ui_helpers__ = __webpack_require__(162);












/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__helpers_app_helpers__["a" /* default */], {
  uploadFile: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(path, params, file, ctx) {
      var toBase64, promise;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (file instanceof Array) {
                file = file[0];
              }

              toBase64 = function toBase64(file) {
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = function () {
                    var encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                    if (encoded.length % 4 > 0) {
                      encoded += '='.repeat(4 - encoded.length % 4);
                    }
                    resolve(encoded);
                  };
                  reader.onerror = function (error) {
                    return reject(error);
                  };
                });
              };

              _context.t0 = ctx.$api;
              _context.t1 = path;
              _context.t2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default.a;
              _context.t3 = {};
              _context.t4 = params;
              _context.t5 = __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$apiToken;
              _context.next = 10;
              return toBase64(file);

            case 10:
              _context.t6 = _context.sent;
              _context.t7 = file.name;
              _context.t8 = file.type;
              _context.t9 = {
                base64: _context.t6,
                name: _context.t7,
                contentType: _context.t8
              };
              _context.t10 = {
                token: _context.t5,
                file: _context.t9
              };
              _context.t11 = (0, _context.t2)(_context.t3, _context.t4, _context.t10);
              promise = _context.t0.post.call(_context.t0, _context.t1, _context.t11);
              return _context.abrupt('return', promise);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function uploadFile(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    }

    return uploadFile;
  }(),
  openSupportChat: function openSupportChat() {
    var dimensions = {
      height: __WEBPACK_IMPORTED_MODULE_10__helpers_ui_helpers__["e" /* isMobile */] ? window.innerHeight : 700,
      width: __WEBPACK_IMPORTED_MODULE_10__helpers_ui_helpers__["e" /* isMobile */] ? window.innerHeight : 400
    };
    window.open('https://widget-page.smartsupp.com/widget/2208bb3618a649a6e2e120bf7daf45d0e18594af', 'supportChat', 'resizable,height=' + dimensions.height + ',width=' + dimensions.width + ',screenX=0,screenY=0');
    return false;
  },
  buildFaviconsAndTheme: function buildFaviconsAndTheme(appName) {
    var mediaLightTheme = '(prefers-color-scheme: light)';
    var mediaDarkTheme = '(prefers-color-scheme: dark)';
    return {
      link: [{ rel: 'apple-touch-icon', sizes: '180x180', href: '/static-appopensalud/img/favicons/' + appName + '/apple-touch-icon.png', media: mediaLightTheme }, { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/static-appopensalud/img/favicons/' + appName + '/favicon-32x32.png', media: mediaLightTheme }, { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/static-appopensalud/img/favicons/' + appName + '/favicon-16x16.png', media: mediaLightTheme }, { rel: 'manifest', href: '/static-appopensalud/img/favicons/' + appName + '/site.webmanifest', media: mediaLightTheme }, { rel: 'mask-icon', href: '/static-appopensalud/img/favicons/' + appName + '/safari-pinned-tab.svg', color: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["m" /* WHITE_COLOUR */], media: mediaLightTheme }, { rel: 'apple-touch-icon', sizes: '180x180', href: '/static-appopensalud/img/favicons/' + appName + '/dark-theme/apple-touch-icon.png', media: mediaDarkTheme }, { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/static-appopensalud/img/favicons/' + appName + '/dark-theme/favicon-32x32.png', media: mediaDarkTheme }, { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/static-appopensalud/img/favicons/' + appName + '/dark-theme/favicon-16x16.png', media: mediaDarkTheme }, { rel: 'manifest', href: '/static-appopensalud/img/favicons/' + appName + '/dark-theme/site.webmanifest', media: mediaDarkTheme }, { rel: 'mask-icon', href: '/static-appopensalud/img/favicons/' + appName + '/dark-theme/safari-pinned-tab.svg', color: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["c" /* BLUE_COLOUR */], media: mediaDarkTheme }],
      meta: [{ name: 'msapplication-TileImage', content: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["c" /* BLUE_COLOUR */] }, { name: 'theme-color', content: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["c" /* BLUE_COLOUR */] }]
    };
  },
  getMetaTitleText: function getMetaTitleText(route) {
    if (route.meta && route.meta.title && route.meta.title.text) {
      if (route.meta.title.text instanceof Function) {
        return route.meta.title.text();
      } else {
        return __WEBPACK_IMPORTED_MODULE_5__plugins_i18n__["a" /* default */].t(route.meta.title.text);
      }
    }
  },
  buildMetaInfo: function buildMetaInfo(_ref2) {
    var appName = _ref2.appName,
        _ref2$appTagLine = _ref2.appTagLine,
        appTagLine = _ref2$appTagLine === undefined ? 'Opensalud' : _ref2$appTagLine;

    var $route = __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].history.current;
    appTagLine = !appTagLine ? '' : ' | ' + ($route.meta.tagLine || Object(__WEBPACK_IMPORTED_MODULE_8__constants_platformNames__["h" /* getPlatformName */])());
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
      title: '' + ($route.meta && $route.meta.title && ($route.meta.title.htmlTitle || $route.meta.title.text) ? '' + ($route.meta.title.htmlTitle || this.getMetaTitleText($route)) : '') + appTagLine
    }, this.buildFaviconsAndTheme(appName));
  },
  getUrlFromAxiosInstance: function getUrlFromAxiosInstance(axiosInstance, path) {
    return axiosInstance.defaults.baseURL + '/' + path;
  },
  goToSection: function goToSection(section) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$scrollTo('#' + section, duration, {
      container: 'body',
      easing: 'ease-in',
      lazy: false,
      force: true,
      cancelable: true,
      onStart: function onStart(element) {
        // scrolling started
      },
      onDone: function onDone(element) {
        // scrolling is done
      },
      onCancel: function onCancel() {
        // scrolling has been interrupted
      },

      x: false,
      y: true
    });
  },
  getFirstLevelDomain: function getFirstLevelDomain() {
    var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var domainParts = (domain || window.location.hostname).split('.');
    if (domainParts.length < 2) {
      return domainParts[0];
    }
    return '.' + domainParts.slice(domainParts.length - 2, domainParts.length).join('.');
  },
  goBack: function goBack() {
    __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].back();
  },
  getBase64: function getBase64(file) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        return resolve(reader.result);
      };
      reader.onerror = function (error) {
        return reject(error);
      };
    });
  },
  generateGuid: function generateGuid() {
    var S4 = function S4() {
      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    };
    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
  },
  isMobileBrowser: function isMobileBrowser() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  },
  randomUid: function randomUid() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  },
  inIframe: function inIframe() {
    return window.location !== window.parent.location;
  }
}));

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"More info","learn-more-btn":"Learn more","upper-header-subtitle":"It promotes the ability to concentrate, fights stress, anxiety, increases self-esteem, improves sleep quality and much more.","header-title":"Meditation classes and sessions, yoga mindfulness, pilates and sleep","subtitle-list-1":"Unlimited online medical assistance, with free choice of family doctor and pediatrician.","subtitle-list-2":"In addition, face-to-face consultations, tests, interventions and treatments at a discounted price.","hire-now-with-price":"Hire now for 12,95 Euros/month 2 adults + 2 children","price-cards":{"title":"Online consultations included","subtitle":"With no additional cost the best specialists 7 days a week.","content":"The best clinical services from more than 25,000 professionals and centers, at a very low price.","subcontent":"Online gym, meditation, health platform and much more.","monthly":"Monthly**","per-family":"per family*","hire":"Hire","family-label":"*Family: Spouse/partner and minor children.","monthly-label":"**Minimum stay commitment of 3 months.","medic-services-discount":"Discount on medical services","wellness-services":"Wellness services","medic-services":"Medical services","tooth-services":"Dental services","pediatry-services":"Pediatric services","dermatology-services":"Dermatology services","traumatology-services":"Traumatology services","endocrinology-services":"Endocrinology services","soon":"Soon","table":{"online-family-medic":"online family doctor","wellness":"Wellness and health platform","title1":"The most complete plan with all our specialties","title2":"The peace of mind of having a general practitioner and a pediatrician available 7 days a week","title3":"Enjoy private clinical services with discounts and access to our health and wellness platform","service-discounts":"Discounts on private medical services","subtitle":"We have plans tailored to all family needs","header":"most popular option","online-dermatology":"Online dermatology","online-endocrinology":"Online endocrinology","online-pediatrics":"Online pediatrics","online-traumatology":"Online traumatology","per-month":"per month*","title":"Our plans"},"family":"Family: Spouse/partner and minor children","permanency":"Commitment of permanence of 3 months"},"hire-now":"hire now","cards":{"1":{"title":"The best","subtitle":"Take care of your health and that of your loved ones with the best doctors and the best technology available"},"2":{"title":"Price to suit you","subtitle":"Accessible plans with the highest quality and peace of mind in our telemedicine services"},"3":{"title":"medical chart","subtitle":"You will have an extensive list of specialists, clinics and medical centers to ensure the best medical care"},"title":"Online consultation with the best professionals in general medicine and pediatrics"},"medical-assistance":{"title":"Online medical assistance","subtitle":"Included free of charge with free choice of family doctor and paediatrics, available 7 days a week.","content":"Included two adults and two children with unlimited consultations every day of the year.","available-consultations":"Available consultation types:","video":"Video consultation","phone-attention":"Phone consultation","written-consultation":"Written consultation","chat":"Chat","electronic-prescription":"Electronic prescription","safe-coms":"The security of communications and data privacy are our priority."},"wellness":{"title":"Health and Wellness Programs","subtitle":"With daily live and deferred classes of mindfulness, pilates, yoga, health programs, workshops, nutrition and much more.","mindfulness":"Mindfulness","pilates":"Pilates","healthy-back":"Healthy back","cardio":"Online Gym","nutrition":"Nutrition","vitality":"Vitality Pills"},"discounts":{"title":"Discounts on private clinical services","subtitle":"If you need proof and don't want to wait<br /><br />Access to the largest list of health services in Spain with more than 25,000 professionals and centers with discounts of up to 60% in consultations, interventions, tests, treatments, products and health services:","clinic-services":"Clinical services","clinic-services-description":"Allows access to doctors and medical centers that make up the Medical List of the 'AVANTSALUD' Service:","close":"Close","teeth-services-description":"This service includes certain free dental services and access to a List of Doctors at a scaled price. The free dental services are:","health-services-description":"Includes certain services related to well-being and health in specialties not usually included in health insurance, such as:","medical-services-list":"Primary medicine consultations (general medicine and paediatrics)<br> Specialist consultations<br> Diagnostic doctors<br> Medical treatments<br> Hospitalization and surgical interventions<br> Medical services<br> Allergology<br> Pathological anatomy<br> Angiology and vascular surgery<br> Digestive system<br> Cardiology<br> Cardiovascular surgery<br> General surgery and Digestive system<br> Breast surgery<br> Maxillofacial surgery<br> Surgery Oncology<br> Pediatric surgery<br> Plastic and reconstructive surgery<br> Thoracic surgery<br> Vascular surgery<br> Dermatology and venereology<br> Endocrinology and nutrition<br> Nursing<br> Hematology and hemotherapy<br> Nephrology<br> Pneumology<br> Neurosurgery<br> Clinical neurophysiology<br> Neurology<br> Obstetrics and gynecology<br> Ophthalmology<br> Medical oncology<br> Radiation oncology<br> Otorhinolaryngology<br> Rehabilitation<br> Rheumatology<br> Traumatology and Orthopedics<br> Urology<br> General Medicine General<br> Paediatrics<br> Paediatrics-Childcare<br> Clinics and Hospitals<br> Polyclinics<br> Perimetry<br> Panoramic/Orthopantomography<br> Ultrasounds<br> Mammograms<br> CAT scan<br> Clinical analysis<br> Diagnostic Imaging<br> Nuclear Medicine","teeth-services-list":"First visit and budget delivery<br> Review visit<br> Oral education<br> Teaching brushing techniques<br> Fluoridation<br> Annual mouth cleaning. Tartrectomy<br> Dental X-rays (periapical, wing, occlusal)<br> Diagnosis and probing<br> Occlusal adjustments<br> Remove stitches<br> Implantology study<br> False titanium stump<br> Healing and cementation screw<br>","health-services-list":"Acupuncture/Homeopathy/Naturopathy<br> Avantsalud in shape<br> Spas<br> Recognition centers<br> Laser ophthalmologic refractive surgery<br> Bobath Concept<br> Stem Cell Conservation- Cordon<br> Digital Dermatoscopy<br> Dietetics<br> 3D and 4D ultrasounds<br> Aesthetics<br> Physiotherapy and child physiotherapy<br> Colon hydrotherapy<br> Preventive Medicine and Genetic Testing<br> Optics and Hearing Aids<br> Orthopedics<br> Osteopathy<br> Plans with children<br> Podiatry and Footprint study<br> Home care services (postpartum care)<br> Minimally invasive procedures<br> Psychology, pedagogy and logophoniatry<br> Chiropractic <br> Cardiac rehabilitation<br> Animal-assisted therapy<br> Smoking cessation treatments<br> Infertility treatments<br> Shock wave treatment (erectile dysfunction)<br> Veterinarians<br> Laser myopia, astigmatism, hyperopia<br> Podiatry at home<br> Analytics at home<br> Physiotherapy at home<br> Prevention of cervical cancer/HPV<br> Cardiological genetic test<br> Screening for colon cancer in blood<br> Genetic test for obesity<br> Genetic test for lung cancer<br> Oncological check-up <br> Alzheimer's genetic test<br> Thromboembolism genetic test<br> Type II Diabetes genetic test<br> Breast cancer genetic test<br> Non-invasive prenatal test<br> Preeclampsia<br> Paternity test<br> Genetic fingerprint <br> Food intolerance test<br> Macular degeneration test<br> Fetal sex in maternal blood<br> Melissa test<br> Migraine test<br> Lactose - fructose intolerance test<br> Gastric balloon<br> Capsule endoscopic<br> Prostate green laser<br> Laser in dermatology<br> Vascular laser/endolaser<br> Percutaneous foot surgery<br> No-scalpel vasectomy<br> Blepharoplasty<br> Abdominoplasty<br> Rhinoplasty<br> Lifting <br> Capillary micrografts<br> Augmentation mammoplasty<br> Reduction mammoplasty<br> Intimate surgery<br> Liposuction<br>"},"subtitle-list-3":"Premium access to private health services.","hire-now-with-price-2":"Hire for 2.95 euros/month\n\n\nwithout permanence","healthappyrest":{"title":"Add mental health, happiness and rest to your life","psico":"Masterclass in psychology, mindfulness and sleep programs","yoga":"Yoga and Pilates classes","relax":"Relaxing audios, tips and curiosities","premium":"Premium access to private health services"},"buy-btn":"MORE INFO","familiar":{"title":"FAMILIAR","text":"3 months stay","subtitle":"Online medical and pediatric consultations for two adults and two children","subtitle1":"Comprehensive health and wellness platform","subtitle2":"Premium access to private health services"},"healthmind":{"title":"HEALTH & WELLNESS","pricing":"€2.95","text":"without permanence","subtitle":"Comprehensive health and wellness platform","subtitle1":"Premium access to private health services"},"pricing":{"title":"Our plans"},"video-corporative":"video we do","hire-now-with-price-2-2":"Hire for 2.95 euros/month\n\n\nwithout permanence","upper-header-thirdtitle":"You will also be able to access the largest range of private health and wellness services, including face-to-face therapies, psychologists, with significant discounts.","carementalhealth":{"title":"Start taking care of your mental health","yoga":"Yoga and meditation","mindfulness":"Mindfulness program","dream":"Sleep and relaxation audios","pilates":"Pilates","yogatext":"Feeling good starts with knowing yourself.","mindfulnesstext":"Learn to be present in the <<here and now>>.","dreamtext":"Reduce stress and anxiety to find calm.","pilatestext":"Enjoy unlimited access to the practice and benefits of Pilates..."},"menttum":{"title":"Meet our psychologists","subtitle":"The mental and emotional well-being that you deserve in the hands of experts.","subtitle2":"If you need online therapy, access our psychologists in Menttum. \nYour online sessions at any time and from anywhere."},"discounts-mindfulness":{"title":"Premium access to private health and wellness services","subtitle":"No waiting lists. \nBook a trial and don't wait.","subtitle2":"<b>Discounts</b> of up to 60% in more than 25,000 professionals and centers of recognized prestige in interventions, tests, treatments, products and health services.","subtitle3":"You will access <b>special prices</b> on wellness treatments, spas, beauty centers, physiotherapists, opticians..."}}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"More info","learn-more-btn":"Learn more","upper-header-subtitle":"Telemedicine","header-title":"PrimeSalud takes care of you. Always","subtitle-list-1":"Unlimited online medical assistance, with free choice of family doctor and pediatrician.","subtitle-list-2":"In addition, face-to-face consultations, tests, interventions and treatments at a discounted price.","hire-now-with-price":"Hire now for 12,95 Euros/month 2 adults + 2 children","price-cards":{"title":"Online consultations included","subtitle":"With no additional cost the best specialists 7 days a week.","content":"The best clinical services from more than 25,000 professionals and centers, at a very low price.","subcontent":"Online gym, meditation, health platform and much more.","monthly":"Monthly**","per-family":"per family*","hire":"Hire","family-label":"*Family: Spouse/partner and minor children.","monthly-label":"**Minimum stay commitment of 3 months.","medic-services-discount":"Discount on medical services","wellness-services":"Wellness services","medic-services":"Medical services","tooth-services":"Dental services","pediatry-services":"Pediatric services","dermatology-services":"Dermatology services","traumatology-services":"Traumatology services","endocrinology-services":"Endocrinology services","soon":"Soon","table":{"online-family-medic":"online family doctor","wellness":"Wellness and health platform","title1":"The most complete plan with all our specialties","title2":"The peace of mind of having a general practitioner and a pediatrician available 7 days a week","title3":"Enjoy private clinical services with discounts and access to our health and wellness platform","service-discounts":"Discounts on private medical services","subtitle":"We have plans tailored to all family needs","header":"most popular option","online-dermatology":"Online dermatology","online-endocrinology":"Online endocrinology","online-pediatrics":"Online pediatrics","online-traumatology":"Online traumatology","per-month":"per month*","title":"Our plans"},"family":"Family: Spouse/partner and minor children","permanency":"Commitment of permanence of 3 months"},"hire-now":"hire now","cards":{"1":{"title":"The best","subtitle":"Take care of your health and that of your loved ones with the best doctors and the best technology available"},"2":{"title":"Price to suit you","subtitle":"Accessible plans with the highest quality and peace of mind in our telemedicine services"},"3":{"title":"medical chart","subtitle":"You will have an extensive list of specialists, clinics and medical centers to ensure the best medical care"},"title":"Online consultation with the best professionals in general medicine and pediatrics"},"medical-assistance":{"title":"Online medical assistance","subtitle":"Included free of charge with free choice of family doctor and paediatrics, available 7 days a week.","content":"Included two adults and two children with unlimited consultations every day of the year.","available-consultations":"Available consultation types:","video":"Video consultation","phone-attention":"Phone consultation","written-consultation":"Written consultation","chat":"Chat","electronic-prescription":"Electronic prescription","safe-coms":"The security of communications and data privacy are our priority."},"wellness":{"title":"Health and Wellness Programs","subtitle":"With daily live and deferred classes of mindfulness, pilates, yoga, health programs, workshops, nutrition and much more.","mindfulness":"Mindfulness","pilates":"Pilates","healthy-back":"Healthy back","cardio":"Online Gym","nutrition":"Nutrition","vitality":"Vitality Pills"},"discounts":{"title":"Discounts on private clinical services","subtitle":"If you need proof and don't want to wait<br /><br />Access to the largest list of health services in Spain with more than 25,000 professionals and centers with discounts of up to 60% in consultations, interventions, tests, treatments, products and health services:","clinic-services":"Clinical services","clinic-services-description":"Allows access to doctors and medical centers that make up the Medical List of the 'AVANTSALUD' Service:","close":"Close","teeth-services-description":"This service includes certain free dental services and access to a List of Doctors at a scaled price. The free dental services are:","health-services-description":"Includes certain services related to well-being and health in specialties not usually included in health insurance, such as:","medical-services-list":"Primary medicine consultations (general medicine and paediatrics)<br> Specialist consultations<br> Diagnostic doctors<br> Medical treatments<br> Hospitalization and surgical interventions<br> Medical services<br> Allergology<br> Pathological anatomy<br> Angiology and vascular surgery<br> Digestive system<br> Cardiology<br> Cardiovascular surgery<br> General surgery and Digestive system<br> Breast surgery<br> Maxillofacial surgery<br> Surgery Oncology<br> Pediatric surgery<br> Plastic and reconstructive surgery<br> Thoracic surgery<br> Vascular surgery<br> Dermatology and venereology<br> Endocrinology and nutrition<br> Nursing<br> Hematology and hemotherapy<br> Nephrology<br> Pneumology<br> Neurosurgery<br> Clinical neurophysiology<br> Neurology<br> Obstetrics and gynecology<br> Ophthalmology<br> Medical oncology<br> Radiation oncology<br> Otorhinolaryngology<br> Rehabilitation<br> Rheumatology<br> Traumatology and Orthopedics<br> Urology<br> General Medicine General<br> Paediatrics<br> Paediatrics-Childcare<br> Clinics and Hospitals<br> Polyclinics<br> Perimetry<br> Panoramic/Orthopantomography<br> Ultrasounds<br> Mammograms<br> CAT scan<br> Clinical analysis<br> Diagnostic Imaging<br> Nuclear Medicine","teeth-services-list":"First visit and budget delivery<br> Review visit<br> Oral education<br> Teaching brushing techniques<br> Fluoridation<br> Annual mouth cleaning. Tartrectomy<br> Dental X-rays (periapical, wing, occlusal)<br> Diagnosis and probing<br> Occlusal adjustments<br> Remove stitches<br> Implantology study<br> False titanium stump<br> Healing and cementation screw<br>","health-services-list":"Acupuncture/Homeopathy/Naturopathy<br> Avantsalud in shape<br> Spas<br> Recognition centers<br> Laser ophthalmologic refractive surgery<br> Bobath Concept<br> Stem Cell Conservation- Cordon<br> Digital Dermatoscopy<br> Dietetics<br> 3D and 4D ultrasounds<br> Aesthetics<br> Physiotherapy and child physiotherapy<br> Colon hydrotherapy<br> Preventive Medicine and Genetic Testing<br> Optics and Hearing Aids<br> Orthopedics<br> Osteopathy<br> Plans with children<br> Podiatry and Footprint study<br> Home care services (postpartum care)<br> Minimally invasive procedures<br> Psychology, pedagogy and logophoniatry<br> Chiropractic <br> Cardiac rehabilitation<br> Animal-assisted therapy<br> Smoking cessation treatments<br> Infertility treatments<br> Shock wave treatment (erectile dysfunction)<br> Veterinarians<br> Laser myopia, astigmatism, hyperopia<br> Podiatry at home<br> Analytics at home<br> Physiotherapy at home<br> Prevention of cervical cancer/HPV<br> Cardiological genetic test<br> Screening for colon cancer in blood<br> Genetic test for obesity<br> Genetic test for lung cancer<br> Oncological check-up <br> Alzheimer's genetic test<br> Thromboembolism genetic test<br> Type II Diabetes genetic test<br> Breast cancer genetic test<br> Non-invasive prenatal test<br> Preeclampsia<br> Paternity test<br> Genetic fingerprint <br> Food intolerance test<br> Macular degeneration test<br> Fetal sex in maternal blood<br> Melissa test<br> Migraine test<br> Lactose - fructose intolerance test<br> Gastric balloon<br> Capsule endoscopic<br> Prostate green laser<br> Laser in dermatology<br> Vascular laser/endolaser<br> Percutaneous foot surgery<br> No-scalpel vasectomy<br> Blepharoplasty<br> Abdominoplasty<br> Rhinoplasty<br> Lifting <br> Capillary micrografts<br> Augmentation mammoplasty<br> Reduction mammoplasty<br> Intimate surgery<br> Liposuction<br>"},"subtitle-list-3":"Premium access to private health services.","hire-now-with-price-2":"Hire for 2.95 euros/month\n\nWithout Telemedicine, or permanence","healthappyrest":{"title":"Add mental health, happiness and rest to your life","psico":"Masterclass in psychology, mindfulness and sleep programs","yoga":"Yoga and Pilates classes","relax":"Relaxing audios, tips and curiosities","premium":"Premium access to private health services"},"buy-btn":"MORE INFO","familiar":{"title":"FAMILIAR","text":"3 months stay","subtitle":"<b>Free online doctor and pediatrician (2 adults 2 children)</b>","subtitle1":"Comprehensive health and wellness platform","subtitle2":"Premium access to private health services","subtitlesingle":"<b>Free online doctor and pediatrician</b>"},"healthmind":{"title":"HEALTH & WELLNESS","pricing":"€2.95","text":"without permanence","subtitle":"Comprehensive health and wellness platform","subtitle1":"Premium access to private health services"},"pricing":{"title":"Our plans"},"video-corporative":"video we do","hire-now-with-price-2-2":"Hire for 2.95 euros/month\n\n\nwithout permanence","see-plans":"See plans","rent":"contract"}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = {"professional-conditions":"Condições para profissionais","patient-conditions":"Condições para os pacientes","companies-telemedicine":"Saúde e bem-estar para empresas","contact":"Contato","legal-notice":"Advertência jurídica","faqs":"Perguntas frequentes","all-rights":"Todos os direitos reservados.","lawyer-conditions":"Condições para advogados","client-conditions":"Condições para clientes","privacy-policy":"Política de Privacidade do Paciente","cookies-policy":"Política de cookies","reminders":"lembretes","privacy-policy-professional":"Política de Privacidade para Profissionais","sgsi-policy":"Política SGSI"}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {"clinichistory":"Registro médico","weight":"Peso","kg":"kg","kg-ph":"Peso em kg","save-btn":"Manter","cancel-btn":"Cancelar","height":"Altura","height-ph":"Altura em cm","temperature-ph":"Temperatura em °C","cm":"cm","cm-ph":"Altura em cm","age":"Idade","habits":"Hábitos","selectoptions-ph":"Selecione uma ou mais opções","presure":"Pressão arterial","mmhg":"mmHg","systolic":"Sistólica","diastolic":"Diastólica","hdl-cholesterol":"Colesterol HDL","mgdl":"mg/dl","hdl":"Colesterol HDL","ldl-cholesterol":"Colesterol LDL","ldl":"Colesterol LDL","cholesterol":"Colesterol","glucose":"Glicose","glucoselevel":"nível de glicose","triglycerides":"Triglicerídeos","blood":"grupo sanguíneo","select-ph":"Selecione","bmi":"índice de massa corporal","waist":"Cintura","waist-ph":"Cintura em cm","hip":"Quadril","hip-ph":"Quadril em cm","heartRate":"Frequência cardíaca","bpm":"ppm","breathingFrequency":"Taxa respiratória","rpm":"rpm","oxygenSaturation":"Saturação de oxigênio","measureUnits":{"weight":"kg","height":"cm","age":"anos","temperature":"ºC","presure":"mmHg","hdl":"mg/dl","ldl":"mg/dl","cholesterol":"mg/dl","glucose":"mg/dl","triglycerides":"mg/dl","hip":"cm","waist":"cm","heartRate":"ppm","breathingFrequency":"rpm","oxygenSaturation":"%","fatMass":"kg","fatFreeMass":"kg","vitaminD":"IU","calories":"calorias"},"adddeletevariables":"Adicionar/excluir variáveis","hide-btn":"Disfarce","healthvariables":"Variáveis ​​de saúde","othervariables":"Outras variáveis ​​de saúde","healthcondition":"Estado de saúde","feeding":"Comida","sleep":"Sonhar","exercise":"Exercício","stress":"Nível de estresse","telemonitorization":"Telemonitoramento e aplicações externas","noservices":"Você ainda não adicionou nenhum serviço.","go-btn":"Ir","delete-btn":"Eliminar","selectservice":"Selecione o serviço que deseja adicionar:","servicesoon":"Este serviço estará disponível em breve","accept-btn":"Aceitar","observations":"Observações","edit-btn":"Editar","experiences":"Eventos e experiências significativas","authorizedpeople":"Pessoas autorizadas","createauthorizedpeople":"Criar pessoa autorizada","show-btn":"Mostrar","diseases":"Doenças","diseases-ph":"Digite o nome da doença","diseasedate-ph":"Data (dd/MM/aaaa) (opcional)","allergies":"Alergias","allergy-ph":"Digite o nome da alergia","gravity-ph":"Gravidade","medication":"Medicamento","medication-ph":"Digite o nome do medicamento","currentmedication":"Atualmente estou tomando medicação","medicationstart-ph":"Início (dd/MM/aaaa) (opcional)","medicationend-ph":"Fim (dd/MM/aaaa) (opcional)","vaccines":"Vacinas","vaccine-ph":"Digite o nome da vacina","familyhistory":"História familiar","familyhistory-ph":"Digite o antecedente","relationship":"Relação","genogram":"Genograma","selectimage":"Selecione uma imagem:","seegenogram":"Ver genograma","hidegenogram":"Ocultar genograma","clinicdocuments":"Documentos e formulários clínicos","recommendedApps":"Candidaturas e informações de interesse","filterdocuments":"Filtrar por tipo de documento","filterapps":"Filtrar por tipo de aplicativo","addfile":"Anexar arquivos/documentos","addfile-ph":"Adicionar arquivo/documentos","addapp-ph":"Adicione aplicativo/informações de interesse","appointments":"Consultas","years-text":"anos","nointroduced":"Não apresentado","name-column":"Nome","surname-column":"Sobrenomes","dni-column":"EU IA","email-column":"E-mail","relationship-column":"Relação","phone-column":"Telefone","description-column":"Descrição","date-column":"Data","gravity-column":"Gravidade","start-column":"Começar","end-column":"Fim","notmedicines":"No momento não estou tomando a medicação.","title18chtvaccine":"Vacina","code-column":"Código","filetype-column":"Tipo de arquivo","uploadedby-column":"Enviado por","see-btn":"Ver","download-btn":"Descarga","disease-del":"A doença foi removida do seu histórico médico","link-del":"O link de interesse foi removido do seu prontuário médico","doc-del":"O documento foi removido do seu prontuário médico","allergy-del":"A alergia foi removida do seu prontuário médico","drug-del":"O medicamento foi removido do seu prontuário médico","vaccine-del":"A vacina foi removida do seu prontuário médico","familyhistory-del":"O histórico familiar foi removido do seu histórico médico","drug-del-error":"Ocorreu um erro ao excluir seu medicamento","nodisease":"Não sofre de nenhuma doença","noallergy":"Não sofre de nenhuma alergia","nolinks":"Não possui links de interesse","nodrug":"Você ainda não adicionou nenhum medicamento","novaccine":"Nenhuma vacina adicionada ainda","nofamilyhistory":"Ele não tem histórico familiar","successchanges":"Alterações feitas com sucesso","health-qst":"Como está sua saúde?","stress-qst":"Atualmente, você diria que seu nível de estresse é...","feeding-qst":"Como você comeu esta semana?","sleep-qst":"Como você dormiu?","exercise-qst":"Você já se exercitou?","history":"Registro","savesuccesshistory":"Suas observações foram salvas corretamente","savedanger":"Ocorreu um erro. ","savesuccesshabits":"Eles mantiveram seus hábitos saudáveis ​​corretamente.","valuenumericerror":"Por favor insira um valor entre 1 e 10","actualdata":"Os dados foram atualizados corretamente","errordata":"Erro ao atualizar dados. ","documentspatient":"Arquivos de pacientes","dataopensalud":"Relatório Opensalud","Name":"Nome","HabitsTypes":"Tipos de hábitos","BloodTypes":"Grupos Sanguíneos","selectarchive":"Selecione um arquivo","selectarchive2":"Selecione ou arraste um arquivo aqui para fazer upload","savedarchive":"Seu arquivo foi salvo. <br> Você pode excluí-lo sempre que quiser em ‘Meus dados de saúde’ > ‘Documentos clínicos’","owarchive":"Seu arquivo foi substituído com sucesso","selectimage-js":"Selecione uma imagem","selectimage2":"Selecione ou arraste uma imagem aqui para fazer upload","savesuccess":"Salvamento concluído com sucesso.","errorhistory":"Erro ao solicitar histórico médico. ","healthcondition-min":"muito ruim","healthcondition-max":"Perfeitamente!","stress-min":"Nenhum","stress-max":"Bastante","feeding-min":"Muito mal","feeding-max":"Muito bom","sleep-min":"Muito mal","sleep-max":"Excelente","exercise-min":"Nada","exercise-max":"Demais!","activeservice":"Você já tem o serviço ativado ","errorservice":"Ocorreu um erro, tente novamente mais tarde","serviceof":"O serviço de ","beendeleted":" foi removido.","serviceerrordelete":"O serviço não pôde ser eliminado. ","diseaseselecterror":"Você deve selecionar uma doença.","dangerdisease":"Você não pode atribuir uma doença já adicionada","mustdeleteallergies":"Você deve excluir as alergias registradas","selectallergy":"Você deve selecionar uma alergia","selectseverity":"Você deve selecionar uma gravidade para a alergia.","notassignedallergy":"Você não pode atribuir uma alergia já adicionada.","selectdrug":"Você deve selecionar um medicamento","dateinfodrugs":"Especifique a data em que terminou de tomar o medicamento ou marque a caixa Atualmente tomando medicamento se estiver tomando o medicamento.","notassigneddrug":"Você não pode atribuir um medicamento já adicionado.","selectvaccine":"Você deve selecionar uma vacina.","selectdisease":"Você deve selecionar uma doença","selectrelationship":"Você deve selecionar um relacionamento.","norepeatdisease":"Você não pode repetir uma doença no mesmo relacionamento.","disease-column":"Sintoma/Doença","speciality-column":"Especialidade","appointmenttype-column":"Tipo de consulta","seeappointment-btn":"Ver consulta","appointmentsHistory":"Histórico de consultas","invalidDate":"Você deve inserir uma data válida","addReminderMedication":"Quer adicionar um lembrete para sua medicação?","yes":"Sim","no":"Não","visit":"Visita","fromURLComplete":"Caso este documento ainda não tenha sido marcado como concluído, será enviado um e-mail ao profissional que o criou notificando desta ação.<br><br> Você quer continuar?","completeSuccess":"Operação realizada com sucesso","fromFileComplete1":"A seguir, você fará o upload de um arquivo, previamente baixado e concluído, que substituirá o anterior.<br><br> O profissional será notificado de que preencheu este documento caso ainda não esteja marcado como tal.<br>","fromFileComplete2":"Deseja substituir o arquivo em questão?","clearUpload":"Limpar","speciality":"Especialidade","filterSpe":"Filtrar por especialidade","fillStartDate":"Insira uma data de início","fillEndDate":"Insira uma data de término","selectReminderInterval":"Insira o intervalo do lembrete","selectReminderFrequency":"Insira a frequência do lembrete","introduceCorrectDates":"Insira um intervalo de tempo correto","reminderSuccess":"Seu lembrete foi criado com sucesso","reminderDeleteSuccess":"Seu lembrete foi excluído com sucesso","reminderDeleteSure":"Tem certeza de que deseja excluir o lembrete?","datePlaceholder":"dd/mm/aaaa","unlockFilesQuestion":"Tem certeza de que deseja desbloquear este arquivo? <br><br> Se você desbloquear este arquivo ele poderá ser visualizado por todos os profissionais/centros com os quais você interage.","unlockFilesAnswer":"O arquivo foi desbloqueado com sucesso","lockFilesQuestion":"Tem certeza de que deseja bloquear este arquivo? <br><br> Se você bloquear este arquivo, ele só poderá ser visualizado por você e pelo profissional/centro que gerou o referido documento, se for o caso.","lockFilesAnswer":"O arquivo foi bloqueado com sucesso","accept":"Aceitar","fileIsLocked":"O paciente bloqueou o arquivo","temperature":"Temperatura","alarms":"Alarmes","alarms.info":"Ao habilitar alarmes para as variáveis ​​de saúde deste paciente, você receberá um WhatsApp e um e-mail toda vez que o paciente fizer alguma medição fora dos limites estabelecidos.","alarms.enable.success":"Os alarmes foram ativados para todas as variáveis ​​de saúde","alarms.disable.success":"Os alarmes foram desativados para todas as variáveis ​​de saúde","fatMass":"massa gorda","fatMass-ph":"Massa gorda (Kg)","fatFreeMass":"massa sem gordura","fatFreeMass-ph":"Massa sem gordura (Kg)","homa":"Homa","homa-ph":"Homa","vitaminD":"Vitamina D","vitaminD-ph":"Vitamina D em UI","steps":"Passos","steps-ph":"Passos","calories":"Calorias","calories-ph":"Calorias em Kcal","mood":"Humor","confirm-save-slider":"Tem certeza de que deseja salvar suas alterações?","additional-health-variables":"Outras variáveis ​​de saúde","appointment-history":{"not-found":"Nenhuma consulta encontrada"},"observations-ph":"Escriba aquí...","signupDiscovery":{"title1":"Recomendação profissional"},"cardsPricing":{"text2":"5 profissionais incluídos. \n<br /> 5€/mês por profissional adicional (máx. 190€/mês)"},"medallergies":"Alergias a medicamentos","chrondiseases":"Doenças crônicas","dateStart":"Data de início","dateEnd":"Data final","nofiles":"Você não adicionou documentos clínicos","healthyVars":"Variáveis ​​de saúde","feedingHabits":"Hábitos alimentares","moodAndHabits":"Hábitos e humor","historyAndDiseases":"História e doenças","medicalEvaluation":"Avaliação médica","historyAndDiseasesReduced":"História/Doenças","dontKnow":"Não sei","mustFillAllData":"Preencha os dados do formulário. \nCaso não saiba o valor, clique em “Não sei” ou “Nenhuma das opções acima”","dontKnowOrDontAnswer":"Não sei/Não respondo","quizDialog":{"completeMedicalEvaluation":"Você está prestes a completar seu perfil básico de saúde. \nAdicione alguns valores da sua última avaliação para aproveitar ao máximo o opensalud.<br><br>Deseja preencher essas informações?"},"completeYourHealthProfile":"Complete seu perfil de saúde","fillQuizAdvice":"Essas informações facilitarão seu atendimento e melhorarão o atendimento recebido quando você precisar, dentro ou fora do OpenSalud.","remindLater":"Lembre-se mais tarde","clinicHistory":"História clínica","clinicDocuments":"Documentos clínicos","applicationsAndInformationOfInterest":"Candidaturas e informações de interesse","bloodMonitor":"Monitorar a pressão arterial","glycemiaMonitor":"Monitore a glicemia","otherMoment":"Em outro momento","soon":"breve","searchOrSelectOptions":"Pesquise ou selecione uma ou mais opções","pressEnterToSelect":"Pressione Enter para selecionar","pressEnterToRemove":"Pressione Enter para desmarcar","selected":"Selecionado","base-select":{"noOptions":"Não foram encontrados resultados"},"healthyHabits":"Meus objetivos e desafios","watch":"Ver","significantEventsAndExperiences":"Eventos e experiências significativas","file-type-column":"Tipo de arquivo","selectOneOption":"Selecione uma opção","clinic-history":{"wellbeing-score":"Wellbeing score","concede-access":"Conceder acesso ao meu histórico médico","professionals-and-centers-authorizated":"Profissionais e centros autorizados","select-patient":"Selecione um paciente","select-pet":"Selecione um animal de estimação","select-prof-center":"selecione um profissional/centro","back-history":"De volta à minha história","grant-access":"Conceder acesso ao histórico","access-authorizated":"Acesso autorizado","already-saved-today-variable":"Você já salvou dados hoje nesta variável. \nVolte amanhã para inseri-los novamente.","in-last-7-days":"Nos últimos 7 dias...","selectPet":"Selecione animal de estimação"},"currentlyTakeMed":"Atualmente estou tomando medicação","selectStartDate":"Selecione a data de início","selectEndDate":"Selecione a data de término","currentlyNoTakeMed":"No momento não estou tomando a medicação.","medicationSelectError":"Você deve selecionar um medicamento","medicationEndDateMinorStartDate":"A data de término da medicação não pode ser inferior à data de início","allergySelectError":"Você deve selecionar uma alergia","allergySeveritySelectError":"Você deve selecionar a gravidade da alergia","vaccineSelectError":"Você deve selecionar uma vacina","familyHistorySelectError":"Você deve selecionar um plano de fundo","relationshipSelectError":"Você deve selecionar um relacionamento","noMedAllergies":"Não tenho alergia a medicamentos","applicationsAndInformationOfInterestReduced":"Cand./info interesse","document":{"url":"URL (http://...)","uploadFromThisDevice":"Fazer upload deste dispositivo","insertLink":"Insira um URL (link)"},"link":{"nameError":"Você deve inserir um nome para o link","linkError":"Você deve inserir um URL válido"},"filterByType":"Filtrar por tipo","revokeAccess":"Revogar acesso","revokeAccessClinic":{"error":"Erro ao realizar a revogação. \nTente de novo","owner":"Você não pode revogar o acesso de quem criou seu usuário","withAppointment":"Não é possível revogar o acesso a um profissional com quem você marcou consulta","center":"Você não pode revogar o acesso ao centro de um profissional com quem você concordou em compartilhar seu histórico com seus centros parceiros","success":"Revogação concluída com sucesso"},"grantAccessClinicHistory":"Conceder acesso ao meu histórico médico","historyGrantAccessText":"Você pode compartilhar seu histórico médico com um profissional/centro na plataforma ou gerar um link somente leitura para compartilhar com quem você decidir.","shareInternally":"Compartilhe internamente","generateLink":"Gerar link","grantAccessSelectProfOrCenter":"Você deve selecionar um profissional ou centro","historyShare":"Compartilhar","validityInDays":"Validade em dias","sharelinkError":{"days":"Você deve inserir uma validade de 1 a 30 dias","emails":"Você deve inserir pelo menos 1 e-mail","wrongEmail":"Você deve corrigir os seguintes e-mails:","validity":"Você deve inserir uma validade entre 1 e 180 dias"},"linkSendedSuccessfully":"Link enviado com sucesso","later":"Mais tarde","significantEventsAndExperiencesReduce":"Acontecer. \ne experimente. \nsignificativo","vaccine-commercial-name":"Nome comercial (opcional)","dateBeforeNowError":"A data selecionada deve ser menor que a data atual","commercial-name-column":"Nome comercial","completedQuiz":"preenchido","completedHistory":"Preenchido","history-files-overwrite-content":"Em seguida, você fará o upload de um arquivo, previamente baixado e preenchido, que substituirá o anterior.<br><br>O profissional será notificado de que completou este documento, caso ainda não esteja marcado como tal.","history-files-overwrite-question":"Deseja substituir o arquivo em questão?","mark-as-complete-text":"Se você marcar este documento como concluído, um e-mail será enviado ao profissional que o criou notificando-o desta ação.<br><br>Deseja continuar?","lock-file-advice":"Tem certeza de que deseja bloquear este arquivo? \n<br><br> Se você bloquear este arquivo, ele só poderá ser visualizado por você e pelo profissional/centro que gerou o referido documento, se for o caso.","unlock-file-advice":"Tem certeza de que deseja desbloquear este arquivo? \n<br><br> Se você desbloquear este arquivo ele poderá ser visualizado por todos os profissionais/centros com os quais você interage.","wantAddReminderMed":"Quer adicionar um lembrete para sua medicação?","medicationReminder":"Lembrete de medicação","reminderMedicationForm":{"alias":"Aliases para o medicamento","aliasInput":"Digite um nome curto para identificar o medicamento na lista telefônica","startDate":"Data de início","endDate":"Data final","color":"Cor para espaço agenda","interval":"Intervalo de lembrete","selectInterval":"Selecione um intervalo","hour":"Selecione um horário","reminderEach":"Lembre-se de cada...","repeatEach":"Repita cada","error":{"alias":"Você deve inserir um alias para o medicamento","endDate":"Você deve inserir a data de término do lembrete","dateBefore":"A data de início deve ser posterior à data atual","color":"Você deve selecionar uma cor para o espaço da agenda","startGreater":"A data de término deve ser posterior à data de início","startGreaterThanNow":"A data de término do lembrete deve ser posterior à data atual","medicine":"Você deve selecionar um medicamento","interval":"Você deve selecionar um intervalo de repetição maior que 1 dia/semana","tabletsLessThan1":"Você deve apresentar uma série de unidades maiores ou iguais a 1","tabletsFromHour":"Você deve selecionar o horário de início da medicação","tabletsToHour":"Você deve selecionar o horário de término da medicação","frequencyOption":"Você deve selecionar a frequência de tomar a medicação","intakesDay":"Você deve selecionar pelo menos 2 doses por dia","weekDays":"Você deve selecionar pelo menos 1 dia da semana","cylicStartDate":"Você deve selecionar a data de início do ciclo","notifications":"Você deve selecionar, pelo menos, um meio para notificações","tabletsReminder":"TOMAS por embalagem do lembrete de estoque deve ser menor que o limite de embalagem","tabletsReminderFill":"Você deve inserir um número válido de fotos por contêineres para o lembrete de substituição"},"option":"Selecione uma opção","sucess":"Lembrete criado com sucesso","frequencyTitle":"Com que frequência você toma esse medicamento?","frequency":{"interval":"Intervalo","severalTimesDay":"Várias vezes ao dia","weekDays":"dias da semana","cyclic":"Cíclico"},"tablets":"Unidades","fromHour":"De","toHour":"Até","selectWeekDays":"Selecione os dias:","tabletsDay":"tiros por dia","pause":"pausa","intakes":"Tomás","pauses":"pausas","hourTitle":"Hora","intakesPerContainer":"doses por contêiner","reminder":"Lembrete","reminderFillQuestion":"Receber lembrete para reabastecer o estoque?","reminderMedicineTitle":"doses por contêiner, lembre-se quando elas estiverem faltando","notificationsQuestion":"Selecione onde você receberá notificações:","units":"unidades","startHour":"Hora de início","endHour":"Hora do final"},"theDay":"O dia","other":"Outro...","maximum":"Máximo","minimum":"Mínimo","file":{"select":"Você deve selecionar um arquivo"},"noEvaluationTests":"Não há exames realizados pelo paciente","relvantsExperiences":"Eventos relevantes","healthProfile":"Perfil de saúde","removeReminder":"Excluir lembrete","removeMedication":"Remover medicação","seeReminder":"Ver lembrete","createReminder":"Criar lembrete","options":"Opções","canNotAccessReadOnly":"Você não pode acessar esta seção no modo somente leitura","documentsAndInformation":"Documentos e informações","healthData":"Variáveis ​​de saúde","healthQuiz":"Questionário de saúde","reason-column":"Razão","pastMedication":"Medicação anterior","currentMedication":"Medicação atual","noPastDrug":"Sem medicamentos anteriores","addOrDeleteHealthvar":"Adicionar/remover variáveis","otherAllergies":"Outras alergias","locked":"bloqueado","unlocked":"Desbloqueado","pets":"Animais de estimação","clinic-history-variable-slider":{"stress":{"min":"Muito alto","max":"Estresse zero!"},"feeding":{"min":"Não é saudável","max":"Super saudável!"},"sleep":{"min":"Muito ruim","max":"Perfeitamente!"},"exercise":{"min":"Nada","max":"Demais!"},"healthcondition":{"min":"Muito ruim","max":"Perfeitamente!"},"healthconditiontoday":{"min":"Muito ruim","max":"Perfeitamente!"}},"howDoYouFeel":"Seus hábitos na última semana","healthMonitoring":"Acompanhamento de saúde","reminderFrequency":"Frequência do lembrete","noDataProfAndCenterAuthorized":"Ainda não concedeu acesso a profissionais ou centros","shareHistoryAccessLinkPlaceholder":"Insira os e-mails dos destinatários (não incluindo os seus) separados por quebras de linha, vírgulas, espaços em branco ou ponto e vírgula","noneOfTheAbove":"Nenhuma das anteriores","mustFillQuizPressureData":"Se você inserir a pressão arterial sistólica ou diastólica, deverá preencher ambos os campos do questionário","presureVarSaveError":"Você deve inserir a pressão arterial no formato: Sistólica/Diastólica","isNanError":"Você deve inserir um número válido","bloodPressureReduced":"Sis/Dia","healthconditiontoday":"Como você se sente hoje?","shareLinkValidity":"Insira um valor entre 1 e 180 dias","reportOrPrescripcion":"Receita/Prescrição","menstrual-calendar":"Calendário menstrual","fileLockedByPatient":"O paciente bloqueou o arquivo","menstrualCycle":"Controle de ciclo","cycleStartDate":"DATA DE INÍCIO DO CICLO","periodDuration":"Duração do período (dias):","cycleDuration":"Duração do ciclo (dias):","addCycle":"Adicionar ciclo","historyCycle":"Histórico do ciclo","cycleDuration2":"Duração do ciclo","periodDuration2":"Duração do período","ovulationDuration":"Dias de ovulação","cycle":"Ciclo","delete":"Eliminar","cycleControl":"Controle de ciclo","noControl":"Nenhum ciclo registrado","startCycle":"iniciar ciclo","setPeriodDuration":"Definir duração do período","current":"EM ANDAMENTO desde","confirmEndCurrentCycle":"Você quer encerrar o ciclo atual?","until":"até","add-txt":"Adicionar","mustSetPeriod":"Você deve definir o período do ciclo atual antes de poder adicionar um novo.","error-cycles-get":"Não foi possível obter os ciclos. \nPor favor, tente novamente mais tarde","error-cycles-delete":"No se pudo eliminar el ciclo. Por favor, inténtelo de nuevo más tarde","error-cycles-set":"A duração do período não pôde ser estabelecida. \nPor favor, tente novamente mais tarde","error-cycles-start":"Não foi possível iniciar o ciclo. \nPor favor, tente novamente mais tarde","error-cycles-set2":"O ciclo atual não pôde ser atualizado. \nPor favor, tente novamente mais tarde","lang":"Linguagem","ovulationDurationPrediction":"Previsão do dia da ovulação","new-cycle":"Novo ciclo","newCyclePredictionDate":"Previsão de início do próximo ciclo","enterMedicineName":"Digite o nome do medicamento","addNewMedicationReminder":"Adicionar lembrete","tabletsLeft":"Unidades restantes","medicationReminderEachXTime":"A cada {time} {interval}","timesToDay":"vezes por dia","confirmRemoveMedicationReminder":"Deseja excluir este lembrete?","resetTabletsReminder":"Redefinir unidades","editMedicationReminder":"Editar lembrete de medicina"}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowUp_vue__ = __webpack_require__(1080);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1350d1ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowUp_vue__ = __webpack_require__(1667);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1665)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1350d1ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1350d1ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/ArrowUp.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1350d1ca", Component.options)
  } else {
    hotAPI.reload("data-v-1350d1ca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = {"sign-in-btn":"Sign in","sign-up-btn":"Sign up","centre":"Centre","professional":"Professional","patient":"Patient","opensaludprime":{"subtitle":"If you don't have health insurance, opensalud prime is what you're looking for.","text1":"Free access to online consultations with a family doctor or pediatrician of your choice.","text2":"Discount on online consultations in the rest of the specialties at opensalud.","text3":"Comprehensive health and wellness platform with live classes, meditation, online gym...","text4":"Free access to online consultations with a family doctor or pediatrician of your choice."},"learn-more-btn":"Learn more","title-big-1":"Everything you need to take care of yourself.","title-big-2":"Enjoy for free the best application to take care of your health.","title-big-3":"How does it work?","title-big-4":"Contact us","title-small-1":"The 360 ​​health platform","title-small-2":"The best professionalss","title-small-3":"Access to free services","title-small-4":"security and privacy","title-small-5":"Sign up in openhealth","title-small-6":"Sign in and choose your service","title-small-7":"Indicate the reason for your consultation","title-small-8":"Log in to the professional","text-1":"Access the best professionals and the most advanced application to take care of your health.","text-1-sm":"opensalud 360 is a health platform for individuals, companies and groups, which allows its users to access the best health professionals, at any time and from anywhere.","text-2":"We select the best centers and specialists individually, so that you can access the best care at the best price.","text-3":"Symptom evaluator, health content, digital medical history, health diary, medication reminder... and many more services free of charge.","text-4":"We put at your disposal the best technology with maximum security in communications and total privacy of your data.","text-5":"Include the code, policy number or booking number provided","text-6":"Select the service and the professional you need using the search engine","text-7":"Add some health data, attaching images or reports if you wish","text-8":"Receive your report and prescription. At the end you will be able to evaluate the service","text-9":"If you want your employees or clients to access the best digital health services (40 medical specialities, psychology and nutrition) contact us","text-9-sm":"If you want your employees or clients to access the best digital health services (40 medical specialities, psychology and nutrition) contact us","specialty":"Specialty","specialties":"Specialties","services":"Services","appointment-type":"Consultation type","error-specialty-required":"You must select at least the specialty","consultations-btn":"Consultations","other-services":"Other services","block-6":{"title":"The secret to excellent online service is to have excellent digital professionals.","subtitle":"Consult the best doctors, psychologists and nutritionists, easily and safely, at the best price, wherever you are."},"discounts":{"clinic-services":"clinical services","clinic-services-description":"It allows access to doctors and medical centers that make up the Medical List of the 'AVANTSALUD' Service:","close":"To close","health-services-description":"It includes certain services related to well-being and health in specialties not usually included in health insurance, such as:","health-services-list":"Acupuncture/Homeopathy/Naturopathy<br> Avantsalud in shape<br> Spas<br> Examination centers<br> Ophthalmological laser refractive surgery<br> Bobath Concept<br> Cord Stem Cell Conservation<br> Digital Dermatoscopy<br> Dietetics<br> 3D and 4D ultrasounds<br> Aesthetics<br> Physiotherapy and child physiotherapy<br> Colon hydrotherapy<br> Preventive Medicine and Genetic Testing<br> Optics and Hearing Aids<br> Orthopedics<br> Osteopathy<br> Plans with children<br> Podiatry and Footprint Study<br> Home care services (postpartum care)<br> Minimally invasive procedures<br> Psychology, pedagogy and logophoniatry<br> Chiropractic<br> Cardiac rehabilitation<br> Therapy assisted with animals<br> Smoking cessation treatments<br> Infertility treatments<br> Shock wave treatment (erectile dysfunction)<br> Veterinarians<br> Laser myopia, astigmatism, hyperopia<br> Podiatry at home<br> Analytics at home<br> Physiotherapy at home \nlio<br> Prevention of cervical cancer/HPV<br> Cardiological genetic test<br> Screening for colon cancer in blood<br> Genetic test for obesity<br> Genetic test Lung cancer<br> Oncological check-up<br> Test Genetic Alzheimer's<br> Genetic thromboembolism test<br> Genetic test Type II Diabetes<br> Genetic test Breast cancer<br> Non-invasive prenatal test<br> Preeclampsia<br> Paternity test<br> Genetic fingerprint<br> Test of food intolerance<br> Macular degeneration test<br> Fetal sex in maternal blood<br> Melissa test<br> Migraine test<br> Lactose - fructose intolerance test<br> Gastric balloon<br> Endoscopic capsule<br> Green prostate laser<br> Laser in dermatology<br> Vascular/endolaser laser<br> Percutaneous foot surgery<br> No-scalpel vasectomy<br> Blepharoplasty<br> Abdominoplasty<br> Rhinoplasty<br> Lifting<br> Micrografts capillaries<br> Augmentation mammoplasty<br> Reduction mammoplasty<br> Intimate surgery<br> Liposuction<br>","medical-services-list":"Primary medicine consultations (general medicine and paediatrics)<br> Specialist consultations<br> Diagnostic doctors<br> Medical treatments<br> Hospitalization and surgical interventions<br> Medical services<br> Allergology<br> Pathological anatomy<br> Angiology and vascular surgery<br> Digestive system<br> Cardiology<br> Cardiovascular surgery<br> General surgery and Digestive system<br> Breast surgery<br> Maxillofacial surgery<br> Oncological surgery<br> Pediatric surgery<br> Plastic and reconstructive surgery<br> Thoracic surgery<br> Vascular surgery<br> Dermatology and venereology<br> Endocrinology and nutrition<br> Nursing<br> Hematology and hemotherapy<br> Nephrology<br> Pulmonology<br> Neurosurgery<br> Clinical neurophysiology<br> Neurology<br> Obstetrics and gynecology<br> Ophthalmology<br> Medical oncology<br> Radiation oncology<br> Otorhinolaryngology<br> Rehabilitation<br> Rheumatology<br> Traumatology and Orthopedics<br> Urology<br> General Medicine<br> Pediatrics<br> Pe \nDiatrics-Childcare<br> Clinics and Hospitals<br> Polyclinics<br> Perimetry<br> Panoramic/Orthopantomography<br> Ultrasounds<br> Mammograms<br> CT<br> Clinical analysis<br> Diagnostic imaging<br> Nuclear medicine","subtitle":"More than 25,000 professionals and centers, in your area, with a very low price<br /><br />Access to the largest list of health services in Spain with more than 25,000 professionals and centers with discounts of up to 60% in consultations , interventions, tests, treatments, products and health services:","teeth-services-description":"This service includes certain free dental services and access to a List of Doctors at a scaled price. \nFree dental services are:","teeth-services-list":"First visit and budget delivery<br> Review visit<br> Oral education<br> Teaching of brushing techniques<br> Fluoridation<br> Annual mouth cleaning. \nTartrectomy<br> Dental X-rays (periapical, wing, occlusal)<br> Diagnosis and probing<br> Occlusal adjustments<br> Remove stitches<br> Implantology study<br> False titanium stump<br> Healing and cementation screw <br>","title":"Discounts on private clinical services"},"wellness":{"pilates":"Pilates","subtitle":"with daily live classes (mindfulness, pilates, yoga, gym...) and deferred, health programs, workshops, nutrition and much more<br /><br />Your online gym:","cardio":"Cardiovascular","healthy-back":"healthy back","mindfulness":"Mindfulness"},"hire-now-with-price":"Hire now for 12,95€/month 2 adults + children included","testimony1":"'The response and attention received were quick and clear. I'm very grateful to you.'","testimony2":"'Dr Montserrat has been very friendly, her diagnosis has been quick after an assessment and a few questions, very good service with quick solutions. A 10 on all counts.'","testimony3":"'It's a very fast and very useful service. I’m very happy. Thank you.'","testimony4":"'The doctor treated me very carefully and she recommended and prescribed the solution to my hair problem.'","testimonyMJesus":"'She has offered me a series of diagnostic assessments that restore my hope and desire to overcome my health problem. A very clear and direct information.'","testimonyEduard":"'The service has been magnificent, fast and effective. He gave me the information I needed without leaving home and at a really cheap price.'","testimonyJesus":"'A second opinion would help me to analyse my health problem from a new perspective. It is highly recommended.'","testimonyEugenia":"'The doctor provided us with a clear and well-explained diagnosis, with recommendations to follow and links to very useful articles.'","urologist":"Urologist","internist":"Internist","psychology":"Psychology","pediatrics":"Paediatrics","clinicalpsychology":"Clinical psychology","familymedicine":"Family medicine","internalmedicine":"Internal medicine","sports":"Sports medicine","geriatrics":"Geriatrics","psychiatry":"Psychiatry","oncology":"Oncology","neurologist":"Neurologist","digestiveSurgeon":"Gastrointestinal Surgeon","block-review":{"title":"What our patients say","title2":"What happens?","text":"Indicate your symptoms and access an initial evaluation. At the end you will have access to the best specialists.","button":"My head hurts, my chest hurts..."},"find-prof":"Find the right professional","block-security":{"blackTitle":"Everything you need, with the highest level of protection.","text2":"We put at your disposal the best technology with maximum security in communications and total privacy of your data. \nOur data security management system has the ISO 27001 certification and is audited by the Collegiate Medical Organization."},"title-small-9":"Always carry your medical history with you accessible from your mobile and be able to share it with whoever you want, it can be essential for proper care (urgent or not).","text-12":"Symptom Evaluator - Patient Forum - Habit Tracking - Clinical history in the cloud - Self-assessment test - Health Agenda - Medication Reminder - Connection with Devices (smartwatch...) - Exclusive Promotions","title-card-1":"Symptom Evaluator","title-card-2":"Patients Like You","title-card-3":"Habit Tracking","title-card-4":"Evaluate your health","title-card-5":"Health Schedule","title-card-6":"Notices and Reminders","title-card-7":"Connection with Devices (smartwatch...)","title-card-8":"Exclusive Promotions","title-card-9":"Cloud clinical history","subtitle-big-2":"Always carry your medical history with you accessible from your mobile and be able to share it with whoever you want, it can be essential for proper care (urgent or not).","subtitle-big-functions":"Always carry your medical history with you accessible from your mobile and be able to share it with whoever you want, it can be essential for proper care (urgent or not).","foro":"patient forum","registerfor-free":"Sing up free!","title-card-2-linkeable":"<router-link to=\"/Foro\" tag=\"a\">Patients Like You</router-link>\n","rev":"reviews","professionals":"Professionals","accesss":"To access","online-consultation":"Online consultation","title-card-10":"Healthy blog","mustSelectAnSpecialty":"You must select a specialty","specialtyOrName":"Specialty or name","error-specialty-or-prof-required":"You must select a specialty or professional","services-consultation":"Consultations and services","request-consultation":"Consultations","request-service":"Medical tests","service":"Medical tests and services","patients-swiper":{"care-your-health":"Consultations, tests and the best wellness app","sign-up-free":"SIGN UP FOR FREE","online-consultation-inplace":"Online and in-person consultations","security-and-privacy":"Security and privacy","health-blog":"Healthy information","healthy-foods":"Foods that care","patients-like-you":"Patients like you","habit-tracker":"Goals and challenges","cloud-clinic-history":"Medical history in the cloud","rate-your-health":"Evaluate your health","health-agenda":"Health agenda","reminders":"Notices and reminders","device-connection":"Variable monitoring","exclusive-promotions":"Exclusive promotions","menstrual-cycle":"Menstrual calendar","habits-that-care":"Habits that take care"},"patients-landing":{"independent-professionals":"The platform of independent professionals","quality-medicine":"Quality medicine, without rush","sign-up-banner":"Register if you are concerned about the quality of care, if you want to improve the profitability of your practice, collaborate with your colleagues and join the largest private medicine group in Spain.","try-it-free":"TRY IT FOR FREE","access-psychologist":"What if I want to access a psychologist?","online-inplace-attention":"Online and in-person attention","menttum-banner":"In <span style='text-decoration: underline; font-weight: bold;'>MENTTUM by opensalud</span> You will be able to access the best psychologists in an easy and safe way. ","go-menttum":"GO TO MENTTUM","request-appointment":"Request appointment","mobile-title":"The best <br class = \"d-lg-none\"> medics and health professionals","sign-up-free":"Register for free","opensalud360-title":"Do you need a health and well -being service for your employees that really work?","opensalud360-subtitle":"Leaders in psychological care services, prevention, integral health and well -being for employees.","opensalud360-text":"opensalud360 allows access to the best doctors, psychologists or nutritionists, the best workshops and welfare programs and the health application and improvement of more successful market habits.","know-more":"Know more","different-health":"Health today is different","mobile-title-2":"The best application to take care of you","mobile-title-lg":"The best specialists and centers and the best application to take care","swiper":{"title":"Consultations and the best health and well -being application"},"why-opensalud-different":"Why is Opensalud different?"},"patients-layout":{"companies":"Companies"},"error-service-required":"You must select a service","location":"Province/Locality","telemedicine":"Telemedicine","patients":{"private-appointments":"Private consultations","insurance-appointments":"Insurance consultations","private-appointments-types":"Appointment type","inplace-visit":"In-person visit","error-insurer-required":"You must select an insurer"},"patient-title":"opensalud: appointments and health and wellness application","patient-panel":{"my-apps":"My applications"},"patients-landing-different-health-description":"We want to make it easier for you to access qualified professionals, top centers and trusted solutions, and the health<br class=\"d-none d-block-lg\"/>\nand wellness app used by leading companies — to help you live longer and live better.","solutions":{"qualityMedicine":{"title":"Quality Healthcare","description":"All professionals are evaluated before being onboarded on OpenSalud"},"agileAppointment":{"title":"Appointment Agility","description":"95% appointments in less than 10 days (less than 3 days for business users, except urgent care)"},"privateConsultations":{"title":"Private Consultations","description":"No insurance-funded consultations are offered, only private appointments"},"medicineWellbeing":{"title":"Medicine and Wellbeing","description":"Specialists in disease prevention and healthy aging"}}}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = {"discounts":{"meta-title":"Discounts"},"more-info-btn":"More information","firstblock":{"title":"The best quality and price for your well-being and health","subtitle":"More than 25,000 professionals and centers of recognized prestige","subtitle2":"Wellness treatments: spas, beauty centers…","title-offer-1":"Allergology consultation","price-before-1":"60€","price-after-1":"25€","subtitle-offer-1-1":"Market price","subtitle-offer-1-2":"Price with opensaludprime","subtitle-offer-1-3":"You save 35€","title-offer-2":"Gynecological ultrasound","price-before-2":"70€","price-after-2":"30€","subtitle-offer-2-1":"Market price","subtitle-offer-2-2":"Price with opensaludprime","subtitle-offer-2-3":"You save 40€","asterisk-text":"*Average prices by province. They can vary from one locality to another.","titleInvert":"No waiting lists","subtitleInvert":"Its operation is very simple, and remember that you do not have to pay anything until you go to the clinical center!","iconTitle1":"Find the service you need","iconTitle2":"Make an appointment at the center or specialist of your choice","iconTitle3":"Ready to download it!","iconTitle4":"Go to the appointment and make the payment at the center"},"secondblock":{"title":"Do you think private medicine is too expensive if you don't have health insurance? <b>You decide</b>","title-offer-1":"Psychology session","price-before-1":"55€","price-after-1":"30€","subtitle-offer-1-1":"Market price","subtitle-offer-1-2":"Price with opensaludprime","subtitle-offer-1-3":"You save {price}","title-offer-2":"Magnetic resonance","price-before-2":"220€","price-after-2":"120€","subtitle-offer-2-1":"Market price","subtitle-offer-2-2":"Price with opensaludprime","subtitle-offer-2-3":"You save 100€","title-offer-3":"Rehabilitation or physiotherapy session","price-before-3":"45€","price-after-3":"15€","subtitle-offer-3-1":"Market price","subtitle-offer-3-2":"Price with opensaludprime","subtitle-offer-3-3":"You save 30€","title-offer-4":"Biradicular endodontics","price-before-4":"200€","price-after-4":"105€","subtitle-offer-4-1":"Market price","subtitle-offer-4-2":"Price with opensaludprime","subtitle-offer-4-3":"You save 95€","asterisk-text":"*Average prices by province. They can vary from one locality to another.","titleInvert":"Advantages opensalud prime","subtitleInvert":"The best quality and price for your well-being and health","iconTitle1":"Access the best wellness and health service at reduced prices","iconTitle2":"More than 25,000 professionals, centers of recognized prestige","iconTitle3":"There are no age limitations or exclusions","iconTitle4":"The latest and most advanced medical technology","iconTitle5":"Coverage from the first day, without waiting periods","iconTitle6":"Alternative wellness treatments: spas, beauty centers..."},"bgheart":{"hire-now-with-price":"Hire for 11.95 euros/month 2 adults + 2 children included","more-info-btn":"More information"},"hire-now-with-price-2-disc":"Hire for 2.95 euros/month\n\n\nwithout permanence"}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = {"wellness":{"meta-title":"Wellness program"},"firstblock":{"title":"Can you imagine having a <b>personal trainer or meditation teacher always available</b>?","titleInvert":"Live classes every day!","subtitleInvert":"You will have multiple disciplines at your disposal based on your preferences and goals. All classes are recorded in case you prefer to watch them later.","titleInvert2":"And also the best health programs!","subtitleInvert2":"Gymnastics for pregnant women, healthy back programs, active health, stretching, mindfulness, cardiovascular or anti-stress.","videoquantity":"","videodetails":"+800 Programs, classes live and deferred","icontitle1":"","iconsubtitle1":"PHYSICAL HEALTH: GAP, HIIT, TBC, Spinning, Step Tone, Dance Tone, Sit-ups...","icontitle2":"","iconsubtitle2":"MENTAL HEALTH: Yoga, Pilates, Mindfulness, Psychology..."},"secondblock":{"titleInvert":"In addition, you will have customizable nutrition programs","iconTitle1":"Select your target","firstlistitem1":"Antistress","firstlistitem2":"Cardiovascular","firstlistitem3":"Fortify","iconTitle2":"Choose the type of diet","secondlistitem1":"Mediterranean","secondlistitem2":"Vegan","secondlistitem3":"Vegetarian","iconTitle3":"Ready to download!","title-diet-1":"Antistress","subtitle-diet-1":"Reduces anxiety levels and helps you fall asleep","title-week-1":"Week 1 - Monday","diet-1":"<b>BREAKFAST</b> <br> · 250ml Skimmed milk<br> · 50g bread<br> · Tomato<br> <br> <b>MID MORNING</b><br>· 25g Cornflakes<br>· Kefir<br>· 1 tbsp sugar-free jam<br><br> <b>LUNCH</b><br>· 50g Salad<br>· 1 Heart of Palm<br>· 150g salmon baked with basil, <br> oregano and thyme<br>· 1 Medium potato<br>· Peach<br><br> <b>SNACK</b><br>· 200ml skim milk<br>· 3 Pancakes of corn or rice<br>· ¼ avocado<br> <br> <b>DINNER</b><br>· 50g Salad: Beetroot + carrot<br>· 150g Grilled chicken<br>· 40g Quinoa<br>· 1 Orange<br><br> <b>RESOPÓN</b><br>· 200ml skimmed milk<br>· 20g Oatmeal<br>· 1 tbsp Chia Seeds","diet-subtitle-1":"Fat 40 gr<br>Protein 120 gr<br>Carbohydrates 270 gr<br><br><b>Calories 1,700 Kcal</b>","asteriskdiet-1":"*Antistress Diet - Mediterranean","title-diet-2":"Cardiovascular","subtitle-diet-2":"Improve your health, get rid of fat and help you lose weight","title-week-2":"Week 2 - Monday","diet-2":"<b>BREAKFAST</b><br> · Raspberry Smoothie Bowl: 100ml Coconut Milk + 2 Cups Frozen Raspberries + 1 Frozen Banana + 10g Chia Seeds + Shredded Coconut + 75% Chocolate grated + crushed hazelnuts<br><br><b>MID MORNING</b><br>· Green tea<br>· 1 Handful of Goji Berries<br>· 2 Rice pancakes<br><br><b>LUNCH</b><br> · 1 Stuffed Aubergine: Tomato Sauce + Onion + Textured Soy + Grated Vegetable Cheese + Olive Oil, Salt and Parsley + Sesame Seeds<br> · 2 Small Baked Potatoes<br> · 1 Apple<br><br><b>SNACK</b><br> · 1 Vegetable Yogurt + Cane Honey + 10g Chia Seeds<br> · 1 Banana<br><br><b>DINNER</b><br>· 1 Plate of Baked Rice:<br>· 130g Rice<br>· Half a tray of Mushrooms<br>· 500ml Vegetable Broth<br>· Half an Onion<br>· 2 Cloves of Garlic <br>· 1 Bay Leaf<br>· Powdered vegetable cheese<br>· 1 kiwi<br>","diet-subtitle-2":"Fat 65 gr<br>Protein 120 gr<br>Carbohydrates 250 gr<br><br><b>Calories 2,100 Kcal</b>","asteriskdiet-2":"*Cardiovascular Diet - vegan","title-diet-3":"Strengthen","subtitle-diet-3":"Helps increase muscle mass and strengthen your body","title-week-3":"Week 3 - Monday","diet-3":"<b>BREAKFAST</b><br> 1 Milkshake: 150ml Skimmed Milk + 50ml Water + 40g Oatmeal + 1 Banana + 1 Handful of Blueberries + 10g Brewer's Yeast + 10g Linseeds<br><br><b>MID MORNING</b><br> 2 Rice cakes<br> 1 Handful of Almonds<br><br><b>LUNCH</b><br> 75g Macaroni wholemeal<br> · Sauteed: Tomato + Onion + Olive oil + Textured soy + Mushrooms<br> · 1 Pear<br><br><b>SNACK</b><br> · 1 Handful of Cashews<br> · 1 Protein Yogurt<br> · Macedonia: 5 Strawberries or 10 Cherries + 1 Banana + Half an Orange<br><br><b>DINNER</b><br> · 1 Whole Wheat Pancake or Crepe: Tofu + Lettuce + Tomato + Corn + Black olives + Avocado + Light mayonnaise (optional)<br> 2 Hard-boiled eggs + Pepper + Oregano<br> 1 Glass of Kefir + Cane honey + 10g Chia Seeds","diet-subtitle-3":"Fat 65 gr<br>Protein 120 gr<br>Carbohydrates 250 gr<br><br><b>Calories 2,100 Kcal</b>","asteriskdiet-3":"*Strengthen Diet - vegetarian"},"bgheart":{"hire-now-with-price":"Hire for 11.95 euros/month 2 adults + 2 children included","more-info-btn":"More information"},"hire-now-with-price-2-2":"Hire for 2.95 euros/month\n\nwithout permanence"}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);





var Repository = function () {
	function Repository(path) {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Repository);

		this.client = function () {
			return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$api;
		};

		this.path = path;
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Repository, [{
		key: 'getAll',
		value: function getAll() {
			var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			return this.client().get('/' + this.path, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ params: criteria }, config));
		}
	}, {
		key: 'get',
		value: function get(id) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			return this.client().get('/' + this.path + '/' + id, config);
		}
	}, {
		key: 'post',
		value: function post(data) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			return this.client().post('/' + this.path, data, config);
		}
	}, {
		key: 'put',
		value: function put(id, data) {
			var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

			return this.client().put('/' + this.path + '/' + id, data, config);
		}
	}, {
		key: 'delete',
		value: function _delete(id) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			return this.client().delete('/' + this.path + '/' + id, config);
		}
	}]);

	return Repository;
}();

/* harmony default export */ __webpack_exports__["a"] = (Repository);

/***/ }),
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports) {

module.exports = {"payments":{"holdername":"Cardholder","cardnumber":"Card number","cvv":"CVV","3digits":"(Last 3 digits)","accept":"Accept payment","expiration":"Date of Expiry","errorTitle":"Error processing your payment method","errorTxt":"An error has occurred processing your payment method. \nContact your bank for more information or try again with another card.","retry":"Retry","enterHolderName":"You must enter the cardholder","enterCardNumber":"You must enter the card number","selectMonth":"You must select the expiration month of the card","selectYear":"You must select the expiration year of the card","enterCvv":"You must enter the CVV of the card","weInform1":"We inform you that in","weInform2":"minutes the session will expire and you will not be able to carry out any transaction.","expiredTitle":"Session expired","expiredTxt":"We inform you that the session has expired and therefore you cannot complete the transaction. <br> <br> Close this tab and repeat the action again.","year":"Year","acceptTerms":"You must accept the terms and conditions","billingData":"Billing information","billingEntity":"Billing entity","billingAddress":"Address","billingCountry":"Country","billingNif":"NIF/NIE","billingProvince":"Province","billingVillage":"Village","billingPostalCode":"Zip code","billingInfo":"To complete your purchase and generate the invoice, you must complete the following fields:","buySummary":"Purchase summary","price":"Price","product":"Product","appointmentPendingPayment":"Consultation pending payment","flatRate":"Flat rate written consultation and chat","teleconsultationBono":"Teleconsultation bonus","errorPayment":"Change of payment method due to collection failure","plusRate":"Plus Rate","authorizePayment":"Authorize payment","payment":"Pay","paymentAdvice1":"In the case of transactions carried out in a currency other than the euro, there may be additional currency exchange charges.","fiscalData1":"Open Healthcare S.L.    CIF: B90209081","fiscalData2":"Avda. República Argentina 25 9th floor","fiscalData3":"(Seville, Spain) CP 41011","fiscalData4":"info@opensalud.es      656383230","priceWithDiscount":"Discounted price","couponQuestion":"Redeem discount code","discountCoupon":"discount coupon","verify":"Verify","selectPaymentMethod":"Select a payment method","bizum":"Bizum","debitCreditCard":"Credit/debit card","confirmPayment":"Confirm payment","bizumBanner":"Next you must enter your phone number to make the payment through bizum. \nYou must have this functionality enabled in your bank.","bizumDirectBanner":"To make the payment to the professional, you must send a bizum to the number that will appear on the screen, after clicking on the green button that appears below. \nIndicate in the subject the type of query and your full name. \n<br><br><b>In the event that we cannot verify the payment, the consultation will be cancelled.</b>","bizumDirectDialog":"You must make the bizum to the telephone number shown on the screen.<br><br><b>If the professional does not confirm receipt of it, the consultation will be cancelled.</b><br><br><b>Telephone :</b>{phone}","invalidCode":"The code is invalid","appliedDiscount":"A discount of {discount} % has been applied","discount":"Discount","mustInsertCode":"You must enter a valid discount code","free":"FREE","ePrescriptionTax":"An additional €0.5 (50 cents) will be pre-authorized corresponding to the cost of a prescription in electronic format (it does not need to be printed).<br><br> If the doctor does not ultimately write the prescription in electronic format, he or she will not be charged. said amount.","confirmPendingPayment":"Your pending payment query has been successfully authorized.","confirmErrorPayment":"Your payment method has been successfully updated.","successPayment":"Your appointmenthas been confirmed.","confirmChangePaymentMethod":"Your payment method has been changed successfully","confirmGiftPayment":"Your gift voucher has been processed and sent successfully.","confirmFlatRatePayment":"Your subscription has been successfully contracted","confirmServicesPackagesPayment":"Your service package has been successfully contracted"}}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = {"terms-conditions":"terms and conditions","contact":"Contact","legal-notice":"Legal notice","faqs":"Frequently asked questions","cookies-policy":"Cookies policy","privacy-policy":"Privacy Policy","sgsi-policy":"SGSI Policy","login":{"iam-professional":"I'm a professional"}}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = {"medical-assistance":{"meta-title":"Online medical assistance"},"title":"Free choice of the best professionals, at any time and from anywhere","general":"General Medicine and Family","pediatrics":"Pediatrics","alert":"Receive the recipe on your mobile!","hire-now-with-price":"Hire for 11.95 euros/month 2 adults + 2 children included","more-info-btn":"More information"}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = {"payments":{"holdername":"Titular da tarjeta","cardnumber":"Número da tarjeta","cvv":"CVV","3digits":"(3 últimos dígitos)","accept":"Aceitar pagamento","expiration":"Data de caducidade","errorTitle":"Erro ao processar seu método de pagamento","errorTxt":"Houve um erro ao processar seu método de pagamento.<br> Entre em contato com seu banco para obter mais informações ou intenções de novo com outro cartão.","retry":"Reinventar","enterHolderName":"Deve apresentar o titular da tarjeta","enterCardNumber":"Você deve inserir o número da tarjeta","selectMonth":"Você deve selecionar o mês de caducidad da tarjeta","selectYear":"Você deve selecionar o ano de caducidade da tarjeta","enterCvv":"Você deve apresentar o CVV da sua tarjeta","weInform1":"Le informamos que en","weInform2":"A sessão expirará em minutos e nenhuma transação poderá ser realizada.","expiredTitle":"Sessão expirada","expiredTxt":"Informamos que a sessão expirou e por consiguiente não é possível concluir a transação.<br><br> Feche esta pestana e repita a ação de novo.","year":"Ano","acceptTerms":"Você deve aceitar os termos e condições","billingData":"Informações de pagamento","billingEntity":"Entidade de cobrança","billingAddress":"Endereço","billingCountry":"País","billingNif":"NIF/NIE","billingProvince":"Província","billingVillage":"Aldeia","billingPostalCode":"CEP","billingInfo":"Para finalizar sua compra e gerar a fatura, você deverá preencher os seguintes campos:","buySummary":"Resumo da compra","price":"Preço","product":"Produto","appointmentPendingPayment":"Consulta pendente de pagamento","flatRate":"Consulta escrita e bate-papo com taxa fixa","teleconsultationBono":"Bônus de teleconsulta","errorPayment":"Alteração da forma de pagamento por falha na cobrança","plusRate":"Taxa adicional","authorizePayment":"Autorizar pagamento","payment":"Pagar","paymentAdvice1":"No caso de transações realizadas numa moeda diferente do euro, poderão existir encargos cambiais adicionais.","fiscalData1":"Open Healthcare S.L.    CIF: B90209081","fiscalData2":"Av. República Argentina 25 9º andar","fiscalData3":"(Sevilha, Espanha) CP 41011","fiscalData4":"info@opensalud.es      656383230","priceWithDiscount":"Preço com desconto","couponQuestion":"Resgatar código de desconto","discountCoupon":"cupom de desconto","verify":"Verificar","selectPaymentMethod":"Selecione um método de pagamento","bizum":"Bizum","debitCreditCard":"Cartão de crédito/débito","confirmPayment":"Confirmar pagamento","bizumBanner":"A seguir você deve inserir seu número de telefone para efetuar o pagamento através do bizum. \nVocê deve ter esta funcionalidade habilitada em seu banco.","bizumDirectBanner":"Para efetuar o pagamento ao profissional, você deve enviar um bizum para o número que aparecerá na tela, após clicar no botão verde que aparece abaixo. \nIndique no assunto o tipo de consulta e seu nome completo. \n<br><br><b>Caso não consigamos verificar o pagamento, a consulta será cancelada.</b>","bizumDirectDialog":"Você deverá fazer o bizum para o número de telefone mostrado na tela.<br><br><b>Caso o profissional não confirme o recebimento do mesmo, a consulta será cancelada.</b><br><br>< b>Telefone:</b>{telefone}","invalidCode":"O código é inválido","appliedDiscount":"Um desconto de: {discount} %","discount":"Desconto","mustInsertCode":"Você deve inserir um código de desconto válido","free":"LIVRE","ePrescriptionTax":"Será pré-autorizado um adicional de 0,5€ (50 cêntimos) correspondente ao custo de uma receita em formato eletrónico (não necessita de ser impressa).<br><br> Se o médico não passar a receita em formato eletrónico formato, ele não será cobrado por esse valor.","confirmPendingPayment":"Sua consulta de pagamento pendente foi autorizada com sucesso.","confirmErrorPayment":"Sua forma de pagamento foi atualizada com sucesso.","successPayment":"Sua consulta foi confirmada.","confirmChangePaymentMethod":"Sua forma de pagamento foi alterada com sucesso","confirmGiftPayment":"Seu vale-presente foi processado e enviado com sucesso.","confirmFlatRatePayment":"Sua assinatura foi contratada com sucesso","confirmServicesPackagesPayment":"Seu pacote de serviços foi contratado com sucesso"}}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OPENHEALTHCARE_COMPANY_NAME */
/* unused harmony export OPENLEGAL_COMPANY_NAME */
/* unused harmony export OPENHEALTHCARE_COMPANY_ADDRESS */
/* unused harmony export OPENLEGAL_COMPANY_ADDRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRIVACY_POLICY_COMPANY_DATA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_platformNames__ = __webpack_require__(49);


var OPENHEALTHCARE_COMPANY_NAME = 'OPENHEALTHCARE S.L.';
var OPENLEGAL_COMPANY_NAME = 'OPENLEGAL S.L.';

var OPENHEALTHCARE_COMPANY_ADDRESS = 'Avda. República Argentina 25 9ª planta, 41011 Sevilla';
var OPENLEGAL_COMPANY_ADDRESS = 'C/ Puente Verde 4, 18008 Granada';

var PRIVACY_POLICY_COMPANY_DATA = !Object(__WEBPACK_IMPORTED_MODULE_0__constants_platformNames__["j" /* inOpenlegal */])() ? {
	companyName: OPENHEALTHCARE_COMPANY_NAME,
	address: OPENHEALTHCARE_COMPANY_ADDRESS,
	platformName: 'Opensalud'
} : {
	companyName: OPENLEGAL_COMPANY_NAME,
	address: OPENLEGAL_COMPANY_ADDRESS,
	platformName: 'Openlegal'
};

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = function client() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    sendWhoInData: function sendWhoInData(data) {
        return client().post('forum/createWhoInEntry', data);
    },
    editWhoInEntry: function editWhoInEntry(data) {
        return client().put('forum/editWhoInEntry', data);
    },
    updateWhoInParticipant: function updateWhoInParticipant(data) {
        return client().put('forum/UpdateWhoInParticipant', data);
    },
    getActivities: function getActivities(forSearch, otherActivitiesGrouped) {
        return client().get('forum/activities', { params: { forSearch: forSearch, otherActivitiesGrouped: otherActivitiesGrouped } });
    },
    getActivitiesLevel: function getActivitiesLevel() {
        return client().get('forum/activitiesLevel');
    },
    searchActivity: function searchActivity(params) {
        return client().get('forum/searchActivity', { params: params });
    }
});

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = {"openlegal":{"home-footer":{"derecho-penal":"Criminal law","derecho-fiscal-tributario":"Fiscal and tax law","derecho-constitucional":"Constitutional law","procesal-civil-penal":"Civil and criminal procedure","derecho-laboral":"Labor law","derecho-administrativo":"Administrative law","derecho-civil":"Civil law","derecho-familia":"Family law","derecho-sucesiones-herencias":"Succession and inheritance rights","derecho-mercantil":"Commercial law","derecho-internacional-privado":"Private international law","derecho-navegacion-maritima-aerea":"Fiscal and tax law1","derecho-urbano":"Urban law","derecho-bancario":"Banking law","corporate-compliance":"Corporate compliance","derecho-transporte":"Transport law","derecho-privacy":"Right to privacy or data protection","derecho-consumo":"Consumer law","derecho-farmaceutico":"Fiscal and tax law8","propiedad-intelectual":"Intellectual property","derecho-agrario":"Constitutional law0","derecho-seguridad-social":"Rights to social security","derecho-agua":"Constitutional law2","derecho-extranjeria":"Foreign law","derecho-militar":"Military law","derecho-europeo":"Constitutional law5","derecho-deporte":"Sports law","comercio-exterior":"Constitutional law7","derecho-aeronautico":"Air or aeronautical law","derecho-menores":"Juvenile jurisdiction","derecho-ambiental":"Environmental law","division-bienes":"Civil and criminal procedure1","arrendamientos-propiedad-horizontal":"Leasing law","defectos-construccion":"Civil and criminal procedure3","concurso-acreedores":"Civil and criminal procedure4","derecho-hipotecario":"Mortgage law","derecho-marcas":"Civil and criminal procedure6","derecho-autor":"Civil and criminal procedure7","derechos-editoriales":"Civil and criminal procedure8","derecho-eclesiastico":"Civil and criminal procedure9","empredimiento-startups":"Labor law0","asistencia-testigos":"Labor law1","asistencia-detenido":"Assistance to the detainee","especialistas-franquicias":"Labor law3","derecho-sanitario":"Health law","derecho-tercer-sector":"Labor law5","licencia-actividad":"Labor law6","recurso-casacion":"Labor law7","derecho-digital-imagen":"Digital and image law","derechos-humanos":"Human rights","client-conditions":"Conditions for clients","derecho-internacional-publico":"Public international law","derecho-contratos":"Contract law","pension-alimentos":"Alimony","pension-compensatoria":"Compensatory pension","juicio-delito-leve":"Misdemeanor Trial","juicio-rapido":"Quick judgment","derecho-penitenciario":"Penitentiary law","derecho-maritimo":"Maritime law"}}}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"More info","learn-more-btn":"Learn more","main-block-h1":"We collaborate with NGOs to offer telemedicine to vulnerable communities anywhere in the world.","section-one":{"title":"Opensalud4all is an initiative that arises to channel the solidarity activities of the\n\nhealth professionals who wish to offer their services to NGOs working in areas with\n\nlimited access to health services, using telemedicine.","subtitle":"Without the need to travel, at any time and from anywhere, doctors\n\nand psychologists who use opensalud, can care for patients or provide support to\n\nlocal health professionals, through telemedicine."},"how-work-btn":"How does it work","section-two":{"title":"Are you a doctor or psychologist?","list":{"1":"Opensalud4all works with health professionals who\n\ndonate their time and knowledge to provide assistance\n\nquality clinic in vulnerable communities with limited\n\naccess to health services anywhere in the world.","2":"All clinical support is through telemedicine through\n\nof the opensalud platform, which serves as a channel to serve\n\ndirectly to patients or to provide support through\n\nconsultations with local clinical teams. \nthis support\n\nclinician is extensible to the field staff of the\n\nNGOs.","3":"Being vocational professions motivated by the desire to\n\ntake care of the health of others, there is a great\n\npredisposition of health professionals to\n\ncollaborate with disadvantaged communities, but the\n\ngeographic or functional barriers made it difficult.","4":"To thank the volunteers for their collaboration and eliminate\n\nany hint of economic interest, the professionals\n\nthat collaborate with the initiative will be able to use the platform\n\nopensalud for your usual clinical practice without paying\n\nno fee."}},"colaborate-btn":"If you want to know how you can collaborate, contact us","section-cero":{"subtitle":"If you want to contribute a small part of your time to attend remotely to\n\npatients in vulnerable areas, request information.","subtitle-2":"If you are an NGO working in communities with limited access to health resources\n\ncontact us","ong":"I am an NGO","medicpsico":"I am a doctor or psychologist"},"form":{"contry":"country of residence","specialities":"Specialty","languages":"Languages"},"user":{"prof":"Health professional","ong":"NGO","another":"Others"},"formHelp":{"selectUser":"Select Entity","ongName":"Name of the NGO"}}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Mais informação","learn-more-btn":"Ler mais","main-block-h1":"Colaboramos com ONGs para oferecer telemedicina a comunidades vulneráveis ​​em qualquer lugar do mundo.","section-one":{"title":"Opensalud4all é uma iniciativa que surge para canalizar as atividades solidárias do\n\nprofissionais de saúde que desejam oferecer seus serviços a ONGs que atuam em áreas com\n\nacesso limitado aos serviços de saúde, por meio da telemedicina.","subtitle":"Sem a necessidade de viajar, a qualquer hora e de qualquer lugar, os médicos\n\ne psicólogos que usam o opensalud, podem cuidar de pacientes ou dar apoio a\n\nprofissionais de saúde locais, por meio da telemedicina."},"how-work-btn":"Como funciona","section-two":{"title":"Você é médico ou psicólogo?","list":{"1":"Opensalud4all trabalha com profissionais de saúde que\n\ndoar seu tempo e conhecimento para fornecer assistência\n\nclínica de qualidade em comunidades vulneráveis ​​com\n\nacesso a serviços de saúde em qualquer lugar do mundo.","2":"Todo o apoio clínico é feito através de telemedicina através\n\nda plataforma opensalud, que serve como canal para atender\n\ndiretamente aos pacientes ou para fornecer suporte por meio de\n\nconsultas com equipes clínicas locais. \nEste suporte\n\na prática clínica é extensível ao pessoal da área de\n\nONGs.","3":"Sendo profissões vocacionais motivadas pelo desejo de\n\ncuidar da saúde dos outros, há uma grande\n\npredisposição dos profissionais de saúde para\n\ncolaborar com comunidades desfavorecidas, mas o\n\nbarreiras geográficas ou funcionais dificultavam.","4":"Agradecer aos voluntários pela colaboração e eliminar\n\nqualquer indício de interesse econômico, os profissionais\n\nque colaborarem com a iniciativa poderão utilizar a plataforma\n\nopensalud para sua prática clínica habitual sem pagar\n\nsem taxa."}},"colaborate-btn":"Se quiser saber como pode colaborar, contacte-nos","section-cero":{"subtitle":"Se você quiser contribuir com uma pequena parte do seu tempo para atender remotamente\n\npacientes em áreas vulneráveis, solicite informações.","subtitle-2":"Se você é uma ONG que trabalha em comunidades com acesso limitado a recursos de saúde\n\nContate-Nos","ong":"Eu sou uma ONG","medicpsico":"Eu sou um médico ou psicólogo"},"form":{"contry":"País de residência","specialities":"Especialidade","languages":"línguas"},"user":{"prof":"Profissional de saúde","ong":"ONG","another":"Outros"},"formHelp":{"selectUser":"Selecionar entidade","ongName":"Nome da ONG"}}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Mais info","learn-more-btn":"Ler mais","upper-header-subtitle":"TELEMEDICINA","header-title":"Cuide-se. \nSempre","subtitle-list-1":"Acesso ilimitado a consultas médicas e pediátricas online.","subtitle-list-2":"Plataforma abrangente de saúde e bem-estar incluída.","subtitle-list-3":"Acesso premium a serviços de saúde privados.","hire-now":"Contratar ahora","hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños","price-cards":{"title":"Consultas online incluidas","subtitle":"Sin coste adicional los mejores especialistas los 7 días de la semana.","content":"Los mejores servicios clínicos de más de 25.000 profesionales y centros, con un precio muy reducido.","subcontent":"Gimnasio online, meditación, programas de salud y mucho más.","monthly":"Mensual**","per-family":"por familia*","hire":"Contratar","family-label":"*Familia: Cónyuge/pareja e hijos menores de edad.","monthly-label":"**Compromiso de permanencia  mínimo de 3 meses.","medic-services-discount":"Descuento en servicios médicos","wellness-services":"Serviços de bem-estar","medic-services":"Servicios médicos","tooth-services":"Serviços odontológicos","pediatry-services":"Servicios de pediatría","dermatology-services":"Servicios de dermatología","traumatology-services":"Servicios de traumatología","endocrinology-services":"Servicios de endocrinología","permanency":"Compromiso de permanencia de 3 meses","family":"Familia: Cónyuge/pareja e hijos menores de edad","soon":"Próximamente","table":{"title":"Nuestros planes","subtitle":"Tenemos planes ajustados a todas las necesidades familiares","wellness":"Plataforma de bienestar y salud","service-discounts":"Descuentos en servicios médicos privados","online-family-medic":"Médico de familia online","online-pediatrics":"Pediatría online","online-dermatology":"Dermatología online","online-traumatology":"Traumatología online","online-endocrinology":"Endocrinología online","title1":"El plan mas completo con todas nuestras especialidades","per-month":"por mes*","header":"Opción más popular","title2":"La tranquilidad de tener a un médico general y un pediatra disponible los 7 días de la semana","title3":"Disfruta de servicios clínicos privados con descuentos y accede a nuestra plataforma de salud y bienestar"}},"cards":{"1":{"title":"Los mejores","subtitle":"Cuida tu salud y la de los tuyos con los mejores médicos y la mejor tecnología disponible"},"2":{"title":"Precio a tu medida","subtitle":"Planes accesibles con la mayor calidad y tranquilidad en nuestros servicios de telemedicina"},"3":{"title":"Cuadro médico","subtitle":"Tendrás un extenso cuadro de especialistas, clínicas y centros médicos para asegurarte la mejor atención médica"},"title":"Consulta online a los mejores profesionales de medicina general y pediatría"},"medical-assistance":{"title":"Assistência médica on-line","subtitle":"Disponível 365 dias por ano com livre escolha de médico de família e pediatra por vídeo, telefone ou chat com prescrição eletrónica, agenda de saúde, histórico médico, lembretes...","content":"Inclui dois adultos e duas crianças com consultas ilimitadas todos os dias do ano.","available-consultations":"Tipos de consulta disponíveis:","video":"Consulta de vídeo","phone-attention":"Atendimento telefónico","written-consultation":"Consulta escrita","chat":"Chat","electronic-prescription":"Receta electrónica","safe-coms":"La seguridad de las comunicaciones y la privacidad de los datos son nuestra prioridad."},"discounts":{"title":"Descontos em serviços clínicos privados","subtitle":"Se precisa de um teste e não quer esperar<br /><br />Acesso à maior lista de serviços de saúde de Espanha com mais de 25.000 profissionais e centros com descontos até 60% em consultas, intervenções, exames , tratamentos, produtos e serviços de saúde:","clinic-services":"Serviços clínicos","clinic-services-description":"Permite o acesso aos médicos e centros médicos que compõem o Corpo Médico do Serviço 'AVANTSALUD':","close":"Fechar","teeth-services-description":"Este serviço inclui determinados serviços dentários gratuitos e acesso a uma Lista de Médicos a preço reduzido. \nOs serviços odontológicos gratuitos são:","health-services-description":"Inclui determinados serviços relacionados com o bem-estar e a saúde em especialidades normalmente não incluídas nos seguros de saúde, tais como:","medical-services-list":"Consultas de medicina primária (medicina geral e pediatria)<br> Consultas especializadas<br> Médicos diagnósticos<br> Tratamentos médicos<br> Hospitalização e intervenções cirúrgicas<br> Serviços médicos<br> Alergologia<br> Anatomia patológica<br > Angiologia e cirurgia vascular<br> Aparelho digestivo<br> Cardiologia<br> Cirurgia cardiovascular<br> Cirurgia geral e aparelho digestivo<br> Cirurgia da mama<br> Cirurgia maxilofacial<br> Cirurgia oncológica<br> Cirurgia pediátrica<br> Plástica e reconstrutiva cirurgia<br> Cirurgia torácica<br> Cirurgia vascular<br> Dermatologia e venereologia<br> Endocrinologia e nutrição<br> Enfermagem<br> Hematologia e hemoterapia<br> Nefrologia<br> Pneumologia<br> Neurocirurgia<br > Neurofisiologia clínica <br> Neurologia<br> Obstetrícia e Ginecologia<br> Oftalmologia<br> Oncologia Médica<br> Radiooncologia<br> Otorrinolaringologia<br> Reabilitação<br> Reumatologia<br> Traumatologia e Ortopedia<br> Urologia<br> br > Medicina geral<br> Pediatria<br> Pediatria-Puericultura<br> Clínicas e Hospitais<br> Policlínicas<br> Campimetria<br> Panorâmica/Ortopantomografia<br> Ultrassonografias<br> Mamografias<br> Tomografia computadorizada<br> Análise clínico<br> Diagnóstico por imagem<br> Medicina nuclear","teeth-services-list":"Primeira visita e entrega do orçamento<br> Visita de revisão<br> Educação oral<br> Ensino de técnicas de escovação<br> Fluoretação<br> Limpeza bucal anual. \nTartrectomia<br> Radiografias dentárias (periapical, retalho, oclusal)<br> Diagnóstico e sondagem<br> Ajustes oclusais<br> Remoção de pontos<br> Estudo implantológico<br> Falso coto de titânio<br> Parafuso de cicatrização e cimentação <br>","health-services-list":"Acupuntura/Homeopatia/Naturopatia<br> Avantsalud en forma<br> Spas<br> Centros de reconhecimento<br> Cirurgia refrativa oftalmológica a laser<br> Conceito Bobath<br> Conservação de células do cordão-tronco<br> Dermatoscopia digital<br> Dietética< br> Ultrassonografias 3D e 4D<br> Estética<br> Fisioterapia e fisioterapia infantil<br> Hidroterapia do cólon<br> Medicina Preventiva e Testes Genéticos<br> Óptica e Aparelhos Auditivos<br> Ortopedia<br> Osteopatia<br> Planos com crianças<br> Estudo de Podologia e Pegada<br> Serviços de atendimento domiciliar (atendimento pós-parto)<br> Procedimentos minimamente invasivos<br> Psicologia, pedagogia e fonoaudiologia<br> Quiropraxia<br> Reabilitação cardíaca<br> Terapia assistida com animais< br> Tratamentos para parar de fumar<br> Tratamentos de infertilidade<br> Tratamento por ondas de choque (disfunção erétil)<br> Veterinários<br> Miopia a laser, astigmatismo, hipermetropia<br> Podologia em casa<br> Análise em casa<br> Fisioterapia em casa<br> Prevenção do câncer cervical/HPV<br> Teste genético cardiológico<br> Rastreamento de sangue para câncer de cólon<br> Teste genético de obesidade<br> Teste genético de câncer de pulmão<br > Exame oncológico<br> Teste genético de Alzheimer<br> Tromboembolismo teste genético<br> Teste genético para diabetes tipo II<br> Teste genético para câncer de mama<br> Teste pré-natal não invasivo<br> Pré-eclâmpsia<br> Teste de paternidade<br> Impressão digital genética<br> Teste de intolerância alimentar<br> Degeneração macular teste<br> Sexo fetal no sangue materno<br> Teste de erva-cidreira<br> Teste de enxaqueca<br> Lactose - teste de intolerância à frutose<br> Balão gástrico<br> br> Endoscopia por cápsula<br> Laser verde de próstata<br> Laser em dermatologia<br> Laser/endolaser vascular<br> Cirurgia percutânea do pé<br> Vasectomia sem bisturi<br> Blefaroplastia<br> Abdominoplastia<br> Rinoplastia<br> br> Lifting<br> Microenxertos capilares<br> Mamoplastia de aumento <br> Mamoplastia redutora<br> Cirurgia íntima<br> Lipoaspiração<br>"},"wellness":{"title":"Plataforma de Saúde e Bem-Estar","subtitle":"Com aulas diárias ao vivo e gravadas de mindfulness, Pilates, yoga, programas de saúde, workshops, nutrição e muito mais.","mindfulness":"Mindfulness","pilates":"Pilates","healthy-back":"Costas Saudáveis","cardio":"Academia on-line","nutrition":"Nutrição","vitality":"Dose de Vitalidade"},"hire-now-with-price-2":"Alugue por 2,95 euros/mês\n\nSem Telemedicina, ou permanência","healthappyrest":{"title":"Adicione saúde mental, felicidade e descanso à sua vida","psico":"Masterclass em psicologia, mindfulness e programas de sono","yoga":"Aulas de ioga e pilates","relax":"Áudios relaxantes, dicas e curiosidades","premium":"Acesso premium a serviços de saúde privados"},"buy-btn":"MAIS INFORMAÇÃO","familiar":{"title":"FAMÍLIA","text":"3 meses de estadia","subtitle":"<b>Médico e pediatra online grátis (2 adultos 2 crianças)</b>","subtitle1":"Plataforma completa de saúde e bem-estar","subtitle2":"Acesso premium a serviços de saúde privados","subtitlesingle":"<b>Médico e pediatra on-line gratuito</b>"},"healthmind":{"title":"SAÚDE E BEM-ESTAR","pricing":"2,95€","text":"sem permanência","subtitle":"Plataforma completa de saúde e bem-estar","subtitle1":"Acesso premium a serviços de saúde privados"},"pricing":{"title":"Nossos planos"},"video-corporative":"vídeo que fazemos","hire-now-with-price-2-2":"Alugue por 2,95 euros/mês\n\n\nsem permanência","see-plans":"Ver planos","rent":"contrato"}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 540 */,
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(1079);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31308b7e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(1664);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1662)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31308b7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31308b7e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/dropdown/Dropdown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31308b7e", Component.options)
  } else {
    hotAPI.reload("data-v-31308b7e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 542 */,
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var api = function api() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

function path(resource) {
  return '/healthyHabits/' + resource;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getTableData: function getTableData(limitDate, prevDates, allData, historyPatientId) {
    return api().get(path('table'), { params: { limitDate: limitDate, prevDates: prevDates, allData: allData, historyPatientId: historyPatientId } });
  },
  updateTableData: function updateTableData(data) {
    return api().put(path('table'), data);
  },
  removeTableData: function removeTableData(data) {
    return api().delete(path('table'), data);
  },
  getStatistics: function getStatistics(id, historyPatientId) {
    return api().get(path('statistic'), { params: { id: id, historyPatientId: historyPatientId } });
  },
  getUserSetting: function getUserSetting() {
    return api().get(path('setting'));
  },
  updateSetting: function updateSetting(nick, notificationsEmail, notificationsPhone, showStoredHabits, showGoalCompletedHabits, allowFreeDays, invertedCalendarDays) {
    return api().put(path('setting'), { nick: nick, notificationsEmail: notificationsEmail, notificationsPhone: notificationsPhone, showStoredHabits: showStoredHabits, showGoalCompletedHabits: showGoalCompletedHabits, allowFreeDays: allowFreeDays, invertedCalendarDays: invertedCalendarDays });
  },
  updateFormData: function updateFormData(data) {
    return api().put(path('dataForm'), data);
  },
  createDataForm: function createDataForm(data) {
    return api().post(path('dataForm'), data);
  }
});

/***/ }),
/* 544 */,
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_GtagIframe_vue__ = __webpack_require__(1307);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'gtag-iframe': __WEBPACK_IMPORTED_MODULE_0__components_utils_GtagIframe_vue__["a" /* default */]
  },
  data: function data() {
    return {
      locale: 'es',
      sidebar: {
        show: false,
        video: false,
        audio: false
      }
    };
  },

  watch: {
    // locale (val) {
    //   this.$i18n.locale = val
    // }
  },
  methods: {
    setLocale: function setLocale(listlocale) {
      // this.locale = listlocale
      this.$i18n.locale = listlocale;
    },
    showVideo: function showVideo() {
      this.sidebar.video = true;
      document.getElementById('rightMenu').style.display = 'block';
    },
    hideVideo: function hideVideo() {
      this.sidebar.video = false;
    },
    setVideoQualityHigh: function setVideoQualityHigh() {
      this.$store.commit('setVideoQuality', 1);
    },
    setVideoQualityMedium: function setVideoQualityMedium() {
      this.$store.commit('setVideoQuality', 2);
    },
    setVideoQualityLow: function setVideoQualityLow() {
      this.$store.commit('setVideoQuality', 3);
    },
    muteVideo: function muteVideo() {
      this.$store.commit('disableVideo');
    },
    shareScreen: function shareScreen() {
      this.$store.commit('toggleShareScreen');
    }
  },
  mounted: function mounted() {
    /* window.addEventListener('orientationchange', this.$store.commit('setIsDesktop'))
    window.addEventListener('resize', this.$store.commit('setIsDesktop')) */
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_domains__ = __webpack_require__(163);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'gtag-iframe',
    computed: {
        inOpensaludES: function inOpensaludES() {
            return window.location.host.includes(__WEBPACK_IMPORTED_MODULE_0__constants_domains__["g" /* OPENSALUD_ES_DOMAIN */]);
        }
    }
});

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */
/***/ (function(module, exports) {

module.exports = {"groups":{"common-questions":"Common questions"},"faqs":{"existe-algun-tipo-de-publicidad-directa-o-indirecta":""}}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"private-layout":{"my-profile":"My profile","health-data":"Health data","chats":"Chats","my-consultations":"My consultations","my-agenda":"My schedule","my-professionals":"My team","search":"Make appointment","change-user":"Change user","questions":"Doubts","logout":"Sign off","evaluate-your-health":"Evaluate your health","habits-challenges":"My goals and habits","healthy-community":"Healthy community","log-off":"Sign off","appointment-request":"Requests and quotes","chats-interconsultation":"Chats-Interconsultations","dashboard":"Control panel","my-invoices":"My bills","my-patients":"my patients","my-requests":"My requests","my-services":"My services","my-profile-services":"My profile","patients-like-you":"Patients like you","activeChats":"Active chats","home":"Home","healthy-foods":"Healthy eating","services":"My services","physiotherapy":"Digital physiotherapy","my-apps":"My applications","who-signs-up":"Who signs up?","idle-time-warning":"We inform you that in 5 minutes your session will be closed by inactivity.\nPlease interact with this window if it is still active."}}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {"simple-search":{"in-person-visit":"In-person visit","online":"Online","appointment-type":"","search":"Buscar","private-appointment":"PRIVATE CONSULTATION","insurance-appointment":"INSURANCE CONSULTATION","select-specialty-professional-or-service":"You must select a specialty, professional or medical exam.","location":"Province/Locality","select-specialty-or-service":"You must first select a specialty or medical exam.","inplace-without-location-warning":"You have selected in-person consultation, if you want a video consultation you must select online consultation. ","no-locations-dialog-warning":"The selected professional has no face -to -face consultation service. \nDo you want to request any of the online services?","select-location":"Since he has selected face -to -face appointment, he must indicate the province/locality. If you want an online query, select the <img width=\"17\" height=\"17\" src=\"/static-appopensalud/img/icons/services/video.svg\"/> <span style=\"color: #3238C4\">ONLINE</span> button"}}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = {"learn-more-btn":"Learn more","title-big-1":"We want to take care of you. Always","title-big-2":"What advantages does opensalud 360 offer?","title-big-3":"How does it work?","title-big-4":"Contact us","title-small-1":"The comprehensive health and well-being platform","title-small-2":"No waiting, wherever you are","title-small-3":"Comfort and security","title-small-4":"The best health programs","title-small-5":"Sign up in openhealth","title-small-6":"Sign in and choose your service","title-small-7":"Indicate the reason for your consultation","title-small-8":"Log in to the professional","text-1":"Access the best professionals and health programs, at any time and from anywhere.","text-1-sm":"opensalud 360 is a health platform for individuals, companies and groups, which allows its users to access the best health professionals, at any time and from anywhere.","text-2":"In your home, workplace or even a hotel, access some of the best specialists by video, phone or chat. You can receive your prescription directly on your mobile.","text-3":"Avoid risks, inconveniences and costs for you and your family, limiting trips to medical centers, emergencies ... you postpone health care due to lack of time.","text-4":"Tailored content, online gym, live mindfulness, Pilates, cardiovascular, pregnant, healthy back classes ... among many other services.","text-5":"Include the code, policy number or booking number provided","text-6":"Select the service and the professional you need using the search engine","text-7":"Add some health data, attaching images or reports if you wish","text-8":"Receive your report and prescription. At the end you will be able to evaluate the service","text-9":"If you want your employees or clients to access the best digital health services (40 medical specialities, psychology and nutrition) contact us","text-9-sm":"If you want your employees or clients to access the best digital health services (40 medical specialities, psychology and nutrition) contact us","specialty":"Specialty","appointment-type":"Consultation type","discounts":{"clinic-services":"clinical services","clinic-services-description":"It allows access to doctors and medical centers that make up the Medical List of the 'AVANTSALUD' Service:","close":"To close","health-services-description":"It includes certain services related to well-being and health in specialties not usually included in health insurance, such as:","health-services-list":"Acupuncture/Homeopathy/Naturopathy<br> Avantsalud in shape<br> Spas<br> Examination centers<br> Ophthalmological laser refractive surgery<br> Bobath Concept<br> Cord Stem Cell Conservation<br> Digital Dermatoscopy<br> Dietetics<br> 3D and 4D ultrasounds<br> Aesthetics<br> Physiotherapy and child physiotherapy<br> Colon hydrotherapy<br> Preventive Medicine and Genetic Testing<br> Optics and Hearing Aids<br> Orthopedics<br> Osteopathy<br> Plans with children<br> Podiatry and Footprint Study<br> Home care services (postpartum care)<br> Minimally invasive procedures<br> Psychology, pedagogy and logophoniatry<br> Chiropractic<br> Cardiac rehabilitation<br> Therapy assisted with animals<br> Smoking cessation treatments<br> Infertility treatments<br> Shock wave treatment (erectile dysfunction)<br> Veterinarians<br> Laser myopia, astigmatism, hyperopia<br> Podiatry at home<br> Analytics at home<br> Physiotherapy at home \nlio<br> Prevention of cervical cancer/HPV<br> Cardiological genetic test<br> Screening for colon cancer in blood<br> Genetic test for obesity<br> Genetic test Lung cancer<br> Oncological check-up<br> Test Genetic Alzheimer's<br> Genetic thromboembolism test<br> Genetic test Type II Diabetes<br> Genetic test Breast cancer<br> Non-invasive prenatal test<br> Preeclampsia<br> Paternity test<br> Genetic fingerprint<br> Test of food intolerance<br> Macular degeneration test<br> Fetal sex in maternal blood<br> Melissa test<br> Migraine test<br> Lactose - fructose intolerance test<br> Gastric balloon<br> Endoscopic capsule<br> Green prostate laser<br> Laser in dermatology<br> Vascular/endolaser laser<br> Percutaneous foot surgery<br> No-scalpel vasectomy<br> Blepharoplasty<br> Abdominoplasty<br> Rhinoplasty<br> Lifting<br> Micrografts capillaries<br> Augmentation mammoplasty<br> Reduction mammoplasty<br> Intimate surgery<br> Liposuction<br>","medical-services-list":"Primary medicine consultations (general medicine and paediatrics)<br> Specialist consultations<br> Diagnostic doctors<br> Medical treatments<br> Hospitalization and surgical interventions<br> Medical services<br> Allergology<br> Pathological anatomy<br> Angiology and vascular surgery<br> Digestive system<br> Cardiology<br> Cardiovascular surgery<br> General surgery and Digestive system<br> Breast surgery<br> Maxillofacial surgery<br> Oncological surgery<br> Pediatric surgery<br> Plastic and reconstructive surgery<br> Thoracic surgery<br> Vascular surgery<br> Dermatology and venereology<br> Endocrinology and nutrition<br> Nursing<br> Hematology and hemotherapy<br> Nephrology<br> Pulmonology<br> Neurosurgery<br> Clinical neurophysiology<br> Neurology<br> Obstetrics and gynecology<br> Ophthalmology<br> Medical oncology<br> Radiation oncology<br> Otorhinolaryngology<br> Rehabilitation<br> Rheumatology<br> Traumatology and Orthopedics<br> Urology<br> General Medicine<br> Pediatrics<br> Pe \nDiatrics-Childcare<br> Clinics and Hospitals<br> Polyclinics<br> Perimetry<br> Panoramic/Orthopantomography<br> Ultrasounds<br> Mammograms<br> CT<br> Clinical analysis<br> Diagnostic imaging<br> Nuclear medicine","subtitle":"More than 25,000 professionals and centers, in your area, with a very low price<br /><br />Access to the largest list of health services in Spain with more than 25,000 professionals and centers with discounts of up to 60% in consultations , interventions, tests, treatments, products and health services:","teeth-services-description":"This service includes certain free dental services and access to a List of Doctors at a scaled price. \nFree dental services are:","teeth-services-list":"First visit and budget delivery<br> Review visit<br> Oral education<br> Teaching of brushing techniques<br> Fluoridation<br> Annual mouth cleaning. \nTartrectomy<br> Dental X-rays (periapical, wing, occlusal)<br> Diagnosis and probing<br> Occlusal adjustments<br> Remove stitches<br> Implantology study<br> False titanium stump<br> Healing and cementation screw <br>","title":"Discounts on private clinical services"},"wellness":{"pilates":"Pilates","subtitle":"with daily live classes (mindfulness, pilates, yoga, gym...) and deferred, health programs, workshops, nutrition and much more<br /><br />Your online gym:","cardio":"Cardiovascular","healthy-back":"healthy back","mindfulness":"Mindfulness"}}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {"abogalitypro":{"title":"The most outstanding lawyers.","subtitle":"If you are one of them and you are interested in the digital environment, we offer you everything you need to serve your clients, in a single web application, with the maximum guarantees of security and privacy.","request-demo":"Request demo","cards":{"1":{"title":"Your own personalized website","subtitle":"You will have your own url so your customers can find you."},"2":{"title":"Secure video platform","subtitle":"Avoid using high cost, poorly functional or insecure platform."},"3":{"title":"Legal chat","subtitle":"Allow your customers to contact you through a secure and functional chat."},"4":{"title":"Legal history and documentation","subtitle":"Access, edit and share documents and legal history with your clients."},"5":{"title":"Secure payment gateway","subtitle":"Your customers must guarantee payment by card or bizum before accessing your services."},"6":{"title":"Online calendar","subtitle":"Manage your face-to-face or online appointments easily and automatically."},"7":{"title":"Online invoicing","subtitle":"Make your collections and issue your invoices automatically."},"8":{"title":"Tasks and reminders","subtitle":"You can create tasks and reminders for you and your customers:"},"9":{"title":"Customizable subscriptions and pricing","subtitle":"You will be able to set different prices depending on the reason for the consultation or the group."},"10":{"subtitle":"Contact other lawyers through internal messaging"},"19":{"title":"Interconsultations"},"title":"You decide.","subtitle":"Access your customers when and how you want.","video":{"title":"Professional video application","subtitle":"Secure and private. \nDoes not require users to be registered (Teams, Zoom...)"}},"register-for-free":"Register for free","security-privacity":{"blackTitle":"Security-privacity.","title":"Everything you need with the highest level of protection.","text":"Communications security and data privacy are our priority.","text2":"We provide you with the best technology with maximum security in communications and total privacy of your data. Our platform is ISO27001 certified and audited by the WTO."},"professional-platform":{"orange-title":"You only need 10 minutes to set it up.","title":"Welcome to your legal services platform.","orange-title-final":"You will be able to connect it with your corporate website, RRSS, blog...","text1":"<b>Increase your visibility and reputation</b><br>Get new customers thanks to your online profile","text2":"<b>Charge all your services</b><br>You will have your own payment gateway","text3":"<b>It simplifies tasks</b><br>We remind the client of their appointments or tasks, we automatically issue the invoice on your behalf","text4":"<b>Improve attention</b><br>Order your communications by reducing the use of email, WhatsApp or telephone"},"block-8":{"iva":"(TAX not included)"},"subscriptions":{"title":"Rates","professional-rate":"Lawyer","law-firm-rate":"Law firm","monthly-payment":"Monthly fee","try-free":"Free trial for 6 months","law-firm-text":"Up to 5 lawyers. Check rates for more than 10 professionals.","price-text":"+ 1.5% of services charged through the legalPRO payment gateway."},"contact-form":{"text":"If you want to access the best platform for lawyers, contact us."},"form":{"collegiateNumber":"Province of collegiate"}},"iva-not-included":"(TAX not included)"}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = {"account":{"login":{"title":"Sign in"}},"login":{"mfaCode":"Code","invalid-credentials":"Incorrect email and/or password","already-sign-in":"Already registered?","errors":{"passwordMaxAttempts":"Because you have failed to log in several times, your account will remain locked for a few moments.<br>Please log in again after a few minutes.","copaymentEnabled":"Your package of available services has been modified, so that certain services will no longer be available or have a copayment. \nIf you have any questions, contact us in the support chat.","deniedAccess":"We're sorry, but your user cannot access this business service.<br/> If you think this may be an error, please contact us using the support chat or send us an email at @:global.contact-email .","expired":"The service that your entity had contracted with <b>Open Health</b> has ended. \nIf you need more information, contact your company or entity.<br><br>However, your data is still available at <a href='{domain}'>{domain}</a> where, if you wish, you can request the services with the professional of your choice, although remember that these will no longer be covered by your company. \nIf you wish to access any of the professionals available, you may do so at the prices that said professional has established for users of opensalud 360.","santanderPaidService":"We remind you that the program has been extended until January 31, 2023. If you wish to continue in it after that date, you must assume the subsidized cost of 36 euros per consultation.","travelExpired":"The medical service related to your reservation with {travelCompany} ended on {endDate}.<br>If you wish to access your data, you can continue to do so at <a href='{domain}'>{domain}</a><br>However, If you have a new reservation number, fill out the form to continue enjoying the service.</b>","travelNotStartedYet":"The medical service related to your reservation with {travelCompany} begins on {startDate}.<br>This service will only be available during your stay in our hotels.","zaraExpired":"The opensalud360 access pilot program for Zara employees has ended on February 28. \nZara Spain will notify you of the possible continuity or not of the service. \nHowever, we inform you that you can continue using your account as a private user, you will be able to continue accessing both your data and your queries through the portal: <a style='font-weight: bold;' \nhref='https://opensalud.es/'>https://opensalud.es/ </a>.<br><br>We thank you for your trust.","zaraPilotEnd":"The opensalud360 access pilot program for Zara employees has ended on February 28. \nZara Spain will notify you in the future of the possible continuity or not of the service. \nWe thank you for your trust. \nIf you are interested in continuing with the service after the end of the pilot program, you can do so by paying the price of the consultations."},"UserLockedException":"","terms-and-conditions":"You must accept our terms and conditions before continuing:","terms-and-conditions-accept":"I have read and accept the legal terms and conditions.","privacy-policy":"You must accept our privacy policy before continuing:","privacy-policy-accept":"I have read and accept the privacy policy.","twoFACode-ph":"Code"},"patient-panel":{"go-360":"Go to openhealth360"}}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {"account":{"password-update":{"update-password":"Update password","password":"Password","success":"Your password has been successfully reset.","reset-password":"We will send you an email with the instructions to recover your password to the email address with which you registered.","expired-password":"Your password has expired after 12 months.","send-password-email":"Send recovery email","email-sent":"We have already sent you an email with instructions to {email}","check-email":"Check your email to recover your password.","check-spam":"If you can't find it in your inbox, remember that it may have landed in your junk or spam folder.","security-requirements":"Due to security requirements, your password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, a special character and one number.","click-login":"Click here to login","repeat-password":"Repeat your password","error":"Your link has expired. \nPlease <a href=\"/cuenta/peticion-actualizar-contrasena\">click here</a> to request one again.","set-password":"set password","success2":"Your password has been set successfully.","error-found":"An error has occurred trying to reset your password. \nPlease contact support.","error-requisites":"We were unable to change your password. \nRemember that you cannot have used the same password before.","email-required":"Enter an email"},"confirm-email":"Confirm account","confirm-account-h1":"Your email has been validated. \nTo complete your registration, you must establish a password for your user.","confirm-account-error":"An error has occurred","confirm":{"error":"Your email link for your account confirmation has been expired."},"set-email-title":"Specify a valid email","set-email":{"error01":"Enter a valid email please","error02":"The email entered is already registered in the system"},"setEmail":"Set email","confirm-account-message":"Please check your inbox or WhatsApp to confirm registration on the platform","confirm-account":{"steps-reenable":"Please, enter the email with which you registered and click on the button below and we will send you the account confirmation email again.","resend-enable-account":"Resend confirmation email","email-required":"Please enter the email you registered with"},"register":{"confirmation-title":"Correct record"}},"signup":{"ok":"An email has been sent to {email} to verify your identity, in addition to a Whatsapp if you have entered a phone number. <br>Please check your mailbox and follow the instructions.","ok2":"to verify your identity, in addition to a Whatsapp if you have entered a phone number. <br>Please check your mailbox and follow the instructions.","titleok":"Registration successful","modal3":"If you haven't received it after a few minutes, please check your junk/spam folder.","modal4":"Remember that you have <b>72 hours</b> to confirm this email. If you have any problems, you can contact us at <b> info@opensalud.es</b>","modal4-openlegal":"Remember that you have <b>72 hours</b> to confirm this email. If you have any problems, you can contact us at <b> hola@openlegal.com</b>"},"kickout":{"title":"Automatic disconnection","explain":"This session has been disconnected because we have not detected any activity for the last hour or because another session was started with the same user in a different tab, browser or device than the current one.","explain2":"We use this system as a security measure to guarantee unique access to the platform.","contact":"If this screen is displayed without you believing that you are in the above case, you can contact us through our support chat, located in the lower right corner."}}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = {"update-required-data":{"text":"Before continuing, please fill out the following information(s):","contact-chat":"If you do not know your employee number, please contact the technical support chat for assistance.","save":"Update data","messages":{"dni-already-exists":"There is already a registered user with that identity document","user-is-underage":"You must be of legal age to register"}}}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = {"cookies-title":"<div class='type-intro-title'>Cookie policy</div><br/>","cookies-1":"<h4>1. COOKIES INFORMATION</h4><br>","cookies-1txt":"<p>Due to the entry into force of the amendment of the 'Ley de Servicios de la Sociedad de la Información' (LSSICE) established by Royal Decree 13/2012, it is mandatory to obtain the express consent of the user of all websites that use cookies expendable, before it navigates through them.</p><br>","cookies-2":"<h4>2. WHAT ARE COOKIES?</h4><br>","cookies-2txt":"<p>Cookies and other similar technologies such as local 'shared objects', 'flash cookies or pixels, are tools used by Web servers to store and retrieve information about their visitors, as well as to provide a correct functioning of the site.</p><br><p>Through the use of these devices the Web server is allowed to remember some data concerning the user, such as your preferences for viewing the pages of that server, name and password, products that most interest you, etc.</p><br>","cookies-3":"<h4>3. COOKIES AFFECTED BY THE REGULATION AND EXCEPTED COOKIES</h4><br>","cookies-3txt":"<p>According to the EU directive, the cookies that require the informed consent of the user are analytical cookies and advertising and affiliation cookies, with the exception of those of a technical nature and those necessary for the operation of the website or the provision of services expressly requested by the user.</p><br>","cookies-4":"<h4>4. WHAT TYPES OF COOKIES EXIST?</h4><br>","cookies-4txt":"<p>About the types of cookies, there are five main groups:</p><br><ul><li>Analytical cookies: they collect information on the use of the website.</li><li>Social cookies: these are those necessary for external social networks.</li><li>Affiliate cookies: these allow tracking of visits from other websites, with which the website establishes an affiliation contract (affiliation companies).</li><li>Advertising and behavioural cookies: these collect information about the user's preferences and personal choices (retargeting).</li><li>Technical and functional cookies: these are strictly necessary for the use of the website and for the provision of the contracted service.</li></ul><br>","cookies-5":"<h4>5. RELATION AND DESCRIPTION OF THE COOKIES WE USE ON THE WEBSITE</h4><br>","cookies-5txt":"<p>The table below outlines the cookies we use on our website:</p><br>","cookies-5table":"<table><tr><th>Type</th><th>Name</th><th>Info</th><th>Caducity</th><th>Property</th><th>Link</th></tr><tr><td>Functional</td><td>ASP.NET_SessionId</td><td>User Session</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>__RequestVerificationToken</td><td>Prevention of CSRF attacks</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>raw_country</td><td>User's country</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>raw_continent</td><td>User's continent</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>langpref</td><td>User language</td><td>01/19/2038</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>lang_established</td><td>User language establishment</td><td>01/19/2038</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>pwa_installed</td><td>Desktop access installed</td><td>30 (No) - 365 (Yes) days</td><td>Own </td><td></td></tr><tr><td>Functional</td><td>AspNet.ApplicationCookie</td><td>User Identity</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>api_token</td><td>Connection with APIs</td><td>24 hours</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>tmc_token</td><td>Connection with TMC</td><td>24 hours</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>Sentry cookies</td><td>Error handling</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Functional</td><td>Cloudflare cookies</td><td>Security</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Functional</td><td>Smartsupp cookies</td><td>Live support chat</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Analytics</td><td>Google cookies</td><td>Tracking</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Analytics</td><td>Facebook cookies</td><td>Tracking</td><td>-</td><td>Third parties</td><td></ td></tr></table><br>","cookies-6":"<h4>6. SOCIAL NETWORKING COOKIES</h4><br>","cookies-6txt":"<p>Some pages on our websites allow you to share our content on social networks like Facebook, Twitter, Google, etc. Sometimes we post videos from sites like YouTube. These websites set their own cookies, which we do not control. You may want to check their websites to find out more about their cookie policy.</p><br><p>FURTHER INFORMATION ABOUT SOCIAL NETWORKING COOKIES:</p><ul><li><a href='https://es-es.facebook.com/about/privacy/cookies'>Facebook</a></li><li><a href='https://twitter.com/privacy'>Twitter</a></li><li><a href='https://www.youtube.com/howyoutubeworks/policies/community-guidelines/'>Youtube</a></li><li><a href='https://www.linkedin.com/legal/privacy-policy'>Linkedin</a></li></ul><br>","cookies-7":"<h4>7. FROM YOUR BROWSER YOU CAN:</h4><br>","cookies-7txt":"<p>Avoid the use of Cookies, disabling in your browser the use of Cookies and deleting the Cookies stored in your browser associated with this website. This possibility of avoiding the use of Cookies can be carried out by you at any time.</p><br><p>Avoid the downloading of Cookies in your browsing, by selecting the option 'Incognito browsing' or similar, (although the next occasion you want to access your personal account you will have to log in) having to also renounce the storage of other session variables.</p><br><p>Delete cookies, To delete cookies linked to your personal account in OPENHEALTHCARE S.L. you must do so from the domain https: www.openhealthcare.es.</p><br>","cookies-8":"<h4>8. WITHDRAWAL OF CONSENT TO INSTALL COOKIES HOW TO REMOVE COOKIES FROM YOUR BROWSER</h4><br>","cookies-8txt":"<p><b><u>Chrome</b></u></u></p><ol><li>Select the Tools icon</li><li>Click Settings.</li><li>Click Show Advanced Options.</li><li>In the 'Privacy' section click Content Settings. - Delete cookies: Click All cookies and site data... - Do not allow cookies to be stored.</li><li>Click Delete browsing data (clear Cache).</li><li>Close and restart the browser.</li></ol><p style='font-weight:bold;'>For more information about Chrome click <a href='https://support.google.com/chrome/answer/95647?hl=es'>here</a>.</p><br>","cookies-8txt2":"<p><b><u>Internet Explorer. Version 11</b></u></p><ol><li>Select Tools | Internet Options.</li><li>Click the General tab.</li><li>In the 'Browsing history' section, click Delete browsing history on exit.</li><li>Select Delete files.</li><li>Select Delete cookies.</li><li>Click Delete.</li><li>Click OK.</li><li>Close and restart the browser.</li></ol><p style='font-weight:bold;'>For more information about Internet Explorer click <a href='http://windows.microsoft.com/es-419/windows7/how-to-manage-cookies-in-internet-explorer-9'>here</a>.</p><br>","cookies-8txt3":"<p><b><u>Firefox. Version 18</b></u></p><ol><li><li>Select Firefox | History | Clear Recent History.</li><li>Next to 'Details', click the down arrow.</li><li>Select the following checkboxes: Cookies, Cache, Active Logins</li><li>Using the 'Time interval to clear' drop-down menu, select All.</li><li>Click Clear Now.</li><li>Close and restart the browser. You can accept or reject cookies individually in Firefox Preferences, in the History section available under Tools > Options > Privacy.</li></ol><p style='font-weight:bold;'>For more information about Mozilla Firefox click <a href='https://www.mozilla.org/es-ES/privacy/websites/#cookies'>here</a>.</p><br>","cookies-8txt4":"<p><b><u>Safari Version 5.1</b></u></p><ol><li><li>Select the Safari / Edit | Reset Safari icon.</li><li>Select the following checkboxes: Clear history, Delete all website data.</li><li>Click Reset.</li><li>Close and restart the browser.</li></ol><p style='font-weight:bold;'>For more information about Safari click <a href='http://support.apple.com/kb/PH5042'>here</a>.</p><br>","cookies-8txt5":"<p><b><u>Opera</b></u></u></p><ol><li>Options - Advanced - Cookies. Cookie options control how Opera handles them and therefore their acceptance or rejection.</li></ol><p style='font-weight:bold;'>For more information about Opera click <a href='http://help.opera.com/Linux/10.60/en-US/cookies.html'>here</a>.</p><br><br><p><b><u>Other browsers</b></u>: See the documentation for the browser you have installed.</p><br>","cookies-9":"<h4>9. INFORMATION REGARDING TRANSFERS OF DATA TO THIRD COUNTRIES PERFORMED BY OPENHEALTHCARE:</h4><br>","cookies-9txt":"<p>OPENHEALTHCARE does not make international transfers to third countries.<br>In the case of third parties, you can inform yourself of the transfers to third countries that, if applicable, are made by the third parties identified in this cookie policy in their corresponding policies (see link third party cookie policy in the table).</p><br>","cookies-10":"<h4>10. ELABORATION OF PROFILES </h4><br>","cookies-10txt":"<p>OPENHEALTHCARE does not engage in profiling.</p><br>","cookies-11":"<h4>11. IN RELATION TO THE OTHER INFORMATION REQUIRED BY ARTICLE 13 OF THE GDPR</h4><br>","cookies-11txt":"<p>We refer you to the <a href='/Home/privacy-policy'>OPENHEALTHCARE Privacy Policy</a>.</p><br>"}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = {"no-events-found":"No available events were found.","no-forums-found":"No open forums were found.","no-chats-found":"No open chats were found.","newEvent":"Add new event","topic":"Theme","expirationDate":"Expiration date","healthyCommunityTitle":"Healthy Community","forumSectionDescription":"Comment your doubts, ask for advice or share your experiences with other patients","forumTitle":"Patients like you","newPostTitle":"New entry {0}","enterPostTitle":"Enter a title for the entry","createNewPost":"Create new entry","getPostNotifications":"Send me reply notifications in the post","commentaries":"Comments","share":"Share","save":"Save","articleSavedCorrectly":"Article successfully saved","createNewEntry":"Create new post","controlPanel":"Control Panel","publishedBy":"published by","accessBtn":"To access","postPublishedCorrectly":"Post published successfully","selectImageForEntry":"Select a file for input (optional)","emptyMessageError":"You must write a message","messagePublishedCorrectly":"Message posted successfully","emptyTitleError":"You must write a title for the entry","emptyForumContentError":"You must enter a content for the entry","showMoreReplies":"see more answers","moreReplies":"answers more","hideMessages":"hide messages","moreReply":"answer more","showMoreEntries":"see more entries","userAlias":"user aliases","entries":"Posts","messages":"Messages","emptyForumTagError":"You must select a category for the entry","mustEnterEntryCategory":"You must select a category for the entry","noEntriesSaved":"You have no saved entries","noMessagesSaved":"You have no saved messages","messagePendingValidation":"Your message has been published successfully. \nIt will be visible once it is validated.","validations":"Validations","validate":"Validate","noMessagesPendingValidation":"There are no messages pending validation","myNotifications":"My notifications","reject":"Decline","getNotificactionsOf":"Receive notifications of:","answersOfFavouritesMessages":"Saved Message Replies","answersOfFavouritesEntries":"Saved Post Replies","newEntries":"New Posts Posted","fieldEmpty":"There can be no empty fields in the form","messagesReply":"Replies to my messages","emptyEntries":"There are no entries published for this section","emptyEntriesSearch":"There is no result for your search.","dateMustBeGreaterThanNow":"The expiration date must be greater than the current date","proposeNewPost":"Propose new post","postPublishedCorrectlyPending":"Your entry has been submitted successfully. \nOur team will review and assess your publication","messagePublishedSuccessfully":"Message posted successfully","searchPlaceholder":"Search by category, title or description","noEntriesPendingValidation":"There are no entries pending validation","shareInSocialMedia":"Share in your social networks","link":"Link","3monthsDefault":"(3 months by default)","mustEnterEntryTags":"Select one or more labels for the input (optional)","noTagsAvailables":"No tags found for your search","entryCategoryNotSelected":"You must select a category for the entry","like":"I like it","moreRecent":"More recent","featured":"Featured","sharingSocialsTitle":"I recommend this entry {0} ","sharingSocialsDescription":"Through this link you can access the publication","searcher":"Searcher","noResults":"Without results","categories":"Categories","tags":"Tags","forumHeaderText":"Comment your doubts, ask for advice or share your experiences with other patients.","enterOrSearchDiseases":"Select or enter a disease for entry","mustSelectDisease":"You must select or enter a disease for the entry","diseasesForum":"Diseases","specialistIn":"Specialist in","healthyInformation":"Healthy information","whoIn":"Who's in?","consultationIn":"consultation in","mustEnterEntrySection":"Select a section for the entry","entrySectionNotSelected":"You must select a section for the input","infoNick":"In this field you can modify the username that will be visible to the rest of the users of the platform","infoEmail":"In this field you can modify the notification email of the platform","patientsLikeYou":"Patients like you","whoInSectionDescription":"Organize healthy plans with your colleagues","healthyInformationSectionDescription":"Stay informed of the latest health and wellness news","removePostAdvice":"Do you want to delete this entry?","healthyCommunityHeaderText":"Organize plans and share experiences and health and wellness information with your colleagues!","noPendingPushNotifications":"You have no pending notifications","notifications":"Notifications","removePushNotifications":"Do you want to clear your notification history?","newPushNotifications":"You have {numberNotifications} unread message{plural}/entry{plural}","favourite":"Favorite","saveds":"Saved","removeHistory":"clear notifications","settingNotifications":"configure notifications","panelEntryTags":"Select one or more tags","panelEntryCategory":"Select one or more categories","mustSelectCategory":"You must select at least one category","mustSelectTags":"You must select at least one tag","notReceiveEmails":"Do not receive emails","receiveEmails":"Receive emails","in":"in","selectImage":"Select an image (optional)","newPostDescription":"Entry Description","whoInNewPostDescription":"Sport/activity, Date, Time, No. of people, Location, etc...","firstAccessForum":"To stay informed about the content you save and set up your notifications, don't forget to turn on notifications in your \"Control Panel\", located by clicking your initials in the upper right corner.","welcomeTo":"Welcome to {0}","healthyCommunityFirstAccessTitle":"the healthy community","whoInNewPost":"<p>Activity: {activityName}</p><p>Level: {activityLevelName}</p><p>Date: {date}</p><p>Start time: {startHour}</p>< \np>End time: {endHour}</p><p>Location: {address}, {stateName}, {cityName}, {countryName}</p><p>Comments: {commentaries}</p>","removeMessageAdvice":"Do you want to delete this message?","messageDeleted":"message deleted","goOpenhealth":"Go to Opensalud360","edited":"edited","loginFromArticle":"If you want to see the comments and participate in this entry, you must log in by clicking here:","panelEmailInterval":"Select notification interval","eachDay":"Every day","eachWeek":"Weekly","eachMonth":"Each month","mustSelectEmailsInterval":"You must select a notification interval for emails","lastMessage":"Last message","lastInteraction":"last interaction","companiesAccessRestrictedMessage":"Your company code has restricted access to the healthy community, so it will be redirected to patients like you","forbiddenMinorUser":"Access is restricted for underage patients.","reportMessage":"Report","reportMessageTitle":"Indicate the reason for the report:","reportmessageSendConfirmation":"The report has been sent successfully.","mustIntroduceReportReasons":"You must enter the reason for the report","reports":"Reports","noMessagesReported":"No messages reported","noRemove":"Do not delete","firstAccessNickForum":"You can then set the name that will appear on your posts. \nYou can simply enter initials, a nickname... Remember that this name is visible to other registered users.","firstAccessFooterForum":"We remind you that it is not possible to send private messages between users through the platform.","emptyNick":"You must enter the name that will appear in your publications","monthlyAccessAdvice":"Your experience can help other users! \nRemember that your profile is anonymous and that no one can contact you directly.","infoName":"Registration name","selectActivity":"Select an activity","selectActivityLevel":"Select a level","selectState":"Select a province","selectCountry":"Select a country","selectCity":"Select a municipality","activityTitle":"Enter a title for the activity","newActivity":"New activity","insertActivityName":"Enter the name of the activity","otherActivity":"Another activity...","activityDuration":"Duration (in minutes)","startHour":"Start time","endHour":"End time","level":"Level","activity":"Activity","hourEndGreaterThanStart":"The start time must be less than the end time","mustSelectActivity":"You must select an activity","mustSelectActivityLevel":"You must select a level","mustSelectState":"You must select a province","mustSelectCity":"You must select a municipality","mustSelectAddress":"You must enter an address","mustInsertOtherActivity":"You must enter the name of the activity","dateEndGreaterThanStart":"The start date must be less than the end date","dateEndGreaterThanToday":"The end date must be greater than the current date","dateStartGreaterThanToday":"Start date must be greater than current","proposeNewActivity":"Propose new activity","participantsLimit":"Participant limit","participantsLimitGreaterThan2":"The number of participants must be greater than 2","whoInDataTitles":{"activity":"Activity","activityLevel":"Level","country":"Country","state":"Province","city":"Ciudad","startDate":"Start","endDate":"End","commentaries":"Comments","address":"Address","otherActivity":"Activity","participants":"Participants"},"signUpWhoIn":"I sign up","noAssistWhoInActivity":"Do not attend","activityUpdatedCorrectly":"The activity has been updated","participantsLimitLowerThenCurrentParticipants":"The limit of participants must be greater than the current participants ({participants})","searchWhoInPlaceholder":"Search for an activity","timeOfDay":{"morning":"Morning (6:00-12:00)","afternoon":"Afternoon (12:00-18:00)","night":"Night (18:00-24:00)"},"participantsLimitsReached":"The maximum number of participants for this activity has been reached","noActivitiesToSearch":"There are no activities available at this time","emptyActivitiesSearch":"No activities have been found for your search.","resetFilters":"Remove filters","endDateNotSelected":"If you select the end time, you must select the end date of the activity","startDateNotSelected":"If you select the start time, you must select the start date of the activity","only-subscriptors-warning":"This content is only for subscribers.","only-subscriptors":"Only subscribers","showMoreDetails":"See more details","comment":"Comment","showDetails":"See details","hideDetails":"Hide details"}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = {"healthyHabitsTitle":"My Goals and challenges","of":"of","doubleClickChangeValue":"Double click on a value to change it","enterNewValue":"Enter a value","tableInfoTitle":"Information about the table","tableInfo":"- To modify your measurements or introduce new values, you can do it directly on the table, by clicking on the corresponding value.","tableInfo2":"- If you want to make changes to the lens settings, click on the pencil that appears to the left of its description.","enterValidNumber":"Please enter a valid number","noDataFound":"No results found for your search","clear":"Clear","week":"Week","total":"Total","historyTitle":"Record","to":"to","weeks":"Weeks","monthsTitle":"Months","yearsTitle":"Years","frequency":"Frequency","day":"Day","daily":"Daily","each":"Each","weekly":"Weekly","monthly":"Monthly","timesToWeek":"times a week","timesToMonth":"Times a month","selectAnOption":"Select an option","selectAnHour":"Select a time","checkInvalidFormData":"Check the fields marked in red","mustSelectOption":"You must select an option","mustEnterValidNumber":"You must enter a valid number","valuesBetween":"values ​​between","notmeasurable":"Not quantifiable","measurable":"Quantifiable","measurableExamples":"(steps, kilos...)","notMeasurableExamples":"(Yes/No)","selectHabitType":"Select a goal:","hideCompletedHabits":"hide completed","clickChangeValue":"Click on a value to change it","newHabit":"New goal","currentStreak":"Current streak","bestStreak":"Best streak","totalWeek":"total week","totalMonth":"Total month","totalYear":"Total year","add":"Add","mustInsertValue":"You must enter a valid value","extra":"extra","tableInfo3":"- You can visualize your progress with detailed graphs by time intervals by clicking on the graph icon.","firstNewHabit":"Add your first goal!","tableInfo4":"- To delete a target or mark it as archived, tap the trash and select the appropriate action.","maxhealthyHabitsReached":"The maximum number of simultaneous targets is 10. If you want to add a new target, you must delete or archive a current one.","reminderDays":"reminder days","selectOneMoreOption":"Select one or more options","mustSelectColor":"You must select a color","whatWantToDo":"What would you like to do?","showStoredHabits":"Show archived goals","insertValidPhone":"Please enter a valid phone number","insertValidEmail":"Enter a valid email","allowFreeDays":"allow days off","allowFreeDaysAdvice":"By disabling this option, your days off will be treated as days not completed.<br><br>Do you want to continue?","atHour":"at","off":"Off","tableInfo6":"- If you want to sort the targets, long press and drag the target to the new position.","sessionExpired":"Your session has expired. \nYou will be redirected to login again.","store":"file","remove":"Remove","notificationsPhoneTooltip":"Notification phone (If you do not want to receive notifications by WhatsApp, leave this field blank)","mustEnterValidInteger":"You must enter a whole number","percentage":"Percentage","weekShort":"Week","totalWeekShort":"Total week","summary":"Summary","remaining":"Remaining","showGoalCompletedHabits":"Show completed objectives","congratulations":"Congratulations!","goalCompletedText":"You have completed your goal 100%. \nRemember that you can show your completed goals in the table by enabling the \"Show completed goals\" option in your settings.","tableInfo7":"- You can modify the configuration of the table and other values ​​such as your email / phone notifications by clicking on \"Settings\".","nameFormPlaceholder":"Description (Ex. Walking)","questionFormPlaceholder":"Question (ex. Have I walked today?)","UnitFormPlaceholder":"Unit (eg Pages)","nameFormMeasurablePlaceholder":"Description (Ex. Read)","questionFormMeasurablePlaceholder":"Question (Ex. How many pages have I read?)","goalFormPlaceholder":"Objective (Ex. 15)","showMore":"see more","showMoreAdvice":"Click on the side arrows to see more statistics","invertCalendarDays":"Reverse order calendar days","newChallenge":"New challenge","firstNewChallenge":"Add your first healthy challenge!","reset":"Restore","predefined-walk-question":"How far have I walked?","predefined-walk":"Walk","predefined-run":"Run","predefined-run-question":"How many kilometers have I run today?","predefined-bike":"Bicycle","predefined-bike-question":"How many kilometers have I done this week?","predefined-swim":"Swim","predefined-swim-question":"I have swum?","predefined-lose-weight":"Lose weight","predefined-lose-weight-question":"How much weight have I lost this week?","predefined-smoke":"Give up smoking","predefined-smoke-question":"Have I quit smoking today?","predefined-sleep-better":"Sleep hours","predefined-sleep-better-question":"Have I slept better?","predefined-week-exercise":"Weekly exercise","predefined-week-exercise-question":"Have I exercised?","predefined-drink-alcohol":"Alcohol consumption","predefined-meditation":"To meditate","predefined-meditation-question":"Have I done meditation?","predefined-go-gym":"Go to the gym","predefined-go-gym-question":"Have I gone to the gym?","predefined-drink-alcohol-question":"Have I stopped consuming alcohol?","predefined-read":"Read","predefined-read-question":"How many pages have I read today?","createOwnHabit":"Or create your own goal:","pagesHabit":"pages","doubts":"Doubts","faq-table":"Table","question-table-1":"How can I add new objectives?","answer-table-1":"There are two ways to add new objectives:<br><br>1) Selecting a predefined objective: which will appear above the table if you have not yet registered any objective or in the window intended to add new objectives.<br>2) Creating a custom goal: You can create them by clicking on the \"New goal\" button in the table and configure it as you like.","question-table-2":"Can I edit a created goal?","answer-table-2":"Yes. You can edit any goal you have created by clicking on the pencil that appears to the left of its description.","question-table-3":"How can I view a target's stats?","answer-table-3":"To view the statistics of a goal, you can click on the bar graph that appears to the left of the goal description.","question-table-4":"Can I delete or archive an already created goal?","answer-table-4":"Clear. \nTo delete or archive a goal, you must click on the trash button that appears to the left of the goal. \nThere you will be asked what action you want to execute.","question-table-5":"How can I see previous days of the week?","answer-table-5":"To see more days in the table, you can click on the arrow that appears at the top of the table. \nIf you're on mobile, you can also flick in the direction you want to see more dates.","question-table-6":"What does the bar below the objective description mean?","answer-table-6":"This bar measures the percentage of <b>current progress</b> of the goal.<br>For example, for a non-quantifiable goal, if it is set for 3 days a week, it will be 100% completed if in the current week at least 3 days have been marked.<br>For a goal that is set monthly and quantifiable, it will be marked 100% when the goal set in the current month is exceeded.","answer-table-7":"For quantifiable targets, a value will appear along with the unit of measurement you have set.<br><br>For non-quantifiable targets, there are 3 types of symbols:<br><br><b>Tick:</b > Indicates that the objective has been completed that day.<br><b>Script:</b> Indicates that that day has been marked as free.<br><b>X:</b> Indicates that that day is not the goal has been completed.<br><br>By default days off are enabled, but you can disable them by clicking the settings button at the top of the screen.","question-table-7":"What do the symbols below each date mean?","question-table-8":"How can I mark a day as completed or enter a value?","answer-table-8":"To mark a day as completed or change between the different states (not completed or day off), you must click on the symbol that appears below each date.<br><br> In the case of quantifiable objectives, you can enter a determined value.","question-table-9":"What do the last three columns of the table indicate?","answer-table-9":"There are 3 different groups of 3 columns each, which reflect different basic statistics of the objective.<br><br>First group:<br><br><b>Current streak:</b> Indicates the number of consecutive days you have completed the goal from the current date. \nIf any day is marked as free in that streak, it will not be counted and therefore will not break the streak.<br><b>Best Streak:</b> Indicates the longest streak of consecutive days completed throughout the objective.<br><b>Total:</b> Shows the total number of days in which any objective data has been filled in.<br><br>Second group:<br><br>Shows the weekly sum/ monthly/annual of the objectives filled in those time intervals.<br><br>Third group:<br><br>Indicates the percentages of weekly/monthly/annual days in which some data has been filled.<br> <br>You can toggle the different blocks by clicking on 'see more' below them or on the arrows.","answer-table-10":"The semi-transparent data displayed in the table indicates that the goal has been completed in that time period.<br><br>For example, if a goal is completed every 3 days and you mark the current day as completed, the next 2 days will be semi-completed. \nYou can also mark those days as completed, but it is not necessary.","question-table-10":"Why does semi-transparent data appear colored?","faq-config":"Setting","answer-config-1":"By clicking on the configuration button that appears in the upper right corner you can configure the following elements:<br><br><b>Show archived objectives:</b> Allows you to show/hide the archived objectives in the table.<br ><b>Show completed goals:</b> Allows you to show/hide completed goals in the table.<br><b>Allow days off:</b> Allows you to mark days as free and do not count towards the streaks.<br><b>Invert order of calendar days</b>: Toggles the order in which the days are displayed on the calendar, that is, decreasing to the right or to the left.<br>< b>Email:</b> You can set the email in which you will receive notifications for the reminders you set.<br><b>Phone:</b> You can set the phone in which you will receive notifications for the reminders you set. configure.","faq-statistics":"Statistics","question-table-11":"When is a goal completed?","answer-table-11":"To determine if a goal has been completed, an exponential smoothing algorithm is used, in which the weighted average is calculated from the first day of the goal to the current day, giving more weight to the current days.<br><br> For example, for a daily goal, 80% would be achieved in the first month, 96% after two months, and 100% after 100 days.","question-statistics-1":"What information appears at the top?","answer-statistics-1":"The following data appears at the top:<br><br>- The question you set when creating the form.<br>- The repetition interval of the goal<br>- The reminder, if you have set it when creating the goal.","question-statistics-2":"What does the Objective section indicate?","answer-statistics-2":"This section is only available for measurable goals and indicates the weekly/monthly/yearly sum of the values ​​set in those intervals.","question-statistics-3":"What is the calendar?","answer-statistics-3":"The calendar shows the same information that you can see in the table, but within a 4-month range from today's date.<br>You can interact with the calendar in the same way as with the table.","question-statistics-4":"What information is shown in the statistics tables?","answer-statistics-4":"There are 3 statistical tables:<br><br><b>Score:</b> Reflects the score calculated by the exponential smoothing algorithm. \nYou can view the scores grouped by days/weeks/months/years.<br><br><b>History:</b> Shows the sum of the values ​​recorded for the target in week/month/year intervals.<br ><br><b>Frequency:</b> Indicates the frequency with which the days of each month have been completed in the last year. \nYou can see the values ​​grouped in that interval by clicking on the circle.","tableInfo8-1":"- For more information, you can access the frequently asked questions section by doing","tableInfo8-2":"Click here.","question-config-1":"What can I configure?","question-table-12":"What does the trophy that appears at the top of the screen indicate?","answer-table-12":"Shows the best streak achieved, taking into account all its objectives.","mustInsertPositiveValue":"You must enter a positive value","dailyShort":"Daily","weeklyShort":"Weekly","calendarInfo":"You can interact with the calendar in the same way as the main goals table. \nThis way, you can add new data by clicking on a date on the calendar.","monthlyShort":"Monthly","showLess":"see less","lessRecent":"less recent","moreRecentHabit":"more recent","freeDay":"Day off","healthyHabitsTable":"Board","partialCompleted":"Partially completed","uncompleted":"Not completed","nonMeasurable":"Not quantifiable","measurableInfo":"- Filled: If the value is filled with the color selected for the target.","measurableInfo2":"- Partially completed: If the value is semi-transparent.","tableInfo8":"- For more information about the symbols in the table, click","healthyHabitsGeneral":"General","stadistics":"Statistics","removeOrStore":"Delete or archive","restore":"Restore","stored":"Archived","progressBar":"Current progress bar","legend":"Legend","completedDay":"day completed","calendarLegendColorInfo":"The fill color of the calendar days will depend on the color selected when creating the objective.","notCompletedDay":"day not completed","filled":"Entered value","predefined-drink-water":"Drinking water","predefined-drink-water-question":"How many liters have I drunk?","liters":"liters","meters":"meters","typeUserNames":"Enter the users name","typeUserEmails":"Enter patient emails","typePatientEmailAdvice":"Write the email of the patient to challenge and press enter","checkInvalidMultiUserEmail":"Check that the patient emails/phone numbers entered are correct","multiUserUncompleted":"You have not completed the objective this day.","multiUserCompleted":"You have completed the objective this day.","multiUserDayFree":"has marked the day as free.","multiUserMeasurableCompleted":"you have completed the objective this day with {value} {unit}.","multiUserMeasurablePartialCompleted":"You have partially completed the goal this day with {value} {unit} of {goal} {unit}.","invitePatientsMultiUser":"Invite users to complete the goal","typeUserEmailsOrPhones":"Enter the emails/phone numbers of registered users","typePatientEmailOrPhoneAdvice":"Write the email/phone number of the registered user and press enter","multiUserInviteLimitExceeded":"The maximum number of invitations is 9","inviteMultiUserInfo":"You can invite other users registered on the platform to see the results of each one in your table together. \nRemember that invited users must be registered with the email/phone number to which you send the invitation.","multiUserPartialCompleted":"You have partially completed the objective this day.","professionalNotAllowed":"Currently you can only access goals through your patients' medical history, where you can add new goals to them.","predefined-more-time-in-family-question":"Have you spent more time with your family?","predefined-more-time-in-family":"Family time","predefined-ultra-processed-foods":"Ultra-processed foods","predefined-ultra-processed-foods-question":"Have you consumed less ultra-processed foods?","predefined-argue-less":"Argue less","predefined-argue-less-question":"Have you argued less?"}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = {"openlegal":{"derecho-fiscal-tributario":{"title":"Fiscal and Tributary Law","description":"Fiscal and Tributary Law regulates the obtaining of resources by public Administrations, especially in terms of taxes, rates and taxes. In fiscal and tributary matters at Openlegal we provide our clients with planning services and tax strategy, advice on compliance with tax obligations, tax settlement and presentation, management of inspections, pleadings, appeals against dismissing resolutions as well as any actions and needs generated for our clients.<br><br>If you need a specialist in tax and tax law, do not hesitate to contact us at Openlegal, we will find your best solution."},"derecho-constitucional":{"title":"Constitutional Law","description":"Constitutional Law integrates the norms of Public Law that establish the sources, rules and fundamental principles by which our Legal System is governed.<br><br>Constitutional Law protects the rights of citizens enshrined in the Spanish Constitution, this being the fundamental norm of our Rule of Law.<br><br>The provision of services in this matter at Openlegal focuses, based on experience, on the presentation of amparo appeals (in which constitutional protection is requested in the face of the violation of fundamental rights ), and procedures for the defense of constitutional rights such as honor, privacy and one's own image.<br><br>If you believe that your fundamental rights have been violated, trust Openlegal, we will help you obtain compensation and compensation for them ."},"derecho-laboral":{"title":"Labor Law","description":"Labor Law is the set of rules that regulate the relationship between employers and workers. This set of laws addresses fundamental aspects of the employment relationship such as hiring modalities, hours, salaries, permits, compensation, dismissals, subsidies, among other aspects.<br><br>At Openlegal we have a team specialized in providing all kinds of labor services, whether it is advice: preparation of payroll, social security, contributions, etc. as well as from the point of view legal, lawsuits before the social jurisdiction, dismissals, claims for amount for non-payment of wages..."},"derecho-administrativo":{"title":"Administrative Law","description":"Administrative Law is the branch of Public Law that regulates the organization, operation, powers and duties of the Public Administration and its legal relationship with citizens. Any act carried out by an Administration (State, regional, local or foral) is an administrative act regulated by this branch of Law.<br><br>The provision of services in this matter focuses on the request for certain benefits and Rights to the Administration and on the making of allegations, challenges and appeals before it .<br><br>If you need to file an administrative procedure or carry out any procedure before the competent Administration, at Openlegal we satisfy your needs."},"derecho-familia":{"title":"Family Law","description":"Family Law is the set of legal norms that regulate matters that affect the members of a family, understood as a natural and social institution. Family Law falls within the scope of Civil Law, which regulates the main aspects of this specialty, and is complemented by a series of specific laws that have been promulgated to adapt the regulation of this institution to the social reality.<br><br>Family Law regulates, among others, the following aspects:<ul><li>Marriage: the law establishes both the valid forms of celebration and the personal and economic effects that this legal bond implies.It also addresses crisis situations that result in its annulment, separation of the couple or dissolution of the bond, or in divorce.</li><li>Figures similar to marriage, such as common-law couples or simply unions from which, although in an unregulated manner, rights and obligations arise.</li><li>International marriages and unions: we are talking about couples made up of members of different nationalities and cultures, which make up a sector within Family Law with specific regulations whose casuistry—increasingly frequent due to the exponential increase in immigration—is necessary dominated by legal professionals.</li><li>Filiation: is the link between parents and children, whether married, extramarital or adoptive, and also includes parental authority (relationship with unemancipated children).</li><li>Guardianship: a set of regulations regarding the custody and protection of minors or incapacitated persons who are not subject to parental authority.</li><li>Family heritage: made up of the set of assets, rights and Obligations that must be managed and/or, where appropriate, be able to settle and adjudicate in the event of death or dissolution of the marriage bond or separation of the domestic partner.</li></ul><br>Do you want to separate or divorce and do not Do you know what you should do or what your rights and interests are? And what about your son? Do you need to liquidate the joint venture? Do you want to recognize or challenge the parentage of your child? If you have these and other questions related to Family Law, count on Openlegal, we will solve all your doubts and help you get what you want."},"derecho-sucesiones-herencias":{"title":"Inheritance and inheritance law","description":"Inheritance law is that part of private law that regulates the succession mortis causa and determines the destination of ownership (assets and rights) and legal relationships, both active and passive (obligations) of a person after his death .<br><br>In the regulation of successions, important aspects are contemplated, such as:<ul><li>Destination that will be given to the assets of the deceased or deceased.The scope of action of the autonomy of the will, the imperative norms that are necessary and the dispositive norms that will replace the will of the deceased, in case there is no will.</li><li>Validity requirements of the will, in order to ensure that what appears in it is really the will of the testator.</li><li>The necessary procedures for the distribution of the relict estate.</li></ul><br>If you want advice to make a will, if you have been an heir and have some doubts about the inheritance or you need to challenge a will because you believe that your rights have been violated, count on Openlegal, we have the best experts in inheritance law."},"derecho-mercantil":{"title":"Commercial Law","description":"Commercial Law, is the branch of private law that regulates commercial acts, the statute of entrepreneurs and the activities they carry out in the market. Commercial acts in general are also regulated, regardless of whether they are carried out or not through merchants and whether or not they are commercial in its economic sense. Also included in this matter are institutions of what is known as Competition Law; They are institutions that arose autonomously but that were added to doctrine and legislative developments in industrial property, made up of patents, trademarks, trade names, and industrial design.Likewise, commercial law includes the defense of competition and unfair competition as well as the regulation of bankruptcy when a businessman is in a situation of insolvency or “bankruptcy”.<br><br>If you need to register a patent or trademark or you think yours has been copied or you have any other commercial need, do not hesitate to contact us, with Openlegal we will be happy to help you."},"derecho-internacional-privado":{"title":"Private International Law","description":"Private International Law is that branch of law whose purpose is international jurisdiction conflicts, international law conflicts, procedural cooperation and determining the legal status of foreigners.<br><br>This branch of law analyzes international legal relations either between private parties, or where there is a private interest.This legal relationship has the particularity of resolving conflicts of jurisdiction or applicable law, with the purpose of determining who can know about the subject and what law should be applied.<br><br>If you are faced with a situation that requires the resolution of a private international conflict, Openlegal, we have the best professionals to advise you on the best way to resolve it."},"derecho-urbano":{"title":"Urban Law","description":"The concept of Urban Law attends to a set of rules that regulate the processes of territorial planning and the physical transformation that occurs due to urbanization and construction. Therefore, among its powers is to organize the the territory as a whole, the processes involved in urbanization and the control of construction that occurs as a result of this urbanization.<br><br>Currently, this legislative activity derives from the Autonomous Communities, leaving state regulation in the background and limiting itself to the establishment of a set of basic and generic postulates.<br><br>What matters does urban law include?<ul><li>The regulation of the land regime, being the responsibility of the State that the basic conditions are met, guaranteeing equality in the exercise of rights and obeying constitutional duties related to the land.</li><li>Territorial planning.</li><li>All those aspects related to urban matters, be it planning, execution of this planning and its discipline.</li><li>Administrative matter related to the land and housing market.</li><li>Legal discipline in relation to land valuations and facilities, constructions and buildings that are carried out.</li><li>Compulsory expropriation due to urban planning.</li><li>Patrimonial responsibility due to urban planning.</li></ul><br>Do you have any problem with obtaining a planning license, do you think your neighbor has carried out illegal works? If you have these or other urban planning questions, at Openlegal we are here to help you, we have the best experts in urban planning so that you can put yourself in their hands and solve your problems."},"derecho-bancario":{"title":"Banking Law","description":"Banking law is the branch of law that studies the rules that regulate the operation of banks and banking activities and, in general, all financial entities.<br><br>Many financial entities have been approved as banks to submit them to banking regulations, which is why banking and financial law are often referred to together.However, within this field there are also specific rules for each type of entity, be they banks, savings banks, credit unions, financing entities, etc.<br><br>This denomination also includes matters related to financial markets, and relations between banking entities and clients.Thus, we understand banking activity both from the point of view of business or contractual relations and from the system organization of the entities.<br><br>If you need advice on Banking Law or if you believe that any of the contracts or clauses that you have signed with your Bank may be abusive, do not hesitate to contact Openlegal, we will resolve your doubts and we will help you with what you need."},"corporate-compliance":{"title":"Corporate compliance","description":"Corporate Compliance is a set of procedures and good practices adopted by organizations to identify and classify the operational and legal risks they face and establish internal mechanisms for their prevention, management and control.<br><br>Corporate compliance has become one of the most influential requirements for optimal business management.Although the term began to be imposed in order to comply with international, national and local legislation, its relevance goes further.Prevention of crimes and sanctions, organization, ethics, social image and with it greater profitability, are the main consequences of a corporate compliance strategy.<br><br>You want to advise yourself on the implementation of a crime prevention plan in your company, you need to establish a compliance policy in your company such as the Complaints Channel, Code of Ethics, Anti-Corruption Policy, Equality Plan or Protocol against sexual harassment and harassment based on sex at work, at Openlegal we have professionals specialized in the matter and with a extensive experience in the sector, which will listen to your needs and develop the necessary policies fully adapted to the reality of your organization."},"derecho-transporte":{"title":"Transportation Law","description":"Transportation Law is the sector of Law that deals with regulating all aspects and conflicts that arise from the transport contract, understood as land transport of goods.<br><br>This contract supposes an agreement of wills by the one in which a businessman agrees to take merchandise or a person from one place to another by means of transport that is agreed upon, in exchange for remuneration.<br><br>Have you had any problems with private or commercial transport?At Openlegal we will do everything in our power to help you solve it."},"derecho-privacidad":{"title":"Privacy or data protection Law","description":"The right to data protection is that fundamental right of every natural person that empowers them to dispose of and control their personal data, being able to decide which ones to provide to third parties, as well as knowing who owns that data and for what , and oppose that possession or processing of data.<br><br>In turn, the Organic Law on Data Protection establishes that each and every one of the companies that process personal data for the normal development of their commercial activity, as well as for other purposes, they have the obligation to comply with Regulation (EU) 2016/679 and the Organic Law on Data Protection and Guarantee of Digital Rights (LOPDGDD 3/2018).Thus, any entity, autonomous or professional that manages data of clients, employees, suppliers, associates or any other figure for the development of its activity, it must compulsorily comply with the LOPDGDD and the RGPD. <br><br>If you believe that the protection of your personal data has been violated or you are a professional who needs advice for the preparation of professional documents in accordance with the regulations for the protection of personal data, contact Openlegal."},"derecho-consumo":{"title":"Consumer law","description":"Consumer Law is the branch of law that is responsible for protecting consumers or users, whether they are natural persons or legal persons who act for a purpose unrelated to their commercial or business activity, when they acquire or contract goods or services.<br><br>Therefore, consumer law is made up of the rules that regulate the rights and obligations in legal relationships between these consumers or users and the companies that offer the goods or services purchased.<br><br>The consumer law and various fundamental aspects of the relationship between producers and consumers: <ul><li>Contracts by adhesion: prohibits unfair terms that unbalance the relationship between the contractual in favor of the provider of goods and services and tries to ensure that the consumer knows in advance all the general contracting conditions that the employer intends to use.</li><li>Quality of the goods and services offered: minimum requirements.</li><li>Regulation of advertising and of the offers directed to the public.</li><li>Establishes special procedures so that consumers, associations and public bodies created can defend themselves and prohibit certain abusive practices.</li><li>Lists a list of infractions by of businessmen and the corresponding sanctions that can be imposed by the competent authorities in consumer matters.</li></ul><br>If you need advice on Consumer Law or if you think you need protection as a consumer and/or user of any product, do not hesitate to contact Openlegal, we will solve your doubts and help you with whatever you need."},"propiedad-intelectual":{"title":"Intellectual Property","description":"Intellectual Property and industrial property are made up of a set of rules that regulate the acquisition and use of rights over intangible assets susceptible to commercial use. According to Spanish legislation, intellectual property and industrial property are clearly differentiated from as follows:<ul><li>Industrial property: patents, trademarks, utility models, distinctive signs, trade names, industrial drawings, etc.</li><li>Intellectual property: copyright, literary and artistic works , works of art, architectural designs...</li></ul><br>When talking about industrial property, reference is being made to a type of rights that protect the creators of inventions so that they can develop their activity in the market against competitors and have sufficient protection against third parties.<br><br>Industrial property rights are patrimonial in nature and, therefore, they can be assigned or encumbered, being transferable by all means admitted by law. One of the most common contracts in this area is the license. Intellectual property rights can be economic or “moral” in nature. Rights of an economic nature can be exploited.<br><br>If you need to protect your copyright or the exploitation, registration or image of your trade name, brand or patent, at Openlegal we will be happy to help you."},"derecho-seguridad-social":{"title":"Social Security Law","description":"Social Security Law is the set of laws and principles that regulates the branch of the country's social and economic policy, which through certain institutions, seeks to protect its members when they suffer states of necessity, produced by certain social contingencies, ensuring socially sufficient living, health, and work conditions, thus implementing the human rights to social security and an adequate standard of living.<br><br>The right to social security is of fundamental importance to guarantee all people their human dignity when faced with circumstances that deprive them of their ability to fully exercise human rights.<br><br>The right to social security includes the right to obtain and maintain social benefits, without discrimination, in order to obtain protection, in particular against: <ol><li>lack of income from work due to illness, disability, maternity, work accident, old age or death of a family member;</li><li>excessive care expenses health; and</li><li>insufficient family support, particularly for children and dependent family members.</li></ol><br>Social security plays an important role in reducing and alleviating poverty, preventing social exclusion and promote social inclusion.<br><br>If you need a professional expert in social security, do not hesitate to contact Openlegal."},"derecho-extranjeria":{"title":"Immigration Law","description":"The right of alienation is the right to free movement and residence of citizens that the international legal system subordinates its exercise to the fact that the person, whatever their nationality, national or foreign, is legally in the territory of a State.The legal requirements for foreigners in Spain require advice and defense in multiple situations before the Administration.<br><br>At Openlegal we are aware of the importance for any foreigner or immigrant to obtain or maintain the corresponding residence authorization or Spanish nationality Although many foreigners are usually familiar with procedures such as applying for a residence permit or card renewal, entrusting the completion of the procedures to lawyers specialized in immigration matters will avoid making mistakes, resolve any doubts and avoid problems. <br><br>Foreign services: <ul><li>Residence permits</li><li>Residence permit renewal</li><li>Obtaining residence on your own</li><li>Obtaining Residency as an employee</li><li>Processing to obtain the N.I.E.</li><li>Processing to obtain nationality</li><li>Obtaining a visa</li><li>Family reunification</li></ul><br>You need help to obtain or renew your residence permit, visa, NIE or family reunification, at Openlegal we help you with all the procedures to achieve it."},"derecho-militar":{"title":"Military Law","description":"Military Law a set of rules and laws that regulate the conduct and organization of a country's armed forces. These rules may include rules for active duty, punishment for military offences, and legal protection for members of the armed forces.It can also deal with the relationship between the armed forces and the government, as well as the relationship between the armed forces and society in general.<br><br>Article 117.5 of the Spanish Constitution establishes that the law shall regulate the exercise of military jurisdiction in the strictly military sphere and in cases of state of siege, in accordance with the principles of the Constitution.<br><br>The military jurisdiction is a jurisdiction dependent on the Judiciary with specific jurisdiction in the military sphere. However, the Organic Law 4/1987, of July 15, of the Competition and Organization of the Military Jurisdiction fixed types of competition: one in times of peace and another in situations of armed conflict. However, always subject to constitutional precepts.<br><br>Military Law regulates the relations between the State and the military, their organization and operation, the legal status of the military, the rights and duties of the themselves, training and military service, as well as military discipline.<br><br>In Spain, there are several institutions that are in charge of ensuring compliance with the rules and the application of Military Law, such as the Council of State, the Council of Military State, the National Court, the Supreme Court or the Court of Military Justice. These institutions have the power to control compliance with the laws and to impose sanctions in case of non-compliance.<br><br>If you need advice on military law, at Openlegal we will help you."},"derecho-aeronautico":{"title":"Air or aeronautical law","description":"Aeronautical law is the set of national and international regulations that regulate air navigation, the development and use of infrastructures, and the legal relationships that may derive from the use of airspace. Given the transversality of matters and interests those it affects —from commerce to passenger transport—, this legislative framework is made up of public and private principles and regulations, trying to respond to all situations arising from the relations that occur between the Administration and the citizens of a country, between different States and between individuals.<br><br>Have you had a problem with air transport? Tell us! At Openlegal we will do everything in our power to help you solve it."},"derecho-deporte":{"title":"Sports Law","description":"Sports law is a specialty of law that is responsible for regulating all conflicts and legal issues related to sport. Its origin dates back to ancient Greece, where the first rules and regulations were established to organize and carry out Olympic Games Over time, these rules have evolved and adapted to the needs of each era, which has led to the creation of a new discipline of law specific to modern sport, which has achieved great popularity. popularity during the 21st century.<br><br>Sports law has certain characteristics that differentiate it from common law.First, it is a specialized law that applies exclusively to matters related to sport.This means that the rules and principles of this specialty are not applicable to situations that have nothing to do with sports activities.<br><br>On the other hand, it is characterized by being a very dynamic branch of law, since it is constantly evolving and adapting to the needs of the Sports world. In addition, it is an area that covers a wide variety of matters, from the regulation of sports competitions to the protection of the rights of athletes.<br><br>At Openlegal we are experts in Sports Law, if you need advice on an athlete contract, image rights, broadcasting, how to convert a club into a sports limited company or other issues related to the legal field of sports, call us!"},"derecho-menores":{"title":"Juvenile Jurisdiction","description":"The rights of minors are strongly protected, but if they commit a crime, they are also investigated and can be punished. Crimes committed by people over the age of fourteen and under the age of eighteen are investigated in the Juvenile Courts , which are also competent to know, execute and decide on civil liability, for which parents are responsible.<br><br>They are, therefore, those in charge of the laws on minors who have incurred in conduct typified by the law as a crime.The juvenile judge also receives the file instructed by the prosecutor to adopt the corresponding decision regarding them, which may entail work for the benefit of the community, submission to some treatment, or internment in a center until supervised release. It is up to these Judges to resolve these matters and monitor the corrective measures imposed on them, surveillance that can last up to 23 years of age.<br><br>If your minor child is immersed in legal proceedings before the jurisdiction of minors, If you have been reported and need advice, do not hesitate to contact Openlegal."},"derecho-ambiental":{"title":"Environmental Law","description":"Environmental Law is the set of legal norms that regulates human activities and behaviors that can directly or indirectly damage the environment. Its purpose is both to prevent such damage and to provide the means to repair it in case it occurs and determine those responsible for those harmful actions.<br><br>Environmental Law is a broad and transversal set of regulations that affects different areas and sectors of society.For its development, legislators rely on key principles:<ul><li>Preventive and precautionary action: seeks to avoid environmental damage.</li><li>Sustainable development: public authorities have the obligation to ensure the use of resources.</li><li>“Whoever pollutes, pays” :This principle focuses on those who with their actions harm the environment and, therefore, have to pay a penalty.</li></ul><br>The root of this legal branch is born in the recognition of the environment as a legal right on which not only economic development depends, but also the well-being and health of citizens: from the use of water to generate electricity, for industry or to supply households, to the protection of forests and the control of polluting emissions to guarantee the quality of the air that is breathed.<br><br>At Openlegal we have experts in environmental law to advise you on whatever you need."},"derecho-arrendamientos":{"title":"Leasing law","description":"The right to lease is one that regulates the existing legal relationship (rights and obligations) between an owner (landlord) and a tenant (lessee) in terms of renting a home or premises.<br><br>By leasing, an owner relinquishes possession of his property (furniture or real estate).In other words, it limits his property right.<br><br>Although the lessor continues to be the owner of the leased property, it will be the lessee who has the right to use it.For this reason, legally this operation is contemplated among real rights, which are those that fall on a thing and not on a person.<br><br>It should be noted that, on occasions, the lessor may not be the owner of the rented property, but a mere manager.And also that there is the possibility of leasing services or works, as will be explained later.<br><br>Leases are regulated in Title VI (On the lease contract), of the Civil Code Spanish.<br><br>If you have to draw up a lease, if you need advice on signing a lease as an owner, tenant, home or business premises; If you are going to be evicted and you think it is unfair or if you need to claim the non-payment of rent from your rental contract, contact Openlegal, we have the best leasing experts to advise and defend you."},"derecho-civil":{"title":"Civil Law","description":"Civil Law is the branch of law that, in general, regulates the civil or private relationships of people. Civil law deals with the civil status of people, their rights and family duties, property and other real rights and easements over things, the regime of obligations and contracts and successions and inheritances.<br><br>Civil law is divided into four large branches: the general part (the subjective right in general, nationality, domicile , the acquisition and extinction of civil personality), the law of obligations and contracts (contractual and extra-contractual liability and general and special legal regime of obligations and contracts), real rights (property and possession, real rights of enjoyment, of preferential acquisition and guarantee, with special attention to mortgage law) and family law and inheritance (regulation of marriage, relations between parents and children, right to support, inheritance and different ways of succession).<br><br> At Openlegal we are civil law experts, tell us your needs, we will ensure that they are met, through the filing of the extrajudicial or judicial action or procedure that is necessary."},"derecho-penal":{"title":"Criminal Law","description":"Criminal Law is the branch of public law that regulates criminal activity within a State. Criminal law encompasses all those procedures by which a person can be investigated if they have committed a crime, or in which they can act as a Private Prosecutor if you have been harmed by the criminal conduct of a third party.<br><br>Crimes are included in different categories, from those that attempt against property (Theft, Theft, Fraud, Misappropriation, money laundering...), those that violate people's rights (homicide, murder, injuries, rape, gender violence) to others of a sectoral type such as socio-economic (false accounts, harmful agreements, false accounting), urban planning, environment and those who have to deal with public powers (influence peddling, bribery, public and private corruption, prevarication, embezzlement...).<br><br>If you need to file a criminal proceeding, or you are part of a process that has already started and you need a Lawyer as Prosecution or Defense, At Openlegal, we have the best criminal lawyers, who will accompany you throughout the procedure until you are acquitted or defend your rights and interests if you have been harmed by a crime committed by a third party."},"derecho-internacional-publico":{"title":"Public International Law","description":"​​Public International Law is the set of rules applicable to States and international organizations in their actions. Its subjects of law are States and international organizations and it addresses aspects of public interest at a supranational level.<br><br>Public international law is made up of norms, customs and legal principles that are applicable at two different levels: on the one hand, it applies to relations between States, and on the other, to relations between citizens that have a legal and international.<br><br>At Openlegal we have experts in public international law."},"derecho-contratos":{"title":"Contract Law","description":"The law of contracts refers to the set of rules that regulate the rights and obligations that arise from the conclusion of a contract.<br><br>A contract can be defined as a private act that two or more people carry out carried out and from which rights and obligations arise for them.In the words of the Civil Code itself, it can be understood as the act by which 'one or several persons agree to be bound, with respect to another or others, to give something or lend some service'.<br><br>The law of contracts is a part of civil law and, as such, its rules are found in the Civil Code. However, there are complementary laws that regulate some specific contracts, such as the Ley de Arrendamientos Ley de Arrendamientos Rusticos, in the case of lease contracts for urban and rural properties, respectively.<br><br>Do not confuse the right of contracts with the right of obligations.Obligations can derive from both relationships contractual (a contract) and tort (a car accident). Therefore, a contract implies an obligation, but an obligation does not always imply a contract.<br><br>Do you need to elaborate or review a contract? Do you need us to advise you on the interpretation of a contract or to defend your interests in the event of a breach of contract? It has Openlegal."},"pension-alimentos":{"title":"Alimony","description":"Are you divorced and your ex doesn't pay alimony for your children? Have you lost your job or your income has decreased and you can't pay as much alimony? Are you thinking of separating from the father/ mother of your children and you need advice on what your rights are or what you should pay/receive for alimony? If you have these or other questions related to the alimony that is generated or has been generated in favor of your children by having separated or divorced from your partner, do not hesitate to contact Openlegal."},"pension-compensatoria":{"title":"Compensatory pension","description":"If you have recognized the right to receive a compensatory pension in a judicial resolution and your ex-partner has not complied with it, if you are thinking of separating or getting a divorce or you need advice on the requirements and possibilities to be able to request a compensatory pension from your ex-partner due to economic imbalance in the separation, at Openlegal we have the best professionals to assist you and give you solutions."},"derecho-hipotecario":{"title":"Mortgage law","description":"It is the branch of Civil Law that studies the content of the Mortgage Law, its foundations, principles and application.<br><br>On the one hand, as a legal branch that regulates real estate, we could call Mortgage Law Real Estate Law On the other hand, as a legal branch that regulates the rights over the properties reflected in the registry, we could call the Mortgage Law as Registry Law. Combining the two concepts into one, would name the Mortgage Law as Real Estate Registry Law.<br><br>So then , we can say that the Mortgage Law is the set of rules that regulate the registration in the Property Registry, the recognition, transmission, constitution, modification, encumbrance and extinction of ownership of real estate and real rights over them.<br><br> Do you need to register a mortgage operation in the Property Registry? Don't worry, at Openlegal we take care of all the paperwork and we accompany you in the process!"},"asistencia-detenido":{"title":"Detainee Assistance","description":"Legal assistance to the detainee (at police or judicial headquarters) is configured as an inalienable right of the citizen to be assisted by a lawyer who is an expert in criminal law.<br><br>Legal assistance to the detainee of art. 17.3 CE is an instrument to safeguard the right to freedom of the detainee and not investigated and a constitutional guarantee, so that the person deprived of freedom of movement does not see restricted rights other than this If the person has been illegally detained, a habeas procedure may be exercised corpus where the duty judge must decide on the freedom or detention of the citizen.<br><br>It also constitutes an extension of the right of defense, which entails the power to choose an expert lawyer in criminal law, becoming at the same time a requirement of validity of the procedural actions.<br><br>If you have been detained and need legal assistance, contact Openlegal, we have expert lawyers who assist detainees 24 hours a day."},"derecho-sanitario":{"title":"Health law","description":"Health law is one of the branches of legal sciences that is responsible for managing and regulating all processes related to health protection, data related to people's health and medical negligence.<br><br>The legal framework of health law is regulated and protected by the Spanish Constitution and the Health Law, which integrate a set of legal regulations and procedures that will serve to fulfill medical tasks.<br><br>Health law deals with a large number of topics related to health.Here are some of the areas studied by this type of law:<ul><li>Medical Law: is in charge of managing all the rules and responsibilities of doctors and the rights of the patient.</li><li>Public health law: regulates public health programs, along with the protection of environmental health and health promotion.</li><li>Right of medical research: manages legal research issues, including the protection of the rights of participants in clinical trials.</li><li>Pharmaceutical law: regulates all aspects related to the preparation, use and distribution of medicines.</li></ul><br>If you believe that they have incurred in health negligence with you or have any questions regarding informed consent or other conditions and contracts in the health sector, contact Openlegal, our specialist lawyers will resolve your doubts and will defend your rights and interests."},"derecho-digital-imagen":{"title":"Digital and Image Law","description":"Digital rights, closely linked to freedom of expression and privacy, are those that allow people to access, use, create and publish digital media, as well as access and use computers, other electronic devices and Internet networks. Communications Cyber rights recognize the right of people to access, use, create and publish digital media, and the right of access to computers, electronic devices and telecommunications networks necessary to exercise them.<br><br>The right to one's own image It is a right enshrined in the Constitution and refers to the protection that any person can demand against the illegitimate capture, reproduction or dissemination of their appearance at any place and time in their private life.This guarantee applies regardless of the medium used, be it television , Internet, photographs, etc.<br><br>Do you have any questions related to digital rights, do you want to defend or enforce your rights against a violation or do you simply need advice? Contact Openlegal, we will do everything in our power to help you."},"derechos-humanos":{"title":"Human Rights","description":"Human Rights are norms that recognize and protect the dignity of all human beings. These rights govern the way in which individuals live in society and relate to each other, as well as their relations with the State and obligations of the State towards them.Human rights are those that every person has by the fact of existing, regardless of their race, color, sex, language, religion or any other condition.They are based on the values of human dignity, justice, peace and freedom, and they are the same for all people, cannot be eliminated and cannot be achieved without each other.<br><br>Human rights fall into two categories: civil and political, and economic, social and cultural.Civil and political guarantee that all people participate free and equal in the civil and political life of their country. Some of these are the right to life, equality or freedom of expression and conscience. Economic, social and cultural rights, for For their part, they seek people to have a dignified life. The right to work, food or housing are some examples.<br><br>In Spain, fundamental rights are enshrined and protected by the Spanish Constitution, and the State and individuals must respect them. When they do not do so, the rights holders who have been harmed have the right to file proceedings before the Constitutional Court through the Amparo Appeal.<br><br>If you believe that your fundamental rights have been violated, trust Openlegal, we will help you to obtain protection, compensation and compensation for the same."},"juicio-delito-leve":{"title":"Mild Crime Trial","description":"The trial for a minor crime is that procedure that is carried out to prosecute certain crimes considered less serious. Normally these crimes, when the damage can be economically assessed, are those that are below €400 and are usually entail penalties of a fine.In this procedure, once the complaint is filed, the complainant and denounced are summoned to the trial act, where they can go with all the documentary and testimonial evidence that they want to use to defend their rights and interests.Ex: minor crime of theft, misdemeanor of fraud, misdemeanor of electric power fraud, minor offense of injury..."},"juicio-rapido":{"title":"Swift Judgment","description":"The expedited trial is the procedure that is followed to prosecute certain crimes that the law includes, the most common being the crime of breathalyzer. Its specialty is based on the fact that, once the complaint is filed or the accused is arrested, can elucidate the same day that the defendant goes to the Duty Court, so that, if he agrees with the facts charged, he obtains a benefit in the reduction of one third of the sentence requested by the Public Prosecutor. will summon you to hold a trial in the following days without the possibility of applying said benefit."},"derecho-penitenciario":{"title":"Prison Law","description":"Prison law constitutes a set of legal norms aimed at regulating and determining the execution of custodial and non-custodial sentences. This right is the one in charge of regulating the situation of those people who are deprived of freedom in Penitentiary Centers, both the regime of entry into them, as well as that of review, permits and benefits, appeals and provisional release.<br><br>Do you have an inmate relative in a judicial proceeding?Do you want to review their grade classification, request or appeal the denial of any prison permit or benefit? At Openlegal we help you achieve it."},"derecho-maritimo":{"title":"Maritime Law","description":"Maritime Law is a regulatory body that governs problems that may arise as a result of relations between private law entities dedicated to maritime traffic. Maritime Law must be differentiated from the Law of the Sea, made up of a body of norms of International Law that regulate legal relations between States, and not between individuals.<br><br>Maritime Law has had a great historical importance that remains to this day, being a very important branch of Commercial Law.This is due to that transport by sea is widely used to transport goods that are subject to international sales. <br><br>Have you had a problem with maritime transport? Tell us! At Openlegal we will do everything in our power to help you solve it."}},"companies-contact-form":{"form":{"disclaimers":{"communications":"I agree to receive other communications from {platform}.<br> In order to provide you with the requested content, we must store and process your data."}}}}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = {"legal-title":"<div class='type-intro-title'>Legal Notice</div><br/>","legal-intro":"<p>OPENHEALTHCARE S.L., Spanish company responsible for the site www.openhealthcare.es, hereinafter RESPONSIBLE, makes available to users this document, which aims to comply with the obligations under Law 34/2002 of July 11, Services Information Society and Electronic Commerce (LSSICE), as well as inform all users of the website regarding what are the conditions of use.</p><br><p>Every person who accesses this website assumes the role of user, committing to the observance and strict compliance with the provisions herein, as well as any other legal provision that may be applicable.</p><br><p>OPENHEALTHCARE S.L., reserves the right to modify any type of information that may appear on the website, without any obligation to give prior notice or inform users of such obligations, being understood as sufficient with the publication on this website.</p><br>","legal-1":"<h4>1. IDENTIFYING DATA</h4><br>","legal-1txt":"<p>Domain name: www.openhealthcare.es</p><p>Company name: OPENHEALTHCARE S.L</p><p>CIF: B90209081</p><p>Postal address: Avda. República Argentina 25 9ª planta, 41011 Sevilla</p><p>Phone: +34 656 383 230</p><p>Email: info@openhealthcare.eu</p><p>Inscribed in the Mercantile Register of Seville in volume 6043, folio 101 inscription 1 with page SE-105834</p><br>","legal-2":"<h4>2. INTELLECTUAL AND INDUSTRIAL PROPERTY RIGHTS</h4><br>","legal-2txt":"<p>The website, including but not limited to programming, editing, compilation and other elements necessary for its operation, designs, logos, text and/or graphics, are the property of the RESPONSIBLE or, if applicable, has a license or express authorization from the authors. All the contents of the website are duly protected by intellectual and industrial property regulations, as well as registered in the corresponding public registers. Regardless of the purpose for which they were intended, the total or partial reproduction, use, exploitation, distribution and commercialization, requires in any case the prior written authorization by the RESPONSIBLE. Any use not previously authorized is considered a serious breach of the intellectual or industrial property rights of the author.</p><br>","legal-3":"<h4>3. DISCLAIMER</h4><br>","legal-3txt":"<p>The LIABLE disclaims any liability of any kind arising from the information published on its website provided that this information has been manipulated or introduced by a third party external to it.</p><br>","legal-4":"<h4>4. LINKING POLICY</h4><br>","legal-4txt":"<p>From the website, you may be redirected to content on third party websites. Since the RESPONSIBLE cannot always control the contents introduced by third parties on their respective websites, it does not assume any responsibility for such content. In any case, it will proceed to the immediate withdrawal of any content that could contravene national or international legislation, morality or public order, proceeding to the immediate withdrawal of the redirection to said website, bringing the content in question to the attention of the competent authorities.</p><br><p>The RESPONSIBLE is not responsible for the information and content stored, including but not limited to, in forums, chats, blog generators, comments, social networks or any other means that allows third parties to publish content independently on the website of the RESPONSIBLE. However, and in compliance with the provisions of Articles 11 and 16 of the LSSICE, is available to all users, authorities and security forces, actively collaborating in the removal or, where appropriate, blocking of all content that may affect or contravene national or international law, the rights of third parties or morality and public order. In the event that the user considers that there is any content on the website that could be susceptible to this classification, please notify the website administrator immediately.</p><br><p>This website has been reviewed and tested to ensure that it functions correctly. In principle, it can be guaranteed to function properly 365 days a year, 24 hours a day. However, the RESPONSIBLE does not rule out the possibility that there may be certain programming errors, or that force majeure, natural disasters, strikes or similar circumstances may occur that make it impossible to access the website.</p><br>","legal-5":"<h4>5.IP ADDRESSES</h4><br>","legal-5txt":"<p>The website servers may automatically detect the IP address and domain name used by the user. An IP address is a number automatically assigned to a computer when it connects to the Internet. All this information is recorded in a server activity file duly registered that allows the subsequent processing of the data in order to obtain measurements only statistics that allow to know the number of page impressions, the number of visits made to web servers, the order of visits, the access point, etc.</p><br>","legal-6":"<h4>6. APPLICABLE LAW AND JURISDICTION</h4><br>","legal-6txt":"<p>For the resolution of all disputes or questions relating to this website or the activities carried out in it, Spanish law shall apply, to which the parties expressly submit themselves, being competent for the resolution of all disputes arising from or related to its use the Courts and Tribunals of Seville.</p><br>","legal-7":"<h4>7. Claims</h4>","legal-7txt":"<p>If you want to file a claim against OPENHEALTHCARE S.L. \nYou can do it at the email quejas@opensalud.es</p>"}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"openlegal":{"menu":{"for-you-and-your-family":"For you and your family","for-business":"For Businesses","for-freelancers":"Freelancers","sign-in":"Sign in","are-you-lawyer":"Are you a lawyer?","business":"Companies"},"title":"We are here to help you","subtitle":"The best legal advice for you and your family, at any time and from anywhere.","more-info":"More information","cards":{"first":{"title":"Whenever you need it","description":"At home, on the road, on vacation wherever you are, access the lawyer you need by video, phone, messaging or chat."},"second":{"title":"Comfortable and secure","description":"You can access your lawyer in person, video, telephone or chat at any time and from anywhere."},"third":{"title":"Take care of yourself and your family","description":"Ignoring your rights, or making decisions without adequate advice, can have serious consequences for you or your family."},"fourth":{"title":"Specialists in your rights","description":"Consumption, housing, defaults, labor, fines, tax, insurance, family... find the right lawyer for your needs."}},"advantages":"Advantages of openlegal","best-legal-services":"The best legal service for companies and individuals","for-freelancers":"openlegal for freelancers","home-subtitle":"Access the best lawyers in an easy and secure way.","contact-form":{"text":"If you want to tell us about your case or request information about the service, contact us"},"find-lawyer":"Find a lawyer","explain-case":"Contact us","home-cards":{"first":{"title":"The right professional","description":"We evaluate each professional individually, so that you can access the best legal advice, both face-to-face and online, at the best price."},"second":{"description":"You can access the lawyer you need by video, phone or chat at any time and from anywhere, in a maximum security environment."},"fourth":{"title":"Professional video platform","description":"Secure and private. \nDoes not require users to be registered (Teams, Zoom...)"}},"search-ph":"How can we help you?","search":"Search","are-you-lawyer":"Are you a lawyer?","sign-up-in":"Sign in","security-privacity":"Security and privacy.","security-subtitle":"Everything you need with the highest level of protection.","security-text1":"The security of communications and data privacy are our priority.","security-text2":"We put at your disposal the best technology with maximum security in communications and total privacy of your data. \nOur platform is ISO 27001 certified.","lawyer-block-description":"Own website, online agenda, video and professional chat, maximum security, billing, payment gateway...\n\n\nIn just 20 minutes you can digitize your office and access clients from anywhere.","form-reason":"Contact reason","companies":"Some clients of opensalud and openlegal"},"card":{"title-video":"Professional video platform"}}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = {"os360-empresas":{"more-info-btn":"More info","know-more-btn":"Learn more","big-companies":{"request-info":"Ask for information"},"more-information-btn":"More information","main-block":{"more-info":"info","paragraph":"opensalud360 allows your employees, clients or policyholders to access the best doctors, psychologists or nutritionists, the best wellness programs and the most complete health application, at any time and from anywhere.","subtitle":"Experts in taking care of your equipment.","title":"The 360 ​​health and wellness platform for companies."},"wellness-services":{"title":"<b>WellbeingScore®</b><br>Know the state of health and well-being of your employees","subtitle":"Offer your employees a self-diagnosis of health and wellness with individual action plans.","cards":{"1":{"title":"Physical wellness","subtitle":"Movement, eating, resting and sleeping habits and health monitoring."},"2":{"title":"Emotional wellness","subtitle":"Happiness and disconnection index, uncertainty and stress management and work capacity."},"3":{"title":"Environment wellness","subtitle":"Personal, professional and digital environment, habits of sustainability and environment and psychosocial risks"},"4":{"title":"Social wellness","subtitle":"Level of social support, financial well-being, level of conciliation, openness to diversity, talent and interpersonal skills."}}},"blocks":{"title":"Welcome to","more-info-question":"Do you need more info?","evaluate-your-health":{"description":"Evaluation of emotional well-being, nutrition, disease risk and much more","title":"Evaluate your health"},"healthy-community":{"description":"Share your health and wellness experience and make healthy plan proposals to your colleagues","title":"Healthy community"},"healthy-habits":{"description":"Create your challenges to improve your habits. \nYou can rely on a professional or do them as a couple","title":"Healthy Foods and Habits"},"opensaludpass":{"description":"Consultations, diagnostic tests and face-to-face treatments at a reduced price","title":"opensaludPass","soon":"Soon"},"teleconsultation":{"title":"Online consultations","description":"Doctors, psychologists, nutritionists and other specialties with free choice"},"wellness":{"description":"Daily live classes, workshops, online gym, meditation, programs and much more...","title":"opensaludWellness"},"what-do-you-need":"What do you need?","digital-phisiotherapy":{"description":"Guided by Artificial Intelligence and monitored by physiotherapists","title":"Digital physiotherapy"}},"social-benefit":{"list":{"1":"Physically and mentally healthier employees","2":"Lower absenteeism rates","3":"Improve conciliation","4":"Happier and more engaged employees","5":"Increase the performance of your equipment","6":"Improves retention and attraction"},"security-description":"And we do it with maximum security in communications and total privacy of your data. \nOur platform is ISO 27001 certified and audited by the Collegiate Medical Organization.","subtitle":"We provide a benefit highly valued by employees and of great impact for the company.","title":"We take care of the most important thing about your company, your employees"},"opensalud-empresas":{"form-subtitle":"If you want your employees to access the best digital health and wellness services, contact us."},"psychological-attention":{"quote":"The most productive work is the one that comes out of the hands of a happy person","subtitle":"Mental and emotional health as a driver of well-being and productivity","subtitle-2":"Anxiety, stress, emotional problems... are not usually easy to detect externally until the damage is very evident and the solutions are expensive. \nThat is why it is key to provide people with quality and highly accessible solutions that allow them to take care of the problem in the initial phases.","title-2":"The importance of early detection and prevention","title":"Experts in mental and emotional health in the company","text":"We started from a general state of fragile mental and emotional health (especially in developed countries), which the current situation has ended up overwhelming and which is going to have a huge impact on organizations in the present and in the future. \n<br><br> Anxiety, stress, depression, family and relationship problems, change management... are situations that we can overcome if we have the right tools and above all with the support of a qualified professional of free choice, accessible anywhere time and from anywhere.","text-2":"These problems are usually not easy to detect externally until the deterioration is more evident and the solutions expensive. \nThat is why it is essential to provide employees with quality and highly accessible solutions, which allow them to manage the problem in the initial phases."},"companies2":"With more than 1,000 health professionals available and more than 50 health and wellness programs, large companies and institutions trust us to take care of the health and well-being of their employees and clients in <b> Spain, Portugal, Mexico and Brazil. \n</b>","companies":"30 employees or 30,000, we have a solution adapted to your needs and budget."}}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"More info","main-block-h1":"Welcome to the future of business health and wellness services","more-information-btn":"More info","know-more-btn":"Learn more","integral-solution":{"title":"Integral solution","subtitle":"The only 360 health and wellness platform","text":"Now more than ever, we want to help improve the physical, mental and emotional health of people and organizations around the world. opensalud360 is a digital health platform that allows its users to access the best doctors, psychologists or nutritionists and the best health and wellness programs, at any time and from anywhere, in an brittle, easy and secure way."},"block-5":{"blackTitle":"Security and privacity.","title":"Everything you need with the highest level of protection.","text":"The security of communications and data privacy are our priority.","text2":"We put at your disposal the best technology with maximum security in communications and total privacy of your data. Our platform has ISO 27001 certification and is audited by the Collegiate Medical Organization."},"discounts":{"title":"Discounts on private clinical services","subtitle":"If you need proof and don't want to wait<br /><br />Access to the largest list of health services in Spain with more than 25,000 professionals and centers with discounts of up to 60% in consultations, interventions, tests, treatments, products and health services:","clinic-services":"Clinical services","clinic-services-description":"Allows access to doctors and medical centers that make up the Medical List of the 'AVANTSALUD' Service:","close":"Close","teeth-services-description":"This service includes certain free dental services and access to a List of Doctors at a scaled price. The free dental services are:","health-services-description":"Includes certain services related to well-being and health in specialties not usually included in health insurance, such as:","medical-services-list":"Primary medicine consultations (general medicine and paediatrics)<br> Specialist consultations<br> Diagnostic doctors<br> Medical treatments<br> Hospitalization and surgical interventions<br> Medical services<br> Allergology<br> Pathological anatomy<br> Angiology and vascular surgery<br> Digestive system<br> Cardiology<br> Cardiovascular surgery<br> General surgery and Digestive system<br> Breast surgery<br> Maxillofacial surgery<br> Surgery Oncology<br> Pediatric surgery<br> Plastic and reconstructive surgery<br> Thoracic surgery<br> Vascular surgery<br> Dermatology and venereology<br> Endocrinology and nutrition<br> Nursing<br> Hematology and hemotherapy<br> Nephrology<br> Pneumology<br> Neurosurgery<br> Clinical neurophysiology<br> Neurology<br> Obstetrics and gynecology<br> Ophthalmology<br> Medical oncology<br> Radiation oncology<br> Otorhinolaryngology<br> Rehabilitation<br> Rheumatology<br> Traumatology and Orthopedics<br> Urology<br> General Medicine General<br> Paediatrics<br> Paediatrics-Childcare<br> Clinics and Hospitals<br> Polyclinics<br> Perimetry<br> Panoramic/Orthopantomography<br> Ultrasounds<br> Mammograms<br> CAT scan<br> Clinical analysis<br> Diagnostic Imaging<br> Nuclear Medicine","teeth-services-list":"First visit and budget delivery<br> Review visit<br> Oral education<br> Teaching brushing techniques<br> Fluoridation<br> Annual mouth cleaning. Tartrectomy<br> Dental X-rays (periapical, wing, occlusal)<br> Diagnosis and probing<br> Occlusal adjustments<br> Remove stitches<br> Implantology study<br> False titanium stump<br> Healing and cementation screw<br>","health-services-list":"Acupuncture/Homeopathy/Naturopathy<br> Avantsalud in shape<br> Spas<br> Recognition centers<br> Laser ophthalmologic refractive surgery<br> Bobath Concept<br> Stem Cell Conservation- Cordon<br> Digital Dermatoscopy<br> Dietetics<br> 3D and 4D ultrasounds<br> Aesthetics<br> Physiotherapy and child physiotherapy<br> Colon hydrotherapy<br> Preventive Medicine and Genetic Testing<br> Optics and Hearing Aids<br> Orthopedics<br> Osteopathy<br> Plans with children<br> Podiatry and Footprint study<br> Home care services (postpartum care)<br> Minimally invasive procedures<br> Psychology, pedagogy and logophoniatry<br> Chiropractic <br> Cardiac rehabilitation<br> Animal-assisted therapy<br> Smoking cessation treatments<br> Infertility treatments<br> Shock wave treatment (erectile dysfunction)<br> Veterinarians<br> Laser myopia, astigmatism, hyperopia<br> Podiatry at home<br> Analytics at home<br> Physiotherapy at home<br> Prevention of cervical cancer/HPV<br> Cardiological genetic test<br> Screening for colon cancer in blood<br> Genetic test for obesity<br> Genetic test for lung cancer<br> Oncological check-up <br> Alzheimer's genetic test<br> Thromboembolism genetic test<br> Type II Diabetes genetic test<br> Breast cancer genetic test<br> Non-invasive prenatal test<br> Preeclampsia<br> Paternity test<br> Genetic fingerprint <br> Food intolerance test<br> Macular degeneration test<br> Fetal sex in maternal blood<br> Melissa test<br> Migraine test<br> Lactose - fructose intolerance test<br> Gastric balloon<br> Capsule endoscopic<br> Prostate green laser<br> Laser in dermatology<br> Vascular laser/endolaser<br> Percutaneous foot surgery<br> No-scalpel vasectomy<br> Blepharoplasty<br> Abdominoplasty<br> Rhinoplasty<br> Lifting <br> Capillary micrografts<br> Augmentation mammoplasty<br> Reduction mammoplasty<br> Intimate surgery<br> Liposuction<br>","wellness-services":"Wellness services","medic-services":"Medical services","tooth-services":"Dental services"},"social-benefit":{"title":"We take care of the most important thing in your company, your employees","subtitle":"We provide a highly valued, high-impact social benefit.","list":{"1":"Reduces absenteeism and improves work-life balance","2":"Boosts performance","3":"Increases motivation and retention","4":"And above all.... Improves health and well-being!"},"list-1":"Lower absenteeism rates","list-2":"Happier and more engaged employees","list-3":"Improve reconciliation","list-4":"Increase the performance of your teams","list-5":"Increases retention and attraction","list-6":"Physically and mentally healthier employees"},"psychological-attention":{"title":"Mental and emotional health","subtitle":"Mental and emotional health as a driver of well-being and productivity","text":"We started from a general state of fragile mental and emotional health (especially in developed countries), which the current situation has finally overwhelmed and which is going to have a huge impact on the present and future of organizations. <br><br> Anxiety, stress, depression, family and couple problems, change management... are situations that we can overcome if we have the right tools and above all the support of a qualified professional of free choice, accessible at any time and from any location.","quote":"The most productive work is the one that comes<br>out of the hands of a happy person.","title-2":"The importance of early detection and prevention","subtitle-2":"Anxiety, stress, emotional problems... are not usually easy to detect externally until the deterioration is very evident and the solutions expensive. \nThat is why it is key to provide people with quality and highly accessible solutions that allow them to take charge of the problem in the initial phases."},"wellness":{"title":"Health and wellness programs","list":{"1":{"title":"Personalized content to get your vitality fix!","text":"Physical, mental and nutritional health."},"2":{"title":"Online training plans","text":"Healthy Back - Cardiovascular - Active Health - Pilates - Pregnant - Mindfulness - Stress."},"3":{"title":"Daily live classes and sessions: you'll have no excuse with your online gym!","text":"We broadcast quality content daily and 'live' from different sports disciplines."},"4":{"title":"Online workshops","text":"Sign up for our workshops on nutrition, stress management and many other topics of interest."}}},"telemedicine-services":{"title":"Tele-scanning and telemonitoring","subtitle":"Turn any space into a health point","text":"opensalud360 offers advanced telemedicine services. Within a teleconsultation service we incorporate tele-exploration devices (digital stethoscope...) and tele-monitoring (temperature, blood pressure, electro cardio...) that allow to develop the full potential of telemedicine, allowing to take medical care wherever the patient is. <br><br> Users can monitor their health variables and, if necessary, share their data with a professional during the teleconsultation. Likewise, the physician during the video consultation can auscultate (heart and lung) the patient and explore him remotely (orifices, skin, etc.)."},"health-platform":{"title":"Would you like to have your own personalized digital health platform?","subtitle":"Possibility to customize the platform for your employees or customers, with your own look and feel."},"wellness-services":{"title":"<b>WellbeingScore®</b><br>Know the state of health and well-being of your employees","subtitle":"Offer your employees a self-diagnosis of health and wellness with individual action plans.","cards":{"1":{"title":"Physical wellness","subtitle":"Movement, eating, resting and sleeping habits and health monitoring."},"2":{"title":"Emotional wellness","subtitle":"Happiness and disconnection index, uncertainty and stress management and work capacity."},"3":{"title":"Environment wellness","subtitle":"Personal, professional and digital environment, habits of sustainability and environment and psychosocial risks"},"4":{"title":"Social wellness","subtitle":"Level of social support, financial well-being, level of conciliation, openness to diversity, talent and interpersonal skills."}}},"discountssect":{"title":"Premium access to private clinical services.","subtitle":"As a complement to online consultations, you will be able to access more than 25,000 professionals and centers throughout Spain, at a very low price. \nInterventions, tests, treatments, consultations, sports, health products, optics, dental...","text":"Access to the largest list of health services in Spain with more than 25,000 professionals and centers with discounts of up to 60% on consultations, interventions, tests, treatments, products and health services:"},"companies":"30 employees or 30,000, we have a solution adapted to your needs and budget.","openlegal":{"are-you-lawyer":"Are you an outstanding lawyer? Are you interested in the digital world?\n\n\nDo you want to gain visibility to access new customers?"},"opensalud-empresas":{"form-subtitle":"If you want your employees to access the best digital health and wellness services, contact us."},"main-block-h1-new":"Health and wellness platform for companies.","main-bussiness-block-h2":"We take care of the well-being of companies, taking care of the people who work in them.","companies2":"With more than 1,000 health professionals available and more than 50 health and wellness programs, large companies and institutions trust us to take care of the health and well-being of their employees and clients in <b> Spain, Portugal, Mexico and Brazil. \n</b>","ask-demo-btn":"request demo","patients-landing-different-health-description":"We want to facilitate access to qualified professionals, reference centers and solutions \n\nand the well-being used by leaders, to help you live more and live better."}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"More info","main-block-h2":"Always.","main-block-h3":"Your professional platform of consultations","main-block-h4":"and wellness.","sign-in-btn":"Sign in","access-btn":"Access","access-patient":"Patients Access","sign-up-btn":"Sign up","patients":"Patient","business":"Business","prove-free":"ASK FOR A DEMO","more-information-btn":"More info","ask-for-demo":"Ask for a demo","ask-for-demo-title":"Recommend opensalud to your patients","register-free":"Sign up and try it free for 6 months with no obligation!","register-free-openlegal":"Sign up and try it free for 6 months with no obligation!","registerfor-free":"Sing up free!","know-more-btn":"Learn more","block-2":{"blackTitle":"Designed by doctors.","title":"Take care of your patients how and when you want."},"block-3":{"blackTitle":"Face-to-face and online.","title":"Offer an innovative service to your patients and complement your face-to-face consultation.","text":"Patients will be able to contact you in an easy and secure way, so that you can decide which consultations you want to do in person and which ones online.","text2":"In addition, you will be able to manage all the information of your patients: their clinical history, appointments, billing, indicate tasks, schedule follow-ups or prescribe online under the approved prescription system of the WTO.","text3":"Your patients will also be able to use the habit tracking application, medication reminder, the health agenda, or connect their smartwatch among other solutions."},"block-4":{"blackTitle":"Optimize your consultation.","title":"Increase your income and improve the attention.","text":"Increase your visibility and reputation. Attract new patients thanks to your online profile.","text2":"You will have a secure payment gateway so that your patients can make the payment safely.","text3":"We take care of reminding the patient of their appointment and automatically issuing the invoice on your behalf.","text4":"Organize and monetize communications with your patients by avoiding mobile phones, emails, WhatsApp or phone calls."},"block-5":{"blackTitle":"Everything you need, with the highest level of protection.","title":"Avoid the use of messaging or video applications not suitable for clinical practice.","text":"The security of communications and data privacy are our priority.","text2":"We put at your disposal the best technology with maximum security in communications and total privacy of your data. \nOur data security management system has the ISO 27001 certification and is audited by the Collegiate Medical Organization."},"block-6":{"title":"The secret to excellent online service is to have excellent digital professionals.","subtitle":"Consult the best doctors, psychologists and nutritionists, easily and safely, at the best price, wherever you are."},"block-8":{"title":"Professionals rates","iva":"(TAX not included)"},"block-7":{"text1":"is an initiative that arises to channel the solidarity activities of health professionals who wish to offer their services to NGOs that work in areas with limited access to health services, using telemedicine.","text2":"If you want to contribute a small part of your time to remotely care for patients in vulnerable areas, request information.","text3":"Professionals who collaborate with the initiative will be able to use the opensalud platform for their usual clinical practice, without paying any fee.","blackTitle":"Telemedicine for vulnerable communities"},"block-end":{"title":"Access the best online. Quality medicine without haste.","subtitle":"Access the best professionals and services at any time and from anywhere in an easy and secure way."},"integral-solution":{"title":"Integral solution","subtitle":"The only 360 health and wellness platform","text":"Now more than ever, we want to help improve the physical, mental and emotional health of people and organizations around the world. opensalud 360 is a digital health platform that allows its users to access the best doctors, psychologists or nutritionists at any time and from anywhere, in an agile, easy and safe way."},"social-benefit":{"title":"We take care of the most important thing in your company, your employees","subtitle":"We provide a highly valued, high-impact social benefit.","list":{"1":"Reduce absenteeism and improve conciliation","2":"Boost performance","3":"Increases motivation and retention","4":"And above all.... Improves health and well-being!"}},"block-360":{"title":"opensalud360","subtitle":"The new service of health and welfare for business.","text":"opensalud360 is a digital health platform that allows its users to access to the best professional and health and welfare programs, everywhere and everytime, in an agile, easy and secure way."},"psychological-attention":{"title":"Experts in mental and emotional health in the company","subtitle":"Mental and emotional health as a driver of well-being and productivity","text":"We started from a general state of fragile mental and emotional health (especially in developed countries), which the current situation has finally overwhelmed and which is going to have a huge impact on the present and future of organizations. <br><br> Anxiety, stress, depression, family and couple problems, change management... are situations that we can overcome if we have the right tools and above all the support of a qualified professional of free choice, accessible at any time and from any location.","quote":"The most productive work is the one that comes<br>out of the hands of a happy person."},"wellness":{"title":"Health and wellness programs","list":{"1":{"title":"Personalized content to get your vitality fix!","text":"Physical, mental and nutritional health."},"2":{"title":"Online training plans","text":"Healthy Back - Cardiovascular - Active Health - Pilates - Pregnant - Mindfulness - Stress."},"3":{"title":"Daily live classes and sessions: you'll have no excuse with your online gym!","text":"We broadcast quality content daily and 'live' from different sports disciplines."},"4":{"title":"Online workshops","text":"Sign up for our workshops on nutrition, stress management and many other topics of interest."}}},"telemedicine-services":{"title":"Tele-scanning and telemonitoring","subtitle":"Turn any space into a health point","text":"opensalud360 offers advanced telemedicine services. Within a teleconsultation service we incorporate tele-exploration devices (digital stethoscope...) and tele-monitoring (temperature, blood pressure, electro cardio...) that allow to develop the full potential of telemedicine, allowing to take medical care wherever the patient is. <br><br> Users can monitor their health variables and, if necessary, share their data with a professional during the teleconsultation. Likewise, the physician during the video consultation can auscultate (heart and lung) the patient and explore him remotely (orifices, skin, etc.)."},"health-platform":{"title":"Would you like to have your own personalized digital health platform?","subtitle":"Possibility to customize the platform for your employees or customers, with your own look and feel."},"cardsPricing":{"title1":"Professionals","text1":"5€/mes por profesional adicional (máx. 260€/mes)","subtitle":"Commission on consultation charged in opensalud","title2":"Clinical centers","text2":"5 professionals included. <br /> 5€/month per additional professional (max. 190€/month)"},"card":{"title1":"Online consultation","subtitle1":"Video consultation, Written consultation, Chat, Second opinion...","title2":"Electronic prescription","subtitle2":"Recipes approved by the Collegiate Medical Organization.","title3":"Clinic History","subtitle3":"Access, edit and share the clinical history with your patients.","title4":"Face-to-face consultation","subtitle4":"Home consultation. Clinic consultation.","title5":"Subscriptions and packs","subtitle5":"Design your own service packs and subscriptions.","title6":"Online diary","subtitle6":"Manage your appointments online easily automatically.","title7":"Online billing","subtitle7":"Make your payments and issue your invoices automatically.","title8":"Remote monitoring and exploration","subtitle8":"It incorporates devices to facilitate online consultation and monitoring.","title9":"Customizable prices","subtitle9":"You can set different prices depending on the reason for consultation or the group.","title10":"Interconsultations","subtitle10":"Contact other colleagues through internal messaging","title-video":"Professional video platform","subtitle-video":"Secure and private. \nDoes not require users to be registered (Teams, Zoom...)","src-price":"'/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg'","title-1":"Individuals","subtitle-1":"The best doctors and the best health application.","title-2":"Professionals","subtitle-2":"Medical table for independent professionals","title-3":"Companies","subtitle-3":"We take care of the health and well-being of employees."},"openlegal":{"menu":{"for-you-and-your-family":"For you and your family","for-business":"For Businesses","for-freelancers":"Freelancers","sign-in":"Sign in"},"title":"We are here to help you","more-info":"More information","cards":{"first":{"title":"No waiting wherever you are","description":"At home, on the road, on vacation wherever you are, access the lawyer you need by video, phone, messaging or chat."},"second":{"title":"Comfort and Security","description":"Avoid inconvenience by limiting travel. You will be able to receive the documentation in digital format and in a highly secure environment."},"third":{"title":"Take care of your life and that of your family","description":"Ignoring your rights, or making decisions without adequate advice, can have serious consequences for you or your family."},"fourth":{"title":"Specialists in your rights","description":"Consumption, housing, defaults, labor, fines, tax, insurance, family... find the right lawyer for your needs."}},"advantages":"Advantages of openlegal","best-legal-services":"The best legal service for companies and individuals","for-freelancers":"openlegal for freelancers","professional":"Professional","patient":"Patient","companies":"With more than 1000 doctors, psychologists and nutritionists available, large companies and institutions trust us to take care of the health and well-being of their employees and clients in Spain and Mexico."},"centre":"Centro","patients-like-you":"Patients Like You","main-h1":"Just take care of your health","main-h1-title":"Just take care of your health and wellness.","block":{"title":"Our profiles","blackTitle":"we introduce you"},"text-1":"Access the best doctors and the most advanced application to take care of your health."}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"More info","main-professional-block-h1":"The platform for independent professionals.","main-professional-block-h2":"If you want to digitize your consultation, we offer you everything you need to attend to your patients (face-to-face and online) in an easy and safe way.","main-professional-block-h3":"Your professional platform of consultations","main-professional-block-h4":"Quality medicine, without rush.","sign-in-btn":"Sign in","access-btn":"Access","access-patient":"Patients Access","sign-up-btn":"Sign up","patients":"Patients","business":"Business","prove-free":"ASK FOR A DEMO","more-information-btn":"More info","ask-for-demo":"Ask for a demo","ask-for-demo-title":"Recommend opensalud to your patients","register-free":"Sign up and try it free for 6 months with no obligation!","register-free-openlegal":"Sign up and try it free for 6 months with no obligation!","registerfor-free":"Sing up free!","know-more-btn":"Learn more","block-2":{"blackTitle":"Designed by doctors.","title":"Take care of your patients how and when you want."},"block-3":{"blackTitle":"Face-to-face and online.","title":"Offer an innovative service to your patients and complement your face-to-face consultation.","text":"Patients will be able to contact you in an easy and secure way, so that you can decide which consultations you want to do in person and which ones online.","text2":"In addition, you will be able to manage all the information of your patients: their clinical history, appointments, billing, indicate tasks, schedule follow-ups or prescribe online under the approved prescription system of the WTO.","text3":"Your patients will also be able to use the habit tracking application, medication reminder, the health agenda, or connect their smartwatch among other solutions."},"block-4":{"blackTitle":"Optimize your consultation.","title":"Increase your income and improve the attention.","text":"Increase your visibility and reputation. Attract new patients thanks to your online profile.","text2":"You will have a secure payment gateway so that your patients can make the payment safely.","text3":"We take care of reminding the patient of their appointment and automatically issuing the invoice on your behalf.","text4":"Organize and monetize communications with your patients by avoiding mobile phones, emails, WhatsApp or phone calls."},"block-5":{"blackTitle":"Everything you need, with the highest level of protection.","title":"Avoid the use of messaging or video applications not suitable for clinical practice.","text":"The security of communications and data privacy are our priority.","text2":"We put at your disposal the best technology with maximum security in communications and total privacy of your data. \nOur data security management system has the ISO 27001 certification and is audited by the Collegiate Medical Organization."},"block-6":{"title":"The secret to excellent online service is to have excellent digital professionals.","subtitle":"Consult the best doctors, psychologists and nutritionists, easily and safely, at the best price, wherever you are."},"block-8":{"title":"Professionals rates","iva":"(TAX not included)"},"block-7":{"text1":"is an initiative that arises to channel the solidarity activities of health professionals who wish to offer their services to NGOs that work in areas with limited access to health services, using telemedicine.","text2":"If you want to contribute a small part of your time to remotely care for patients in vulnerable areas, request information.","text3":"Professionals who collaborate with the initiative will be able to use the opensalud platform for their usual clinical practice, without paying any fee.","blackTitle":"Telemedicine for vulnerable communities"},"block-end":{"title":"Access the best online. Quality medicine without haste.","subtitle":"Access the best professionals and services at any time and from anywhere in an easy and secure way."},"integral-solution":{"title":"Integral solution","subtitle":"The only 360 health and wellness platform","text":"Now more than ever, we want to help improve the physical, mental and emotional health of people and organizations around the world. opensalud 360 is a digital health platform that allows its users to access the best doctors, psychologists or nutritionists at any time and from anywhere, in an agile, easy and safe way."},"social-benefit":{"title":"We take care of the most important thing in your company, your employees","subtitle":"We provide a highly valued, high-impact social benefit.","list":{"1":"Reduce absenteeism and improve conciliation","2":"Boost performance","3":"Increases motivation and retention","4":"And above all.... Improves health and well-being!"}},"block-360":{"title":"opensalud360","subtitle":"The new service of health and welfare for business.","text":"opensalud360 is a digital health platform that allows its users to access to the best professional and health and welfare programs, everywhere and everytime, in an agile, easy and secure way."},"psychological-attention":{"title":"Experts in mental and emotional health in the company","subtitle":"Mental and emotional health as a driver of well-being and productivity","text":"We started from a general state of fragile mental and emotional health (especially in developed countries), which the current situation has finally overwhelmed and which is going to have a huge impact on the present and future of organizations. <br><br> Anxiety, stress, depression, family and couple problems, change management... are situations that we can overcome if we have the right tools and above all the support of a qualified professional of free choice, accessible at any time and from any location.","quote":"The most productive work is the one that comes<br>out of the hands of a happy person."},"wellness":{"title":"Health and wellness programs","list":{"1":{"title":"Personalized content to get your vitality fix!","text":"Physical, mental and nutritional health."},"2":{"title":"Online training plans","text":"Healthy Back - Cardiovascular - Active Health - Pilates - Pregnant - Mindfulness - Stress."},"3":{"title":"Daily live classes and sessions: you'll have no excuse with your online gym!","text":"We broadcast quality content daily and 'live' from different sports disciplines."},"4":{"title":"Online workshops","text":"Sign up for our workshops on nutrition, stress management and many other topics of interest."}}},"telemedicine-services":{"title":"Tele-scanning and telemonitoring","subtitle":"Turn any space into a health point","text":"opensalud360 offers advanced telemedicine services. Within a teleconsultation service we incorporate tele-exploration devices (digital stethoscope...) and tele-monitoring (temperature, blood pressure, electro cardio...) that allow to develop the full potential of telemedicine, allowing to take medical care wherever the patient is. <br><br> Users can monitor their health variables and, if necessary, share their data with a professional during the teleconsultation. Likewise, the physician during the video consultation can auscultate (heart and lung) the patient and explore him remotely (orifices, skin, etc.)."},"health-platform":{"title":"Would you like to have your own personalized digital health platform?","subtitle":"Possibility to customize the platform for your employees or customers, with your own look and feel."},"cardsPricing":{"title1":"Professionals","text1":"5€/mes por profesional adicional (máx. 260€/mes)","subtitle":"Commission on consultation charged in opensalud","title2":"Clinical centers","text2":"5 professionals included. <br /> 5€/month per additional professional (max. 190€/month)","electronicrecipe":"Electronic prescription add-on module","electronicrecipeprice":"€5.90/professional","subtitle1":"<b>3.5%</b> up to <b>€2,500</b> monthly billing","subtitle2":"2.5% up to €2,500 monthly billing","subtitle3":"<b>1.5%</b> from <b>€2,500</b>"},"card":{"title1":"Online consultation","subtitle1":"Video consultation, Written consultation, Chat, Second opinion...","title2":"Electronic prescription","subtitle2":"Recipes approved by the Collegiate Medical Organization.","title3":"Clinic History","subtitle3":"Access, edit and share the clinical history with your patients.","title4":"Face-to-face consultation","subtitle4":"Home consultation. Clinic consultation.","title5":"Subscriptions and packs","subtitle5":"Design your own service packs and subscriptions.","title6":"Online diary","subtitle6":"Manage your appointments online easily automatically.","title7":"Online billing","subtitle7":"Make your payments and issue your invoices automatically.","title8":"Remote monitoring and exploration","subtitle8":"It incorporates devices to facilitate online consultation and monitoring.","title9":"Customizable prices","subtitle9":"You can set different prices depending on the reason for consultation or the group.","title10":"Interconsultations","subtitle10":"Contact other colleagues through internal messaging","title-video":"Professional video platform","subtitle-video":"Secure and private. \nDoes not require users to be registered (Teams, Zoom...)","src-price":"/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg"},"openlegal":{"menu":{"for-you-and-your-family":"For you and your family","for-business":"For Businesses","for-freelancers":"Freelancers","sign-in":"Sign in"},"title":"We are here to help you","more-info":"More information","cards":{"first":{"title":"No waiting wherever you are","description":"At home, on the road, on vacation wherever you are, access the lawyer you need by video, phone, messaging or chat."},"second":{"title":"Comfort and Security","description":"Avoid inconvenience by limiting travel. You will be able to receive the documentation in digital format and in a highly secure environment."},"third":{"title":"Take care of your life and that of your family","description":"Ignoring your rights, or making decisions without adequate advice, can have serious consequences for you or your family."},"fourth":{"title":"Specialists in your rights","description":"Consumption, housing, defaults, labor, fines, tax, insurance, family... find the right lawyer for your needs."}},"advantages":"Advantages of openlegal","best-legal-services":"The best legal service for companies and individuals","for-freelancers":"openlegal for freelancers","professional":"Professional","patient":"Patient","companies":"With more than 1000 doctors, psychologists and nutritionists available, large companies and institutions trust us to take care of the health and well-being of their employees and clients in Spain and Mexico."},"centre":"Centro","patients-like-you":"Patients Like You","primeByOpensaludWarning":"Starting September 15, opensalud will become <b>prime by opensalud</b>, a new concept focused on the needs of doctors practicing private medicine. \nRegister or follow us on our social networks to stay informed."}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = {"appointmentsTitle":"Consultations","unassigned":"Not assigned","appointmentsSearchBanner":"Indicate the interval if you cannot find your consultation (by default we show appointments from 60 days ago).","nextAppointmentsTitle":"Upcoming consultations","writtenAppointmentsTitle":"Written Consultation/Second Opinion","pastChatsAppointmentsTitle":"Chats ended","pastAppointmentsTitle":"Past Appointments","emptyNextAppointments":"There are no upcoming consultations/video consultations","emptyWrittenAppointments":"You have not made any Written Consultation/Second Opinion","emptypastAppointments":"No consultation/video consultation has been carried out yet","emptypastChatsAppointments":"You haven't made any chat yet","webmailStates":{"additionalInfoCompleted":"Additional information completed","pendingConfirm":"Pending confirm","additionalInfoRequested":"Additional information requested","profReviewingCase":"The professional is studying your case"},"nextAppointmentsStates":{"waitingCall":"waiting for call","postponedCall":"Call postponed"},"appointmentStates":{"expired":"Expired","cancelledPatient":"Canceled patient","cancelledProfessional":"Canceled professional","finishedWithPrescription":"Finished with recipe","finished":"Finalized","finishedWithoutReport":"Terminated without report","attendedOutsidePlatform":"Served off platform","chargedByProfessional":"Charged by professional","finishedWithReport":"Completed with report","expiredRequest":"Expired request","patientDoesntShowUp":"Patient not presented","rejectedRequest":"Request not accepted","stillNoReported":"Waiting for report","appointmentCancelledProfessional":"Canceled by professional","appointmentCancelledPatient":"Canceled by patient"},"historySharedWithProfessional":"Your medical history has been shared with this professional","changePaymentMethod":"Change payment method","showAppointment":"Show appointment","payAppointment":"Pay consultation","goVideoAppointment":"Go to video consultation","showChat":"See chat","appointmentReport":"Report","appointmentPrescription":"Prescription","showFilters":"Show filters","appointmentType":"Query type","profName":"Name of professional","filterAppointments":"Search","confirmAppointment":"Confirm appointment","changeUserAdvice":"You will then be directed to this patient's profile.<br><br>Do you want to continue?","payment":{"selectState":"Select a province"},"appointmentCancel":{"cancel":"Cancel","cancelationReason":"Reason for cancellation","patientData":"Patient data","appointmentSummary":"Appointment summary","wantToCancel":"Yes, I want to cancel the appointment","writeAReason":"Write a reason...","noCancelReason":"You must add a reason for canceling the consultation","cancel-success":"Consultation successfully canceled","cancel-error":"The consultation has not been canceled"},"duration":"Duration"}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = {"foods":{"categories":{"title":"What do you care about?"},"disclaimer":"Although the consumption of certain foods cannot by itself prevent or cure diseases, there is evidence that certain nutritional habits help reduce the risks of contracting certain diseases.\n<br><br>\nOur objective is to offer updated information from accredited sources (public organizations, scientific societies, medical associations, validated studies...), however, if you intend to make any changes to your habits based on the information provided in this section, it is You need to consult your doctor or nutritionist beforehand. \nThis recommendation is even more imperative in the case of previous pathologies."},"patient":{"foods":{"diet-question":"Add to my current diet","habits-question":"Add reminder","delete-food":"Remove from My Foods","remove-from-diet":"Eliminate only from my current diet","remove-from-my-foods-warning":"Are you sure you want to remove this food from 'My Foods'?","remove-from-my-foods":"Remove from 'My Foods'","patient-food-add-success":"The food has been successfully added to 'My Foods'","patient-food-delete-success":"The food has been successfully removed from 'My Foods'","patient-food-remove-diet-success":"The food has been removed from your diet correctly","in-diet":"In my diet","remove-habit":"Eliminate associated habit","create-habit":"Add reminder","go-to-habit":"See reminder","remove-from-habits":"Also eliminate reminder","habit-created-success":"The reminder has been created correctly. \nTo finish the process, click on the button below to add the food to 'My Foods'.","patient-food-add-diet-success":"The food has been marked as correctly added to your diet.","select-category":"Select a category1","go-to-category":"Go to {category}","habit-created-success-on-modify":"The habit has been created and associated correctly","no-foods-with-filters":"You do not have added foods that meet the established filters.","no-foods":"You have not yet added any food to this section.","show-only-in-diet":"Show only included in my diet","add-to-diet":"Mark as already added to my diet","see-associated-habit":"Associated habit","add-food":"Start adding foods","food-detail-dialog-info":"You can select the foods that interest you by clicking on the heart and adding them to the My Foods section, where you can create a task or reminder for each food.","added-to-favourites":"Added to 'My Foods'","go-to-my-foods":"Go to My foods"}},"patient-panel":{"no-foods":"You have not yet added any food to this section"}}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = {"patient":{"menu-banners":{"queue-instant-video":"Your request for an Immediate Video Consultation is waiting to be attended to. ","queue-written":"Your request for a Written Consultation is waiting to be attended to. \nYou will receive a notification when the professional has accepted your consultation.","queue-chat":"Your Chat request is waiting to be attended to. ","queue-call":"Your call request is waiting to be answered. ","new-chat-messages":"You have new chat messages. "}}}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = {"microhabits":{"simple":{"categories-menu":{"title":"Small changes. \nGreat results.","subtitle":"The objective is to help you adopt seemingly simple habits, but that can have a significant impact on your health and well-being in the short, medium and long term."},"panel-menu":{"on-block-click-disclaimer":"You can select the habits that interest you by clicking on the heart and incorporating them into the My Habits section, where you can create a task or reminder for each habit.","add-to-my-habits":"Add to My Habits","max-favourites-reached":"You have too many habits that you haven't completed yet. \nBefore adding a new habit, complete or eliminate one.","added-to-favourites":"Habit added to My Habits successfully!"}}},"patient-panel":{"my-microhabits":"My Habits"},"patient":{"microhabits":{"remove-from-favourites":"Delete from My Habits","added-to-favourites":"Remove from My {habitType}","remove-from-achieved":"Mark as 'Not achieved'","add-to-achieved":"Mark as achieved","added-to-achieved":"Achieved","create-habit":"Add reminder","patient-microhabit-achieved-success":"Congratulations! \nYou have managed to complete this habit.","patient-microhabit-remove-diet-success":"This habit has been removed from your completed habits.","removed-from-favourites":"{typeName} successfully removed.","no-microhabits":"You haven't added any {typeName} to this section yet.","add-microhabit":"Start adding {typeName}","no-microhabits-with-filters":"You do not have {typeName} added that meets the established filters.","reminder":"Reminder"}},"patients":{"microhabits":{"selected":"Added","achieved":"Achieved"}}}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = {"patient-panel":{"welcome":"Welcome to {platform}","what-do-you-need":"What do you need?","teleconsultation":"Teleconsultations","teleconsultation-description":"Doctors, psychologists and other specialties.","health-wealth":"opensaludWellness","health-wealth-description":"Daily classes, mindfulness, online gym...","bonified-services":"opensaludPass","bonified-services-description":"Reduced price health and wellness services","wellbeing-score":"Wellbeing score<br><small>by freedom and flow</small>","wellbeing-score-description":"Evaluate your level of personal well-being and access your improvement program.","telemonitoring":"Telemonitoring","telemonitoring-description":"You can synchronize devices to monitor you health status.","healthy-community":"Healthy Community","healthy-community-description":"Comment your doubts, ask for advice or share your experiences","health-data":"Health Data","health-data-description":"Clinical history, health variables{param}...","habits-description":"Set goals. \nImprove your habits.","healthy-habits":"My goals and habits","self-evaluation-tests":"Evaluate your health","self-evaluation-tests-description":"Emotional health, sleep, diabetes risk...","reminders":"Agenda","reminders-description":"Useful communications for your health and well-being","title":"Dashboard","appointment-type":"Consultation type","specialty":"Specialty","error-specialty-required":"You must select specialty","patients-like-you":"Patients like you","show-more":"Show more...","go-360-decision":"We have detected that you are accessing with an opensalud360 or opensaludPrime user.<br><br>The services included in your opensalud360 or opensaludPrime subscription will be displayed free of charge on opensalud.<br><br>What do you want to do?","go-360":"Go to opensalud360","stay-opensalud":"Continue in opensalud","evaluateYourHealthWarning":"The objective of the evaluate your health module is to help you better understand some aspects of your health and your lifestyle habits. \nThe results of the evaluations are also useful for the professionals who, if applicable, could assist you in consultation.<br><br>In no case is it intended to issue a diagnosis or therapeutic recommendation and therefore, any decision you make derived from the result of the different self-assessment tools, must be previously validated by a health professional (generally a doctor, psychologist or nutritionist).<br><br>All results are confidential and only you and, where applicable, those healthcare professionals. health to which you give access, they will be able to access them.","go-to-my-consultations":"Access 'My consultations'","get-new-consultation":"Request a new consultation","food-healthy-habits":"Foods and Habits","healthy-blog":"Healthy blog","foods":"Healthy eating","soon-label":"Soon","habits-challenges":"My goals and habits","physiotherapy":"Digital physiotherapy","physiotherapy-description":"Guided by Artificial Intelligence and monitored by physiotherapists","my-foods":"My food","how-do-you-feel-today":"How do you feel today, {name}?","today-health-condition-saved-nice":"We are glad you are feeling well and we wish you to continue like this for the rest of the day!","today-health-condition-saved-ok":"Remember that if you don't feel today as you would like, opensalud offers you different resources to help you feel better.","today-health-condition-saved-bad":"We are sorry that you are not feeling well today. Remember that opensalud offers you different resources that can help you feel better.","get-new-consultation-or-service":"Request a consultation or service","consultations":"Consultations","services":"My services","consultation-or-service":"Consultation or service","professionalsOrCenters":"Professionals/Centers","service":"Service","location":"Province/Locality","error-service-required":"You must select a service","medicalTests":"Medical tests","health-condition-graph-label":"How do you feel today?","specialtyOrName":"Specialty or name","error-specialty-or-prof-required":"You must select a specialty or professional","notifications":"Health agenda and notifications","caring-foods":"Foods that care of you","foods-description":"Foods that help take care of your health","diets-recipes":"Workshops and recipes","go-to-next-consultations":"Next appointments","go-to-past-consultation":"Past appointments","reminders-notifications":"Notices and notifications","health-agenda":"My health agenda","menstrual-calendar":"Menstrual calendar","menstrual-calendar-description":"Duration, next period, ovulation…","healthy-blog-description":"Tips and articles on nutrition, exercise and wellness.","habits-that-care":"Habits that take care","habits-that-care-description":"Small changes that improve your life","my-goals":"My goals","micro-habits":"Micro habits","microhabits-keyword":"habit | habits","foods-keyword":"food | foods","my-apps":"My applications","my-apps-description":"Tools to manage your health and well-being","medication-reminder":"Medication reminder","menstrual-calendar-male-warning":"We are sorry but this tool is only available for women.","blood-monitor":"Blood pressure application","not-available":"Not available","only-subscriptors":"Only subscribers","only-subscriptors-warning":"This content is only for subscribers.","healthProfile":"Health profile","surveyAvailable":"It has a survey available to be filled","clickHere":"Click here to go to the survey","who-signs-up":"Who signs up?","who-signs-up-description":"Organize healthy plans with your colleagues"},"patient":{"foods":{"add-to-my-foods":"Add to My Foods"}},"newMedicationReminder":"New medication reminder","private-layout":{"who-signs-up":"Who points?"}}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = {"filters":{"professionals":"Professionals","centers":"Centers","speciality":"Specialty","subscriptionIncluded":"Only professionals included in my subscription","discountedPrice":"Professionals with discounted price","consultationType":"Query type","location":"Cities","name":"Name","coupon":"Coupon","showResults":"Show results","removeFilters":"Remove filters","showMoreFilters":"More filters","hideFilters":"Hide filters","insurance":"Insurance company (Inplace)","subspeciality":"Subspecialty","services":"Services","disease":"Disease","service":"Service","consultationsType":"Appointment type","morning":"Morning","afternoon":"Afternoon","indifferent":"Indifferent","language":"Language","priceMinorTo":"Price less than","surname":"Surname","secondSurname":"Second surname","surnames":"Surnames","selectFilter":"Select a filter to search","servicesPackages":"Service packages","flatRate":"Flat rate Cons. \nWritten and Chat","emptySearch":"No results found. \nUse other search criteria","specialityNotFoundCompanies":"Can't find the specialty you are looking for?","selectSpecialty":"You must select a specialty","tests":"Medical tests","analysis":"Analysis","clinicalAnalysis":"Clinical analysis","specialityOrName":"Specialty or name","insuranceAdvice":"Service available only for in-person consultation","enterWord":"Enter a word","insurers":"Insurance companies","showProfsNotIncludedSubscription":"Professionals not included in my subscription","anyInsurer":"With insurers"},"ratings":"ratings","addToMyTeam":"Add to my team","removeOfMyTeam":"Remove from my team","unipromelPopover":"Doctor associated with www.unipromel.es","request-appointment":"Request appointment","serviceName":{"inplace":"Consultation","video":"Scheduled Video Consultation","written":"Written Consultation","secondOpinion":"Second Opinion","immediate":"Immediate video consultation","atHome":"Home Consultation","chat":"Chat","call":"A professional calls you","insurance":"Consultation by insurer","servicesPackages":"Service packages","flatRate":"Flat rate Cons. \nWritten and Chat"},"firstAppointment":"First consultation","sendConsultation":"send consultation","makeConsultation":"Make consultation","requestCall":"Request call","hire":"Hire","requestAppointment":"Request appointment","otherConsultations":"Other appointments","requestConsultation":"Request consultation","availableOnOpensaludPrime":"Available in opensalud prime","availableOnCompanies":"Available in opensalud companies","includedInSubscription":"Included in your subscription","onlyUnderSubscription":"Subscription only","specialPrice":"Special price","minorRestricted":"We are sorry but this specialty is aimed only at minors. \nIf you have any linked minor patients who meet these conditions, change the user and repeat the steps.","tarifaPlusDisabled":{"title":"Inactive Access","description":"Currently access to this service is inactive. \nIf you want us to notify you when it is available again, tell us your email.","email":"Email","error":{"email":"You must enter a valid email","terms":"You must accept the terms and conditions","captcha":"You must complete the captcha"},"success":"Your request has been sent"},"professionalPrevalidated":{"title":"Consultation or service request","description":"We are currently validating the professional you have selected. \nIf you wish, you can enter your email and we will inform you when this procedure is complete.","email":"Email","error":{"email":"You must enter a valid email","terms":"You must accept the terms and conditions","captcha":"You must complete the captcha"},"success":"Your request has been sent"},"availabilityRequest":{"title":"Consultation or service request","note":"Note: the professional does not currently have his online agenda available. \nTo request an appointment, complete the following form.","englishPrescription":"Recipe in English","form":{"appointmentType":"Appointment type","center":"Center","selectAService":"Select a service","firstAppointment":"Is this your first consultation?","availabilityDescription":"Time zone (e.g. Monday, Wednesday and Thursday from 6:00 p.m. to 9:00 p.m., Any day of the week after 4:00 p.m.)","haveInsurance":"Individual or with insurance?","insurance":"Select an insurer","forWho":"Select who the query is for","pet":"Select a pet for the consultation","minorPatient":"Select a patient for the consultation","phone":"Phone","description":"Reason for inquiry/comments","service":"Select a service"},"error":{"mustSelectPet":"It is only possible to request an appointment for this specialty for one pet.","typeAppointment":"You must select the type of appointment","firstAppointment":"You must select if it is a first appointment","selectInsurance":"You must select whether you attend as an individual or through an insurance company.","insurance":"You must select your insurer","forWho":"You must indicate who the query is for","selectPet":"Select a pet for the consultation","phonePrefix":"You must select your phone prefix","phone":"You must enter your phone number","description":"You must enter your query/comments","captcha":"You must verify the captcha","terms":"You must accept the legal terms and conditions","service":"You must select a service"},"success":"Your request has been sent"},"forMe":"For me","forMinor":"For minor patient","forPet":"For pet","showInsurances":"See insurers","firstAppointmentWithNumber":"1st consultation","moreCenters":"more centers","specialistInSearh":"Specialist in:","notAllowFirstAppointmentChat":"We inform you that this professional is not allowed to chat as a first consultation. \nInstead, you can request any other available service","free":"Free","consultationsAndServices":"Consultations and services","request":"Request","otherConsultationsAndServices":"Other consultations and services","specialtyNotFoundAdvice":"We remind you that access to professionals for online consultations is a pay-per-use service with discounted prices.","noPhysicalLocation":"No physical location","showProfessionals":"See Professionals","servicesSearch":"Services","search-banner":"We do not include advertising. \nWe do not transfer data to third parties. \nWe do not offer “premium accounts”.","our-policy":"Our politic","searcherTitle":"Searcher","professionalServices":{"sendMessage":"Send message","interconsultation":"Interconsultations","facilityRent":"Facilities for rent"},"soon-label":"Soon","requestBudget":"Request budget","budget":"Budget","subscriptorsAdviceSearch":"Below will all the OpenSalud professionals relating to their search criteria. \nIf you just want to access professionals included in your subscription (particular or company), you can mark the <b> only professionals included in my subscription </b> or log in to 360.Opensalud.es"}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = {"pyme":{"title":"PYME Program","text":"<p>OPEN HEALTHCARE, S.L. \nhas been a beneficiary of European Funds, whose objective is to improve the competitiveness of SMEs, and thanks to which it has launched an Action Plan with the aim of promoting the safe and reliable use of cyberspace and the competitiveness of SMEs during \nthe year 2024. For this, it has had the support of the Cybersecurity SME Program of the Seville Chamber of Commerce."}}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"tests":{"finishTest":"See results","section":"Section","previousResults":"View previous results","psychosocial-risks":{"title":"Psychosocial risks","questions":{"q1":"Do you have to work very fast?","q2":"Is the distribution of tasks irregular and causes you to accumulate work?","q3":"Do you have time to keep up with your work?","q4":"Is it hard for you to forget the problems at work?","q5":"Is your job, in general, emotionally draining?","q6":"Does your job require you to hide your emotions?","q7":"Do you have influence over the amount of work assigned to you?","q8":"Is your opinion taken into account when tasks are assigned to you?","q9":"Do you have influence over the order in which you perform tasks?","q10":"Can you decide when you take a break?","q11":"If you have a personal or family matter, can you leave your job for at least an hour without having to ask for special permission?","q12":"Does your job require you to have initiative?","q13":"Does your job allow you to learn new things?","q14":"Do you feel committed to your profession?","q15":"Do your tasks make sense?","q16":"Do you enthusiastically talk about your company to other people?","q17":"At the moment, are you worried about how difficult it would be to find another job if you were to become unemployed?","q18":"At this time, are you worried that your tasks will be changed against your will?","q19":"At this time, are you worried that your schedule (shift, days of the week, start and end times) will be changed against your will?","q20":"At this time, are you worried about whether your salary varies (that they don't update it, that they lower it, that they introduce a variable salary, that they pay you in kind, etc.)?","q21":"Do you know exactly what margin of autonomy you have in your work?","q22":"Do you know exactly which tasks are your responsibility?","q23":"In this company, are you informed sufficiently in advance of the changes that may affect your future?","q24":"Do you receive all the information you need to do your job well?","q25":"Do you receive help and support from your classmates?","q26":"Do you receive help and support from your immediate or immediate superior?","q27":"Is your job position isolated from that of your colleagues?","q28":"At work, do you feel like you are part of a group?","q29":"Do your current immediate bosses plan the work well?","q30":"Do your current immediate bosses communicate well with the workers?","q31":"What part of the family and domestic work do you do?","q32":"If you miss a day at home, do the housework you do go undone?","q33":"When you are in the company, do you think about domestic and family tasks?","q34":"Are there times when you need to be at the company and at home at the same time?","q35":"My superiors give me the recognition I deserve","q36":"In difficult situations at work I receive the necessary support","q37":"At my job I am treated unfairly","q38":"If I think of all the work and effort that I have put in, the recognition that I receive in my work seems appropriate to me."},"dimensions":{"ap1":"Psychological demands","ap2":"Control over work","ap3":"Insecurity about the future","ap4":"Social support and leadership quality","ap5":"Double presence","ap6":"Esteem"},"scores":{"psicoDemandsLow":"There is an excess of psychological demands at work: you have to work quickly or irregularly, work requires you to hide your feelings...","controlOverWorkLow":"There is a certain lack of control over the contents and working conditions or development possibilities: we have no influence or margin of autonomy in the way we carry out our work, the work does not provide opportunities to apply our skills and knowledge or it does not make sense , we cannot adapt the schedule to family needs.","insecuritiesLow":"It is considered that there is insufficient compensation for work such as: lack of respect, contractual insecurity, change of position or service against our will, unfair treatment...","leadershipLow":"There is a certain lack of social support, leadership quality, predictability or role clarity at work: when you have to work in isolation, without support from superiors or colleagues, with poorly defined tasks or without adequate and timely information …","doublePresenceLow":"Family and domestic work implies demands that must be assumed simultaneously with those of paid work, which implies a double workload, and the organization of this can make it difficult to reconcile both.","esteemLow":"It is considered that there is insufficient compensation for work such as: lack of respect, contractual insecurity, change of position or service against our will, unfair treatment..."},"description":"The test that you are going to answer will be used to carry out the evaluation of psychosocial risks. \nIts objective is to identify and measure working conditions related to the organization of work and that may represent a risk to health.","positive":"Favorable","middle":"Intermediate","negative":"Unfavorable","finalCompletedMessage":"Thank you for completing the psychosocial risk test. \n<br><br>The results, like any other personal information on the platform, are confidential and are only accessible where appropriate by the health professional who is treating you, if they so decide. \nWe remind you that your company only receives aggregated platform usage data and never receives personal information.","finalCompletedMessageAccessAgain":"You have already completed the psychosocial risk test this month. \nYou will be able to re-assess after 30 days. \n<br><br>The results, like any other personal information on the platform, are confidential and are only accessible where appropriate by the health professional who is treating you, if they so decide. \nWe remind you that your company only receives aggregated platform usage data and never receives personal information."},"ryff-scale":{"title":"Psychological well-being","questions":{"q1":"I am not afraid to voice my opinions, even when they are in opposition to the opinions of most people.","q2":"For me, life has been a continuous process of learning, changing, and growth","q3":"In general, I feel I am in charge of the situation in which I live","q4":"People would describe me as a giving person, willing to share my time with others","q5":"I am not interested in activities that will expand my horizons","q6":"I enjoy making plans for the future and working to make them a reality","q7":"Most people see me as loving and affectionate","q8":"In many ways I feel disappointed about my achievements in life","q9":"I live life one day at a time and don't really think about the future","q10":"I tend to worry about what other people think of me","q11":"When I look at the story of my life, I am pleased with how things have turned out","q12":"I have difficulty arranging my life in a way that is satisfying to me","q13":"My decisions are not usually influenced by what everyone else is doing","q14":"I gave up trying to make big improvements or changes in my life a long time ago","q15":"The demands of everyday life often get me down","q16":"I have not experienced many warm and trusting relationships with others","q17":"I think it is important to have new experiences that challenge how you think about yourself and the world","q18":"Maintaining close relationships has been difficult and frustrating for me","q19":"My attitude about myself is probably not as positive as most people feel about themselves","q20":"I have a sense of direction and purpose in life","q21":"I judge myself by what I think is important, not by the values of what others think is important","q22":"In general, I feel confident and positive about myself","q23":"I have been able to build a living environment and a lifestyle for myself that is much to my liking","q24":"I tend to be influenced by people with strong opinions","q25":"I do not enjoy being in new situations that require me to change my old familiar ways of doing things","q26":"I do not fit very well with the people and the community around me","q27":"I know that I can trust my friends, and they know they can trust me","q28":"When I think about it, I haven’t really improved much as a person over the years","q29":"Some people wander aimlessly through life, but I am not one of them","q30":"I often feel lonely because I have few close friends with whom to share my concerns","q31":"When I compare myself to friends and acquaintances, it makes me feel good about who I am","q32":"I don’t have a good sense of what it is I’m trying to accomplish in life","q33":"I sometimes feel as if I've done all there is to do in life","q34":"I feel like many of the people I know have gotten more out of life than I have","q35":"I have confidence in my opinions, even if they are contrary to the general consensus","q36":"I am quite good at managing the many responsibilities of my daily life","q37":"I have the sense that I have developed a lot as a person over time.","q38":"I enjoy personal and mutual conversations with family members and friends","q39":"My daily activities often seem trivial and unimportant to me","q40":"I like most parts of my personality","q41":"It’s difficult for me to voice my own opinions on controversial matters","q42":"I often feel overwhelmed by my responsibilities"},"dimensions":{"self-acceptance":"Self-acceptance","life-purposes":"Life purposes","environmental-control":"Environmental control","positive-relationships":"Positive relationships","personal-growth":"Personal growth","autonomy":"Autonomy"},"scores":{"selfAcceptanceHigh":"It is not always easy, but it is very important to feel good as one is, also assuming the defects that we all have and those things that we do not like so much about ourselves.<br /><br />Do not forget to continue taking care of yourself and maintaining a good level of self-esteem in different life situations. \nOne of the most important things we can do in our life is to accept our image, our past, the way we act, the things we feel and the thoughts we have.","selfAcceptanceLow":"It can become difficult to have a positive image of ourselves if we demand too much of ourselves. \nLean on the things that you like the most about yourself and analyze those that convince you the least but that can be improved with your effort. \nWe will always have aspects that we would like to improve but that we must accept, especially when they are out of our possibilities.","lifePurposesHigh":"Well done. \nMany times we know that there are things we want to do in life, but we don't know how to start. \nHaving purposes and being able to direct our lives towards them allows us to feel motivated and live a healthier and more rewarding life.<br /><br />Everyone has their good days and their bad days, but having a purpose helps us to have perspective even when things are not going well.","lifePurposesLow":"Instead of focusing on having a 'big' purpose, seek to enjoy the little things in everyday life, and try to prioritize those situations in your life. \nIf you don't find a clear path, let the moments you live each day be the ones that guide you towards what you may be looking for but you can't quite see clearly. \nDon't be in a hurry.","environmentalControlHigh":"The ability to master the environment is essential to adequately manage the different situations that occur in life, many of which have nothing to do with us or our actions.<br /><br />Adequate control of the circumstances that surround us, can be a fundamental support in adverse situations.","environmentalControlLow":"On many occasions we seek to control something that has happened around us, when in most cases these situations are out of our control. \nTry not to obsess over things that do not depend on you, and focus on what is in your power to change.","positiveRelationshipsHigh":"You are able to maintain quality relationships with other people. \nYou care about the well-being of others and have the ability to show empathy, care, and respect for other people. \nIf you have good relationships, work to maintain them! \nand don't be afraid to speak up when a problem arises.","positiveRelationshipsLow":"To build good relationships it is important to make small efforts to be, for example, something more open and empathetic. \nIf you have difficulty maintaining quality relationships (affection, trust...) with other people, it is sometimes advisable to analyze our attitudes towards them.<br /><br />If you feel that you are doing everything in your power and you are not receiving an appropriate answer, remember that you do not have to maintain a close relationship with everyone. \nIf, on the other hand, you think you could do something more, work on it little by little, making small efforts that can help you build a more positive relationship, sometimes something apparently as simple as a smile or a kind comment, produce great effects.","personalGrowthHigh":"Personal growth is basic to living a full life. \nIt does not manifest immediately, but is something that is seen on a day-to-day basis. \nIt helps us change, improve and improve ourselves.<br /><br />We all have the potential to grow throughout our lives, take advantage of the good moment to continue taking big or small steps. \nSmall changes are made daily, even though it may seem otherwise to you.","personalGrowthLow":"Personal growth is not something that can be forced to obtain immediate results. \nIf you feel that you have stagnated, think that growth occurs with small actions.<br /><br />It can be very frustrating to think that progress is not being made, but the reality is that even without being aware, you can be making small strides. \nIt all adds up. \nFocus on the aspects you want to improve and set yourself goals that are easy to complete in the short term. \nPersonal growth is not only about big changes, enjoy the process of getting to know yourself.","autonomyHigh":"Autonomy is one of the essential characteristics of happy people. \nIt means that you have the power to manage your life and follow your own path without being overly affected by what others may think.","autonomyLow":"If you find it difficult to say no, or express your opinions freely, start by working on it with people in your circle of trust to gradually develop your autonomy. \nLikewise, it is important to learn to distinguish those people who are worth listening to from those who do not contribute much."},"description":"The Ryff scale is a multidimensional self-assessment test that measures a person's general level of psychological well-being based on the answers provided to questions belonging to 6 different dimensions.","resultsAnalysisGood":"Well done. \nYou have managed to improve your level of emotional well-being compared to the last time. \nDo not forget to continue working day by day on your emotional health, taking into account that there will be situations that are easy to solve and others that cost something more, but always with the good attitude that you show.<br /><br />Here is a summary of the results that will allow you to know if there is room for improvement in any of the dimensions analyzed.","resultsAnalysisBad":"The level of emotional well-being shown by the test result is somewhat lower than what was obtained last time, but anyone has a setback. \nIt is possible that some things have accumulated in your day to day during this period that have hindered your evolution. \nIn any case, do not be discouraged, the simple fact of taking the test shows that you want to do your part to improve and that is what is important.<br /><br />Here is a brief summary of your emotional well-being. \nTake the opportunity to analyze those areas that are costing you the most to improve.","resultsAnalysisMedium":"Your level of emotional well-being remains at a level similar to that shown the last time you completed the test. \nEach day brings us a different adventure, and it is likely that there have been changes in some of the dimensions.<br /><br />Here is a summary of the results that will let you know if there is room for improvement in any of them. the dimensions analyzed.","resultsAnalysisFirstTime":"Congratulations on completing our emotional well-being test. \nRemember to do it every month to be able to monitor your evolution.<br /><br />Here is a summary of the results that will let you know if there is room for improvement in any of the dimensions analysed."},"completed":"completed","notCompleted":"Not completed","testResults":"TEST RESULTS","dimensions":"Dimensions","results":"Results","well-being":"Psychological well-being","alreadyCompletedMessage":"You have already taken the test this month, so the results will be displayed. \nCome back next month to complete it again.","wannaStart":"It will take about 8 minutes. Do you want to start?","startTest":"Start test","downloadResults":"Download results","testCompleted":"You have invested time in you to complete self -assessment. \nDo not forget to complete it periodically so you can see your progression. \n<br> <br> The test ends to store the results. \nIf you wish, you can share the results with a professional when requesting a consultation.","psicosocialRisks":"Psychosocial risks","self-evaluation-tests":{"title":"Evaluate your health"},"hello":"Hello","findrisk":{"title":"Findrisk (Diabetes risk)","questions":{"q1":"Age","q2":"BMI (Body Mass Index)","q3":"Waist circumference","q4":"Do you usually do at least 30 minutes of physical activity daily or 4 hours a week, at work and/or at leisure?","q5":"Do you eat fruits or vegetables daily?","q6":"Do you take medication for high blood pressure?","q7":"Have you ever been found to have high glucose levels, for example, at a medical check-up, during pregnancy, or during an illness?","q8":"Has any of your family or relatives been diagnosed with diabetes (type 1 or 2)?"},"scores":{"lowRisk":"Low risk","lightRisk":"Light risk","moderateRisk":"Moderate risk","highRisk":"High risk","veryHighRisk":"Very high risk","maxRisk":"Maximum risk"},"weightPH":"Weight","heightPH":"Height","IMC":"BMI","diabetesRisk":"Diabetes risk","tips":{"highRiskTip":"According to the results, the risk of developing diabetes in the next 10 years is high or very high. \nAlthough the professional will specify the specific guidelines for action in your case, you should know that you may still be in time to prevent it by maintaining a healthy lifestyle.","tip1":"<strong>Reduce your weight</strong> if you are overweight (BMI equal to or greater than 25) or obese (BMI equal to or greater than 30)","tip2":"Practice <strong>regular physical activity</strong> for at least 30min (walking at a high pace, for example) and at least 5 days a week.","tip3":"<strong>Improve your diet</strong>, increasing the intake of fruits and vegetables, decreasing the consumption of fats and increasing the consumption of natural fiber among others."},"cantReplaceDiagnosis":"The FINDRISK test <b>cannot replace an optional diagnosis</b>. \nFor this reason, you should consult your doctor about the result obtained. \nIt is essential that you consult a specialist if the risk is high or very high.","description":"The Findrisk test is a questionnaire that assesses a person's risk of suffering from diabetes in the next 10 years.","heightUnit":"cm","weightUnit":"kg"},"wannaStartShort":"It will take about 5 minutes. \nDo you want to start?","answers":{"yesCloseFamily":"Yes (Parents, siblings or children)","yesNotCloseFamily":"Yes (grandparents, uncles, first cousins)","lessThan45":"Less than 45 years","45to54":"45-54 years","55to64":"55-64 years","moreThan64":"Over 64 years","total-agreement":"Strongly agree","some-agreement":"Pretty much agree","bit-agreement":"Slightly agree","agreement-disagreement":"Neither agree nor disagree","bit-disagreement":"Slightly disagree","some-disagreement":"Pretty much disagree","total-disagreement":"Strongly disagree","always":"Always","alot":"Many times","sometimes":"Sometimes","justsometimes":"Only ever","never":"Never","worried":"Very worried","prettyWorried":"Pretty worried","moreorlessWorried":"More or less worried","littleWorried":"Little worried","notWorried":"Not worried","mainResponsible":"I am the main person in charge and I do most of the family and household chores","halfResponsible":"I do about half of the family and household chores","quarterResponsible":"I do about a quarter of the family and household chores","punctuallyResponsible":"I only do very specific tasks","notResponsible":"I do none or almost none of these tasks","lessThan94":"Less than 94cm","94to102":"Between 94 and 102 cm","moreThan102":"More than 102cm","lessThan80":"Less than 80cm","80to88":"Between 80 and 88cm","moreThan88":"More than 88cm","nothingAtAll":"Nothing at all","something":"Something","yes":"Yes","no":"No","aLot":"A lot","lotsOf":"Very much","none":"None","orMore":"or more","lessThan":"Less than","almostNever":"Hardly ever","alot2":"Very often","notInTheLastMonth":"Not once in the last month","lessThanOnceAWeek":"Less than once a week","onceAWeek":"Once or twice a week","moreThanOnceAWeek":"Three or more times a week","noProblem":"No problem","lightProblem":"Just a slight problem","problem":"A problem","seriousProblem":"A serious problem","moreThan60minutes":"More than 60 minutes","30to60minutes":"Between 30 and 60 minutes","15to30minutes":"Between 15 and 30 minutes","lessThan15minutes":"Less than 15 minutes","veryGood":"Very good","prettyGood":"Pretty good","prettyBad":"Pretty bad","veryBad":"Very bad","veryHigh":"Very high","high":"High","low":"Low","veryLow":"Very low","alone":"Home alone","someoneOtherRoom":"With someone in another room","man":"Man","someoneSameBed":"With someone in the same bed","woman":"Woman","someoneSameRoom":"With someone in the same room, but in another bed","slightly":"Slightly","moderately":"Moderately","severely":"Severely","limitALot":"Yes, it limits me a lot","limitABit":"Yes, it limits me a little","limitNone":"No, nothing limits me","noneMasculine":"Ninguno","verySlight":"Very mild","slight":"Mild","moderate":"Moderate","severe":"Severe","verySevere":"Very severe","veryLittle":"Very little","prettyMuch":"Quite","extremately":"Extremely","excelent":"Excellent","good":"Good","regular":"Badly","bad":"Bad","muchBetterNow":"Much better now","someBetterNow":"something better now","moreOrLessTheSame":"More or less the same","someWorseNow":"Something worse now","muchWorseNow":"Much worse now","agreement":"Agree","disagreement":"Disagree"},"nicotine-dependency":{"description":"You are about to take the Glover-Nilsson nicotine dependence test, which is used to assess the level of physical and psychological dependence on nicotine in smokers. \nThis test classifies dependence into four levels: mild, moderate, strong and very strong.","title":"Nicotine dependence","questions":{"q1":"My smoking habit is very important to me","q2":"I play and handle the cigarette as part of the smoking ritual","q3":"Do you usually put something in your mouth to avoid smoking?","q4":"Do you reward yourself with a cigarette after completing any task?","q5":"When you don't have tobacco, do you find it difficult to concentrate and perform any task?","q6":"When you are in a place where smoking is prohibited, do you play with your cigarette or pack of tobacco?","q7":"Do some places or circumstances encourage you to smoke: your favorite chair, room, car, drink (alcohol, coffee, etc.)?","q8":"Do you often find yourself lighting up a cigarette out of the blue, without really wanting to?","q9":"Do you often put unlit cigarettes or other objects in your mouth (pens, chopsticks, etc.) and suck on them to relax from stress, tension, frustration, etc.?","q10":"Does part of your smoking pleasure come from the ritual of lighting a cigarette?","q11":"When you are alone in a restaurant, bus stop, etc. \nDo you feel safer, safer or more confident with a cigarette in your hands?"},"scores":{"depLevel":"Tu nivel de dependencia","noDependency":{"name":"You have no dependency","description":"Congratulations on your determination and willpower! \nMaintaining a nicotine-free lifestyle is an admirable and brave decision. \nYou are choosing a healthier and more energetic life, demonstrating your commitment to taking care of your well-being. \nThis path you are following is an inspiration to many. \nYour choice to live smoke-free is a testament to your dedication to taking care of yourself and those around you. \nKeep going on this positive journey and continue to take care of yourself."},"lowDependency":{"name":"Mild dependency","description":"Mildly dependent smokers may experience an occasional urge to smoke, but do not have a constant or strong need for nicotine. \nThey may smoke intermittently or socially, and may be able to quit smoking without experiencing severe withdrawal symptoms."},"midDependency":{"name":"Moderate dependency","description":"Smokers with a moderate dependence may feel a constant need for nicotine and may smoke regularly throughout the day. \nThey may experience withdrawal symptoms when trying to quit, but these symptoms are not as severe as those of heavy or very heavy dependence."},"highDependency":{"name":"Strong dependency","description":"Strongly dependent smokers experience an intense and constant need for nicotine. \nThey may smoke numerous cigarettes a day and may experience severe withdrawal symptoms when trying to quit. \nThey may feel like their daily life revolves around smoking, and they may have a hard time doing activities that don't involve smoking."},"veryHighDependency":{"name":"Very strong dependency","description":"Smokers with a very strong dependence experience an extreme and constant need for nicotine. \nThey may smoke a large number of cigarettes a day and may experience severe withdrawal symptoms when trying to quit. \nVery strong dependency can affect your ability to perform daily activities, work, and socialize. \nThey may feel that they cannot control their smoking behavior and may have great difficulty quitting."}},"tips":{"general":"Quitting smoking can be a difficult process, but it is one of the healthiest decisions you can make to improve your health. \nIf you need more help, see a health professional or smoking cessation specialist. \nEven so, below you will find a series of tips that can help you in the process.","motivation":{"name":"Seek support and motivation","description":"Share your plans to quit smoking with friends, family, and health professionals. \nLook for support groups and treatment programs to stop smoking."},"causes":{"name":"Identify your triggers and avoid them","description":"Identify the triggers that make you smoke, such as stress, boredom, or anxiety. \nTry to avoid them or find healthy ways to deal with them."},"endDate":{"name":"Set a date to quit smoking","description":"Set a target date to quit smoking and work toward that goal."},"forgetTheHabit":{"name":"Try to replace smoking with other activities","description":"Find activities that you enjoy that do not involve smoking, such as exercising, reading or listening to music, spending time with friends or family, etc."},"relaxTechniques":{"name":"Practice relaxation techniques and stress management","description":"Stress and anxiety can be common triggers for smoking. \nTry techniques like meditation, deep breathing, or yoga to reduce stress."},"rewards":{"name":"Set rewards to achieve your goals","description":"Set rewards for yourself for reaching your goals, like saving money or buying something you've been wanting."},"conscious":{"name":"Become aware of your smoking habit","description":"Once you have a clear idea of ​​when, where, and why you smoke, it will be easier to work on reducing dependence."},"reduceDaily":{"name":"Reduce the number of cigarettes you smoke daily","description":"If you're not ready to quit smoking completely, reducing the number of cigarettes you smoke each day can be an important first step."},"lookForSupport":{"name":"Find support","description":"Share your plans to quit smoking with friends, family or support groups. \nSeeking help and motivation can make it easier to quit smoking."},"rememberBenefits":{"name":"Remember the benefits","description":"The benefits of quitting smoking are many, among them, remember that you will feel better physically and have better health, preventing diseases such as respiratory problems or some type of cancer."},"healthyLifestyle":{"name":"Maintain a healthy lifestyle","description":"Maintaining a healthy lifestyle can help you deal with withdrawal symptoms and reduce the temptation to smoke. \nTry to exercise regularly, eat a balanced diet, and get enough sleep."}}},"mediterranean-diet":{"title":"Meditarranean diet","description":"The Mediterranean Diet is a way of eating that is characterized by the consumption of fresh, natural and varied foods, such as fruits, vegetables, legumes, fish, olive oil and nuts. \nThis diet has been widely studied and has been shown to have many health benefits.","questions":{"q1":"Do you use olive oil as your main cooking fat?","q2":"How many tablespoons of olive oil do you consume in total per day? \n(including those used for frying, meals outside the home, salads, etc.)","q3":"How many servings of vegetables do you consume per day? \n(garnishes or accompaniments count as half a portion)","q4":"How many pieces of fruit do you eat per day?","q5":"How many servings of red meat, hamburgers, sausages or sausages do you consume per day? \n(one serving is equivalent to 100-150 gr.)","q6":"How many servings of butter, margarine or cream do you consume per day? \n(an individual serving is equivalent to 12 gr.)","q7":"How many carbonated and/or sugary drinks (soft drinks, colas, tonics, bitters) do you consume per day?","q8":"How many servings of legumes do you consume per week? \n(a portion or dish is equivalent to 150 gr.)","q9":"How many servings of fish or seafood do you eat per week? \n(a dish, piece or portion is equivalent to 100-150 grams of fish or 4-5 pieces of seafood)","q10":"How many times do you consume commercial pastries (not homemade) such as cookies, flans, sweets or cakes per week?","q11":"How many times do you eat nuts a week? \n(one serving is equivalent to 30 gr.)","q12":"Do you prefer chicken, turkey or rabbit instead of beef, pork, hamburgers or sausages? \n(chicken meat: one piece or portion is equivalent to 100-150 gr.)","q13":"How many times a week do you eat cooked vegetables, pasta, rice or other dishes seasoned with a tomato, garlic, onion or leek sauce made over low heat with olive oil (sautéed)?"},"scores":{"lowAdherence":{"name":"Low adherence","description":"You are not eating a healthy diet, which can have numerous negative consequences for your health. \nA healthy diet is essential to provide the body with the nutrients necessary to maintain good health, prevent diseases and maintain a healthy weight."},"goodAdherence":{"name":"Good adherence","description":"You eat a healthy diet which has numerous benefits for your health, both short and long term!"}},"consequences":{"heartDiseasesRisk":{"name":"Increased risk of cardiovascular diseases","description":"The Mediterranean Diet has been associated with a significant reduction in the risk of heart disease. \nTherefore, low adherence to this diet can increase the risk of suffering from cardiovascular problems."},"diabetesRisk":{"name":"Increased risk of diabetes","description":"It has been shown that the Mediterranean Diet can reduce the risk of type 2 diabetes, and poor adherence to this diet can increase the risk of developing this disease, in addition to other chronic diseases."},"cancerRisk":{"name":"Increased risk of cancer","description":"Some studies have found that the Mediterranean Diet can reduce the risk of certain types of cancer, such as breast cancer and colorectal cancer. \nTherefore, low adherence to this diet may increase the risk of developing these types of cancer."},"cognitiveFunction":{"name":"Weight gain","description":"The Mediterranean Diet is rich in healthy, low-calorie foods, which can help control weight. \nLow adherence to this diet can lead to weight gain and ultimately obesity, caused mainly by the intake of processed foods, foods high in saturated fats and added sugars, and low consumption of fruits, vegetables and whole grains."},"mentalHealth":{"name":"Increased risk of depression","description":"The Mediterranean Diet helps improve mental health as it can reduce the risk of depression, anxiety and improve mood. \nTherefore, low adherence to this diet may increase the risk of depression and other mental health problems."},"consequences":"Consequences of low adherence to the Mediterranean diet"},"benefits":{"heartDiseasesRisk":{"name":"Reduced risk of cardiovascular diseases","description":"The Mediterranean Diet has been associated with a reduced risk of cardiovascular diseases, such as high blood pressure, coronary heart disease and stroke. \nThis is partly due to the high intake of monounsaturated fats and omega-3 fatty acids, present in foods such as olive oil and fish, which help reduce inflammation and LDL or 'bad' cholesterol."},"diabetesRisk":{"name":"Diabetes risk reduction","description":"The Mediterranean Diet can reduce the risk of type 2 diabetes due to its high intake of fiber, which helps regulate blood glucose levels, and its low consumption of processed foods and red meat."},"cancerRisk":{"name":"Reduced risk of cancer","description":"The Mediterranean Diet has been associated with a reduced risk of certain types of cancer, such as breast cancer and colorectal cancer. \nThis is due in part to the high intake of antioxidants and fiber present in fruits and vegetables, as well as the low consumption of processed meats and foods high in saturated fats."},"cognitiveFunction":{"name":"Improves cognitive function","description":"The Mediterranean Diet has been linked to improved cognitive function and memory. \nThis is partly due to the high intake of omega-3 fatty acids present in fish, which are involved in brain health."},"mentalHealth":{"name":"Improves mental health","description":"The Mediterranean Diet has been associated with a reduced risk of depression and anxiety due to its high intake of antioxidants and omega-3 fatty acids."},"keepGoing":"Por ello, ¡sigue adoptando hábitos alimentarios saludables y lleva una dieta equilibrada para mantener una buena salud y prevenir enfermedades!","benefits":"Benefits of high adherence to the Mediterranean diet"},"tips":{"description":"Tips to improve your eating habits and increase adherence to the Mediterranean Diet","tip1":{"title":"Include a variety of healthy foods","description":"It is important to include a variety of healthy foods in your diet, such as fruits, vegetables, whole grains, lean proteins, and healthy fats. \nThis will ensure that you are receiving all the necessary nutrients."},"tip2":{"title":"Reduce consumption of processed foods","description":"Processed foods are often high in saturated fat, sodium and added sugars, and low in nutrients. \nTry to reduce your consumption and opt for fresh and natural foods."},"tip3":{"title":"Eat slowly and enjoy the food","description":"Eat slowly and enjoy the food. \nThis will help you feel full faster and avoid overeating."},"tip4":{"title":"Reduce alcohol consumption","description":"Alcohol contains many empty calories and can negatively affect overall health. \nTry to reduce your consumption and drink in moderation."},"tip5":{"title":"Keep the body hydrated","description":"Drink enough water to keep your body hydrated. \nAlso, try to reduce the consumption of sugary drinks and soft drinks."},"tip6":{"title":"Plan meals","description":"Plan meals beforehand to ensure you are eating a balanced diet and avoid overeating."},"tip7":{"title":"Cook at home","description":"Cooking at home allows you to have greater control over the ingredients used in meals and ensures that you are eating fresh, healthy foods."},"general":"In short, adopting healthy eating habits and maintaining a balanced diet can be easy if you make a few simple changes to your diet and lifestyle.<br><br>With these changes, you can maintain good health and prevent diseases!"}},"stress":{"title":"Perceived Stress Scale","description":"This stress self-evaluation test will help you identify your current stress levels and how they may be affecting your well-being.","stressPerceived":"Perceived stress","questions":{"q1":"In the last month, how often have you been affected by something that happened unexpectedly?","q2":"In the last month, how often have you felt unable to control the important things in your life?","q3":"In the last month, how often have you felt nervous or stressed?","q4":"In the past month, how often have you successfully handled life's irritating little problems?","q5":"In the past month, how often have you felt that you have effectively coped with major changes that have been occurring in your life?","q6":"In the last month, how often have you felt confident about your ability to handle your personal problems?","q7":"In the last month, how often have you felt that things are going well for you?","q8":"In the last month, how often have you felt like you couldn't handle all the things you had to do?","q9":"In the last month, how often have you been able to control the difficulties in your life?","q10":"In the last month, how often have you felt like you were in control?","q11":"In the last month, how often have you been angry because things that happened to you were out of your control?","q12":"In the last month, how often have you thought about the things you still have to do?","q13":"In the last month, how often have you been able to control the way you spend your time?","q14":"In the last month, how often have you felt that difficulties were piling up so much that you couldn't get over them?"}},"sleep-quality":{"pittsburg":"Sleep quality questionnaire","title":"Sleep quality","dimensionsDescriptions":{"apartado-1":"Subjective sleep quality refers to a person's personal and subjective evaluation of the satisfaction or level of rest they experience during their sleep period. \nThis evaluation is based on the person's individual perception of the duration, depth and effectiveness of their sleep, as well as their feeling of rest and well-being when they wake up.</br></br>Some factors that can influence the quality Subjective sleep outcomes include the comfort of the sleeping environment, the duration of sleep, the presence of interruptions during the night, the feeling of freshness upon awakening, and overall satisfaction with the sleeping experience. \nThis subjective assessment is important for understanding how a person feels about their sleep and can be useful in identifying sleep problems or improving sleep quality.</br></br>It is important to note that subjective sleep quality It can vary from night to night and from person to person, so what may be considered good quality sleep for one person may be different for another. \nIt is also relevant to note that, although subjective, sleep quality can have a significant impact on a person's overall health and well-being.","apartado-2":"Sleep latency refers to the period of time that elapses from the time a person lies down and tries to fall asleep to the time they manage to fall asleep. \nIn other words, it is the time it takes to fall asleep from when you lie down in bed and turn off the lights until you finally enter a sleep state.</br></br>Sleep latency can vary widely from one person to another and from one night to the next. \nSome people can fall asleep quickly, within minutes, while others may experience worse sleep latency, which can extend to longer periods, even hours.</br></br>Measuring sleep latency It is relevant in the study of sleep disorders and can help health professionals evaluate the quality of a person's sleep. \nProlonged sleep latency or persistent problems falling asleep may indicate the presence of problems such as insomnia. \nTherefore, sleep latency is an important parameter to consider when evaluating a person's sleep quality.","apartado-3":"Sleep duration refers to the total length of time a person remains asleep during a night's sleep. \nIn other words, it is the amount of time a person spends in a state of continuous, restful sleep from the moment they fall asleep to the moment they wake up in the morning.</br></br>The duration Sleep can vary considerably from person to person and across different stages of life. \nSleep duration recommendations may vary depending on age and individual needs, but in general, it is considered that healthy adults typically need between 7 and 9 hours of sleep per night to feel rested and alert the next day. \nHowever, some people may need more or less sleep time to function optimally.</br></br>Sleep duration is an important component in evaluating sleep quality and may be related to overall health and the well-being of a person. \nBoth chronic lack of sleep and too much sleep can have negative effects on health, so finding a proper balance in sleep duration is essential to maintaining a healthy lifestyle.","apartado-4":"Sleep efficiency is the percentage of time a person spends sleeping relative to the total time spent in bed.","apartado-5":"Sleep disturbances refer to any interruption or alteration in a person's normal sleep pattern that negatively affects their quality of rest and their ability to sleep adequately during the night. \nThese disturbances can manifest themselves in various ways and have different causes, and can be temporary or chronic.</br></br>Sleep disturbances can have a significant impact on a person's quality of life, as they can cause fatigue. , daytime sleepiness, irritability and long-term health problems if not properly addressed. \nIdentifying the underlying cause of sleep disturbances is important in order to implement effective management and treatment strategies. \nIn many cases, it is advisable to seek the care of a healthcare professional who specializes in sleep disorders for a proper diagnosis and treatment plan.","apartado-6":"Sleep medications, also known as hypnotics or sleeping pills, are medications designed to help people fall asleep or stay asleep throughout the night. \nThese medications are typically used to treat sleep disorders such as insomnia, which can cause difficulty falling asleep or frequent awakenings during the night.</br></br>Sleep medications typically exert their effect on the central nervous system and They may have different mechanisms of action, depending on the type of medication.</br></br>It is important to note that the use of sleep medications should be done under the supervision of a health professional and in accordance with the specific indications of the medication. doctor. \nThese medications should not be used indiscriminately, as they can have side effects, create dependency, and do not address the underlying causes of sleep disorders.</br></br>In addition, it is recommended that sleep medications be used as part of a comprehensive treatment plan that includes lifestyle changes and sleep hygiene, as well as cognitive behavioral therapies to address sleep disorders more effectively in the long term. \nThe greater the dependence on sleeping medication, the worse the score will be in this section.","apartado-7":"Daytime dysfunction refers to the inability or difficulty a person experiences in functioning appropriately and effectively in their daily activities due to sleep-related problems or sleep disorders. \nThis dysfunction can manifest itself in various aspects of daily life, such as work, personal relationships, concentration, mood, and general health."},"questions":{"q1":"Over the past month, what has your bedtime usually been?","q2":"How long has it taken you to fall asleep, normally, on the nights of the last month?","q3":"During the last month, what time have you usually gotten up in the morning?","q4":"How many hours do you estimate you have actually slept each night over the past month?","q5":"During the last month, how many times have you had trouble sleeping because of not being able to fall asleep within the first half hour?","q6":"During the last month, how many times have you had trouble sleeping because of waking up during the night or early in the morning?","q7":"During the last month, how many times have you had trouble sleeping because of having to get up to go to the bathroom?","q8":"During the last month, how many times have you had trouble sleeping because of not being able to breathe properly?","q9":"During the past month, how many times have you had trouble sleeping because of coughing or snoring loudly?","q10":"During the last month, how many times have you had trouble sleeping because of feeling cold?","q11":"During the last month, how many times have you had trouble sleeping because of feeling too hot?","q12":"During the last month, how many times have you had trouble sleeping because of nightmares or bad dreams?","q13":"During the last month, how many times have you had trouble sleeping because of pain?","q14":"During the last month, how many times have you had trouble sleeping because of other reasons?","q15":"During the last month, how would you overall rate the quality of your sleep?","q16":"During the last month, how many times have you taken medicine (on your own or prescribed by your doctor) to help you sleep?","q17":"During the last month, how many times have you felt drowsy while driving, eating, or doing some other activity?","q18":"During the last month, has it been a big problem for you to find the courage to do any of the activities detailed in the previous question?","q19":"Do you sleep alone or with someone?"},"hours":"Hours","minutes":"Minutes","description":"The following questions only concern your sleeping habits over the past month. \nIn your answers you should reflect what your behavior has been during the majority of the days and nights of the past month. \nPlease answer all questions.","dimensions":{"subjectiveQuality":"Subjective sleep quality","sleepLatency":"Sleep latency","sleepDuration":"Sleep duration","sleepEfficiency":"Habitual sleep efficiency","sleepPerturbations":"Sleep disturbances","medicationToSleep":"Use of sleeping medication","dayDisfunction":"Dysfunction during the day"}},"tips":"Tips","seeResuts":"See results","anxiety-beck":{"title":"Anxiety test","description":"The Beck Anxiety Inventory is a useful tool that consists of 21 questions to assess somatic symptoms of anxiety, both in anxiety disorders and depressive symptoms.<br><br>Answer this questionnaire about common symptoms of anxiety considering their current difficulties. \nIndicate how much they have affected you this last month.","questions":{"q1":"Clumsy or numb","q2":"Heated","q3":"With trembling in the legs","q4":"Unable to relax","q5":"Fearing the worst will happen","q6":"Dizzy, or losing your mind","q7":"With strong and rapid heartbeat","q8":"Unstable","q9":"Frightened or frightened","q10":"Highly strung","q11":"With a feeling of blockage","q12":"With tremors in the hands","q13":"Restless, insecure","q14":"Afraid of losing control","q15":"With a feeling of suffocation","q16":"With fear of dying","q17":"Fearfully","q18":"With digestive problems","q19":"with fades","q20":"With facial blush","q21":"With sweats, hot or cold"},"lowAnxiety":"Very low anxiety","moderateAnxiety":"Moderate anxiety","severeAnxiety":"Severe anxiety"},"physical-activity":{"title":"Physical activity test","description":"The following questionnaire measures the level of physical activity in adults according to the criteria established by the International Physical Activity Questionnaire (IPAQ)","intensity":{"intense":"Intense physical activity","moderate":"moderate physical activity","walking":"Walk","sitting":"Sitting"},"questions":{"q1":"During the last week, how many days did you do intense physical activities such as running, weight training at the gym, or cycling at a high pace?","q2":"How much total time did you spend doing <b>intense</b> physical activity on one of those days?","q3":"During the last week, how many days did you do moderate physical activities such as walking bicycle, tennis doubles, Pilates or any other moderate intensity exercise?<br><br><b>Attention,</b> do not include walking, unless you do it at a very intense pace and for more than 30 minutes without interruptions","q4":"How much total time did you spend doing <b>moderate</b> physical activity on one of those days?","q5":"During the past week, on how many days did you walk for at least 10 minutes straight?","q6":"How much total time did you spend walking on one of those days?","q7":"During the last week, on average, how much time did you spend sitting in a day?"},"levels":{"highLevel":"High activity level","moderateLevel":"Moderate activity level","lowLevel":"Low activity level","name":"Activity level"},"percentPopulationResult":{"high":"It is among the 27.8% of the population between 18 and 69 years old that is in the high category of physical activity.","moderate":"It is among the 38.6% of the population between 18 and 69 years old that is in the medium category of physical activity.","low":"It is among the 33.6% of the population between 18 and 69 years old that is in the low category of physical activity."},"metsExplanation":"*METS are the reference unit used in this test. \nThe result is obtained by multiplying the number of total weekly hours by a constant value for each intensity level."},"cardiovascular-risk":{"title":"Cardiovascular risk","questions":{"q1":"Age","q2":"Have you been diagnosed with diabetes?","q3":"Do you smoke regularly?","q4":"Total cholesterol","q5":"'Good' HDL Cholesterol","q6":"Blood pressure"},"scores":{"lowRisk":{"name":"Your risk is low!","description":"Congratulations, your cardiovascular risk is low. \nDon't neglect yourself and maintain your good lifestyle habits, play sports, follow a healthy diet and avoid tobacco."},"midRisk":{"name":"Your risk is medium!","description":"Your risk of developing cardiovascular disease in the next 10 years is medium, so it is important to ensure that you follow healthy lifestyle guidelines.","tips":{"tip1":"Eat healthy. \nLimit alcohol, fatty or salty foods, sugar, pastries, as well as pre-cooked products. \nInclude fruits, vegetables and legumes in your daily diet.","tip2":"Avoid a sedentary lifestyle. \nGym, climbing stairs, playing with the children, avoiding the car... everything counts. \nYou should do at least 45 minutes of moderate physical activity for 5 days a week.","tip3":"Avoid tobacco.","tip4":"Keep stress (especially if it is continuous) under control."}},"highRisk":{"name":"Your risk is high!","description":"Your risk of developing cardiovascular disease in the next 10 years is high, so it is important to ensure that you follow some guidelines regarding your lifestyle habits. \nAnd don't forget to periodically make an appointment with your doctor. \nSome type of treatment may be advisable.","tips":{"tip4":"Keep stress (especially if it is continuous) under control.","tip3":"Avoid tobacco.","tip2":"You have to move every day. \nGym, climbing stairs, playing with the children, avoiding the car... everything counts. \nYou should do at least 45 minutes of moderate physical activity for 5 days a week. \nIf you need it, a professional can advise you on exercises appropriate to your age and condition.","tip1":"Ensures healthy eating. \nLimit alcohol, fatty or salty foods, sugar, pastries, as well as pre-cooked products. \nInclude fruits, vegetables and legumes in your daily diet. \nSee a nutrition professional if you need help improving your eating habits."}}},"description":"The following test calculates, through factors such as age, sex, genetic inheritance and habits, the estimated risk of suffering from cardiovascular disease in the next 10 years. \nIt is based on the Framingham equation."},"gender":"Sex","resultsDiagram":"Results diagram","testNamesForResultsDiagram":{"Test ryff scale":"Psychological well-being","Test findrisk":"Diabetes risk","Test mediterranean diet":"Meditarranean diet","Test nicotine dependency":"Nicotine dependency","Test stress":"Perceived stress","Test sleep quality":"Sleep quality","Test anxiety beck":"Anxiety level","Test physical activity":"Physical activity","Test cardiovascular risk":"Cardiovascular risk","Test interpersonal relationships":"Interpersonal relationships","Test social skills":"Social skills","Test general health":"General health"},"general-health":{"title":"General health","description":"The SF-36 is a questionnaire designed to assess the perception of health status and well-being. It analyzes eight key areas, such as physical capacity, pain, vitality, and emotional state, providing a comprehensive view of a person's quality of life.","dimensions":{"physical-function":"Physical function","physical-limitations":"Physical limitations","body-pain":"Body pain","general-health":"General health","vitality":"Vitality","social-function":"Social function","emotional-limitations":"Emotional limitations","mental-health":"Mental health"},"questions":{"q1":"In general, would you say your health is:","q2":"How would you rate your current health compared to a year ago?","q3":"Does your current health limit you in performing intense activities, such as running, lifting heavy objects, or participating in strenuous sports?","q4":"Does your current health limit you in performing moderate activities, such as moving a table, vacuuming, bowling, or walking for more than an hour?","q5":"Does your current health limit you in carrying or lifting a grocery bag?","q6":"Does your current health limit you in climbing several flights of stairs?","q7":"Does your current health limit you in climbing a single flight of stairs?","q8":"Does your current health limit you in bending down or kneeling?","q9":"Does your current health limit you in walking a kilometer or more?","q10":"Does your current health limit you in walking several blocks (several hundred meters)?","q11":"Does your current health limit you in walking a single block (about 100 meters)?","q12":"Does your current health limit you in bathing or dressing yourself?","q13":"In the past 4 weeks, did you have to reduce the time spent at work or in daily activities due to your physical health?","q14":"In the past 4 weeks, did you do less than you would have liked due to your physical health?","q15":"In the past 4 weeks, did you have to stop doing some tasks at work or in your daily activities due to your physical health?","q16":"In the past 4 weeks, did you have difficulty doing your work or daily activities (for example, was it harder than usual) due to your physical health?","q17":"In the past 4 weeks, did you have to reduce the time spent at work or in daily activities due to an emotional problem (such as feeling sad, depressed, or nervous)?","q18":"In the past 4 weeks, did you do less than you would have liked due to an emotional problem (such as feeling sad, depressed, or nervous)?","q19":"In the past 4 weeks, did you not perform your work or daily activities as carefully as usual due to an emotional problem (such as feeling sad, depressed, or nervous)?","q20":"In the past 4 weeks, to what extent has your physical health or emotional problems interfered with your usual social activities with family, friends, neighbors, or others?","q21":"Did you experience pain in any part of your body during the past 4 weeks?","q22":"In the past 4 weeks, to what extent has pain interfered with your usual work (including work outside the home and household tasks)?","q23":"In the past 4 weeks, how often did you feel full of vitality?","q24":"In the past 4 weeks, how often did you feel very nervous?","q25":"In the past 4 weeks, how often did you feel so downhearted that nothing could cheer you up?","q26":"In the past 4 weeks, how often did you feel calm and tranquil?","q27":"In the past 4 weeks, how often did you have a lot of energy?","q28":"In the past 4 weeks, how often did you feel discouraged and sad?","q29":"In the past 4 weeks, how often did you feel exhausted?","q30":"In the past 4 weeks, how often did you feel happy?","q31":"In the past 4 weeks, how often did you feel tired?","q32":"In the past 4 weeks, how frequently have physical health or emotional problems interfered with your social activities (such as visiting friends or family)?","q33":"I believe I get sick more easily than other people","q34":"I am as healthy as anyone","q35":"I believe my health will get worse","q36":"My health is excellent"}},"interpersonal-relationships":{"title":"Interpersonal relationships","description":"This self-assessment test invites you to explore how you manage your interpersonal relationships, evaluating key aspects such as communication, empathy, trust, and conflict resolution. Its goal is to help you identify strengths and areas for improvement in your social interactions.","questions":{"q1":"I feel supported by the people close to me","q2":"I enjoy spending time with my friends and family","q3":"I find it easy to share my thoughts and feelings with others","q4":"I can trust the people around me","q5":"I feel that the people I interact with value my opinion","q6":"I feel understood in my personal relationships","q7":"I know how to resolve conflicts without damaging my relationships","q8":"I feel comfortable asking for help when I need it","q9":"I have healthy relationships in my work environment","q10":"I enjoy social interactions, even with new people","q11":"I feel valued by my coworkers","q12":"It is easy for me to establish new relationships","q13":"I am capable of maintaining long and satisfying relationships","q14":"I feel I can be myself with the people close to me","q15":"I am able to forgive others' mistakes in my relationships","q16":"I have the ability to listen and support others when they need it","q17":"I feel comfortable expressing my needs in a relationship","q18":"I have confidence in myself when interacting with others","q19":"The people in my life respect my personal boundaries","q20":"I maintain a healthy balance between my personal and professional life","q21":"I feel accepted as I am by the people I relate to","q22":"When I argue with someone, I can resolve the situation constructively","q23":"I feel that my relationships bring me happiness and satisfaction","q24":"I have no problem apologizing if I have made a mistake","q25":"I find it easy to handle frustration in difficult social situations","q26":"The people close to me are affectionate and understanding","q27":"I can express my frustration without hurting others","q28":"I appreciate the small gestures of others in my relationships","q29":"I know how to handle rejection in a healthy way","q30":"I feel I can freely express my thoughts at work without fear of being judged","q31":"I make an effort to maintain good communication with the important people in my life","q32":"I have confidence in the decisions I make in my personal relationships","q33":"I can deal with changes in my relationships without feeling overwhelmed","q34":"I feel I have emotional support when going through personal difficulties","q35":"I find it easy to integrate new people into my social circle"},"scores":{"lowScore":{"score":"Low Score","description":"Your interpersonal relationships appear to be limited or unsatisfactory. You may be experiencing difficulties with communication, trust, or emotional support. Reflecting on how to improve these areas could be helpful."},"mid-lowScore":{"score":"Mid-Low Score","description":"Your relationships are functional, but there are aspects that could be improved. Sometimes you struggle to express your emotions or manage conflicts, which affects the quality of some of your relationships."},"midScore":{"score":"Mid Score","description":"You generally have satisfactory interpersonal relationships, although you could improve aspects such as conflict resolution or expressing your emotional needs. Overall, your relationships are balanced."},"mid-highScore":{"score":"Mid-High Score","description":"Your relationships are quite good. You feel valued and supported by others, and you handle conflicts well. However, there may be small areas to work on to further enhance the quality of your relationships."},"highScore":{"score":"High Score","description":"You have excellent interpersonal relationships. You feel completely satisfied and supported in your relationships, and you have the ability to handle conflicts and express your needs assertively. Your social and emotional environment is healthy and balanced."}}},"social-skills":{"title":"Social skills","description":"The Social Skills Inventory is designed to analyze how you navigate social situations and how well you manage aspects such as communication, conflict resolution, and emotional expression.","questions":{"q1":"Is it easy for you to start a conversation with strangers?","q2":"Can you express your opinion when you disagree with someone in a discussion?","q3":"Is it easy for you to ask for help when you need it?","q4":"Can you say 'no' when you don't want to do something without feeling guilty?","q5":"Do you feel comfortable speaking in public or in front of a group of people?","q6":"Do you know how to express disagreement without creating conflict?","q7":"Do you often praise others for their good work or attitude?","q8":"Is it easy for you to express positive feelings towards others?","q9":"Can you handle criticism calmly without reacting defensively?","q10":"Do you have confidence in resolving disagreements respectfully?","q11":"Do you feel comfortable asking for a raise or promotion at work?","q12":"Do you usually take the initiative to talk to people you'd like to collaborate with?","q13":"Is it easy for you to express frustration without hurting others' feelings?","q14":"Can you resolve interpersonal conflicts without involving third parties?","q15":"Do you feel comfortable asking for feedback about your performance at work?","q16":"Do you often express gratitude to your coworkers or acquaintances?","q17":"Do you feel comfortable setting boundaries when others invade your space or time?","q18":"Can you handle differences of opinion without becoming emotionally upset?","q19":"Is it easy for you to offer emotional support to others when they need it?","q20":"Do you feel comfortable talking about your needs or personal concerns?","q21":"Can you accept compliments without feeling uncomfortable?","q22":"Do you make decisions quickly in awkward social situations?","q23":"Do you feel capable of resolving misunderstandings without avoiding confrontation?","q24":"Do you often actively participate in group conversations?","q25":"Is it easy for you to start conversations with your superiors or bosses?","q26":"Can you apologize when you realize you've made a mistake?","q27":"Do you feel confident expressing disagreement with a close friend or family member?","q28":"Do you know how to handle rejection in social situations?","q29":"Is it easy for you to express concern when you see someone struggling?","q30":"Do you usually act calmly and constructively in stressful social situations?","q31":"Can you handle situations where others contradict you without losing your composure?","q32":"Do you often acknowledge and express others' positive contributions in a group?","q33":"Do you feel capable of apologizing when you think your words or actions may have offended someone?"},"scores":{"lowScore":{"score":"Low Score","description":"Your social skills are below the desired level. You may find it difficult to interact effectively in various everyday situations. Developing strategies to improve your social skills, such as assertiveness, empathy, and conflict management, could be helpful."},"mid-lowScore":{"score":"Mid-Low Score","description":"You have some social skills, but in certain contexts, you may feel uncomfortable or encounter difficulties. It would be beneficial to work on key aspects."},"midScore":{"score":"Mid Score","description":"Your social skills are adequate, and you are capable of managing interpersonal relationships in most situations. While you handle social interactions well, there are still areas where you could improve."},"mid-highScore":{"score":"Mid-High Score","description":"Your social skills are quite good. You perform well in most social situations and handle complex interactions effectively. However, you can work on refining details in some specific areas."},"highScore":{"score":"High Score","description":"You have excellent social skills. You feel comfortable in a wide variety of situations and manage interpersonal relationships effectively and assertively. You are capable of resolving conflicts, communicating clearly, and empathizing with others."}}},"health-data-agerestriction":"Only available for users between 18 and 67 years old","health-data-colorwarning":"The colors are merely indicative and should in no case be taken as a clinical evaluation or professional opinion. \nOnly a doctor can determine whether or not your values ​​are within normal limits or indicate treatment if necessary.","work-environment":{"title":"Work environment","description":"This workplace climate survey assesses employees' perceptions of various aspects of the work environment, such as communication, leadership, working conditions, and motivation. Through 91 questions, it helps identify strengths and areas for improvement within the organization","finalCompletedMessage":"Thanks for completing the work climate test. \n<br> <br> The results, like any other personal information on the platform, are confidential and are only accessible where appropriate by the health professional who is attending to him, if he decides. \nWe remind you that your company only receives aggregate data for the use of the platform and never receives personal information.","finalCompletedMessageAccessAgain":"You have already completed the work climate test this month. \nYou can perform an evaluation after 4 months.  \n<br> <br> The results, like any other personal information on the platform are confidential and are only accessible where appropriate by the health professional who is attending to him, if he decides. \nWe remind you that your company only receives aggregate data for the use of the platform and never receives personal information.","confidentialityWarning":"The work environment is an increasingly relevant element for the well-being of people. \nWe remind you that your answers are confidential and that the survey can only be completed a maximum of 4 times a year.","dimensions":{"social-interaction":"Social interaction","communication":"Communication","work-conditions":"Work conditions","risk-prevention":"Occupational risk prevention","satisfaction":"Recognition, satisfaction, and belonging","wage":"Remuneration","promotion":"Promotion","formation":"Training","leadership":"Leadership","autonomy":"Autonomy and innovation","client-orientation":"Customer orientation (external and internal)","organization":"Organization","motivation":"Motivation"},"questions":{"q1":"I believe there is a good work environment.","q2":"I receive collaboration from people in other departments.","q3":"I receive collaboration from my department colleagues.","q4":"The people I interact with in the organization act respectfully and ethically.","q5":"My relationship with my boss is good.","q6":"There is a lot of mobility and job changes among my colleagues.","q7":"I have access to information about the organization's product and service catalog.","q8":"Communication about the company's results and progress is clear and transparent.","q9":"Internal communication in the organization is a continuous and planned activity.","q10":"I am familiar with the organization's Code of Ethics and Conduct.","q11":"I have access to information about the organization and its evolution across all locations.","q12":"Internal communications provide me with useful information.","q13":"It is easy for me to communicate with executives or staff from other administrative areas.","q14":"I have the materials and resources necessary to do my job.","q15":"The space conditions, comfort, noise, temperature, lighting, my chair, the computer screen filter, and its height allow me to perform my job normally.","q16":"Work areas are kept clean and organized, allowing activities to be carried out as intended.","q17":"There are sufficient sanitary facilities and rest areas.","q18":"A first aid protocol is defined, and there are means to carry it out.","q19":"The organization is concerned about my stress level and provides me with means and tools to manage it.","q20":"The mental workload and stress are a problem for me.","q21":"There are spaces, apart from the cafeteria, where I can relax and recover my capacities to keep performing.","q22":"I feel proud to work for the organization.","q23":"I consider the Corporate Social Responsibility projects implemented in my country to be appropriate and important.","q24":"I feel like a part of the organization's project.","q25":"I think the organization is a good place to work, and I would like to continue working here.","q26":"I understand and share the company's values.","q27":"I feel valued by the organization.","q28":"I receive information about the elements that make up my salary (base salary plus benefits).","q29":"I am satisfied with the social benefits provided by the organization.","q30":"I believe my job is well paid.","q31":"I think my salary is in line with the salaries within the organization.","q32":"I believe my salary is consistent with the organization's economic situation and performance.","q33":"I believe that if I do my job well, I have the opportunity to be promoted within the organization.","q34":"I believe I have the opportunity to develop professionally within the organization.","q35":"When assuming a new position in the organization, my supervisor clearly informs me about the job functions and responsibilities.","q36":"I have autonomy in carrying out my work.","q37":"I have access to information about available job positions within the company.","q38":"Internal promotions are conducted fairly.","q39":"I consider the organization's performance evaluation criteria to be appropriate.","q40":"I receive training to update my job-related knowledge.","q41":"The organization's training plans align with my professional development needs.","q42":"The organization provides employees with courses on stress management and mental workload.","q43":"I receive training for personal development and talent management.","q44":"My supervisor is concerned with maintaining a good team environment.","q45":"The leadership encourages teamwork.","q46":"My supervisor praises me when I do my job well.","q47":"My supervisor listens to my opinions and involves me in decision-making.","q48":"My supervisor is committed to conveying the organization's values, mission, and objectives.","q49":"I have a good relationship with my supervisor.","q50":"My supervisor follows up on my Individual Development Plan.","q51":"My supervisor treats me fairly and avoids any kind of favoritism.","q52":"My supervisor respects differences in culture, gender, religion, etc.","q53":"My supervisor regularly provides me with feedback on my performance.","q54":"My supervisor takes the time to understand my needs and interests.","q55":"My supervisor is a role model in the company.","q56":"My supervisor is clear and specific when defining my work objectives or those of the department.","q57":"The management has realistic expectations regarding work outcomes.","q58":"Employees trust any decision made by the management.","q59":"My boss's level of demand is appropriate.","q60":"I feel like I work as a team with my boss.","q61":"I can make my own decisions without consulting my boss.","q62":"The organization continuously innovates and improves to be the leader in its sector.","q63":"Employees are encouraged to seek new ways to solve problems.","q64":"Management is open to suggestions and advice from employees.","q65":"The company appreciates and values ideas.","q66":"The company is looking for changes to maintain its competitiveness.","q67":"My job is varied enough.","q68":"The organization's work processes and procedures guide me toward internal/external customer satisfaction.","q69":"I have spoken to family and friends about the benefits of contracting the organization's services.","q70":"I am willing to put in extra effort to satisfy my internal or external customer.","q71":"The documentation (procedures, instructions, and formats) included in the Quality Management System is useful and appropriate for performing my job.","q72":"I receive the help I need from the Legal department.","q73":"I receive the help I need from the Purchasing department.","q74":"I receive the help I need from the organization's HR department.","q75":"I receive the help I need from the Commercial/Marketing department.","q76":"I receive the help I need from the Finance department.","q77":"I receive the help I need from the IT department.","q78":"I believe the organization's values reflect the working style within the company.","q79":"Since I joined the company, I believe the organization has transformed into a better place to work.","q80":"I believe that most of the action plans derived from the previous satisfaction survey have been fulfilled.","q81":"I understand how my work contributes to achieving my department’s results.","q82":"My professional skills align with the tasks and responsibilities assigned to me.","q83":"I have the opportunity to propose new projects or new ways of working.","q84":"I have the information I need to perform my job excellently.","q85":"The organization gives me the opportunity to work on projects or activities that involve new challenges.","q86":"I am clear about my tasks and responsibilities.","q87":"My job provides me with challenges and opportunities for continuous improvement.","q88":"My work is recognized and valued.","q89":"I am currently satisfied with my job in the organization.","q90":"In performing my duties, I regularly use the documentation included in the Quality Management System.","q91":"I have received the necessary training to perform the functions I currently carry out."}},"physical-health":"Physical health","mental-health":"Mental health","congratulations":"Congratulations"}}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"sgsi-policy":{"title":"SGSI Policy","text":"<p>Open HealthCare S.L. \nis aware of the importance of information security,\n\nespecially that relating to employees, clients and business processes, has implemented\n\nan information management system based on the ISO 27001 standard:</p>\n\n\n<p>In order to develop the express commitment of the Organization in continuous improvement\n\nof the management system, the Management establishes the following management principles of\n\ninformation security:</p>\n\n\n<ul>\n  \n<li>\n    \n<p>Knowledge and application by all employees and collaborators, according to\n    \ntheir role within the Company, security policies and procedures, both\n    \ngeneral ones and those that may apply to specific groups, including:</p>\n    \n<span>\n      \n<ul>\n          \n<li><p>Access control, opening and closing of facilities.</p></li>\n          \n<li><p>Information and treatment of visits to the facilities.</p></li>\n          \n<li><p>Training, awareness and motivation in safety.</p></li>\n          \n<li><p>Knowledge of roles and responsibilities.</p></li>\n          \n<li><p>Business continuity management.</p></li>\n          \n<li><p>Consequences of failure to comply with security policies.</p></li>\n          \n<li><p>Support in information security management.</p></li>\n          \n<li><p>Compliance with legislation.</p></li>\n          \n<li><p>User Good Practices Manual.</p></li>\n      \n</ul>\n    \n</span>\n  \n</li>\n  \n<li>\n    \n<p>Diligence on the part of all employees and collaborators in the communication of\n    \npossible security incidents.</p>\n  \n</li>\n  \n<li>\n    \n<p>It is necessary to ensure that the procedures that determine the\n    \nconfidentiality, integrity, availability, traceability and authenticity of the\n    \ninformation.</p>\n  \n</li>\n  \n<li>\n    \n<p>Support for the security organizational structure established to meet objectives\n    \ninformation security control and continuous risk management.</p>\n  \n</li>\n  \n<li>\n    \n<p>Guarantee the correct use of facilities and equipment so that\n    \nare in accordance with the activity and objectives of the organization.</p>\n  \n</li>\n  \n<li>\n    \n<p>Commitment to protecting the safety and health of its workers, as well as\n    \nimplement an adequate work environment.</p>\n  \n</li>\n  \n<li>\n    \n<p>Structure our management system so that it is easy to understand.</p>\n  \n</li>\n\n</ul>\n    \n<p>The management of our system is entrusted to the person responsible for Management and the system\n    \nwill be available in our information system in a repository, which can be accessed\n    \naccess according to the access profiles granted according to our current procedure\n    \naccess management.</p>\n\n    \n<p>This policy is complemented by the rest of the policies, procedures and\n    \ndocuments in force to develop our management system.</p>\n\n    \n<p>These principles are assumed by the Management, who has the necessary means\n    \nfor its implementation and are communicated for compliance by all employees and\n    \ncollaborators of the company through this Security Policy of the company\n    \nInformation.</p>"}}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {"chats":{"chat":"Chat","patients":"Patients","professionals":"Professionals","contact-patient":"Contact patient","contact-prof":"Contact professional | Interconsultation","new-message":"Write a message...","delete-message":"Do you want to delete the message?","delete-message-success":"Successfully deleted message","edit-message-success":"Message edited successfully","cant-upload-file":"Could not send file","delete":"Delete","select-patient":"Select a patient","attach-file":"Attach file/document","select-file-type":"Select file type","administrative-chat":"Administrative chat (No consultation)","select-prof":"Select a professional","finish-chat":"Finish chat","finish-chat-message-success":"Consultation successfully consolidated","finish-chat-message":"Do you want to finish the consultation?","finished-chats":"Finished chats","cancel-chat":"Cancel chat","cancel-chat-message":"Do you want to cancel the consultation?","emit-eprescription":"Issue electronic prescription","emit-eprescriptionMessage":"You will then be redirected to the electronic prescription platform.<br><br><strong>Remember that before consolidating the consultation you must issue the prescription on said platform, since it cannot be done a posteriori.</strong>","unread-messages":"unread messages","unread-message":"unread message","view-all":"See all","select-file":"Select a file","ask-for-new-chat":"Request new chat","no-active-chat":"You have no active chat"}}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"survey":"Survey","surveys":{"not-avaliable":"Survey not available","not-allowed":"You have no permission to access this survey.","loading":"Loading Survey ...","completed":"Completed survey","percentage-completed":"% completed","mandatory":"The valuation is mandatory","comment-review":"Add a comment ... (optional)","finish":"Finish","following":"Following","error":{"error-loading":"Error when loading survey. \nPlease try again later.","error-send":"Error sending the survey. \nPlease try again later."},"info":{"error-finish":"You must answer all the questions before finishing."},"congratulations":"Congratulations","finishText":"Click the 'Finish' button to send the survey results","completed2":"Thanks for completing the survey","opensalud-go":"Go to Opensalud","close-dialog":"This window will close automatically in 5 seconds","start":"Start survey"}}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {"unipromel":{"title":"The platform of independent doctors","subtitle":"Quality medicine,<br>without rush.","text":"UNIPROMEL was established in 2020, to bring together doctors who practice in the Spanish private health sector in order to defend their interests and guarantee the quality of care for the patient.","learn-more":"Learn more","card":{"title1":"Online consultation","subtitle1":"Video consultation, Written consultation, Chat, Second opinion...","title2":"Electronic prescription","subtitle2":"Recipes approved by the Collegiate Medical Organization.","title3":"Clinic History","subtitle3":"Access, edit and share the clinical history with your patients.","title4":"Face-to-face consultation","subtitle4":"Home consultation. Clinic consultation.","title5":"Subscriptions and packs","subtitle5":"Design your own service packs and subscriptions.","title6":"Online diary","subtitle6":"Manage your appointments online easily automatically.","title7":"Online billing","subtitle7":"Make your payments and issue your invoices automatically.","title8":"Remote monitoring and exploration","subtitle8":"It incorporates devices to facilitate online consultation and monitoring.","title9":"Customizable prices","subtitle9":"You can set different prices depending on the reason for consultation or the group."},"block-2":{"blackTitle":"You decide.","title":"Take care of your patients how and when you want."},"insurance-appointments":"Insurance appointments","private-appointments":"Premium private consultations","insurance-appointments-subtitle":"At place consultation only.<br>Consultation of limited duration.<br>Delay in schedule subject to availability.","private-appointments-subtitle":"At place and online consultation.<br>Consultation is not limited in duration.<br>The maximum delay in the agenda is 15 days.<br>Minimum price guaranteed at unihealth.","more-information":"(*) Premium private consultations are available to all doctors, are not limited in duration and have a low appointment delay.","patients":"Patients","medics-together":"Doctors united.","free-professionals":"Free professionals.","become-partner":"¡Become a partner!","block-patients":{"title":"Unhurried quality medicine\n\nand with Unipromel's guarantee.","subtitle":"Access the best doctors in Spain in\nanytime and from anywhere\nan easy and safe way and with the best price guaranteed.","access-btn":"Sign up free"},"paragraph":"Unihealth is the platform of UNIPROMEL, an association that brings together doctors who practice in the private sector in Spain."}}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {"legal-notice":"Aviso legal y cookies"}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {"profConditions-link":"Condiciones para profesionales","patConditions-link":"Condiciones para pacientes","telemedicineCompanies-link":"Salud y bienestar para empresas","contact-link":"Contacto","legalNotice-link":"Aviso legal y cookies","questions-link":"Preguntas frecuentes","lastUpdate":"Última actualización"}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"forumSectionDescription":""}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"finishTest":"Finalizar test","section":"Apartado","highScore":"PUNTUACIÓN ALTA","lowScore":"PUNTUACIÓN BAJA","psychosocial-risks":{"title":"Riesgos psicosociales","questions":{"q1":"¿Tienes que trabajar muy rápido?","q2":"¿La distribución de tareas es irregular y provoca que se te acumule el trabajo?","q3":"¿Tienes tiempo de llevar al día tu trabajo?","q4":"¿Te cuesta olvidar los problemas del trabajo?","q5":"¿Tu trabajo, en general, es desgastador emocionalmente?","q6":"¿Tu trabajo requiere que escondas tus emociones?","q7":"¿Tienes influencia sobre la cantidad de trabajo que se te asigna?","q8":"¿Se tiene en cuenta tu opinión cuando se te asignan tareas?","q9":"¿Tienes influencia sobre el orden en el que realizas las tareas?","q10":" ¿Puedes decidir cuándo haces un descanso?","q11":"Si tienes algún asunto personal o familiar ¿puedes dejar tu puesto de trabajo al menos una hora sin tener que pedir un permiso especial?","q12":"¿Tu trabajo requiere que tengas iniciativa?","q13":"¿Tu trabajo permite que aprendas cosas nuevas? ","q14":"¿Te sientes comprometido con tu profesión? ","q15":"¿Tienen sentido tus tareas? ","q16":"¿Hablas con entusiasmo de tu empresa a otras personas? ","q17":"En estos momentos, ¿estás preocupado/a por lo difícil que sería encontrar otro trabajo en el caso de que te quedaras en paro?","q18":"En estos momentos, ¿estás preocupado/a por si te cambian de tareas contra tu voluntad? ","q19":"En estos momentos, ¿estás preocupado/a por si te cambian el horario (turno, días de la semana, horas de entrada y salida) contra tu voluntad? ","q20":"En estos momentos, ¿estás preocupado/a por si te varían el salario (que no te lo actualicen, que te lo bajen, que introduzcan el salario variable, que te paguen en especie, etc.)? ","q21":"¿Sabes exactamente qué margen de autonomía tienes en tu trabajo?","q22":"¿Sabes exactamente qué tareas son de tu responsabilidad?","q23":"¿En esta empresa se te informa con suficiente antelación de los cambios que pueden afectar tu futuro?","q24":"¿Recibes toda la información que necesitas para realizar bien tu trabajo?","q25":"¿Recibes ayuda y apoyo de tus compañeras o compañeros?","q26":"¿Recibes ayuda y apoyo de tu inmediato o inmediata superior?","q27":"¿Tu puesto de trabajo se encuentra aislado del de tus compañeros/as?","q28":"En el trabajo, ¿sientes que formas parte de un grupo?","q29":"¿Tus actuales jefes inmediatos planifican bien el trabajo?","q30":"¿Tus actuales jefes inmediatos se comunican bien con los trabajadores y trabajadoras?","q31":"¿Qué parte del trabajo familiar y doméstico haces tú?","q32":"Si faltas algún día de casa, ¿las tareas domésticas que realizas se quedan sin hacer?","q33":"Cuando estás en la empresa ¿piensas en las tareas domésticas y familiares?","q34":"¿Hay momentos en los que necesitarías estar en la empresa y en la casa a la vez?","q35":"Mis superiores me dan el reconocimiento que me merezco","q36":"En las situaciones difíciles en el trabajo recibo el apoyo necesario","q37":"En mi trabajo me tratan injustamente","q38":"Si pienso en todo el trabajo y esfuerzo que he realizado, el reconocimiento que recibo en mi trabajo me parece adecuado"},"answers":{},"dimensions":{"ap1":"Exigencias psicológicas","ap2":"Control sobre el trabajo","ap3":"Inseguridad sobre el futuro","ap4":"Apoyo social y calidad de liderazgo","ap5":"Doble presencia","ap6":"Estima"}},"ryff-scale":{"title":"Escala Ryff","questions":{"q1":"No tengo miedo a expresar mis opiniones, incluso cuando son contrarias a las de la mayoría de la gente","q2":"Para mí, la vida ha sido un proceso continuo de aprendizaje, cambio y crecimiento","q3":"En general, siento que tengo el control de la situación en la que vivo","q4":"La gente me describiría como una persona generosa, dispuesta a compartir mi tiempo con los demás","q5":"No estoy interesado en actividades que amplíen mis horizontes","q6":"Disfruto haciendo planes para el futuro y trabajando para hacerlos realidad","q7":"La mayoría de la gente me ve como cariñoso y afectuoso","q8":"En muchos aspectos me siento decepcionado por mis logros en la vida","q9":"Vivo la vida día a día y no pienso en el futuro","q10":"Tiendo a preocuparme por lo que los demás piensan de mí","q11":"Cuando miro la historia de mi vida, me alegro de cómo han ido las cosas","q12":"Tengo dificultades para organizar mi vida de forma que me resulte satisfactoria","q13":"Mis decisiones no suelen estar influidas por lo que hacen los demás","q14":"Hace tiempo que dejé de intentar hacer grandes mejoras o cambios en mi vida","q15":"Las exigencias de la vida cotidiana a menudo me deprimen","q16":"No he experimentado muchas relaciones afectuosas y de confianza con los demás","q17":"Creo que es importante vivir nuevas experiencias que desafíen tu forma de pensar sobre ti mismo y sobre el mundo","q18":"Mantener relaciones estrechas me ha resultado difícil y frustrante","q19":"Mi actitud hacia mí mismo probablemente no sea tan positiva como la de la mayoría de la gente hacia ellos mismos","q20":"Tengo un sentido de dirección y propósito en la vida","q21":"Me juzgo por lo que creo que es importante, no por los valores de lo que otros creen que es importante","q22":"En general, me siento seguro y positivo conmigo mismo","q23":"He podido construirme un entorno y un estilo de vida que me gustan mucho","q24":"Tiendo a dejarme influenciar por personas con opiniones firmes","q25":"No me gusta encontrarme en situaciones nuevas que me obliguen a cambiar mi forma habitual de hacer las cosas","q26":"No encajo muy bien con la gente y la comunidad que me rodea","q27":"Sé que puedo confiar en mis amigos, y ellos saben que pueden confiar en mí","q28":"Cuando pienso en ello, no he mejorado mucho como persona a lo largo de los años","q29":"Algunas personas vagan sin rumbo por la vida, pero yo no soy una de ellas","q30":"A menudo me siento solo porque tengo pocos amigos íntimos con los que compartir mis preocupaciones","q31":"Cuando me comparo con amigos y conocidos, me siento bien con lo que soy","q32":"No tengo del todo claro lo que estoy tratando de lograr en la vida","q33":"A veces me siento como si hubiera hecho todo lo que hay que hacer en la vida","q34":"Siento que muchas de las personas que conozco han sacado más provecho de la vida que yo","q35":"Confío en mis opiniones, aunque sean contrarias al consenso general","q36":"Soy bastante bueno gestionando las muchas responsabilidades de mi vida diaria","q37":"Tengo la sensación de que me he desarrollado mucho como persona con el tiempo","q38":"Disfruto de las conversaciones personales y mutuas con familiares y amigos","q39":"Mis actividades diarias a menudo me parecen triviales y sin importancia","q40":"Me gusta la mayor parte de mi personalidad","q41":"Me cuesta expresar mis opiniones sobre temas controvertidos","q42":"A menudo me siento abrumado por mis responsabilidades"},"answers":{},"dimensions":{"self-acceptance":"Autoaceptación","life-purposes":"Propósitos de la vida","environmental-control":"Dominio del entorno","positive-relationships":"Relaciones positivas","personal-growth":"Crecimiento personal"}},"nicotine-dependency":{"title":""}}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"signup":{"modal4":"Recuerde que dispone de <b>72 horas</b> para confirmar este email. Si tiene algún problema puede ponerse en contacto con nosotros a través de <b>contactomx@opensalud.es</b> ","ok":"Se ha enviado un correo electrónico a {email} para verificar su identidad, además de un Whatsapp si ha introducido número de teléfono. <br>Por favor consulte su buzón y siga las instrucciones."},"account":{"confirm-account":{"email-required":""},"confirm-account-h1":"Su email ha sido validado. Para completar su registro, debe de establecer una contraseña para su usuario.","password-update":{"email-required":"Enter an email"}}}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = {"card":{"title7":"Recibo online","src-price":"/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN-OUT-DOLAR.svg"},"block-3":{"text2":"Además, podrás gestionar toda la información de tus pacientes: su historial clínico, citas, pagos, indicarles tareas, programar seguimientos o recetar online bajo el sistema homologado de prescripción de la OMC."}}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"pyme":{"title":"PYME Program","text":"<p>OPEN HEALTHCARE, S.L. ha sido beneficiaria de Fondos Europeos, cuyo objetivo es la mejora de la competitividad de las PYMES, y gracias al cual ha puesto en marcha un Plan de Acción con el objetivo de impulsar el uso seguro y fiable del ciberespacio y la competitividad de las pymes durante el año 2024. Para ello ha contado con el apoyo del Programa Pyme Cibersegura de la Cámara de Comercio de Sevilla. #EuropaSeSiente</p>"}}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {"sgsi-policy":{"title":"Política SGSI","text":"<p>Open HealthCare S.L. es consciente de la importancia de la seguridad de la información,\nespecialmente la relativa a empleados, clientes y procesos de negocio, ha implantado\nun sistema de gestión de la información basado en la norma ISO 27001:</p>\n\n<p>Para poder desarrollar el compromiso expreso de la Organización en la mejora continua\ndel sistema de gestión, la Dirección establece los siguientes principios de gestión de\nseguridad de la información:</p>\n\n<ul>\n  <li>\n    <p>Conocimiento y aplicación por parte de todos los empleados y colaboradores, según\n    su función dentro de la Compañía, de las políticas y procedimientos de seguridad, tanto\n    las generales como las que puedan aplicar a grupos específicos, incluyendo:</p>\n    <span>\n      <ul>\n          <li><p>Control de accesos, apertura y cierre de las instalaciones.</p></li>\n          <li><p>Información y tratamiento de las visitas a las instalaciones.</p></li>\n          <li><p>Formación, concienciación y motivación en seguridad.</p></li>\n          <li><p>Conocimiento de roles y responsabilidades.</p></li>\n          <li><p>Gestión de la continuidad del negocio.</p></li>\n          <li><p>Consecuencias de la falta de cumplimiento de las políticas de seguridad.</p></li>\n          <li><p>Apoyo en la gestión de la seguridad de la información.</p></li>\n          <li><p>Cumplimiento con la legislación.</p></li>\n          <li><p>Manual de Buenas prácticas del usuario.</p></li>\n      </ul>\n    </span>\n  </li>\n  <li>\n    <p>Diligencia por parte de todos los empleados y colaboradores en la comunicación de\n    posibles incidentes de seguridad.</p>\n  </li>\n  <li>\n    <p>Hay que asegurar que se cumplen los procedimientos donde se determina la\n    confidencialidad, integridad, disponibilidad, trazabilidad y autenticidad de la\n    información.</p>\n  </li>\n  <li>\n    <p>Apoyo a la estructura organizativa de seguridad establecida para cumplir los objetivos\n    de control de la seguridad de la información y gestión continua de los riesgos.</p>\n  </li>\n  <li>\n    <p>Garantizar el correcto uso de las instalaciones y el equipamiento de forma tal que\n    estén en correspondencia con la actividad y objetivos de la organización.</p>\n  </li>\n  <li>\n    <p>Compromiso de proteger la seguridad y salud de sus trabajadores, así como de\n    implantar un adecuado ambiente de trabajo.</p>\n  </li>\n  <li>\n    <p>Estructurar nuestro sistema de gestión de forma que sea fácil de comprender.</p>\n  </li>\n</ul>\n    <p>La gestión de nuestro sistema se encomienda al responsable de Gestión y el sistema\n    estará disponible en nuestro sistema de información en un repositorio, al cual se puede\n    acceder según los perfiles de acceso concedidos según nuestro procedimiento en vigor\n    de gestión de los accesos.</p>\n\n    <p>Esta política se complementa con el resto de las políticas, procedimientos y\n    documentos en vigor para desarrollar nuestro sistema de gestión.</p>\n\n    <p>Estos principios son asumidos por la Dirección, quien dispone de los medios necesarios\n    para su implantación y se comunican para su cumplimiento por todos los empleados y\n    colaboradores de la empresa a través de la presente Política de Seguridad de la\n    Información.</p>\n"}}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {"private-layout":{"my-profile":"Meu perfil","health-data":"Dados de saúde","chats":"Chats","my-consultations":"Minhas consultas","my-agenda":"Meu horário","my-professionals":"A minha equipa","search":"Marque consulta","change-user":"Mudar usuário","questions":"Dúvidas","logout":"Fechar Sessão","evaluate-your-health":"Avalie sua saúde","habits-challenges":"Meus objetivos e hábitos","healthy-community":"Comunidade saudável","log-off":"Fechar Sessão","appointment-request":"Solicitações e cotações","chats-interconsultation":"Chats-Interconsultas","dashboard":"Painel de controle","my-invoices":"Minhas contas","my-patients":"meus pacientes","my-requests":"Minhas solicitações","my-services":"Meus serviços","my-profile-services":"Meu perfil","patients-like-you":"Pacientes como você","activeChats":"Chats ativos","home":"Começar","healthy-foods":"Alimentação saudável","services":"Meus serviços","physiotherapy":"Fisioterapia digital","my-apps":"Meus aplicativos","who-signs-up":"Quem aponta?","idle-time-warning":"Informamos que em 5 minutos sua sessão será fechada por inatividade.\nInteraja com esta janela se ainda estiver ativa."}}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"terms-conditions":"Términos y condiciones","contact":"Contacto","legal-notice":"Aviso legal","cookies-policy":"Política de cookies","privacy-policy":"Política de privacidad","faqs":"Preguntas frecuentes","sgsi-policy":"Política SGSI"}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"simple-search":{"in-person-visit":"Visita presencial","online":"On-line","appointment-type":"","search":"Procurar","private-appointment":"CONSULTA PRIVADA","insurance-appointment":"CONSULTA DE SEGUROS","select-specialty-professional-or-service":"Você deve selecionar uma especialidade, profissional ou serviço.","location":"Província/Localidade","select-specialty-or-service":"Você deve primeiro selecionar uma especialidade ou teste.","inplace-without-location-warning":"Você selecionou a consulta presencial, se quiser uma videoconsulta deverá selecionar a consulta online. \nContinuar e cancelar.","no-locations-dialog-warning":"O profissional selecionado não possui um serviço de consulta de face -a -face. \nQuer solicitar algum dos serviços on -line?","select-location":"Como ele selecionou a nomeação de face a face, ele deve indicar a província/localidade. Se você deseja uma consulta online, selecione o botão <img width=\"17\" height=\"17\" src=\"/static-appopensalud/img/icons/services/video.svg\"/> <span style=\"color: #3238C4\">ON-LINE</span>"}}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = {"learn-more-btn":"Ler mais","title-big-1":"Queremos cuidar de si. Sempre.","title-big-2":"Aproveite gratuitamente o melhor aplicativo para cuidar da sua saúde.","title-big-3":"¿Cómo funciona?","title-big-4":"Contáctanos","title-small-1":"A plataforma abrangente de saúde e bem-estar","title-small-2":"Sin esperas, estés donde estés","title-small-3":"Comodidad y seguridad","title-small-4":"segurança e privacidade","title-small-5":"Regístrate en openhealth","title-small-6":"Inicia sesión y elige el servicio","title-small-7":"Indica el motivo de tu consulta","title-small-8":"Accede al profesional","text-1":"Aceder aos melhores profissionais e programas de saúde e bem-estar, a qualquer hora e em qualquer lugar.","text-1-sm":"opensalud 360 es una plataforma de salud para personas,empresas y colectivos, que permite a sus usuarios acceder a los mejores profesionales de la salud, en cualquier momento y desde cualquier lugar.","text-2":"En tu hogar, lugar de trabajo o incluso un hotel, accede por video, teléfono o chat a algunos de los mejores especialistas. Podrás recibir tu receta directamente en el móvil.","text-3":"Evita riesgos, molestias y costes para ti y tu familia, limitando los desplazamientos a centros médicos, urgencias... nos pospongas el cuidado de salud por falta de tiempo.","text-4":"Contenidos a medida, gimnasio online, clases en directo de mindfulness, pilates, cardiovascular, embarazadas, espalda sana… entre otros muchos servicios.","text-5":"Incluye el código, número de póliza o reserva facilitado","text-6":"Selecciona el servicio y el profesional que necesitas utilizando el buscador","text-7":"Añade algunos datos de salud, adjuntando si lo deseas imágenes o informes","text-8":"Recibe tu informe y prescripción. Al finalizar podrás valorar el servicio","text-9":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","text-9-sm":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","specialty":"Especialidad","appointment-type":"Tipo de consulta","bonified-services":"Outros serviços de saúde subsidiados","bonified-services-description":"Consultas, exames de diagnóstico e tratamentos a um preço reduzido.","healthy-community":"Comunidade Saudável","healthy-community-description":"Organize planos, compartilhe experiências e acesse informações de saúde","health-wealth":"Plataforma de bem-estar","health-data":"dados de saúde","health-data-description":"Consulte os dados do seu histórico médico (doenças, alergias, medicamentos, etc.)","habits-description":"Te ajudamos a criar desafios para melhorar seus hábitos","healthy-habits":"Hábitos saudaveis","self-evaluation-tests":"Avalie sua saúde","self-evaluation-tests-description":"Saúde mental e emocional, riscos psicossociais, risco de diabetes, etc.","reminders":"Lembretes","reminders-description":"Comunicações úteis para sua saúde e bem-estar"}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = {"abogalitypro":{"form":{"collegiateNumber":"Província de colegiado"},"cards":{"10":{"subtitle":"Entre em contato com outros advogados por meio de mensagens internas"},"19":{"title":"Interconsultas"},"video":{"title":"Plataforma de vídeo profissional","subtitle":"Seguro e privado. \nNão requer cadastro de usuários (Teams, Zoom...)"}}},"iva-not-included":"(IVA não incluído)"}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {"account":{"login":{"title":"Iniciar sessão"}},"login":{"mfaCode":"Código","invalid-credentials":"E-mail e/ou senha incorretos","already-sign-in":"Já registrado?","errors":{"passwordMaxAttempts":"Como você não conseguiu fazer login várias vezes, sua conta permanecerá bloqueada por alguns momentos.<br>Faça login novamente após alguns minutos.","copaymentEnabled":"Seu pacote de serviços disponíveis foi modificado, de modo que determinados serviços não estarão mais disponíveis ou terão copagamento. \nSe você tiver alguma dúvida, entre em contato conosco no chat de suporte.","expired":"O serviço que a sua entidade tinha contratado com a <b>Open Health</b> terminou. \nSe precisar de mais informações, entre em contato com sua empresa ou entidade.<br><br>No entanto, seus dados ainda estão disponíveis em <a href='{domain}'>{domain}</a> onde, se desejar, você pode solicitar os serviços com o profissional de sua escolha, porém lembre-se que estes não serão mais cobertos por sua empresa. \nSe desejar aceder a algum dos profissionais disponíveis, poderá fazê-lo aos preços que o referido profissional estabeleceu para os utilizadores do opensalud 360.","deniedAccess":"Lamentamos, mas seu usuário não pode acessar este serviço comercial.<br/> Se você acha que isso pode ser um erro, entre em contato conosco usando o bate-papo de suporte ou envie um e-mail para @:global.contact-email .","santanderPaidService":"Relembramos que o programa foi prorrogado até 31 de janeiro de 2023. Caso pretenda continuar nele após essa data deverá assumir o custo subsidiado de 36 euros por consulta.","travelExpired":"O serviço médico relacionado com a sua reserva com a {travelCompany} terminou a {endDate}.<br>Se desejar aceder aos seus dados, pode continuar a fazê-lo em <a href='{domain}'>{domain}</a><br>No entanto, se tiver um novo número de reserva, preencha o formulário para continuar a usufruir do serviço.</b>","travelNotStartedYet":"O serviço médico relacionado com a sua reserva com {travelCompany} começa em {startDate}.<br>Este serviço estará disponível apenas durante a sua estadia nos nossos hotéis.","zaraExpired":"O programa piloto de acesso opensalud360 para funcionários da Zara terminou em 28 de fevereiro. \nA Zara Espanha irá notificá-lo sobre a possível continuidade ou não do serviço. \nNo entanto, informamos que pode continuar a utilizar a sua conta como utilizador privado, poderá continuar a aceder tanto aos seus dados como às suas consultas através do portal: <a style='font-weight: bold;' \nhref='https://opensalud.es/'>https://opensalud.es/ </a>.<br><br>Agradecemos a sua confiança.","zaraPilotEnd":"O programa piloto de acesso opensalud360 para funcionários da Zara terminou em 28 de fevereiro. \nA Zara Espanha irá notificá-lo no futuro sobre a possível continuidade ou não do serviço. \nAgradecemos a sua confiança. \nCaso tenha interesse em continuar com o atendimento após o término do programa piloto, poderá fazê-lo mediante o pagamento do valor das consultas."},"iam-client":"sou cliente","iam-lawfirm":"eu sou um escritório de advocacia","iam-lawyer":"Sou advogado","dialog-lawyer":"Atualmente, o registro só é possível por convite, para o qual você precisará incluir o código recebido.","terms-and-conditions":"Você deve aceitar nossos termos e condições antes de continuar:","terms-and-conditions-accept":"Li e aceito os termos e condições legais.","privacy-policy":"Você deve aceitar nossa política de privacidade antes de continuar:","privacy-policy-accept":"Eu li e aceito a política de privacidade.","twoFACode-ph":"Código"}}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {"account":{"password-update":{"update-password":"Atualizar senha","password":"Senha","success":"Sua senha foi redefinida com sucesso.","reset-password":"Nós lhe enviaremos um e-mail com as instruções para recuperar sua senha para o endereço de e-mail com o qual você se cadastrou.","expired-password":"Sua senha expirou após 12 meses.","send-password-email":"Enviar e-mail de recuperação","email-sent":"Já lhe enviamos um e-mail com instruções para {email}","check-email":"Verifique seu e-mail para recuperar sua senha.","check-spam":"Se você não conseguir encontrá-lo em sua caixa de entrada, lembre-se de que ele pode ter ido parar na sua pasta de lixo eletrônico ou spam.","security-requirements":"Devido a requisitos de segurança, a senha deve ter no mínimo 8 caracteres, e conter pelo menos uma letra maiúscula, uma letra minúscula, um caractere especial e um número.","click-login":"Clique aqui para logar","repeat-password":"Repita sua senha","error":"Seu link expirou. \nPor favor, <a href=\"/cuenta/peticion-actualizar-contrasena\">clique aqui</a> para solicitar um novamente.","set-password":"configurar senha","success2":"Sua senha foi definida com sucesso.","error-found":"Ocorreu um erro ao tentar redefinir sua senha. \nEntre em contato com o suporte.","error-requisites":"Não foi possível alterar sua senha. \nLembre-se de que você não pode ter usado a mesma senha antes.","email-required":"Digite um e-mail"},"confirm-email":"Confirmar conta","confirm-account-h1":"Seu e-mail foi validado. \nPara completar seu registro, você deve estabelecer uma senha para seu usuário.","confirm-account-error":"ocorreu um erro","confirm":{"error":"O e-mail de confirmação expirou."},"set-email-title":"Especifique um e-mail válido","set-email":{"error01":"Digite um e-mail válido por favor","error02":"O e-mail informado já está cadastrado no sistema"},"setEmail":"Definir e-mail","confirm-account-message":"Verifique sua caixa de entrada ou WhatsApp para confirmar o registro na plataforma","confirm-account":{"steps-reenable":"Por favor, digite o e-mail com o qual você se cadastrou e clique no botão abaixo e nós lhe enviaremos o e-mail de confirmação da conta novamente.","resend-enable-account":"Reenviar e-mail de confirmação","email-required":"Por favor, digite o e-mail com o qual você se cadastrou"},"register":{"confirmation-title":"Registro correto"}},"signup":{"ok":"Um e-mail foi enviado para {email} para verificar sua identidade, bem como um Whatsapp se você digitou seu número de telefone. \n<br>Verifique sua caixa de correio e siga as instruções.","ok2":"para verificar sua identidade, além de um Whatsapp se você digitou um número de telefone. \n<br>Verifique sua caixa de correio e siga as instruções.","titleok":"Registro bem-sucedido","modal3":"Se você não receber depois de alguns minutos, verifique sua pasta de lixo eletrônico/spam.","modal4":"Lembre-se que você tem <b>72 horas</b> para confirmar este e-mail. \nSe tiver algum problema, pode contactar-nos em <b> info@opensalud.es</b>","modal4-openlegal":"Lembre-se que você tem <b>72 horas</b> para confirmar este e-mail. \nSe tiver algum problema, pode contactar-nos em <b> hola@openlegal.com</b>"},"kickout":{"title":"desconexão automática","explain":"Esta sessão foi desconectada porque outra sessão foi iniciada com o mesmo usuário em uma guia, navegador ou dispositivo diferente do atual.","explain2":"Utilizamos este sistema como medida de segurança para garantir acesso exclusivo à plataforma.","contact":"Se esta tela for exibida sem que você acredite que está no caso acima, você pode entrar em contato conosco através do nosso chat de suporte, localizado no canto inferior direito."}}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = {"update-required-data":{"text":"Antes de continuar, preencha as seguintes informações:","save":"Atualizar dados","contact-chat":"Se você não souber seu número de empregado, por favor entre em contato com o chat de suporte técnico para obter ajuda.","messages":{"dni-already-exists":"Já existe um usuário cadastrado com esse documento de identidade","user-is-underage":"Você deve ser maior de idade para se registrar"}}}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = {"cookies-1":"<h4>1. INFORMACIÓN SOBRE COOKIES</h4><br>","cookies-1txt":"<p>Debido a la entrada en vigor de la referente modificación de la “Ley de Servicios de la Sociedad de la Información” (LSSICE) establecida por el Real Decreto 13/2012, es de obligación obtener el consentimiento expreso del usuario de todas las páginas web que usan cookies prescindibles, antes de que éste navegue por ellas.</p><br>","cookies-2":"<h4>2. ¿QUÉ SON LAS COOKIES?</h4><br>","cookies-2txt":"<p>Las cookies y otras tecnologías similares tales como local “shared objects”, “flash cookies” o píxeles, son herramientas empleadas por los servidores Web para almacenar y recuperar información acerca de sus visitantes, así como para ofrecer un correcto funcionamiento del sitio.</p><br><p>Mediante el uso de estos dispositivos se permite al servidor Web recordar algunos datos concernientes al usuario, como sus preferencias para la visualización de las páginas de ese servidor, nombre y contraseña, productos que más le interesan, etc.</p><br>","cookies-3":"<h4>3. COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS</h4><br>","cookies-3txt":"<p>Según la directiva de la UE, las cookies que requieren el consentimiento informado por parte del usuario son las cookies de analítica y las de publicidad y afiliación, quedando exceptuadas las de carácter técnico y las necesarias para el funcionamiento del sitio web o la prestación de servicios expresamente solicitados por el usuario.</p><br>","cookies-4":"<h4>4. ¿QUÉ TIPOS DE COOKIES EXISTEN?</h4><br>","cookies-4txt":"<p>Sobre los tipos de cookies, existen cinco grandes grupos:</p><br><ul><li>Cookies analíticas: recogen información del uso que se realiza del sitio web.</li><li>Cookies sociales: son aquellas necesarias para redes sociales externas.</li><li>Cookies de afiliados: permiten hacer un seguimiento de las visitas procedentes de otras webs, con las que el sitio web establece un contrato de afiliación (empresas de afiliación).</li><li>Cookies de publicidad y comportamentales: recogen información sobre las preferencias y elecciones personales del usuario (retargeting).</li><li>Cookies técnicas y funcionales: son las estrictamente necesarias para el uso del sitio web y para la prestación del servicio contratado.</li></ul><br>","cookies-5":"<h4>5. RELACIÓN Y DESCRIPCIÓN DE LAS COOKIES QUE UTILIZAMOS EN LA PÁGINA WEB</h4><br>","cookies-5txt":"<p>La tabla que publicamos a continuación recoge de forma esquematizada las cookies que utilizamos en nuestra página web:</p><br>","cookies-5table":"<table><tr><th>Tipo</th><th>Nombre</th><th>Info</th><th>Caducidad</th><th>Propiedad</th><th>Link</th></tr><tr><td>Funcional</td><td>ASP.NET_SessionId</td><td>Sesión del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>__RequestVerificationToken</td><td>Prevención de ataques CSRF</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>raw_country</td><td>País del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>raw_continent</td><td>Continente del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>langpref</td><td>Lenguaje del usuario</td><td>19/01/2038</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>lang_established</td><td>Establecimiento del lenguaje del usuario</td><td>19/01/2038</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>pwa_installed</td><td>Acceso escritorio instalado</td><td>30 (No) - 365 (Sí) días</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>.AspNet.ApplicationCookie</td><td>Identidad del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>api_token</td><td>Conexión con APIs</td><td>24 horas</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>tmc_token</td><td>Conexión con TMC</td><td>24 horas</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>Sentry cookies</td><td>Gestión de errores</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Funcional</td><td>Cloudflare cookies</td><td>Seguridad</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Funcional</td><td>Smartsupp cookies</td><td>Chat de soporte</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Analítica</td><td>Google cookies</td><td>Seguimiento</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Analítica</td><td>Facebook cookies</td><td>Seguimiento</td><td>-</td><td>Terceros</td><td></td></tr></table><br>","cookies-5clarify":"<p>Ao clicar em <u>'Aceitar tudo'</u> em nosso banner, você aceita cookies funcionais e analíticos. Ao contrário, se você clicar em <u>'Somente necessário'</u> você só faz isso com funcionais.</p><br>","cookies-6":"<h4>6. COOKIES DE REDES SOCIALES</h4><br>","cookies-6txt":"<p>Algunas páginas de nuestros sitios web le permiten compartir nuestros contenidos en redes sociales como Facebook, Twitter, Google, etc. Algunas veces colgamos vídeos de sitios como YouTube. Estos sitios web depositan sus propias cookies, que nosotros no controlamos. Quizás quiera comprobar sus sitios web para saber más acerca de su política de cookies.</p><br><p>MÁS INFORMACIÓN SOBRE COOKIES DE REDES SOCIALES:</p><ul><li><a href='https://es-es.facebook.com/about/privacy/cookies'>Facebook</a></li><li><a href='https://twitter.com/privacy'>Twitter</a></li><li><a href='https://www.youtube.com/howyoutubeworks/policies/community-guidelines/'>Youtube</a></li><li><a href='https://www.linkedin.com/legal/privacy-policy'>Linkedin</a></li></ul><br>","cookies-7":"<h4>7. DESDE SU NAVEGADOR PUEDE:</h4><br>","cookies-7txt":"<p>Evitar el uso de Cookies, deshabilitando en su navegador el uso de Cookies y eliminando las Cookies guardadas en su navegador asociadas a este sitio web. Esta posibilidad de evitar el uso de Cookies puede ser llevada a cabo por usted en cualquier momento.</p><br><p>Evitar la descarga de cookies en tu navegación, seleccionando la opción “Navegación de incógnito” o similar, (aunque la siguiente ocasión que quiera acceder a tu cuenta personal tendrá que loguearte) debiendo renunciar además a la memorización de otras variables de sesión.</p><br><p>Borrar cookies, Para borrar las cookies vinculadas con tu cuenta personal en OPENHEALTHCARE S.L deberás hacerlo desde el dominio https: www.openhealthcare.es.</p><br>","cookies-8":"<h4>8. REVOCACIÓN DEL CONSENTIMIENTO PARA INSTALAR COOKIES COMO ELIMINAR LAS COOKIES DEL NAVEGADOR</h4><br>","cookies-8txt":"<p><b><u>Chrome</b></u></p><ol><li>Selecciona el icono de Herramientas</li><li>Haz clic en Configuración.</li><li>Haz clic en Mostrar Opciones Avanzadas.</li><li>En la sección «Privacidad» haz clic en Configuración de contenido. • Eliminar cookies: Haz clic en Todas las cookies y los datos de sitios… • No permitir que se almacenen cookies.</li><li>Haz clic en Eliminar datos de navegación (vaciar la Caché).</li><li>Cierra y reinicia el navegador.</li></ol><p style='font-weight:bold;'>Para más información sobre Chrome pulse <a href='https://support.google.com/chrome/answer/95647?hl=es'>aquí</a>.</p><br>","cookies-8txt2":"<p><b><u>Internet Explorer. Versión 11</b></u></p><ol><li>Selecciona Herramientas | Opciones de Internet.</li><li>Haz clic en la ficha General.</li><li>En la sección «Historial de exploración», haz clic en Eliminar el historial de exploración al salir.</li><li>Seleccionar Eliminar archivos.</li><li>Seleccionar Eliminar cookies.</li><li>Haz clic en Eliminar.</li><li>Haz clic en Aceptar.</li><li>Cierra y reinicia el navegador.</li></ol><p style='font-weight:bold;'>Para más información sobre Internet Explorer pulse <a href='http://windows.microsoft.com/es-419/windows7/how-to-manage-cookies-in-internet-explorer-9'>aquí</a>.</p><br>","cookies-8txt3":"<p><b><u>Firefox. Versión 18</b></u></p><ol><li>Selecciona Firefox | Historial | Limpiar el historial reciente.</li><li>Al lado de «Detalles», haz clic en la flecha hacia abajo.</li><li>Selecciona las siguientes casillas de verificación: Cookies, Caché, Inicios de sesión activos</li><li>Usando el «Intervalo de tiempo para borrar» en el menú desplegable, selecciona Todo.</li><li>Haz clic en Borrar ahora.</li><li>Cierra y reinicia el navegador. Puede aceptar o rechazar las cookies individualmente en las Preferencias de Firefox, en la sección Historial disponible en Herramientas > Opciones > Privacidad.</li></ol><p style='font-weight:bold;'>Para más información sobre Mozilla Firefox pulse <a href='https://www.mozilla.org/es-ES/privacy/websites/#cookies'>aquí</a>.</p><br>","cookies-8txt4":"<p><b><u>Safari Versión 5.1</b></u></p><ol><li>Selecciona el icono de Safari / Editar | Restaurar Safari.</li><li>Selecciona las siguientes casillas de verificación: Borrar el historial, Eliminar todos los datos de sitio web.</li><li>Haz clic en Restablecer.</li><li>Cierra y reinicia el navegador.</li></ol><p style='font-weight:bold;'>Para más información sobre Safari pulse <a href='http://support.apple.com/kb/PH5042'>aquí</a>.</p><br>","cookies-8txt5":"<p><b><u>Opera</b></u></p><ol><li>Opciones – Avanzado – Cookies. Las opciones de cookies controlan el modo en que Opera los maneja y por lo tanto su aceptación o rechazo.</li></ol><p style='font-weight:bold;'>Para más información sobre Ópera pulse <a href='http://help.opera.com/Linux/10.60/es-ES/cookies.html'>aquí</a>.</p><br><p><b><u>Otros navegadores</b></u>: Consulte la documentación del navegador que tenga instalado.</p><br>","cookies-9":"<h4>9. INFORMACIÓN SOBRE LAS TRANSFERENCIAS DE DATOS A TERCEROS PAÍSES REALIZADAS POR OPENHEALTHCARE:</h4><br>","cookies-9txt":"<p>OPENHEALTHCARE no realiza transferencias internacionales a terceros países.<br>En el caso de terceros, puedes informarte de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies en sus correspondientes políticas (ver link política cookies de terceros en la tabla).</p><br>","cookies-10":"<h4>10. ELABORACIÓN DE PERFILES </h4><br>","cookies-10txt":"<p>OPENHEALTHCARE no realiza elaboración de perfiles.</p><br>","cookies-11":"<h4>11. EN RELACIÓN CON EL RESTO DE INFORMACIÓN EXIGIDA POR EL ARTÍCULO 13 DEL RGPD</h4><br>","cookies-11txt":"<p>Les remitimos a la <a href='/Home/politica-privacidad'>Política de Privacidad de OPENHEALTHCARE</a>.</p><br>"}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = {"healthyCommunityTitle":"Comunidade saudável","forumSectionDescription":"Comente suas dúvidas, peça conselhos ou compartilhe suas experiências com outros pacientes","forumTitle":"Pacientes como você","newPostTitle":"Nova entrada {0}","enterPostTitle":"Insira um título para a entrada","createNewPost":"Criar nova entrada","getPostNotifications":"Envie-me notificações de resposta na postagem","commentaries":"Comentários","share":"Compartilhar","save":"Salvar","articleSavedCorrectly":"Artigo salvo com sucesso","createNewEntry":"Criar nova entrada","controlPanel":"Painel de controle","publishedBy":"Publicado por","accessBtn":"Acessar","postPublishedCorrectly":"Postagem publicada com sucesso","selectImageForEntry":"Selecione um arquivo para entrada (opcional)","emptyMessageError":"Você deve escrever uma mensagem","messagePublishedCorrectly":"Mensagem postada com sucesso","emptyTitleError":"Você deve escrever um título para a entrada","emptyForumContentError":"Você deve inserir um conteúdo para a entrada","showMoreReplies":"veja mais respostas","moreReplies":"responde mais","hideMessages":"ocultar mensagens","moreReply":"responda mais","showMoreEntries":"ver mais entradas","userAlias":"aliases de usuário","entries":"Ingressos","messages":"Mensagens","emptyForumTagError":"Você deve selecionar uma categoria para a entrada","mustEnterEntryCategory":"Você deve selecionar uma categoria para a entrada","noEntriesSaved":"Você não tem entradas salvas","noMessagesSaved":"Você não tem mensagens salvas","messagePendingValidation":"Sua mensagem foi publicada com sucesso. \nEle ficará visível assim que for validado.","validations":"Validações","validate":"Validar","noMessagesPendingValidation":"Não há mensagens com validação pendente","myNotifications":"Minhas notificações","reject":"Declínio","getNotificactionsOf":"Receba notificações de:","answersOfFavouritesMessages":"Respostas de mensagens salvas","answersOfFavouritesEntries":"Respostas de postagem salvas","newEntries":"Novos Posts Postados","fieldEmpty":"Não pode haver campos vazios no formulário","messagesReply":"Respostas às minhas mensagens","emptyEntries":"Não há entradas publicadas para esta seção","emptyEntriesSearch":"Não há resultado para sua pesquisa.","expirationDate":"Data de validade","dateMustBeGreaterThanNow":"A data de expiração deve ser maior que a data atual","proposeNewPost":"Fazer Nova Postagem","postPublishedCorrectlyPending":"Sua entrada foi enviada com sucesso. \nNossa equipe revisará e avaliará sua publicação","messagePublishedSuccessfully":"Mensagem postada com sucesso","searchPlaceholder":"Pesquise por categoria, título ou descrição","noEntriesPendingValidation":"Não há entradas pendentes de validação","shareInSocialMedia":"Compartilhe em suas redes sociais","link":"Link","3monthsDefault":"(3 meses por padrão)","mustEnterEntryTags":"Selecione um ou mais rótulos para a entrada (opcional)","noTagsAvailables":"Nenhuma tag encontrada para sua pesquisa","entryCategoryNotSelected":"Você deve selecionar uma categoria para a entrada","like":"Eu gosto","moreRecent":"Mais recente","featured":"Destaque","sharingSocialsTitle":"Eu recomendo esta entrada {0} ","sharingSocialsDescription":"Através deste link você pode acessar a publicação","searcher":"Buscador","noResults":"Sem resultados","categories":"Categorias","tags":"Tag","forumHeaderText":"Comente suas dúvidas, peça conselhos ou compartilhe suas experiências com outros pacientes.","enterOrSearchDiseases":"Selecione ou insira uma doença para entrada","mustSelectDisease":"Você deve selecionar ou inserir uma doença para a entrada","diseasesForum":"Doenças","specialistIn":"Especialista em","healthyInformation":"Informação saudável","whoIn":"Quem está dentro?","consultationIn":"consulta em","mustEnterEntrySection":"Selecione uma seção para a entrada","entrySectionNotSelected":"Você deve selecionar uma seção para a entrada","infoNick":"Neste campo você pode modificar o nome de usuário que ficará visível para o resto dos usuários da plataforma","infoEmail":"Neste campo você pode modificar o e-mail de notificação da plataforma","patientsLikeYou":"Pacientes como você","whoInSectionDescription":"Organize planos saudáveis ​​com seus colegas","healthyInformationSectionDescription":"Fique por dentro das novidades sobre saúde e bem-estar","removePostAdvice":"Deseja excluir esta entrada?","healthyCommunityHeaderText":"Organize planos e compartilhe experiências e informações de saúde e bem-estar com seus colegas!","noPendingPushNotifications":"Você não tem notificações pendentes","notifications":"Notificações","removePushNotifications":"Deseja limpar seu histórico de notificações?","newPushNotifications":"Você tem {numberNotifications} mensagem não lida{plural}/entrada{plural}","favourite":"Favorito","saveds":"Salvou","removeHistory":"limpar notificações","settingNotifications":"configurar notificações","panelEntryTags":"Selecione uma ou mais tags","panelEntryCategory":"Selecione uma ou mais categorias","mustSelectCategory":"Você deve selecionar pelo menos uma categoria","mustSelectTags":"Você deve selecionar pelo menos uma tag","notReceiveEmails":"Não receba e-mails","receiveEmails":"Receber e-mails","in":"em","selectImage":"Selecione uma imagem (opcional)","newPostDescription":"Descrição da entrada","whoInNewPostDescription":"Esporte/atividade, data, hora, número de pessoas, localização, etc...","firstAccessForum":"Para se manter informado sobre o conteúdo que você salva e configurar suas notificações, não se esqueça de ativar as notificações em seu \"Painel de Controle\", localizado clicando em suas iniciais no canto superior direito.","welcomeTo":"Bem-vindo a {0}","healthyCommunityFirstAccessTitle":"a comunidade saudável","whoInNewPost":"<p>Atividade: {activityName}</p><p>Nível: {activityLevelName}</p><p>Data: {date}</p><p>Hora de início: {startHour}</p>< p>Hora de término: {endHour}</p><p>Local: {address}, {stateName}, {cityName}, {countryName}</p><p>Comentários: {commentaries}</p>","removeMessageAdvice":"Deseja excluir esta mensagem?","messageDeleted":"mensagem apagada","goOpenhealth":"Ir para Opensalud360","edited":"editado","loginFromArticle":"Se você quiser ver os comentários e participar desta entrada, você deve fazer login clicando aqui:","panelEmailInterval":"Selecione o intervalo de notificação","eachDay":"Cada dia","eachWeek":"Cada semana","eachMonth":"Cada mês","mustSelectEmailsInterval":"Você deve selecionar um intervalo de notificação para e-mails","lastMessage":"Última mensagem","lastInteraction":"última interação","companiesAccessRestrictedMessage":"O código da sua empresa restringiu o acesso à comunidade saudável, por isso será redirecionado para pacientes como você","forbiddenMinorUser":"O acesso é restrito a pacientes menores de idade.","reportMessage":"Relatório","reportMessageTitle":"Indique o motivo da denúncia:","reportmessageSendConfirmation":"O relatório foi enviado com sucesso.","mustIntroduceReportReasons":"Você deve inserir o motivo do relatório","reports":"Relatórios","noMessagesReported":"Nenhuma mensagem relatada","noRemove":"Não apague","firstAccessNickForum":"Você pode então definir o nome que aparecerá em suas postagens. \nVocê pode simplesmente inserir iniciais, um apelido... Lembre-se que este nome é visível para outros usuários registrados.","firstAccessFooterForum":"Lembramos que não é possível enviar mensagens privadas entre usuários através da plataforma.","emptyNick":"Você deve inserir o nome que aparecerá em suas publicações","monthlyAccessAdvice":"Sua experiência pode ajudar outros usuários! \nLembre-se de que seu perfil é anônimo e ninguém pode contatá-lo diretamente.","infoName":"Nome de registro","selectActivity":"Selecione uma atividade","selectActivityLevel":"Selecione um nível","selectState":"Selecione uma província","selectCountry":"Selecione um país","selectCity":"Selecione um município","activityTitle":"Insira um título para a atividade","newActivity":"Nova atividade","insertActivityName":"Digite o nome da atividade","otherActivity":"Outra atividade...","activityDuration":"Duração (em minutos)","startHour":"Hora de início","endHour":"Hora de término","level":"Nível","activity":"Atividade","hourEndGreaterThanStart":"A hora de início deve ser menor que a hora de término","mustSelectActivity":"Você deve selecionar uma atividade","mustSelectActivityLevel":"Você deve selecionar um nível","mustSelectState":"Você deve selecionar uma província","mustSelectCity":"Você deve selecionar um município","mustSelectAddress":"Você deve inserir um endereço","mustInsertOtherActivity":"Você deve inserir o nome da atividade","dateEndGreaterThanStart":"A data de início deve ser inferior à data de término","dateEndGreaterThanToday":"A data de término deve ser posterior à data atual","dateStartGreaterThanToday":"A data de início deve ser posterior à atual","proposeNewActivity":"Propor nova atividade","participantsLimit":"Limite de participantes","participantsLimitGreaterThan2":"O número de participantes deve ser superior a 2","whoInDataTitles":{"activity":"Atividade","activityLevel":"Nível","country":"País","state":"Província","city":"Município","endDate":"Fim","commentaries":"Comentários","address":"Endereço","otherActivity":"Atividade","participants":"Participantes"},"signUpWhoIn":"Eu me inscrevo","noAssistWhoInActivity":"Não compareça","activityUpdatedCorrectly":"A atividade foi atualizada","participantsLimitLowerThenCurrentParticipants":"O limite de participantes deve ser maior que os participantes atuais ({participantes})","searchWhoInPlaceholder":"Procure uma atividade","timeOfDay":{"morning":"Manhã (6h00-12h00)","night":"Noite (18h00-24h00)"},"participantsLimitsReached":"O número máximo de participantes para esta atividade foi atingido","noActivitiesToSearch":"Não há atividades disponíveis neste momento","emptyActivitiesSearch":"Nenhuma atividade foi encontrada para sua pesquisa.","resetFilters":"Remover filtros","endDateNotSelected":"Se você selecionar o horário final, deve selecionar a data de término da atividade","startDateNotSelected":"Se você selecionar a hora de início, deve selecionar a data de início da atividade","only-subscriptors-warning":"Este conteúdo é apenas para assinantes.","only-subscriptors":"Apenas assinantes","showMoreDetails":"Veja mais detalhes","comment":"Comentário","showDetails":"Veja detalhes","hideDetails":"Ocultar detalhes"}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = {"healthyHabitsTitle":"Meus objetivos e desafios","of":"de","doubleClickChangeValue":"Clique duas vezes em um valor para alterá-lo","enterNewValue":"Insira um valor","tableInfoTitle":"Informações sobre a mesa","tableInfo":"- Para modificar as suas medidas ou introduzir novos valores, pode fazê-lo diretamente na tabela, clicando no valor correspondente.","tableInfo2":"- Se quiser fazer alterações nas configurações da lente, clique no lápis que aparece à esquerda de sua descrição.","enterValidNumber":"Por favor insira um número válido","noDataFound":"Nenhum resultado encontrado para a sua pesquisa","clear":"Limpar","week":"Semana","total":"Total","historyTitle":"Registro","to":"para","weeks":"Semanas","monthsTitle":"Meses","yearsTitle":"Anos","frequency":"Frequência","day":"Dia","daily":"Diário","each":"Cada","weekly":"Semanalmente","monthly":"Por mês","timesToWeek":"vezes por semana","timesToMonth":"Vezes por mês","selectAnOption":"Selecione uma opção","selectAnHour":"Selecione um horário","checkInvalidFormData":"Verifique os campos marcados em vermelho","mustSelectOption":"Você deve selecionar uma opção","mustEnterValidNumber":"Você deve inserir um número válido","valuesBetween":"valores entre","notmeasurable":"Não quantificável","measurable":"Quantificável","measurableExamples":"(passos, quilos...)","notMeasurableExamples":"(Sim/Não)","selectHabitType":"Selecione uma meta:","hideCompletedHabits":"esconder concluído","clickChangeValue":"Clique em um valor para alterá-lo","newHabit":"Novo objetivo","currentStreak":"Raia atual","bestStreak":"Melhor sequê","totalWeek":"semana total","totalMonth":"Mês total","totalYear":"Ano total","add":"Adicionar","mustInsertValue":"Você deve inserir um valor válido","extra":"extra","tableInfo3":"- Você pode visualizar seu progresso com gráficos detalhados por intervalos de tempo clicando no ícone do gráfico.","firstNewHabit":"Adicione seu primeiro objetivo!","tableInfo4":"- Para excluir um alvo ou marcá-lo como arquivado, toque na lixeira e selecione a ação apropriada.","maxhealthyHabitsReached":"O número máximo de destinos simultâneos é 10. Se desejar adicionar um novo destino, você deverá excluir ou arquivar o atual.","reminderDays":"dias de lembrete","selectOneMoreOption":"Selecione uma ou mais opções","mustSelectColor":"Você deve selecionar uma cor","whatWantToDo":"O que você gostaria de fazer?","showStoredHabits":"Mostrar metas arquivadas","insertValidPhone":"Por favor insira um número de telefone válido","insertValidEmail":"Entre com um email válido","allowFreeDays":"permitir dias de folga","allowFreeDaysAdvice":"Ao desativar esta opção, seus dias de folga serão tratados como dias não concluídos.<br><br>Deseja continuar?","atHour":"no","off":"Desligado","tableInfo6":"- Se quiser classificar os alvos, mantenha pressionado e arraste o alvo para a nova posição.","store":"arquivo","remove":"Eliminar","notificationsPhoneTooltip":"Telefone de notificação (Caso não queira receber notificações pelo WhatsApp, deixe este campo em branco)","mustEnterValidInteger":"Você deve inserir um número inteiro","percentage":"Percentagem","weekShort":"Sem","totalWeekShort":"Sem total","summary":"Resumo","remaining":"Restante","showGoalCompletedHabits":"Mostrar objetivos concluídos","congratulations":"Parabéns!","goalCompletedText":"Você completou sua meta 100%. \nLembre-se que você pode mostrar suas metas concluídas na tabela habilitando a opção “Mostrar metas concluídas” em suas configurações.","tableInfo7":"- Você pode modificar a configuração da tabela e outros valores, como notificações por e-mail/telefone, clicando em \"Configurações\".","nameFormPlaceholder":"Descrição (Ex. Caminhada)","questionFormPlaceholder":"Pergunta (por exemplo, eu já caminhei hoje?)","UnitFormPlaceholder":"Unidade (por exemplo, páginas)","nameFormMeasurablePlaceholder":"Descrição (Ex. Ler)","questionFormMeasurablePlaceholder":"Pergunta (Ex. Quantas páginas eu li?)","goalFormPlaceholder":"Objetivo (Ex. 15)","showMore":"ver mais","showMoreAdvice":"Clique nas setas laterais para ver mais estatísticas","invertCalendarDays":"Dias corridos de ordem inversa","newChallenge":"Novo desafio","firstNewChallenge":"Adicione seu primeiro desafio saudável!","reset":"Restaurar","predefined-walk-question":"Quanto eu andei?","predefined-walk":"Andar","predefined-run":"Correr","predefined-run-question":"Quantos quilômetros eu corri hoje?","predefined-bike":"Bicicleta","predefined-bike-question":"Quantos quilômetros eu fiz esta semana?","predefined-swim":"Nadar","predefined-swim-question":"Eu nadei?","predefined-lose-weight":"Perder peso","predefined-lose-weight-question":"Quanto peso perdi esta semana?","predefined-smoke":"Deixar de fumar","predefined-smoke-question":"Já parei de fumar hoje?","predefined-sleep-better":"Horário de sono","predefined-sleep-better-question":"Tenho dormido melhor?","predefined-week-exercise":"Exercício semanal","predefined-week-exercise-question":"Eu me exercitei?","predefined-drink-alcohol":"Consumo de álcool","predefined-meditation":"Meditar","predefined-meditation-question":"Fiz meditação?","predefined-go-gym":"Ir ao ginásio","predefined-go-gym-question":"Eu fui para a academia?","predefined-drink-alcohol-question":"Parei de consumir álcool?","predefined-read":"Ler","predefined-read-question":"Quantas páginas li hoje?","createOwnHabit":"Ou crie seu próprio objetivo:","pagesHabit":"Páginas","doubts":"duvidas","faq-table":"Tabela","question-table-1":"Como posso adicionar novos objetivos?","answer-table-1":"Existem duas maneiras de adicionar novos objetivos:<br><br>1) Selecionando um objetivo pré-definido: que aparecerá acima da tabela caso você ainda não tenha cadastrado nenhum objetivo ou na janela destinada a adicionar novos objetivos.<br>2 ) Criando uma meta personalizada: Você pode criá-las clicando no botão “Nova meta” da tabela e configurá-la como desejar.","question-table-2":"Posso editar uma meta criada?","answer-table-2":"Sim. Você pode editar qualquer meta criada clicando no lápis que aparece à esquerda da descrição.","question-table-3":"Como posso ver as estatísticas de um alvo?","answer-table-3":"Para visualizar as estatísticas de uma meta, você pode clicar no gráfico de barras que aparece à esquerda da descrição da meta.","question-table-4":"Posso excluir ou arquivar uma meta já criada?","answer-table-4":"Claro. \nPara excluir ou arquivar uma meta, você deve clicar no botão da lixeira que aparece à esquerda da meta. \nLá você será questionado sobre qual ação deseja executar.","question-table-5":"Como posso ver os dias anteriores da semana?","answer-table-5":"Para ver mais dias na tabela, você pode clicar na seta que aparece no topo da tabela. \nSe você estiver no celular, também pode deslizar na direção em que deseja ver mais datas.","question-table-6":"O que significa a barra abaixo da descrição do objetivo?","answer-table-6":"Esta barra mede a porcentagem do <b>progresso atual</b> da meta.<br>Por exemplo, para uma meta não quantificável, se for definida para 3 dias por semana, será 100% concluída se estiver em na semana atual foram marcados pelo menos 3 dias.<br>Para uma meta definida mensalmente e quantificável, será marcado 100% quando a meta definida no mês atual for superada.","answer-table-7":"Para metas quantificáveis, um valor aparecerá junto com a unidade de medida que você definiu.<br><br>Para metas não quantificáveis, existem três tipos de símbolos:<br><br><b>Marque:</ b > Indica que o objetivo foi concluído naquele dia.<br><b>Script:</b> Indica que aquele dia foi marcado como gratuito.<br><b>X:</b> Indica que aquele dia a meta não foi concluída.<br><br>Por padrão, os dias de folga estão habilitados, mas você pode desativá-los clicando no botão de configurações na parte superior da tela.","question-table-7":"O que significam os símbolos abaixo de cada data?","question-table-8":"Como posso marcar um dia como concluído ou inserir um valor?","answer-table-8":"Para marcar um dia como concluído ou mudar entre os diferentes estados (não concluído ou dia de folga), você deve clicar no símbolo que aparece abaixo de cada data.<br><br> No caso de objetivos quantificáveis, você pode inserir um determinado valor.","question-table-9":"O que indicam as três últimas colunas da tabela?","answer-table-9":"Existem 3 grupos diferentes de 3 colunas cada, que refletem diferentes estatísticas básicas do objetivo.<br><br>Primeiro grupo:<br><br><b>Sequência atual:</b> Indica o número de dias consecutivos você completou a meta a partir da data atual. \nSe algum dia for marcado como livre nessa sequência, ele não será contado e, portanto, não quebrará a sequência.<br><b>Melhor sequência:</b> indica a sequência mais longa de dias consecutivos concluídos ao longo do objetivo.<br><b>Total:</b> Mostra o número total de dias em que quaisquer dados objetivos foram preenchidos.<br><br>Segundo grupo:<br><br>Mostra a soma semanal/mensal/anual dos objetivos preenchidos nesses intervalos de tempo.<br><br>Terceiro grupo:<br><br>Indica as porcentagens de dias semanais/mensais/anuais em que alguns dados foram preenchidos.<br> <br>Você pode alterne os diferentes blocos clicando em 'ver mais' abaixo deles ou nas setas.","answer-table-10":"Os dados semitransparentes exibidos na tabela indicam que a meta foi concluída naquele período.<br><br>Por exemplo, se uma meta for concluída a cada 3 dias e você marcar o dia atual como concluído, os próximos 2 dias serão concluídos. os dias serão semicompletos. \nVocê também pode marcar esses dias como concluídos, mas não é necessário.","question-table-10":"Por que os dados semitransparentes aparecem coloridos?","faq-config":"Contexto","answer-config-1":"Ao clicar no botão de configuração que aparece no canto superior direito você pode configurar os seguintes elementos:<br><br><b>Mostrar objetivos arquivados:</b> Permite mostrar/ocultar os objetivos arquivados na tabela. <br ><b>Mostrar metas concluídas:</b> permite mostrar/ocultar metas concluídas na tabela.<br><b>Permitir dias de folga:</b> permite marcar dias como livres e não contagem em direção às listras.<br><b>Inverter ordem dos dias do calendário</b>: alterna a ordem em que os dias são exibidos no calendário, ou seja, diminuindo para a direita ou para a esquerda.<br><b>E-mail:</b> Você pode definir o e-mail no qual receberá notificações dos lembretes definidos.<br><b>Telefone:</b> Você pode definir o telefone no qual receberá notificações dos lembretes que você configura.","faq-statistics":"Estatisticas","question-table-11":"Quando uma meta é concluída?","answer-table-11":"Para determinar se uma meta foi cumprida, é utilizado um algoritmo de suavização exponencial, no qual a média ponderada é calculada desde o primeiro dia da meta até o dia atual, dando mais peso aos dias atuais.<br><br> Para por exemplo, para uma meta diária, 80% seria alcançado no primeiro mês, 96% após dois meses e 100% após 100 dias.","question-statistics-1":"Quais informações aparecem no topo?","answer-statistics-1":"Os seguintes dados aparecem na parte superior:<br><br>- A pergunta que você definiu ao criar o formulário.<br>- O intervalo de repetição da meta<br>- O lembrete, se você o tiver definido ao criar a meta .","question-statistics-2":"O que a seção Objetivo indica?","answer-statistics-2":"Esta seção está disponível apenas para metas mensuráveis ​​e indica a soma semanal/mensal/anual dos valores definidos nesses intervalos.","question-statistics-3":"Qual é o calendário?","answer-statistics-3":"O calendário mostra as mesmas informações que você pode ver na tabela, mas dentro de um intervalo de 4 meses a partir da data de hoje.<br>Você pode interagir com o calendário da mesma forma que com a tabela.","question-statistics-4":"Que informações são mostradas nas tabelas de estatísticas?","answer-statistics-4":"Existem três tabelas estatísticas:<br><br><b>Pontuação:</b> reflete a pontuação calculada pelo algoritmo de suavização exponencial. \nVocê pode visualizar as pontuações agrupadas por dias/semanas/meses/anos.<br><br><b>Histórico:</b> Mostra a soma dos valores registrados para a meta em intervalos de semana/mês/ano. <br ><br><b>Frequência:</b> Indica a frequência com que os dias de cada mês foram concluídos no último ano. \nVocê pode ver os valores agrupados nesse intervalo clicando no círculo.","tableInfo8-1":"- Para mais informações, você pode acessar a seção de perguntas frequentes fazendo","tableInfo8-2":"Clique aqui.","question-config-1":"O que posso configurar?","question-table-12":"O que indica o troféu que aparece no topo da tela?","answer-table-12":"Mostra a melhor sequência alcançada, tendo em conta todos os seus objetivos.","mustInsertPositiveValue":"Você deve inserir um valor positivo","dailyShort":"Diário","weeklyShort":"Semanalmente","calendarInfo":"Você pode interagir com o calendário da mesma forma que com a tabela de metas principais. \nDessa forma, você pode adicionar novos dados clicando em uma data do calendário.","monthlyShort":"Por mês","showLess":"veja menos","lessRecent":"menos recente","moreRecentHabit":"mais recente","freeDay":"Dia livre","healthyHabitsTable":"Tabela","partialCompleted":"Parcialmente completo","uncompleted":"Não completo","nonMeasurable":"Não quantificável","measurableInfo":"- Preenchido: Se o valor for preenchido com a cor selecionada para o alvo.","measurableInfo2":"- Parcialmente concluído: Se o valor for semitransparente.","tableInfo8":"- Para mais informações sobre os símbolos da tabela, clique","healthyHabitsGeneral":"Em geral","stadistics":"Estatisticas","removeOrStore":"Excluir ou arquivar","restore":"Restaurar","stored":"Arquivado","progressBar":"Barra de progresso atual","legend":"Lenda","completedDay":"dia concluído","calendarLegendColorInfo":"A cor de preenchimento dos dias corridos dependerá da cor selecionada na criação do objetivo.","notCompletedDay":"dia não concluído","filled":"Valor inserido","predefined-drink-water":"Beber água","predefined-drink-water-question":"Quantos litros eu bebi?","liters":"litros","meters":"metros","typeUserNames":"Digite o nome dos usuários","typeUserEmails":"Insira os e-mails dos pacientes","typePatientEmailAdvice":"Escreva o e-mail do paciente para desafiar e pressione enter","checkInvalidMultiUserEmail":"Verifique se os e-mails/números de telefone do paciente inseridos estão corretos","multiUserUncompleted":"Você não completou o objetivo neste dia.","multiUserCompleted":"Você completou o objetivo neste dia.","multiUserDayFree":"marcou o dia como livre.","multiUserMeasurableCompleted":"você completou o objetivo hoje com {value} {unit}.","multiUserMeasurablePartialCompleted":"Você completou parcialmente a meta neste dia com {value} {unit} de {goal} {unit}.","invitePatientsMultiUser":"Convide os usuários para completar a meta","typeUserEmailsOrPhones":"Insira os e-mails/números de telefone dos usuários registrados","typePatientEmailOrPhoneAdvice":"Escreva o e-mail/número de telefone do usuário registrado e pressione enter","multiUserInviteLimitExceeded":"O número máximo de convites é 9","inviteMultiUserInfo":"Você pode convidar outros usuários cadastrados na plataforma para verem juntos os resultados de cada um da sua tabela. \nLembre-se que os usuários convidados devem estar cadastrados com o e-mail/telefone para o qual você envia o convite.","multiUserPartialCompleted":"Você completou parcialmente o objetivo neste dia.","professionalNotAllowed":"Atualmente você só pode acessar as metas através do histórico médico de seus pacientes, onde poderá adicionar novas metas a eles.","predefined-more-time-in-family-question":"Você tem passado mais tempo com sua família?","predefined-more-time-in-family":"Tempo para a família","predefined-ultra-processed-foods":"Alimentos ultraprocessados","predefined-ultra-processed-foods-question":"Você tem consumido menos alimentos ultraprocessados?","predefined-argue-less":"Discuta menos","predefined-argue-less-question":"Você tem discutido menos?","whoInDataTitles":{"startDate":"Começar"},"timeOfDay":{"afternoon":"Tarde (12h00-18h00)"}}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = {"legal-title":"<div class='type-intro-title'>Aviso Legal</div><br/>","legal-intro":"<p>OPENHEALTHCARE S.L., sociedad española responsable del sitio www.openhealthcare.es, en adelante RESPONSABLE, pone a disposición de los usuarios el presente documento, con el que pretende dar cumplimiento a las obligaciones dispuestas en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSICE), así como informar a todos los usuarios del sitio web respecto a cuáles son las condiciones de uso.</p><br><p>Toda persona que acceda a este sitio web asume el papel de usuario, comprometiéndose a la observancia y cumplimiento riguroso de las disposiciones aquí dispuestas, así como a cualquier otra disposición legal que fuera de aplicación.</p><br><p>OPENHEALTHCARE S.L., se reserva el derecho de modificar cualquier tipo de información que pudiera aparecer en el sitio web, sin que exista obligación de preavisar o poner en conocimiento de los usuarios dichas obligaciones, entendiéndose como suficiente con la publicación en este sitio web.</p><br>","legal-1":"<h4>1. DATOS IDENTIFICATIVOS</h4><br>","legal-1txt":"<p>Nombre de dominio: www.openhealthcare.es</p><p>Denominación social: OPENHEALTHCARE S.L</p><p>CIF: B90209081</p><p>Dir. Postal: Avda. República Argentina 25 9ª planta, 41011 Sevilla</p><p>Teléfono: +34 656 383 230</p><p>Email: info@openhealthcare.eu</p><p>Inscrita en el Registro Mercantil de Sevilla en el tomo 6043, folio 101 inscripción 1 con hoja SE-105834</p><br>","legal-2":"<h4>2. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL</h4><br>","legal-2txt":"<p>El sitio web, incluyendo a título enunciativo pero no limitativo su programación, edición, compilación y demás elementos necesarios para su funcionamiento, los diseños, logotipos, texto y/o gráficos, son propiedad del RESPONSABLE o, si es el caso, dispone de licencia o autorización expresa por parte de los autores. Todos los contenidos del sitio web se encuentran debidamente protegidos por la normativa de propiedad intelectual e industrial, así como inscritos en los registros públicos correspondientes. Independientemente de la finalidad para la que fueran destinados, la reproducción total o parcial, uso, explotación, distribución y comercialización, requiere en todo caso de la autorización escrita previa por parte del RESPONSABLE. Cualquier uso no autorizado previamente se considera un incumplimiento grave de los derechos de propiedad intelectual o industrial del autor.</p><br>","legal-3":"<h4>3. EXENCIÓN DE RESPONSABILIDADES</h4><br>","legal-3txt":"<p>El RESPONSABLE se exime de cualquier tipo de responsabilidad derivada de la información publicada en su sitio web siempre que esta información haya sido manipulada o introducida por un tercero ajeno al mismo.</p><br>","legal-4":"<h4>4. POLÍTICA DE ENLACES</h4><br>","legal-4txt":"<p>Desde el sitio web, es posible que se redirija a contenidos de terceros sitios web. Dado que el RESPONSABLE no puede controlar siempre los contenidos introducidos por los terceros en sus respectivos sitios web, no asume ningún tipo de responsabilidad respecto a dichos contenidos. En todo caso, procederá a la retirada inmediata de cualquier contenido que pudiera contravenir la legislación nacional o internacional, la moral o el orden público, procediendo a la retirada inmediata de la redirección a dicho sitio web, poniendo en conocimiento de las autoridades competentes el contenido en cuestión.</p><br><p>El RESPONSABLE no se hace responsable de la información y contenidos almacenados, a título enunciativo pero no limitativo, en foros, chats, generadores de blogs, comentarios, redes sociales o cualquier otro medio que permita a terceros publicar contenidos de forma independiente en la página web del RESPONSABLE. Sin embargo, y en cumplimiento de lo dispuesto en los artículos 11 y 16 de la LSSICE, se pone a disposición de todos los usuarios, autoridades y fuerzas de seguridad, colaborando de forma activa en la retirada o, en su caso, bloqueo de todos aquellos contenidos que puedan afectar o contravenir la legislación nacional o internacional, los derechos de terceros o la moral y el orden público. En caso de que el usuario considere que existe en el sitio web algún contenido que pudiera ser susceptible de esta clasificación, se ruega lo notifique de forma inmediata al administrador del sitio web.</p><br><p>Este sitio web ha sido revisado y probado para que funcione correctamente. En principio, puede garantizarse el correcto funcionamiento los 365 días del año, 24 horas al día. Sin embargo, el RESPONSABLE no descarta la posibilidad de que existan ciertos errores de programación, o que acontezcan causas de fuerza mayor, catástrofes naturales, huelgas o circunstancias semejantes que hagan imposible el acceso a la página web.</p><br>","legal-5":"<h4>5.DIRECCIONES IP</h4><br>","legal-5txt":"<p>Los servidores del sitio web podrán detectar de manera automática la dirección IP y el nombre de dominio utilizados por el usuario. Una dirección IP es un número asignado automáticamente a un ordenador cuando éste se conecta a Internet. Toda esta información es registrada en un fichero de actividad del servidor debidamente inscrito que permite el posterior procesamiento de los datos con el fin de obtener mediciones únicamente estadísticas que permitan conocer el número de impresiones de páginas, el número de visitas realizadas a los servidores web, el orden de visitas, el punto de acceso, etc.</p><br>","legal-6":"<h4>6. LEY APLICABLE Y JURISDICCIÓN</h4><br>","legal-6txt":"<p>Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los Juzgados y Tribunales de Sevilla.</p><br>","legal-7":"<h4>7. Reivindicações</h4>","legal-7txt":"<p>Se você deseja registrar uma reclamação contra o OPENHEALTHCARE S.L. \nVocê pode fazer isso no e -mail quejas@opensalud.es</p>"}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más información","learn-more-btn":"Ler mais","upper-header-subtitle":"Promove a capacidade de concentração, combate o estresse, a ansiedade, aumenta a autoestima, melhora a qualidade do sono e muito mais.","header-title":"Aulas e sessões de meditação, yoga mindfulness, pilates e sono","subtitle-list-1":"Acceso ilimitado a consulta médica y pediátrica online.","subtitle-list-2":"Plataforma integral de salud y bienestar incluida.","subtitle-list-3":"Acceso premium a servicios de salud privados.","hire-now":"Contratar ahora","hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños","price-cards":{"title":"Consultas online incluidas","subtitle":"Sin coste adicional los mejores especialistas los 7 días de la semana.","content":"Los mejores servicios clínicos de más de 25.000 profesionales y centros, con un precio muy reducido.","subcontent":"Gimnasio online, meditación, programas de salud y mucho más.","monthly":"Mensual**","per-family":"por familia*","hire":"Contratar","family-label":"*Familia: Cónyuge/pareja e hijos menores de edad.","monthly-label":"**Compromiso de permanencia  mínimo de 3 meses.","medic-services-discount":"Descuento en servicios médicos","wellness-services":"Servicios de bienestar","medic-services":"Servicios médicos","tooth-services":"Servicios dentales","pediatry-services":"Servicios de pediatría","dermatology-services":"Servicios de dermatología","traumatology-services":"Servicios de traumatología","endocrinology-services":"Servicios de endocrinología","permanency":"Compromiso de permanencia de 3 meses","family":"Familia: Cónyuge/pareja e hijos menores de edad","soon":"Próximamente","table":{"title":"Nuestros planes","subtitle":"Tenemos planes ajustados a todas las necesidades familiares","wellness":"Plataforma de bienestar y salud","service-discounts":"Descuentos en servicios médicos privados","online-family-medic":"Médico de familia online","online-pediatrics":"Pediatría online","online-dermatology":"Dermatología online","online-traumatology":"Traumatología online","online-endocrinology":"Endocrinología online","title1":"El plan mas completo con todas nuestras especialidades","per-month":"por mes*","header":"Opción más popular","title2":"La tranquilidad de tener a un médico general y un pediatra disponible los 7 días de la semana","title3":"Disfruta de servicios clínicos privados con descuentos y accede a nuestra plataforma de salud y bienestar"}},"cards":{"1":{"title":"Los mejores","subtitle":"Cuida tu salud y la de los tuyos con los mejores médicos y la mejor tecnología disponible"},"2":{"title":"Precio a tu medida","subtitle":"Planes accesibles con la mayor calidad y tranquilidad en nuestros servicios de telemedicina"},"3":{"title":"Cuadro médico","subtitle":"Tendrás un extenso cuadro de especialistas, clínicas y centros médicos para asegurarte la mejor atención médica"},"title":"Consulta online a los mejores profesionales de medicina general y pediatría"},"medical-assistance":{"title":"Asistencia médica online","subtitle":"Disponible los 365 días del año con libre elección de médico de familia y pediatra por video, teléfono o chat con receta electrónica, agenda de salud, historia clínica, recordatorios…","content":"Incluye dos adultos y dos niños con consultas ilimitadas todos los días del año.","available-consultations":"Tipos de consulta disponibles:","video":"Videoconsulta","phone-attention":"Atención telefónica","written-consultation":"Consulta escrita","chat":"Chat","electronic-prescription":"Receta electrónica","safe-coms":"La seguridad de las comunicaciones y la privacidad de los datos son nuestra prioridad."},"discounts":{"title":"Descuentos en servicios clínicos privados","subtitle":"Si necesitas una prueba y no quieres esperar<br /><br />Acceso al mayor cuadro de servicios de salud de España con más de 25.000 profesionales y centros con descuentos de hasta el 60% en consultas, intervenciones, pruebas, tratamientos, productos y servicios de salud:","clinic-services":"Servicios clínicos","clinic-services-description":"Permite el acceso a facultativos y centros médicos que conforman el Cuadro Médico del Servicio 'AVANTSALUD':","close":"Cerrar","teeth-services-description":"Este servicio comprende determinados servicios dentales gratuitos y el acceso a un Cuadro de Facultativos a precio baremado. Los servicios dentales gratuitos son:","health-services-description":"Comprende determinados servicios relacionados con el bienestar y la salud en especialidades no incluidas habitualmente en seguros de salud tales como:","medical-services-list":"Consultas de medicina primaria (medicina general y pediatría)<br> Consulta de especialistas<br> Médicos de diagnóstico<br> Tratamientos médicos<br> Hospitalización e intervenciones quirúrgicas<br> Servicios médicos<br> Alergología<br> Anatomía patológica<br> Angiología y cirugía vascular<br> Aparato digestivo<br> Cardiología<br> Cirugía cardiovascular<br> Cirugía general y Aparato digestivo<br> Cirugía mamaria<br> Cirugía maxilofacial<br> Cirugía oncológica<br> Cirugía pedríatica<br> Cirugía plástica y reparadora<br> Cirugía torácica<br> Cirugía vascular<br> Dermatología y venereología<br> Endocrinología y nutrición<br> Enfermería<br> Hematología y hemoterapia<br> Nefrología<br> Neumología<br> Neurocirugía<br> Neurofisiología clínica<br> Neurología<br> Obstetricia y ginecología<br> Oftalmología<br> Oncología médica<br> Oncología radioterápica<br> Otorrinolaringología<br> Rehabilitación<br> Reumatología<br> Traumatología y Ortopedia<br> Urología<br> Medicina general<br> Pediatría<br> Pediatría-Puericultura<br> Clínicas y Hospitales<br> Policlínicas<br> Campimetrías<br> Panorámica/Ortopantomografía<br> Ecografías<br> Mamografías<br> T.A.C.<br> Analísis clínicos<br> Diagnóstico por la imagen<br> Medicina nuclear","teeth-services-list":"Primera vista y entrega de presupuesto<br> Visita de revisón<br> Educación bucodental<br> Enseñanza de técnicas de cepillado<br> Fluorizaciones<br> Limpieza de boca anual. Tartrectomía<br> Radiografías odontológicas (periapical, aleta, oclusal)<br> Diagnóstico y sondaje<br> Ajustes oclusales<br> Retirar puntos<br> Estudio implantológico<br> Falso muñón de titanio<br> Tornillo de cicatrización y de cementación<br>","health-services-list":"Acupuntura/Homeopatía/Naturopatía<br> Avantsalud en forma<br> Balnearios<br> Centros de reconocimiento<br> Cirugía refractiva oftalmológica láser<br> Concepto Bobath<br> Conservación de Células Madre-Cordón<br> Dermatoscopia Digital<br> Dietética<br> Ecografías 3D y 4D<br> Estética<br> Fisioterapia y fisioterapia infantil<br> Hidroterapia de colon<br> Medicina Preventiva y Test Genéticos<br> Ópticas y Audífonos<br> Ortopedia<br> Osteopatía<br> Planes con niños<br> Podología y Estudio de la pisada<br> Prestaciones asistenciales a domicilio (atención postparto)<br> Procedimientos mínimamente invasivos<br> Psicología, pedagogía y logofoniatría<br> Quiropráctica<br> Rehabilitación cardiaca<br> Terapia asistida con animales<br> Tratamientos de deshabituación tabáquica<br> Tratamientos de infertilidad<br> Tratamiento ondas de choque (disfunción eréctil)<br> Veterinarios<br> Láser miopía, astigmatismo, hipermetropía<br> Podología a domicilio<br> Analítica a domicilio<br> Fisioterapia a domicilio<br> Prevención Cáncer cuello de útero/HPV<br> Test genético cardiológico<br> Cribado Cáncer de colon en sangre<br> Test genético de la obesidad<br> Test genético Cáncer pulmonar<br> Chequeo oncológico<br> Test genético Alzhéimer<br> Test genético tromboembolismo<br> Test genético Diabetes Tipo II<br> Test genético Cáncer de mama<br> Test prenatal no invasivo<br> Preeclampsia<br> Test de paternidad<br> Huella genética<br> Test de intolerancia alimentaria<br> Test degeneración macular<br> Sexo fetal en sangre materna<br> Test melisa<br> Test migraña<br> Test intolerancia a la lactosa - fructosa<br> Balón gástrico<br> Cápsula endoscópica<br> Láser verde próstata<br> Láser en dermatología<br> Láser en vascular/endoláser<br> Cirugía percutánea del pie<br> Vasectomía sin bisturí<br> Blefaroplastia<br> Abdominoplastia<br> Rinoplastia<br> Lifting<br> Microinjertos capilares<br> Mamoplastia de aumento<br> Mamoplastia de reducción<br> Cirugía íntima<br> Liposucción<br>"},"wellness":{"title":"Plataforma de Salud y Bienestar","subtitle":"Con clases diarias en directo y en diferido de mindfulness, pilates, yoga, programas de salud, talleres, nutrición y mucho más.","mindfulness":"Mindfulness","pilates":"Pilates","healthy-back":"Espalda Sana","cardio":"Gimnasio Online","nutrition":"Nutrición","vitality":"Dosis de Vitalidad"},"hire-now-with-price-2":"Alugue por 2,95 euros/mês\n\nSem permanência","healthappyrest":{"title":"Adicione saúde mental, felicidade e descanso à sua vida","psico":"Masterclass em psicologia, mindfulness e programas de sono","yoga":"Aulas de ioga e pilates","relax":"Áudios relaxantes, dicas e curiosidades","premium":"Acesso premium a serviços de saúde privados"},"buy-btn":"MAIS INFORMAÇÃO","familiar":{"title":"FAMÍLIA","text":"3 meses de estadia","subtitle":"Consultas médicas e pediátricas online para dois adultos e duas crianças","subtitle1":"Plataforma completa de saúde e bem-estar","subtitle2":"Acesso premium a serviços de saúde privados"},"healthmind":{"title":"SAÚDE E BEM-ESTAR","pricing":"2,95€","text":"sem permanência","subtitle":"Plataforma completa de saúde e bem-estar","subtitle1":"Acesso premium a serviços de saúde privados"},"pricing":{"title":"Nossos planos"},"video-corporative":"vídeo que fazemos","hire-now-with-price-2-2":"Alugue por 2,95 euros/mês\n\n\nsem permanência","upper-header-thirdtitle":"Poderá também aceder ao maior leque de serviços privados de saúde e bem-estar, incluindo terapias presenciais, psicólogos, com descontos significativos.","carementalhealth":{"title":"Comece a cuidar da sua saúde mental","yoga":"ioga e meditação","mindfulness":"programa de atenção plena","dream":"Áudios de sono e relaxamento","pilates":"Pilates","yogatext":"Sentir-se bem começa com o conhecimento de si mesmo.","mindfulnesstext":"Aprenda a estar presente no <<aqui e agora>>.","dreamtext":"Reduza o estresse e a ansiedade para encontrar a calma.","pilatestext":"Desfrute de acesso ilimitado à prática e benefícios do Pilates..."},"menttum":{"title":"Conheça nossos psicólogos","subtitle":"O bem-estar mental e emocional que você merece nas mãos de especialistas.","subtitle2":"Se precisar de terapia online, acesse nossos psicólogos em Menttum. \nSuas sessões online a qualquer hora e de qualquer lugar."},"discounts-mindfulness":{"title":"Acesso premium a serviços privados de saúde e bem-estar","subtitle":"Sem listas de espera. \nMarque uma avaliação e não espere.","subtitle2":"<b>Descontos</b> até 60% em mais de 25.000 profissionais e centros de reconhecido prestígio em intervenções, exames, tratamentos, produtos e serviços de saúde.","subtitle3":"Você terá acesso a <b>preços especiais</b> em tratamentos de bem-estar, spas, centros de beleza, fisioterapeutas, oftalmologistas..."}}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = {"openlegal":{"menu":{"for-you-and-your-family":"Para ti y tu familia","for-business":"Para Empresas","for-freelancers":"Autónomos","sign-in":"Acceder","are-you-lawyer":"Você é um advogado?","business":"Empresas"},"title":"Estamos aqui para ajudá-lo","subtitle":"A melhor assessoria jurídica para você e sua família, a qualquer hora e de qualquer lugar.","more-info":"Más información","cards":{"first":{"title":"","description":"En tu hogar, de viaje, en vacaciones estés donde estés, accede por video, teléfono, mensajería o chat al abogado que necesitas."},"second":{"title":"Comodidad y Seguridad","description":"Evita molestias, limitando los desplazamientos. Podrás recibir la documentación en formato digital y en un entorno de máxima seguridad."},"third":{"title":"Cuida tu vida y la de tu familia","description":"Desconocer tus derechos, o tomar decisiones sin un adecuado asesoramiento, puede tener graves consecuencias para ti  o para tu familia."},"fourth":{"title":"Especialistas en tus derechos","description":"Consumo, vivienda, impagos, laboral, multas, sanciones, fiscal, seguros, contratación internet, familia… encuentra el abogado adecuado a tus necesidades."}},"advantages":"Ventajas de openlegal","best-legal-services":"El mejor servicio legal para empresas y particulares","for-freelancers":"openlegal para autónomos","contact-form":{"text":"Se você quiser nos contar sobre seu caso ou solicitar informações sobre o serviço, entre em contato conosco"},"find-lawyer":"Encontrar um advogado","explain-case":"Contate-Nos","home-cards":{"first":{"title":"O profissional certo","description":"Avaliamos cada profissional individualmente, para que você tenha acesso à melhor assessoria jurídica, tanto presencial quanto online, com o melhor preço."},"second":{"description":"Você pode acessar o advogado que precisa por vídeo, telefone ou chat a qualquer hora e de qualquer lugar, em um ambiente de máxima segurança."},"fourth":{"title":"Plataforma de vídeo profissional","description":"Seguro e privado. \nNão requer cadastro de usuários (Teams, Zoom...)"}},"search-ph":"O que você precisa?","search":"Procurar","are-you-lawyer":"Você é um advogado de destaque? Está interessado no mundo digital?\n\n\nQuer ganhar visibilidade para acessar novos clientes?","sign-up-in":"Entrar","security-privacity":"Segurança e privacidade.","security-subtitle":"Tudo o que você precisa com o mais alto nível de proteção.","security-text1":"A segurança das comunicações e a privacidade dos dados são a nossa prioridade.","security-text2":"Colocamos à sua disposição a melhor tecnologia com a máxima segurança nas comunicações e total privacidade dos seus dados. \nNossa plataforma é certificada ISO 27001.","lawyer-block-description":"Site próprio, agenda online, vídeo e chat profissional, segurança máxima, cobrança, gateway de pagamento...\n\n\nEm apenas 20 minutos você pode digitalizar seu escritório e acessar clientes de qualquer lugar.","form-reason":"Motivo do contato"},"card":{"title-video":"Plataforma de vídeo profissional"}}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = {"os360-empresas":{"more-info-btn":"Mais info","know-more-btn":"Saber mais","big-companies":{"request-info":"Solicitar informação"},"more-information-btn":"Mais informação","main-block":{"paragraph":"O opensalud360 permite que seus funcionários, clientes ou segurados acessem os melhores médicos, psicólogos ou nutricionistas, os melhores programas de bem-estar e o aplicativo de saúde mais completo, a qualquer hora e de qualquer lugar.","more-info":"informação","subtitle":"Especialistas em cuidar do seu equipamento.","title":"A plataforma 360 ​​de saúde e bem-estar para empresas."},"wellness-services":{"cards":{"1":{"subtitle":"Hábitos de movimento, alimentação, repouso e sono e acompanhamento da saúde.","title":"bem-estar físico"},"2":{"subtitle":"Índice de felicidade e desconexão, gerenciamento de incerteza e estresse e capacidade de trabalho.","title":"bem-estar emocional"},"3":{"subtitle":"Ambiente pessoal, profissional e digital, sustentabilidade e hábitos ambientais e riscos psicossociais.","title":"ambiente de bem-estar"},"4":{"subtitle":"Nível de suporte social, bem-estar financeiro, nível de conciliação, abertura à diversidade, talento e relacionamento interpessoal.","title":"Bem estar social"}},"subtitle":"Ofereça aos seus funcionários um autodiagnóstico de saúde e bem-estar com planos de ação individuais.","title":"<b>Wellbeing Score®</b><br>Conheça a saúde e o bem-estar de sua equipe."},"blocks":{"title":"Bem-vindo ao","more-info-question":"Necessita de mais informações?","evaluate-your-health":{"description":"Avaliação do bem-estar emocional, nutrição, risco de doenças e muito mais","title":"Avalie sua saúde"},"healthy-community":{"description":"Partilhe a sua experiência de saúde e bem-estar e faça propostas de planos saudáveis ​​aos seus colegas","title":"Comunidade saudável"},"healthy-habits":{"description":"Crie seus desafios para melhorar seus hábitos. \nVocê pode contar com um profissional ou fazê-los em casal","title":"Alimentos e hábitos saudáveis"},"opensaludpass":{"description":"Consultas, exames de diagnóstico e tratamentos presenciais a preço reduzido","title":"opensaludPass","soon":"Breve"},"teleconsultation":{"title":"Consultas on-line","description":"Médicos, psicólogos, nutricionistas e outras especialidades de livre escolha"},"wellness":{"description":"Aulas diárias ao vivo, workshops, academia online, meditação, programas e muito mais...","title":"opensaludWellness"},"what-do-you-need":"O que você precisa?","digital-phisiotherapy":{"title":"Fisioterapia digital","description":"Guiado por Inteligência Artificial e monitorado por fisioterapeutas"}},"social-benefit":{"list":{"1":"Funcionários fisicamente e mentalmente mais saudáveis","2":"Menores taxas de absenteísmo","3":"Melhorar a conciliação","4":"Funcionários mais felizes e engajados","5":"Aumente a performance do seu equipamento","6":"Melhora a retenção e atração"},"security-description":"E fazemos isso com máxima segurança nas comunicações e total privacidade de seus dados. \nNossa plataforma é certificada pela ISO 27001 e auditada pela Collegiate Medical Organization.","subtitle":"Oferecemos um benefício muito valorizado pelos colaboradores e de grande impacto para a empresa.","title":"Cuidamos do que há de mais importante na sua empresa, seus funcionários"},"companies":"30 funcionários ou 30.000, temos uma solução adaptada às suas necessidades e orçamento.","opensalud-empresas":{"form-subtitle":"Se pretende que os seus colaboradores tenham acesso aos melhores serviços digitais de saúde e bem-estar, contacte-nos."},"psychological-attention":{"quote":"O trabalho mais produtivo é aquele que sai das mãos de uma pessoa feliz","subtitle":"Saúde mental e emocional como fator de bem-estar e produtividade","subtitle-2":"Ansiedade, estresse, problemas emocionais... geralmente não são fáceis de detectar externamente até que os danos sejam muito evidentes e as soluções sejam caras. \nÉ por isso que é fundamental fornecer às pessoas soluções de qualidade e altamente acessíveis que permitam cuidar do problema nas fases iniciais.","title-2":"A importância da detecção e prevenção precoces","title":"Especialistas em saúde mental e emocional na empresa","text":"Partimos de um estado geral de frágil saúde mental e emocional (sobretudo nos países desenvolvidos), que a conjuntura atual acabou por avassaladorar e que vai ter um enorme impacto nas organizações do presente e do futuro. \n<br><br> Ansiedade, stress, depressão, problemas familiares e de relacionamento, gestão de mudanças... são situações que podemos ultrapassar se tivermos as ferramentas certas e sobretudo com o apoio de um profissional qualificado de livre escolha, acessível em qualquer lugar hora e de qualquer lugar.","text-2":"Esses problemas geralmente não são fáceis de detectar externamente até que a deterioração seja mais evidente e as soluções caras. \nPor isso, é essencial fornecer aos funcionários soluções de qualidade e altamente acessíveis, que permitam gerenciar o problema nas fases iniciais."},"companies2":"Com mais de 1.000 profissionais de saúde disponíveis e mais de 50 programas de saúde e bem-estar, grandes empresas e instituições confiam em nós para cuidar da saúde e bem-estar de seus funcionários e clientes na <b> Espanha, Portugal, México e Brasil. \n</b>"}}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Mais info","main-block-h1":"Bienvenido al futuro de los servicios de salud y bienestar para empresas","more-information-btn":"Más información","know-more-btn":"Ler mais","integral-solution":{"title":"Solución integral","subtitle":"La única plataforma de salud y bienestar 360","text":"Ahora más que nunca, queremos ayudar a mejorar la salud física, mental y emocional de personas y organizaciones en todo el mundo. opensalud360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores médicos, psicólogos o nutricionistas y los mejores programas de salud y bienestar, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"social-benefit":{"title":"Cuidamos lo más importante de tu empresa, tus empleados","subtitle":"Proporcionamos un beneficio social muy valorado y de gran impacto.","list":{"1":"Reduzir o absentismo e melhorar a conciliação","2":"Potencia el rendimiento","3":"Aumenta la motivación y la retención","4":"Y sobre todo... ¡mejora la salud y el bienestar!"},"list-1":"Menores taxas de absenteísmo","list-2":"Funcionários mais felizes e engajados","list-3":"Melhorar a reconciliação","list-4":"Aumente o desempenho de suas equipes","list-5":"Aumenta a retenção e atração","list-6":"Colaboradores fisicamente e mentalmente mais saudáveis"},"psychological-attention":{"title":"Salud mental y emocional","subtitle":"La salud mental y emocional como motor de bienestar y productividad","text":"Partíamos de un estado general de salud mental y emocional frágil (especialmente en los países desarrollados), que la actual situación ha terminado por desbordar y que va a tener un enorme impacto en el presente y en el futuro las organizaciones. <br><br> Ansiedad, estrés, depresión, problemas familiares y de pareja, gestión del cambio… son situaciones que podemos superar si contamos con las herramientas adecuadas y sobre todo con el apoyo de un profesional cualificado de libre elección, accesible en cualquier momento y desde cualquier lugar.","quote":"El trabajo más productivo es el que sale<br> de las manos de una persona contenta","title-2":"A importância da detecção precoce e prevenção","subtitle-2":"Ansiedade, estresse, problemas emocionais... geralmente não são fáceis de detectar externamente até que a deterioração seja muito evidente e as soluções caras. \nPor isso, é fundamental fornecer às pessoas soluções de qualidade e de alta acessibilidade que lhes permitam assumir o problema nas fases iniciais."},"wellness":{"title":"Programas de salud y bienestar","list":{"1":{"title":"¡Contenidos personalizados para que recibas tu dosis de vitalidad!","text":"Salud física, mental y nutricional."},"2":{"title":"Planes de entrenamiento online","text":"Espalda sana - Cardiovascular - Salud Activa - Pilates - Embarazadas - Mindfulness - Estrés"},"3":{"title":"Clases y sesiones diarias en directo: ¡No tendrás excusa con tu gimnasio online!","text":"Emitimos contenido de calidad a diario y en 'directo' de diferentes disciplinas deportivas."},"4":{"title":"Talleres online","text":"Inscríbete a nuestros talleres sobre alimentación, gestión del estrés y otros muchos temas de interés."}}},"telemedicine-services":{"title":"Tele exploración y telemonitorización","subtitle":"Convierte cualquier espacio en un punto de salud","text":"opensalud360 ofrece servicios de telemedicina avanzados. Dentro de un servicio de teleconsulta incorporamos dispositivos de tele exploración (estetoscopio digital...) y tele monitorización (temperatura, presión arterial, electro cardio...) que permiten desarrollar todo el potencial de la telemedicina, permitiendo llevar la atención médica allí donde se encuentre el paciente. <br><br> Los usuarios pueden controlar sus variables de salud y en caso necesario, compartir sus datos con un profesional durante la teleconsulta. Asimismo, el médico durante la videoconsulta puede auscultar (corazón y pulmón) al paciente y explorarle de manera remota (orificios, piel, etc.)."},"health-platform":{"title":"¿Te gustaría tener tu propia plataforma personalizada de salud digital?","subtitle":"Posibilidad de personalizar la plataforma para tus empleados o clientes, con tu propio look and feel."},"discountssect":{"title":"Acesso premium a serviços clínicos privados.","subtitle":"Como complemento às consultas online, poderá aceder a mais de 25.000 profissionais e centros em toda a Espanha, a um preço muito baixo. \nIntervenções, exames, tratamentos, consultas, desporto, produtos de saúde, ótica, odontologia...","text":"Acesso à maior lista de serviços de saúde da Espanha com mais de 25.000 profissionais e centros com descontos de até 60% em consultas, intervenções, exames, tratamentos, produtos e serviços de saúde:"},"companies":"30 funcionários ou 30.000, temos uma solução adaptada às suas necessidades e orçamento.","opensalud-empresas":{"form-subtitle":"Se pretende que os seus colaboradores tenham acesso aos melhores serviços digitais de saúde e bem-estar, contacte-nos."},"main-block-h1-new":"Plataforma de saúde e bem-estar para empresas.","main-bussiness-block-h2":"Cuidamos do bem-estar das empresas, cuidando das pessoas que nelas trabalham.","companies2":"Com mais de 1.000 profissionais de saúde disponíveis e mais de 50 programas de saúde e bem-estar, grandes empresas e instituições confiam em nós para cuidar da saúde e bem-estar de seus funcionários e clientes em <b> Espanha, Portugal, Mexico e Brasil. \n</b>","ask-demo-btn":"solicitar demonstração"}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = {"sign-in-btn":"Iniciar sessão","sign-up-btn":"Registro","centre":"Centro","professional":"Profissional","patient":"Paciente","opensaludprime":{"subtitle":"Se não tem seguro de saúde, opensalud prime é o que procura.","text1":"Acesso gratuito a consultas online com um médico de família ou pediatra à sua escolha.","text2":"Desconto nas consultas online nas restantes especialidades da opensalud.","text3":"Plataforma integral de salud y bienestar con clases en directo, meditación, gimnasio online...","text4":"Acesso gratuito a consultas online com um médico de família ou pediatra à sua escolha."},"learn-more-btn":"Saber mais","title-big-1":"Tudo que você precisa para cuidar de si mesmo.","title-big-2":"Aproveite o melhor aplicativo para cuidar da sua saúde gratuitamente.","title-big-3":"¿Cómo funciona?","title-big-4":"Contáctanos","title-small-1":"A plataforma de saúde 360","title-small-2":"Os melhores profissionais","title-small-3":"Acesse serviços gratuitos","title-small-4":"Segurança e privacidade","title-small-5":"Regístrate en openhealth","title-small-6":"Inicia sesión y elige el servicio","title-small-7":"Indica el motivo de tu consulta","title-small-8":"Accede al profesional","text-1":"Acesse os melhores doctores e o aplicativo mais avançado para cuidar da sua saúde.","text-1-sm":"opensalud 360 es una plataforma de salud para personas,empresas y colectivos, que permite a sus usuarios acceder a los mejores profesionales de la salud, en cualquier momento y desde cualquier lugar.","text-2":"Selecionamos individualmente os melhores centros e especialistas, para que tenha acesso ao melhor atendimento ao melhor preço.","text-3":"Avaliador de sintomas, conteúdo de saúde, histórico médico digital, diário de saúde, lembrete de medicação... e muitos outros serviços sem custo.","text-4":"Colocamos ao seu dispor a melhor tecnologia com a máxima segurança nas comunicações e total privacidade dos seus dados.","text-5":"Incluye el código, número de póliza o reserva facilitado","text-6":"Selecciona el servicio y el profesional que necesitas utilizando el buscador","text-7":"Añade algunos datos de salud, adjuntando si lo deseas imágenes o informes","text-8":"Recibe tu informe y prescripción. Al finalizar podrás valorar el servicio","text-9":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","text-9-sm":"Si quieres que tus empleados o clientes accedan a los mejores servicios de salud digital (40 especialidades médicas, psicología y nutrición) contáctanos.","specialty":"Especialidad","specialties":"Especialidades","services":"Serviços","appointment-type":"Tipo de consulta","error-specialty-required":"Você deve selecionar pelo menos a especialidade","consultations-btn":"Consultas","other-services":"Otros servicios","block-6":{"title":"O segredo para um excelente atendimento online é ter excelentes profissionais digitais.","subtitle":"Consulte os melhores médicos, psicólogos e nutricionistas, de forma fácil e segura, com o melhor preço, onde você estiver."},"prime":{"blackTitle":"opensalud prime.","title":"Si no tienes seguro de salud, opensalud prime es lo que buscas.","text":"Acceso gratuito a consultas online con un médico de familia o un pedriatra de tu elección.","text2":"Descuento en consultas online en el resto de especialidades en opensalud.","text3":"Plataforma integral de salud y bienestar con claes en directo, meditación, gimnasio online...","text4":"Acceso premium al mayor cuadro de España de servicios de salud privados con descuentos de hasta el 70%."},"hire-now-with-price":"Contratar por 12,95€/mes 2 adultos + niños incluidos","testimony1":"'La respuesta y la atención fueron rápidas y claras. Le estoy muy agradecido.'","testimony2":"'La Dra. Montserrat ha sido muy amable, el diagnóstico ha sido rápido tras una valoración y unas preguntas, servicio muy bueno y además dando soluciones rápidas. Todo 10.'","testimony3":"'Es un servicio muy rápido y muy útil. Muy contenta. Gracias.'","testimony4":"'La doctora me trató con gran atención y me recomendó y recetó la solución a mi problema capilar.'","testimonyEduard":"'O serviço tem sido magnífico, rápido e eficaz. \nEle me deu as informações que eu precisava sem sair de casa e por um preço muito barato.'","testimonyJesus":"'Sua segunda opinião me ajuda a avaliar uma nova abordagem para meu problema de saúde. \nMuito recomendável.'","testimonyMJesus":"'Me ha dado una serie de valoraciones diagnósticas que me hacen recuperar la esperanza y las ganas de superar mi problema de salud. Una información clara y directa.'","testimonyEugenia":"'La doctora nos proporcionó un diagnóstico claro y bien explicado, con recomendaciones a seguir y enlaces a artículos muy útiles..'","urologist":"Urologista","internist":"Internista","psychology":"Psicología","pediatrics":"Pediatría","clinicalpsychology":"Psicología clínica","familymedicine":"Medicina familiar","internalmedicine":"Medicina interna","psychiatry":"Psiquiatría","sports":"Medicina del deporte","geriatrics":"Geriatría","oncology":"Oncología","neurologist":"Neurologista","digestiveSurgeon":"Cirujano Digestivo","block-review":{"title":"Qué opinan nuestros pacientes","title2":"¿Qué te sucede?","text":"Indica tus síntomas y accede a una evaluación inicial. Al finalizar podrás acceder a los mejores especialistas.","button":"Me duele la cabeza, me duele el pecho..."},"find-prof":"Encuentra el profesional adecuado","block-security":{"blackTitle":"Tudo o que você precisa, com o mais alto nível de proteção.","text2":"Colocamos ao seu dispor a melhor tecnologia com a máxima segurança nas comunicações e total privacidade dos seus dados. \nNosso sistema de gerenciamento de segurança de dados é certificado pela ISO 27001 e auditado pela Collegiate Medical Organization."},"title-small-9":"Llevar siempre contigo tu historia clínica accesible desde el móvil y poderla compartir con quien tú desees, puede ser esencial para una correcta atención (urgente o no).","text-12":"Evaluador de Síntomas - Foro de Pacientes - Seguimiento de Hábitos - Historia clínica en la nube – Test de autoevaluación - Agenda de Salud - Recordatorio de Medicamentos – Conexión con Dispositivos (smartwatch…) – Promociones Exclusivas","title-card-1":"Avaliador de sintomas","title-card-2":"Pacientes como você","title-card-3":"Rastreamento de hábitos","title-card-4":"Avalie sua saúde","title-card-5":"Agenda de Saúde","title-card-6":"Avisos e lembretes","title-card-7":"Conexão com dispositivos (smartwatch...)","title-card-8":"Promoções Exclusivas","title-card-9":"Histórico médico na nuvem","subtitle-big-2":"Llevar siempre contigo tu historia clínica accesible desde el móvil y poderla compartir con quien tú desees, puede ser esencial para una correcta atención (urgente o no).","subtitle-big-functions":"Levar sempre consigo o seu historial médico, acessível a partir do seu telemóvel e poder partilhá-lo com quem quiser, pode ser essencial para um correto atendimento (urgente ou não).","foro":"Foro de pacientes","registerfor-free":"Inscreva-se gratuitamente!","title-card-2-linkeable":"<router-link to=\"/Foro\" tag=\"a\">Pacientes Como Tú</router-link>\n","rev":"classificações","professionals":"Profissionais","welcomeOH":"Bem-vindo a","accesss":"Acessar","online-consultation":"Consulta on-line","title-card-10":"Blog saudável","mustSelectAnSpecialty":"Você deve selecionar uma especialidade","specialtyOrName":"Especialidade ou nome","error-specialty-or-prof-required":"Você deve selecionar uma especialidade ou profissional","services-consultation":"Consultas e serviços","request-consultation":"Consultas","request-service":"Exames médicos","service":"Exames e serviços médicos","patients-swiper":{"care-your-health":"Consultas, exames e a melhor aplicativo de bem-estar","sign-up-free":"REGISTE-SE GRATUITAMENTE","online-consultation-inplace":"Consultas online e presenciais","security-and-privacy":"Segurança e privacidade","health-blog":"Informação saudável","healthy-foods":"Alimentos que cuidam","patients-like-you":"Pacientes como você","habit-tracker":"Objetivos e desafios","cloud-clinic-history":"Histórico médico na nuvem","rate-your-health":"Avalie sua saúde","health-agenda":"Agenda de saúde","reminders":"Avisos e lembretes","device-connection":"Monitoramento variável","exclusive-promotions":"Promoções exclusivas","menstrual-cycle":"Calendário menstrual","habits-that-care":"Hábitos que tomam cuidado"},"patients-landing":{"independent-professionals":"A plataforma de profissionais independentes","quality-medicine":"Medicina de qualidade, sem pressa","sign-up-banner":"Registe-se se se preocupa com a qualidade do atendimento, se pretende melhorar a rentabilidade do seu consultório, colabore com os seus colegas e junte-se ao maior grupo de medicina privada de Espanha.","try-it-free":"EXPERIMENTE GRATUITAMENTE","access-psychologist":"E se eu quiser consultar um psicólogo?","online-inplace-attention":"Atendimento online e presencial","menttum-banner":"Em <span style='text-decoration: underline; font-weight: bold;'>MENTTUM por OpenSalud</span> Você poderá acessar os melhores psicólogos de forma fácil e segura. ","go-menttum":"IR PARA MENTTUM","request-appointment":"Solicitar agendamento","mobile-title":"O melhor <r class = \"d-lg-none\"> doctores e profissionais de saúde","sign-up-free":"Registre -se gratuitamente","opensalud360-title":"Você precisa de um serviço de saúde e bem -estar para seus funcionários que realmente funcionam?","opensalud360-subtitle":"Líderes em serviços de assistência psicológica, prevenção, saúde integral e poço para funcionários.","opensalud360-text":"opensalud360 permite o acesso aos melhores médicos, psicólogos ou nutricionistas, os melhores workshops e programas de bem -estar e a aplicação de saúde e melhoria de hábitos de mercado mais bem -sucedidos.","know-more":"Saiba mais","different-health":"A saúde hoje é diferente","mobile-title-2":"A melhor aplicação para cuidar de você","mobile-title-lg":"Os melhores especialistas e centros e a melhor aplicação para cuidar","swiper":{"title":"Citas e a melhor aplicação de saúde e bem -estar"},"why-opensalud-different":"Por que o OpenSalud é diferente?"},"patients-layout":{"companies":"Empresas"},"error-service-required":"Você deve selecionar um serviço","location":"Província/Localidade","telemedicine":"Telemedicina","patient-title":"opensalud: consultas e aplicação de saúde e bem-estar","patients-landing-different-health-description":"Queremos facilitar o seu acesso a profissionais qualificados, centros de referência e soluções confiáveis, além do aplicativo de saúde<br class=\"d-none d-block-lg\"/>\ne bem-estar utilizado pelas empresas líderes, para ajudá-lo a viver mais e melhor.","solutions":{"qualityMedicine":{"title":"Medicina de Qualidade","description":"Todos os profissionais são avaliados antes de serem integrados no OpenSalud"},"agileAppointment":{"title":"Agilidade no Agendamento","description":"95% de consultas em menos de 10 dias (menos de 3 dias para usuários empresariais, exceto atendimento de urgência)"},"privateConsultations":{"title":"Consultas Privadas","description":"Não são oferecidas consultas financiadas por seguros de saúde, apenas consultas privadas"},"medicineWellbeing":{"title":"Medicina e Bem-Estar","description":"Especialistas em prevenção de doenças e envelhecimento saudável"}}}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Mais info","sign-in-btn":"Iniciar sesión","access-btn":"Acceder","access-patient":"Acceso Pacientes","sign-up-btn":"Registro","patients":"Paciente","business":"Empresas","prove-free":"SOLICITAR DEMO","main-block-h2":"Sempre.","main-block-h3":"Tu plataforma profesional de consulta","main-block-h4":"e bem-estar.","more-information-btn":"Más información","ask-for-demo":"Solicitar demo","ask-for-demo-title":"Recomende o opensalud aos seus pacientes","register-free":"Cadastre-se e experimente grátis por 6 meses sem compromisso!","register-free-openlegal":"Cadastre-se e experimente gratuitamente por 6 meses sem compromisso!","registerfor-free":"¡Regístrate gratis!","know-more-btn":"Ler mais","block-2":{"blackTitle":"Diseñado por médicos.","title":"Cuida de tus pacientes cuándo y cómo quieras."},"block-3":{"blackTitle":"Presencial y online.","title":"Ofrece un servicio innovador a tus pacientes.","text":"Os pacientes poderão entrar em contato com você de maneira fácil e segura, para que você possa decidir quais consultas deseja fazer pessoalmente e quais on-line.","text2":"Além disso, você poderá gerenciar todas as informações de seus pacientes: seu histórico clínico, consultas, faturamento, indicar tarefas, agendar acompanhamentos ou prescrever on-line sob o sistema de prescrição aprovado da OMC.","text3":"Seus pacientes também poderão usar o aplicativo de rastreamento de hábitos, lembrete de medicação, agenda de saúde ou conectar seu smartwatch entre outras soluções."},"block-4":{"blackTitle":"Optimiza tu consulta.","title":"Aumenta tus ingresos y mejora la atención.","text":"Aumenta tu visibilidad y reputación. Capta nuevos pacientes gracias a tu perfil online.","text2":"Dispondrás de una pasarela de pago segura para que tus pacientes puedan realizar el pago de forma segura.","text3":"Nos encargamos de recordar al paciente su cita y emitir de manera automática la factura en tu nombre.","text4":"Ordena y monetiza las comunicaciones con tus pacientes evitando el móvil, email, whatsapp o llamadas por teléfono."},"block-5":{"blackTitle":"Tudo o que você precisa, com o mais alto nível de proteção.","title":"Evita el uso de aplicaciones de mensajería o vídeo no aptas para la práctica clínica.","text":"La seguridad de las comunicaciones y privacidad de los datos son nuestra prioridad.","text2":"Colocamos à sua disposição a melhor tecnologia com a máxima segurança nas comunicações e total privacidade dos seus dados. \nNosso sistema de gestão de segurança de dados possui a certificação ISO 27001 e é auditado pela Collegiate Medical Organization."},"block-6":{"title":"El secreto para una atención online excelente es contar con excelentes profesionales digitales.","subtitle":"Consulta a los mejores médicos, psicólogos y nutricionistas, de manera fácil y segura, con el mejor precio, estés donde estés."},"block-8":{"title":"Tarifas profesionales ","iva":"(IVA No incluido)"},"block-7":{"text1":"es una iniciativa que surge para canalizar las actividades solidarias de los profesionales de la salud que desean ofrecer sus servicios a ONGs que trabajan en zonas con limitado acceso a servicios de salud, utilizando la telemedicina.","text2":"Si quieres aportar una pequeña parte de tu tiempo para atender de manera remota a pacientes en zonas vulnerables, solicita información.","text3":"Los profesionales que colaboren con la iniciativa, podrán utilizar la plataforma opensalud para su práctica clínica habitual, sin pagar ninguna cuota.","blackTitle":"Telemedicina para comunidades vulnerables"},"block-end":{"title":"Accede online a los mejores. Medicina de calidad sin prisas.","subtitle":"Accede a los mejores profesionales y servicios en cualquier momento y desde cualquier lugar de una forma fácil y segura."},"integral-solution":{"title":"Solución integral","subtitle":"La única plataforma de salud y bienestar 360","text":"Agora, mais do que nunca, queremos ajudar a melhorar a saúde física, mental e emocional de pessoas e organizações em todo o mundo. opensalud 360 é uma plataforma digital de saúde que permite que seus usuários acessem os melhores médicos, psicólogos ou nutricionistas a qualquer hora e de qualquer lugar , de forma ágil, fácil e segura."},"social-benefit":{"title":"Cuidamos lo más importante de tu empresa, tus empleados","subtitle":"Proporcionamos un beneficio social muy valorado y de gran impacto.","list":{"1":"Reduce el absentismo y mejora la conciliación","2":"Potencia el rendimiento","3":"Aumenta la motivación y la retención","4":"Y sobre todo... ¡mejora la salud y el bienestar!"}},"block-360":{"title":"opensalud360","subtitle":"El nuevo servicio de salud y bienestar para empresas.","text":"opensalud360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores profesionales y programas de salud y bienestar, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"psychological-attention":{"title":"Especialistas em saúde mental e emocional na empresa","subtitle":"La salud mental y emocional como motor de bienestar y productividad","text":"Partíamos de un estado general de salud mental y emocional frágil (especialmente en los países desarrollados), que la actual situación ha terminado por desbordar y que va a tener un enorme impacto en el presente y en el futuro las organizaciones. <br><br> Ansiedad, estrés, depresión, problemas familiares y de pareja, gestión del cambio… son situaciones que podemos superar si contamos con las herramientas adecuadas y sobre todo con el apoyo de un profesional cualificado de libre elección, accesible en cualquier momento y desde cualquier lugar.","quote":"El trabajo más productivo es el que sale<br> de las manos de una persona contenta"},"wellness":{"title":"Programas de salud y bienestar","list":{"1":{"title":"¡Contenidos personalizados para que recibas tu dosis de vitalidad!","text":"Salud física, mental y nutricional."},"2":{"title":"Planes de entrenamiento online","text":"Espalda sana - Cardiovascular - Salud Activa - Pilates - Embarazadas - Mindfulness - Estrés"},"3":{"title":"Clases y sesiones diarias en directo: ¡No tendrás excusa con tu gimnasio online!","text":"Emitimos contenido de calidad a diario y en 'directo' de diferentes disciplinas deportivas."},"4":{"title":"Talleres online","text":"Inscríbete a nuestros talleres sobre alimentación, gestión del estrés y otros muchos temas de interés."}}},"telemedicine-services":{"title":"Tele exploración y telemonitorización","subtitle":"Convierte cualquier espacio en un punto de salud","text":"opensalud360 ofrece servicios de telemedicina avanzados. Dentro de un servicio de teleconsulta incorporamos dispositivos de tele exploración (estetoscopio digital...) y tele monitorización (temperatura, presión arterial, electro cardio...) que permiten desarrollar todo el potencial de la telemedicina, permitiendo llevar la atención médica allí donde se encuentre el paciente. <br><br> Los usuarios pueden controlar sus variables de salud y en caso necesario, compartir sus datos con un profesional durante la teleconsulta. Asimismo, el médico durante la videoconsulta puede auscultar (corazón y pulmón) al paciente y explorarle de manera remota (orificios, piel, etc.)."},"health-platform":{"title":"¿Te gustaría tener tu propia plataforma personalizada de salud digital?","subtitle":"Posibilidad de personalizar la plataforma para tus empleados o clientes, con tu propio look and feel."},"card":{"title1":"Consulta online","subtitle1":"Videoconsulta, Consulta escrita, Chat, Segunda opinión...","title2":"Receta electrónica","subtitle2":" Recetas homologadas por la Organización Médico Colegial.","title3":"Historial clínico","subtitle3":"Accede, edita y comparte el historial clínico con tus pacientes.","title4":"Consulta presencial","subtitle4":"Consulta a domicilio. Consulta en clínica.","title5":"Suscripciones y packs","subtitle5":"Diseña tus propios packs de servicios y suscripciones.","title6":"Agenda online","subtitle6":"Gestiona tus citas online de forma fácil automática.","title7":"Facturación online","subtitle7":"Realiza tus cobros y emite tus facturas de forma automática.","title8":"Monitorización y exploración remota","subtitle8":"Incorpora dispositivos para facilitar la consulta online y el seguimiento.","title9":"Precios personalizables","subtitle9":"Podrás establecer diferentes precios en función del motivo de consulta o el colectivo.","title10":"Interconsultas","subtitle10":"Entre em contato com outros colegas por meio de mensagens internas","title-video":"Plataforma de vídeo profissional","subtitle-video":"Seguro e privado. \nNão requer cadastro de usuários (Teams, Zoom...)","src-price":"'/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg'","title-1":"Indivíduos","subtitle-1":"Os melhores médicos e o melhor aplicativo de saúde.","title-2":"Profissionais","subtitle-2":"Mesa médica para profissionais independentes","title-3":"Empresas","subtitle-3":"Cuidamos da saúde e do bem-estar dos colaboradores."},"cardsPricing":{"title1":"Profesionales","text1":"5 profesionales incluidos. 5€/mes por profesional adicional (máx. 260€/mes)","subtitle":"Comisión sobre consulta cobrada en opensalud","title2":"Centros clínicos","text2":"5 profesionales incluidos. <br /> 5€/mes por profesional adicional (máx. 190€/mes)"},"openlegal":{"menu":{"for-you-and-your-family":"For you and your family","for-business":"For Businesses","for-freelancers":"Freelancers","sign-in":"Sign in"},"title":"We are here to help you","more-info":"More information","cards":{"first":{"title":"No waiting wherever you are","description":"At home, on the road, on vacation wherever you are, access the lawyer you need by video, phone, messaging or chat."},"second":{"title":"Comfort and Security","description":"Avoid inconvenience by limiting travel. You will be able to receive the documentation in digital format and in a highly secure environment."},"third":{"title":"Take care of your life and that of your family","description":"Ignoring your rights, or making decisions without adequate advice, can have serious consequences for you or your family."},"fourth":{"title":"Specialists in your rights","description":"Consumption, housing, defaults, labor, fines, tax, insurance, family... find the right lawyer for your needs."}},"advantages":"Advantages of openlegal","best-legal-services":"The best legal service for companies and individuals","for-freelancers":"openlegal for freelancers","professional":"Profesional","patient":"Paciente","companies":"Con mas de 1000 médicos, psicólogos y nutricionistas disponibles, grandes compañías e instituciones confían en nosotros para cuidar la salud y el bienestar de sus empleados y clientes en España y México."},"centre":"Centro","main-h1":"Apenas cuide da sua saúde","main-h1-title":"Apenas cuide da sua saúde e bem-estar.","block":{"title":"Nossos perfis","blackTitle":"nós apresentamos você"}}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más info","main-professional-block-h1":"A plataforma para profissionais independentes.","sign-in-btn":"Iniciar sesión","access-btn":"Acceder","access-patient":"Acesso do paciente","sign-up-btn":"Registro","patients":"Pacientes","business":"Empresas","prove-free":"SOLICITAR DEMONSTRAÇÃO","main-professional-block-h2":"Se você deseja digitalizar sua clínica, oferecemos tudo o que você precisa para cuidar de seus pacientes (presencial e online) de maneira fácil e segura.","main-professional-block-h3":"Tu plataforma profesional de consulta","main-professional-block-h4":"Medicina de qualidade, sem pressa.","more-information-btn":"Mais informação","ask-for-demo":"solicitar demonstração","ask-for-demo-title":"Recomende opensalud para seus pacientes","register-free":"Cadastre-se e experimente grátis por 6 meses sem compromisso!","register-free-openlegal":"¡Regístrate y pruébalo gratis durante 6 meses sin compromiso!","registerfor-free":"Inscreva-se gratuitamente!","know-more-btn":"Ler mais","block-2":{"blackTitle":"Projetado por médicos.","title":"Cuide de seus pacientes quando e como quiser."},"block-3":{"blackTitle":"Presencial e online.","title":"Ofereça um serviço inovador aos seus pacientes.","text":"Os pacientes poderão entrar em contato com você de forma fácil e segura, para que você possa decidir quais consultas deseja fazer presencialmente e quais online.","text2":"Além disso, você poderá gerenciar todas as informações de seus pacientes: seu histórico clínico, consultas, faturamento, indicar tarefas, agendar acompanhamentos ou prescrever on-line sob o sistema de prescrição aprovado da OMC.","text3":"Seus pacientes também poderão usar o aplicativo de rastreamento de hábitos, lembrete de medicação, agenda de saúde ou conectar seu smartwatch entre outras soluções."},"block-4":{"blackTitle":"Otimize sua consulta.","title":"Aumente sua renda e melhore o atendimento.","text":"Aumente sua visibilidade e reputação. \nRecrute novos pacientes graças ao seu perfil online.","text2":"Você terá um gateway de pagamento seguro para que seus pacientes possam efetuar o pagamento com segurança.","text3":"Nós nos encarregamos de lembrar o paciente de sua consulta e emitimos automaticamente fatura em seu nome.","text4":"Organize e rentabilize as comunicações com os seus pacientes evitando telemóveis, e-mails, WhatsApp ou chamadas telefónicas."},"block-5":{"blackTitle":"Tudo o que você precisa, com o mais alto nível de proteção.","title":"Evita el uso de aplicaciones de mensajería o vídeo no aptas para la práctica clínica.","text":"La seguridad de las comunicaciones y privacidad de los datos son nuestra prioridad.","text2":"Colocamos à sua disposição a melhor tecnologia com a máxima segurança nas comunicações e total privacidade dos seus dados. \nNosso sistema de gestão de segurança de dados possui a certificação ISO 27001 e é auditado pela Collegiate Medical Organization."},"block-6":{"title":"El secreto para una atención online excelente es contar con excelentes profesionales digitales.","subtitle":"Consulta a los mejores médicos, psicólogos y nutricionistas, de manera fácil y segura, con el mejor precio, estés donde estés."},"block-8":{"title":"Taxas profissionais","iva":"(IVA não incluído)"},"block-7":{"text1":"é uma iniciativa que surge para canalizar as ações solidárias dos profissionais de saúde que desejam oferecer seus serviços a ONGs que atuam em áreas com acesso limitado aos serviços de saúde, utilizando a telemedicina.","text2":"Se você deseja contribuir com uma pequena parte do seu tempo para atender remotamente pacientes em áreas vulneráveis, solicite informações.","text3":"Os profissionais que colaborarem com a iniciativa poderão utilizar a plataforma opensalud para a sua prática clínica regular, sem pagar qualquer taxa.","blackTitle":"Telemedicina para comunidades vulneráveis"},"block-end":{"title":"Accede online a los mejores. Medicina de calidad sin prisas.","subtitle":"Accede a los mejores profesionales y servicios en cualquier momento y desde cualquier lugar de una forma fácil y segura."},"integral-solution":{"title":"Solución integral","subtitle":"La única plataforma de salud y bienestar 360","text":"Agora, mais do que nunca, queremos ajudar a melhorar a saúde física, mental e emocional de pessoas e organizações em todo o mundo. opensalud 360 é uma plataforma digital de saúde que permite que seus usuários acessem os melhores médicos, psicólogos ou nutricionistas a qualquer hora e de qualquer lugar , de forma ágil, fácil e segura."},"social-benefit":{"title":"Cuidamos lo más importante de tu empresa, tus empleados","subtitle":"Proporcionamos un beneficio social muy valorado y de gran impacto.","list":{"1":"Reduce el absentismo y mejora la conciliación","2":"Potencia el rendimiento","3":"Aumenta la motivación y la retención","4":"Y sobre todo... ¡mejora la salud y el bienestar!"}},"block-360":{"title":"opensalud360","subtitle":"El nuevo servicio de salud y bienestar para empresas.","text":"opensalud360 es una plataforma de salud digital que permite a sus usuarios acceder a los mejores profesionales y programas de salud y bienestar, en cualquier momento y desde cualquier lugar, de una forma ágil, fácil y segura."},"psychological-attention":{"title":"Especialistas em saúde mental e emocional na empresa","subtitle":"La salud mental y emocional como motor de bienestar y productividad","text":"Partíamos de un estado general de salud mental y emocional frágil (especialmente en los países desarrollados), que la actual situación ha terminado por desbordar y que va a tener un enorme impacto en el presente y en el futuro las organizaciones. <br><br> Ansiedad, estrés, depresión, problemas familiares y de pareja, gestión del cambio… son situaciones que podemos superar si contamos con las herramientas adecuadas y sobre todo con el apoyo de un profesional cualificado de libre elección, accesible en cualquier momento y desde cualquier lugar.","quote":"El trabajo más productivo es el que sale<br> de las manos de una persona contenta"},"wellness":{"title":"Programas de salud y bienestar","list":{"1":{"title":"¡Contenidos personalizados para que recibas tu dosis de vitalidad!","text":"Salud física, mental y nutricional."},"2":{"title":"Planes de entrenamiento online","text":"Espalda sana - Cardiovascular - Salud Activa - Pilates - Embarazadas - Mindfulness - Estrés"},"3":{"title":"Clases y sesiones diarias en directo: ¡No tendrás excusa con tu gimnasio online!","text":"Emitimos contenido de calidad a diario y en 'directo' de diferentes disciplinas deportivas."},"4":{"title":"Talleres online","text":"Inscríbete a nuestros talleres sobre alimentación, gestión del estrés y otros muchos temas de interés."}}},"telemedicine-services":{"title":"Tele exploración y telemonitorización","subtitle":"Convierte cualquier espacio en un punto de salud","text":"opensalud360 ofrece servicios de telemedicina avanzados. Dentro de un servicio de teleconsulta incorporamos dispositivos de tele exploración (estetoscopio digital...) y tele monitorización (temperatura, presión arterial, electro cardio...) que permiten desarrollar todo el potencial de la telemedicina, permitiendo llevar la atención médica allí donde se encuentre el paciente. <br><br> Los usuarios pueden controlar sus variables de salud y en caso necesario, compartir sus datos con un profesional durante la teleconsulta. Asimismo, el médico durante la videoconsulta puede auscultar (corazón y pulmón) al paciente y explorarle de manera remota (orificios, piel, etc.)."},"health-platform":{"title":"¿Te gustaría tener tu propia plataforma personalizada de salud digital?","subtitle":"Posibilidad de personalizar la plataforma para tus empleados o clientes, con tu propio look and feel."},"card":{"title1":"Consulta online","subtitle1":"Consulta por vídeo, Consulta por escrito, Chat, Segunda opinião...","title2":"Receta electrónica","subtitle2":" Recetas homologadas por la Organización Médico Colegial.","title3":"Histórico clínico","subtitle3":"Acesse, edite e compartilhe o histórico clínico com seus pacientes.","title4":"Consulta presencial","subtitle4":"Consulta a domicilio. Consulta en clínica.","title5":"Assinaturas e pacotes","subtitle5":"Crie seus próprios pacotes de serviços e assinaturas.","title6":"Agenda online","subtitle6":"Gerencie seus compromissos online de forma fácil e automática.","title7":"Cobrança on-line","subtitle7":"Efetue seus pagamentos e emita suas faturas automaticamente.","title8":"Monitorización y exploración remota","subtitle8":"Incorpora dispositivos para facilitar a consulta e monitorização online.","title9":"Preços personalizáveis","subtitle9":"Você pode estabelecer preços diferentes dependendo do motivo da consulta ou do grupo.","title10":"Interconsultas","subtitle10":"Entre em contato com outros colegas por meio de mensagens internas","title-video":"Plataforma de vídeo profissional","subtitle-video":"Seguro e privado. \nNão requer cadastro de usuários (Teams, Zoom...)","src-price":"/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg"},"cardsPricing":{"title1":"Profissionais","text1":"5 profesionales incluidos. 5€/mes por profesional adicional (máx. 260€/mes)","subtitle":"Comissão de consulta cobrada em opensalud","title2":"Centros clínicos","text2":"5 profissionais incluídos. \n<br /> 5€/mês por profissional adicional (máx. 190€/mês)","electronicrecipe":"Módulo complementar de prescrição eletrônica","electronicrecipeprice":"5,90€/profissional","subtitle1":"<b>3,5%</b> até <b>€ 2.500</b> de faturamento mensal","subtitle2":"2,5% até €2.500 de faturação mensal","subtitle3":"<b>1,5%</b> de <b>€ 2.500</b>"},"openlegal":{"menu":{"for-you-and-your-family":"For you and your family","for-business":"For Businesses","for-freelancers":"Freelancers","sign-in":"Sign in"},"title":"We are here to help you","more-info":"More information","cards":{"first":{"title":"No waiting wherever you are","description":"At home, on the road, on vacation wherever you are, access the lawyer you need by video, phone, messaging or chat."},"second":{"title":"Comfort and Security","description":"Avoid inconvenience by limiting travel. You will be able to receive the documentation in digital format and in a highly secure environment."},"third":{"title":"Take care of your life and that of your family","description":"Ignoring your rights, or making decisions without adequate advice, can have serious consequences for you or your family."},"fourth":{"title":"Specialists in your rights","description":"Consumption, housing, defaults, labor, fines, tax, insurance, family... find the right lawyer for your needs."}},"advantages":"Advantages of openlegal","best-legal-services":"The best legal service for companies and individuals","for-freelancers":"openlegal for freelancers","professional":"Profesional","patient":"Paciente","companies":"Con mas de 1000 médicos, psicólogos y nutricionistas disponibles, grandes compañías e instituciones confían en nosotros para cuidar la salud y el bienestar de sus empleados y clientes en España y México."},"centre":"Centro","primeByOpensaludWarning":"A partir del 15 de setembro, o opensalud se tornará o <b>prime by opensalud</b>, um novo conceito focado nas necessidades dos médicos e outros profissionais que praticam medicina privada. \nCadastre-se ou siga-nos em nossas redes sociais para se manter informado."}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = {"appointmentsTitle":"Consultas","unassigned":"Não atribuído","appointmentsSearchBanner":"Indique o intervalo caso não encontre sua consulta (por padrão mostramos consultas de 60 dias atrás).","nextAppointmentsTitle":"Próximas consultas","writtenAppointmentsTitle":"Consulta Escrita/Segunda Opinião","pastChatsAppointmentsTitle":"Bate-papos encerrados","pastAppointmentsTitle":"Consultas anteriores","emptyNextAppointments":"Não há consultas futuras/videoconsultas","emptyWrittenAppointments":"Você não fez nenhuma Consulta Escrita/Segunda Opinião","emptypastAppointments":"Ainda não foi realizada nenhuma consulta/videoconsulta","emptypastChatsAppointments":"Você ainda não fez nenhum bate-papo","webmailStates":{"additionalInfoCompleted":"Informações adicionais concluídas","pendingConfirm":"Aceitação pendente","additionalInfoRequested":"Informações adicionais solicitadas","profReviewingCase":"O profissional está estudando seu caso"},"nextAppointmentsStates":{"waitingCall":"esperando por chamada","postponedCall":"Chamada adiada"},"appointmentStates":{"expired":"Tempo esgotado","cancelledPatient":"Paciente cancelado","cancelledProfessional":"Profissional cancelado","finishedWithPrescription":"Finalizado com receita","finished":"Finalizado","finishedWithoutReport":"Encerrado sem relatório","attendedOutsidePlatform":"Servido fora da plataforma","chargedByProfessional":"Cobrado por profissional","finishedWithReport":"Concluído com relatório","expiredRequest":"Solicitação expirada","patientDoesntShowUp":"Paciente não apresentado","rejectedRequest":"Inscrição não aceita","stillNoReported":"Aguardando relatório","appointmentCancelledProfessional":"Cancelado pelo profissional","appointmentCancelledPatient":"Cancelado pelo paciente"},"historySharedWithProfessional":"Seu histórico médico foi compartilhado com este profissional","changePaymentMethod":"Mudar o metodo de pagamento","showAppointment":"Ver consulta","payAppointment":"Consulta de pagamento","goVideoAppointment":"Vá para a videoconsulta","showChat":"Ver bate-papo","appointmentReport":"Relatório","appointmentPrescription":"Prescrição","showFilters":"Mostrar filtros","appointmentType":"Tipo de consulta","profName":"Nome do profissional","filterAppointments":"Procurar","confirmAppointment":"Confirmar consulta","changeUserAdvice":"Você será direcionado para o perfil deste paciente.<br><br>Deseja continuar?","payment":{"selectState":"Selecione uma província"},"appointmentCancel":{"cancel":"Cancelar","cancelationReason":"Motivo do cancelamento","patientData":"Dados do paciente","appointmentSummary":"Resumo da consulta","wantToCancel":"Sim, quero cancelar a consulta","writeAReason":"Escreva um motivo...","noCancelReason":"Você deve adicionar um motivo para cancelar a consulta","cancel-success":"Consulta cancelada com sucesso","cancel-error":"A consulta não foi cancelada"},"duration":"Duração"}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = {"foods":{"categories":{"title":"Que te preocupa?"},"disclaimer":"Embora o consumo de determinados alimentos não possa, por si só, prevenir ou curar doenças, há evidências de que determinados hábitos nutricionais ajudam a reduzir os riscos de contrair determinadas doenças.\n<br><br>\nNosso objetivo é oferecer informações atualizadas de fontes credenciadas (organizações públicas, sociedades científicas, associações médicas, estudos validados...), porém, se você pretende fazer alguma alteração em seus hábitos com base nas informações fornecidas nesta seção, é Você precisa consultar seu médico ou nutricionista com antecedência. \nEsta recomendação é ainda mais imperativa no caso de patologias anteriores."},"patient":{"foods":{"diet-question":"Adicionar à minha dieta atual","habits-question":"Adicionar lembrete","delete-food":"Remover dos meus alimentos","remove-from-diet":"Eliminar apenas da minha dieta atual","remove-from-my-foods-warning":"Tem certeza de que deseja eliminar este alimento?","remove-from-my-foods":"Remover de 'Meus Alimentos'","patient-food-add-success":"A comida foi adicionada com sucesso a 'Meus Alimentos'","patient-food-delete-success":"A comida foi removida com sucesso de 'My Foods'","patient-food-remove-diet-success":"O alimento foi retirado da sua dieta corretamente","in-diet":"Na minha dieta","remove-habit":"Excluir lembrete","create-habit":"Adicionar lembrete","go-to-habit":"Lembrete associado","remove-from-habits":"Excluir também lembrete associado","habit-created-success":"O hábito foi criado corretamente. \nPara finalizar o processo, clique no botão abaixo para adicionar o alimento em ‘Meus Alimentos’.","patient-food-add-diet-success":"O alimento foi marcado como adicionado corretamente à sua dieta.","select-category":"Selecione uma categoria","go-to-category":"Vá para {categoria}","no-foods-with-filters":"Você não adicionou alimentos que atendam aos filtros estabelecidos.","no-foods":"Você ainda não adicionou nenhum alimento a esta seção.","show-only-in-diet":"Show incluído apenas na minha dieta","add-to-diet":"Marcar como já adicionado à minha dieta","see-associated-habit":"Lembrete","add-food":"Comece a adicionar alimentos","food-detail-dialog-info":"Você pode selecionar os alimentos de seu interesse clicando no coração e adicionando-os à seção Meus Alimentos, onde você pode criar uma tarefa ou lembrete para cada alimento.","added-to-favourites":"Adicionado a 'Meus alimentos'","go-to-my-foods":"Vá para Minha comida"}},"patient-panel":{"no-foods":"Você ainda não adicionou nenhum alimento a esta seção"}}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = {"patient":{"menu-banners":{"queue-instant-video":"O seu pedido de Consulta Imediata por Vídeo está aguardando atendimento. ","queue-written":"Sua solicitação de Consulta Escrita está aguardando atendimento. \nVocê receberá uma notificação quando o profissional aceitar sua consulta.","queue-chat":"Sua solicitação de bate-papo está aguardando para ser atendida. ","queue-call":"Sua solicitação de chamada está aguardando para ser atendida. ","new-chat-messages":"Você tem novas mensagens de bate-papo. "}}}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = {"microhabits":{"simple":{"categories-menu":{"title":"Pequenas mudanças. Ótimos resultados.","subtitle":"O objetivo é ajudá-lo a adotar hábitos aparentemente simples, mas que podem ter um impacto significativo na sua saúde e bem-estar a curto, médio e longo prazo."},"panel-menu":{"on-block-click-disclaimer":"Você pode selecionar os hábitos que lhe interessam clicando no coração e incorporando-os na seção Meus hábitos, onde você pode criar uma tarefa ou lembrete para cada hábito.","add-to-my-habits":"Adicionar aos meus hábitos","max-favourites-reached":"Você tem muitos hábitos que ainda não completou. \nAntes de adicionar um novo hábito, complete ou elimine um.","added-to-favourites":"Hábito adicionado a Meus hábitos com sucesso!"}}},"patient-panel":{"my-microhabits":"Meus hábitos"},"patient":{"microhabits":{"remove-from-favourites":"Excluir de Meus hábitos","added-to-favourites":"Remover de Meu {habitType}","remove-from-achieved":"Marcar como 'Não alcançado'","add-to-achieved":"Marcar como alcançado","added-to-achieved":"Alcançou","create-habit":"Adicionar lembrete","patient-microhabit-achieved-success":"Parabéns! \nVocê conseguiu completar este hábito.","patient-microhabit-remove-diet-success":"Este hábito foi removido de seus hábitos concluídos.","removed-from-favourites":"{typeName} removido com sucesso.","no-microhabits":"Você ainda não adicionou nenhum {typeName} a esta seção.","add-microhabit":"Comece a adicionar {typeName}","no-microhabits-with-filters":"Você não adicionou {typeName} que atenda aos filtros estabelecidos.","reminder":"Lembrete"}},"patients":{"microhabits":{"selected":"Adicionado","achieved":"Alcançou"}}}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"patient-panel":{"welcome":"Bem-vindo ao {platform}","what-do-you-need":"O que você precisa?","teleconsultation":"Consultas","teleconsultation-description":"Médicos, psicólogos e outras especialidades.","health-wealth":"opensaludWellness","health-wealth-description":"Aulas diárias, mindfulness, academia online...","bonified-services":"opensaludPass","bonified-services-description":"Serviços de saúde e bem-estar a preços reduzidos","wellbeing-score":"Wellbeing score<br><small>by freedom and flow</small>","wellbeing-score-description":"Pontuação de bem-estar por liberdade e fluxo","telemonitoring":"Telemonitorização","telemonitoring-description":"Pode sincronizar dispositivos para monitorizar o seu estado de saúde.","healthy-community":"Comunidade saudável","healthy-community-description":"Comente suas dúvidas, peça conselhos ou compartilhe suas experiências com outros","health-data":"Dados de saúde","health-data-description":"História clínica, variáveis ​​de saúde{param}...","habits-description":"Estabeleça metas. \nMelhore seus hábitos","healthy-habits":"Meus objetivos e hábitos","self-evaluation-tests":"Avalie sua saúde","self-evaluation-tests-description":"Saúde emocional, sono, risco de diabetes...","reminders":"Agenda","reminders-description":"Comunicações úteis para sua saúde e bem-estar","title":"Painel","appointment-type":"Tipo de consulta","specialty":"Especialidade","error-specialty-required":"Você deve selecionar a especialidade","patients-like-you":"Pacientes como você","show-more":"Ver más...","go-360-decision":"Detectamos que você está acessando com um usuário opensalud360 ou opensaludPrime.<br><br>Os serviços incluídos em sua assinatura opensalud360 ou opensaludPrime serão exibidos gratuitamente em opensalud.<br><br>O que fazer você quer?","go-360":"Ir para opensalud360","stay-opensalud":"continuar em opensalud","evaluateYourHealthWarning":"O objetivo do módulo avalie sua saúde é ajudá-lo a compreender melhor alguns aspectos de sua saúde e seus hábitos de vida. \nOs resultados das avaliações também são úteis para profissionais que, se for o caso, poderão auxiliá-lo na consulta.<br><br>Em nenhum caso se pretende emitir um diagnóstico ou recomendação terapêutica e, portanto, qualquer decisão que você tome decorra do resultado das diferentes ferramentas de autoavaliação, deve ser previamente validado por um profissional de saúde (médico, psicólogo ou nutricionista em geral).<br><br>Todos os resultados são confidenciais e somente você e, quando aplicável, esses profissionais de saúde. aos quais você dá acesso, eles poderão acessá-los.","go-to-my-consultations":"Acesse 'Minhas consultas'","get-new-consultation":"Solicite uma nova consulta","food-healthy-habits":"Alimentos e hábitos","healthy-blog":"Blog saudável","foods":"Alimentação saudável","soon-label":"Breve","habits-challenges":"Meus objetivos e hábitos","physiotherapy":"Fisioterapia Digital","physiotherapy-description":"Guiado por Inteligência Artificial e monitorado por fisioterapeutas","my-foods":"Meus alimentos","how-do-you-feel-today":"Como você se sente hoje, {name}?","today-health-condition-saved":"Ficamos felizes que você esteja se sentindo bem!","today-health-condition-saved-ok":"Lembre-se que se você não se sentir totalmente bem, o Opensalud coloca médicos e profissionais à sua disposição para ajudá-lo a se sentir melhor.","today-health-condition-saved-bad":"Lamentamos que você não esteja se sentindo bem hoje. \nLembre-se que o Opensalud coloca médicos e profissionais à sua disposição para ajudá-lo a se sentir melhor.","get-new-consultation-or-service":"Solicite uma consulta ou serviço","consultations":"Consultas","services":"Meus serviços","consultation-or-service":"Consulta ou serviço","professionalsOrCenters":"Profissionais/Centros","service":"Serviço","location":"Província/Localidade","error-service-required":"Você deve selecionar um serviço","medicalTests":"Provas medicas","health-condition-graph-label":"Como você se sente hoje?","specialtyOrName":"Especialidade ou nome","today-health-condition-saved-nice":"Estamos felizes que você esteja se sentindo bem e esperamos que continue assim pelo resto do dia!","error-specialty-or-prof-required":"Você deve selecionar uma especialidade ou profissional","notifications":"Agenda e notificações de saúde","caring-foods":"Alimentos que cuidam","foods-description":"Alimentos que ajudam a cuidar da sua saúde","diets-recipes":"Oficinas e receitas","go-to-next-consultations":"Próximas consultas","go-to-past-consultation":"Consultas anteriores","reminders-notifications":"Avisos e notificações","health-agenda":"Minha agenda de saúde","menstrual-calendar":"Calendário menstrual","menstrual-calendar-description":"Duração, próxima menstruação, ovulação…","healthy-blog-description":"Dicas e artigos sobre nutrição, exercício e bem-estar.","habits-that-care":"Hábitos que cuidam","habits-that-care-description":"Pequenas mudanças que melhoram sua vida","my-goals":"Meus objetivos","micro-habits":"Microhábitos","microhabits-keyword":"hábito | hábitos","foods-keyword":"alimento | alimentos","my-apps":"Meus aplicativos","my-apps-description":"Ferramentas para gerenciar sua saúde e bem-estar","medication-reminder":"Lembrete de medicação","menstrual-calendar-male-warning":"Sentimos isso, mas essa ferramenta está disponível apenas para mulheres.","blood-monitor":"Aplicação de tensão","not-available":"Não disponível","only-subscriptors":"Apenas assinantes","only-subscriptors-warning":"Este conteúdo é apenas para assinantes.","healthProfile":"Perfil de saúde","surveyAvailable":"Tem uma pesquisa disponível para ser preenchida","clickHere":"Clique aqui para ir para a pesquisa","who-signs-up":"Quem aponta?","who-signs-up-description":"Organize planos saudáveis ​​com seus colegas"},"patient":{"foods":{"add-to-my-foods":"Adicionar aos meus alimentos","habit-created-success-on-modify":"O hábito foi criado e associado corretamente"}},"newMedicationReminder":"Novo lembrete de medicamentos"}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"filters":{"professionals":"Profissionais","centers":"Centros","speciality":"Especialidade","subscriptionIncluded":"Somente profissionais incluídos na minha assinatura","discountedPrice":"Profissionais com preço com desconto","consultationType":"Tipo de consulta","location":"Província/Localidade","name":"Nome","coupon":"Cupom","showResults":"Mostrar resultados","removeFilters":"Remover filtros","showMoreFilters":"Mais filtros","hideFilters":"Ocultar filtros","insurance":"Companhia de seguros (presencial)","subspeciality":"Sub especialidade","services":"Serviços","disease":"Doença","service":"Serviço","consultationsType":"Tipo de consulta","morning":"Manhã","afternoon":"Tarde","indifferent":"Indiferente","language":"Linguagem","priceMinorTo":"Preço menor que","surname":"Primeiro apelido","secondSurname":"Segundo sobrenome","surnames":"Sobrenomes","selectFilter":"Selecione um filtro para pesquisar","servicesPackages":"Pacotes de serviços","flatRate":"Taxa fixa Contras. \nEscrito e Bate-papo","emptySearch":"Não foram encontrados resultados. \nUse outros critérios de pesquisa","specialityNotFoundCompanies":"Não consegue encontrar a especialidade que procura?","selectSpecialty":"Você deve selecionar uma especialidade","tests":"Provas medicas","analysis":"Análise","clinicalAnalysis":"Análises clínicas","specialityOrName":"Especialidade ou nome","insuranceAdvice":"Serviço disponível apenas para consulta presencial","enterWord":"Digite uma palavra","insurers":"Seguradoras","showProfsNotIncludedSubscription":"Profissionais não incluídos na minha assinatura","anyInsurer":"Com seguradoras"},"ratings":"classificações","addToMyTeam":"Adicionar à minha equipe","removeOfMyTeam":"Excluir à minha equipe","unipromelPopover":"Médico associado a www.unipromel.es","request-appointment":"Para pedir um encontro","serviceName":{"inplace":"Consulta","video":"Consulta de vídeo agendada","written":"Consulta Escrita","secondOpinion":"Segunda opinião","immediate":"Consulta de vídeo imediata","atHome":"Consulta Domiciliar","chat":"Bater papo","call":"Um profissional liga para você","insurance":"Consulta pela seguradora","servicesPackages":"Pacotes de serviços","flatRate":"Taxa fixa Contras. \nEscrito e Bate-papo"},"firstAppointment":"Primeira consulta","sendConsultation":"enviar consulta","makeConsultation":"Faça uma consulta","requestCall":"Solicitar chamada","hire":"Contratar","requestAppointment":"solicite uma consulta","otherConsultations":"Outras consultas","requestConsultation":"Solicitar consulta","availableOnOpensaludPrime":"Disponível no OpenSalud Prime","availableOnCompanies":"Disponível em empresas opensalud","includedInSubscription":"Incluído na sua assinatura","onlyUnderSubscription":"Somente assinatura","specialPrice":"Preço especial","minorRestricted":"Lamentamos, mas esta especialidade destina-se apenas a menores. \nCaso você tenha algum paciente menor vinculado que atenda a essas condições, altere o usuário e repita os passos.","tarifaPlusDisabled":{"title":"Acesso inativo","description":"Atualmente o acesso a este serviço está inativo. \nSe quiser que o avisemos quando estiver novamente disponível, informe-nos o seu email.","email":"E-mail","error":{"email":"Você deve inserir um e-mail válido","terms":"Você deve aceitar os Termos e Condições","captcha":"Você deve completar o captcha"},"success":"Sua solicitação foi enviada"},"professionalPrevalidated":{"title":"Consulta ou solicitação de serviço","description":"No momento estamos validando o profissional que você selecionou. \nSe desejar, você pode inserir seu e-mail e iremos informá-lo quando este procedimento for concluído.","email":"E-mail","error":{"email":"Você deve inserir um e-mail válido","terms":"Você deve aceitar os Termos e Condições","captcha":"Você deve completar o captcha"},"success":"Sua solicitação foi enviada"},"availabilityRequest":{"title":"Consulta ou solicitação de serviço","note":"Obs: o profissional não tem sua agenda online disponível no momento. \nPara solicitar uma consulta, preencha o seguinte formulário.","englishPrescription":"Receita em inglês","form":{"appointmentType":"Tipo de compromisso","center":"Centro","selectAService":"Selecione um serviço","firstAppointment":"Esta é sua primeira consulta?","availabilityDescription":"Fuso horário (por exemplo, segunda, quarta e quinta-feira, das 18h00 às 21h00, qualquer dia da semana após as 16h00)","haveInsurance":"Individual ou com seguro?","insurance":"Selecione uma seguradora","forWho":"Selecione a quem se destina a consulta","pet":"Selecione um animal de estimação para a consulta","minorPatient":"Selecione um paciente para a consulta","phone":"Telefone","description":"Motivo da consulta/comentários","service":"Selecione um serviço"},"error":{"mustSelectPet":"Só é possível solicitar consulta desta especialidade para um animal de estimação.","typeAppointment":"Você deve selecionar o tipo de compromisso","firstAppointment":"Você deve selecionar se é uma primeira consulta","selectInsurance":"Você deve selecionar se participa como pessoa física ou por meio de uma seguradora.","insurance":"Você deve selecionar sua seguradora","forWho":"Você deve indicar a quem se destina a consulta","selectPet":"Selecione um animal de estimação para a consulta","phonePrefix":"Você deve selecionar o prefixo do seu telefone","phone":"Você deve inserir seu número de telefone","description":"Você deve inserir sua consulta/comentários","captcha":"Você deve verificar o captcha","terms":"Você deve aceitar os termos e condições legais","service":"Você deve selecionar um serviço"},"success":"Sua solicitação foi enviada"},"forMe":"Para mim","forMinor":"Para paciente menor","forPet":"Para animal de estimação","showInsurances":"Veja seguradoras","firstAppointmentWithNumber":"1ª consulta","moreCenters":"mais centros","specialistInSearh":"Especialista em:","notAllowFirstAppointmentChat":"Informamos que este profissional não está autorizado a conversar em primeira consulta. \nEm vez disso, você pode solicitar qualquer outro serviço disponível","free":"Livre","consultationsAndServices":"Consultas e serviços","request":"Solicitar","otherConsultationsAndServices":"Outras consultas e serviços","specialtyNotFoundAdvice":"Relembramos que o acesso a profissionais para consultas online é um serviço pay-per-use com preços promocionais.","noPhysicalLocation":"Sem localização física","showProfessionals":"Veja Profissionais","servicesSearch":"Serviços","search-banner":"Não incluímos publicidade. \nNão transferimos dados a terceiros. \nNão oferecemos “contas premium”.","our-policy":"Nossa política","searcherTitle":"Buscador","professionalServices":{"sendMessage":"Enviar mensagem","interconsultation":"Interconsultas","facilityRent":"Instalações para alugar"},"soon-label":"Breve","requestBudget":"Orçamento de solicitação","budget":"Orçamento","subscriptorsAdviceSearch":"Abaixo, todos os profissionais do OpenSalud relacionados aos seus critérios de pesquisa. \nSe você deseja apenas acessar profissionais incluídos na sua assinatura (particular ou empresa), pode marcar os profissionais <b> incluídos na minha assinatura </b> ou efetuar login em 360.opensalud.es"}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = {"more-info-btn":"Más información","firstblock":{"title":"¿Piensas que la medicina privada es demasiado cara si no tienes seguro de salud?","title-offer-1":"Consulta alergología","price-before-1":"60€","price-after-1":"25€","subtitle-offer-1-1":"Precio mercado","subtitle-offer-1-2":"Precio con opensaludprime","subtitle-offer-1-3":"Ahorras 35€","title-offer-2":"Ecografía ginecológica","price-before-2":"70€","price-after-2":"30€","subtitle-offer-2-1":"Precio mercado","subtitle-offer-2-2":"Precio con opensaludprime","subtitle-offer-2-3":"Ahorras 40€","asterisk-text":"*Precios medios por provincia. Pueden variar de unas localidades a otras.","titleInvert":"Sin listas de espera","subtitleInvert":"¡Su funcionamiento es muy sencillo, y recuerda que no tienes que pagar nada hasta que acudas al centro clínico!","iconTitle1":"Encuentra el servicio que necesitas","iconTitle2":"Pide cita en el centro o especilista que elijas","iconTitle3":"¡Listo para descargarla!","iconTitle4":"Acude a la cita y realiza el pago en el centro"},"secondblock":{"title":"Más ejemplos de opensalud Prime comparado con la medicina privada","title-offer-1":"Sesión de psicología","price-before-1":"55€","price-after-1":"30€","subtitle-offer-1-1":"Precio mercado","subtitle-offer-1-2":"Precio con opensaludprime","subtitle-offer-1-3":"Ahorras {price}","title-offer-2":"Resonancia Magnética","price-before-2":"220€","price-after-2":"120€","subtitle-offer-2-1":"Precio mercado","subtitle-offer-2-2":"Precio con opensaludprime","subtitle-offer-2-3":"Ahorras 100€","title-offer-3":"Sesión de rehabilitación o fisoterapia","price-before-3":"45€","price-after-3":"15€","subtitle-offer-3-1":"Precio mercado","subtitle-offer-3-2":"Precio con opensaludprime","subtitle-offer-3-3":"Ahorras 30€","title-offer-4":"Endodoncia birradicular","price-before-4":"200€","price-after-4":"105€","subtitle-offer-4-1":"Precio mercado","subtitle-offer-4-2":"Precio con opensaludprime","subtitle-offer-4-3":"Ahorras 95€","asterisk-text":"*Precios medios por provincia. Pueden variar de unas localidades a otras.","titleInvert":"Ventajas opensalud prime","subtitleInvert":"La mejor calidad y precio para tu bienestar y salud","iconTitle1":"Accede al mejor servicio de bienestar y salud a precio reducidos","iconTitle2":"Mas de 25.000 profesionales, centros de reconocido prestigio","iconTitle3":"No hay limitaciones por edad ni exclusiones","iconTitle4":"La tecnologia médica mas puntera y avanzada","iconTitle5":"Cobertura desde el primer dia, sin periodos de carencia","iconTitle6":"Tratamientos de bienestar alternativos: balnearios, centros estéticos…"},"bgheart":{"hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños incluídos","more-info-btn":"Más información"},"hire-now-with-price-2-disc":"Alugue por 2,95 euros/mês\n\n\nsem permanência"}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = {"title":"Libre elección de los mejores profesionales, en cualquier momento y desde cualquier lugar","general":"Medicina general y familiar","pediatrics":"Pediatría","alert":"¡Recibe la receta en tu móvil!","hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños incluídos","more-info-btn":"Más información"}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = {"firstblock":{"title":"¿Te imaginas tener un <b> entrenador personal o un profesor de meditación siempre disponibles</b>?","titleInvert":"¡Clases en directo todos los días!","subtitleInvert":"Tendrás a tu disposición múltiples disciplinas basadas en tus preferencias y objetivos.  Todas las clases quedabn grabadas por si prefieres verlas en otro momento.","titleInvert2":"¡Y además los mejores programas de salud!","subtitleInvert2":"Gimnasia para embarazadas, programas de espalda sana, salud activa, estreching, mindfulness, cardiovascular o antiestrés.","videoquantity":"","videodetails":"+800 Programas, clases en Directo y en diferido","icontitle1":"","iconsubtitle1":"SALUD FÍSICA: GAP, HIIT, TBC, Spinning, Step Tono, Tono Dance, Abdominales...","icontitle2":"","iconsubtitle2":"SALUD MENTAL: Yoga, Pilates, Mindfulness, Psicología..."},"secondblock":{"titleInvert":"Además, tendrás programas de nutrición personalizables","iconTitle1":"Selecciona tu objetivo","firstlistitem1":"Antiestrés","firstlistitem2":"Cardiovascular","firstlistitem3":"Fortalecer","iconTitle2":"Elige el tipo de dieta","secondlistitem1":"Mediterránea","secondlistitem2":"Vegana","secondlistitem3":"Vegetariana","iconTitle3":"¡Listo para descargarla!","title-diet-1":"Antiestrés","subtitle-diet-1":"Rebaja los niveles de ansiedad y ayuda a conciliar el sueño","title-week-1":"Semana 1 - Lunes","diet-1":"<b>DESAYUNO</b> <br> · 250ml Leche desnatada<br>· 50g pan<br>· Tomate<br> <br> <b>MEDIA MAÑANA</b><br>· 25g Cornflakes<br>· Kéfir<br>· 1 cda mermelada sin azucar<br><br> <b>COMIDA</b><br>· 50g Ensalada<br>· 1 Palmito<br>· 150g salmón al horno con albahaca, <br> orégano y tomillo<br>· 1 Patata mediana<br>· Melocotón<br><br> <b>MERIENDA</b><br>· 200ml leche desnatada<br>· 3 Tortitas de maíz o arroz<br>· ¼ aguacate<br> <br> <b>CENA</b><br>· 50g Ensalada: Remolacha + zanahoria<br>· 150g Pollo a la plancha<br>· 40g Quinoa<br>· 1 Naranja<br><br> <b>RESOPÓN</b><br>· 200ml leche desnatada<br>· 20g Avena<br>· 1 cda Semillas de Chía","diet-subtitle-1":"Grasas  40 gr<br>Proteínas  120 gr<br>Carbohidratos  270 gr<br><br><b>Calorías  1.700 Kcal</b>","asteriskdiet-1":"*Dieta Antiestrés - mediterránea","title-diet-2":"Cardiovascular","subtitle-diet-2":"Mejora tu salud, elimina grasa y ayuda a perder peso","title-week-2":"Semana 2 - Lunes","diet-2":"<b>DESAYUNO</b><br>· Bol de Batido de Frambuesa: 100ml Leche de Coco + 2 Tazas Frambuesas congeladas + 1 Plátano congelado + 10g Semillas de Chía + Coco rallado + Chocolate 75% rallado + Avellanas trituradas<br><br><b>MEDIA MAÑANA</b><br>· Té verde<br>· 1 Puñado de Bayas de Goji<br>· 2 Tortitas de arroz<br><br><b>COMIDA</b><br>· 1 Berenjena rellena: Salsa de Tomate + Cebolla + Soja texturizada + Queso vegetal rallado + Aceite de oliva, sal y perejil + Semillas de Sésamo<br>· 2 Patatas pequeñas asadas<br>· 1 Manzana<br><br><b>MERIENDA</b><br>· 1 Yogur vegetal + Miel de caña + 10g Semillas de Chía<br>· 1 Plátano<br><br><b>CENA</b><br>· 1 Plato de Arroz al horno:<br>· 130g Arroz<br>· Media bandeja de Champiñones<br>· 500ml Caldo de Verduras<br>· Media Cebolla<br>· 2 Dientes de Ajo<br>· 1 Hoja de Laurel<br>· Queso vegetal en polvo<br>· 1 kiwi<br>","diet-subtitle-2":"Grasas  65 gr<br>Proteínas  120 gr<br>Carbohidratos  250 gr<br><br><b>Calorías  2.100 Kcal</b>","asteriskdiet-2":"*Dieta Cardiovascular - vegana","title-diet-3":"Fortalecer","subtitle-diet-3":"Ayuda a incrementar la masa muscular y fortalecer tu cuerpo","title-week-3":"Semana 3 - Lunes","diet-3":"<b>DESAYUNO</b><br>· 1 Milkshake: 150ml Leche desnatada + 50ml Agua + 40g Avena + 1 Plátano + 1 Puñado de Arándanos + 10g Levadura de cerveza +10g Semillas de Lino<br><br><b>MEDIA MAÑANA</b><br>· 2 Tortitas de arroz<br>· 1 Puñado de Almendr<br><br><b>COMIDA</b><br>· 75g Macarrones integrales<br>· Sofrito: Tomate + Cebolla + Aceite de oliva + Soja texturizada + Champiñones<br>· 1 Pera<br><br><b>MERIENDA</b><br>· 1 Puñado de Anacardos<br>· 1 Yogur proteico<br>· Macedonia: 5 Fresas o 10 Cerezas + 1 Plátano + Media naranja<br><br><b>CENA</b><br>· 1 Tortita o crepe integral: Tofu + Lechuga + Tomate + Maíz + Aceitunas negras + Aguacate + Mayonesa light (opcional)<br>· 2 Huevos duros + Pimienta + Orégano<br>· 1 Vasito de Kéfir + Miel de caña + 10g Semillas de Chía","diet-subtitle-3":"Grasas  65 gr<br>Proteínas  120 gr<br>Carbohidratos  250 gr<br><br><b>Calorías  2.100 Kcal</b>","asteriskdiet-3":"*Dieta Fortalecer - vegetariana"},"bgheart":{"hire-now-with-price":"Contratar por 12,95 euros/mes 2 adultos + 2 niños incluídos","more-info-btn":"Más información"},"hire-now-with-price-2-2":"Alugue por 2,95 euros/mês\n\nsem permanência"}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = {"pyme":{"title":"Programa PYME","text":"<p>OPEN HEALTHCARE, S.L. \ntem sido beneficiário de Fundos Europeus, cujo objetivo é melhorar a competitividade das PME, e graças aos quais lançou um Plano de Ação com o objetivo de promover a utilização segura e fiável do ciberespaço e a competitividade das PME durante o ano de 2024. Para isso, contou com o apoio do Programa PME de Cibersegurança da Câmara de Comércio de Sevilha."}}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = {"tests":{"finishTest":"Veja os resultados","section":"Ponto","previousResults":"Ver resultados anteriores","psychosocial-risks":{"title":"Risco psicossocial","questions":{"q1":"Você tem que trabalhar muito rápido?","q2":"A distribuição de tarefas é irregular e faz com que você acumule trabalho?","q3":"Você tem tempo para atualizar seu trabalho?","q4":"É difícil para você esquecer os problemas no trabalho?","q5":"O seu trabalho, em geral, é emocionalmente desgastante?","q6":"Seu trabalho exige que você esconda suas emoções?","q7":"Você tem influência sobre a quantidade de trabalho que lhe é atribuído?","q8":"Sua opinião é levada em consideração quando as tarefas são atribuídas a você?","q9":"Você tem influência sobre a ordem em que executa as tarefas?","q10":"Você pode decidir quando fazer uma pausa?","q11":"Se você tem um assunto pessoal ou familiar, pode deixar o emprego por pelo menos uma hora sem precisar pedir permissão especial?","q12":"Seu trabalho exige que você tenha iniciativa?","q13":"Seu trabalho permite que você aprenda coisas novas?","q14":"Você se sente comprometido com sua profissão?","q15":"Suas tarefas fazem sentido?","q16":"Você fala com entusiasmo sobre sua empresa para outras pessoas?","q17":"No momento, você está preocupado com a dificuldade de encontrar outro emprego se ficar desempregado?","q18":"Neste momento, você está preocupado que suas tarefas sejam alteradas contra sua vontade?","q19":"Neste momento, você está preocupado que sua programação (turno, dias da semana, horário de início e término) seja alterada contra sua vontade?","q20":"Neste momento, preocupa-se se o seu salário varia (que não o atualizem, que o baixem, que introduzam um salário variável, que lhe paguem em espécie, etc.)?","q21":"Você sabe exatamente qual a margem de autonomia que tem no seu trabalho?","q22":"Você sabe exatamente quais tarefas são de sua responsabilidade?","q23":"Nesta empresa, você é informado com antecedência sobre as mudanças que podem afetar seu futuro?","q24":"Você recebe todas as informações de que precisa para fazer bem o seu trabalho?","q25":"Você recebe ajuda e apoio de seus colegas?","q26":"Você recebe ajuda e apoio do seu superior imediato ou imediato?","q27":"O seu cargo é isolado do de seus colegas?","q28":"No trabalho, você se sente parte de um grupo?","q29":"Seus atuais chefes imediatos planejam bem o trabalho?","q30":"Seus atuais chefes imediatos se comunicam bem com os trabalhadores?","q31":"Que parte da família e trabalho doméstico você faz?","q32":"Se você faltar um dia em casa, as tarefas domésticas que você faz ficam desfeitas?","q33":"Quando você está na empresa, pensa nas tarefas domésticas e familiares?","q34":"Há momentos em que você precisa estar na empresa e em casa ao mesmo tempo?","q35":"Meus superiores me dão o reconhecimento que mereço","q36":"Em situações difíceis no trabalho recebo o apoio necessário","q37":"No meu trabalho sou tratado injustamente","q38":"Se penso em todo o trabalho e esforço que tenho feito, o reconhecimento que recebo no meu trabalho parece-me adequado."},"dimensions":{"ap1":"Demandas psicológicas","ap2":"Controle sobre o trabalho","ap3":"Insegurança sobre o futuro","ap4":"Apoio social e qualidade de liderança","ap5":"Dupla presença","ap6":"Estima"},"scores":{"psicoDemandsLow":"Há um excesso de demandas psicológicas no trabalho: você tem que trabalhar rápido ou irregularmente, o trabalho exige que você esconda seus sentimentos...","controlOverWorkLow":"Existe um certo descontrole sobre os conteúdos e condições de trabalho ou possibilidades de desenvolvimento: não temos influência ou margem de autonomia na forma como realizamos nosso trabalho, o trabalho não oferece oportunidades para aplicar nossas habilidades e conhecimentos ou não faz sentido, não podemos adaptar o horário às necessidades da família.","insecuritiesLow":"Considera-se que há remuneração insuficiente pelo trabalho como: falta de respeito, insegurança contratual, mudança de cargo ou serviço contra nossa vontade, tratamento injusto...","leadershipLow":"Existe una cierta falta de apoyo social, de calidad de liderazgo, de previsibilidad o de claridad de rol en el trabajo: cuando hay que trabajar aisladamente, sin apoyo de los superiores o compañeros, con las tareas mal definidas o sin la información adecuada y a tiempo…","doublePresenceLow":"O trabalho familiar e doméstico implica exigências que devem ser assumidas em simultâneo com as do trabalho remunerado, o que implica uma dupla carga horária, sendo que a organização deste pode dificultar a conciliação de ambos.","esteemLow":"Se considera que existen insuficientes compensaciones por el trabajo como por ejemplo: falta de respeto, inseguridad contractual, cambio de puesto o servicio contra nuestra voluntad, trato injusto…"},"description":"O teste que você vai responder servirá para realizar a avaliação dos riscos psicossociais. \nSeu objetivo é identificar e mensurar as condições de trabalho relacionadas à organização do trabalho e que possam representar risco à saúde.","positive":"Favorável","middle":"Intermediário","negative":"Desfavorável","finalCompletedMessage":"Obrigado por completar o teste de risco psicossocial. \n<br><br>Os resultados, como qualquer outra informação pessoal na plataforma, são confidenciais e só são acessíveis quando apropriado pelo profissional de saúde que o trata, se assim o decidir. \nLembramos que sua empresa recebe apenas dados agregados de utilização da plataforma e nunca recebe informações pessoais.","finalCompletedMessageAccessAgain":"Ele já concluiu o teste de riscos psicossociais este mês. \nVocê pode realizar uma avaliação após 30 dias.  \n<br> <br> Os resultados, como qualquer outra informação pessoal na plataforma são confidenciais e só são acessíveis quando apropriado pelo profissional de saúde que o atende, se ele decidir. \nLembramos que sua empresa recebe apenas dados agregados para o uso da plataforma e nunca recebe informações pessoais."},"ryff-scale":{"title":"Bem-estar psicológico","questions":{"q1":"Não tenho medo de expressar minhas opiniões, mesmo quando são contrárias às da maioria das pessoas.","q2":"Para mim, a vida tem sido um processo contínuo de aprendizado, mudança e crescimento.","q3":"Em geral, sinto que estou no controle da situação em que vivo","q4":"As pessoas me descreveriam como uma pessoa generosa, disposta a compartilhar meu tempo com os outros.","q5":"Não me interesso por atividades que ampliem meus horizontes","q6":"Gosto de fazer planos para o futuro e trabalhar para torná-los realidade.","q7":"A maioria das pessoas me vê como carinhosa e afetuosa.","q8":"De muitas maneiras, sinto-me desapontado com minhas conquistas na vida.","q9":"Eu vivo a vida dia a dia e não penso no futuro","q10":"Costumo me preocupar com o que os outros pensam de mim.","q11":"Quando olho para a história da minha vida, fico feliz como as coisas aconteceram","q12":"Tenho dificuldade em organizar a minha vida de uma forma que me satisfaça","q13":"Minhas decisões geralmente não são influenciadas pelo que os outros fazem","q14":"Há muito tempo desisti de tentar fazer grandes melhorias ou mudanças em minha vida.","q15":"As exigências da vida cotidiana muitas vezes me deixam para baixo.","q16":"Eu não experimentei muitos relacionamentos de carinho e confiança com os outros","q17":"Acho importante ter novas experiências que desafiem a maneira como você pensa sobre si mesmo e sobre o mundo.","q18":"Manter relacionamentos próximos tem sido difícil e frustrante para mim","q19":"Minha atitude em relação a mim mesmo provavelmente não é tão positiva quanto a maioria das pessoas em relação a si mesmas.","q20":"Eu tenho um senso de direção e propósito na vida","q21":"Eu me julgo pelo que acho importante, não pelos valores do que os outros acham importante.","q22":"Em geral, sinto-me confiante e positivo comigo mesmo.","q23":"Consegui construir um ambiente e um estilo de vida que realmente gosto","q24":"Costumo ser influenciado por pessoas com opiniões fortes.","q25":"Não gosto de me encontrar em situações novas que me obriguem a mudar minha maneira habitual de fazer as coisas","q26":"Não me encaixo muito bem com as pessoas e a comunidade ao meu redor","q27":"Sei que posso confiar em meus amigos e eles sabem que podem confiar em mim.","q28":"Quando penso nisso, não melhorei muito como pessoa ao longo dos anos.","q29":"Algumas pessoas vagam sem rumo pela vida, mas eu não sou uma delas.","q30":"Muitas vezes me sinto sozinho porque tenho poucos amigos íntimos com quem compartilhar minhas preocupações.","q31":"Quando me comparo com amigos e conhecidos, sinto-me bem com quem sou","q32":"Não estou totalmente claro sobre o que estou tentando alcançar na vida","q33":"Às vezes sinto que já fiz tudo o que há para fazer na vida","q34":"Sinto que muitas das pessoas que conheço tiraram mais proveito da vida do que eu.","q35":"Confio nas minhas opiniões, mesmo que sejam contrárias ao consenso geral","q36":"Sou muito bom em administrar as muitas responsabilidades da minha vida diária.","q37":"Sinto que me desenvolvi muito como pessoa ao longo do tempo.","q38":"Gosto de conversas pessoais e mútuas com a família e amigos.","q39":"Minhas atividades diárias muitas vezes parecem triviais e sem importância.","q40":"I like most parts of my personality","q41":"Acho difícil expressar minhas opiniões sobre assuntos controversos","q42":"Frequentemente me sinto sobrecarregado com minhas responsabilidades"},"dimensions":{"self-acceptance":"Auto aceitação","life-purposes":"Propósitos de vida","environmental-control":"Domínio do ambiente","positive-relationships":"Relacionamentos positivos","personal-growth":"Crescimento pessoal","autonomy":"Autonomia"},"scores":{"selfAcceptanceHigh":"Nem sempre é fácil, mas é muito importante sentir-se bem como se é, assumindo também os defeitos que todos temos e aquelas coisas que não gostamos tanto em nós.<br /><br />Não te esqueças para continuar cuidando de si e mantendo um bom nível de auto-estima em diferentes situações da vida. \nUma das coisas mais importantes que podemos fazer na nossa vida é aceitar a nossa imagem, o nosso passado, a forma como agimos, as coisas que sentimos e os pensamentos que temos.","selfAcceptanceLow":"Pode ser difícil ter uma imagem positiva de nós mesmos se exigirmos demais de nós mesmos. \nApoie-se nas coisas que você mais gosta em você e analise aquelas que menos te convencem, mas que podem ser melhoradas com o seu esforço. \nSempre teremos aspectos que gostaríamos de melhorar, mas que devemos aceitar, principalmente quando estão fora de nossas possibilidades.","lifePurposesHigh":"Bem feito. \nMuitas vezes sabemos que há coisas que queremos fazer na vida, mas não sabemos por onde começar. \nTer propósitos e ser capaz de direcionar nossas vidas para eles nos permite sentirmo-nos motivados e viver uma vida mais saudável e gratificante.<br /><br />Todo mundo tem seus dias bons e ruins, mas ter um propósito nos ajuda a tenha perspectiva mesmo quando as coisas não estão indo bem.","lifePurposesLow":"Em vez de se concentrar em ter um 'grande' propósito, procure aproveitar as pequenas coisas do dia a dia e tente priorizar essas situações em sua vida. \nSe você não encontra um caminho claro, deixe que os momentos que você vive todos os dias sejam os que o guiam para o que você pode estar procurando, mas não consegue ver com clareza. \nNão tenhas pressa.","environmentalControlHigh":"A capacidade de domínio do ambiente é essencial para gerir adequadamente as diversas situações que se apresentam na vida, muitas das quais nada têm a ver connosco ou com as nossas acções.<br /><br />O controlo adequado das circunstâncias que nos rodeiam, pode ser um apoio fundamental em situações adversas.","environmentalControlLow":"Muitas vezes procuramos controlar algo que aconteceu ao nosso redor, quando na maioria das vezes essas situações estão fora de nosso controle. \nTente não ficar obcecado com coisas que não dependem de você e concentre-se no que está ao seu alcance para mudar.","positiveRelationshipsHigh":"Você é capaz de manter relacionamentos de qualidade com outras pessoas. \nVocê se preocupa com o bem-estar dos outros e tem a capacidade de demonstrar empatia, cuidado e respeito pelos outros. \nSe você tem bons relacionamentos, trabalhe para mantê-los! \ne não tenha medo de falar quando surgir um problema.","positiveRelationshipsLow":"Para construir bons relacionamentos é importante fazer pequenos esforços para ser, por exemplo, algo mais aberto e empático. \nSe tem dificuldade em manter relações de qualidade (carinho, confiança...) com outras pessoas, por vezes é aconselhável analisar as nossas atitudes para com elas.<br /><br />Se sente que está a fazer tudo o que está ao seu alcance e você não está recebendo uma resposta adequada, lembre-se de que não precisa manter um relacionamento próximo com todos. \nSe, por outro lado, você acha que poderia fazer algo mais, trabalhe aos poucos, fazendo pequenos esforços que possam ajudá-lo a construir um relacionamento mais positivo, às vezes algo aparentemente tão simples como um sorriso ou um comentário gentil, produza grandes efeitos.","personalGrowthHigh":"O crescimento pessoal é realmente importante para viver uma vida plena. Não se manifesta imediatamente, mas é algo que se vê no dia a dia. Ajuda-nos a mudar, a melhorar e a superar-nos.<br /><br />Todos nós temos potencial para crescer constantemente ao longo de nossas vidas, em qualquer dimensão de nossa pessoa. Aproveite o bom momento para continuar dando passos adiante, mesmo que alguns sejam maiores que outros. Pequenas mudanças são feitas diariamente, mesmo que pareça o contrário para você.","personalGrowthLow":"O crescimento pessoal não é algo que se possa forçar para obter resultados imediatos. \nSe você sente que estagnou, pense que o crescimento ocorre com pequenas ações.<br /><br />Pode ser muito frustrante pensar que o progresso não está sendo feito, mas a realidade é que mesmo sem estar ciente, você pode estar fazendo pequenos passos. \nTudo se resume. \nConcentre-se nos aspectos que deseja melhorar e estabeleça metas fáceis de serem concluídas no curto prazo. \nO crescimento pessoal não é apenas sobre grandes mudanças, aproveite o processo de se conhecer.","autonomyHigh":"A autonomia é uma das características essenciais das pessoas felizes. \nIsso significa que você tem o poder de administrar sua vida e seguir seu próprio caminho sem ser excessivamente afetado pelo que os outros possam pensar.","autonomyLow":"Se você acha difícil dizer não ou expressar suas opiniões livremente, comece trabalhando nisso com pessoas de seu círculo de confiança para desenvolver gradualmente sua autonomia. \nDa mesma forma, é importante aprender a distinguir as pessoas que vale a pena ouvir daquelas que não contribuem muito."},"description":"A escala de Ryff é um teste de autoavaliação multidimensional que mede o nível geral de bem-estar psicológico de uma pessoa com base nas respostas dadas a questões pertencentes a 6 dimensões diferentes.","resultsAnalysisGood":"Bem feito. \nVocê conseguiu melhorar seu nível de bem-estar emocional em comparação com a última vez. \nNão te esqueças de continuar a trabalhar dia a dia a tua saúde emocional, tendo em conta que haverá situações fáceis de resolver e outras que custam algo mais, mas sempre com a boa atitude que demonstras.<br /><br />Aqui encontra-se um resumo dos resultados que lhe permitirá saber se existe margem para melhorias em alguma das dimensões analisadas.","resultsAnalysisBad":"O nível de bem-estar emocional mostrado pelo resultado do teste é um pouco menor do que o obtido da última vez, mas qualquer um tem um revés. \nÉ possível que algumas coisas tenham se acumulado no seu dia a dia durante esse período que tenham atrapalhado sua evolução. \nDe qualquer forma, não desanime, o simples fato de fazer o teste mostra que você quer fazer a sua parte para melhorar e isso é o que importa.<br /><br />Aqui está um breve resumo do seu bem-estar emocional -ser. \nAproveite a oportunidade para analisar as áreas que estão custando mais para você melhorar.","resultsAnalysisMedium":"Seu nível de bem-estar emocional permanece em um nível semelhante ao mostrado na última vez que você completou o teste. \nCada dia traz-nos uma aventura diferente, e é provável que tenha havido alterações em alguma das dimensões.<br /><br />Aqui fica um resumo dos resultados que lhe permitirá saber se há margem para melhorias qualquer uma delas, as dimensões analisadas.","resultsAnalysisFirstTime":"Parabéns por concluir nosso teste de bem-estar emocional. \nLembre-se de o fazer todos os meses para poder acompanhar a sua evolução.<br /><br />Aqui fica um resumo dos resultados que lhe permitirá saber se existe margem para melhorias em alguma das dimensões analisadas."},"completed":"preenchido","testResults":"RESULTADO DOS TESTES","dimensions":"Dimensões","results":"Resultados","well-being":"Bem-estar psicológico","alreadyCompletedMessage":"Você já fez o teste este mês, então os resultados serão exibidos. \nVolte no próximo mês para completá-lo novamente.","wannaStart":"Isso levará cerca de 8 minutos. Você quer começar?","startTest":"Iniciar teste","downloadResults":"Baixar resultados","testCompleted":"Você investiu tempo em você para concluir a auto -avaliação. \nNão se esqueça de concluí -lo periodicamente para que você possa ver sua progressão. \n<br> <br> O teste termina para armazenar os resultados. \nSe desejar, você pode compartilhar os resultados com um profissional ao solicitar uma consulta.","psicosocialRisks":"Riscos psicossociais","self-evaluation-tests":{"title":"Autoavaliação"},"hello":"Olá","findrisk":{"title":"Findrisk (Risco de diabetes)","questions":{"q1":"Idade","q2":"IMC (Índice de Massa Corporal)","q3":"Circunferência da cintura","q4":"Você costuma praticar pelo menos 30 minutos diários de atividade física ou 4 horas semanais, no trabalho e/ou lazer?","q5":"Você come frutas ou vegetais diariamente?","q6":"Você toma remédio para pressão alta?","q7":"Você já teve altos níveis de glicose, por exemplo, em um check-up médico, durante a gravidez ou durante uma doença?","q8":"Algum de seus familiares ou parentes foi diagnosticado com diabetes (tipo 1 ou 2)?"},"scores":{"lowRisk":"Baixo risco","lightRisk":"Risco leve","moderateRisk":"Risco moderado","highRisk":"Alto risco","veryHighRisk":"Risco muito alto","maxRisk":"Risco máximo"},"weightPH":"Peso","heightPH":"Altura","IMC":"IMC","diabetesRisk":"Risco de diabetes","tips":{"highRiskTip":"De acordo com os resultados, o risco de desenvolver diabetes nos próximos 10 anos é alto ou muito alto. \nEmbora o profissional especifique as orientações específicas de atuação no seu caso, você deve saber que ainda pode chegar a tempo de prevenir, mantendo um estilo de vida saudável.","tip1":"<strong>Reduza seu peso</strong> se você estiver com sobrepeso (IMC igual ou superior a 25) ou obeso (IMC igual ou superior a 30)","tip2":"Pratique <strong>atividade física regular</strong> por pelo menos 30min (caminhada em ritmo acelerado, por exemplo) e pelo menos 5 dias por semana.","tip3":"<strong>Melhore a sua alimentação</strong>, aumentando o consumo de frutas e vegetais, diminuindo o consumo de gorduras e aumentando o consumo de fibras naturais entre outros."},"cantReplaceDiagnosis":"O teste FINDRISK <b>não pode substituir um diagnóstico opcional</b>. \nPor este motivo, você deve consultar o seu médico sobre o resultado obtido. \nÉ fundamental consultar um especialista se o risco for alto ou muito alto.","description":"O teste Findrisk é um questionário que avalia o risco de uma pessoa sofrer de diabetes nos próximos 10 anos.","heightUnit":"cm","weightUnit":"kg"},"wannaStartShort":"Isso levará cerca de 5 minutos. \nVocê quer começar?","answers":{"yesCloseFamily":"Sim (Pais, irmãos ou filhos)","lessThan45":"Menos de 45 anos","45to54":"45-54 anos","55to64":"55-64 anos","moreThan64":"Mais de 64 anos","always":"Sempre","alot":"Muitas vezes","sometimes":"Algumas vezes","justsometimes":"Só sempre","never":"Nunca","worried":"Muito preocupado","prettyWorried":"Muito preocupado","moreorlessWorried":"Mais ou menos preocupado","littleWorried":"Pouco preocupado","notWorried":"Nada preocupado","mainResponsible":"Sou o principal responsável e faço a maior parte das tarefas familiares e domésticas","halfResponsible":"Eu faço cerca de metade das tarefas familiares e domésticas","quarterResponsible":"Eu faço cerca de um quarto das tarefas familiares e domésticas","punctuallyResponsible":"Eu só faço tarefas muito específicas","notResponsible":"Eu não faço nenhuma ou quase nenhuma dessas tarefas","total-agreement":"Totalmente de acordo","some-agreement":"Concordo muito","bit-agreement":"Eu meio que concordo","agreement-disagreement":"Não concordo nem discordo","bit-disagreement":"Discordo ligeiramente","some-disagreement":"Discordo bastante","total-disagreement":"Discordo fortemente","lessThan94":"Menos de 94 cm","94to102":"Entre 94 e 102 cm","moreThan102":"Mais de 102 cm","lessThan80":"Menos de 80 cm","80to88":"Entre 80 e 88cm","moreThan88":"Mais de 88 cm","nothingAtAll":"Absolutamente nada","something":"Algo","yes":"Sim","no":"Não","aLot":"Bastante","lotsOf":"Muito","none":"Nenhum","orMore":"o mais","lessThan":"Menos de","almostNever":"Quase nunca","alot2":"Quase sempre","notInTheLastMonth":"Nem uma vez no último mês","lessThanOnceAWeek":"Menos de uma vez por semana","onceAWeek":"Uma ou duas vezes por semana","moreThanOnceAWeek":"Três ou mais vezes por semana","noProblem":"Nenhum problema","lightProblem":"Apenas um pequeno problema","problem":"Um problema","seriousProblem":"Um problema sério","moreThan60minutes":"Mais de 60 minutos","30to60minutes":"Entre 30 e 60 minutos","15to30minutes":"Entre 15 e 30 minutos","lessThan15minutes":"Menos de 15 minutos","veryGood":"Muito boa","prettyGood":"Muito bom","prettyBad":"Muito mal","veryBad":"Muito má","veryHigh":"Muito alta","high":"Alta","low":"Baixa","veryLow":"Muito baixa","alone":"Sozinho em casa","man":"Homem","someoneOtherRoom":"Com alguém em outro quarto","someoneSameBed":"Com alguém na mesma cama","someoneSameRoom":"Com alguém no mesmo quarto, mas em outra cama","woman":"Mulher","yesNotCloseFamily":"Sim (avós, tios, primos de primeiro grau)","slightly":"Um pouco","moderately":"Moderadamente","severely":"Severamente","limitALot":"Sim, isso me limita muito","limitABit":"Sim, isso me limita um pouco","limitNone":"Não, nada me limita","noneMasculine":"Ninguno","verySlight":"Muito suave","slight":"Leve","moderate":"Moderado","severe":"Forte","verySevere":"Muito grave","veryLittle":"Muito pouco","prettyMuch":"Bastante","extremately":"Extremamente","excelent":"Excelente","good":"Bom","regular":"Regular","bad":"Ruim","muchBetterNow":"Muito melhor agora","someBetterNow":"algo melhor agora","moreOrLessTheSame":"Mais ou menos o mesmo","someWorseNow":"Algo pior agora","muchWorseNow":"Muito pior agora","agreement":"De acordo","disagreement":"Discordo"},"nicotine-dependency":{"description":"Você está prestes a fazer o teste de dependência de nicotina de Glover-Nilsson, que é usado para avaliar o nível de dependência física e psicológica da nicotina em fumantes. \nEsse teste classifica a dependência em quatro níveis: leve, moderada, forte e muito forte.","title":"Dependência nicotina","questions":{"q1":"Meu hábito de fumar é muito importante para mim","q2":"Toco e manuseio o cigarro como parte do ritual de fumar","q3":"Você costuma colocar algo na boca para evitar fumar?","q4":"Você se recompensa com um cigarro após concluir alguma tarefa?","q5":"Quando você não fuma, sente dificuldade para se concentrar e realizar alguma tarefa?","q6":"Quando você está em um local onde é proibido fumar, você brinca com seu cigarro ou maço de tabaco?","q7":"Alguns lugares ou circunstâncias o encorajam a fumar: sua cadeira favorita, quarto, carro, bebida (álcool, café, etc.)?","q8":"Você costuma acender um cigarro do nada, sem realmente querer?","q9":"Você costuma colocar cigarros apagados ou outros objetos na boca (canetas, pauzinhos, etc.) e chupá-los para relaxar do estresse, tensão, frustração, etc.?","q10":"Parte do seu prazer de fumar vem do ritual de acender um cigarro?","q11":"Quando você está sozinho em um restaurante, ponto de ônibus, etc. \nVocê se sente mais seguro, protegido ou confiante com um cigarro nas mãos?"},"scores":{"depLevel":"Tu nivel de dependencia","noDependency":{"name":"Você não tem dependência","description":"Parabéns pela determinação e força de vontade! \nManter um estilo de vida livre de nicotina é uma decisão admirável e corajosa. \nVocê está optando por uma vida mais saudável e energética, demonstrando seu compromisso em cuidar do seu bem-estar. \nEste caminho que você está seguindo é uma inspiração para muitos. \nSua escolha de viver sem fumar é uma prova de sua dedicação em cuidar de si mesmo e das pessoas ao seu redor. \nContinue nesta jornada positiva e continue cuidando de si mesmo."},"lowDependency":{"name":"Dependência leve","description":"Fumantes levemente dependentes podem experimentar um desejo ocasional de fumar, mas não têm uma necessidade constante ou forte de nicotina. \nEles podem fumar intermitentemente ou socialmente e podem ser capazes de parar de fumar sem apresentar sintomas graves de abstinência."},"midDependency":{"name":"Dependência moderada","description":"Fumantes com dependência moderada podem sentir uma necessidade constante de nicotina e podem fumar regularmente ao longo do dia. \nEles podem apresentar sintomas de abstinência ao tentar parar, mas esses sintomas não são tão graves quanto os de dependência pesada ou muito pesada."},"highDependency":{"name":"Forte dependência","description":"Fumantes fortemente dependentes experimentam uma necessidade intensa e constante de nicotina. \nEles podem fumar vários cigarros por dia e podem apresentar sintomas de abstinência graves ao tentar parar. \nEles podem sentir que sua vida diária gira em torno do fumo e podem ter dificuldade em fazer atividades que não envolvam fumar."},"veryHighDependency":{"name":"Dependência muito forte","description":"Fumantes com dependência muito forte experimentam uma necessidade extrema e constante de nicotina. \nEles podem fumar um grande número de cigarros por dia e podem apresentar sintomas de abstinência graves ao tentar parar. \nUma dependência muito forte pode afetar sua capacidade de realizar atividades diárias, trabalhar e socializar. \nEles podem sentir que não conseguem controlar seu comportamento de fumar e podem ter grande dificuldade em parar."}},"tips":{"general":"Parar de fumar pode ser um processo difícil, mas é uma das decisões mais saudáveis ​​que você pode tomar para melhorar sua saúde. \nSe precisar de mais ajuda, consulte um profissional de saúde ou especialista em parar de fumar. \nMesmo assim, abaixo você encontrará uma série de dicas que podem te ajudar no processo.","motivation":{"name":"Busque apoio e motivação","description":"Compartilhe seus planos para parar de fumar com amigos, familiares e profissionais de saúde. \nProcure grupos de apoio e programas de tratamento para parar de fumar."},"causes":{"name":"Identifique seus gatilhos e evite-os","description":"Identifique os gatilhos que fazem você fumar, como estresse, tédio ou ansiedade. \nTente evitá-los ou encontrar maneiras saudáveis ​​de lidar com eles."},"endDate":{"name":"Defina uma data para parar de fumar","description":"Defina uma data-alvo para parar de fumar e trabalhe em direção a esse objetivo."},"forgetTheHabit":{"name":"Tente substituir o fumo por outras atividades","description":"Encontre atividades que você goste que não envolvam fumar, como fazer exercícios, ler ou ouvir música, passar tempo com amigos ou familiares, etc."},"relaxTechniques":{"name":"Practica técnicas de relajación y manejo del estrés","description":"Estresse e ansiedade podem ser gatilhos comuns para fumar. \nExperimente técnicas como meditação, respiração profunda ou ioga para reduzir o estresse."},"rewards":{"name":"Defina recompensas para atingir seus objetivos","description":"Defina recompensas para si mesmo por atingir seus objetivos, como economizar dinheiro ou comprar algo que você deseja."},"conscious":{"name":"Tome consciência do seu hábito de fumar","description":"Depois de ter uma ideia clara de quando, onde e por que fuma, será mais fácil trabalhar na redução da dependência."},"reduceDaily":{"name":"Reduza o número de cigarros que você fuma diariamente","description":"Se você não está pronto para parar de fumar completamente, reduzir o número de cigarros que fuma por dia pode ser um primeiro passo importante."},"lookForSupport":{"name":"Encontre suporte","description":"Compartilhe seus planos para parar de fumar com amigos, familiares ou grupos de apoio. \nBuscar ajuda e motivação pode tornar mais fácil parar de fumar."},"rememberBenefits":{"name":"Lembre-se dos benefícios","description":"Os benefícios de parar de fumar são muitos, entre eles, lembrar que você se sentirá melhor fisicamente e terá melhor saúde, prevenindo doenças como problemas respiratórios ou algum tipo de câncer."},"healthyLifestyle":{"name":"Mantenha um estilo de vida saudável","description":"Manter um estilo de vida saudável pode ajudá-lo a lidar com os sintomas de abstinência e reduzir a tentação de fumar. \nTente fazer exercícios regularmente, seguir uma dieta balanceada e dormir o suficiente."}}},"mediterranean-diet":{"title":"Dieta mediterrânea","description":"A Dieta Mediterrânica é uma forma de alimentação que se caracteriza pelo consumo de alimentos frescos, naturais e variados, como frutas, legumes, legumes, peixe, azeite e frutos secos. \nEsta dieta foi amplamente estudada e demonstrou trazer muitos benefícios à saúde.","questions":{"q1":"Você usa azeite como principal gordura para cozinhar?","q2":"Quantas colheres de sopa de azeite você consome no total por dia? \n(incluindo os utilizados para fritar, refeições fora de casa, saladas, etc.)","q3":"Quantas porções de vegetais você consome por dia? \n(guarnições ou acompanhamentos contam como meia porção)","q4":"Quantas peças de fruta você come por dia?","q5":"Quantas porções de carne vermelha, hambúrguer, salsicha ou salsicha você consome por dia? \n(uma porção equivale a 100-150 gr.)","q6":"Quantas porções de manteiga, margarina ou creme você consome por dia? \n(uma porção individual equivale a 12 gr.)","q7":"Quantas bebidas carbonatadas e/ou açucaradas (refrigerantes, colas, tônicos, amargos) você consome por dia?","q8":"Quantas porções de leguminosas você consome por semana? \n(uma porção ou prato equivale a 150 gr.)","q9":"Quantas porções de peixe ou frutos do mar você come por semana? \n(um prato, pedaço ou porção equivale a 100-150 gramas de peixe ou 4-5 pedaços de frutos do mar)","q10":"Quantas vezes por semana você consome doces comerciais (não caseiros), como biscoitos, pudins, doces ou bolos?","q11":"Quantas vezes você come nozes por semana? \n(uma porção equivale a 30 gr.)","q12":"Você prefere frango, peru ou coelho em vez de carne bovina, suína, hambúrgueres ou salsichas? \n(carne de frango: um pedaço ou porção equivale a 100-150 gr.)","q13":"Quantas vezes por semana come legumes cozidos, massa, arroz ou outros pratos temperados com molho de tomate, alho, cebola ou alho francês feito em lume brando com azeite (refogado)?"},"scores":{"lowAdherence":{"name":"Baixa adesão","description":"Você não está seguindo uma dieta saudável, o que pode ter inúmeras consequências negativas para sua saúde. \nUma alimentação saudável é essencial para fornecer ao corpo os nutrientes necessários para manter uma boa saúde, prevenir doenças e manter um peso saudável."},"goodAdherence":{"name":"Boa adesão","description":"Você segue uma dieta saudável que traz inúmeros benefícios para sua saúde, tanto a curto quanto a longo prazo!"}},"consequences":{"heartDiseasesRisk":{"name":"Aumento do risco de doenças cardiovasculares","description":"A Dieta Mediterrânica tem sido associada a uma redução significativa no risco de doenças cardíacas. \nPortanto, a baixa adesão a esta dieta pode aumentar o risco de sofrer de problemas cardiovasculares."},"diabetesRisk":{"name":"Aumento do risco de diabetes","description":"Foi demonstrado que a Dieta Mediterrânica pode reduzir o risco de diabetes tipo 2, e a má adesão a esta dieta pode aumentar o risco de desenvolver esta doença, além de outras doenças crónicas."},"cancerRisk":{"name":"Mayor riesgo de cáncer","description":"Alguns estudos descobriram que a Dieta Mediterrânica pode reduzir o risco de certos tipos de cancro, como o cancro da mama e o cancro colorrectal. \nPortanto, a baixa adesão a essa dieta pode aumentar o risco de desenvolver esses tipos de câncer."},"cognitiveFunction":{"name":"Aumento de peso","description":"A Dieta Mediterrânea é rica em alimentos saudáveis ​​e com poucas calorias, que podem ajudar a controlar o peso. \nA baixa adesão a essa dieta pode levar ao ganho de peso e, em última análise, à obesidade, causada principalmente pela ingestão de alimentos processados, alimentos ricos em gorduras saturadas e açúcares adicionados, e pelo baixo consumo de frutas, vegetais e grãos integrais."},"mentalHealth":{"name":"Aumento do risco de depressão","description":"A Dieta Mediterrânica ajuda a melhorar a saúde mental, pois pode reduzir o risco de depressão, ansiedade e melhorar o humor. \nPortanto, a baixa adesão a esta dieta pode aumentar o risco de depressão e outros problemas de saúde mental."},"consequences":"Consequências da baixa adesão à dieta mediterrânea"},"benefits":{"heartDiseasesRisk":{"name":"Risco reduzido de doenças cardiovasculares","description":"A Dieta Mediterrânica tem sido associada a um risco reduzido de doenças cardiovasculares, como hipertensão, doença coronária e acidente vascular cerebral. \nIsto se deve em parte à alta ingestão de gorduras monoinsaturadas e ácidos graxos ômega-3, presentes em alimentos como azeite e peixe, que ajudam a reduzir a inflamação e o LDL ou colesterol “ruim”."},"diabetesRisk":{"name":"Redução do risco de diabetes","description":"A Dieta Mediterrânea pode reduzir o risco de diabetes tipo 2 devido ao alto consumo de fibras, que ajuda a regular os níveis de glicose no sangue, e ao baixo consumo de alimentos processados ​​e carne vermelha."},"cancerRisk":{"name":"Risco reduzido de câncer","description":"A Dieta Mediterrânica tem sido associada a um risco reduzido de certos tipos de cancro, como o cancro da mama e o cancro colorrectal. \nIsto se deve em parte à alta ingestão de antioxidantes e fibras presentes em frutas e vegetais, bem como ao baixo consumo de carnes processadas e alimentos ricos em gorduras saturadas."},"cognitiveFunction":{"name":"Melhora a função cognitiva","description":"A Dieta Mediterrânica tem sido associada à melhoria da função cognitiva e da memória. \nIsto se deve em parte à alta ingestão de ácidos graxos ômega-3 presentes nos peixes, que estão envolvidos na saúde do cérebro."},"mentalHealth":{"name":"Melhora a saúde mental","description":"A Dieta Mediterrânica tem sido associada a um risco reduzido de depressão e ansiedade devido à sua elevada ingestão de antioxidantes e ácidos gordos ómega-3."},"keepGoing":"Por ello, ¡sigue adoptando hábitos alimentarios saludables y lleva una dieta equilibrada para mantener una buena salud y prevenir enfermedades!","benefits":"Benefícios da alta adesão à dieta mediterrânea"},"tips":{"description":"Dicas para melhorar seus hábitos alimentares e aumentar a adesão à Dieta Mediterrânea","tip1":{"title":"Inclui uma variedade de alimentos saudáveis","description":"É importante incluir uma variedade de alimentos saudáveis ​​em sua dieta, como frutas, vegetais, grãos integrais, proteínas magras e gorduras saudáveis. \nIsso garantirá que você receba todos os nutrientes necessários."},"tip2":{"title":"Reduza o consumo de alimentos processados","description":"Os alimentos processados ​​costumam ser ricos em gordura saturada, sódio e açúcares adicionados, e pobres em nutrientes. \nProcure reduzir o consumo e opte por alimentos frescos e naturais."},"tip3":{"title":"Coma devagar e aproveite a comida","description":"Coma devagar e aproveite a comida. \nIsso ajudará você a se sentir saciado mais rapidamente e a evitar comer demais."},"tip4":{"title":"Reduzir o consumo de álcool","description":"O álcool contém muitas calorias vazias e pode afetar negativamente a saúde geral. \nTente reduzir o consumo e beba com moderação."},"tip5":{"title":"Mantenha o corpo hidratado","description":"Beba água suficiente para manter seu corpo hidratado. \nAlém disso, procure reduzir o consumo de bebidas açucaradas e refrigerantes."},"tip6":{"title":"Planeje refeições","description":"Planeje as refeições com antecedência para garantir uma dieta balanceada e evitar comer demais."},"tip7":{"title":"Cozinha em casa","description":"Cozinhar em casa permite ter maior controle sobre os ingredientes utilizados nas refeições e garante que você esteja consumindo alimentos frescos e saudáveis."},"general":"Em suma, adotar hábitos alimentares saudáveis e manter uma dieta equilibrada pode ser fácil se fizer algumas mudanças simples na sua dieta e estilo de vida.<br><br>Com estas mudanças, pode manter uma boa saúde e prevenir doenças!"}},"stress":{"title":"Escala de Estresse Percebido","description":"Este teste de autoavaliação do stress ajudá-lo-á a identificar os seus actuais níveis de stress e a forma como estes podem estar a afetar o seu bem-estar.","stressPerceived":"Estresse percebido","questions":{"q1":"No último mês, com que frequência você foi afetado por algo que aconteceu inesperadamente?","q2":"No último mês, com que frequência você se sentiu incapaz de controlar as coisas importantes da sua vida?","q3":"No último mês, com que frequência você se sentiu nervoso ou estressado?","q4":"No último mês, com que frequência você lidou com sucesso com os probleminhas irritantes da vida?","q5":"No último mês, com que frequência você sentiu que lidou efetivamente com grandes mudanças que ocorreram em sua vida?","q6":"No último mês, com que frequência você se sentiu confiante sobre sua capacidade de lidar com seus problemas pessoais?","q7":"No último mês, com que frequência você sentiu que as coisas estão indo bem para você?","q8":"No último mês, com que frequência você sentiu que não conseguiria lidar com todas as coisas que precisava fazer?","q9":"No último mês, com que frequência você conseguiu controlar as dificuldades da sua vida?","q10":"No último mês, com que frequência você sentiu que estava no controle?","q11":"No último mês, com que frequência você ficou com raiva porque as coisas que aconteceram com você estavam fora de seu controle?","q12":"No último mês, com que frequência você pensou nas coisas que ainda precisa fazer?","q13":"No último mês, com que frequência você conseguiu controlar a maneira como gasta seu tempo?","q14":"No último mês, com que frequência você sentiu que as dificuldades estavam se acumulando tanto que você não conseguia superá-las?"}},"sleep-quality":{"pittsburg":"Questionário de qualidade do sono","title":"Qualidade do sono","dimensionsDescriptions":{"apartado-1":"A qualidade subjetiva do sono refere-se à avaliação pessoal e subjetiva de uma pessoa sobre a satisfação ou o nível de descanso que experimenta durante o período de sono. \nEsta avaliação baseia-se na percepção individual da pessoa sobre a duração, profundidade e eficácia do seu sono, bem como na sua sensação de descanso e bem-estar ao acordar.</br></br>Alguns factores que podem influenciar o qualidade Os resultados subjetivos do sono incluem o conforto do ambiente de sono, a duração do sono, a presença de interrupções durante a noite, a sensação de frescor ao acordar e a satisfação geral com a experiência de dormir. \nEsta avaliação subjetiva é importante para entender como uma pessoa se sente em relação ao seu sono e pode ser útil na identificação de problemas de sono ou na melhoria da qualidade do sono.</br></br>É importante observar que a qualidade subjetiva do sono pode variar de noite para noite. noite e de pessoa para pessoa, portanto, o que pode ser considerado um sono de boa qualidade para uma pessoa pode ser diferente para outra. \nÉ também relevante notar que, embora subjetiva, a qualidade do sono pode ter um impacto significativo na saúde e no bem-estar geral de uma pessoa.","apartado-2":"A latência do sono refere-se ao período de tempo que decorre desde o momento em que uma pessoa se deita e tenta adormecer até o momento em que consegue adormecer. \nEm outras palavras, é o tempo que leva para adormecer, desde quando você se deita na cama e apaga as luzes até finalmente entrar no estado de sono.</br></br>A latência do sono pode variar muito de uma pessoa para outra. outra e de uma noite para outra. \nAlgumas pessoas podem adormecer rapidamente, em poucos minutos, enquanto outras podem apresentar pior latência do sono, que pode se estender por períodos mais longos, até horas.</br></br>Medir a latência do sono É relevante no estudo dos distúrbios do sono e pode ajudar os profissionais de saúde a avaliar a qualidade do sono de uma pessoa. \nA latência prolongada do sono ou problemas persistentes para adormecer podem indicar a presença de problemas como insônia. \nPortanto, a latência do sono é um parâmetro importante a considerar na avaliação da qualidade do sono de uma pessoa.","apartado-3":"A duração do sono refere-se ao tempo total que uma pessoa permanece dormindo durante uma noite de sono. \nEm outras palavras, é a quantidade de tempo que uma pessoa passa em um estado de sono contínuo e reparador, desde o momento em que adormece até o momento em que acorda pela manhã.</br></br>A duração do sono pode variar. consideravelmente de pessoa para pessoa e em diferentes fases da vida. \nAs recomendações de duração do sono podem variar dependendo da idade e das necessidades individuais, mas, em geral, considera-se que adultos saudáveis ​​normalmente precisam de 7 a 9 horas de sono por noite para se sentirem descansados ​​e alertas no dia seguinte. \nNo entanto, algumas pessoas podem precisar de mais ou menos tempo de sono para funcionar de maneira ideal.</br></br>A duração do sono é um componente importante na avaliação da qualidade do sono e pode estar relacionada à saúde geral e ao bem-estar de uma pessoa. \nTanto a falta crónica de sono como o excesso de sono podem ter efeitos negativos na saúde, pelo que encontrar um equilíbrio adequado na duração do sono é essencial para manter um estilo de vida saudável.","apartado-4":"A eficiência do sono é a porcentagem de tempo que uma pessoa passa dormindo em relação ao tempo total gasto na cama.","apartado-5":"Os distúrbios do sono referem-se a qualquer interrupção ou alteração no padrão normal de sono de uma pessoa que afeta negativamente a qualidade do descanso e a capacidade de dormir adequadamente durante a noite. \nEsses distúrbios podem se manifestar de diversas maneiras e ter diferentes causas, podendo ser temporários ou crônicos.</br></br>Os distúrbios do sono podem ter um impacto significativo na qualidade de vida de uma pessoa, pois podem causar fadiga. sonolência, irritabilidade e problemas de saúde a longo prazo se não forem tratados adequadamente. \nA identificação da causa subjacente dos distúrbios do sono é importante para implementar estratégias eficazes de gestão e tratamento. \nEm muitos casos, é aconselhável procurar atendimento de um profissional de saúde especializado em distúrbios do sono para um diagnóstico e plano de tratamento adequados.","apartado-6":"Medicamentos para dormir, também conhecidos como hipnóticos ou pílulas para dormir, são medicamentos desenvolvidos para ajudar as pessoas a adormecer ou permanecer dormindo durante a noite. \nEsses medicamentos são normalmente usados ​​para tratar distúrbios do sono, como insônia, que podem causar dificuldade em adormecer ou despertares frequentes durante a noite.</br></br>Os medicamentos para dormir normalmente exercem seu efeito no sistema nervoso central e podem ter diferentes efeitos. mecanismos de ação, dependendo do tipo de medicamento.</br></br>É importante ressaltar que o uso de medicamentos para dormir deve ser feito sob supervisão de um profissional de saúde e de acordo com as indicações específicas do medicamento ... doutor. \nEsses medicamentos não devem ser usados ​​indiscriminadamente, pois podem ter efeitos colaterais, criar dependência e não tratar as causas subjacentes dos distúrbios do sono.</br></br>Além disso, é recomendado que os medicamentos para dormir sejam usados ​​como parte de um plano de tratamento abrangente que inclua mudanças no estilo de vida e higiene do sono, bem como terapias cognitivo-comportamentais para tratar os distúrbios do sono de forma mais eficaz a longo prazo. \nQuanto maior a dependência de medicamentos para dormir, pior será a pontuação nesta seção.","apartado-7":"A disfunção diurna refere-se à incapacidade ou dificuldade que uma pessoa experimenta em funcionar de forma adequada e eficaz em suas atividades diárias devido a problemas ou distúrbios do sono. \nEssa disfunção pode se manifestar em diversos aspectos da vida diária, como trabalho, relacionamentos pessoais, concentração, humor e saúde geral."},"questions":{"q1":"Durante o último mês, qual tem sido geralmente a sua hora de dormir?","q2":"Quanto tempo você demorou para adormecer normalmente nas noites do último mês?","q3":"Durante o último mês, a que horas você geralmente se levantou pela manhã?","q4":"Quantas horas você estima que realmente dormiu todas as noites no último mês?","q5":"Durante o último mês, quantas vezes você teve problemas para dormir porque não conseguiu adormecer na primeira meia hora?","q6":"Durante o último mês, quantas vezes você teve problemas para dormir por ter acordado durante a noite ou de manhã cedo?","q7":"Durante o último mês, quantas vezes você teve problemas para dormir por ter que se levantar para ir ao banheiro?","q8":"Durante o último mês, quantas vezes você teve problemas para dormir por não conseguir respirar adequadamente?","q9":"Durante o último mês, quantas vezes você teve problemas para dormir por causa de tosse ou ronco alto?","q10":"Durante o último mês, quantas vezes você teve dificuldade para dormir por sentir frio?","q11":"Durante o último mês, quantas vezes você teve problemas para dormir por sentir muito calor?","q12":"Durante o último mês, quantas vezes você teve problemas para dormir por causa de pesadelos ou pesadelos?","q13":"Durante o último mês, quantas vezes você teve problemas para dormir por causa da dor?","q14":"Durante o último mês, quantas vezes você teve problemas para dormir por outros motivos?","q15":"Durante o último mês, como você classificaria globalmente a qualidade do seu sono?","q16":"Durante o último mês, quantas vezes você tomou remédios (por conta própria ou prescritos pelo seu médico) para ajudá-lo a dormir?","q17":"Durante o último mês, quantas vezes você se sentiu sonolento enquanto dirigia, comia ou fazia alguma outra atividade?","q18":"Durante o último mês, foi um grande problema para você encontrar coragem para realizar alguma das atividades detalhadas na pergunta anterior?","q19":"Você dorme sozinho ou com alguém?"},"hours":"Horas","minutes":"Minutos","description":"As perguntas a seguir referem-se apenas aos seus hábitos de sono no último mês. \nNas suas respostas você deve refletir qual foi o seu comportamento durante a maior parte dos dias e noites do último mês. \nPor favor, responda a todas as perguntas.","dimensions":{"subjectiveQuality":"Qualidade subjetiva do sono","sleepLatency":"Latência do sono","sleepDuration":"Duração do sono","sleepEfficiency":"Eficiência habitual do sono","sleepPerturbations":"Distúrbios do sono","medicationToSleep":"Uso de medicação para dormir","dayDisfunction":"Disfunção durante o dia"}},"tips":"Pontas","seeResuts":"Ver resultados","anxiety-beck":{"title":"Teste de ansiedade","description":"O Inventário de Ansiedade de Beck é uma ferramenta útil que consiste em 21 perguntas para avaliar sintomas somáticos de ansiedade, tanto em transtornos de ansiedade quanto em sintomas depressivos.<br><br>Responda a este questionário sobre sintomas comuns de ansiedade considerando suas dificuldades atuais. \nIndique o quanto eles afetaram você no último mês.","questions":{"q1":"Desajeitado ou entorpecido","q2":"Aquecido","q3":"Com tremores nas pernas","q4":"Incapaz de relaxar","q5":"Temendo que o pior aconteça","q6":"Tonto ou perdendo a cabeça","q7":"Com batimentos cardíacos fortes e rápidos","q8":"Instável","q9":"Assustado ou assustado","q10":"Altamente tenso","q11":"Com uma sensação de bloqueio","q12":"Com tremores nas mãos","q13":"Inquieto, inseguro","q14":"Com medo de perder o controle","q15":"Com uma sensação de sufocamento","q16":"Com medo de morrer","q17":"Com medo","q18":"Com problemas digestivos","q19":"com desbotamento","q20":"Com blush facial","q21":"Com suores, quentes ou frios"},"lowAnxiety":"Ansiedade muito baixa","moderateAnxiety":"Ansiedade moderada","severeAnxiety":"Ansiedade severa"},"physical-activity":{"title":"Teste de atividade física","description":"O seguinte questionário mede o nível de atividade física em adultos de acordo com os critérios estabelecidos pelo Questionário Internacional de Atividade Física (IPAQ)","intensity":{"intense":"Atividade física intensa","moderate":"atividade física moderada","walking":"Andar","sitting":"Sentado"},"questions":{"q1":"Durante a última semana, quantos dias você praticou atividades físicas intensas como corrida, musculação na academia ou ciclismo em ritmo acelerado?","q2":"Quanto tempo total você gastou fazendo atividade física <b>intensa</b> em um desses dias?","q3":"Durante a última semana, quantos dias você praticou atividades físicas moderadas, como andar de bicicleta, tênis em duplas, Pilates ou qualquer outro exercício de intensidade moderada?<br><br><b>Atenção,</b> não inclua caminhada, a menos que você faça isso em um ritmo muito intenso e por mais de 30 minutos sem interrupções","q4":"Quanto tempo total você gastou fazendo atividade física <b>moderada</b> em um desses dias?","q5":"Durante a última semana, em quantos dias você caminhou pelo menos 10 minutos seguidos?","q6":"Quanto tempo total você gastou caminhando em um desses dias?","q7":"Durante a última semana, em média, quanto tempo por dia você passou sentado?"},"levels":{"highLevel":"Alto nível de atividade","moderateLevel":"Nível de atividade moderado","lowLevel":"Baixo nível de atividade","name":"Nível de atividade"},"percentPopulationResult":{"high":"Está entre os 27,8% da população entre 18 e 69 anos que se enquadra na categoria alta de atividade física.","moderate":"Está entre os 38,6% da população entre 18 e 69 anos que se enquadra na categoria média de atividade física.","low":"Está entre os 33,6% da população entre 18 e 69 anos que se encontra na categoria baixa de atividade física."},"metsExplanation":"*METS é a unidade de referência usada neste teste. \nO resultado é obtido multiplicando o número total de horas semanais por um valor constante para cada nível de intensidade."},"cardiovascular-risk":{"title":"Risco cardiovascular","questions":{"q1":"Idade","q2":"Você foi diagnosticado com diabetes?","q3":"Você fuma regularmente?","q4":"Colesterol total","q5":"Colesterol HDL “bom”","q6":"Pressão arterial"},"scores":{"lowRisk":{"name":"Seu risco é baixo!","description":"Parabéns, seu risco cardiovascular é baixo. \nNão se descuide e mantenha bons hábitos de vida, pratique esportes, siga uma alimentação saudável e evite o tabaco."},"midRisk":{"name":"Seu risco é médio!","description":"O risco de desenvolver doenças cardiovasculares nos próximos 10 anos é médio, por isso é importante garantir que você siga as diretrizes de estilo de vida saudável.","tips":{"tip1":"Comer saudável. \nLimite o consumo de álcool, alimentos gordurosos ou salgados, açúcar, doces e produtos pré-cozidos. \nInclua frutas, vegetais e legumes em sua dieta diária.","tip2":"Evite um estilo de vida sedentário. \nAcademia, subir escadas, brincar com as crianças, evitar o carro... tudo conta. \nVocê deve fazer pelo menos 45 minutos de atividade física moderada durante 5 dias por semana.","tip3":"Evite tabaco.","tip4":"Mantenha o estresse (especialmente se for contínuo) sob controle."}},"highRisk":{"name":"Seu risco é alto!","description":"O risco de desenvolver doenças cardiovasculares nos próximos 10 anos é elevado, por isso é importante garantir que segue algumas orientações relativamente aos seus hábitos de vida. \nE não se esqueça de marcar periodicamente uma consulta com seu médico. \nAlgum tipo de tratamento pode ser aconselhável.","tips":{"tip4":"Mantenha o estresse (especialmente se for contínuo) sob controle.","tip3":"Evite tabaco.","tip2":"Você tem que se mover todos os dias. \nAcademia, subir escadas, brincar com as crianças, evitar o carro... tudo conta. \nVocê deve fazer pelo menos 45 minutos de atividade física moderada durante 5 dias por semana. \nSe precisar, um profissional poderá aconselhá-lo sobre exercícios adequados à sua idade e condição.","tip1":"Garante uma alimentação saudável. \nLimite o consumo de álcool, alimentos gordurosos ou salgados, açúcar, doces e produtos pré-cozidos. \nInclua frutas, vegetais e legumes em sua dieta diária. \nConsulte um profissional de nutrição se precisar de ajuda para melhorar seus hábitos alimentares."}}},"description":"O teste a seguir calcula, através de fatores como idade, sexo, herança genética e hábitos, o risco estimado de sofrer de doenças cardiovasculares nos próximos 10 anos. \nÉ baseado na equação de Framingham."},"gender":"Sexo","testNamesForResultsDiagram":{"Test ryff scale":"Bem-estar psicológico","Test findrisk":"Risco de diabetes","Test mediterranean diet":"Dieta mediterrânica","Test nicotine dependency":"Dependência nicotina","Test stress":"Perceção do stress","Test sleep quality":"Qualidade do sono","Test anxiety beck":"Nível de ansiedade","Test physical activity":"Atividade física","Test cardiovascular risk":"Risco cardiovascular","Test interpersonal relationships":"Relações interpessoais","Test social skills":"Competências sociais","Test general health":"Saúde geral"},"resultsDiagram":"Diagrama de resultados","notCompleted":"Não completo","general-health":{"title":"Saúde geral","description":"O SF-36 é um questionário projetado para avaliar a percepção do estado de saúde e bem-estar. Ele analisa oito áreas fundamentais, como a capacidade física, a dor, a vitalidade e o estado emocional, oferecendo uma visão completa da qualidade de vida de uma pessoa.","dimensions":{"physical-function":"Função física","physical-limitations":"Limitações físicas","body-pain":"Dor no corpo","general-health":"Saúde geral","vitality":"Vitalidade","social-function":"Função social","emotional-limitations":"Limitações emocionais","mental-health":"Saúde mental"},"questions":{"q1":"Em geral, você diria que sua saúde é:","q2":"Como você avaliaria sua saúde atual em comparação com a de um ano atrás?","q3":"Sua saúde atual limita você em atividades intensas, como correr, levantar objetos pesados ou praticar esportes extenuantes?","q4":"Sua saúde atual limita você em atividades moderadas, como mover uma mesa, passar o aspirador, jogar boliche ou caminhar por mais de uma hora?","q5":"Sua saúde atual limita você em carregar ou levantar uma sacola de compras?","q6":"Sua saúde atual limita você em subir vários lances de escada?","q7":"Sua saúde atual limita você em subir um único lance de escada?","q8":"Sua saúde atual limita você em se abaixar ou ajoelhar?","q9":"Sua saúde atual limita você em caminhar um quilômetro ou mais?","q10":"Sua saúde atual limita você em caminhar vários quarteirões (algumas centenas de metros)?","q11":"Sua saúde atual limita você em caminhar um único quarteirão (cerca de 100 metros)?","q12":"Sua saúde atual limita você em tomar banho ou se vestir sozinho?","q13":"Nas últimas 4 semanas, você precisou reduzir o tempo dedicado ao trabalho ou às atividades diárias por causa da sua saúde física?","q14":"Nas últimas 4 semanas, você fez menos do que gostaria por causa da sua saúde física?","q15":"Nas últimas 4 semanas, você teve que parar de fazer algumas tarefas no trabalho ou nas atividades diárias por causa da sua saúde física?","q16":"Nas últimas 4 semanas, você teve dificuldade em realizar seu trabalho ou atividades diárias (por exemplo, foi mais difícil do que o normal) por causa da sua saúde física?","q17":"Nas últimas 4 semanas, você precisou reduzir o tempo dedicado ao trabalho ou às atividades diárias por causa de algum problema emocional (como se sentir triste, deprimido ou nervoso)?","q18":"Nas últimas 4 semanas, você fez menos do que gostaria por causa de algum problema emocional (como se sentir triste, deprimido ou nervoso)?","q19":"Nas últimas 4 semanas, você não fez seu trabalho ou suas atividades diárias com o mesmo cuidado de sempre por causa de algum problema emocional (como se sentir triste, deprimido ou nervoso)?","q20":"Nas últimas 4 semanas, até que ponto sua saúde física ou problemas emocionais dificultaram suas atividades sociais habituais com a família, amigos, vizinhos ou outras pessoas?","q21":"Você sentiu dor em alguma parte do corpo nas últimas 4 semanas?","q22":"Nas últimas 4 semanas, até que ponto a dor dificultou seu trabalho habitual (incluindo trabalho fora de casa e tarefas domésticas)?","q23":"Nas últimas 4 semanas, com que frequência você se sentiu cheio de vitalidade?","q24":"Nas últimas 4 semanas, com que frequência você se sentiu muito nervoso?","q25":"Nas últimas 4 semanas, com que frequência você se sentiu tão desanimado que nada conseguia animá-lo?","q26":"Nas últimas 4 semanas, com que frequência você se sentiu calmo e tranquilo?","q27":"Nas últimas 4 semanas, com que frequência você teve muita energia?","q28":"Nas últimas 4 semanas, com que frequência você se sentiu desanimado e triste?","q29":"Nas últimas 4 semanas, com que frequência você se sentiu exausto?","q30":"Nas últimas 4 semanas, com que frequência você se sentiu feliz?","q31":"Nas últimas 4 semanas, com que frequência você se sentiu cansado?","q32":"Nas últimas 4 semanas, com que frequência sua saúde física ou problemas emocionais dificultaram suas atividades sociais (como visitar amigos ou familiares)?","q33":"Acho que fico doente mais facilmente do que outras pessoas","q34":"Sou tão saudável quanto qualquer outra pessoa","q35":"Acho que minha saúde vai piorar","q36":"Minha saúde é excelente"}},"interpersonal-relationships":{"title":"Relações interpessoais","description":"Este teste de autoavaliação convida você a explorar como lida com seus relacionamentos interpessoais, avaliando aspectos-chave como comunicação, empatia, confiança e resolução de conflitos. Seu objetivo é ajudá-lo a identificar pontos fortes e áreas para melhoria nas suas interações sociais.","questions":{"q1":"Eu me sinto apoiado pelas pessoas próximas a mim","q2":"Eu gosto de passar tempo com meus amigos e familiares","q3":"Acho fácil compartilhar meus pensamentos e sentimentos com os outros","q4":"Posso confiar nas pessoas ao meu redor","q5":"Sinto que as pessoas com quem me relaciono valorizam minha opinião","q6":"Sinto-me compreendido em meus relacionamentos pessoais","q7":"Sei como resolver conflitos sem prejudicar meus relacionamentos","q8":"Sinto-me à vontade para pedir ajuda quando preciso","q9":"Tenho relacionamentos saudáveis no meu ambiente de trabalho","q10":"Gosto de interações sociais, mesmo com pessoas novas","q11":"Sinto-me valorizado pelos meus colegas de trabalho","q12":"É fácil para mim estabelecer novos relacionamentos","q13":"Sou capaz de manter relacionamentos longos e satisfatórios","q14":"Sinto que posso ser eu mesmo com as pessoas próximas a mim","q15":"Sou capaz de perdoar os erros dos outros nos meus relacionamentos","q16":"Tenho a capacidade de ouvir e apoiar os outros quando precisam","q17":"Sinto-me à vontade para expressar minhas necessidades em um relacionamento","q18":"Tenho confiança em mim mesmo ao interagir com os outros","q19":"As pessoas na minha vida respeitam meus limites pessoais","q20":"Mantenho um equilíbrio saudável entre minha vida pessoal e profissional","q21":"Sinto-me aceito como sou pelas pessoas com quem me relaciono","q22":"Quando discuto com alguém, consigo resolver a situação de forma construtiva","q23":"Sinto que meus relacionamentos me trazem felicidade e satisfação","q24":"Não tenho problemas em pedir desculpas se cometi um erro","q25":"Acho fácil lidar com a frustração em situações sociais difíceis","q26":"As pessoas próximas a mim são afetuosas e compreensivas","q27":"Posso expressar minha frustração sem machucar os outros","q28":"Aprecio os pequenos gestos dos outros em meus relacionamentos","q29":"Sei como lidar com a rejeição de forma saudável","q30":"Sinto que posso expressar livremente meus pensamentos no trabalho sem medo de ser julgado","q31":"Me esforço para manter uma boa comunicação com as pessoas importantes na minha vida","q32":"Tenho confiança nas decisões que tomo em meus relacionamentos pessoais","q33":"Posso lidar com as mudanças nos meus relacionamentos sem me sentir sobrecarregado","q34":"Sinto que tenho apoio emocional quando passo por dificuldades pessoais","q35":"Acho fácil integrar novas pessoas ao meu círculo social"},"scores":{"lowScore":{"score":"Pontuação Baixa","description":"Suas relações interpessoais parecem ser limitadas ou insatisfatórias. Você pode estar enfrentando dificuldades de comunicação, confiança ou apoio emocional. Refletir sobre como melhorar essas áreas pode ser útil."},"mid-lowScore":{"score":"Pontuação Média-Baixa","description":"Suas relações são funcionais, mas há aspectos que poderiam ser melhorados. Às vezes, você tem dificuldade em expressar suas emoções ou lidar com conflitos, o que afeta a qualidade de algumas de suas relações."},"midScore":{"score":"Pontuação Média","description":"Você geralmente tem relações interpessoais satisfatórias, embora possa melhorar em aspectos como resolução de conflitos ou expressão de suas necessidades emocionais. No geral, suas relações são equilibradas."},"mid-highScore":{"score":"Pontuação Média-Alta","description":"Suas relações são bastante boas. Você se sente valorizado e apoiado pelos outros e lida bem com os conflitos. No entanto, pode haver pequenas áreas para trabalhar e melhorar ainda mais a qualidade de suas relações."},"highScore":{"score":"Pontuação Alta","description":"Você tem excelentes relações interpessoais. Sente-se completamente satisfeito e apoiado em suas relações, e possui a capacidade de lidar com conflitos e expressar suas necessidades de forma assertiva. Seu ambiente social e emocional é saudável e equilibrado."}}},"social-skills":{"title":"Competências sociais","description":"O Inventário de Habilidades Sociais foi desenvolvido para analisar como você lida com situações sociais e quão bem gerencia aspectos como comunicação, resolução de conflitos e expressão emocional.","questions":{"q1":"É fácil para você iniciar uma conversa com desconhecidos?","q2":"Você consegue expressar sua opinião quando discorda de alguém em uma discussão?","q3":"É fácil para você pedir ajuda quando precisa?","q4":"Você consegue dizer 'não' quando não quer fazer algo, sem se sentir culpado?","q5":"Você se sente confortável falando em público ou diante de um grupo de pessoas?","q6":"Você sabe como expressar desacordo sem criar conflito?","q7":"Você costuma elogiar outras pessoas pelo bom trabalho ou atitude?","q8":"É fácil para você expressar sentimentos positivos em relação aos outros?","q9":"Você consegue lidar com críticas de forma calma, sem reagir defensivamente?","q10":"Você tem confiança para resolver desacordos de forma respeitosa?","q11":"Você se sente confortável pedindo um aumento ou promoção no trabalho?","q12":"Você costuma tomar a iniciativa de falar com pessoas com quem gostaria de colaborar?","q13":"É fácil para você expressar frustração sem magoar os sentimentos dos outros?","q14":"Você consegue resolver conflitos interpessoais sem recorrer a terceiros?","q15":"Você se sente confortável pedindo feedback sobre seu desempenho no trabalho?","q16":"Você costuma expressar gratidão aos seus colegas de trabalho ou conhecidos?","q17":"Você se sente confortável estabelecendo limites quando outras pessoas invadem seu espaço ou tempo?","q18":"Você consegue lidar com diferenças de opinião sem se abalar emocionalmente?","q19":"É fácil para você oferecer apoio emocional a outros quando eles precisam?","q20":"Você se sente confortável falando sobre suas necessidades ou preocupações pessoais?","q21":"Você consegue aceitar elogios sem se sentir desconfortável?","q22":"Você toma decisões rapidamente em situações sociais desconfortáveis?","q23":"Você se sente capaz de resolver mal-entendidos sem evitar a confrontação?","q24":"Você costuma se envolver ativamente em conversas em grupo?","q25":"É fácil para você iniciar conversas com seus superiores ou chefes?","q26":"Você consegue pedir desculpas quando percebe que cometeu um erro?","q27":"Você tem confiança para expressar desacordo com um amigo próximo ou membro da família?","q28":"Você sabe como lidar com rejeição em situações sociais?","q29":"É fácil para você expressar preocupação quando vê alguém com dificuldades?","q30":"Você costuma agir de forma calma e construtiva em situações sociais estressantes?","q31":"Você consegue lidar com situações em que outros o contradizem sem perder a calma?","q32":"Você costuma reconhecer e expressar as contribuições positivas dos outros em grupo?","q33":"Você se sente capaz de pedir desculpas quando acha que suas palavras ou ações podem ter ofendido alguém?"},"scores":{"lowScore":{"score":"Pontuação Baixa","description":"Suas habilidades sociais estão abaixo do nível desejado. Você pode achar difícil interagir de maneira eficaz em diversas situações cotidianas. Pode ser útil desenvolver estratégias para melhorar suas habilidades sociais, como assertividade, empatia e gestão de conflitos."},"mid-lowScore":{"score":"Pontuação Média-Baixa","description":"Você tem algumas habilidades sociais, mas em certos contextos pode se sentir desconfortável ou encontrar dificuldades. Seria benéfico trabalhar em aspectos-chave."},"midScore":{"score":"Pontuação Média","description":"Suas habilidades sociais são adequadas, e você é capaz de gerenciar relações interpessoais na maioria das situações. Embora lide bem com interações sociais, ainda existem áreas em que você pode melhorar."},"mid-highScore":{"score":"Pontuação Média-Alta","description":"Suas habilidades sociais são bastante boas. Você se sai bem na maioria das situações sociais e gerencia interações complexas de forma eficaz. No entanto, pode trabalhar para refinar detalhes em algumas áreas específicas."},"highScore":{"score":"Pontuação Alta","description":"Você possui excelentes habilidades sociais. Sente-se confortável em uma ampla variedade de situações e gerencia relações interpessoais de forma eficaz e assertiva. Você é capaz de resolver conflitos, se comunicar claramente e demonstrar empatia pelos outros."}}},"health-data-agerestriction":"Disponível apenas para usuários entre 18 e 67 anos","health-data-colorwarning":"As cores são meramente indicativas e em nenhum caso devem ser interpretadas como avaliação clínica ou opinião profissional. \nSomente um médico poderá determinar se seus valores estão ou não dentro da normalidade ou indicar tratamento, se necessário.","work-environment":{"title":"Ambiente de trabalho","description":"Este teste de clima organizacional avalia a percepção dos funcionários sobre diversos aspectos do ambiente de trabalho, como comunicação, liderança, condições de trabalho e motivação. Através de 91 perguntas, ajuda a identificar pontos fortes e áreas de melhoria na organização","finalCompletedMessage":"Obrigado por concluir o teste de clima de trabalho. \n<br> <br> Os resultados, como qualquer outra informação pessoal na plataforma, são confidenciais e só são acessíveis quando apropriado pelo profissional de saúde que o atende, se ele decidir. \nLembramos que sua empresa recebe apenas dados agregados para o uso da plataforma e nunca recebe informações pessoais.","finalCompletedMessageAccessAgain":"Ele já concluiu o teste climático do trabalho este mês. \nVocê pode realizar uma avaliação após 4 meses.  \n<br> <br> Os resultados, como qualquer outra informação pessoal na plataforma são confidenciais e só são acessíveis quando apropriado pelo profissional de saúde que o atende, se ele decidir. \nLembramos que sua empresa recebe apenas dados agregados para o uso da plataforma e nunca recebe informações pessoais.","confidentialityWarning":"O ambiente de trabalho é um elemento cada vez mais relevante para o poço de pessoas. \nLembramos que suas respostas são confidenciais e que a pesquisa só pode ser concluída no máximo 4 vezes por ano.","dimensions":{"social-interaction":"Interação social","communication":"Comunicação","work-conditions":"Condições de trabalho","risk-prevention":"Prevenção de riscos ocupacionais","satisfaction":"Reconhecimento, satisfação e pertencimento","wage":"Remuneração","promotion":"Promoção","formation":"Formação","leadership":"Liderança","autonomy":"Autonomia e inovação","client-orientation":"Orientação ao cliente (externo e interno)","organization":"Organização","motivation":"Motivação"},"questions":{"q1":"Acredito que há um bom ambiente de trabalho.","q2":"Recebo colaboração de pessoas de outros departamentos.","q3":"Recebo colaboração de meus colegas de departamento.","q4":"As pessoas com quem me relaciono na organização agem com respeito e ética.","q5":"Meu relacionamento com meu chefe é bom.","q6":"Há muita mobilidade e mudanças de cargo entre meus colegas.","q7":"Tenho acesso a informações sobre o catálogo de produtos e serviços da organização.","q8":"A comunicação sobre os resultados e o andamento da empresa é clara e transparente.","q9":"A comunicação interna na organização é uma atividade contínua e planejada.","q10":"Conheço o Código de Ética e Conduta da organização.","q11":"Tenho acesso a informações sobre a organização e sua evolução em todas as localidades.","q12":"Os comunicados internos me fornecem informações úteis.","q13":"É fácil me comunicar com diretores ou funcionários de outras áreas administrativas.","q14":"Tenho os materiais e recursos necessários para realizar meu trabalho.","q15":"As condições de espaço, conforto, ruído, temperatura, iluminação, minha cadeira, o filtro da tela do computador e sua altura me permitem desempenhar meu trabalho normalmente.","q16":"As áreas de trabalho são mantidas limpas e organizadas, permitindo a realização das atividades para as quais foram destinadas.","q17":"Há instalações sanitárias e áreas de descanso suficientes.","q18":"Existe um protocolo de primeiros socorros definido e há meios para realizá-lo.","q19":"A organização se preocupa com meu nível de estresse e me fornece meios e ferramentas para gerenciá-lo.","q20":"A carga mental do trabalho e o estresse são um problema para mim.","q21":"Há espaços, além da cafeteria, onde posso relaxar e recuperar minha capacidade de continuar desempenhando meu trabalho.","q22":"Tenho orgulho de trabalhar para a organização.","q23":"Considero adequados e importantes os projetos de Responsabilidade Social implementados em meu país.","q24":"Sinto-me parte do projeto da organização.","q25":"Acho que a organização é um bom lugar para trabalhar e gostaria de continuar trabalhando aqui.","q26":"Compreendo e compartilho os valores da empresa.","q27":"Sinto-me valorizado pela organização.","q28":"Recebo informações sobre os elementos que compõem meu salário (salário base mais benefícios).","q29":"Estou satisfeito com os benefícios sociais oferecidos pela organização.","q30":"Acredito que meu trabalho é bem remunerado.","q31":"Acho que meu salário está de acordo com os salários dentro da organização.","q32":"Acredito que meu salário é compatível com a situação econômica e o desempenho da organização.","q33":"Acredito que, se eu fizer bem o meu trabalho, tenho a possibilidade de ser promovido na organização.","q34":"Acredito que tenho a oportunidade de me desenvolver profissionalmente na organização.","q35":"Ao assumir um novo cargo na organização, meu supervisor me informa claramente sobre as funções e responsabilidades do cargo.","q36":"Tenho autonomia para realizar meu trabalho.","q37":"Tenho acesso a informações sobre vagas disponíveis na empresa.","q38":"As promoções internas são realizadas de maneira justa.","q39":"Considero adequados os critérios de avaliação de desempenho na organização.","q40":"Recebo treinamento para atualizar meus conhecimentos no trabalho.","q41":"Os planos de formação da organização atendem às minhas necessidades de desenvolvimento profissional.","q42":"A organização oferece cursos de gestão do estresse e da carga mental do trabalho aos funcionários.","q43":"Recebo treinamento para desenvolvimento pessoal e gestão de talentos.","q44":"Meu supervisor se preocupa em manter um bom ambiente na equipe.","q45":"A liderança incentiva o trabalho em equipe.","q46":"Meu supervisor me elogia quando realizo bem meu trabalho.","q47":"Meu supervisor ouve minhas opiniões e me envolve na tomada de decisões.","q48":"Meu supervisor se preocupa em transmitir os valores, a missão e os objetivos da organização.","q49":"Tenho um bom relacionamento com meu supervisor.","q50":"Meu supervisor acompanha meu Plano de Desenvolvimento Individual.","q51":"Meu supervisor me trata de maneira justa e evita qualquer tipo de favoritismo.","q52":"Meu supervisor respeita as diferenças de cultura, gênero, religião, etc.","q53":"Meu supervisor me fornece periodicamente informações sobre meu desempenho.","q54":"Meu supervisor se preocupa em conhecer minhas necessidades e interesses.","q55":"Meu supervisor é uma referência na empresa.","q56":"Meu supervisor é claro e específico ao definir meus objetivos de trabalho ou os do departamento.","q57":"A diretoria tem expectativas realistas em relação aos resultados do trabalho.","q58":"Os funcionários confiam em qualquer decisão tomada pela diretoria.","q59":"O nível de exigência do meu chefe é adequado.","q60":"Sinto que trabalho em equipe com meu chefe.","q61":"Posso tomar minhas próprias decisões sem precisar consultar meu chefe.","q62":"A organização inova e melhora continuamente para ser a líder em seu setor.","q63":"Os funcionários são incentivados a buscar novas formas de resolver problemas.","q64":"A diretoria está aberta a sugestões e conselhos dos funcionários.","q65":"A empresa valoriza e aprecia ideias.","q66":"A empresa busca mudanças para manter sua competitividade.","q67":"Meu trabalho é suficientemente variado.","q68":"Os processos e procedimentos de trabalho na organização me orientam para a satisfação do cliente interno/externo.","q69":"Falei com familiares e amigos sobre as vantagens de contratar os serviços da organização.","q70":"Estou disposto a fazer um esforço extra para satisfazer meu cliente interno ou externo.","q71":"A documentação (procedimentos, instruções e formatos) incluída no Sistema de Gestão da Qualidade é útil e apropriada para a realização do meu trabalho.","q72":"Recebo a ajuda necessária do departamento Jurídico.","q73":"Recebo a ajuda necessária do departamento de Compras.","q74":"Recebo a ajuda necessária do departamento de RH da organização.","q75":"Recebo a ajuda necessária do departamento Comercial/Marketing.","q76":"Recebo a ajuda necessária do departamento Financeiro.","q77":"Recebo a ajuda necessária do departamento de TI.","q78":"Acredito que os valores da organização refletem o estilo de trabalho da empresa.","q79":"Desde que entrei na empresa, acredito que a organização se tornou um lugar melhor para trabalhar.","q80":"Acredito que a maioria dos planos de ação derivados da pesquisa de satisfação anterior foi cumprida.","q81":"Compreendo como meu trabalho contribui para alcançar os resultados do meu departamento.","q82":"Minhas competências profissionais estão alinhadas com as tarefas e responsabilidades atribuídas.","q83":"Tenho a oportunidade de propor novos projetos ou novas formas de realizar o trabalho.","q84":"Tenho as informações necessárias para realizar meu trabalho com excelência.","q85":"A organização me dá a oportunidade de trabalhar em projetos ou atividades que representam novos desafios.","q86":"Tenho clareza sobre minhas tarefas e responsabilidades.","q87":"Meu trabalho me proporciona desafios e oportunidades para continuar melhorando.","q88":"Meu trabalho é reconhecido e valorizado.","q89":"Atualmente, estou satisfeito com meu trabalho na organização.","q90":"No desempenho de minhas funções, utilizo regularmente a documentação incluída no Sistema de Gestão da Qualidade.","q91":"Recebi o treinamento necessário para desempenhar minhas funções atuais."}},"physical-health":"Saúde física","mental-health":"Saúde mental","congratulations":"Parabéns"}}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = {"sgsi-policy":{"title":"Política SGSI","text":"<p>Open HealthCare S.L. \nestá ciente da importância da segurança da informação,\n\nespecialmente aquela relativa a funcionários, clientes e processos de negócios, implementou\n\num sistema de gestão de informação baseado na norma ISO 27001:</p>\n\n\n<p>Com o objetivo de desenvolver o compromisso expresso da Organização na melhoria contínua\n\ndo sistema de gestão, a Administração estabelece os seguintes princípios de gestão de\n\nsegurança da informação:</p>\n\n\n<ul>\n  \n<li>\n    \n<p>Conhecimento e aplicação por todos os funcionários e colaboradores, conforme\n    \nseu papel dentro da Empresa, políticas e procedimentos de segurança, tanto\n    \ngerais e aquelas que podem ser aplicadas a grupos específicos, incluindo:</p>\n    \n<span>\n      \n<ul>\n          \n<li><p>Controle de acesso, abertura e fechamento de instalações.</p></li>\n          \n<li><p>Informação e tratamento das visitas às instalações.</p></li>\n          \n<li><p>Treinamento, conscientização e motivação em segurança.</p></li>\n          \n<li><p>Conhecimento de funções e responsabilidades.</p></li>\n          \n<li><p>Gerenciamento de continuidade de negócios.</p></li>\n          \n<li><p>Consequências do não cumprimento das políticas de segurança.</p></li>\n          \n<li><p>Apoio na gestão da segurança da informação.</p></li>\n          \n<li><p>Conformidade com a legislação.</p></li>\n          \n<li><p>Manual de boas práticas do usuário.</p></li>\n      \n</ul>\n    \n</span>\n  \n</li>\n  \n<li>\n    \n<p>Diligência por parte de todos os funcionários e colaboradores na comunicação de\n    \npossíveis incidentes de segurança.</p>\n  \n</li>\n  \n<li>\n    \n<p>É necessário garantir que os procedimentos que determinam o\n    \nconfidencialidade, integridade, disponibilidade, rastreabilidade e autenticidade do\n    \ninformações.</p>\n  \n</li>\n  \n<li>\n    \n<p>Apoio à estrutura organizacional de segurança estabelecida para cumprir os objetivos\n    \ncontrole de segurança da informação e gerenciamento contínuo de riscos.</p>\n  \n</li>\n  \n<li>\n    \n<p>Garantir o uso correto das instalações e equipamentos para que\n    \nestão de acordo com a atividade e objetivos da organização.</p>\n  \n</li>\n  \n<li>\n    \n<p>Compromisso com a proteção da segurança e saúde dos seus trabalhadores, bem como\n    \nimplementar um ambiente de trabalho adequado.</p>\n  \n</li>\n  \n<li>\n    \n<p>Estruture nosso sistema de gestão para que seja fácil de entender.</p>\n  \n</li>\n\n</ul>\n    \n<p>A gestão do nosso sistema é confiada ao responsável pela Gestão e pelo sistema\n    \nestará disponível em nosso sistema de informação em um repositório, que poderá ser acessado\n    \nacesso de acordo com os perfis de acesso concedidos de acordo com nosso procedimento atual\n    \ngerenciamento de acesso.</p>\n\n    \n<p>Esta política é complementada pelas demais políticas, procedimentos e\n    \ndocumentos em vigor para desenvolver nosso sistema de gestão.</p>\n\n    \n<p>Estes princípios são assumidos pela Administração, que dispõe dos meios necessários\n    \npara sua implementação e são comunicados para cumprimento por todos os funcionários e\n    \ncolaboradores da empresa através desta Política de Segurança da empresa\n    \nInformações.</p>"}}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = {"chats":{"chat":"Chat","patients":"Pacientes","professionals":"Profissionais","contact-patient":"Entre em contato com o paciente","contact-prof":"Contate profissional | Interconsulta","new-message":"Escreva uma mensagem...","delete-message":"Deseja excluir a mensagem?","delete-message-success":"Mensagem excluída com sucesso","edit-message-success":"Mensagem editada com sucesso","cant-upload-file":"Não foi possível enviar o arquivo","delete":"Eliminar","select-patient":"Selecione um paciente","attach-file":"Anexar arquivo/documento","select-file-type":"Selecione o tipo de arquivo","administrative-chat":"Chat administrativo (sem consulta)","select-prof":"Selecione um profissional","finish-chat":"Encerrar chat","finish-chat-message-success":"Consulta concluída com sucesso","finish-chat-message":"Quer encerrar a consulta?","finished-chats":"Chats encerrados","cancel-chat":"Cancelar bate-papo","cancel-chat-message":"Deseja cancelar a consulta?","emit-eprescription":"Emitir prescrição eletrônica","emit-eprescriptionMessage":"Em seguida, você será redirecionado para a plataforma de prescrição eletrônica.<br><br><strong>Lembre-se que antes de consolidar a consulta deverá emitir a receita nessa plataforma, pois não pode ser feita a posteriori.</strong>","unread-messages":"mensagens não lidas","unread-message":"mensagem não lida","view-all":"Veja tudo","select-file":"Selecione um arquivo","ask-for-new-chat":"Solicite novo bate -papo","no-active-chat":"Não tem nenhum chat ativo"}}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = {"survey":"Enquete","surveys":{"not-avaliable":"Pesquisa não disponível","not-allowed":"Você não tem permissão para acessar esta pesquisa.","loading":"Pesquisa de carregamento ...","completed":"Pesquisa concluída","percentage-completed":"% preenchido","mandatory":"A avaliação é obrigatória","comment-review":"Adicione um comentário ... (opcional)","finish":"Terminar","following":"Seguindo","error":{"error-loading":"Erro ao carregar a pesquisa. \nPor favor, tente novamente mais tarde.","error-send":"Erro ao enviar a pesquisa. \nPor favor, tente novamente mais tarde."},"info":{"error-finish":"Você deve responder a todas as perguntas antes de terminar."},"congratulations":"Parabéns","finishText":"Clique no botão 'Acabamento' para enviar os resultados da pesquisa","completed2":"Obrigado por concluir a pesquisa","opensalud-go":"Vá para OpenSalud","close-dialog":"Esta janela será fechada automaticamente em 5 segundos","start":"Iniciar o Survey"}}

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_roles__ = __webpack_require__(100);

/* import routeHelpers from '@/router/routeHelpers' */


var routes = [{
  path: '/',
  name: 'Video',
  component: function component() {
    return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 2335));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('videoSession');
      }
    },
    roles: [__WEBPACK_IMPORTED_MODULE_1__constants_roles__["f" /* PATIENT_ROLE */], __WEBPACK_IMPORTED_MODULE_1__constants_roles__["h" /* PROFESSIONAL_ROLE */]]
  }
}, {
  path: 'test',
  name: 'Test',
  component: function component() {
    return __webpack_require__.e/* import() */(24/* duplicate */).then(__webpack_require__.bind(null, 1268));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('dialog-title-videoTest');
      }
    }
  }
}, {
  path: 'test/:token',
  name: 'TestToken',
  component: function component() {
    return __webpack_require__.e/* import() */(24/* duplicate */).then(__webpack_require__.bind(null, 1268));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('dialog-title-videoTest');
      }
    }
  }
}, {
  path: 'error',
  name: 'Error',
  component: function component() {
    return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 2326));
  },
  meta: {
    title: {
      text: 'Error'
    }
  }
}, {
  path: 'support-chat',
  name: 'SupportChatVideo',
  component: function component() {
    return __webpack_require__.e/* import() */(27/* duplicate */).then(__webpack_require__.bind(null, 1240));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('support-chat');
      }
    }
  }
}, {
  path: ':token',
  name: 'VideoToken',
  component: function component() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 2336));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('videoSession');
      }
    }
  }
}];

routes.forEach(function (o) {
  return o.meta.footer = { disabled: true };
});

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-alert',
  components: {
    'b-alert': __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* BAlert */]
  },
  data: function data() {
    return {
      dismissCountDown: 0
    };
  },

  props: {
    value: {
      type: Boolean,
      required: false,
      default: true
    },
    variant: {
      type: String,
      required: true,
      default: null
    },
    time: {
      type: Number,
      required: false,
      default: 6
    }
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.value ? this.time : 0;
      },
      set: function set(val) {
        this.$emit('input', val > 0);
      }
    }
  }
});

/***/ }),
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_element_loading__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_element_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_element_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_colours__ = __webpack_require__(42);
//
//
//
//




var VELMLD_PARENT_CLASS = 'velmld-parent';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading-anim',
  components: {
    VueElementLoading: __WEBPACK_IMPORTED_MODULE_0_vue_element_loading___default.a
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: '110'
    },
    spinner: {
      type: String,
      required: false,
      default: 'ring'
    },
    fullScreen: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: false
    },
    toggleParentClass: {
      type: Boolean,
      required: false,
      default: false
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'rgba(255, 255, 255, 0.85)'
    }
  },
  data: function data() {
    return {
      getPrimaryColour: __WEBPACK_IMPORTED_MODULE_1__constants_colours__["o" /* getPrimaryColour */]
    };
  },

  watch: {
    active: function active(val) {
      if (this.toggleParentClass && !val) {
        var parent = document.querySelector('.' + VELMLD_PARENT_CLASS);
        parent.classList.remove(VELMLD_PARENT_CLASS);
      }
    }
    /* mounted () {
      document.querySelector('.velmld-parent').style.backgroundColor = 'rgba(255, 255, 255, 0.5)'
    } */
  } });

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_LoadingAnim_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_icons_ArrowIcon_vue__ = __webpack_require__(1239);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paginated-table',
  components: {
    BTable: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_49" /* BTable */],
    BRow: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_45" /* BRow */],
    BCol: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["i" /* BCol */],
    'loading-anim': __WEBPACK_IMPORTED_MODULE_1__utils_LoadingAnim_vue__["default"],
    BPagination: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_41" /* BPagination */],
    ArrowIcon: __WEBPACK_IMPORTED_MODULE_2__components_base_icons_ArrowIcon_vue__["a" /* default */]
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    emptyText: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('table.no-results');
      }
    },
    showCaption: {
      type: Boolean,
      required: false,
      default: function _default() {
        return !this.$uiHelpers.isMobile;
      }
    },
    emptyFilteredText: {
      type: String,
      default: function _default() {
        return this.$t('noMatchingElements');
      }
    },
    filter: [Array, Object, String, RegExp],
    filterIncludedFields: Array,
    filterFn: Function,
    stacked: [String, Boolean],
    itemsPerPage: {
      type: Number,
      required: false,
      default: function _default() {
        return this.stacked ? 3 : 5;
      }
    }
  },
  created: function created() {
    if (this.stacked) {
      this.localFields = this.fields.filter(function (item) {
        return !item.hiddenStacked;
      });
    } else {
      this.localFields = this.fields;
    }
  },
  data: function data() {
    return {
      id: null,
      currentPage: 1,
      arrowColor: '#8A8A8A',
      filteredCount: 0,
      localFields: []
    };
  },

  computed: {
    rows: function rows() {
      return this.filter ? this.filteredCount : this.items.length;
    },
    paginationLabelData: function paginationLabelData() {
      var firstOfPage = this.currentPage === 1 ? 1 : (this.currentPage - 1) * this.itemsPerPage;
      return {
        firstOfPage: firstOfPage,
        lastOfPage: firstOfPage === 1 ? this.rows > this.itemsPerPage ? this.itemsPerPage : this.rows : firstOfPage + this.itemsPerPage,
        totalItems: this.rows
      };
    }
  },
  methods: {
    filtered: function filtered(filteredItems) {
      this.filteredCount = filteredItems.length;
    },
    showTableCell: function showTableCell(slotName) {
      return slotName.includes('cell') && !slotName.includes('actionsMobile') || slotName.includes('actionsMobile') && this.stacked;
    }
  },
  mounted: function mounted() {
    this.id = 'paginated-table-' + this._uid.toString();
  }
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'arrow-icon',
  props: ['color']
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-card',
  components: {
    BTooltip: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_51" /* BTooltip */]
  },
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    info: { // Nueva prop para mostrar info
      type: String,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    titleClass: {
      type: String,
      required: false,
      default: ''
    },
    hideTitle: Boolean,
    overflowVisible: Boolean,
    flowRoot: Boolean,
    marginBottom: {
      type: Number,
      default: 3
    },
    hideNeuCardClass: Boolean,
    hideButtons: Boolean
  },
  data: function data() {
    return {
      showInfo: false
    };
  },

  computed: {
    hasTitle: function hasTitle() {
      return this.title || this.$slots.title;
    },
    hasRightButtonSlot: function hasRightButtonSlot() {
      return !!this.$slots['right-button'];
    },
    baseContainerClass: function baseContainerClass() {
      var carFlowRoot = this.flowRoot ? 'card-flow-root' : null;
      var marginBottom = 'mb-' + this.marginBottom;
      return [carFlowRoot, marginBottom];
    }
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_vue_select__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_transitions__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popperjs_core__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-select',
  components: {
    SlideYUpTransition: __WEBPACK_IMPORTED_MODULE_1_vue2_transitions__["a" /* SlideYUpTransition */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["t" /* BFormInvalidFeedback */]
  },
  props: {
    value: [String, Object, Boolean, Number],
    placeholder: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('base-select.select-option');
      }
    },
    options: Array,
    filterable: {
      type: Boolean,
      required: false,
      default: false
    },
    valueSearch1: {
      type: String,
      required: false
    },
    attributeSearch1: {
      type: String,
      required: false
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'label'
    },
    loading: {
      type: Boolean,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    disabledText: {
      type: String,
      required: false,
      default: null
    },
    valueProp: {
      type: String,
      required: false,
      default: 'value'
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDropdownPlacement: {
      type: Boolean,
      required: false,
      default: false
    },
    clean: {
      type: Boolean,
      required: false,
      default: false
    },
    dataAttributes: {
      type: Array,
      required: false,
      default: null
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('base-select.errorMsg');
      }
    },
    insideDiv: {
      type: Boolean,
      required: false,
      default: false
    },
    avoidDefaultSort: Boolean,
    reduce: Function,
    filter: Function,
    noOptionsTitle: String,
    selectAttributes: {
      type: Object,
      required: false,
      default: null
      // dropdownShouldOpen: {
      //   type: Function,
      //   required: false
      // }
    } },
  data: function data() {
    return {
      uid: null,
      placement: 'top',
      localOptions: []
    };
  },

  methods: {
    onChangeRun: function onChangeRun() {
      this.uid = this._uid.toString();
      // Add CSS rule to hide .vs-search div inside selected option
      /* const style = document.createElement('style')
      document.head.appendChild(style)
      const sheet = style.sheet
      var styles = `#vs${this.uid}__combobox input.vs__search { position: absolute; !important }`
      sheet.insertRule(styles, 0) */
    },
    mapSelectedOption: function mapSelectedOption(option) {
      if (option === null) {
        return null;
      }
      var mappedOpt = {};
      mappedOpt.label = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.options.find(function (element) {
        return element.value === option.toString() || element.value === option;
      }), this.label);
      mappedOpt.value = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.options.find(function (element) {
        return element.value === option.toString() || element.value === option;
      }), this.valueProp);
      return mappedOpt;
    },
    mapOption: function mapOption(option) {
      if (option === null) {
        return null;
      }
      var mappedOpt = {};
      mappedOpt.label = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(option, this.label);
      mappedOpt.value = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(option, this.valueProp);
      return mappedOpt;
    },
    calcPositionWithPopper: function calcPositionWithPopper(dropdownList, component, _ref) {
      var width = _ref.width;

      dropdownList.style.width = width;
      var popper = Object(__WEBPACK_IMPORTED_MODULE_3__popperjs_core__["a" /* createPopper */])(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [{
          name: 'offset',
          options: {
            offset: [0, -1]
          }
        }, {
          name: 'toggleClass',
          enabled: true,
          phase: 'write',
          fn: function fn(_ref2) {
            var state = _ref2.state;

            component.$el.classList.toggle('drop-up', state.placement === 'top');
          }
        }]
      });
      return function () {
        return popper.destroy();
      };
    },
    createDataAttributes: function createDataAttributes() {
      var input = document.querySelector('#vs' + this.uid + '__combobox input');
      if (this.dataAttributes) {
        this.dataAttributes.forEach(function (item) {
          input.dataset[item.key] = item.value;
        });
      }
    },
    closeDropdown: function closeDropdown() {
      this.$refs[this.uid].open = false;
    },
    onClickPrevent: function onClickPrevent(e) {
      if (this.disabledText) {
        this.$store.dispatch('showInfoAlert', { text: this.disabledText });
        this.$refs[this.uid].open = false;
      }
    }
  },
  computed: {
    isLoading: function isLoading() {
      return this.loading !== null ? this.loading : !this.options || this.options.length === 0;
    },
    hasOptionSlot: function hasOptionSlot() {
      return !!this.$slots.option;
    },

    localValue: {
      get: function get() {
        var _this = this;

        if (!this.options) return null;
        var option = this.options.find(function (option) {
          return option[_this.valueProp] === _this.value;
        });
        if (!option) {
          if (this.options.length > 0 && this.value !== null) {
            this.$emit('input', null);
            this.$emit('change', null);
          }
          return null;
        }
        this.onChangeRun();
        return this.mapOption(option);
      },
      set: function set(value) {
        this.$emit('input', value ? value.value : value);
        this.$emit('change', value ? value.value : value);
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.uid = this._uid.toString();

    // Add CSS rule to hide .vs-search div inside selected option
    if (this.insideDiv) {
      var style = document.createElement('style');
      document.head.appendChild(style);
      var sheet = style.sheet;
      var styles = '#vs' + this.uid + '__combobox input.vs__search { position: absolute; !important }';
      sheet.insertRule(styles, 0);
    }
    /* this.localValue = this.mapOption(this.value)
    this.localValue = this.mapSelectedOption(this.value) */
    /* this.$watch('value', (value, old) => {
      if (!old || (value && old.value !== value.value)) {
        this.localValue = this.mapOption(value)
      }
    }) */
    this.localOptions = this.options.map(function (item) {
      return _this2.mapOption(item);
    });
    this.$watch('options', function (value) {
      if (!value) return [];
      var valueMapped = value.map(function (item) {
        return _this2.mapOption(item);
      });
      _this2.localOptions = !value ? [] : _this2.avoidDefaultSort ? valueMapped : valueMapped.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      // if (!this.localOptions.some(item => item.value === (this.localValue ? this.localValue.value : this.localValue))) this.localValue = null
    });
  },
  mounted: function mounted() {
    this.createDataAttributes();
    // this.localValue = this.clearable === true ? null : this.localValue
  }
});

/***/ }),
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */],
    BSpinner: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_47" /* BSpinner */]
  },
  data: function data() {
    return {
      internalTextColor: null,
      lastInternalTextColor: null
    };
  },

  props: {
    variant: {
      type: String
    },
    blue: Boolean,
    white: Boolean,
    red: Boolean,
    gray: Boolean,
    outline: Boolean,
    negative: Boolean,
    shadow: Boolean,
    pseudoShadow: Boolean,
    transparent: Boolean,
    size: String,
    href: String,
    textColor: String,
    backgroundColor: String,
    borderColor: String,
    fitContent: Boolean,
    bold: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: String,
    iconColor: String,
    noHoverStyles: Boolean
  },
  computed: {
    id: function id() {
      return 'base-button-' + this._uid;
    },
    getVariant: function getVariant() {
      return (this.outline ? 'outline-' : '') + (this.variant ? this.variant : this.getVariantFromProps());
    },
    getOverridenStyles: function getOverridenStyles() {
      var styles = {};

      if (this.backgroundColor) {
        styles['background-color'] = '' + this.backgroundColor;
      }
      if (this.borderColor) {
        styles.border = '1px solid ' + this.borderColor + ' !important';
      }
      if (this.textColor) {
        styles['color'] = this.textColor + ' !important';
      }
      return styles;
    },
    darkenOnHover: function darkenOnHover() {
      return this.backgroundColor === __WEBPACK_IMPORTED_MODULE_1__constants_colours__["c" /* BLUE_COLOUR */] && this.textColor === __WEBPACK_IMPORTED_MODULE_1__constants_colours__["m" /* WHITE_COLOUR */];
    },
    hrefIsRelativePath: function hrefIsRelativePath() {
      return this.href && this.href.startsWith('/');
    }
  },
  methods: {
    getVariantFromProps: function getVariantFromProps() {
      var variant = 'primary';
      if (this.white) {
        variant = 'secondary';
      } else if (this.red) {
        variant = 'danger';
      } else if (this.gray) {
        variant = 'info';
      } else if (this.transparent) {
        variant = 'light';
      }
      return variant;
    },
    click: function click(e) {
      if (this.hrefIsRelativePath) {
        this.$router.push(this.href);
      } else if (this.href) {
        window.location.href = this.href;
      } else {
        this.$emit('click', e);
      }
    },
    getTextColorFromButton: function getTextColorFromButton() {
      // Get the color CSS property value from the button
      var button = document.getElementById(this.id);
      return button ? window.getComputedStyle(button).color : '';
    },
    updateInternalTextColor: function updateInternalTextColor() {
      var _this = this;

      // Do it in next tick
      this.$nextTick(function () {
        _this.lastInternalTextColor = _this.internalTextColor;
        _this.internalTextColor = _this.getTextColorFromButton();
      });
    }
  },
  watch: {
    getVariant: function getVariant(newValue) {
      this.updateInternalTextColor();
    },
    textColor: function textColor(newValue, oldValue) {
      this.lastInternalTextColor = oldValue;
      this.internalTextColor = newValue;
    },
    getOverridenStyles: function getOverridenStyles(newValue) {
      this.updateInternalTextColor();
    }
  },
  mounted: function mounted() {
    if (this.icon) {
      this.internalTextColor = this.getTextColorFromButton();
    }
  }
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-textarea',
  components: {
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */],
    BFormTextarea: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["A" /* BFormTextarea */]
  },
  props: {
    value: String,
    rows: {
      type: Number,
      required: false,
      default: null
    },
    maxRows: {
      type: Number,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    maxlength: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('appointment-notes.write-here');
      }
    },
    noResize: Boolean,
    readOnly: Boolean
  },
  data: function data() {
    return {
      id: null,
      localValue: null
    };
  },
  mounted: function mounted() {
    this.id = this._uid.toString();
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('value', function (value) {
      _this.localValue = value;
    });
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
      _this.$emit('change', value);
    });
  }
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_forms_BaseCheckbox__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cookies_helpers__ = __webpack_require__(182);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-dialog',
  components: {
    BModal: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_32" /* BModal */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */],
    BaseCheckbox: __WEBPACK_IMPORTED_MODULE_1__components_base_forms_BaseCheckbox__["default"]
  },
  props: {
    value: [Boolean],
    title: {
      type: String,
      required: false,
      default: null
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    okFn: {
      type: Function,
      required: false,
      default: null
    },
    cancelFn: {
      type: Function,
      required: false,
      default: null
    },
    okBtnVariant: {
      type: String,
      required: false,
      default: 'primary'
    },
    okBtnText: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('dialog.ok-button');
      }
    },
    cancelBtnVariant: {
      type: String,
      required: false,
      default: 'danger'
    },
    cancelBtnText: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('dialog.cancel-button');
      }
    },
    dontShowAgainCookie: {
      type: String,
      required: false
    },
    dontShowAgainCookieExpirationDays: {
      type: Number,
      required: false,
      default: 365
    },
    keepOpened: {
      type: Boolean,
      required: false,
      default: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    okBtnVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      required: false,
      default: 'lg',
      validator: function validator(value) {
        return ['sm', 'md', 'lg', 'xl'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      localValue: false,
      dontShowAgainChecked: false
    };
  },

  methods: {
    builtInOkFn: function builtInOkFn() {
      if (this.okFn) {
        this.okFn();
      }
      this.processDontShowAgainCookie();
      this.localValue = this.keepOpened || false;
      this.$store.commit('hideSharedDialog');
    },
    builtInCancelFn: function builtInCancelFn() {
      if (this.cancelFn) {
        this.cancelFn();
      }
      if (!this.okBtnVisible) {
        this.processDontShowAgainCookie();
      }
      this.localValue = this.keepOpened || false;
      this.$store.commit('hideSharedDialog');
    },
    processDontShowAgainCookie: function processDontShowAgainCookie() {
      if (this.dontShowAgainChecked) {
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cookies_helpers__["e" /* setCookie */])(this.dontShowAgainCookie, true, this.dontShowAgainCookieExpirationDays);
      }
    }
  },
  computed: {
    cancelDisabled: function cancelDisabled() {
      return !this.cancelFn;
    }
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value && Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cookies_helpers__["b" /* getCookie */])(this.dontShowAgainCookie) !== 'true';
    this.$watch('value', function (value) {
      _this.localValue = value && Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cookies_helpers__["b" /* getCookie */])(_this.dontShowAgainCookie) !== 'true';
    });
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
      _this.$emit('change', value);
    });
  }
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//



var messages = {
  es: {
    'base-checkbox': {
      'error-msg': 'Debe marcar la casilla'
    }
  },
  en: {
    'base-checkbox': {
      'error-msg': 'You must check the box'
    }
  },
  pt: {
    'base-checkbox': {
      'error-msg': 'Você deve marcar a caixa'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BFormCheckbox: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["n" /* BFormCheckbox */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */]
  },
  i18n: {
    messages: messages
  },
  props: {
    value: [String, Object, Boolean],
    onInput: {
      type: Function,
      required: false,
      default: function _default() {}
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('base-checkbox.error-msg');
      }
    },
    noMargin: Boolean
  },
  data: function data() {
    return {
      localValue: null
    };
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
    });
    this.$watch('value', function (value) {
      _this.localValue = value;
    });
  }
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_LoadingAnim__ = __webpack_require__(67);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BModal: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_32" /* BModal */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */],
    LoadingAnim: __WEBPACK_IMPORTED_MODULE_1__components_utils_LoadingAnim__["default"]
  },
  props: {
    value: [Boolean],
    title: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    hideClose: {
      type: Boolean,
      required: false,
      default: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'lg',
      validator: function validator(value) {
        return ['sm', 'md', 'lg', 'xl'].includes(value);
      }
    },
    bodyClass: String,
    titleAlignLeft: Boolean,
    noCloseOnBackdrop: Boolean,
    noCloseOnScape: Boolean
  },
  data: function data() {
    return {
      localValue: false
    };
  },

  computed: {
    isVisible: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    footerSlotExists: function footerSlotExists() {
      return this.$slots['modal-footer'];
    }
  }
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_forms_VuelidateError__ = __webpack_require__(969);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var compName = 'base-datepicker';
var MONDAY_START_ID = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BFormDatepicker: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["p" /* BFormDatepicker */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    VuelidateError: __WEBPACK_IMPORTED_MODULE_1__components_base_forms_VuelidateError__["a" /* default */],
    BInputGroupAppend: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_26" /* BInputGroupAppend */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["s" /* BFormInput */]
  },
  props: {
    value: [Date, String],
    label: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('datepicker-ph');
      }
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('labelNoDateSelected');
      }
    },
    validator: {
      type: Object,
      required: false,
      default: null
    },
    parentValidators: {
      type: Object,
      required: false,
      default: null
    },
    dateBeforeNow: Boolean,
    dateAfterNow: Boolean,
    right: Boolean,
    resetButtton: Boolean,
    noMarginBottom: Boolean,
    min: [Date, String],
    max: [Date, String]
  },
  data: function data() {
    return {
      id: null,
      localValue: null,
      dateFormatOptions: { day: 'numeric', month: 'numeric', year: 'numeric' },
      formatted: '',
      selected: '',
      MONDAY_START_ID: MONDAY_START_ID
    };
  },
  mounted: function mounted() {
    this.id = '' + compName + this._uid.toString();
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
    });
    this.$watch('value', function (value) {
      _this.localValue = value;
    });
  },

  methods: {
    onContext: function onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    }
  }
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuelidateError_vue__ = __webpack_require__(970);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52dc9e16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuelidateError_vue__ = __webpack_require__(1572);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1570)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuelidateError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52dc9e16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuelidateError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/VuelidateError.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52dc9e16", Component.options)
  } else {
    hotAPI.reload("data-v-52dc9e16", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//



var messages = {
  es: {
    'vuelidate': {
      'errors': {
        'required': 'Este campo es obligatorio',
        'minLength': 'Este campo debe tener al menos {value} caracteres',
        'maxLength': 'Este campo no debe tener más de {value} caracteres',
        'minValue': 'Este campo debe tener un valor mayor o igual a {value}',
        'email': 'Este campo debe ser un email válido',
        'numeric': 'Este campo debe ser numérico',
        'afterToday': 'La fecha debe ser posterior a hoy',
        'afterDate': 'La fecha debe ser posterior a {value}',
        'beforeDate': 'La fecha debe ser anterior a {value}',
        'beforeToday': 'La fecha debe ser anterior a hoy',
        'sameAsPassword': 'Las contraseñas no coinciden',
        'hasNumber': 'Debe contener al menos un número',
        'hasSpecialChar': 'Debe contener al menos un caracter especial',
        'hasUpperCase': 'Debe contener al menos una letra mayúscula',
        'hasLowerCase': 'Debe contener al menos una letra minúscula'
      }
    }
  },
  en: {
    'vuelidate': {
      'errors': {
        'required': 'This field is required',
        'minLength': 'This field must have at least {value} characters',
        'maxLength': 'This field must have less than {value} characters',
        'minValue': 'This field must have a value greater or equal to {value}',
        'email': 'This field must be a valid email',
        'numeric': 'This field must be numeric',
        'afterToday': 'The date must be after today',
        'afterDate': 'The date must be after {value}',
        'beforeDate': 'The date must be before {value}',
        'beforeToday': 'The date must be before today',
        'sameAsPassword': 'Passwords do not match',
        'hasNumber': 'Must contain at least one number',
        'hasSpecialChar': 'Must contain at least one special character',
        'hasUpperCase': 'Must contain at least one uppercase letter',
        'hasLowerCase': 'Must contain at least one lowercase letter'
      }
    }
  },
  pt: {
    'vuelidate': {
      'errors': {
        'required': 'Este campo é obrigatório',
        'minLength': 'Este campo deve ter pelo menos {value} caracteres',
        'maxLength': 'Este campo não deve ter mais de {value} caracteres',
        'minValue': 'Este campo deve ter um valor maior ou igual a {value}',
        'email': 'Este campo deve ser um email válido',
        'numeric': 'Este campo deve ser numérico',
        'afterToday': 'A data deve ser posterior a hoje',
        'afterDate': 'A data deve ser posterior a {value}',
        'beforeDate': 'A data deve ser anterior a {value}',
        'beforeToday': 'A data deve ser anterior a hoje',
        'sameAsPassword': 'As senhas não coincidem',
        'hasNumber': 'Deve conter pelo menos um número',
        'hasSpecialChar': 'Deve conter pelo menos um caracter especial',
        'hasUpperCase': 'Deve conter pelo menos uma letra maiúscula',
        'hasLowerCase': 'Deve conter pelo menos uma letra minúscula'
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuelidate-error',
  components: {
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */]
  },
  i18n: {
    messages: messages
  },
  props: {
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    validator: {
      type: Object,
      required: false,
      default: null
    },
    requiredErrorMsg: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('vuelidate.errors.required');
      }
    },
    parentValidators: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    errorMsg: function errorMsg() {
      if (!this.validator || this.validator['required'] === false) {
        return this.requiredErrorMsg;
      }
      for (var prop in this.validator) {
        if (this.validator[prop] === false) {
          var msgKey = 'vuelidate.errors.' + prop;
          var params = this.validator.$params[prop];
          var value = params ? params.value || params.min || params.max || params.minDate || params.maxDate || params.minValue || params.maxValue : null;
          return value ? this.$t(msgKey, { value: value }) : this.$t(msgKey);
        }
      }
    }
  }

});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_opensalud_Home__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_auth__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_opensalud_LogoutSuccess__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_user_info_store__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_user_info_api__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_logosFileNames__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_themes__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__error_routes__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__(25);



var _meta;
















function requireAuth(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_5__app_auth__["a" /* default */].auth.isUserSignedIn()) {
    __WEBPACK_IMPORTED_MODULE_7__app_user_info_store__["a" /* default */].setLoggedIn(false);
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_8__app_user_info_api__["a" /* default */].getUserInfo().then(function (response) {
      __WEBPACK_IMPORTED_MODULE_7__app_user_info_store__["a" /* default */].setLoggedIn(true);
      __WEBPACK_IMPORTED_MODULE_7__app_user_info_store__["a" /* default */].setCognitoInfo(response);
      next();
    });
  }
}
var layout = __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["j" /* PUBLIC_LAYOUT */];
var footer = {
  component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENLEGAL

};
var themeOpenlegal = 'openlegal-theme';
var i18nFile = 'public/views/openlegal';
var tagLine = 'Openlegal';
function scrollTop(to, from, next) {
  window.scrollTo(0, 0);
  next();
}

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'support-chat',
  name: 'SupportChat',
  component: function component() {
    return __webpack_require__.e/* import() */(27/* duplicate */).then(__webpack_require__.bind(null, 1240));
  },
  meta: {
    footer: {
      disabled: true
    }
  }
},
// Account views
{
  path: 'signup-cognito',
  name: 'SignUpCognito',
  component: function component() {
    return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 2340));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up');
      }
    }
  }
}, {
  path: 'signup',
  name: 'SignUpCertificate',
  component: function component() {
    return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 2341));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up');
      }
    }
  }
},
/*   {
    path: 'login-cognito',
    name: 'LoginCognito',
    component: () => import('@/components/public/account/LoginCognito'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text: i18n.t('log-in')
      }
    }
  }, */
{
  path: 'inicio-sesion',
  name: 'InicioSesion',
  component: function component() {
    return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 2328));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('log-in');
      },

      hide: true
    },
    i18n: 'public/views/account/login.json',
    showInstallAppButton: true
  }
}, {
  path: 'account/login',
  redirect: { name: 'InicioSesion' }
}, {
  path: 'homepaciente',
  beforeEnter: function beforeEnter(to, from, next) {
    window.location.href = helpers.getAppUrl('HomePaciente');
  }
}, {
  path: 'homeprofesional',
  beforeEnter: function beforeEnter(to, from, next) {
    window.location.href = helpers.getAppUrl('HomeProfesional');
  }
}, {
  path: 'homecentro',
  beforeEnter: function beforeEnter(to, from, next) {
    window.location.href = helpers.getAppUrl('HomeCentro');
  }
}, {
  path: 'home/index',
  redirect: '/'
},
/* {
  path: 'cuenta/reactivar',
  name: 'ReenableAccount',
  component: () => import('@/components/public/account/ReenableAccount'),
  meta: {
    layout: PUBLIC_REDUCED_LAYOUT,
    title: {
      text: i18n.t('reenable-account')
    }
  }
}, */
/*   {
    path: 'new-password',
    name: 'NewPassword',
    component: () => import('@/components/public/account/NewPassword'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text: i18n.t('change-password')
      }
    }
  },
  {
    path: 'recover-password',
    name: 'RecoverPassword',
    component: () => import('@/components/public/account/RecoverPassword'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      title: {
        text: i18n.t('recover-password.title')
      }
    }
  }, */
{
  path: 'payments-gateway',
  name: 'PaymentsGateway',
  component: function component() {
    return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 2342));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["i" /* PUBLIC_EXTENDED_LAYOUT */],
    footer: {
      disabled: true
    },
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('payments-gateway.title');
      }
    }
  }
}, {
  name: 'comunidad-saludable',
  path: 'comunidad-saludable',
  component: function component() {
    return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 540));
  },
  meta: {
    // layout: PUBLIC_MENU_LAYOUT,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('healthyCommunityTitle');
      }
    },
    i18n: 'public/views/healthy-community'
  }
}, {
  path: 'opensalud360/empresas',
  name: 'Empresas',
  /* beforeEnter () {
  	window.location.replace('https://prime.opensalud.es/empresas')
  } */
  component: function component() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 2343));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["e" /* OPENSALUD_EMPRESAS_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('business-title');
      }
    },
    tagLine: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["c" /* OPENSALUD360_PLATFORM_NAME */],
    i18n: 'public/views/opensalud-empresas-new.json',
    gtag: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["c" /* OPENSALUD360_PLATFORM_NAME */]
  }
}, {
  path: 'opensalud360/empresas/gracias',
  name: 'ContactFormSuccessOpensalud360',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 185));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    i18n: 'forms/companies-contact-form.json',
    gtag: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["c" /* OPENSALUD360_PLATFORM_NAME */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('companies-contact-form.form.thank-you');
      }
    }
  }
}, {
  path: 'opensalud360/contacto',
  name: 'Contacto360',
  component: function component() {
    return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 2344));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["footerHelpers"].getFooterComponentName()
    },
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('contact-title');
      },

      hide: true
    },
    tagLine: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["c" /* OPENSALUD360_PLATFORM_NAME */]

  }
}, {
  path: 'contacto',
  name: 'Contacto',
  component: function component() {
    return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 2345));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["footerHelpers"].getFooterComponentName()
    },
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('contact-title');
      },

      hide: true
    },
    tagLine: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["d" /* OPENSALUD_PLATFORM_NAME */]

  }
}, {
  path: 'opensalud4all-contacto',
  name: 'ContactoOpensalud4All',
  component: function component() {
    return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 2329));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["footerHelpers"].getFooterComponentName()
    },
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('contact-title');
      },

      hide: true
    },
    tagLine: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["d" /* OPENSALUD_PLATFORM_NAME */]

  }
}, {
  path: 'openlegal360/empresas',
  name: 'Openlegal360',
  component: function component() {
    return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 1273));
  },
  meta: (_meta = {
    tagLine: tagLine,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('openlegal.title');
      }
    },
    layout: layout,
    footer: footer
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'footer', {
    component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENLEGAL360
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'logo', {
    src: __WEBPACK_IMPORTED_MODULE_11__constants_logosFileNames__["c" /* OPENLEGAL360_LOGO */]
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'theme', themeOpenlegal), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'i18n', i18nFile), _meta)
}, {
  path: 'profesionales',
  name: 'Profesionales',
  component: function component() {
    return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 2346));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["g" /* OPENSALUD_PROFESIONALES_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('main-professional-block-h1');
      }
    },
    tagLine: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["e" /* OPENSALUD_PROFESIONALES_PLATFORM_NAME */],
    i18n: 'public/views/opensalud-profesionales.json'
  }
}, {
  path: 'tarifas-profesionales',
  name: 'Tarifas profesionales',
  component: function component() {
    return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 2347));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('patient-title');
      }
    },
    tagLine: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["e" /* OPENSALUD_PROFESIONALES_PLATFORM_NAME */],
    i18n: 'public/views/opensalud-profesionales.json'
  }
}, {
  path: 'sign-up',
  name: 'Signup',
  component: function component() {
    return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 2327));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up');
      }
    },
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENSALUD360
    },
    tagLine: __WEBPACK_IMPORTED_MODULE_10__constants_platformNames__["c" /* OPENSALUD360_PLATFORM_NAME */],
    logo: {
      src: __WEBPACK_IMPORTED_MODULE_11__constants_logosFileNames__["e" /* OPENSALUD360_LOGO */]
    }
  }
}, {
  path: 'registro-profesional',
  alias: ['registro-abogado'],
  name: 'Registro Profesional',
  component: function component() {
    return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 1274));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    // layout: PUBLIC_EXTENDED_LAYOUT,
    title: {
      text: function text() {
        return Object(__WEBPACK_IMPORTED_MODULE_12__constants_themes__["c" /* getThemeName */])() === __WEBPACK_IMPORTED_MODULE_12__constants_themes__["a" /* OPENLEGAL_THEME */] ? __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up-lawyer') : __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up-professional');
      },

      hide: true
    }
  }
}, {
  path: 'registro-paciente',
  alias: ['registro-cliente', 'registro-empresas'],
  name: 'Registro Paciente',
  component: function component() {
    return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 2323));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return Object(__WEBPACK_IMPORTED_MODULE_12__constants_themes__["c" /* getThemeName */])() === __WEBPACK_IMPORTED_MODULE_12__constants_themes__["a" /* OPENLEGAL_THEME */] ? __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up-customer') : __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up-patient');
      },

      hide: true
    }
  }
}, {
  path: 'registro-centro',
  alias: ['registro-bufete'],
  name: 'Registro Centro',
  component: function component() {
    return __webpack_require__.e/* import() */(15/* duplicate */).then(__webpack_require__.bind(null, 1275));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sign-up-centre');
      },

      hide: true
    }
  }
}, {
  path: 'sign-in',
  name: 'Signin',
  component: function component() {
    return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 2349));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('log-in');
      }
    }
  }
}, {
  path: 'terminos-condiciones-paciente',
  name: 'TermsAndConditionsPatient',
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 993));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('terms-and-conditions-patient');
      }
    }
  }
}, {
  path: 'terminos-condiciones-profesional',
  name: 'TermsAndConditionsProfessional',
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 995));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('terms-and-conditions-professional');
      }
    }

  }
}, {
  path: 'aviso-legal',
  name: 'LegalWarning',
  component: function component() {
    return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 2350));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('legal-warning');
      }
    },
    i18n: 'public/views/legal-warning.json'
  }
}, {
  path: 'aviso-legal-cookies',
  name: 'LegalWarningCookies',
  component: function component() {
    return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 2351));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('legal-warning');
      }
    }
  }
}, {
  path: 'politica-cookies',
  name: 'CookiesPolicy',
  component: function component() {
    return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 2352));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('cookies-policy');
      }
    },

    i18n: 'public/views/cookies-policy.json'
  }
}, {
  path: 'politica-privacidad',
  name: 'PrivacyPolicy',
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 997));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('privacy-policy.title');
      }
    },

    i18n: 'public/views/privacy-policy.json'
  }
}, {
  path: 'politica-privacidad-profesional',
  name: 'PrivacyPolicyProfessional',
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 999));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('privacy-policy-professional.title');
      }
    },

    i18n: 'public/views/privacy-policy-professional.json'
  }
}, {
  path: 'politica-sgsi',
  name: 'SGSIPolicy',
  component: function component() {
    return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 2353));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('sgsi-policy.title');
      }
    },

    i18n: 'public/views/sgsi-policy.json'
  }
}, {
  path: 'programa-pyme',
  name: 'Pyme',
  component: function component() {
    return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 2354));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('pyme.title');
      }
    },

    i18n: 'public/views/pyme.json'
  }
}, {
  path: 'faqs',
  name: 'FAQs',
  component: function component() {
    return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 523));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('faqs-title');
      },

      hide: true
    },
    i18n: 'public/views/faqs.json'
  }
}, {
  path: 'faqs/:groupId',
  name: 'FAQsGroup',
  component: function component() {
    return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 523));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('faqs-title');
      },

      hide: true
    },

    i18n: 'public/views/faqs.json'
  }
}, {
  path: 'faqs/:groupId/:questionId',
  name: 'FAQsGroupQuestion',
  component: function component() {
    return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 523));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('faqs-title');
      },

      hide: true
    },

    i18n: 'public/views/faqs.json'
  }
}, {
  path: 'contact/success',
  name: 'ContactFormSuccess',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 185));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('companies-contact-form.form.thank-you');
      }
    },
    i18n: 'forms/companies-contact-form.json'
  }
}, {
  path: 'Home/Login',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_4__components_views_opensalud_Home__["a" /* default */],
  beforeEnter: requireAuth
}, {
  path: '/login', beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_5__app_auth__["a" /* default */].auth.getSession();
  }
}, {
  path: 'search',
  name: 'public-search',
  component: function component() {
    return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 1276));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_9__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    i18n: 'public/views/patient/search',
    roles: [__WEBPACK_IMPORTED_MODULE_14__constants_roles__["d" /* API_CLIENT_ROLE */]]
  }
}, {
  path: 'login/oauth2/code/cognito', beforeEnter: function beforeEnter(to, from, next) {
    var currUrl = window.location.href;

    //console.log(currUrl);
    __WEBPACK_IMPORTED_MODULE_5__app_auth__["a" /* default */].auth.parseCognitoWebResponse(currUrl);
    //next();
  }
}, {
  // Route for current app version
  path: 'version',
  name: 'Version',
  component: __WEBPACK_IMPORTED_MODULE_15_vue__["default"].component('version-view', { template: '<div>Version: {{ version }}</div>', data: function data() {
      return { version: '' + "022025" };
    }
  }),
  meta: {
    footer: {
      disabled: true
    }
  }
}, {
  path: 'logout', component: __WEBPACK_IMPORTED_MODULE_6__components_views_opensalud_LogoutSuccess__["a" /* default */], beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_5__app_auth__["a" /* default */].logout();
    next();
  }
}].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__error_routes__["a" /* default */])));

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_user_info_store__ = __webpack_require__(434);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    data: function data() {
        return {
            userInfo: __WEBPACK_IMPORTED_MODULE_0__app_user_info_store__["a" /* default */].state.cognitoInfo
        };
    }
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_amazon_cognito_auth_js__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_info_store__ = __webpack_require__(434);

// import IndexRouter from '../router/index';

// import UserInfoApi from './user-info-api';


var CLIENT_ID = Object({"PACKAGE_VERSION":"022025"}).VUE_APP_COGNITO_CLIENT_ID;
var APP_DOMAIN = Object({"PACKAGE_VERSION":"022025"}).VUE_APP_COGNITO_APP_DOMAIN;
var REDIRECT_URI = Object({"PACKAGE_VERSION":"022025"}).VUE_APP_COGNITO_REDIRECT_URI;
var USERPOOL_ID = Object({"PACKAGE_VERSION":"022025"}).VUE_APP_COGNITO_USERPOOL_ID;
var REDIRECT_URI_SIGNOUT = Object({"PACKAGE_VERSION":"022025"}).VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;
var APP_URL = Object({"PACKAGE_VERSION":"022025"}).VUE_APP_APP_URL;

var authData = {
    ClientId: '6578o95eaaqtrn7vlcc88ph9f4', // Your client id here
    AppWebDomain: 'opensalud-test-es.auth.eu-west-1.amazoncognito.com',
    TokenScopesArray: ['openid', 'email'],
    RedirectUriSignIn: 'https://app-dev.opensalud.es/es/login/oauth2/code/cognito',
    RedirectUriSignOut: 'https://app-dev.opensalud.es/es/logout',
    // RedirectUriSignIn : 'https://localhost:8080/es/login/oauth2/code/cognito',
    // RedirectUriSignOut : 'https://localhost:8080/es/logout',
    UserPoolId: 'opensalud-test-es'
};

var auth = new __WEBPACK_IMPORTED_MODULE_0_amazon_cognito_auth_js__["a" /* CognitoAuth */](authData);
// auth.userhandler = {
//     onSuccess: function(result) {
//         console.log("On Success result", result);
//         UserInfoStore.setLoggedIn(true);
//         UserInfoApi.getUserInfo().then(response => {
//             IndexRouter.push('/');
//         });


//     },
//     onFailure: function(err) {
//         UserInfoStore.setLoggedOut();
//         IndexRouter.go({ path: '/error', query: { message: 'Login failed due to ' + err } });
//     }
// };

function getUserInfoStorageKey() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + auth.getClientId();
    var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
    var userInfoKey = keyPrefix + '.' + tokenUserName + '.userInfo';
    return userInfoKey;
}

var storageHelper = new __WEBPACK_IMPORTED_MODULE_0_amazon_cognito_auth_js__["b" /* StorageHelper */]();
var storage = storageHelper.getStorage();
/* harmony default export */ __webpack_exports__["a"] = ({
    auth: auth,
    login: function login() {
        auth.getSession();
    },
    logout: function logout() {
        if (auth.isUserSignedIn()) {
            var userInfoKey = this.getUserInfoStorageKey();
            auth.signOut();

            storage.removeItem(userInfoKey);
        }
    },

    getUserInfoStorageKey: getUserInfoStorageKey

});

/***/ }),
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {}
});

/***/ }),
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundErrorPage_vue__ = __webpack_require__(991);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c26e156_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundErrorPage_vue__ = __webpack_require__(1613);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1611)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundErrorPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c26e156_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundErrorPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/errors/NotFoundErrorPage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c26e156", Component.options)
  } else {
    hotAPI.reload("data-v-7c26e156", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_app_helpers__ = __webpack_require__(216);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeCreate: function beforeCreate() {
    // Redirect to app-test.opensalud.es
    if (!this.$route.fullPath.includes('static-appopensalud')) {
      window.location.href = '' + __WEBPACK_IMPORTED_MODULE_0__helpers_app_helpers__["a" /* default */].getAppUrl(this.$route.fullPath);
    }
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_AccountRepository__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_LoadingAnim_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_domains_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_domains_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_domains_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_loginEdgeCases__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_app_helpers__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_base_BaseDialog_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_filters__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__repositories_WebappRepository__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_TermsAndConditionsPatient_vue__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_TermsAndConditionsProfessional_vue__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_PrivacyPolicy_vue__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_PrivacyPolicyProfessional_vue__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_account_mixin__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants_subdomains__ = __webpack_require__(158);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_18__mixins_account_mixin__["a" /* default */]],
  components: {
    BForm: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["m" /* BForm */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["r" /* BFormGroup */],
    BButton: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["d" /* BButton */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["s" /* BFormInput */],
    BAlert: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* BAlert */],
    BIconEyeSlash: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["W" /* BIconEyeSlash */],
    BIconEye: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["V" /* BIconEye */],
    LoadingAnim: __WEBPACK_IMPORTED_MODULE_4__components_utils_LoadingAnim_vue__["default"],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_10__components_base_BaseDialog_vue__["default"],
    TermsAndConditionsPatient: __WEBPACK_IMPORTED_MODULE_14__components_views_TermsAndConditionsPatient_vue__["default"],
    TermsAndConditionsProfessional: __WEBPACK_IMPORTED_MODULE_15__components_views_TermsAndConditionsProfessional_vue__["default"],
    PrivacyPolicy: __WEBPACK_IMPORTED_MODULE_16__components_views_PrivacyPolicy_vue__["default"],
    PrivacyPolicyProfessional: __WEBPACK_IMPORTED_MODULE_17__components_views_PrivacyPolicyProfessional_vue__["default"]
  },
  props: {
    loginCallback: {
      type: Function,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      inOpenlegal: __WEBPACK_IMPORTED_MODULE_11__constants_platformNames__["j" /* inOpenlegal */],
      showPassword: false,
      form: {
        email: null,
        password: null,
        csrfToken: null,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        },
        mfaCode: null
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null,
      visibility: 'password',
      mfaVisible: false,
      checkCredentials: false,
      accountError: null,
      domains: __WEBPACK_IMPORTED_MODULE_6__static_domains_json___default.a,
      loginInfo: null,
      loginEdgeCaseDialog: {
        visible: false,
        content: null
      },
      termsAndConditionsModalVisible: false,
      termsAndConditionsAccepted: null,
      privacyPolicyModalVisible: false,
      privacyPolicyAccepted: null
    };
  },

  methods: {
    login: function login() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.resetForm();
                _this2.form.state.submitted = true;
                _this2.form.state.waiting = true;
                if (_this2.formValid !== false) {
                  __WEBPACK_IMPORTED_MODULE_3__repositories_AccountRepository__["a" /* default */].login(_this2.form.email.trim(), _this2.form.password.trim(), _this2.form.mfaCode ? _this2.form.mfaCode.trim() : null).then(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                      var responseData, hasExceptionType, hasErrorMessage, msgKey, transKey, token, edgeCaseObj;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _this2.$store.commit('setLoading', true);
                              responseData = response.data || (response.response ? response.response.data : null);
                              hasExceptionType = response.response && response.response.status !== 200 && response.response.data.ExceptionType;
                              hasErrorMessage = response.data && response.data.error && response.data.error.errorMessage;

                              if (!((hasExceptionType || hasErrorMessage) && (!responseData || !responseData.requiredAction))) {
                                _context.next = 10;
                                break;
                              }

                              msgKey = hasExceptionType ? response.response.data.ExceptionType : response.data.error.errorMessage;
                              transKey = 'login.errors.' + msgKey;

                              _this2.showError(_this2.$te(transKey) ? _this2.$t(transKey) : null);
                              _context.next = 69;
                              break;

                            case 10:
                              if (!(!response.data && !responseData.requiredAction && response.message)) {
                                _context.next = 14;
                                break;
                              }

                              _this2.showError(response.message);
                              _context.next = 69;
                              break;

                            case 14:
                              _context.t0 = responseData.requiredAction;
                              _context.next = _context.t0 === __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__["a" /* CHECK_CREDENTIALS_ACTION */] ? 17 : _context.t0 === __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__["b" /* PASSWORD_MAX_ATTEMPTS_ACTION */] ? 19 : _context.t0 === __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__["c" /* PASSWORD_UPDATE_ACTION */] ? 22 : _context.t0 === __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__["e" /* REENABLE_ACCOUNT_ACTION */] ? 25 : _context.t0 === __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__["g" /* TWO_FACTOR_ACTION */] ? 28 : _context.t0 === __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__["f" /* TERMS_AND_CONDITIONS_ACTION */] ? 31 : _context.t0 === __WEBPACK_IMPORTED_MODULE_5__constants_loginAdditionalActions__["d" /* PRIVACY_POLICY_ACTION */] ? 34 : 37;
                              break;

                            case 17:
                              _this2.checkCredentials = true;
                              return _context.abrupt('break', 69);

                            case 19:
                              _this2.checkCredentials = false;
                              _this2.showError(_this2.$t('login.errors.passwordMaxAttempts'));
                              return _context.abrupt('break', 69);

                            case 22:
                              _context.next = 24;
                              return _this2.$router.push({ path: '/cuenta/peticion-actualizar-contrasena', query: { expired: true } });

                            case 24:
                              return _context.abrupt('break', 69);

                            case 25:
                              _context.next = 27;
                              return _this2.$router.push({ path: '/cuenta/reactivar', query: { email: _this2.form.email.trim() } });

                            case 27:
                              return _context.abrupt('break', 69);

                            case 28:
                              _this2.checkCredentials = false;
                              _this2.mfaVisible = true;
                              return _context.abrupt('break', 69);

                            case 31:
                              _this2.loginInfo = responseData;
                              _this2.termsAndConditionsModalVisible = true;
                              return _context.abrupt('break', 69);

                            case 34:
                              _this2.loginInfo = responseData;
                              _this2.privacyPolicyModalVisible = true;
                              return _context.abrupt('break', 69);

                            case 37:
                              token = responseData.apiToken;

                              _this2.loginInfo = responseData;
                              _this2.$store.dispatch('session/set', responseData);

                              if (!(responseData.edgeCase && Object(__WEBPACK_IMPORTED_MODULE_11__constants_platformNames__["k" /* inOpensalud360 */])())) {
                                _context.next = 52;
                                break;
                              }

                              edgeCaseObj = Object(__WEBPACK_IMPORTED_MODULE_7__constants_loginEdgeCases__["a" /* LOGIN_EDGE_CASES */])(__WEBPACK_IMPORTED_MODULE_8__helpers_app_helpers__["a" /* default */].getV2AppUrl(), responseData.travelCompanyName, __WEBPACK_IMPORTED_MODULE_12__plugins_filters__["a" /* default */].beautifyDate(responseData.user.companyCode.startDate), __WEBPACK_IMPORTED_MODULE_12__plugins_filters__["a" /* default */].beautifyDate(responseData.user.companyCode.endDate), responseData.apiToken)[responseData.edgeCase];

                              if (!(edgeCaseObj && edgeCaseObj.view)) {
                                _context.next = 48;
                                break;
                              }

                              _this2.$store.commit('setErrorPageMessage', _this2.$t(edgeCaseObj.message));
                              _context.next = 46;
                              return _this2.$router.push(edgeCaseObj.view);

                            case 46:
                              _context.next = 49;
                              break;

                            case 48:
                              _this2.showLoginEdgeCaseDialog(_this2.$t(edgeCaseObj.message));

                            case 49:
                              return _context.abrupt('break', 69);

                            case 52:
                              if (!(responseData.requiredFields && responseData.requiredFields.length > 0)) {
                                _context.next = 56;
                                break;
                              }

                              _this2.processRequiredFields(responseData.user, responseData.requiredFields, token);
                              _context.next = 68;
                              break;

                            case 56:
                              if (!_this2.loginCallback) {
                                _context.next = 61;
                                break;
                              }

                              _this2.loginCallback();
                              return _context.abrupt('break', 69);

                            case 61:
                              if (!_this2.$store.state.session.loginCallback) {
                                _context.next = 66;
                                break;
                              }

                              _this2.$store.state.session.loginCallback();
                              return _context.abrupt('break', 69);

                            case 66:
                              _context.next = 68;
                              return _this2.defaultLoginCallback(responseData);

                            case 68:
                              return _context.abrupt('break', 69);

                            case 69:
                              _this2.form.state.waiting = false;
                              _this2.$store.commit('setLoading', false);
                              _this2.$store.dispatch('signalr/init');

                            case 72:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    resetForm: function resetForm() {
      this.form.state.submitted = false;
      this.form.state.waiting = false;
      this.form.state.unauthorized = false;
      this.form.state.errors = false;
    },
    showError: function showError(error) {
      this.form.state.errors = true;
      this.accountError = error;
    },
    showLoginEdgeCaseDialog: function showLoginEdgeCaseDialog(content) {
      this.loginEdgeCaseDialog = {
        visible: true,
        content: content
      };
    },
    acceptTerms: function acceptTerms() {
      var _this3 = this;

      if (this.termsAndConditionsAccepted === true) {
        __WEBPACK_IMPORTED_MODULE_13__repositories_WebappRepository__["a" /* default */].updateReadTermsDate(this.loginInfo.apiToken).then(function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!response.data) {
                      _context3.next = 4;
                      break;
                    }

                    _this3.termsAndConditionsModalVisible = false;
                    _context3.next = 4;
                    return _this3.login();

                  case 4:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this3);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      } else {
        this.termsAndConditionsAccepted = false;
      }
    },
    denyTerms: function denyTerms() {
      this.termsAndConditionsModalVisible = false;
      window.location.reload();
    },
    acceptPrivacyPolicy: function acceptPrivacyPolicy() {
      var _this4 = this;

      if (this.privacyPolicyAccepted === true) {
        __WEBPACK_IMPORTED_MODULE_13__repositories_WebappRepository__["a" /* default */].updateReadPrivacyPolicyDate(this.loginInfo.apiToken).then(function () {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(response) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!response.data) {
                      _context4.next = 4;
                      break;
                    }

                    _this4.privacyPolicyModalVisible = false;
                    _context4.next = 4;
                    return _this4.login();

                  case 4:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this4);
          }));

          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }());
      } else {
        this.privacyPolicyAccepted = false;
      }
    },
    denyPrivacyPolicy: function denyPrivacyPolicy() {
      this.privacyPolicyModalVisible = false;
      window.location.reload();
    }
  },
  computed: {
    formValid: function formValid() {
      return this.emailValidation && this.passwordValidation;
    },
    emailValidation: function emailValidation() {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted);
    },
    passwordValidation: function passwordValidation() {
      return this.$validators.validate(this.form.password, ['required'], this.form.state.submitted);
    },
    userRoleIsPatient: function userRoleIsPatient() {
      return this.loginInfo && this.loginInfo.user && this.loginInfo.user.roles && this.loginInfo.user.roles.includes(__WEBPACK_IMPORTED_MODULE_9__constants_roles__["f" /* PATIENT_ROLE */]);
    },
    titleVisible: function titleVisible() {
      return this.title && this.mfaVisible === false;
    }
  },
  created: function created() {
    if (window.location.hostname.includes(__WEBPACK_IMPORTED_MODULE_19__constants_subdomains__["i" /* HEALTHY_HABITS_SUBDOMAIN */]) && !this.$store.state.session.loginCallback) {
      var _this = this;
      this.$store.commit('session/setLoginCallback', function () {
        _this.$router.push('/').catch(function () {});
      });
    }
  }
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditionsPatient_vue__ = __webpack_require__(994);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ac9848_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditionsPatient_vue__ = __webpack_require__(1619);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditionsPatient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ac9848_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditionsPatient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/TermsAndConditionsPatient.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-86ac9848", Component.options)
  } else {
    hotAPI.reload("data-v-86ac9848", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_global_helpers__ = __webpack_require__(47);
//
//
//
//
//

/* eslint-disable */


var mx = {
  'terms-and-conditions-patient': '<p><b>bluMEDICA LATAM, S.A. DE C.V.</b> (en lo sucesivo bluMEDICA) como titular de los sitios www.blumedica.mx,  www.opensalud.mx  y www.openpsicologos.com (en lo sucesivo el SITIO WEB), establece y da a conocer, los TERMINOS Y CONDICIONES DE USO, a los que se sujetaran TODAS las personas físicas (en lo sucesivo el USUARIO), que ingresen y hagan uso del SITIO WEB.</p>            <br />            <br />            <h4><b>1. DISPONIBILIDAD DE LOS TERMINOS Y CONDICIONES DE USO</b> </h4>            <br />            <p>Los presentes TERMINOS Y CONDICIONES, se exponen con carácter permanente en el SITIO WEB, donde el USUARIO podrá consultarlos, archivarlos y/o imprimirlos en cualquier momento. </p>            <br />            <p>Al acceder y hacer uso del SITIO WEB, el USUARIO acepta en su totalidad y sin reservas, los presentes TÉRMINOS Y CONDICIONES, si EL USUARIO no estuviese de acuerdo con los presentes TÉRMINOS Y CONDICIONES, ya sea en algunas de sus cláusulas o en la totalidad de ellas, se abstendrá de acceder y hacer uso del SITIO WEB. </p>            <br />            <p>bluMEDICA se reserva el derecho, a su sola discreción, de cambiar, modificar, añadir, quitar o actualizar en cualquier momento, en su totalidad o en partes, los presentes TÉRMINOS Y CONDICIONES.</p>            <br />            <p>Los cambios en los TÉRMINOS Y CONDICIONES, serán efectivos en cuanto sean publicados en el SITIO WEB; por lo que al acceder y/o hacer uso del sitio, después de haber sido publicado cualquier cambio, será considerado como aceptación del mismo, siendo responsabilidad del USUARIO, leer los términos y condiciones vigentes.</p>            <br />            <br />            <h4><b>2. DEL SITIO WEB</b></h4>            <br />            <p>bluMEDICA se reserva el derecho de terminar, cambiar, suspender o descontinuar cualquier aspecto del SITIO WEB,  en cualquier momento. </p>            <br />            <p>Además, puede restringir, suspender, cancelar o terminar el acceso del USUARIO al SITIO WEB y/o tomar la acción legal que juzgue conveniente, en los siguientes casos: </p>            <br />            <p>                a)	Cuando el USUARIO proporcione datos incorrectos con el fin de registrarse o ingresar a la PLATAFORMA<br />                b)	Cuando el USUARIO no cumpla con los presentes Términos y Condiciones, los Avisos de Privacidad o con la ley aplicable.<br />                c)	Cuando el USUARIO no dé cumplimiento a cualquier normativa aplicable respecto del acceso y/o el uso del SITIO WEB.<br />                d)	Cuando EL USUARIO le dé un uso, al contenido el SITIO WEB, distinto al autorizado.<br />                e)	Cuando le sea a ordenado por autoridad competente.            </p>            <br />            <br />            <h4><b>3. DEL SERVICIO</b></h4>            <br />            <br />            <p>                Los servicios proporcionados por bluMEDICA, consisten únicamente, en proporcionar una plataforma tecnológica, para la gestión en línea de citas presenciales y no presenciales, a través de la cual, el USUARIO del SITIO WEB, puede contactar médicos y especialistas en el área de la salud, reduciendo desplazamientos y costos innecesarios.<br />            </p>            <p>                En el SITIO WEB, se pone a disposición de EL USUARIO, un directorio de médicos y profesionales de la salud, dentro de los cuales el USUARIO, podrá elegir de acuerdos a sus necesidades, al médico o profesionista de la salud, para solicitar una consulta en línea, presencial, video consulta o segunda opinión.<br />            </p>            <p>                Para la integración del directorio de médicos del SITIO WEB, bluMEDICA  solicita a cada médico o profesional de la salud interesado, su información personal y datos académicos y profesionales, con el objeto de verificar su identidad y que cuente con los títulos y certificados que acrediten su capacidad, para el ejercicio de su actividad.  Al aceptar los presentes TERMINOS Y CONDICIONES el USUARIO, libera a BLUMEDICA de toda responsabilidad, civil, penal o de cualquier tipo, asociada con la veracidad  de la información que proporcionan los médicos o profesionales de la salud que aparezcan en el directorio del SITIO WEB.<br />            </p>            <p>                El médico o profesional de la salud, que el USUARIO haya seleccionado del directorio que aparece en el SITIO WEB, podrá solicitarle la información médica, incluyendo estudios, tratamientos, padecimientos, etc., que requiera para la prestación del servicio de consulta en la modalidad que el USUARIO haya  solicitado, el uso de dicha información es responsabilidad del médico o profesional de la salud seleccionado, quien además deberá respetar los términos del aviso de privacidad de bluMEDICA, que se encuentran disponibles para su lectura en el SITIO WEB, POR LO TANTO, AL SOLICITAR LOS SERVICIOS EN EL SITIO WEB, EL USUARIO LIBERA A BLUMEDICA  DE CUALQUIER RESPONSABILIDAD, DERIVADA DEL USO O TRATAMIENTO QUE EL MEDICO O ESPECILISTA DE SALUD SELECCIONADO, DE A SU INFORMACION PERSONAL.<br />            </p>            <p>                A través de la plataforma de bluMEDICA podrán imprimirse recetas médicas, estando limitado el sistema, a una sola impresión por receta, la emisión de dichas recetas, así como su contenido, es responsabilidad del médico o profesional de la salud que haya sido seleccionado por el USUARIO, por lo que BLUMEDICA se deslinda de cualquier responsabilidad al respecto, ya que el servicio de BLUMEDICA es únicamente el de proporcionar la plataforma para que EL USUARIO y el médico o especialista elegido por este, se contacten.            </p>            <br />            <br />            <h4><b>4. LIMITE DE LOS SERVICIOS</b></h4>            <br />            <br />            <p>                bluMEDICA, NO PROPORCIONA NINGUN TIPO DE SERVICIO MEDICO, ya sean consultas, diagnósticos médicos o psicológicos,  tratamientos, prescripción, etc. deslindándose de cualquier responsabilidad que se pudiera generar al respecto, siendo bajo la responsabilidad del USUARIO, confiar en la información que le sea proporcionada a través del SITIO WEB por el médico o profesional de la salud que haya elegido.<br />            </p>            <p>                La inclusión de médicos y profesionales de la salud, en el directorio del SITIO WEB, no implica recomendación ni aprobación de los mismos por parte de bluMEDICA, por lo que cualquier opinión, tratamiento, producto, procedimiento, diagnóstico, prescripción, que realicen los médicos y profesionales de la salud al USUARIO, a través del SITIO WEB O FUERA DE ESTE, son independientes y no reflejan opiniones de BLUMEDICA; siendo decisión y responsabilidad del USUARIO seguirlas o no, liberando desde este momento de cualquier responsabilidad al respecto a BLUMEDICA, ya que ésta última no tiene la capacidad de evaluar ni avalar, la calidad o validez de cualquier tipo de asesoramiento médico o psicológico.<br />            </p>            <p>                EL USUARIO, es responsable de la compra e ingesta de los medicamentos que le sean prescritos, por el médico o especialista de la salud que haya seleccionado; al igual que de toda transacción o acuerdo que realice con dicho especialista.<br />            </p>            <p>                POR LO TANTO, AL ACEPTAR LOS PRESENTES TERMINOS Y CONDICIONES, EL USUARIO RECONOCE QUE BLUMEDICA, NO PRESTA SERVICIOS MEDICOS DE NINGÚN TIPO Y QUE DICHOS SERVICIOS MEDICOS, SE PRESTAN POR TERCEROS PRESTADORES PARTICULARES INDEPENDIENTES, QUE NO ESTÁN EMPLEADOS POR BLUMEDICA, SIENDO ESTA ULTIMA, UNICAMENTE UNA PLATAFORMA DE CONTACTO ENTRE EL USUARIO Y EL PROFESIONAL DE LA SALUD, POR LO QUE EL USUARIO LIBERA EXPRESAMENTE A BLUMEDICA DE TODA RESPONSABILIDAD ASOCIADA CON EL ASESORAMIENTO, RECOMENDACIONES U OTRA INFORMACION QUE LE PROPORCIONEN LOS MEDICOS O PROFESIONALES DE LA SALUD, A TRAVÉS DEL SITIO WEB O DE CUALQUIER OTRO MEDIO.<br />            </p>            <br />            <br />            <h4><b>5. DATOS PERSONALES DE USUARIOS</b></h4>            <br />            <br />            <p>                El USUARIO del SITIO WEB; se comprometen a proporcionar información real, precisa y actualizada acerca de sus datos personales, sensibles y en general de todos los datos que proporcionen a través de dicho sitio, con la finalidad de poder ofrecerles los servicios adecuados.<br />            </p>            <p>                El USUARIO deslinda de cualquier responsabilidad a bluMEDICA que se pudiera generar derivada de datos erróneos o falsos.<br />            </p>            <p>                El uso y recopilación de información de bluMEDICA, tiene la finalidad de conectar a médicos y especialistas de la salud con EL USUARIO, así como demás finalidades señaladas en el AVISO DE PRIVACIDAD del SITIO WEB, el cual está incorporado al mismo para que pueda ser consultado,  archivado o impreso en cualquier momento por EL USUARIO.<br />            </p>            <p>                EL USUARIO podrá, en cualquier momento, ejercitar los derechos de acceso, oposición, rectificación y cancelación reconocidos en la normativa vigente a través de www.blumedica.mx de acuerdo al AVISO DE PRIVACIDAD, publicado en dicha página.            </p>            <br />            <br />            <h4><b>6. PRECIO Y MÉTODO DE PAGO</b></h4>            <br />            <br />            <p>                El costo de la consulta (ya sea presencial o en línea), es determinado de manera particular por cada uno de los médicos y  profesionales de la salud, que aparece en el directorio del SITIO WEB y se pagará,  de la forma que dicho médico o especialista determine (tarjeta de crédito, débito o efectivo).<br />            </p>            <p>                Para el caso de las consultas en línea, será necesario utilizar un medio de pago (tarjeta de crédito o débito), que servirá para reservar la cita, (que puede cancelar en cualquier momento), por lo que no se realiza ningún cargo hasta que la consulta finaliza y el médico o profesional de la salud seleccionado por el USUARIO, emite el informe.<br />            </p>            <p>                El proveedor de bluMEDICA, para el servicio de cobro en línea es OPENPAY, mismo que ofrece las herramientas tecnológicas necesarias para la protección para su información personal y que tratará su información de acuerdo a su propio aviso de privacidad, contenido en la página de internet www.openpay.mx y al de BLUMEDICA que se encuentra inserto en el SITIO WEB, para consulta del USUARIO.<br />            </p>            <p>                La facturación del pago efectuado por el USUARIO, deberá solicitarlo directamente con el médico o especialista de la salud que le haya proporcionado el servicio médico, bluMEDICA, NO EXPIDE FACTURAS, A LOS USUARIOS DE LOS SERVICIOS MEDICOS DEL SITIO WEB.<br />            </p>            <br />            <br />            <h4><b>7. CANCELACIÓN DEL SERVICIO</b></h4>            <br />            <br />            <p>                Respecto de las citas gestionadas en el SITIO WEB, EL USUARIO podrá, sin costo alguno, cancelar la cita en cualquier momento, ya que el cobro de la misma se realiza con posterioridad a su realización y a la emisión del dictamen correspondiente del médico o especialista de la salud seleccionado.<br />            </p>            <p>                La forma y en su caso, costo de la cancelación de citas o servicios, agendados de manera directa con el médico o profesional de la salud,  fuera del SITIO WEB,  serán determinadas por el médico o especialista de que se trate, siendo responsabilidad del USUARIO, consultar con ellos de manera directa, dichos términos y costos.            </p>            <br />            <br />            <h4><b>8. USO DE COOKIES, WEB BEACONS Y OTRAS HERRAMIENTAS INFORMÁTICAS DE RECOPILACIÓN DE DATOS</b></h4>            <br />            <br />            <p>                Al ingresar al SITIO WEB, EL USUARIO acepta recibir las cookies que se transmitan a través de este.  Las “Cookies” son archivos de datos que se generan cuando te conectas a una página o sitio web, y se almacenan en el disco duro de la computadora, pueden contener información sobre el perfil de conducta en internet dentro del sitio web. Los datos recabados a través de este medio, se utilizan para mejorar el SITIO WEB y ajustarlo al comportamiento de los usuarios que lo visitan, así como para el trámite de los registros y la remisión de información. Una Cookie no puede leer los datos o información del disco duro del usuario ni leer las Cookies creadas por otros sitios o páginas.<br />            </p>            <p>                En el apartado “Ayuda” de la barra de herramientas de la mayoría de los buscadores se señala al Usuario cómo impedir que su buscador acepte nuevos cookies, cómo hacer que su buscador le avise de la recepción de nuevos cookies, o cómo inhabilitar todos los cookies. Sin embargo, si usted inhabilita los cookies, algunas de las aplicaciones de nuestro SITIO WEB pueden quedar también inhabilitadas, y el uso de la página web puede verse limitado.            </p>            <br />            <br />            <h4><b>9. LIMITACIÓN DE RESPONSABILIDAD</b></h4>            <br />            <br />            <p>                bluMEDICA de acuerdo a lo permitido por las leyes aplicables, no garantiza que el SITIO WEB y los servicios que ofrece, sufran de interrupciones o puedan estar sujetos a errores; eventualmente podrá no estar disponible por alguna falla en la conectividad de internet o técnica en sus componentes o cualquier razón ajena a nosotros.<br />            </p>            <p>                En ningún caso bluMEDICA, será responsable de Controlar o informar acción alguna que haga referencia a la presencia o ausencia de errores, virus, gusanos, material o información contaminante o cualquier otro elemento informático dañino. Por lo que BLUMEDICA queda liberado de imputación alguna por tales causas, así como del pago de toda  indemnización bajo cualquier concepto, por los perjuicios resultantes de dificultades técnicas o fallas en los sistemas o en internet, dado que es responsabilidad de EL USUARIO el contar con herramientas adecuadas para la detección y desinfección de programas informáticos dañinos.<br />            </p>            bluMEDICA en ningún caso y bajo ninguna circunstancia, será responsable por daños de cualquier tipo, que EL USUARIO pueda tener por causa de fallas en las telecomunicaciones, redes o desconexiones que limiten el uso, interrumpan o cancelen el servicio brindado en este SITIO WEB.<br />            <p>                bluMEDICA sus proveedores y colaboradores podrán actualizar en cualquier momento el contenido e información del SITIO WEB; por lo que en ocasiones algunas funciones e información publicada dentro de nuestro sitio puede ser obsoleta, contener errores ortográficos y/o tipográficos, dichas actualizaciones serán constantes y tienen por objeto dar el mejor servicio a todos nuestros clientes.<br />            </p>            <p>                bluMEDICA tiene completas facultades para revisar e investigar el uso ilegal y no autorizado del SITIO WEB de conformidad con los presentes Términos y Condiciones y lo establecido por las leyes aplicables.<br />            </p>            <p>                bluMEDICA se reserva el derecho de no permitir el acceso de EL USUARIO al SITIO WEB,  sin perjuicio de cualquier otra acción que en defensa de sus intereses ejerza,  cuando tenga indicios que:<br />            </p>            <p>                a)	EL USUARIO tiene conducta difamatoria, violatoria o que represente un riesgo para la información contenida en el SITIO WEB.<br />                b)	EL USUARIO violenta las leyes aplicables, nacionales e internacionales relativas al uso de la información, derechos de autor y propiedad intelectual, del contenido disponible en este SITIO WEB.<br />            </p>            <p>                bluMEDICA tiene la facultad de investigar el tipo de uso ilegal o no autorizado del SITIO WEB en conformidad a los presentes Términos y Condiciones, por tal motivo, EL USUARIO acepta que, en cualquier caso en que se le atribuya responsabilidad de manera directa o indirecta a BLUMEDICA, sus empresas subsidiarias, accionistas, consejo directivo y ejecutivo, afiliados, proveedores, asesores o empleados, deberá sacar a ésta última en paz y a salvo, así como pagar los daños y perjuicios ocasionados.            </p>            <br />            <br />            <h4><b>10. PROPIEDAD INTELECTUAL</b></h4>            <br />            <br />            <p>                Las marcas y logotipos de bluMEDICA así como el contenido del sitio web, el nombre de dominio, los sistemas utilizados, bases de datos, y en general los derechos de autor respecto del contenido, información, fotografías, imágenes, aplicaciones, programas y en su totalidad y generalidad el contenido publicado en este SITIO WEB están debidamente registrados y protegidos por sus respectivos propietarios de conformidad a la legislación aplicable, por tales motivos, EL USUARIO no puede darle un uso distinto al establecido en los presentes Términos y Condiciones.<br />            </p>            <p>                Queda estrictamente prohibido eliminar, suprimir, alterar, modificar, reproducir, descargar, publicar, explotar, distribuir o corromper el uso del contenido de este SITIO WEB, ya sea para fines comerciales o de cualquier otra índole. El incumplimiento de lo antes previsto, podría derivar en responsabilidad civil, penal u otra de cualquier tipo.<br />            </p>            <p>                El ingresar o hacer uso del SITIO WEB de ninguna manera concede al USUARIO, licencia ni autorización tácita o expresa para el uso de los derechos de propiedad Intelectual, de sus marcas o de sus proveedores, ni de cualquier material utilizado o que exista en el SITIO WEB.<br />            </p>            <p>                El uso de las imágenes, ilustraciones y sus fragmentos; así como el demás material que sea objeto de protección de los derechos de autor, será para fines informativos e ilustrativos, por lo que cualquier uso distinto como el lucro, reproducción, edición o modificación, será perseguido legalmente por bluMEDICA o por el titular de los derechos de propiedad intelectual.<br />            </p>            <p>                bluMEDICA se reserva el derecho de investigar y procesar, cualquier intento y/o comisión de infracción en materia de derechos de autor o propiedad industrial, relacionada con el material contenido en el SITIO WEB y/o las violaciones del sistema informático o de la seguridad de la red, mismas que pueden generar responsabilidades civiles o penales y que a consideración de BLUMEDICA podrán ser denunciadas ante las autoridades competentes.            </p>            <br />            <br />            <h4><b>11. NO RELACIÓN LABORAL</b></h4>            <br />            <br />            <p>                El USUARIO reconoce que  los profesionales que aparecen en el directorio del SITIO WEB no son empleados ni tienen ningún tipo de vinculación contractual como prestadores de servicios con bluMEDICA, ni  tienen sociedad, asociación, o figura jurídica análoga a las anteriores, por lo que no tienen obligación alguna para con dichos médicos o especialistas de la salud, de carácter laboral, fiscal, civil o de cualquier otra naturaleza.<br />            </p>            <p>                BLUMEDICA QUEDA LIBERADA DE CUALQUIER RESPONSABILIDAD, DERIVADA DEL DESEMPEÑO DE LA ACTIVIDAD, PROFESION O ESPECIALIDAD DE CADA MEDICO Y PROFESIONAL DE LA SALUD QUE APARAECA EN EL DIRECTORIO DEL SITIO WEB.            </p>            <br />            <br />            <h4><b>12. NO CESIÓN</b></h4>            <br />            <br />            <p>                El USUARIO no podrán ceder sus derechos de acceso y uso del SITIO WEB, en caso contrario, bluMEDICA podrá restringir el acceso y ejercer las acciones legales que estime pertinentes.            </p>            <br />            <br />            <h4><b>13. DATOS DE CONTACTO</b></h4>            <br />            <br />            <p>                Para cualquier solicitud de aclaraciones, reclamaciones o información bluMEDICA pone a disposición de EL USUARIO el correo electrónico: rambrosi@blumedica.mx  o bien el número telefónico: (55) 5920 9768.            </p>            <br />            <br />            <h4><b>14. JURISDICCIÓN Y COMPETENCIA</b></h4>            <br />            <br />            <p>                Para la interpretación y cumplimiento de los presentes TERMINOS Y CONDICIONES, las partes se someten expresamente a las Leyes y Tribunales competentes en la Ciudad de México, renunciando a cualquier otro fuero que con motivo de su domicilio presente o futuro pudiera llegar a corresponderles.            </p>            <br />            <br />'
};

var en = __WEBPACK_IMPORTED_MODULE_0__helpers_global_helpers__["l" /* inMx */] ? mx : { 'terms-and-conditions-patient': "<p>This agreement has been written in Spanish (Spain). In case of discrepancies between the original and a translated version, the original in Spanish shall be the binding document.</p> <br /> <h4>Statement of Responsibilities and Rights.</h4> <br /> <p>This Declaration of Rights and Responsibilities regulates the relationship of opensalud, openpsicólogos, second opinion oncology and openhealth (hereinafter we refer to all as ‘opensalud’), their users and doctors, psychologists and other professionals who make use of the website. Individuals who access and use opensalud and openpsicólogos expressly agree to our terms of service without any reservation. In the event of any reservation or waiver thereof, the user will be deemed to refuse his membership and will be unsubscribed when such statement is expressed.</p> <p>To obtain the status of a user on this website, it is necessary to be a registered user and thereby expressly submit to and accept all the provisions laid out in these Terms of Service.</p> <p>Using the website, its services in general and other content specifically, implies the user undertakes to do so in accordance with the law, the provisions of these Terms of Service, and other established instructions or regulations that are brought to the attention of the user.</p> <br /> <h4>Subscription of minors</h4> <br /> <p>The platform only allows registration of users of legal age (18 years in Spain). However, minors can use it through the user profile created for them by the parent or legal guardian. Minors may under no circumstances have individual credentials to access the platform and their access with their parent or legal guardian is mandatory. The user always declares that, as stated on the registration form, he is over 18 years of age.</p> <br /> <h4><u>1. Corporate legal information</u></h4> <br /> <p>The owner of the website is the company OpenHealthCare S.L., with registered office at Avda. República Argentina 25 9th floor, 41011 Seville and VAT: B90209081 (hereinafter referred to as 'OpenSalud'), registered in the Commercial Registry of Seville in volume 6043, page 101, inscription 1 with sheet SE-105834.</p> <h4><u>2. The Service of OpenSalud</u></h4> <br /> <p>OpenSalud is a platform for online management of face-to-face and non-face-to-face appointments in the scope of healthcare with private centres or professionals as well as providing consultations in a virtual environment.</p> <p>This service provides users with an online platform that allows them to request a face-to-face appointment or virtually connect with doctors and healthcare professionals. In no case does OpenSalud provide medical or psychological diagnosis, treatment or prescription of any kind. Trusting any information provided through the platform or by any professional who uses opensalud will be under your own responsibility.</p> <p>Users of the opensalud platform have a service level agreement (SLA) that can be consulted through the website at the following <a href='https://opensaludes.sharepoint.com/sites/General2/Documentos%20compartidos/Forms/AllItems.aspx?id=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio%2FAcuerdo%20de%20nivel%20de%20servicio%20%28SLA%29%2Epdf&parent=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio&p=true&ga=1'>link.</a></p> <p>Every user has the right to formally submit a complaint or claim through the following email address: quejas@opensalud.es. The internal managers of the Incidents and Operations departments, as well as the OH management, are responsible for handling these complaints or claims. Complaints or claims received in the corresponding email address will be processed within a maximum period of one month.</p> <h4>Credentials and independence of professionals I</h4> <br /> <p>Professionals who use or appear on the website/application are neither employees nor have any type of contract as service providers with opensalud, except where appropriate, related to telemedicine services for companies. Opensalud does not provide opinions, advice or medical care and disclaims all responsibility for the opinions, advice and information provided by professionals through the platform. Opensalud neither recommends nor endorses any test, doctor, products, procedures, opinions or other information that may be mentioned on opensalud or by a professional.</p> <p>Opensalud requires each professional to provide opensalud with personal information and professional details to prove his identity and credentials, before opensalud allows the professional to be available on the platform.</p> <p>Each Professional must be registered with the corresponding official professional body and have the required legal qualifications to perform his activity. In this regard, the professional expressly authorises opensalud to verify his information with the corresponding Official College.</p> <p>Likewise, opensalud may use the external verification services included in current regulations, in the event that the professional requires the use of functionalities, such as the electronic prescription for example, that require additional security elements.</p> <p>By accepting these terms, you expressly release and discharge opensalud from any and all liability associated with the veracity or verification of the information provided by you as a professional.</p> <p>The inclusion of professionals on our platform does not imply any recommendation or approval of such professionals. The use of the platform by any entity or individual to verify the credentials of professionals is prohibited.</p> <p>All opinions and statements expressed by professionals on or through our platform and during any session provided through it are solely the views and statements of the (individual and independent) Professional and do not reflect the views of opensalud. </p> <p>Opensalud is not qualified to evaluate the quality or validity of any type of medical or psychological advice.</p><p>Therefore, in any case and regardless of the channel through which the patient accesses the services of the professional, this will hold harmless and free opensalud of any liability or claim of users that is related to the provision of clinical services, taking responsibility for any compensation arising therefrom. In the case of clinical care to users of opensalud client companies, the professional expressly declares that it has all the legal, fiscal, administrative, as well as the relevant insurance and permits required in your case, for the exercise of their activity in the private sector. Opensalud may at any time require documentary evidence of compliance with these obligations.</p> <p><b>By agreeing to the terms thereof, you expressly release and discharge opensalud from all liability associated with the consultations, advice, recommendations or other information that is provided by the practitioner to the patient.</b></p> <br /><h4>Credentials and independence of professionals II</h4><br /> <p>Notwithstanding the above, in the case of professionals who provide services directly to opensalud client companies, prior to the start of the provision of the service, the professionals must expressly accept the conditions of service provision for opensalud. For these professionals and In addition to the prior checks carried out by opensalud at the time of registration, the professional expressly declares that he or she has all the legal, fiscal, and administrative authorizations, as well as the corresponding insurance and permits required, where applicable, for the exercise of his or her duties. professional activity. Opensalud may require you to prove compliance with the aforementioned obligations.</p> <p>The professional assumes the commitment to provide correct care to all users of the service, as well as to notify opensalud as soon as possible of any incident that prevents them from guaranteeing the adequate provision of services (holidays...).</p> <br />   <h4>Intellectual Property of OpenSalud</h4> <p>OpenSalud by itself or as a transferee, owns all the intellectual and industrial property rights of the website, as well as its programming structure and the elements contained therein (sound, audio, video, images, software and others, this serving only for illustrative purposes) and reserves all rights or, when applicable, those of its licensors, being expressly prohibited the use by third parties, in accordance with the Intellectual Property regulations in force (Royal Legislative Decree 1/1996, of 12 April) without formal consent from their owners.</p> <p>The user must refrain from deleting, altering, avoiding or changing any protection device or security system that has been installed on the website.</p> <p>In this regard, the website reserves the right to exercise both criminal and civil actions at its disposal to give effect to these rights against third parties.</p> <br /> <h4><u>3. Exclusion of warranties and liability</u></h4> <br /> <p>The OpenSalud website is not responsible for damages resulting from improper use of or actions through the website, nor resulting from common use thereof, provided it has fulfilled its due diligence obligations to prevent these from occurring.</p> <br /> <h4><u>4. Modifications</u></h4> <br /> <p>OpenSalud reserves the right to make the modifications it deems appropriate on its website without prior notice, such as modifying, deleting or introducing both the content and services provided thereon, as well as the provision or organisation thereof on the website.</p> <br /> <h4><u>5. Your information on OpenSalud and how it is shared</u></h4> <br /> <p>The data and information of OpenSalud users are private. The information entered on the website must be authentic, that is, be real in order to be able to provide a correct service. In the event such information is false, OpenSalud shall be exempt from any damage or liability that may result from such false information.</p> <p>a) After registering on the website, you become a user. However, your data are only accessible to OpenSalud as well as the doctors and psychologists registered on the platform to whom you request an appointment in any of its modalities.</p> <p>b) The information you share will only be accessible at the time of the consultation, and will never be provided to third parties, except to the doctor who has requested it.</p> <br /> <h4><u>6. Your Image and Intellectual Property Rights on OpenSalud</u></h4> <br /> <p>When you publish content such as audio-visual images, photographs and texts that are subject to intellectual property rights (hereinafter referred to as 'Content subject to Intellectual Property'), you grant OpenSalud the possibility to use such material under a non-exclusive, transferable license and without the possibility of sublicense, free of any commission or other means of offering any compensation to its author for the use and international scope (hereinafter, 'Intellectual Property License'). That is, you authorise the platform to make use of it, but in no case, to undertake direct commercial activities through the sale or transfer of such content to third parties for its actual operation.</p> <br /> <h4><u>7. Use of content</u></h4> <br /> <p>The website provides certain information and links that may be of interest to the user, who undertakes to make appropriate use of the content and services it offers and, including but not limited to, not to use it for the following activities:</p> <p>1. Engage in illicit or illegal activities, or contrary to good faith and public order through them.</p> <p>2. Cause any type of damage to the systems of the website, its suppliers or third parties, introduce or spread computer viruses or Trojans on Internet, or any other systems that are susceptible or able to generate such damages.</p> <p>3. Perform any type of activity that may be contrary to the right to honour of any of the users or administrators of OpenSalud.</p> <p>4. Undertake actions to falsify the details of made purchases.</p> <br /> <h4><u>8. Security on OpenSalud</u></h4> <br /> <p>Our team works daily to ensure that OpenSalud is a secure platform, respecting the data protection of Registered Users. However, like any on other Internet platform, data protection cannot be guaranteed absolutely and under all circumstances. Nonetheless, in order to comply with such protection with maximum security, Registered Users understand that it is expressly prohibited to:</p> <p>a) Transfer and spread of any type of unauthorised commercial communication (such as 'spam') by using any communication tool that OpenSalud offers to Registered Users.</p> <p>b) Access OpenSalud in any other way than through a browser, official mobile application except for any tool that we officially may add in the future and notify Users about.</p> <p>c) Use automated means of access (such as any use of technology known as bots, robots, spiders) that interact within the OpenSalud platform and with any of the Registered Users.</p> <p>d) Perform and participate in any type of illegal marketing operation through OpenSalud.</p> <p>e) Upload viruses, scripts, or any type of malicious code against OpenSalud and each of its Registered Users.</p> <p>f) Request registration and login information to access another person’s account.</p> <p>g) Harass, burden, intimidate or otherwise annoy any of the Registered Users.</p> <p>h) Publish any content that is offensive, blackmailing or pornographic; or that incites violence; or contains unwarranted nudity or graphic violence.</p> <p>i) Develop or use the application for third parties that include content related to the consumption of alcohol or of an adult nature (including advertisements) without the appropriate age restrictions to the specific region.</p> <p>k) Use OpenSalud for any type of illegal activity, whether against the network itself or against any user, that is, any act that contravenes Spanish law, especially acts that violate the rights to privacy and/ or honour of users of this network.</p> <p>l) Perform any activity that may disable, overload or impede the proper functioning of OpenSalud, such as a denial of service attack.</p> <p>m) Directly or indirectly inspire to violation of this Statement.</p> <br /> <h4><u>9. Account and registration security</u></h4> <br /> <p>Users are required to provide their real names and real information. Moreover, they understand that it is expressly prohibited to:</p> <p>1. Use OpenSalud if they are under 18 years of age, except for subscriptions made through the legal representative in accordance with these terms and conditions.</p> <p>2. Share access information (user and password) for someone else to access their account or perform any activity that compromises the security of their account and that of others. In the case of business services provided under the openhealth brand, it is expressly reiterated that it is prohibited to assign your user credentials to any user or allow any identity theft thereby enabling a user who has not been authorised to use the services by the company.</p> <br /> <h4><u>10. Price and terms of payment</u></h4> <br /> <p>Access to the Opensalud website is free of charge. Regarding making appointments and having consultations, irrespective of whether they be through the platform, these amount to the fee set by the professionals providing their services through the platform and are billed by them. The fees are freely established by each professional and known to the user when making his request.</p> <p>With the exception of telemedicine services for companies, in which they fully assume the cost, in order to guarantee the provision of teleconsultation services (video consultation, written consultation or second opinion), it is necessary to enter a means of payment when making an appointment, requesting an immediate video consultation, or making a second opinion request or written consultation. However, you will not be charged until the teleconsultation has ended. In addition, the patient/user may cancel his video consultation request without any cost, at any time, until latest 15 minutes before the scheduled appointment time. In the case of a written consultation, chat or second opinion request, you can cancel it until before the professional accepts the request.</p> <p>Since the regulations applicable to electronic commerce and means of payment require specifying it, it is obvious that considering the characteristics of the service there is no possibility of returning it.</p> <p>In the event the patient is not satisfied with the provided service, he must contact us by using the form that appears in the footer of the website and selecting the claim option. After its evaluation, it will be answered with a maximum delay of 72 (working) hours and if the decision is favourable, you will get a refund of the cost of the service within maximum of 10 days by the same means of payment you used.</p> <p>Regard to opensalud prime services, the minimum period of contract is 3 month. These services are provided by HNA SC company.</p> <br /> <h4><u>11. Suspension of the service or user account</u></h4> <br /> <p>If you violate any of the provisions in this Statement, OpenSalud reserves the right to immediately cancel your account on OpenSalud without prior notice.</p> <br /> <h4><u>12. Legal Issues</u></h4> <br /> <p>OpenSalud adheres to the applicable legislation in Spain and with it, the courts that have jurisdiction in the event of a conflict, it being up to the consumer to determine which is his court of jurisdiction.</p> <h4>Definitions</h4> <p>1. 'OpenSalud' means the service we provide through the website to manage consultations.</p> <p>2. 'Platform' means the APIs and services that allow others, including application developers and website operators, to retrieve data from OpenSalud and to provide us with data.</p> <p>3. 'Information' means any data or information about you as a user.</p> <p>4. 'Content' means anything you post on OpenSalud that is not included in the definition of 'Information'.</p> <p>5. 'Data' means the content and information that a third party may retrieve from OpenSalud.</p> <p>6. 'Publish' means to publish on OpenSalud.</p> <p>7. 'Use' means to use, copy, reproduce or publicly display, distribute, modify, translate and create derivative works.</p> <p>8. 'Benefits' Any prize, discount, promotion or similar that is provided to users of the website.</p>" };

/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: {
    messages: {
      es: {
        'terms-and-conditions-patient': "<p>Este acuerdo ha sido escrito en español (España). En caso de existir discrepancias entre el original y una versión traducida, el original en español es el documento vinculante.</p> <br /> <h4>Declaración de responsabilidades y de derechos.</h4> <br /> <p>Esta Declaración de derechos y responsabilidades regula la relación de opensalud, openpsicólogos, segunda opinion oncología y opensalud 360 (en adelante nos referimos a todas como opensalud), sus usuarios y los medicos, psicólogos y otros profesionales que hacen uso de la web. Los individuos que acceden y utilicen opensalud y openpsicólogos están aceptando expresamente nuestros términos de servicio sin reserva alguna, en el caso de que se produjese reserva o renuncia alguna a los mismos, se entenderá que el usuario rechaza formar parte de la misma y se procederá a la baja de su usuario cuando dicha declaración sea expresada.</p> <p>Para obtener la condición de usuario de la presente web, es necesario ser usuario registrado de la misma, sometiéndose y aceptando expresamente con ello, todo lo dispuesto en estos Términos del Servicio.</p> <p>Utilizar la web, sus servicios con carácter general y otros contenidos con carácter particular, implica que el usuario se compromete a hacerlo con arreglo a lo dispuesto en la Ley, a lo estipulado en estos Términos del Servicio, y a lo establecido en otras instrucciones o normativas de uso que se establezcan y se pongan en conocimiento del usuario.</p> <br /> <h4>Alta de menores</h4> <br /> <p>La plataforma sólo permite el alta a usuarios mayores de edad (18 años en España). No obstante los menores de edad pueden utilizarla a través del perfil de usuario creado para ellos por el padre, madre o tutor legal. Los menores en ningún caso podrán tener credenciales individuales de acceso a la plataforma, sinedo obligatorio el acceso con el padre, madre o tutor legal. El usuario declara en todo momento que, tal y como consta en el formulario de registro, es mayor de 18 años.</p> <br /> <h4><u>1. Información legal corporativa</u></h4> <br /> <p>El titular del sitio web es la sociedad OpenHealthCare S.L., empresa con domicilio sito en Avda. República Argentina 25 9ª planta, 41011 Sevilla y CIF: B90209081 (en adelante, 'OpenSalud'), Inscrita en el registro mercantil de Sevilla en el tomo 6043, folio 101 inscripción 1 con hoja SE-105834.</p> <h4><u>2. El Servicio de OpenSalud</u></h4> <br /> <p>OpenSalud es una plataforma para la gestión online de citas presenciales y no presenciales dentro del ámbito sanitario con centros o profesionales privados así como la realización en su caso de consultas en un entorno virtual.</p> <p>Este servicio proporciona a los usuarios una plataforma on line que les permite solicitar una cita presencial o conectarse de manera virtual con médicos y profesionales de la salud. Opensalud en ningún caso proporciona diagnóstico médico o psicológico, tratamiento o prescripción de ningún tipo. Si confía en cualquier información proporcionada a través de la plataforma o cualquier profesional que utiliza opensalud será bajo su propia responsabilidad.</p> <p>Los usuarios de la plataforma opensalud disponen de un acuerdo de nivel de servicio (SLA) que puede ser consultado a través de la web en la siguiente <a href='https://opensaludes.sharepoint.com/sites/General2/Documentos%20compartidos/Forms/AllItems.aspx?id=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio%2FAcuerdo%20de%20nivel%20de%20servicio%20%28SLA%29%2Epdf&parent=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio&p=true&ga=1'>dirección.</a></p> <p>Todo usuario tendrá derecho a presentar formalmente una queja o reclamación a través del siguiente buzón de correo electrónico: quejas@opensalud.es. Los responsables de la gestión de dichas quejas o reclamaciones son los responsable internos de los departamentos incidencias y operaciones,  y la dirección de OH. Las quejas o reclamaciones recibidas en el buzón de correo en cuestión  se gestionarán en el plazo máximo de un mes.</p> <h4>Credenciales e independencia de profesionales I</h4> <br /> <p>Los profesionales que utilizan o aparecen en el sitio / aplicación no son empleados ni tienen ningún tipo de vinculación contractual como prestadores de servicios con opensalud, salvo en su caso, lo relativo a los servicios de telemedicina para empresas. Opensalud no proporciona opiniones, consejos ni atención médica y se exime de toda responsabilidad por las opiniones, consejos e información proporcionada por los profesionales a través de la plataforma. Opensalud no recomienda ni aprueba ninguna prueba, médico, productos, procedimientos, opiniones u otra información que pueda mencionarse en opensalud o por un profesional.</p> <p>Opensalud requiere que cada profesional proporcione a opensalud información personal y datos profesionales para acreditar su identidad y credenciales, antes de que opensalud permita que el profesional esté disponible en la plataforma.</p> <p>Cada Profesional debe estar colegiado en el correspondiente colegio oficial y tener en vigor las habilitaciones legales requeridas para ejercer su actividad. En este sentido el profesional autoriza expresamente a opensalud para que verifique en su caso sus datos con el Colegio Oficial que corresponda.</p> <p>Asimismo opensalud podrá utilizar los servicios de verificación externos que recoge la normativa vigente, en el caso de que el profesional requiera el uso de funcionalidades, como la receta electrónica por ejemplo, que requieran de elementos de seguridad adicionales.</p> <p>Al aceptar los términos del mismo, usted libera expresamente y descarga a opensalud de toda responsabilidad asociada con la veracidad o la verificación de la información que proporcionan los profesionales.</p> <p>La inclusión de profesionales en nuestra plataforma no implica ninguna recomendación o aprobación de tales profesionales. Está prohibido el uso de la plataforma por cualquier entidad o individuo para verificar las credenciales de los profesionales.</p> <p>Todas las opiniones y afirmaciones expresadas por los profesionales en o a través de nuestra plataforma y durante cualquier sesión facilitada a través de la misma son exclusivamente las opiniones y declaraciones del Profesional, individuales e independientes, y no reflejan las opiniones de opensalud. </p> <p>Opensalud no está cualificado para evaluar la calidad o validez de cualquier tipo de asesoramiento médico o psicológico.</p><p>Por tanto, en cualquier caso y con independencia del canal por el cual el paciente accede a los servicios del profesional, este mantendrá indemne y libre a opensalud de cualquier responsabilidad o reclamación de los Usuarios que esté relacionada con la prestación de los Servicios clínicos, responsabilizándose el profesional de cualquier indemnización que se derive de las mismas. En el caso de la atención clínica a usuarios de empresas clientes de opensalud, el profesional declara expresamente que dispone de todas las habilitaciones legales, fiscales, administrativas, así como de los correspondientes seguros y permisos requeridos en su caso, para el ejercicio de su actividad en el sector privado. Opensalud podrá requerir en cualquier momento que acredite documentalmente el cumplimiento de las citadas obligaciones.</p> <p><b>Al aceptar los términos del mismo, usted libera expresamente y descarga a opensalud de toda responsabilidad asociada con las consultas, el asesoramiento, recomendaciones u otra información que sea proporcionada por el profesional al paciente.</b></p> <br /> <h4>Credenciales e independencia de profesionales II</h4> <br /> <p>No obstante lo anterior, en el caso de los profesionales que presten servicios directamente a empresas clientes de opensalud, de manera previa al inicio de la prestación del servicio, los profesionales deberán aceptar expresamente las condiciones de prestación del servicio para opensalud.</p> <p>Para estos profesionales y de manera adicional a las comprobaciones previas realizadas por opensalud en el momento del registro, el profesional declara expresamente que dispone de todas las habilitaciones legales, fiscales, administrativas, así como de los correspondientes seguros y permisos requeridos en su caso, para el ejercicio de su actividad profesional. Opensalud podrá requerir que acredite el cumplimiento de las citadas obligaciones.</p> <p>El profesional asume el compromiso de facilitar la correcta atención a todos los usuarios del servicio, así como a notificar a opensalud con la mayor brevedad posible cualquier incidencia que le impida garantizar la adecuada prestación de los servicios (vacaciones…).</p> <h4>Propiedad Intelectual de OpenSalud</h4> <p>OpenSalud por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de la web, así como de la estructura de programación de la misma, así como de los elementos contenidos en la misma (Sonido, audio, vídeo, imágenes, software y demás, sirviendo esto sólo a título ilustrativo) y de los cuales se reserva todos los derechos o bien, en su caso, el de sus licenciantes, quedando expresamente prohibido el uso por parte de terceros, conforme a la normativa vigente de Propiedad Intelectual (Real Decreto Legislativo 1/1996, de 12 de abril) sin que exista un consentimiento formal por parte de sus titulares.</p> <p>El usuario deberá abstenerse de suprimir, alterar, evitar o cambiar cualquier dispositivo de protección o sistema de seguridad que estuviera instalado en la web.</p> <p>En este sentido, la web se reserva el ejercicio de las acciones tanto penales como civiles que le amparen para hacer efectivo estos derechos frente a terceros.</p> <br /> <h4><u>3. Exclusión de garantías y responsabilidad</u></h4> <br /> <p>La web OpenSalud no se hace responsable de los daños derivados del uso de la web por usos o gestiones con la misma de forma indebida, así como por los usos comunes de estos, siempre que haya existido por parte de la misma las diligencias debidas para que estos no se produzcan.</p> <br /> <h4><u>4. Modificaciones</u></h4> <br /> <p>OpenSalud se reserva el derecho de realizar las modificaciones que se estimen oportunas sin previo aviso en su web, pudiendo modificar, eliminar o introducir tanto contenidos como servicios que se presten por las mismas, así como la disposición u organización de los mismos en la web.</p> <br /> <h4><u>5. Tu información en OpenSalud y su manera de ser compartida</u></h4> <br /> <p>Los datos e información de los usuarios de OpenSalud son privados. Los datos registrados en la web deben de tener autenticidad, es decir, ser reales a los efectos de poder dar un servicio correcto. En caso de falsedad de dicha información, Opensalud se exonera de cualquier daño o responsabilidad que pueda generar la misma.</p> <p>a) Una vez registrado en la web, pasas a ser usuario, no obstante dichos datos sólo son accesibles para OpenSalud, así como para los profesionales y centros con los que solicites cita en cualquiera de sus modalidades.</p> <p>b) Aquella información que compartas será accesible por los profesionales y en su caso el centro al que pertenezcan, a los efectos de garantizar una correcta atención y velar por la calidad en la prestación de los servicios y en ningún caso será facilitada a terceros ajenos a la prestación del servicio solicitado por el usuario. En cualquier momento podrás revocar esta autorización de manera directa y automática.</p> <br /> <h4><u>6. Tus derechos de imagen y Propiedad Intelectual en OpenSalud</u></h4> <br /> <p>Al publicar contenido como imágenes audiovisuales, fotografías y textos que estén sujetos a derechos de propiedad intelectual (en adelante, 'Contenido Sujeto a Propiedad Intelectual'), otorgas a OpenSalud la posibilidad de usar los mismos bajo una licencia no exclusiva, transferible y sin posibilidad de ser subotorgada, sin comisión u otra necesidad de ofrecer cualquier remuneración a su autor por el uso, y alcance internacional (en adelante, 'Licencia de Propiedad Intelectual'). Es decir, autorizas para que la plataforma haga uso de la misma, pero en ningún caso, que realice actividad comercial directa a través de la venta o cesión de dichos contenidos a terceros para el propio funcionamiento de la misma.</p> <br /> <h4><u>7. Uso de los contenidos</u></h4> <br /> <p>Desde la web se facilitan distintas informaciones y enlaces que pueden resultar de interés para el usuario, el cual se compromete a hacer un uso adecuado de los contenidos y servicios que las mismas le ofrecen y con carácter enunciativo pero no limitativo, a no emplearlos para las siguientes actividades:</p> <p>1. Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público a través de los mismos.</p> <p>2. Provocar cualquier tipo de daño en los sistemas propios de la web, de sus proveedores o terceras personas, ingresar o difundir en la red virus informáticos, troyanos o cualesquiera otros sistemas que sean susceptibles o hábiles de generar los referidos daños.</p> <p>3. Realizar cualquier tipo de actividad que pueda ser contraria al derecho al honor de cualquiera de los usuarios o administradores de OpenSalud.</p> <p>4. Realizar acciones encaminadas a falsear los datos de las compras realizadas.</p> <br /> <h4><u>8. La seguridad en OpenSalud</u></h4> <br /> <p>Nuestro equipo trabaja a diario para asegurarse que OpenSalud sea una plataforma segura, respetando la protección de datos de los Usuarios Registrados. Sin embargo, como cualquier otra plataforma web la protección de datos no puede garantizarse de manera absoluta y en cualquier circunstancia No obstante, para cumplir con dicha protección con la mayor seguridad posible, los Usuarios Registrados entienden que queda expresamente prohibido:</p> <p>a) La transmisión y difusión de cualquier tipo de comunicación comercial no autorizada (como 'spam' o 'correo no deseado') utilizando cualquier herramienta de comunicación que OpenSalud ofrezca a los Usuarios Registrados.</p> <p>b) Acceder a OpenSalud de otra forma que no sea a través de un navegador, aplicación móvil oficial salvo de cualquier herramienta que agreguemos oficialmente en el futuro y sea notificada a los Usuarios.</p> <p>c) El uso de medios de acceso automáticos (como cualquier uso de tecnologías conocidas como bots, robots, arañas) que realicen una interacción dentro de la plataforma de OpenSalud y con cualquiera de los Usuarios Registrados.</p> <p>d) La práctica y la participación en cualquier tipo de operación de márketing ilegal a través de OpenSalud.</p> <p>e) Cargar virus, scripts, ni cualquier tipo de código con aspiraciones malintencionadas en contra de OpenSalud y cada uno de sus Usuarios Registrados.</p> <p>f) La solicitud de información de registro y de inicio de sesión para acceder a la cuenta de propiedad de otro individuo.</p> <p>g) El acoso, agobio, intimidación o cualquier tipo de molestia a cualquiera de los Usuarios Registrados.</p> <p>h) La publicación de cualquier contenido que resulte ofensivo, chantajista o pornográfico; o que incite a la violencia; o que contenga desnudos o violencia gráfica injustificada.</p> <p>i) El desarrollo o uso de aplicación a terceros que incluyan contenidos relacionados con el consumo de alcohol o de naturaleza adulta (incluidos anuncios) sin las restricciones de edad apropiadas a la región determinada.</p> <p>k) Utilizar OpenSalud para cualquier tipo de actividad ilegal, ya sea contra la propia red, cómo contra cualquier usuario, entendiendo por ello cualquier acto que contravenga la normativa española, en especial aquellos que vulneren los derechos a la privacidad y/ o honor de los usuarios de esta red.</p> <p>l) Cualquier actividad que pueda desactivar, sobrecargar o impedir el funcionamiento correcto de OpenSalud, como un ataque de denegación de servicio.</p> <p>m) Motivar directa o indirectamente la violación de esta Declaración.</p> <br /> <h4><u>9. Seguridad de la cuenta y registro</u></h4> <br /> <p>Los Usuarios están obligados a facilitar sus nombres reales e información real. Además, entienden que queda expresamente prohibido:</p> <p>1. La utilización de OpenSalud si eres menor de 18 años, salvo el alta realizada a través de representante legal conforme a las presentes condiciones.</p> <p>2. Compartir la información de acceso (usuario y contraseña) para que otra persona acceda a tu cuenta o cualquier actividad que ponga en peligro la seguridad de tu cuenta y la de los demás. De manera expresa, en el caso de los servicios a empresas prestados bajo la marca openhealth, se reitera la prohibición de ceder sus credenciales de usuario o permitir cualquier suplantación de identidad que permita a un usuario no autorizado por la compañía, la utilización de los servicios.</p> <br /> <h4><u>10. Precio y condiciones de pago</u></h4> <br /> <p>El acceso a la web de OpenSalud es de naturaleza gratuita. Respecto a la concertación de citas y realización de las mismas a través o no de la plataforma, las mismas serán tarificadas y facturadas por parte de los profesionales que prestan sus servicios utilizando la plataforma conforme a los precios libremente establecidos por los profesionales y conocidos por el usuario en el momento de su solicitud.</p> <p>Con la excepción de los servicios de telemedicina para empresas, en los cuales estas asuman integramente el costo, para garantizar la prestación de los servicios de teleconsulta (videoconsulta, consulta escrita u segunda opinión), es necesario introducir un medio de pago a la hora de reservar una cita, solicitar una videoconsulta inmediata realizar una solicitud de segunda opinión o consulta escrita. No obstante no se realizará ningún cargo hasta que la teleconsulta haya finalizado. Asimismo, el paciente/usuario podrá cancelar su solicitud de videoconsulta sin ningún costo, en cualquier momento con una antelación mínima de 15 minutos sobre la hora de la cita programada. En el caso de las solicitudes de consulta escrita, chat o segunda opinión podrá cancelarlas hasta el momento en el cual el profesional acepta la solicitud.</p><p>Dado que la normativa aplicable a comercio electrónico y medios de pago exige especificarlo, es obvio que considerando las características del servicio no existe posibilidad de devolución del mismo.</p> <p>En el caso de que el paciente no estuviese conforme con el servicio prestado deberá contactarnos utilizando el formulario que aparece en el pie de la página web y seleccionando la opción reclamación. Una vez evaluada, esta será respondida en un plazo máximo de 72 horas (laborables) y en el caso de estimarla favorablemente, en un máximo de 10 días le será reembolsado el costo del servicio utilizando el mismo medio de pago.</p> <br /> <h4><u>11. Suspensión del servicio o de la cuenta de usuario</u></h4> <br /> <p>Si se realiza alguna infracción de los puntos expresados en esta Declaración, OpenSalud se reserva el derecho de la cancelación inmediata sin previo aviso de tu cuenta en OpenSalud.</p> <br /> <h4><u>12. Asuntos Legales</u></h4> <br /> <p>OpenSalud se atiene a la legislación aplicable en España y con ello a los tribunales que sean competentes en caso de conflicto, quedando a disposición del consumidor la selección del mismo.</p> <h4>Definiciones</h4> <p>1. 'OpenSalud' se refiere al servicio que proporcionamos a través de la web para la gestión de consultas.</p> <p>2. 'Plataforma' se refiere a las API y servicios que permiten que otros, incluidos los desarrolladores de aplicaciones y operadores de sitios web, recuperen datos de OpenSalud y nos proporcionen datos.</p> <p>3. “Información' se refiere a cualquier dato o información sobre tu persona como usuario.</p> <p>4. 'Contenido' se refiere a cualquier cosa que publiques en OpenSalud que no se incluya en la definición de 'información'.</p> <p>5. 'Datos' se refiere al contenido y la información que un tercero pueda recuperar de OpenSalud.</p> <p>6. 'Publicar' significa publicar en OpenSalud.</p> <p>7. 'Usar' se entiende utilizar, copiar, reproducir o mostrar públicamente, distribuir, modificar, traducir y crear obras derivadas.</p> <p>8. “Beneficios” Todo aquel premio, descuento, promoción o similar que se facilita a los usuarios de la web.</p>"
      },
      en: en,
      mx: mx,
      pt: {
        "terms-and-conditions-patient": "<p>Este acordo foi escrito em espanhol (Espanha). </p> <br /> <h4>Declaração de responsabilidades e direitos.</h4> <br /> <p>Esta Declaração de Direitos e Responsabilidades regula a relação entre o opensalud, openpsychologists, segunda opinião oncológica e opensalud 360 (doravante denominados todos eles como opensalud), seus usuários e os médicos, psicólogos e outros profissionais que utilizam o site. </p> <p>Para obter o estatuto de utilizador deste site é necessário ser utilizador registado do mesmo, submetendo-se e aceitando expressamente tudo o que está previsto nestes Termos de Serviço.</p> <p>A utilização do site, dos seus serviços em geral e de outros conteúdos em particular, implica que o utilizador se compromete a fazê-lo de acordo com o disposto na Lei, no disposto nestes Termos de Serviço, e no disposto em outras instruções ou regulamentos de utilização. que são estabelecidos e divulgados ao usuário.</p> <br /> <h4>Cadastro de menores</h4> <br /> <p>A plataforma só permite o registo a utilizadores maiores de idade (18 anos em Espanha). </p> <br /> <h4><u>1. Informações jurídicas corporativas</u></h4> <br /> <p>O proprietário do site é a empresa OpenHealthCare S.L., empresa com sede em Avda. República Argentina 25 9ª planta, 41011 Sevilha e CIF: B90209081 (doravante, 'OpenSalud'), inscrita no registro comercial de Sevilha no tomo 6043, fólio 101 inscrição 1 com folha SE-105834.</p> <h4><u>2. O serviço OpenSalud</u></h4> <br /> <p>OpenSalud é uma plataforma para a gestão online de consultas presenciais e não presenciais na área da saúde com centros ou profissionais privados, bem como para a realização de consultas em ambiente virtual, quando apropriado.</p> <p>Este serviço disponibiliza aos utilizadores uma plataforma online que lhes permite solicitar uma consulta presencial ou contactar virtualmente com médicos e profissionais de saúde. </p> <p>Os utilizadores da plataforma opensalud dispõem de um acordo de nível de serviço (SLA) que pode ser consultado através do site no seguinte <a href='https://opensaludes.sharepoint.com/sites/General2/Documentos%20compartidos/Forms/AllItems.aspx?id=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio%2FAcuerdo%20de%20nivel%20de%20servicio%20%28SLA%29%2Epdf&parent=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio&p=true&ga=1'>endereço.</a></p><p>Todo o utilizador tem o direito de apresentar formalmente uma reclamação ou queixa através do seguinte endereço de correio eletrónico: quejas@opensalud.es. Os gestores internos dos departamentos de incidentes e operações, bem como a gestão de OH, são responsáveis ​​pela gestão destas reclamações ou reclamações. As reclamações ou reclamações recebidas na caixa de correio correspondente serão processadas no prazo máximo de um mês.</p> <h4>Credenciais e independência dos profissionais I</h4> <br /> <p>Os profissionais que utilizam ou aparecem no site/aplicativo não são funcionários nem possuem qualquer tipo de vínculo contratual como prestadores de serviços com o opensalud, exceto quando aplicável, no que diz respeito a serviços de telemedicina para empresas. </p> <p>A Opensalud exige que cada profissional forneça à Opensalud informações pessoais e dados profissionais para comprovar sua identidade e credenciais, antes que a Opensalud permita que o profissional esteja disponível na plataforma.</p> <p>Cada Profissional deverá estar inscrito na associação oficial correspondente e ter em vigor as autorizações legais necessárias ao exercício da sua atividade. </p> <p>Da mesma forma, o opensalud poderá utilizar os serviços de verificação externa incluídos na regulamentação em vigor, caso o profissional necessite da utilização de funcionalidades, como a prescrição eletrônica por exemplo, que requeiram elementos adicionais de segurança.</p> <p>Ao aceitar os termos deste documento, você isenta e isenta expressamente a opensalud de qualquer responsabilidade associada à veracidade ou verificação das informações fornecidas pelos profissionais.</p> <p>A inclusão de profissionais em nossa plataforma não implica qualquer recomendação ou aprovação de tais profissionais. </p> <p>Todas as opiniões e declarações expressas por profissionais em ou através de nossa plataforma e durante qualquer sessão facilitada por ela são exclusivamente opiniões e declarações do Profissional, individual e independente, e não refletem as opiniões da opensalud. </p> <p>A Opensalud não está qualificada para avaliar a qualidade ou validade de qualquer tipo de aconselhamento médico ou psicológico.</p><p>Portanto, em qualquer caso e independentemente do canal pelo qual o paciente acesse os serviços do profissional, este manterá o opensalud inofensivo e livre de qualquer responsabilidade ou reclamação dos Usuários que esteja relacionada à prestação dos Serviços clínicos, sendo responsável o profissional de qualquer compensação deles derivada. </p> <p><b>Ao aceitar os termos deste documento, você isenta e isenta expressamente a opensalud de toda responsabilidade associada às consultas, conselhos, recomendações ou outras informações fornecidas pelo profissional ao paciente.</b></p> <br /> <h4>Credenciais e independência dos profissionais II</h4> <br /> <p>Não obstante o acima exposto, no caso de profissionais que prestam serviços diretamente às empresas clientes do opensalud, antes do início da prestação do serviço, os profissionais deverão aceitar expressamente as condições de prestação de serviços do opensalud.</p> <p>Para estes profissionais e além das verificações prévias realizadas pela opensalud no momento da inscrição, o profissional declara expressamente que possui todas as autorizações legais, fiscais e administrativas, bem como os correspondentes seguros e autorizações exigidas, onde adequado, ao exercício da sua actividade profissional. </p> <p>O profissional assume o compromisso de prestar um atendimento correto a todos os usuários do serviço, bem como de notificar o OpenSalud o mais rápido possível sobre qualquer incidente que os impeça de garantir a prestação adequada dos serviços (férias...).</p> <h4>Propriedade Intelectual do OpenSalud</h4> <p>A OpenSalud, por si ou como cessionária, é titular de todos os direitos de propriedade intelectual e industrial do site, bem como de sua estrutura de programação, bem como dos elementos nele contidos (Som, áudio, vídeo, imagens, software e outros , servindo apenas a título ilustrativo) e do qual todos os direitos são reservados ou, se for o caso, dos seus licenciantes, sendo expressamente proibida a utilização por terceiros, de acordo com a legislação em vigor sobre Propriedade Intelectual (Real Decreto Legislativo 1/1996, de 12 de abril) sem que haja consentimento formal por parte dos seus proprietários.</p> <p>O utilizador deverá abster-se de eliminar, alterar, evitar ou modificar qualquer dispositivo de proteção ou sistema de segurança que tenha sido instalado no site.</p> <p>Neste sentido, o site reserva-se o direito de exercer ações penais e civis que o protejam para fazer valer esses direitos contra terceiros.</p> <br /> <h4><u>3. Exclusão de garantias e responsabilidade</u></h4> <br /> <p>O site OpenSalud não se responsabiliza pelos danos derivados da utilização do site devido ao uso ou gestão indevida do mesmo, bem como pelos seus usos comuns, desde que tenha sido realizada a devida diligência de sua parte para garantir que estes não ocorrer.</p> <br /> <h4><u>4. Modificações</u></h4> <br /> <p>OpenSalud reserva-se o direito de fazer as modificações que considere oportunas sem aviso prévio em seu site, podendo modificar, excluir ou introduzir tanto os conteúdos e serviços por ele fornecidos, bem como a disposição ou organização dos mesmos no site.</p> <br /> <h4><u>5. Suas informações no OpenSalud e como elas são compartilhadas</u></h4> <br /> <p>Os dados e informações dos usuários do OpenSalud são privados. </p> <p>a) Uma vez cadastrado no site, você se torna usuário, porém esses dados só são acessíveis ao OpenSalud, bem como aos profissionais e centros com os quais você solicita consulta em qualquer uma de suas modalidades.</p> <p>b) As informações que você compartilhar serão acessíveis aos profissionais e, se for o caso, ao centro a que pertencem, a fim de garantir um atendimento correto e garantir a qualidade na prestação de serviços e em nenhum caso serão fornecidas a terceiros outros do que a prestação do serviço solicitado pelo usuário. </p> <br /> <h4><u>6. Seus direitos de imagem e propriedade intelectual no OpenSalud</u></h4> <br /> <p>Ao publicar conteúdos como imagens audiovisuais, fotografias e textos que estão sujeitos a direitos de propriedade intelectual (doravante, 'Conteúdos Sujeitos a Propriedade Intelectual'), você concede ao OpenSalud a possibilidade de utilizá-los sob uma licença não exclusiva, transferível e não exclusiva .ser sublicenciado, sem comissão ou outra necessidade de oferecer qualquer remuneração ao seu autor pela utilização, e âmbito internacional (doravante, 'Licença de Propriedade Intelectual'). </p> <br /> <h4><u>7. Uso de conteúdo</u></h4> <br /> <p>O site disponibiliza diversas informações e links que podem ser do interesse do usuário, que se compromete a fazer uso adequado dos conteúdos e serviços que oferece e, a título de exemplo, mas não limitado a, não utilizá-los para as seguintes atividades:</p> <p>1. Envolver-se através deles em atividades ilícitas, ilegais ou contrárias à boa-fé e à ordem pública.</p> <p>2. Causar qualquer tipo de dano aos sistemas próprios do site, aos seus fornecedores ou a terceiros, introduzir ou difundir vírus informáticos, cavalos de Tróia ou quaisquer outros sistemas que sejam suscetíveis ou capazes de gerar os danos acima mencionados.</p> <p>3. Realizar qualquer tipo de atividade que possa ser contrária ao direito à honra de qualquer um dos usuários ou administradores do OpenSalud.</p> <p>4. Realizar ações que visem falsificar os dados das compras realizadas.</p> <br /> <h4><u>8. Segurança no OpenSalud</u></h4> <br /> <p>Nossa equipe trabalha diariamente para garantir que o OpenSalud seja uma plataforma segura, respeitando a proteção de dados dos Usuários Cadastrados. </p> <p>a) A transmissão e divulgação de qualquer tipo de comunicação comercial não autorizada (como 'spam' ou 'junk mail') utilizando qualquer ferramenta de comunicação que OpenSalud ofereça aos Usuários Cadastrados.</p> <p>b) Acessar o OpenSalud de qualquer forma que não seja através de um navegador, aplicativo móvel oficial, exceto qualquer ferramenta que adicionarmos oficialmente no futuro e for notificada aos Usuários.</p> <p>c) A utilização de meios de acesso automático (como qualquer uso de tecnologias conhecidas como bots, robôs, spiders) que realizem uma interação dentro da plataforma OpenSalud e com qualquer um dos Usuários Cadastrados.</p> <p>d) A prática e participação em qualquer tipo de operação de marketing ilegal através do OpenSalud.</p> <p>e) Carregar vírus, scripts ou qualquer tipo de código com aspirações maliciosas contra o OpenSalud e cada um de seus Usuários Cadastrados.</p> <p>f) A solicitação de informações de registro e login para acessar a conta de outra pessoa física.</p> <p>g) Assédio, assédio, intimidação ou qualquer tipo de incômodo a qualquer um dos Usuários Cadastrados.</p> <p>h) A publicação de qualquer conteúdo ofensivo, chantagista ou pornográfico; </p> <p>i) O desenvolvimento ou utilização de aplicação de terceiros que inclua conteúdo relacionado ao consumo de álcool ou de natureza adulta (incluindo anúncios) sem as restrições de idade adequadas à região em questão.</p> <p>k) Utilizar o OpenSalud para qualquer tipo de atividade ilegal, seja contra a própria rede ou contra qualquer usuário, ou seja, qualquer ato que contrarie a regulamentação espanhola, especialmente aqueles que violem os direitos à privacidade e/ou honra dos usuários desta rede.</p> <p>l) Qualquer atividade que possa desabilitar, sobrecarregar ou impedir o correto funcionamento do OpenSalud, como um ataque de negação de serviço.</p> <p>m) Motivar direta ou indiretamente a violação desta Declaração.</p> <br /> <h4><u>9. Segurança e registro da conta</u></h4> <br /> <p>Os usuários são obrigados a fornecer seus nomes reais e informações reais. </p> <p>1. A utilização do OpenSalud se você tiver menos de 18 anos, exceto o registro feito através de um representante legal de acordo com estas condições.</p> <p>2. Compartilhar informações de acesso (nome de usuário e senha) para que outra pessoa possa acessar sua conta ou qualquer atividade que coloque em risco a segurança de sua conta ou de terceiros. </p> <br /> <h4><u>10. Preço e condições de pagamento</u></h4> <br /> <p>O acesso ao site OpenSalud é gratuito. </p> <p>Com exceção dos serviços de telemedicina para empresas, em que estas assumem integralmente o custo, para garantir a prestação dos serviços de teleconsulta (videoconsulta, consulta escrita ou segunda opinião), é necessária a introdução de um meio de pagamento no momento da reserva. consulta, solicitar uma videoconsulta imediata, solicitar uma segunda opinião ou consulta por escrito. </p><p>Dado que a regulamentação aplicável ao comércio eletrónico e aos meios de pagamento exige que tal seja especificado, é óbvio que dadas as características do serviço não existe possibilidade da sua devolução.</p> <p>Caso o paciente não fique satisfeito com o serviço prestado, deverá entrar em contato conosco através do formulário que aparece no final do site e selecionando a opção de reclamação. </p> <br /> <h4><u>11. Suspensão do serviço ou conta de usuário</u></h4> <br /> <p>Se for cometida qualquer violação dos pontos expressos nesta Declaração, o OpenSalud reserva-se o direito de cancelar imediatamente sua conta OpenSalud sem aviso prévio.</p> <br /> <h4><u>12. Assuntos Jurídicos</u></h4> <br /> <p>OpenSalud cumpre a legislação aplicável em Espanha e, portanto, os tribunais competentes em caso de conflito, deixando a escolha do consumidor.</p> <h4>Definições</h4> <p>1. 'OpenSalud' refere-se ao serviço que prestamos através do site para a gestão de consultas.</p> <p>2. 'Plataforma' significa as APIs e serviços que permitem que terceiros, incluindo desenvolvedores de aplicativos e operadores de sites, recuperem dados do OpenSalud e nos forneçam dados.</p> <p>3. “Informações” refere-se a quaisquer dados ou informações sobre você como usuário.</p> <p>4. 'Conteúdo' refere-se a qualquer coisa que você publique no OpenSalud que não se enquadre na definição de 'informação'.</p> <p>5. 'Dados' significa o conteúdo e as informações que terceiros podem recuperar do OpenSalud.</p> <p>6. 'Publicar' significa publicar no OpenSalud.</p> <p>7. «Utilização» significa a utilização, cópia, reprodução ou exibição pública, distribuição, modificação, tradução e criação de trabalhos derivados.</p> <p>8. “Benefícios” Qualquer prêmio, desconto, promoção ou similar que seja oferecido aos usuários do site.</p>"
      }
    }
  }
});

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditionsProfessional_vue__ = __webpack_require__(996);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484163e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditionsProfessional_vue__ = __webpack_require__(1620);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditionsProfessional_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484163e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditionsProfessional_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/TermsAndConditionsProfessional.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-484163e0", Component.options)
  } else {
    hotAPI.reload("data-v-484163e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_global_helpers__ = __webpack_require__(47);
//
//
//
//
//

/* eslint-disable */


var mx = {
  'terms-and-conditions-professional': '<p><b>bluMEDICA LATAM, S.A. DE C.V.,</b> como titular de la plataforma de los SITIOS WEB www.blumedica.mx,  www.opensalud.mx y www.openpsicologos.com (en lo sucesivo el SITIO WEB) CON DOMICILIO UBICADO EN: CALLE FUJIYAMA NUMERO 74, COLONIA LAS AGUILAS, ALVARO OBREGÓN, CODIGO POSTAL 01710, CIUDAD DE MÉXICO, por este medio establece y da a conocer, los TÉRMINOS Y CONDICIONES DE USO, a los que se sujetaran todas las personas físicas y/o morales (en lo sucesivo EL USUARIO), que deseen formar parte del Directorio de PROFESIONALES DE LA SALUD, del SITIO WEB.</p>            <br />            <br />            <h4><b>1. DISPONIBILIDAD DE LOS TERMINOS Y CONDICIONES DE USO</b></h4>            <br />            <p>Los presentes TÉRMINOS Y CONDICIONES, se exponen con carácter permanente en el SITIO WEB, donde EL USUARIO podrá consultarlos, archivarlos y/o imprimirlos en cualquier momento.  </p>            <br />            <p>Al solicitar su ingreso al Directorio de profesionales de la salud, acceder y hacer uso del SITIO WEB, EL USUARIO acepta en su totalidad y sin reservas, los presentes TÉRMINOS Y CONDICIONES, si EL USUARIO no estuviese de acuerdo los presentes TÉRMINOS Y CONDICIONES, ya sea en algunas de sus cláusulas o en la totalidad de ellas, se abstendrá de acceder y hacer uso del SITIO WEB.  </p>            <br />            <p>bluMEDICA se reserva el derecho, a su sola discreción, de cambiar, modificar, añadir, quitar o actualizar en cualquier momento, en su totalidad o en partes, los presentes TÉRMINOS Y CONDICIONES.</p>            <br />            <p>Los cambios en los TÉRMINOS Y CONDICIONES, serán efectivos en cuanto sean publicados en el SITIO WEB; por lo que, acceder y/o hacer uso de LA PLATAFORMA, después de haber sido publicado cualquier cambio, será considerado como aceptación del mismo, por lo tanto, es responsabilidad DEL USUARIO leer los términos y condiciones vigentes.</p>            <br />            <br />            <h4><b>2. DEL SITIO WEB</b></h4>            <br />            <p>bluMEDICA se reserva el derecho de terminar, cambiar, suspender o descontinuar cualquier aspecto del SITIO WEB, de LA PLATAFORMA, en cualquier momento.  </p>            <br />            <p>Además, puede restringir, suspender, cancelar o terminar el acceso de EL USUARIO al SITIO WEB y/o a LA PLATAFORMA, y/o tomar la acción legal que juzgue conveniente, en los siguientes casos: </p>            <br />            <p>                a)	Cuando EL USUARIO proporcione datos incorrectos con el fin de registrarse o ingresar al Directorio de PROFESIONALES DE LA SALUD, en el SITIO WEB <br />                b)	Cuando EL USUARIO no cumpla con los presentes Términos y Condiciones, los Avisos de Privacidad o con la ley aplicable.<br />                c)	Cuando EL USUARIO no de cumplimiento a cualquier normativa aplicable respecto del acceso y/o el uso del SITIO WEB o LA PLATAFORMA.<br />                d)	Cuando EL USUARIO le dé un uso  al SITIO WEB y a su contenido distinto al autorizado.<br />                e)	Cuando le sea a ordenado por autoridad competente.            </p>            <br />            <br />            <h4><b>3. DEL SERVICIO</b></h4>            <br />            <br />            <p>                Los servicios proporcionados por bluMEDICA, consisten únicamente, en proporcionar una plataforma tecnológica, para la gestión en línea de citas presenciales y no presenciales (consulta en línea, presencial, video consulta o segunda opinión), a través de la cual, EL USUARIO, podrá ser contactado a través del SITIO WEB por los interesados en los servicios que se ofrecen a través de éste (en lo sucesivo PACIENTE).<br />            </p>            <p>                En el SITIO WEB, se pondrá  a disposición de los PACIENTES, un directorio de PROFESIONALES DE LA SALUD, dentro del Territorio Nacional, en el que se ingresaran los datos de EL USUARIO, una vez que este haya proporcionado a bluMEDICA los documentos necesarios para acreditar su identidad y estar certificado o autorizado para el ejercicio de su actividad en el área de la salud. <br />            </p>            <p>                EL USUARIO, se obliga a presentar a bluMEDICA  información real y actualizada, asumiendo EL USUARIO, toda responsabilidad derivada de la falta de veracidad de dicha información y las consecuencias que ello pudiere generar en la prestación de su servicios. <br />            </p>            <p>                El USUARIO, al ser contactado por algún PACIENTE a través del SITIO WEB, podrá solicitar al PACIENTE la información médica, incluyendo estudios, tratamientos, padecimientos, etc., que requiera para la prestación del servicio de consulta en la modalidad que el PACIENTE haya  solicitado, el uso de dicha información es responsabilidad del USUARIO,  quien se obliga a dar cumplimiento a las Leyes de protección de datos, vigentes en éste país, bajo su más estricta responsabilidad, así como al aviso de privacidad de bluMEDICA, que se encuentran disponibles para su lectura en el SITIO WEB <a href="www.blumedica.mx">www.blumedica.mx</a>, en el apartado Aviso de Privacidad para Pacientes, y que el USUARIO manifiesta haber leído y comprendido en todos y cada uno de sus términos y comprometerse a darle cumplimiento en términos de ley, POR LO TANTO, AL HACER USO DEL SITIO WEB, EL USUARIO LIBERA A BLUMEDICA  DE CUALQUIER RESPONSABILIDAD, DERIVADA DEL USO O TRATAMIENTO ILEGAL O INADECUADO QUE EL USUARIO DÉ A LA INFORMACION PERSONAL QUE LE SEA ENVIADA POR EL PACIENTE.<br />            </p>            <p>                A través de la plataforma de bluMEDICA podrán imprimirse recetas médicas, estando limitado el sistema, a una sola impresión por receta, la emisión de dichas recetas, así como su contenido, es responsabilidad del USUARIO, quien deberá cumplir con la normativa vigente en este país, para la emisión de las mismas y el control de los medicamentos, por lo que BLUMEDICA se deslinda de cualquier responsabilidad al respecto.            </p>            <br />            <br />            <h4><b>4. LIMITE DE LOS SERVICIOS</b></h4>            <br />            <br />            <p>                El servicio de bluMEDICA, consiste en una  PLATAFORMA de tecnología, que permite a EL USUARIO del sitio web, establecer conexión con PACIENTES, reduciendo desplazamientos y costos innecesarios. <br />            </p>            <p>                La aprobación e inclusión de profesionales de la salud en el directorio del sitio web, no implica recomendación de los mismos por parte de bluMEDICA, por lo que cualquier opinión, tratamiento, diagnóstico, prescripción, que realice EL USUARIO a EL PACIENTE, a través de LA PLATAFORMA, son particulares e independientes de BLUMEDICA, y bajo la más estricta responsabilidad del USUARIO; siendo decisión y responsabilidad del PACIENTE seguirlas o no, liberando desde este momento de cualquier responsabilidad al respecto a BLUMEDICA. <br />            </p>            <p>                EL USUARIO, es responsable de la prescripción de los medicamentos al PACIENTE, al igual que toda transacción o acuerdo que realice con el mismo, siendo el USUARIO responsable de cualquier información que el PACIENTE le proporcione a través de sus medios de contacto personales, por lo que desde este momento, bluMEDICA queda liberada de cualquier responsabilidad al respecto.  <br />            </p>            <p>                POR LO TANTO, EL USUARIO RECONOCE QUE BLUMEDICA, NO PRESTA SERVICIOS MEDICOS DE NINGÚN TIPO Y QUE NO ESTÁ SIENDO EMPLEADO POR BLUMEDICA DE FORMA ALGUNA, SIENDO ÉSTA ULTIMA, UNICAMENTE UNA PLATAFORMA DE CONTACTO ENTRE EL USUARIO Y EL PACIENTE.<br />            </p>            <br />            <br />            <h4><b>5. DATOS PERSONALES DE USUARIOS</b></h4>            <br />            <br />            <p>                LOS USUARIOS se comprometen a proporcionar información real, precisa y actualizada acerca de sus datos personales, sensibles y en general de todos los datos que proporcionen a través de LA APLICACIÓN, con la finalidad de poder ofrecer los servicios adecuados a los PACIENTES. <br />            </p>            <p>                LOS USUARIOS deslindan de cualquier responsabilidad a bluMEDICA que se pudiera generar derivada de datos erróneos o falsos. <br />            </p>            <p>                El uso y recopilación de información de bluMEDICA tiene la finalidad de conectar al USUARIO con EL PACIENTE, así como demás finalidades señaladas en el AVISO DE PRIVACIDAD del SITIO WEB www.blumedica.mx, en el apartado Aviso de Privacidad para Profesionales de la Salud, el cual está incorporado al mismo para que pueda ser consultado, archivado o impreso en cualquier momento por EL USUARIO y que manifiesta haber leído y comprendido en todos y cada uno de sus términos.<br />            </p>            <p>                EL USUARIO, por lo que hace a sus datos personales, podrá, en cualquier momento, ejercitar los derechos de acceso, oposición, rectificación y cancelación reconocidos en la normativa vigente a través de www.blumedica.mx de acuerdo al AVISO DE PRIVACIDAD, publicado en dicha página.            </p>            <br />            <br />            <h4><b>6. PROPIEDAD INTELECTUAL DE LOS USUARIOS.</b></h4>            <br />            <br />            <p>                Por lo que hace a las imágenes, audiovisuales, fotografías y textos que estén sujetos a derechos de propiedad intelectual de LOS USUARIOS éstos otorgan a bluMEDICA, la autorización para que el SITIO WEB haga uso de los mismos, pero en ningún caso, que realice actividad comercial directa a través de la venta o cesión de dichos contenidos a terceros. <br />            </p>            <br />            <br />            <h4><b>7. PRECIO Y MÉTODO DE PAGO</b></h4>            <br />            <br />            <p>                EL USUARIO determinará el costo de los servicios que ofrecerá a través del SITIO WEB, una vez que se haya dado la consulta en la modalidad solicitada por el PACIENTE, dado el diagnóstico por EL USUARIO y emitida la receta, el PACIENTE procederá a realizar el pago por los servicios prestados. <br />            </p>            <p>                El pago de la consulta, podrá realizarse a través de la página web www.opensalud.mx, mediante el proveedor de servicios de cobro OPENPAY, por medio del pago en línea con tarjeta bancaria, dicho pago se realizará por EL PACIENTE a favor de bluMEDICA, de dicho pago bluMEDICA retendrá el 10% (DIEZ POR CIENTO) más I.V.A de su monto y por la cantidad restante se realizará transferencia bancaria a favor de EL USUARIO de acuerdo a los datos bancarios proporcionados por éste.            </p>            <p>                Los pagos desde bluMEDICA al USUARIO, se realizarán los primeros días del mes inmediato posterior al mes de su consulta.            </p>            <p>                bluMEDICA otorgará al USUARIO, el comprobante fiscal respectivo, por concepto de cobro de la cantidad retenida, de acuerdo a los datos de facturación proporcionados por EL USUARIO.            </p>            <br />            <p>                De igual manera, EL USUARIO será el responsable de otorgar al PACIENTE, el comprobante de pago respectivo por los servicios prestados, quedando liberado bluMEDICA de cualquier responsabilidad al respecto.            </p>            <br />            <br />            <h4><b>8. CANCELACION DEL SERVICIO</b></h4>            <br />            <br />            <p>                EL USUARIO, podrá cancelar la cita otorgada al PACIENTE, en caso de alguna dificultad técnica o por causa de fuerza mayor, debiendo en todo caso reagendarla, en caso de no ser así, bluMEDICA  puede restringir, suspender, cancelar o terminar el acceso de EL USUARIO al SITIO WEB y/o a LA PLATAFORMA.<br />            </p>            <p>                EL PACIENTE podrá, sin costo alguno, cancelar la cita en cualquier momento, antes de haberse llevado a cabo la consulta.            </p>            <br />            <br />            <h4><b>9. USO DE COOKIES, WEB BEACONS Y OTRAS HERRAMIENTAS INFORMÁTICAS DE RECOPILACIÓN DE DATOS</b></h4>            <br />            <br />            <p>                Al ingresar al SITIO WEB, EL USUARIO acepta recibir las cookies que se transmitan a través de este.  Las “Cookies” son archivos de datos que se generan cuando te conectas a una página o sitio web, y se almacenan en el disco duro de la computadora, pueden contener información sobre el perfil de conducta en internet dentro del sitio web. Los datos recabados a través de este medio, se utilizan para mejorar el SITIO WEB y ajustarlo al comportamiento de los usuarios que lo visitan, así como para el trámite de los registros y la remisión de información. Una Cookie no puede leer los datos o información del disco duro del usuario ni leer las Cookies creadas por otros sitios o páginas. <br />            </p>            <p>                En el apartado “Ayuda” de la barra de herramientas de la mayoría de los buscadores se señala al Usuario cómo impedir que su buscador acepte nuevos cookies, cómo hacer que su buscador le avise de la recepción de nuevos cookies, o cómo inhabilitar todos los cookies. Sin embargo, si usted inhabilita los cookies, algunas de las aplicaciones de nuestro SITIO WEB pueden quedar también inhabilitadas, y el uso de la página web puede verse limitado.<br />            </p>            <br />            <br />            <h4><b>10. LIMITACIÓN DE RESPONSABILIDAD</b></h4>            <br />            <br />            <p>                bluMEDICA de acuerdo a lo permitido por las leyes aplicables, no garantiza que el SITIO WEB y los servicios que ofrece, sufran de interrupciones o puedan estar sujetos a errores; eventualmente podrá no estar disponible por alguna falla en la conectividad de internet o técnica en sus componentes o cualquier razón ajena a nosotros.<br />            </p>            <p>                En ningún caso bluMEDICA, será responsable de Controlar o informar acción alguna que haga referencia a la presencia o ausencia de errores, virus, gusanos, material o información contaminante o cualquier otro elemento informático dañino. Por lo que BLUMEDICA queda liberado de imputación alguna por tales causas, así como del pago de toda  indemnización bajo cualquier concepto, por los perjuicios resultantes de dificultades técnicas o fallas en los sistemas o en internet, dado que es responsabilidad de EL USUARIO el contar con herramientas adecuadas para la detección y desinfección de programas informáticos dañinos.<br />            </p>            <p>                bluMEDICA en ningún caso y bajo ninguna circunstancia, será responsable por daños de cualquier tipo, que EL USUARIO pueda tener por causa de fallas en las telecomunicaciones, redes o desconexiones que limiten el uso, interrumpan o cancelen el servicio brindado en este SITIO WEB.<br />            </p>            <p>                bluMEDICA sus proveedores y colaboradores podrán actualizar en cualquier momento el contenido e información del SITIO WEB; por lo que en ocasiones algunas funciones e información publicada dentro de nuestro sitio puede ser obsoleta, contener errores ortográficos y/o tipográficos, dichas actualizaciones serán constantes y tienen por objeto dar el mejor servicio a todos nuestros clientes.<br />            </p>            <p>                bluMEDICA tiene completas facultades para revisar e investigar el uso ilegal y no autorizado del SITIO WEB de conformidad con los presentes Términos y Condiciones y lo establecido por las leyes aplicables.<br />            </p>            <p>                bluMEDICA se reserva el derecho de no permitir el acceso de EL USUARIO a LA PLATAFORMA, sin perjuicio de cualquier otra acción que en defensa de sus intereses ejerza,  cuando tenga indicios que:<br />            </p>            <p>                a)	EL USUARIO tiene conducta difamatoria, violatoria o que represente un riesgo para la información contenida en el SITIO WEB.                b)	EL USUARIO violenta las leyes aplicables, nacionales e internacionales relativas al uso de la información, derechos de autor y propiedad intelectual, del contenido disponible en este SITIO WEB.<br />            </p>            <p>                bluMEDICA tiene la facultad de investigar el tipo de uso ilegal o no autorizado del SITIO WEB en conformidad a los presentes Términos y Condiciones, por tal motivo, EL USUARIO acepta que, en cualquier caso en que se le atribuya responsabilidad de manera directa o indirecta a BLUMEDICA, sus empresas subsidiarias, accionistas, consejo directivo y ejecutivo, afiliados, proveedores, asesores o empleados, deberá sacar a ésta última en paz y a salvo, así como pagar los daños y perjuicios ocasionados.            </p>            <br />            <br />            <h4><b>11. PROPIEDAD INTELECTUAL</b></h4>            <br />            <br />            <p>                Las marcas y logotipos de bluMEDICA así como el contenido del sitio web, de LA PLATAFORMA, el nombre de dominio, los sistemas utilizados, bases de datos, y en general los derechos de autor respecto del contenido, información, fotografías, imágenes, aplicaciones, programas y en su totalidad y generalidad el contenido publicado en este SITIO WEB y LA PLATAFORMA están debidamente registrados y protegidos por sus respectivos propietarios de conformidad a la legislación aplicable, por tales motivos, EL USUARIO no puede darle un uso distinto al establecido en los presentes Términos y Condiciones. <br />            </p>            <p>                Queda estrictamente prohibido eliminar, suprimir, alterar, modificar, reproducir, descargar, publicar, explotar, distribuir o corromper el uso del contenido de este SITIO WEB, ya sea para fines comerciales o de cualquier otra índole. El incumplimiento de lo antes previsto, podría derivar en responsabilidad civil, penal u otra de cualquier tipo.<br />            </p>            <p>                El ingresar o hacer uso del SITIO WEB de ninguna manera concede al USUARIO, licencia ni autorización tácita o expresa para el uso de los derechos de propiedad Intelectual, de sus marcas o de sus proveedores, ni de cualquier material utilizado o que exista en el SITIO WEB. <br />            </p>            <p>                El uso de las imágenes, ilustraciones y sus fragmentos; así como el demás material que sea objeto de protección de los derechos de autor, será para fines informativos e ilustrativos, por lo que cualquier uso distinto como el lucro, reproducción, edición o modificación, será perseguido legalmente por bluMEDICA o por el titular de los derechos de propiedad intelectual.<br />            </p>            <p>                bluMEDICA se reserva el derecho de investigar y procesar, cualquier intento y/o comisión de infracción en materia de derechos de autor o propiedad industrial, relacionada con el material contenido en el SITIO WEB y/o las violaciones del sistema informático o de la seguridad de la red, mismas que pueden generar responsabilidades civiles o penales y que a consideración de BLUMEDICA podrán ser denunciadas ante las autoridades competentes.            </p>            <br />            <br />            <h4><b>12. NO RELACIÓN LABORAL</b></h4>            <br />            <br />            <p>                LOS USUARIOS reconocen y aceptan que las únicas relaciones jurídicas existentes entre ellos y bluMEDICA son las derivadas de los presentes Términos y Condiciones, por lo que los mismos no crean sociedad, asociación, o figura jurídica análoga a las anteriores, siendo cada uno responsable de sus obligaciones de carácter laboral, fiscal, civil o de cualquier otra naturaleza.<br />            </p>            <p>                Los servicios que ofrecen LOS USUARIOS, son independientes y sin subordinación alguna a bluMEDICA, no implicando por ello relación de trabajo con esta última ni con ningún representante legal o socio de BLUMEDICA.            </p>            <br />            <br />            <h4><b>13. NO CESIÓN</b></h4>            <br />            <br />            <p>                Ni LOS USUARIOS, ni los PACIENTES, podrán ceder sus derechos de acceso y uso de la plataforma, en caso contrario, bluMEDICA podrá restringir el acceso y ejercer las acciones legales que estime pertinentes.            </p>            <br />            <br />            <h4><b>14. DATOS DE CONTACTO</b></h4>            <br />            <br />            <p>                Para cualquier solicitud de aclaraciones, reclamaciones o información bluMEDICA pone a disposición de EL USUARIO el correo electrónico rambrosi@blumedica.mx, o bien el número telefónico (55) 5920 9768.            </p>            <br />            <br />            <h4><b>15. JURISDICCIÓN Y COMPETENCIA</b></h4>            <br />            <br />            <p>                Para la interpretación y cumplimiento de los presentes TERMINOS Y CONDICIONES, las partes se someten expresamente a las Leyes y Tribunales competentes en la Ciudad de México, renunciando a cualquier otro fuero que con motivo de su domicilio presente o futuro pudiera llegar a corresponderles.            </p>            <br />            <br />'
};

var en = __WEBPACK_IMPORTED_MODULE_0__helpers_global_helpers__["l" /* inMx */] ? mx : { 'terms-and-conditions-professional': "<p>This agreement has been written in Spanish (Spain). In case of discrepancies between the original and a translated version, the original in Spanish shall be the binding document. Statement of Responsibilities and Rights.</p> <p>This Declaration of Rights and Responsibilities regulates the relationship of opensalud, openhealth and other open healthcare websites accessible through <a href='https://www.openhealthcare.es'>www.openhealthcare.es</a> (hereinafter we refer to all as ‘opensalud’), their users and doctors, psychologists and other professionals who make use of the website, with regard to subscribing to and using the professional’s services on the platform. Professionals who access and use opensalud expressly agree to our terms of service without any reservation. In the event of any reservation or waiver thereof, the user will be deemed to refuse his membership and will be unsubscribed when such statement is expressed. To obtain the status of a professional on this website, it is necessary to be a registered user and thereby expressly submit to and accept all the provisions laid out in these Terms of Service. Using the website, its services in general and other content specifically, implies the user undertakes to do so in accordance with the law, the provisions of these Terms of Service, and other established instructions or regulations that are brought to the attention of the user.</p> <br /> <h4><u>1. Corporate legal information</u></h4> <br /> <p>The owner of the website is the company OpenHealthCare S.L., with registered office at Avda. República Argentina 25, 9st floor 41011 41004 Seville and VAT: B90209081 (hereinafter referred to as 'OpenSalud'), registered in the Commercial Registry of Seville in volume 6043, page 101, inscription 1 with sheet SE-105834.</p> <br /> <h4><u>2. The Service of OpenSalud</u></h4> <br /> <p>OpenSalud is a platform for online management of face-to-face and non-face-to-face appointments in the scope of healthcare with private centres or professionals as well as providing consultations in a virtual environment.</p> <p>This service provides users with an online platform that allows them to request a face-to-face appointment or virtually connect with doctors and healthcare professionals. In no case does OpenSalud provide medical or psychological diagnosis, treatment or prescription of any kind. Trusting any information provided through the platform or by any professional who uses opensalud will be under your own responsibility.</p> <p>Users of the opensalud platform have a service level agreement (SLA) that can be consulted through the website at the following <a href='https://opensaludes.sharepoint.com/sites/General2/Documentos%20compartidos/Forms/AllItems.aspx?id=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio%2FAcuerdo%20de%20nivel%20de%20servicio%20%28SLA%29%2Epdf&parent=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio&p=true&ga=1'>link.</a></p> <p>Every user has the right to formally submit a complaint or claim through the following email address: quejas@opensalud.es. The internal managers of the Incidents and Operations departments, as well as the OH management, are responsible for handling these complaints or claims. Complaints or claims received in the corresponding email address will be processed within a maximum period of one month.</p><br /> <h4>Credentials and independence of professionals I</h4> <br /> <p>Professionals who use or appear on the website/application are neither employees nor have any type of contract as service providers with opensalud, except where appropriate, related to telemedicine services for companies. Opensalud does not provide opinions, advice or medical care and disclaims all responsibility for the opinions, advice and information provided by professionals through the platform. Opensalud neither recommends nor endorses any test, doctor, products, procedures, opinions or other information that may be mentioned on opensalud or by a professional.</p> <p>Opensalud requires each professional to provide opensalud with personal information and professional details to prove his identity and credentials, before opensalud allows the professional to be available on the platform.</p> <p>Each Professional must be registered with the corresponding official professional body and have the required legal qualifications to perform his activity. In this regard, the professional expressly authorises opensalud to verify his information with the corresponding Official College.</p> <p>Likewise, opensalud may use the external verification services included in current regulations, in the event that the professional requires the use of functionalities, such as the electronic prescription for example, that require additional security elements.</p> <p>By accepting these terms, you expressly release and discharge opensalud from any and all liability associated with the veracity or verification of the information provided by you as a professional.</p> <p>The inclusion of professionals on our platform does not imply any recommendation or approval of such professionals. The use of the platform by any entity or individual to verify the credentials of professionals is prohibited.</p> <p>All opinions and statements expressed by professionals on or through our platform and during any session provided through it are solely the views and statements of the (individual and independent) Professional and do not reflect the views of opensalud. </p> <p>Opensalud is not qualified to evaluate the quality or validity of any type of medical or psychological advice.</p><p>Therefore, in any case and regardless of the channel through which the patient accesses the services of the professional, this will hold harmless and free opensalud of any liability or claim of users that is related to the provision of clinical services, taking responsibility for any compensation arising therefrom. In the case of clinical care to users of opensalud client companies, the professional expressly declares that it has all the legal, fiscal, administrative, as well as the relevant insurance and permits required in your case, for the exercise of their activity in the private sector. Opensalud may at any time require documentary evidence of compliance with these obligations.</p> <p><b>By agreeing to the terms thereof, you expressly release and discharge opensalud from all liability associated with the consultations, advice, recommendations or other information that is provided by the practitioner to the patient.</b></p> <br /><h4>Credentials and independence of professionals II</h4><br /> <p>Notwithstanding the above, in the case of professionals who provide services directly to opensalud client companies, prior to the start of the provision of the service, the professionals must expressly accept the conditions of service provision for opensalud. For these professionals and In addition to the prior checks carried out by opensalud at the time of registration, the professional expressly declares that he or she has all the legal, fiscal, and administrative authorizations, as well as the corresponding insurance and permits required, where applicable, for the exercise of his or her duties. professional activity. Opensalud may require you to prove compliance with the aforementioned obligations.</p> <p>The professional assumes the commitment to provide correct care to all users of the service, as well as to notify opensalud as soon as possible of any incident that prevents them from guaranteeing the adequate provision of services (holidays...).</p> <br />  <h4>Intellectual Property of OpenSalud</h4> <br /> <p>OpenSalud by itself or as a transferee, owns all the intellectual and industrial property rights of the website, as well as its programming structure and the elements contained therein (sound, audio, video, images, software and others, this serving only for illustrative purposes) and reserves all rights or, when applicable, those of its licensors, being expressly prohibited the use by third parties, in accordance with the Intellectual Property regulations in force (Royal Legislative Decree 1/1996, of 12 April) without formal consent from their owners. The user must refrain from deleting, altering, avoiding or changing any protection device or security system that has been installed on the website. In this regard, the website reserves the right to exercise both criminal and civil actions at its disposal to give effect to these rights against third parties.</p> <br /> <h4><u>3. Exclusion of warranties and liability</u></h4> <br /> <p>The OpenSalud website is not responsible for damages resulting from improper use of or actions through the website, nor resulting from common use thereof, provided it has fulfilled its due diligence obligations to prevent these from occurring. At the same time, given its character as a platform to interconnect professionals and users, it disclaims any liability for consultations and questions, recommendations or any activity that links both parties.</p> <br /> <h4><u>4. Modifications</u></h4> <br /> <p>OpenSalud reserves the right to make the modifications it deems appropriate on its website without prior notice, such as modifying, deleting or introducing both the content and services provided thereon, as well as the provision or organisation thereof on the website.</p> <br /> <h4><u>5. Your information on OpenSalud and how it is shared</u></h4> <br /> <p>The data and information of OpenSalud users are private. The information entered on the website must be authentic, that is, be real in order to be able to provide a correct service. In the event such information is false, OpenSalud shall be exempt from any damage or liability that may result from such false information.</p> <p>After subscribing to the website, you become a professional user, and your information will be made available to users for the purpose of making an appointment. The information related to your clients and their associated details, however, will not be made public. By accepting these terms and conditions you agree to the dual relationship of data processor to be carried out, in such a way that:</p> <p>1) In accordance with the Organic Law on Data Protection you expressly declare compliance with all legal obligations, as well as the required technical and organizational measures, assuming full responsibility in the event of non-compliance with said regulations.</p> <p>2) In accordance with said regulations, you accept the relationship as the Data Processor with respect to the personal data of registered users provided to opensalud for the purpose of making appointments and consultations, maintaining in all cases the level of data specially protected for said information.</p> <p>3) In turn, with respect to the information you store about your clients, OpenSalud assumes its status as Data Processor for special category personal data in accordance with the RGPD.</p> <br /> <h4><u>6. Your Image and Intellectual Property Rights on OpenSalud</u></h4> <br /> <p>When you publish content such as audio-visual images, photographs and texts that are subject to intellectual property rights (hereinafter referred to as 'Content subject to Intellectual Property'), you grant OpenSalud the possibility to use such material under a non-exclusive, transferable license and without the possibility of sublicense, free of any commission or other means of offering any compensation to its author for the use and international scope (hereinafter, 'Intellectual Property License'). That is, you authorise the platform to make use of it, but in no case, to undertake direct commercial activities through the sale or transfer of such content to third parties for its actual operation.</p> <br /> <h4><u>7. Use of content</u></h4> <br /> <p>The website provides certain information and links that may be of interest to the user, who undertakes to make appropriate use of the content and services it offers and, including but not limited to, not to use it for the following activities:</p> <p>1. Engage in illicit or illegal activities, or contrary to good faith and public order through them.</p> <p>2. Cause any type of damage to the systems of the website, its suppliers or third parties, introduce or spread computer viruses or Trojans on Internet, or any other systems that are susceptible or able to generate such damages.</p> <p>3. Perform any type of activity that may be contrary to the right to honour of any of the users or administrators of OpenSalud.</p> <p>4. Carry out the registered professional activity without the qualification required for it.</p> <br /> <h4><u>8. Security on OpenSalud</u></h4> <br /> <p>Our team works daily to ensure that OpenSalud is a secure platform, respecting the data protection of Registered Users. However, like on any other Internet platform, data protection cannot be guaranteed absolutely and under all circumstances. However, in order to comply with such protection with maximum security, Registered Users understand that it is expressly prohibited to:</p> <p>a) Transfer and spread of any type of unauthorised commercial communication (such as 'spam') by using any communication tool that OpenSalud offers to Registered Users.</p> <p>b) Access OpenSalud in any other way than through a browser, official mobile application or any tool that we officially may add in the future and notify Users about.</p> <p>c) Use automated means of access (such as any use of technology known as bots, robots, spiders) that interact within the OpenSalud platform and with any of the Registered Users.</p> <p>d) Perform and participate in any type of illegal marketing operation through OpenSalud.</p> <p>e) Upload viruses, scripts, or any type of malicious code against OpenSalud and each of its Registered Users.</p> <p>f) Request registration and login information to access another person’s account.</p> <p>g) Harass, burden, intimidate or otherwise annoy any of the Registered Users.</p> <p>h) Publish any content that is offensive, blackmailing or pornographic; or that incites violence; or contains unwarranted nudity or graphic violence.</p> <p>i) Develop or use the application for third parties that include content related to the consumption of alcohol or of an adult nature (including advertisements) without the appropriate age restrictions to the specific region.</p> <p>k) Use OpenSalud for any type of illegal activity, whether against the network itself or against any user, that is, any act that contravenes Spanish law, especially acts that violate the rights to privacy and/ or honour of users of this network.</p> <p>l) Perform any activity that may disable, overload or impede the proper functioning of OpenSalud, such as a denial of service attack.</p> <p>m) Directly or indirectly inspire to violation of this Statement.</p> <br /> <h4><u>9. Account and registration security</u></h4> <br /> <p>Users are required to provide their real names and real information. They understand that it is expressly prohibited to:</p> <p>1. Share access information (user and password; or secret key in the case of programmers) for someone else to access their account or perform any activity that compromises the security of their account and that of others.</p> <p>2. Transfer their account to another person under any circumstance, given the professional nature of it.</p> <br /> <h4><u>10. Access and Price</u></h4> <br /> <p>For professional users, the cost of using the platform will be as follows:</p> <p><b>For individual professionals:</b>. <u>€9,90/month</u> per professional (free for 6 months).</p> <p><b>For centers: </b>€29/month up to 5 professionals + €5/ month per additional professional with a maximum of €190/month. For centers with more than 40 professionals or that require an integration project, request a quote. This rate will be free for 6 months without any commitment. The professional can automatically cancel/activate the rate at any time in the My profile section. The main services included in the fee are the following: </p> <div style='margin-left:20px;'> <p>- Access to the directory of professionals</p> <p>- Individual professional page. https://nombreprofesional.opensalud.es</p> <p>- Booking and Agenda online</p> <p>- Health data/clinical history with unlimited storage in a secure environment</p> <p>- Prescription in digital format (electronic prescriptions are not included)</p> <p>- Online services (teleconsultation)</p> <div style='margin-left:40px;'> <p>. Scheduled video consultation</p> <p>. Immediate video consultation</p> <p>. Chat</p> <p>. Written query</p> <p>. Second medical opinion</p> </div> <p>- Advanced payment system for credit/debit cards in Spain and abroad. Guaranteed collections with a pre-authorization system.</p> <p>- Automatic billing</p> <p>- Customizable prices, creation of packages and subscriptions</p> <p> Other functionalities available in opensalud as of the 30th September 2022 except for the electronic prescription (if it includes a digital prescription). </p> </div> <p>Any service (consultation, video consultation, written consultation and chat) charged through the payment gateway of the platform, including, where appropriate, the authorization gateways of the insurance companies, have a commission of 3,5% (1,5% if your monthly billing exceeds the amount of 2500€). In the case of transactions carried out in foreign currency with patients from outside the Euro zone, there may be additional charges for currency exchange. There is no commission for face-to-face consultations that are not charged through the platform, as well as consultations with business services. </p><p>In the case of second opinion services provided exclusively for patients not residing in Spain, the conditions may be different from those referred to here. In any case, these conditions will be known by the professional prior to the activation of these services.</p> <p>The issuance of prescriptions in electronic format may have an additional cost, which will be communicated to you before selecting this service.</p><p>The indicated rates do not include the corresponding VAT.</p><p>In the case of new registrations and renewals, these rates replace the Plus, Advance and Basic rates in force until September 30, 2022.</p><p>Since the regulations applicable to electronic commerce and means of payment require specifying it, it is obvious that considering the characteristics of the service there is no possibility of returning it.</p> <p>Those professionals who have joined the opensalud4all program, provide services in opensalud360 or belong to a group (medical association, official colleges...) with which the company maintains a collaboration agreement, will have a bonus to 0 euros the monthly fee for a maximum of 24 months. If you need more information about the bonuses, you can contact us in the active chat on this same page or in the contact form.</p> <br /> <h4><u>11. Suspension of the service or user account</u></h4> <br /> <p>If you violate any of the provisions in this Statement, OpenSalud reserves the right to immediately cancel your account on OpenSalud without prior notice. At the same time, OpenSalud has the internal policy of keeping its users informed about any incident or change in its services that could alter the habits of access of Registered Users to the platform, and will therefore, depending on the severity of the conduct and the social network, require users to cease such activity which is in breach of these terms and conditions or proceed to delete the violating user, at the discretion of the platform’s administrators.</p> <br /> <h4><u>12. Legal Issues</u></h4> <br /> <p>OpenSalud adheres to the applicable legislation in Spain and with it, the courts that have jurisdiction in the event of a conflict, it being up to the consumer to determine which is his court of jurisdiction.</p> <br /> <h4>Definitions</h4> <br /> <p>1. 'OpenSalud' means the service we provide through the website to manage consultations.</p> <p>2. 'Platform' means the APIs and services that allow others, including application developers and website operators, to retrieve data from OpenSalud and to provide us with data.</p> <p>3. 'Information' means any data or information about you as a user.</p> <p>4. 'Content' means anything you post on OpenSalud that is not included in the definition of 'Information'.</p> <p>5. 'Data' means the content and information that a third party may retrieve from OpenSalud.</p> <p>6. 'Publish' means to publish on OpenSalud.</p> <p>7. 'Use' means to use, copy, reproduce or publicly display, distribute, modify, translate and create derivative works.</p> <p>8. 'Benefits' Any prize, discount, promotion or similar that is provided to users of the website.</p>" };

/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: {
    messages: {
      en: en,
      es: {
        'terms-and-conditions-professional': "<p>Este acuerdo ha sido escrito en español (España). En caso de existir discrepancias entre el original y una versión traducida, el original en español es el documento vinculante. Declaración de responsabilidades y de derechos.</p> <p>Esta Declaración de derechos y responsabilidades regula la relación de opensalud , opensalud 360 y el resto de webs de open healthcare accesibles a través de <a href='https://www.openhealthcare.es'>www.openhealthcare.es</a> (en adelante nos referimos a todas como opensalud), sus usuarios y los médicos , psicólogos y otros profesionales que hacen uso de la web, en lo relativo al alta y uso de los profesionales de la plataforma. Los profesionales que acceden y utilicen opensalud están aceptando expresamente nuestros términos de servicio sin reserva alguna, en el caso de que se produjese reserva o renuncia alguna a los mismos, se entenderá que el usuario rechaza formar parte de la misma y se procederá a la baja de su usuario cuando dicha declaración sea expresada. Para obtener la condición de profesional de la presente web, es necesario ser usuario registrado de la misma, sometiéndose y aceptando expresamente con ello, todo lo dispuesto en estos Términos del Servicio. Utilizar la web, sus servicios con carácter general y otros contenidos con carácter particular, implica que el usuario se compromete a hacerlo con arreglo a lo dispuesto en la Ley, a lo estipulado en estos Términos del Servicio, y a lo establecido en otras instrucciones o normativas de uso que se establezcan y se pongan en conocimiento del usuario.</p> <br /> <h4><u>1. Información legal corporativa</u></h4> <br /> <p>El titular del sitio web es la sociedad OpenHealthCare S.L., empresa con domicilio sito en Avda. República Argentina 25, 9 planta 41011 de Sevilla y CIF: B90209081 (en adelante, 'OpenSalud'), Inscrita en el registro mercantil de Sevilla en el tomo 6043, folio 101 inscripción 1 con hoja SE-105834.</p> <br /> <h4><u>2. El Servicio de OpenSalud</u></h4> <br /> <p>OpenSalud es una plataforma para la gestión online de citas presenciales y no presenciales dentro del ámbito de la salud con centros o profesionales privados así como la realización en su caso de consultas en un entorno virtual.</p> <p>Este servicio proporciona a los usuarios una plataforma online que les permite solicitar una cita presencial o conectarse de manera virtual con médicos y profesionales de la salud. Opensalud en ningún caso proporciona diagnóstico médico o psicológico, tratamiento o prescripción de ningún tipo. Si confía en cualquier información proporcionada a través de la plataforma o cualquier profesional que utiliza opensalud será bajo su propia responsabilidad.</p><p>Los usuarios de la plataforma opensalud disponen de un acuerdo de nivel de servicio (SLA) que puede ser consultado a través de la web en la siguiente <a href='https://opensaludes.sharepoint.com/sites/General2/Documentos%20compartidos/Forms/AllItems.aspx?id=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio%2FAcuerdo%20de%20nivel%20de%20servicio%20%28SLA%29%2Epdf&parent=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio&p=true&ga=1'>dirección.</a></p> <p>Todo usuario tendrá derecho a presentar formalmente una queja o reclamación a través del siguiente buzón de correo electrónico: quejas@opensalud.es. Los responsables de la gestión de dichas quejas o reclamaciones son los responsable internos de los departamentos incidencias y operaciones,  y la dirección de OH. Las quejas o reclamaciones recibidas en el buzón de correo en cuestión  se gestionarán en el plazo máximo de un mes.</p><br /> <h4>Credenciales e independencia de profesionales I</h4> <br /> <p>Los profesionales que utilizan o aparecen en el sitio / aplicación no son empleados ni tienen ningún tipo de vinculación contractual como prestadores de servicios con opensalud, salvo en su caso, lo relativo a los servicios de telemedicina para empresas. Opensalud no proporciona opiniones, consejos ni atención médica y se exime de toda responsabilidad por las opiniones, consejos e información proporcionada por los profesionales a través de la plataforma. Opensalud no recomienda ni aprueba ninguna prueba, médico, productos, procedimientos, opiniones u otra información que pueda mencionarse en opensalud o por un profesional.</p> <p>Opensalud requiere que cada profesional proporcione a opensalud información personal y datos profesionales para acreditar su identidad y credenciales, antes de que opensalud permita que el profesional esté disponible en la plataforma.</p> <p>Cada Profesional debe estar colegiado en el correspondiente colegio oficial y tener en vigor las habilitaciones legales requeridas para ejercer su actividad. En este sentido el profesional autoriza expresamente a opensalud para que verifique en su caso sus datos con el Colegio Oficial que corresponda.</p> <p>Asimismo opensalud podrá utilizar los servicios de verificación externos que recoge la normativa vigente, en el caso de que el profesional requiera el uso de funcionalidades, como la receta electrónica por ejemplo, que requieran de elementos de seguridad adicionales.</p> <p>Al aceptar los términos del mismo, usted libera expresamente y descarga a opensalud de toda responsabilidad asociada con la veracidad o la verificación de la información que proporcionan los profesionales.</p> <p>La inclusión de profesionales en nuestra plataforma no implica ninguna recomendación o aprobación de tales profesionales. Está prohibido el uso de la plataforma por cualquier entidad o individuo para verificar las credenciales de los profesionales.</p> <p>Todas las opiniones y afirmaciones expresadas por los profesionales en o a través de nuestra plataforma y durante cualquier sesión facilitada a través de la misma son exclusivamente las opiniones y declaraciones del Profesional, individuales e independientes, y no reflejan las opiniones de opensalud. </p> <p>Opensalud no está cualificado para evaluar la calidad o validez de cualquier tipo de asesoramiento médico o psicológico.</p><p>Por tanto, en cualquier caso y con independencia del canal por el cual el paciente accede a los servicios del profesional, este mantendrá indemne y libre a opensalud de cualquier responsabilidad o reclamación de los Usuarios que esté relacionada con la prestación de los Servicios clínicos, responsabilizándose el profesional de cualquier indemnización que se derive de las mismas. En el caso de la atención clínica a usuarios de empresas clientes de opensalud, el profesional declara expresamente que dispone de todas las habilitaciones legales, fiscales, administrativas, así como de los correspondientes seguros y permisos requeridos en su caso, para el ejercicio de su actividad en el sector privado. Opensalud podrá requerir en cualquier momento que acredite documentalmente el cumplimiento de las citadas obligaciones.</p> <p><b>Al aceptar los términos del mismo, usted libera expresamente y descarga a opensalud de toda responsabilidad asociada con las consultas, el asesoramiento, recomendaciones u otra información que sea proporcionada por el profesional al paciente.</b></p> <br /> <h4>Credenciales e independencia de profesionales II</h4> <br /> <p>No obstante lo anterior, en el caso de los profesionales que presten servicios directamente a empresas clientes de opensalud, de manera previa al inicio de la prestación del servicio, los profesionales deberán aceptar expresamente las condiciones de prestación del servicio para opensalud.</p> <p>Para estos profesionales y de manera adicional a las comprobaciones previas realizadas por opensalud en el momento del registro, el profesional declara expresamente que dispone de todas las habilitaciones legales, fiscales, administrativas, así como de los correspondientes seguros y permisos requeridos en su caso, para el ejercicio de su actividad profesional. Opensalud podrá requerir que acredite el cumplimiento de las citadas obligaciones.</p> <p>El profesional asume el compromiso de facilitar la correcta atención a todos los usuarios del servicio, así como a notificar a opensalud con la mayor brevedad posible cualquier incidencia que le impida garantizar la adecuada prestación de los servicios (vacaciones…).</p> <h4>Propiedad Intelectual de OpenSalud</h4> <br /> <p>OpenSalud por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de la web, así como de la estructura de programación de la misma, así como de los elementos contenidos en la misma (Sonido, audio, vídeo, imágenes, software y demás, sirviendo esto sólo a título ilustrativo) y de los cuales se reserva todos los derechos o bien, en su caso, el de sus licenciantes, quedando expresamente prohibido el uso por parte de terceros, conforme a la normativa vigente de Propiedad Intelectual (Real Decreto Legislativo 1/1996, de 12 de abril) sin que exista un consentimiento formal por parte de sus titulares. El usuario deberá abstenerse de suprimir, alterar, evitar o cambiar cualquier dispositivo de protección o sistema de seguridad que estuviera instalado en la web. En este sentido, la web se reserva el ejercicio de las acciones tanto penales como civiles que le amparen para hacer efectivo estos derechos frente a terceros.</p> <br /> <h4><u>3. Exclusión de garantías y responsabilidad</u></h4> <br /> <p>La web OpenSalud no se hace responsable de los daños derivados del uso de la web por usos o gestiones con la misma de forma indebida, así como por los usos comunes de estos, siempre que haya existido por parte de la misma las diligencias debidas para que estos no se produzcan. A su vez, dado su carácter de plataforma de interconexión de profesionales y usuarios, se exime de cualquier responsabilidad asociada por las consultas, recomendaciones o cualquier actividad que vincule a ambas partes.</p> <br /> <h4><u>4. Modificaciones</u></h4> <br /> <p>OpenSalud se reserva el derecho de realizar las modificaciones que se estimen oportunas sin previo aviso en su web, pudiendo modificar, eliminar o introducir tanto contenidos como servicios que se presten por las mismas, así como la disposición u organización de los mismos en la web.</p> <br /> <h4><u>5. Tu información en OpenSalud y su manera de ser compartida</u></h4> <br /> <p>Los datos e información de los usuarios de OpenSalud son privados. Los datos registrados en la web deben de tener autenticidad, es decir, ser reales a los efectos de poder dar un servicio correcto. En caso de falsedad de dicha información, Opensalud se exonera de cualquier daño o responsabilidad que pueda generar la misma.</p> <p>Una vez registrado en la web como usuario individual o usuario centro, pasas a tener la consideración de usuario profesional y los datos que incluyes en tu perfil (excluidos aquellos de índole personal como el móvil o el email) estarán a disposición de los usuarios/pacientes a los efectos de poder concertar los servicios ofrecidos por el profesional. Con la aceptación de las presentes condiciones aceptas la doble relación de encargado del tratamiento que se va a llevar a cabo, de tal forma que:</p> <p>1) Conforme a la normativa de protección de datos declaras expresamente el cumplimiento de todas las obligaciones legales, así como las medidas técnicas y organizativas requeridas, asumiendo toda la responsabilidad en caso de incumplimiento de dicha normativa.</p> <p>2) Conforme a dicha normativa aceptas la relación como encargado del Tratamiento con respecto a los datos personales de los usuarios registrados facilitan a opensalud a la misma a los efectos de realizar las citas y consultas, manteniendo en todo caso el nivel de datos especialmente protegidos para dicha información.</p> <p>3) A su vez, con respecto a los datos que almacene de sus usuarios, OpenSalud asume su condición de encargado del Tratamiento de datos especialmente protegidos conforme al RGPD.</p> <br /> <h4><u>6. Tus derechos de imagen y Propiedad Intelectual en OpenSalud</u></h4> <br /> <p>Al publicar contenido como imágenes audiovisuales, fotografías y textos que estén sujetos a derechos de propiedad intelectual (en adelante, 'Contenido Sujeto a Propiedad Intelectual'), otorgas a OpenSalud la posibilidad de usar los mismos bajo una licencia no exclusiva, transferible y sin posibilidad de ser subotorgada, sin comisión u otra necesidad de ofrecer cualquier remuneración a su autor por el uso, y alcance internacional (en adelante, 'Licencia de Propiedad Intelectual'). Es decir, autorizas para que la plataforma haga uso de la misma, pero en ningún caso, que realice actividad comercial directa a través de la venta o cesión de dichos contenidos a terceros para el propio funcionamiento de la misma.</p> <br /> <h4><u>7. Uso de los contenidos</u></h4> <br /> <p>Desde la web se facilitan distintas informaciones y enlaces que pueden resultar de interés para el usuario, el cual se compromete a hacer un uso adecuado de los contenidos y servicios que las mismas le ofrecen y con carácter enunciativo pero no limitativo, a no emplearlos para las siguientes actividades:</p> <p>1. Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público a través de los mismos.</p> <p>2. Provocar cualquier tipo de daño en los sistemas propios de la web, de sus proveedores o terceras personas, ingresar o difundir en la red virus informáticos, troyanos o cualesquiera otros sistemas que sean susceptibles o hábiles de generar los referidos daños.</p> <p>3. Realizar cualquier tipo de actividad que pueda ser contraria al derecho al honor de cualquiera de los usuarios o administradores de OpenSalud.</p> <p>4. Llevar a cabo la actividad profesional con la que se da de alta sin la titulación requerida para ello.</p> <br /> <h4><u>8. La seguridad en OpenSalud</u></h4> <br /> <p>Nuestro equipo trabaja a diario para asegurarse que OpenSalud sea una plataforma segura, respetando la protección de datos de los Usuarios Registrados. Sin embargo, como cualquier otra plataforma web la protección de datos no puede garantizarse de manera absoluta y en cualquier circunstancia. No obstante, para cumplir con dicha protección con la mayor seguridad posible, los Usuarios Registrados entienden que queda expresamente prohibido:</p> <p>a) La transmisión y difusión de cualquier tipo de comunicación comercial no autorizada (como 'spam' o 'correo no deseado') utilizando cualquier herramienta de comunicación que OpenSalud ofrezca a los Usuarios Registrados.</p> <p>b) Acceder a OpenSalud de otra forma que no sea a través de un navegador, aplicación móvil oficial o cualquier herramienta que agreguemos oficialmente en el futuro y sea notificada a los Usuarios.</p> <p>c) El uso de medios de acceso automáticos (como cualquier uso de tecnología conocidas como bots, robots, arañas) que realicen una interacción dentro de la plataforma de OpenSalud y con cualquiera de los Usuarios Registrados.</p> <p>d) La práctica y la participación en cualquier tipo de operación de márketing ilegal a través de OpenSalud.</p> <p>e) Cargar virus, scripts, ni cualquier tipo de código con aspiraciones malintencionadas en contra de OpenSalud y cada uno de sus Usuarios Registrados.</p> <p>f) La solicitud de información de registro y de inicio de sesión para acceder a la cuenta de propiedad de otro individuo.</p> <p>g) El acoso, agobio, intimidación o cualquier tipo de molestia a cualquiera de los Usuarios Registrados.</p> <p>h) La publicación de cualquier contenido que resulte ofensivo, chantajista o pornográfico; o que incite a la violencia; o que contenga desnudos o violencia gráfica injustificada.</p> <p>i) El desarrollo o uso de aplicación a terceros que incluyan contenidos relacionado con el consumo de alcohol o de naturaleza adulta (incluidos anuncios) sin las restricciones de edad apropiadas a la región determinada.</p> <p>k) Utilizar OpenSalud para cualquier tipo de actividad ilegal, ya sea contra la propia red, cómo contra cualquier usuario, entendiendo por ello cualquier acto que contravenga la normativa española, en especial aquellos que vulneren los derechos a la privacidad y/ o honor de los usuarios de esta red.</p> <p>l) Cualquier actividad que pueda desactivar, sobrecargar o impedir el funcionamiento correcto de OpenSalud, como un ataque de denegación de servicio.</p> <p>m) Motivar directa o indirectamente la violación de esta Declaración.</p> <br /> <h4><u>9. Seguridad de la cuenta y registro</u></h4> <br /> <p>Los Usuarios están obligados a facilitar sus nombres reales e información real. Entienden que queda expresamente prohibido:</p> <p>1. Compartir la información de acceso (usuario y contraseña; o clave secreta en el caso de programadores) para que otra persona acceda a tu cuenta o cualquier actividad que ponga en peligro la seguridad de tu cuenta y la de los demás.</p> <p>2. Transferir tu cuenta a otra persona bajo ningún concepto, dado el carácter profesional de la misma.</p> <br /> <h4><u>10. Acceso y Precio</u></h4> <br /> <p>Para el usuario profesional  el coste de utilización de la plataforma será el siguiente:</p> <p><b>Para profesionales individuales:</b>. <u>9,90€/mes</u> por profesional (gratis durante 6 meses).</p> <p><b>Para centros: </b> 29€/mes hasta 5 profesionales + 5€/mes por profesional adicional con un máximo de 190€/mes. Para centros de más de 40 profesionales o que requieran un proyecto de integración, solicitar presupuesto. Esta tarifa será gratuita durante 6 meses sin ningún compromiso. El profesional puede cancelar/activar la tarifa en cualquier momento de manera automática en el apartado Mi perfil. Los principales servicios que incluye la tarifa son los siguientes: </p> <div style='margin-left:20px;'> <p>- Acceso al directorio de profesionales</p> <p>- Página individual del profesional. https://nombreprofesional.opensalud.es</p> <p>- Reserva y Agenda online</p> <p>- Datos de salud/historia clínica con almacenamiento ilimitado en entorno seguro</p> <p>- Receta en formato digital (no se incluyen las recetas electrónicas)</p> <p>- Servicios online (teleconsulta)</p> <div style='margin-left:40px;'> <p>. Videoconsulta programada</p> <p>. Videoconsulta inmediata</p> <p>. Chat</p> <p>. Consulta escrita</p> <p>. Segunda opinión médica</p> </div> <p>- Sistema de pago avanzado para tarjetas de crédito/débito en España y el extranjero. Cobros garantizados con sistema de pre autorización.</p> <p>- Facturación automática</p> <p>- Precios personalizables, creación de paquetes y suscripciones</p> <p> Resto de funcionalidades disponibles en opensalud a fecha 30 de septiembre de 2022 excepto la receta electrónica (si incluye receta digital). </p> </div> <p>Cualquier servicio (consulta, videoconsulta, consulta escrita y chat) cobrado a través de la pasarela de pago de la plataforma, incluido en su caso las pasarelas de autorizaciones de las compañías aseguradoras, tienen una comisión del 3,5% (1,5% si tu facturación mensual excede los 2500€). En el caso de transacciones que se realicen en moneda extranjera con pacientes de fuera de la zona Euro pueden existir cargos adicionales por cambio de moneda. No tienen ninguna comisión las consultas presenciales que no se cobren a través de la plataforma, así como las consultas de los servicios a empresas. </p><p>En el caso de servicios de segunda opinión prestados exclusivamente para pacientes no residentes en España, las condiciones podrán ser distintas de las aquí referidas. En todo caso esas condiciones serán conocidas por el profesional con anterioridad a la activación de estos servicios.</p> <p>La emisión de recetas en formato electrónico puede tener un coste adicional, que le será comunicado antes de seleccionar este servicio.</p><p>Las tarifas indicadas no incluyen el IVA correspondiente.</p><p>En el caso de las nuevas altas y renovaciones, estas tarifas sustituyen a las tarifas Plus, Advance y Basic vigentes hasta el 30 de septiembre de 2022.</p> <p>Dado que la normativa aplicable a comercio electrónico y medios de pago exige especificarlo, es obvio que considerando las características del servicio no existe posibilidad de devolución del mismo.</p><p>Aquellos profesionales que se hayan incorporado al programa opensalud4all, presten servicios en opensalud360 o pertenezcan a algún colectivo (asociación médica, colegios oficial…) con el cual la empresa mantenga un acuerdo de colaboración, tendrán bonificada a 0 euros la cuota mensual durante un máximo de 24 meses. Si necesita más información sobre las bonificaciones, puede contactarnos en el chat activo en esta misma página o en el formulario de contacto.</p> <br /> <h4><u>11. Suspensión del servicio o de la cuenta de usuario</u></h4> <br /> <p>Si se realiza alguna infracción de los puntos expresados en esta Declaración, OpenSalud se reserva el derecho de la cancelación inmediata sin previo aviso de tu cuenta en OpenSalud. Al mismo tiempo, OpenSalud tiene la política interna de mantener informado a sus usuarios sobre cualquier incidencia o cambio dentro de su servicio que pueda modificar los hábitos de acceso a la plataforma de los Usuarios Registrados, con lo que en función de la gravedad de la conducta, la red social, requerirá para cesar la actividad que incumple las presentes condiciones o procederá a la supresión del usuario infractor a decisión de los administradores de la misma.</p> <br /> <h4><u>12. Asuntos Legales</u></h4> <br /> <p>OpenSalud se atiene a la legislación aplicable en España y con ello a los tribunales que sean competentes en caso de conflicto, quedando a disposición del consumidor la selección del mismo.</p> <br /> <h4>Definiciones</h4> <br /> <p>1. 'OpenSalud' se refiere al servicio que proporcionamos a través de la web para la gestión de consultas.</p> <p>2. 'Plataforma' se refiere a las API y servicios que permiten que otros, incluidos los desarrolladores de aplicaciones y operadores de sitios web, recuperen datos de OpenSalud y nos proporcionen datos.</p> <p>3. “Información' se refiere a cualquier dato o información sobre tu persona como usuario.</p> <p>4. 'Contenido' se refiere a cualquier cosa que publiques en OpenSalud que no se incluya en la definición de 'información'.</p> <p>5. 'Datos' se refiere al contenido y la información que un tercero pueda recuperar de OpenSalud.</p> <p>6. 'Publicar' significa publicar en OpenSalud.</p> <p>7. 'Usar' se entiende utilizar, copiar, reproducir o mostrar públicamente, distribuir, modificar, traducir y crear obras derivadas.</p> <p>8. “Beneficios” Todo aquel premio, descuento, promoción o similar que se facilita a los usuarios de la web.</p>"
      },
      mx: mx,
      pt: {
        "terms-and-conditions-professional": "<p>Este acordo foi escrito em espanhol (Espanha). </p> <p>Esta Declaração de Direitos e Responsabilidades regula a relação entre o opensalud, o opensalud 360 e o resto dos sites abertos de saúde acessíveis através <a href='https://www.openhealthcare.es'>www.openhealthcare.es</a> (doravante denominados todos eles como opensalud), seus usuários e os médicos, psicólogos e demais profissionais que utilizam o site, em relação ao cadastro e utilização dos profissionais na plataforma. </p> <br /> <h4><u>1. Informações jurídicas corporativas</u></h4> <br /> <p>O proprietário do site é a empresa OpenHealthCare S.L., empresa com sede na Avda. República Argentina 25, 9 planta 41011 de Sevilha e CIF: B90209081 (doravante, 'OpenSalud'), inscrita no registro comercial de Sevilha no volume 6043, fólio 101 inscrição 1 com folha SE-105834.</p> <br /> <h4><u>2. O serviço OpenSalud</u></h4> <br /> <p>OpenSalud é uma plataforma para a gestão online de consultas presenciais e não presenciais na área da saúde com centros ou profissionais privados, bem como para a realização de consultas em ambiente virtual, quando apropriado.</p> <p>Este serviço disponibiliza aos utilizadores uma plataforma online que lhes permite solicitar uma consulta presencial ou contactar virtualmente com médicos e profissionais de saúde. </p><p>Os utilizadores da plataforma opensalud dispõem de um acordo de nível de serviço (SLA) que pode ser consultado através do site no seguinte <a href='https://opensaludes.sharepoint.com/sites/General2/Documentos%20compartidos/Forms/AllItems.aspx?id=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio%2FAcuerdo%20de%20nivel%20de%20servicio%20%28SLA%29%2Epdf&parent=%2Fsites%2FGeneral2%2FDocumentos%20compartidos%2F8%2E%20Info%20de%20inter%C3%A9s%20%28Documentaci%C3%B3n%29%2F10%2E%20Acuerdo%20a%20nivel%20de%20servicio&p=true&ga=1'>endereço.</a></p> <p>Todo o utilizador tem o direito de apresentar formalmente uma reclamação ou queixa através do seguinte endereço de correio eletrónico: quejas@opensalud.es. Os gestores internos dos departamentos de incidentes e operações, bem como a gestão de OH, são responsáveis ​​pela gestão destas reclamações ou reclamações. As reclamações ou reclamações recebidas na caixa de correio correspondente serão processadas no prazo máximo de um mês.</p> <br /> <h4>Credenciais e independência dos profissionais I</h4> <br /> <p>Os profissionais que utilizam ou aparecem no site/aplicativo não são funcionários nem possuem qualquer tipo de vínculo contratual como prestadores de serviços com o opensalud, exceto quando aplicável, no que diz respeito a serviços de telemedicina para empresas. </p> <p>A Opensalud exige que cada profissional forneça à Opensalud informações pessoais e dados profissionais para comprovar sua identidade e credenciais, antes que a Opensalud permita que o profissional esteja disponível na plataforma.</p> <p>Cada Profissional deverá estar inscrito na associação oficial correspondente e ter em vigor as autorizações legais necessárias ao exercício da sua atividade. </p> <p>Da mesma forma, o opensalud poderá utilizar os serviços de verificação externa incluídos na regulamentação em vigor, caso o profissional necessite da utilização de funcionalidades, como a prescrição eletrônica por exemplo, que requeiram elementos adicionais de segurança.</p> <p>Ao aceitar os termos deste documento, você isenta e isenta expressamente a opensalud de qualquer responsabilidade associada à veracidade ou verificação das informações fornecidas pelos profissionais.</p> <p>A inclusão de profissionais em nossa plataforma não implica qualquer recomendação ou aprovação de tais profissionais. </p> <p>Todas as opiniões e declarações expressas por profissionais em ou através de nossa plataforma e durante qualquer sessão facilitada por ela são exclusivamente opiniões e declarações do Profissional, individual e independente, e não refletem as opiniões da opensalud. </p> <p>A Opensalud não está qualificada para avaliar a qualidade ou validade de qualquer tipo de aconselhamento médico ou psicológico.</p><p>Portanto, em qualquer caso e independentemente do canal pelo qual o paciente acesse os serviços do profissional, este manterá o opensalud inofensivo e livre de qualquer responsabilidade ou reclamação dos Usuários que esteja relacionada à prestação dos Serviços clínicos, sendo responsável o profissional de qualquer compensação deles derivada. </p> <p><b>Ao aceitar os termos deste documento, você isenta e isenta expressamente a opensalud de toda responsabilidade associada às consultas, conselhos, recomendações ou outras informações fornecidas pelo profissional ao paciente.</b></p> <br /> <h4>Credenciais e independência dos profissionais II</h4> <br /> <p>Não obstante o acima exposto, no caso de profissionais que prestam serviços diretamente às empresas clientes do opensalud, antes do início da prestação do serviço, os profissionais deverão aceitar expressamente as condições de prestação de serviços do opensalud.</p> <p>Para estes profissionais e além das verificações prévias realizadas pela opensalud no momento da inscrição, o profissional declara expressamente que possui todas as autorizações legais, fiscais e administrativas, bem como os correspondentes seguros e autorizações exigidas, onde adequado, ao exercício da sua actividade profissional. </p> <p>O profissional assume o compromisso de prestar um atendimento correto a todos os usuários do serviço, bem como de notificar o OpenSalud o mais rápido possível sobre qualquer incidente que os impeça de garantir a prestação adequada dos serviços (férias...).</p> <h4>Propriedade Intelectual do OpenSalud</h4> <br /> <p>A OpenSalud, por si ou como cessionária, é titular de todos os direitos de propriedade intelectual e industrial do site, bem como de sua estrutura de programação, bem como dos elementos nele contidos (Som, áudio, vídeo, imagens, software e outros , servindo apenas a título ilustrativo) e do qual todos os direitos são reservados ou, se for o caso, dos seus licenciantes, sendo expressamente proibida a utilização por terceiros, de acordo com a legislação em vigor sobre Propriedade Intelectual (Real Decreto Legislativo 1/1996, de 12 de abril) sem que haja consentimento formal por parte dos seus proprietários. </p> <br /> <h4><u>3. Exclusão de garantias e responsabilidade</u></h4> <br /> <p>O site OpenSalud não se responsabiliza pelos danos derivados da utilização do site devido ao uso ou gestão indevida do mesmo, bem como pelos seus usos comuns, desde que tenha sido realizada a devida diligência de sua parte para garantir que estes não ocorrer. </p> <br /> <h4><u>4. Modificações</u></h4> <br /> <p>OpenSalud reserva-se o direito de fazer as modificações que considere oportunas sem aviso prévio em seu site, podendo modificar, excluir ou introduzir tanto os conteúdos e serviços por ele fornecidos, bem como a disposição ou organização dos mesmos no site.</p> <br /> <h4><u>5. Suas informações no OpenSalud e como elas são compartilhadas</u></h4> <br /> <p>Os dados e informações dos usuários do OpenSalud são privados. </p> <p>Uma vez registado no site como utilizador individual ou utilizador do centro, será considerado utilizador profissional e os dados que incluir no seu perfil (excluindo os de carácter pessoal como telemóvel ou email) ficarão à disposição dos utilizadores/pacientes. para poder organizar os serviços oferecidos pelo profissional. </p> <p>1) De acordo com a regulamentação de proteção de dados, você declara expressamente o cumprimento de todas as obrigações legais, bem como das medidas técnicas e organizacionais exigidas, assumindo toda a responsabilidade em caso de incumprimento dos referidos regulamentos.</p> <p>2 ) Em de acordo com o referido regulamento, aceita a relação como responsável pelo Tratamento no que diz respeito aos dados pessoais dos utilizadores registados fornecidos ao opensalud para efeitos de marcação de consultas e consultas, mantendo em todos os casos o nível de dados especialmente protegidos para disse informação.</p> <p>3) Por sua vez, no que diz respeito aos dados que armazena sobre os seus utilizadores, OpenSalud assume a sua condição de processador de dados especialmente protegido de acordo com o RGPD.</p> <br /> <h4><u>6. Seus direitos de imagem e propriedade intelectual no OpenSalud</u></h4> <br /> <p>Ao publicar conteúdos como imagens audiovisuais, fotografias e textos que estão sujeitos a direitos de propriedade intelectual (doravante, 'Conteúdos Sujeitos a Propriedade Intelectual'), você concede ao OpenSalud a possibilidade de utilizá-los sob uma licença não exclusiva, transferível e não exclusiva .ser sublicenciado, sem comissão ou outra necessidade de oferecer qualquer remuneração ao seu autor pela utilização, e âmbito internacional (doravante, 'Licença de Propriedade Intelectual'). </p> <br /> <h4><u>7. Uso de conteúdo</u></h4> <br /> <p>O site disponibiliza diversas informações e links que podem ser do interesse do usuário, que se compromete a fazer uso adequado dos conteúdos e serviços que oferece e, a título de exemplo, mas não limitado a, não utilizá-los para as seguintes atividades:</p> <p>1. Envolver-se através deles em atividades ilícitas, ilegais ou contrárias à boa-fé e à ordem pública.</p> <p>2. Causar qualquer tipo de dano aos sistemas próprios do site, aos seus fornecedores ou a terceiros, introduzir ou difundir vírus informáticos, cavalos de Tróia ou quaisquer outros sistemas que sejam suscetíveis ou capazes de gerar os danos acima mencionados.</p> <p>3. Realizar qualquer tipo de atividade que possa ser contrária ao direito à honra de qualquer um dos usuários ou administradores do OpenSalud.</p> <p>4. Exercer a atividade profissional em que se inscreve sem a qualificação exigida para tal.</p> <br /> <h4><u>8. Segurança no OpenSalud</u></h4> <br /> <p>Nossa equipe trabalha diariamente para garantir que o OpenSalud seja uma plataforma segura, respeitando a proteção de dados dos Usuários Cadastrados. </p> <p>a) A transmissão e divulgação de qualquer tipo de comunicação comercial não autorizada (como 'spam' ou 'junk mail') utilizando qualquer ferramenta de comunicação que OpenSalud ofereça aos Usuários Cadastrados.</p> <p>b) Acessar o OpenSalud de qualquer forma que não seja através de um navegador, aplicativo móvel oficial ou qualquer ferramenta que adicionarmos oficialmente no futuro e for notificada aos Usuários.</p> <p>c) A utilização de meios de acesso automático (como qualquer uso de tecnologia conhecida como bots, robôs, spiders) que realizem uma interação dentro da plataforma OpenSalud e com qualquer um dos Usuários Cadastrados.</p> <p>d) A prática e participação em qualquer tipo de operação de marketing ilegal através do OpenSalud.</p> <p>e) Carregar vírus, scripts ou qualquer tipo de código com aspirações maliciosas contra o OpenSalud e cada um de seus Usuários Cadastrados.</p> <p>f) A solicitação de informações de registro e login para acessar a conta de outra pessoa física.</p> <p>g) Assédio, assédio, intimidação ou qualquer tipo de incômodo a qualquer um dos Usuários Cadastrados.</p> <p>h) A publicação de qualquer conteúdo ofensivo, chantagista ou pornográfico; </p> <p>i) O desenvolvimento ou utilização de aplicações de terceiros que incluam conteúdos relacionados com o consumo de álcool ou de carácter adulto (incluindo anúncios) sem as restrições de idade adequadas à região em questão.</p> <p>k) Utilizar o OpenSalud para qualquer tipo de atividade ilegal, seja contra a própria rede ou contra qualquer usuário, ou seja, qualquer ato que contrarie a regulamentação espanhola, especialmente aqueles que violem os direitos à privacidade e/ou honra dos usuários desta rede.</p> <p>l) Qualquer atividade que possa desabilitar, sobrecarregar ou impedir o correto funcionamento do OpenSalud, como um ataque de negação de serviço.</p> <p>m) Motivar direta ou indiretamente a violação desta Declaração.</p> <br /> <h4><u>9. Segurança e registro da conta</u></h4> <br /> <p>Os usuários são obrigados a fornecer seus nomes reais e informações reais. </p> <p>1. Compartilhar informações de acesso (nome de usuário e senha; ou chave secreta no caso de programadores) para que outra pessoa possa acessar sua conta ou qualquer atividade que coloque em risco a segurança de sua conta e de terceiros.</p> <p>2. Não transfira a sua conta para outra pessoa em hipótese alguma, dada a sua natureza profissional.</p> <br /> <h4><u>10. Acesso e Preço</u></h4> <br /> <p>Para o usuário profissional, o custo de utilização da plataforma será o seguinte:</p> <p><b>Para profissionais individuais:</b>. <u>9,90€/mês</u> por profissional (grátis por 6 meses).</p> <p><b>Para centros: </b> 29€/mês até 5 profissionais 5€/mês por profissional adicional até um máximo de 190€/mês.  </p> <div style='margin-left:20px;'> <p>- Acesso ao diretório de profissionais</p> <p>- Página individual do profissional. </p> <p>- Reserva e agenda online</p> <p>- Dados de saúde/histórico médico com armazenamento ilimitado em ambiente seguro</p> <p>- Receita em formato digital (receitas eletrônicas não incluídas)</p> <p>- Atendimentos online (teleconsulta)</p> <div style='margin-left:40px;'> <p>. Consulta por vídeo agendada</p> <p>. Consulta por vídeo imediata</p> <p>. Bate-papo</p> <p>. Consulta escrita</p> <p>. Segunda opinião médica</p> </div> <p>- Sistema avançado de pagamento para cartões de crédito/débito em Espanha e no estrangeiro. Cobranças garantidas com sistema de pré-autorização.</p> <p>- Faturamento automático</p> <p>- Preços personalizáveis, criação de pacotes e assinaturas</p> <p> Restos das funcionalidades disponíveis no opensalud a partir de 30 de setembro de 2022, exceto a prescrição eletrônica (se incluir prescrição digital). </p> </div> <p>Qualquer serviço (consulta, videoconsulta, consulta escrita e chat) cobrado através da plataforma de pagamento da plataforma, incluindo, quando aplicável, as plataformas de autorização das seguradoras, tem uma comissão de 3,5% (1,5% se a sua faturação mensal exceder 2500€).  </p><p>No caso de serviços de segunda opinião prestados exclusivamente a pacientes não residentes em Espanha, as condições podem ser diferentes das aqui referidas. </p> <p>A emissão de receitas em formato eletrónico poderá ter um custo adicional, que lhe será comunicado antes de selecionar este serviço.</p><p>As taxas indicadas não incluem o IVA correspondente.</p><p>No caso de novas inscrições e renovações, estas tarifas substituem as tarifas Plus, Antecipadas e Básicas vigentes até 30 de setembro de 2022.</p> <p>Dado que a regulamentação aplicável ao comércio eletrónico e aos meios de pagamento exige que tal seja especificado, é óbvio que dadas as características do serviço não existe possibilidade da sua devolução.</p><p>Os profissionais que aderirem ao programa opensalud4all, prestarem serviços no opensalud360 ou pertencerem a qualquer grupo (associação médica, escolas oficiais...) com o qual a empresa mantenha um acordo de colaboração, terão a sua mensalidade reduzida para 0 euros por um máximo de 24 meses. </p> <br /> <h4><u>11. Suspensão do serviço ou conta de usuário</u></h4> <br /> <p>Se for cometida qualquer violação dos pontos expressos nesta Declaração, o OpenSalud reserva-se o direito de cancelar imediatamente sua conta OpenSalud sem aviso prévio. </p> <br /> <h4><u>12. Assuntos Jurídicos</u></h4> <br /> <p>OpenSalud cumpre a legislação aplicável em Espanha e, portanto, os tribunais competentes em caso de conflito, deixando a escolha do consumidor.</p> <br /> <h4>Definições</h4> <br /> <p>1. 'OpenSalud' refere-se ao serviço que prestamos através do site para a gestão de consultas.</p> <p>2. 'Plataforma' significa as APIs e serviços que permitem que terceiros, incluindo desenvolvedores de aplicativos e operadores de sites, recuperem dados do OpenSalud e nos forneçam dados.</p> <p>3. “Informações” refere-se a quaisquer dados ou informações sobre você como usuário.</p> <p>4. 'Conteúdo' refere-se a qualquer coisa que você publique no OpenSalud que não se enquadre na definição de 'informação'.</p> <p>5. 'Dados' significa o conteúdo e as informações que terceiros podem recuperar do OpenSalud.</p> <p>6. 'Publicar' significa publicar no OpenSalud.</p> <p>7. «Utilização» significa a utilização, cópia, reprodução ou exibição pública, distribuição, modificação, tradução e criação de trabalhos derivados.</p> <p>8. “Benefícios” Qualquer prêmio, desconto, promoção ou similar que seja oferecido aos usuários do site.</p>"
      }
    }
  }
});

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(998);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cba630e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(1623);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1621)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cba630e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cba630e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/PrivacyPolicy.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0cba630e", Component.options)
  } else {
    hotAPI.reload("data-v-0cba630e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_json__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_json__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_json__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_json__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_companyCommonData__ = __webpack_require__(533);
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	i18n: {
		messages: {
			es: __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_json___default.a,
			en: __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_json___default.a,
			pt: __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_json___default.a,
			mx: __WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_json___default.a
		}
	},
	data: function data() {
		return {
			PRIVACY_POLICY_COMPANY_DATA: __WEBPACK_IMPORTED_MODULE_4__constants_companyCommonData__["a" /* PRIVACY_POLICY_COMPANY_DATA */]
		};
	}
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyProfessional_vue__ = __webpack_require__(1000);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e30880_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyProfessional_vue__ = __webpack_require__(1626);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1624)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45e30880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyProfessional_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e30880_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyProfessional_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/PrivacyPolicyProfessional.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45e30880", Component.options)
  } else {
    hotAPI.reload("data-v-45e30880", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_professional_json__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_professional_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_professional_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_professional_json__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_professional_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_professional_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_professional_json__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_professional_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_professional_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_professional_json__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_professional_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_professional_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_companyCommonData__ = __webpack_require__(533);
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	i18n: {
		messages: {
			es: __WEBPACK_IMPORTED_MODULE_0__lang_es_public_views_privacy_policy_professional_json___default.a,
			en: __WEBPACK_IMPORTED_MODULE_1__lang_en_public_views_privacy_policy_professional_json___default.a,
			pt: __WEBPACK_IMPORTED_MODULE_2__lang_pt_public_views_privacy_policy_professional_json___default.a,
			mx: __WEBPACK_IMPORTED_MODULE_3__lang_mx_public_views_privacy_policy_professional_json___default.a
		}
	},
	data: function data() {
		return {
			PRIVACY_POLICY_COMPANY_DATA: __WEBPACK_IMPORTED_MODULE_4__constants_companyCommonData__["a" /* PRIVACY_POLICY_COMPANY_DATA */]
		};
	}
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'back-button',
    props: {
        action: {
            type: Function,
            required: false,
            default: function _default() {
                history.back();
            }
        },
        withoutButton: Boolean
    },
    data: function data() {
        return {
            hover: false
        };
    }
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var WIDTH_DIMENSION = 'width';
var HEIGHT_DIMENSION = 'height';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'CollapseTransition',
	props: {
		name: {
			type: String,
			required: false,
			default: 'collapse'
		},
		dimension: {
			type: String,
			required: false,
			default: 'height',
			validator: function validator(value) {
				return [WIDTH_DIMENSION, HEIGHT_DIMENSION].includes(value);
			}
		},
		duration: {
			type: Number,
			required: false,
			default: 300
		},
		easing: {
			type: String,
			required: false,
			default: 'ease-in-out'
		}
	},
	watch: {
		dimension: function dimension() {
			this.clearCachedDimensions();
		}
	},
	data: function data() {
		return {
			cachedStyles: null
		};
	},

	computed: {
		transition: function transition() {
			var _this = this;

			var transitions = [];

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.cachedStyles).forEach(function (key) {
				transitions.push(_this.convertToCssProperty(key) + ' ' + _this.duration + 'ms ' + _this.easing);
			});

			return transitions.join(', ');
		}
	},
	methods: {
		beforeAppear: function beforeAppear(el) {
			// Emit the event to the parent
			this.$emit('before-appear', el);
		},
		appear: function appear(el) {
			// Emit the event to the parent
			this.$emit('appear', el);
		},
		afterAppear: function afterAppear(el) {
			// Emit the event to the parent
			this.$emit('after-appear', el);
		},
		appearCancelled: function appearCancelled(el) {
			// Emit the event to the parent
			this.$emit('appear-cancelled', el);
		},
		beforeEnter: function beforeEnter(el) {
			// Emit the event to the parent
			this.$emit('before-enter', el);
		},
		enter: function enter(el, done) {
			// Because width and height may be 'auto',
			// first detect and cache the dimensions
			this.detectAndCacheDimensions(el);

			// The order of applying styles is important:
			// - 1. Set styles for state before transition
			// - 2. Force repaint
			// - 3. Add transition style
			// - 4. Set styles for state after transition
			// If the order is not right and you open any 2nd level submenu
			// for the first time, the transition will not work.
			this.setClosedDimensions(el);
			this.hideOverflow(el);
			this.forceRepaint(el);
			this.setTransition(el);
			this.setOpenedDimensions(el);

			// Emit the event to the parent
			this.$emit('enter', el, done);

			// Call done() when the transition ends
			// to trigger the @after-enter event.
			setTimeout(done, this.duration);
		},
		afterEnter: function afterEnter(el) {
			// Clean up inline styles
			this.unsetOverflow(el);
			this.unsetTransition(el);
			this.unsetDimensions(el);
			this.clearCachedDimensions();

			// Emit the event to the parent
			this.$emit('after-enter', el);
		},
		enterCancelled: function enterCancelled(el) {
			// Emit the event to the parent
			this.$emit('enter-cancelled', el);
		},
		beforeLeave: function beforeLeave(el) {
			// Emit the event to the parent
			this.$emit('before-leave', el);
		},
		leave: function leave(el, done) {
			// For some reason, @leave triggered when starting
			// from open state on page load. So for safety,
			// check if the dimensions have been cached.
			this.detectAndCacheDimensions(el);

			// The order of applying styles is less important
			// than in the enter phase, as long as we repaint
			// before setting the closed dimensions.
			// But it is probably best to use the same
			// order as the enter phase.
			this.setOpenedDimensions(el);
			this.hideOverflow(el);
			this.forceRepaint(el);
			this.setTransition(el);
			this.setClosedDimensions(el);

			// Emit the event to the parent
			this.$emit('leave', el, done);

			// Call done() when the transition ends
			// to trigger the @after-leave event.
			// This will also cause v-show
			// to reapply 'display: none'.
			setTimeout(done, this.duration);
		},
		afterLeave: function afterLeave(el) {
			// Clean up inline styles
			this.unsetOverflow(el);
			this.unsetTransition(el);
			this.unsetDimensions(el);
			this.clearCachedDimensions();

			// Emit the event to the parent
			this.$emit('after-leave', el);
		},
		leaveCancelled: function leaveCancelled(el) {
			// Emit the event to the parent
			this.$emit('leave-cancelled', el);
		},
		detectAndCacheDimensions: function detectAndCacheDimensions(el) {
			// Cache actual dimensions
			// only once to void invalid values when
			// triggering during a transition
			if (this.cachedStyles) return;

			var visibility = el.style.visibility;
			var display = el.style.display;

			// Trick to get the width and
			// height of a hidden element
			el.style.visibility = 'hidden';
			el.style.display = '';

			this.cachedStyles = this.detectRelevantDimensions(el);

			// Restore any original styling
			el.style.visibility = visibility;
			el.style.display = display;
		},
		clearCachedDimensions: function clearCachedDimensions() {
			this.cachedStyles = null;
		},
		detectRelevantDimensions: function detectRelevantDimensions(el) {
			// These properties will be transitioned
			if (this.dimension === HEIGHT_DIMENSION) {
				return {
					'height': el.offsetHeight + 'px',
					'paddingTop': el.style.paddingTop || this.getCssValue(el, 'padding-top'),
					'paddingBottom': el.style.paddingBottom || this.getCssValue(el, 'padding-bottom')
				};
			}

			if (this.dimension === WIDTH_DIMENSION) {
				return {
					'width': el.offsetWidth + 'px',
					'paddingLeft': el.style.paddingLeft || this.getCssValue(el, 'padding-left'),
					'paddingRight': el.style.paddingRight || this.getCssValue(el, 'padding-right')
				};
			}
			return {};
		},
		setTransition: function setTransition(el) {
			el.style.transition = this.transition;
		},
		unsetTransition: function unsetTransition(el) {
			el.style.transition = '';
		},
		hideOverflow: function hideOverflow(el) {
			el.style.overflow = 'hidden';
		},
		unsetOverflow: function unsetOverflow(el) {
			el.style.overflow = '';
		},
		setClosedDimensions: function setClosedDimensions(el) {
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.cachedStyles).forEach(function (key) {
				el.style[key] = '0';
			});
		},
		setOpenedDimensions: function setOpenedDimensions(el) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.cachedStyles).forEach(function (key) {
				el.style[key] = _this2.cachedStyles[key];
			});
		},
		unsetDimensions: function unsetDimensions(el) {
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.cachedStyles).forEach(function (key) {
				el.style[key] = '';
			});
		},
		forceRepaint: function forceRepaint(el) {
			// Force repaint to make sure the animation is triggered correctly.
			// Thanks: https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/
			// eslint-disable-next-line no-unused-expressions
			window.getComputedStyle(el)[this.dimension];
		},
		getCssValue: function getCssValue(el, style) {
			return window.getComputedStyle(el, null).getPropertyValue(style);
		},
		convertToCssProperty: function convertToCssProperty(style) {
			// Example: convert 'paddingTop' to 'padding-top'
			// Thanks: https://gist.github.com/tan-yuki/3450323
			var upperChars = style.match(/([A-Z])/g);

			if (!upperChars) {
				return style;
			}

			for (var i = 0, n = upperChars.length; i < n; i++) {
				style = style.replace(new RegExp(upperChars[i]), '-' + upperChars[i].toLowerCase());
			}

			if (style.slice(0, 1) === '-') {
				style = style.slice(1);
			}

			return style;
		}
	}
});

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./IVECO": 1004,
	"./IVECO.svg": 1004,
	"./IVECO_2": 1005,
	"./IVECO_2.svg": 1005,
	"./RGB_Neom_positivo": 1006,
	"./RGB_Neom_positivo.svg": 1006,
	"./RGB_OPENSALUD_AZUL": 441,
	"./RGB_OPENSALUD_AZUL.png": 441,
	"./RGB_OPENSALUD_AZUL.svg": 539,
	"./_IKEA": 1007,
	"./_IKEA.svg": 1007,
	"./abogalitypro_orange": 1008,
	"./abogalitypro_orange.svg": 1008,
	"./abogalitypro_white": 1009,
	"./abogalitypro_white.svg": 1009,
	"./aon": 1010,
	"./aon.svg": 1010,
	"./barcelo": 1011,
	"./barcelo.svg": 1011,
	"./camaras-fundacion": 1012,
	"./camaras-fundacion.png": 1012,
	"./comunidad-saludable-azul": 1013,
	"./comunidad-saludable-azul.svg": 1013,
	"./fondos-europeos": 1014,
	"./fondos-europeos.png": 1014,
	"./hacienda": 1015,
	"./hacienda-recorte": 1016,
	"./hacienda-recorte.png": 1016,
	"./hacienda.png": 1015,
	"./iberostart": 1017,
	"./iberostart.svg": 1017,
	"./logo-menttum-grande": 1018,
	"./logo-menttum-grande-2": 1019,
	"./logo-menttum-grande-2.png": 1019,
	"./logo-menttum-grande-blanco": 1020,
	"./logo-menttum-grande-blanco.png": 1020,
	"./logo-menttum-grande.png": 1018,
	"./logo-unipromel-azul": 1021,
	"./logo-unipromel-azul.png": 1021,
	"./loreal": 1022,
	"./loreal.svg": 1022,
	"./menttum": 1023,
	"./menttum.svg": 1023,
	"./montero-aramburu": 1024,
	"./montero-aramburu.png": 1024,
	"./mp": 1025,
	"./mp.png": 1025,
	"./msm": 1026,
	"./msm.svg": 1026,
	"./novo-nordisk": 1027,
	"./novo-nordisk.svg": 1027,
	"./openlegal360_orange": 1028,
	"./openlegal360_orange.svg": 1028,
	"./openlegal360_white": 1029,
	"./openlegal360_white.svg": 1029,
	"./openlegal_blue": 1030,
	"./openlegal_blue.svg": 1030,
	"./openlegal_blue_1x1": 1031,
	"./openlegal_blue_1x1.svg": 1031,
	"./openlegal_orange": 442,
	"./openlegal_orange.png": 442,
	"./openlegal_orange.svg": 1633,
	"./openlegal_white": 443,
	"./openlegal_white.png": 443,
	"./openlegal_white.svg": 1634,
	"./openlegalpro_blue": 1032,
	"./openlegalpro_blue.svg": 1032,
	"./openlegalpro_orange": 1033,
	"./openlegalpro_orange.svg": 1033,
	"./openlegalpro_white": 1034,
	"./openlegalpro_white.svg": 1034,
	"./opensalud360-blue": 1035,
	"./opensalud360-blue.svg": 1035,
	"./opensalud360_healthierlives_blue": 1036,
	"./opensalud360_healthierlives_blue.svg": 1036,
	"./opensalud360_healthierlives_color": 1037,
	"./opensalud360_healthierlives_color.svg": 1037,
	"./opensalud360_healthierlives_white": 1038,
	"./opensalud360_healthierlives_white.svg": 1038,
	"./opensalud360_mx_healthierlives_color": 1039,
	"./opensalud360_mx_healthierlives_color.svg": 1039,
	"./opensalud360_mx_healthierlives_white": 1040,
	"./opensalud360_mx_healthierlives_white.svg": 1040,
	"./opensalud360_white": 1041,
	"./opensalud360_white.svg": 1041,
	"./opensalud_blue_mx": 1042,
	"./opensalud_blue_mx.svg": 1042,
	"./opensalud_healthierlives_blue": 1043,
	"./opensalud_healthierlives_blue.svg": 1043,
	"./opensalud_healthierlives_color": 444,
	"./opensalud_healthierlives_color.png": 444,
	"./opensalud_healthierlives_color.svg": 1635,
	"./opensalud_healthierlives_white": 1044,
	"./opensalud_healthierlives_white.svg": 1044,
	"./opensalud_mx_healthierlives_color": 1045,
	"./opensalud_mx_healthierlives_color.png": 1045,
	"./opensalud_mx_healthierlives_white": 1046,
	"./opensalud_mx_healthierlives_white.svg": 1046,
	"./opensalud_newblue_mx": 1047,
	"./opensalud_newblue_mx.svg": 1047,
	"./opensalud_white": 1048,
	"./opensalud_white.svg": 1048,
	"./opensalud_white_mx": 1049,
	"./opensalud_white_mx.svg": 1049,
	"./opensaludmx_healthierlives_color": 445,
	"./opensaludmx_healthierlives_color.png": 445,
	"./opensaludmx_healthierlives_color.svg": 1636,
	"./pacientes-como-tu-azul": 1050,
	"./pacientes-como-tu-azul.svg": 1050,
	"./pepsico": 1051,
	"./pepsico.svg": 1051,
	"./philips_avent": 1052,
	"./philips_avent.svg": 1052,
	"./prime_by_opensalud": 1053,
	"./prime_by_opensalud.svg": 1053,
	"./primebyopensalud-healthierlives-color": 1054,
	"./primebyopensalud-healthierlives-color.svg": 1054,
	"./primebyopensalud-healthierlives-white": 1055,
	"./primebyopensalud-healthierlives-white.svg": 1055,
	"./primesalud_blue": 1056,
	"./primesalud_blue.svg": 1056,
	"./primesalud_blue_02": 1057,
	"./primesalud_blue_02.svg": 1057,
	"./primesalud_blue_powered": 1058,
	"./primesalud_blue_powered.png": 1058,
	"./primesalud_white": 1059,
	"./primesalud_white.svg": 1059,
	"./primesalud_white_02": 1060,
	"./primesalud_white_02.svg": 1060,
	"./programapyme": 1061,
	"./programapyme.png": 1061,
	"./pyme": 1062,
	"./pyme-white": 1063,
	"./pyme-white.png": 1063,
	"./pyme.png": 1062,
	"./santander": 1064,
	"./santander.svg": 1064,
	"./scania": 1065,
	"./scania.png": 1065,
	"./siemens": 1066,
	"./siemens.svg": 1066,
	"./unihealth_blue": 1067,
	"./unihealth_blue.svg": 1067,
	"./unihealth_blue_unipromel": 1068,
	"./unihealth_blue_unipromel.svg": 1068,
	"./unihealth_white": 1069,
	"./unihealth_white.svg": 1069,
	"./union-europea": 1070,
	"./union-europea.png": 1070
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1003;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/IVECO.b530f56.svg";

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/RGB_Neom_positivo.8dfd1fe.svg";

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/abogalitypro_orange.d0e03cd.svg";

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/abogalitypro_white.b10621f.svg";

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/comunidad-saludable-azul.a3fffb2.svg";

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/hacienda.a79c76a.png";

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/hacienda-recorte.8890c4b.png";

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/iberostart.55ea5f9.svg";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/logo-menttum-grande.864e805.png";

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/logo-menttum-grande-2.8b80667.png";

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/logo-menttum-grande-blanco.a46f11d.png";

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/logo-unipromel-azul.aad04a8.png";

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/menttum.2ba4be7.svg";

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/montero-aramburu.4ba8c6b.png";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/mp.60fabdf.png";

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegal360_orange.e6739e7.svg";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegal360_white.1c1162f.svg";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegal_blue.c9d1c89.svg";

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegalpro_blue.78122e0.svg";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegalpro_orange.528d4c4.svg";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegalpro_white.419b491.svg";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud360-blue.2a75ca9.svg";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud360_healthierlives_blue.770f0a2.svg";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud360_healthierlives_color.4fad8c9.svg";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud360_healthierlives_white.c28dfaa.svg";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud360_mx_healthierlives_color.966faed.svg";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud360_mx_healthierlives_white.0ef20b4.svg";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud360_white.b88f9a4.svg";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_blue_mx.5edb789.svg";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_healthierlives_blue.e9cfbcc.svg";

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_healthierlives_white.1a470f9.svg";

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_mx_healthierlives_color.054a380.png";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_mx_healthierlives_white.6cb29ab.svg";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_newblue_mx.1a0d65b.svg";

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_white.440ffe9.svg";

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_white_mx.23fc36d.svg";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/pacientes-como-tu-azul.eb2eae7.svg";

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/philips_avent.b1fca27.svg";

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/prime_by_opensalud.7731a50.svg";

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/primebyopensalud-healthierlives-color.21c886f.svg";

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/primebyopensalud-healthierlives-white.881cb0a.svg";

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/primesalud_blue.97aa48e.svg";

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/primesalud_blue_powered.7bb8d8b.png";

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/primesalud_white.e7e110f.svg";

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/programapyme.e528d2d.png";

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/pyme.be20d1b.png";

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/pyme-white.5155a02.png";

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/scania.7cdcd91.png";

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/unihealth_blue.b497995.svg";

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/unihealth_blue_unipromel.e517a02.svg";

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/unihealth_white.6bb5dff.svg";

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASkAAABiCAMAAAA7r9WrAAADAFBMVEVHcEz///////////////////8ATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATaYATab///////////////////////////8ATabv9PoAYrEASqT2+PwAarUASaQATKfk7vcAW60AS6UAS6gARKJYm80ASaoASqkATqUARqwAQq8ASKsAUKMARa0AU6AAXZYAVJ4AX5SuxA0AW5hyoUtqnVEkf3Q8h2sAZI8AaIoAYZEAUqEAQLIAc39clFsAbYY/iGkAWZrl5QDi4wA5hmyivCP/+wB9qUPM1QCSszMAS6fd4AAmgHL//QAffHb07QAXe3ilvh4AXpUAdX6auCv//wDv6gCMsTiCrD8Gd3z/8wAAbIc0hG//9QAPeXptn05Vkl7o5gBDimcAcIP3+v3v9Pm0xwFLjmMAV5zT2QDo5wD67wC6ywDH0wD+/v//9wDo8PgAVqsARqNUmswAQKD////0+PsAbbcAYLDw9fotgnBkmFYFenkCeXp3pUcAVpxvqNPAzgAAdrsAaLQAZLF4rNUdGUaxAAAAknRSTlMAe0qaMP4RAwYTGg4F42T4AfX8HuVo/ld0/SDrDDsSCu0o30kqTsV2NDLW2ry2Q8d6NstTkmK+EKqh8NA5Lt6tiIzzulBLjpWyayTN4WfxiT/n6Sy4+RaswhyYRmB+CI3Sgaj69hkwXW+ltMAY7sk9JnKPapsjbaMVVZ+Khc7cQVpFN5172C+whMN4nzGAFy1NDt5zXngAAA2zSURBVHic7Zt3XBRnGsefayy7LIussLCFovRVUIqu0qsoAkGqIGykd1FRUCJqVCR4ufa7u9zt3e0dxZ7YExNjTe+9t7skd0ku15LrvXzeGXZ1YRYWs5x88pnvH+7szDDl6zvP+87zvEskIiIiIiIiIiIiIiIiIiIiIiIiIiIiIjJVvv4FZ/O1L97oe5oebv/kjp9924n87I+//OqNvqfp4ctf+ccPv+NE/vD7X33pRt/T9PDlr/z2d991Ir/59Q8+t6Z+8mM4kR/9UDQlmhJNOYbDpkxm0ZRDpkyH73RIlYAp+SyhE8v/P/fnPCY1ZeI/9j/zwFnTtSscNFW+L3Jda9yusaf1K4sZqKxcum8qvnTberaOX7u15zbd9d36FJnU1D3sH/PdLz74/LOPcq3q4PAUTGV6cWtrw2zPOnsVgKoa9LlO4VKl7agYvzYbXv7XffdTYRJTI0PHHx5hql56+bkHhk3A0NlT9+6f4Dm0NbXLE+kVXXH5QKbNWdcAYTkuTcW3TKlNVURWjl+7Eckun+H+HWdCU6aDJ+97676TB00YPPfus8cPAeZXTv3z8qXT9lXZmiqGZxARBanQz74GREQ1BLDPRVBn6UgnNRC5yfxJWuDnxu1f7xcVzVqIUdZGxvAdMv4omoKC2UQ0y0XKnjN50Y6C9Xzo0+zYS2m8KcmcHYlXjelkW2hLQXQA/03WUaBhn66yNtpcUD8dpmB6/OJjF06aAPPp9w+8MgyYj1y+8vGLR+3HKhtTwZ5Yyi1478whIp8EFdQJmURLlYCne32FR4acqmtTFIWA3o+IqrUAchVEUe19W2MAbRcRuWzKB+KzdeSysq6aaO+AEqhbXk7keks8UNPMmYrIqAPmbrCceIXHYoUXVDHhRGSI0wL53TKiXYHbw7SIFOxgPqspHLrrkXdHmBezGUNsxf5LFy6+MmL/D2xMxQKKq6dqBLQLAqHaSRWegLavtBm9rrQMdSWti1WIcaUVwOoyL9StpyCo6vT96fBIIkk/MLAA2ET+7thIhj4UlrWqWMSqBvQp7WCmIrQoickFto2eKgwlKv1qNXJlJF8O6BOAGCl1AGoPddX1iZrElPnY/cP3H7n2WTNfuvPck4MOmuoEYq1f/JORkEM5vUj2Jx+o1xiphulJA3yJmpGuocaWZVwIy6IgoN9ICmAnWwwjyi5ZIDXMxc00O3t+IlEkBmiLFwY4R8kGikR7ELmUoTacP5cv0OPKTr+HdgKpRkmeGtXkB/QVFZU63RQ/1Bw0j9EyNDT48AQD0bGmrvbrIYAPEbvyLMqC2o8sptplRF3wnENEbhGVKcxuEKc4yQMKuglaGZFhs478mSnWcQZV5SKG3TcL8DVIdtPEI5s97HWospgqKSKSr0ULLcF2FgNb0cv+Ys91aprAlGnw6WdGHrbXckyD5x8fEXRlYyoTaOIWwjcTKVAbzRZVyKMQqDusptz9ibyZKWlcLpCuQiYzdSt35wpairkG/mi8qazWOig9sY6yANZb3IxkXYQSXERzxyaLKW0916EMSAawmAWmHrjrEoFGp5syHT3/5lN/P2ZP1NEjpz489vSkpnLyEck+A+bV7SYfIIqIbmVNy9aUYdRUDbR7oqM8EHKtqWwUthHpgl14Ux21aPHRNCOUdvBtdBOSdXP4xlQeiDSLqbr1RBSKDCrGSjYUScE8SeK1wcBZpsxPX/7g5Y9eGhI2ZX7/oSde+/lJoa22o4QaqLqIJKlANrvvHiJaivQcQVM50kAWkS1xymIqj3uCO9XJc9yYqVQEbiHKwABp4lnH6j8PyQZjHxIMRBuswzZfLrgV5SOObkNtEFGRFt3s6cu0K+J6TeHAnU9ceW+/nTaFwaMXrpwQ3GpranMusKA7BsgtZw8AUjb0g/2/W03J6WaLqfW6XCREhcwbjVMWU6W5KNy2TYt1ci6ihwG3RaQBKyXUDfUmxQDX93UB68IqPJDhajWlTOvSozaRNhdCm1qVjPiG6TL15IlXT9jt4wbfeePJ44KDqjFvM0mh3Nq17MXPUMMtVxi5AFbAnogEV9qIQhcW0ZXB1MQ2h3ohlcWgNURFangTRbmz1X1JJPVCHMkSAKQXI19D9ezYXs1cnKuqYztljA5VyRftxQCULEpGbWeb3LOIjRKc//QBRwdHDtt9wzMdHhoRfv8b+4bsGrKsO86HH4FTQerSmwrYgiZP0UYU1ZkpoV2dO41EwZ2VBqKg7N2NxqjOLCpXKMqJXBZ5sw6xvmn3Jm8pkdGnM5GoNGxparBBkTebyK2zp1qj6fQxsn5vX09cpvUt0heBmtjdG/24L/6VFbu7mMNSRZ5mGkyZJswa2N06M/JTvoif7exj2h0l2Lc04S4zw1QYG8g6GXumJs6tcByeuaY64/vKnX1MYVODZ987M1FuheVjDrwxfGh8s5oZpnSyUomzjyloynTvqQcfenWidLDp4KP3vXXi1cPjVM0MU9OBoCnz6XevvPbGPRPFKvMzjzz2i0dnapuaDoSfvv33XXjk7gkyBiwf89QjHw6JpnD/+XufmdCU6fwl/Eng+bQ1JZePDxcSuVxwm0Q+WsSRyDRtQpcqt+JkB45hx9SQeXCyccKgSUiljSlDS8KKcWdMTehnA1HdkoRlNutDVq7O4Rc8C9cIXKlb/7pQjpjsafAwOdNaQ5Zq+YySDcvhxdIohrnIsFnfCTSwT/m6axOlV/EvtJxj3TR4mJzJMnn2cCiTJ/XCTePOmMInnAzz+IyMlaQ9YVw6sjTbR/BKXdyxUsHIy3K+Bgew/zZzdMJRwj13C28VMqXZ6duUaS3K2ZjKCWqgxKbOYGaoI5GVXgJu7fSOYm9yhqgdRlnlhlst0czFHUssx5gVvaaIiBrWRBBFBGk0TTv9ibZkbvBmuULSrAknvw0K/n1GU+m7lU8I71WEreCO7FxTw/uffOCsXVHDh849tH/ytxneVGMg26AvEjJ1M1ZnA/BsJFqEuiSi8Bi280AwUYc6vYoVUJfKrabKLAeW93LWMrCYaDH69Sw1sXUuyx40uxAtRG8cgFUsxdLIlXtYK6wuYUculjrZ1NDpF37+/GXBXB0bTB158cEnnrok1KrGm9J4IjQsu86SuLU1tQxoT9uYznLdi1CSRLNzkd5c44m+eupQQ9W/cC2Xfxk1VVjMET3GFNJjBuQFSrhvigT6JbQHUHbHadE+hwqUaN3XypaCgBTfJUCnk01h6KWXnztustf/DZ174rkXhoW2jjdVqrhNSjQfxXZMxRLFsTzoIlazSkVJCFGsEtXUoUQN0Q41lyLnTY2SyUzVXDWlzJrlT8Vwn8NVtkJoIbCPKESJbbSEpcDka7GN1jftI3LLxS3ONnXg3rseOnHIjigMnrnrhQcOCG0RilPSoKpiT2SMViTLrKZamCltG9EKlkVfBI8iWofVbB/24adkfeDmdFbkGjWVsME3LCwsbPMYU3o5UXk72KBDpsVGWsjyfOSqx/KAeRiI3RkbivmziGbH3rRAKdAZf0ZT5tNHD5wZFsqtcHXSu88fOnPQMVOSai1UfausbaoZ7qws7pKMFGaKZSzzRk0Fy/V8LOpHAjPlQ6TJv8aUNaLLe7n95vOmWmcRBXuwzDkZtqObFmLVFq7eML+Ub4dqxMjdejzhsTbfUpNwnimYTXzReGxuxcTlYywlZQdM+QDV6yVlVlNx8GR1E1kgK0As47TlWdtUKEJZ1xaDxUKmro3o/ZwLzlQx35jiWC2wHWm0EHVziIx9SAnYjpak8PDwhhxKRbyi3KBHqtNN8YwMHTfZ1NaHzr79jsNzXThTcVilowC9dfSUByyRuRo2crVjW1MsTil9iCpV2Mfi1FhTkW0yRr2EFrBiRXD7VVOUgcIGYhXpKBanNhLFqrGHyqA3kLGnJ4tWo5VoTvw0mWJzXX7x50e5pAIf3c3n7v/o8ik7YykhU7ew2QbNeauB0NGB0RY9oO11B9w1FlPevCnW981FSUtkLWIM1KHiTF0bp0q0jHZ9PVUAy9PclbwpbqwfVQvtkgGwhrqQFR+64+GlYX3fyqoMVgjrQUlaUx+EpmA5wRQefv3iYxceZ0nzA0//5ZCZjQ+euvLx38anpeyYckcqufUD6M3GKku+tqhVzfaMSSTWBnK5NhXPTHkmEe1drAJULbOJOjw4U4EYncHiMhdKFQOrZLS5F0D3JiYpY7S1ZuoB1MUFMFOFy2qB7ay40cimugV2EZsQAbSUIfR6x56TznW5yOa6mI4ee/OuY0dYPubtty6eEez1BEzJk6LLieRrukJ0xvBwN+vq6MouRQd3xeXRSXKiLdENRpKGR7D5TpJohSKcdZO6iHB/ImNDdJvlYOERHOF75URusZ2JJNu1nmh9NP9iTbqozkZWy2GmpMHePvwYsy2zy4cbrRtiVxRIXKIbpjIN0HFT5mNvH2RzXczHnv3gtQdfHwLMp+5853VH57rcIBbysxKczCRtanh0rsvgkeevvMkVjc1DE+ZjZoKpKuTLHNhtijiYdTnw1xMn37DzbjPjTDXGtFz32519HM1PHR4cuWfywtbMMDU9ODxz36FiqWjKcURToinRlKOw34x+34l8nn8z+t//fM+J/Ptfn9ffId/+yU8/vcOJfHrH5/W37d/6orP55jdu9D2JiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIjcaP4HJmVsK6LwYI4AAAAASUVORK5CYII="

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_forms_VuelidateError__ = __webpack_require__(969);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var compName = 'base-input';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: compName,
  components: {
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["s" /* BFormInput */],
    BInputGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_25" /* BInputGroup */],
    BInputGroupAppend: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_26" /* BInputGroupAppend */],
    BInputGroupText: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_28" /* BInputGroupText */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    BTooltip: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_51" /* BTooltip */],
    VuelidateError: __WEBPACK_IMPORTED_MODULE_1__components_base_forms_VuelidateError__["a" /* default */],
    BFormText: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["z" /* BFormText */]
  },
  props: {
    value: [String, Number],
    label: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('base-input.placeholder');
      }
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    requiredErrorMsg: {
      type: String,
      required: false,
      default: function _default() {}
    },
    errorMsg: {
      type: String,
      required: false
    },
    validator: {
      type: Object,
      required: false,
      default: null
    },
    dataAttributes: {
      type: Object,
      required: false,
      default: null
    },
    zeroMarginBottom: {
      type: Boolean
    },
    alignLeft: {
      type: Boolean
    },
    width50: {
      type: Boolean
    },
    autocomplete: {
      type: String
    },
    tooltip: String,
    inlineBlock: Boolean,
    width25: Boolean,
    min: Number,
    max: Number,
    step: Number,
    name: String,
    size: {
      type: String,
      default: 'md'
    },
    inputInfoText: {
      type: String,
      required: false,
      default: null
    },
    borderNone: Boolean,
    disabled: Boolean,
    enterEventAction: Function,
    maxlength: Number
  },
  data: function data() {
    return {
      id: null,
      localValue: null
    };
  },
  mounted: function mounted() {
    this.id = '' + compName + this._uid.toString();
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('value', function (value) {
      _this.localValue = value;
    });
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
      _this.$emit('change', value);
    });
  },

  computed: {
    hasAppendSlot: function hasAppendSlot() {
      return this.$slots.append !== undefined;
    }
  }
});

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var messages = {
  es: {
    'base-radio-group': {
      'error-msg': 'Seleccione una opción'
    }
  },
  en: {
    'base-radio-group': {
      'error-msg': 'Select an option'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BFormGroup: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["r" /* BFormGroup */],
    BFormRadioGroup: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["v" /* BFormRadioGroup */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["t" /* BFormInvalidFeedback */]
  },
  i18n: {
    messages: messages
  },
  props: {
    value: [String, Object, Boolean, Number],
    options: {
      type: Array,
      required: true
    },
    state: {
      type: [Boolean, Object],
      required: false,
      default: null
    },
    stacked: {
      type: Boolean,
      required: false
    },
    errorMsg: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('base-radio-group.error-msg');
      }
    },
    labelsEnabled: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      localValue: null
    };
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
    });
    this.$watch('value', function (newValue) {
      _this.localValue = newValue;
    });
  },

  computed: {
    optionsSettledLabels: function optionsSettledLabels() {
      var _this2 = this;

      return this.options.map(function (option) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, option, {
          label: _this2.labelsEnabled ? option.text || option.value : ''
        });
      });
    }
  }
});

/***/ }),
/* 1073 */,
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_cookies__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(162);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'AddToHomeScreen',
	components: {
		BaseDialog: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__["default"]
	},
	props: {
		showPromptOnLoad: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		animate: {
			type: Boolean,
			default: false
		},
		shadow: {
			type: Boolean,
			default: false
		},
		white: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			modalVisible: false,
			deferredPrompt: null,
			getPlatformName: Object(__WEBPACK_IMPORTED_MODULE_2__constants_platformNames__["h" /* getPlatformName */])(),
			mounted: false,
			safariTooltipVisible: false,
			shareIconImg: '<img src=\'/static-appopensalud/img/icons/morillas-svg-icons/primary/share.svg\' class="safari-tooltip-icon"></img>',
			plusIconImg: '<img src=\'/static-appopensalud/img/icons/morillas-svg-icons/primary/add.svg\' class="safari-tooltip-icon"></img>'
		};
	},

	methods: {
		addToHomeScreen: function addToHomeScreen() {
			var _this = this;

			if (this.deviceIsAllowedIOS) {
				this.safariTooltipVisible = true;
				setTimeout(function () {
					_this.safariTooltipVisible = false;
				}, 6000);
			} else {
				// Show the prompt
				this.deferredPrompt.prompt();
				// Wait for the user to respond to the prompt
				this.deferredPrompt.userChoice.then(function (choiceResult) {
					if (choiceResult.outcome === 'accepted') {
						window.$cookies.set(__WEBPACK_IMPORTED_MODULE_1__constants_cookies__["j" /* PWA_INSTALLED_COOKIE_NAME */], false, 365, '/', _this.$helpers.getFirstLevelDomain());
					} else {
						window.$cookies.set(__WEBPACK_IMPORTED_MODULE_1__constants_cookies__["j" /* PWA_INSTALLED_COOKIE_NAME */], false, 30, '/', _this.$helpers.getFirstLevelDomain());
					}
					_this.modalVisible = false;
					_this.deferredPrompt = null;
				});
			}
		},
		saveNotAddingToHomeScreen: function saveNotAddingToHomeScreen() {
			this.modalVisible = false;
			this.deferredPrompt = null;
			window.$cookies.set(__WEBPACK_IMPORTED_MODULE_1__constants_cookies__["j" /* PWA_INSTALLED_COOKIE_NAME */], false, 30, '/', this.$helpers.getFirstLevelDomain());
		}
	},
	watch: {
		safariTooltipVisible: function safariTooltipVisible(val) {
			if (val) {
				Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["c" /* hideSmartsuppChat */])();
			}
		}
	},
	computed: {
		getAppIcon: function getAppIcon() {
			return '/static-appopensalud/img/favicons/' + (this.getPlatformName === __WEBPACK_IMPORTED_MODULE_2__constants_platformNames__["b" /* OPENLEGAL_PLATFORM_NAME */] ? this.getPlatformName : __WEBPACK_IMPORTED_MODULE_2__constants_platformNames__["d" /* OPENSALUD_PLATFORM_NAME */]) + '/dark-theme/favicon-32x32.png';
		},
		animateActive: function animateActive() {
			return this.animate && this.mounted;
		},
		deviceIsAllowedIOS: function deviceIsAllowedIOS() {
			return !window.navigator.standalone && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		},
		showA2HS: function showA2HS() {
			// Check device is iOS with Safari and app is not running in standalone mode
			return this.deferredPrompt || this.deviceIsAllowedIOS;
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		// Before install prompt opening modal
		window.addEventListener('beforeinstallprompt', function (e) {
			// Prevent Chrome 67 and earlier from automatically showing the prompt
			e.preventDefault();
			// Stash the event so it can be triggered later.
			_this2.deferredPrompt = e;
			// Update UI to notify the user they can add to home screen
			if (_this2.showPromptOnLoad && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.$cookies.get(__WEBPACK_IMPORTED_MODULE_1__constants_cookies__["j" /* PWA_INSTALLED_COOKIE_NAME */]) !== 'true' && window.$cookies.get(__WEBPACK_IMPORTED_MODULE_1__constants_cookies__["j" /* PWA_INSTALLED_COOKIE_NAME */]) !== 'false') {
				_this2.modalVisible = true;
			}
		});

		this.mounted = true;
	}
});

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_colours_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_locales__ = __webpack_require__(152);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LangSelector',
  props: {
    enablePortuguese: Boolean,
    color: {
      required: false,
      type: String,
      default: Object(__WEBPACK_IMPORTED_MODULE_0__constants_colours_js__["o" /* getPrimaryColour */])()
    },
    labeled: Boolean
  },
  data: function data() {
    return {
      lang: this.$i18n.locale,
      EN_LOCALE: __WEBPACK_IMPORTED_MODULE_1__constants_locales__["a" /* EN_LOCALE */],
      PT_LOCALE: __WEBPACK_IMPORTED_MODULE_1__constants_locales__["d" /* PT_LOCALE */]
    };
  },

  computed: {
    esLocale: function esLocale() {
      return window.location.href.includes('.mx') ? __WEBPACK_IMPORTED_MODULE_1__constants_locales__["c" /* MX_LOCALE */] : __WEBPACK_IMPORTED_MODULE_1__constants_locales__["b" /* ES_LOCALE */];
    },
    cssProps: function cssProps() {
      return { '--color': this.color };
    }
  },
  methods: {
    isActive: function isActive(lang) {
      return this.lang === lang;
    }
  }
});

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inline_svg__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_inline_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_sizes__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-icon',
  components: {
    'inline-svg': __WEBPACK_IMPORTED_MODULE_0_vue_inline_svg___default.a
  },
  data: function data() {
    return {
      id: null
    };
  },

  props: {
    src: {
      type: String
    },
    color: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: [String],
      required: false,
      validator: function validator(value) {
        return value === __WEBPACK_IMPORTED_MODULE_1__constants_sizes__["c" /* SMALL_SIZE */] || value === __WEBPACK_IMPORTED_MODULE_1__constants_sizes__["b" /* MEDIUM_SIZE */] || value === __WEBPACK_IMPORTED_MODULE_1__constants_sizes__["a" /* LARGE_SIZE */];
      },
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__constants_sizes__["c" /* SMALL_SIZE */];
      }
    },
    width: {
      type: [Number, String],
      required: false
    },
    height: {
      type: [Number, String],
      required: false
    },
    svgClasses: {
      type: String,
      required: false
    },
    blue: Boolean,
    green: Boolean,
    white: Boolean,
    red: Boolean,
    gray: Boolean,
    fullWidth: Boolean,
    shadow: Boolean,
    reverse: Boolean
  },
  computed: {
    getSize: function getSize() {
      var size = {};
      if (this.fullWidth) {
        var full = '100%';
        size.width = full;
        size.height = full;
      } else {
        switch (this.size) {
          case __WEBPACK_IMPORTED_MODULE_1__constants_sizes__["c" /* SMALL_SIZE */]:
            size.width = 17;
            size.height = 17;
            break;
          case __WEBPACK_IMPORTED_MODULE_1__constants_sizes__["b" /* MEDIUM_SIZE */]:
            size.width = 30;
            size.height = 30;
            break;
          case __WEBPACK_IMPORTED_MODULE_1__constants_sizes__["a" /* LARGE_SIZE */]:
            size.width = 50;
            size.height = 50;
            break;
        }
      }
      return size;
    },
    getSvgClasses: function getSvgClasses() {
      var classes = this.svgClasses;
      if (this.shadow) {
        classes += ' svg-shadow';
      }
      if (this.reverse) {
        classes += ' reverse';
      }
      return classes ? classes.trim() : '';
    },
    isSvg: function isSvg() {
      return this.src && this.src.includes('.svg');
    }
  },
  watch: {
    color: function color(newColor) {
      this.updateSvgStyles(newColor);
    },
    blue: function blue(isBlue) {
      if (isBlue) {
        this.updateSvgStyles(this.getColor(true));
      }
    },
    green: function green(isGreen) {
      if (isGreen) {
        this.updateSvgStyles(this.getColor(true));
      }
    },
    white: function white(isWhite) {
      if (isWhite) {
        this.updateSvgStyles(this.getColor(true));
      }
    },
    red: function red(isRed) {
      if (isRed) {
        this.updateSvgStyles(this.getColor(true));
      }
    },
    gray: function gray(isGray) {
      if (isGray) {
        this.updateSvgStyles(this.getColor(true));
      }
    }
  },
  methods: {
    updateSvgStyles: function updateSvgStyles(color) {
      var elem = document.getElementById(this.id);
      if (!elem) {
        return;
      }
      var paths = elem.querySelectorAll('path');
      if (paths.length === 0) {
        return;
      }
      paths.forEach(function (elem) {
        var modified = false;
        if (elem.style.fill || elem.outerHTML.includes('fill="') && !elem.outerHTML.includes('fill="none"')) {
          elem.style.fill = color;
          modified = true;
        }
        if (elem.style.stroke || elem.outerHTML.includes('stroke="') && !elem.outerHTML.includes('stroke="none"')) {
          elem.style.stroke = color;
          modified = true;
        }
        if (!modified) {
          elem.style.fill = color;
        }
      });
      var rects = elem.querySelectorAll('rect');
      if (rects.length === 0) {
        return;
      }
      rects.forEach(function (elem) {
        elem.style.fill = color;
      });
    },
    svgLoaded: function svgLoaded() {
      this.updateSvgStyles(this.getColor());
    },
    getColor: function getColor() {
      var onlyColorProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.color || onlyColorProps) {
        if (this.blue) {
          return __WEBPACK_IMPORTED_MODULE_2__constants_colours__["c" /* BLUE_COLOUR */];
        } else if (this.green) {
          return __WEBPACK_IMPORTED_MODULE_2__constants_colours__["g" /* GREEN_COLOUR */];
        } else if (this.white) {
          return __WEBPACK_IMPORTED_MODULE_2__constants_colours__["m" /* WHITE_COLOUR */];
        } else if (this.red) {
          return __WEBPACK_IMPORTED_MODULE_2__constants_colours__["k" /* RED_COLOUR */];
        } else {
          // default
          return __WEBPACK_IMPORTED_MODULE_2__constants_colours__["f" /* GRAY_COLOUR */];
        }
      } else {
        return this.color;
      }
    }
  },
  mounted: function mounted() {
    this.id = this._uid.toString();
  }
});

/***/ }),
/* 1077 */,
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SMALL_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEDIUM_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LARGE_SIZE; });
var SMALL_SIZE = 'sm';
var MEDIUM_SIZE = 'md';
var LARGE_SIZE = 'lg';

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_LangSelector__ = __webpack_require__(125);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropdown',
  components: {
    'sign-up-form': function signUpForm() {
      return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 2348));
    },
    'professional-sign-up-form': function professionalSignUpForm() {
      return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 1274));
    },
    'center-sign-up-form': function centerSignUpForm() {
      return __webpack_require__.e/* import() */(15/* duplicate */).then(__webpack_require__.bind(null, 1275));
    },
    BaseModal: __WEBPACK_IMPORTED_MODULE_0__BaseModal_vue__["a" /* default */],
    LangSelector: __WEBPACK_IMPORTED_MODULE_1__components_base_LangSelector__["default"]
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showLanguageSelector: {
      type: Boolean
    },
    enablePortuguese: Boolean,
    showAsNavbarBtn: Boolean
  },
  data: function data() {
    return {
      isOpen: false,
      signUpVisibleCenter: false,
      signUpVisibleProfessional: false,
      signUpVisiblePatient: false,
      signUpVisible: false
    };
  },

  methods: {
    goToForm: function goToForm(form) {
      window.location = this.$helpers.getAppUrl(form);
    },
    dropdownOptionClick: function dropdownOptionClick(item, i) {
      var _this = this;

      if (item.href) {
        this.$router.push({ path: item.href }).catch(function () {
          _this.$router.go();
        });
      } else if (item.event) {
        this.$store.commit(item.event);
      } else if (item.click) {
        this.$emit(item.click);
      } else {
        if (i === 0) {
          this.signUpVisibleProfessional = true;
        } else if (i === 1) {
          this.signUpVisiblePatient = true;
        } else {
          this.signUpVisibleCenter = true;
        }
      }
    }
  }
});

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            scTimer: 0,
            scY: 0
        };
    },

    computed: {
        calculateWindowHeight: function calculateWindowHeight() {
            return this.scY > window.screen.height;
        }
    },
    methods: {
        handleScroll: function handleScroll() {
            var _this = this;

            if (this.scTimer) return;
            this.scTimer = setTimeout(function () {
                _this.scY = window.scrollY;
                clearTimeout(_this.scTimer);
                _this.scTimer = 0;
            }, 100);
        },
        goTop: function goTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    },
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__ = __webpack_require__(1676);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypehead',

  components: {
    VueBootstrapTypeaheadList: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__["a" /* default */]
  },

  props: {
    size: {
      type: String,
      default: null,
      validator: function validator(size) {
        return ['lg', 'sm'].indexOf(size) > -1;
      }
    },
    value: {
      type: String
    },
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    serializer: {
      type: Function,
      default: function _default(d) {
        return d;
      },
      validator: function validator(d) {
        return d instanceof Function;
      }
    },
    backgroundVariant: String,
    textVariant: String,
    inputClass: {
      type: String,
      default: ''
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    placeholder: String,
    prepend: String,
    append: String
  },

  computed: {
    sizeClasses: function sizeClasses() {
      return this.size ? 'input-group input-group-' + this.size : 'input-group';
    },
    formattedData: function formattedData() {
      var _this = this;

      if (!(this.data instanceof Array)) {
        return [];
      }
      return this.data.map(function (d, i) {
        return {
          id: i,
          data: d,
          text: _this.serializer(d)
        };
      });
    }
  },

  methods: {
    resizeList: function resizeList(el) {
      var rect = el.getBoundingClientRect();
      var listStyle = this.$refs.list.$el.style;

      // Set the width of the list on resize
      listStyle.width = rect.width + 'px';

      // Set the margin when the prepend prop or slot is populated
      // (setting the "left" CSS property doesn't work)
      if (this.$refs.prependDiv) {
        var prependRect = this.$refs.prependDiv.getBoundingClientRect();
        listStyle.marginLeft = prependRect.width + 'px';
      }
    },
    handleHit: function handleHit(evt) {
      if (typeof this.value !== 'undefined') {
        this.$emit('input', evt.text);
      }

      this.inputValue = evt.text;
      this.$emit('hit', evt.data);
      this.$refs.input.blur();
      this.isFocused = false;
    },
    handleBlur: function handleBlur(evt) {
      var tgt = evt.relatedTarget;
      if (tgt && tgt.classList.contains('vbst-item')) {
        return;
      }
      this.isFocused = false;
    },
    handleInput: function handleInput(newValue) {
      this.inputValue = newValue;

      // If v-model is being used, emit an input event
      if (typeof this.value !== 'undefined') {
        this.$emit('input', newValue);
      }
    }
  },

  data: function data() {
    return {
      isFocused: false,
      inputValue: ''
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$_ro = new __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__["a" /* default */](function (e) {
      _this2.resizeList(_this2.$refs.input);
    });
    this.$_ro.observe(this.$refs.input);
    this.$_ro.observe(this.$refs.list.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.$_ro.disconnect();
  }
});

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(1673);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function sanitize(text) {
  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadList',

  components: {
    VueBootstrapTypeaheadListItem: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__["a" /* default */]
  },

  props: {
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    query: {
      type: String,
      default: ''
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    }
  },

  computed: {
    highlight: function highlight() {
      var _this = this;

      return function (text) {
        text = sanitize(text);
        if (_this.query.length === 0) {
          return text;
        }
        var re = new RegExp(_this.escapedQuery, 'gi');

        return text.replace(re, '<strong>$&</strong>');
      };
    },
    escapedQuery: function escapedQuery() {
      return escapeRegExp(sanitize(this.query));
    },
    matchedItems: function matchedItems() {
      if (this.query.length === 0 || this.query.length < this.minMatchingChars) {
        return [];
      }

      var re = new RegExp(this.escapedQuery, 'gi');

      // Filter, sort, and concat
      return this.data.filter(function (i) {
        return i.text.match(re) !== null;
      }).sort(function (a, b) {
        var aIndex = a.text.indexOf(a.text.match(re)[0]);
        var bIndex = b.text.indexOf(b.text.match(re)[0]);

        if (aIndex < bIndex) {
          return -1;
        }
        if (aIndex > bIndex) {
          return 1;
        }
        return 0;
      }).slice(0, this.maxMatches);
    }
  },

  methods: {
    handleHit: function handleHit(item, evt) {
      this.$emit('hit', item);
      evt.preventDefault();
    }
  }
});

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadListItem',

  props: {
    data: {},
    htmlText: {
      type: String
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    }
  },

  data: function data() {
    return {
      active: false
    };
  },


  computed: {
    textClasses: function textClasses() {
      var classes = '';
      classes += this.active ? 'active' : '';
      classes += this.backgroundVariant ? ' bg-' + this.backgroundVariant : '';
      classes += this.textVariant ? ' text-' + this.textVariant : '';
      return 'vbst-item list-group-item list-group-item-action ' + classes;
    }
  }
});

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var compName = 'base-spin-input';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: compName,
  components: {
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["s" /* BFormInput */],
    BInputGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_25" /* BInputGroup */],
    BInputGroupAppend: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_26" /* BInputGroupAppend */],
    BInputGroupText: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_28" /* BInputGroupText */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    BFormSpinbutton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["y" /* BFormSpinbutton */]
  },
  props: {
    value: Number,
    label: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMsg: {
      type: String,
      required: false,
      default: null
    },
    min: {
      type: String,
      required: true,
      default: 0
    },
    max: {
      type: String,
      required: true,
      default: 100
    },
    step: {
      type: String,
      required: true,
      default: 1
    }
  },
  data: function data() {
    return {
      id: null,
      localValue: null
    };
  },
  mounted: function mounted() {
    this.id = '' + compName + this._uid.toString();
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('value', function (value) {
      _this.localValue = value;
    });
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
      _this.$emit('change', value);
    });
  },

  computed: {
    hasAppendSlot: function hasAppendSlot() {
      return this.$slots.append !== undefined;
    }
  }
});

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customHeader',
  components: {
    BIcon: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["C" /* BIcon */],
    BIconStarFill: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_12" /* BIconStarFill */],
    BIconStar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_11" /* BIconStar */],
    BIconStarHalf: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_13" /* BIconStarHalf */],
    BNavbar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_40" /* BNavbarToggle */],
    BCollapse: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["j" /* BCollapse */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_39" /* BNavbarNav */],
    BDropdownItem: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["l" /* BDropdownItem */],
    BNavItemDropdown: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_36" /* BNavItemDropdown */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_35" /* BNavItem */],
    BContainer: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["k" /* BContainer */],
    BCol: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["i" /* BCol */],
    BRow: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_45" /* BRow */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */],
    BTabs: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_50" /* BTabs */],
    BTab: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_48" /* BTab */]
  },
  props: {},
  data: function data() {
    return {
      activeTab: 'appointments'
    };
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_i18n_mixin__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseModal: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseModal__["a" /* default */]
    },
    props: {
        value: Boolean
    },
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    computed: {
        isVisible: {
            get: function get() {
                return this.value;
            },
            set: function set(val) {
                this.$emit('input', val);
            }
        }
    },
    data: function data() {
        return {
            showInternalShareSelector: false,
            showGenerateLinkSelector: false,
            userEmails: null,
            selectProfCenter: {
                value: null,
                loading: false,
                data: []
            },
            shareLink: {
                validity: null,
                emails: null
            }
        };
    },

    methods: {
        shareInternally: function shareInternally() {
            this.showInternalShareSelector = !this.showInternalShareSelector;
            this.showGenerateLinkSelector = false;
        },
        generateLink: function generateLink() {
            this.showGenerateLinkSelector = !this.showGenerateLinkSelector;
            this.showInternalShareSelector = false;
        },
        loadProfsAndCenters: function loadProfsAndCenters(name) {
            var _this = this;

            this.selectProfCenter.loading = true;
            if (name && name.length >= 3) {
                Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().getProfsAndCentersGrantAccessHistory(name).then(function (response) {
                    if (response.data.data) {
                        _this.selectProfCenter.data = response.data.data;
                    }
                    _this.selectProfCenter.loading = false;
                });
            } else {
                this.selectProfCenter.loading = false;
            }
        },
        grantInternalAccessHistory: function grantInternalAccessHistory() {
            var _this2 = this;

            if (!this.selectProfCenter.value) {
                this.$store.dispatch('showInfoAlert', this.$t('grantAccessSelectProfOrCenter'));
                return;
            }
            var data = { userId: this.selectProfCenter.value };
            Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().grantAccessHistory(data).then(function (response) {
                if (response.data.data) {
                    _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
                    _this2.selectProfCenter.value = null;
                    _this2.showInternalShareSelector = false;
                }
            });
        },
        sendLink: function sendLink() {
            var _this3 = this;

            if (!this.shareLink.validity || this.shareLink.validity > 180 || this.shareLink.validity <= 0) {
                this.$store.dispatch('showInfoAlert', this.$t('sharelinkError.validity'));
            } else if (!this.shareLink.emails) {
                this.$store.dispatch('showInfoAlert', this.$t('sharelinkError.emails'));
            } else {
                var wrongEmails = this.shareLink.emails.split(/(,|;| |\n)+/).filter(function (m) {
                    return _this3.$validators.validate(m, ['email']) === false && m !== ',' && m !== ';' && m !== ' ' && m !== '\n';
                }).filter(function (v, i, a) {
                    return a.indexOf(v) === i;
                });
                if (wrongEmails.length > 0) {
                    this.$store.dispatch('showInfoAlert', this.$t('sharelinkError.wrongEmail') + ' ' + wrongEmails);
                } else {
                    var emails = this.shareLink.emails.split(/(,|;| |\n)+/).filter(function (m) {
                        return _this3.$validators.validate(m, ['email']) !== false;
                    }).filter(function (v, i, a) {
                        return a.indexOf(v) === i;
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().shareHistoryLink({ validity: this.shareLink.validity, emails: emails }).then(function (response) {
                        if (response.data.data) {
                            _this3.$store.dispatch('showSuccessAlert', _this3.$t('linkSendedSuccessfully'));
                            _this3.shareLink.validity = null;
                            _this3.shareLink.emails = null;
                            _this3.showGenerateLinkSelector = false;
                        }
                    });
                }
            }
        }
    }
});

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_PaginatedTable__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_i18n_mixin__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//






var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseModal: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseModal__["a" /* default */],
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_2__components_base_PaginatedTable__["a" /* default */]
    },
    props: {
        value: Boolean
    },
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_3__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    data: function data() {
        return {
            profAndCenterAuthorized: {
                data: [],
                loading: true,
                fields: [{
                    label: this.$t('name-column'),
                    key: 'nombre'
                }, {
                    label: '',
                    key: 'remove'
                }]
            }
        };
    },
    created: function created() {},

    computed: {
        isVisible: {
            get: function get() {
                return this.value;
            },
            set: function set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        loadProfAndCentersAuthorized: function loadProfAndCentersAuthorized(refresh) {
            var _this = this;

            if (this.profAndCenterAuthorized.data.length === 0 || refresh) {
                Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().getProfessionalsAndCentersSharedClinic().then(function (result) {
                    if (result.data.data) {
                        _this.profAndCenterAuthorized.data = result.data.data;
                        _this.profAndCenterAuthorized.loading = false;
                    }
                });
            }
        },
        revokeAccess: function revokeAccess(data) {
            var _this2 = this;

            Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().deleteProfessionalsAndCentersSharedClinic(data.item.id).then(function (response) {
                var data = response.data.data;
                if (data) {
                    if (data === 0) {
                        _this2.$store.dispatch('showDangerAlert', _this2.$t('revokeAccessClinic.error'));
                    } else if (data === 1) {
                        _this2.$store.dispatch('showDangerAlert', _this2.$t('revokeAccessClinic.owner'));
                    } else if (data === 2) {
                        _this2.$store.dispatch('showDangerAlert', _this2.$t('revokeAccessClinic.withAppointment'));
                    } else if (data === 4) {
                        _this2.$store.dispatch('showDangerAlert', _this2.$t('revokeAccessClinic.center'));
                    } else {
                        _this2.$store.dispatch('showSuccessAlert', _this2.$t('revokeAccessClinic.success'));
                        _this2.loadProfAndCentersAuthorized(true);
                    }
                }
            });
        }
    }
});

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_healthyHabits_mixin__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseCard__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseInput__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_base_forms_BaseTextarea__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_base_buttons_BaseButton__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__repositories_HealthyHabitsRepository__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pencilpix_vue2_clock_picker__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pencilpix_vue2_clock_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pencilpix_vue2_clock_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_healthy_habits_HealthyHabitsPredefined__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pencilpix_vue2_clock_picker_dist_vue2_clock_picker_min_css__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pencilpix_vue2_clock_picker_dist_vue2_clock_picker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pencilpix_vue2_clock_picker_dist_vue2_clock_picker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_date_helpers__ = __webpack_require__(179);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var WEEKDAY_NAMES = Object(__WEBPACK_IMPORTED_MODULE_16__helpers_date_helpers__["p" /* getWeekDaysNames */])();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'healthyHabitsForm',
    components: {
        BaseCard: __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseCard__["default"],
        BaseInput: __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseInput__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_9__components_base_buttons_BaseButton__["default"],
        BaseModal: __WEBPACK_IMPORTED_MODULE_10__components_base_BaseModal__["a" /* default */],
        BFormGroup: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["r" /* BFormGroup */],
        BFormRadio: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["u" /* BFormRadio */],
        BFormTimepicker: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["B" /* BFormTimepicker */],
        BInputGroupAppend: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["_26" /* BInputGroupAppend */],
        BFormInput: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["s" /* BFormInput */],
        BInputGroup: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["_25" /* BInputGroup */],
        BFormCheckboxGroup: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["o" /* BFormCheckboxGroup */],
        BTooltip: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["_51" /* BTooltip */],
        BInputGroupPrepend: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["_27" /* BInputGroupPrepend */],
        BInputGroupText: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["_28" /* BInputGroupText */],
        VueClockPicker: __WEBPACK_IMPORTED_MODULE_12__pencilpix_vue2_clock_picker___default.a,
        HealthyHabitsPredefined: __WEBPACK_IMPORTED_MODULE_13__components_views_healthy_habits_HealthyHabitsPredefined__["a" /* default */],
        BaseTextArea: __WEBPACK_IMPORTED_MODULE_8__components_base_forms_BaseTextarea__["default"],
        BFormCheckbox: __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue__["n" /* BFormCheckbox */]
    },
    props: {
        inModal: Boolean,
        habitDescription: String
    },
    created: function created() {
        if (this.$store.state.healthyHabits.form.editing) {
            this.fillhealthyHabitsFields();
        } else if (this.$store.state.healthyHabits.form.predefinedHabit && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.$store.state.healthyHabits.form.predefinedHabit).length > 0) {
            this.loadPredefinedHabit();
        }
        if (this.$route.params.historyGroupId || this.$route.params.historyVarName) {
            this.loadPredefinedHabitFromHistory();
        }
        if (this.habitDescription) {
            this.healthyHabitsData.description = this.habitDescription;
        }
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_healthyHabits_mixin__["a" /* default */]],
    data: function data() {
        return {
            showFrequencyModal: false,
            showReminderDaysModal: false,
            showReminderDaysInput: false,
            goalDays: 1,
            goalWeek: 4,
            goalMonth: 2,
            frequencyText: null,
            reminderDaysText: null,
            reminderDaysArray: [],
            currentGoalFrequencyId: null,
            currentGoal: null,
            isMultiUser: false,
            weekDaysOptions: [{ name: WEEKDAY_NAMES[0], value: 0 }, { name: WEEKDAY_NAMES[1], value: 1 }, { name: WEEKDAY_NAMES[2], value: 2 }, { name: WEEKDAY_NAMES[3], value: 3 }, { name: WEEKDAY_NAMES[4], value: 4 }, { name: WEEKDAY_NAMES[5], value: 5 }, { name: WEEKDAY_NAMES[6], value: 6 }],
            state: {
                description: null,
                question: null,
                reminder: null,
                notes: null,
                measureUnit: null,
                goalFrequencyId: null,
                goal: null,
                reminderDays: null
            },
            healthyHabitsData: {
                id: null,
                measurable: null,
                description: null,
                question: null,
                color: '#3238C4',
                measureUnit: null,
                goal: null,
                reminder: null,
                reminderDays: null,
                notes: null,
                goalFrequencyId: null,
                predefined: false,
                multiUsersEmailsOrPhones: []
            }
        };
    },

    computed: {
        showWeekDaysStacked: function showWeekDaysStacked() {
            return window.innerWidth < 720;
        }
    },
    methods: {
        healthyHabitTypeSelected: function healthyHabitTypeSelected(measurable) {
            this.healthyHabitsData.measurable = measurable;
            this.resetForm();
            setTimeout(function () {
                document.querySelector('.type-habit-form-box').scrollIntoView({ block: 'end', behavior: 'smooth' });
            }, 1);
        },
        setDefaultTime: function setDefaultTime() {
            if (!this.healthyHabitsData.reminder) {
                this.healthyHabitsData.reminder = '00:00';
            }
        },
        resetReminder: function resetReminder() {
            this.healthyHabitsData.reminder = null;
            this.showReminderDaysInput = false;
            this.reminderDaysText = null;
            this.healthyHabitsData.reminderDays = null;
            this.reminderDaysArray = [];
        },
        checkValidMultiUserEmailOrPhone: function checkValidMultiUserEmailOrPhone() {
            var _this = this;

            if (this.healthyHabitsData.multiUsersEmailsOrPhones.length === 0 || this.healthyHabitsData.multiUsersEmailsOrPhones.some(function (e) {
                return _this.$validators.validate(e, ['email'], true) === false && _this.$validators.validate(e, ['phone'], true) === false;
            })) {
                return false;
            }
            return true;
        },
        switchInviteMultiUser: function switchInviteMultiUser() {
            if (!this.$store.state.healthyHabits.form.multiUser) {
                this.healthyHabitsData.multiUsersEmailsOrPhones = [];
            }
        },
        sendData: function sendData() {
            var _this2 = this;

            if (this.$store.state.healthyHabits.form.multiUser && !this.checkValidMultiUserEmailOrPhone()) {
                this.$store.dispatch('showInfoAlert', this.$t('checkInvalidMultiUserEmail'));
                return;
            }
            if (this.$store.state.healthyHabits.form.multiUser && this.healthyHabitsData.multiUsersEmailsOrPhones.length > 9) {
                this.$store.dispatch('showInfoAlert', this.$t('multiUserInviteLimitExceeded'));
                return;
            }
            var invalidData = false;
            var objectKeys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.state).filter(function (key) {
                return key !== 'notes' && key !== 'question' && key !== 'multiUsersEmailsOrPhones' && key !== 'reminder' && (_this2.healthyHabitsData.reminder ? true : key !== 'reminderDays') && (!_this2.healthyHabitsData.measurable ? key !== 'measureUnit' : true);
            });
            if (!this.healthyHabitsData.color) {
                this.$store.dispatch('showInfoAlert', this.$t('mustSelectColor'));
                return;
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(objectKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (!this.healthyHabitsData[key] || this.state[key] === false) {
                        this.state[key] = false;
                        invalidData = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (invalidData) {
                this.$store.dispatch('showInfoAlert', this.$t('checkInvalidFormData'));
                return;
            }
            if (this.$store.state.healthyHabits.form.editing) {
                __WEBPACK_IMPORTED_MODULE_11__repositories_HealthyHabitsRepository__["a" /* default */].updateFormData(this.healthyHabitsData).then(function (response) {
                    if (response.data) {
                        _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
                        if (response.data.data) {
                            var currentItem = _this2.$store.state.healthyHabits.table.data.items.find(function (item) {
                                return item.id === _this2.$store.state.healthyHabits.table.itemSelectedId;
                            });
                            currentItem.goal = _this2.healthyHabitsData.goal;
                            currentItem.goalFrequencyId = _this2.healthyHabitsData.goalFrequencyId;
                            var dataKeys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(currentItem);
                            var serverData = response.data.data.filter(function (item) {
                                return !dataKeys.some(function (key) {
                                    return key === _this2.getDateOnlyFormatted(item.date);
                                });
                            });
                            for (var index in serverData) {
                                var item = serverData[index];
                                if (currentItem.measurable) {
                                    currentItem[_this2.getDateOnlyFormatted(item.date)] = parseFloat(item.value);
                                } else {
                                    currentItem[_this2.getDateOnlyFormatted(item.date)] = item.value === 'true' ? true : item.value === 'false' || item.value === 0 ? false : null;
                                }
                            }
                            dataKeys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(currentItem);
                            var dataMapped = dataKeys.filter(function (key) {
                                return _this2.checkValidDate(key);
                            }).map(function (date) {
                                return new Date(date);
                            });
                            if (!currentItem.measurable) {
                                _this2.fillPartialGoalCompleted(currentItem, new Date(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(dataMapped))));
                            }
                            _this2.updateGoalStreak(null, true);
                            currentItem.accumulatedGoal = _this2.lastGoalAccumulated(currentItem);
                        } else {
                            _this2.getHealthyHabitsData();
                        }
                        _this2.cancel();
                    } else {
                        _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
                        _this2.cancel();
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_11__repositories_HealthyHabitsRepository__["a" /* default */].createDataForm(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.healthyHabitsData, { historyVarName: this.$route.params.historyVarName, historyGroupId: this.$route.params.historyGroupId, historyPatientId: this.$route.params.historyPatientId })).then(function (response) {
                    if (response.data) {
                        _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
                        _this2.$emit('habitCreated', response.data[0]);
                        _this2.cancel();
                        if (!_this2.isRouteFromClinicHistory()) {
                            _this2.getHealthyHabitsData();
                        }
                    } else {
                        _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
                        _this2.cancel();
                    }
                });
            }
        },
        cancel: function cancel() {
            this.healthyHabitsData.measurable = null;
            this.resetForm();
            this.$emit('closeModal');
        },
        checkValidField: function checkValidField(key, constraint) {
            if (!this.healthyHabitsData[key] || this.$validators.validate(this.healthyHabitsData[key], [constraint], true) === false) {
                this.state[key] = false;
            } else {
                this.state[key] = true;
            }
            return this.state[key];
        },
        saveReminderDays: function saveReminderDays() {
            if (this.reminderDaysArray.length === 0) {
                this.$store.dispatch('showInfoAlert', this.$t('mustSelectOption'));
                return;
            }
            this.healthyHabitsData.reminderDays = this.reminderDaysArray.sort().map(function (index) {
                return Object(__WEBPACK_IMPORTED_MODULE_16__helpers_date_helpers__["p" /* getWeekDaysNames */])(false, true)[index];
            }).join(',');
            this.reminderDaysText = this.reminderDaysArray.sort().map(function (index) {
                return WEEKDAY_NAMES[index];
            }).join(', ');
            this.state.reminderDays = true;
            this.showReminderDaysModal = false;
        },
        saveFrequency: function saveFrequency() {
            if (!this.healthyHabitsData.goalFrequencyId) {
                this.$store.dispatch('showInfoAlert', this.$t('mustSelectOption'));
                return;
            }
            if (!this.healthyHabitsData.measurable) {
                var value = void 0;
                if (this.healthyHabitsData.goalFrequencyId === 1) {
                    value = parseFloat(this.goalDays);
                    if (!value || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value) || value < 1 || value > 90) {
                        this.$store.dispatch('showInfoAlert', this.$t('mustEnterValidInteger') + ' ' + this.$t('between') + ' 1 ' + this.$t('and') + ' 90');
                        return;
                    }
                    this.healthyHabitsData.goal = value;
                    this.frequencyText = this.healthyHabitsData.goal === 1 ? '' + this.$t('daily') : this.$t('each') + ' ' + this.healthyHabitsData.goal + ' ' + this.$t('days');
                } else if (this.healthyHabitsData.goalFrequencyId === 2) {
                    value = parseFloat(this.goalWeek);
                    if (!value || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value) || value < 1 || value > 6) {
                        this.$store.dispatch('showInfoAlert', this.$t('mustEnterValidInteger') + ' ' + this.$t('between') + ' 1 ' + this.$t('and') + ' 6');
                        return;
                    }
                    this.healthyHabitsData.goal = value;
                    this.frequencyText = this.healthyHabitsData.goal === 1 ? '' + this.$t('weekly') : this.healthyHabitsData.goal + ' ' + this.$t('timesToWeek');
                } else if (this.healthyHabitsData.goalFrequencyId === 3) {
                    value = parseFloat(this.goalMonth);
                    if (!value || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value) || value < 1 || value > 29) {
                        this.$store.dispatch('showInfoAlert', this.$t('mustEnterValidInteger') + ' ' + this.$t('between') + ' 1 ' + this.$t('and') + ' 29');
                        return;
                    }
                    this.healthyHabitsData.goal = value;
                    this.frequencyText = this.healthyHabitsData.goal === 1 ? '' + this.$t('monthly') : this.healthyHabitsData.goal + ' ' + this.$t('timesToMonth');
                }
            } else {
                if (this.healthyHabitsData.goalFrequencyId === 1) {
                    this.frequencyText = this.$t('daily');
                } else if (this.healthyHabitsData.goalFrequencyId === 2) {
                    this.frequencyText = this.$t('weekly');
                } else if (this.healthyHabitsData.goalFrequencyId === 3) {
                    this.frequencyText = this.$t('monthly');
                }
            }
            this.showFrequencyModal = false;
            this.state.goalFrequencyId = true;
        },
        resetForm: function resetForm() {
            this.healthyHabitsData.description = this.habitDescription || null;
            this.healthyHabitsData.question = null;
            this.healthyHabitsData.measureUnit = null;
            this.healthyHabitsData.goal = null;
            this.healthyHabitsData.goalFrequencyId = null;
            this.healthyHabitsData.reminder = null;
            this.healthyHabitsData.reminderDays = null;
            this.healthyHabitsData.notes = null;
            this.healthyHabitsData.predefined = false;
            this.frequencyText = null;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.state)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    this.state[key] = null;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        loadPredefinedHabit: function loadPredefinedHabit() {
            var predefinedHabit = this.$store.state.healthyHabits.form.predefinedHabit;
            this.healthyHabitTypeSelected(predefinedHabit.measurable);
            this.healthyHabitsData.description = predefinedHabit.description;
            this.healthyHabitsData.question = predefinedHabit.question;
            this.healthyHabitsData.goal = predefinedHabit.goal ? predefinedHabit.goal : this.healthyHabitsData.goal;
            this.healthyHabitsData.goalFrequencyId = predefinedHabit.goalFrequencyId;
            this.healthyHabitsData.predefined = true;
            this.healthyHabitsData.measureUnit = predefinedHabit.measurable ? predefinedHabit.measureUnit : null;
            this.getHealthyHabitsFrequencyText();
            if (this.healthyHabitsData.goalFrequencyId === 1) {
                this.goalDays = this.healthyHabitsData.goal;
            } else if (this.healthyHabitsData.goalFrequencyId === 2) {
                this.goalWeek = this.healthyHabitsData.goal;
            } else if (this.healthyHabitsData.goalFrequencyId === 3) {
                this.goalMonth = this.healthyHabitsData.goal;
            }
        },
        loadPredefinedHabitFromHistory: function loadPredefinedHabitFromHistory() {
            this.healthyHabitsData.measurable = this.$route.params.healthyHabitMeasureUnit !== 'null';
            this.healthyHabitTypeSelected(this.healthyHabitsData.measurable);
            this.healthyHabitsData.description = this.$route.params.healthyHabitName;
            this.healthyHabitsData.goalFrequencyId = parseInt(this.$route.params.healthyHabitFrequencyId);
            this.healthyHabitsData.measureUnit = this.healthyHabitsData.measurable ? this.$route.params.healthyHabitMeasureUnit : null;
            this.healthyHabitsData.goal = !this.healthyHabitsData.measurable ? 1 : this.healthyHabitsData.goal;
            this.getHealthyHabitsFrequencyText();
            if (this.healthyHabitsData.goalFrequencyId === 1) {
                this.goalDays = this.healthyHabitsData.goal;
            } else if (this.healthyHabitsData.goalFrequencyId === 2) {
                this.goalWeek = this.healthyHabitsData.goal;
            }
        },
        fillhealthyHabitsFields: function fillhealthyHabitsFields() {
            var _this3 = this;

            var item = this.$store.state.healthyHabits.table.data.items.find(function (item) {
                return item.id === _this3.$store.state.healthyHabits.table.itemSelectedId;
            });
            this.healthyHabitsData.id = item.id;
            this.healthyHabitsData.description = item.description;
            this.healthyHabitsData.question = item.question;
            this.healthyHabitsData.measureUnit = item.measureUnit;
            this.healthyHabitsData.goal = item.goal;
            this.healthyHabitsData.goalFrequencyId = item.goalFrequencyId;
            this.currentGoalFrequencyId = item.goalFrequencyId;
            this.currentGoal = item.goal;
            this.healthyHabitsData.reminder = item.reminder;
            this.healthyHabitsData.reminderDays = item.reminderDays;
            this.healthyHabitsData.notes = item.notes;
            this.healthyHabitsData.measurable = item.measurable;
            this.healthyHabitsData.color = item.color;
            this.isMultiUser = item.isMultiUser;
            this.getHealthyHabitsFrequencyText();
            if (this.healthyHabitsData.reminderDays) {
                this.getHealthyHabitsReminderDaysText();
                this.showReminderDaysInput = true;
            }
            if (item.goalFrequencyId === 1) {
                this.goalDays = item.goal;
            } else if (item.goalFrequencyId === 2) {
                this.goalWeek = item.goal;
            } else if (item.goalFrequencyId === 3) {
                this.goalMonth = item.goal;
            }
        },
        getHealthyHabitsFrequencyText: function getHealthyHabitsFrequencyText() {
            if (this.healthyHabitsData.goalFrequencyId === 1) {
                this.frequencyText = this.healthyHabitsData.measurable ? this.frequencyText = this.$t('daily') : this.healthyHabitsData.goal === 1 ? '' + this.$t('daily') : this.$t('each') + ' ' + this.healthyHabitsData.goal + ' ' + this.$t('days');
            } else if (this.healthyHabitsData.goalFrequencyId === 2) {
                this.frequencyText = this.healthyHabitsData.measurable ? this.frequencyText = this.$t('weekly') : this.healthyHabitsData.goal === 1 ? '' + this.$t('weekly') : this.healthyHabitsData.goal + ' ' + this.$t('timesToWeek');
            } else if (this.healthyHabitsData.goalFrequencyId === 3) {
                this.frequencyText = this.healthyHabitsData.measurable ? this.frequencyText = this.$t('monthly') : this.healthyHabitsData.goal === 1 ? '' + this.$t('monthly') : this.healthyHabitsData.goal + ' ' + this.$t('timesToMonth');
            }
        },
        getHealthyHabitsReminderDaysText: function getHealthyHabitsReminderDaysText() {
            var reminderDays = this.healthyHabitsData.reminderDays.split(',').map(function (day) {
                return Object(__WEBPACK_IMPORTED_MODULE_16__helpers_date_helpers__["p" /* getWeekDaysNames */])(false, true).indexOf(day);
            });
            this.reminderDaysArray = reminderDays;
            this.reminderDaysText = reminderDays.map(function (index) {
                return WEEKDAY_NAMES[index];
            }).join(', ');
        }
    }
});

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_healthyHabits_mixin__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_ui_BaseCard__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_vue_touch__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'healthyHabitsPredefined',
    components: {
        BaseCard: __WEBPACK_IMPORTED_MODULE_1__components_base_ui_BaseCard__["default"],
        BaseModal: __WEBPACK_IMPORTED_MODULE_2__components_base_BaseModal__["a" /* default */],
        BRow: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["_45" /* BRow */],
        BCol: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["i" /* BCol */],
        BIcon: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["C" /* BIcon */]
    },
    props: {
        showingInForm: Boolean
    },
    created: function created() {
        this.$store.state.healthyHabits.predefinedHabit.startIndex = this.$store.state.healthyHabits.form.predefinedHabit && this.$store.state.healthyHabits.predefinedHabit.startIndex ? this.$store.state.healthyHabits.predefinedHabit.startIndex : 0;
        this.$store.state.healthyHabits.predefinedHabit.endIndex = this.$store.state.healthyHabits.form.predefinedHabit && this.$store.state.healthyHabits.predefinedHabit.endIndex ? this.$store.state.healthyHabits.predefinedHabit.endIndex : this.itemsPerPage;
        this.itemsToShow = this.data.slice(this.$store.state.healthyHabits.predefinedHabit.startIndex, this.$store.state.healthyHabits.predefinedHabit.endIndex);
        this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow = this.$store.state.healthyHabits.predefinedHabit.startIndex === 0 ? true : this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow;
        this.$store.state.healthyHabits.predefinedHabit.hideRightArrow = this.$store.state.healthyHabits.predefinedHabit.endIndex === this.data.length ? true : this.$store.state.healthyHabits.predefinedHabit.hideRighArrow;
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_healthyHabits_mixin__["a" /* default */]],
    data: function data() {
        return {
            itemsToShow: [],
            data: [{ id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-walk'), question: this.$t('predefined-walk-question'), measurable: true, goalFrequencyId: 1, measureUnit: 'Km' }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-more-time-in-family'), question: this.$t('predefined-more-time-in-family-question'), measurable: false, goal: 1, goalFrequencyId: 1 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-lose-weight'), question: this.$t('predefined-lose-weight-question'), measurable: true, goalFrequencyId: 2, measureUnit: 'Kg' }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-sleep-better'), question: this.$t('predefined-sleep-better-question'), measurable: false, goal: 1, goalFrequencyId: 1 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-week-exercise'), question: this.$t('predefined-week-exercise-question'), measurable: false, goal: 6, goalFrequencyId: 2 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-ultra-processed-foods'), question: this.$t('predefined-ultra-processed-foods-question'), measurable: false, goal: 1, goalFrequencyId: 1 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-run'), question: this.$t('predefined-run-question'), measurable: true, goalFrequencyId: 1, measureUnit: 'Km' }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-bike'), question: this.$t('predefined-bike-question'), measurable: true, goalFrequencyId: 2, measureUnit: 'Km' }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-swim'), question: this.$t('predefined-swim-question'), measurable: true, goalFrequencyId: 2, measureUnit: this.$t('meters') }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-read'), question: this.$t('predefined-read-question'), measurable: true, goalFrequencyId: 1, measureUnit: this.$t('pagesHabit') }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-argue-less'), question: this.$t('predefined-argue-less-question'), measurable: false, goal: 1, goalFrequencyId: 2 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-meditation'), question: this.$t('predefined-meditation-question'), measurable: false, goal: 3, goalFrequencyId: 2 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-drink-water'), question: this.$t('predefined-drink-water-question'), measurable: true, goalFrequencyId: 1, measureUnit: this.$t('liters') }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-smoke'), question: this.$t('predefined-smoke-question'), measurable: false, goal: 1, goalFrequencyId: 1 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-go-gym'), question: this.$t('predefined-go-gym-question'), measurable: false, goal: 3, goalFrequencyId: 2 }, { id: __WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* default */].generateGuid(), description: this.$t('predefined-drink-alcohol'), question: this.$t('predefined-drink-alcohol-question'), measurable: false, goal: 1, goalFrequencyId: 1 }]
        };
    },

    computed: {
        itemsPerPage: function itemsPerPage() {
            return window.innerWidth >= 1200 ? 3 : window.innerWidth >= 768 ? this.showingInForm ? 3 : 2 : window.innerWidth < 576 ? 2 : this.showingInForm ? 2 : 3;
        }
    },
    methods: {
        predefinedHabitSelected: function predefinedHabitSelected(item) {
            this.$store.state.healthyHabits.form.predefinedHabit = item;
            this.$store.state.healthyHabits.predefinedHabit.itemIdSelected = item.id;
            this.$store.state.healthyHabits.form.show = true;
            this.$emit('predefinedHabitSelected');
        },
        previousPage: function previousPage() {
            if (this.$store.state.healthyHabits.predefinedHabit.startIndex === 0) {
                return;
            }
            this.itemsToShow = this.data.slice(this.$store.state.healthyHabits.predefinedHabit.startIndex - this.itemsPerPage, this.$store.state.healthyHabits.predefinedHabit.startIndex);
            this.$store.state.healthyHabits.predefinedHabit.endIndex = this.$store.state.healthyHabits.predefinedHabit.startIndex;
            this.$store.state.healthyHabits.predefinedHabit.startIndex -= this.itemsPerPage;
            if (this.$store.state.healthyHabits.predefinedHabit.startIndex <= 0) {
                this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow = true;
                this.$store.state.healthyHabits.predefinedHabit.startIndex = 0;
            }
            this.$store.state.healthyHabits.predefinedHabit.hideRightArrow = false;
        },
        nextPage: function nextPage() {
            if (this.$store.state.healthyHabits.predefinedHabit.endIndex === this.data.length) {
                return;
            }
            this.itemsToShow = this.data.slice(this.$store.state.healthyHabits.predefinedHabit.endIndex, this.$store.state.healthyHabits.predefinedHabit.endIndex + this.itemsPerPage);
            this.$store.state.healthyHabits.predefinedHabit.startIndex = this.$store.state.healthyHabits.predefinedHabit.endIndex;
            this.$store.state.healthyHabits.predefinedHabit.endIndex = this.$store.state.healthyHabits.predefinedHabit.startIndex + this.itemsPerPage;
            if (this.$store.state.healthyHabits.predefinedHabit.endIndex >= this.data.length) {
                this.$store.state.healthyHabits.predefinedHabit.hideRightArrow = true;
                this.$store.state.healthyHabits.predefinedHabit.endIndex = this.data.length;
            }
            this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow = false;
        },
        boxPredefinedZIndex: function boxPredefinedZIndex(index) {
            return this.itemsPerPage === 2 && index === 0 || this.itemsPerPage === 3 && index === 1 ? 1 : this.itemsPerPage === 3 && index === 0 ? 2 : 'auto';
        }
    }
});

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		text: {
			type: String,
			required: true
		},
		action: {
			type: Function,
			required: true
		},
		reverse: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_icons_BaseIcon_vue__ = __webpack_require__(502);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BForm: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["m" /* BForm */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["s" /* BFormInput */],
    BAlert: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* BAlert */],
    'base-select': function baseSelect() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 499));
    },
    'base-multiSelect': function baseMultiSelect() {
      return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 2324));
    },
    'binary-radio-group': function binaryRadioGroup() {
      return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 2325));
    },
    BaseIcon: __WEBPACK_IMPORTED_MODULE_2__base_icons_BaseIcon_vue__["a" /* default */]
  },
  props: {
    loginUrl: {
      type: String,
      required: false
    },
    loginCallback: {
      type: Function,
      required: false
    }
  },
  data: function data() {
    return {
      WHITE_COLOUR: __WEBPACK_IMPORTED_MODULE_1__constants_colours__["m" /* WHITE_COLOUR */],
      form: {
        email: null,
        password: null,
        csrfToken: null,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        }
      },
      formSelectLang: {
        selected: null,
        options: [{ value: '1', text: 'Español' }, { value: '2', text: 'English' }, { value: '4', text: 'Français' }, { value: '5', text: 'Deutsch' }, { value: '7', text: 'Català' }, { value: '3', text: 'Italiano' }, { value: '6', text: 'Portugués' }, { value: '8', text: 'Galego' }, { value: '9', text: 'Euskara' }, { value: '10', text: 'русский язык' }, { value: '11', text: '漢語' }, { value: '12', text: 'Valencià' }, { value: '13', text: 'العربية' }, { value: '14', text: 'Български език' }, { value: '15', text: 'Čeština' }, { value: '16', text: 'Dansk' }, { value: '17', text: 'Slovenčina' }, { value: '18', text: 'Slovenščina' }, { value: '19', text: 'Eesti keel' }, { value: '20', text: 'Suomen kieli' }, { value: '21', text: 'Ελληνική γλώσσα' }, { value: '22', text: 'Magyar nyelv' }, { value: '23', text: 'Gaeilge' }, { value: '24', text: 'Latviešu valoda' }, { value: '25', text: 'Lietuvių kalba' }, { value: '26', text: 'Il-Malti' }, { value: '27', text: 'Nederlands' }, { value: '28', text: 'Polski' }, { value: '29', text: 'Limba română' }, { value: '30', text: 'Hrvatski jezik' }, { value: '31', text: 'Svenska' }]
      },
      binRadioGroup: {
        selected: null
      },
      selectSpeciality: {
        selected: null,
        options: []
        /* options: [
          { value: 1, text: 'Videoconsulta Inmediata' },
          { value: 4, text: 'Videoconsulta Programada' },
          { value: 5, text: 'Consulta Escrita' },
          { value: 10, text: 'Chat' },
          { value: 11, text: 'El profesional te llama' },
          { value: 2, text: 'Consulta Presencial' },
          { value: 7, text: 'Segunda Opinión' }
        ] */
      },
      selectConsultation: {
        selected: null,
        options: [{ value: 52, text: 'Pediatría' }, { value: 56, text: 'Psiquiatría' }, { value: 'a', text: 'Otra' }, { value: 'b', text: 'Otra' }, { value: 'c', text: 'Otra' }, { value: 'd', text: 'Otra' }]
      },
      selectProvince: {
        selected: null,
        options: [{ value: '651', text: 'Sevilla' }, { value: 'a', text: 'Otra' }, { value: 'b', text: 'Otra' }, { value: 'c', text: 'Otra' }, { value: 'd', text: 'Otra' }]
      },
      selectPrefix: {
        selected: null,
        options: [{ value: '28', text: 'España (+34)' }, { value: 'a', text: 'Otra' }, { value: 'b', text: 'Otra' }, { value: 'c', text: 'Otra' }, { value: 'd', text: 'Otra' }]
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null
    };
  },

  methods: {
    signup: function signup() {
      var _this2 = this;

      var _this = this;
      this.resetForm();
      this.form.state.submitted = true;
      this.form.state.waiting = true;
      if (this.formValid !== false) {
        this.$api.post(this.loginUrl, {
          companyCode: _this.form.companyCode.trim(),
          languages: _this.formSelectLang.selected.trim(),
          name: _this.form.name.trim()
        }).then(function (response) {
          _this2.loginCallback ? _this2.loginCallback(response) : _this2.defaultLoginCallback(response);
        }).catch(function () {
          _this.form.state.errors = true;
          _this.form.state.waiting = false;
        });
      } else {
        _this.form.state.waiting = false;
      }
    },
    defaultLoginCallback: function defaultLoginCallback(response) {
      if (response.data) {
        switch (response.data.code) {
          case 200:
            window.location = response.data.url;
            break;
          case 403:
            this.submitError = response.data.message;
            this.form.state.unauthorized = true;
            this.form.state.waiting = false;
            break;
          default:
            this.form.state.errors = true;
            this.form.state.waiting = false;
            break;
        }
      } else {
        this.form.state.errors = true;
        this.form.state.waiting = false;
      }
    },

    resetForm: function resetForm() {
      this.form.state.submitted = false;
      this.form.state.waiting = false;
      this.form.state.unauthorized = false;
      this.form.state.errors = false;
    }
  },
  computed: {
    formValid: function formValid() {
      return this.emailValidation && this.passwordValidation;
    },
    emailValidation: function emailValidation() {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted);
    },
    passwordValidation: function passwordValidation() {
      return this.$validators.validate(this.form.password, ['required'], this.form.state.submitted);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    // Retrieve specialties from api and load on specialties select
    this.$api.get('specialties').then(function (response) {
      _this3.selectSpeciality.options = response.data;
    });
  }
});

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__ = __webpack_require__(49);





var theme = 'opensaludprime';
var footer = {
  component: __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].PRIMESALUD
};

var gtag = __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["f" /* PRIMESALUD_PLATFORM_NAME */];

var i18nFile = 'public/views/primesalud';

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'Opensaludprime',
  component: function component() {
    return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 2388));
  },
  meta: {
    title: {
      text: 'Opensaludprime'
    },
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].PRIMESALUD
    },
    i18n: 'public/views/primesalud',
    gtag: gtag,
    theme: theme
  }
}, {
  path: 'mindfulness',
  name: 'Mindfulness',
  component: function component() {
    return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 2389));
  },
  meta: {
    title: {
      text: 'Mindfulness'
    },
    footer: footer
  },
  i18n: 'public/views/Mindfulness',
  gtag: gtag,
  theme: theme
}, {
  path: 'bienestar',
  name: 'Wellness',
  component: function component() {
    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 2390));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('wellness.meta-title');
      }
    },
    footer: footer,
    i18n: 'public/views/primesalud-wellness',
    gtag: gtag,
    theme: theme
  }
}, {
  path: 'asistenciamedica',
  name: 'Medicalassistance',
  component: function component() {
    return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 2391));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('medical-assistance.meta-title');
      }
    },
    footer: footer,
    i18n: 'public/views/primesalud-medical-assistance',
    gtag: gtag,
    theme: theme
  }
}, {
  path: 'descuentos',
  name: 'Discounts',
  component: function component() {
    return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 2392));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('discounts.meta-title');
      }
    },
    footer: footer,
    i18n: 'public/views/primesalud-discounts',
    gtag: gtag,
    theme: theme
  }
}, {
  path: 'gracias',
  name: 'ContactFormSuccessOpensaludPrime',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 185));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    i18n: 'forms/companies-contact-form.json',
    gtag: gtag,
    theme: theme
  }
}]);

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_platformNames__ = __webpack_require__(49);




var layout = __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["j" /* PUBLIC_LAYOUT */];
var footer = {
  component: __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENSALUD
};

var i18nFile = 'public/views/opensalud4all';

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'opensalud4all',
  component: function component() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 2393));
  },
  meta: {
    title: {
      text: 'opensalud4all'
    },
    layout: layout,
    footer: footer,
    i18n: 'public/views/opensalud4all',
    gtag: __WEBPACK_IMPORTED_MODULE_2__constants_platformNames__["c" /* OPENSALUD360_PLATFORM_NAME */]
  }
}, {
  path: 'contact/success',
  name: 'ContactFormSuccessOpensalud4All',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 185));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    i18n: 'forms/companies-contact-form.json'
  }
}]);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_logosFileNames__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_openlegal_Area__ = __webpack_require__(1713);



var _meta;







var layout = __WEBPACK_IMPORTED_MODULE_2__constants_layouts__["j" /* PUBLIC_LAYOUT */];
var footer = {
  component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENLEGAL

};
var logo = {
  src: __WEBPACK_IMPORTED_MODULE_5__constants_logosFileNames__["d" /* OPENLEGAL_LOGO */]
};
var theme = 'openlegal-theme';
var i18nFile = 'public/views/openlegal';
var tagLine = 'Openlegal';

function generateAreasRoutes() {
  // Generate vue routes for every key in areasJson object
  var areasJson = __webpack_require__(225);
  var areasRoutes = [];

  var _loop = function _loop(area) {
    areasRoutes.push({
      path: 'areas/' + area,
      name: area,
      component: __WEBPACK_IMPORTED_MODULE_6__components_views_openlegal_Area__["a" /* default */],
      meta: {
        tagLine: tagLine,
        title: {
          text: function text() {
            return __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["a" /* default */].t('openlegal.' + area + '.title');
          }
        },
        layout: __WEBPACK_IMPORTED_MODULE_2__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
        footer: {
          component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENLEGALHOME
        },
        logo: logo,
        theme: theme,
        i18n: 'public/views/legal-areas'
      }
    });
  };

  for (var area in areasJson.openlegal) {
    _loop(area);
  }
  return areasRoutes;
}

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'Openlegal',
  component: function component() {
    return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 2394));
  },
  meta: {
    tagLine: tagLine,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["a" /* default */].t('openlegal.title');
      }
    },
    layout: layout,
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENLEGALHOME
    },
    logo: logo,
    theme: theme,
    i18n: i18nFile
  }
}, {
  path: 'legacy',
  name: 'OpenlegalLegacy',
  component: function component() {
    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 2395));
  },
  meta: {
    tagLine: tagLine,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["a" /* default */].t('openlegal.title');
      }
    },
    layout: layout,
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENLEGALHOME
    },
    logo: logo,
    theme: theme,
    i18n: i18nFile
  }
}, {
  path: 'openlegal360/empresas',
  name: 'Openlegal360Openlegal',
  component: function component() {
    return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 1273));
  },
  meta: (_meta = {
    tagLine: tagLine,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["a" /* default */].t('openlegal.title');
      }
    },
    layout: layout,
    footer: footer
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'footer', {
    component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].OPENLEGAL360
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'logo', {
    src: __WEBPACK_IMPORTED_MODULE_5__constants_logosFileNames__["c" /* OPENLEGAL360_LOGO */]
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'theme', theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'i18n', i18nFile), _meta)
}, {
  path: 'abogados',
  name: 'Openlegalpro',
  component: function component() {
    return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 1286));
  },
  meta: {
    tagLine: tagLine,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_4__plugins_i18n__["a" /* default */].t('abogalitypro.title');
      }
    },
    footer: {
      component: __WEBPACK_IMPORTED_MODULE_3__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].ABOGALITYPRO
    },
    logo: {
      src: __WEBPACK_IMPORTED_MODULE_5__constants_logosFileNames__["a" /* ABOGALITYPRO_LOGO */]
    },
    i18n: 'public/views/abogalitypro'
  }
}, {
  path: 'terms-clients',
  name: 'TermsClients',
  component: function component() {
    return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 2396));
  },
  meta: {
    tagLine: tagLine,
    title: {
      text: 'Términos y condiciones para clientes'
    },
    layout: __WEBPACK_IMPORTED_MODULE_2__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    footer: footer,
    logo: logo,
    theme: theme
  }
}, {
  path: 'contact/success',
  name: 'ContactFormSuccessOpenlegal',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 185));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_2__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    i18n: 'forms/companies-contact-form.json'
  }
}].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(generateAreasRoutes()), [{
  path: 'error-aca',
  name: 'ErrorACA',
  component: function component() {
    return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 2397));
  },
  meta: {
    tagLine: tagLine,
    layout: __WEBPACK_IMPORTED_MODULE_2__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    footer: footer,
    logo: logo,
    i18n: 'forms/companies-contact-form.json',
    theme: theme
  }
}]));

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Area',
    computed: {
        description: function description() {
            return this.$t('openlegal.' + this.$route.name + '.description');
        }
    }
});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_logosFileNames__ = __webpack_require__(154);


var _meta;







var layout = __WEBPACK_IMPORTED_MODULE_4__constants_layouts__["j" /* PUBLIC_LAYOUT */];
var footer = {
  component: __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].ABOGALITYPRO
};
var logo = {
  src: __WEBPACK_IMPORTED_MODULE_5__constants_logosFileNames__["a" /* ABOGALITYPRO_LOGO */]
};

var tagLine = 'Openlegal';

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'Abogalitypro',
  component: function component() {
    return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 1286));
  },
  meta: (_meta = {
    tagLine: tagLine,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('abogalitypro.title');
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'tagLine', __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["a" /* ABOGALITYPRO_PLATFORM_NAME */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'layout', layout), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'footer', footer), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'logo', logo), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_meta, 'i18n', 'public/views/abogalitypro'), _meta)
}, {
  path: 'terminos-condiciones-abogados',
  name: 'TermsLawyers',
  component: function component() {
    return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 2398));
  },
  meta: {
    tagLine: tagLine,
    title: {
      text: function text() {
        return 'Términos y condiciones para abogados';
      }
    },
    layout: __WEBPACK_IMPORTED_MODULE_4__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    footer: footer,
    logo: logo
  }
}, {
  path: 'contact/success',
  name: 'ContactFormSuccessAbogalityPRO',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 185));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_4__constants_layouts__["k" /* PUBLIC_MENU_LAYOUT */],
    i18n: 'forms/companies-contact-form.json'
  }
}]);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_themes__ = __webpack_require__(200);
var _this = this;






var layout = __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["j" /* PUBLIC_LAYOUT */];
var footer = {
  component: __WEBPACK_IMPORTED_MODULE_1__components_public_footers_index__["FOOTER_COMPONENT_NAMES"].UNIPROMEL
};

var tagLine = 'Unihealth';

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'Unipromel',
  component: function component() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 2399));
  },
  beforeEnter: function beforeEnter(to, from, next) {
    _this.$helpers.goToProfessionalsLanding();
  },
  meta: {
    tagLine: tagLine,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('unipromel.title');
      }
    },
    layout: layout,
    footer: footer,
    theme: __WEBPACK_IMPORTED_MODULE_3__constants_themes__["b" /* UNIPROMEL_THEME */],
    i18n: 'public/views/unipromel'
  }
}]);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_LoginForm__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_wrapper_mixin__ = __webpack_require__(509);
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseModal__["a" /* default */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_1__components_forms_LoginForm__["default"]
  },
  props: {
    title: String,
    loginCallback: Function,
    returnUrl: String
  },
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_wrapper_mixin__["a" /* default */])(Boolean)],
  data: function data() {
    return {
      signInVisible: false
    };
  }
});

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_inline_svg__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_inline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_inline_svg__);




/* harmony default export */ __webpack_exports__["a"] = ([
/*   {
    path: 'iniciose',
    name: 'Login',
    component: () => import('@/components/views/SignIn.vue'),
    meta: {
      layout: 'PublicReducedLayout',
      title: {
        text: i18n.t('account.login.title')
      },
      i18n: 'public/views/account/login'
    }
  }, */
{
  path: 'peticion-actualizar-contrasena',
  name: 'PasswordUpdateEmail',
  component: function component() {
    return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 2400));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('account.password-update.update-password');
      }
    },
    i18n: 'public/views/account/password-update'
  }
}, {
  path: 'confirmar-cuenta',
  name: 'ConfirmEmail',
  component: function component() {
    return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 2401));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('account.confirm-email');
      }
    },
    i18n: 'public/views/account/password-update'
  }
}, {
  path: 'establecer-email',
  name: 'SetEmail',
  component: function component() {
    return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 2402));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('account.setEmail');
      }
    },
    i18n: 'public/views/account/password-update'
  }
}, {
  path: 'registro-correcto',
  name: 'RegisterPostScreen',
  component: function component() {
    return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 2403));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    i18n: 'public/views/account/password-update',
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('signup.titleok');
      }
    }
  }
}, {
  path: 'kickout',
  name: 'Kickout',
  component: function component() {
    return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 2404));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('kickout.title');
      }
    },
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["m" /* PUBLIC_REDUCED_LAYOUT_DYNAMIC */],
    i18n: 'public/views/account/password-update'
  }
}, {
  path: 'cerrar-sesion',
  name: 'Cerrar sesión',
  component: function component() {
    return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 2405));
  },
  meta: {
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('logOff');
      }
    },
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["m" /* PUBLIC_REDUCED_LAYOUT_DYNAMIC */]
  }
}, {
  path: 'actualizar-contrasena',
  name: 'UpdatePassword',
  component: function component() {
    return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 2406));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('account.password-update.update-password');
      }
    },
    i18n: 'public/views/account/password-update'
  }
}, {
  path: 'reactivar',
  name: 'Reactivate',
  component: function component() {
    return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 2407));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('reenable-account');
      }
    }
  }
}, {
  path: 'actualizar-datos',
  name: 'UpdateData',
  component: function component() {
    return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 2408));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('update-required-data.save');
      }
    },
    i18n: 'public/views/account/update-required-data'
  }
}]);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_ui_SocialSharingPopover__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_date_helpers__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repositories_ForumRepository__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_colours__ = __webpack_require__(42);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forum-article-block',
  components: {
    BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
    SocialSharingPopover: __WEBPACK_IMPORTED_MODULE_4__components_base_ui_SocialSharingPopover__["a" /* default */],
    BPopover: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_42" /* BPopover */],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_6__components_base_BaseDialog__["default"],
    BModal: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_32" /* BModal */],
    BButton: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["d" /* BButton */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_forum_mixin__["a" /* default */]],
  props: {
    resetValue: Boolean,
    disableClick: Boolean,
    showImage: Boolean,
    hideFooter: Boolean,
    showValidateEntry: Boolean,
    showAnswerBtn: Boolean,
    hideForumDescriptionMobile: Boolean,
    showFullWhoInDescription: Boolean
  },
  data: function data() {
    return {
      showConfirmDelete: false,
      entryIdSelected: null,
      GREEN_COLOUR: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["g" /* GREEN_COLOUR */],
      RED_COLOUR: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["k" /* RED_COLOUR */],
      BLACK_COLOUR: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["b" /* BLACK_COLOUR */]
    };
  },
  created: function created() {},

  computed: {
    showMorePostMessages: function showMorePostMessages() {
      return this.$store.state.forum.numEntries > this.$store.state.forum.articleData.length;
    },
    hideForumDescription: function hideForumDescription() {
      return this.hideForumDescriptionMobile && !this.inWhoInSection;
    }
  },
  methods: {
    forumBlockClick: function forumBlockClick(e) {
      if (this.disableClick) {
        return;
      }
      if (!this.$store.getters['session/isLogged']) {
        this.logIn();
        return;
      }
      this.$router.push(this.getPathUrl(e.currentTarget.id));
    },
    loadMoreEntries: function loadMoreEntries() {
      this.$emit('loadMoreEntries');
    },
    shareArticleLink: function shareArticleLink(id) {
      if (!this.disableClick) {
        return location.href + '/' + id;
      } else {
        return location.href;
      }
    },
    articleLike: function articleLike(id) {
      var _this = this;

      if (!this.$store.getters['session/isLogged']) {
        this.logIn();
        return;
      }
      var like = !this.$store.state.forum.userBasicInfo.entriesLike.includes(id);
      this.$api.put('/Forum/UpdateEntryLike', null, { params: { entryId: id, like: like } }).then(function (response) {
        if (response.data) {
          var item = _this.$store.state.forum.articleData.find(function (item) {
            return item.id === id;
          });
          if (like) {
            _this.$store.state.forum.userBasicInfo.entriesLike.push(id);
            item.likes = item.likes > 0 ? ++item.likes : 1;
          } else {
            _this.$store.state.forum.userBasicInfo.entriesLike = _this.$store.state.forum.userBasicInfo.entriesLike.filter(function (item) {
              return item !== id;
            });
            --item.likes;
          }
          _this.updateLastInteractionDate(id);
          _this.$store.dispatch('showSuccessAlert', _this.$t('changesPerformedCorrectly'));
        } else {
          _this.$store.dispatch('showDangerAlert', _this.$t('defaultErrorMessage'));
        }
      });
    },
    saveArticle: function saveArticle(id) {
      var _this2 = this;

      if (!this.$store.getters['session/isLogged']) {
        this.logIn();
        return;
      }
      var save = !this.$store.state.forum.userBasicInfo.entriesSaved.includes(id);
      this.$api.put('/Forum/UpdateSaveEntry', null, { params: { entryId: id, save: save } }).then(function (response) {
        if (response.data) {
          if (save) {
            _this2.$store.state.forum.userBasicInfo.entriesSaved.push(id);
          } else {
            _this2.$store.state.forum.userBasicInfo.entriesSaved = _this2.$store.state.forum.userBasicInfo.entriesSaved.filter(function (item) {
              return item !== id;
            });
          }
          _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
        } else {
          _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
        }
      });
    },
    removeEntry: function removeEntry() {
      var _this3 = this;

      if (!this.$store.getters['session/isLogged']) {
        this.logIn();
        return;
      }
      this.$api.delete('/Forum/RemoveEntry', { params: { entryId: this.entryIdSelected } }).then(function (response) {
        if (response.data) {
          _this3.$store.dispatch('showSuccessAlert', _this3.$t('changesPerformedCorrectly'));
          _this3.loadForumEntries();
        } else {
          _this3.$store.dispatch('showDangerAlert', _this3.$t('defaultErrorMessage'));
        }
      });
    },
    validateEntry: function validateEntry(id, validate) {
      var _this4 = this;

      this.$api.post('/Forum/ValidateEntry', null, { params: { entryId: id, validate: validate } }).then(function (response) {
        if (response.data) {
          _this4.$emit('updateValidatedEntries');
          _this4.$store.dispatch('showSuccessAlert', _this4.$t('changesPerformedCorrectly'));
        } else {
          _this4.$store.dispatch('showDangerAlert', _this4.$t('defaultErrorMessage'));
        }
      });
    },
    showEntryAnswerBlock: function showEntryAnswerBlock() {
      this.$store.state.forum.showMainAnswerBlock = !this.$store.state.forum.showMainAnswerBlock;
    },
    toggleWhoInDescription: function toggleWhoInDescription(data) {
      data.showingFullDetails = !data.showingFullDetails;
      data.description = data.showingFullDetails ? this.getWhoInDescription(data.whoInData) : this.getWhoInDescriptionShort(data.whoInData);
    },
    activityIsFull: function activityIsFull(data) {
      return data.participantsLimit && data.participants.length >= data.participantsLimit;
    },
    getActivityName: function getActivityName(data) {
      return this.getWhoInPropValue(data, 'activity');
    },
    getActivitityPicture: function getActivitityPicture(data) {
      var picture = data.activity.nameEn.toLowerCase().replaceAll(' ', '');
      return '/static-appopensalud/img/healthy-community/who-in/' + picture + '.jpg';
    },
    getWhoInDescriptionShort: function getWhoInDescriptionShort(data) {
      var _this5 = this;

      var whoInDescription = '';
      var keysToShow = ['activityLevel', 'city', 'startDate', 'endDate'];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).filter(function (key) {
        return keysToShow.includes(key);
      }).forEach(function (key) {
        if (data[key]) {
          whoInDescription = whoInDescription.concat('', '<p><b>' + _this5.$t('whoInDataTitles.' + key) + '</b>: ' + _this5.getWhoInPropValue(data, key) + '</p>');
        }
      });
      return whoInDescription;
    },
    getWhoInDescription: function getWhoInDescription(data) {
      var _this6 = this;

      var whoInDescription = '';
      var keysToExclude = ['activity', 'participantsLimit', 'noStartTime', 'noEndTime'];
      var participantsKey = 'participants';
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).filter(function (key) {
        return !keysToExclude.includes(key);
      }).forEach(function (key) {
        if (key === participantsKey) {
          whoInDescription = whoInDescription.concat('', '<p><b>' + _this6.$t('whoInDataTitles.participants') + '</b>: ' + data[key].map(function (item) {
            return item.fullName;
          }).join(', ') + '</p>');
        } else if (data[key]) {
          whoInDescription = whoInDescription.concat('', '<p><b>' + _this6.$t('whoInDataTitles.' + key) + '</b>: ' + _this6.getWhoInPropValue(data, key) + '</p>');
        }
      });
      return whoInDescription;
    },
    getWhoInPropValue: function getWhoInPropValue(data, key) {
      var startDateKey = 'startDate';
      var endDateKey = 'endDate';
      var noStartTimeKey = 'noStartTime';
      var noEndTimeKey = 'noEndTime';
      var value = data[key];

      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        return value[this.normalizeForumProp('name')];
      } else if (!isNaN(new Date(value))) {
        var excludeTime = key === startDateKey && data[noStartTimeKey] || key === endDateKey && data[noEndTimeKey];
        return Object(__WEBPACK_IMPORTED_MODULE_7__helpers_date_helpers__["s" /* longDateFormat */])(value, excludeTime);
      } else {
        return value;
      }
    },
    getWhoInParticipants: function getWhoInParticipants(data) {
      if (data.participantsLimit) {
        return '(' + data.participants.length + '/' + data.participantsLimit + ')';
      } else {
        return '(' + data.participants.length + ')';
      }
    },
    signedUpWhoInActivity: function signedUpWhoInActivity(data) {
      var _this7 = this;

      return data.participants.some(function (p) {
        return p.userId === _this7.$store.state.forum.userBasicInfo.userAspId;
      });
    },
    getSignUpTitle: function getSignUpTitle(data) {
      return '' + (this.signedUpWhoInActivity(data) ? this.$t('noAssistWhoInActivity') : this.$t('signUpWhoIn'));
    },
    updateEntry: function updateEntry(data) {
      if (this.inWhoInSection) {
        this.$store.state.forum.editingEntry = true;
        this.createNewPost(this.$store.state.forum.articleData.find(function (item) {
          return item.id === data.id;
        }));
      } else {
        this.$store.state.forum.wysiwygEntryAnswer = data.description;
        this.$store.state.forum.editingEntry = true;
        this.showEntryAnswerBlock();
        this.$root.$emit('bv::hide::popover');
        this.$router.push(this.getPathUrl(data.id));
      }
    },
    toggleSignUpWhoIn: function toggleSignUpWhoIn(item) {
      var _this8 = this;

      var entryId = item.id;
      var value = !this.signedUpWhoInActivity(item.whoInData);
      if (value && item.whoInData.participantsLimit && item.whoInData.participants.length >= item.whoInData.participantsLimit) {
        this.$store.dispatch('showInfoAlert', this.$t('participantsLimitsReached'));
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__repositories_ForumRepository__["a" /* default */].updateWhoInParticipant({ entryId: entryId, value: value }).then(function (response) {
        if (response) {
          var entry = _this8.$store.state.forum.articleData.find(function (item) {
            return item.id === entryId;
          });
          if (value) {
            entry.whoInData.participants.push(response.data);
          } else {
            entry.whoInData.participants = entry.whoInData.participants.filter(function (p) {
              return p.userId !== _this8.$store.state.forum.userBasicInfo.userAspId;
            });
          }
        } else {
          _this8.$store.dispatch('showDangerAlert', _this8.$t('defaultErrorMessage'));
        }
      });
    }
  }
});

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialSharingPopover_vue__ = __webpack_require__(1102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655d6103_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialSharingPopover_vue__ = __webpack_require__(1726);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1723)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialSharingPopover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655d6103_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialSharingPopover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/ui/SocialSharingPopover.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-655d6103", Component.options)
  } else {
    hotAPI.reload("data-v-655d6103", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_social_sharing__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_social_sharing__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'socialSharingPopover',
    components: {
        BPopover: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_42" /* BPopover */],
        ShareNetwork: __WEBPACK_IMPORTED_MODULE_1_vue_social_sharing__["ShareNetwork"]
    },
    props: {
        sectionName: String,
        socialNetworks: {
            type: Object,
            default: function _default() {
                return {
                    sharing: {
                        url: '',
                        title: this.$t('sharingSocialsTitle', [this.sectionName]),
                        description: this.$t('sharingSocialsDescription'),
                        quote: '',
                        hashtags: 'opensalud',
                        twitterUser: ''
                    },
                    networks: [{ network: 'email', name: 'Email', icon: 'envelope', color: '#333333' }, { network: 'twitter', name: 'Twitter', icon: 'twitter', color: '#1da1f2' }, { network: 'facebook', name: 'Facebook', icon: 'facebook', color: '#1877f2' }, { network: 'whatsapp', name: 'Whatsapp', icon: 'whatsapp', color: '#25d366' }, { network: 'linkedin', name: 'LinkedIn', icon: 'linkedin', color: '#007bb5' }, { network: 'telegram', name: 'Telegram', icon: 'telegram', color: '#0088cc' }]
                };
            }
        },
        url: String,
        targetId: String
    },
    data: function data() {
        return {};
    },
    created: function created() {
        var _this = this;

        document.getElementsByTagName('body')[0].addEventListener('click', function (e) {
            _this.$root.$emit('bv::hide::popover');
        });
    },

    methods: {
        copyLinkClipboard: function copyLinkClipboard(url) {
            navigator.clipboard.writeText(url);
            this.$store.dispatch('showSuccessAlert', this.$t('linkCopiedClipboard'));
        }
    }
});

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_forms_BaseInput__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ForumArticleBlock__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ForumMessageBlock__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_forum_mixin__ = __webpack_require__(157);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forum-control-panel',
  components: {
    BNav: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_33" /* BNav */],
    BNavbar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_39" /* BNavbarNav */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_35" /* BNavItem */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_40" /* BNavbarToggle */],
    BFormCheckbox: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["n" /* BFormCheckbox */],
    BaseInput: __WEBPACK_IMPORTED_MODULE_1__components_base_forms_BaseInput__["default"],
    BaseButton: __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton__["default"],
    ForumArticleBlock: __WEBPACK_IMPORTED_MODULE_3__ForumArticleBlock__["default"],
    ForumMessageBlock: __WEBPACK_IMPORTED_MODULE_4__ForumMessageBlock__["default"],
    BCollapse: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["j" /* BCollapse */],
    BSidebar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_46" /* BSidebar */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */],
    IconsPlugin: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_54" /* IconsPlugin */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_forum_mixin__["a" /* default */]],
  data: function data() {
    var _this = this;

    return {
      section: 'perfil',
      showSaveBtn: false,
      sectionTitle: null,
      favouritesSectionSelected: 'entries',
      validationsSectionSelected: 'messages',
      noEntriesSaved: false,
      noMessagesSaved: false,
      noMessagesPendingValidation: false,
      noMessagesReported: false,
      noEntriesPendingValidation: false,
      showSideBarAdmin: false,
      tags: [],
      tagsSource: [],
      tagsSourceFull: [],
      categories: [],
      categoriesSource: [],
      categoriesSourceFull: [],
      emailsDaysIntervalSource: [{ name: this.$t('eachDay'), days: 1 }, { name: this.$t('eachWeek'), days: 7 }, { name: this.$t('eachMonth'), days: 30 }],
      emailsDaysInterval: null,
      showTagsSelector: false,
      showCategoriesSelector: false,
      sectionInputs: {
        perfil: [{ id: this.randomString('fullName_'), label: this.$t('name'), value: null, placeholder: this.$t('name'), type: 'text', readonly: true, tooltip: this.$t('infoName') }, { id: this.randomString('nick_'), label: this.$t('userAlias'), value: null, placeholder: this.$t('userAlias'), type: 'text', readonly: false, tooltip: this.$t('infoNick') }, { id: this.randomString('email_'), label: this.$t('notificationsEmail'), value: null, placeholder: this.$t('notificationsEmail'), type: 'text', readonly: false, tooltip: this.$t('infoEmail') }],
        notificaciones: [{ id: this.randomString('receiveEmails_'), label: this.$t('receiveEmails'), value: null }, { id: this.randomString('emailsDaysInterval_'), customName: 'emailsDaysInterval' }, { id: this.randomString('messagesReply_'), label: this.$t('messagesReply'), value: null }, { id: this.randomString('newEntries_'), label: this.$t('newEntries'), value: null }, { id: this.randomString('favouritesEntries_'), label: this.$t('answersOfFavouritesEntries'), value: null }, { id: this.randomString('favouritesMessages_'), label: this.$t('answersOfFavouritesMessages'), value: null }, { id: this.randomString('categories_'), label: this.$t('categories'), value: null, isList: true, fn: function fn() {
            _this.showCategoriesSelector = !_this.showCategoriesSelector;if (_this.showCategoriesSelector) {
              _this.getCategories();
            }
          } }, { id: this.randomString('tags_'), label: this.$t('tags'), value: null, isList: true, fn: function fn() {
            _this.showTagsSelector = !_this.showTagsSelector;if (_this.showTagsSelector) {
              _this.getTags();
            }
          } }]
      }
    };
  },
  created: function created() {
    if (!this.$store.getters['session/isLogged']) {
      this.logIn();
      return;
    }
    /* if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
    } */
    this.$store.state.forum.hideSearcher = false;
    this.$store.state.forum.hideOutsideSearchBar = true;
    this.$store.state.forum.messages = [];
    var section = this.$route.params.section || 'perfil';
    this.showSection(section);
  },

  methods: {
    getSectionData: function getSectionData() {
      var _this2 = this;

      this.$api.get('/Forum/Panel/' + this.section).then(function (response) {
        var data = response.data[_this2.section];
        if (data) {
          var _loop = function _loop(key) {
            var item = _this2.sectionInputs[_this2.section].find(function (item) {
              return item.id.includes(key + '_');
            });
            if (item && item.isList) {
              item.value = data[key] && data[key].length > 0;
              var selectorName = key.charAt(0).toUpperCase() + key.slice(1);
              _this2['show' + selectorName + 'Selector'] = item.value;
              if (item.value) {
                _this2['get' + selectorName]();
              }
              _this2[key] = data[key];
            } else if (item) {
              if (item.customName) {
                _this2[item.customName] = data[key];
              } else {
                item.value = data[key];
              }
            }
          };

          for (var key in data) {
            _loop(key);
          }
        } else {
          _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
        }
      });
    },
    showFavouritesSection: function showFavouritesSection(section) {
      this.favouritesSectionSelected = section;
      this['loadFavourites' + (section.charAt(0).toUpperCase() + section.slice(1))]();
    },
    showValidationsSection: function showValidationsSection(section) {
      this.validationsSectionSelected = section;
      this['loadValidations' + (section.charAt(0).toUpperCase() + section.slice(1))]();
    },
    loadFavouritesEntries: function loadFavouritesEntries() {
      var _this3 = this;

      this.$api.get('/Forum/GetFavouritesEntries').then(function (response) {
        if (response.data && response.data.entryData.length > 0) {
          _this3.noEntriesSaved = false;
        } else {
          _this3.noEntriesSaved = true;
        }
        _this3.$store.state.forum.articleData = response.data.entryData;
      });
    },
    loadFavouritesMessages: function loadFavouritesMessages() {
      var _this4 = this;

      this.$api.get('/Forum/GetFavouritesMessages').then(function (response) {
        if (response.data && response.data.entryMessageData.length > 0) {
          _this4.noMessagesSaved = false;
        } else {
          _this4.noMessagesSaved = true;
        }
        _this4.$store.state.forum.messages = response.data.entryMessageData;
      });
    },
    loadValidationsMessages: function loadValidationsMessages() {
      var _this5 = this;

      this.$api.get('/Forum/GetMessagesPendingValidation').then(function (response) {
        if (response.data && response.data.entryMessageData.length > 0) {
          _this5.noMessagesPendingValidation = false;
        } else {
          _this5.noMessagesPendingValidation = true;
        }
        _this5.$store.state.forum.messages = response.data.entryMessageData;
      });
    },
    loadReportedMessages: function loadReportedMessages() {
      var _this6 = this;

      this.$api.get('/Forum/GetReportedMessages').then(function (response) {
        if (response.data && response.data.entryMessageData.length > 0) {
          _this6.noMessagesReported = false;
        } else {
          _this6.noMessagesReported = true;
        }
        _this6.$store.state.forum.messages = response.data.entryMessageData;
      });
    },
    loadValidationsEntries: function loadValidationsEntries() {
      var _this7 = this;

      this.$api.get('/Forum/GetEntriesPendingValidation').then(function (response) {
        if (response.data && response.data.entryData.length > 0) {
          _this7.noEntriesPendingValidation = false;
        } else {
          _this7.noEntriesPendingValidation = true;
        }
        _this7.$store.state.forum.articleData = response.data.entryData;
      });
    },
    sendData: function sendData() {
      var _this8 = this;

      var data = {};
      if (this.section === 'perfil') {
        data.nick = this.sectionInputs.perfil.find(function (item) {
          return item.id.includes('nick');
        }).value;
        data.email = this.sectionInputs.perfil.find(function (item) {
          return item.id.includes('email');
        }).value;
        if (!data.nick || !data.email) {
          this.$store.dispatch('showDangerAlert', this.$t('fieldEmpty'));
          return;
        }
      } else if (this.section === 'notificaciones') {
        if (this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('receiveEmails');
        }).value && !this.emailsDaysInterval) {
          this.$store.dispatch('showDangerAlert', this.$t('mustSelectEmailsInterval'));
          return;
        }
        if (this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('categories');
        }).value && this.categories.length === 0) {
          this.$store.dispatch('showDangerAlert', this.$t('mustSelectCategory'));
          return;
        }
        if (this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('tags');
        }).value && this.tags.length === 0) {
          this.$store.dispatch('showDangerAlert', this.$t('mustSelectTags'));
          return;
        }
        data.receiveEmails = this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('receiveEmails');
        }).value;
        data.emailsDaysInterval = data.receiveEmails ? this[this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('emailsDaysInterval');
        }).customName] : null;
        data.messagesReply = this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('messagesReply');
        }).value;
        data.newEntries = this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('newEntries');
        }).value;
        data.favouritesEntries = this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('favouritesEntries');
        }).value;
        data.favouritesMessages = this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('favouritesMessages');
        }).value;
        data.categories = this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('categories');
        }).value ? this.categories : [];
        data.tags = this.sectionInputs.notificaciones.find(function (item) {
          return item.id.includes('tags');
        }).value ? this.tags : [];
      }
      this.$api.post('/Forum/Panel/' + this.section, data).then(function (response) {
        if (response.data) {
          _this8.$store.dispatch('showSuccessAlert', _this8.$t('changesPerformedCorrectly'));
          _this8.showSaveBtn = false;
          if (data.nick) {
            _this8.$store.state.forum.userBasicInfo.nick = data.nick;
          }
        } else {
          _this8.$store.dispatch('showDangerAlert', _this8.$t('defaultErrorMessage'));
        }
      });
    },
    goBack: function goBack() {
      this.$router.push(this.getPathUrl());
    },
    showSection: function showSection(section) {
      this.showSideBarAdmin = false;
      this.section = section;
      this.$store.state.forum.messages = [];
      switch (section) {
        case 'perfil':
        case 'notificaciones':
          this.getSectionData();
          break;
        case 'favoritos':
          this.showFavouritesSection('entries');
          break;
        case 'validaciones':
          this.loadValidationsMessages();
          break;
        case 'reportes':
          this.loadReportedMessages();
          break;
        default:
          this.getSectionData();
      }
      this.getSectionTitle();
    },
    getSectionTitle: function getSectionTitle() {
      switch (this.section) {
        case 'perfil':
          this.sectionTitle = this.$t('myProfile');
          break;
        case 'favoritos':
          this.sectionTitle = this.$t('saveds');
          break;
        case 'notificaciones':
          this.sectionTitle = this.$t('myNotifications');
          break;
        case 'validaciones':
          this.sectionTitle = this.$t('validations');
          break;
        case 'reportes':
          this.sectionTitle = this.$t('reports');
          break;
      }
    },
    randomString: function randomString(prefix) {
      return Math.random().toString(36).replace('0.', prefix || '');
    },
    getTags: function getTags(search, loading) {
      var _this9 = this;

      if (search) {
        loading(true);
        this.tagsSource = this.tagsSourceFull.filter(function (item) {
          return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
        });
        loading(false);
      } else if (this.tagsSourceFull.length === 0) {
        this.$api.get('Forum/SearchEntryTag').then(function (response) {
          _this9.tagsSourceFull = response.data;
          _this9.tagsSource = response.data;
        });
      }
    },
    getCategories: function getCategories(search, loading) {
      var _this10 = this;

      if (search) {
        loading(true);
        this.categoriesSource = this.categoriesSourceFull.filter(function (item) {
          return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
        });
        loading(false);
      } else if (this.categoriesSourceFull.length === 0) {
        this.$api.get('Forum/SearchEntryCategory').then(function (response) {
          _this10.categoriesSourceFull = response.data;
          _this10.categoriesSource = response.data;
        });
      }
    },
    notificationsSwitch: function notificationsSwitch(fn) {
      if (fn) {
        fn();
      }
      this.showSaveBtn = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.state.forum.hideOutsideSearchBar = false;
  }
});

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_ui_SocialSharingPopover__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_BaseModal__ = __webpack_require__(58);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forum-message-block',
  components: {
    'base-button': function baseButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 124)).then(function (m) {
        return m.default;
      });
    },
    VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* VueEditor */],
    SocialSharingPopover: __WEBPACK_IMPORTED_MODULE_4__components_base_ui_SocialSharingPopover__["a" /* default */],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__["default"],
    BPopover: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_42" /* BPopover */],
    BaseModal: __WEBPACK_IMPORTED_MODULE_6__components_base_BaseModal__["a" /* default */],
    BFormTextarea: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["A" /* BFormTextarea */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_forum_mixin__["a" /* default */]],
  props: {
    entryReferenceId: String,
    numPrincipalReplies: Number,
    hideOptions: Boolean,
    showValidateMessage: Boolean,
    showReportMessage: Boolean
  },
  data: function data() {
    return {
      messageIdSelected: null,
      editingMessage: false,
      wysiwygInput: null,
      showConfirmDelete: false,
      showReportModal: false,
      messageIdToRemove: null,
      messageIdToReport: null,
      reportReasons: null
    };
  },
  created: function created() {},

  computed: {
    showMorePrincipalMessages: function showMorePrincipalMessages() {
      return this.numPrincipalReplies > this.$store.state.forum.messages.filter(function (item) {
        return item.messageReferenceId == null;
      }).length;
    }
  },
  methods: {
    answerMessage: function answerMessage(id) {
      this.wysiwygInput = null;
      this.messageIdSelected = id;
    },
    resetReportModal: function resetReportModal() {
      this.reportReasons = null;
      this.showReportModal = false;
    },
    saveMessage: function saveMessage(id) {
      var _this = this;

      var save = !this.$store.state.forum.userBasicInfo.messagesSaved.includes(id);
      this.$api.put('/Forum/UpdateSaveMessage', null, { params: { messageId: id, save: save } }).then(function (response) {
        if (response.data) {
          if (save) {
            _this.$store.state.forum.userBasicInfo.messagesSaved.push(id);
          } else {
            _this.$store.state.forum.userBasicInfo.messagesSaved = _this.$store.state.forum.userBasicInfo.messagesSaved.filter(function (item) {
              return item !== id;
            });
          }
          _this.$store.dispatch('showSuccessAlert', _this.$t('changesPerformedCorrectly'));
        } else {
          _this.$store.dispatch('showDangerAlert', _this.$t('defaultErrorMessage'));
        }
      });
    },
    sendReport: function sendReport() {
      var _this2 = this;

      this.reportReasons = this.reportReasons ? this.reportReasons.trim() : this.reportReasons;
      if (!this.reportReasons || this.reportReasons.length === 0) {
        this.$store.dispatch('showDangerAlert', this.$t('mustIntroduceReportReasons'));
        return;
      }
      this.$api.post('/Forum/ReportMessage', { messageId: this.messageIdToReport, reportReasons: this.reportReasons }).then(function (response) {
        if (response.data) {
          _this2.$store.dispatch('showSuccessAlert', _this2.$t('reportmessageSendConfirmation'));
          _this2.showReportModal = false;
        } else {
          _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
        }
      });
    },
    shareMessageLink: function shareMessageLink() {
      return window.location.href;
    },
    sendMessage: function sendMessage() {
      var _this3 = this;

      if (!this.wysiwygInput) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyMessageError'));
        return;
      }
      if (this.editingMessage) {
        this.$api.put('/Forum/EditEntryMessage', null, { params: { message: this.wysiwygInput, messageReferenceId: this.messageIdSelected } }).then(function (response) {
          if (response.data) {
            _this3.messageIdSelected = null;
            _this3.wysiwygInput = null;
            _this3.editingMessage = false;
            _this3.$store.dispatch('showSuccessAlert', _this3.$t('changesPerformedCorrectly'));
            _this3.getForumMessages(_this3.entryReferenceId);
            _this3.updateLastInteractionDate(_this3.entryReferenceId);
          } else {
            _this3.$store.dispatch('showDangerAlert', _this3.$t('defaultErrorMessage'));
          }
        });
      } else {
        this.$api.post('/Forum/SendEntryMessage', { entryReferenceId: this.entryReferenceId, message: this.wysiwygInput, messageReferenceId: this.messageIdSelected }).then(function (response) {
          if (response.data) {
            _this3.messageIdSelected = null;
            _this3.wysiwygInput = null;
            if (_this3.$store.getters['forum/forumMessageWithoutValidation']) {
              _this3.$store.dispatch('showSuccessAlert', _this3.$t('messagePublishedSuccessfully'));
              _this3.getForumMessages(_this3.entryReferenceId);
              _this3.updateLastInteractionDate(_this3.entryReferenceId);
            } else {
              _this3.$store.dispatch('showSuccessAlert', _this3.$t('messagePendingValidation'));
            }
          } else {
            _this3.$store.dispatch('showDangerAlert', _this3.$t('defaultErrorMessage'));
          }
        });
      }
    },
    showMoreMessages: function showMoreMessages(id) {
      var _this4 = this;

      var searchItem = this.$store.state.forum.showLessIds.find(function (item) {
        return item === id;
      });
      if (searchItem) {
        this.$store.state.forum.showMoreIds.push(id);
        this.toggleShowItems(id, false);
      } else {
        this.$api.get('/Forum/GetEntryMessage', { params: { entryId: this.entryReferenceId, messageReferenceId: id } }).then(function (response) {
          if (response.data && response.data.entryMessageData) {
            var _$store$state$forum$m;

            var actualItem = _this4.$store.state.forum.messages.find(function (item) {
              return item.id === id;
            });
            _this4.$store.state.forum.showMoreIds.push(id);
            var newTier = actualItem.messageTier ? actualItem.messageTier + 1 : 1;
            response.data.entryMessageData.forEach(function (item) {
              item.messageTier = newTier;
            });
            var index = _this4.$store.state.forum.messages.findIndex(function (item) {
              return item.id === id;
            });
            (_$store$state$forum$m = _this4.$store.state.forum.messages).splice.apply(_$store$state$forum$m, [index + 1, 0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data.entryMessageData)));
          } else {
            _this4.$store.dispatch('showDangerAlert', _this4.$t('defaultErrorMessage'));
          }
        });
      }
    },
    showLessMessages: function showLessMessages(id) {
      // let newValues = this.$store.state.forum.showMoreIds.filter(function (item) {
      //   return item !== id
      // })
      // this.$store.state.forum.showLessIds.push(id)
      this.showLessItemByTier(id);
      // this.$store.state.forum.showMoreIds = newValues
    },
    toggleShowItems: function toggleShowItems(id, hide) {
      var index = this.$store.state.forum.messages.findIndex(function (i) {
        return i.id === id;
      });
      for (var i = index + 1; i < this.$store.state.forum.messages.length; i++) {
        var item = this.$store.state.forum.messages[i];
        if (item.messageReferenceId === id) {
          item.hide = hide;
          this.$set(this.$store.state.forum.messages, i, item);
        } else if (!item.hide) {
          break;
        }
      }
    },
    showLessItemByTier: function showLessItemByTier(id) {
      var index = this.$store.state.forum.messages.findIndex(function (i) {
        return i.id === id;
      });
      var itemsToRemove = [];
      var rootTier = this.$store.state.forum.messages[index].messageTier ? this.$store.state.forum.messages[index].messageTier : 0;
      for (var i = index + 1; i < this.$store.state.forum.messages.length; i++) {
        var item = this.$store.state.forum.messages[i];
        if (item.messageTier > rootTier) {
          if (itemsToRemove.indexOf(item.messageReferenceId) === -1) {
            this.$store.state.forum.showLessIds.push(item.messageReferenceId);
            itemsToRemove.push(item.messageReferenceId);
          }
          item.hide = true;
          this.$set(this.$store.state.forum.messages, i, item);
        } else {
          break;
        }
      }
      this.$store.state.forum.showMoreIds = this.$store.state.forum.showMoreIds.filter(function (item) {
        return !itemsToRemove.includes(item);
      });
    },
    messageLike: function messageLike(id) {
      var _this5 = this;

      if (!this.$store.getters['session/isLogged']) {
        this.logIn();
        return;
      }
      var like = !this.$store.state.forum.userBasicInfo.messagesLike.includes(id);
      this.$api.put('/Forum/UpdateMessageLike', null, { params: { messageId: id, like: like } }).then(function (response) {
        if (response.data) {
          var item = _this5.$store.state.forum.messages.find(function (item) {
            return item.id === id;
          });
          if (like) {
            _this5.$store.state.forum.userBasicInfo.messagesLike.push(id);
            item.likes = item.likes > 0 ? ++item.likes : 1;
          } else {
            _this5.$store.state.forum.userBasicInfo.messagesLike = _this5.$store.state.forum.userBasicInfo.messagesLike.filter(function (item) {
              return item !== id;
            });
            --item.likes;
          }
          _this5.updateLastInteractionDate(_this5.entryReferenceId);
          _this5.$store.dispatch('showSuccessAlert', _this5.$t('changesPerformedCorrectly'));
        } else {
          _this5.$store.dispatch('showDangerAlert', _this5.$t('defaultErrorMessage'));
        }
      });
    },
    loadMorePrincipalMessages: function loadMorePrincipalMessages() {
      var _this6 = this;

      var findPageNumber = this.$store.state.forum.messagesPageNumber.find(function (item) {
        return item.id === _this6.entryReferenceId;
      });
      if (!findPageNumber) {
        this.$store.state.forum.messagesPageNumber.push({ id: this.entryReferenceId, pageNumber: 1 });
      } else {
        findPageNumber.pageNumber += this.$store.state.forum.messagesPerPage;
      }
      this.getForumMessages(this.entryReferenceId, findPageNumber ? findPageNumber.pageNumber : 1);
    },
    removeMessage: function removeMessage() {
      var _this7 = this;

      if (!this.$store.getters['session/isLogged']) {
        this.logIn();
        return;
      }
      this.$api.delete('/Forum/RemoveMessage', { params: { messageId: this.messageIdToRemove } }).then(function (response) {
        if (response.data) {
          _this7.$store.dispatch('showSuccessAlert', _this7.$t('changesPerformedCorrectly'));
          _this7.getForumMessages(_this7.entryReferenceId);
        } else {
          _this7.$store.dispatch('showDangerAlert', _this7.$t('defaultErrorMessage'));
        }
      });
    },
    validateMessage: function validateMessage(id, validate) {
      var _this8 = this;

      this.$api.post('/Forum/ValidateEntryMessage', null, { params: { messageId: id, validate: validate } }).then(function (response) {
        if (response.data) {
          _this8.$emit('updateValidatedMessages');
          _this8.$store.dispatch('showSuccessAlert', _this8.$t('changesPerformedCorrectly'));
        } else {
          _this8.$store.dispatch('showDangerAlert', _this8.$t('defaultErrorMessage'));
        }
      });
    },
    validateReportedMessageAction: function validateReportedMessageAction(id, validate) {
      var _this9 = this;

      this.$api.post('/Forum/ValidateReportedMessage', null, { params: { messageId: id, validate: validate } }).then(function (response) {
        if (response.data) {
          _this9.$emit('updateReportedMessages');
          _this9.$store.dispatch('showSuccessAlert', _this9.$t('changesPerformedCorrectly'));
        } else {
          _this9.$store.dispatch('showDangerAlert', _this9.$t('defaultErrorMessage'));
        }
      });
    },
    goBack: function goBack() {
      this.wysiwygInput = null;
      this.messageIdSelected = null;
      this.editingMessage = false;
    }
  }
});

/***/ }),
/* 1105 */,
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_layouts__ = __webpack_require__(50);



function scrollTop(to, from, next) {
    window.scrollTo(0, 0);
    next();
}

/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'comunidadsaludable',
    path: '/',
    component: function component() {
        return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 540));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyCommunityTitle');
            }
        },
        i18n: 'public/views/healthy-community'
    },
    beforeEnter: scrollTop
}, {
    name: 'new-entry',
    path: 'new',
    component: function component() {
        return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 2409));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyCommunityTitle');
            }
        },
        i18n: 'public/views/healthy-community'
    },
    beforeEnter: scrollTop
}, {
    name: 'comunidadsaludable-entry',
    path: 'comunidadsaludable-entry/:entryId?',
    component: function component() {
        return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 540));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyCommunityTitle');
            }
        },
        i18n: 'public/views/healthy-community'
        // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
    }
}, {
    name: 'foro-healthycommunity',
    path: ':forumSection',
    component: function component() {
        return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 544));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyCommunityTitle');
            }
        },
        i18n: 'public/views/healthy-community'
    },
    beforeEnter: scrollTop
}, {
    name: 'panel-administracion-healthycommunity',
    path: ':forumSection?/panel/:section?',
    component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 448));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyCommunityTitle');
            }
        },
        i18n: 'public/views/healthy-community'
        // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
    },
    beforeEnter: scrollTop
}, {
    name: 'hilo-foro-healthyCommunity',
    path: ':forumSection/:id',
    component: function component() {
        return __webpack_require__.e/* import() */(26/* duplicate */).then(__webpack_require__.bind(null, 1289));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyCommunityTitle');
            }
        },
        i18n: 'public/views/healthy-community'
        // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
    },
    beforeEnter: scrollTop
}]);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_layouts__ = __webpack_require__(50);



function scrollTop(to, from, next) {
    window.scrollTo(0, 0);
    next();
}

/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'healthyHabits',
    path: '/',
    component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 301));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["c" /* HEALTHY_HABITS_LAYOUT */],
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyHabitsTitle');
            }
        },
        i18n: 'public/views/healthy-habits'
    },
    beforeEnter: scrollTop
}, {
    name: 'healthyHabitsFaqs',
    path: 'healthyHabitsFaqs',
    component: function component() {
        return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 2410));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["c" /* HEALTHY_HABITS_LAYOUT */],
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('faqs-title');
            }
        },
        i18n: 'public/views/healthy-habits'
    },
    beforeEnter: scrollTop
}, {
    name: 'healthyHabitsCreate',
    path: 'create/:historyVarName/:healthyHabitName/:healthyHabitFrequencyId/:healthyHabitMeasureUnit/:historyPatientId?',
    component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 301));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["c" /* HEALTHY_HABITS_LAYOUT */],
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyHabitsTitle');
            }
        },
        i18n: 'public/views/healthy-habits'
    },
    beforeEnter: scrollTop
}, {
    name: 'healthyHabitsCreateByType',
    path: 'createByType/:historyGroupId/:healthyHabitName/:healthyHabitFrequencyId/:healthyHabitMeasureUnit/:historyPatientId?',
    component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 301));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["c" /* HEALTHY_HABITS_LAYOUT */],
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyHabitsTitle');
            }
        },
        i18n: 'public/views/healthy-habits'
    },
    beforeEnter: scrollTop
}, {
    name: 'healthyHabitsShow',
    path: 'show/:healthyHabitPreselectedId/:historyPatientId?',
    component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 301));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["c" /* HEALTHY_HABITS_LAYOUT */],
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyHabitsTitle');
            }
        },
        i18n: 'public/views/healthy-habits'
    },
    beforeEnter: scrollTop
}, {
    name: 'healthyHabitsStatistics',
    path: ':id',
    component: function component() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 2411));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["c" /* HEALTHY_HABITS_LAYOUT */],
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthyHabitsTitle');
            }
        },
        i18n: 'public/views/healthy-habits'
    },
    beforeEnter: scrollTop
}]);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_logosFileNames__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: '360',
  component: function component() {
    return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 2412));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_3__constants_layouts__["d" /* OPENSALUD_360_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('title-big-1');
      }
    },
    tagLine: Object(__WEBPACK_IMPORTED_MODULE_1__constants_platformNames__["h" /* getPlatformName */])(),
    logo: {
      src: __WEBPACK_IMPORTED_MODULE_4__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_2__constants_logosFileNames__["f" /* OPENSALUD360_MX_LOGO */] : __WEBPACK_IMPORTED_MODULE_2__constants_logosFileNames__["e" /* OPENSALUD360_LOGO */],
      classes: 'bigger-navbar-brand-img'
    },
    i18n: 'public/views/360.json'
  }
}, {
  path: 'homeempresas/index',
  redirect: '/'
}]);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLayout_vue__ = __webpack_require__(1110);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf8a0d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLayout_vue__ = __webpack_require__(1737);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1735)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf8a0d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/video-launcher/VideoLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fbf8a0d0", Component.options)
  } else {
    hotAPI.reload("data-v-fbf8a0d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseAlert_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//

/* import routeHelpers from '@/router/routeHelpers' */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoLayout',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__["a" /* default */]],
  components: {
    BaseAlert: __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseAlert_vue__["a" /* default */]
  },
  data: function data() {
    return {
      locale: 'es',
      sidebar: {
        show: false,
        video: false,
        audio: false
      }
    };
  },

  watch: {
    // locale (val) {
    //   this.$i18n.locale = val
    // }
  },
  methods: {
    setLocale: function setLocale(listlocale) {
      // this.locale = listlocale
      this.$i18n.locale = listlocale;
    },
    showVideo: function showVideo() {
      this.sidebar.video = true;
      document.getElementById('rightMenu').style.display = 'block';
    },
    hideVideo: function hideVideo() {
      this.sidebar.video = false;
    },
    setVideoQualityHigh: function setVideoQualityHigh() {
      this.$store.commit('setVideoQuality', 1);
    },
    setVideoQualityMedium: function setVideoQualityMedium() {
      this.$store.commit('setVideoQuality', 2);
    },
    setVideoQualityLow: function setVideoQualityLow() {
      this.$store.commit('setVideoQuality', 3);
    },
    muteVideo: function muteVideo() {
      this.$store.commit('disableVideo');
    },
    shareScreen: function shareScreen() {
      this.$store.commit('toggleShareScreen');
    }
  },
  created: function created() {
    /* setTimeout(() => {
      const chatbotIframe = document.getElementById('chat-application')
      if (chatbotIframe) {
        chatbotIframe.style.display = 'none'
      }
    document.querySelector('#smartsupp-widget-container > div').style.display = 'none'
    }, 2000) */
  }
});

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLayout_vue__ = __webpack_require__(1112);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2b435e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLayout_vue__ = __webpack_require__(1748);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1738)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2b435e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/BaseLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b2b435e", Component.options)
  } else {
    hotAPI.reload("data-v-4b2b435e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_footers_Footer_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_CookiesBanner_vue__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_themes__ = __webpack_require__(200);
//
//
//
//
//
//
//
//
//
//





/* import AddToHomeScreenModal from '@/components/utils/AddToHomeScreenModal.vue' */

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BaseDialog: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__["default"],
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_public_footers_Footer_vue__["default"],
    CookiesBanner: __WEBPACK_IMPORTED_MODULE_2__components_shared_CookiesBanner_vue__["a" /* default */]
    /* AddToHomeScreenModal */
  },
  data: function data() {
    return {};
  },

  computed: {
    sharedDialogVisible: {
      get: function get() {
        return this.$store.state.sharedDialog.visible;
      },
      set: function set(value) {
        this.$store.commit('setSharedDialogVisible', value);
      }
    },
    layoutType: function layoutType() {
      return this.$route.meta.layout || 'PublicLayout';
    },
    themeName: function themeName() {
      return this.$route.meta.theme || (typeof THEME_NAMES !== 'undefined' ? Object(__WEBPACK_IMPORTED_MODULE_3__constants_themes__["c" /* getThemeName */])() : 'opensalud');
    },
    themeClass: function themeClass() {
      return this.themeName + '-theme';
    }
  }
});

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_footers_index_js__ = __webpack_require__(91);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',
  computed: {
    footerComponent: function footerComponent() {
      var _ref = this.$route.meta.footer || { component: __WEBPACK_IMPORTED_MODULE_0__components_public_footers_index_js__["footerHelpers"].getFooterComponentName(), disabled: false },
          component = _ref.component,
          disabled = _ref.disabled;

      return disabled ? null : function () {
        return component ? __webpack_require__(1742)("./" + component) : null;
      };
    }
  }
});

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_cookies__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cookies_helpers__ = __webpack_require__(182);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var messages = {
    es: {
        'cookies-banner': {
            'banner-text': 'Usamos cookies propias y de terceros para mejorar nuestros servicios.<br>Si continúa navegando en esta página, consideramos que acepta su uso en los términos indicados en nuestra',
            'cookies-policy': 'Política de Cookies',
            'got-it': 'Aceptar todas',
            'only-necessary': 'Solo necesarias',
            'accept-btn': 'Aceptar'
        },
        'cookies-modal': {
            'cookies-title': '<div class=\'type-intro-title\'>Política de cookies</div><br/>',
            'cookies-1': '<h4>1. INFORMACIÓN SOBRE COOKIES</h4><br>',
            'cookies-1txt': '<p>Debido a la entrada en vigor de la referente modificación de la “Ley de Servicios de la Sociedad de la Información” (LSSICE) establecida por el Real Decreto 13/2012, es de obligación obtener el consentimiento expreso del usuario de todas las páginas web que usan cookies prescindibles, antes de que éste navegue por ellas.</p><br>',
            'cookies-2': '<h4>2. ¿QUÉ SON LAS COOKIES?</h4><br>',
            'cookies-2txt': '<p>Las cookies y otras tecnologías similares tales como local “shared objects”, “flash cookies” o píxeles, son herramientas empleadas por los servidores Web para almacenar y recuperar información acerca de sus visitantes, así como para ofrecer un correcto funcionamiento del sitio.</p><br><p>Mediante el uso de estos dispositivos se permite al servidor Web recordar algunos datos concernientes al usuario, como sus preferencias para la visualización de las páginas de ese servidor, nombre y contraseña, productos que más le interesan, etc.</p><br>',
            'cookies-3': '<h4>3. COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS</h4><br>',
            'cookies-3txt': '<p>Según la directiva de la UE, las cookies que requieren el consentimiento informado por parte del usuario son las cookies de analítica y las de publicidad y afiliación, quedando exceptuadas las de carácter técnico y las necesarias para el funcionamiento del sitio web o la prestación de servicios expresamente solicitados por el usuario.</p><br>',
            'cookies-4': '<h4>4. ¿QUÉ TIPOS DE COOKIES EXISTEN?</h4><br>',
            'cookies-4txt': '<p>Sobre los tipos de cookies, existen cinco grandes grupos:</p><br><ul><li>Cookies analíticas: recogen información del uso que se realiza del sitio web.</li><li>Cookies sociales: son aquellas necesarias para redes sociales externas.</li><li>Cookies de afiliados: permiten hacer un seguimiento de las visitas procedentes de otras webs, con las que el sitio web establece un contrato de afiliación (empresas de afiliación).</li><li>Cookies de publicidad y comportamentales: recogen información sobre las preferencias y elecciones personales del usuario (retargeting).</li><li>Cookies técnicas y funcionales: son las estrictamente necesarias para el uso del sitio web y para la prestación del servicio contratado.</li></ul><br>',
            'cookies-5': '<h4>5. RELACIÓN Y DESCRIPCIÓN DE LAS COOKIES QUE UTILIZAMOS EN LA PÁGINA WEB</h4><br>',
            'cookies-5txt': '<p>La tabla que publicamos a continuación recoge de forma esquematizada las cookies que utilizamos en nuestra página web:</p><br>',
            'cookies-5table': '<table><tr><th>Tipo</th><th>Nombre</th><th>Info</th><th>Caducidad</th><th>Propiedad</th><th>Link</th></tr><tr><td>Funcional</td><td>ASP.NET_SessionId</td><td>Sesión del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>__RequestVerificationToken</td><td>Prevención de ataques CSRF</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>raw_country</td><td>País del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>raw_continent</td><td>Continente del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>langpref</td><td>Lenguaje del usuario</td><td>19/01/2038</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>lang_established</td><td>Establecimiento del lenguaje del usuario</td><td>19/01/2038</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>pwa_installed</td><td>Acceso escritorio instalado</td><td>30 (No) - 365 (Sí) días</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>.AspNet.ApplicationCookie</td><td>Identidad del usuario</td><td>Sesión</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>api_token</td><td>Conexión con APIs</td><td>24 horas</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>tmc_token</td><td>Conexión con TMC</td><td>24 horas</td><td>Propia</td><td></td></tr><tr><td>Funcional</td><td>Sentry cookies</td><td>Gestión de errores</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Funcional</td><td>Cloudflare cookies</td><td>Seguridad</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Funcional</td><td>Smartsupp cookies</td><td>Chat de soporte</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Analítica</td><td>Google cookies</td><td>Seguimiento</td><td>-</td><td>Terceros</td><td></td></tr><tr><td>Analítica</td><td>Facebook cookies</td><td>Seguimiento</td><td>-</td><td>Terceros</td><td></td></tr></table><br>',
            'cookies-5clarify': '<p>Al pulsar en <u>\'Aceptar todas\'</u> en nuestro banner, acepta tanto las cookies funcionales como las analiticas. Por el contrario, si pulsa en <u>\'Solo necesarias\'</u> solo lo hace con las funcionales.</p><br>',
            'cookies-6': '<h4>6. COOKIES DE REDES SOCIALES</h4><br>',
            'cookies-6txt': '<p>Algunas páginas de nuestros sitios web le permiten compartir nuestros contenidos en redes sociales como Facebook, Twitter, Google, etc. Algunas veces colgamos vídeos de sitios como YouTube. Estos sitios web depositan sus propias cookies, que nosotros no controlamos. Quizás quiera comprobar sus sitios web para saber más acerca de su política de cookies.</p><br><p>MÁS INFORMACIÓN SOBRE COOKIES DE REDES SOCIALES:</p><ul><li><a href=\'https://es-es.facebook.com/about/privacy/cookies\'>Facebook</a></li><li><a href=\'https://twitter.com/privacy\'>Twitter</a></li><li><a href=\'https://www.youtube.com/howyoutubeworks/policies/community-guidelines/\'>Youtube</a></li><li><a href=\'https://www.linkedin.com/legal/privacy-policy\'>Linkedin</a></li></ul><br>',
            'cookies-7': '<h4>7. DESDE SU NAVEGADOR PUEDE:</h4><br>',
            'cookies-7txt': '<p>Evitar el uso de Cookies, deshabilitando en su navegador el uso de Cookies y eliminando las Cookies guardadas en su navegador asociadas a este sitio web. Esta posibilidad de evitar el uso de Cookies puede ser llevada a cabo por usted en cualquier momento.</p><br><p>Evitar la descarga de cookies en tu navegación, seleccionando la opción “Navegación de incógnito” o similar, (aunque la siguiente ocasión que quiera acceder a tu cuenta personal tendrá que loguearte) debiendo renunciar además a la memorización de otras variables de sesión.</p><br><p>Borrar cookies, Para borrar las cookies vinculadas con tu cuenta personal en OPENHEALTHCARE S.L deberás hacerlo desde el dominio https: www.openhealthcare.es.</p><br>',
            'cookies-8': '<h4>8. REVOCACIÓN DEL CONSENTIMIENTO PARA INSTALAR COOKIES COMO ELIMINAR LAS COOKIES DEL NAVEGADOR</h4><br>',
            'cookies-8txt': '<p><b><u>Chrome</b></u></p><ol><li>Selecciona el icono de Herramientas</li><li>Haz clic en Configuración.</li><li>Haz clic en Mostrar Opciones Avanzadas.</li><li>En la sección «Privacidad» haz clic en Configuración de contenido. • Eliminar cookies: Haz clic en Todas las cookies y los datos de sitios… • No permitir que se almacenen cookies.</li><li>Haz clic en Eliminar datos de navegación (vaciar la Caché).</li><li>Cierra y reinicia el navegador.</li></ol><p style=\'font-weight:bold;\'>Para más información sobre Chrome pulse <a href=\'https://support.google.com/chrome/answer/95647?hl=es\'>aquí</a>.</p><br>',
            'cookies-8txt2': '<p><b><u>Internet Explorer. Versión 11</b></u></p><ol><li>Selecciona Herramientas | Opciones de Internet.</li><li>Haz clic en la ficha General.</li><li>En la sección «Historial de exploración», haz clic en Eliminar el historial de exploración al salir.</li><li>Seleccionar Eliminar archivos.</li><li>Seleccionar Eliminar cookies.</li><li>Haz clic en Eliminar.</li><li>Haz clic en Aceptar.</li><li>Cierra y reinicia el navegador.</li></ol><p style=\'font-weight:bold;\'>Para más información sobre Internet Explorer pulse <a href=\'http://windows.microsoft.com/es-419/windows7/how-to-manage-cookies-in-internet-explorer-9\'>aquí</a>.</p><br>',
            'cookies-8txt3': '<p><b><u>Firefox. Versión 18</b></u></p><ol><li>Selecciona Firefox | Historial | Limpiar el historial reciente.</li><li>Al lado de «Detalles», haz clic en la flecha hacia abajo.</li><li>Selecciona las siguientes casillas de verificación: Cookies, Caché, Inicios de sesión activos</li><li>Usando el «Intervalo de tiempo para borrar» en el menú desplegable, selecciona Todo.</li><li>Haz clic en Borrar ahora.</li><li>Cierra y reinicia el navegador. Puede aceptar o rechazar las cookies individualmente en las Preferencias de Firefox, en la sección Historial disponible en Herramientas > Opciones > Privacidad.</li></ol><p style=\'font-weight:bold;\'>Para más información sobre Mozilla Firefox pulse <a href=\'https://www.mozilla.org/es-ES/privacy/websites/#cookies\'>aquí</a>.</p><br>',
            'cookies-8txt4': '<p><b><u>Safari Versión 5.1</b></u></p><ol><li>Selecciona el icono de Safari / Editar | Restaurar Safari.</li><li>Selecciona las siguientes casillas de verificación: Borrar el historial, Eliminar todos los datos de sitio web.</li><li>Haz clic en Restablecer.</li><li>Cierra y reinicia el navegador.</li></ol><p style=\'font-weight:bold;\'>Para más información sobre Safari pulse <a href=\'http://support.apple.com/kb/PH5042\'>aquí</a>.</p><br>',
            'cookies-8txt5': '<p><b><u>Opera</b></u></p><ol><li>Opciones – Avanzado – Cookies. Las opciones de cookies controlan el modo en que Opera los maneja y por lo tanto su aceptación o rechazo.</li></ol><p style=\'font-weight:bold;\'>Para más información sobre Ópera pulse <a href=\'http://help.opera.com/Linux/10.60/es-ES/cookies.html\'>aquí</a>.</p><br><p><b><u>Otros navegadores</b></u>: Consulte la documentación del navegador que tenga instalado.</p><br>',
            'cookies-9': '<h4>9. INFORMACIÓN SOBRE LAS TRANSFERENCIAS DE DATOS A TERCEROS PAÍSES REALIZADAS POR OPENHEALTHCARE:</h4><br>',
            'cookies-9txt': '<p>OPENHEALTHCARE no realiza transferencias internacionales a terceros países.<br>En el caso de terceros, puedes informarte de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies en sus correspondientes políticas (ver link política cookies de terceros en la tabla).</p><br>',
            'cookies-10': '<h4>10. ELABORACIÓN DE PERFILES </h4><br>',
            'cookies-10txt': '<p>OPENHEALTHCARE no realiza elaboración de perfiles.</p><br>',
            'cookies-11': '<h4>11. EN RELACIÓN CON EL RESTO DE INFORMACIÓN EXIGIDA POR EL ARTÍCULO 13 DEL RGPD</h4><br>',
            'cookies-11txt': '<p>Les remitimos a la <a href=\'/politica-privacidad\'>Política de Privacidad de OPENHEALTHCARE</a>.</p><br>',
            'goToCookiesPolicy': 'Para más información acceda íntegramente a nuestra <a href=\'/politica-cookies\' target=\'_blank\'>política de cookies</a>.'
        }
    },
    en: {
        'cookies-banner': {
            'banner-text': 'We use cookies and third-party cookies to improve our services.<br>If you continue browsing this page, we consider that you accept our use of cookies in the terms indicated in our',
            'cookies-policy': 'Cookies Policy',
            'got-it': 'Accept all',
            'only-necessary': 'Only necessary',
            'accept-btn': 'Accept'
        },
        'cookies-modal': {
            'cookies-title': '<div class=\'type-intro-title\'>Cookie policy</div><br/>',
            'cookies-1': '<h4>1. COOKIES INFORMATION</h4><br>',
            'cookies-1txt': '<p>Due to the entry into force of the amendment of the \'Ley de Servicios de la Sociedad de la Información\' (LSSICE) established by Royal Decree 13/2012, it is mandatory to obtain the express consent of the user of all websites that use cookies expendable, before it navigates through them.</p><br>',
            'cookies-2': '<h4>2. WHAT ARE COOKIES?</h4><br>',
            'cookies-2txt': '<p>Cookies and other similar technologies such as local \'shared objects\', \'flash cookies or pixels, are tools used by Web servers to store and retrieve information about their visitors, as well as to provide a correct functioning of the site.</p><br><p>Through the use of these devices the Web server is allowed to remember some data concerning the user, such as your preferences for viewing the pages of that server, name and password, products that most interest you, etc.</p><br>',
            'cookies-3': '<h4>3. COOKIES AFFECTED BY THE REGULATION AND EXCEPTED COOKIES</h4><br>',
            'cookies-3txt': '<p>According to the EU directive, the cookies that require the informed consent of the user are analytical cookies and advertising and affiliation cookies, with the exception of those of a technical nature and those necessary for the operation of the website or the provision of services expressly requested by the user.</p><br>',
            'cookies-4': '<h4>4. WHAT TYPES OF COOKIES EXIST?</h4><br>',
            'cookies-4txt': '<p>About the types of cookies, there are five main groups:</p><br><ul><li>Analytical cookies: they collect information on the use of the website.</li><li>Social cookies: these are those necessary for external social networks.</li><li>Affiliate cookies: these allow tracking of visits from other websites, with which the website establishes an affiliation contract (affiliation companies).</li><li>Advertising and behavioural cookies: these collect information about the user\'s preferences and personal choices (retargeting).</li><li>Technical and functional cookies: these are strictly necessary for the use of the website and for the provision of the contracted service.</li></ul><br>',
            'cookies-5': '<h4>5. RELATION AND DESCRIPTION OF THE COOKIES WE USE ON THE WEBSITE</h4><br>',
            'cookies-5txt': '<p>The table below outlines the cookies we use on our website:</p><br>',
            'cookies-5table': '<table><tr><th>Type</th><th>Name</th><th>Info</th><th>Caducity</th><th>Property</th><th>Link</th></tr><tr><td>Functional</td><td>ASP.NET_SessionId</td><td>User Session</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>__RequestVerificationToken</td><td>Prevention of CSRF attacks</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>raw_country</td><td>User\'s country</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>raw_continent</td><td>User\'s continent</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>langpref</td><td>User language</td><td>01/19/2038</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>lang_established</td><td>User language establishment</td><td>01/19/2038</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>pwa_installed</td><td>Desktop access installed</td><td>30 (No) - 365 (Yes) days</td><td>Own </td><td></td></tr><tr><td>Functional</td><td>AspNet.ApplicationCookie</td><td>User Identity</td><td>Session</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>api_token</td><td>Connection with APIs</td><td>24 hours</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>tmc_token</td><td>Connection with TMC</td><td>24 hours</td><td>Own</td><td></td></tr><tr><td>Functional</td><td>Sentry cookies</td><td>Error handling</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Functional</td><td>Cloudflare cookies</td><td>Security</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Functional</td><td>Smartsupp cookies</td><td>Live support chat</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Analytics</td><td>Google cookies</td><td>Tracking</td><td>-</td><td>Third parties</td><td></td></tr><tr><td>Analytics</td><td>Facebook cookies</td><td>Tracking</td><td>-</td><td>Third parties</td><td></ td></tr></table><br>',
            'cookies-5clarify': '<p>By clicking on <u>\'Accept all\'</u> on our banner, you accept both functional and analytical cookies. On the contrary, if you click on <u>\'Only necessary\'</u> you only do it with functionals.</p><br>',
            'cookies-6': '<h4>6. SOCIAL NETWORKING COOKIES</h4><br>',
            'cookies-6txt': '<p>Some pages on our websites allow you to share our content on social networks like Facebook, Twitter, Google, etc. Sometimes we post videos from sites like YouTube. These websites set their own cookies, which we do not control. You may want to check their websites to find out more about their cookie policy.</p><br><p>FURTHER INFORMATION ABOUT SOCIAL NETWORKING COOKIES:</p><ul><li><a href=\'https://es-es.facebook.com/about/privacy/cookies\'>Facebook</a></li><li><a href=\'https://twitter.com/privacy\'>Twitter</a></li><li><a href=\'https://www.youtube.com/howyoutubeworks/policies/community-guidelines/\'>Youtube</a></li><li><a href=\'https://www.linkedin.com/legal/privacy-policy\'>Linkedin</a></li></ul><br>',
            'cookies-7': '<h4>7. FROM YOUR BROWSER YOU CAN:</h4><br>',
            'cookies-7txt': '<p>Avoid the use of Cookies, disabling in your browser the use of Cookies and deleting the Cookies stored in your browser associated with this website. This possibility of avoiding the use of Cookies can be carried out by you at any time.</p><br><p>Avoid the downloading of Cookies in your browsing, by selecting the option \'Incognito browsing\' or similar, (although the next occasion you want to access your personal account you will have to log in) having to also renounce the storage of other session variables.</p><br><p>Delete cookies, To delete cookies linked to your personal account in OPENHEALTHCARE S.L. you must do so from the domain https: www.openhealthcare.es.</p><br>',
            'cookies-8': '<h4>8. WITHDRAWAL OF CONSENT TO INSTALL COOKIES HOW TO REMOVE COOKIES FROM YOUR BROWSER</h4><br>',
            'cookies-8txt': '<p><b><u>Chrome</b></u></u></p><ol><li>Select the Tools icon</li><li>Click Settings.</li><li>Click Show Advanced Options.</li><li>In the \'Privacy\' section click Content Settings. - Delete cookies: Click All cookies and site data... - Do not allow cookies to be stored.</li><li>Click Delete browsing data (clear Cache).</li><li>Close and restart the browser.</li></ol><p style=\'font-weight:bold;\'>For more information about Chrome click <a href=\'https://support.google.com/chrome/answer/95647?hl=es\'>here</a>.</p><br>',
            'cookies-8txt2': '<p><b><u>Internet Explorer. Version 11</b></u></p><ol><li>Select Tools | Internet Options.</li><li>Click the General tab.</li><li>In the \'Browsing history\' section, click Delete browsing history on exit.</li><li>Select Delete files.</li><li>Select Delete cookies.</li><li>Click Delete.</li><li>Click OK.</li><li>Close and restart the browser.</li></ol><p style=\'font-weight:bold;\'>For more information about Internet Explorer click <a href=\'http://windows.microsoft.com/es-419/windows7/how-to-manage-cookies-in-internet-explorer-9\'>here</a>.</p><br>',
            'cookies-8txt3': '<p><b><u>Firefox. Version 18</b></u></p><ol><li><li>Select Firefox | History | Clear Recent History.</li><li>Next to \'Details\', click the down arrow.</li><li>Select the following checkboxes: Cookies, Cache, Active Logins</li><li>Using the \'Time interval to clear\' drop-down menu, select All.</li><li>Click Clear Now.</li><li>Close and restart the browser. You can accept or reject cookies individually in Firefox Preferences, in the History section available under Tools > Options > Privacy.</li></ol><p style=\'font-weight:bold;\'>For more information about Mozilla Firefox click <a href=\'https://www.mozilla.org/es-ES/privacy/websites/#cookies\'>here</a>.</p><br>',
            'cookies-8txt4': '<p><b><u>Safari Version 5.1</b></u></p><ol><li><li>Select the Safari / Edit | Reset Safari icon.</li><li>Select the following checkboxes: Clear history, Delete all website data.</li><li>Click Reset.</li><li>Close and restart the browser.</li></ol><p style=\'font-weight:bold;\'>For more information about Safari click <a href=\'http://support.apple.com/kb/PH5042\'>here</a>.</p><br>',
            'cookies-8txt5': '<p><b><u>Opera</b></u></u></p><ol><li>Options - Advanced - Cookies. Cookie options control how Opera handles them and therefore their acceptance or rejection.</li></ol><p style=\'font-weight:bold;\'>For more information about Opera click <a href=\'http://help.opera.com/Linux/10.60/en-US/cookies.html\'>here</a>.</p><br><br><p><b><u>Other browsers</b></u>: See the documentation for the browser you have installed.</p><br>',
            'cookies-9': '<h4>9. INFORMATION REGARDING TRANSFERS OF DATA TO THIRD COUNTRIES PERFORMED BY OPENHEALTHCARE:</h4><br>',
            'cookies-9txt': '<p>OPENHEALTHCARE does not make international transfers to third countries.<br>In the case of third parties, you can inform yourself of the transfers to third countries that, if applicable, are made by the third parties identified in this cookie policy in their corresponding policies (see link third party cookie policy in the table).</p><br>',
            'cookies-10': '<h4>10. ELABORATION OF PROFILES </h4><br>',
            'cookies-10txt': '<p>OPENHEALTHCARE does not engage in profiling.</p><br>',
            'cookies-11': '<h4>11. IN RELATION TO THE OTHER INFORMATION REQUIRED BY ARTICLE 13 OF THE GDPR</h4><br>',
            'cookies-11txt': '<p>We refer you to the <a href=\'/Home/privacy-policy\'>OPENHEALTHCARE Privacy Policy</a>.</p><br>',
            'goToCookiesPolicy': 'For more information, access our full <a href=\'/politica-cookies\' target=\'_blank\'>cookies policy</a>.'
        }
    },
    pt: {
        'cookies-banner': {
            'banner-text': 'Utilizamos cookies próprias e de terceiros para melhorar os nossos serviços.<br>Se continuar a navegar nesta página, consideramos que aceita a sua utilização nos termos indicados no nosso',
            'cookies-policy': 'Política de Cookies',
            'got-it': 'Aceitar tudo',
            'only-necessary': 'Apenas necessário',
            'accept-btn': 'Aceitar'
        },
        'cookies-modal': {
            'cookies-title': '<div class=\'type-intro-title\'>Política de cookies</div><br/>',
            'cookies-1': '<h4>1. INFORMAÇÕES SOBRE COOKIES</h4><br>',
            'cookies-1txt': '<p>Devido à entrada em vigor da referida modificação da "Lei de Serviços da Sociedade da Informação" (LSSICE) estabelecida pelo Real Decreto 13/2012, é obrigatório obter o consentimento expresso do usuário de todas as páginas da web que usam cookies dispensáveis, antes de navegar por eles.</p><br>',
            'cookies-2': '<h4>2. ¿QUÉ SON LAS COOKIES?</h4><br>',
            'cookies-2txt': '<p>Os cookies e outras tecnologias semelhantes, como "objetos compartilhados" locais, "flash cookies" ou pixels, são ferramentas utilizadas pelos servidores da Web para armazenar e recuperar informações sobre seus visitantes, bem como para oferecer um correto funcionamento do site. </p><br><p>Ao utilizar estes dispositivos, o servidor Web permite recordar alguns dados relativos ao utilizador, tais como as suas preferências de visualização das páginas desse servidor, nome e palavra-passe, produtos que mais lhe interessam, etc. .</p><br>',
            'cookies-3': '<h4>3. COOKIES AFETADOS PELO REGULAMENTO E COOKIES EXCEPTOS</h4><br>',
            'cookies-3txt': '<p>De acordo com a diretiva da UE, os cookies que requerem o consentimento informado do usuário são cookies analíticos e cookies de publicidade e afiliação, exceto os de natureza técnica e os necessários para o funcionamento do site ou a prestação de serviços. do utilizador.</p><br>',
            'cookies-4': '<h4>4. QUE TIPOS DE COOKIES EXISTEM?</h4><br>',
            'cookies-4txt': '<p>Em relação aos tipos de cookies, existem cinco grandes grupos:</p><br><ul><li>Cookies analíticos: coletam informações sobre o uso que é feito do site.</li><li>Cookies sociais : são aqueles necessários para redes sociais externas.</li><li>Cookies afiliados: permitem o monitoramento de visitas de outros sites, com os quais o site estabelece um contrato de afiliação (empresas afiliadas).</li><li>Publicidade e comportamento cookies: recolhem informação sobre as preferências e escolhas pessoais do utilizador (retargeting).</li><li>Cookies técnicos e funcionais: são estritamente necessários para a utilização do website e para a prestação do serviço contratado.< /li></ul><br>',
            'cookies-5': '<h4>5. LISTA E DESCRIÇÃO DOS COOKIES QUE USAMOS NO WEBSITE</h4><br>',
            'cookies-5txt': '<p>A tabela que publicamos abaixo resume os cookies que usamos em nosso site:</p><br>',
            'cookies-5table': '<table><tr><th>Tipo</th><th>Nome</th><th>Informações</th><th>Expiração</th><th>Propriedade</th><th>Link </th></tr><tr><td>Funcional</td><td>ASP.NET_SessionId</td><td>Sessão do usuário</td><td>Sessão</td><td> Própria </td><td></td></tr><tr><td>Funcional</td><td>__RequestVerificationToken</td><td>Prevenção de Ataque CSRF</td><td>Sessão </ td><td>Proprietário</td><td></td></tr><tr><td>Funcional</td><td>raw_country</td><td>País do usuário</ td>< td>Sessão</td><td>Proprietário</td><td></td></tr><tr><td>Funcional</td><td>raw_continent</td><td >Usuário continente </td><td>Sessão</td><td>Própria</td><td></td></tr><tr><td>Funcional</td><td>langpref </td> <td>Idioma do usuário</td><td>19/01/2038</td><td>Proprietário</td><td></td></tr><tr><td >Funcional</td ><td>lang_established</td><td>Configuração de idioma do usuário</td><td>19/01/2038</td><td>Proprietário</td><td>< /td></tr> <tr><td>Funcional</td><td>pwa_installed</td><td>Acesso ao desktop instalado</td><td>30 (Não) - 365 (Sim) dias</td><td>Próprio </td><td></td></tr><tr><td>Funcional</td><td>.AspNet.ApplicationCookie</td><td>Identidade do usuário </td><td>Sessão </td><td>Próprio</td><td></td></tr><tr><td>Funcional</td><td>api_token</td> <td>Conexão com APIs</ td><td>24 horas</td><td>Próprio</td><td></td></tr><tr><td>Funcional</td>< td>tmc_token</td>< td>Conexão TMC</td><td>24 horas</td><td>Proprietário</td><td></td></tr><tr><td >Funcional</td><td> Cookies de sentinela</td><td>Tratamento de erros</td><td>-</td><td>Terceiros</td><td></td></ tr><tr><td>Funcional </td><td>Cookies Cloudflare</td><td>Segurança</td><td>-</td><td>Terceiros</td><td>< /td></tr>< tr><td>Funcional</td><td>Cookies Smartsupp</td><td>Bate-papo de suporte</td><td>-</td><td>Terceiros</td><td></ td></tr><tr><td>Análise</td><td>Cookies do Google</td><td>Rastreamento</td><td>-</td> <td>Terceiros</ td><td></td></tr><tr><td>Análise</td><td>Cookies do Facebook</td><td>Monitoramento</td><td> -</td>< td>Terceiros</td><td></td></tr></table><br>',
            'cookies-5clarify': '<p>Ao clicar em <u>\'Aceitar todos\'</u> em nosso banner, você aceita cookies funcionais e analíticos. Pelo contrário, se clicar em <u>\'Só o necessário\'</u> só o faz com os funcionais.</p><br>',
            'cookies-6': '<h4>6. COOKIES DE REDES SOCIAIS</h4><br>',
            'cookies-6txt': '<p>Algumas páginas de nossos sites permitem que você compartilhe nosso conteúdo em redes sociais como Facebook, Twitter, Google, etc. Às vezes, carregamos vídeos de sites como o YouTube. Esses sites depositam seus próprios cookies, que não controlamos. Você pode querer verificar seus sites para saber mais sobre sua política de cookies.</p><br><p>MAIS INFORMAÇÕES SOBRE COOKIES DE REDES SOCIAIS:</p><ul><li><a href=\' https: //es-es.facebook.com/about/privacy/cookies\'>Facebook</a></li><li><a href=\'https://twitter.com/privacy\'> Twitter< /a></li><li><a href=\'https://www.youtube.com/howyoutubeworks/policies/community-guidelines/\'>Youtube</a></li><li >< a href=\'https://www.linkedin.com/legal/privacy-policy\'>Linkedin</a></li></ul><br>',
            'cookies-7': '<h4>7. A PARTIR DO SEU NAVEGADOR VOCÊ PODE:</h4><br>',
            'cookies-7txt': '<p>Evite a utilização de Cookies, desativando a utilização de Cookies no seu navegador e apagando os Cookies armazenados no seu navegador associados a este website. Esta possibilidade de evitar o uso de Cookies pode ser realizada por você a qualquer momento.</p><br><p>Evite o download de cookies em sua navegação, selecionando a opção "Navegação anônima" ou similar, (embora o da próxima vez que você quiser acessar sua conta pessoal, você terá que fazer login) e também deve renunciar à memorização de outras variáveis ​​de sessão.</p><br><p>Excluir cookies, Para excluir os cookies vinculados à sua conta pessoal em OPENHEALTHCARE S.L deve fazê-lo a partir do domínio https: www.openhealthcare.es.</p><br>',
            'cookies-8': '<h4>8. REVOGAÇÃO DO CONSENTIMENTO DE INSTALAÇÃO DE COOKIES COMO EXCLUIR COOKIES DO NAVEGADOR</h4><br>',
            'cookies-8txt': '<p><b><u>Chrome</b></u></p><ol><li>Selecione o ícone Ferramentas</li><li>Clique em Configurações.</li>< li>Clique Mostrar opções avançadas.</li><li>Na seção "Privacidade", clique em Configurações de conteúdo. • Excluir cookies: Clique em Todos os cookies e dados do site… • Não permitir que os cookies sejam armazenados.</li><li>Clique em Limpar dados de navegação (limpar cache).</li><li >Feche e reinicie o navegador .</li></ol><p style=\'font-weight:bold;\'>Para obter mais informações sobre o Chrome, clique em <a href=\'https://support.google.com/chrome/answer/ 95647?hl=está\'>aqui</a>.</p><br>',
            'cookies-8txt2': '<p><b><u>Internet Explorer. Versão 11</b></u></p><ol><li>Selecione Ferramentas | Opções da Internet.</li><li>Clique na guia Geral.</li><li>Na seção "Histórico de navegação", clique em Excluir histórico de navegação ao sair.</li>< li>Selecione Excluir arquivos.</li><li>Selecione Excluir arquivos.</li><li> li><li>Selecione Excluir cookies.</li><li>Clique em Excluir.</li><li>Clique em OK.</li><li>Feche e reinicie o navegador.</li></ol> <p style=\'font-weight:bold;\'>Para obter mais informações sobre o Internet Explorer, clique em <a href=\'http://windows.microsoft.com/en-419/windows7/how-to-manage- cookies-in-internet-explorer-9\'>aqui</a>.</p><br>',
            'cookies-8txt3': '<p><b><u>Firefox. Versión 18</b></u></p><ol><li>Selecciona Firefox | Historial | Limpiar el historial reciente.</li><li>Al lado de «Detalles», haz clic en la flecha hacia abajo.</li><li>Selecciona las siguientes casillas de verificación: Cookies, Caché, Inicios de sesión activos</li><li>Usando el «Intervalo de tiempo para borrar» en el menú desplegable, selecciona Todo.</li><li>Haz clic en Borrar ahora.</li><li>Cierra y reinicia el navegador. Puede aceptar o rechazar las cookies individualmente en las Preferencias de Firefox, en la sección Historial disponible en Herramientas > Opciones > Privacidad.</li></ol><p style=\'font-weight:bold;\'>Para más información sobre Mozilla Firefox pulse <a href=\'https://www.mozilla.org/es-ES/privacy/websites/#cookies\'>aquí</a>.</p><br>',
            'cookies-8txt4': '<p><b><u>Safari Versión 5.1</b></u></p><ol><li>Selecciona el icono de Safari / Editar | Restaurar Safari.</li><li>Selecciona las siguientes casillas de verificación: Borrar el historial, Eliminar todos los datos de sitio web.</li><li>Haz clic en Restablecer.</li><li>Cierra y reinicia el navegador.</li></ol><p style=\'font-weight:bold;\'>Para más información sobre Safari pulse <a href=\'http://support.apple.com/kb/PH5042\'>aquí</a>.</p><br>',
            'cookies-8txt5': '<p><b><u>Opera</b></u></p><ol><li>Opções – Avançado – Cookies. As opções de cookies controlam a maneira como o Opera os manipula e, portanto, sua aceitação ou rejeição.</li></ol><p style=\'font-weight:bold;\'>Para obter mais informações sobre o Opera, clique em <a href =\'http://help.opera.com/Linux/10.60/es-ES/cookies.html\'>aqui</a>.</p><br><p><b>< u>Outros navegadores</b></u>: Consulte a documentação do navegador que você instalou.</p><br>',
            'cookies-9': '<h4>9. INFORMAÇÕES SOBRE TRANSFERÊNCIAS DE DADOS A TERCEIROS PAÍSES REALIZADAS PELA OPENHEALTHCARE:</h4><br>',
            'cookies-9txt': '<p>A OPENHEALTHCARE não efectua transferências internacionais para países terceiros.<br>No caso de terceiros, pode informar-se sobre as transferências para países terceiros que, no seu caso, são efectuadas pelos terceiros identificados nesta política de cookies em suas políticas correspondentes (consulte o link da política de cookies de terceiros na tabela).</p><br>',
            'cookies-10': '<h4>10. ELABORAÇÃO DE PERFIS </h4><br>',
            'cookies-10txt': '<p>OPENHEALTHCARE não realiza perfis.</p><br>',
            'cookies-11': '<h4>11. EM RELAÇÃO ÀS OUTRAS INFORMAÇÕES EXIGIDAS PELO ARTIGO 13.º DO RGPD</h4><br>',
            'cookies-11txt': '<p>Recomendamos a <a href=\'/privacy-policy\'>Política de Privacidade da OPENHEALTHCARE</a>.</p><br>',
            'goToCookiesPolicy': 'Para mais informações, acesse nossa <a href=\'/politica-cookies\' target=\'_blank\'>política de cookies</a> na íntegra.'
        }
    }
};

var cookiesKeys = {
    acceptance: __WEBPACK_IMPORTED_MODULE_2__constants_cookies__["a" /* ACCEPTANCE_COOKIE_NAME */],
    minimum: __WEBPACK_IMPORTED_MODULE_2__constants_cookies__["g" /* MINIMUM_COOKIE_NAME */]
};

var trackingCookieKeys = __WEBPACK_IMPORTED_MODULE_2__constants_cookies__["m" /* TRACKING_COOKIES_KEYS */];

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseModal: __WEBPACK_IMPORTED_MODULE_1__components_base_BaseModal__["a" /* default */]
    },
    data: function data() {
        return {
            modalVisible: false
        };
    },

    computed: {
        cookiesAccepted: function cookiesAccepted() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cookies_helpers__["b" /* getCookie */])(cookiesKeys.acceptance);
        },
        minimumCookiesAccepted: function minimumCookiesAccepted() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cookies_helpers__["b" /* getCookie */])(cookiesKeys.minimum);
        },
        cookies: function cookies() {
            return this.$cookies.keys();
        }
    },
    methods: {
        acceptCookies: function acceptCookies() {
            // Set cookies
            Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cookies_helpers__["e" /* setCookie */])(cookiesKeys.acceptance, true);
            this.modalVisible = false;
            this.$store.commit('setCookiesBannerVisible', false);
            window.location.reload();
        },
        acceptMinimumCookies: function acceptMinimumCookies() {
            Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cookies_helpers__["e" /* setCookie */])(cookiesKeys.acceptance, true);
            Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cookies_helpers__["e" /* setCookie */])(cookiesKeys.minimum, true);
            this.disableTrackingCookies();
            this.modalVisible = false;
            this.$store.commit('setCookiesBannerVisible', false);
            window.location.reload();
        },
        disableTrackingCookies: function disableTrackingCookies() {
            var _loop = function _loop(cookie) {
                if (trackingCookieKeys.filter(function (key) {
                    return cookie.includes(key);
                }).length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cookies_helpers__["c" /* removeCookie */])(cookie);
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.cookies), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var cookie = _step.value;

                    _loop(cookie);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    },
    mounted: function mounted() {
        if (this.minimumCookiesAccepted) {
            this.disableTrackingCookies();
        }
        this.$store.commit('setCookiesBannerVisible', !this.cookiesAccepted);
    },

    i18n: {
        messages: messages
    }
});

/***/ }),
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		icon: {
			type: String
		},
		text: {
			type: String
		},
		reverse: {
			type: Boolean,
			default: false
		},
		action: {
			type: Function
		}
	},
	data: function data() {
		return {
			hover: false
		};
	},

	computed: {
		activeBlueColor: function activeBlueColor() {
			return !this.hover && this.$attrs.blue;
		},
		activeWhiteColor: function activeWhiteColor() {
			return !this.activeBlueColor && this.$attrs.white;
		}
	}
});

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChatWindow = __webpack_require__(1856);

var _ChatWindow2 = _interopRequireDefault(_ChatWindow);

var _closeIcon = __webpack_require__(1269);

var _closeIcon2 = _interopRequireDefault(_closeIcon);

var _logoNoBg = __webpack_require__(1270);

var _logoNoBg2 = _interopRequireDefault(_logoNoBg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    icons: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          open: {
            img: _logoNoBg2.default,
            name: 'default'
          },
          close: {
            img: _closeIcon2.default,
            name: 'default'
          }
        };
      }
    },
    showEmoji: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    open: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    showLauncher: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    titleImageUrl: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    onMessageWasSent: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    newMessagesCount: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    placeholder: {
      type: String,
      default: 'Write a message...'
    },
    showTypingIndicator: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    colors: {
      type: Object,
      required: false,
      validator: function validator(c) {
        return 'header' in c && 'bg' in c.header && 'text' in c.header && 'launcher' in c && 'bg' in c.launcher && 'messageList' in c && 'bg' in c.messageList && 'sentMessage' in c && 'bg' in c.sentMessage && 'text' in c.sentMessage && 'receivedMessage' in c && 'bg' in c.receivedMessage && 'text' in c.receivedMessage && 'userInput' in c && 'bg' in c.userInput && 'text' in c.userInput;
      },
      default: function _default() {
        return {
          header: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          launcher: {
            bg: '#4e8cff'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#f4f7f9',
            text: '#ffffff'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        };
      }
    },
    alwaysScrollToBottom: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    messageStyling: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disableUserListToggle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openAndFocus: function openAndFocus() {
      this.open();
      this.$root.$emit('focusUserInput');
    }
  },
  computed: {
    chatWindowTitle: function chatWindowTitle() {
      if (this.title !== '') {
        return this.title;
      }

      if (this.participants.length === 0) {
        return 'You';
      } else if (this.participants.length > 1) {
        return 'You, ' + this.participants[0].name + ' & others';
      } else {
        return 'You & ' + this.participants[0].name;
      }
    }
  },
  components: {
    ChatWindow: _ChatWindow2.default
  }
};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(1859);

var _Header2 = _interopRequireDefault(_Header);

var _MessageList = __webpack_require__(1864);

var _MessageList2 = _interopRequireDefault(_MessageList);

var _UserInput = __webpack_require__(1919);

var _UserInput2 = _interopRequireDefault(_UserInput);

var _UserList = __webpack_require__(1950);

var _UserList2 = _interopRequireDefault(_UserList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Header: _Header2.default,
    MessageList: _MessageList2.default,
    UserInput: _UserInput2.default,
    UserList: _UserList2.default
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    titleImageUrl: {
      type: String,
      default: ''
    },
    onUserInputSubmit: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isOpen: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    placeholder: {
      type: String,
      default: 'Write a message...'
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    disableUserListToggle: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showUserList: false
    };
  },

  computed: {
    messages: function messages() {
      var messages = this.messageList;
      return messages;
    }
  },
  methods: {
    handleUserListToggle: function handleUserListToggle(showUserList) {
      this.showUserList = showUserList;
    },
    getSuggestions: function getSuggestions() {
      return this.messages.length > 0 ? this.messages[this.messages.length - 1].suggestions : [];
    }
  }
};

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closeIconBig = __webpack_require__(1862);

var _closeIconBig2 = _interopRequireDefault(_closeIconBig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    icons: {
      type: Object,
      default: function _default() {
        return {
          close: {
            img: _closeIconBig2.default,
            name: 'default'
          }
        };
      }
    },
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    disableUserListToggle: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleUserList: function toggleUserList() {
      this.inUserList = !this.inUserList;
      this.$emit("userList", this.inUserList);
    }
  },
  data: function data() {
    return {
      inUserList: false
    };
  }
};

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Message = __webpack_require__(1867);

var _Message2 = _interopRequireDefault(_Message);

var _chatIcon = __webpack_require__(1145);

var _chatIcon2 = _interopRequireDefault(_chatIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Message: _Message2.default
  },
  props: {
    participants: {
      type: Array,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    _scrollDown: function _scrollDown() {
      this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
    },
    handleScroll: function handleScroll(e) {
      if (e.target.scrollTop === 0) {
        this.$emit('scrollToTop');
      }
    },
    shouldScrollToBottom: function shouldScrollToBottom() {
      return this.alwaysScrollToBottom || this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - 600;
    },
    profile: function profile(author) {
      var profile = this.participants.find(function (profile) {
        return profile.id === author;
      });

      return profile || { imageUrl: '', name: '' };
    }
  },
  computed: {
    defaultChatIcon: function defaultChatIcon() {
      return _chatIcon2.default;
    }
  },
  mounted: function mounted() {
    this.$nextTick(this._scrollDown());
  },
  updated: function updated() {
    if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
  }
};

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextMessage = __webpack_require__(1870);

var _TextMessage2 = _interopRequireDefault(_TextMessage);

var _FileMessage = __webpack_require__(1883);

var _FileMessage2 = _interopRequireDefault(_FileMessage);

var _EmojiMessage = __webpack_require__(1905);

var _EmojiMessage2 = _interopRequireDefault(_EmojiMessage);

var _TypingMessage = __webpack_require__(1909);

var _TypingMessage2 = _interopRequireDefault(_TypingMessage);

var _SystemMessage = __webpack_require__(1913);

var _SystemMessage2 = _interopRequireDefault(_SystemMessage);

var _chatIcon = __webpack_require__(1145);

var _chatIcon2 = _interopRequireDefault(_chatIcon);

var _store = __webpack_require__(467);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    TextMessage: _TextMessage2.default,
    FileMessage: _FileMessage2.default,
    EmojiMessage: _EmojiMessage2.default,
    TypingMessage: _TypingMessage2.default,
    SystemMessage: _SystemMessage2.default
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    sentColorsStyle: function sentColorsStyle() {
      return {
        color: this.colors.sentMessage.text,
        backgroundColor: this.colors.sentMessage.bg
      };
    },
    receivedColorsStyle: function receivedColorsStyle() {
      return {
        color: this.colors.receivedMessage.text,
        backgroundColor: this.colors.receivedMessage.bg
      };
    },
    determineMessageColors: function determineMessageColors() {
      return this.message.author === 'me' ? this.sentColorsStyle() : this.receivedColorsStyle();
    }
  },
  computed: {
    authorName: function authorName() {
      return this.user && this.user.name;
    },
    chatImageUrl: function chatImageUrl() {
      return this.user && this.user.imageUrl || this.chatIcon;
    }
  }
};

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconBase = __webpack_require__(1137);

var _IconBase2 = _interopRequireDefault(_IconBase);

var _IconEdit = __webpack_require__(1876);

var _IconEdit2 = _interopRequireDefault(_IconEdit);

var _IconCross = __webpack_require__(1139);

var _IconCross2 = _interopRequireDefault(_IconCross);

var _escapeGoat = __webpack_require__(1879);

var _autolinker = __webpack_require__(1880);

var _autolinker2 = _interopRequireDefault(_autolinker);

var _store = __webpack_require__(467);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fmt = __webpack_require__(1881);

exports.default = {
  data: function data() {
    return {
      store: _store2.default
    };
  },

  props: {
    message: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    messageText: function messageText() {
      var escaped = (0, _escapeGoat.htmlEscape)(this.message.data.text);

      return _autolinker2.default.link(this.messageStyling ? fmt(escaped) : escaped, {
        className: 'chatLink',
        truncate: { length: 50, location: 'smart' }
      });
    },
    me: function me() {
      return this.message.author === 'me';
    },
    isEditing: function isEditing() {
      return (_store2.default.editMessage && _store2.default.editMessage.id) == this.message.id;
    }
  },
  methods: {
    edit: function edit() {
      this.store.editMessage = this.message;
    }
  },
  components: {
    IconBase: _IconBase2.default,
    IconCross: _IconCross2.default,
    IconEdit: _IconEdit2.default
  }
};

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f984718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconBase_vue__ = __webpack_require__(1875);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1873)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f984718"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f984718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconBase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/components/IconBase.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f984718", Component.options)
  } else {
    hotAPI.reload("data-v-5f984718", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f31f0010_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconCross_vue__ = __webpack_require__(1878);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f31f0010_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconCross_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/components/icons/IconCross.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f31f0010", Component.options)
  } else {
    hotAPI.reload("data-v-f31f0010", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mimeTypes = __webpack_require__(1886);

var _mimeTypes2 = _interopRequireDefault(_mimeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  },
  methods: {
    getNonImageFileIcon: function getNonImageFileIcon(contentType) {
      var fileExtension = _mimeTypes2.default.extension(contentType);
      try {
        switch (fileExtension) {
          case 'docx':
            fileExtension = 'doc';
            break;
          case 'mpga':
            fileExtension = 'mp3';
            break;
          default:
            break;
        }
        return __webpack_require__(1890)("./" + fileExtension + '.svg');
      } catch (e) {
        return __webpack_require__(1141);
      }
    },
    onFileMessageClick: function onFileMessageClick() {
      if (this.data.file.type.includes('image')) {
        this.$store.commit('video/addToLightbox', this.data.url);
      } else {
        window.open(this.data.url, '_blank');
      }
    }
  }
};

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDU2IDU2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1NiA1NjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggc3R5bGU9ImZpbGw6I0U5RTlFMDsiIGQ9Ik0zNi45ODUsMEg3Ljk2M0M3LjE1NSwwLDYuNSwwLjY1NSw2LjUsMS45MjZWNTVjMCwwLjM0NSwwLjY1NSwxLDEuNDYzLDFoNDAuMDc0DQoJCWMwLjgwOCwwLDEuNDYzLTAuNjU1LDEuNDYzLTFWMTIuOTc4YzAtMC42OTYtMC4wOTMtMC45Mi0wLjI1Ny0xLjA4NUwzNy42MDcsMC4yNTdDMzcuNDQyLDAuMDkzLDM3LjIxOCwwLDM2Ljk4NSwweiIvPg0KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNEOUQ3Q0E7IiBwb2ludHM9IjM3LjUsMC4xNTEgMzcuNSwxMiA0OS4zNDksMTIgCSIvPg0KCTxwYXRoIHN0eWxlPSJmaWxsOiNDOEJEQjg7IiBkPSJNNDguMDM3LDU2SDcuOTYzQzcuMTU1LDU2LDYuNSw1NS4zNDUsNi41LDU0LjUzN1YzOWg0M3YxNS41MzdDNDkuNSw1NS4zNDUsNDguODQ1LDU2LDQ4LjAzNyw1NnoiLz4NCgk8Y2lyY2xlIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBjeD0iMTguNSIgY3k9IjQ3IiByPSIzIi8+DQoJPGNpcmNsZSBzdHlsZT0iZmlsbDojRkZGRkZGOyIgY3g9IjI4LjUiIGN5PSI0NyIgcj0iMyIvPg0KCTxjaXJjbGUgc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGN4PSIzOC41IiBjeT0iNDciIHI9IjMiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSIxNy41MTgiIGN5PSIxNy41MTgiIHI9IjE3LjUxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2LjUyIDU1KSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiIcon = __webpack_require__(1922);

var _EmojiIcon2 = _interopRequireDefault(_EmojiIcon);

var _FileIcons = __webpack_require__(1932);

var _FileIcons2 = _interopRequireDefault(_FileIcons);

var _UserInputButton = __webpack_require__(1936);

var _UserInputButton2 = _interopRequireDefault(_UserInputButton);

var _Suggestions = __webpack_require__(1940);

var _Suggestions2 = _interopRequireDefault(_Suggestions);

var _file = __webpack_require__(1944);

var _file2 = _interopRequireDefault(_file);

var _close = __webpack_require__(1271);

var _close2 = _interopRequireDefault(_close);

var _store = __webpack_require__(467);

var _store2 = _interopRequireDefault(_store);

var _IconCross = __webpack_require__(1139);

var _IconCross2 = _interopRequireDefault(_IconCross);

var _IconOk = __webpack_require__(1945);

var _IconOk2 = _interopRequireDefault(_IconOk);

var _IconSend = __webpack_require__(1947);

var _IconSend2 = _interopRequireDefault(_IconSend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiIcon: _EmojiIcon2.default,
    FileIcons: _FileIcons2.default,
    UserInputButton: _UserInputButton2.default,
    Suggestions: _Suggestions2.default,
    IconCross: _IconCross2.default,
    IconOk: _IconOk2.default,
    IconSend: _IconSend2.default
  },
  props: {
    icons: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          file: {
            img: _file2.default,
            name: 'default'
          },
          closeSvg: {
            img: _close2.default,
            name: 'default'
          }
        };
      }
    },
    showEmoji: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    suggestions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showFile: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    onSubmit: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Write something...'
    },
    colors: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      file: null,
      inputActive: false,
      store: _store2.default
    };
  },

  methods: {
    cancelFile: function cancelFile() {
      this.file = null;
    },
    setInputActive: function setInputActive(onoff) {
      this.inputActive = onoff;
    },
    handleKey: function handleKey(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        if (!this.isEditing) {
          this._submitText(event);
        } else {
          this._editText(event);
        }
        this._editFinish();
        event.preventDefault();
      } else if (event.keyCode === 27) {
        this._editFinish();
        event.preventDefault();
      }

      this.$emit('onType');
    },
    focusUserInput: function focusUserInput() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.userInput.focus();
      });
    },
    _submitSuggestion: function _submitSuggestion(suggestion) {
      this.onSubmit({ author: 'me', type: 'text', data: { text: suggestion } });
    },
    _submitText: function _submitText(event) {
      var text = this.$refs.userInput.textContent;
      var file = this.file;
      if (file) {
        this._submitTextWhenFile(event, text, file);
      } else {
        if (text && text.length > 0) {
          this.onSubmit({
            author: 'me',
            type: 'text',
            data: { text: text }
          });
          this.$refs.userInput.innerHTML = '';
        }
      }
    },
    _submitTextWhenFile: function _submitTextWhenFile(event, text, file) {
      if (text && text.length > 0) {
        this.onSubmit({
          author: 'me',
          type: 'file',
          data: { text: text, file: file }
        });
        this.file = null;
        this.$refs.userInput.innerHTML = '';
      } else {
        this.onSubmit({
          author: 'me',
          type: 'file',
          data: { file: file }
        });
        this.file = null;
      }
    },
    _editText: function _editText(event) {
      var text = this.$refs.userInput.textContent;
      if (text && text.length) {
        this.$emit('edit', {
          author: 'me',
          type: 'text',
          id: _store2.default.editMessage.id,
          data: { text: text }
        });
        this._editFinish();
      }
    },
    _handleEmojiPicked: function _handleEmojiPicked(emoji) {
      this.onSubmit({
        author: 'me',
        type: 'emoji',
        data: { emoji: emoji }
      });
    },
    _handleFileSubmit: function _handleFileSubmit(file) {
      this.file = file;
    },
    _editFinish: function _editFinish() {
      this.store.editMessage = null;
    }
  },
  watch: {
    editMessageId: function editMessageId(m) {
      if (_store2.default.editMessage != null && _store2.default.editMessage != undefined) {
        this.$refs.userInput.focus();
        this.$refs.userInput.textContent = _store2.default.editMessage.data.text;
      } else {
        this.$refs.userInput.textContent = '';
      }
    }
  },
  computed: {
    editMessageId: function editMessageId() {
      return this.isEditing && _store2.default.editMessage.id;
    },
    isEditing: function isEditing() {
      return _store2.default.editMessage && _store2.default.editMessage.id;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$root.$on('focusUserInput', function () {
      _this2.focusUserInput();
    });
  }
};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiPicker = __webpack_require__(1925);

var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiPicker: _EmojiPicker2.default
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  props: {
    onEmojiPicked: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    _openPicker: function _openPicker(e) {
      this.isActive = !this.isActive;
    },
    _handlePickerBlur: function _handlePickerBlur() {
      this.isActive = false;
    }
  }
};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emojiJs = __webpack_require__(1928);

var _emojiJs2 = _interopRequireDefault(_emojiJs);

var _emojiData = __webpack_require__(1929);

var _emojiData2 = _interopRequireDefault(_emojiData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      emojiData: _emojiData2.default,
      emojiConvertor: new _emojiJs2.default()
    };
  },

  props: {
    onBlur: {
      type: Function,
      required: true
    },
    onEmojiPicked: {
      type: Function,
      required: true
    }
  },
  methods: {
    emojiClicked: function emojiClicked(emoji) {
      this.onEmojiPicked(emoji);
      this.$refs.domNode.blur();
    }
  },
  mounted: function mounted() {
    var elem = this.$refs.domNode;
    elem.style.opacity = 0;
    window.requestAnimationFrame(function () {
      elem.style.transition = 'opacity 350ms';
      elem.style.opacity = 1;
    });
    this.$refs.domNode.focus();
    this.emojiConvertor.init_env();
  }
};

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    onChange: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    _handleClick: function _handleClick(e) {
      e.target.value = null;
    },
    _handleChange: function _handleChange(e) {
      this.onChange(e.target.files[0]);
    }
  }
};

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconBase = __webpack_require__(1137);

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    color: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: false,
      default: ''
    }
  },
  components: {
    IconBase: _IconBase2.default
  }
};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {};
    },

    props: {
        suggestions: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        colors: {
            type: Object,
            required: true
        }
    }
};

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    participants: {
      type: Array,
      required: true
    }
  }
};

/***/ }),
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BNavbar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_37" /* BNavbar */],
        BNavItem: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_35" /* BNavItem */]
    },
    computed: {
        showBackBtn: function showBackBtn() {
            return window.history.length > 1;
        }
    }
});

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_buttons_BaseButton_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_clinicHistory__ = __webpack_require__(1228);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BSidebar: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_46" /* BSidebar */],
        BNavbar: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_37" /* BNavbar */],
        BNavItem: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_35" /* BNavItem */],
        BaseButton: __WEBPACK_IMPORTED_MODULE_2__base_buttons_BaseButton_vue__["default"],
        BNav: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_33" /* BNav */]
    },
    props: {
        rightSide: Boolean,
        sidebarData: Object,
        defaultLiHeight: Number
    },
    data: function data() {
        return {
            BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["c" /* BLUE_COLOUR */],
            marginTop: 0,
            sidebarHeight: null,
            sidebarMargin: 0,
            sidebarWidth: 'auto',
            liHeight: null,
            topMarginBackBtn: null,
            loadCompleted: false,
            heightLimitExpanded: 550,
            widthLimitExpanded: 1650,
            scTimer: 0,
            position: 'fixed'
        };
    },

    methods: {
        goToSection: function goToSection(section) {
            this.$emit('openHistorySection', section);
            document.querySelector('#' + section).scrollIntoView({
                behavior: 'smooth'
            });
        },

        handleScroll: function handleScroll() {
            var _this2 = this;

            if (location.href.indexOf(__WEBPACK_IMPORTED_MODULE_4__constants_clinicHistory__["d" /* BASE_PATH */] + '/' + __WEBPACK_IMPORTED_MODULE_4__constants_clinicHistory__["D" /* HEALTH_VARS_PATH */]) === -1) {
                window.removeEventListener('scroll', this.handleScroll);
                return;
            }
            if (this.scTimer) return;
            this.scTimer = setTimeout(function () {
                var scY = document.getElementById('familyBackground').getBoundingClientRect().top - window.scrollY;
                clearTimeout(_this2.scTimer);
                _this2.scTimer = 0;
                _this2.$store.state.clinicHistory.sidebarHidden = scY < 0;
            }, 100);
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var _this = this;
        setTimeout(function () {
            _this3.$store.state.clinicHistory.sidebarHidden = window.innerHeight < _this3.heightLimitExpanded || !_this3.expanded;
            if (_this3.$store.state.clinicHistory.sidebarHidden) {
                return;
            }
            var innerContainer = document.getElementById('history-container');
            _this3.marginTop = parseInt(innerContainer.offsetTop);
            _this3.sidebarHeight = parseInt(document.getElementsByClassName('b-sidebar-body')[0].offsetHeight) - _this3.marginTop - (_this3.expanded ? 30 : 0);
            var sidebarWidth = parseInt(document.getElementsByClassName('b-sidebar')[0].offsetWidth);
            var containerWidth = parseInt(window.getComputedStyle(document.getElementById('history-view-container')).width.replace('px', '')) - 2 * sidebarWidth;
            _this3.liHeight = _this3.defaultLiHeight ? _this3.defaultLiHeight : _this3.sidebarHeight / __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.sidebarData).length - 0.5;
            var containerMarginLeft = parseInt(window.getComputedStyle(document.getElementsByClassName('custom-container')[0]).paddingLeft.replace('px', ''));
            _this3.sidebarMargin = containerMarginLeft;
            innerContainer.style.width = containerWidth + 'px';
            document.getElementById('history-view-container').style.display = 'flex';
            document.getElementById('history-view-container').style['justify-content'] = 'center';
            var sideUlright = parseInt(document.querySelector('.b-sidebar-body ul').offsetHeight);
            _this3.topMarginBackBtn = Math.min(_this3.sidebarHeight, sideUlright) + _this3.marginTopByDevice;
            _this3.position = 'sticky';
            _this3.loadCompleted = true;
            // window.addEventListener('scroll', this.handleScroll)
            if (!_this3.rightSide) _this3.$emit('liHeight', _this3.liHeight);
        }, 300);
        window.removeEventListener('orientationchange');
        window.addEventListener('orientationchange', function (event) {
            _this.$emit('refreshSidebar');
        });
    },

    computed: {
        containerStyle: function containerStyle() {
            return { 'width': (!this.expanded ? this.sidebarCollapsedWidth : this.sidebarWidth) + 'px', 'top': this.marginTop + 'px', 'height': 'calc(100vh - ' + (this.marginTop + 20) + 'px)', position: this.position };
        },
        containerClass: function containerClass() {
            return { hidden: !this.loadCompleted, 'b-sidebar-right': this.rightSide };
        },
        navStyle: function navStyle() {
            return { 'height': this.sidebarHeight + 'px' };
        },
        liStyle: function liStyle() {
            return { height: this.liHeight + 'px' };
        },
        liSpanStyle: function liSpanStyle() {
            return { height: this.liHeight - 10 + 'px' };
        },
        historyMenuPath: function historyMenuPath() {
            return '' + this.historyBasePath + (!this.$store.getters['session/userIsPatient'] ? '?patientId=' + this.$route.query.patientId : '');
        },
        iconBasePath: function iconBasePath() {
            return '/static-appopensalud/img/icons/history-sidebar/';
        },
        historyBasePath: function historyBasePath() {
            return __WEBPACK_IMPORTED_MODULE_4__constants_clinicHistory__["d" /* BASE_PATH */];
        },
        iconSize: function iconSize() {
            return this.$uiHelpers.isMobileOrTablet ? '20' : '21';
        },
        sidebarCollapsedWidth: function sidebarCollapsedWidth() {
            return this.$uiHelpers.isMobileOrTablet ? '28' : '45';
        },
        sidebarFooter: function sidebarFooter() {
            return this.expanded ? 50 : 45;
        },
        marginTopByDevice: function marginTopByDevice() {
            return this.expanded ? 20 : 10;
        },
        expanded: function expanded() {
            return window.innerWidth >= this.widthLimitExpanded;
        }
    }
});

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_dropdown_Dropdown__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_healthy_community_forum_ForumSearcher__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_LangSelector__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_modals_LoginFormModal__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_healthy_community_forum_ForumControlPanel__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_bootstrap_typeahead__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_healthy_community_forum_ForumActivitySearch__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_healthyCommunitySections__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_forms_BaseInput_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__base_buttons_BaseButton_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_shared_ArrowUp__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_utils_IdleTracker__ = __webpack_require__(469);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forumNavbar',
  components: {
    BIcon: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["C" /* BIcon */],
    BIconStarFill: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_12" /* BIconStarFill */],
    BIconStar: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_11" /* BIconStar */],
    BIconStarHalf: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_13" /* BIconStarHalf */],
    BNavbar: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_40" /* BNavbarToggle */],
    BCollapse: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["j" /* BCollapse */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_39" /* BNavbarNav */],
    BDropdownItem: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["l" /* BDropdownItem */],
    BNavItemDropdown: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_36" /* BNavItemDropdown */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_35" /* BNavItem */],
    BContainer: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["k" /* BContainer */],
    BCol: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["i" /* BCol */],
    BRow: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_45" /* BRow */],
    BButton: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["d" /* BButton */],
    BTabs: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_50" /* BTabs */],
    BTab: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_48" /* BTab */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["s" /* BFormInput */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["r" /* BFormGroup */],
    BModal: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_32" /* BModal */],
    BPopover: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_42" /* BPopover */],
    BaseModal: __WEBPACK_IMPORTED_MODULE_3__components_base_BaseModal__["a" /* default */],
    VueBootstrapTypeahead: __WEBPACK_IMPORTED_MODULE_10_vue_bootstrap_typeahead__["a" /* default */],
    Dropdown: __WEBPACK_IMPORTED_MODULE_2__components_base_dropdown_Dropdown__["a" /* default */],
    ForumActivitySearch: __WEBPACK_IMPORTED_MODULE_12__components_views_healthy_community_forum_ForumActivitySearch__["a" /* default */],
    ForumControlPanel: __WEBPACK_IMPORTED_MODULE_7__components_views_healthy_community_forum_ForumControlPanel__["default"],
    'lang-selector': __WEBPACK_IMPORTED_MODULE_5__components_base_LangSelector__["default"],
    LoginFormModal: __WEBPACK_IMPORTED_MODULE_6__components_base_modals_LoginFormModal__["a" /* default */],
    'loading-anim': function loadingAnim() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67)).then(function (m) {
        return m.default;
      });
    },
    ForumSearcher: __WEBPACK_IMPORTED_MODULE_4__components_views_healthy_community_forum_ForumSearcher__["a" /* default */],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_11__components_base_BaseDialog__["default"],
    BaseInput: __WEBPACK_IMPORTED_MODULE_14__base_forms_BaseInput_vue__["default"],
    BaseButton: __WEBPACK_IMPORTED_MODULE_15__base_buttons_BaseButton_vue__["default"],
    ArrowUp: __WEBPACK_IMPORTED_MODULE_16__components_shared_ArrowUp__["a" /* default */],
    IdleTracker: __WEBPACK_IMPORTED_MODULE_19__components_utils_IdleTracker__["a" /* default */]
  },
  computed: {
    showInSubmenu: function showInSubmenu() {
      return window.innerWidth >= 1200;
    },
    getModalFirstAccessTitle: function getModalFirstAccessTitle() {
      return this.$t('welcomeTo', [location.href.toLowerCase().indexOf('comunidadsaludable') > -1 ? this.$t('healthyCommunityFirstAccessTitle') : this.$t('patientsLikeYou')]);
    },
    noMarginBottom: function noMarginBottom() {
      return location.pathname.indexOf('/panel') > -1;
    },
    showSearchNavbarOutside: function showSearchNavbarOutside() {
      return window.innerWidth >= 1485;
    },
    showHealthyCommunityBanner: function showHealthyCommunityBanner() {
      return location.href.toLowerCase().indexOf('comunidadsaludable') > -1 && !this.$route.params.forumSection;
    },
    showSectionBanner: function showSectionBanner() {
      return location.href.toLowerCase().indexOf('comunidadsaludable') > -1 && (this.inWhoInSection || this.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_13__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */] || this.$store.state.forum.sectionId === __WEBPACK_IMPORTED_MODULE_13__constants_healthyCommunitySections__["a" /* FORUM_HEALTH_COMMUNITY_SECTION */]);
    },
    getSectionName: function getSectionName() {
      return this.getForumSectionTitle(this.$store.state.forum.sectionId);
    },
    showMonthlyAdviceModal: function showMonthlyAdviceModal() {
      return !this.$store.state.forum.userBasicInfo.firstAccess && this.showMonthlyAdvice;
    },
    newPostTitle: function newPostTitle() {
      return this.inWhoInSection ? this.$t('proposeNewActivity') : this.$t('proposeNewPost');
    },
    searchPlaceholder: function searchPlaceholder() {
      return this.inWhoInSection ? this.$t('searchWhoInPlaceholder') : this.$t('searchPlaceholder');
    }
  },
  props: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      dropdownLoginItems: [{
        title: this.$t('controlPanel'),
        href: this.getPathUrl('panel/perfil')
      }, {
        title: this.$t('logOff'),
        click: 'logOff'
      }],
      showNewPostForm: false,
      showLoginForm: false,
      search: {
        display: 'none',
        timer: null,
        categories: [],
        tags: [],
        entries: [],
        diseases: []
      },
      showActivitySearch: false,
      showConfirmDelete: false,
      showMonthlyAdvice: localStorage.getItem('forumNextDateMonthlyAccessAdvice') ? new Date(localStorage.getItem('forumNextDateMonthlyAccessAdvice')) < new Date() : true,
      BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_18__constants_colours__["c" /* BLUE_COLOUR */]
    };
  },
  created: function created() {
    if (this.$store.getters['session/isLogged'] && !this.$store.state.forum.userBasicInfo.userAspId) {
      this.getUserBasicInfo();
    }
    if (this.$route.params.forumSection) {
      this.$store.state.forum.sectionId = this.getForumSectionByPath(this.$route.params.forumSection);
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_forum_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_layout_mixin__["a" /* default */]],
  methods: {
    searchModal: function searchModal() {
      var _this = this;

      this.search.display = 'initial';
      clearTimeout(this.search.timer);

      this.search.timer = setTimeout(function () {
        _this.getSearch();
      }, 800);
    },
    searchModalClick: function searchModalClick() {
      if (this.inWhoInSection) {
        if (!this.$store.state.forum.numEntries && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.forum.activityFilters).length) {
          this.$store.dispatch('showInfoAlert', this.$t('noActivitiesToSearch'));
          return;
        }
        this.showActivitySearch = true;
      } else {
        window.scrollTo(0, 0);
        this.search.display = 'initial';
        this.getSearch();
      }
    },
    saveNewNick: function saveNewNick() {
      var _this2 = this;

      if (!this.$store.state.forum.userBasicInfo.nick) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyNick'));
        return;
      }
      this.$api.put('/Forum/UpdateNick', null, { params: { nick: this.$store.state.forum.userBasicInfo.nick } }).then(function (response) {
        if (response.data) {
          _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
          _this2.resetMonthlyAccessAdvice();
          _this2.$store.state.forum.userBasicInfo.firstAccess = false;
        } else {
          _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
        }
      });
    },
    getSearch: function getSearch() {
      var _this3 = this;

      this.$api.get('/Forum/Search', { params: { search: this.$store.state.forum.entrySearchValue, sectionId: this.$store.state.forum.sectionId } }).then(function (response) {
        if (response.data) {
          _this3.search.entries = response.data.entries;
          _this3.search.categories = response.data.categories;
          _this3.search.tags = response.data.tags;
          _this3.search.diseases = response.data.diseases;
        } else {
          _this3.$store.dispatch('showDangerAlert', _this3.$t('defaultErrorMessage'));
        }
      });
    },
    removePushNotifications: function removePushNotifications() {
      var _this4 = this;

      this.$api.delete('/Forum/RemovePushNotifications').then(function (response) {
        _this4.clearPushNotifications();
      });
    },
    pushNotificationClick: function pushNotificationClick(entryId, sectionId) {
      if (entryId) {
        this.$router.push(this.getPathUrl(entryId, this.getForumPathBySectionId(sectionId)));
        this.clearPushNotifications();
      }
    },
    clearPushNotifications: function clearPushNotifications() {
      this.$store.state.forum.pushNotifications = [];
      this.$store.state.forum.userBasicInfo.pushNotificationsSectionId = [];
      this.$store.state.forum.showPushNotificationsModal = false;
      this.$store.state.forum.numberPushNotifications = 0;
    },
    goNotificationsSetting: function goNotificationsSetting() {
      this.$router.push({ name: 'panel-administracion' + (location.href.indexOf('comunidadsaludable') > -1 ? '-healthycommunity' : ''), params: { section: 'notificaciones' } });
      this.$store.state.forum.showPushNotificationsModal = false;
    },
    resetMonthlyAccessAdvice: function resetMonthlyAccessAdvice() {
      localStorage.setItem('forumNextDateMonthlyAccessAdvice', new Date(new Date().setMonth(new Date().getMonth() + 1)));
      this.showMonthlyAdvice = false;
    },
    goOpenhealth: function goOpenhealth() {
      location.href = this.$store.getters['forum/forumUserIsProfessionalRole'] ? 'https://app-360.opensalud.es/' + this.$i18n.locale + '/HomeProfesional' : 'https://' + (location.href.indexOf('test') > -1 ? 'pruebas-' : '') + '360.opensalud.' + __WEBPACK_IMPORTED_MODULE_17__helpers_global_helpers__["a" /* country */] + '/' + (this.$store.getters['forum/forumUserIsPatientRole'] ? 'patient' : '');
    },
    removeSearch: function removeSearch() {
      this.$store.state.forum.showingSearch = false;
      this.$store.state.forum.searchType = false;
      this.$store.state.forum.searchId = false;
      this.$store.state.forum.entriesPageNumber = 0;
      this.loadForumEntries();
    },
    onBackButtonClick: function onBackButtonClick() {
      if (this.$route.name === 'comunidadsaludable') {
        this.goOpenhealth();
      } else if (this.$route.name === 'foro' && this.inHealthyCommunity && !this.$store.state.forum.showingSearch) {
        this.$router.push(this.getHealthyCommunityPathUrl());
      } else if (this.$route.name === 'foro' && this.$store.state.forum.showingSearch) {
        this.removeSearch();
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_forum_mixin__ = __webpack_require__(157);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forumSearcher',
  components: {
    forumMixin: __WEBPACK_IMPORTED_MODULE_0__mixins_forum_mixin__["a" /* default */]
  },
  props: {
    search: Object
  },
  data: function data() {
    return {};
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_forum_mixin__["a" /* default */]],
  methods: {
    searchSelected: function searchSelected(id, type) {
      this.$store.state.forum.entriesPageNumber = 0;
      this.$store.state.forum.searchId = id;
      this.$store.state.forum.searchType = type;
      this.$store.state.forum.showingSearch = true;
      this.searchModalClose();
      this.loadForumEntries();
      this.$router.push(this.getPathUrl()).catch(function () {});
    },
    searchModalClose: function searchModalClose() {
      this.$store.state.forum.entrySearchValue = null;
      this.search.entries = [];
      this.search.categories = [];
      this.search.tags = [];
      this.search.display = 'none';
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        document.getElementsByClassName('banner-title')[0].style.display = 'block';
        // this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
      }
    }
  }
});

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseDatepicker__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_ForumRepository__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_GeographyRepository__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_db_countries__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_wrapper_mixin__ = __webpack_require__(509);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var OTHER_ACTIVITIES_ID = '000000000000000000000000';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseModal: __WEBPACK_IMPORTED_MODULE_1__components_base_BaseModal__["a" /* default */],
        BaseDatepicker: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseDatepicker__["default"]
    },
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_8__mixins_wrapper_mixin__["a" /* default */])(Boolean), __WEBPACK_IMPORTED_MODULE_3__mixins_forum_mixin__["a" /* default */]],
    created: function created() {
        this.getActivities();
        this.getActivitiesLevel();
        this.getCountries();
        this.getStates();
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.forum.activityFilters).length) {
            this.filters = this.$store.state.forum.activityFilters;
        }
    },
    data: function data() {
        return {
            showingCalendar: false,
            activitySource: [],
            activityLevelSource: [],
            countrySource: [],
            stateSource: [],
            citySource: [],
            timeOfDaySource: [{ id: 1, name: this.$t('timeOfDay.morning') }, { id: 2, name: this.$t('timeOfDay.afternoon') }, { id: 3, name: this.$t('timeOfDay.night') }],
            filters: {
                activity: null,
                activityLevel: null,
                country: __WEBPACK_IMPORTED_MODULE_7__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_6__constants_db_countries__["a" /* MX_COUNTRY_ID */] : __WEBPACK_IMPORTED_MODULE_6__constants_db_countries__["b" /* SPAIN_COUNTRY_ID */],
                state: null,
                city: null,
                date: null,
                timeOfDay: null,
                sortId: null
            }
        };
    },

    methods: {
        getActivities: function getActivities() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_4__repositories_ForumRepository__["a" /* default */].getActivities(true).then(function (response) {
                _this.activitySource = response.data;
            });
        },
        getActivitiesLevel: function getActivitiesLevel() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_4__repositories_ForumRepository__["a" /* default */].getActivitiesLevel().then(function (response) {
                _this2.activityLevelSource = response.data;
            });
        },
        getCountries: function getCountries() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_5__repositories_GeographyRepository__["a" /* default */].getCountries().then(function (response) {
                _this3.countrySource = response.data;
            });
        },
        getStates: function getStates() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_5__repositories_GeographyRepository__["a" /* default */].getStatesByCountry(this.filters.country).then(function (response) {
                _this4.stateSource = response.data;
            });
        },
        getCities: function getCities() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_5__repositories_GeographyRepository__["a" /* default */].getStateCities(this.filters.state).then(function (response) {
                _this5.citySource = response.data;
            });
        },
        countryChange: function countryChange() {
            this.getStates();
            this.citySource = [];
            this.filters.state = null;
            this.filters.city = null;
        },
        stateChange: function stateChange() {
            this.filters.city = null;
            this.getCities();
        },
        filter: function filter() {
            var _this6 = this;

            this.filters.sortId = this.$store.state.forum.searchSort;
            this.$store.commit('forum/setActivityFilters', this.filters);
            __WEBPACK_IMPORTED_MODULE_4__repositories_ForumRepository__["a" /* default */].searchActivity(this.filters).then(function (response) {
                if (response.data && response.data.entryData.length > 0) {
                    _this6.processForumEntry(response.data);
                    _this6.$store.commit('forum/setActivityFilterSelected', _this6.filters.activity && _this6.activitySource.some(function (item) {
                        return item.id === _this6.filters.activity && item.createdByUser;
                    }) ? OTHER_ACTIVITIES_ID : _this6.filters.activity);
                    _this6.$router.push(_this6.getPathUrl()).catch(function () {});
                } else {
                    _this6.$store.dispatch('showInfoAlert', _this6.$t('emptyActivitiesSearch'));
                    _this6.resetActivityFiltersStore();
                }
            });
            this.localValue = false;
        },
        resetFilters: function resetFilters() {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).forEach(function (key) {
                _this7.filters[key] = null;
            });
            this.resetActivityFiltersStore();
            this.localValue = false;
        },
        resetActivityFiltersStore: function resetActivityFiltersStore() {
            this.$store.commit('forum/setActivityFilters', {});
            this.$store.commit('forum/setActivityFilterSelected', null);
        }
    }
});

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_i18n_mixin__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//



var MAX_IDLE_MINUTES = 60;
var WARNING_IDLE_MINUTES = 55;

var I18N_FILE = 'private-layout';

/* harmony default export */ __webpack_exports__["a"] = ({
	mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
	data: function data() {
		return {
			idleMinutes: 0,
			intervalId: null
		};
	},

	watch: {
		idleMinutes: function idleMinutes(val) {
			if (val >= MAX_IDLE_MINUTES) {
				this.$router.push('/cuenta/kickout');
				return;
			}
			if (val === WARNING_IDLE_MINUTES) {
				this.$store.dispatch('showSharedDialog', { content: this.$t('private-layout.idle-time-warning') });
			}
		}
	},
	created: function created() {
		this.init();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	},

	methods: {
		init: function init() {
			var _this = this;

			if (this.$store.getters['session/isLogged']) {
				this.intervalId = setInterval(function () {
					_this.idleMinutes++;
				}, MAX_IDLE_MINUTES * 1000);
			}
		},
		reset: function reset() {
			this.idleMinutes = 0;
		}
	}
});

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_dropdown_Dropdown__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_LangSelector__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_healthyHabits_mixin__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils_LoadingAnim__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_healthy_habits_HealthyHabitsForm__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_ArrowUp__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_utils_IdleTracker__ = __webpack_require__(469);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'healthyHabitsLayout',
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_1__components_base_dropdown_Dropdown__["a" /* default */],
    BaseModal: __WEBPACK_IMPORTED_MODULE_2__components_base_BaseModal__["a" /* default */],
    LangSelector: __WEBPACK_IMPORTED_MODULE_3__components_base_LangSelector__["default"],
    LoadingAnim: __WEBPACK_IMPORTED_MODULE_6__components_utils_LoadingAnim__["default"],
    BNavbar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_40" /* BNavbarToggle */],
    BCollapse: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["j" /* BCollapse */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_35" /* BNavItem */],
    BIcon: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["C" /* BIcon */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_39" /* BNavbarNav */],
    BFormCheckbox: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["n" /* BFormCheckbox */],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_7__components_base_BaseDialog__["default"],
    BRow: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_45" /* BRow */],
    BCol: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["i" /* BCol */],
    HealthyHabitsForm: __WEBPACK_IMPORTED_MODULE_8__components_views_healthy_habits_HealthyHabitsForm__["a" /* default */],
    BProgress: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_43" /* BProgress */],
    BProgressBar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_44" /* BProgressBar */],
    ArrowUp: __WEBPACK_IMPORTED_MODULE_9__components_shared_ArrowUp__["a" /* default */],
    IdleTracker: __WEBPACK_IMPORTED_MODULE_10__components_utils_IdleTracker__["a" /* default */]
  },
  computed: {
    showInSubmenu: function showInSubmenu() {
      return window.innerWidth >= 1200;
    },
    currentRouteName: function currentRouteName() {
      return this.$route.name;
    }
  },
  props: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      showAllowFreeDaysAdvice: false,
      settingCopy: {
        notifications: {
          phone: null,
          email: null
        },
        showStoredHabits: null,
        showGoalCompletedHabits: null,
        allowFreeDays: null,
        invertedCalendarDays: null
      },
      dropdownLoginItems: [{
        title: this.$t('logOff'),
        click: 'logOff'
      }]
    };
  },
  created: function created() {
    if (this.$store.getters['session/isLogged']) {
      this.getUserSetting();
    } else {
      this.logIn();
    }
    this.$store.state.loading = false;
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_healthyHabits_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_layout_mixin__["a" /* default */]],
  methods: {
    sendMeasurableData: function sendMeasurableData() {
      if (this.$store.state.healthyHabits.table.updatingItem) {
        return;
      }
      this.$store.state.healthyHabits.itemSelected.newValue = parseFloat(this.$store.state.healthyHabits.itemSelected.newValue) ? parseFloat(parseFloat(this.$store.state.healthyHabits.itemSelected.newValue).toFixed(2)) : 0;
      if (this.$store.state.healthyHabits.itemSelected.newValue < 0) {
        this.$store.dispatch('showInfoAlert', this.$t('mustInsertPositiveValue'));
        return;
      }
      if (this.$store.state.healthyHabits.itemSelected.newValue !== this.$store.state.healthyHabits.itemSelected.currentValue) {
        this.sendModifiedData();
      }
      this.$store.state.healthyHabits.showMeasurableInputModal = false;
    },
    healthyHabitsFormModalHidden: function healthyHabitsFormModalHidden() {
      this.$store.state.healthyHabits.form.show = false;
      this.$store.state.healthyHabits.form.editing = false;
      this.$store.state.healthyHabits.predefinedHabit.itemIdSelected = null;
      this.$store.state.healthyHabits.form.predefinedHabit = null;
      this.$store.state.healthyHabits.form.multiUser = false;
      if (this.isRouteFromClinicHistory()) {
        this.goHealthyHabitsPath();
      }
    },
    allowFreeDaysChange: function allowFreeDaysChange(value) {
      if (!value) {
        this.showAllowFreeDaysAdvice = true;
      }
    },
    showSettingModal: function showSettingModal() {
      this.settingCopy.notifications.email = this.$store.state.healthyHabits.setting.notifications.email;
      this.settingCopy.notifications.phone = this.$store.state.healthyHabits.setting.notifications.phone;
      this.settingCopy.showStoredHabits = this.$store.state.healthyHabits.setting.showStoredHabits;
      this.settingCopy.showGoalCompletedHabits = this.$store.state.healthyHabits.setting.showGoalCompletedHabits;
      this.settingCopy.allowFreeDays = this.$store.state.healthyHabits.setting.allowFreeDays;
      this.settingCopy.invertedCalendarDays = this.$store.state.healthyHabits.setting.invertedCalendarDays;
      this.$store.state.healthyHabits.setting.showModal = true;
    },
    resetSetting: function resetSetting() {
      this.$store.state.healthyHabits.setting.showModal = false;
      this.$store.state.healthyHabits.setting.notifications.email = this.settingCopy.notifications.email;
      this.$store.state.healthyHabits.setting.notifications.phone = this.settingCopy.notifications.phone;
      this.$store.state.healthyHabits.setting.showStoredHabits = this.settingCopy.showStoredHabits;
      this.$store.state.healthyHabits.setting.showGoalCompletedHabits = this.settingCopy.showGoalCompletedHabits;
      this.$store.state.healthyHabits.setting.allowFreeDays = this.settingCopy.allowFreeDays;
      this.$store.state.healthyHabits.setting.invertedCalendarDays = this.settingCopy.invertedCalendarDays;
    },
    closeTab: function closeTab() {
      window.close();
    },
    onBackButtonClick: function onBackButtonClick() {
      if (this.currentRouteName === 'healthyHabits') {
        this.goPatientMenu();
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__["a" /* default */]],
  props: {
    backVisible: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    'loading-anim': function loadingAnim() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67));
    },
    BContainer: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["k" /* BContainer */],
    BNavbar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_39" /* BNavbarNav */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_40" /* BNavbarToggle */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_35" /* BNavItem */]
  },
  methods: {
    back: function back() {
      window.history.back();
    }
  },
  computed: {
    styleClasses: function styleClasses() {
      return this.$route.meta && this.$route.meta.title ? this.$route.meta.title.styleClasses || '' : '';
    }
  }
});

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_gtag_mixin__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Opensalud360Layout',
	mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_gtag_mixin__["a" /* default */]],
	components: {
		BNavItem: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_35" /* BNavItem */],
		PublicMenuLayoutV2: __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__["default"],
		ArrowButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__["a" /* default */]
	},
	data: function data() {
		return {
			BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["c" /* BLUE_COLOUR */],
			WHITE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["m" /* WHITE_COLOUR */]
		};
	}
});

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_AddToHomeScreen__ = __webpack_require__(508);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var LI_ELEMENT_HEIGHT = 51;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PublicMenuLayoutV2',
	vcoConfig: {
		middleware: this.processClickOutside
	},
	mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__["a" /* default */]],
	components: {
		'loading-anim': function loadingAnim() {
			return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67));
		},
		'lang-selector': function langSelector() {
			return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 125));
		},
		BNavbar: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["_37" /* BNavbar */],
		BNavbarNav: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["_39" /* BNavbarNav */],
		BNavbarBrand: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["_38" /* BNavbarBrand */],
		BNavbarToggle: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["_40" /* BNavbarToggle */],
		BCollapse: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["j" /* BCollapse */],
		BNavItem: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["_35" /* BNavItem */],
		AddToHomeScreen: __WEBPACK_IMPORTED_MODULE_5__components_utils_AddToHomeScreen__["a" /* default */]
	},
	props: {
		showInstallAppButton: {
			type: Boolean,
			default: false
		},
		showLangSelector: {
			type: Boolean,
			default: true
		},
		showTabContent: {
			type: Boolean,
			default: false
		},
		privateMenuLayout: {
			type: Boolean,
			default: false
		},
		invertedColorsMobile: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			isFixedScrolled: false,
			BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_4__constants_colours__["c" /* BLUE_COLOUR */],
			collapseVisible: false
		};
	},

	methods: {
		handleScroll: function handleScroll() {
			this.isFixedScrolled = window.scrollY > 50;
		},
		processClickOutside: function processClickOutside(event) {
			return !(event.target.closest('#navbar-toggler') || event.target.closest('#nav-collapse'));
		},
		hideMenu: function hideMenu(event) {
			var _this = this;

			// Check clicked element or parent element is not navbar-toggler
			if (!event.target.closest('#navbar-toggler') && !this.$uiHelpers.isDesktop && this.collapseVisible) {
				this.$root.$emit('bv::toggle::collapse', 'nav-collapse');
				// Do it in next tick
				setTimeout(function () {
					_this.collapseVisible = false;
				}, 0);
			}
		},
		setDropdownMenuTopMargin: function setDropdownMenuTopMargin() {
			var visibleMenuElements = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(document.querySelectorAll('#nav-collapse li'))).filter(function (el) {
				return window.getComputedStyle(el).display !== 'none';
			});
			var dropdownMenuHeight = visibleMenuElements.length * LI_ELEMENT_HEIGHT;
			var navbarHeight = document.querySelector('.os-navbar').offsetHeight;
			document.documentElement.style.setProperty('--margin-top-dropdown-menu', dropdownMenuHeight + navbarHeight + 'px');
		}
	},
	mounted: function mounted() {
		window.addEventListener('scroll', this.handleScroll);
		// Reload page when orientation change
		window.addEventListener('orientationchange', function () {
			window.location.reload();
		});
		this.setDropdownMenuTopMargin();
	},

	computed: {
		iconSize: function iconSize() {
			return this.$uiHelpers.isMobile ? 21 : 23;
		},
		hasHeadingSlot: function hasHeadingSlot() {
			return !!this.$slots.heading;
		},
		hasNavCollapseMobileSlot: function hasNavCollapseMobileSlot() {
			return !!this.$slots['nav-collapse-mobile'];
		},
		isToggleable: function isToggleable() {
			return !this.$uiHelpers.isDesktop || this.$uiHelpers.isPortrait;
		},
		color: function color() {
			return this.$uiHelpers.isMobileOrTablet && this.invertedColorsMobile ? 'white' : __WEBPACK_IMPORTED_MODULE_4__constants_colours__["c" /* BLUE_COLOUR */];
		}
	}
});

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'OpensaludEmpresasLayout',
	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__["a" /* default */]],
	components: {
		BNavItem: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_35" /* BNavItem */],
		PublicMenuLayoutV2: __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__["default"]
	},
	methods: {
		goToContactForm: function goToContactForm() {
			var contactFormElement = document.getElementById('contact-form');
			if (contactFormElement) {
				contactFormElement.scrollIntoView({ behavior: 'smooth' });
			} else {
				this.$router.push('/opensalud360/contacto');
			}
		}
	}
});

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'OpensaludLayout',
	components: {
		BNavItem: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_35" /* BNavItem */],
		PublicMenuLayoutV2: __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__["default"],
		ArrowButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__["a" /* default */]
	},
	data: function data() {
		return {
			BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["c" /* BLUE_COLOUR */],
			WHITE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["m" /* WHITE_COLOUR */]
		};
	},

	methods: {
		goToOpensalud4allLanding: function goToOpensalud4allLanding() {
			window.location = 'https://opensalud4all.com/';
		},
		goToMenttum: function goToMenttum() {
			window.location = 'https://menttum.com/';
		}
	}
});

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_gtag_mixin__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'OpensaludLayout',
	mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_gtag_mixin__["a" /* default */]],
	components: {
		BNavItem: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_35" /* BNavItem */],
		PublicMenuLayoutV2: __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__["default"],
		ArrowButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__["a" /* default */]
	},
	data: function data() {
		return {
			BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["c" /* BLUE_COLOUR */],
			WHITE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["m" /* WHITE_COLOUR */]
		};
	},

	methods: {
		goForum: function goForum() {
			location.href = this.$helpers.getHealthyCommunityUrl('pacientescomotu');
		},
		goToMenttum: function goToMenttum() {
			window.location = 'https://menttum.com/';
		}
	}
});

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_cookies__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'OpensaludLayout',
	components: {
		BNavItem: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_35" /* BNavItem */],
		PublicMenuLayoutV2: __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicMenuLayoutV2__["default"],
		ArrowButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_ArrowButton__["a" /* default */],
		BaseDialog: __WEBPACK_IMPORTED_MODULE_4__components_base_BaseDialog__["default"]
	},
	data: function data() {
		return {
			inMx: __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["l" /* inMx */],
			BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["c" /* BLUE_COLOUR */],
			WHITE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["m" /* WHITE_COLOUR */],
			primeDialog: {
				visible: true,
				cookie: __WEBPACK_IMPORTED_MODULE_5__constants_cookies__["i" /* PRIME_BY_OPENSALUD_WARNING_COOKIE */]
			},
			socialLinks: [{
				href: 'https://www.facebook.com/opensalud/',
				src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook_blue.svg',
				alt: 'opensalud social facebook'
			}, {
				href: 'https://www.instagram.com/opensalud/',
				src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram_blue.svg',
				alt: 'opensalud social instagram'
			}, {
				href: 'https://www.linkedin.com/company/10606222?trk=tyah&amp;trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A10606222%2Cidx%3A1-1-1%2CtarId%3A1461928785973%2Ctas%3Aopensalud',
				src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin_blue.svg',
				alt: 'opensalud social linkedin'
			}, {
				href: 'https://www.twitter.com/opensalud',
				src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Twitter_blue.svg',
				alt: 'opensalud social twitter'
			}]
		};
	},

	methods: {
		goToOpensalud4allLanding: function goToOpensalud4allLanding() {
			window.location = 'https://opensalud4all.com/';
		}
	}
});

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_companyServices_mixin__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_i18n_mixin__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_gtag_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_webapp_patient_ChangeUserModal__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_LoadingAnim_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_app_helpers__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_webapp_patient_MenuBanners__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repositories_AccountRepository__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_PrivateLayoutMenu__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_PrivateLayoutMobileSubmenu__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_signalRCommands__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_consultationTypes__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_signalRCommands__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants_patientServices__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_base_buttons_BackButton__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_utils_IdleTracker__ = __webpack_require__(469);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















var I18N_FILE = 'private-layout';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PrivateLayout',
	mixins: [Object(__WEBPACK_IMPORTED_MODULE_3__mixins_i18n_mixin__["a" /* default */])(I18N_FILE), __WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_gtag_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_companyServices_mixin__["a" /* default */]],
	components: {
		ChangeUserModal: __WEBPACK_IMPORTED_MODULE_6__components_webapp_patient_ChangeUserModal__["a" /* default */],
		BTabs: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["_50" /* BTabs */],
		BTab: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["_48" /* BTab */],
		'loading-anim': __WEBPACK_IMPORTED_MODULE_7__utils_LoadingAnim_vue__["default"],
		MenuBanners: __WEBPACK_IMPORTED_MODULE_9__components_webapp_patient_MenuBanners__["a" /* default */],
		PrivateLayoutMenu: __WEBPACK_IMPORTED_MODULE_11__components_shared_PrivateLayoutMenu__["a" /* default */],
		PrivateLayoutMobileSubmenu: __WEBPACK_IMPORTED_MODULE_12__components_shared_PrivateLayoutMobileSubmenu__["a" /* default */],
		BBadge: __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["b" /* BBadge */],
		BackButton: __WEBPACK_IMPORTED_MODULE_17__components_base_buttons_BackButton__["a" /* default */],
		IdleTracker: __WEBPACK_IMPORTED_MODULE_18__components_utils_IdleTracker__["a" /* default */]
	},
	mounted: function mounted() {
		this.$store.dispatch('signalr/init');
	},
	created: function created() {
		this.$store.dispatch('layout/init');
	},

	methods: {
		isTabActive: function isTabActive(path) {
			return this.$route.path.includes(path);
		}
	},
	computed: {
		menuItems: function menuItems() {
			if (this.$store.getters['session/userIsPatient']) {
				return [{
					title: this.$t('private-layout.my-profile-services'),
					path: 'profile',
					href: 'HomePaciente#/profile',
					tab: true,
					mainMenu: false
				}, {
					title: this.$t('private-layout.health-data'),
					path: 'clinic-history',
					bubble: this.$store.getters['notifications/getUnreadFilesNumber']
				}, {
					title: this.$t('private-layout.chats'),
					path: 'chats',
					bubble: this.$store.getters['notifications/getUnreadChatMessagesNumber']
				}, {
					title: this.$t('private-layout.my-consultations'),
					path: 'appointments'
				}, {
					title: this.$t('private-layout.my-agenda'),
					path: 'schedule',
					href: 'HomePaciente#/schedule'
				}, {
					title: this.$t('private-layout.my-professionals'),
					path: 'professionals',
					href: 'HomePaciente#/doctors',
					mainMenu: true,
					tab: false
				}, {
					title: this.$t('private-layout.search'),
					path: 'search'
				}];
			} else if (this.$store.getters['session/userIsProfessional']) {
				return [{
					title: this.$t('private-layout.my-profile'),
					path: 'profile',
					href: '/HomeProfesional#/profile'
				}, {
					title: this.$t('private-layout.my-services'),
					path: 'services',
					href: '/HomeProfesional#/services'
				}, {
					title: this.$t('private-layout.chats-interconsultation'),
					path: 'chats',
					href: '/HomeProfesional#/chat'
				}, {
					title: this.$t('private-layout.my-consultations'),
					path: 'appointments',
					href: '/HomeProfesional#/appointments'
				}, {
					title: this.$t('private-layout.appointment-request'),
					path: 'requests',
					href: '/HomeProfesional#/requests'
				}, {
					title: this.$t('private-layout.my-agenda'),
					path: 'schedule',
					href: '/HomeProfesional#/schedule'
				}, {
					title: this.$t('private-layout.my-patients'),
					path: 'patients',
					href: '/HomeProfesional#/patients'
				}];
			} else if (this.$store.getters['session/userIsCenter']) {
				return [];
				/* return [
    {
    title: this.$t('private-layout.my-profile'),
    path: 'profile',
    href: '/HomeCentro#/profile'
    },
      {
        title: this.$t('private-layout.my-requests'),
    path: 'requests',
        href: '/HomeCentro#/appointments'
      },
      {
        title: this.$t('private-layout.my-consultations'),
    path: 'appointments',
        href: '/HomeCentro#/requests'
      },
      {
        title: this.$t('private-layout.my-professionals'),
    path: 'professionals',
        href: '/HomeCentro#/professionals'
      },
      {
        title: this.$t('private-layout.my-patients'),
    path: 'patients',
        href: '/HomeCentro#/patients'
      }
    ] */
			}
			return [];
		},
		showTabsMenu: function showTabsMenu() {
			return this.$route.meta && !!this.$route.meta.showTabMenu && this.menuItems && this.menuItems.length > 0;
		},
		notTabMenuItems: function notTabMenuItems() {
			var _this2 = this;

			var _this = this;
			return [{
				title: this.$t('private-layout.my-apps'),
				path: 'my-apps',
				action: function action() {
					_this.$router.push('/patient/my-apps');
				},
				tab: false,
				mainMenu: false
			}, {
				title: this.$t('private-layout.habits-challenges'),
				path: 'habits',
				action: function action() {
					_this2.$router.push('/patient/goals-habits-menu');
				},
				tab: false,
				mainMenu: false
			}, {
				title: this.$store.getters['session/healthyCommunityActive'] ? this.$t('private-layout.healthy-community') : this.$t('private-layout.patients-like-you'),
				action: function action() {
					if (_this.$store.getters['session/healthyCommunityActive']) {
						_this.goToHealthyCommunity();
					} else {
						__WEBPACK_IMPORTED_MODULE_8__helpers_app_helpers__["a" /* default */].goToForum();
					}
				},
				tab: false,
				mainMenu: false
			}, {
				title: this.$t('private-layout.evaluate-your-health'),
				action: function action() {
					_this.$router.push('/patient/tests');
				},
				tab: false,
				mainMenu: false
			}, {
				title: this.$t('private-layout.healthy-foods'),
				action: function action() {
					_this.$router.push('/patient/foods');
				},
				tab: false,
				mainMenu: false
			}];
		},
		menuServiceItems: function menuServiceItems() {
			var _this = this;
			var items = [{
				title: 'opensaludWellness',
				action: function action() {
					_this.goToWellwo();
				},
				active: this.$store.getters['session/userHasActiveCompanyService'](__WEBPACK_IMPORTED_MODULE_16__constants_patientServices__["z" /* WELLWO_SERVICE */])
			}, {
				title: 'opensaludPass',
				action: function action() {
					_this.goToOpensaludPrime(_this.$apiToken);
				},
				active: this.$store.getters['session/userHasActiveCompanyService'](__WEBPACK_IMPORTED_MODULE_16__constants_patientServices__["g" /* OPENSALUD_PRIME_SERVICE */])
			}, {
				title: this.$t('private-layout.physiotherapy'),
				action: function action() {
					_this.goToRehBody();
				},
				active: this.$store.getters['session/userHasActiveCompanyService'](__WEBPACK_IMPORTED_MODULE_16__constants_patientServices__["i" /* REHANDREBODY_SERVICE */])
			}];
			return items.filter(function (item) {
				return item.active;
			});
		},
		allItems: function allItems() {
			return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.menuItems), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.notTabMenuItems));
		}
	},
	watch: {
		'$store.state.signalr.commandReceived': function $storeStateSignalrCommandReceived(_ref) {
			var _this3 = this;

			var command = _ref.command,
			    data = _ref.data;

			switch (command) {
				case __WEBPACK_IMPORTED_MODULE_13__constants_signalRCommands__["h" /* LOG_OFF */]:
					this.logOff();
					break;
				case __WEBPACK_IMPORTED_MODULE_13__constants_signalRCommands__["g" /* KICKOUT */]:
					__WEBPACK_IMPORTED_MODULE_10__repositories_AccountRepository__["a" /* default */].isntMultiUser().then(function (response) {
						if (response.data) _this3.$router.push('/cuenta/kickout');
					});
					break;
				case __WEBPACK_IMPORTED_MODULE_13__constants_signalRCommands__["a" /* APPOINTMENT_CANCELED */]:
				case __WEBPACK_IMPORTED_MODULE_15__constants_signalRCommands__["i" /* NEW_APPOINTMENT */]:
					var dataSplitted = data.split(';');
					var profName = dataSplitted[0];
					var date = dataSplitted[1];
					var appointmentType = Object(__WEBPACK_IMPORTED_MODULE_14__constants_consultationTypes__["o" /* getConsultationTitleById */])(dataSplitted[2]);
					var title = command === __WEBPACK_IMPORTED_MODULE_13__constants_signalRCommands__["a" /* APPOINTMENT_CANCELED */] ? this.$t('notifications.hasCanceled') : this.$t('notifications.hasScheduled');
					this.$store.dispatch('showInfoAlert', this.$t('notifications.appointmentCanceledByProf', { profName: profName, title: title, date: date, appointmentType: appointmentType }));
					break;
			}
		}
	}
});

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_PatientsRepository__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_account_mixin__ = __webpack_require__(213);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ChangeUserModal',
	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_account_mixin__["a" /* default */]],
	components: {
		PatientsRepository: __WEBPACK_IMPORTED_MODULE_0__repositories_PatientsRepository__["a" /* default */],
		BModal: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_32" /* BModal */]
	},
	props: {
		value: [Boolean]
	},
	data: function data() {
		return {
			loading: true,
			patients: [],
			patientId: null
		};
	},

	methods: {
		createAssociatedPatient: function createAssociatedPatient() {
			this.$helpers.goToPatientWebapp('profile', this.$apiToken);
		},
		load: function load() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__repositories_PatientsRepository__["a" /* default */].getAssociatedPatients().then(function (response) {
				if (response.data && response.data.length > 0) {
					_this.patients = response.data;
				}
				_this.loading = false;
			});
		}
	},
	computed: {
		isVisible: {
			get: function get() {
				return this.value;
			},
			set: function set(val) {
				this.$emit('input', val);
			}
		}
	}
});

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_i18n_mixin__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_signalRCommands__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_ui_BaseMenuBanner__ = __webpack_require__(2050);
//
//
//
//
//
//





var I18N_FILE = 'public/views/patient/menu-banners';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'menu-banners',
	components: {
		BaseMenuBanner: __WEBPACK_IMPORTED_MODULE_2__components_base_ui_BaseMenuBanner__["a" /* default */]
	},
	mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
	data: function data() {
		return {
			allBanners: [{
				eventId: __WEBPACK_IMPORTED_MODULE_1__constants_signalRCommands__["f" /* INMEDIATA_NOTIFICATION */],
				text: this.$t('patient.menu-banners.queue-instant-video')
			}, {
				eventId: __WEBPACK_IMPORTED_MODULE_1__constants_signalRCommands__["l" /* WRITTEN_NOTIFICATION */],
				text: this.$t('patient.menu-banners.queue-written')
			}, {
				eventId: __WEBPACK_IMPORTED_MODULE_1__constants_signalRCommands__["c" /* CHAT_NOTIFICATION */],
				text: this.$t('patient.menu-banners.queue-chat')
			}, {
				eventId: __WEBPACK_IMPORTED_MODULE_1__constants_signalRCommands__["b" /* CALL_NOTIFICATION */],
				text: this.$t('patient.menu-banners.queue-call')
			}, {
				eventId: __WEBPACK_IMPORTED_MODULE_1__constants_signalRCommands__["j" /* NEW_CHAT_MESSAGE */],
				text: this.$t('patient.menu-banners.new-chat-messages')
			}]
		};
	},

	computed: {
		banners: function banners() {
			var liveStates = this.$store.state.notifications.liveStates;
			if (liveStates.length) {
				return this.allBanners.filter(function (banner) {
					return liveStates.includes(banner.eventId);
				});
			} else {
				return [];
			}
		}
	},
	methods: {
		getLiveStates: function getLiveStates() {
			this.$store.dispatch('notifications/get');
		}
	},
	created: function created() {
		if (!this.$store.state.notifications.retrievedLiveStates) {
			this.getLiveStates();
		}
	},

	watch: {
		'$store.state.notifications.lastNotification': function $storeStateNotificationsLastNotification(notification) {
			if (this.allBanners.map(function (banner) {
				return banner.eventId;
			}).includes(notification.id) && (!this.$store.state.notifications.liveStates || !this.$store.state.notifications.liveStates.includes(notification.id))) {
				this.$store.commit('notifications/addLiveState', notification.id);
			}

			if (notification.id === __WEBPACK_IMPORTED_MODULE_1__constants_signalRCommands__["j" /* NEW_CHAT_MESSAGE */]) {
				this.$store.commit('notifications/updateSummary');
			}
		}
	}
});

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'BaseMenuBanner',
	data: function data() {
		return {
			closed: true
		};
	},

	computed: {
		id: function id() {
			return 'menu-banner-' + this._uid;
		}
	},
	props: {
		text: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			default: 'exclamation-circle'
		},
		color: {
			type: String,
			default: __WEBPACK_IMPORTED_MODULE_0__constants_colours__["c" /* BLUE_COLOUR */]
		}
	},
	methods: {
		onClose: function onClose() {
			this.closed = true;

			this.$emit('close');
		}
	},
	created: function created() {
		var _this = this;

		setTimeout(function () {
			_this.closed = false;
		}, 150);
	}
});

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_account_mixin__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_dropdown_HamburguerDropdown__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_LangSelector__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_i18n_mixin__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_colours__ = __webpack_require__(42);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var I18N_FILE = 'private-layout';

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		BNavbar: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_37" /* BNavbar */],
		BNavbarNav: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_39" /* BNavbarNav */],
		BNavbarBrand: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_38" /* BNavbarBrand */],
		BNavItem: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_35" /* BNavItem */],
		HamburguerDropdown: __WEBPACK_IMPORTED_MODULE_4__components_base_dropdown_HamburguerDropdown__["a" /* default */],
		LangSelector: __WEBPACK_IMPORTED_MODULE_5__components_base_LangSelector__["default"],
		BBadge: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["b" /* BBadge */]
	},
	data: function data() {
		return {
			BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_8__constants_colours__["c" /* BLUE_COLOUR */]
		};
	},

	mixins: [Object(__WEBPACK_IMPORTED_MODULE_6__mixins_i18n_mixin__["a" /* default */])(I18N_FILE), __WEBPACK_IMPORTED_MODULE_2__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_account_mixin__["a" /* default */]],
	props: {
		menuItems: {
			type: Array,
			required: true
		},
		menuServiceItems: {
			type: Array,
			required: false,
			default: function _default() {
				return [];
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
		isToggleable: 'layout/isToggleable'
	}), {
		mainMenuItems: function mainMenuItems() {
			return this.menuItems.filter(function (i) {
				return i.mainMenu !== false;
			});
		},
		notTabMenuItems: function notTabMenuItems() {
			return this.menuItems.filter(function (i) {
				return i.tab === false && i.mainMenu === false;
			});
		},
		navbarBrandClasses: function navbarBrandClasses() {
			return !this.inPanel ? 'mx-auto mx-lg-0' : {};
		}
	})
});

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_LangSelector__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_sizes__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburguer-dropdown',
  vcoConfig: {
    middleware: this.processClickOutside
  },
  components: {
    BaseModal: __WEBPACK_IMPORTED_MODULE_0__BaseModal_vue__["a" /* default */],
    LangSelector: __WEBPACK_IMPORTED_MODULE_1__components_base_LangSelector__["default"]
  },
  props: {
    showLanguageSelector: {
      type: Boolean
    },
    enablePortuguese: Boolean,
    dontDisplayDropdown: Boolean
  },
  data: function data() {
    return {
      isOpen: false,
      LARGE_SIZE: __WEBPACK_IMPORTED_MODULE_2__constants_sizes__["a" /* LARGE_SIZE */],
      MEDIUM_SIZE: __WEBPACK_IMPORTED_MODULE_2__constants_sizes__["b" /* MEDIUM_SIZE */],
      BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["c" /* BLUE_COLOUR */]
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isOpen = !this.isOpen;
      this.$store.dispatch('layout/toggleMenu');
    },
    hideMenu: function hideMenu() {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
    processClickOutside: function processClickOutside(event) {
      return this.isOpen && !event.target.closest('.hamburguer');
    }
  }
});

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_HistoryGrantAccessMenu__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_account_mixin__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_i18n_mixin__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_LangSelector__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var I18N_FILE = 'private-layout';

/* harmony default export */ __webpack_exports__["a"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_account_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
	components: {
		HistoryGrantAccessMenu: __WEBPACK_IMPORTED_MODULE_1__components_shared_HistoryGrantAccessMenu__["a" /* default */],
		LangSelector: __WEBPACK_IMPORTED_MODULE_5__components_base_LangSelector__["default"],
		BBadge: __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__["b" /* BBadge */]
	},
	props: {
		menuItems: {
			type: Array,
			required: true
		},
		menuServiceItems: {
			type: Array,
			required: false,
			default: function _default() {
				return [];
			}
		}
	},
	data: function data() {
		return {
			showGrantAccessHistoryModal: false,
			showServicesMenu: false,
			showToggler: false
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('layout', ['hideMenu']), {
		filterMenuItems: function filterMenuItems(items) {
			return items.filter(function (item) {
				return item.hideSm !== true;
			});
		},
		isLastItem: function isLastItem(index, items) {
			return index === items.length - 1;
		},
		onAfterEnterMenuTransition: function onAfterEnterMenuTransition() {
			this.showToggler = true;
		},
		onBeforeLeaveMenuTransition: function onBeforeLeaveMenuTransition() {
			this.showToggler = false;
		},
		handleMenuClick: function handleMenuClick(event) {
			var clickedElem = event.target;
			if (!clickedElem.closest('#services-toggler')) {
				this.hideMenu();
			}
		}
	}),
	computed: {
		caretIconClasses: function caretIconClasses() {
			return !this.$store.state.layout.showMenu ? 'reverse' : '';
		},
		notMainMenuItems: function notMainMenuItems() {
			return this.menuItems.filter(function (item) {
				return item.tab === false && item.mainMenu === false;
			});
		},
		menuMobileItems: function menuMobileItems() {
			return this.filterMenuItems(this.menuItems.filter(function (i) {
				return i.mainMenu !== false;
			}));
		},
		allMenuItems: function allMenuItems() {
			return [this.notMainMenuItems, this.menuMobileItems];
		}
	}
});

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HistoryProfAndCenterAuthorized__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_HistoryGrantAccess__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_BaseModal__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_i18n_mixin__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        HistoryProfAndCenterAuthorized: __WEBPACK_IMPORTED_MODULE_0__components_shared_HistoryProfAndCenterAuthorized__["a" /* default */],
        HistoryGrantAccess: __WEBPACK_IMPORTED_MODULE_1__components_shared_HistoryGrantAccess__["a" /* default */],
        BaseModal: __WEBPACK_IMPORTED_MODULE_2__components_base_BaseModal__["a" /* default */]
    },
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_3__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    data: function data() {
        return {
            showProfAndCenterAuthorizedModal: false,
            showGrantAccess: false
        };
    },

    props: {
        value: Boolean
    },
    methods: {},
    computed: {
        isVisible: {
            get: function get() {
                return this.value;
            },
            set: function set(val) {
                this.$emit('input', val);
            }
        }
    }
});

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__["a" /* default */]],
  components: {
    'loading-anim': function loadingAnim() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67));
    }
  }
});

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__ = __webpack_require__(79);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__["a" /* default */]]
});

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_AddToHomeScreen__ = __webpack_require__(508);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__["a" /* default */]],
  components: {
    'loading-anim': function loadingAnim() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67));
    },
    BNavbar: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_39" /* BNavbarNav */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_40" /* BNavbarToggle */],
    BCollapse: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["j" /* BCollapse */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_35" /* BNavItem */],
    AddToHomeScreen: __WEBPACK_IMPORTED_MODULE_3__components_utils_AddToHomeScreen__["a" /* default */]
  },
  data: function data() {
    return {
      key: this.$route.path
    };
  },

  methods: {
    back: function back() {
      window.history.back();
    }
  },
  computed: {
    showInstallAppButton: function showInstallAppButton() {
      return this.$route.meta && this.$route.meta.showInstallAppButton;
    }
  }
});

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_gtag_mixin__["a" /* default */]],
  components: {
    'loading-anim': function loadingAnim() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67));
    },
    BNavbar: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_39" /* BNavbarNav */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_40" /* BNavbarToggle */],
    BCollapse: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["j" /* BCollapse */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_35" /* BNavItem */]
  },
  data: function data() {
    return {
      key: this.$route.path,
      collapsed: true,
      isFixedScrolled: false
    };
  },

  methods: {
    back: function back() {
      window.history.back();
    },
    openMenu: function openMenu() {
      // const navbar = document.querySelector('.navbar')
      var navbarToggler = document.querySelector('.navbar-toggler');
      var collapse = document.querySelector('.collapse ');
      navbarToggler.classList.add('not-collapsed');
      var posFixed = document.querySelector('.position-fixed');
      posFixed.classList.add('background-set');
      collapse.classList.add('show');
      collapse.classList.remove('colapse-none');
      collapse.classList.add('colapse-initial');
    },
    closeMenu: function closeMenu() {
      // const navbar = document.querySelector('.navbar')
      var navbarToggler = document.querySelector('.navbar-toggler');
      var collapse = document.querySelector('.collapse ');
      var posFixed = document.querySelector('.position-fixed');
      posFixed.classList.remove('background-set');
      navbarToggler.classList.remove('not-collapsed');
      navbarToggler.classList.add('collapsed');
      collapse.classList.remove('show');
      collapse.classList.add('colapse-none');
      collapse.classList.remove('colapse-initial');
    },
    manageMenu: function manageMenu() {
      if (this.collapsed === true) {
        this.openMenu();
        this.collapsed = false;
      } else {
        this.closeMenu();
        this.collapsed = true;
      }
    },
    handleScroll: function handleScroll() {
      this.isFixedScrolled = window.scrollY > 50;
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicReducedLayout_vue__ = __webpack_require__(1184);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7b8999_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicReducedLayout_vue__ = __webpack_require__(2090);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2088)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b7b8999"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicReducedLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7b8999_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicReducedLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PublicReducedLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b7b8999", Component.options)
  } else {
    hotAPI.reload("data-v-5b7b8999", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_layout_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_gtag_mixin__["a" /* default */]],
  props: {
    backVisible: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    'loading-anim': function loadingAnim() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67));
    },
    BContainer: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["k" /* BContainer */],
    BNavbar: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_37" /* BNavbar */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_39" /* BNavbarNav */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_38" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_40" /* BNavbarToggle */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_35" /* BNavItem */]
  },
  methods: {
    back: function back() {
      window.history.back();
    }
  },
  computed: {
    styleClasses: function styleClasses() {
      return this.$route.meta && this.$route.meta.title ? this.$route.meta.title.styleClasses || '' : '';
    },
    colClasses: function colClasses() {
      return this.$route.meta.fullWidthLayout ? { 'col-12 col-sm-12 col-md-12 col-lg-12': true } : { 'offset-lg-4 col-lg-4 offset-md-3 offset-sm-2': this.$route.meta.layoutCentered, 'col-lg-5': !this.$route.meta.layoutCentered };
    }
  }
});

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicReducedLayout__ = __webpack_require__(1183);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicReducedLayout: __WEBPACK_IMPORTED_MODULE_0__components_layouts_PublicReducedLayout__["default"]
  }
});

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customFooter',
  components: {},
  props: {}
});

/***/ }),
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return HABITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TEMPERATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return STRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GLUCOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BLOOD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return HEART_RATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BLOOD_PRESSURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return HDL_CHOLESTEROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return LDL_CHOLESTEROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHOLESTEROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TRIGLYCERIDES; });
/* unused harmony export BODY_MASS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BREATHING_FREQUENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return OXYGEN_SATURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FEEDING_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SLEEP_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EXERCISE_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return WAIST_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return HIP_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return MOOD_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FAT_MASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FREE_FAT_MASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return HOMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return VITAMIN_D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return STEPS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CALORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BODY_MASS_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return HEALTH_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return HEALTH_CONDITION_TODAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BLOOD_PRESSURE_QUIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return HIGH_BLOOD_PRESSURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return LOW_BLOOD_PRESSURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHRONIC_DISEASE_QUIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DISEASES_RELATIONSHIP_QUIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return HEALTH_VARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FEEDING_HABITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return MOOD_AND_HABITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return HISTORY_AND_DISEASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return MEDICAL_EVALUATION; });
/* unused harmony export RELATIONSHIP_SUFFER_DISEASE */
/* unused harmony export SUFFER_SOME_DISEASE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ANALYTICS_HIGH_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BASE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return MENU_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return HEALTH_VARS_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DOCUMENTS_HISTORY_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return HEALTH_DATA; });
/* unused harmony export BLOOD_PRESSURE_MONITOR_PATH */
/* unused harmony export MENSTRUAL_CALENDAR_PATH */
/* unused harmony export MEDICATION_REMINDER_PATH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return QUIZ_PATH; });
/* unused harmony export CM */
/* unused harmony export KG */
/* unused harmony export DEGREES */
/* unused harmony export MMHG */
/* unused harmony export MGDL */
/* unused harmony export PPM */
/* unused harmony export RPM */
/* unused harmony export KCAL */
/* unused harmony export UI */
/* unused harmony export PERCENT */
/* unused harmony export HEALTHY_HABITS_SECTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return HEALTH_VARS_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADDITIONAL_VARS_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return QUIZ_TYPES; });
/* harmony export (immutable) */ __webpack_exports__["_6"] = getQuizNameByType;
/* harmony export (immutable) */ __webpack_exports__["_5"] = getAllQuizTypesIds;
/* harmony export (immutable) */ __webpack_exports__["_10"] = showDontKnowAnswerByQuestionId;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return VAR_UNITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FEEDING_HABIT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EXERCISE_HABIT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return HABITS_HABIT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return USEFUL_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return RECOMMENDED_APPLICATIONS; });
/* harmony export (immutable) */ __webpack_exports__["_7"] = isDocumentOrLink;
/* harmony export (immutable) */ __webpack_exports__["_9"] = isDocumentOrLinkPendingComplete;
/* harmony export (immutable) */ __webpack_exports__["_8"] = isDocumentOrLinkCompleted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);




var _QUIZ_TYPES, _VAR_UNITS;

// Default
var HEIGHT = 'height';
var WEIGHT = 'weight';
var AGE = 'age';
var HABITS = 'habits';
var TEMPERATURE = 'temperature';

// Optional
var STRESS = 'stress';
var GLUCOSE = 'glucose';
var BLOOD_TYPE = 'blood';
var HEART_RATE = 'heartRate';
var BLOOD_PRESSURE = 'presure';
var HDL_CHOLESTEROL = 'hdl';
var LDL_CHOLESTEROL = 'ldl';
var CHOLESTEROL = 'cholesterol';
var TRIGLYCERIDES = 'triglycerides';
var BODY_MASS = 'bodyMass';
var BREATHING_FREQUENCY = 'breathingFrequency';
var OXYGEN_SATURATION = 'oxygenSaturation';
var FEEDING_QUALITY = 'feeding';
var SLEEP_QUALITY = 'sleep';
var EXERCISE_AMOUNT = 'exercise';
var WAIST_SIZE = 'waist';
var HIP_SIZE = 'hip';
var MOOD_LEVEL = 'mood';
var FAT_MASS = 'fatMass';
var FREE_FAT_MASS = 'fatFreeMass';
var HOMA = 'homa';
var VITAMIN_D = 'vitaminD';
var STEPS_NUMBER = 'steps';
var CALORIES = 'calories';
var BODY_MASS_INDEX = 'bmi';
var HEALTH_CONDITION = 'healthcondition';
var HEALTH_CONDITION_TODAY = 'healthconditiontoday';

//Quiz
var BLOOD_PRESSURE_QUIZ = 'pressure';
var HIGH_BLOOD_PRESSURE = 'high_pressure';
var LOW_BLOOD_PRESSURE = 'low_pressure';
var CHRONIC_DISEASE_QUIZ = 'chronic_diseases';
var DISEASES_RELATIONSHIP_QUIZ = 'diseases_relationship';

// Quiz Blocks
var HEALTH_VARS = 'healthVars';
var FEEDING_HABITS = 'feedingHabits';
var MOOD_AND_HABITS = 'moodAndHabits';
var HISTORY_AND_DISEASES = 'historyAndDiseases';
var MEDICAL_EVALUATION = 'medicalEvaluation';

// Question Ids
var RELATIONSHIP_SUFFER_DISEASE = '1EECE3B2-64F8-41B4-A9A9-328E99D1A539';
var SUFFER_SOME_DISEASE = 'B2F7E48C-B37A-4D64-8E1F-4D1D6BC7465E';
var ANALYTICS_HIGH_LEVEL = '49DC52E1-D7E4-4D42-9EE0-9C4DA52772BE';

// Base route
var BASE_PATH = '/patient/clinic-history';

// History Menu Paths
var MENU_PATH = '/';
var HEALTH_VARS_PATH = 'view';
var DOCUMENTS_HISTORY_PATH = 'documents';
var HEALTH_DATA = 'health-data';
var BLOOD_PRESSURE_MONITOR_PATH = 'blood-pressure';
var MENSTRUAL_CALENDAR_PATH = 'menstrual-calendar';
var MEDICATION_REMINDER_PATH = 'medication-reminder';

// History Internal Paths
var QUIZ_PATH = 'quiz';

// Units
var CM = 'cm';
var KG = 'kg';
var DEGREES = '°C';
var MMHG = 'mmHG';
var MGDL = 'mg/dl';
var PPM = 'ppm';
var RPM = 'rpm';
var KCAL = 'kcal';
var UI = 'UI';
var PERCENT = '%';

// Sections identifiers to open presents in 'section' param
var HEALTHY_HABITS_SECTION = 'healthyHabits';
var HEALTH_VARS_SECTION = 'healthVars';
var ADDITIONAL_VARS_SECTION = 'additionalVarsSection';

// Quiz
var QUIZ_TYPES = (_QUIZ_TYPES = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_QUIZ_TYPES, HEALTH_VARS, 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_QUIZ_TYPES, FEEDING_HABITS, 2), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_QUIZ_TYPES, MOOD_AND_HABITS, 3), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_QUIZ_TYPES, HISTORY_AND_DISEASES, 4), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_QUIZ_TYPES, MEDICAL_EVALUATION, 5), _QUIZ_TYPES);

function getQuizNameByType(quizId) {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(QUIZ_TYPES).find(function (key) {
								return QUIZ_TYPES[key] === quizId;
				});
}

function getAllQuizTypesIds() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(QUIZ_TYPES);
}

function showDontKnowAnswerByQuestionId(questionId) {
				switch (questionId) {
								case RELATIONSHIP_SUFFER_DISEASE:
								case SUFFER_SOME_DISEASE:
								case ANALYTICS_HIGH_LEVEL:
												return true;
								default:
												return false;
				}
}

// Variables
var VAR_UNITS = (_VAR_UNITS = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, HEIGHT, CM), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, WEIGHT, KG), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, TEMPERATURE, DEGREES), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, GLUCOSE, MGDL), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, HEART_RATE, PPM), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, BLOOD_PRESSURE, MMHG), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, HDL_CHOLESTEROL, MGDL), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, LDL_CHOLESTEROL, MGDL), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, TRIGLYCERIDES, MGDL), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, BREATHING_FREQUENCY, RPM), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, OXYGEN_SATURATION, PERCENT), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, WAIST_SIZE, CM), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, HIP_SIZE, CM), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, FAT_MASS, KG), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, FREE_FAT_MASS, KG), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, VITAMIN_D, UI), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_VAR_UNITS, CALORIES, KCAL), _VAR_UNITS);

// Healthy habits groups
var FEEDING_HABIT_GROUP = 1;
var EXERCISE_HABIT_GROUP = 2;
var HABITS_HABIT_GROUP = 3;

// File types
var USEFUL_LINK = 24;
var RECOMMENDED_APPLICATIONS = 28;

function isDocumentOrLink(documentType) {
				return [20, 21, 22, 23, 24, 28].some(function (f) {
								return f === documentType;
				});
}
function isDocumentOrLinkPendingComplete(documentType) {
				return [20, 22].some(function (f) {
								return f === documentType;
				});
}
function isDocumentOrLinkCompleted(documentType) {
				return [21, 23].some(function (f) {
								return f === documentType;
				});
}

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTable_vue__ = __webpack_require__(944);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29eed2bf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTable_vue__ = __webpack_require__(1518);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1513)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29eed2bf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/PaginatedTable.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29eed2bf", Component.options)
  } else {
    hotAPI.reload("data-v-29eed2bf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseDatepicker_vue__ = __webpack_require__(968);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364c408b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseDatepicker_vue__ = __webpack_require__(1573);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1568)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseDatepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364c408b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseDatepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseDatepicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-364c408b", Component.options)
  } else {
    hotAPI.reload("data-v-364c408b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseRadioGroup_vue__ = __webpack_require__(1072);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efd13da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseRadioGroup_vue__ = __webpack_require__(1642);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1640)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseRadioGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efd13da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseRadioGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseRadioGroup.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6efd13da", Component.options)
  } else {
    hotAPI.reload("data-v-6efd13da", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1232 */,
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_i18n_helpers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_date_helpers__ = __webpack_require__(179);






var defaultDateFormat = 'dddd, LL';

function formatDate(date, format) {
  var utc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!date) return '';
  if (utc) {
    date = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_date_helpers__["t" /* utcDateToUtcFormat */])(date);
  }
  var dateWithLocale = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).locale(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_i18n_helpers__["b" /* getNormalizedLocale */])());
  return '' + dateWithLocale.format(format) + (format === defaultDateFormat ? ' ' + __WEBPACK_IMPORTED_MODULE_2__plugins_i18n__["a" /* default */].t('at-time') + ' ' + dateWithLocale.format('LT') : '');
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('beautifyDate', function (date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDateFormat;
  var utc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return formatDate(date, format, utc);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('beautifySimpleDate', function (date) {
  var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return formatDate(date, 'DD/MM/YYYY', utc);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('beautifySimpleDateTime', function (date) {
  var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return formatDate(date, 'DD/MM/YYYY HH:mm:ss', utc);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].options.filters);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCountries */
/* unused harmony export getAllStates */
/* unused harmony export getStates */
/* unused harmony export getStatesByCountry */
/* unused harmony export getStateCities */
/* unused harmony export getProfStates */
/* unused harmony export getCenterStates */
/* unused harmony export getStatesByService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;

function getCountries() {
	return client.get('/countries');
}

function getAllStates() {
	var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { specialty: null, service: null, withProfessionals: false, withCenters: false };

	return client.get('states', { params: criteria });
}

function getStates() {
	var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { countryId: null, specialty: null, professional: null, service: null };

	return client.get('states', { params: criteria });
}

function getStatesByCountry() {
	var countryId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	return getStates({ countryId: countryId });
}

function getStateCities(stateId) {
	return client.get('cities/' + stateId);
}

function getProfStates() {
	var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { specialty: specialty, appointmentType: appointmentType };

	return client.get('states/getProfStates', { params: criteria });
}

function getCenterStates() {
	var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { specialty: specialty, appointmentType: appointmentType };

	return client.get('states/getCenterStates', { params: criteria });
}

function getStatesByService(serviceId) {
	return client.get('states/GetStatesByService', { params: { serviceId: serviceId } });
}

/* harmony default export */ __webpack_exports__["a"] = ({
	getCountries: getCountries,
	getAllStates: getAllStates,
	getStates: getStates,
	getStatesByCountry: getStatesByCountry,
	getStateCities: getStateCities,
	getProfStates: getProfStates,
	getCenterStates: getCenterStates,
	getStatesByService: getStatesByService
});

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FEMALE; });
var MALE = 'H';
var FEMALE = 'M';

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_appopensalud_css_vendor_v_select_scss__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_appopensalud_css_vendor_v_select_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_appopensalud_css_vendor_v_select_scss__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IMMEDIATE_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INPLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return WRITTEN; });
/* unused harmony export PERSONAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SECOND_OPINION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AT_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INSURANCE; });
/* unused harmony export CONSULTATIONS_TYPES_ICONS */
/* unused harmony export CONSULTATIONS_TYPES_COLOURS */
/* unused harmony export FLAT_RATE_ICON */
/* unused harmony export SERVICES_PACKAGES_ICON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TESTS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUDGET_ICON; });
/* unused harmony export ANALYSIS_ICON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OTHER_CONSULTATIONS_ICON; });
/* unused harmony export FLAT_RATE_COLOUR */
/* unused harmony export SERVICES_PACKAGES_COLOUR */
/* unused harmony export TESTS_COLOUR */
/* unused harmony export ANALYSIS_COLOUR */
/* unused harmony export DEFAULT_COLOUR */
/* harmony export (immutable) */ __webpack_exports__["n"] = getConsultationIconById;
/* unused harmony export getConsultationColourById */
/* harmony export (immutable) */ __webpack_exports__["o"] = getConsultationTitleById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__ = __webpack_require__(30);


var _CONSULTATIONS_TYPES_, _CONSULTATIONS_TYPES_2;



var IMMEDIATE_VIDEO = 1;
var INPLACE = 2;
var VIDEO = 4;
var WRITTEN = 5;
var PERSONAL = 6;
var SECOND_OPINION = 7;
var COMPANIES = 8;
var AT_HOME = 9;
var CHAT = 10;
var CALL = 11;
var INSURANCE = 12;

var iconsBasePath = '/static-appopensalud/img/icons/services/';
var CONSULTATIONS_TYPES_ICONS = (_CONSULTATIONS_TYPES_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, INPLACE, iconsBasePath + 'inplace.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, VIDEO, iconsBasePath + 'video.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, IMMEDIATE_VIDEO, iconsBasePath + 'immediate.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, WRITTEN, iconsBasePath + 'written.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, SECOND_OPINION, iconsBasePath + 'second-opinion.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, AT_HOME, iconsBasePath + 'at-home.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, CHAT, iconsBasePath + 'chat.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, CALL, iconsBasePath + 'call.svg'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_, INSURANCE, iconsBasePath + 'insurance.svg'), _CONSULTATIONS_TYPES_);
var CONSULTATIONS_TYPES_COLOURS = (_CONSULTATIONS_TYPES_2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, INPLACE, '#3498DB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, VIDEO, '#1ABC9C'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, IMMEDIATE_VIDEO, '#267F6E'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, WRITTEN, '#F39C12'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, SECOND_OPINION, '#9B59B6'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, AT_HOME, '#1D6089'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, CHAT, '#CD840F'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, CALL, '#A0A9E8'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_2, INSURANCE, '#5271FF'), _CONSULTATIONS_TYPES_2);

var FLAT_RATE_ICON = '/static-appopensalud/img/icons/services/flat-rate.svg';
var SERVICES_PACKAGES_ICON = '/static-appopensalud/img/icons/services/services-packages.svg';
var TESTS_ICON = '/static-appopensalud/img/icons/services/tests.svg';
var BUDGET_ICON = '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg';
var ANALYSIS_ICON = '/static-appopensalud/img/icons/services/analysis.svg';
var OTHER_CONSULTATIONS_ICON = '/static-appopensalud/img/icons/services/other-consultations.svg';
var FLAT_RATE_COLOUR = '#E8A0A4';
var SERVICES_PACKAGES_COLOUR = '#D2414C';
var TESTS_COLOUR = '#43B8C4';
var ANALYSIS_COLOUR = '#43B8C4';
var DEFAULT_COLOUR = '#3238C4';

function getConsultationIconById(consultationId) {
    return CONSULTATIONS_TYPES_ICONS[consultationId];
}
function getConsultationColourById(consultationId) {
    return CONSULTATIONS_TYPES_COLOURS[consultationId];
}
function getConsultationTitleById(consultationId) {
    var _CONSULTATIONS_TYPES_3;

    // included inside function because i18n not loaded in PrivateLayout
    var CONSULTATIONS_TYPES_TITLES = (_CONSULTATIONS_TYPES_3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, INPLACE, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-one')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, VIDEO, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-two')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, IMMEDIATE_VIDEO, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-five')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, WRITTEN, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-four')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, SECOND_OPINION, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-seven')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, AT_HOME, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-six')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, CHAT, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-three')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, CALL, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-ten')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_CONSULTATIONS_TYPES_3, INSURANCE, __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('services-title.type-eleven')), _CONSULTATIONS_TYPES_3);
    return consultationId ? CONSULTATIONS_TYPES_TITLES[consultationId] : CONSULTATIONS_TYPES_TITLES;
}

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__ = __webpack_require__(1001);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88233bf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__ = __webpack_require__(1630);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1628)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88233bf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88233bf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/BackButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-88233bf6", Component.options)
  } else {
    hotAPI.reload("data-v-88233bf6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowIcon_vue__ = __webpack_require__(945);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_457f5ec2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowIcon_vue__ = __webpack_require__(1517);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1515)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_457f5ec2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/icons/ArrowIcon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-457f5ec2", Component.options)
  } else {
    hotAPI.reload("data-v-457f5ec2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1240 */,
/* 1241 */,
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SMARTSUPP_ES */
/* unused harmony export SMARTSUPP_MX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPENPAY_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPENPAY_ID; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getSmartsuppKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_global_helpers__ = __webpack_require__(47);


var SMARTSUPP_ES = '2208bb3618a649a6e2e120bf7daf45d0e18594af';
var SMARTSUPP_MX = '75e63a8149f1eca528b1aca1f4a789c4b8fc115a';
var OPENPAY_API_KEY = __WEBPACK_IMPORTED_MODULE_0__helpers_global_helpers__["m" /* inProductionEnv */] ? 'pk_a5d322d100964e819ed5346f3837f6f0' : 'pk_b5acc0902c924292821de794c91f6fd3';
var OPENPAY_ID = __WEBPACK_IMPORTED_MODULE_0__helpers_global_helpers__["m" /* inProductionEnv */] ? 'mumpqe6et4bx9b5uethf' : 'mmzcbm6dlgqc6n4ikogz';
function getSmartsuppKey() {
    return window.location.href.includes('.mx') ? SMARTSUPP_MX : SMARTSUPP_ES;
}

/***/ }),
/* 1243 */,
/* 1244 */,
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__(992);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c7aad26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__(1627);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1614)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c7aad26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c7aad26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/forms/LoginForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8c7aad26", Component.options)
  } else {
    hotAPI.reload("data-v-8c7aad26", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyHabitsForm_vue__ = __webpack_require__(1088);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d6321e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyHabitsForm_vue__ = __webpack_require__(1705);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1693)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyHabitsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d6321e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyHabitsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-habits/HealthyHabitsForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37d6321e", Component.options)
  } else {
    hotAPI.reload("data-v-37d6321e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1247 */,
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MX_DOMAIN_EXTENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ES_DOMAIN_EXTENSION; });
var MX_DOMAIN_EXTENSION = '.mx';
var ES_DOMAIN_EXTENSION = '.es';

/***/ }),
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_CompanyServicesRepository__ = __webpack_require__(1686);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    goToFreedomAndFlow: function goToFreedomAndFlow() {
      __WEBPACK_IMPORTED_MODULE_0__repositories_CompanyServicesRepository__["a" /* default */].getFreedomAndFlowUrl().then(function (response) {
        window.location.href = response.data;
      });
    },
    goToWellwo: function goToWellwo() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      __WEBPACK_IMPORTED_MODULE_0__repositories_CompanyServicesRepository__["a" /* default */].getWellwoUrl(path).then(function (response) {
        window.location.href = response.data;
      });
    },
    goToRehBody: function goToRehBody() {
      __WEBPACK_IMPORTED_MODULE_0__repositories_CompanyServicesRepository__["a" /* default */].getRehBodyUrl().then(function (response) {
        window.location.href = response.data;
      });
    },
    goToTmc: function goToTmc(tmcEnabled) {
      if (tmcEnabled) {
        window.location.href = this.$helpers.getV2AppUrl('patient/sso-tmc');
      } else {
        this.$helpers.showSharedDialog(this.$t('companyServices.tmc.disabled.title'), this.$t('companyServices.tmc.disabled.message'));
      }
    },
    goToHealthyCommunity: function goToHealthyCommunity() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      window.open(this.$helpers.getHealthyCommunityUrl(path), '_blank');
    },
    goToWhoSignsUp: function goToWhoSignsUp() {
      this.goToHealthyCommunity('quienseapunta');
    },
    goToOpensaludPrime: function goToOpensaludPrime(token) {
      this.$helpers.goToPatientWebApp('goOpensaludprime', token);
    }
  }
});

/***/ }),
/* 1254 */,
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUPPORTED_SOUNDCARDS; });
var SUPPORTED_SOUNDCARDS = ['USB Audio Device', 'Sound Blaster Play! 3'];

/***/ }),
/* 1256 */,
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customHeader_vue__ = __webpack_require__(1085);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c37ff40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customHeader_vue__ = __webpack_require__(1684);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1682)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c37ff40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/professional/customHeader.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c37ff40", Component.options)
  } else {
    hotAPI.reload("data-v-0c37ff40", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAILY_GOAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WEEKLY_GOAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MONTHLY_GOAL; });
var DAILY_GOAL = 1;
var WEEKLY_GOAL = 2;
var MONTHLY_GOAL = 3;

/***/ }),
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = function client() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllUserChats: function getAllUserChats() {
    return client().get('appointments/Chats');
  },
  getChat: function getChat(appointmentId) {
    var pastChat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return client().get('appointments/Chats/GetAllChatMessages', { params: { appointmentId: appointmentId, pastChat: pastChat } });
  },
  getPastChat: function getPastChat(appointmentId) {
    return client().get('appointments/Chats/GetChatById', { params: { appointmentId: appointmentId } });
  },
  sendMessage: function sendMessage(appointmentId, msg, receiverId, file) {
    var chatMessage = {
      AppointmentId: appointmentId,
      Text: msg,
      ReceiverId: receiverId,
      File: file
    };
    return client().post('appointments/Chats/PostChatMessage', chatMessage);
  },
  deleteMessage: function deleteMessage(messageId) {
    return client().delete('appointments/Chats/DeleteChatMessage', { params: { chatId: messageId } });
  },
  getMessage: function getMessage(messageId) {
    return client().get('appointments/Chats/GetChatMessage', { params: { chatId: messageId }, loading: false });
  },
  editMessage: function editMessage(messageId, editedMessage) {
    return client().get('appointments/Chats/EditChatMessage', { params: { chatId: messageId, editedMessage: editedMessage } });
  }
});

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INDIVIDUAL_CODE_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDUCATIVE_CENTER_CODE_TYPE; });
/* unused harmony export CENTER_CODE_TYPE */
/* unused harmony export HOTELS_CODE_TYPE */
/* unused harmony export TRAVEL_CODE_TYPE */
/* unused harmony export GENERIC_CODE_TYPE */
var INDIVIDUAL_CODE_TYPE = 1;
var EDUCATIVE_CENTER_CODE_TYPE = 2;
var CENTER_CODE_TYPE = 3;
var HOTELS_CODE_TYPE = 4;
var TRAVEL_CODE_TYPE = 5;
var GENERIC_CODE_TYPE = 6;

/* unused harmony default export */ var _unused_webpack_default_export = ({
	INDIVIDUAL_CODE_TYPE: INDIVIDUAL_CODE_TYPE,
	EDUCATIVE_CENTER_CODE_TYPE: EDUCATIVE_CENTER_CODE_TYPE,
	CENTER_CODE_TYPE: CENTER_CODE_TYPE,
	HOTELS_CODE_TYPE: HOTELS_CODE_TYPE,
	TRAVEL_CODE_TYPE: TRAVEL_CODE_TYPE,
	GENERIC_CODE_TYPE: GENERIC_CODE_TYPE
});

/***/ }),
/* 1264 */,
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(1081);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9a21a6f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(1677);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1670)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a21a6f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9a21a6f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9a21a6f4", Component.options)
  } else {
    hotAPI.reload("data-v-9a21a6f4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumArticleBlock_vue__ = __webpack_require__(1100);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8b81d5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumArticleBlock_vue__ = __webpack_require__(1727);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1721)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumArticleBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8b81d5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumArticleBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/ForumArticleBlock.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a8b81d5a", Component.options)
  } else {
    hotAPI.reload("data-v-a8b81d5a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1267 */,
/* 1268 */,
/* 1269 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAKVQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////uP3jVQAAADd0Uk5TAE9lCAXd9XA4y/9zDQJG7HYB8Hc3yHoPQ8fuezMSoYPrEcEugj0tqb6G+Lw5ifHcKk3SIAx/MjRpS8YAAADsSURBVHic7dDJDoIwEIDhQURwQNGiIBVkUQH3BfX9H00MEvHW9qj9L3RIvkxTAJlMJvu1lI7aHtWOwm67Wk9vz3pP67Jro4+m1QyWiX2D3cJgqNmjt7ZGtjYccGAYK8R26qNjE2XMY6smU3Q9AM/F6YSTVrtnPp173pz6M969Lx1Q6rqUBgK2KvAR/UCIAoQLxEUoiCMSxyQSokmE6XKZYpQI2BVJ1wDrlKz4dXXn7PXN+G8e5lhk9TErMOd6tXCz3e2bYb/bbnj04Xg6f6bz6Xhgtxe8lu25vOKFGd/uj+8fj/uNfbVMJpP9QU/STxAzeUFqVwAAAABJRU5ErkJggg=="

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxyZWN0IGlkPSJiYWNrZ3JvdW5kcmVjdCIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgeD0iMCIgeT0iMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJub25lIi8+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTt9LmJ7ZmlsbDojNGU4Y2ZmO30uY3tjbGlwLXBhdGg6dXJsKCNhKTt9LmR7ZmlsbDojZmZmO30uZXtmaWxsOiNlZmY0Zjk7fTwvc3R5bGU+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBjbGFzcz0iYSIgZD0iTSAwIDAgSCAxNy41NTUgdiAxNy41NTUgSCAwIFoiIGlkPSJzdmdfMSIgdHJhbnNmb3JtPSIiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyBjbGFzcz0iY3VycmVudExheWVyIiBzdHlsZT0iIj48dGl0bGU+TGF5ZXIgMTwvdGl0bGU+PGcgaWQ9InN2Z18yIiBjbGFzcz0ic2VsZWN0ZWQiIHRyYW5zZm9ybT0iIj48ZyBpZD0ic3ZnXzMiIHRyYW5zZm9ybT0iIj48ZyBjbGFzcz0iYyIgaWQ9InN2Z180IiB0cmFuc2Zvcm09IiI+PGcgaWQ9InN2Z181IiB0cmFuc2Zvcm09IiI+PHBhdGggY2xhc3M9ImQiIGQ9Ik0gMTcuNTU2IDguNzc4NDIgYSA4Ljc3OCA4Ljc3OCAwIDAgMCAtOC43NzggLTguNzc4IGEgOC43NzggOC43NzggMCAwIDAgLTguNzc4IDguNzc4IGEgOC43NDUgOC43NDUgMCAwIDAgMi4yNiA1Ljg3OSB2IDEuNDQyIGMgMCAwLjggMC40OTIgMS40NTcgMS4xIDEuNDU3IGggNS44MyBhIDAuODQzIDAuODQzIDAgMCAwIDAuMTgzIC0wLjAyIGEgOC43NzggOC43NzggMCAwIDAgOC4xODQgLTguNzU3IiBpZD0ic3ZnXzYiIHRyYW5zZm9ybT0iIi8+PC9nPjxnIGlkPSJzdmdfNyIgdHJhbnNmb3JtPSIiPjxwYXRoIGNsYXNzPSJlIiBkPSJNIDMuMTYxNDggOC45MjEgYSA5LjI5MiA5LjI5MiAwIDAgMSA2LjM4IC04Ljg4OCBjIC0wLjI1MiAtMC4wMjIgLTAuNTA2IC0wLjAzMyAtMC43NjMgLTAuMDMzIGEgOC43NzQgOC43NzQgMCAwIDAgLTguNzc4IDguNzc4IEEgOS41MDggOS41MDggMCAwIDAgMi4yMjQ0NyAxNC43MDAzIGMgMC4wMDUgMCAwIDAuMDA5IDAgMC4wMSBjIC0wLjMxMSAwLjM1MiAtMS45MjQgMi44NDkgMC4wMjEgMi44NDkgaCAyLjI1IGMgLTEuMjMgLTAuMDIyIDEuMjYzIC0yLjEwNyAwLjI2OSAtMy40OTQgYSA4LjIyNSA4LjIyNSAwIDAgMSAtMS42IC01LjE0MSIgaWQ9InN2Z184IiB0cmFuc2Zvcm09IiIvPjwvZz48L2c+PC9nPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDcuOTcxIDQ3Ljk3MSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcuOTcxIDQ3Ljk3MTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZD0iTTI4LjIyOCwyMy45ODZMNDcuMDkyLDUuMTIyYzEuMTcyLTEuMTcxLDEuMTcyLTMuMDcxLDAtNC4yNDJjLTEuMTcyLTEuMTcyLTMuMDctMS4xNzItNC4yNDIsMEwyMy45ODYsMTkuNzQ0TDUuMTIxLDAuODgNCgkJYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBjLTEuMTcyLDEuMTcxLTEuMTcyLDMuMDcxLDAsNC4yNDJsMTguODY1LDE4Ljg2NEwwLjg3OSw0Mi44NWMtMS4xNzIsMS4xNzEtMS4xNzIsMy4wNzEsMCw0LjI0Mg0KCQlDMS40NjUsNDcuNjc3LDIuMjMzLDQ3Ljk3LDMsNDcuOTdzMS41MzUtMC4yOTMsMi4xMjEtMC44NzlsMTguODY1LTE4Ljg2NEw0Mi44NSw0Ny4wOTFjMC41ODYsMC41ODYsMS4zNTQsMC44NzksMi4xMjEsMC44NzkNCgkJczEuNTM1LTAuMjkzLDIuMTIxLTAuODc5YzEuMTcyLTEuMTcxLDEuMTcyLTMuMDcxLDAtNC4yNDJMMjguMjI4LDIzLjk4NnoiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);



var opts = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a(opts));

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSpinInput_vue__ = __webpack_require__(1084);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e0113ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSpinInput_vue__ = __webpack_require__(1681);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1679)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSpinInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e0113ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSpinInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseSpinInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9e0113ae", Component.options)
  } else {
    hotAPI.reload("data-v-9e0113ae", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryGrantAccess_vue__ = __webpack_require__(1086);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76349f96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryGrantAccess_vue__ = __webpack_require__(1689);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1687)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76349f96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryGrantAccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76349f96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryGrantAccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryGrantAccess.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-76349f96", Component.options)
  } else {
    hotAPI.reload("data-v-76349f96", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryProfAndCenterAuthorized_vue__ = __webpack_require__(1087);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0ea1a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryProfAndCenterAuthorized_vue__ = __webpack_require__(1692);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1690)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d0ea1a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryProfAndCenterAuthorized_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0ea1a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryProfAndCenterAuthorized_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryProfAndCenterAuthorized.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d0ea1a4", Component.options)
  } else {
    hotAPI.reload("data-v-3d0ea1a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1281 */,
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyHabitsPredefined_vue__ = __webpack_require__(1089);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102d2373_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyHabitsPredefined_vue__ = __webpack_require__(1703);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1700)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyHabitsPredefined_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102d2373_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyHabitsPredefined_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-habits/HealthyHabitsPredefined.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-102d2373", Component.options)
  } else {
    hotAPI.reload("data-v-102d2373", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_touch_events__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_touch_events__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue2_touch_events___default.a);

/***/ }),
/* 1284 */,
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTab_vue__ = __webpack_require__(1091);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60886486_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTab_vue__ = __webpack_require__(1712);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1710)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60886486_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/patient/SearchTab.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60886486", Component.options)
  } else {
    hotAPI.reload("data-v-60886486", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1286 */,
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginFormModal_vue__ = __webpack_require__(1098);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8dbdeca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginFormModal_vue__ = __webpack_require__(1719);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1717)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginFormModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8dbdeca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginFormModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/modals/LoginFormModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8dbdeca", Component.options)
  } else {
    hotAPI.reload("data-v-d8dbdeca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumMessageBlock_vue__ = __webpack_require__(1104);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25bba162_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumMessageBlock_vue__ = __webpack_require__(1732);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1730)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25bba162"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumMessageBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25bba162_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumMessageBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/ForumMessageBlock.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25bba162", Component.options)
  } else {
    hotAPI.reload("data-v-25bba162", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_axiosApis__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_vue_cookies__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_i18n_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_i18n_helpers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_domains_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_domains_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_domains_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sentry_browser__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sentry_integrations__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sentry_tracing__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_validators__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_upperFirst__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_camelCase__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_session__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_scrollto__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__plugins_registerGlobalComponents__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__plugins_vuetify__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_gtag__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_v_click_outside__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_v_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_v_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_html2canvas__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_regenerator_runtime__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_regenerator_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_regenerator_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuelidate_error_extractor__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_vue_beautiful_chat__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_vue_beautiful_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_vue_beautiful_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__constants_cookies__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__static_appopensalud_css_scss_misc_scss__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__static_appopensalud_css_scss_misc_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__static_appopensalud_css_scss_misc_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_tree_navigation__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_tree_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vue_tree_navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__helpers_ui_helpers__ = __webpack_require__(162);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




/* import BootstrapVue from 'bootstrap-vue' */



















 // path to vuetify export









if (window.location.href.includes('openlegal') && !window.location.href.includes('/abogados')) {
  /* require('../static-appopensalud/css/openlegal/colors.scss') */
  __webpack_require__(1982);
} else {
  /* require('../static-appopensalud/css/scss/colors.scss') */
  __webpack_require__(1983);
}



if (window.location.href.includes('opensaludprime')) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_gtag__["a" /* default */], {
    config: { id: 'G-MNCV80RN1Y' }
  });
}




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_session___default.a, { persist: true });
/* Vue.use(BootstrapVue) */
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_vue_cookies__);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__plugins_axiosApis__["a" /* default */], { store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_meta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_bootstrap_vue__["_58" /* VBTooltipPlugin */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_bootstrap_vue__["_56" /* VBTogglePlugin */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_bootstrap_vue__["_52" /* BootstrapVueIcons */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23__plugins_registerGlobalComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_vue_html2canvas___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue_scrollto___default.a, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  y: false
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_v_click_outside___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30__components_vue_beautiful_chat___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34_vue_tree_navigation___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_vuelidate_error_extractor__["a" /* default */], {
  /**
   * Optionally provide the template in the configuration. 
   * or register like so Vue.component("FormField", templates.singleErrorExtractor.foundation6)
   */
  template: __WEBPACK_IMPORTED_MODULE_29_vuelidate_error_extractor__["b" /* templates */].singleErrorExtractor.bootstrap4 // you can also pass your own custom template
});

/* Vue.use(VueTreeNavigation) */

// Used to register layout components globally (allows using it without importing in single vue component file)
var requireComponent = __webpack_require__(1986);

__webpack_require__(2119);
__webpack_require__(2121);

requireComponent.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponent(fileName);
  // Get PascalCase name of component
  var componentName = __WEBPACK_IMPORTED_MODULE_18_lodash_upperFirst___default()(__WEBPACK_IMPORTED_MODULE_19_lodash_camelCase___default()(fileName.split('/').pop().replace(/\.\w+$/, '')));

  // Register component globally
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(componentName,
  // Look for the component options on `.default`, which will
  // exist if the component was exported with `export default`,
  // otherwise fall back to module's root.
  componentConfig.default || componentConfig);
});

__WEBPACK_IMPORTED_MODULE_14__sentry_browser__["b" /* init */]({
  Vue: __WEBPACK_IMPORTED_MODULE_1_vue__["default"],
  autoSessionTracking: true,
  dsn: 'https://f427a5a410a9d72c9775e322c07977a0@o4508794609860609.ingest.de.sentry.io/4508794677493840',
  integrations: [new __WEBPACK_IMPORTED_MODULE_16__sentry_tracing__["a" /* Integrations */].BrowserTracing(), new __WEBPACK_IMPORTED_MODULE_15__sentry_integrations__["a" /* Vue */]({
    Vue: __WEBPACK_IMPORTED_MODULE_1_vue__["default"],
    tracing: true,
    attachProps: true
  })],
  tracingOptions: {
    trackComponents: true
  },
  sendDefaultPii: true,
  environment: Object(__WEBPACK_IMPORTED_MODULE_32__helpers_global_helpers__["g" /* getEnvironmentName */])() + '-' + Object(__WEBPACK_IMPORTED_MODULE_32__helpers_global_helpers__["d" /* getCountry */])()
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.errorHandler = function (err, vm, info) {
  __WEBPACK_IMPORTED_MODULE_14__sentry_browser__["a" /* captureException */]('Vuejs Error: ' + err.stack + '\nComponent: ' + (vm != null ? vm.$options.name : '') + '\nInfo: ' + info);
  // Vue.rollbar.error(`Vuejs Error: ${err.stack}\nComponent: ${vm != null ? vm.$options.name : ''}\nInfo: ${info}`)
  console.error(err);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

// Get query param 't' from url
var urlParams = new URLSearchParams(window.location.search);
var token = urlParams.get('t') || urlParams.get('api_token') || urlParams.get('token');

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$apiToken = window.$cookies.get(__WEBPACK_IMPORTED_MODULE_31__constants_cookies__["b" /* API_TOKEN_COOKIE_NAME */]) || token;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$helpers = __WEBPACK_IMPORTED_MODULE_12__helpers__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$uiHelpers = __WEBPACK_IMPORTED_MODULE_35__helpers_ui_helpers__["b" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$i18nHelpers = __WEBPACK_IMPORTED_MODULE_11__helpers_i18n_helpers__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$domains = __WEBPACK_IMPORTED_MODULE_13__static_domains_json___default.a;
/* Vue.prototype.$filters = Vue.options.filters */
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$validators = __WEBPACK_IMPORTED_MODULE_17__plugins_validators__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$history = window.history;

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  i18n: __WEBPACK_IMPORTED_MODULE_10__plugins_i18n_js__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  vuetify: __WEBPACK_IMPORTED_MODULE_24__plugins_vuetify__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  mounted: function mounted() {}
}).inEs;

window.root = vm;

/***/ }),
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1311);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1302)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1303);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2c113a5e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports
exports.i(__webpack_require__(1304), "");
exports.i(__webpack_require__(1305), "");

// module
exports.push([module.i, "\n.fade-enter-active, .fade-leave-active {\r\n  -webkit-transition: opacity .4s;\r\n  transition: opacity .4s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\r\n  opacity: 0;\n}\n.dropdown-item img {\r\n  margin-right:10px;\n}\r\n", ""]);

// exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "  #app {\r\n    font-family: 'Space Grotesk', sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    \r\n  }\r\n\r\n  #videoTemplate {\r\n    background-image: url(\"/static-appopensalud/img/background.svg\");\r\n    background-repeat: no-repeat;\r\n    background-attachment: fixed;\r\n    background-position: center;\r\n    width: 100vw;\r\n    height: calc(100vh);\r\n    /* background-color: #E4E4E4; */\r\n  }\r\n\r\n  .b-table-sticky-header > .table.b-table > thead > tr > th {\r\n    top: -1px !important;\r\n  }\r\n\r\n  .custom-select {\r\n    font-size:0.875rem;\r\n  }\r\n\r\n  .b-form-spinbutton {\r\n    font-size:0.875rem;\r\n  }\r\n\r\n  .input-group-text {\r\n    font-size:0.875rem;\r\n  }\r\n\r\n  #smartsupp-widget-container > div {\r\n    z-index: 1000 !important;\r\n  }", ""]);

// exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "#menu-top {\r\n    position: absolute;\r\n    background-color: rgba(255, 255, 255, 0.9);\r\n    top: 0px;\r\n    left: 0px;\r\n    height: 60px;\r\n    padding: 10px;\r\n    width: 100%;\r\n}\r\n\r\n#navigation-bar-logo {\r\n    margin-left: 20px;\r\n    height: 40px;\r\n    width: auto;\r\n}\r\n\r\n.dropdown-item-checked::before {\r\n    position: absolute;\r\n    left: .4rem;\r\n    content: '\\2713';\r\n    font-weight: 600;\r\n  }\r\n\r\n /* .nav-link img { \r\n    padding-bottom: 4px; \r\n    height: 16px;\r\n    width: 16px;\r\n }  */\r\n\r\n.flag {\r\n    height: 16px;\r\n    width: 16px; \r\n}\r\n\r\n.nav-item .border-left {\r\n    border-left-color: #333;\r\n    border-left-style: solid;\r\n    border-left-width: 1px;\r\n    margin-left: 5px;\r\n}", ""]);

// exports


/***/ }),
/* 1306 */,
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GtagIframe_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e2e7b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GtagIframe_vue__ = __webpack_require__(1310);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1308)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GtagIframe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e2e7b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GtagIframe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/GtagIframe.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-97e2e7b6", Component.options)
  } else {
    hotAPI.reload("data-v-97e2e7b6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1309);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("45221d95", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-97e2e7b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GtagIframe.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-97e2e7b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GtagIframe.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inOpensaludES
    ? _c("noscript", [
        _c("iframe", {
          staticStyle: { display: "none", visibility: "hidden" },
          attrs: {
            src: "//www.googletagmanager.com/ns.html?id=GTM-KHHSWQZ",
            height: "0",
            width: "0"
          }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97e2e7b6", esExports)
  }
}

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "main",
        [
          _c("gtag-iframe"),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isbot; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}
function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
  _classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _classPrivateMethodInitSpec(obj, privateSet) {
  _checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}

var list = [
	" daum[ /]",
	" deusu/",
	"(?:^| )site",
	"@[a-z]",
	"\\(at\\)[a-z]",
	"\\(github\\.com/",
	"\\[at\\][a-z]",
	"^12345",
	"^<",
	"^[\\w \\.\\-\\(\\)]+(/v?\\d+(\\.\\d+)?(\\.\\d{1,10})?)?$",
	"^[^ ]{50,}$",
	"^active",
	"^ad muncher",
	"^anglesharp/",
	"^anonymous",
	"^avsdevicesdk/",
	"^axios/",
	"^bidtellect/",
	"^biglotron",
	"^castro",
	"^clamav[ /]",
	"^cobweb/",
	"^coccoc",
	"^custom",
	"^ddg[_-]android",
	"^discourse",
	"^dispatch/\\d",
	"^downcast/",
	"^duckduckgo",
	"^facebook",
	"^fdm[ /]\\d",
	"^getright/",
	"^gozilla/",
	"^hatena",
	"^hobbit",
	"^hotzonu",
	"^hwcdn/",
	"^jeode/",
	"^jetty/",
	"^jigsaw",
	"^linkdex",
	"^lwp[-: ]",
	"^metauri",
	"^microsoft bits",
	"^movabletype",
	"^mozilla/\\d\\.\\d \\(compatible;?\\)$",
	"^mozilla/\\d\\.\\d \\w*$",
	"^navermailapp",
	"^netsurf",
	"^offline explorer",
	"^phantom",
	"^php",
	"^postman",
	"^postrank",
	"^python",
	"^read",
	"^reed",
	"^restsharp/",
	"^snapchat",
	"^space bison",
	"^svn",
	"^swcd ",
	"^taringa",
	"^test certificate info",
	"^thumbor/",
	"^tumblr/",
	"^user-agent:mozilla",
	"^valid",
	"^venus/fedoraplanet",
	"^w3c",
	"^webbandit/",
	"^webcopier",
	"^wget",
	"^whatsapp",
	"^xenu link sleuth",
	"^yahoo",
	"^yandex",
	"^zdm/\\d",
	"^zoom marketplace/",
	"^{{.*}}$",
	"adbeat\\.com",
	"appinsights",
	"archive",
	"ask jeeves/teoma",
	"bit\\.ly/",
	"bluecoat drtr",
	"bot",
	"browsex",
	"burpcollaborator",
	"capture",
	"catch",
	"check",
	"chrome-lighthouse",
	"chromeframe",
	"client",
	"cloud",
	"crawl",
	"dareboost",
	"datanyze",
	"dataprovider",
	"dejaclick",
	"dmbrowser",
	"download",
	"evc-batch/",
	"feed",
	"firephp",
	"freesafeip",
	"ghost",
	"gomezagent",
	"google",
	"headlesschrome/",
	"http",
	"httrack",
	"hubspot marketing grader",
	"hydra",
	"ibisbrowser",
	"images",
	"iplabel",
	"ips-agent",
	"java",
	"library",
	"mail\\.ru/",
	"manager",
	"monitor",
	"morningscore/",
	"neustar wpm",
	"news",
	"nutch",
	"offbyone",
	"optimize",
	"pageburst",
	"pagespeed",
	"perl",
	"pingdom",
	"powermarks",
	"preview",
	"proxy",
	"ptst[ /]\\d",
	"reader",
	"rexx;",
	"rigor",
	"rss",
	"scan",
	"scrape",
	"search",
	"serp ?reputation ?management",
	"server",
	"sogou",
	"sparkler/",
	"spider",
	"statuscake",
	"stumbleupon\\.com",
	"supercleaner",
	"synapse",
	"synthetic",
	"taginspector/",
	"torrent",
	"tracemyfile",
	"transcoder",
	"trendsmapresolver",
	"twingly recon",
	"url",
	"virtuoso",
	"wappalyzer",
	"webglance",
	"webkit2png",
	"websitemetadataretriever",
	"whatcms/",
	"wordpress",
	"zgrab"
];

/**
 * Mutate given list of patter strings
 * @param {string[]} list
 * @returns {string[]}
 */
function amend(list) {
  try {
    // Risk: Uses lookbehind assertion, avoid breakage in parsing by using RegExp constructor
    new RegExp('(?<! cu)bot').test('dangerbot'); // eslint-disable-line prefer-regex-literals
  } catch (error) {
    // Skip regex fixes
    return list;
  }
  [
  // Addresses: Cubot device
  ['bot', '(?<! cu)bot'],
  // Addresses: Android webview
  ['google', '(?<! (?:channel/|google/))google(?!(app|/google| pixel))'],
  // Addresses: libhttp browser
  ['http', '(?<!(?:lib))http'],
  // Addresses: java based browsers
  ['java', 'java(?!;)'],
  // Addresses: Yandex Search App
  ['search', '(?<! ya(?:yandex)?)search']].forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      search = _ref2[0],
      replace = _ref2[1];
    var index = list.lastIndexOf(search);
    if (~index) {
      list.splice(index, 1, replace);
    }
  });
  return list;
}

amend(list);
var flags = 'i';

/**
 * Test user agents for matching patterns
 */
var _list = /*#__PURE__*/new WeakMap();
var _pattern = /*#__PURE__*/new WeakMap();
var _update = /*#__PURE__*/new WeakSet();
var _index = /*#__PURE__*/new WeakSet();
var Isbot = /*#__PURE__*/function () {
  /**
   * @type {string[]}
   */

  /**
   * @type {RegExp}
   */

  function Isbot(patterns) {
    var _this = this;
    _classCallCheck(this, Isbot);
    _classPrivateMethodInitSpec(this, _index);
    _classPrivateMethodInitSpec(this, _update);
    _classPrivateFieldInitSpec(this, _list, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _pattern, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _list, patterns || list.slice());
    _classPrivateMethodGet(this, _update, _update2).call(this);
    var isbot = function isbot(ua) {
      return _this.test(ua);
    };
    return Object.defineProperties(isbot, Object.entries(Object.getOwnPropertyDescriptors(Isbot.prototype)).reduce(function (accumulator, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        prop = _ref2[0],
        descriptor = _ref2[1];
      if (typeof descriptor.value === 'function') {
        Object.assign(accumulator, _defineProperty({}, prop, {
          value: _this[prop].bind(_this)
        }));
      }
      if (typeof descriptor.get === 'function') {
        Object.assign(accumulator, _defineProperty({}, prop, {
          get: function get() {
            return _this[prop];
          }
        }));
      }
      return accumulator;
    }, {}));
  }

  /**
   * Recreate the pattern from rules list
   */
  _createClass(Isbot, [{
    key: "pattern",
    get:
    /**
     * Get a clone of the pattern
     * @type RegExp
     */
    function get() {
      return new RegExp(_classPrivateFieldGet(this, _pattern));
    }

    /**
     * Match given string against out pattern
     * @param  {string} ua User Agent string
     * @returns {boolean}
     */
  }, {
    key: "test",
    value: function test(ua) {
      return Boolean(ua) && _classPrivateFieldGet(this, _pattern).test(ua);
    }

    /**
     * Get the match for strings' known crawler pattern
     * @param  {string} ua User Agent string
     * @returns {string|null}
     */
  }, {
    key: "find",
    value: function find() {
      var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var match = ua.match(_classPrivateFieldGet(this, _pattern));
      return match && match[0];
    }

    /**
     * Get the patterns that match user agent string if any
     * @param  {string} ua User Agent string
     * @returns {string[]}
     */
  }, {
    key: "matches",
    value: function matches() {
      var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _classPrivateFieldGet(this, _list).filter(function (entry) {
        return new RegExp(entry, flags).test(ua);
      });
    }

    /**
     * Clear all patterns that match user agent
     * @param  {string} ua User Agent string
     * @returns {void}
     */
  }, {
    key: "clear",
    value: function clear() {
      var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.exclude(this.matches(ua));
    }

    /**
     * Extent patterns for known crawlers
     * @param  {string[]} filters
     * @returns {void}
     */
  }, {
    key: "extend",
    value: function extend() {
      var _this2 = this;
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      [].push.apply(_classPrivateFieldGet(this, _list), filters.filter(function (rule) {
        return _classPrivateMethodGet(_this2, _index, _index2).call(_this2, rule) === -1;
      }).map(function (filter) {
        return filter.toLowerCase();
      }));
      _classPrivateMethodGet(this, _update, _update2).call(this);
    }

    /**
     * Exclude patterns from bot pattern rule
     * @param  {string[]} filters
     * @returns {void}
     */
  }, {
    key: "exclude",
    value: function exclude() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var length = filters.length;
      while (length--) {
        var index = _classPrivateMethodGet(this, _index, _index2).call(this, filters[length]);
        if (index > -1) {
          _classPrivateFieldGet(this, _list).splice(index, 1);
        }
      }
      _classPrivateMethodGet(this, _update, _update2).call(this);
    }

    /**
     * Create a new Isbot instance using given list or self's list
     * @param  {string[]} [list]
     * @returns {Isbot}
     */
  }, {
    key: "spawn",
    value: function spawn(list) {
      return new Isbot(list || _classPrivateFieldGet(this, _list));
    }
  }]);
  return Isbot;
}();
function _update2() {
  _classPrivateFieldSet(this, _pattern, new RegExp(_classPrivateFieldGet(this, _list).join('|'), flags));
}
function _index2(rule) {
  return _classPrivateFieldGet(this, _list).indexOf(rule.toLowerCase());
}

var isbot = new Isbot();


//# sourceMappingURL=index.mjs.map


/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEV_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TEST_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROD_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCAL_ENV; });
var DEV_ENV = 'development';
var TEST_ENV = 'staging';
var PROD_ENV = 'production';
var LOCAL_ENV = 'local';

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/global-variables.json": [
		311
	],
	"./es/global-variables.json": [
		224
	],
	"./mx/global-variables.json": [
		312
	],
	"./pt/global-variables.json": [
		313
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1338;
module.exports = webpackAsyncContext;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/common.json": [
		314
	],
	"./es/common.json": [
		189
	],
	"./mx/common.json": [
		315
	],
	"./pt/common.json": [
		316
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1339;
module.exports = webpackAsyncContext;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./clinic-history.json": [
		284
	],
	"./common.json": [
		189
	],
	"./forms/companies-contact-form.json": [
		279
	],
	"./global-variables.json": [
		224
	],
	"./payments.json": [
		295
	],
	"./private-layout.json": [
		317
	],
	"./public/footer-360.json": [
		296
	],
	"./public/footer-openlegal.json": [
		298
	],
	"./public/footer-opensalud.json": [
		282
	],
	"./public/simple-search.json": [
		318
	],
	"./public/views/360.json": [
		319
	],
	"./public/views/abogalitypro.json": [
		320
	],
	"./public/views/account/login.json": [
		321
	],
	"./public/views/account/password-update.json": [
		322
	],
	"./public/views/account/update-required-data.json": [
		323
	],
	"./public/views/cookies-policy.json": [
		324
	],
	"./public/views/faqs.json": [
		325
	],
	"./public/views/healthy-community.json": [
		326
	],
	"./public/views/healthy-habits.json": [
		327
	],
	"./public/views/legal-areas.json": [
		225
	],
	"./public/views/legal-warning.json": [
		328
	],
	"./public/views/mindfulness.json": [
		286
	],
	"./public/views/openlegal.json": [
		329
	],
	"./public/views/opensalud-empresas-new.json": [
		330
	],
	"./public/views/opensalud-empresas.json": [
		331
	],
	"./public/views/opensalud-pacientes.json": [
		288
	],
	"./public/views/opensalud-principal.json": [
		332
	],
	"./public/views/opensalud-profesionales.json": [
		333
	],
	"./public/views/opensalud4all.json": [
		299
	],
	"./public/views/patient/appointments.json": [
		334
	],
	"./public/views/patient/foods.json": [
		335
	],
	"./public/views/patient/menu-banners.json": [
		336
	],
	"./public/views/patient/microhabits.json": [
		337
	],
	"./public/views/patient/panel.json": [
		338
	],
	"./public/views/patient/search.json": [
		339
	],
	"./public/views/primesalud-discounts.json": [
		289
	],
	"./public/views/primesalud-medical-assistance.json": [
		297
	],
	"./public/views/primesalud-wellness.json": [
		290
	],
	"./public/views/primesalud.json": [
		287
	],
	"./public/views/privacy-policy-professional.json": [
		226
	],
	"./public/views/privacy-policy.json": [
		227
	],
	"./public/views/pyme.json": [
		340
	],
	"./public/views/selfEvaluationTests.json": [
		341
	],
	"./public/views/sgsi-policy.json": [
		342
	],
	"./public/views/shared/chat.json": [
		343
	],
	"./public/views/survey.json": [
		344
	],
	"./public/views/unipromel.json": [
		345
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1340;
module.exports = webpackAsyncContext;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/clinic-history.json": [
		512
	],
	"./en/common.json": [
		314
	],
	"./en/faqs.json": [
		560
	],
	"./en/forms/companies-contact-form.json": [
		503
	],
	"./en/global-variables.json": [
		311
	],
	"./en/payments.json": [
		529
	],
	"./en/private-layout.json": [
		561
	],
	"./en/public/footer-360.json": [
		530
	],
	"./en/public/footer-openlegal.json": [
		535
	],
	"./en/public/footer-opensalud.json": [
		510
	],
	"./en/public/simple-search.json": [
		562
	],
	"./en/public/views/360.json": [
		563
	],
	"./en/public/views/abogalitypro.json": [
		564
	],
	"./en/public/views/account/login.json": [
		565
	],
	"./en/public/views/account/password-update.json": [
		566
	],
	"./en/public/views/account/update-required-data.json": [
		567
	],
	"./en/public/views/cookies-policy.json": [
		568
	],
	"./en/public/views/healthy-community.json": [
		569
	],
	"./en/public/views/healthy-habits.json": [
		570
	],
	"./en/public/views/legal-areas.json": [
		571
	],
	"./en/public/views/legal-warning.json": [
		572
	],
	"./en/public/views/mindfulness.json": [
		514
	],
	"./en/public/views/openlegal.json": [
		573
	],
	"./en/public/views/opensalud-empresas-new.json": [
		574
	],
	"./en/public/views/opensalud-empresas.json": [
		575
	],
	"./en/public/views/opensalud-pacientes.json": [
		519
	],
	"./en/public/views/opensalud-principal.json": [
		576
	],
	"./en/public/views/opensalud-profesionales.json": [
		577
	],
	"./en/public/views/opensalud4all.json": [
		536
	],
	"./en/public/views/patient/appointments.json": [
		578
	],
	"./en/public/views/patient/foods.json": [
		579
	],
	"./en/public/views/patient/menu-banner.json": [
		580
	],
	"./en/public/views/patient/microhabits.json": [
		581
	],
	"./en/public/views/patient/panel.json": [
		582
	],
	"./en/public/views/patient/search.json": [
		583
	],
	"./en/public/views/primesalud-discounts.json": [
		520
	],
	"./en/public/views/primesalud-medical-assistance.json": [
		531
	],
	"./en/public/views/primesalud-wellness.json": [
		521
	],
	"./en/public/views/primesalud.json": [
		515
	],
	"./en/public/views/privacy-policy-professional.json": [
		346
	],
	"./en/public/views/privacy-policy.json": [
		347
	],
	"./en/public/views/pyme.json": [
		584
	],
	"./en/public/views/selfEvaluationTests.json": [
		585
	],
	"./en/public/views/sgsi-policy.json": [
		586
	],
	"./en/public/views/shared/chat.json": [
		587
	],
	"./en/public/views/survey.json": [
		588
	],
	"./en/public/views/unipromel.json": [
		589
	],
	"./es/clinic-history.json": [
		284
	],
	"./es/common.json": [
		189
	],
	"./es/forms/companies-contact-form.json": [
		279
	],
	"./es/global-variables.json": [
		224
	],
	"./es/payments.json": [
		295
	],
	"./es/private-layout.json": [
		317
	],
	"./es/public/footer-360.json": [
		296
	],
	"./es/public/footer-openlegal.json": [
		298
	],
	"./es/public/footer-opensalud.json": [
		282
	],
	"./es/public/simple-search.json": [
		318
	],
	"./es/public/views/360.json": [
		319
	],
	"./es/public/views/abogalitypro.json": [
		320
	],
	"./es/public/views/account/login.json": [
		321
	],
	"./es/public/views/account/password-update.json": [
		322
	],
	"./es/public/views/account/update-required-data.json": [
		323
	],
	"./es/public/views/cookies-policy.json": [
		324
	],
	"./es/public/views/faqs.json": [
		325
	],
	"./es/public/views/healthy-community.json": [
		326
	],
	"./es/public/views/healthy-habits.json": [
		327
	],
	"./es/public/views/legal-areas.json": [
		225
	],
	"./es/public/views/legal-warning.json": [
		328
	],
	"./es/public/views/mindfulness.json": [
		286
	],
	"./es/public/views/openlegal.json": [
		329
	],
	"./es/public/views/opensalud-empresas-new.json": [
		330
	],
	"./es/public/views/opensalud-empresas.json": [
		331
	],
	"./es/public/views/opensalud-pacientes.json": [
		288
	],
	"./es/public/views/opensalud-principal.json": [
		332
	],
	"./es/public/views/opensalud-profesionales.json": [
		333
	],
	"./es/public/views/opensalud4all.json": [
		299
	],
	"./es/public/views/patient/appointments.json": [
		334
	],
	"./es/public/views/patient/foods.json": [
		335
	],
	"./es/public/views/patient/menu-banners.json": [
		336
	],
	"./es/public/views/patient/microhabits.json": [
		337
	],
	"./es/public/views/patient/panel.json": [
		338
	],
	"./es/public/views/patient/search.json": [
		339
	],
	"./es/public/views/primesalud-discounts.json": [
		289
	],
	"./es/public/views/primesalud-medical-assistance.json": [
		297
	],
	"./es/public/views/primesalud-wellness.json": [
		290
	],
	"./es/public/views/primesalud.json": [
		287
	],
	"./es/public/views/privacy-policy-professional.json": [
		226
	],
	"./es/public/views/privacy-policy.json": [
		227
	],
	"./es/public/views/pyme.json": [
		340
	],
	"./es/public/views/selfEvaluationTests.json": [
		341
	],
	"./es/public/views/sgsi-policy.json": [
		342
	],
	"./es/public/views/shared/chat.json": [
		343
	],
	"./es/public/views/survey.json": [
		344
	],
	"./es/public/views/unipromel.json": [
		345
	],
	"./mx/common.json": [
		315
	],
	"./mx/global-variables.json": [
		312
	],
	"./mx/public/footer-opensalud.json": [
		590
	],
	"./mx/public/footer.json": [
		591
	],
	"./mx/public/shared/views/healthy-community.json": [
		592
	],
	"./mx/public/shared/views/selfEvaluationTests.json": [
		593
	],
	"./mx/public/views/account/password-update.json": [
		594
	],
	"./mx/public/views/healthy-community.json": [
		595
	],
	"./mx/public/views/opensalud-profesionales.json": [
		596
	],
	"./mx/public/views/privacy-policy-professional.json": [
		348
	],
	"./mx/public/views/privacy-policy.json": [
		349
	],
	"./mx/public/views/pyme.json": [
		597
	],
	"./mx/public/views/sgsi-policy.json": [
		598
	],
	"./mx/public/views/survey.json": [
		599
	],
	"./pt/clinic-history.json": [
		517
	],
	"./pt/common.json": [
		316
	],
	"./pt/forms/companies-contact-form.json": [
		504
	],
	"./pt/global-variables.json": [
		313
	],
	"./pt/payments.json": [
		532
	],
	"./pt/private-layout.json": [
		600
	],
	"./pt/public/footer-360.json": [
		601
	],
	"./pt/public/footer-opensalud.json": [
		516
	],
	"./pt/public/simple-search.json": [
		602
	],
	"./pt/public/views/360.json": [
		603
	],
	"./pt/public/views/abogalitypro.json": [
		604
	],
	"./pt/public/views/account/login.json": [
		605
	],
	"./pt/public/views/account/password-update.json": [
		606
	],
	"./pt/public/views/account/update-required-data.json": [
		607
	],
	"./pt/public/views/cookies-policy.json": [
		608
	],
	"./pt/public/views/faqs.json": [
		609
	],
	"./pt/public/views/healthy-community.json": [
		610
	],
	"./pt/public/views/healthy-habits.json": [
		611
	],
	"./pt/public/views/legal-warning.json": [
		612
	],
	"./pt/public/views/mindfulness.json": [
		613
	],
	"./pt/public/views/openlegal.json": [
		614
	],
	"./pt/public/views/opensalud-empresas-new.json": [
		615
	],
	"./pt/public/views/opensalud-empresas.json": [
		616
	],
	"./pt/public/views/opensalud-pacientes.json": [
		617
	],
	"./pt/public/views/opensalud-principal.json": [
		618
	],
	"./pt/public/views/opensalud-profesionales.json": [
		619
	],
	"./pt/public/views/opensalud4all.json": [
		537
	],
	"./pt/public/views/patient/appointments.json": [
		620
	],
	"./pt/public/views/patient/foods.json": [
		621
	],
	"./pt/public/views/patient/menu-banners.json": [
		622
	],
	"./pt/public/views/patient/microhabits.json": [
		623
	],
	"./pt/public/views/patient/panel.json": [
		624
	],
	"./pt/public/views/patient/search.json": [
		625
	],
	"./pt/public/views/primesalud-discounts.json": [
		626
	],
	"./pt/public/views/primesalud-medical-assistance.json": [
		627
	],
	"./pt/public/views/primesalud-wellness.json": [
		628
	],
	"./pt/public/views/primesalud.json": [
		538
	],
	"./pt/public/views/privacy-policy-professional.json": [
		350
	],
	"./pt/public/views/privacy-policy.json": [
		351
	],
	"./pt/public/views/pyme.json": [
		629
	],
	"./pt/public/views/selfEvaluationTests.json": [
		630
	],
	"./pt/public/views/sgsi-policy.json": [
		631
	],
	"./pt/public/views/shared/chat.json": [
		632
	],
	"./pt/public/views/survey.json": [
		633
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1341;
module.exports = webpackAsyncContext;

/***/ }),
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 779,
	"./af.js": 779,
	"./ar": 780,
	"./ar-dz": 781,
	"./ar-dz.js": 781,
	"./ar-kw": 782,
	"./ar-kw.js": 782,
	"./ar-ly": 783,
	"./ar-ly.js": 783,
	"./ar-ma": 784,
	"./ar-ma.js": 784,
	"./ar-sa": 785,
	"./ar-sa.js": 785,
	"./ar-tn": 786,
	"./ar-tn.js": 786,
	"./ar.js": 780,
	"./az": 787,
	"./az.js": 787,
	"./be": 788,
	"./be.js": 788,
	"./bg": 789,
	"./bg.js": 789,
	"./bm": 790,
	"./bm.js": 790,
	"./bn": 791,
	"./bn-bd": 792,
	"./bn-bd.js": 792,
	"./bn.js": 791,
	"./bo": 793,
	"./bo.js": 793,
	"./br": 794,
	"./br.js": 794,
	"./bs": 795,
	"./bs.js": 795,
	"./ca": 796,
	"./ca.js": 796,
	"./cs": 797,
	"./cs.js": 797,
	"./cv": 798,
	"./cv.js": 798,
	"./cy": 799,
	"./cy.js": 799,
	"./da": 800,
	"./da.js": 800,
	"./de": 801,
	"./de-at": 802,
	"./de-at.js": 802,
	"./de-ch": 803,
	"./de-ch.js": 803,
	"./de.js": 801,
	"./dv": 804,
	"./dv.js": 804,
	"./el": 805,
	"./el.js": 805,
	"./en-au": 806,
	"./en-au.js": 806,
	"./en-ca": 807,
	"./en-ca.js": 807,
	"./en-gb": 808,
	"./en-gb.js": 808,
	"./en-ie": 809,
	"./en-ie.js": 809,
	"./en-il": 810,
	"./en-il.js": 810,
	"./en-in": 811,
	"./en-in.js": 811,
	"./en-nz": 812,
	"./en-nz.js": 812,
	"./en-sg": 813,
	"./en-sg.js": 813,
	"./eo": 814,
	"./eo.js": 814,
	"./es": 815,
	"./es-do": 816,
	"./es-do.js": 816,
	"./es-mx": 817,
	"./es-mx.js": 817,
	"./es-us": 818,
	"./es-us.js": 818,
	"./es.js": 815,
	"./et": 819,
	"./et.js": 819,
	"./eu": 820,
	"./eu.js": 820,
	"./fa": 821,
	"./fa.js": 821,
	"./fi": 822,
	"./fi.js": 822,
	"./fil": 823,
	"./fil.js": 823,
	"./fo": 824,
	"./fo.js": 824,
	"./fr": 825,
	"./fr-ca": 826,
	"./fr-ca.js": 826,
	"./fr-ch": 827,
	"./fr-ch.js": 827,
	"./fr.js": 825,
	"./fy": 828,
	"./fy.js": 828,
	"./ga": 829,
	"./ga.js": 829,
	"./gd": 830,
	"./gd.js": 830,
	"./gl": 831,
	"./gl.js": 831,
	"./gom-deva": 832,
	"./gom-deva.js": 832,
	"./gom-latn": 833,
	"./gom-latn.js": 833,
	"./gu": 834,
	"./gu.js": 834,
	"./he": 835,
	"./he.js": 835,
	"./hi": 836,
	"./hi.js": 836,
	"./hr": 837,
	"./hr.js": 837,
	"./hu": 838,
	"./hu.js": 838,
	"./hy-am": 839,
	"./hy-am.js": 839,
	"./id": 840,
	"./id.js": 840,
	"./is": 841,
	"./is.js": 841,
	"./it": 842,
	"./it-ch": 843,
	"./it-ch.js": 843,
	"./it.js": 842,
	"./ja": 844,
	"./ja.js": 844,
	"./jv": 845,
	"./jv.js": 845,
	"./ka": 846,
	"./ka.js": 846,
	"./kk": 847,
	"./kk.js": 847,
	"./km": 848,
	"./km.js": 848,
	"./kn": 849,
	"./kn.js": 849,
	"./ko": 850,
	"./ko.js": 850,
	"./ku": 851,
	"./ku.js": 851,
	"./ky": 852,
	"./ky.js": 852,
	"./lb": 853,
	"./lb.js": 853,
	"./lo": 854,
	"./lo.js": 854,
	"./lt": 855,
	"./lt.js": 855,
	"./lv": 856,
	"./lv.js": 856,
	"./me": 857,
	"./me.js": 857,
	"./mi": 858,
	"./mi.js": 858,
	"./mk": 859,
	"./mk.js": 859,
	"./ml": 860,
	"./ml.js": 860,
	"./mn": 861,
	"./mn.js": 861,
	"./mr": 862,
	"./mr.js": 862,
	"./ms": 863,
	"./ms-my": 864,
	"./ms-my.js": 864,
	"./ms.js": 863,
	"./mt": 865,
	"./mt.js": 865,
	"./my": 866,
	"./my.js": 866,
	"./nb": 867,
	"./nb.js": 867,
	"./ne": 868,
	"./ne.js": 868,
	"./nl": 869,
	"./nl-be": 870,
	"./nl-be.js": 870,
	"./nl.js": 869,
	"./nn": 871,
	"./nn.js": 871,
	"./oc-lnc": 872,
	"./oc-lnc.js": 872,
	"./pa-in": 873,
	"./pa-in.js": 873,
	"./pl": 874,
	"./pl.js": 874,
	"./pt": 875,
	"./pt-br": 876,
	"./pt-br.js": 876,
	"./pt.js": 875,
	"./ro": 877,
	"./ro.js": 877,
	"./ru": 878,
	"./ru.js": 878,
	"./sd": 879,
	"./sd.js": 879,
	"./se": 880,
	"./se.js": 880,
	"./si": 881,
	"./si.js": 881,
	"./sk": 882,
	"./sk.js": 882,
	"./sl": 883,
	"./sl.js": 883,
	"./sq": 884,
	"./sq.js": 884,
	"./sr": 885,
	"./sr-cyrl": 886,
	"./sr-cyrl.js": 886,
	"./sr.js": 885,
	"./ss": 887,
	"./ss.js": 887,
	"./sv": 888,
	"./sv.js": 888,
	"./sw": 889,
	"./sw.js": 889,
	"./ta": 890,
	"./ta.js": 890,
	"./te": 891,
	"./te.js": 891,
	"./tet": 892,
	"./tet.js": 892,
	"./tg": 893,
	"./tg.js": 893,
	"./th": 894,
	"./th.js": 894,
	"./tk": 895,
	"./tk.js": 895,
	"./tl-ph": 896,
	"./tl-ph.js": 896,
	"./tlh": 897,
	"./tlh.js": 897,
	"./tr": 898,
	"./tr.js": 898,
	"./tzl": 899,
	"./tzl.js": 899,
	"./tzm": 900,
	"./tzm-latn": 901,
	"./tzm-latn.js": 901,
	"./tzm.js": 900,
	"./ug-cn": 902,
	"./ug-cn.js": 902,
	"./uk": 903,
	"./uk.js": 903,
	"./ur": 904,
	"./ur.js": 904,
	"./uz": 905,
	"./uz-latn": 906,
	"./uz-latn.js": 906,
	"./uz.js": 905,
	"./vi": 907,
	"./vi.js": 907,
	"./x-pseudo": 908,
	"./x-pseudo.js": 908,
	"./yo": 909,
	"./yo.js": 909,
	"./zh-cn": 910,
	"./zh-cn.js": 910,
	"./zh-hk": 911,
	"./zh-hk.js": 911,
	"./zh-mo": 912,
	"./zh-mo.js": 912,
	"./zh-tw": 913,
	"./zh-tw.js": 913
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;

/***/ }),
/* 1383 */,
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1385);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("525b860b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d2a09264\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseAlert.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d2a09264\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseAlert.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.alert-dismissible .close{top:-12px !important\n}\n.alert-danger{border-color:transparent\n}\n.alert-info{background-color:#3238C4;color:#fff !important\n}\n.alert-ctn{margin:auto;text-align:center;position:absolute;width:100%\n}\n@media only screen and (min-width: 1024px){\n.alert-ctn{padding:0px 30rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.alert-ctn{padding:0 10rem\n}\n}\n@media only screen and (max-width: 575px){\n.alert-ctn{padding:0 1rem\n}\n}\n.alert-ctn .alert{color:#1D1D1E;z-index:1000000;position:fixed;left:0;right:0;margin:auto;width:50%;top:1rem;overflow:hidden;z-index:9999;white-space:normal\n}\n", ""]);

// exports


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible"
        }
      ],
      staticClass: "alert-ctn"
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _c(
            "b-alert",
            {
              staticClass: "alert",
              attrs: { variant: _vm.variant },
              model: {
                value: _vm.isVisible,
                callback: function($$v) {
                  _vm.isVisible = $$v
                },
                expression: "isVisible"
              }
            },
            [_vm._t("default")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2a09264", esExports)
  }
}

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var microhabitsStore = {
	namespaced: true,
	state: {
		currentCategory: null,
		currentMicrohabit: null
	},
	mutations: {
		setCurrentCategory: function setCurrentCategory(state, category) {
			state.currentCategory = category;
		},
		setCurrentMicrohabit: function setCurrentMicrohabit(state, microhabit) {
			state.currentMicrohabit = microhabit;
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (microhabitsStore);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var surveyStore = {
	namespaced: true,
	state: {
		currentSurvey: null
	},
	mutations: {
		setSurvey: function setSurvey(state, sv) {
			state.currentSurvey = sv;
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (surveyStore);

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sessionStorage_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_roles_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repositories_AccountRepository__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_patientServices__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_genders__ = __webpack_require__(1235);













var sessionStore = {
	namespaced: true,
	state: {
		apiToken: null,
		loginInfo: null,
		user: null,
		requiredLoginFields: [],
		loginOptionalActions: [],
		loginCallback: null,
		changeUserModalVisible: false
	},
	mutations: {
		setLoginInfo: function setLoginInfo(state, loginInfo) {
			state.loginInfo = loginInfo;
		},
		setLogged: function setLogged(state, token) {
			Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__["e" /* setCookie */])(__WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__["b" /* API_TOKEN_COOKIE_NAME */], token, 1);
			__WEBPACK_IMPORTED_MODULE_9_vue__["default"].prototype.$apiToken = token;
			state.apiToken = token;
		},
		setUser: function setUser(state, user) {
			state.user = user;
		},
		setUserAge: function setUserAge(state, age) {
			state.user.age = age;
		},
		setApiToken: function setApiToken(state, token) {
			Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__["e" /* setCookie */])(__WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__["b" /* API_TOKEN_COOKIE_NAME */], token, 1);
			__WEBPACK_IMPORTED_MODULE_9_vue__["default"].prototype.$apiToken = token;
			state.apiToken = token;
		},
		setUserCookies: function setUserCookies(state, cookies) {
			if (!cookies) {
				return;
			}
			var cookiesList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(cookies);
			if (cookiesList && cookiesList.length > 0) {
				cookiesList.forEach(function (entry) {
					var _entry = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(entry, 2),
					    key = _entry[0],
					    value = _entry[1];

					Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__["e" /* setCookie */])(key, value, 1);
				});
			}
		},
		setRequiredLoginFields: function setRequiredLoginFields(state, data) {
			state.requiredLoginFields = data;
		},
		setLoginOptionalActions: function setLoginOptionalActions(state, data) {
			state.loginOptionalActions = data;
		},
		removeLoginOptionalAction: function removeLoginOptionalAction(state, action) {
			state.loginOptionalActions = state.loginOptionalActions.filter(function (a) {
				return a !== action;
			});
		},
		setLoginCallback: function setLoginCallback(state, data) {
			state.loginCallback = data;
		}
	},
	getters: {
		companyCodeInfoMessages: function companyCodeInfoMessages(state) {
			return state.user && state.user.companyCode && state.user.companyCode.infoMessages ? state.user.companyCode.infoMessages : [];
		},
		userIsType: function userIsType(state) {
			return function (userType) {
				return state.user && state.user.userType === userType;
			};
		},
		userIsProfessional: function userIsProfessional(state, getters) {
			return getters.userIsType(__WEBPACK_IMPORTED_MODULE_6__constants_roles_js__["h" /* PROFESSIONAL_ROLE */]);
		},
		userIsPatient: function userIsPatient(state, getters) {
			return getters.userIsType(__WEBPACK_IMPORTED_MODULE_6__constants_roles_js__["f" /* PATIENT_ROLE */]);
		},
		userIsCenter: function userIsCenter(state, getters) {
			return getters.userIsType(__WEBPACK_IMPORTED_MODULE_6__constants_roles_js__["e" /* CENTER_ROLE */]);
		},
		userIsApiClient: function userIsApiClient(state, getters) {
			return getters.userIsType(__WEBPACK_IMPORTED_MODULE_6__constants_roles_js__["d" /* API_CLIENT_ROLE */]);
		},
		userHasCompanies: function userHasCompanies(state) {
			return state.user && state.user.companiesActive;
		},
		isSessionRoleAllowed: function isSessionRoleAllowed(state) {
			return function (allowedRoles) {
				return state.user && allowedRoles.includes(state.user.userType);
			};
		},
		getCompanyService: function getCompanyService(state) {
			return function (service) {
				return state.user && state.user.activeCompanyServices ? state.user.activeCompanyServices.find(function (s) {
					return s.id === service;
				}) : null;
			};
		},
		userHasActiveCompanyService: function userHasActiveCompanyService(state, getters) {
			return function (service) {
				return getters.getCompanyService(service) && getters.getCompanyService(service).active;
			};
		},
		getHealthyCommunityService: function getHealthyCommunityService(state, getters) {
			return getters.getCompanyService(__WEBPACK_IMPORTED_MODULE_10__constants_patientServices__["d" /* HEALTHY_COMMUNITY_SERVICE */]);
		},
		healthyCommunityActive: function healthyCommunityActive(state, getters) {
			return getters.userHasActiveCompanyService(__WEBPACK_IMPORTED_MODULE_10__constants_patientServices__["d" /* HEALTHY_COMMUNITY_SERVICE */]) || getters.userHasPaidSomething || getters.userIsProfessional;
		},
		search360Active: function search360Active(state, getters) {
			return getters.userHasActiveCompanyService(__WEBPACK_IMPORTED_MODULE_10__constants_patientServices__["j" /* SEARCH_SERVICE */]);
		},
		userIsMale: function userIsMale(state) {
			return state.user && state.user.sex === __WEBPACK_IMPORTED_MODULE_11__constants_genders__["b" /* MALE */];
		},
		userIsFemale: function userIsFemale(state) {
			return state.user && state.user.sex === __WEBPACK_IMPORTED_MODULE_11__constants_genders__["a" /* FEMALE */];
		},
		referralActiveByApiClient: function referralActiveByApiClient(state, getters) {
			return getters.userIsApiClient && !!state.user.companyCode;
		},
		menstruationsActive: function menstruationsActive(state, getters) {
			return getters.userIsFemale && state.user.menstruations && state.user.menstruations.length > 0;
		},
		userHasPaidSomething: function userHasPaidSomething(state) {
			return state.user && state.user.hasPaidSomething;
		},
		isLogged: function isLogged(state) {
			return state.apiToken || Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__["b" /* getCookie */])(__WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__["b" /* API_TOKEN_COOKIE_NAME */]) || sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants_sessionStorage_js__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */]);
		}
	},
	actions: {
		set: function set(_ref, loginInfo) {
			var commit = _ref.commit;

			commit('setLoginInfo', loginInfo);
			commit('setUser', loginInfo.user);
			commit('setUserCookies', loginInfo.cookies);
			commit('setLoginOptionalActions', loginInfo.optionalActions);
			commit('setLogged', loginInfo.apiToken);
		},
		create: function create(_ref2) {
			var _this = this;

			var state = _ref2.state,
			    commit = _ref2.commit,
			    dispatch = _ref2.dispatch;
			var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { token: null, loginInfo: null, reload: true };
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var loginInfo;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(state.user && state.apiToken && state.apiToken === window.$cookies.get(__WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__["b" /* API_TOKEN_COOKIE_NAME */]))) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								try {
									dispatch('remove');
								} catch (e) {
									// do nothing
								}
								if (payload.token) {
									Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__["c" /* removeCookie */])(__WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__["b" /* API_TOKEN_COOKIE_NAME */]);
									commit('setApiToken', payload.token);
								}

								if (!(!state.user || !state.apiToken)) {
									_context.next = 20;
									break;
								}

								_context.prev = 5;
								_context.t0 = payload.loginInfo;

								if (_context.t0) {
									_context.next = 11;
									break;
								}

								_context.next = 10;
								return __WEBPACK_IMPORTED_MODULE_8__repositories_AccountRepository__["a" /* default */].getSession().catch(function (e) {
									return null;
								});

							case 10:
								_context.t0 = _context.sent.data;

							case 11:
								loginInfo = _context.t0;

								dispatch('set', loginInfo);
								if (payload.reload) {
									window.location.reload();
								}
								return _context.abrupt('return', loginInfo);

							case 17:
								_context.prev = 17;
								_context.t1 = _context['catch'](5);
								return _context.abrupt('return', null);

							case 20:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[5, 17]]);
			}))();
		},
		remove: function remove(_ref3) {
			var state = _ref3.state,
			    dispatch = _ref3.dispatch;

			state.user = null;
			state.apiToken = null;
			Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__["c" /* removeCookie */])(__WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__["b" /* API_TOKEN_COOKIE_NAME */]);
			Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cookies_helpers__["c" /* removeCookie */])(__WEBPACK_IMPORTED_MODULE_4__constants_cookies_js__["c" /* ASPNET_APPLICATION_COOKIE_NAME */]);
			dispatch('notifications/resetState', null, { root: true });
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (sessionStore);

/***/ }),
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_supportedSoundcards__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_difference__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(25);









/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		videoSession: {
			id: '',
			videoUserId: '',
			videoSessionStart: null
		},
		opentok: {
			api_key: '',
			session_token: '',
			publisher_token: '',
			session: null,
			OTSession: null,
			publisher: null,
			subscriber: null,
			resolution: '1280x720',
			frameRate: 30,
			video: 1,
			audio: 1,
			error: {
				title: null,
				msg: null
			}
		},
		patient: null,
		appointment: null,
		smallToken: null,
		testPassed: false,
		useStethoscope: false,
		useLamp: false,
		muted: false,
		camShared: true,
		screenShared: false,
		source: null,
		audioSource: null,
		videoDevices: [],
		audioDevices: [],
		useFrontCamera: true,
		useRearCamera: false,
		menu: {
			activeNavItem: null,
			selectedVideoSource: null,
			selectedAudioSource: null
		},
		alert: {
			visible: false,
			text: null,
			variant: 'success'
		},
		session: null,
		error: {
			type: 0
		},
		db: null,
		documentsTable: {
			files: [],
			loading: false,
			uploader: {
				file: null,
				fileTypes: [],
				selectedType: 0
			}
		},
		lightbox: {
			items: [],
			index: null
		}
	},
	mutations: {
		setVideoSession: function setVideoSession(state, payload) {
			state.videoSession.id = payload.idVideoSession;
			state.videoSession.videoUserId = payload.idVideoUser;
			state.videoSession.videoSessionStart = payload.videoSessionStart;
		},
		setError: function setError(state, payload) {
			state.error.type = payload;
		},
		setResultVideoTest: function setResultVideoTest(state, payload) {
			state.videoTestPassed = payload;
		},
		setSmallToken: function setSmallToken(state, payload) {
			state.smallToken = payload;
		},
		setPatient: function setPatient(state, payload) {
			state.patient = payload;
		},
		setAppointment: function setAppointment(state, appointment) {
			state.appointment = appointment;
		},
		setPublisher: function setPublisher(state, publisher) {
			state.opentok.publisher = publisher;
		},
		toggleAudio: function toggleAudio(state) {
			state.opentok.audio = !state.opentok.audio;
		},
		setAudioOn: function setAudioOn(state) {
			state.opentok.audio = 1;
		},
		setSessionOpentokToken: function setSessionOpentokToken(state, payload) {
			state.opentok.api_key = payload.opentokKey;
			state.opentok.session_token = payload.opentokSession;
			state.opentok.publisher_token = payload.opentokPublishToken;
		},
		setVideoQuality: function setVideoQuality(state, payload) {
			switch (payload) {
				case 1:
					state.opentok.resolution = '1280x720';
					state.opentok.frameRate = 30;
					break;
				case 2:
					state.opentok.resolution = '640x480';
					state.opentok.frameRate = 15;
					break;
				case 3:
					state.opentok.resolution = '320x240';
					state.opentok.frameRate = 1;
					break;
				default:
					state.opentok.resolution = '1280x720';
					state.opentok.frameRate = 30;
					break;
			}
		},

		disableVideo: function disableVideo(state) {
			state.opentok.publisher.publishVideo(false);
		},
		setDb: function setDb(state, db) {
			state.db = db;
		},
		toggleStethoscope: function toggleStethoscope(state) {
			state.useStethoscope = !state.useStethoscope;
		},
		toggleLamp: function toggleLamp(state, val) {
			state.useLamp = !state.useLamp;
		},
		toggleVideoMute: function toggleVideoMute(state) {
			state.muted = !state.muted;
		},
		toggleCameraShare: function toggleCameraShare(state) {
			state.camShared = !state.camShared;
		},
		toggleShareScreen: function toggleShareScreen(state) {
			state.screenShared = !state.screenShared;
		},

		/*     setApiToken (state, apiToken) {
  			state.apiToken = apiToken
  		}, */
		setDevices: function setDevices(state, devices) {
			var videoDevices = devices.filter(function (d) {
				return d.kind === 'videoinput';
			});
			var audioDevices = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(devices.filter(function (d) {
				return d.kind === 'audioinput';
			})));
			audioDevices = __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default()(audioDevices, 'groupId');

			// Check if connected device is supported one
			if (audioDevices.length > state.audioDevices.length) {
				var newDevice = __WEBPACK_IMPORTED_MODULE_6_lodash_difference___default()(audioDevices, state.audioDevices);
				if (newDevice.length > 0) {
					state.menu.selectedAudioSource = newDevice[0].deviceId;
				}
			} else {
				state.menu.selectedAudioSource = audioDevices[0].deviceId;
			}

			state.videoDevices = videoDevices;
			state.audioDevices = audioDevices;
			state.audioSource = audioDevices[0];
			/* state.menu.selectedAudioSource = audioDevices[0].deviceId */
			/* state.video.source = videoDevices[0] */
		},
		setAudioSource: function setAudioSource(state, source) {
			// Source is mediaStreamTrack
			state.audioSource = source;
			/* state.menu.selectedAudioSource = source.deviceId */
			if (__WEBPACK_IMPORTED_MODULE_4__constants_supportedSoundcards__["a" /* SUPPORTED_SOUNDCARDS */].some(function (ss) {
				return source.label.includes(ss);
			})) {
				state.useStethoscope = true;
			} else if (!__WEBPACK_IMPORTED_MODULE_4__constants_supportedSoundcards__["a" /* SUPPORTED_SOUNDCARDS */].some(function (ss) {
				return source.label.includes(ss);
			}) && state.useStethoscope) {
				state.useStethoscope = false;
			}
		},
		setVideoSource: function setVideoSource(state, source) {
			state.source = source;
		},
		setOpentokError: function setOpentokError(state, obj) {
			state.opentok.error = obj;
		},
		setOTSession: function setOTSession(state, session) {
			state.opentok.OTSession = session;
		},
		setSelectedVideoSource: function setSelectedVideoSource(state, videoDevice) {
			if (!videoDevice) {
				state.menu.selectedVideoSource = state.videoDevices[0].deviceId;
				return;
			}
			// videoDevice could be either mediastreamtrack or deviceId
			var videoSource = !videoDevice.track ? state.videoDevices.find(function (item) {
				return item.deviceId === videoDevice;
			}) : state.videoDevices.find(function (item) {
				return item.deviceId === videoDevice.deviceId || item.label === videoDevice.track.label;
			});
			if (videoSource) {
				state.menu.selectedVideoSource = videoSource.deviceId;
			}
		},
		setSelectedAudioSource: function setSelectedAudioSource(state, mediaStreamTrack) {
			var audioSource = state.audioDevices.find(function (item) {
				return item.label === mediaStreamTrack.label || item.deviceId === mediaStreamTrack.id;
			});
			if (audioSource) {
				state.menu.selectedAudioSource = audioSource.deviceId;
				if (__WEBPACK_IMPORTED_MODULE_4__constants_supportedSoundcards__["a" /* SUPPORTED_SOUNDCARDS */].some(function (ss) {
					return mediaStreamTrack.label.includes(ss);
				})) {
					state.useStethoscope = true;
				} else if (!__WEBPACK_IMPORTED_MODULE_4__constants_supportedSoundcards__["a" /* SUPPORTED_SOUNDCARDS */].some(function (ss) {
					return mediaStreamTrack.label.includes(ss);
				}) && state.useStethoscope) {
					state.useStethoscope = false;
				}
			}
		},
		toggleMobileCamera: function toggleMobileCamera(state) {
			state.useFrontCamera = !state.useFrontCamera;
			// useRearCamera is changed by v-model in switch component
			/* state.video.useRearCamera = !state.video.useRearCamera */
		},
		showVideoSidebarAlert: function showVideoSidebarAlert(state, payload) {
			state.alert.text = payload.message;
			state.alert.variant = payload.type || 'success';
			state.alert.visible = true;
		},
		setMenuActiveNavItem: function setMenuActiveNavItem(state, data) {
			state.menu.activeNavItem = data;
		},
		setDocumentsTableFiles: function setDocumentsTableFiles(state, files) {
			state.documentsTable.files = files;
		},
		setDocumentsTableLoading: function setDocumentsTableLoading(state, loading) {
			state.documentsTable.loading = loading;
		},
		setDocumentsTableUploaderFile: function setDocumentsTableUploaderFile(state, file) {
			state.documentsTable.uploader.file = file;
		},
		setDocumentsTableUploaderFileTypes: function setDocumentsTableUploaderFileTypes(state, fileTypes) {
			state.documentsTable.uploader.fileTypes = fileTypes;
		},
		setDocumentsTableUploaderSelectedType: function setDocumentsTableUploaderSelectedType(state, type) {
			state.documentsTable.uploader.selectedType = type;
		},
		addToLightbox: function addToLightbox(state, src) {
			var item = {
				src: src,
				mediaType: 'iframe'
			};
			state.lightbox.items.push(item);
			state.lightbox.index = state.lightbox.items.length - 1;
		},
		resetLightbox: function resetLightbox(state) {
			state.lightbox.items = [];
			state.lightbox.index = null;
		}
	},
	getters: {
		getSelectedAudioSource: function getSelectedAudioSource(state) {
			return state.audioDevices.find(function (item) {
				return item.deviceId === state.menu.selectedAudioSource;
			});
		}
	},
	actions: {
		sendSignalCommand: function sendSignalCommand(_ref, _ref2) {
			var state = _ref.state;
			var command = _ref2.command,
			    errorCallback = _ref2.errorCallback;

			return state.opentok.OTSession.signal({
				type: 'command',
				data: command
			}, errorCallback || function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		sendSignalMessage: function sendSignalMessage(_ref3, _ref4) {
			var state = _ref3.state,
			    dispatch = _ref3.dispatch;
			var msg = _ref4.msg,
			    callback = _ref4.callback;

			return dispatch('sendSignalCommand', {
				command: state.patient.name + ': ' + msg,
				errorCallback: callback
			});
		},
		sendSignalFileMessage: function sendSignalFileMessage(_ref5, fileId) {
			var dispatch = _ref5.dispatch;

			return dispatch('sendSignalCommand', {
				command: 'newDocument;' + fileId,
				errorCallback: function errorCallback(error) {
					if (error) {
						console.log('Error signalR file');
					} else {
						console.log(fileId + ' enviado');
					}
				}
			});
		},
		loadDocumentsTable: function loadDocumentsTable(_ref6) {
			var commit = _ref6.commit,
			    state = _ref6.state;

			commit('setMenuActiveNavItem', 'docs');
			commit('setDocumentsTableLoading', true);
			__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$api.get('AppointmentFiles/' + state.appointment.id).then(function (response) {
				commit('setDocumentsTableFiles', response.data.data);
				commit('setDocumentsTableLoading', false);
			});
		},

		uploadClinicalDocument: function () {
			var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref8, _ref9) {
				var state = _ref8.state,
				    commit = _ref8.commit;
				var file = _ref9.file,
				    fileTagId = _ref9.fileTagId;
				var toBase64;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								commit('setDocumentsTableLoading', true);
								if (file instanceof Array) {
									file = file[0];
								}

								toBase64 = function toBase64(file) {
									return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
										var reader = new FileReader();
										reader.readAsDataURL(file);
										reader.onload = function () {
											var encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
											if (encoded.length % 4 > 0) {
												encoded += '='.repeat(4 - encoded.length % 4);
											}
											resolve(encoded);
										};
										reader.onerror = function (error) {
											return reject(error);
										};
									});
								};

								_context.t0 = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$api;
								_context.t1 = state.patient.id;
								_context.t2 = state.appointment.id;
								_context.next = 8;
								return toBase64(file);

							case 8:
								_context.t3 = _context.sent;
								_context.t4 = file.name;
								_context.t5 = file.type;
								_context.t6 = fileTagId;
								_context.t7 = {
									base64: _context.t3,
									name: _context.t4,
									contentType: _context.t5,
									idFileTag: _context.t6
								};
								_context.t8 = {
									id: _context.t1,
									appointmentId: _context.t2,
									file: _context.t7
								};
								return _context.abrupt('return', _context.t0.post.call(_context.t0, 'PatientsClinicalDocument', _context.t8));

							case 15:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function uploadClinicalDocument(_x, _x2) {
				return _ref7.apply(this, arguments);
			}

			return uploadClinicalDocument;
		}(),
		resetDocumentsTableUploader: function resetDocumentsTableUploader(_ref10) {
			var commit = _ref10.commit;

			commit('setDocumentsTableUploaderFile', null);
			commit('setDocumentsTableUploaderSelectedType', 0);
		}
	}
});

/***/ }),
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__ = __webpack_require__(291);



var forumStore = {
	namespaced: true,
	state: {
		userBasicInfo: {
			userAspId: null,
			nick: '',
			entriesSaved: [],
			messagesSaved: [],
			entriesLike: [],
			messagesLike: [],
			roleId: null,
			companyCode: null,
			pushNotificationsSectionId: [],
			firstAccess: null,
			companiesAccessRestricted: false
		},
		articleData: [],
		entriesCreatedByUser: [],
		entryMessagesCreatedByUser: [],
		numEntries: null,
		messages: [],
		showMoreIds: [],
		showLessIds: [],
		messagesPageNumber: [],
		messagesPerPage: 20,
		entriesPageNumber: 0,
		entriesPerPage: 15,
		showMainPage: true,
		entrySearchValue: null,
		searchSort: 0,
		searchType: null,
		searchId: null,
		showingSearch: false,
		hideOutsideSearchBar: false,
		showMainAnswerBlock: false,
		editingEntry: false,
		sectionId: null,
		hideSearcher: false,
		pushNotifications: [],
		showPushNotificationsModal: false,
		numberPushNotifications: 0,
		entryEditData: null,
		activityFilters: {},
		activityFilterSelected: null
	},
	mutations: {
		toggleCreateNewPost: function toggleCreateNewPost(state, data) {
			state.entryEditData = data || null;
		},
		resetMessagesValues: function resetMessagesValues(state) {
			state.showMoreIds = [];
			state.showLessIds = [];
		},
		setActivityFilters: function setActivityFilters(state, filters) {
			state.activityFilters = filters;
		},
		setActivityFilterSelected: function setActivityFilterSelected(state, value) {
			state.activityFilterSelected = value;
		}
	},
	getters: {
		forumUserIsProfessionalRole: function forumUserIsProfessionalRole(state) {
			return state.userBasicInfo.roleId === __WEBPACK_IMPORTED_MODULE_0__constants_roles__["i" /* PROFESSIONAL_ROLE_ID */];
		},
		forumUserIsPatientRole: function forumUserIsPatientRole(state) {
			return state.userBasicInfo.roleId === __WEBPACK_IMPORTED_MODULE_0__constants_roles__["g" /* PATIENT_ROLE_ID */];
		},
		forumMessageWithoutValidation: function forumMessageWithoutValidation(state, getters) {
			return !getters.forumUserIsPatientRole || state.userBasicInfo.companyCode;
		},
		forumEntryWithoutValidation: function forumEntryWithoutValidation(state, getters) {
			return !getters.forumUserIsPatientRole || state.userBasicInfo.companyCode && state.sectionId == __WEBPACK_IMPORTED_MODULE_1__constants_healthyCommunitySections__["b" /* HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION */];
		},
		forumUserIsAdminRole: function forumUserIsAdminRole(state) {
			return state.userBasicInfo.roleId === __WEBPACK_IMPORTED_MODULE_0__constants_roles__["b" /* ADMIN_ROLE_ID */];
		},
		forumUserIsAdminRestrictedRole: function forumUserIsAdminRestrictedRole(state) {
			return state.userBasicInfo.roleId === __WEBPACK_IMPORTED_MODULE_0__constants_roles__["a" /* ADMIN_RESTRICTED_ROLE_ID */];
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (forumStore);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var healthyHabitsStore = {
	namespaced: true,
	state: {
		showMeasurableInputModal: false,
		showGoalCompletedModal: false,
		showTableLegendModal: false,
		showCalendarLegendModal: false,
		hideLoadingIcon: false,
		bestStreak: 0,
		historyPatientId: null,
		isReadOnlyView: false,
		mobileSizeLimit: 510,
		itemSelected: {
			date: null,
			currentValue: null,
			newValue: null,
			measureUnit: null,
			fromCalendar: false
		},
		setting: {
			nick: null,
			habitUserId: null,
			showModal: false,
			notifications: {
				email: null,
				phone: null
			},
			showStoredHabits: false,
			showGoalCompletedHabits: false,
			invertedCalendarDays: null,
			allowFreeDays: true,
			isProfessional: false,
			imageData: null
		},
		predefinedHabit: {
			startIndex: 0,
			endIndex: null,
			hideRightArrow: false,
			hideLeftArrow: true,
			itemIdSelected: null
		},
		form: {
			show: false,
			editing: false,
			predefinedHabit: null,
			multiUser: false
		},
		chart: {
			title: null,
			question: null,
			notes: null,
			reminder: null,
			reminderDays: null,
			color: null,
			history: {
				key: 0,
				options: {},
				interval: 1
			},
			frequency: {
				options: {}
			},
			score: {
				key: 0,
				options: {},
				dataCache: [],
				interval: 0,
				currentValue: 0
			},
			showChart: false,
			goalFrequencyId: null,
			goal: null,
			goalCompleted: null,
			measurable: false,
			measureUnit: null,
			total: 0,
			data: [],
			dataMapped: null
		},
		table: {
			itemSelectedId: null,
			updatingItem: false,
			minDate: null,
			maxDate: null,
			minDateServer: null,
			maxDateServer: null,
			limitDate: null,
			prevDates: true,
			key: 1,
			currentMonth: null,
			data: {}
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (healthyHabitsStore);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_domains_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_domains_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_domains_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repositories_SignalrRepository__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__microsoft_signalr__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_signalRCommands__ = __webpack_require__(220);










var HUB = 'hub';
var HUB_URL = (__WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__["k" /* inLocalEnv */] ? __WEBPACK_IMPORTED_MODULE_4__static_domains_json___default.a.apis.api.local : __WEBPACK_IMPORTED_MODULE_4__static_domains_json___default.a.apis.api[__WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__["a" /* country */]][__WEBPACK_IMPORTED_MODULE_5__helpers_global_helpers__["b" /* environment */]]) + '/' + HUB;
var RECEIVER_COMMAND = 'ReceiveMessage';
var SENDER_COMMAND = 'SendMessageToClient';

var signalRStore = {
	namespaced: true,
	state: {
		socket: null,
		commandsHistory: [],
		commandReceived: null
	},
	mutations: {
		setCommandReceived: function setCommandReceived(state, payload) {
			state.commandReceived = payload;
			state.commandsHistory = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.commandsHistory), [payload]);
		}
	},
	actions: {
		init: function init(_ref) {
			var _this = this;

			var dispatch = _ref.dispatch,
			    state = _ref.state;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!state.socket) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								state.socket = new __WEBPACK_IMPORTED_MODULE_7__microsoft_signalr__["a" /* HubConnectionBuilder */]().configureLogging(__WEBPACK_IMPORTED_MODULE_7__microsoft_signalr__["b" /* LogLevel */].Error).withUrl(HUB_URL + '?token=' + __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$apiToken).build();
								return _context.abrupt('return', state.socket.start().then(function () {
									state.socket.on(RECEIVER_COMMAND, function (_ref2) {
										var command = _ref2.command,
										    data = _ref2.data,
										    signalRId = _ref2.signalRId;

										dispatch('onCommandReceived', { command: command, data: data, signalRId: signalRId });
									});
								}));

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		sendCommand: function sendCommand(_ref3, _ref4) {
			var _this2 = this;

			var state = _ref3.state,
			    dispatch = _ref3.dispatch;
			var userId = _ref4.userId,
			    message = _ref4.message;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (state.socket) {
									_context2.next = 3;
									break;
								}

								_context2.next = 3;
								return dispatch('init');

							case 3:
								state.socket.invoke(SENDER_COMMAND, userId, message);

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		onCommandReceived: function onCommandReceived(_ref5, payload) {
			var commit = _ref5.commit,
			    dispatch = _ref5.dispatch;

			__WEBPACK_IMPORTED_MODULE_6__repositories_SignalrRepository__["a" /* default */].setSignalrMessageState(payload.signalRId);
			commit('setCommandReceived', payload);
			if (__WEBPACK_IMPORTED_MODULE_8__constants_signalRCommands__["k" /* NOTIFICATION_TYPE_COMMANDS */].includes(payload.command)) {
				dispatch('notifications/onNewNotification', { id: payload.command, data: payload.data, signalRId: payload.signalRId }, { root: true });
			}
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (signalRStore);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = function client() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    setSignalrMessageState: function setSignalrMessageState(signalRId) {
        return client().put('signalR', null, { params: { signalRId: signalRId }, loading: false });
    }
});

/***/ }),
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_PatientsRepository__ = __webpack_require__(500);


var testsStore = {
    namespaced: true,
    state: {
        test: {},
        currentSlide: 0,
        completed: false,
        previousTestResults: [],
        DBResults: {},
        resultInfo: {}
    },
    mutations: {
        incrementSlide: function incrementSlide(state) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            data != null ? state.currentSlide += data : state.currentSlide++;
        },
        setPreviousTestResults: function setPreviousTestResults(state, data) {
            state.previousTestResults = data;
        },
        setTestCompletedThisMonth: function setTestCompletedThisMonth(state, data) {
            state.DBResults = data;
            state.completed = true;
        },
        setTestCompleted: function setTestCompleted(state) {
            state.completed = true;
        },
        setDBResult: function setDBResult(state, data) {
            state.DBResults = { generalResult: data.result, percentage: data.percentage, userId: data.userId, date: data.date, testId: data.testId, testName: data.testName, dimensions: data.dimensions };
        },
        pushLastTestCompleted: function pushLastTestCompleted(state) {
            state.previousTestResults.push(state.DBResults);
        },
        setResultInfo: function setResultInfo(state, data) {
            state.resultInfo = data;
        }
    },
    actions: {
        saveTestResult: function saveTestResult(_ref, testInfo) {
            var commit = _ref.commit,
                state = _ref.state;

            commit('setDBResult', testInfo);
            commit('pushLastTestCompleted');
            commit('setTestCompleted');
            __WEBPACK_IMPORTED_MODULE_0__repositories_PatientsRepository__["a" /* default */].fillSelfEvaluationTest(state.DBResults);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (testsStore);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_NotificationsSummaryRepository__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_PatientLiveStatesRepository__ = __webpack_require__(1502);




var notificationsStore = {
	namespaced: true,
	state: {
		notifications: [],
		unreadNotifications: [],
		unreadNotificationsNumber: null,
		lastNotification: null,
		liveStates: [],
		retrievedLiveStates: false,
		summary: {
			unreadChatMessagesNumber: null,
			unreadFilesNumber: null
		}
	},
	mutations: {
		setNotifications: function setNotifications(state, notifications) {
			state.notifications = notifications;
		},
		setUnreadNotifications: function setUnreadNotifications(state, notifications) {
			state.unreadNotifications = notifications;
		},
		setLastNotification: function setLastNotification(state, notification) {
			state.lastNotification = notification;
		},
		setLiveStates: function setLiveStates(state, liveStates) {
			state.liveStates = liveStates;
		},
		setRetrievedLiveStates: function setRetrievedLiveStates(state, value) {
			state.retrievedLiveStates = value;
		},
		addLiveState: function addLiveState(state, liveState) {
			state.liveStates = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.liveStates), [liveState]);
		},
		removeLiveState: function removeLiveState(state, liveState) {
			state.liveStates = state.liveStates.filter(function (state) {
				return state.id !== liveState.id;
			});
		},
		setSummary: function setSummary(state, summary) {
			state.summary = summary;
		},
		setUnreadNotificationsNumber: function setUnreadNotificationsNumber(state, number) {
			state.unreadNotificationsNumber = number;
		}
	},
	getters: {
		unreadNotificationsCount: function unreadNotificationsCount(state) {
			return state.unreadNotificationsNumber || state.unreadNotifications.length;
		},
		getUnreadChatMessagesNumber: function getUnreadChatMessagesNumber(state) {
			return state.summary ? state.summary.unreadChatMessagesNumber : 0;
		},
		getUnreadFilesNumber: function getUnreadFilesNumber(state) {
			return state.summary ? state.summary.unreadFilesNumber : 0;
		}
	},
	actions: {
		getSummary: function getSummary(_ref) {
			var state = _ref.state,
			    dispatch = _ref.dispatch;

			// Do not retrieve summary from server if it is already set
			if (state.summary.unreadChatMessagesNumber === null || state.summary.unreadFilesNumber === null) {
				dispatch('updateSummary');
			}
		},
		updateSummary: function updateSummary(_ref2) {
			var commit = _ref2.commit;

			__WEBPACK_IMPORTED_MODULE_1__repositories_NotificationsSummaryRepository__["a" /* default */].getAll().then(function (response) {
				commit('setSummary', response.data);
			});
		},
		getUnreadNotificationsNumber: function getUnreadNotificationsNumber(_ref3) {
			/* NotificationsRepository.getUnreadNotificationsNumber().then((response) => {
   	commit('setUnreadNotificationsNumber', response.data)
   }) */

			var commit = _ref3.commit;
		},
		onNewNotification: function onNewNotification(_ref4, notification) {
			var commit = _ref4.commit;

			commit('setLastNotification', notification);
			commit('setNotifications', [notification].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.notifications)));
			commit('setUnreadNotificationsNumber', (state.unreadNotificationsNumber || 0) + 1);
		},
		resetState: function resetState(_ref5) {
			var commit = _ref5.commit;

			commit('setNotifications', []);
			commit('setUnreadNotifications', []);
			commit('setUnreadNotificationsNumber', null);
			commit('setLastNotification', null);
			commit('setRetrievedLiveStates', false);
		},
		updateLiveStates: function updateLiveStates(_ref6) {
			var commit = _ref6.commit;

			__WEBPACK_IMPORTED_MODULE_2__repositories_PatientLiveStatesRepository__["a" /* default */].getAll().then(function (response) {
				var liveStates = response && response.data ? response.data : [];
				commit('setLiveStates', liveStates);
				commit('setRetrievedLiveStates', true);
			});
		},
		get: function get(_ref7) {
			var dispatch = _ref7.dispatch;

			dispatch('updateSummary');
			dispatch('updateLiveStates');
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (notificationsStore);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Repository__ = __webpack_require__(522);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__Repository__["a" /* default */]('notifications/summary'));

/***/ }),
/* 1500 */,
/* 1501 */,
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Repository__ = __webpack_require__(522);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__Repository__["a" /* default */]('patients/live-states'));

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(162);



var layoutStore = {
	namespaced: true,
	state: {
		showMenu: false,
		changeUserModalVisible: false
	},
	mutations: {
		toggleChangeUserModalVisible: function toggleChangeUserModalVisible(state) {
			state.changeUserModalVisible = !state.changeUserModalVisible;
		}
	},
	getters: {
		isToggleable: function isToggleable() {
			return !__WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["d" /* isDesktop */] || __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["g" /* isPortrait */];
		}
	},
	actions: {
		init: function init(_ref) {
			var dispatch = _ref.dispatch;

			dispatch('notifications/getSummary', null, { root: true });
		},
		toggleMenu: function toggleMenu(_ref2) {
			var state = _ref2.state,
			    getters = _ref2.getters;

			if (getters.isToggleable) {
				state.showMenu = !state.showMenu;
			}
		},
		hideMenu: function hideMenu(_ref3) {
			var state = _ref3.state;

			state.showMenu = false;
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (layoutStore);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__ = __webpack_require__(162);








var chatStore = {
    namespaced: true,
    state: {
        selectedChat: {
            user: null,
            messages: null
        },
        newMessage: '',
        editingMessage: null,
        showMsgOptions: null,
        messagesPendingReadLabel: 0,
        showDialog: {
            delete: false,
            finish: false,
            ePrescription: false
        },
        refs: {
            messageList: null,
            messageInput: null
        }
    },
    mutations: {
        deleteMessageFromChat: function deleteMessageFromChat(state, msgId) {
            var msgIndex = state.selectedChat.messages.findIndex(function (x) {
                return x.chatMessageId === msgId;
            });
            state.selectedChat.messages.splice(msgIndex, 1);
        },
        sendMessage: function sendMessage(state, data) {
            state.selectedChat.messages.push(data);
        },
        editMessage: function editMessage(state, data) {
            var msgIndex = state.selectedChat.messages.findIndex(function (x) {
                return x.chatMessageId === data.msgId;
            });
            if (msgIndex !== -1) {
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.selectedChat.messages, msgIndex, data.msg);
            }
        },
        toggleShowMsgOptions: function toggleShowMsgOptions(state) {
            var msgId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            state.showMsgOptions = msgId;
        },
        incrementUnreadMessages: function incrementUnreadMessages(state) {
            var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            if (amount) state.messagesPendingReadLabel += amount;
        },
        resetMsg: function resetMsg(state) {
            state.editingMessage = null;
            state.showMsgOptions = null;
            state.newMessage = '';
            state.messagesPendingReadLabel = 0;
        },
        setChatUserDetails: function setChatUserDetails(state, data) {
            state.selectedChat.user = data;
        },
        setChatMessages: function setChatMessages(state, data) {
            state.selectedChat.messages = data;
        },
        unselectChat: function unselectChat(state) {
            state.selectedChat = { user: null, messages: null };
        },
        setNewMessage: function setNewMessage(state, data) {
            state.newMessage = data;
        },
        setEditingMessage: function setEditingMessage(state, data) {
            state.editingMessage = data;
        },
        updateEditedMessageProperties: function updateEditedMessageProperties(state) {
            state.editingMessage.text = state.newMessage;
            state.editingMessage.edited = true;
        },
        toggleShowDialog: function toggleShowDialog(state, type) {
            state.showDialog[type] = !state.showDialog[type];
        },
        hideAllDialogs: function hideAllDialogs(state) {
            state.showDialog = { delete: false, finish: false, ePrescription: false };
        },
        setRefs: function setRefs(state, data) {
            state.refs.messageList = data.msgList;
            state.refs.messageInput = data.msgInput;
        }
    },
    actions: {
        resetStateOnLoad: function resetStateOnLoad(_ref) {
            var commit = _ref.commit;

            commit('unselectChat');
            commit('resetMsg');
            commit('hideAllDialogs');
        },
        sendMessage: function sendMessage(_ref2) {
            var _this = this;

            var commit = _ref2.commit,
                state = _ref2.state;
            var file = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!((state.newMessage.trim() !== '' || file !== null) && state.selectedChat)) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__["a" /* default */].sendMessage(state.selectedChat.user.idAppointment, state.newMessage, state.selectedChat.user.idUser, file).then(function (response) {
                                    commit('sendMessage', response.data.data);
                                    commit('resetMsg');
                                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
                                        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* centerScreen */])(state.refs.messageInput);
                                        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["h" /* scrollBottom */])(state.refs.messageList, true);
                                    });
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        editMessage: function editMessage(_ref3) {
            var _this2 = this;

            var commit = _ref3.commit,
                state = _ref3.state,
                dispatch = _ref3.dispatch;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__["a" /* default */].editMessage(state.editingMessage.chatMessageId, state.newMessage).then(function (response) {
                                    dispatch('showSuccessAlert', __WEBPACK_IMPORTED_MODULE_3__plugins_i18n__["a" /* default */].t('chats.edit-message-success'), { root: true });
                                });

                            case 2:
                                commit('updateEditedMessageProperties');
                                commit('resetMsg');

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        deleteMessage: function deleteMessage(_ref4, msgId) {
            var _this3 = this;

            var commit = _ref4.commit,
                dispatch = _ref4.dispatch;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__["a" /* default */].deleteMessage(msgId);

                            case 2:
                                commit('deleteMessageFromChat', msgId);
                                commit('toggleShowMsgOptions');
                                dispatch('showSuccessAlert', __WEBPACK_IMPORTED_MODULE_3__plugins_i18n__["a" /* default */].t('chats.delete-message-success'), { root: true });

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (chatStore);

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = vuexPersistence;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_persist__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);



function vuexPersistence() {
	var reducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	return new __WEBPACK_IMPORTED_MODULE_0_vuex_persist__["a" /* default */]({
		storage: __WEBPACK_IMPORTED_MODULE_1_localforage___default.a,
		asyncStorage: true,
		reducer: reducer
	});
}

/***/ }),
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1510);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2c19a172", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-317e5d8f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoadingAnim.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-317e5d8f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoadingAnim.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.velmld-overlay{background-color:rgba(255,255,255,0.3) !important\n}\n", ""]);

// exports


/***/ }),
/* 1511 */,
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c("vue-element-loading", {
        attrs: {
          active: _vm.active,
          spinner: _vm.spinner,
          color: _vm.getPrimaryColour(),
          backgroundColor: _vm.backgroundColor,
          size: _vm.size,
          duration: "1.5",
          "is-full-screen": _vm.fullScreen,
          text: _vm.text
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-317e5d8f", esExports)
  }
}

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1514);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5e8032b4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29eed2bf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PaginatedTable.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29eed2bf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PaginatedTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.pagination-arrow{width:17px;height:17px\n}\nbutton:hover span svg g path{stroke:#eee !important\n}\n.showBtnTable{color:#3238C4;text-decoration:underline;cursor:pointer\n}\n.hideBtnTable{color:#FF7061;text-decoration:underline;cursor:pointer\n}\ntable[class*=\"stacked\"] tr.b-table-details{margin-top:1rem\n}\ntable[class*=\"stacked\"] tr.b-table-details>td>div{text-align:center\n}\ntable[class*=\"stacked\"] td{padding:0\n}\ntable[class*=\"stacked\"] td::before{font-size:0.9rem\n}\ntable[class*=\"stacked\"] td>div{font-size:0.9rem\n}\ntable[class*=\"stacked\"] td hr{margin-top:1rem;margin-bottom:1rem;width:100%\n}\ntable .table-actions{text-align:center;margin-top:1rem\n}\ntable .table-actions>div{width:100% !important\n}\ntable .table-actions>div>div{display:inline-block;margin-right:.5rem\n}\n", ""]);

// exports


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("632b9186", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-457f5ec2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ArrowIcon.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-457f5ec2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ArrowIcon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17.207",
        height: "12.707",
        viewBox: "0 0 17.207 12.707"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_4",
            "data-name": "Group 4",
            transform: "translate(-0.5 -0.56)"
          }
        },
        [
          _c("path", {
            attrs: {
              id: "Path_3",
              "data-name": "Path 3",
              d: "M0,.5H16.5",
              transform: "translate(0.5 6.5)",
              fill: "none",
              stroke: _vm.color,
              "stroke-miterlimit": "10",
              "stroke-width": "1"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_4",
              "data-name": "Path 4",
              d: "M0,0,6,6,0,12",
              transform: "translate(11 0.913)",
              fill: "none",
              stroke: _vm.color,
              "stroke-miterlimit": "10",
              "stroke-width": "1"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-457f5ec2", esExports)
  }
}

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          id: _vm.id,
          fields: _vm.localFields,
          items: _vm.items,
          responsive: "",
          small: "",
          filter: _vm.filter,
          "filter-included-fields": _vm.filterIncludedFields,
          "filter-function": _vm.filterFn,
          "empty-filtered-text": _vm.emptyFilteredText,
          stacked: _vm.stacked,
          busy: _vm.loading,
          "show-empty": "",
          "empty-text": _vm.emptyText,
          "per-page": _vm.itemsPerPage,
          "current-page": _vm.currentPage
        },
        on: { filtered: _vm.filtered },
        scopedSlots: _vm._u(
          [
            {
              key: "table-busy",
              fn: function() {
                return [_c("loading-anim", { attrs: { active: _vm.loading } })]
              },
              proxy: true
            },
            _vm._l(_vm.$scopedSlots, function(_, slotName) {
              return {
                key: slotName,
                fn: function(scope) {
                  return [
                    _vm.showTableCell(slotName)
                      ? _vm._t(slotName, null, null, scope)
                      : _vm._e()
                  ]
                }
              }
            })
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-pagination", {
                attrs: {
                  pills: "",
                  "total-rows": _vm.rows,
                  "per-page": _vm.itemsPerPage,
                  "aria-controls": _vm.id,
                  "hide-ellipsis": "",
                  "first-number": "",
                  "last-number": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "prev-text",
                    fn: function() {
                      return [
                        _c("base-icon", {
                          staticClass: "pagination-arrow",
                          attrs: {
                            src:
                              "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                            svgClasses: "reverse",
                            color: _vm.arrowColor
                          }
                        })
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "next-text",
                    fn: function() {
                      return [
                        _c("base-icon", {
                          staticClass: "pagination-arrow",
                          attrs: {
                            src:
                              "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                            color: _vm.arrowColor
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCaption
            ? _c("b-col", [
                _c("span", { staticClass: "float-right text-info" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("table.pagination.label", _vm.paginationLabelData)
                    )
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29eed2bf", esExports)
  }
}

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1520);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0bca119f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1fe4198e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseCard.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1fe4198e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-1fe4198e]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-1fe4198e],.slide-down-leave-active[data-v-1fe4198e]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-1fe4198e],.slide-down-leave-to[data-v-1fe4198e]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-1fe4198e],.slide-fade-left-leave-active[data-v-1fe4198e]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-1fe4198e],.slide-fade-left-leave-to[data-v-1fe4198e]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-1fe4198e]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-1fe4198e],.fade-leave-to[data-v-1fe4198e]{opacity:0\n}\n.legend-point[data-v-1fe4198e]{display:inline-block;width:10px;height:10px;border-radius:50%;margin-right:5px\n}\n.period-day[data-v-1fe4198e]{background-color:red\n}\n.predicted-ovulation-day[data-v-1fe4198e]{background-color:orange\n}\n.ovulation-day[data-v-1fe4198e]{background-color:lightblue\n}\n.neu-card[data-v-1fe4198e]{position:relative;overflow:hidden;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);padding:3rem 4rem;border-radius:23px;border:1px solid #eee;background-color:#eee\n}\n@media only screen and (max-width: 575px){\n.neu-card[data-v-1fe4198e]{padding:2rem\n}\n}\n.neu-card-title .btn[data-v-1fe4198e]{margin-top:0px !important\n}\n.info-container[data-v-1fe4198e]{position:relative;margin-left:10px\n}\n.info-text[data-v-1fe4198e]{cursor:pointer;color:#3238C4;text-decoration:underline;font-size:13px\n}\n.info-bubble[data-v-1fe4198e]{background-color:#f5f5f5 !important;border:1px solid #ddd !important;border-radius:5px !important;padding:5px 10px !important;font-size:14px !important;color:#333 !important;max-width:300px;word-wrap:break-word\n}\n.tooltip .b-tooltip[data-v-1fe4198e]{position:absolute;background-color:#f5f5f5 !important;color:#333 !important;border:1px solid #ddd !important;padding:5px 10px !important;font-size:14px !important;max-width:300px !important;word-wrap:break-word !important\n}\n.card-flow-root[data-v-1fe4198e]{display:flow-root\n}\n", ""]);

// exports


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "neu-card": !_vm.hideNeuCardClass },
      style: { overflow: _vm.overflowVisible ? "initial" : "" },
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm.hasTitle
        ? _c(
            "div",
            {
              staticClass: "neu-card-title mb-3",
              class: _vm.baseContainerClass
            },
            [
              !_vm.title
                ? _vm._t("title")
                : !_vm.hideTitle
                ? _c(
                    "h3",
                    {
                      class:
                        "d-inline-block" +
                        (_vm.titleClass ? " " + _vm.titleClass : "")
                    },
                    [
                      _vm._v("\n      " + _vm._s(_vm.title) + "\n        "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.html",
                              value: { title: _vm.info, placement: "top" },
                              expression: "{ title: info, placement: 'top'}",
                              modifiers: { hover: true, html: true }
                            }
                          ],
                          staticClass: "info-container"
                        },
                        [
                          _vm.info
                            ? _c("span", { staticClass: "info-text" }, [
                                _vm._v("[Info]")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.hideButtons
                        ? _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.$emit("rightBtnClick")
                                }
                              }
                            },
                            [_vm._t("append-btn-title")],
                            2
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRightButtonSlot && !_vm.hideButtons
                ? _c(
                    "div",
                    {
                      staticClass: "float-right",
                      on: {
                        click: function($event) {
                          return _vm.$emit("rightBtnClick")
                        }
                      }
                    },
                    [_vm._t("right-button")],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fe4198e", esExports)
  }
}

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1523);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("09b37c35", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ae28b4b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseSelect.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ae28b4b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseSelect.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.v-select{margin-bottom:0rem !important\n}\n.v-select:not(.vs--multiple) .vs__selected{left:0;right:0;margin-left:auto !important;margin-right:auto !important;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content\n}\ninput .v__search{width:0\n}\n.vs__selected-options{padding:0 1rem\n}\n.vs__dropdown-menu{display:grid !important;text-align:left\n}\n.drop-up .vs__dropdown-toggle{border-radius:0px 0px 23px 23px;border-top-style:none;border-bottom-style:solid;border-bottom-color:initial;-webkit-box-shadow:0 -3px 6px rgba(0,0,0,0.15);box-shadow:0 -3px 6px rgba(0,0,0,0.15)\n}\n[data-popper-placement=\"top\"]{border-radius:23px 23px 0px 0px;border-top-style:solid;border-bottom-style:none;border-bottom-color:initial;-webkit-box-shadow:0 -3px 6px rgba(0,0,0,0.15);box-shadow:0 -3px 6px rgba(0,0,0,0.15)\n}\n.invalid-state .vs__dropdown-toggle{border-color:#FF7061\n}\n.vs--searchable:not(.vs--open) .vs__search:not([placeholder]),.vs--unsearchable:not(.vs--open) .vs__search:not([placeholder]){display:none\n}\n", ""]);

// exports


/***/ }),
/* 1524 */,
/* 1525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeDropdown,
          expression: "closeDropdown"
        }
      ],
      on: {
        click: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onClickPrevent.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "v-select",
        _vm._b(
          {
            ref: _vm.uid,
            class: { "invalid-state": _vm.state === false },
            attrs: {
              type: "text",
              "item-text": _vm.attributeSearch1,
              "persistent-hint": "",
              ref: "select",
              id: _vm.uid,
              uid: _vm.uid,
              placeholder: _vm.placeholder,
              "menu-props": "auto",
              searchable: _vm.searchable,
              options: _vm.localOptions,
              label: "label",
              loading: _vm.isLoading,
              disabled: _vm.disabled,
              valueProp: _vm.valueProp,
              getOptionLabel: function(option) {
                return option.label
              },
              clearable: _vm.clearable,
              "append-to-body": _vm.autoDropdownPlacement,
              reduce: _vm.reduce,
              filter: _vm.filter,
              "calculate-position": _vm.calcPositionWithPopper,
              multiple: _vm.multiple
            },
            on: {
              open: function($event) {
                return _vm.$emit("open", $event)
              },
              search: function($event) {
                return _vm.$emit("search", $event)
              },
              "option:selected": function($event) {
                return _vm.$emit("option:selected", $event)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "option",
                  fn: function(option) {
                    return [_vm._t("option", null, { option: option })]
                  }
                },
                {
                  key: "no-options",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n       " +
                          _vm._s(
                            _vm.noOptionsTitle || _vm.$t("signupOH.no-options")
                          ) +
                          "\n     "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "open-indicator",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    return [
                      _c("span", _vm._b({}, "span", attributes, false), [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "12",
                              height: "6",
                              viewBox: "0 0 12 6"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "Path_4_Copy",
                                "data-name": "Path 4 Copy",
                                d: "M0,0,6,6,0,12Z",
                                transform: "translate(12) rotate(90)",
                                fill: "#8a8a8a"
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          },
          "v-select",
          _vm.selectAttributes,
          false
        )
      ),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { state: _vm.state } }, [
        _vm._v("\n     " + _vm._s(_vm.errorMsg) + "\n   ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ae28b4b", esExports)
  }
}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("16518504", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8ca6f122\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8ca6f122\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-8ca6f122]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-8ca6f122],.slide-down-leave-active[data-v-8ca6f122]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-8ca6f122],.slide-down-leave-to[data-v-8ca6f122]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-8ca6f122],.slide-fade-left-leave-active[data-v-8ca6f122]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-8ca6f122],.slide-fade-left-leave-to[data-v-8ca6f122]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-8ca6f122]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-8ca6f122],.fade-leave-to[data-v-8ca6f122]{opacity:0\n}\n.fit-content[data-v-8ca6f122]{min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content\n}\n[data-v-8ca6f122].btn-outline-info{color:#8A8A8A;background-color:transparent;border:1px solid #8A8A8A\n}\n[data-v-8ca6f122].btn-outline-info:hover{background-color:white;color:#8A8A8A;border:1px solid #8A8A8A\n}\n.darken-on-hover[data-v-8ca6f122]:hover{background-color:#282c9b !important\n}\n.btn-negative[data-v-8ca6f122]{color:white;border:1px solid white;background-color:transparent\n}\n[data-v-8ca6f122]:focus{-webkit-box-shadow:none;box-shadow:none\n}\n[data-v-8ca6f122].no-hover:hover{background-color:inherit;border-color:inherit;color:inherit\n}\n", ""]);

// exports


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button",
    {
      class: {
        "shadow-btn": _vm.shadow,
        "shadow-btn-pseudo": _vm.pseudoShadow,
        "fit-content": _vm.fitContent,
        "btn-negative": _vm.negative,
        "font-weight-bold": _vm.bold,
        "darken-on-hover": _vm.darkenOnHover,
        "no-hover": _vm.noHoverStyles
      },
      style: _vm.getOverridenStyles,
      attrs: {
        id: _vm.id,
        variant: _vm.getVariant,
        size: _vm.size,
        disabled: _vm.disabled
      },
      on: { click: _vm.click }
    },
    [
      _vm.icon
        ? _c("base-icon", {
            staticClass: "mr-2",
            attrs: {
              src: _vm.icon,
              color:
                _vm.iconColor ||
                (_vm.lastInternalTextColor || _vm.internalTextColor)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _vm._t("default")
        : _c("b-spinner", {
            attrs: { variant: "light", label: "Spinning", small: "" }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ca6f122", esExports)
  }
}

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1551);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("36e1b4de", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a962cc9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseTextarea.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a962cc9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseTextarea.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c("b-form-textarea", {
            staticStyle: { overflow: "hidden" },
            attrs: {
              maxlength: _vm.maxlength,
              rows: _vm.rows,
              "max-rows": _vm.maxRows,
              id: _vm.id,
              placeholder: _vm.placeholder,
              readonly: _vm.readOnly,
              "no-resize": _vm.noResize
            },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a962cc9", esExports)
  }
}

/***/ }),
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/clinic-history.json": 512,
	"./en/common.json": 314,
	"./en/faqs.json": 560,
	"./en/forms/companies-contact-form.json": 503,
	"./en/global-variables.json": 311,
	"./en/payments.json": 529,
	"./en/private-layout.json": 561,
	"./en/public/footer-360.json": 530,
	"./en/public/footer-openlegal.json": 535,
	"./en/public/footer-opensalud.json": 510,
	"./en/public/simple-search.json": 562,
	"./en/public/views/360.json": 563,
	"./en/public/views/abogalitypro.json": 564,
	"./en/public/views/account/login.json": 565,
	"./en/public/views/account/password-update.json": 566,
	"./en/public/views/account/update-required-data.json": 567,
	"./en/public/views/cookies-policy.json": 568,
	"./en/public/views/healthy-community.json": 569,
	"./en/public/views/healthy-habits.json": 570,
	"./en/public/views/legal-areas.json": 571,
	"./en/public/views/legal-warning.json": 572,
	"./en/public/views/mindfulness.json": 514,
	"./en/public/views/openlegal.json": 573,
	"./en/public/views/opensalud-empresas-new.json": 574,
	"./en/public/views/opensalud-empresas.json": 575,
	"./en/public/views/opensalud-pacientes.json": 519,
	"./en/public/views/opensalud-principal.json": 576,
	"./en/public/views/opensalud-profesionales.json": 577,
	"./en/public/views/opensalud4all.json": 536,
	"./en/public/views/patient/appointments.json": 578,
	"./en/public/views/patient/foods.json": 579,
	"./en/public/views/patient/menu-banner.json": 580,
	"./en/public/views/patient/microhabits.json": 581,
	"./en/public/views/patient/panel.json": 582,
	"./en/public/views/patient/search.json": 583,
	"./en/public/views/primesalud-discounts.json": 520,
	"./en/public/views/primesalud-medical-assistance.json": 531,
	"./en/public/views/primesalud-wellness.json": 521,
	"./en/public/views/primesalud.json": 515,
	"./en/public/views/privacy-policy-professional.json": 346,
	"./en/public/views/privacy-policy.json": 347,
	"./en/public/views/pyme.json": 584,
	"./en/public/views/selfEvaluationTests.json": 585,
	"./en/public/views/sgsi-policy.json": 586,
	"./en/public/views/shared/chat.json": 587,
	"./en/public/views/survey.json": 588,
	"./en/public/views/unipromel.json": 589,
	"./es/clinic-history.json": 284,
	"./es/common.json": 189,
	"./es/forms/companies-contact-form.json": 279,
	"./es/global-variables.json": 224,
	"./es/payments.json": 295,
	"./es/private-layout.json": 317,
	"./es/public/footer-360.json": 296,
	"./es/public/footer-openlegal.json": 298,
	"./es/public/footer-opensalud.json": 282,
	"./es/public/simple-search.json": 318,
	"./es/public/views/360.json": 319,
	"./es/public/views/abogalitypro.json": 320,
	"./es/public/views/account/login.json": 321,
	"./es/public/views/account/password-update.json": 322,
	"./es/public/views/account/update-required-data.json": 323,
	"./es/public/views/cookies-policy.json": 324,
	"./es/public/views/faqs.json": 325,
	"./es/public/views/healthy-community.json": 326,
	"./es/public/views/healthy-habits.json": 327,
	"./es/public/views/legal-areas.json": 225,
	"./es/public/views/legal-warning.json": 328,
	"./es/public/views/mindfulness.json": 286,
	"./es/public/views/openlegal.json": 329,
	"./es/public/views/opensalud-empresas-new.json": 330,
	"./es/public/views/opensalud-empresas.json": 331,
	"./es/public/views/opensalud-pacientes.json": 288,
	"./es/public/views/opensalud-principal.json": 332,
	"./es/public/views/opensalud-profesionales.json": 333,
	"./es/public/views/opensalud4all.json": 299,
	"./es/public/views/patient/appointments.json": 334,
	"./es/public/views/patient/foods.json": 335,
	"./es/public/views/patient/menu-banners.json": 336,
	"./es/public/views/patient/microhabits.json": 337,
	"./es/public/views/patient/panel.json": 338,
	"./es/public/views/patient/search.json": 339,
	"./es/public/views/primesalud-discounts.json": 289,
	"./es/public/views/primesalud-medical-assistance.json": 297,
	"./es/public/views/primesalud-wellness.json": 290,
	"./es/public/views/primesalud.json": 287,
	"./es/public/views/privacy-policy-professional.json": 226,
	"./es/public/views/privacy-policy.json": 227,
	"./es/public/views/pyme.json": 340,
	"./es/public/views/selfEvaluationTests.json": 341,
	"./es/public/views/sgsi-policy.json": 342,
	"./es/public/views/shared/chat.json": 343,
	"./es/public/views/survey.json": 344,
	"./es/public/views/unipromel.json": 345,
	"./mx/common.json": 315,
	"./mx/global-variables.json": 312,
	"./mx/public/footer-opensalud.json": 590,
	"./mx/public/footer.json": 591,
	"./mx/public/shared/views/healthy-community.json": 592,
	"./mx/public/shared/views/selfEvaluationTests.json": 593,
	"./mx/public/views/account/password-update.json": 594,
	"./mx/public/views/healthy-community.json": 595,
	"./mx/public/views/opensalud-profesionales.json": 596,
	"./mx/public/views/privacy-policy-professional.json": 348,
	"./mx/public/views/privacy-policy.json": 349,
	"./mx/public/views/pyme.json": 597,
	"./mx/public/views/sgsi-policy.json": 598,
	"./mx/public/views/survey.json": 599,
	"./pt/clinic-history.json": 517,
	"./pt/common.json": 316,
	"./pt/forms/companies-contact-form.json": 504,
	"./pt/global-variables.json": 313,
	"./pt/payments.json": 532,
	"./pt/private-layout.json": 600,
	"./pt/public/footer-360.json": 601,
	"./pt/public/footer-opensalud.json": 516,
	"./pt/public/simple-search.json": 602,
	"./pt/public/views/360.json": 603,
	"./pt/public/views/abogalitypro.json": 604,
	"./pt/public/views/account/login.json": 605,
	"./pt/public/views/account/password-update.json": 606,
	"./pt/public/views/account/update-required-data.json": 607,
	"./pt/public/views/cookies-policy.json": 608,
	"./pt/public/views/faqs.json": 609,
	"./pt/public/views/healthy-community.json": 610,
	"./pt/public/views/healthy-habits.json": 611,
	"./pt/public/views/legal-warning.json": 612,
	"./pt/public/views/mindfulness.json": 613,
	"./pt/public/views/openlegal.json": 614,
	"./pt/public/views/opensalud-empresas-new.json": 615,
	"./pt/public/views/opensalud-empresas.json": 616,
	"./pt/public/views/opensalud-pacientes.json": 617,
	"./pt/public/views/opensalud-principal.json": 618,
	"./pt/public/views/opensalud-profesionales.json": 619,
	"./pt/public/views/opensalud4all.json": 537,
	"./pt/public/views/patient/appointments.json": 620,
	"./pt/public/views/patient/foods.json": 621,
	"./pt/public/views/patient/menu-banners.json": 622,
	"./pt/public/views/patient/microhabits.json": 623,
	"./pt/public/views/patient/panel.json": 624,
	"./pt/public/views/patient/search.json": 625,
	"./pt/public/views/primesalud-discounts.json": 626,
	"./pt/public/views/primesalud-medical-assistance.json": 627,
	"./pt/public/views/primesalud-wellness.json": 628,
	"./pt/public/views/primesalud.json": 538,
	"./pt/public/views/privacy-policy-professional.json": 350,
	"./pt/public/views/privacy-policy.json": 351,
	"./pt/public/views/pyme.json": 629,
	"./pt/public/views/selfEvaluationTests.json": 630,
	"./pt/public/views/sgsi-policy.json": 631,
	"./pt/public/views/shared/chat.json": 632,
	"./pt/public/views/survey.json": 633
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1558;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1560);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("397a56cc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e26acf92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseDialog.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e26acf92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-e26acf92]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-e26acf92],.slide-down-leave-active[data-v-e26acf92]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-e26acf92],.slide-down-leave-to[data-v-e26acf92]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-e26acf92],.slide-fade-left-leave-active[data-v-e26acf92]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-e26acf92],.slide-fade-left-leave-to[data-v-e26acf92]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-e26acf92]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-e26acf92],.fade-leave-to[data-v-e26acf92]{opacity:0\n}\n[data-v-e26acf92] .modal-header .close{display:none\n}\n[data-v-e26acf92] .cookie-checkbox-ctn{margin-bottom:-2.5rem;margin-top:3rem\n}\n[data-v-e26acf92] .modal-footer{padding-bottom:0\n}\n", ""]);

// exports


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1562);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3c607ba8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e193b65c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseCheckbox.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e193b65c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseCheckbox.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.invalid-state .custom-control-label::before{border-color:#FF7061\n}\n", ""]);

// exports


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-checkbox",
        {
          class: { "invalid-state": _vm.state === false },
          style: { margin: _vm.noMargin ? 0 : null },
          on: { input: _vm.onInput },
          model: {
            value: _vm.localValue,
            callback: function($$v) {
              _vm.localValue = $$v
            },
            expression: "localValue"
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { state: _vm.state } }, [
        _vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e193b65c", esExports)
  }
}

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "cancel-disabled": _vm.cancelDisabled,
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        title: _vm.title,
        "hide-footer": _vm.hideFooter,
        "hide-header": !_vm.title,
        size: _vm.size
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _vm.okBtnVisible
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: _vm.okBtnVariant },
                      on: {
                        click: function($event) {
                          return _vm.builtInOkFn()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.okBtnText || _vm.$t("dialog.ok-button")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.cancelFn
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: _vm.cancelBtnVariant },
                      on: {
                        click: function($event) {
                          return _vm.builtInCancelFn()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.cancelBtnText || _vm.$t("dialog.cancel-button")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.localValue,
        callback: function($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue"
      }
    },
    [
      _vm.content
        ? _c("div", {
            staticClass: "text-center",
            domProps: { innerHTML: _vm._s(_vm.content) }
          })
        : _vm._t("default"),
      _vm._v(" "),
      !_vm.hideFooter
        ? _c(
            "div",
            { staticClass: "cookie-checkbox-ctn" },
            [
              _vm.dontShowAgainCookie
                ? _c(
                    "base-checkbox",
                    {
                      staticClass: "text-center mb-0",
                      model: {
                        value: _vm.dontShowAgainChecked,
                        callback: function($$v) {
                          _vm.dontShowAgainChecked = $$v
                        },
                        expression: "dontShowAgainChecked"
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$t("dontShowAgain")) }
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e26acf92", esExports)
  }
}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1566);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("97c39d90", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9c5948e4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9c5948e4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.modal-dialog{margin:auto\n}\n.modal-body h5{margin-bottom:1.5rem\n}\n", ""]);

// exports


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        name: "base-modal",
        centered: "",
        "hide-header-close": _vm.hideClose,
        size: _vm.size,
        "hide-footer": !_vm.footerSlotExists,
        "no-close-on-backdrop": _vm.noCloseOnBackdrop,
        "no-close-on-esc": _vm.noCloseOnScape,
        "body-class": _vm.bodyClass
      },
      on: {
        shown: function($event) {
          return _vm.$emit("shown", $event)
        },
        hidden: function($event) {
          return _vm.$emit("hidden", $event)
        },
        hide: function($event) {
          return _vm.$emit("hide")
        }
      },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _vm.title
        ? _c("h5", {
            class: { "text-center": !_vm.titleAlignLeft },
            domProps: { innerHTML: _vm._s(_vm.title) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c5948e4", esExports)
  }
}

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1569);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3ce717c8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-364c408b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseDatepicker.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-364c408b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseDatepicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.b-calendar .btn-outline-secondary{color:#8A8A8A !important\n}\n", ""]);

// exports


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1571);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b51ea8c6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52dc9e16\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./VuelidateError.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52dc9e16\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./VuelidateError.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-invalid-feedback", { attrs: { state: _vm.state } }, [
    _vm._v("\n  " + _vm._s(_vm.errorMsg) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52dc9e16", esExports)
  }
}

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          class: { "no-margin-bottom": _vm.noMarginBottom },
          staticStyle: { "text-align": "initial !important" },
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "b-input-group-append",
                [
                  _c("b-form-datepicker", {
                    attrs: {
                      right: _vm.right,
                      "label-help": "",
                      "show-decade-nav": true,
                      "reset-button": _vm.resetButtton,
                      "label-reset-button": _vm.$t("reset"),
                      "label-current-month": _vm.$t("current-month"),
                      "label-next-year": _vm.$t("next-year"),
                      "label-selected": _vm.$t("selected-date"),
                      "label-next-month": _vm.$t("next-month"),
                      "label-prev-year": _vm.$t("prev-year"),
                      "label-prev-month": _vm.$t("prev-month"),
                      "label-next-decade": _vm.$t("next-decade"),
                      "label-prev-decade": _vm.$t("prev-decade"),
                      min: _vm.min
                        ? _vm.min
                        : _vm.dateAfterNow
                        ? new Date()
                        : null,
                      max: _vm.max
                        ? _vm.max
                        : _vm.dateBeforeNow
                        ? new Date()
                        : null,
                      "label-no-date-selected": _vm.placeholder,
                      "date-format-options": _vm.dateFormatOptions,
                      "start-weekday": _vm.MONDAY_START_ID,
                      locale: _vm.$i18nHelpers.getNormalizedLocale(),
                      placeholder: _vm.placeholder,
                      state: _vm.state
                    },
                    on: {
                      shown: function($event) {
                        return _vm.$emit("shown", $event)
                      },
                      hidden: function($event) {
                        return _vm.$emit("hidden", $event)
                      },
                      input: function($event) {
                        return _vm.$emit("input", $event)
                      }
                    },
                    model: {
                      value: _vm.localValue,
                      callback: function($$v) {
                        _vm.localValue = $$v
                      },
                      expression: "localValue"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("vuelidate-error", {
            attrs: {
              validator: _vm.validator,
              parentValidators: _vm.parentValidators,
              requiredErrorMsg: _vm.errorMsg,
              state: _vm.state
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-364c408b", esExports)
  }
}

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_i18n_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_routes_public_routes__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_routes_video_routes__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_routes_webapp_professional_routes__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_routes_webapp_patient_routes__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_routes_testing_routes__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_routes_opensaludprime_routes__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_routes_opensalud4all_routes__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_routes_openlegal_routes__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_routes_abogalitypro_routes__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_routes_unipromel_routes__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router_routes_account_routes__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router_routes_webapp_forum_routes__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router_routes_webapp_healthycommunity_routes__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router_routes_webapp_healthyhabits_routes__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router_routes_opensalud360_routes__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__router_routes_webapp_survey_routes__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants_logosFileNames__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_ui_helpers__ = __webpack_require__(162);
























var mixedPublicRoutes = __WEBPACK_IMPORTED_MODULE_2__router_routes_public_routes__["a" /* default */];

if (false) {
  mixedPublicRoutes = publicRoutes.concat(testingRoutes);
}

var baseRoutes = [{
  path: '/',
  name: 'Pacientes',
  component: function component() {
    return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 2413));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_19__constants_layouts__["f" /* OPENSALUD_PACIENTES_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_1__plugins_i18n_js__["a" /* default */].t('patient-title');
      }
    },
    logo: {
      src: __WEBPACK_IMPORTED_MODULE_20__helpers_global_helpers__["l" /* inMx */] ? __WEBPACK_IMPORTED_MODULE_22__helpers_ui_helpers__["f" /* isMobileOrTablet */] ? __WEBPACK_IMPORTED_MODULE_21__constants_logosFileNames__["k" /* OPENSALUD_MX_WHITE_LOGO */] : __WEBPACK_IMPORTED_MODULE_21__constants_logosFileNames__["j" /* OPENSALUD_MX_LOGO */] : __WEBPACK_IMPORTED_MODULE_22__helpers_ui_helpers__["f" /* isMobileOrTablet */] ? __WEBPACK_IMPORTED_MODULE_21__constants_logosFileNames__["n" /* PRIME_BY_OPENSALUD_LOGO_WHITE */] : __WEBPACK_IMPORTED_MODULE_21__constants_logosFileNames__["m" /* PRIME_BY_OPENSALUD_LOGO */],
      styleClasses: __WEBPACK_IMPORTED_MODULE_20__helpers_global_helpers__["l" /* inMx */] ? '' : 'wider'
    },
    tagLine: false,
    i18n: 'public/views/opensalud-pacientes.json'
  }
}].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(mixedPublicRoutes));

var children = [{
  path: '',
  component: function component() {
    return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 2414));
  }
}, __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('patient', __WEBPACK_IMPORTED_MODULE_5__router_routes_webapp_patient_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('professional', __WEBPACK_IMPORTED_MODULE_4__router_routes_webapp_professional_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('center', []), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('video', __WEBPACK_IMPORTED_MODULE_3__router_routes_video_routes__["a" /* default */], function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1109));
}), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('opensaludprime', __WEBPACK_IMPORTED_MODULE_8__router_routes_opensaludprime_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('openlegal', __WEBPACK_IMPORTED_MODULE_10__router_routes_openlegal_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('opensalud4all', __WEBPACK_IMPORTED_MODULE_9__router_routes_opensalud4all_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('abogalitypro', __WEBPACK_IMPORTED_MODULE_11__router_routes_abogalitypro_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('unipromel', __WEBPACK_IMPORTED_MODULE_12__router_routes_unipromel_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('cuenta', __WEBPACK_IMPORTED_MODULE_13__router_routes_account_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('foro', __WEBPACK_IMPORTED_MODULE_14__router_routes_webapp_forum_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('comunidadsaludable', __WEBPACK_IMPORTED_MODULE_15__router_routes_webapp_healthycommunity_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('habitossaludables', __WEBPACK_IMPORTED_MODULE_16__router_routes_webapp_healthyhabits_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('360', __WEBPACK_IMPORTED_MODULE_17__router_routes_opensalud360_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6__router_routeHelpers__["a" /* default */].buildRoutes('survey', __WEBPACK_IMPORTED_MODULE_18__router_routes_webapp_survey_routes__["a" /* default */])];

var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(baseRoutes), children);

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(972);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_693f4c7c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1578);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1576)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_693f4c7c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/opensalud/Home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-693f4c7c", Component.options)
  } else {
    hotAPI.reload("data-v-693f4c7c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("40c5f04c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-693f4c7c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-693f4c7c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col" },
      [
        _c("h3", [_vm._v("Welcome, ")]),
        _vm._v(" "),
        _c("div", { staticClass: "alert alert-info" }, [
          _vm._v("\n            " + _vm._s(_vm.userInfo) + "\n        ")
        ]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: "/logout" } }, [
          _vm._v("\n            Logout\n        ")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-693f4c7c", esExports)
  }
}

/***/ }),
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoutSuccess_vue__ = __webpack_require__(977);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a29ea4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoutSuccess_vue__ = __webpack_require__(1586);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoutSuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a29ea4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoutSuccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/opensalud/LogoutSuccess.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a29ea4c", Component.options)
  } else {
    hotAPI.reload("data-v-6a29ea4c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col" },
      [
        _c("h2", [_vm._v("Logged Out successfully")]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: "/login" } }, [_vm._v("Login")])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a29ea4c", esExports)
  }
}

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(973);



/* harmony default export */ __webpack_exports__["a"] = ({
    getUserInfo: function getUserInfo() {
        var jwtToken = __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].auth.getSignInUserSession().getAccessToken().jwtToken;
        var USERINFO_URL = 'https://' + __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].auth.getAppWebDomain() + '/oauth2/userInfo';
        var requestData = {
            headers: {
                'Authorization': 'Bearer ' + jwtToken
            }
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(USERINFO_URL, requestData).then(function (response) {
            return response.data;
        });
    }
});

/***/ }),
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__ = __webpack_require__(30);



/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Error.NotFound',
  path: 'error/not-found',
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 990));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('page-not-found');
      }
    }
  }
}, {
  name: 'Error.Unauthorized',
  path: 'error/unauthorized',
  component: function component() {
    return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 2337));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    fullWidthLayout: true,
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('base.errors.unauthorized.title');
      },

      hide: true
    }
  }
}, {
  name: 'Error.Unauthorized360',
  path: 'error/unauthorized/360',
  component: function component() {
    return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 2338));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('base.errors.unauthorized.title');
      }
    }
  }
}, {
  name: 'Error.UnauthorizedTravel',
  path: 'error/unauthorized/travel',
  component: function component() {
    return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 2339));
  },
  meta: {
    layout: __WEBPACK_IMPORTED_MODULE_0__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
    title: {
      text: function text() {
        return __WEBPACK_IMPORTED_MODULE_1__plugins_i18n__["a" /* default */].t('base.errors.unauthorized.title');
      }
    }
  }
}]);

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1612);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("25bc0c6a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c26e156\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotFoundErrorPage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c26e156\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotFoundErrorPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t("page-not-found")))])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c26e156", esExports)
  }
}

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1615);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("845e7c98", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8c7aad26\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8c7aad26\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-8c7aad26]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-8c7aad26],.slide-down-leave-active[data-v-8c7aad26]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-8c7aad26],.slide-down-leave-to[data-v-8c7aad26]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-8c7aad26],.slide-fade-left-leave-active[data-v-8c7aad26]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-8c7aad26],.slide-fade-left-leave-to[data-v-8c7aad26]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-8c7aad26]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-8c7aad26],.fade-leave-to[data-v-8c7aad26]{opacity:0\n}\n.eyeIconPass[data-v-8c7aad26]{cursor:pointer;position:absolute;margin:-9.5% 0px 0px 33%\n}\n.terms-ctn[data-v-8c7aad26]{max-height:300px;overflow-y:auto;padding:10px;border:1px solid #ccc;border-radius:5px;margin-bottom:10px;border-radius:23px\n}\n", ""]);

// exports


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PASSWORD_UPDATE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TWO_FACTOR_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REENABLE_ACCOUNT_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_CREDENTIALS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PASSWORD_MAX_ATTEMPTS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TERMS_AND_CONDITIONS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PRIVACY_POLICY_ACTION; });
var PASSWORD_UPDATE_ACTION = 'PasswordUpdateRequired';
var TWO_FACTOR_ACTION = 'TwoFactorRequired';
var REENABLE_ACCOUNT_ACTION = 'ReenableAccount';
var CHECK_CREDENTIALS_ACTION = 'CheckCredentials';
var PASSWORD_MAX_ATTEMPTS_ACTION = 'PasswordMaxAttempts';
var TERMS_AND_CONDITIONS_ACTION = 'TermsAndConditions';
var PRIVACY_POLICY_ACTION = 'PrivacyPolicy';

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_EDGE_CASES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);


var LOGIN_EDGE_CASES = function LOGIN_EDGE_CASES(domain, travelCompany, startDate, endDate, token) {
    return {
        INDITEX_OLD_EMPLOYEE: {
            view: '/error/unauthorized/360'
        },
        ZARA_EXPIRED: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.zaraExpired'),
            view: '/error/unauthorized'
        },
        DENIED_ACCESS: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.deniedAccess'),
            view: '/error/unauthorized'
        },
        ZARA_PILOT_END: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.zaraPilotEnd'),
            view: '/error/unauthorized'
        },
        COPAYMENT_ENABLED: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.copaymentEnabled')
        },
        SANTANDER_PAID_SERVICE: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.santanderPaidService')
        },
        TRAVEL_EXPIRED: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.travelExpired', { travelCompany: travelCompany, endDate: endDate, domain: domain }),
            view: '/error/unauthorized/travel?t=' + token
        },
        TRAVEL_NOT_STARTED_YET: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.travelNotStartedYet', { travelCompany: travelCompany, startDate: startDate }),
            view: '/error/unauthorized'
        },
        EXPIRED: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.expired', { domain: domain }),
            view: '/error/unauthorized'
        },
        EMPLOYEE_NUMBER_NOT_ACTIVE: {
            message: __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('login.errors.deniedAccess'),
            view: '/error/unauthorized'
        }
    };
};

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);



var api = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$api;
function accountPath(resource) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* path */])('/webapp/' + resource);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	updateReadTermsDate: function updateReadTermsDate(token) {
		return api.post(accountPath('user-terms'), {}, {
			headers: {
				'Authorization': 'Bearer ' + token
			}
		});
	},
	updateReadPrivacyPolicyDate: function updateReadPrivacyPolicyDate(token) {
		return api.post(accountPath('user-privacy-policies'), {}, {
			headers: {
				'Authorization': 'Bearer ' + token
			}
		});
	}
});

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", {
    staticClass: "text-left",
    domProps: { innerHTML: _vm._s(_vm.$t("terms-and-conditions-patient")) }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86ac9848", esExports)
  }
}

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", {
    staticClass: "text-left",
    domProps: { innerHTML: _vm._s(_vm.$t("terms-and-conditions-professional")) }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-484163e0", esExports)
  }
}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("232909ca", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0cba630e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivacyPolicy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0cba630e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivacyPolicy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-0cba630e]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-0cba630e],.slide-down-leave-active[data-v-0cba630e]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-0cba630e],.slide-down-leave-to[data-v-0cba630e]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-0cba630e],.slide-fade-left-leave-active[data-v-0cba630e]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-0cba630e],.slide-fade-left-leave-to[data-v-0cba630e]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-0cba630e]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-0cba630e],.fade-leave-to[data-v-0cba630e]{opacity:0\n}\n[data-v-0cba630e] li{list-style:inherit !important\n}\n", ""]);

// exports


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", {
    staticClass: "text-left",
    domProps: {
      innerHTML: _vm._s(
        _vm.$t("privacy-policy.text", _vm.PRIVACY_POLICY_COMPANY_DATA)
      )
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cba630e", esExports)
  }
}

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("7605a4f4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-45e30880\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivacyPolicyProfessional.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-45e30880\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivacyPolicyProfessional.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-45e30880]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-45e30880],.slide-down-leave-active[data-v-45e30880]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-45e30880],.slide-down-leave-to[data-v-45e30880]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-45e30880],.slide-fade-left-leave-active[data-v-45e30880]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-45e30880],.slide-fade-left-leave-to[data-v-45e30880]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-45e30880]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-45e30880],.fade-leave-to[data-v-45e30880]{opacity:0\n}\n[data-v-45e30880] li{list-style:inherit !important\n}\n", ""]);

// exports


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", {
    staticClass: "text-left",
    domProps: {
      innerHTML: _vm._s(
        _vm.$t(
          "privacy-policy-professional.text",
          _vm.PRIVACY_POLICY_COMPANY_DATA
        )
      )
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45e30880", esExports)
  }
}

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-2" },
    [
      _c("base-dialog", {
        attrs: {
          okFn: function async() {
            _vm.defaultLoginCallback(_vm.loginInfo)
          },
          content: _vm.loginEdgeCaseDialog.content
        },
        model: {
          value: _vm.loginEdgeCaseDialog.visible,
          callback: function($$v) {
            _vm.$set(_vm.loginEdgeCaseDialog, "visible", $$v)
          },
          expression: "loginEdgeCaseDialog.visible"
        }
      }),
      _vm._v(" "),
      _c(
        "base-dialog",
        {
          attrs: {
            keepOpened: "",
            okFn: function async() {
              _vm.acceptTerms()
            },
            cancelFn: function() {
              _vm.denyTerms()
            }
          },
          model: {
            value: _vm.termsAndConditionsModalVisible,
            callback: function($$v) {
              _vm.termsAndConditionsModalVisible = $$v
            },
            expression: "termsAndConditionsModalVisible"
          }
        },
        [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.$t("login.terms-and-conditions")) +
              "\n\t\t\t"
          ),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "terms-ctn" },
            [
              _vm.userRoleIsPatient
                ? _c("TermsAndConditionsPatient")
                : _c("TermsAndConditionsProfessional")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              attrs: { state: _vm.termsAndConditionsAccepted },
              model: {
                value: _vm.termsAndConditionsAccepted,
                callback: function($$v) {
                  _vm.termsAndConditionsAccepted = $$v
                },
                expression: "termsAndConditionsAccepted"
              }
            },
            [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("login.terms-and-conditions-accept")) +
                  "\n\t\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-dialog",
        {
          attrs: {
            keepOpened: "",
            okFn: function async() {
              _vm.acceptPrivacyPolicy()
            },
            cancelFn: function() {
              _vm.denyPrivacyPolicy()
            }
          },
          model: {
            value: _vm.privacyPolicyModalVisible,
            callback: function($$v) {
              _vm.privacyPolicyModalVisible = $$v
            },
            expression: "privacyPolicyModalVisible"
          }
        },
        [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.$t("login.privacy-policy")) + "\n\t\t\t"
          ),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "terms-ctn" },
            [
              _vm.userRoleIsPatient
                ? _c("PrivacyPolicy")
                : _c("PrivacyPolicyProfessional")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              attrs: { state: _vm.privacyPolicyAccepted },
              model: {
                value: _vm.privacyPolicyAccepted,
                callback: function($$v) {
                  _vm.privacyPolicyAccepted = $$v
                },
                expression: "privacyPolicyAccepted"
              }
            },
            [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("login.privacy-policy-accept")) +
                  "\n\t\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.titleVisible ? _c("h3", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form",
        {
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.login.apply(null, arguments)
            }
          }
        },
        [
          _vm.form.state.submitted && _vm.form.state.unauthorized
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v(_vm._s(_vm.submitError))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.checkCredentials
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v(
                  _vm._s(
                    !_vm.mfaVisible
                      ? _vm.$t("invalid-credentials")
                      : _vm.$t("invalid-2facode")
                  )
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.state.submitted && _vm.form.state.errors
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.accountError || _vm.$t("login.server-error")
                    )
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.mfaVisible
            ? _c(
                "b-form-group",
                [
                  _c("base-input", {
                    attrs: {
                      placeholder: _vm.$t("login.email"),
                      state: _vm.emailValidation,
                      errorMsg: _vm.$t("login.errors.email"),
                      autocomplete: "disabled"
                    },
                    model: {
                      value: _vm.form.email,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "base-input",
                    {
                      attrs: {
                        placeholder: _vm.$t("login.password"),
                        type: _vm.showPassword ? "text" : "password",
                        state: _vm.passwordValidation,
                        errorMsg: _vm.$t("login.errors.password"),
                        autocomplete: "disabled"
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password"
                      }
                    },
                    [
                      _c("template", { slot: "append" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                _vm.showPassword = !_vm.showPassword
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              [
                                !_vm.showPassword ? _c("b-icon-eye") : _vm._e(),
                                _vm.showPassword
                                  ? _c("b-icon-eye-slash")
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _c(
                "b-form-group",
                [
                  _c("base-input", {
                    attrs: {
                      placeholder: _vm.$t("login.twoFACode-ph"),
                      label: _vm.$t("login.twoFACode")
                    },
                    model: {
                      value: _vm.form.mfaCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mfaCode", $$v)
                      },
                      expression: "form.mfaCode"
                    }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticStyle: { width: "100%" },
              attrs: {
                type: "submit",
                variant: "primary",
                disabled: _vm.$store.state.loading
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("login.sign-in")) + "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _vm.inOpenlegal()
            ? _c(
                "b-button",
                {
                  staticClass: "mt-4",
                  staticStyle: { width: "100%" },
                  attrs: { variant: "outline-primary" },
                  on: { click: _vm.$helpers.gotoACAUrl }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.aca-sign-in")) +
                      "\n      "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "router-link",
            {
              attrs: { to: "/cuenta/peticion-actualizar-contrasena", tag: "a" }
            },
            [_vm._v(_vm._s(_vm.$t("login.forget-password")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c7aad26", esExports)
  }
}

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1629);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b22a45a2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-88233bf6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BackButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-88233bf6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BackButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-88233bf6]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-88233bf6],.slide-down-leave-active[data-v-88233bf6]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-88233bf6],.slide-down-leave-to[data-v-88233bf6]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-88233bf6],.slide-fade-left-leave-active[data-v-88233bf6]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-88233bf6],.slide-fade-left-leave-to[data-v-88233bf6]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-88233bf6]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-88233bf6],.fade-leave-to[data-v-88233bf6]{opacity:0\n}\n@media only screen and (max-width: 575px){\n.back-btn[data-v-88233bf6]{padding:.6rem 1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.back-btn[data-v-88233bf6]{padding:.6rem 1rem\n}\n}\n.base-btn[data-v-88233bf6]{display:inline-block;color:#8A8A8A;cursor:pointer\n}\n", ""]);

// exports


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.withoutButton
    ? _c(
        "div",
        {
          staticClass: "base-btn",
          on: {
            click: function($event) {
              return _vm.action()
            }
          }
        },
        [
          _c("base-icon", {
            staticClass: "mr-2",
            attrs: {
              src:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
              color: "gray",
              reverse: ""
            }
          }),
          _vm._v(_vm._s(_vm.$t("back")))
        ],
        1
      )
    : _c(
        "base-button",
        {
          attrs: { gray: "", outline: "" },
          on: {
            click: function($event) {
              return _vm.action()
            }
          },
          nativeOn: {
            mouseover: function($event) {
              _vm.hover = true
            },
            mouseleave: function($event) {
              _vm.hover = false
            }
          }
        },
        [
          _c("base-icon", {
            staticClass: "mr-2",
            attrs: {
              src:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
              color: "gray",
              reverse: ""
            }
          }),
          _vm._v(_vm._s(_vm.$t("back")))
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88233bf6", esExports)
  }
}

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapseTransition_vue__ = __webpack_require__(1002);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18781591_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapseTransition_vue__ = __webpack_require__(1632);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapseTransition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18781591_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapseTransition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/transitions/CollapseTransition.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-18781591", Component.options)
  } else {
    hotAPI.reload("data-v-18781591", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: _vm.name },
      on: {
        "before-appear": _vm.beforeAppear,
        appear: _vm.appear,
        "after-appear": _vm.afterAppear,
        "appear-cancelled": _vm.appearCancelled,
        "before-enter": _vm.beforeEnter,
        enter: _vm.enter,
        "after-enter": _vm.afterEnter,
        "enter-cancelled": _vm.enterCancelled,
        "before-leave": _vm.beforeLeave,
        leave: _vm.leave,
        "after-leave": _vm.afterLeave,
        "leave-cancelled": _vm.leaveCancelled
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18781591", esExports)
  }
}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegal_orange.9d746eb.svg";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/openlegal_white.c4f5275.svg";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensalud_healthierlives_color.5833d4c.svg";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-appopensalud/img/opensaludmx_healthierlives_color.fbf9a1b.svg";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1638);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0bbc7fe2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ac300cb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseInput.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ac300cb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-4ac300cb]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-4ac300cb],.slide-down-leave-active[data-v-4ac300cb]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-4ac300cb],.slide-down-leave-to[data-v-4ac300cb]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-4ac300cb],.slide-fade-left-leave-active[data-v-4ac300cb]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-4ac300cb],.slide-fade-left-leave-to[data-v-4ac300cb]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-4ac300cb]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-4ac300cb],.fade-leave-to[data-v-4ac300cb]{opacity:0\n}\n[data-v-4ac300cb].zero-margin-bottom{margin-bottom:0px !important\n}\n[data-v-4ac300cb].align-left{width:100%\n}\n[data-v-4ac300cb].align-left label{margin-left:1%;text-align:left\n}\n@media only screen and (min-width: 1024px){\n[data-v-4ac300cb].align-left{width:30%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-4ac300cb].align-left{width:30%\n}\n}\n[data-v-4ac300cb].width-50{width:50%\n}\n@media only screen and (max-width: 575px){\n[data-v-4ac300cb].width-50{width:95%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-4ac300cb].width-50{width:95%\n}\n}\n.width-25[data-v-4ac300cb]{width:25%\n}\n@media only screen and (max-width: 575px){\n.width-25[data-v-4ac300cb]{width:95%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.width-25[data-v-4ac300cb]{width:95%\n}\n}\n.input-center[data-v-4ac300cb]{display:block;margin:auto\n}\n.inline-Block[data-v-4ac300cb]{display:inline-block\n}\n.tooltip-width[data-v-4ac300cb]{display:inline-block;width:90%\n}\n[data-v-4ac300cb] label{padding-left:1rem;text-align:center\n}\n.border-none[data-v-4ac300cb]{border:none\n}\n.border-none[data-v-4ac300cb]:focus{-webkit-box-shadow:none;box-shadow:none\n}\n", ""]);

// exports


/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          class: {
            "zero-margin-bottom": _vm.zeroMarginBottom,
            "align-left": _vm.alignLeft,
            "width-50": _vm.width50,
            "width-25": _vm.width25,
            "inline-Block": _vm.inlineBlock,
            "tooltip-width": _vm.tooltip
          },
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          !_vm.hasAppendSlot
            ? _c(
                "b-form-input",
                _vm._b(
                  {
                    class: { "border-none": _vm.borderNone },
                    attrs: {
                      type: _vm.type,
                      id: _vm.id,
                      maxlength: _vm.maxlength,
                      placeholder: _vm.placeholder,
                      readonly: _vm.readonly,
                      autocomplete: _vm.autocomplete,
                      state: _vm.state,
                      size: _vm.size,
                      min: _vm.min,
                      max: _vm.max,
                      disabled: _vm.disabled,
                      step: _vm.step
                    },
                    on: {
                      keyup: function($event) {
                        return _vm.$emit("keyup", $event)
                      },
                      click: function($event) {
                        return _vm.$emit("click", $event)
                      },
                      blur: function($event) {
                        return _vm.$emit("blur", $event)
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.enterEventAction ? _vm.enterEventAction() : null
                      }
                    },
                    model: {
                      value: _vm.localValue,
                      callback: function($$v) {
                        _vm.localValue = $$v
                      },
                      expression: "localValue"
                    }
                  },
                  "b-form-input",
                  _vm.dataAttributes,
                  false
                )
              )
            : _c(
                "b-input-group",
                [
                  _c(
                    "b-form-input",
                    _vm._b(
                      {
                        class: { "border-none": _vm.borderNone },
                        attrs: {
                          type: _vm.type,
                          id: _vm.id,
                          placeholder: _vm.placeholder,
                          maxlength: _vm.maxlength,
                          readonly: _vm.readonly,
                          state: _vm.state,
                          autocomplete: _vm.autocomplete,
                          size: _vm.size,
                          min: _vm.min,
                          max: _vm.max,
                          disabled: _vm.disabled,
                          step: _vm.step
                        },
                        on: {
                          keyup: function($event) {
                            return _vm.$emit("keyup", $event)
                          },
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            _vm.enterEventAction ? _vm.enterEventAction() : null
                          }
                        },
                        model: {
                          value: _vm.localValue,
                          callback: function($$v) {
                            _vm.localValue = $$v
                          },
                          expression: "localValue"
                        }
                      },
                      "b-form-input",
                      _vm.dataAttributes,
                      false
                    )
                  ),
                  _vm._v(" "),
                  _vm.hasAppendSlot
                    ? _c(
                        "b-input-group-append",
                        [_c("b-input-group-text", [_vm._t("append")], 2)],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("vuelidate-error", {
                    attrs: {
                      state: _vm.state,
                      validator: _vm.validator,
                      requiredErrorMsg: _vm.requiredErrorMsg
                    }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _vm.tooltip
        ? _c("b-icon-question-circle", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover",
                modifiers: { hover: true }
              },
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.click",
                value: _vm.tooltip,
                expression: "tooltip",
                modifiers: { click: true }
              }
            ],
            attrs: { title: _vm.tooltip }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.inputInfoText
        ? _c("b-form-text", [_vm._v(_vm._s(_vm.inputInfoText))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ac300cb", esExports)
  }
}

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("235a69dc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6efd13da\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseRadioGroup.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6efd13da\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseRadioGroup.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-group", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var ariaDescribedby = ref.ariaDescribedby
          return [
            _c("b-form-radio-group", {
              attrs: {
                options: _vm.optionsSettledLabels,
                "aria-describedby": ariaDescribedby,
                size: "lg",
                state: _vm.state,
                stacked: _vm.stacked,
                "text-field": "label"
              },
              on: {
                change: function($event) {
                  return _vm.$emit("change", $event)
                }
              },
              model: {
                value: _vm.localValue,
                callback: function($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue"
              }
            }),
            _vm._v(" "),
            _c("b-form-invalid-feedback", { attrs: { state: _vm.state } }, [
              _vm._v(_vm._s(_vm.errorMsg))
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6efd13da", esExports)
  }
}

/***/ }),
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1654);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("37ca65f9", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48d0a069\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddToHomeScreen.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48d0a069\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddToHomeScreen.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.install-app-block{cursor:pointer;background-color:#3238C4;color:#eee;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;padding:0.5rem 1.75rem;border-radius:23px;-webkit-transition:all 0.5s;transition:all 0.5s\n}\n.install-app-block.white{background-color:transparent;border:1px solid #eee\n}\n@media only screen and (max-width: 575px){\n.install-app-block{font-size:12.25px\n}\n}\n.install-app-block:hover{border:1px solid white;font-size:1.05rem;-webkit-transition:all 0.5s;transition:all 0.5s\n}\n.install-app-block.shadow{-webkit-box-shadow:-14px -14px 23px #fff,14px 14px 25px rgba(13,39,80,0.160784);box-shadow:-14px -14px 23px #fff,14px 14px 25px rgba(13,39,80,0.160784)\n}\n.install-app-block img{width:20px;vertical-align:text-bottom\n}\n.install-app-block .animate{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-name:animate-fade;animation-name:animate-fade;-webkit-animation-timing-function:cubic-bezier(0.26, 0.53, 0.74, 1.48);animation-timing-function:cubic-bezier(0.26, 0.53, 0.74, 1.48);-webkit-animation-fill-mode:backwards;animation-fill-mode:backwards;-webkit-animation-name:animate-glow;animation-name:animate-glow;-webkit-animation-timing-function:ease;animation-timing-function:ease\n}\n@-webkit-keyframes animate-glow{\n0%{opacity:0;-webkit-filter:brightness(3) saturate(3);filter:brightness(3) saturate(3);-webkit-transform:scale(0.8, 0.8);transform:scale(0.8, 0.8)\n}\n100%{opacity:1;-webkit-filter:brightness(1) saturate(1);filter:brightness(1) saturate(1);-webkit-transform:scale(1, 1);transform:scale(1, 1)\n}\n}\n@keyframes animate-glow{\n0%{opacity:0;-webkit-filter:brightness(3) saturate(3);filter:brightness(3) saturate(3);-webkit-transform:scale(0.8, 0.8);transform:scale(0.8, 0.8)\n}\n100%{opacity:1;-webkit-filter:brightness(1) saturate(1);filter:brightness(1) saturate(1);-webkit-transform:scale(1, 1);transform:scale(1, 1)\n}\n}\n.install-app-block span{color:#eee\n}\n.safari-tooltip{position:fixed;bottom:15px;left:0;right:0;padding:1rem;background-color:#eee;color:#1D1D1E;text-align:center;font-size:0.9rem;z-index:9999;border-radius:23px;margin-left:1rem;margin-right:1rem\n}\n.safari-tooltip span{display:inline-block;width:100%;max-width:500px;text-align:left\n}\n.safari-tooltip:after{content:'';position:fixed;bottom:-5px;left:50%;margin-left:-11px;border-width:11px;border-style:solid;border-color:#eee transparent transparent transparent\n}\n.safari-tooltip .safari-tooltip-icon{width:19px;height:19px\n}\n", ""]);

// exports


/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showA2HS
    ? _c(
        "div",
        [
          _vm.modalVisible
            ? _c(
                "base-dialog",
                {
                  attrs: {
                    okFn: _vm.addToHomeScreen,
                    cancelFn: _vm.saveNotAddingToHomeScreen,
                    okBtnText: _vm.$t("a2hs.modal-install-btn")
                  },
                  model: {
                    value: _vm.modalVisible,
                    callback: function($$v) {
                      _vm.modalVisible = $$v
                    },
                    expression: "modalVisible"
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-4 d-flex" }, [
                      _c("img", {
                        staticClass: "img-fluid m-auto",
                        attrs: { src: _vm.getAppIcon, alt: "App icon" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-8" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("a2hs.modal-message", {
                              platform: _vm.getPlatformName
                            })
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.deferredPrompt || _vm.deviceIsAllowedIOS
            ? _c(
                "div",
                {
                  staticClass: "install-app-block",
                  class: {
                    animate: _vm.animateActive,
                    shadow: _vm.shadow,
                    white: _vm.white
                  },
                  on: { click: _vm.addToHomeScreen }
                },
                [
                  _c("img", {
                    staticClass: "d-inline-block mr-2",
                    attrs: { src: _vm.getAppIcon }
                  }),
                  _vm._v(" "),
                  !_vm.small
                    ? _c("span", { staticClass: "d-inline-block" }, [
                        _vm._v(
                          _vm._s(_vm.$t("a2hs.modal-install-btn")) + " app"
                        )
                      ])
                    : _c("base-icon", {
                        staticClass: "d-inline-block ml-2",
                        attrs: {
                          blue: !_vm.white,
                          white: _vm.white,
                          src:
                            "/static-appopensalud/img/icons/install-browser.svg",
                          alt: "Instalar"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.safariTooltipVisible
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: function() {
                        return (_vm.safariTooltipVisible = false)
                      },
                      expression: "() => safariTooltipVisible = false"
                    }
                  ],
                  staticClass: "safari-tooltip"
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("a2hs.safari-tooltip", {
                          shareIconImg: _vm.shareIconImg
                        })
                      )
                    }
                  })
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48d0a069", esExports)
  }
}

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("388a758a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1abd792b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LangSelector.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1abd792b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LangSelector.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-1abd792b]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-1abd792b],.slide-down-leave-active[data-v-1abd792b]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-1abd792b],.slide-down-leave-to[data-v-1abd792b]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-1abd792b],.slide-fade-left-leave-active[data-v-1abd792b]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-1abd792b],.slide-fade-left-leave-to[data-v-1abd792b]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-1abd792b]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-1abd792b],.fade-leave-to[data-v-1abd792b]{opacity:0\n}\n.lang-cnt[data-v-1abd792b]{color:var(--color);font-weight:bold\n}\n.lang-cnt span[data-v-1abd792b]{cursor:pointer\n}\n.lang-cnt span[data-v-1abd792b]:not(:last-child){margin-right:1rem\n}\n.lang-cnt span[data-v-1abd792b]:hover{border-top:1px solid var(--color)\n}\n.lang-cnt span.active[data-v-1abd792b]{border-top:2px solid var(--color)\n}\n", ""]);

// exports


/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lang-cnt my-auto", style: _vm.cssProps }, [
    _vm.labeled ? _c("span", [_vm._v(_vm._s(_vm.$t("lang")) + ":")]) : _vm._e(),
    _vm._v(" "),
    _c(
      "span",
      {
        class: { active: _vm.isActive(_vm.esLocale) },
        style: _vm.cssProps,
        on: {
          click: function($event) {
            return _vm.$i18nHelpers.changeLang(_vm.esLocale)
          }
        }
      },
      [_vm._v("ES")]
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        class: { active: _vm.isActive(_vm.EN_LOCALE) },
        style: _vm.cssProps,
        on: {
          click: function($event) {
            return _vm.$i18nHelpers.changeLang(_vm.EN_LOCALE)
          }
        }
      },
      [_vm._v("EN")]
    ),
    _vm._v(" "),
    _vm.enablePortuguese
      ? _c(
          "span",
          {
            class: { active: _vm.isActive(_vm.PT_LOCALE) },
            style: _vm.cssProps,
            on: {
              click: function($event) {
                return _vm.$i18nHelpers.changeLang(_vm.PT_LOCALE)
              }
            }
          },
          [_vm._v("PT")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1abd792b", esExports)
  }
}

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1660);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("37373008", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-71129cfd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseIcon.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-71129cfd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseIcon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\nsvg.svg-shadow{-webkit-box-shadow:none !important;box-shadow:none !important;-webkit-filter:drop-shadow(-15px -14px 20px #fff) drop-shadow(15px 14px 20px rgba(13,39,80,0.3));filter:drop-shadow(-15px -14px 20px #fff) drop-shadow(15px 14px 20px rgba(13,39,80,0.3))\n}\nsvg.reverse{-webkit-transform:scale(-1, 1);transform:scale(-1, 1)\n}\n", ""]);

// exports


/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      attrs: { id: _vm.id },
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm.isSvg
        ? _c("inline-svg", {
            class: _vm.getSvgClasses,
            attrs: {
              src: _vm.src,
              width: _vm.width || _vm.getSize.width,
              height: _vm.height || _vm.getSize.height
            },
            on: { loaded: _vm.svgLoaded }
          })
        : _c("img", {
            attrs: { src: _vm.src, width: _vm.width || _vm.getSize.width }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71129cfd", esExports)
  }
}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1663);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b40e2008", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31308b7e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dropdown.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31308b7e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dropdown.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-31308b7e]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-31308b7e],.slide-down-leave-active[data-v-31308b7e]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-31308b7e],.slide-down-leave-to[data-v-31308b7e]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-31308b7e],.slide-fade-left-leave-active[data-v-31308b7e]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-31308b7e],.slide-fade-left-leave-to[data-v-31308b7e]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-31308b7e]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-31308b7e],.fade-leave-to[data-v-31308b7e]{opacity:0\n}\nnav .menu-item .title[data-v-31308b7e]{font-weight:bold\n}\nnav .menu-item svg[data-v-31308b7e]{width:10px;margin-left:10px\n}\nnav .menu-item-list[data-v-31308b7e]{margin:1.15rem\n}\nnav .menu-item .sub-menu[data-v-31308b7e]{font-size:.875rem;top:4rem;right:-2rem;position:absolute;width:-webkit-max-content;width:-moz-max-content;width:max-content;padding:1rem 2rem;z-index:10;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);padding:1rem 2rem;background-color:#eee\n}\n.sub-menu hr[data-v-31308b7e]{margin-top:0rem;margin-bottom:1rem\n}\n.nav-item[data-v-31308b7e]{padding-top:0 !important;padding-bottom:0 !important\n}\n.fade-enter-active[data-v-31308b7e],.fade-leave-active[data-v-31308b7e]{-webkit-transition:all .5s ease-out;transition:all .5s ease-out\n}\n.fade-enter[data-v-31308b7e],.fade-leave-to[data-v-31308b7e]{opacity:0\n}\n", ""]);

// exports


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-item",
      on: {
        click: function($event) {
          _vm.isOpen = !_vm.isOpen
        }
      }
    },
    [
      _vm.showAsNavbarBtn
        ? _c(
            "base-button",
            {
              staticStyle: { "background-color": "transparent", width: "10rem" }
            },
            [
              _c("a", { staticClass: "title", attrs: { href: "#" } }, [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
              ])
            ]
          )
        : _c("a", { staticClass: "title", attrs: { href: "#" } }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
          ]),
      _vm._v(" "),
      _vm.signUpVisibleProfessional
        ? _c(
            "base-modal",
            {
              ref: "signUpVisibleProfessional",
              attrs: { title: _vm.$t("sign-up"), hideClose: "" },
              model: {
                value: _vm.signUpVisibleProfessional,
                callback: function($$v) {
                  _vm.signUpVisibleProfessional = $$v
                },
                expression: "signUpVisibleProfessional"
              }
            },
            [
              _c("professional-sign-up-form", {
                attrs: {
                  callback: function() {
                    _vm.signUpVisibleProfessional = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.signUpVisiblePatient
        ? _c(
            "base-modal",
            {
              ref: "signUpVisiblePatient",
              attrs: { title: _vm.$t("sign-up"), hideClose: "" },
              model: {
                value: _vm.signUpVisiblePatient,
                callback: function($$v) {
                  _vm.signUpVisiblePatient = $$v
                },
                expression: "signUpVisiblePatient"
              }
            },
            [
              _c("sign-up-form", {
                attrs: {
                  callback: function() {
                    _vm.signUpVisiblePatient = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.signUpVisibleCenter
        ? _c(
            "base-modal",
            {
              ref: "signUpVisibleCenter",
              attrs: { title: _vm.$t("sign-up"), hideClose: "" },
              model: {
                value: _vm.signUpVisibleCenter,
                callback: function($$v) {
                  _vm.signUpVisibleCenter = $$v
                },
                expression: "signUpVisibleCenter"
              }
            },
            [
              _c("center-sign-up-form", {
                attrs: {
                  callback: function() {
                    _vm.signUpVisibleCenter = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        _vm.isOpen
          ? _c(
              "div",
              { staticClass: "sub-menu" },
              [
                _vm.showLanguageSelector
                  ? _c(
                      "div",
                      { staticClass: "menu-item-list" },
                      [
                        _c("lang-selector", {
                          staticClass: "d-inline-block",
                          staticStyle: { margin: "0px !important" },
                          attrs: { enablePortuguese: _vm.enablePortuguese }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(_vm.items, function(item, i) {
                  return _c("div", { key: i, staticClass: "menu-item-list" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.dropdownOptionClick(item, i)
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              color: "#3238c4"
                            }
                          },
                          [_vm._v(_vm._s(item.title))]
                        )
                      ]
                    )
                  ])
                })
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31308b7e", esExports)
  }
}

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1666);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("a0e0ded8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1350d1ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ArrowUp.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1350d1ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ArrowUp.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-1350d1ca]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-1350d1ca],.slide-down-leave-active[data-v-1350d1ca]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-1350d1ca],.slide-down-leave-to[data-v-1350d1ca]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-1350d1ca],.slide-fade-left-leave-active[data-v-1350d1ca]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-1350d1ca],.slide-fade-left-leave-to[data-v-1350d1ca]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-1350d1ca]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-1350d1ca],.fade-leave-to[data-v-1350d1ca]{opacity:0\n}\n.arrow-go-top[data-v-1350d1ca]{position:fixed !important;display:block !important;top:89vh !important;left:5vw !important;z-index:2 !important;color:#3238C4 !important;cursor:pointer\n}\n@media only screen and (max-width: 575px){\n.arrow-go-top[data-v-1350d1ca]{top:87vh !important;left:8vw !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.arrow-go-top[data-v-1350d1ca]{top:87vh !important;left:8vw !important\n}\n}\n", ""]);

// exports


/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.calculateWindowHeight
    ? _c("b-icon-arrow-up-circle", {
        staticClass: "arrow-go-top",
        attrs: { scale: "2.5" },
        on: { click: _vm.goTop }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1350d1ca", esExports)
  }
}

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import i18n from '@/plugins/i18n'
// import { PRIVATE_LAYOUT } from '@/constants/layouts'
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'es-nodofarma',
  name: 'EsNodofarma',
  component: function component() {
    return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 2355));
  },
  meta: {
    pageTitle: 'Nuevo tratamiento'
  }
}, {
  path: 'es-nodofarma-list',
  name: 'PrescriptionList',
  component: function component() {
    return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 2330));
  },
  meta: {
    pageTitle: 'Lista tratamientos'
  }
  // {
  //   path: 'professional-network',
  //   name: 'Search',
  //   component: () => import('@/components/webapp/patient/search/Search'),
  //   meta: {
  //     layout: PRIVATE_LAYOUT,
  //     showTabMenu: true,
  //     bequeath: true,
  // 		title: {
  // 			text () {
  // 				return i18n.t('searcherTitle')
  // 			},
  // 			hide: true
  // 		},
  // 		i18n: 'public/views/patient/search'
  //   }
  // },
  // {
  //   path: 'chats',
  //   name: 'Chat',
  //   component: () => import('@/components/views/chat-interconsultations/Chat'),
  //   meta: {
  //     layout: PRIVATE_LAYOUT,
  //     showTabMenu: true,
  //     bequeath: true,
  // 		title: {
  // 			text () {
  // 				return i18n.t('chat')
  // 			},
  // 			hide: true
  // 		},
  // 		i18n: ['public/views/shared/chat', 'public/views/patient/appointments']
  //   }
  // }
}]);

/***/ }),
/* 1669 */,
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1671);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("f27b9f94", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/index.js?{\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9a21a6f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./VueBootstrapTypeahead.vue", function() {
     var newContent = require("!!../../../css-loader/index.js?{\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9a21a6f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./VueBootstrapTypeahead.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.vbt-autcomplete-list[data-v-9a21a6f4] {\n  padding-top: 5px;\n  position: absolute;\n  max-height: 350px;\n  overflow-y: auto;\n  z-index: 999;\n}\n", ""]);

// exports


/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(1082);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_dde7c978_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(1675);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_dde7c978_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeaheadList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dde7c978", Component.options)
  } else {
    hotAPI.reload("data-v-dde7c978", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(1083);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1b7202f7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(1674);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1b7202f7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeaheadListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b7202f7", Component.options)
  } else {
    hotAPI.reload("data-v-1b7202f7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: _vm.textClasses,
      attrs: { tabindex: "0", href: "#" },
      on: {
        mouseover: function($event) {
          _vm.active = true
        },
        mouseout: function($event) {
          _vm.active = false
        }
      }
    },
    [
      _vm._t(
        "suggestion",
        function() {
          return [_c("span", { domProps: { innerHTML: _vm._s(_vm.htmlText) } })]
        },
        null,
        { data: _vm.data, htmlText: _vm.htmlText }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b7202f7", esExports)
  }
}

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-group shadow" },
    _vm._l(_vm.matchedItems, function(item, id) {
      return _c("vue-bootstrap-typeahead-list-item", {
        key: id,
        attrs: {
          data: item.data,
          "html-text": _vm.highlight(item.text),
          "background-variant": _vm.backgroundVariant,
          "text-variant": _vm.textVariant
        },
        nativeOn: {
          click: function($event) {
            return _vm.handleHit(item, $event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "suggestion",
              fn: function(ref) {
                var data = ref.data
                var htmlText = ref.htmlText
                return _vm.$scopedSlots.suggestion
                  ? [
                      _vm._t("suggestion", null, null, {
                        data: data,
                        htmlText: htmlText
                      })
                    ]
                  : undefined
              }
            }
          ],
          null,
          true
        )
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dde7c978", esExports)
  }
}

/***/ }),
/* 1676 */,
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { class: _vm.sizeClasses }, [
        _vm.$slots.prepend || _vm.prepend
          ? _c(
              "div",
              { ref: "prependDiv", staticClass: "input-group-prepend" },
              [
                _vm._t("prepend", function() {
                  return [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v(_vm._s(_vm.prepend))
                    ])
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          ref: "input",
          class: "form-control " + _vm.inputClass,
          attrs: {
            type: "search",
            placeholder: _vm.placeholder,
            "aria-label": _vm.placeholder,
            autocomplete: "off"
          },
          domProps: { value: _vm.inputValue },
          on: {
            focus: function($event) {
              _vm.isFocused = true
            },
            blur: _vm.handleBlur,
            input: function($event) {
              return _vm.handleInput($event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.$slots.append || _vm.append
          ? _c(
              "div",
              { staticClass: "input-group-append" },
              [
                _vm._t("append", function() {
                  return [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v(_vm._s(_vm.append))
                    ])
                  ]
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("vue-bootstrap-typeahead-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isFocused && _vm.data.length > 0,
            expression: "isFocused && data.length > 0"
          }
        ],
        ref: "list",
        staticClass: "vbt-autcomplete-list",
        attrs: {
          query: _vm.inputValue,
          data: _vm.formattedData,
          "background-variant": _vm.backgroundVariant,
          "text-variant": _vm.textVariant,
          maxMatches: _vm.maxMatches,
          minMatchingChars: _vm.minMatchingChars
        },
        on: { hit: _vm.handleHit },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.$scopedSlots, function(slot, slotName) {
              return {
                key: slotName,
                fn: function(ref) {
                  var data = ref.data
                  var htmlText = ref.htmlText
                  return [
                    _vm._t(slotName, null, null, {
                      data: data,
                      htmlText: htmlText
                    })
                  ]
                }
              }
            })
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a21a6f4", esExports)
  }
}

/***/ }),
/* 1678 */,
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1680);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("fff6476e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9e0113ae\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseSpinInput.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9e0113ae\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseSpinInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c("b-form-spinbutton", {
            attrs: {
              id: _vm.id,
              min: _vm.min,
              max: _vm.max,
              step: _vm.step,
              readonly: _vm.readonly
            },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          }),
          _vm._v(" "),
          _vm.errorMsg
            ? _c("b-form-invalid-feedback", [
                _vm._v("\n      " + _vm._s(_vm.errorMsg) + "\n    ")
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasAppendSlot
        ? _c(
            "b-input-group-append",
            [_c("b-input-group-text", [_vm._t("append")], 2)],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e0113ae", esExports)
  }
}

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1683);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("334f8296", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0c37ff40\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./customHeader.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0c37ff40\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./customHeader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.c-header {\n  border-bottom: 1px solid #ddd;\n}\n.logo {\n  widows: auto;\n  height: 34px;\n  padding: 0;\n  margin: 0 !important;\n}\n", ""]);

// exports


/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "lg" } },
        [
          _c("b-navbar-brand", { attrs: { href: "#" } }, [
            _c("img", {
              staticClass: "mb-4 logo",
              attrs: { src: __webpack_require__(539) }
            }),
            _c("br")
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    {
                      attrs: {
                        href:
                          "https://localhost:8080/es/professional/es-nodofarma-list"
                      }
                    },
                    [_vm._v("Test de video")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      attrs: {
                        href:
                          "https://localhost:8080/es/professional/es-nodofarma"
                      }
                    },
                    [_vm._v("Cuadro de mando")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    { attrs: { text: "Español", right: "" } },
                    [
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Español")
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Ingles")
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Catalan")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("em", [
                                _vm._v("Dr. Francisco Luis Velasco Reina")
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Configurar")
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Salir")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            {
              staticClass: "vh-50 mx-auto text-center",
              attrs: { "align-v": "center" }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-tabs",
                    { attrs: { fill: "" } },
                    [
                      _c("b-tab", {
                        attrs: {
                          title: "Mi perfil",
                          active: _vm.activeTab == "profile"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mis servicios",
                          active: _vm.activeTab == "services"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Chats",
                          active: _vm.activeTab == "chats"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mis consultas",
                          active: _vm.activeTab == "appointments"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Solicitudes de cita",
                          active: _vm.activeTab == "requests"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mi agenda",
                          active: _vm.activeTab == "scheduler"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mis pacientes",
                          active: _vm.activeTab == "patients"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c37ff40", esExports)
  }
}

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_i18n_helpers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_routeHelpers__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(221);







// /patient/*

var routes = [{
	path: '/',
	name: 'Panel',
	component: function component() {
		return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 2356));
	},
	meta: {
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.title');
			},

			hide: true
		},
		i18n: 'public/views/patient/panel'
	}
}, {
	path: 'sso-tmc',
	name: 'SsoTMC',
	component: function component() {
		return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 2357));
	},
	meta: {
		layout: __WEBPACK_IMPORTED_MODULE_3__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('telemedcare-account-association');
			}
		},
		logo: {
			src: 'opensalud360_healthierlives_color.svg'
		}
	}
}, {
	path: 'menttum',
	name: 'MenttumProxyView',
	component: function component() {
		return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 2358));
	},
	meta: {
		layout: __WEBPACK_IMPORTED_MODULE_3__constants_layouts__["l" /* PUBLIC_REDUCED_LAYOUT */],
		layoutCentered: true,
		logo: {
			src: 'logo-menttum-grande.png'
		},
		title: {
			htmlTitle: 'Menttum',
			styleClasses: 'text-center'
		}
	}
}, {
	path: 'clinic-history',
	component: {
		template: '<router-view></router-view>'
	},
	meta: {
		// Determines if children meta properties are inherited from parent route (default: true)
		// Possible values are true (all), false or an array of property names to inherit
		// Example: bequeath: ['roles', 'i18n'], bequeath: true, bequeath: false
		// If meta property is defined in both parent and child, child property will be used (i18n will be always mixed)
		bequeath: true,
		showTabMenu: true,
		roles: [__WEBPACK_IMPORTED_MODULE_2__constants_roles__["h" /* PROFESSIONAL_ROLE */], __WEBPACK_IMPORTED_MODULE_2__constants_roles__["e" /* CENTER_ROLE */], __WEBPACK_IMPORTED_MODULE_2__constants_roles__["c" /* ANONYMOUS_ROLE */]],
		i18n: 'clinic-history',
		layout: window.location !== window.parent.location ? __WEBPACK_IMPORTED_MODULE_3__constants_layouts__["a" /* BACK_BTN_LAYOUT */] : __WEBPACK_IMPORTED_MODULE_3__constants_layouts__["h" /* PRIVATE_LAYOUT */]
	},
	children: [{
		path: '/',
		name: 'clinicHistoryMenu',
		component: function component() {
			return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 2359));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthData');
				}
			}
		}
	}, {
		path: 'view',
		name: 'clinicHistoryView',
		component: function component() {
			return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 2360));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('clinichistory');
				}
			}
		}
	}, {
		path: 'documents',
		component: function component() {
			return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 2361));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('documentsAndInformation');
				}
			}
		}
	}, {
		path: 'health-data',
		component: function component() {
			return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 2362));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthData');
				}
			},
			i18n: 'public/views/selfEvaluationTests.json'
		}
	}, {
		path: 'menstrual-calendar',
		component: function component() {
			return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 2363));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('menstrual-calendar');
				}
			}
		}
	}, {
		path: 'medication-reminder/new',
		name: 'newMedicationReminder',
		component: function component() {
			return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 542));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('newMedicationReminder');
				}
			}
		}
	}, {
		path: 'medication-reminder/edit/:id',
		name: 'editMedicationReminder',
		component: function component() {
			return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 542));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('editMedicationReminder');
				}
			}
		}
	}, {
		path: 'medication-reminder/:code?',
		name: 'medicationReminder',
		component: function component() {
			return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 542));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('medicationReminder');
				}
			}
		}
	}, {
		path: 'quiz',
		name: 'clinicHistoryQuiz',
		component: function component() {
			return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 2332));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('healthQuiz');
				}
			}
		}
	}]
}, {
	path: 'search',
	component: {
		template: '<router-view></router-view>'
	},
	meta: {
		showTabMenu: true,
		bequeath: true,
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('searcherTitle');
			},

			hide: true
		},
		i18n: 'public/views/patient/search'
	},
	children: [{
		path: '/',
		name: 'search',
		component: function component() {
			return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 1276));
		}
	}, {
		path: 'services',
		name: 'searchServices',
		component: function component() {
			return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 2364));
		}
	}]
}, {
	path: 'appointments',
	component: {
		template: '<router-view></router-view>'
	},
	meta: {
		showTabMenu: true,
		bequeath: true,
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('appointmentsTitle');
			},

			hide: true
		},
		i18n: ['public/views/patient/appointments', 'public/views/patient/panel']
	},
	children: [{
		path: '/',
		name: 'appointmentsMenu',
		component: function component() {
			return __webpack_require__.e/* import() */(25/* duplicate */).then(__webpack_require__.bind(null, 1281));
		},
		title: {
			hide: true
		}
	}, {
		path: 'next',
		name: 'nextAppointments',
		component: function component() {
			return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 2365));
		}
	}, {
		path: 'past',
		name: 'pastAppointments',
		component: function component() {
			return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 2366));
		},
		props: true
	}]
}, {
	path: 'tests',
	component: {
		template: '<router-view></router-view>'
	},
	meta: {
		bequeath: true,
		roles: [__WEBPACK_IMPORTED_MODULE_2__constants_roles__["f" /* PATIENT_ROLE */], __WEBPACK_IMPORTED_MODULE_2__constants_roles__["h" /* PROFESSIONAL_ROLE */]],
		i18n: ['public/views/selfEvaluationTests.json', 'public/views/patient/panel', 'clinic-history']
	},
	children: [{
		path: '/',
		name: 'Tests',
		component: function component() {
			return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 2367));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('tests.self-evaluation-tests.title');
				}
			},
			hide: true
		}
	}, {
		path: 'opensalud-scorecard',
		name: 'OpensaludScorecard',
		component: function component() {
			return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 2333));
		},
		meta: {
			title: {
				text: function text() {
					return 'opensalud ScoreCard';
				}
			},
			only360Users: true
		}
	}, {
		path: ':testId/:patientId?',
		name: 'do-test',
		component: function component() {
			return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 2334));
		},
		meta: {
			title: {
				hide: true
			}
		}
	}]
}, {
	path: 'appointments-menu',
	name: 'AppointmentsMenu',
	component: function component() {
		return __webpack_require__.e/* import() */(25/* duplicate */).then(__webpack_require__.bind(null, 1281));
	},
	meta: {
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.teleconsultation');
			},

			hide: true
		},
		i18n: 'public/views/patient/panel'
	}
}, {
	path: 'goals-habits-menu',
	name: 'GoalsHabitsMenu',
	component: function component() {
		return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 2368));
	},
	meta: {
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.habits-challenges');
			},

			hide: true
		},
		i18n: 'public/views/patient/panel'
	}
}, {
	path: 'panel-search',
	name: 'Panel-search',
	component: function component() {
		return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 2369));
	},
	meta: {
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.teleconsultation');
			},

			hide: true
		},
		i18n: 'public/views/patient/panel'
	}
}, {
	path: 'panel-search-selector',
	name: 'Panel-search-selector',
	component: function component() {
		return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 2370));
	},
	meta: {
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.teleconsultation');
			},

			hide: true
		},
		i18n: 'public/views/patient/panel'
	}
}, {
	path: 'test-health',
	name: 'TestHealth',
	component: function component() {
		return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 2371));
	},
	meta: {
		showTabMenu: true,
		title: {
			text: 'Test Health',
			hide: true
			/* i18n: 'public/views/test-health.json' */
		} }
}, {
	path: 'healthy-food-menu',
	name: 'FoodHabitsMenu',
	component: function component() {
		return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 2372));
	},
	meta: {
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.foods');
			},

			hide: true
		},
		i18n: 'public/views/patient/panel'
	}
},
// Microhabits
{
	path: 'microhabits',
	component: {
		template: '<router-view></router-view>'
	},
	meta: {
		bequeath: true,
		i18n: ['public/views/patient/microhabits.json', 'public/views/healthy-habits', 'public/views/patient/panel.json']
	},
	children: [{
		path: '/',
		name: 'MicrohabitsPanelMenu',
		component: function component() {
			return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 2373));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.habits-that-care');
				}
			},
			hide: true
		}
	}, {
		path: 'favorites',
		name: 'FavoritesMicrohabit',
		component: function component() {
			return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 2374));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.my-microhabits');
				},

				hide: true
			},
			only360Users: true
		}
	}, {
		path: ':category',
		name: 'SimpleMicrohabitsPanelMenu',
		component: function component() {
			return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 2375));
		},
		meta: {
			title: {
				text: function text() {
					return (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.microhabits.currentCategory ? Object(__WEBPACK_IMPORTED_MODULE_1__helpers_i18n_helpers__["d" /* normalize */])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.microhabits.currentCategory.name) + ' |' : '') + ' ' + __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.habits-that-care');
				},

				hide: true
			}
		}
	}]
},
// Foods
{
	path: 'foods',
	component: {
		template: '<router-view></router-view>'
	},
	meta: {
		bequeath: true,
		i18n: ['public/views/patient/foods.json', 'public/views/patient/panel.json', 'public/views/patient/microhabits.json']
	},
	children: [{
		path: '/',
		name: 'FoodsPanelMenu',
		component: function component() {
			return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 2376));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.foods');
				}
			},
			hide: true,
			i18n: ['public/views/healthy-habits']
		}
	}, {
		path: 'favorites',
		name: 'FavoritesFood',
		component: function component() {
			return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 2377));
		},
		meta: {
			title: {
				text: function text() {
					return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.my-foods');
				},

				hide: true
			},
			only360Users: true
		}
	}, {
		path: ':category',
		name: 'FoodCategoriesPanelMenu',
		component: function component() {
			return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 2378));
		},
		meta: {
			title: {
				text: function text() {
					return (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.microhabits.currentCategory ? Object(__WEBPACK_IMPORTED_MODULE_1__helpers_i18n_helpers__["d" /* normalize */])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.microhabits.currentCategory.name) + ' |' : '') + ' ' + __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.foods');
				},

				hide: true
			}
		}
	}, {
		path: ':category/:food',
		name: 'FoodDetail',
		component: function component() {
			return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 2379));
		},
		meta: {
			title: {
				text: function text() {
					return (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.microhabits.currentMicrohabit ? Object(__WEBPACK_IMPORTED_MODULE_1__helpers_i18n_helpers__["d" /* normalize */])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.microhabits.currentMicrohabit.name) + ' |' : '') + ' ' + __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.foods');
				},

				hide: true
			},
			i18n: ['public/views/healthy-habits']
		}
	}]
}, {
	path: 'my-apps',
	name: 'MyApps',
	component: function component() {
		return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 2380));
	},
	meta: {
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('patient-panel.my-apps');
			},

			hide: false
		},
		i18n: ['public/views/patient/panel']
	}
}, {
	path: 'chats',
	component: {
		template: '<router-view></router-view>'
	},
	meta: {
		layout: __WEBPACK_IMPORTED_MODULE_3__constants_layouts__["h" /* PRIVATE_LAYOUT */],
		showTabMenu: true,
		bequeath: true,
		i18n: ['public/views/shared/chat', 'public/views/patient/appointments'],
		title: {
			text: function text() {
				return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('chats.chat');
			},

			hide: true
		}
	},
	children: [{
		path: '/',
		name: 'Chat',
		component: function component() {
			return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, 1284));
		}
	}, {
		path: 'showChat/:appointmentId',
		name: 'PastChat',
		component: function component() {
			return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, 1284));
		}
	}]
}];

// Add meta roles patient and private layout to all routes
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__router_routeHelpers__["a" /* default */].completeRoutesMeta(routes, __WEBPACK_IMPORTED_MODULE_2__constants_roles__["f" /* PATIENT_ROLE */], __WEBPACK_IMPORTED_MODULE_3__constants_layouts__["h" /* PRIVATE_LAYOUT */]));

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(278);



var client = function client() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getFreedomAndFlowUrl: function getFreedomAndFlowUrl() {
    return client().prototype.$api.get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('webapp/patients/services/freedom-urls'));
  },
  getWellwoUrl: function getWellwoUrl() {
    var returnPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('webapp/patients/services/wellwo-urls'), { params: { path: returnPath } });
  },
  getRehBodyUrl: function getRehBodyUrl() {
    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('webapp/patients/services/rehbody-urls'));
  }
});

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2a6c45e0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-76349f96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryGrantAccess.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-76349f96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryGrantAccess.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-76349f96]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-76349f96],.slide-down-leave-active[data-v-76349f96]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-76349f96],.slide-down-leave-to[data-v-76349f96]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-76349f96],.slide-fade-left-leave-active[data-v-76349f96]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-76349f96],.slide-fade-left-leave-to[data-v-76349f96]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-76349f96]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-76349f96],.fade-leave-to[data-v-76349f96]{opacity:0\n}\n.grant-access-btn[data-v-76349f96]{display:block;margin-left:auto;margin-right:auto\n}\n", ""]);

// exports


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("h2", {
        staticClass: "text-center",
        domProps: { innerHTML: _vm._s(_vm.$t("grantAccessClinicHistory")) }
      }),
      _vm._v(" "),
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.$t("historyGrantAccessText")) }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "text-center px-2 my-2",
                  attrs: { sm: "12", md: "6" }
                },
                [
                  _c("base-button", { on: { click: _vm.shareInternally } }, [
                    _vm._v(_vm._s(_vm.$t("shareInternally")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "text-center px-2 my-2",
                  attrs: { sm: "12", md: "6" }
                },
                [
                  _c(
                    "base-button",
                    { attrs: { white: "" }, on: { click: _vm.generateLink } },
                    [_vm._v(_vm._s(_vm.$t("generateLink")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showInternalShareSelector
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("base-select", {
                    attrs: {
                      loading: _vm.selectProfCenter.loading,
                      placeholder: _vm.$t("clinic-history.select-prof-center"),
                      label: "name",
                      valueProp: "id",
                      searchable: "",
                      filtered: "",
                      options: _vm.selectProfCenter.data,
                      clearable: ""
                    },
                    on: {
                      search: function($event) {
                        return _vm.loadProfsAndCenters($event)
                      }
                    },
                    model: {
                      value: _vm.selectProfCenter.value,
                      callback: function($$v) {
                        _vm.$set(_vm.selectProfCenter, "value", $$v)
                      },
                      expression: "selectProfCenter.value"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "mt-4 grant-access-btn",
                      on: { click: _vm.grantInternalAccessHistory }
                    },
                    [_vm._v(_vm._s(_vm.$t("historyShare")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showGenerateLinkSelector
        ? _c("div", { staticClass: "mt-4" }, [
            _c(
              "div",
              [
                _c("h3", {
                  domProps: { innerHTML: _vm._s(_vm.$t("validityInDays")) }
                }),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    type: "number",
                    placeholder: _vm.$t("shareLinkValidity"),
                    min: 1,
                    max: 180
                  },
                  model: {
                    value: _vm.shareLink.validity,
                    callback: function($$v) {
                      _vm.$set(_vm.shareLink, "validity", $$v)
                    },
                    expression: "shareLink.validity"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("h3", {
                  domProps: { innerHTML: _vm._s(_vm.$t("recipients")) }
                }),
                _vm._v(" "),
                _c("base-textarea", {
                  attrs: {
                    rows: 5,
                    placeholder: _vm.$t("shareHistoryAccessLinkPlaceholder")
                  },
                  model: {
                    value: _vm.shareLink.emails,
                    callback: function($$v) {
                      _vm.$set(_vm.shareLink, "emails", $$v)
                    },
                    expression: "shareLink.emails"
                  }
                }),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "mt-4 grant-access-btn",
                    on: { click: _vm.sendLink }
                  },
                  [_vm._v(_vm._s(_vm.$t("send")))]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76349f96", esExports)
  }
}

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3e7918f1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d0ea1a4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryProfAndCenterAuthorized.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d0ea1a4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryProfAndCenterAuthorized.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-3d0ea1a4]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-3d0ea1a4],.slide-down-leave-active[data-v-3d0ea1a4]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-3d0ea1a4],.slide-down-leave-to[data-v-3d0ea1a4]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-3d0ea1a4],.slide-fade-left-leave-active[data-v-3d0ea1a4]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-3d0ea1a4],.slide-fade-left-leave-to[data-v-3d0ea1a4]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-3d0ea1a4]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-3d0ea1a4],.fade-leave-to[data-v-3d0ea1a4]{opacity:0\n}\n.revoke-access[data-v-3d0ea1a4]{cursor:pointer;color:#FF7061\n}\n", ""]);

// exports


/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      on: { shown: _vm.loadProfAndCentersAuthorized },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("paginated-table", {
        attrs: {
          fields: _vm.profAndCenterAuthorized.fields,
          items: _vm.profAndCenterAuthorized.data,
          "empty-text": _vm.$t("noDataProfAndCenterAuthorized")
        },
        scopedSlots: _vm._u(
          [
            !_vm.$route.query.h
              ? {
                  key: "cell(remove)",
                  fn: function(data) {
                    return [
                      data.item.canDecline
                        ? _c("span", {
                            staticClass: "revoke-access",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("revokeAccess"))
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.revokeAccess(data)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0ea1a4", esExports)
  }
}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1694);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("394d8884", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-37d6321e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyHabitsForm.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-37d6321e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyHabitsForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.type-habit-title{text-align:center\n}\n.type-habit-option-selected{background-color:#3238C4 !important;color:white;border:0px !important\n}\n.type-habit-option-selected span{color:white\n}\n.type-habit-options-box{color:#3238C4;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center\n}\n.type-habit-form-box{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;max-width:1200px;margin-left:auto;margin-right:auto;margin-top:2rem;overflow:visible !important\n}\n.input-modal-options{display:inline-block;width:85px\n}\n.form-check-input{position:initial !important;margin-right:1rem !important\n}\n.margin-bottom-form{margin-bottom:1.5rem\n}\n.margin-top-form{margin-top:1.5rem\n}\n.type-habit-form-box .input-group-append .btn-secondary{background-color:#8A8A8A;color:#eee\n}\n.b-form-date-controls button{color:#3238C4;border-color:#3238C4\n}\n.type-habit-form-box .form-control[readonly]{background-color:#eee;opacity:initial\n}\n.type-habit-form-box [name=\"readonlymultiuser\"]{background-color:rgba(138,138,138,0.5) !important;opacity:1 !important\n}\n.frequency-options-examples{color:black;font-size:0.75rem\n}\n.width-95{width:95vw\n}\n.no-margin-bottom{margin-bottom:0px\n}\n.reminder-input-form .input-group-prepend .input-group-text{border-top-right-radius:inherit !important;border-bottom-right-radius:inherit !important;border-left-width:1px !important\n}\n.clock-selector-input{width:100%;background-color:#eee;border:none;font-size:0.875rem;color:#8a8a8a\n}\n.clock-selector-input::-webkit-input-placeholder{opacity:1\n}\n.clock-selector-input::-moz-placeholder{opacity:1\n}\n.clock-selector-input::-ms-input-placeholder{opacity:1\n}\n.clock-selector-input::placeholder{opacity:1\n}\n.reminder-container *{outline:none !important\n}\n.type-habit-card{min-width:135px;cursor:pointer;display:table\n}\n.card-form-content{display:table-cell;vertical-align:middle\n}\n.clock-picker__dialog-content{text-align:center\n}\n", ""]);

// exports


/***/ }),
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1701);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("c9a1cff2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-102d2373\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyHabitsPredefined.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-102d2373\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyHabitsPredefined.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.card-predefined{cursor:pointer;text-align:center;color:#3238C4;display:table\n}\n.arrow-left-predefined{color:#8A8A8A;cursor:pointer;position:absolute;right:20%;top:50%\n}\n.arrow-right-predefined{color:#8A8A8A;cursor:pointer;position:absolute;left:20%;top:50%\n}\n.arrow-container{max-width:20px\n}\n.card-predefined-description{display:table-cell;width:65.5px;height:45px;min-width:60px;min-height:45px;vertical-align:middle\n}\n@media screen and (max-width: 374px){\n.card-predefined-description{width:auto;max-width:41px\n}\n}\n.predefined-selected{background-color:#3238C4;color:white;border:0px !important\n}\n", ""]);

// exports


/***/ }),
/* 1702 */,
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch:swipe.left",
              value: _vm.nextPage,
              expression: "nextPage",
              arg: "swipe",
              modifiers: { left: true }
            },
            {
              name: "touch",
              rawName: "v-touch:swipe.right",
              value: _vm.previousPage,
              expression: "previousPage",
              arg: "swipe",
              modifiers: { right: true }
            }
          ],
          class: {
            "d-flex": true,
            "justify-content-center": true,
            "my-5": !_vm.showingInForm,
            "my-4": _vm.showingInForm
          }
        },
        [
          _c(
            "b-col",
            { staticClass: "arrow-container", attrs: { cols: "1" } },
            [
              !_vm.$store.state.healthyHabits.predefinedHabit.hideLeftArrow
                ? _c("b-icon-caret-left", {
                    staticClass: "arrow-left-predefined",
                    attrs: { scale: "1.4" },
                    on: { click: _vm.previousPage }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.itemsToShow, function(item, index) {
            return _c(
              "b-col",
              {
                key: "habit-predefined-" + index,
                staticClass: "d-flex justify-content-center",
                attrs: {
                  cols: "5",
                  sm: _vm.showingInForm ? 5 : 3,
                  md: _vm.showingInForm ? 3 : 5,
                  xl: "3"
                }
              },
              [
                _c(
                  "base-card",
                  {
                    class: {
                      "card-predefined": true,
                      "predefined-selected":
                        item.id ===
                        _vm.$store.state.healthyHabits.predefinedHabit
                          .itemIdSelected
                    },
                    style: { "z-index": _vm.boxPredefinedZIndex(index) },
                    on: {
                      click: function($event) {
                        return _vm.predefinedHabitSelected(item)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "card-predefined-description" }, [
                      _vm._v(_vm._s(item.description))
                    ])
                  ]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "arrow-container", attrs: { cols: "1" } },
            [
              !_vm.$store.state.healthyHabits.predefinedHabit.hideRightArrow
                ? _c("b-icon-caret-right", {
                    staticClass: "arrow-right-predefined",
                    attrs: { scale: "1.4" },
                    on: { click: _vm.nextPage }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-102d2373", esExports)
  }
}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.healthyHabits.table.data.items &&
    _vm.$store.state.healthyHabits.table.data.items.length > 0 &&
    !_vm.$store.state.healthyHabits.form.editing
      ? _c(
          "div",
          [
            _c("h3", { staticClass: "type-habit-title my-4" }, [
              _vm._v(_vm._s(_vm.$t("selectHabitType")))
            ]),
            _vm._v(" "),
            _c("healthy-habits-predefined", {
              attrs: { showingInForm: "" },
              on: {
                predefinedHabitSelected: function($event) {
                  return _vm.loadPredefinedHabit()
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.$store.state.healthyHabits.form.editing
      ? _c("div", [
          _c("h3", { staticClass: "type-habit-title my-4" }, [
            _vm._v(
              _vm._s(
                _vm.$store.state.healthyHabits.table.data.items &&
                  _vm.$store.state.healthyHabits.table.data.items.length > 0
                  ? _vm.$t("createOwnHabit")
                  : _vm.$t("selectHabitType")
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "type-habit-options-box" },
            [
              _c(
                "base-card",
                {
                  class: {
                    "type-habit-option-selected":
                      _vm.healthyHabitsData.measurable === true,
                    "type-habit-card": true,
                    "mr-3": true
                  },
                  staticStyle: { "z-index": "1" },
                  attrs: { name: "measurable-option" },
                  on: {
                    click: function($event) {
                      _vm.healthyHabitTypeSelected(true)
                      _vm.$store.state.healthyHabits.predefinedHabit.itemIdSelected = null
                    }
                  }
                },
                [
                  _c("span", { staticClass: "card-form-content" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("measurable")))]),
                    _c("br"),
                    _c("span", { staticClass: "frequency-options-examples" }, [
                      _vm._v(_vm._s(_vm.$t("measurableExamples")))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "base-card",
                {
                  class: {
                    "type-habit-option-selected":
                      _vm.healthyHabitsData.measurable === false,
                    "type-habit-card": true
                  },
                  attrs: { name: "no-measurable-option" },
                  on: {
                    click: function($event) {
                      _vm.healthyHabitTypeSelected(false)
                      _vm.$store.state.healthyHabits.predefinedHabit.itemIdSelected = null
                    }
                  }
                },
                [
                  _c("span", { staticClass: "card-form-content" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("notmeasurable")))]),
                    _c("br"),
                    _c("span", { staticClass: "frequency-options-examples" }, [
                      _vm._v(_vm._s(_vm.$t("notMeasurableExamples")))
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.healthyHabitsData.measurable != null
      ? _c(
          "div",
          [
            _c(
              "base-card",
              {
                class: {
                  row: true,
                  "type-habit-form-box": true,
                  "width-95": !this.inModal
                }
              },
              [
                _c(
                  "b-row",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "margin-bottom-form px-2",
                        attrs: { cols: "12" }
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("color")) + ": "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.healthyHabitsData.color,
                              expression: "healthyHabitsData.color"
                            }
                          ],
                          staticClass: "cursor-pointer",
                          attrs: { type: "color" },
                          domProps: { value: _vm.healthyHabitsData.color },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.healthyHabitsData,
                                "color",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.state.description,
                            placeholder: _vm.healthyHabitsData.measurable
                              ? _vm.$t("nameFormMeasurablePlaceholder")
                              : _vm.$t("nameFormPlaceholder")
                          },
                          on: {
                            blur: function($event) {
                              _vm.state.description = _vm.healthyHabitsData
                                .description
                                ? true
                                : false
                            }
                          },
                          model: {
                            value: _vm.healthyHabitsData.description,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.healthyHabitsData,
                                "description",
                                $$v
                              )
                            },
                            expression: "healthyHabitsData.description"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.healthyHabitsData.measurable
                      ? _c(
                          "b-col",
                          { staticClass: "px-2", attrs: { cols: "12" } },
                          [
                            _c("base-input", {
                              attrs: {
                                state: _vm.state.goal,
                                readonly: _vm.isMultiUser,
                                name: _vm.isMultiUser
                                  ? "readonlymultiuser"
                                  : "",
                                type: _vm.isMultiUser ? "text" : "number",
                                min: 0,
                                step: 1,
                                placeholder: _vm.$t("goalFormPlaceholder")
                              },
                              on: {
                                blur: function($event) {
                                  _vm.state.goal =
                                    _vm.healthyHabitsData.goal > 0
                                }
                              },
                              model: {
                                value: _vm.healthyHabitsData.goal,
                                callback: function($$v) {
                                  _vm.$set(_vm.healthyHabitsData, "goal", $$v)
                                },
                                expression: "healthyHabitsData.goal"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.healthyHabitsData.measurable
                      ? _c(
                          "b-col",
                          { staticClass: "px-2", attrs: { cols: "12" } },
                          [
                            _c("base-input", {
                              attrs: {
                                state: _vm.state.measureUnit,
                                readonly: _vm.isMultiUser,
                                name: _vm.isMultiUser
                                  ? "readonlymultiuser"
                                  : "",
                                placeholder: _vm.$t("UnitFormPlaceholder")
                              },
                              on: {
                                blur: function($event) {
                                  _vm.state.measureUnit = _vm.healthyHabitsData
                                    .measureUnit
                                    ? true
                                    : false
                                }
                              },
                              model: {
                                value: _vm.healthyHabitsData.measureUnit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.healthyHabitsData,
                                    "measureUnit",
                                    $$v
                                  )
                                },
                                expression: "healthyHabitsData.measureUnit"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "px-2",
                        attrs: { cols: "12" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.isMultiUser
                              ? (_vm.showFrequencyModal =
                                  _vm.showFrequencyModal)
                              : (_vm.showFrequencyModal = true)
                          }
                        }
                      },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.state.goalFrequencyId,
                            name: _vm.isMultiUser ? "readonlymultiuser" : "",
                            readonly: "",
                            placeholder: _vm.$t("frequency")
                          },
                          model: {
                            value: _vm.frequencyText,
                            callback: function($$v) {
                              _vm.frequencyText = $$v
                            },
                            expression: "frequencyText"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-input-group",
                          {
                            staticClass: "reminder-input-form",
                            staticStyle: { "margin-bottom": "1.5rem" }
                          },
                          [
                            _c(
                              "b-input-group-prepend",
                              [
                                _c("b-input-group-text", [_c("b-icon-bell")], 1)
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "reminder-container form-control"
                              },
                              [
                                _c("vue-clock-picker", {
                                  attrs: {
                                    id: "reminder-clock-selector",
                                    "active-color": _vm.healthyHabitsData.color,
                                    "done-text": _vm.$t("save"),
                                    "cancel-text": _vm.$t("reset"),
                                    "input-class": "clock-selector-input",
                                    placeholder:
                                      _vm.$t("reminder") +
                                      " " +
                                      _vm.$t("optional")
                                  },
                                  on: {
                                    timeset: function($event) {
                                      _vm.showReminderDaysInput = true
                                    },
                                    beforeOpen: _vm.setDefaultTime,
                                    cancel: _vm.resetReminder
                                  },
                                  model: {
                                    value: _vm.healthyHabitsData.reminder,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.healthyHabitsData,
                                        "reminder",
                                        $$v
                                      )
                                    },
                                    expression: "healthyHabitsData.reminder"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-input-group-text",
                                  {
                                    staticClass: "cursor-pointer",
                                    on: { click: _vm.resetReminder }
                                  },
                                  [_c("b-icon-trash")],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showReminderDaysInput
                      ? _c(
                          "b-col",
                          {
                            staticClass: "px-2",
                            attrs: { cols: "12" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.showReminderDaysModal = true
                              }
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              {
                                staticClass: "reminder-input-form",
                                staticStyle: { "margin-bottom": "1.5rem" }
                              },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  [
                                    _c(
                                      "b-input-group-text",
                                      [_c("b-icon-bell")],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  attrs: {
                                    readonly: "",
                                    placeholder: _vm.$t("reminderDays")
                                  },
                                  model: {
                                    value: _vm.reminderDaysText,
                                    callback: function($$v) {
                                      _vm.reminderDaysText = $$v
                                    },
                                    expression: "reminderDaysText"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _c("base-textarea", {
                          attrs: {
                            noResize: "",
                            maxRows: 10,
                            rows: 1,
                            state: _vm.state.notes,
                            placeholder:
                              _vm.$t("notes") + " " + _vm.$t("optional"),
                            readOnly: !!_vm.$route.params.t
                          },
                          on: {
                            blur: function($event) {
                              _vm.state.notes = _vm.healthyHabitsData.notes
                                ? true
                                : null
                            }
                          },
                          model: {
                            value: _vm.healthyHabitsData.notes,
                            callback: function($$v) {
                              _vm.$set(_vm.healthyHabitsData, "notes", $$v)
                            },
                            expression: "healthyHabitsData.notes"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.$store.state.healthyHabits.form.editing
                      ? _c(
                          "b-col",
                          { staticClass: "px-2", attrs: { cols: "12" } },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "form-group",
                                attrs: { switch: "" },
                                on: { change: _vm.switchInviteMultiUser },
                                model: {
                                  value:
                                    _vm.$store.state.healthyHabits.form
                                      .multiUser,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$store.state.healthyHabits.form,
                                      "multiUser",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$store.state.healthyHabits.form.multiUser"
                                }
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("invitePatientsMultiUser")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-icon-question-circle", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    },
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.click",
                                      value: _vm.$t("inviteMultiUserInfo"),
                                      expression: "$t('inviteMultiUserInfo')",
                                      modifiers: { click: true }
                                    }
                                  ],
                                  attrs: {
                                    title: _vm.$t("inviteMultiUserInfo")
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "px-2", attrs: { cols: "12" } },
                      [
                        _vm.$store.state.healthyHabits.form.multiUser
                          ? _c("v-select", {
                              attrs: {
                                multiple: "",
                                taggable: "",
                                placeholder: _vm.$t("typeUserEmailsOrPhones"),
                                label: "name"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "no-options",
                                    fn: function() {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "typePatientEmailOrPhoneAdvice"
                                              )
                                            ) + "(⏎)"
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3185750296
                              ),
                              model: {
                                value:
                                  _vm.healthyHabitsData
                                    .multiUsersEmailsOrPhones,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.healthyHabitsData,
                                    "multiUsersEmailsOrPhones",
                                    $$v
                                  )
                                },
                                expression:
                                  "healthyHabitsData.multiUsersEmailsOrPhones"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "base-button",
                          {
                            staticClass: "mr-1 my-1",
                            on: {
                              click: function($event) {
                                return _vm.sendData()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("save")))]
                        ),
                        _c(
                          "base-button",
                          {
                            attrs: { gray: "" },
                            on: {
                              click: function($event) {
                                return _vm.cancel()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("back")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "base-modal",
              {
                attrs: {
                  noCloseOnBackdrop: "",
                  noCloseOnScape: "",
                  hideClose: "",
                  titleAlignLeft: "",
                  value: _vm.showFrequencyModal,
                  title: _vm.$t("selectAnOption")
                },
                on: {
                  hide: function($event) {
                    _vm.showFrequencyModal = false
                  }
                }
              },
              [
                _c("b-form-group", {
                  class: {
                    "no-margin-bottom": !_vm.healthyHabitsData.measurable
                  },
                  attrs: { label: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var ariaDescribedby = ref.ariaDescribedby
                          return [
                            _vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 1
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("daily")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 2
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("weekly")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 3
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("monthly")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 1
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [
                                    _vm._v(_vm._s(_vm.$t("each")) + " "),
                                    _c("base-input", {
                                      staticClass: "input-modal-options",
                                      attrs: {
                                        placeholder: "",
                                        type: "number",
                                        min: 1,
                                        max: 90
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.healthyHabitsData.goalFrequencyId = 1
                                        }
                                      },
                                      model: {
                                        value: _vm.goalDays,
                                        callback: function($$v) {
                                          _vm.goalDays = $$v
                                        },
                                        expression: "goalDays"
                                      }
                                    }),
                                    _vm._v(" " + _vm._s(_vm.$t("days")) + " "),
                                    _c("b-icon-question-circle", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        },
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.click",
                                          value:
                                            _vm.$t("valuesBetween") + " 1 y 90",
                                          expression:
                                            "`${$t('valuesBetween')} 1 y 90`",
                                          modifiers: { click: true }
                                        }
                                      ],
                                      attrs: {
                                        title:
                                          _vm.$t("valuesBetween") + " 1 y 90"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 2
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [
                                    _c("base-input", {
                                      staticClass: "input-modal-options",
                                      attrs: {
                                        placeholder: "",
                                        type: "number",
                                        min: 1,
                                        max: 6
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.healthyHabitsData.goalFrequencyId = 2
                                        }
                                      },
                                      model: {
                                        value: _vm.goalWeek,
                                        callback: function($$v) {
                                          _vm.goalWeek = $$v
                                        },
                                        expression: "goalWeek"
                                      }
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("timesToWeek")) + " "
                                    ),
                                    _c("b-icon-question-circle", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        },
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.click",
                                          value:
                                            _vm.$t("valuesBetween") + " 1 y 6",
                                          expression:
                                            "`${$t('valuesBetween')} 1 y 6`",
                                          modifiers: { click: true }
                                        }
                                      ],
                                      attrs: {
                                        title:
                                          _vm.$t("valuesBetween") + " 1 y 6"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.healthyHabitsData.measurable
                              ? _c(
                                  "b-form-radio",
                                  {
                                    staticClass: "my-2",
                                    attrs: {
                                      plain: "",
                                      "aria-describedby": ariaDescribedby,
                                      name: "frequency-radio",
                                      value: 3
                                    },
                                    model: {
                                      value:
                                        _vm.healthyHabitsData.goalFrequencyId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.healthyHabitsData,
                                          "goalFrequencyId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "healthyHabitsData.goalFrequencyId"
                                    }
                                  },
                                  [
                                    _c("base-input", {
                                      staticClass: "input-modal-options",
                                      attrs: {
                                        placeholder: "",
                                        type: "number",
                                        min: 1,
                                        max: 29
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.healthyHabitsData.goalFrequencyId = 3
                                        }
                                      },
                                      model: {
                                        value: _vm.goalMonth,
                                        callback: function($$v) {
                                          _vm.goalMonth = $$v
                                        },
                                        expression: "goalMonth"
                                      }
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("timesToMonth")) + " "
                                    ),
                                    _c("b-icon-question-circle", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        },
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.click",
                                          value:
                                            _vm.$t("valuesBetween") + " 1 y 29",
                                          expression:
                                            "`${$t('valuesBetween')} 1 y 29`",
                                          modifiers: { click: true }
                                        }
                                      ],
                                      attrs: {
                                        title:
                                          _vm.$t("valuesBetween") + " 1 y 29"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1253626556
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("base-button", { on: { click: _vm.saveFrequency } }, [
                      _vm._v(_vm._s(_vm.$t("save")))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "base-modal",
              {
                attrs: {
                  noCloseOnBackdrop: "",
                  noCloseOnScape: "",
                  hideClose: "",
                  titleAlignLeft: "",
                  value: _vm.showReminderDaysModal,
                  title: _vm.$t("selectOneMoreOption")
                },
                on: {
                  hide: function($event) {
                    _vm.showReminderDaysModal = false
                  }
                }
              },
              [
                _c("b-form-checkbox-group", {
                  staticClass: "form-group",
                  attrs: {
                    stacked: _vm.showWeekDaysStacked,
                    options: _vm.weekDaysOptions,
                    "value-field": "value",
                    "text-field": "name"
                  },
                  model: {
                    value: _vm.reminderDaysArray,
                    callback: function($$v) {
                      _vm.reminderDaysArray = $$v
                    },
                    expression: "reminderDaysArray"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("base-button", { on: { click: _vm.saveReminderDays } }, [
                      _vm._v(_vm._s(_vm.$t("save")))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37d6321e", esExports)
  }
}

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1707);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("87969720", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ac5e33f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ArrowButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ac5e33f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ArrowButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "icon-button",
    _vm._b(
      {
        attrs: {
          icon:
            "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
          text: _vm.text,
          action: _vm.action,
          reverse: _vm.reverse
        }
      },
      "icon-button",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ac5e33f", esExports)
  }
}

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ([{
  path: 'component-testing',
  name: 'ComponentTesting',
  component: function component() {
    return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 2381));
  },
  meta: {
    pageTitle: 'Testing'
  }
}, {
  path: 'device-selector-testing',
  name: 'DeviceSelectorTesting',
  component: function component() {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 2382));
  },
  meta: {
    pageTitle: 'Testing'
    /* roles: [ 'Profesional' ] */
  }
}, {
  path: 'base-card-testing',
  name: 'BaseCardTesting',
  component: function component() {
    return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 2383));
  },
  meta: {
    pageTitle: 'BaseCard'
    /* roles: [ 'Profesional' ] */
  }
}, {
  path: 'history-testing',
  name: 'HistoryTesting',
  component: function component() {
    return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 2384));
  },
  meta: {
    pageTitle: 'ClinicHistory'
    /* roles: [ 'Profesional' ] */
  }
}, {
  path: 'swiper-testing',
  name: 'SwiperTesting',
  component: function component() {
    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 2385));
  },
  meta: {
    pageTitle: 'Swiper'
  }
}, {
  path: 'vue-tree-navigation',
  name: 'VueTreeNavigation',
  component: function component() {
    return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 2386));
  },
  meta: {
    pageTitle: 'Swiper'
  }
}, {
  path: 'navbar',
  name: 'Navbar',
  component: function component() {
    return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 2387));
  },
  meta: {
    pageTitle: 'Navbar'
  }
}]);

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2b9f8e48", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60886486\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SearchTab.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60886486\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SearchTab.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.searchContainer{width:60vw !important;text-align:left;display:inline;margin-top:-14%;margin-left:0px !important\n}\n.searchArrow{height:50%;margin:34% 0% 0% 0% !important\n}\n.searchSubmit{display:contents\n}\n.vs__search{width:auto !important\n}\n.searchButton{height:37px\n}\n.searchOHDiv{padding-top:8px\n}\n", ""]);

// exports


/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { staticClass: "row searchContainer" },
    [
      _c(
        "b-form-group",
        [
          _c("base-select", {
            staticClass: "searchSpeciality",
            attrs: {
              id: "specialities",
              label: _vm.$i18nHelpers.normalizeProp("name"),
              placeholder: "Especialidad",
              valueProp: "id",
              options: _vm.selectSpeciality.options
            },
            model: {
              value: _vm.selectSpeciality.selected,
              callback: function($$v) {
                _vm.$set(_vm.selectSpeciality, "selected", $$v)
              },
              expression: "selectSpeciality.selected"
            }
          }),
          _vm._v(" "),
          _c("b-form-invalid-feedback", [
            _vm._v(_vm._s(_vm.$t("signupOH.errors.enterCountry")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("base-select", {
            staticClass: "searchConsultationType",
            attrs: {
              id: "services",
              label: "text",
              placeholder: "Servicios",
              options: _vm.selectConsultation.options
            },
            model: {
              value: _vm.selectConsultation.selected,
              callback: function($$v) {
                _vm.$set(_vm.selectConsultation, "selected", $$v)
              },
              expression: "selectConsultation.selected"
            }
          }),
          _vm._v(" "),
          _c("b-form-invalid-feedback", [
            _vm._v(_vm._s(_vm.$t("signupOH.errors.enterCountry")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { staticClass: "searchOHDiv" },
        [
          _c(
            "b-button",
            {
              staticClass: "searchButton",
              attrs: { type: "submit", variant: "primary" }
            },
            [
              _c("base-icon", {
                staticClass: "arrowImage",
                attrs: {
                  color: _vm.WHITE_COLOUR,
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60886486", esExports)
  }
}

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Area_vue__ = __webpack_require__(1095);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec48e244_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Area_vue__ = __webpack_require__(1716);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1714)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec48e244"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Area_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec48e244_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Area_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/openlegal/Area.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ec48e244", Component.options)
  } else {
    hotAPI.reload("data-v-ec48e244", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1715);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("7cfe6c2b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ec48e244\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Area.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ec48e244\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Area.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-ec48e244]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-ec48e244],.slide-down-leave-active[data-v-ec48e244]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-ec48e244],.slide-down-leave-to[data-v-ec48e244]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-ec48e244],.slide-fade-left-leave-active[data-v-ec48e244]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-ec48e244],.slide-fade-left-leave-to[data-v-ec48e244]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-ec48e244]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-ec48e244],.fade-leave-to[data-v-ec48e244]{opacity:0\n}\n[data-v-ec48e244] ul,[data-v-ec48e244] ul li{list-style-type:disc !important\n}\n[data-v-ec48e244] ol li{list-style-type:decimal !important\n}\n", ""]);

// exports


/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { domProps: { innerHTML: _vm._s(_vm.description) } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec48e244", esExports)
  }
}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1718);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("ecf052dc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8dbdeca\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginFormModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8dbdeca\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginFormModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      attrs: { title: _vm.title, hideClose: "" },
      model: {
        value: _vm.localValue,
        callback: function($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue"
      }
    },
    [_c("login-form", { attrs: { loginCallback: _vm.loginCallback } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8dbdeca", esExports)
  }
}

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_layouts__ = __webpack_require__(50);



function scrollTop(to, from, next) {
    window.scrollTo(0, 0);
    next();
}

/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'foro',
    path: '/',
    component: function component() {
        return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 544));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('forumTitle');
            }
        },
        i18n: 'public/views/healthy-community'
    },
    beforeEnter: scrollTop
}, {
    name: 'panel-administracion',
    path: 'panel/:section?',
    component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 448));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('forumTitle');
            }
        },
        i18n: 'public/views/healthy-community'
        // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
    },
    beforeEnter: scrollTop
}, {
    name: 'foro-entry',
    path: 'foro-entry/:entryId?',
    component: function component() {
        return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 544));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('forumTitle');
            }
        },
        i18n: 'public/views/healthy-community'
        // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
    }
}, {
    name: 'hilo-foro',
    path: ':id',
    component: function component() {
        return __webpack_require__.e/* import() */(26/* duplicate */).then(__webpack_require__.bind(null, 1289));
    },
    meta: {
        layout: __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["b" /* FORUM_NAVBAR_LAYOUT */],
        forumClass: true,
        title: {
            text: function text() {
                return __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('forumTitle');
            }
        },
        i18n: 'public/views/healthy-community'
        // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
    },
    beforeEnter: scrollTop
}]);

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1722);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("359d290e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a8b81d5a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumArticleBlock.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a8b81d5a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumArticleBlock.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.forumBlock{width:60vw;vertical-align:baseline;margin-bottom:2rem;cursor:pointer\n}\n@media only screen and (max-width: 575px){\n.forumBlock{width:97vw\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.forumBlock{width:97vw\n}\n}\n.forumArticleTitle{margin:1.5% !important;color:#3238C4\n}\n@media only screen and (max-width: 575px){\n.forumArticleTitle{font-size:1.5em\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.forumArticleTitle{font-size:1.5em\n}\n}\n.forumImageSize{width:350px\n}\n@media only screen and (min-width: 1200px){\n.forumImageSize{width:600px\n}\n}\n.seeMoreEntries{text-align:center;margin-bottom:5%\n}\n.forumDescription{margin:3% 2% 1.5% 2%\n}\n.whoInDescription{margin:0\n}\n@media only screen and (max-width: 575px){\n.hide-forum-description-mobile{display:none\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.hide-forum-description-mobile{display:none\n}\n}\n.forumDescriptionEllipsis{margin:3% 1% 1% 1% !important\n}\n.forumDescriptionEllipsis p{white-space:nowrap;text-overflow:ellipsis;overflow:hidden\n}\n.popover-more-options{display:-webkit-box;display:-ms-flexbox;display:flex;min-width:35px\n}\n@media only screen and (max-width: 575px){\n.popover-more-options{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:initial\n}\n}\n.margin-left-more-options{margin-left:3%\n}\n.show-more-details{color:#3238C4;cursor:pointer\n}\n.activity-block{text-align:left;padding:3rem;display:-webkit-box;display:-ms-flexbox;display:flex;gap:3rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n@media only screen and (max-width: 1199px){\n.activity-block{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:1rem;gap:2rem\n}\n}\n.activity-picture{width:250px;-webkit-box-flex:0;-ms-flex:0 0 300px;flex:0 0 300px;border-radius:23px\n}\n@media only screen and (max-width: 1199px){\n.activity-picture{width:100%;max-height:200px;max-width:300px\n}\n}\n.activity-content{-webkit-box-flex:0;-ms-flex:0 0 initial;flex:0 0 initial\n}\n@media only screen and (max-width: 1199px){\n.activity-content{text-align:center\n}\n}\n.activity-name-block{display:-webkit-box;display:-ms-flexbox;display:flex;gap:1rem;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n", ""]);

// exports


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1724);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("fe1d61fe", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-655d6103\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SocialSharingPopover.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-655d6103\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SocialSharingPopover.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.share-network-list{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;max-width:1000px;margin:auto\n}\na[class^=\"share-network-\"]{-webkit-box-flex:0;-ms-flex:none;flex:none;color:#FFFFFF;background-color:#333;border-radius:3px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;margin:0 10px 10px 0;padding:1%\n}\na[class^=\"share-network-\"] span{padding:0 10px;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;font-weight:500\n}\n.popover{max-width:initial !important\n}\n.popover-article{display:-webkit-box;display:-ms-flexbox;display:flex;width:751px\n}\n@media only screen and (max-width: 575px){\n.popover-article{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:initial\n}\n}\n.popover-header{text-align:center;background-color:initial;border-bottom:initial\n}\n", ""]);

// exports


/***/ }),
/* 1725 */,
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-popover",
        {
          attrs: {
            target: _vm.targetId,
            triggers: "click blur",
            placement: "top"
          }
        },
        [
          _c("h3", { staticClass: "popover-header" }, [
            _vm._v(_vm._s(_vm.$t("shareInSocialMedia")) + "\r\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "popover-article" },
            [
              _vm._l(_vm.socialNetworks.networks, function(socialNetwork) {
                return _c(
                  "ShareNetwork",
                  {
                    key: socialNetwork.network,
                    style: { "background-Color": socialNetwork.color },
                    attrs: {
                      network: socialNetwork.network,
                      url: _vm.url,
                      title: _vm.socialNetworks.sharing.title,
                      description: _vm.socialNetworks.sharing.description,
                      quote: _vm.socialNetworks.sharing.quote,
                      hashtags: _vm.socialNetworks.sharing.hashtags,
                      twitterUser: _vm.socialNetworks.sharing.twitterUser
                    }
                  },
                  [
                    _c("b-icon", {
                      attrs: { "font-scale": "1.5", icon: socialNetwork.icon }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(socialNetwork.name))])
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "share-network-link",
                  staticStyle: { "background-color": "#4a76a8" },
                  on: {
                    click: function($event) {
                      return _vm.copyLinkClipboard(_vm.url)
                    }
                  }
                },
                [
                  _c("b-icon", {
                    attrs: { "font-scale": "1.5", icon: "share" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("link")))])
                ],
                1
              )
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-655d6103", esExports)
  }
}

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verticalCenter" }, [
    _vm.$store.state.forum.articleData &&
    _vm.$store.state.forum.articleData.length > 0
      ? _c(
          "div",
          [
            _vm._l(_vm.$store.state.forum.articleData, function(item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "forumBlock",
                  attrs: { id: item.id },
                  on: { click: _vm.forumBlockClick }
                },
                [
                  _c(
                    "div",
                    { staticClass: "forumArticle" },
                    [
                      _c(
                        "div",
                        { staticClass: "forumAuthor" },
                        [
                          item.category
                            ? _c(
                                "base-button",
                                {
                                  staticClass: "tag-style-left",
                                  style: {
                                    "background-color":
                                      item.category.color + " !important",
                                    "border-color":
                                      item.category.color + " !important"
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        item.category[
                                          _vm.normalizeForumProp("name")
                                        ]
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _vm._v(
                                "\r\n                    " +
                                  _vm._s(_vm.$t("publishedBy")) +
                                  "\r\n                    "
                              ),
                              item.userPage
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "underlined bold",
                                      attrs: {
                                        target: "_blank",
                                        href: item.userPage
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.authorName))]
                                  )
                                : _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(item.authorName)
                                    }
                                  }),
                              _vm._v(" "),
                              item.userSpeciality
                                ? _c("span", [
                                    _vm._v("\r\n                      ("),
                                    item.userPage
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "underlined bold",
                                            attrs: {
                                              target: "_blank",
                                              href: item.userPage
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("consultationIn")) +
                                                " "
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.userSpeciality[
                                                    _vm.normalizeForumProp(
                                                      "name"
                                                    )
                                                  ]
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(")\r\n                    ")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.disease
                                ? _c(
                                    "base-button",
                                    { staticClass: "tag-style-right" },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.disease[
                                              _vm.normalizeForumProp("name")
                                            ]
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      item.category
                        ? _c(
                            "base-button",
                            {
                              staticClass: "tag-style-mobile",
                              style: {
                                "background-color":
                                  item.category.color + " !important",
                                "border-color":
                                  item.category.color + " !important"
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.category[
                                      _vm.normalizeForumProp("name")
                                    ]
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.disease
                        ? _c(
                            "base-button",
                            { staticClass: "tag-style-mobile-disease" },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.disease[_vm.normalizeForumProp("name")]
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.title
                        ? _c("h3", {
                            staticClass: "forumArticleTitle",
                            domProps: { innerHTML: _vm._s(item.title) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.articlePicture && _vm.showImage
                        ? _c("img", {
                            staticClass: "forumImageSize",
                            attrs: { src: item.articlePicture }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.whoInData
                        ? _c("div", { staticClass: "activity-block" }, [
                            _c("img", {
                              staticClass: "activity-picture",
                              attrs: {
                                alt: "",
                                src: _vm.getActivitityPicture(item.whoInData)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "activity-content" }, [
                              _c(
                                "div",
                                { staticClass: "activity-name-block" },
                                [
                                  _c("base-button", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getActivityName(item.whoInData)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.activityIsFull(item.whoInData)
                                    ? _c(
                                        "base-button",
                                        { attrs: { red: "" } },
                                        [_vm._v(_vm._s(_vm.$t("closed")))]
                                      )
                                    : _c(
                                        "base-button",
                                        {
                                          attrs: {
                                            textColor: _vm.BLACK_COLOUR,
                                            borderColor: _vm.GREEN_COLOUR,
                                            backgroundColor: _vm.GREEN_COLOUR
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("open")))]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", {
                                staticClass:
                                  "forumDescription whoInDescription",
                                class: {
                                  "hide-forum-description-mobile":
                                    _vm.hideForumDescription
                                },
                                attrs: { id: "whoInDescription-" + item.id },
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.description ||
                                      (_vm.showFullWhoInDescription
                                        ? _vm.getWhoInDescription(
                                            item.whoInData
                                          )
                                        : _vm.getWhoInDescriptionShort(
                                            item.whoInData
                                          ))
                                  )
                                }
                              })
                            ])
                          ])
                        : _c("p", {
                            staticClass: "forumDescription",
                            class: {
                              "hide-forum-description-mobile":
                                _vm.hideForumDescription
                            },
                            domProps: { innerHTML: _vm._s(item.description) }
                          }),
                      _vm._v(" "),
                      !_vm.hideFooter
                        ? _c(
                            "div",
                            [
                              item.whoInData
                                ? _c(
                                    "b-row",
                                    { staticClass: "forumFooter" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: {
                                            cols: _vm.showFullWhoInDescription
                                              ? 4
                                              : 3
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleSignUpWhoIn(item)
                                            }
                                          }
                                        },
                                        [
                                          _vm.signedUpWhoInActivity(
                                            item.whoInData
                                          )
                                            ? _c("b-icon-person-check-fill", {
                                                staticClass:
                                                  "opensalud-blue margin-right-icon"
                                              })
                                            : _c("b-icon-person-check", {
                                                staticClass: "margin-right-icon"
                                              }),
                                          _c("span", {
                                            staticClass: "hide-title-mobile",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getSignUpTitle(
                                                  item.whoInData
                                                ) + " "
                                              )
                                            }
                                          }),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getWhoInParticipants(
                                                  item.whoInData
                                                )
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.showFullWhoInDescription
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: { cols: "3" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleWhoInDescription(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-info-circle", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.showingFullDetails
                                                        ? _vm.$t("hideDetails")
                                                        : _vm.$t("showDetails")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.showAnswerBtn
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3
                                              }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("commentaries")
                                                    )
                                                  )
                                                ]
                                              ),
                                              item.totalMessages
                                                ? _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "hide-title-mobile"
                                                      },
                                                      [_vm._v(": ")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opensalud-blue"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.totalMessages
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showEntryAnswerBlock.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("comment"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _vm.canEditForumEntry(item.id) ||
                                      _vm.canModifyForumEntry(item.id)
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3,
                                                id: "more-options-" + item.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-three-dots", {
                                                attrs: { scale: "1.5" }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3,
                                                id: "share-socials-" + item.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-share", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("share"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-row",
                                    { staticClass: "forumFooter" },
                                    [
                                      !_vm.showAnswerBtn
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: { cols: "3" }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("commentaries")
                                                    )
                                                  )
                                                ]
                                              ),
                                              item.totalMessages
                                                ? _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "hide-title-mobile"
                                                      },
                                                      [_vm._v(": ")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opensalud-blue"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.totalMessages
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: { cols: "3" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showEntryAnswerBlock.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("answer"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: { cols: "3" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.articleLike(item.id)
                                            }
                                          }
                                        },
                                        [
                                          _vm.$store.state.forum.userBasicInfo.entriesLike.includes(
                                            item.id
                                          )
                                            ? _c("b-icon-hand-thumbs-up-fill", {
                                                staticClass:
                                                  "opensalud-blue margin-right-icon"
                                              })
                                            : _c("b-icon-hand-thumbs-up", {
                                                staticClass: "margin-right-icon"
                                              }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hide-title-mobile"
                                            },
                                            [_vm._v(_vm._s(_vm.$t("like")))]
                                          ),
                                          item.likes
                                            ? _c("span", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "hide-title-mobile"
                                                  },
                                                  [_vm._v(": ")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "opensalud-blue"
                                                  },
                                                  [_vm._v(_vm._s(item.likes))]
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: { cols: "3" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.saveArticle(item.id)
                                            }
                                          }
                                        },
                                        [
                                          _vm.$store.state.forum.userBasicInfo.entriesSaved.includes(
                                            item.id
                                          )
                                            ? _c("b-icon-bookmark-check-fill", {
                                                staticClass:
                                                  "opensalud-blue margin-right-icon"
                                              })
                                            : _c("b-icon-bookmark", {
                                                staticClass: "margin-right-icon"
                                              }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hide-title-mobile"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$store.state.forum.userBasicInfo.entriesSaved.includes(
                                                    item.id
                                                  )
                                                    ? _vm.$t("saved")
                                                    : _vm.$t("save")
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.canEditForumEntry(item.id) ||
                                      _vm.canModifyForumEntry(item.id)
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                id: "more-options-" + item.id,
                                                cols: "3"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-three-dots", {
                                                attrs: { scale: "1.5" }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: "3",
                                                id: "share-socials-" + item.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-share", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("share"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showValidateEntry
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "2%" } },
                        [
                          _c(
                            "base-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.validateEntry(item.id, true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("validate")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              attrs: { red: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateEntry(item.id, false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("reject")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("social-sharing-popover", {
                    attrs: {
                      url: _vm.shareArticleLink(item.id),
                      targetId: "share-socials-" + item.id,
                      sectionName: _vm.getForumSectionTitle(
                        _vm.$store.state.forum.sectionId,
                        true
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target: "more-options-" + item.id,
                        triggers: "click",
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "more-options-row" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: {
                                cols: "12",
                                id: "share-socials-popover-" + item.id
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "more-options-item" },
                                [
                                  _c("b-icon-share", {
                                    staticClass: "margin-right-icon"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("share")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.canEditForumEntry(item.id)
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.updateEntry(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-pencil-square", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("edit")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canModifyForumEntry(item.id)
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.showConfirmDelete = true
                                        _vm.entryIdSelected = item.id
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-trash", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("remove")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("social-sharing-popover", {
                            attrs: {
                              url: _vm.shareArticleLink(item.id),
                              targetId: "share-socials-popover-" + item.id,
                              sectionName: _vm.getForumSectionTitle(
                                _vm.$store.state.forum.sectionId,
                                true
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("base-dialog", {
              attrs: {
                value: _vm.showConfirmDelete,
                okFn: function() {
                  _vm.removeEntry()
                  _vm.showConfirmDelete = false
                },
                cancelFn: function() {
                  _vm.showConfirmDelete = false
                },
                okBtnText: _vm.$t("yes"),
                cancelBtnText: _vm.$t("no"),
                content: _vm.$t("removePostAdvice")
              }
            }),
            _vm._v(" "),
            _vm.showMorePostMessages && !_vm.hideFooter
              ? _c(
                  "div",
                  {
                    staticClass: "seeMoreEntries",
                    on: { click: _vm.loadMoreEntries }
                  },
                  [
                    _c("b-icon", {
                      staticClass: "pointer",
                      attrs: { icon: "arrow-down", scale: "0.7" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pointer" }, [
                      _vm._v(_vm._s(_vm.$t("showMoreEntries")))
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      : _c("div", { staticStyle: { "margin-top": "30vh" } }, [
          _vm.$store.state.forum.entrySearchValue
            ? _c("h1", [_vm._v(_vm._s(_vm.$t("emptyEntriesSearch")))])
            : _vm.inWhoInSection
            ? _c(
                "div",
                [
                  _c("h1", [_vm._v(_vm._s(_vm.$t("emptyActivitiesSearch")))]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    { staticClass: "mt-3", on: { click: _vm.createNewPost } },
                    [_vm._v(_vm._s(_vm.$t("proposeNewActivity")))]
                  )
                ],
                1
              )
            : _c("h1", [_vm._v(_vm._s(_vm.$t("emptyEntries")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8b81d5a", esExports)
  }
}

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1729);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0827ca64", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ad40e27a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumControlPanel.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ad40e27a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumControlPanel.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.nav-mod-admin{z-index:inherit !important;position:relative !important;width:15% !important\n}\n.nav-mod-admin>div{position:inherit !important;min-height:100vh !important;margin:7% 1% 0 0 !important\n}\n.column-content{margin-top:1vh;width:75%\n}\n.centerInput{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.text-align-left{text-align:left\n}\n.label-align{min-width:300px;display:block;text-align:left\n}\n.show-navbar-mobile{display:none !important\n}\n@media only screen and (max-width: 575px){\n.show-navbar-mobile{display:inline-block !important\n}\n}\n.show-navbar-lg{display:none !important\n}\n@media only screen and (min-width: 1024px){\n.show-navbar-lg{display:inline-block !important\n}\n}\n@media only screen and (max-width: 575px){\n.justify-center-mobile{margin-top:2vh !important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.justify-center-mobile{margin-top:2vh !important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n}\n.three-dots-admin{position:absolute;left:7%;margin-top:2%;cursor:pointer\n}\ndiv.b-sidebar{margin-top:0px !important\n}\n.btn-control{margin-top:3vh !important\n}\n.black{color:#1D1D1E\n}\n.notificationsSelector{width:auto;max-width:350px;margin-left:auto;margin-right:auto;margin-bottom:0px !important\n}\n", ""]);

// exports


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1731);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("97ae1db0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25bba162\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumMessageBlock.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25bba162\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumMessageBlock.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-25bba162]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-25bba162],.slide-down-leave-active[data-v-25bba162]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-25bba162],.slide-down-leave-to[data-v-25bba162]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-25bba162],.slide-fade-left-leave-active[data-v-25bba162]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-25bba162],.slide-fade-left-leave-to[data-v-25bba162]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-25bba162]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-25bba162],.fade-leave-to[data-v-25bba162]{opacity:0\n}\n.a[data-v-25bba162]{-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:inline-block;height:100%;margin-left:5px;vertical-align:top;width:16px\n}\n.threadLine[data-v-25bba162]{border-right:2px solid #EDEFF1;display:block;height:100%;width:50%\n}\n.forumMessageBlock[data-v-25bba162]{width:60vw;vertical-align:baseline\n}\n@media only screen and (max-width: 575px){\n.forumMessageBlock[data-v-25bba162]{width:97vw\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.forumMessageBlock[data-v-25bba162]{width:97vw\n}\n}\n.messageThread[data-v-25bba162]{padding-left:1%\n}\n.messageBox[data-v-25bba162]{display:block;font-size:initial;text-align:left\n}\n.seeMoreReplies[data-v-25bba162]{color:#e61010;text-align:left;margin-top:10px;margin-left:1%\n}\n.seeLessReplies[data-v-25bba162]{text-align:left;margin-top:10px;margin-left:1%\n}\n.seeMoreAnswers[data-v-25bba162]{color:#e61010;text-align:left;margin-top:10px;margin-left:1%\n}\n", ""]);

// exports


/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "verticalCenter", staticStyle: { "margin-top": "0" } },
      [
        _vm._l(_vm.$store.state.forum.messages, function(item) {
          return _c(
            "div",
            { key: item.id },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !item.hide,
                      expression: "!item.hide"
                    }
                  ],
                  staticClass: "forumMessageBlock mb-4",
                  style: { "padding-left": item.messageTier + "%" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "forumArticle" },
                    [
                      _c("div", { staticClass: "forumAuthor" }, [
                        item.userPage
                          ? _c(
                              "a",
                              {
                                staticClass: "underlined bold",
                                attrs: {
                                  target: "_blank",
                                  href: item.userPage
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.authorName))]
                            )
                          : _c("span", {
                              domProps: { innerHTML: _vm._s(item.authorName) }
                            }),
                        _vm._v(" "),
                        item.userSpeciality
                          ? _c("span", [
                              _vm._v("\r\n                  ("),
                              item.userPage
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "underlined bold",
                                      attrs: {
                                        target: "_blank",
                                        href: item.userPage
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("consultationIn")) + " "
                                      ),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.userSpeciality[
                                              _vm.normalizeForumProp("name")
                                            ]
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(")\r\n                ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getTimeAgoFromDate(item.createdAt)
                            )
                          }
                        }),
                        _vm._v(" "),
                        item.edited
                          ? _c("span", [
                              _vm._v("(" + _vm._s(_vm.$t("edited")) + ")")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      item.active
                        ? _c("span", {
                            staticClass: "messageBox mx-3",
                            domProps: { innerHTML: _vm._s(item.message) }
                          })
                        : _c(
                            "p",
                            {
                              staticClass: "messageBox mx-3",
                              staticStyle: { "font-style": "italic" }
                            },
                            [_vm._v(_vm._s(_vm.$t("messageDeleted")))]
                          ),
                      _vm._v(" "),
                      !_vm.hideOptions && item.active
                        ? _c(
                            "b-row",
                            { staticClass: "forumFooter" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "3", sm: "3" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.answerMessage(item.id)
                                    }
                                  }
                                },
                                [
                                  _c("b-icon-chat-left", {
                                    staticClass: "margin-right-icon"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("answer")))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "3", sm: "3" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.messageLike(item.id)
                                    }
                                  }
                                },
                                [
                                  _vm.$store.state.forum.userBasicInfo.messagesLike.includes(
                                    item.id
                                  )
                                    ? _c("b-icon-hand-thumbs-up-fill", {
                                        staticClass:
                                          "opensalud-blue margin-right-icon"
                                      })
                                    : _c("b-icon-hand-thumbs-up", {
                                        staticClass: "margin-right-icon"
                                      }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("like")))]
                                  ),
                                  item.likes
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "hide-title-mobile" },
                                          [_vm._v(": ")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "opensalud-blue" },
                                          [_vm._v(_vm._s(item.likes))]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "3", sm: "3" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.saveMessage(item.id)
                                    }
                                  }
                                },
                                [
                                  _vm.$store.state.forum.userBasicInfo.messagesSaved.includes(
                                    item.id
                                  )
                                    ? _c("b-icon-bookmark-check-fill", {
                                        staticClass:
                                          "opensalud-blue margin-right-icon"
                                      })
                                    : _c("b-icon-bookmark", {
                                        staticClass: "margin-right-icon"
                                      }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.forum.userBasicInfo.messagesSaved.includes(
                                            item.id
                                          )
                                            ? _vm.$t("saved")
                                            : _vm.$t("save")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: {
                                    id: "more-options-message-" + item.id,
                                    cols: "3",
                                    sm: "3"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                [
                                  _c("b-icon-three-dots", {
                                    attrs: { scale: "1.5" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.messageIdSelected === item.id
                        ? _c(
                            "div",
                            [
                              _c("vue-editor", {
                                attrs: { useCustomImageHandler: "" },
                                on: { "image-added": _vm.handleImageAdded },
                                model: {
                                  value: _vm.wysiwygInput,
                                  callback: function($$v) {
                                    _vm.wysiwygInput = $$v
                                  },
                                  expression: "wysiwygInput"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  staticStyle: { margin: "2% 0" },
                                  on: {
                                    click: function($event) {
                                      return _vm.sendMessage(
                                        item.messageReferenceId
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("send")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  staticStyle: { margin: "2% 0" },
                                  attrs: { gray: "", outline: "" },
                                  on: { click: _vm.goBack }
                                },
                                [_vm._v(_vm._s(_vm.$t("cancel")))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target: "more-options-message-" + item.id,
                        triggers: "click",
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "more-options-row" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: {
                                cols: "12",
                                id: "share-socials-message-popover-" + item.id
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "more-options-item" },
                                [
                                  _c("b-icon-share", {
                                    staticClass: "margin-right-icon"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("share")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.canEditForumMessage(item.id) && item.active
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.wysiwygInput = item.message
                                        _vm.messageIdSelected = item.id
                                        _vm.editingMessage = true
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-pencil-square", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("edit")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canModifyForumMessage(item.id) && item.active
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.showConfirmDelete = true
                                        _vm.messageIdToRemove = item.id
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-trash", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("remove")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.aspIdPublisher !=
                          _vm.$store.state.forum.userBasicInfo.userAspId
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.showReportModal = true
                                        _vm.messageIdToReport = item.id
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-exclamation-circle", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("reportMessage"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("social-sharing-popover", {
                            attrs: {
                              url: _vm.shareMessageLink(),
                              targetId:
                                "share-socials-message-popover-" + item.id,
                              sectionName: _vm.getForumSectionTitle(
                                _vm.$store.state.forum.sectionId,
                                true
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showValidateMessage
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "2%" } },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { green: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateMessage(item.id, true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("validate")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              attrs: { red: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateMessage(item.id, false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("reject")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showReportMessage
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "2%" } },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { green: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateReportedMessageAction(
                                    item.id,
                                    true
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("noRemove")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              attrs: { red: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateReportedMessageAction(
                                    item.id,
                                    false
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("remove")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideOptions
                    ? _c("div", [
                        item.numReplies &&
                        !_vm.$store.state.forum.showMoreIds.find(function(i) {
                          return i === item.id
                        })
                          ? _c(
                              "div",
                              { staticClass: "seeMoreReplies" },
                              [
                                _c("b-icon", {
                                  staticClass: "pointer",
                                  attrs: { icon: "arrow-down", scale: "0.7" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showMoreMessages(item.id)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.showMoreMessages(item.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("show")) +
                                        " " +
                                        _vm._s(item.numReplies) +
                                        " " +
                                        _vm._s(
                                          item.numReplies === 1
                                            ? _vm.$t("moreReply")
                                            : _vm.$t("moreReplies")
                                        )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$store.state.forum.showMoreIds.find(function(i) {
                          return i === item.id
                        })
                          ? _c(
                              "div",
                              { staticClass: "seeLessReplies" },
                              [
                                _c("b-icon", {
                                  staticClass: "pointer",
                                  attrs: { icon: "arrow-up", scale: "0.7" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showLessMessages(item.id)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.showLessMessages(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("hideMessages")))]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("social-sharing-popover", {
                attrs: {
                  url: _vm.shareMessageLink(),
                  targetId: "share-socials-message-" + item.id,
                  sectionName: _vm.getForumSectionTitle(
                    _vm.$store.state.forum.sectionId,
                    true
                  )
                }
              })
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("base-dialog", {
          attrs: {
            value: _vm.showConfirmDelete,
            okFn: function() {
              _vm.removeMessage()
              _vm.showConfirmDelete = false
            },
            cancelFn: function() {
              _vm.showConfirmDelete = false
            },
            okBtnText: _vm.$t("yes"),
            cancelBtnText: _vm.$t("no"),
            content: _vm.$t("removeMessageAdvice")
          }
        }),
        _vm._v(" "),
        _c(
          "base-modal",
          {
            attrs: {
              value: _vm.showReportModal,
              title: _vm.$t("reportMessageTitle")
            },
            on: { hidden: _vm.resetReportModal }
          },
          [
            _c("b-form-textarea", {
              attrs: { rows: 10, "no-resize": true },
              model: {
                value: _vm.reportReasons,
                callback: function($$v) {
                  _vm.reportReasons = $$v
                },
                expression: "reportReasons"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "my-4 text-center" },
              [
                _c(
                  "base-button",
                  { staticClass: "btn-control", on: { click: _vm.sendReport } },
                  [_vm._v(_vm._s(_vm.$t("send")))]
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.resetReportModal }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        !_vm.hideOptions
          ? _c("div", { staticClass: "forumMessageBlock" }, [
              _vm.showMorePrincipalMessages
                ? _c(
                    "div",
                    { staticClass: "seeMoreAnswers my-4" },
                    [
                      _c("b-icon", {
                        staticClass: "pointer",
                        attrs: { icon: "arrow-down", scale: "0.7" },
                        on: { click: _vm.loadMorePrincipalMessages }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pointer",
                          on: { click: _vm.loadMorePrincipalMessages }
                        },
                        [_vm._v(_vm._s(_vm.$t("showMoreReplies")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25bba162", esExports)
  }
}

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "justify-center-mobile",
      staticStyle: { display: "flex", "min-height": "100vh" }
    },
    [
      _c(
        "b-sidebar",
        {
          staticClass: "show-navbar-lg nav-mod-admin",
          attrs: { visible: "", "no-header": "", shadow: "" }
        },
        [
          _c(
            "nav",
            { staticClass: "mb-3" },
            [
              _c(
                "b-nav",
                { attrs: { vertical: "" } },
                [
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "perfil" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("perfil")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myProfile")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "favoritos" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("favoritos")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("saveds")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "notificaciones" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("notificaciones")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myNotifications")))]
                  ),
                  _vm._v(" "),
                  _vm.$store.getters["forum/forumUserIsAdminRole"]
                    ? _c(
                        "b-nav-item",
                        {
                          staticStyle: { "margin-right": "0px" },
                          attrs: { active: _vm.section === "validaciones" },
                          on: {
                            click: function($event) {
                              return _vm.showSection("validaciones")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("validations")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.getters["forum/forumUserIsAdminRole"]
                    ? _c(
                        "b-nav-item",
                        {
                          staticStyle: { "margin-right": "0px" },
                          attrs: { active: _vm.section === "reportes" },
                          on: {
                            click: function($event) {
                              return _vm.showSection("reportes")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("reports")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("b-icon-three-dots-vertical", {
        directives: [
          {
            name: "b-toggle",
            rawName: "v-b-toggle.sidebar-admin",
            modifiers: { "sidebar-admin": true }
          }
        ],
        staticClass: "three-dots-admin show-navbar-mobile",
        attrs: { scale: "1.5" }
      }),
      _vm._v(" "),
      _c(
        "b-sidebar",
        {
          attrs: { id: "sidebar-admin", "no-header": "", shadow: "" },
          model: {
            value: _vm.showSideBarAdmin,
            callback: function($$v) {
              _vm.showSideBarAdmin = $$v
            },
            expression: "showSideBarAdmin"
          }
        },
        [
          _c(
            "nav",
            { staticClass: "mb-3" },
            [
              _c(
                "b-nav",
                { attrs: { vertical: "" } },
                [
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "perfil" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("perfil")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myProfile")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "favoritos" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("favoritos")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("saveds")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "notificaciones" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("notificaciones")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myNotifications")))]
                  ),
                  _vm._v(" "),
                  _vm.$store.getters["forum/forumUserIsAdminRole"]
                    ? _c(
                        "b-nav-item",
                        {
                          staticStyle: { "margin-right": "0px" },
                          attrs: { active: _vm.section === "validaciones" },
                          on: {
                            click: function($event) {
                              return _vm.showSection("validaciones")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("validations")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-button",
            {
              on: {
                click: function($event) {
                  _vm.showSideBarAdmin = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-column column-content" }, [
        _c("h1", { staticStyle: { "margin-bottom": "2%" } }, [
          _vm._v(_vm._s(_vm.sectionTitle))
        ]),
        _vm._v(" "),
        _vm.section === "perfil"
          ? _c(
              "div",
              [
                _vm._l(_vm.sectionInputs[_vm.section], function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      _c("base-input", {
                        staticClass: "centerInput",
                        attrs: {
                          width50: "",
                          id: item.id,
                          tooltip: item.tooltip,
                          readonly: item.readonly,
                          label: item.label,
                          placeholder: item.placeholder,
                          type: item.type
                        },
                        on: {
                          keyup: function($event) {
                            _vm.showSaveBtn = true
                          }
                        },
                        model: {
                          value: item.value,
                          callback: function($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value"
                        }
                      })
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.showSaveBtn
                  ? _c(
                      "base-button",
                      {
                        staticClass: "btn-control",
                        on: { click: _vm.sendData }
                      },
                      [_vm._v(_vm._s(_vm.$t("save")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "notificaciones"
          ? _c(
              "div",
              [
                _vm._l(_vm.sectionInputs[_vm.section], function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      !item.customName
                        ? _c(
                            "b-form-checkbox",
                            {
                              attrs: { switch: "" },
                              on: {
                                change: function($event) {
                                  return _vm.notificationsSwitch(item.fn)
                                }
                              },
                              model: {
                                value: item.value,
                                callback: function($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "label-align",
                                domProps: { innerHTML: _vm._s(item.label) }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.id.includes("receiveEmails") && item.value
                        ? _c("v-select", {
                            staticClass: "notificationsSelector",
                            attrs: {
                              placeholder: _vm.$t("panelEmailInterval"),
                              options: _vm.emailsDaysIntervalSource,
                              label: "name",
                              reduce: function(x) {
                                return x.days
                              }
                            },
                            on: {
                              "option:selected": function($event) {
                                _vm.showSaveBtn = true
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("panelEmailInterval")) +
                                          "\n          "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.emailsDaysInterval,
                              callback: function($$v) {
                                _vm.emailsDaysInterval = $$v
                              },
                              expression: "emailsDaysInterval"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.id.includes("categories") &&
                      _vm.showCategoriesSelector
                        ? _c("v-select", {
                            staticClass: "notificationsSelector",
                            attrs: {
                              multiple: "",
                              placeholder: _vm.$t("panelEntryCategory"),
                              options: _vm.categoriesSource,
                              filtered: "",
                              searchable: "",
                              label: "name",
                              reduce: function(x) {
                                return x.id
                              }
                            },
                            on: {
                              "option:selected": function($event) {
                                _vm.showSaveBtn = true
                              },
                              search: _vm.getCategories
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("panelEntryCategory")) +
                                          "\n          "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.categories,
                              callback: function($$v) {
                                _vm.categories = $$v
                              },
                              expression: "categories"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.id.includes("tags") && _vm.showTagsSelector
                        ? _c("v-select", {
                            staticClass: "notificationsSelector",
                            attrs: {
                              multiple: "",
                              placeholder: _vm.$t("panelEntryTags"),
                              options: _vm.tagsSource,
                              filtered: "",
                              searchable: "",
                              label: "name",
                              reduce: function(x) {
                                return x.id
                              }
                            },
                            on: {
                              "option:selected": function($event) {
                                _vm.showSaveBtn = true
                              },
                              search: _vm.getTags
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("panelEntryTags")) +
                                          "\n          "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.tags,
                              callback: function($$v) {
                                _vm.tags = $$v
                              },
                              expression: "tags"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.showSaveBtn
                  ? _c(
                      "base-button",
                      {
                        staticClass: "btn-control",
                        on: { click: _vm.sendData }
                      },
                      [_vm._v(_vm._s(_vm.$t("save")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "favoritos"
          ? _c(
              "div",
              [
                _c(
                  "b-nav",
                  {
                    staticClass: "centerInput",
                    staticStyle: { "margin-bottom": "2%" }
                  },
                  [
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.favouritesSectionSelected === "entries"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showFavouritesSection("entries")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "black" }, [
                          _vm._v(_vm._s(_vm.$t("entries")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.favouritesSectionSelected === "messages"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showFavouritesSection("messages")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "black" }, [
                          _vm._v(_vm._s(_vm.$t("messages")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.favouritesSectionSelected === "entries"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.articleData &&
                        _vm.$store.state.forum.articleData.length > 0
                          ? _c("forum-article-block", {
                              attrs: { hideFooter: "" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noEntriesSaved
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("noEntriesSaved")))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.favouritesSectionSelected === "messages"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.messages
                          ? _c("forum-message-block", {
                              attrs: { hideOptions: "" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noMessagesSaved
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("noMessagesSaved")))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn-panel btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "validaciones"
          ? _c(
              "div",
              [
                _c(
                  "b-nav",
                  {
                    staticClass: "centerInput",
                    staticStyle: { "margin-bottom": "2%" }
                  },
                  [
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.validationsSectionSelected === "messages"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showValidationsSection("messages")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("messages")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.validationsSectionSelected === "entries"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showValidationsSection("entries")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("entries")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.validationsSectionSelected === "messages"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.messages
                          ? _c("forum-message-block", {
                              attrs: {
                                hideOptions: "",
                                showValidateMessage: ""
                              },
                              on: {
                                updateValidatedMessages:
                                  _vm.loadValidationsMessages
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noMessagesPendingValidation
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("noMessagesPendingValidation"))
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.validationsSectionSelected === "entries"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.articleData &&
                        _vm.$store.state.forum.articleData.length > 0
                          ? _c("forum-article-block", {
                              attrs: {
                                hideFooter: "",
                                disableClick: "",
                                showValidateEntry: ""
                              },
                              on: {
                                updateValidatedEntries:
                                  _vm.loadValidationsEntries
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noEntriesPendingValidation
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("noEntriesPendingValidation"))
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn-panel btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "reportes"
          ? _c(
              "div",
              [
                _c(
                  "div",
                  [
                    _vm.$store.state.forum.messages
                      ? _c("forum-message-block", {
                          attrs: { hideOptions: "", showReportMessage: "" },
                          on: {
                            updateReportedMessages: _vm.loadReportedMessages
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.noMessagesReported
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("noMessagesReported")))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn-panel btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad40e27a", esExports)
  }
}

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_layouts__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_routeHelpers__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_i18n_helpers__ = __webpack_require__(156);







function scrollTop(to, from, next) {
	window.scrollTo(0, 0);
	next();
}

var routes = [{
	path: ':surveyId',
	name: 'do-survey',
	component: function component() {
		return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 2331));
	},
	meta: {
		title: {
			text: function text() {
				return '' + (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.survey.currentSurvey ? '' + Object(__WEBPACK_IMPORTED_MODULE_5__helpers_i18n_helpers__["d" /* normalize */])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.survey.currentSurvey) : '' + __WEBPACK_IMPORTED_MODULE_0__plugins_i18n__["a" /* default */].t('survey'));
			}
		},
		i18n: 'public/views/survey'
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__router_routeHelpers__["a" /* default */].completeRoutesMeta(routes, [__WEBPACK_IMPORTED_MODULE_2__constants_roles__["f" /* PATIENT_ROLE */], __WEBPACK_IMPORTED_MODULE_2__constants_roles__["h" /* PROFESSIONAL_ROLE */], __WEBPACK_IMPORTED_MODULE_2__constants_roles__["e" /* CENTER_ROLE */]], __WEBPACK_IMPORTED_MODULE_1__constants_layouts__["h" /* PRIVATE_LAYOUT */]));

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1736);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("daf1de78", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fbf8a0d0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./VideoLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fbf8a0d0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./VideoLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports
exports.push([module.i, "@import url(/static-appopensalud/css/general.css);", ""]);
exports.push([module.i, "@import url(/static-appopensalud/css/navbar.css);", ""]);

// module
exports.push([module.i, "\n.fade-enter-active, .fade-leave-active {\r\n  -webkit-transition: opacity .5s;\r\n  transition: opacity .5s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\r\n  opacity: 0;\n}\n.dropdown-item img {\r\n  margin-right:10px;\n}\r\n", ""]);

// exports


/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "base-alert",
        {
          attrs: { variant: _vm.$store.state.video.alert.variant },
          model: {
            value: _vm.$store.state.video.alert.visible,
            callback: function($$v) {
              _vm.$set(_vm.$store.state.video.alert, "visible", $$v)
            },
            expression: "$store.state.video.alert.visible"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$store.state.video.alert.text) + "\n  ")]
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbf8a0d0", esExports)
  }
}

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1739);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("44cc966a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b2b435e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b2b435e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\nhtml{font-size:14px !important\n}\n", ""]);

// exports


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("24ab8226", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3aa39410\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Footer.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3aa39410\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Footer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-3aa39410]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-3aa39410],.slide-down-leave-active[data-v-3aa39410]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-3aa39410],.slide-down-leave-to[data-v-3aa39410]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-3aa39410],.slide-fade-left-leave-active[data-v-3aa39410]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-3aa39410],.slide-fade-left-leave-to[data-v-3aa39410]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-3aa39410]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-3aa39410],.fade-leave-to[data-v-3aa39410]{opacity:0\n}\n.footer[data-v-3aa39410]{padding-top:5rem\n}\n@media only screen and (max-width: 575px){\n.footer[data-v-3aa39410]{padding-top:3rem\n}\n}\n", ""]);

// exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./": [
		91
	],
	"./Footer": [
		449
	],
	"./Footer.vue": [
		449
	],
	"./Footer360": [
		1259,
		23
	],
	"./Footer360.vue": [
		1259,
		23
	],
	"./FooterAbogalityPro": [
		1290,
		22
	],
	"./FooterAbogalityPro.vue": [
		1290,
		22
	],
	"./FooterOpenlegal": [
		1291,
		21
	],
	"./FooterOpenlegal.vue": [
		1291,
		21
	],
	"./FooterOpenlegal360": [
		1292,
		20
	],
	"./FooterOpenlegal360.vue": [
		1292,
		20
	],
	"./FooterOpenlegalHome": [
		1293,
		19
	],
	"./FooterOpenlegalHome.vue": [
		1293,
		19
	],
	"./FooterOpensalud": [
		1249,
		18
	],
	"./FooterOpensalud.vue": [
		1249,
		18
	],
	"./FooterPrimesalud": [
		1294,
		17
	],
	"./FooterPrimesalud.vue": [
		1294,
		17
	],
	"./FooterUnipromel": [
		1295,
		16
	],
	"./FooterUnipromel.vue": [
		1295,
		16
	],
	"./index": [
		91
	],
	"./index.js": [
		91
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1742;
module.exports = webpackAsyncContext;

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.footerComponent
    ? _c(_vm.footerComponent, { tag: "component", staticClass: "footer" })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aa39410", esExports)
  }
}

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookiesBanner_vue__ = __webpack_require__(1114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4553d9e1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookiesBanner_vue__ = __webpack_require__(1747);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1745)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4553d9e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookiesBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4553d9e1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookiesBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/CookiesBanner.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4553d9e1", Component.options)
  } else {
    hotAPI.reload("data-v-4553d9e1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1746);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("67279cec", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4553d9e1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CookiesBanner.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4553d9e1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CookiesBanner.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-4553d9e1]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-4553d9e1],.slide-down-leave-active[data-v-4553d9e1]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-4553d9e1],.slide-down-leave-to[data-v-4553d9e1]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-4553d9e1],.slide-fade-left-leave-active[data-v-4553d9e1]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-4553d9e1],.slide-fade-left-leave-to[data-v-4553d9e1]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-4553d9e1]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-4553d9e1],.fade-leave-to[data-v-4553d9e1]{opacity:0\n}\n.cookies-banner[data-v-4553d9e1]{position:fixed;bottom:2rem;left:0;right:0;background-color:#f5f5f5;padding:10px;text-align:center;font-size:12px;font-weight:bold;color:#333;z-index:9999;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);margin:auto;width:80vw;padding-top:2rem;padding-bottom:2rem;border-radius:23px\n}\n.private-image--responsive[data-v-4553d9e1]{display:block;height:2px !important\n}\n[data-v-4553d9e1] table{border-collapse:collapse;width:100%\n}\n[data-v-4553d9e1] th,[data-v-4553d9e1] td{text-align:left;padding:8px\n}\n[data-v-4553d9e1] tr:nth-child(even){background-color:#f2f2f2\n}\n[data-v-4553d9e1] th{background-color:#3238C4;color:white\n}\n", ""]);

// exports


/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.cookiesBannerVisible && !_vm.modalVisible
        ? _c("div", { staticClass: "cookies-banner" }, [
            !_vm.modalVisible
              ? _c("span", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-banner.banner-text"))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "text-decoration": "underline"
                      },
                      on: {
                        click: function() {
                          _vm.modalVisible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cookies-banner.cookies-policy")))]
                  ),
                  _vm._v(".\n      "),
                  _c(
                    "div",
                    { staticClass: "d-block" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "d-inline-block mx-auto mt-3 mr-4",
                          on: { click: _vm.acceptCookies }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("cookies-banner.got-it")) +
                                "\n          "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          staticClass: "d-inline-block mx-auto mt-3",
                          on: { click: _vm.acceptMinimumCookies }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("cookies-banner.only-necessary")) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modalVisible
        ? _c(
            "base-modal",
            {
              ref: "cookies-modal",
              attrs: {
                title: _vm.$t("cookies-banner.cookies-policy"),
                hideClose: ""
              },
              model: {
                value: _vm.modalVisible,
                callback: function($$v) {
                  _vm.modalVisible = $$v
                },
                expression: "modalVisible"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "20px", "text-align": "left" } },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-modal.cookies-4txt"))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-modal.cookies-5txt"))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-modal.cookies-5table"))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cookies-modal.cookies-5clarify")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cookies-modal.goToCookiesPolicy")
                      )
                    }
                  }),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "mt-3",
                      on: {
                        click: function() {
                          return (_vm.modalVisible = false)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("cookies-banner.accept-btn")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4553d9e1", esExports)
  }
}

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CookiesBanner", { class: [_vm.themeClass] }),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$store.state.sharedDialog.content,
          okFn: _vm.$store.state.sharedDialog.okFn,
          okBtnText: _vm.$store.state.sharedDialog.okBtnText,
          size: _vm.$store.state.sharedDialog.size
        },
        model: {
          value: _vm.sharedDialogVisible,
          callback: function($$v) {
            _vm.sharedDialogVisible = $$v
          },
          expression: "sharedDialogVisible"
        }
      }),
      _vm._v(" "),
      _c(_vm.layoutType, {
        tag: "component",
        class: [_vm.themeClass, { "forum-class": _vm.$route.meta.forumClass }]
      }),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b2b435e", esExports)
  }
}

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_domains_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_domains_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_domains_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_i18n__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sessionStorage_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__ = __webpack_require__(1750);









var HEADERS = {
  AUTHORIZATION: 'Authorization'
};

function interceptRequest(config, store, Vue) {
  store.commit('setLoading', config.loading !== false);
  config.headers = buildCommonHeaders(Vue, config.headers);
  return config;
}

function interceptResponse(response, store) {
  store.commit('setLoading', false);
  return response;
}

function interceptError(error, store) {
  store.commit('setLoading', false);
  // Get request URL from error
  var errorMessage = void 0;
  if (error && error.request) {
    var requestUrl = error.request.responseURL;
    var serverErrorMessage = error.response && error.response.data ? error.response.data.errorMessage : error.message;
    errorMessage = 'Request \'' + requestUrl + '\': ' + (serverErrorMessage || null);
  } else {
    errorMessage = error.message;
  }

  console.error(errorMessage);
  // Add serverErrorMessage to error object
  error.customErrorMessage = errorMessage;
  if (error.config && error.config.headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].DEFAULT_INTERCEPT_ERROR] == true) {
    store.dispatch('showDangerAlert', errorMessage);
    throw error;
  }
  return error;
}

function buildCommonHeaders(Vue) {
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].REFERER_WEBAPP]) {
    headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].REFERER_WEBAPP] = window.location.href;
  }
  if (!headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].TIMEZONE]) {
    headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].TIMEZONE] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  if (!headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].LANG]) {
    headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].LANG] = __WEBPACK_IMPORTED_MODULE_3__plugins_i18n__["c" /* i18nLocale */];
  }
  var returnUrl = __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].currentRoute.query.returnUrl || __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].currentRoute.query.ReturnUrl;
  if (!headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].RETURN_URL] && returnUrl) {
    var encodedReturnUrl = encodeURIComponent('' + returnUrl + (__WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].currentRoute.hash || ''));
    headers[__WEBPACK_IMPORTED_MODULE_7__constants_customHeaders_js__["a" /* default */].RETURN_URL] = encodedReturnUrl;
  }
  if (Vue.prototype.$apiToken && !headers[HEADERS.AUTHORIZATION] || sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants_sessionStorage_js__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */])) {
    headers[HEADERS.AUTHORIZATION] = 'Bearer ' + (sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants_sessionStorage_js__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */]) || Vue.prototype.$apiToken);
  }
  return headers;
}

function createApiInstance(apiName, Vue) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["k" /* inLocalEnv */] ? __WEBPACK_IMPORTED_MODULE_2__static_domains_json___default.a.apis[apiName].local : __WEBPACK_IMPORTED_MODULE_2__static_domains_json___default.a.apis[apiName][__WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["a" /* country */]][__WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["b" /* environment */]],
    headers: buildCommonHeaders(Vue),
    paramsSerializer: { indexes: null }
  });
}

function createApiGwInstance(apiName, Vue) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["k" /* inLocalEnv */] ? __WEBPACK_IMPORTED_MODULE_2__static_domains_json___default.a.apiGw.local : __WEBPACK_IMPORTED_MODULE_2__static_domains_json___default.a.apiGw[__WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["a" /* country */]][__WEBPACK_IMPORTED_MODULE_6__helpers_global_helpers__["b" /* environment */]] + '/' + apiName,
    headers: buildCommonHeaders(Vue),
    paramsSerializer: { indexes: null }
  });
}

function processApiInstance(apiInstance, apiName, store, Vue) {
  apiInstance.interceptors.request.use(function (config) {
    return interceptRequest(config, store, Vue);
  }, function (error) {
    return interceptError(error, store);
  });
  apiInstance.interceptors.response.use(function (response) {
    return interceptResponse(response, store);
  }, function (error) {
    return interceptError(error, store);
  });
  // Vue prototype name for global access is '(apiName in domains.json)+Api', except for global API, which is 'api'
  Vue.prototype['$' + apiName + (apiName !== 'api' ? 'Api' : '')] = apiInstance;
}

function createFromDomainsFile(Vue, store) {
  for (var apiName in __WEBPACK_IMPORTED_MODULE_2__static_domains_json___default.a.apis) {
    var apiInstance = createApiInstance(apiName, Vue);
    processApiInstance(apiInstance, apiName, store, Vue);
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2__static_domains_json___default.a.apiGw.apis), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var apiGwName = _step.value;

      var apiGwInstance = createApiGwInstance(apiGwName, Vue);
      processApiInstance(apiGwInstance, apiGwName, store, Vue);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, _ref) {
    var store = _ref.store;

    createFromDomainsFile(Vue, store);
  }
});

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REFERER_WEBAPP */
/* unused harmony export TIMEZONE */
/* unused harmony export LANG */
/* unused harmony export RETURN_URL */
/* unused harmony export DEFAULT_INTERCEPT_ERROR */
var REFERER_WEBAPP = 'ohc_Referer-Webapp';
var TIMEZONE = 'ohc_TZ';
var LANG = 'ohc_Lang';
var RETURN_URL = 'ohc_Return-Url';
var DEFAULT_INTERCEPT_ERROR = 'ohc_Default-Intercept-Error';

/* harmony default export */ __webpack_exports__["a"] = ({
	REFERER_WEBAPP: REFERER_WEBAPP,
	TIMEZONE: TIMEZONE,
	LANG: LANG,
	RETURN_URL: RETURN_URL,
	DEFAULT_INTERCEPT_ERROR: DEFAULT_INTERCEPT_ERROR
});

/***/ }),
/* 1751 */,
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/**
 * Vue Cookies v1.6.1
 * https://github.com/cmp-cc/vue-cookies
 *
 * Copyright 2016, cmp-cc
 * Released under the MIT license
 */

/* eslint-disable */

(function () {

    var defaultConfig = {
        expires: '1d',
        path: '; path=/',
        domain: '',
        secure: ''
    };

    var VueCookies = {
        // install of Vue
        install: function install(Vue) {
            Vue.prototype.$cookies = this;
            Vue.$cookies = this;
        },
        config: function config(expireTimes, path, domain, secure) {
            defaultConfig.expires = expireTimes ? expireTimes : '1d';
            defaultConfig.path = path ? '; path=' + path : '; path=/';
            defaultConfig.domain = domain ? '; domain=' + domain : '';
            defaultConfig.secure = secure ? '; secure' : '';
        },
        get: function get(key) {
            var value = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;

            if (value && value.substr(0, 1) === "{" && value.substr(-1) === "}") {
                try {
                    value = JSON.parse(value);
                } catch (e) {
                    return value;
                }
            }
            return value;
        },
        set: function set(key, value, expireTimes, path, domain, secure) {
            if (!key) {
                throw new Error("cookie name is not find in first argument");
            } else if (/^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
                throw new Error("cookie key name illegality ,Cannot be set to ['expires','max-age','path','domain','secure']\t", "current key name: " + key);
            }
            // support json object
            if (value && value.constructor === Object) {
                value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value);
            }
            var _expires = "";
            expireTimes = expireTimes === undefined ? defaultConfig.expires : expireTimes;
            if (expireTimes && expireTimes != 0) {
                switch (expireTimes.constructor) {
                    case Number:
                        if (expireTimes === Infinity || expireTimes === -1) _expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";else _expires = "; max-age=" + expireTimes;
                        break;
                    case String:
                        if (/^(?:\d{1,}(y|m|d|h|min|s))$/i.test(expireTimes)) {
                            // get capture number group
                            var _expireTime = expireTimes.replace(/^(\d{1,})(?:y|m|d|h|min|s)$/i, "$1");
                            // get capture type group , to lower case
                            switch (expireTimes.replace(/^(?:\d{1,})(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                                // Frequency sorting
                                case 'm':
                                    _expires = "; max-age=" + +_expireTime * 2592000;break; // 60 * 60 * 24 * 30
                                case 'd':
                                    _expires = "; max-age=" + +_expireTime * 86400;break; // 60 * 60 * 24
                                case 'h':
                                    _expires = "; max-age=" + +_expireTime * 3600;break; // 60 * 60
                                case 'min':
                                    _expires = "; max-age=" + +_expireTime * 60;break; // 60
                                case 's':
                                    _expires = "; max-age=" + _expireTime;break;
                                case 'y':
                                    _expires = "; max-age=" + +_expireTime * 31104000;break; // 60 * 60 * 24 * 30 * 12
                                default:
                                    new Error("unknown exception of 'set operation'");
                            }
                        } else {
                            _expires = "; expires=" + expireTimes;
                        }
                        break;
                    case Date:
                        _expires = "; expires=" + expireTimes.toUTCString();
                        break;
                }
            }
            document.cookie = encodeURIComponent(key) + "=" + value + _expires + (domain ? "; domain=" + domain : defaultConfig.domain) + (path ? "; path=" + path : defaultConfig.path) + (secure === undefined ? defaultConfig.secure : secure ? "; secure" : "");
            return this;
        },
        remove: function remove(key, path, domain) {
            if (!key || !this.isKey(key)) {
                return false;
            }
            document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : defaultConfig.domain) + (path ? "; path=" + path : defaultConfig.path);
            return this;
        },
        isKey: function isKey(key) {
            return new RegExp("(?:^|;\\s*)" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
        },
        keys: function keys() {
            if (!document.cookie) return [];
            var _keys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
            for (var _index = 0; _index < _keys.length; _index++) {
                _keys[_index] = decodeURIComponent(_keys[_index]);
            }
            return _keys;
        }
    };

    if ((typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(exports)) == "object") {
        module.exports = VueCookies;
    } else if (typeof define == "function" && __webpack_require__(1753)) {
        define([], function () {
            return VueCookies;
        });
    } else if (window.Vue) {
        Vue.use(VueCookies);
    }
    // vue-cookies can exist independently,no dependencies library
    if (typeof window !== "undefined") {
        window.$cookies = VueCookies;
    }
})();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(126)(module)))

/***/ }),
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validate */
/* unused harmony export validateUrl */
/* unused harmony export validateNIF */
/* unused harmony export validNIE */
/* unused harmony export validatePersonalId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_db_companyCodeTypes__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_db_countries__ = __webpack_require__(283);




var availableConstraints = {
		required: function required(val) {
				return !!val;
		},
		email: function email(val) {
				var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(val);
		},
		password: function password(val) {
				var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬])[A-Za-z\d@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬]{8,}$/;
				return re.test(val);
		},
		phone: function phone(val) {
				var re = /^\d+$/;
				return re.test(val);
		},
		text: function text(val) {
				return (/^[ñA-Za-zÀ-ÿ]+$/.test(val)
				);
		},
		textWithWhiteScape: function textWithWhiteScape(val) {
				return (/^[ñA-Za-zÀ-ÿ ]*[ñA-Za-zÀ-ÿ][ñA-Za-zÀ-ÿ ]*$/.test(val)
				);
		},
		question: function question(val) {
				return (/^¿?[ñA-Za-zÀ-ÿ ]*[ñA-Za-zÀ-ÿ][ñA-Za-zÀ-ÿ ]*\??$/.test(val)
				);
		},
		number: function number(val) {
				return (/^(\d+(?:[\.\,]\d+)?)$/.test(val)
				);
		},
		validTime: function validTime(val) {
				return (/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(val)
				);
		}
};

function validate(val, constraints) {
		var submitted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

		var result = null;
		if (submitted) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(constraints), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var c = _step.value;

								if (!availableConstraints[c](val)) {
										result = false;
										break;
								}
						}
				} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
				} finally {
						try {
								if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
								}
						} finally {
								if (_didIteratorError) {
										throw _iteratorError;
								}
						}
				}
		} else {
				return null;
		}
		return result;
}

function validateUrl(val) {
		return (/(https?:\/\/)?([\w\-])+\.{1}([a-zA-Z]{2,63})([\/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/.test(val)
		);
}

function validateNIF(dni) {
		if (dni == null) {
				return false;
		}
		var numero, let2, letra;
		var expresionRegularDni = /^[XYZ]?\d{5,8}[A-Z]$/;

		dni = dni.toUpperCase();

		if (expresionRegularDni.test(dni) === true) {
				numero = dni.substr(0, dni.length - 1);
				numero = numero.replace('X', 0);
				numero = numero.replace('Y', 1);
				numero = numero.replace('Z', 2);
				let2 = dni.substr(dni.length - 1, 1);
				numero = numero % 23;
				letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
				letra = letra.substring(numero, numero + 1);
				if (letra !== let2) {
						return false;
				} else {
						return true;
				}
		} else {
				return false;
		}
}

function validNIE(nie) {
		// Change the initial letter for the corresponding number and validate as DNI
		var niePrefix = nie.charAt(0);
		switch (niePrefix) {
				case 'X':
						niePrefix = 0;break;
				case 'Y':
						niePrefix = 1;break;
				case 'Z':
						niePrefix = 2;break;
		}
		return this.validateNIF(niePrefix + nie.substr(1));
}

function validatePersonalId(id, countryId) {
		var codeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return !(countryId === __WEBPACK_IMPORTED_MODULE_2__constants_db_countries__["b" /* SPAIN_COUNTRY_ID */] || countryId === null) || id != null && this.validateNIF(id) || codeType === __WEBPACK_IMPORTED_MODULE_1__constants_db_companyCodeTypes__["a" /* EDUCATIVE_CENTER_CODE_TYPE */];
}

/* harmony default export */ __webpack_exports__["a"] = ({
		validate: validate,
		validateUrl: validateUrl,
		validateNIF: validateNIF,
		validNIE: validNIE,
		validatePersonalId: validatePersonalId
});

/***/ }),
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_buttons_BaseButton__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_icons_BaseIcon__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_ui_BaseCard__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseInput__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_forms_BaseSpinInput__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_forms_BaseCheckbox__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseRadioGroup__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_base_forms_BaseTextarea__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_base_buttons_IconButton__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue__ = __webpack_require__(17);












/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('base-button', __WEBPACK_IMPORTED_MODULE_0__components_base_buttons_BaseButton__["default"]);
    Vue.component('base-icon', __WEBPACK_IMPORTED_MODULE_1__components_base_icons_BaseIcon__["a" /* default */]);
    Vue.component('base-select', __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"]);
    Vue.component('base-card', __WEBPACK_IMPORTED_MODULE_3__components_base_ui_BaseCard__["default"]);
    Vue.component('base-input', __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseInput__["default"]);
    Vue.component('base-spin-input', __WEBPACK_IMPORTED_MODULE_5__components_base_forms_BaseSpinInput__["default"]);
    Vue.component('base-checkbox', __WEBPACK_IMPORTED_MODULE_6__components_base_forms_BaseCheckbox__["default"]);
    Vue.component('base-radio-group', __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseRadioGroup__["default"]);
    Vue.component('base-textarea', __WEBPACK_IMPORTED_MODULE_8__components_base_forms_BaseTextarea__["default"]);
    Vue.component('b-row', __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue__["_45" /* BRow */]);
    Vue.component('b-col', __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue__["i" /* BCol */]);
    Vue.component('b-container', __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue__["k" /* BContainer */]);
    Vue.component('icon-button', __WEBPACK_IMPORTED_MODULE_9__components_base_buttons_IconButton__["a" /* default */]);
  }
});

/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconButton_vue__ = __webpack_require__(1130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df269d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconButton_vue__ = __webpack_require__(1843);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1841)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3df269d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df269d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/IconButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3df269d2", Component.options)
  } else {
    hotAPI.reload("data-v-3df269d2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1842);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("6fef6cbe", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3df269d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./IconButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3df269d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./IconButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-3df269d2]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-3df269d2],.slide-down-leave-active[data-v-3df269d2]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-3df269d2],.slide-down-leave-to[data-v-3df269d2]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-3df269d2],.slide-fade-left-leave-active[data-v-3df269d2]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-3df269d2],.slide-fade-left-leave-to[data-v-3df269d2]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-3df269d2]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-3df269d2],.fade-leave-to[data-v-3df269d2]{opacity:0\n}\n.btn-icon[data-v-3df269d2]{vertical-align:text-bottom;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:12px\n}\n.reduced-padding-btn[data-v-3df269d2]{padding:0.5rem 1rem\n}\n", ""]);

// exports


/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-button",
    _vm._b(
      {
        class: { "reduced-padding-btn": _vm.$uiHelpers.isMobileOrTablet },
        attrs: { outline: "" },
        on: {
          click: function($event) {
            _vm.action ? _vm.action() : null
          }
        },
        nativeOn: {
          mouseover: function($event) {
            _vm.hover = true
          },
          mouseleave: function($event) {
            _vm.hover = false
          }
        }
      },
      "base-button",
      _vm.$attrs,
      false
    ),
    [
      _vm.reverse
        ? _c("span", { staticClass: "mr-2" }, [_vm._v(_vm._s(_vm.text))])
        : _vm._e(),
      _c("base-icon", {
        staticClass: "btn-icon",
        attrs: { color: _vm.$attrs.textColor, src: _vm.icon }
      }),
      !_vm.reverse && _vm.text
        ? _c("span", { staticClass: "ml-2" }, [_vm._v(_vm._s(_vm.text))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3df269d2", esExports)
  }
}

/***/ }),
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Launcher = __webpack_require__(1853);

var _Launcher2 = _interopRequireDefault(_Launcher);

var _vTooltip = __webpack_require__(1956);

var _vTooltip2 = _interopRequireDefault(_vTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultComponentName = 'beautiful-chat';

var Plugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.installed) {
      return;
    }

    this.installed = true;
    this.event = new Vue();
    this.dynamicContainer = null;
    this.componentName = options.componentName || defaultComponentName;

    Vue.prototype.$chat = {
      _setDynamicContainer: function _setDynamicContainer(dynamicContainer) {
        Plugin.dynamicContainer = dynamicContainer;
      }
    };

    Vue.component(this.componentName, _Launcher2.default);
    Vue.use(_vTooltip2.default);
  }
};

exports.default = Plugin;

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Launcher_vue__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Launcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Launcher_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Launcher_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Launcher_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ad5b02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Launcher_vue__ = __webpack_require__(1955);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1854)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64ad5b02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Launcher_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ad5b02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Launcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/Launcher.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-64ad5b02", Component.options)
  } else {
    hotAPI.reload("data-v-64ad5b02", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1855);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2b08e73e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64ad5b02\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Launcher.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64ad5b02\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Launcher.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-launcher[data-v-64ad5b02] {\r\n  width: 60px;\r\n  height: 60px;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  position: fixed;\r\n  right: 25px;\r\n  bottom: 25px;\r\n  border-radius: 50%;\r\n  -webkit-box-shadow: none;\r\n          box-shadow: none;\r\n  -webkit-transition: -webkit-box-shadow 0.2s ease-in-out;\r\n  transition: -webkit-box-shadow 0.2s ease-in-out;\r\n  transition: box-shadow 0.2s ease-in-out;\r\n  transition: box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;\r\n  cursor: pointer;\n}\n.sc-launcher[data-v-64ad5b02]:before {\r\n  content: '';\r\n  position: relative;\r\n  display: block;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  -webkit-transition: -webkit-box-shadow 0.2s ease-in-out;\r\n  transition: -webkit-box-shadow 0.2s ease-in-out;\r\n  transition: box-shadow 0.2s ease-in-out;\r\n  transition: box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;\n}\n.sc-launcher .sc-open-icon[data-v-64ad5b02],\r\n.sc-launcher .sc-closed-icon[data-v-64ad5b02] {\r\n  width: 60px;\r\n  height: 60px;\r\n  position: fixed;\r\n  right: 25px;\r\n  bottom: 25px;\r\n  -webkit-transition: opacity 100ms ease-in-out, -webkit-transform 100ms ease-in-out;\r\n  transition: opacity 100ms ease-in-out, -webkit-transform 100ms ease-in-out;\r\n  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;\r\n  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out, -webkit-transform 100ms ease-in-out;\n}\n.sc-launcher .sc-closed-icon[data-v-64ad5b02] {\r\n  -webkit-transition: opacity 100ms ease-in-out, -webkit-transform 100ms ease-in-out;\r\n  transition: opacity 100ms ease-in-out, -webkit-transform 100ms ease-in-out;\r\n  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;\r\n  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out, -webkit-transform 100ms ease-in-out;\r\n  width: 60px;\r\n  height: 60px;\n}\n.sc-launcher .sc-open-icon[data-v-64ad5b02] {\r\n  padding: 20px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  opacity: 1;\n}\n.sc-launcher.opened .sc-open-icon[data-v-64ad5b02] {\r\n  -webkit-transform: rotate(-90deg);\r\n          transform: rotate(-90deg);\r\n  opacity: 1;\n}\n.sc-launcher.opened .sc-closed-icon[data-v-64ad5b02] {\r\n  -webkit-transform: rotate(-90deg);\r\n          transform: rotate(-90deg);\r\n  opacity: 1;\n}\n.sc-launcher.opened[data-v-64ad5b02]:before {\r\n  -webkit-box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);\r\n          box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);\n}\n.sc-launcher[data-v-64ad5b02]:hover {\r\n  -webkit-box-shadow: 0 0px 27px 1.5px rgba(0,0,0,0.2);\r\n          box-shadow: 0 0px 27px 1.5px rgba(0,0,0,0.2);\n}\n.sc-new-messsages-count[data-v-64ad5b02] {\r\n  position: absolute;\r\n  top: -3px;\r\n  left: 41px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  border-radius: 50%;\r\n\twidth: 22px;\r\n  height: 22px;\r\n  background: #ff4646;\r\n  color: white;\r\n  text-align: center;\r\n  margin: auto;\r\n  font-size: 12px;\r\n  font-weight: 500;\n}\r\n", ""]);

// exports


/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a3abaf2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatWindow_vue__ = __webpack_require__(1954);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1857)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a3abaf2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a3abaf2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/ChatWindow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a3abaf2", Component.options)
  } else {
    hotAPI.reload("data-v-5a3abaf2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1858);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0b4255ae", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a3abaf2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatWindow.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a3abaf2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatWindow.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-chat-window[data-v-5a3abaf2] {\r\n  width: 370px;\r\n  height: calc(100% - 120px);\r\n  max-height: 590px;\r\n  position: fixed;\r\n  right: 25px;\r\n  bottom: 100px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  -webkit-box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);\r\n          box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);\r\n  background: white;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n  border-radius: 10px;\r\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n  -webkit-animation: fadeIn-data-v-5a3abaf2;\r\n          animation: fadeIn-data-v-5a3abaf2;\r\n  -webkit-animation-duration: 0.3s;\r\n          animation-duration: 0.3s;\r\n  -webkit-animation-timing-function: ease-in-out;\r\n          animation-timing-function: ease-in-out;\n}\n.sc-chat-window.closed[data-v-5a3abaf2] {\r\n  opacity: 0;\r\n  display: none;\r\n  bottom: 90px;\n}\n@-webkit-keyframes fadeIn-data-v-5a3abaf2 {\n0% {\r\n    display: none;\r\n    opacity: 0;\n}\n100% {\r\n    display: -webkit-box;\r\n    display: flex;\r\n    opacity: 1;\n}\n}\n@keyframes fadeIn-data-v-5a3abaf2 {\n0% {\r\n    display: none;\r\n    opacity: 0;\n}\n100% {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    opacity: 1;\n}\n}\n.sc-message--me[data-v-5a3abaf2] {\r\n  text-align: right;\n}\n.sc-message--them[data-v-5a3abaf2] {\r\n  text-align: left;\n}\n@media (max-width: 450px) {\n.sc-chat-window[data-v-5a3abaf2] {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-height: 100%;\r\n    right: 0px;\r\n    bottom: 0px;\r\n    border-radius: 0px;\n}\n.sc-chat-window[data-v-5a3abaf2] {\r\n    -webkit-transition: 0.1s ease-in-out;\r\n    transition: 0.1s ease-in-out;\n}\n.sc-chat-window.closed[data-v-5a3abaf2] {\r\n    bottom: 0px;\n}\n}\r\n", ""]);

// exports


/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a2966a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1863);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1860)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a2966a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a2966a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/Header.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9a2966a8", Component.options)
  } else {
    hotAPI.reload("data-v-9a2966a8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1861);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("25ab20c8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9a2966a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9a2966a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-header[data-v-9a2966a8] {\r\n  min-height: 75px;\r\n  border-top-left-radius: 9px;\r\n  border-top-right-radius: 9px;\r\n  padding: 10px;\r\n  -webkit-box-shadow: 0 1px 4px rgba(0,0,0,.2);\r\n          box-shadow: 0 1px 4px rgba(0,0,0,.2);\r\n  position: relative;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\n}\n.sc-header--img[data-v-9a2966a8] {\r\n  border-radius: 50%;\r\n  -ms-flex-item-align: center;\r\n      align-self: center;\r\n  padding: 10px;\n}\n.sc-header--title[data-v-9a2966a8] {\r\n  -ms-flex-item-align: center;\r\n      align-self: center;\r\n  padding: 10px;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1;\r\n          flex: 1;\r\n  -webkit-user-select: none;\r\n     -moz-user-select: none;\r\n      -ms-user-select: none;\r\n          user-select: none;\r\n  font-size: 20px;\n}\n.sc-header--title.enabled[data-v-9a2966a8] {\r\n  cursor: pointer;\r\n  border-radius: 5px;\n}\n.sc-header--title.enabled[data-v-9a2966a8]:hover {\r\n  -webkit-box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);\r\n          box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);\n}\n.sc-header--close-button[data-v-9a2966a8] {\r\n  width: 40px;\r\n  -ms-flex-item-align: center;\r\n      align-self: center;\r\n  height: 40px;\r\n  margin-right: 10px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  margin-left: auto;\n}\n.sc-header--close-button[data-v-9a2966a8]:hover {\r\n  -webkit-box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);\r\n          box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);\n}\n.sc-header--close-button img[data-v-9a2966a8] {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 13px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\n}\n@media (max-width: 450px) {\n.sc-header[data-v-9a2966a8] {\r\n    border-radius: 0px;\n}\n}\r\n", ""]);

// exports


/***/ }),
/* 1862 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAMAAACxiD++AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUxpcf///////////////////////////////////////////////////////3EAnbYAAAAOdFJOUwADZ66SoQjEhnS7/gsNGQL7+wAAAKtJREFUKM+F01sOhCAQRNESFV/I/pc70Og0YJfyJbmHhBAbGGYHstw8IPV4EOGOmERYIhGpxyUAJxHSz/xlC+1FxE64qB1yj1ZID7oXsel+63ovnj2JXUXue+hvrcLugL+EdG+9XBG8X+Kl34J3YM1g/egvIvdx5EK691RIz78YEXdnQrst6m6JqemXmNo+D/WJNAyVePZWWL0WdlfB+l+UAQQReaAc65DB/wGsZgzLN0IQWAAAAABJRU5ErkJggg=="

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-header",
      style: { background: _vm.colors.header.bg, color: _vm.colors.header.text }
    },
    [
      _vm._t("default", function() {
        return [
          _vm.imageUrl
            ? _c("img", {
                staticClass: "sc-header--img",
                attrs: { src: _vm.imageUrl, alt: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableUserListToggle
            ? _c(
                "div",
                {
                  staticClass: "sc-header--title enabled",
                  on: { click: _vm.toggleUserList }
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              )
            : _c("div", { staticClass: "sc-header--title" }, [
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ])
        ]
      }),
      _vm._v(" "),
      _vm.showCloseButton
        ? _c(
            "div",
            {
              staticClass: "sc-header--close-button",
              on: { click: _vm.onClose }
            },
            [
              _c("img", {
                attrs: { src: _vm.icons.close.img, alt: _vm.icons.close.name }
              })
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a2966a8", esExports)
  }
}

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6f9094_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__ = __webpack_require__(1918);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1865)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f6f9094"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6f9094_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/MessageList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f6f9094", Component.options)
  } else {
    hotAPI.reload("data-v-4f6f9094", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1866);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0bfaafcc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f6f9094\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MessageList.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f6f9094\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MessageList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-message-list[data-v-4f6f9094] {\r\n  height: 80%;\r\n  overflow-y: auto;\r\n  background-size: 100%;\r\n  padding: 40px 0px;\n}\r\n", ""]);

// exports


/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_327f51f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__ = __webpack_require__(1917);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1868)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_327f51f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/Message.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-327f51f8", Component.options)
  } else {
    hotAPI.reload("data-v-327f51f8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1869);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0db06c36", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-327f51f8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Message.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-327f51f8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Message.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.sc-message{width:300px;margin:auto;padding-bottom:10px;display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left\n}\n.sc-message .sc-message--edited{opacity:0.7;word-wrap:normal;font-size:xx-small;text-align:left\n}\n.sc-message--content{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.sc-message--content.sent{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end\n}\n.sc-message--content.system{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.sc-message--content.sent .sc-message--avatar{display:none\n}\n.sc-message--avatar{background-repeat:no-repeat;background-size:100%;background-position:center;min-width:30px;min-height:30px;border-radius:50%;-ms-flex-item-align:center;align-self:center;margin-right:15px\n}\n.sc-message--meta{font-size:xx-small;margin-bottom:0px;margin-top:0px;color:white;text-align:right\n}\n@media (max-width: 450px){\n.sc-message{width:80%\n}\n}\n.sc-message--text{padding:5px 20px;border-radius:6px;font-weight:300;font-size:14px;line-height:1.4;position:relative;-webkit-font-smoothing:subpixel-antialiased\n}\n.sc-message--text .sc-message--text-body .sc-message--text-content{white-space:pre-wrap\n}\n.sc-message--text:hover .sc-message--toolbox{left:-20px;opacity:1\n}\n.sc-message--text .sc-message--toolbox{-webkit-transition:left 0.2s ease-out 0s;transition:left 0.2s ease-out 0s;white-space:normal;opacity:0;position:absolute;left:0px;width:25px;top:0\n}\n.sc-message--text .sc-message--toolbox button{background:none;border:none;padding:0px;margin:0px;outline:none;width:100%;text-align:center;cursor:pointer\n}\n.sc-message--text .sc-message--toolbox button:focus{outline:none\n}\n.sc-message--content.sent .sc-message--text{color:white;background-color:#4e8cff;max-width:calc(100% - 120px);word-wrap:break-word\n}\n.sc-message--text code{font-family:'Courier New', Courier, monospace !important\n}\n.sc-message--content.received .sc-message--text{color:#263238;background-color:#f4f7f9;margin-right:40px\n}\n.tooltip{display:block !important;z-index:10000\n}\n.tooltip .tooltip-inner{background:black;color:white;border-radius:16px;padding:5px 10px 4px\n}\n.tooltip .tooltip-arrow{width:0;height:0;border-style:solid;position:absolute;margin:5px;border-color:black;z-index:1\n}\n.tooltip[x-placement^=\"top\"]{margin-bottom:5px\n}\n.tooltip[x-placement^=\"top\"] .tooltip-arrow{border-width:5px 5px 0 5px;border-left-color:transparent !important;border-right-color:transparent !important;border-bottom-color:transparent !important;bottom:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0\n}\n.tooltip[x-placement^=\"bottom\"]{margin-top:5px\n}\n.tooltip[x-placement^=\"bottom\"] .tooltip-arrow{border-width:0 5px 5px 5px;border-left-color:transparent !important;border-right-color:transparent !important;border-top-color:transparent !important;top:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0\n}\n.tooltip[x-placement^=\"right\"]{margin-left:5px\n}\n.tooltip[x-placement^=\"right\"] .tooltip-arrow{border-width:5px 5px 5px 0;border-left-color:transparent !important;border-top-color:transparent !important;border-bottom-color:transparent !important;left:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0\n}\n.tooltip[x-placement^=\"left\"]{margin-right:5px\n}\n.tooltip[x-placement^=\"left\"] .tooltip-arrow{border-width:5px 0 5px 5px;border-top-color:transparent !important;border-right-color:transparent !important;border-bottom-color:transparent !important;right:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0\n}\n.tooltip[aria-hidden='true']{visibility:hidden;opacity:0;-webkit-transition:opacity .15s, visibility .15s;transition:opacity .15s, visibility .15s\n}\n.tooltip[aria-hidden='false']{visibility:visible;opacity:1;-webkit-transition:opacity .15s;transition:opacity .15s\n}\n.tooltip.info .tooltip-inner{background:rgba(0,68,153,0.9);color:white;padding:24px;border-radius:5px;-webkit-box-shadow:0 5px 30px rgba(0,0,0,0.1);box-shadow:0 5px 30px rgba(0,0,0,0.1)\n}\n.tooltip.info .tooltip-arrow{border-color:rgba(0,68,153,0.9)\n}\n.tooltip.popover .popover-inner{background:#f9f9f9;color:black;padding:24px;border-radius:5px;-webkit-box-shadow:0 5px 30px rgba(0,0,0,0.1);box-shadow:0 5px 30px rgba(0,0,0,0.1)\n}\n.tooltip.popover .popover-arrow{border-color:#f9f9f9\n}\n", ""]);

// exports


/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc05db14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextMessage_vue__ = __webpack_require__(1882);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1871)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc05db14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc05db14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/messages/TextMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bc05db14", Component.options)
  } else {
    hotAPI.reload("data-v-bc05db14", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("04725746", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bc05db14\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TextMessage.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bc05db14\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TextMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\na.chatLink[data-v-bc05db14] {\r\n  color: inherit !important;\n}\r\n", ""]);

// exports


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1874);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3bf6f7d3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f984718\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./IconBase.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f984718\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./IconBase.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\nsvg[data-v-5f984718] {\r\n  display: inline-block;\r\n  vertical-align: baseline;\r\n  margin-bottom: -2px; /* yes, I'm that particular about formatting */\n}\r\n", ""]);

// exports


/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 18 18",
        "aria-labelledby": _vm.iconName,
        role: "presentation"
      }
    },
    [
      _c("title", { attrs: { id: _vm.iconName, lang: "en" } }, [
        _vm._v(_vm._s(_vm.iconName))
      ]),
      _vm._v(" "),
      _c("g", { attrs: { fill: _vm.iconColor } }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f984718", esExports)
  }
}

/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a934dafc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconEdit_vue__ = __webpack_require__(1877);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a934dafc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/components/icons/IconEdit.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a934dafc", Component.options)
  } else {
    hotAPI.reload("data-v-a934dafc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M19.404,6.65l-5.998-5.996c-0.292-0.292-0.765-0.292-1.056,0l-2.22,2.22l-8.311,8.313l-0.003,0.001v0.003l-0.161,0.161c-0.114,0.112-0.187,0.258-0.21,0.417l-1.059,7.051c-0.035,0.233,0.044,0.47,0.21,0.639c0.143,0.14,0.333,0.219,0.528,0.219c0.038,0,0.073-0.003,0.111-0.009l7.054-1.055c0.158-0.025,0.306-0.098,0.417-0.211l8.478-8.476l2.22-2.22C19.695,7.414,19.695,6.941,19.404,6.65z M8.341,16.656l-0.989-0.99l7.258-7.258l0.989,0.99L8.341,16.656z M2.332,15.919l0.411-2.748l4.143,4.143l-2.748,0.41L2.332,15.919z M13.554,7.351L6.296,14.61l-0.849-0.848l7.259-7.258l0.423,0.424L13.554,7.351zM10.658,4.457l0.992,0.99l-7.259,7.258L3.4,11.715L10.658,4.457z M16.656,8.342l-1.517-1.517V6.823h-0.003l-0.951-0.951l-2.471-2.471l1.164-1.164l4.942,4.94L16.656,8.342z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a934dafc", esExports)
  }
}

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f31f0010", esExports)
  }
}

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var htmlEscape = function htmlEscape(string) {
	return string.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

var htmlUnescape = function htmlUnescape(htmlString) {
	return htmlString.replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&#0?39;/g, '\'').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
};

exports.htmlEscape = function (strings) {
	for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		values[_key - 1] = arguments[_key];
	}

	if (typeof strings === 'string') {
		return htmlEscape(strings);
	}

	var output = strings[0];
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = values.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref = _step.value;

			var _ref2 = _slicedToArray(_ref, 2);

			var index = _ref2[0];
			var value = _ref2[1];

			output = output + htmlEscape(String(value)) + strings[index + 1];
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return output;
};

exports.htmlUnescape = function (strings) {
	for (var _len2 = arguments.length, values = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		values[_key2 - 1] = arguments[_key2];
	}

	if (typeof strings === 'string') {
		return htmlUnescape(strings);
	}

	var output = strings[0];
	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;

	try {
		for (var _iterator2 = values.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
			var _ref3 = _step2.value;

			var _ref4 = _slicedToArray(_ref3, 2);

			var index = _ref4[0];
			var value = _ref4[1];

			output = output + htmlUnescape(String(value)) + strings[index + 1];
		}
	} catch (err) {
		_didIteratorError2 = true;
		_iteratorError2 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion2 && _iterator2.return) {
				_iterator2.return();
			}
		} finally {
			if (_didIteratorError2) {
				throw _iteratorError2;
			}
		}
	}

	return output;
};

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
		module.exports = factory();
	} else {
		root.Autolinker = factory();
	}
})(undefined, function () {
	var Autolinker = function Autolinker(cfg) {
		cfg = cfg || {};

		this.version = Autolinker.version;

		this.urls = this.normalizeUrlsCfg(cfg.urls);
		this.email = typeof cfg.email === 'boolean' ? cfg.email : true;
		this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : true;
		this.hashtag = cfg.hashtag || false;
		this.mention = cfg.mention || false;
		this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : true;
		this.stripPrefix = this.normalizeStripPrefixCfg(cfg.stripPrefix);
		this.stripTrailingSlash = typeof cfg.stripTrailingSlash === 'boolean' ? cfg.stripTrailingSlash : true;
		this.decodePercentEncoding = typeof cfg.decodePercentEncoding === 'boolean' ? cfg.decodePercentEncoding : true;

		var mention = this.mention;
		if (mention !== false && mention !== 'twitter' && mention !== 'instagram' && mention !== 'soundcloud') {
			throw new Error("invalid `mention` cfg - see docs");
		}

		var hashtag = this.hashtag;
		if (hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram') {
			throw new Error("invalid `hashtag` cfg - see docs");
		}

		this.truncate = this.normalizeTruncateCfg(cfg.truncate);
		this.className = cfg.className || '';
		this.replaceFn = cfg.replaceFn || null;
		this.context = cfg.context || this;

		this.htmlParser = null;
		this.matchers = null;
		this.tagBuilder = null;
	};

	Autolinker.link = function (textOrHtml, options) {
		var autolinker = new Autolinker(options);
		return autolinker.link(textOrHtml);
	};

	Autolinker.parse = function (textOrHtml, options) {
		var autolinker = new Autolinker(options);
		return autolinker.parse(textOrHtml);
	};

	Autolinker.version = '1.8.3';

	Autolinker.prototype = {
		constructor: Autolinker,
		normalizeUrlsCfg: function normalizeUrlsCfg(urls) {
			if (urls == null) urls = true;

			if (typeof urls === 'boolean') {
				return { schemeMatches: urls, wwwMatches: urls, tldMatches: urls };
			} else {
				return {
					schemeMatches: typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
					wwwMatches: typeof urls.wwwMatches === 'boolean' ? urls.wwwMatches : true,
					tldMatches: typeof urls.tldMatches === 'boolean' ? urls.tldMatches : true
				};
			}
		},

		normalizeStripPrefixCfg: function normalizeStripPrefixCfg(stripPrefix) {
			if (stripPrefix == null) stripPrefix = true;

			if (typeof stripPrefix === 'boolean') {
				return { scheme: stripPrefix, www: stripPrefix };
			} else {
				return {
					scheme: typeof stripPrefix.scheme === 'boolean' ? stripPrefix.scheme : true,
					www: typeof stripPrefix.www === 'boolean' ? stripPrefix.www : true
				};
			}
		},

		normalizeTruncateCfg: function normalizeTruncateCfg(truncate) {
			if (typeof truncate === 'number') {
				return { length: truncate, location: 'end' };
			} else {
				return Autolinker.Util.defaults(truncate || {}, {
					length: Number.POSITIVE_INFINITY,
					location: 'end'
				});
			}
		},

		parse: function parse(textOrHtml) {
			var htmlParser = this.getHtmlParser(),
			    htmlNodes = htmlParser.parse(textOrHtml),
			    anchorTagStackCount = 0,
			    matches = [];

			for (var i = 0, len = htmlNodes.length; i < len; i++) {
				var node = htmlNodes[i],
				    nodeType = node.getType();

				if (nodeType === 'element' && ['a', 'style', 'script'].indexOf(node.getTagName()) !== -1) {
					if (!node.isClosing()) {
						anchorTagStackCount++;
					} else {
						anchorTagStackCount = Math.max(anchorTagStackCount - 1, 0);
					}
				} else if (nodeType === 'text' && anchorTagStackCount === 0) {
					var textNodeMatches = this.parseText(node.getText(), node.getOffset());

					matches.push.apply(matches, textNodeMatches);
				}
			}

			matches = this.compactMatches(matches);

			matches = this.removeUnwantedMatches(matches);

			return matches;
		},

		compactMatches: function compactMatches(matches) {
			matches.sort(function (a, b) {
				return a.getOffset() - b.getOffset();
			});

			for (var i = 0; i < matches.length - 1; i++) {
				var match = matches[i],
				    offset = match.getOffset(),
				    matchedTextLength = match.getMatchedText().length,
				    endIdx = offset + matchedTextLength;

				if (i + 1 < matches.length) {
					if (matches[i + 1].getOffset() === offset) {
						var removeIdx = matches[i + 1].getMatchedText().length > matchedTextLength ? i : i + 1;
						matches.splice(removeIdx, 1);
						continue;
					}

					if (matches[i + 1].getOffset() < endIdx) {
						matches.splice(i + 1, 1);
					}
				}
			}

			return matches;
		},

		removeUnwantedMatches: function removeUnwantedMatches(matches) {
			var remove = Autolinker.Util.remove;

			if (!this.hashtag) remove(matches, function (match) {
				return match.getType() === 'hashtag';
			});
			if (!this.email) remove(matches, function (match) {
				return match.getType() === 'email';
			});
			if (!this.phone) remove(matches, function (match) {
				return match.getType() === 'phone';
			});
			if (!this.mention) remove(matches, function (match) {
				return match.getType() === 'mention';
			});
			if (!this.urls.schemeMatches) {
				remove(matches, function (m) {
					return m.getType() === 'url' && m.getUrlMatchType() === 'scheme';
				});
			}
			if (!this.urls.wwwMatches) {
				remove(matches, function (m) {
					return m.getType() === 'url' && m.getUrlMatchType() === 'www';
				});
			}
			if (!this.urls.tldMatches) {
				remove(matches, function (m) {
					return m.getType() === 'url' && m.getUrlMatchType() === 'tld';
				});
			}

			return matches;
		},

		parseText: function parseText(text, offset) {
			offset = offset || 0;
			var matchers = this.getMatchers(),
			    matches = [];

			for (var i = 0, numMatchers = matchers.length; i < numMatchers; i++) {
				var textMatches = matchers[i].parseMatches(text);

				for (var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++) {
					textMatches[j].setOffset(offset + textMatches[j].getOffset());
				}

				matches.push.apply(matches, textMatches);
			}
			return matches;
		},

		link: function link(textOrHtml) {
			if (!textOrHtml) {
				return "";
			}

			var matches = this.parse(textOrHtml),
			    newHtml = [],
			    lastIndex = 0;

			for (var i = 0, len = matches.length; i < len; i++) {
				var match = matches[i];

				newHtml.push(textOrHtml.substring(lastIndex, match.getOffset()));
				newHtml.push(this.createMatchReturnVal(match));

				lastIndex = match.getOffset() + match.getMatchedText().length;
			}
			newHtml.push(textOrHtml.substring(lastIndex));

			return newHtml.join('');
		},

		createMatchReturnVal: function createMatchReturnVal(match) {
			var replaceFnResult;
			if (this.replaceFn) {
				replaceFnResult = this.replaceFn.call(this.context, match);
			}

			if (typeof replaceFnResult === 'string') {
				return replaceFnResult;
			} else if (replaceFnResult === false) {
				return match.getMatchedText();
			} else if (replaceFnResult instanceof Autolinker.HtmlTag) {
				return replaceFnResult.toAnchorString();
			} else {
				var anchorTag = match.buildTag();

				return anchorTag.toAnchorString();
			}
		},

		getHtmlParser: function getHtmlParser() {
			var htmlParser = this.htmlParser;

			if (!htmlParser) {
				htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
			}

			return htmlParser;
		},

		getMatchers: function getMatchers() {
			if (!this.matchers) {
				var matchersNs = Autolinker.matcher,
				    tagBuilder = this.getTagBuilder();

				var matchers = [new matchersNs.Hashtag({ tagBuilder: tagBuilder, serviceName: this.hashtag }), new matchersNs.Email({ tagBuilder: tagBuilder }), new matchersNs.Phone({ tagBuilder: tagBuilder }), new matchersNs.Mention({ tagBuilder: tagBuilder, serviceName: this.mention }), new matchersNs.Url({ tagBuilder: tagBuilder, stripPrefix: this.stripPrefix, stripTrailingSlash: this.stripTrailingSlash, decodePercentEncoding: this.decodePercentEncoding })];

				return this.matchers = matchers;
			} else {
				return this.matchers;
			}
		},

		getTagBuilder: function getTagBuilder() {
			var tagBuilder = this.tagBuilder;

			if (!tagBuilder) {
				tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder({
					newWindow: this.newWindow,
					truncate: this.truncate,
					className: this.className
				});
			}

			return tagBuilder;
		}

	};

	Autolinker.match = {};
	Autolinker.matcher = {};
	Autolinker.htmlParser = {};
	Autolinker.truncate = {};

	Autolinker.Util = {
		abstractMethod: function abstractMethod() {
			throw "abstract";
		},

		trimRegex: /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

		assign: function assign(dest, src) {
			for (var prop in src) {
				if (src.hasOwnProperty(prop)) {
					dest[prop] = src[prop];
				}
			}

			return dest;
		},

		defaults: function defaults(dest, src) {
			for (var prop in src) {
				if (src.hasOwnProperty(prop) && dest[prop] === undefined) {
					dest[prop] = src[prop];
				}
			}

			return dest;
		},

		extend: function extend(superclass, protoProps) {
			var superclassProto = superclass.prototype;

			var F = function F() {};
			F.prototype = superclassProto;

			var subclass;
			if (protoProps.hasOwnProperty('constructor')) {
				subclass = protoProps.constructor;
			} else {
				subclass = function subclass() {
					superclassProto.constructor.apply(this, arguments);
				};
			}

			var subclassProto = subclass.prototype = new F();
			subclassProto.constructor = subclass;
			subclassProto.superclass = superclassProto;

			delete protoProps.constructor;
			Autolinker.Util.assign(subclassProto, protoProps);

			return subclass;
		},

		ellipsis: function ellipsis(str, truncateLen, ellipsisChars) {
			var ellipsisLength;

			if (str.length > truncateLen) {
				if (ellipsisChars == null) {
					ellipsisChars = '&hellip;';
					ellipsisLength = 3;
				} else {
					ellipsisLength = ellipsisChars.length;
				}

				str = str.substring(0, truncateLen - ellipsisLength) + ellipsisChars;
			}
			return str;
		},

		indexOf: function indexOf(arr, element) {
			if (Array.prototype.indexOf) {
				return arr.indexOf(element);
			} else {
				for (var i = 0, len = arr.length; i < len; i++) {
					if (arr[i] === element) return i;
				}
				return -1;
			}
		},

		remove: function remove(arr, fn) {
			for (var i = arr.length - 1; i >= 0; i--) {
				if (fn(arr[i]) === true) {
					arr.splice(i, 1);
				}
			}
		},

		splitAndCapture: function splitAndCapture(str, splitRegex) {
			if (!splitRegex.global) throw new Error("`splitRegex` must have the 'g' flag set");

			var result = [],
			    lastIdx = 0,
			    match;

			while (match = splitRegex.exec(str)) {
				result.push(str.substring(lastIdx, match.index));
				result.push(match[0]);

				lastIdx = match.index + match[0].length;
			}
			result.push(str.substring(lastIdx));

			return result;
		},

		trim: function trim(str) {
			return str.replace(this.trimRegex, '');
		}

	};

	Autolinker.HtmlTag = Autolinker.Util.extend(Object, {
		whitespaceRegex: /\s+/,

		constructor: function constructor(cfg) {
			Autolinker.Util.assign(this, cfg);

			this.innerHtml = this.innerHtml || this.innerHTML;
		},

		setTagName: function setTagName(tagName) {
			this.tagName = tagName;
			return this;
		},

		getTagName: function getTagName() {
			return this.tagName || "";
		},

		setAttr: function setAttr(attrName, attrValue) {
			var tagAttrs = this.getAttrs();
			tagAttrs[attrName] = attrValue;

			return this;
		},

		getAttr: function getAttr(attrName) {
			return this.getAttrs()[attrName];
		},

		setAttrs: function setAttrs(attrs) {
			var tagAttrs = this.getAttrs();
			Autolinker.Util.assign(tagAttrs, attrs);

			return this;
		},

		getAttrs: function getAttrs() {
			return this.attrs || (this.attrs = {});
		},

		setClass: function setClass(cssClass) {
			return this.setAttr('class', cssClass);
		},

		addClass: function addClass(cssClass) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,
			    classes = !classAttr ? [] : classAttr.split(whitespaceRegex),
			    newClasses = cssClass.split(whitespaceRegex),
			    newClass;

			while (newClass = newClasses.shift()) {
				if (indexOf(classes, newClass) === -1) {
					classes.push(newClass);
				}
			}

			this.getAttrs()['class'] = classes.join(" ");
			return this;
		},

		removeClass: function removeClass(cssClass) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,
			    classes = !classAttr ? [] : classAttr.split(whitespaceRegex),
			    removeClasses = cssClass.split(whitespaceRegex),
			    removeClass;

			while (classes.length && (removeClass = removeClasses.shift())) {
				var idx = indexOf(classes, removeClass);
				if (idx !== -1) {
					classes.splice(idx, 1);
				}
			}

			this.getAttrs()['class'] = classes.join(" ");
			return this;
		},

		getClass: function getClass() {
			return this.getAttrs()['class'] || "";
		},

		hasClass: function hasClass(cssClass) {
			return (' ' + this.getClass() + ' ').indexOf(' ' + cssClass + ' ') !== -1;
		},

		setInnerHtml: function setInnerHtml(html) {
			this.innerHtml = html;

			return this;
		},

		getInnerHtml: function getInnerHtml() {
			return this.innerHtml || "";
		},

		toAnchorString: function toAnchorString() {
			var tagName = this.getTagName(),
			    attrsStr = this.buildAttrsStr();

			attrsStr = attrsStr ? ' ' + attrsStr : '';

			return ['<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>'].join("");
		},

		buildAttrsStr: function buildAttrsStr() {
			if (!this.attrs) return "";

			var attrs = this.getAttrs(),
			    attrsArr = [];

			for (var prop in attrs) {
				if (attrs.hasOwnProperty(prop)) {
					attrsArr.push(prop + '="' + attrs[prop] + '"');
				}
			}
			return attrsArr.join(" ");
		}

	});

	Autolinker.RegexLib = function () {
		var alphaCharsStr = 'A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';

		var decimalNumbersStr = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';

		var alphaNumericCharsStr = alphaCharsStr + decimalNumbersStr;

		var ipStr = '(?:[' + decimalNumbersStr + ']{1,3}\\.){3}[' + decimalNumbersStr + ']{1,3}';

		var domainLabelStr = '[' + alphaNumericCharsStr + '](?:[' + alphaNumericCharsStr + '\\-]{0,61}[' + alphaNumericCharsStr + '])?';

		var getDomainLabelStr = function getDomainLabelStr(group) {
			return '(?=(' + domainLabelStr + '))\\' + group;
		};

		var getDomainNameStr = function getDomainNameStr(group) {
			return '(?:' + getDomainLabelStr(group) + '(?:\\.' + getDomainLabelStr(group + 1) + '){0,126}|' + ipStr + ')';
		};

		return {
			alphaNumericCharsStr: alphaNumericCharsStr,

			alphaCharsStr: alphaCharsStr,

			getDomainNameStr: getDomainNameStr

		};
	}();

	Autolinker.AnchorTagBuilder = Autolinker.Util.extend(Object, {
		constructor: function constructor(cfg) {
			cfg = cfg || {};

			this.newWindow = cfg.newWindow;
			this.truncate = cfg.truncate;
			this.className = cfg.className;
		},

		build: function build(match) {
			return new Autolinker.HtmlTag({
				tagName: 'a',
				attrs: this.createAttrs(match),
				innerHtml: this.processAnchorText(match.getAnchorText())
			});
		},

		createAttrs: function createAttrs(match) {
			var attrs = {
				'href': match.getAnchorHref() };

			var cssClass = this.createCssClass(match);
			if (cssClass) {
				attrs['class'] = cssClass;
			}
			if (this.newWindow) {
				attrs['target'] = "_blank";
				attrs['rel'] = "noopener noreferrer";
			}

			if (this.truncate) {
				if (this.truncate.length && this.truncate.length < match.getAnchorText().length) {
					attrs['title'] = match.getAnchorHref();
				}
			}

			return attrs;
		},

		createCssClass: function createCssClass(match) {
			var className = this.className;

			if (!className) {
				return "";
			} else {
				var returnClasses = [className],
				    cssClassSuffixes = match.getCssClassSuffixes();

				for (var i = 0, len = cssClassSuffixes.length; i < len; i++) {
					returnClasses.push(className + '-' + cssClassSuffixes[i]);
				}
				return returnClasses.join(' ');
			}
		},

		processAnchorText: function processAnchorText(anchorText) {
			anchorText = this.doTruncate(anchorText);

			return anchorText;
		},

		doTruncate: function doTruncate(anchorText) {
			var truncate = this.truncate;
			if (!truncate || !truncate.length) return anchorText;

			var truncateLength = truncate.length,
			    truncateLocation = truncate.location;

			if (truncateLocation === 'smart') {
				return Autolinker.truncate.TruncateSmart(anchorText, truncateLength);
			} else if (truncateLocation === 'middle') {
				return Autolinker.truncate.TruncateMiddle(anchorText, truncateLength);
			} else {
				return Autolinker.truncate.TruncateEnd(anchorText, truncateLength);
			}
		}

	});

	Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend(Object, {
		htmlRegex: function () {
			var commentTagRegex = /!--([\s\S]+?)--/,
			    tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/,
			    attrNameRegex = /[^\s"'>\/=\x00-\x1F\x7F]+/,
			    attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/,
			    optionalAttrValueRegex = '(?:\\s*?=\\s*?' + attrValueRegex.source + ')?';

			var getNameEqualsValueRegex = function getNameEqualsValueRegex(group) {
				return '(?=(' + attrNameRegex.source + '))\\' + group + optionalAttrValueRegex;
			};

			return new RegExp(['(?:', '<(!DOCTYPE)', '(?:', '\\s+', '(?:', getNameEqualsValueRegex(2), '|', attrValueRegex.source + ')', ')*', '>', ')', '|', '(?:', '<(/)?', '(?:', commentTagRegex.source, '|', '(?:', '(' + tagNameRegex.source + ')', '\\s*/?', ')', '|', '(?:', '(' + tagNameRegex.source + ')', '\\s+', '(?:', '(?:\\s+|\\b)', getNameEqualsValueRegex(7), ')*', '\\s*/?', ')', ')', '>', ')'].join(""), 'gi');
		}(),

		htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,

		parse: function parse(html) {
			var htmlRegex = this.htmlRegex,
			    currentResult,
			    lastIndex = 0,
			    textAndEntityNodes,
			    nodes = [];

			while ((currentResult = htmlRegex.exec(html)) !== null) {
				var tagText = currentResult[0],
				    commentText = currentResult[4],
				    tagName = currentResult[1] || currentResult[5] || currentResult[6],
				    isClosingTag = !!currentResult[3],
				    offset = currentResult.index,
				    inBetweenTagsText = html.substring(lastIndex, offset);

				if (inBetweenTagsText) {
					textAndEntityNodes = this.parseTextAndEntityNodes(lastIndex, inBetweenTagsText);
					nodes.push.apply(nodes, textAndEntityNodes);
				}

				if (commentText) {
					nodes.push(this.createCommentNode(offset, tagText, commentText));
				} else {
					nodes.push(this.createElementNode(offset, tagText, tagName, isClosingTag));
				}

				lastIndex = offset + tagText.length;
			}

			if (lastIndex < html.length) {
				var text = html.substring(lastIndex);

				if (text) {
					textAndEntityNodes = this.parseTextAndEntityNodes(lastIndex, text);

					textAndEntityNodes.forEach(function (node) {
						nodes.push(node);
					});
				}
			}

			return nodes;
		},

		parseTextAndEntityNodes: function parseTextAndEntityNodes(offset, text) {
			var nodes = [],
			    textAndEntityTokens = Autolinker.Util.splitAndCapture(text, this.htmlCharacterEntitiesRegex);
			for (var i = 0, len = textAndEntityTokens.length; i < len; i += 2) {
				var textToken = textAndEntityTokens[i],
				    entityToken = textAndEntityTokens[i + 1];

				if (textToken) {
					nodes.push(this.createTextNode(offset, textToken));
					offset += textToken.length;
				}
				if (entityToken) {
					nodes.push(this.createEntityNode(offset, entityToken));
					offset += entityToken.length;
				}
			}
			return nodes;
		},

		createCommentNode: function createCommentNode(offset, tagText, commentText) {
			return new Autolinker.htmlParser.CommentNode({
				offset: offset,
				text: tagText,
				comment: Autolinker.Util.trim(commentText)
			});
		},

		createElementNode: function createElementNode(offset, tagText, tagName, isClosingTag) {
			return new Autolinker.htmlParser.ElementNode({
				offset: offset,
				text: tagText,
				tagName: tagName.toLowerCase(),
				closing: isClosingTag
			});
		},

		createEntityNode: function createEntityNode(offset, text) {
			return new Autolinker.htmlParser.EntityNode({ offset: offset, text: text });
		},

		createTextNode: function createTextNode(offset, text) {
			return new Autolinker.htmlParser.TextNode({ offset: offset, text: text });
		}

	});

	Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend(Object, {
		offset: undefined,

		text: undefined,

		constructor: function constructor(cfg) {
			Autolinker.Util.assign(this, cfg);

			if (this.offset == null) throw new Error('`offset` cfg required');
			if (this.text == null) throw new Error('`text` cfg required');
		},

		getType: Autolinker.Util.abstractMethod,

		getOffset: function getOffset() {
			return this.offset;
		},

		getText: function getText() {
			return this.text;
		}

	});

	Autolinker.htmlParser.CommentNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
		comment: '',

		getType: function getType() {
			return 'comment';
		},

		getComment: function getComment() {
			return this.comment;
		}

	});

	Autolinker.htmlParser.ElementNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
		tagName: '',

		closing: false,

		getType: function getType() {
			return 'element';
		},

		getTagName: function getTagName() {
			return this.tagName;
		},

		isClosing: function isClosing() {
			return this.closing;
		}

	});

	Autolinker.htmlParser.EntityNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
		getType: function getType() {
			return 'entity';
		}

	});

	Autolinker.htmlParser.TextNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
		getType: function getType() {
			return 'text';
		}

	});

	Autolinker.match.Match = Autolinker.Util.extend(Object, {
		constructor: function constructor(cfg) {
			if (cfg.tagBuilder == null) throw new Error('`tagBuilder` cfg required');
			if (cfg.matchedText == null) throw new Error('`matchedText` cfg required');
			if (cfg.offset == null) throw new Error('`offset` cfg required');

			this.tagBuilder = cfg.tagBuilder;
			this.matchedText = cfg.matchedText;
			this.offset = cfg.offset;
		},

		getType: Autolinker.Util.abstractMethod,

		getMatchedText: function getMatchedText() {
			return this.matchedText;
		},

		setOffset: function setOffset(offset) {
			this.offset = offset;
		},

		getOffset: function getOffset() {
			return this.offset;
		},

		getAnchorHref: Autolinker.Util.abstractMethod,

		getAnchorText: Autolinker.Util.abstractMethod,

		getCssClassSuffixes: function getCssClassSuffixes() {
			return [this.getType()];
		},

		buildTag: function buildTag() {
			return this.tagBuilder.build(this);
		}

	});

	Autolinker.match.Email = Autolinker.Util.extend(Autolinker.match.Match, {
		constructor: function constructor(cfg) {
			Autolinker.match.Match.prototype.constructor.call(this, cfg);

			if (!cfg.email) throw new Error('`email` cfg required');

			this.email = cfg.email;
		},

		getType: function getType() {
			return 'email';
		},

		getEmail: function getEmail() {
			return this.email;
		},

		getAnchorHref: function getAnchorHref() {
			return 'mailto:' + this.email;
		},

		getAnchorText: function getAnchorText() {
			return this.email;
		}

	});

	Autolinker.match.Hashtag = Autolinker.Util.extend(Autolinker.match.Match, {
		constructor: function constructor(cfg) {
			Autolinker.match.Match.prototype.constructor.call(this, cfg);

			if (!cfg.hashtag) throw new Error('`hashtag` cfg required');

			this.serviceName = cfg.serviceName;
			this.hashtag = cfg.hashtag;
		},

		getType: function getType() {
			return 'hashtag';
		},

		getServiceName: function getServiceName() {
			return this.serviceName;
		},

		getHashtag: function getHashtag() {
			return this.hashtag;
		},

		getAnchorHref: function getAnchorHref() {
			var serviceName = this.serviceName,
			    hashtag = this.hashtag;

			switch (serviceName) {
				case 'twitter':
					return 'https://twitter.com/hashtag/' + hashtag;
				case 'facebook':
					return 'https://www.facebook.com/hashtag/' + hashtag;
				case 'instagram':
					return 'https://instagram.com/explore/tags/' + hashtag;

				default:
					throw new Error('Unknown service name to point hashtag to: ', serviceName);
			}
		},

		getAnchorText: function getAnchorText() {
			return '#' + this.hashtag;
		}

	});

	Autolinker.match.Phone = Autolinker.Util.extend(Autolinker.match.Match, {
		constructor: function constructor(cfg) {
			Autolinker.match.Match.prototype.constructor.call(this, cfg);

			if (!cfg.number) throw new Error('`number` cfg required');
			if (cfg.plusSign == null) throw new Error('`plusSign` cfg required');

			this.number = cfg.number;
			this.plusSign = cfg.plusSign;
		},

		getType: function getType() {
			return 'phone';
		},

		getNumber: function getNumber() {
			return this.number;
		},

		getAnchorHref: function getAnchorHref() {
			return 'tel:' + (this.plusSign ? '+' : '') + this.number;
		},

		getAnchorText: function getAnchorText() {
			return this.matchedText;
		}

	});

	Autolinker.match.Mention = Autolinker.Util.extend(Autolinker.match.Match, {
		constructor: function constructor(cfg) {
			Autolinker.match.Match.prototype.constructor.call(this, cfg);

			if (!cfg.serviceName) throw new Error('`serviceName` cfg required');
			if (!cfg.mention) throw new Error('`mention` cfg required');

			this.mention = cfg.mention;
			this.serviceName = cfg.serviceName;
		},

		getType: function getType() {
			return 'mention';
		},

		getMention: function getMention() {
			return this.mention;
		},

		getServiceName: function getServiceName() {
			return this.serviceName;
		},

		getAnchorHref: function getAnchorHref() {
			switch (this.serviceName) {
				case 'twitter':
					return 'https://twitter.com/' + this.mention;
				case 'instagram':
					return 'https://instagram.com/' + this.mention;
				case 'soundcloud':
					return 'https://soundcloud.com/' + this.mention;

				default:
					throw new Error('Unknown service name to point mention to: ', this.serviceName);
			}
		},

		getAnchorText: function getAnchorText() {
			return '@' + this.mention;
		},

		getCssClassSuffixes: function getCssClassSuffixes() {
			var cssClassSuffixes = Autolinker.match.Match.prototype.getCssClassSuffixes.call(this),
			    serviceName = this.getServiceName();

			if (serviceName) {
				cssClassSuffixes.push(serviceName);
			}
			return cssClassSuffixes;
		}

	});

	Autolinker.match.Url = Autolinker.Util.extend(Autolinker.match.Match, {
		constructor: function constructor(cfg) {
			Autolinker.match.Match.prototype.constructor.call(this, cfg);

			if (cfg.urlMatchType !== 'scheme' && cfg.urlMatchType !== 'www' && cfg.urlMatchType !== 'tld') throw new Error('`urlMatchType` cfg must be one of: "scheme", "www", or "tld"');
			if (!cfg.url) throw new Error('`url` cfg required');
			if (cfg.protocolUrlMatch == null) throw new Error('`protocolUrlMatch` cfg required');
			if (cfg.protocolRelativeMatch == null) throw new Error('`protocolRelativeMatch` cfg required');
			if (cfg.stripPrefix == null) throw new Error('`stripPrefix` cfg required');
			if (cfg.stripTrailingSlash == null) throw new Error('`stripTrailingSlash` cfg required');
			if (cfg.decodePercentEncoding == null) throw new Error('`decodePercentEncoding` cfg required');

			this.urlMatchType = cfg.urlMatchType;
			this.url = cfg.url;
			this.protocolUrlMatch = cfg.protocolUrlMatch;
			this.protocolRelativeMatch = cfg.protocolRelativeMatch;
			this.stripPrefix = cfg.stripPrefix;
			this.stripTrailingSlash = cfg.stripTrailingSlash;
			this.decodePercentEncoding = cfg.decodePercentEncoding;
		},

		schemePrefixRegex: /^(https?:\/\/)?/i,

		wwwPrefixRegex: /^(https?:\/\/)?(www\.)?/i,

		protocolRelativeRegex: /^\/\//,

		protocolPrepended: false,

		getType: function getType() {
			return 'url';
		},

		getUrlMatchType: function getUrlMatchType() {
			return this.urlMatchType;
		},

		getUrl: function getUrl() {
			var url = this.url;

			if (!this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended) {
				url = this.url = 'http://' + url;

				this.protocolPrepended = true;
			}

			return url;
		},

		getAnchorHref: function getAnchorHref() {
			var url = this.getUrl();

			return url.replace(/&amp;/g, '&');
		},

		getAnchorText: function getAnchorText() {
			var anchorText = this.getMatchedText();

			if (this.protocolRelativeMatch) {
				anchorText = this.stripProtocolRelativePrefix(anchorText);
			}
			if (this.stripPrefix.scheme) {
				anchorText = this.stripSchemePrefix(anchorText);
			}
			if (this.stripPrefix.www) {
				anchorText = this.stripWwwPrefix(anchorText);
			}
			if (this.stripTrailingSlash) {
				anchorText = this.removeTrailingSlash(anchorText);
			}
			if (this.decodePercentEncoding) {
				anchorText = this.removePercentEncoding(anchorText);
			}

			return anchorText;
		},

		stripSchemePrefix: function stripSchemePrefix(url) {
			return url.replace(this.schemePrefixRegex, '');
		},

		stripWwwPrefix: function stripWwwPrefix(url) {
			return url.replace(this.wwwPrefixRegex, '$1');
		},

		stripProtocolRelativePrefix: function stripProtocolRelativePrefix(text) {
			return text.replace(this.protocolRelativeRegex, '');
		},

		removeTrailingSlash: function removeTrailingSlash(anchorText) {
			if (anchorText.charAt(anchorText.length - 1) === '/') {
				anchorText = anchorText.slice(0, -1);
			}
			return anchorText;
		},

		removePercentEncoding: function removePercentEncoding(anchorText) {
			try {
				return decodeURIComponent(anchorText.replace(/%22/gi, '&quot;').replace(/%26/gi, '&amp;').replace(/%27/gi, '&#39;').replace(/%3C/gi, '&lt;').replace(/%3E/gi, '&gt;'));
			} catch (e) {
				return anchorText;
			}
		}

	});

	Autolinker.tldRegex = /(?:xn--vermgensberatung-pwb|xn--vermgensberater-ctb|xn--clchc0ea0b2g2a9gcd|xn--w4r85el8fhu5dnra|northwesternmutual|travelersinsurance|vermögensberatung|xn--3oq18vl8pn36a|xn--5su34j936bgsg|xn--bck1b9a5dre4c|xn--mgbai9azgqp6j|xn--mgberp4a5d4ar|xn--xkc2dl3a5ee0h|vermögensberater|xn--fzys8d69uvgm|xn--mgba7c0bbn0a|xn--xkc2al3hye2a|americanexpress|kerryproperties|sandvikcoromant|xn--i1b6b1a6a2e|xn--kcrx77d1x4a|xn--lgbbat1ad8j|xn--mgba3a4f16a|xn--mgbc0a9azcg|xn--nqv7fs00ema|afamilycompany|americanfamily|bananarepublic|cancerresearch|cookingchannel|kerrylogistics|weatherchannel|xn--54b7fta0cc|xn--6qq986b3xl|xn--80aqecdr1a|xn--b4w605ferd|xn--fiq228c5hs|xn--jlq61u9w7b|xn--mgba3a3ejt|xn--mgbaam7a8h|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a71e|xn--mgbca7dzdo|xn--mgbi4ecexp|xn--mgbx4cd0ab|international|lifeinsurance|orientexpress|spreadbetting|travelchannel|wolterskluwer|xn--eckvdtc9d|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--tiq49xqyj|xn--yfro4i67o|xn--ygbi2ammx|construction|lplfinancial|pamperedchef|scholarships|versicherung|xn--3e0b707e|xn--80adxhks|xn--80asehdb|xn--8y0a063a|xn--gckr3f0f|xn--mgb9awbf|xn--mgbab2bd|xn--mgbpl2fh|xn--mgbt3dhd|xn--mk1bu44c|xn--ngbc5azd|xn--ngbe9e0a|xn--ogbpf8fl|xn--qcka1pmc|accountants|barclaycard|blackfriday|blockbuster|bridgestone|calvinklein|contractors|creditunion|engineering|enterprises|foodnetwork|investments|kerryhotels|lamborghini|motorcycles|olayangroup|photography|playstation|productions|progressive|redumbrella|rightathome|williamhill|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--3bst00m|xn--3ds443g|xn--42c2d9a|xn--45brj9c|xn--55qw42g|xn--6frz82g|xn--80ao21a|xn--9krt00a|xn--cck2b3b|xn--czr694b|xn--d1acj3b|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fjq720a|xn--flw351e|xn--g2xx48c|xn--gecrj9c|xn--gk3at1e|xn--h2brj9c|xn--hxt814e|xn--imr513n|xn--j6w193g|xn--jvr189m|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--mgbtx2b|xn--mix891f|xn--nyqy26a|xn--pbt977c|xn--pgbs0dh|xn--q9jyb4c|xn--rhqv96g|xn--rovu88b|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--vuq861b|xn--w4rs40l|xn--xhq521b|xn--zfr164b|சிங்கப்பூர்|accountant|apartments|associates|basketball|bnpparibas|boehringer|capitalone|consulting|creditcard|cuisinella|eurovision|extraspace|foundation|healthcare|immobilien|industries|management|mitsubishi|nationwide|newholland|nextdirect|onyourside|properties|protection|prudential|realestate|republican|restaurant|schaeffler|swiftcover|tatamotors|technology|telefonica|university|vistaprint|vlaanderen|volkswagen|xn--30rr7y|xn--3pxu8k|xn--45q11c|xn--4gbrim|xn--55qx5d|xn--5tzm5g|xn--80aswg|xn--90a3ac|xn--9dbq2a|xn--9et52u|xn--c2br7g|xn--cg4bki|xn--czrs0t|xn--czru2d|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--io0a7i|xn--kput3i|xn--mxtq1m|xn--o3cw4h|xn--pssy2u|xn--unup4y|xn--wgbh1c|xn--wgbl6a|xn--y9a3aq|accenture|alfaromeo|allfinanz|amsterdam|analytics|aquarelle|barcelona|bloomberg|christmas|community|directory|education|equipment|fairwinds|financial|firestone|fresenius|frontdoor|fujixerox|furniture|goldpoint|goodhands|hisamitsu|homedepot|homegoods|homesense|honeywell|institute|insurance|kuokgroup|ladbrokes|lancaster|landrover|lifestyle|marketing|marshalls|mcdonalds|melbourne|microsoft|montblanc|panasonic|passagens|pramerica|richardli|scjohnson|shangrila|solutions|statebank|statefarm|stockholm|travelers|vacations|xn--90ais|xn--c1avg|xn--d1alf|xn--e1a4c|xn--fhbei|xn--j1aef|xn--j1amh|xn--l1acc|xn--nqv7f|xn--p1acf|xn--tckwe|xn--vhquv|yodobashi|abudhabi|airforce|allstate|attorney|barclays|barefoot|bargains|baseball|boutique|bradesco|broadway|brussels|budapest|builders|business|capetown|catering|catholic|chrysler|cipriani|cityeats|cleaning|clinique|clothing|commbank|computer|delivery|deloitte|democrat|diamonds|discount|discover|download|engineer|ericsson|esurance|everbank|exchange|feedback|fidelity|firmdale|football|frontier|goodyear|grainger|graphics|guardian|hdfcbank|helsinki|holdings|hospital|infiniti|ipiranga|istanbul|jpmorgan|lighting|lundbeck|marriott|maserati|mckinsey|memorial|mortgage|movistar|observer|partners|pharmacy|pictures|plumbing|property|redstone|reliance|saarland|samsclub|security|services|shopping|showtime|softbank|software|stcgroup|supplies|symantec|telecity|training|uconnect|vanguard|ventures|verisign|woodside|xn--90ae|xn--node|xn--p1ai|xn--qxam|yokohama|السعودية|abogado|academy|agakhan|alibaba|android|athleta|auction|audible|auspost|avianca|banamex|bauhaus|bentley|bestbuy|booking|brother|bugatti|capital|caravan|careers|cartier|channel|chintai|citadel|clubmed|college|cologne|comcast|company|compare|contact|cooking|corsica|country|coupons|courses|cricket|cruises|dentist|digital|domains|exposed|express|farmers|fashion|ferrari|ferrero|finance|fishing|fitness|flights|florist|flowers|forsale|frogans|fujitsu|gallery|genting|godaddy|guitars|hamburg|hangout|hitachi|holiday|hosting|hoteles|hotmail|hyundai|iselect|ismaili|jewelry|juniper|kitchen|komatsu|lacaixa|lancome|lanxess|lasalle|latrobe|leclerc|liaison|limited|lincoln|markets|metlife|monster|netbank|netflix|network|neustar|okinawa|oldnavy|organic|origins|panerai|philips|pioneer|politie|realtor|recipes|rentals|reviews|rexroth|samsung|sandvik|schmidt|schwarz|science|shiksha|shriram|singles|spiegel|staples|starhub|statoil|storage|support|surgery|systems|temasek|theater|theatre|tickets|tiffany|toshiba|trading|walmart|wanggou|watches|weather|website|wedding|whoswho|windows|winners|xfinity|yamaxun|youtube|zuerich|католик|الجزائر|العليان|پاکستان|كاثوليك|موبايلي|இந்தியா|abarth|abbott|abbvie|active|africa|agency|airbus|airtel|alipay|alsace|alstom|anquan|aramco|author|bayern|beauty|berlin|bharti|blanco|bostik|boston|broker|camera|career|caseih|casino|center|chanel|chrome|church|circle|claims|clinic|coffee|comsec|condos|coupon|credit|cruise|dating|datsun|dealer|degree|dental|design|direct|doctor|dunlop|dupont|durban|emerck|energy|estate|events|expert|family|flickr|futbol|gallup|garden|george|giving|global|google|gratis|health|hermes|hiphop|hockey|hughes|imamat|insure|intuit|jaguar|joburg|juegos|kaufen|kinder|kindle|kosher|lancia|latino|lawyer|lefrak|living|locker|london|luxury|madrid|maison|makeup|market|mattel|mobile|mobily|monash|mormon|moscow|museum|mutual|nagoya|natura|nissan|nissay|norton|nowruz|office|olayan|online|oracle|orange|otsuka|pfizer|photos|physio|piaget|pictet|quebec|racing|realty|reisen|repair|report|review|rocher|rogers|ryukyu|safety|sakura|sanofi|school|schule|secure|select|shouji|soccer|social|stream|studio|supply|suzuki|swatch|sydney|taipei|taobao|target|tattoo|tennis|tienda|tjmaxx|tkmaxx|toyota|travel|unicom|viajes|viking|villas|virgin|vision|voting|voyage|vuelos|walter|warman|webcam|xihuan|xperia|yachts|yandex|zappos|москва|онлайн|ابوظبي|ارامكو|الاردن|المغرب|امارات|فلسطين|مليسيا|இலங்கை|ファッション|actor|adult|aetna|amfam|amica|apple|archi|audio|autos|azure|baidu|beats|bible|bingo|black|boats|boots|bosch|build|canon|cards|chase|cheap|chloe|cisco|citic|click|cloud|coach|codes|crown|cymru|dabur|dance|deals|delta|dodge|drive|dubai|earth|edeka|email|epost|epson|faith|fedex|final|forex|forum|gallo|games|gifts|gives|glade|glass|globo|gmail|green|gripe|group|gucci|guide|homes|honda|horse|house|hyatt|ikano|intel|irish|iveco|jetzt|koeln|kyoto|lamer|lease|legal|lexus|lilly|linde|lipsy|lixil|loans|locus|lotte|lotto|lupin|macys|mango|media|miami|money|mopar|movie|nadex|nexus|nikon|ninja|nokia|nowtv|omega|osaka|paris|parts|party|phone|photo|pizza|place|poker|praxi|press|prime|promo|quest|radio|rehab|reise|ricoh|rocks|rodeo|salon|sener|seven|sharp|shell|shoes|skype|sling|smart|smile|solar|space|stada|store|study|style|sucks|swiss|tatar|tires|tirol|tmall|today|tokyo|tools|toray|total|tours|trade|trust|tunes|tushu|ubank|vegas|video|vista|vodka|volvo|wales|watch|weber|weibo|works|world|xerox|yahoo|zippo|ایران|بازار|بھارت|سودان|سورية|همراه|संगठन|বাংলা|భారత్|嘉里大酒店|aarp|able|adac|aero|aigo|akdn|ally|amex|army|arpa|arte|asda|asia|audi|auto|baby|band|bank|bbva|beer|best|bike|bing|blog|blue|bofa|bond|book|buzz|cafe|call|camp|care|cars|casa|case|cash|cbre|cern|chat|citi|city|club|cool|coop|cyou|data|date|dclk|deal|dell|desi|diet|dish|docs|doha|duck|duns|dvag|erni|fage|fail|fans|farm|fast|fiat|fido|film|fire|fish|flir|food|ford|free|fund|game|gbiz|gent|ggee|gift|gmbh|gold|golf|goog|guge|guru|hair|haus|hdfc|help|here|hgtv|host|hsbc|icbc|ieee|imdb|immo|info|itau|java|jeep|jobs|jprs|kddi|kiwi|kpmg|kred|land|lego|lgbt|lidl|life|like|limo|link|live|loan|loft|love|ltda|luxe|maif|meet|meme|menu|mini|mint|mobi|moda|moto|mtpc|name|navy|news|next|nico|nike|ollo|open|page|pars|pccw|pics|ping|pink|play|plus|pohl|porn|post|prod|prof|qpon|raid|read|reit|rent|rest|rich|rmit|room|rsvp|ruhr|safe|sale|sapo|sarl|save|saxo|scor|scot|seat|seek|sexy|shaw|shia|shop|show|silk|sina|site|skin|sncf|sohu|song|sony|spot|star|surf|talk|taxi|team|tech|teva|tiaa|tips|town|toys|tube|vana|visa|viva|vivo|vote|voto|wang|weir|wien|wiki|wine|work|xbox|yoga|zara|zero|zone|дети|сайт|بيتك|تونس|شبكة|عراق|عمان|موقع|भारत|ভারত|ਭਾਰਤ|ભારત|ලංකා|グーグル|クラウド|ポイント|大众汽车|组织机构|電訊盈科|香格里拉|aaa|abb|abc|aco|ads|aeg|afl|aig|anz|aol|app|art|aws|axa|bar|bbc|bbt|bcg|bcn|bet|bid|bio|biz|bms|bmw|bnl|bom|boo|bot|box|buy|bzh|cab|cal|cam|car|cat|cba|cbn|cbs|ceb|ceo|cfa|cfd|com|crs|csc|dad|day|dds|dev|dhl|diy|dnp|dog|dot|dtv|dvr|eat|eco|edu|esq|eus|fan|fit|fly|foo|fox|frl|ftr|fun|fyi|gal|gap|gdn|gea|gle|gmo|gmx|goo|gop|got|gov|hbo|hiv|hkt|hot|how|htc|ibm|ice|icu|ifm|ing|ink|int|ist|itv|iwc|jcb|jcp|jio|jlc|jll|jmp|jnj|jot|joy|kfh|kia|kim|kpn|krd|lat|law|lds|lol|lpl|ltd|man|mba|mcd|med|men|meo|mil|mit|mlb|mls|mma|moe|moi|mom|mov|msd|mtn|mtr|nab|nba|nec|net|new|nfl|ngo|nhk|now|nra|nrw|ntt|nyc|obi|off|one|ong|onl|ooo|org|ott|ovh|pay|pet|pid|pin|pnc|pro|pru|pub|pwc|qvc|red|ren|ril|rio|rip|run|rwe|sap|sas|sbi|sbs|sca|scb|ses|sew|sex|sfr|ski|sky|soy|srl|srt|stc|tab|tax|tci|tdk|tel|thd|tjx|top|trv|tui|tvs|ubs|uno|uol|ups|vet|vig|vin|vip|wed|win|wme|wow|wtc|wtf|xin|xxx|xyz|you|yun|zip|бел|ком|қаз|мкд|мон|орг|рус|срб|укр|հայ|קום|قطر|كوم|مصر|कॉम|नेट|คอม|ไทย|ストア|セール|みんな|中文网|天主教|我爱你|新加坡|淡马锡|诺基亚|飞利浦|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|ελ|бг|ею|рф|გე|닷넷|닷컴|삼성|한국|コム|世界|中信|中国|中國|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|在线|大拿|娱乐|家電|工行|广东|微博|慈善|手机|手表|政务|政府|新闻|时尚|書籍|机构|游戏|澳門|点看|珠宝|移动|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|食品|餐厅|香港)/;

	Autolinker.matcher.Matcher = Autolinker.Util.extend(Object, {
		constructor: function constructor(cfg) {
			if (!cfg.tagBuilder) throw new Error('`tagBuilder` cfg required');

			this.tagBuilder = cfg.tagBuilder;
		},

		parseMatches: Autolinker.Util.abstractMethod

	});

	Autolinker.matcher.Email = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
		matcherRegex: function () {
			var alphaNumericChars = Autolinker.RegexLib.alphaNumericCharsStr,
			    specialCharacters = '!#$%&\'*+\\-\\/=?^_`{|}~',
			    restrictedSpecialCharacters = '\\s"(),:;<>@\\[\\]',
			    validCharacters = alphaNumericChars + specialCharacters,
			    validRestrictedCharacters = validCharacters + restrictedSpecialCharacters,
			    emailRegex = new RegExp('(?:[' + validCharacters + '](?:[' + validCharacters + ']|\\.(?!\\.|@))*|\\"[' + validRestrictedCharacters + '.]+\\")@'),
			    getDomainNameStr = Autolinker.RegexLib.getDomainNameStr,
			    tldRegex = Autolinker.tldRegex;

			return new RegExp([emailRegex.source, getDomainNameStr(1), '\\.', tldRegex.source].join(""), 'gi');
		}(),

		parseMatches: function parseMatches(text) {
			var matcherRegex = this.matcherRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;

			while ((match = matcherRegex.exec(text)) !== null) {
				var matchedText = match[0];

				matches.push(new Autolinker.match.Email({
					tagBuilder: tagBuilder,
					matchedText: matchedText,
					offset: match.index,
					email: matchedText
				}));
			}

			return matches;
		}

	});

	Autolinker.matcher.Hashtag = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
		matcherRegex: new RegExp('#[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,139}', 'g'),

		nonWordCharRegex: new RegExp('[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']'),

		constructor: function constructor(cfg) {
			Autolinker.matcher.Matcher.prototype.constructor.call(this, cfg);

			this.serviceName = cfg.serviceName;
		},

		parseMatches: function parseMatches(text) {
			var matcherRegex = this.matcherRegex,
			    nonWordCharRegex = this.nonWordCharRegex,
			    serviceName = this.serviceName,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;

			while ((match = matcherRegex.exec(text)) !== null) {
				var offset = match.index,
				    prevChar = text.charAt(offset - 1);

				if (offset === 0 || nonWordCharRegex.test(prevChar)) {
					var matchedText = match[0],
					    hashtag = match[0].slice(1);

					matches.push(new Autolinker.match.Hashtag({
						tagBuilder: tagBuilder,
						matchedText: matchedText,
						offset: offset,
						serviceName: serviceName,
						hashtag: hashtag
					}));
				}
			}

			return matches;
		}

	});

	Autolinker.matcher.Phone = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
		matcherRegex: /(?:(?:(?:(\+)?\d{1,3}[-\040.]?)?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]?\d{4})|(?:(\+)(?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)[-\040.]?(?:\d[-\040.]?){6,12}\d+))([,;]+[0-9]+#?)*/g,

		parseMatches: function parseMatches(text) {
			var matcherRegex = this.matcherRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;

			while ((match = matcherRegex.exec(text)) !== null) {
				var matchedText = match[0],
				    cleanNumber = matchedText.replace(/[^0-9,;#]/g, ''),
				    plusSign = !!(match[1] || match[2]),
				    before = match.index == 0 ? '' : text.substr(match.index - 1, 1),
				    after = text.substr(match.index + matchedText.length, 1),
				    contextClear = !before.match(/\d/) && !after.match(/\d/);

				if (this.testMatch(match[3]) && this.testMatch(matchedText) && contextClear) {
					matches.push(new Autolinker.match.Phone({
						tagBuilder: tagBuilder,
						matchedText: matchedText,
						offset: match.index,
						number: cleanNumber,
						plusSign: plusSign
					}));
				}
			}

			return matches;
		},

		testMatch: function testMatch(text) {
			return (/\D/.test(text)
			);
		}

	});

	Autolinker.matcher.Mention = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
		matcherRegexes: {
			"twitter": new RegExp('@[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,20}', 'g'),
			"instagram": new RegExp('@[_.' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,50}', 'g'),
			"soundcloud": new RegExp('@[_.' + Autolinker.RegexLib.alphaNumericCharsStr + "\-" + ']{1,50}', 'g')
		},

		nonWordCharRegex: new RegExp('[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']'),

		constructor: function constructor(cfg) {
			Autolinker.matcher.Matcher.prototype.constructor.call(this, cfg);

			this.serviceName = cfg.serviceName;
		},

		parseMatches: function parseMatches(text) {
			var matcherRegex = this.matcherRegexes[this.serviceName],
			    nonWordCharRegex = this.nonWordCharRegex,
			    serviceName = this.serviceName,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;

			if (!matcherRegex) {
				return matches;
			}

			while ((match = matcherRegex.exec(text)) !== null) {
				var offset = match.index,
				    prevChar = text.charAt(offset - 1);

				if (offset === 0 || nonWordCharRegex.test(prevChar)) {
					var matchedText = match[0].replace(/\.+$/g, ''),
					    mention = matchedText.slice(1);

					matches.push(new Autolinker.match.Mention({
						tagBuilder: tagBuilder,
						matchedText: matchedText,
						offset: offset,
						serviceName: serviceName,
						mention: mention
					}));
				}
			}

			return matches;
		}

	});

	Autolinker.matcher.Url = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
		matcherRegex: function () {
			var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]{0,63}:(?![A-Za-z][-.+A-Za-z0-9]{0,63}:\/\/)(?!\d+\/?)(?:\/\/)?)/,
			    wwwRegex = /(?:www\.)/,
			    getDomainNameStr = Autolinker.RegexLib.getDomainNameStr,
			    tldRegex = Autolinker.tldRegex,
			    alphaNumericCharsStr = Autolinker.RegexLib.alphaNumericCharsStr,
			    urlSuffixRegex = new RegExp('[/?#](?:[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]?!:,.;\u2713]*[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]\u2713])?');

			return new RegExp(['(?:', '(', schemeRegex.source, getDomainNameStr(2), ')', '|', '(', '(//)?', wwwRegex.source, getDomainNameStr(6), ')', '|', '(', '(//)?', getDomainNameStr(10) + '\\.', tldRegex.source, '(?![-' + alphaNumericCharsStr + '])', ')', ')', '(?::[0-9]+)?', '(?:' + urlSuffixRegex.source + ')?'].join(""), 'gi');
		}(),

		wordCharRegExp: new RegExp('[' + Autolinker.RegexLib.alphaNumericCharsStr + ']'),

		openParensRe: /\(/g,

		closeParensRe: /\)/g,

		constructor: function constructor(cfg) {
			Autolinker.matcher.Matcher.prototype.constructor.call(this, cfg);

			if (cfg.stripPrefix == null) throw new Error('`stripPrefix` cfg required');
			if (cfg.stripTrailingSlash == null) throw new Error('`stripTrailingSlash` cfg required');

			this.stripPrefix = cfg.stripPrefix;
			this.stripTrailingSlash = cfg.stripTrailingSlash;
			this.decodePercentEncoding = cfg.decodePercentEncoding;
		},

		parseMatches: function parseMatches(text) {
			var matcherRegex = this.matcherRegex,
			    stripPrefix = this.stripPrefix,
			    stripTrailingSlash = this.stripTrailingSlash,
			    decodePercentEncoding = this.decodePercentEncoding,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;

			while ((match = matcherRegex.exec(text)) !== null) {
				var matchStr = match[0],
				    schemeUrlMatch = match[1],
				    wwwUrlMatch = match[4],
				    wwwProtocolRelativeMatch = match[5],
				    tldProtocolRelativeMatch = match[9],
				    offset = match.index,
				    protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch,
				    prevChar = text.charAt(offset - 1);

				if (!Autolinker.matcher.UrlMatchValidator.isValid(matchStr, schemeUrlMatch)) {
					continue;
				}

				if (offset > 0 && prevChar === '@') {
					continue;
				}

				if (offset > 0 && protocolRelativeMatch && this.wordCharRegExp.test(prevChar)) {
					continue;
				}

				if (/\?$/.test(matchStr)) {
					matchStr = matchStr.substr(0, matchStr.length - 1);
				}

				if (this.matchHasUnbalancedClosingParen(matchStr)) {
					matchStr = matchStr.substr(0, matchStr.length - 1);
				} else {
					var pos = this.matchHasInvalidCharAfterTld(matchStr, schemeUrlMatch);
					if (pos > -1) {
						matchStr = matchStr.substr(0, pos);
					}
				}

				var urlMatchType = schemeUrlMatch ? 'scheme' : wwwUrlMatch ? 'www' : 'tld',
				    protocolUrlMatch = !!schemeUrlMatch;

				matches.push(new Autolinker.match.Url({
					tagBuilder: tagBuilder,
					matchedText: matchStr,
					offset: offset,
					urlMatchType: urlMatchType,
					url: matchStr,
					protocolUrlMatch: protocolUrlMatch,
					protocolRelativeMatch: !!protocolRelativeMatch,
					stripPrefix: stripPrefix,
					stripTrailingSlash: stripTrailingSlash,
					decodePercentEncoding: decodePercentEncoding
				}));
			}

			return matches;
		},

		matchHasUnbalancedClosingParen: function matchHasUnbalancedClosingParen(matchStr) {
			var lastChar = matchStr.charAt(matchStr.length - 1);

			if (lastChar === ')') {
				var openParensMatch = matchStr.match(this.openParensRe),
				    closeParensMatch = matchStr.match(this.closeParensRe),
				    numOpenParens = openParensMatch && openParensMatch.length || 0,
				    numCloseParens = closeParensMatch && closeParensMatch.length || 0;

				if (numOpenParens < numCloseParens) {
					return true;
				}
			}

			return false;
		},

		matchHasInvalidCharAfterTld: function matchHasInvalidCharAfterTld(urlMatch, schemeUrlMatch) {
			if (!urlMatch) {
				return -1;
			}

			var offset = 0;
			if (schemeUrlMatch) {
				offset = urlMatch.indexOf(':');
				urlMatch = urlMatch.slice(offset);
			}

			var alphaNumeric = Autolinker.RegexLib.alphaNumericCharsStr;

			var re = new RegExp("^((.?\/\/)?[-." + alphaNumeric + "]*[-" + alphaNumeric + "]\\.[-" + alphaNumeric + "]+)");
			var res = re.exec(urlMatch);
			if (res === null) {
				return -1;
			}

			offset += res[1].length;
			urlMatch = urlMatch.slice(res[1].length);
			if (/^[^-.A-Za-z0-9:\/?#]/.test(urlMatch)) {
				return offset;
			}

			return -1;
		}

	});

	Autolinker.matcher.UrlMatchValidator = {
		hasFullProtocolRegex: /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,

		uriSchemeRegex: /^[A-Za-z][-.+A-Za-z0-9]*:/,

		hasWordCharAfterProtocolRegex: new RegExp(":[^\\s]*?[" + Autolinker.RegexLib.alphaCharsStr + "]"),

		ipRegex: /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,

		isValid: function isValid(urlMatch, protocolUrlMatch) {
			if (protocolUrlMatch && !this.isValidUriScheme(protocolUrlMatch) || this.urlMatchDoesNotHaveProtocolOrDot(urlMatch, protocolUrlMatch) || this.urlMatchDoesNotHaveAtLeastOneWordChar(urlMatch, protocolUrlMatch) && !this.isValidIpAddress(urlMatch) || this.containsMultipleDots(urlMatch)) {
				return false;
			}

			return true;
		},

		isValidIpAddress: function isValidIpAddress(uriSchemeMatch) {
			var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
			var uriScheme = uriSchemeMatch.match(newRegex);

			return uriScheme !== null;
		},

		containsMultipleDots: function containsMultipleDots(urlMatch) {
			var stringBeforeSlash = urlMatch;
			if (this.hasFullProtocolRegex.test(urlMatch)) {
				stringBeforeSlash = urlMatch.split('://')[1];
			}
			return stringBeforeSlash.split('/')[0].indexOf("..") > -1;
		},

		isValidUriScheme: function isValidUriScheme(uriSchemeMatch) {
			var uriScheme = uriSchemeMatch.match(this.uriSchemeRegex)[0].toLowerCase();

			return uriScheme !== 'javascript:' && uriScheme !== 'vbscript:';
		},

		urlMatchDoesNotHaveProtocolOrDot: function urlMatchDoesNotHaveProtocolOrDot(urlMatch, protocolUrlMatch) {
			return !!urlMatch && (!protocolUrlMatch || !this.hasFullProtocolRegex.test(protocolUrlMatch)) && urlMatch.indexOf('.') === -1;
		},

		urlMatchDoesNotHaveAtLeastOneWordChar: function urlMatchDoesNotHaveAtLeastOneWordChar(urlMatch, protocolUrlMatch) {
			if (urlMatch && protocolUrlMatch) {
				return !this.hasWordCharAfterProtocolRegex.test(urlMatch);
			} else {
				return false;
			}
		}

	};

	Autolinker.truncate.TruncateEnd = function (anchorText, truncateLen, ellipsisChars) {
		return Autolinker.Util.ellipsis(anchorText, truncateLen, ellipsisChars);
	};

	Autolinker.truncate.TruncateMiddle = function (url, truncateLen, ellipsisChars) {
		if (url.length <= truncateLen) {
			return url;
		}

		var ellipsisLengthBeforeParsing;
		var ellipsisLength;

		if (ellipsisChars == null) {
			ellipsisChars = '&hellip;';
			ellipsisLengthBeforeParsing = 8;
			ellipsisLength = 3;
		} else {
			ellipsisLengthBeforeParsing = ellipsisChars.length;
			ellipsisLength = ellipsisChars.length;
		}

		var availableLength = truncateLen - ellipsisLength;
		var end = "";
		if (availableLength > 0) {
			end = url.substr(-1 * Math.floor(availableLength / 2));
		}
		return (url.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
	};

	Autolinker.truncate.TruncateSmart = function (url, truncateLen, ellipsisChars) {

		var ellipsisLengthBeforeParsing;
		var ellipsisLength;

		if (ellipsisChars == null) {
			ellipsisChars = '&hellip;';
			ellipsisLength = 3;
			ellipsisLengthBeforeParsing = 8;
		} else {
			ellipsisLength = ellipsisChars.length;
			ellipsisLengthBeforeParsing = ellipsisChars.length;
		}

		var parse_url = function parse_url(url) {
			var urlObj = {};
			var urlSub = url;
			var match = urlSub.match(/^([a-z]+):\/\//i);
			if (match) {
				urlObj.scheme = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
			if (match) {
				urlObj.host = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
			if (match) {
				urlObj.path = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
			if (match) {
				urlObj.query = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^#(.*?)$/i);
			if (match) {
				urlObj.fragment = match[1];
			}
			return urlObj;
		};

		var buildUrl = function buildUrl(urlObj) {
			var url = "";
			if (urlObj.scheme && urlObj.host) {
				url += urlObj.scheme + "://";
			}
			if (urlObj.host) {
				url += urlObj.host;
			}
			if (urlObj.path) {
				url += "/" + urlObj.path;
			}
			if (urlObj.query) {
				url += "?" + urlObj.query;
			}
			if (urlObj.fragment) {
				url += "#" + urlObj.fragment;
			}
			return url;
		};

		var buildSegment = function buildSegment(segment, remainingAvailableLength) {
			var remainingAvailableLengthHalf = remainingAvailableLength / 2,
			    startOffset = Math.ceil(remainingAvailableLengthHalf),
			    endOffset = -1 * Math.floor(remainingAvailableLengthHalf),
			    end = "";
			if (endOffset < 0) {
				end = segment.substr(endOffset);
			}
			return segment.substr(0, startOffset) + ellipsisChars + end;
		};
		if (url.length <= truncateLen) {
			return url;
		}
		var availableLength = truncateLen - ellipsisLength;
		var urlObj = parse_url(url);

		if (urlObj.query) {
			var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
			if (matchQuery) {
				urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
				url = buildUrl(urlObj);
			}
		}
		if (url.length <= truncateLen) {
			return url;
		}
		if (urlObj.host) {
			urlObj.host = urlObj.host.replace(/^www\./, "");
			url = buildUrl(urlObj);
		}
		if (url.length <= truncateLen) {
			return url;
		}

		var str = "";
		if (urlObj.host) {
			str += urlObj.host;
		}
		if (str.length >= availableLength) {
			if (urlObj.host.length == truncateLen) {
				return (urlObj.host.substr(0, truncateLen - ellipsisLength) + ellipsisChars).substr(0, availableLength + ellipsisLengthBeforeParsing);
			}
			return buildSegment(str, availableLength).substr(0, availableLength + ellipsisLengthBeforeParsing);
		}
		var pathAndQuery = "";
		if (urlObj.path) {
			pathAndQuery += "/" + urlObj.path;
		}
		if (urlObj.query) {
			pathAndQuery += "?" + urlObj.query;
		}
		if (pathAndQuery) {
			if ((str + pathAndQuery).length >= availableLength) {
				if ((str + pathAndQuery).length == truncateLen) {
					return (str + pathAndQuery).substr(0, truncateLen);
				}
				var remainingAvailableLength = availableLength - str.length;
				return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, availableLength + ellipsisLengthBeforeParsing);
			} else {
				str += pathAndQuery;
			}
		}
		if (urlObj.fragment) {
			var fragment = "#" + urlObj.fragment;
			if ((str + fragment).length >= availableLength) {
				if ((str + fragment).length == truncateLen) {
					return (str + fragment).substr(0, truncateLen);
				}
				var remainingAvailableLength2 = availableLength - str.length;
				return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, availableLength + ellipsisLengthBeforeParsing);
			} else {
				str += fragment;
			}
		}
		if (urlObj.scheme && urlObj.host) {
			var scheme = urlObj.scheme + "://";
			if ((str + scheme).length < availableLength) {
				return (scheme + str).substr(0, truncateLen);
			}
		}
		if (str.length <= truncateLen) {
			return str;
		}
		var end = "";
		if (availableLength > 0) {
			end = str.substr(-1 * Math.floor(availableLength / 2));
		}
		return (str.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
	};

	return Autolinker;
});

/***/ }),
/* 1881 */,
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--text", style: _vm.messageColors },
    [
      [
        _c(
          "div",
          {
            staticClass: "sc-message--toolbox",
            style: { background: _vm.messageColors.backgroundColor }
          },
          [
            _vm.me && _vm.message.id != null && _vm.message.id != undefined
              ? _c(
                  "button",
                  {
                    attrs: { disabled: _vm.isEditing },
                    on: { click: _vm.edit }
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          color: _vm.isEditing
                            ? "black"
                            : _vm.messageColors.color,
                          width: "10",
                          "icon-name": "edit"
                        }
                      },
                      [_c("icon-edit")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.me && _vm.message.id != null && _vm.message.id != undefined
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$emit("remove")
                      }
                    }
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          color: _vm.messageColors.color,
                          width: "10",
                          "icon-name": "remove"
                        }
                      },
                      [_c("icon-cross")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("text-message-toolbox", null, {
              message: _vm.message,
              me: _vm.me
            })
          ],
          2
        )
      ],
      _vm._v(" "),
      _vm._t(
        "default",
        function() {
          return [
            _c("p", {
              staticClass: "sc-message--text-content",
              domProps: { innerHTML: _vm._s(_vm.messageText) }
            }),
            _vm._v(" "),
            _vm.message.data.meta
              ? _c(
                  "p",
                  {
                    staticClass: "sc-message--meta",
                    style: { color: _vm.messageColors.color }
                  },
                  [_vm._v(_vm._s(_vm.message.data.meta))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.message.isEdited
              ? _c(
                  "p",
                  { staticClass: "sc-message--edited" },
                  [
                    _c(
                      "icon-base",
                      { attrs: { width: "10", "icon-name": "edited" } },
                      [_c("icon-edit")],
                      1
                    ),
                    _vm._v(" edited\n    ")
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        {
          message: _vm.message,
          messageText: _vm.messageText,
          messageColors: _vm.messageColors,
          me: _vm.me
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc05db14", esExports)
  }
}

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4312a72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMessage_vue__ = __webpack_require__(1904);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1884)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4312a72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4312a72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/messages/FileMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c4312a72", Component.options)
  } else {
    hotAPI.reload("data-v-c4312a72", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1885);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("20e3f574", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4312a72\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileMessage.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4312a72\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-message--file[data-v-c4312a72] {\r\n  border-radius: 6px;\r\n  font-weight: 300;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  /* white-space: pre-wrap; */\r\n  -webkit-font-smoothing: subpixel-antialiased\n}\n.sc-message--content.sent .sc-message--file[data-v-c4312a72] {\r\n  word-wrap: break-word;\n}\n.sc-message--file-icon[data-v-c4312a72] {\r\n  text-align: center;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  margin-top: 15px;\r\n  margin-bottom: 0px;\n}\n.sc-image[data-v-c4312a72] {\r\n  max-width: 100%;\r\n  min-width: 100%;\n}\n.sc-file-icon[data-v-c4312a72] {\r\n  min-width: 50%;\r\n  max-width: 50%;\n}\n.sc-message--file-text[data-v-c4312a72] {\r\n  padding: 17px 20px;\r\n  border-radius: 6px;\r\n  font-weight: 300;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  white-space: pre-wrap;\r\n  -webkit-font-smoothing: subpixel-antialiased\n}\n.sc-message--file-name[data-v-c4312a72] {\r\n  color: white;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  padding-top: 0;\r\n  font-size: x-small;\r\n  text-align: center;\n}\n.sc-message--file-name a[data-v-c4312a72] {\r\n  text-decoration: none;\r\n  color: #ece7e7;\n}\n.sc-message--file-name a[data-v-c4312a72]:hover {\r\n  color: white;\n}\n.sc-message--content.sent .sc-message--file-text[data-v-c4312a72] {\r\n  color: white;\r\n  background-color: #4e8cff;\r\n  word-wrap: break-word;\n}\n.sc-message--content.received .sc-message--file[data-v-c4312a72] {\r\n  color: #263238;\r\n  background-color: #f4f7f9;\r\n  margin-right: 40px;\n}\n.sc-message--content.received .sc-message--file-name[data-v-c4312a72] {\r\n  color: #000;\n}\n.sc-message--content.received .sc-message--file a[data-v-c4312a72] {\r\n  color: rgba(43, 40, 40, 0.7);\n}\n.sc-message--content.received .sc-message--file a[data-v-c4312a72]:hover {\r\n  color: #0c0c0c;\n}\r\n", ""]);

// exports


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




var db = __webpack_require__(1887);
var extname = __webpack_require__(1889).extname;

var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
var TEXT_TYPE_REGEXP = /^text\//i;

exports.charset = charset;
exports.charsets = { lookup: charset };
exports.contentType = contentType;
exports.extension = extension;
exports.extensions = Object.create(null);
exports.lookup = lookup;
exports.types = Object.create(null);

populateMaps(exports.extensions, exports.types);

function charset(type) {
  if (!type || typeof type !== 'string') {
    return false;
  }

  var match = EXTRACT_TYPE_REGEXP.exec(type);
  var mime = match && db[match[1].toLowerCase()];

  if (mime && mime.charset) {
    return mime.charset;
  }

  if (match && TEXT_TYPE_REGEXP.test(match[1])) {
    return 'UTF-8';
  }

  return false;
}

function contentType(str) {
  if (!str || typeof str !== 'string') {
    return false;
  }

  var mime = str.indexOf('/') === -1 ? exports.lookup(str) : str;

  if (!mime) {
    return false;
  }

  if (mime.indexOf('charset') === -1) {
    var charset = exports.charset(mime);
    if (charset) mime += '; charset=' + charset.toLowerCase();
  }

  return mime;
}

function extension(type) {
  if (!type || typeof type !== 'string') {
    return false;
  }

  var match = EXTRACT_TYPE_REGEXP.exec(type);

  var exts = match && exports.extensions[match[1].toLowerCase()];

  if (!exts || !exts.length) {
    return false;
  }

  return exts[0];
}

function lookup(path) {
  if (!path || typeof path !== 'string') {
    return false;
  }

  var extension = extname('x.' + path).toLowerCase().substr(1);

  if (!extension) {
    return false;
  }

  return exports.types[extension] || false;
}

function populateMaps(extensions, types) {
  var preference = ['nginx', 'apache', undefined, 'iana'];

  Object.keys(db).forEach(function forEachMimeType(type) {
    var mime = db[type];
    var exts = mime.extensions;

    if (!exts || !exts.length) {
      return;
    }

    extensions[type] = exts;

    for (var i = 0; i < exts.length; i++) {
      var extension = exts[i];

      if (types[extension]) {
        var from = preference.indexOf(db[types[extension]].source);
        var to = preference.indexOf(mime.source);

        if (types[extension] !== 'application/octet-stream' && (from > to || from === to && types[extension].substr(0, 12) === 'application/')) {
          continue;
        }
      }

      types[extension] = type;
    }
  });
}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1888);

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),
/* 1889 */,
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./audition.svg": 1891,
	"./avi.svg": 1892,
	"./doc.svg": 1893,
	"./exe.svg": 1894,
	"./file.svg": 1141,
	"./jpg.svg": 1895,
	"./mp3.svg": 1896,
	"./mp4.svg": 1897,
	"./pdf.svg": 1898,
	"./ppt.svg": 1899,
	"./rtf.svg": 1900,
	"./txt.svg": 1901,
	"./xls.svg": 1902,
	"./zip.svg": 1903
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1890;

/***/ }),
/* 1891 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUyIDUyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MiA1MjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggc3R5bGU9ImZpbGw6IzJGNTA3NDsiIGQ9Ik00MC44MjQsNTJIMTEuMTc2QzUuMDAzLDUyLDAsNDYuOTk3LDAsNDAuODI0VjExLjE3NkMwLDUuMDAzLDUuMDAzLDAsMTEuMTc2LDBoMjkuNjQ5DQoJCUM0Ni45OTcsMCw1Miw1LjAwMyw1MiwxMS4xNzZ2MjkuNjQ5QzUyLDQ2Ljk5Nyw0Ni45OTcsNTIsNDAuODI0LDUyeiIvPg0KCTxnPg0KCQk8cGF0aCBzdHlsZT0iZmlsbDojMDBGNUYxOyIgZD0iTTI4LjA4LDM5aC0zLjI0bC0yLjc2LTkuMDRoLTguMzJMMTEuMTIsMzlIOGw4LjIzOS0yOGgzLjMyTDI4LjA4LDM5eiBNMjEuMzU5LDI3TDE3Ljg4LDE1LjY0DQoJCQlMMTQuNTIsMjdIMjEuMzU5eiIvPg0KCQk8cGF0aCBzdHlsZT0iZmlsbDojMDBGNUYxOyIgZD0iTTQzLjg0LDM5aC0yLjc2di0xLjQ4Yy0xLjE0NywxLjI4LTIuNjk0LDEuOTIxLTQuNjQxLDEuOTIxYy01LjAxNCwwLTcuNTItMi40NC03LjUyLTcuMzJWMTguOTYNCgkJCWgyLjg4djEzLjE2YzAsMy4wNjYsMS41NDYsNC42LDQuNjQsNC42YzMuMDE0LDAsNC41MjEtMS41NDYsNC41MjEtNC42NFYxOC45NmgyLjg4VjM5eiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 1892 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDU2IDU2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1NiA1NjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggc3R5bGU9ImZpbGw6I0U5RTlFMDsiIGQ9Ik0zNi45ODUsMEg3Ljk2M0M3LjE1NSwwLDYuNSwwLjY1NSw2LjUsMS45MjZWNTVjMCwwLjM0NSwwLjY1NSwxLDEuNDYzLDFoNDAuMDc0DQoJCWMwLjgwOCwwLDEuNDYzLTAuNjU1LDEuNDYzLTFWMTIuOTc4YzAtMC42OTYtMC4wOTMtMC45Mi0wLjI1Ny0xLjA4NUwzNy42MDcsMC4yNTdDMzcuNDQyLDAuMDkzLDM3LjIxOCwwLDM2Ljk4NSwweiIvPg0KCTxwYXRoIHN0eWxlPSJmaWxsOiNGRjUzNjQ7IiBkPSJNNDguMDM3LDU2SDcuOTYzQzcuMTU1LDU2LDYuNSw1NS4zNDUsNi41LDU0LjUzN1YzOWg0M3YxNS41MzdDNDkuNSw1NS4zNDUsNDguODQ1LDU2LDQ4LjAzNyw1NnoiLz4NCgk8Zz4NCgkJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik0yMi40LDQyLjkyNGgxLjY2OFY1M0gyMi40di02LjkzMmwtMi4yNTYsNS42MDVoLTEuNDQ5bC0yLjI3LTUuNjA1VjUzaC0xLjY2OFY0Mi45MjRoMS42NjgNCgkJCWwyLjk5NCw2Ljg5MUwyMi40LDQyLjkyNHoiLz4NCgkJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik0yOC4yMTEsNTNIMjYuNTdWNDIuOTI0aDIuODk4YzAuNDI4LDAsMC44NTIsMC4wNjgsMS4yNzEsMC4yMDUNCgkJCWMwLjQxOSwwLjEzNywwLjc5NSwwLjM0MiwxLjEyOCwwLjYxNWMwLjMzMywwLjI3MywwLjYwMiwwLjYwNCwwLjgwNywwLjk5MXMwLjMwOCwwLjgyMiwwLjMwOCwxLjMwNg0KCQkJYzAsMC41MTEtMC4wODcsMC45NzMtMC4yNiwxLjM4OGMtMC4xNzMsMC40MTUtMC40MTUsMC43NjQtMC43MjUsMS4wNDZjLTAuMzEsMC4yODItMC42ODQsMC41MDEtMS4xMjEsMC42NTYNCgkJCXMtMC45MjEsMC4yMzItMS40NDksMC4yMzJoLTEuMjE3VjUzeiBNMjguMjExLDQ0LjE2OHYzLjk5MmgxLjUwNGMwLjIsMCwwLjM5OC0wLjAzNCwwLjU5NS0wLjEwMw0KCQkJYzAuMTk2LTAuMDY4LDAuMzc2LTAuMTgsMC41NC0wLjMzNXMwLjI5Ni0wLjM3MSwwLjM5Ni0wLjY0OWMwLjEtMC4yNzgsMC4xNS0wLjYyMiwwLjE1LTEuMDMyYzAtMC4xNjQtMC4wMjMtMC4zNTQtMC4wNjgtMC41NjcNCgkJCWMtMC4wNDYtMC4yMTQtMC4xMzktMC40MTktMC4yOC0wLjYxNWMtMC4xNDItMC4xOTYtMC4zNC0wLjM2LTAuNTk1LTAuNDkyYy0wLjI1NS0wLjEzMi0wLjU5My0wLjE5OC0xLjAxMi0wLjE5OEgyOC4yMTF6Ii8+DQoJCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMzguNDc5LDUwLjY0OGgtNC4zNjFWNDkuMzVsNC4zNjEtNi40MjZoMS42Njh2Ni40MjZoMS4wNTN2MS4yOTloLTEuMDUzVjUzaC0xLjY2OFY1MC42NDh6DQoJCQkgTTM4LjQ3OSw0OS4zNXYtNC41MTJMMzUuNTgsNDkuMzVIMzguNDc5eiIvPg0KCTwvZz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojQzhCREI4OyIgZD0iTTI0LjUsMjhjLTAuMTY2LDAtMC4zMzEtMC4wNDEtMC40ODEtMC4xMjNDMjMuNjk5LDI3LjcwMSwyMy41LDI3LjM2NSwyMy41LDI3VjEzDQoJCWMwLTAuMzY1LDAuMTk5LTAuNzAxLDAuNTE5LTAuODc3YzAuMzIxLTAuMTc1LDAuNzEtMC4xNjIsMS4wMTksMC4wMzNsMTEsN0MzNi4zMjUsMTkuMzQsMzYuNSwxOS42NTgsMzYuNSwyMA0KCQlzLTAuMTc1LDAuNjYtMC40NjMsMC44NDRsLTExLDdDMjQuODc0LDI3Ljk0NywyNC42ODcsMjgsMjQuNSwyOHogTTI1LjUsMTQuODIxdjEwLjM1N0wzMy42MzcsMjBMMjUuNSwxNC44MjF6Ii8+DQoJPHBhdGggc3R5bGU9ImZpbGw6I0M4QkRCODsiIGQ9Ik0yOC41LDM1Yy04LjI3MSwwLTE1LTYuNzI5LTE1LTE1czYuNzI5LTE1LDE1LTE1czE1LDYuNzI5LDE1LDE1UzM2Ljc3MSwzNSwyOC41LDM1eiBNMjguNSw3DQoJCWMtNy4xNjgsMC0xMyw1LjgzMi0xMywxM3M1LjgzMiwxMywxMywxM3MxMy01LjgzMiwxMy0xM1MzNS42NjgsNywyOC41LDd6Ii8+DQoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0Q5RDdDQTsiIHBvaW50cz0iMzcuNSwwLjE1MSAzNy41LDEyIDQ5LjM0OSwxMiAJIi8+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-message--file",
      style: _vm.messageColors,
      on: { click: _vm.onFileMessageClick }
    },
    [
      _c("div", { staticClass: "sc-message--file-icon" }, [
        _c("a", { attrs: { href: "#" } }, [
          _vm.data.file.type
            ? _c("img", {
                class: {
                  "sc-image": true,
                  "sc-file-icon": !_vm.data.file.type.includes("image")
                },
                attrs: {
                  src: _vm.data.file.type.includes("image")
                    ? _vm.data.url
                    : _vm.getNonImageFileIcon(_vm.data.file.type)
                }
              })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-name", style: _vm.messageColors },
        [
          _c("a", { attrs: { href: "#", target: "_blank" } }, [
            _vm._v(_vm._s(_vm.data.file.name || ""))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-text", style: _vm.messageColors },
        [
          _vm._v(_vm._s(_vm.data.text)),
          _vm.data.meta
            ? _c(
                "p",
                { staticClass: "sc-message--meta", style: _vm.messageColors },
                [_vm._v(_vm._s(_vm.data.meta))]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4312a72", esExports)
  }
}

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e079ae96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiMessage_vue__ = __webpack_require__(1908);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1906)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e079ae96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e079ae96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/messages/EmojiMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e079ae96", Component.options)
  } else {
    hotAPI.reload("data-v-e079ae96", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1907);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("19f13b17", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e079ae96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmojiMessage.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e079ae96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmojiMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-message--emoji[data-v-e079ae96] {\r\n  font-size: 40px;\n}\r\n", ""]);

// exports


/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sc-message--emoji" }, [
    _vm._v(_vm._s(_vm.data.emoji))
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e079ae96", esExports)
  }
}

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634ebeec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingMessage_vue__ = __webpack_require__(1912);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1910)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-634ebeec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634ebeec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/messages/TypingMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-634ebeec", Component.options)
  } else {
    hotAPI.reload("data-v-634ebeec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1911);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("e4d10dc4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-634ebeec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TypingMessage.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-634ebeec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TypingMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-typing-indicator[data-v-634ebeec] {\r\n  text-align: center;\r\n  padding: 17px 20px;\r\n  border-radius: 6px;\n}\n.sc-typing-indicator span[data-v-634ebeec] {\r\n  display: inline-block;\r\n  background-color: #B6B5BA;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 100%;\r\n  margin-right: 3px;\r\n  -webkit-animation: bob-data-v-634ebeec 2s infinite;\r\n          animation: bob-data-v-634ebeec 2s infinite;\n}\r\n\r\n/* SAFARI GLITCH */\n.sc-typing-indicator span[data-v-634ebeec]:nth-child(1) {\r\n  -webkit-animation-delay: -1s;\r\n          animation-delay: -1s;\n}\n.sc-typing-indicator span[data-v-634ebeec]:nth-child(2) {\r\n  -webkit-animation-delay: -0.85s;\r\n          animation-delay: -0.85s;\n}\n.sc-typing-indicator span[data-v-634ebeec]:nth-child(3) {\r\n  -webkit-animation-delay: -0.7s;\r\n          animation-delay: -0.7s;\n}\n@-webkit-keyframes bob-data-v-634ebeec {\n10% {\r\n    -webkit-transform: translateY(-10px);\r\n            transform: translateY(-10px);\r\n    background-color: #9E9DA2;\n}\n50% {\r\n    -webkit-transform: translateY(0);\r\n            transform: translateY(0);\r\n    background-color: #B6B5BA;\n}\n}\n@keyframes bob-data-v-634ebeec {\n10% {\r\n    -webkit-transform: translateY(-10px);\r\n            transform: translateY(-10px);\r\n    background-color: #9E9DA2;\n}\n50% {\r\n    -webkit-transform: translateY(0);\r\n            transform: translateY(0);\r\n    background-color: #B6B5BA;\n}\n}\r\n", ""]);

// exports


/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-typing-indicator", style: _vm.messageColors },
    [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-634ebeec", esExports)
  }
}

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf652198_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemMessage_vue__ = __webpack_require__(1916);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1914)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf652198"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf652198_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/messages/SystemMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bf652198", Component.options)
  } else {
    hotAPI.reload("data-v-bf652198", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1915);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("261d1fe8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bf652198\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SystemMessage.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bf652198\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SystemMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-message--system[data-v-bf652198] {\r\n  padding: 8px 20px;\r\n  border-radius: 6px;\r\n  font-weight: 300;\r\n  font-size: 12px;\r\n  line-height: 1.2;\r\n  white-space: pre-wrap;\r\n  -webkit-font-smoothing: subpixel-antialiased;\r\n  font-style: italic;\r\n  opacity: .55;\n}\n.sc-message--meta[data-v-bf652198] {\r\n  font-size: xx-small;\r\n  margin-bottom: 0px;\r\n  margin-top: 5px;\r\n  opacity: .5;\r\n  text-align: center;\n}\r\n", ""]);

// exports


/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--system", style: _vm.messageColors },
    [
      _vm._t(
        "default",
        function() {
          return [
            _vm._v("\n    " + _vm._s(_vm.data.text)),
            _vm.data.meta
              ? _c(
                  "p",
                  {
                    staticClass: "sc-message--meta",
                    style: { color: _vm.messageColors.color }
                  },
                  [_vm._v(_vm._s(_vm.data.meta))]
                )
              : _vm._e()
          ]
        },
        { message: _vm.data }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf652198", esExports)
  }
}

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sc-message" }, [
    _c(
      "div",
      {
        staticClass: "sc-message--content",
        class: {
          sent: _vm.message.author === "me",
          received:
            _vm.message.author !== "me" && _vm.message.type !== "system",
          system: _vm.message.type === "system"
        }
      },
      [
        _vm._t(
          "user-avatar",
          function() {
            return [
              _vm.message.type !== "system"
                ? _c("div", {
                    staticClass: "sc-message--avatar",
                    style: {
                      backgroundImage: "url(" + _vm.chatImageUrl + ")"
                    },
                    attrs: { title: _vm.authorName }
                  })
                : _vm._e()
            ]
          },
          { message: _vm.message, user: _vm.user }
        ),
        _vm._v(" "),
        _vm.message.type === "text"
          ? _c("TextMessage", {
              attrs: {
                message: _vm.message,
                messageColors: _vm.determineMessageColors(),
                messageStyling: _vm.messageStyling
              },
              on: {
                remove: function($event) {
                  return _vm.$emit("remove")
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(scopedProps) {
                      return [
                        _vm._t("text-message-body", null, {
                          message: scopedProps.message,
                          messageText: scopedProps.messageText,
                          messageColors: scopedProps.messageColors,
                          me: scopedProps.me
                        })
                      ]
                    }
                  },
                  {
                    key: "text-message-toolbox",
                    fn: function(scopedProps) {
                      return [
                        _vm._t("text-message-toolbox", null, {
                          message: scopedProps.message,
                          me: scopedProps.me
                        })
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          : _vm.message.type === "emoji"
          ? _c("EmojiMessage", { attrs: { data: _vm.message.data } })
          : _vm.message.type === "file"
          ? _c("FileMessage", {
              attrs: {
                data: _vm.message.data,
                messageColors: _vm.determineMessageColors()
              }
            })
          : _vm.message.type === "typing"
          ? _c("TypingMessage", {
              attrs: { messageColors: _vm.determineMessageColors() }
            })
          : _vm.message.type === "system"
          ? _c(
              "SystemMessage",
              {
                attrs: {
                  data: _vm.message.data,
                  messageColors: _vm.determineMessageColors()
                }
              },
              [
                _vm._t("system-message-body", null, {
                  message: _vm.message.data
                })
              ],
              2
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-327f51f8", esExports)
  }
}

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollList",
      staticClass: "sc-message-list",
      style: { backgroundColor: _vm.colors.messageList.bg },
      on: { scroll: _vm.handleScroll }
    },
    [
      _vm._l(_vm.messages, function(message, idx) {
        return _c("Message", {
          key: idx,
          attrs: {
            message: message,
            user: _vm.profile(message.author),
            colors: _vm.colors,
            messageStyling: _vm.messageStyling
          },
          on: {
            remove: function($event) {
              return _vm.$emit("remove", message)
            }
          },
          scopedSlots: _vm._u(
            [
              {
                key: "user-avatar",
                fn: function(scopedProps) {
                  return [
                    _vm._t("user-avatar", null, {
                      user: scopedProps.user,
                      message: scopedProps.message
                    })
                  ]
                }
              },
              {
                key: "text-message-body",
                fn: function(scopedProps) {
                  return [
                    _vm._t("text-message-body", null, {
                      message: scopedProps.message,
                      messageText: scopedProps.messageText,
                      messageColors: scopedProps.messageColors,
                      me: scopedProps.me
                    })
                  ]
                }
              },
              {
                key: "text-message-toolbox",
                fn: function(scopedProps) {
                  return [
                    _vm._t("text-message-toolbox", null, {
                      message: scopedProps.message,
                      me: scopedProps.me
                    })
                  ]
                }
              }
            ],
            null,
            true
          )
        })
      }),
      _vm._v(" "),
      _c("Message", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTypingIndicator !== "",
            expression: "showTypingIndicator !== ''"
          }
        ],
        attrs: {
          message: { author: _vm.showTypingIndicator, type: "typing" },
          user: {},
          colors: _vm.colors,
          messageStyling: _vm.messageStyling
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f6f9094", esExports)
  }
}

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInput_vue__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInput_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInput_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInput_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06850670_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInput_vue__ = __webpack_require__(1949);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1920)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06850670_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/UserInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06850670", Component.options)
  } else {
    hotAPI.reload("data-v-06850670", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1921);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("e0223cf2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06850670\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInput.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06850670\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-user-input {\r\n  min-height: 55px;\r\n  margin: 0px;\r\n  position: relative;\r\n  bottom: 0;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  background-color: #f4f7f9;\r\n  border-bottom-left-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n  -webkit-transition: background-color 0.2s ease, -webkit-box-shadow 0.2s ease;\r\n  transition: background-color 0.2s ease, -webkit-box-shadow 0.2s ease;\r\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\r\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, -webkit-box-shadow 0.2s ease;\n}\n.sc-user-input--text {\r\n  width: 300px;\r\n  resize: none;\r\n  border: none;\r\n  outline: none;\r\n  border-bottom-left-radius: 10px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding: 18px;\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  line-height: 1.33;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n  color: #565867;\r\n  -webkit-font-smoothing: antialiased;\r\n  max-height: 200px;\r\n  overflow: scroll;\r\n  bottom: 0;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\n}\n.sc-user-input--text:empty:before {\r\n  content: attr(placeholder);\r\n  display: block; /* For Firefox */\r\n  /* color: rgba(86, 88, 103, 0.3); */\r\n  -webkit-filter: contrast(15%);\r\n          filter: contrast(15%);\r\n  outline: none;\r\n  cursor: text;\n}\n.sc-user-input--buttons {\r\n  width: 100px;\r\n  position: absolute;\r\n  right: 30px;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: end;\r\n      -ms-flex-pack: end;\r\n          justify-content: flex-end;\n}\n.sc-user-input--button:first-of-type {\r\n  width: 40px;\n}\n.sc-user-input--button {\r\n  width: 30px;\r\n  height: 55px;\r\n  margin-left: 2px;\r\n  margin-right: 2px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\n}\n.sc-user-input.active {\r\n  -webkit-box-shadow: none;\r\n          box-shadow: none;\r\n  background-color: white;\r\n  -webkit-box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);\r\n          box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);\n}\n.sc-user-input--button label {\r\n  position: relative;\r\n  height: 24px;\r\n  padding-left: 3px;\r\n  cursor: pointer;\n}\n.sc-user-input--button label:hover path {\r\n  fill: rgba(86, 88, 103, 1);\n}\n.sc-user-input--button input {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: 99999;\r\n  height: 100%;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  overflow: hidden;\n}\n.file-container {\r\n  background-color: #f4f7f9;\r\n  border-top-left-radius: 10px;\r\n  padding: 5px 20px;\r\n  color: #565867;\n}\n.delete-file-message {\r\n  font-style: normal;\r\n  float: right;\r\n  cursor: pointer;\r\n  color: #c8cad0;\n}\n.delete-file-message:hover {\r\n  color: #5d5e6d;\n}\n.icon-file-message {\r\n  margin-right: 5px;\n}\r\n", ""]);

// exports


/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ea49b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiIcon_vue__ = __webpack_require__(1931);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1923)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c9ea49b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ea49b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/icons/EmojiIcon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c9ea49b", Component.options)
  } else {
    hotAPI.reload("data-v-6c9ea49b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1924);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b4075ab8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6c9ea49b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmojiIcon.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6c9ea49b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmojiIcon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-user-input--emoji-icon-wrapper[data-v-6c9ea49b] {\r\n  background: none;\r\n  border: none;\r\n  padding: 0px;\r\n  margin: 0px;\r\n  outline: none;\n}\n.sc-user-input--emoji-icon-wrapper[data-v-6c9ea49b]:focus {\r\n  outline: none;\n}\n.sc-user-input--emoji-icon[data-v-6c9ea49b] {\r\n  height: 18px;\r\n  cursor: pointer;\r\n  -ms-flex-item-align: center;\r\n      align-self: center;\n}\n.sc-user-input--emoji-icon-wrapper:focus .sc-user-input--emoji-icon path[data-v-6c9ea49b],\r\n.sc-user-input--emoji-icon-wrapper:focus .sc-user-input--emoji-icon circle[data-v-6c9ea49b],\r\n.sc-user-input--emoji-icon.active path[data-v-6c9ea49b],\r\n.sc-user-input--emoji-icon.active circle[data-v-6c9ea49b],\r\n.sc-user-input--emoji-icon:hover path[data-v-6c9ea49b],\r\n.sc-user-input--emoji-icon:hover circle[data-v-6c9ea49b] {\r\n  -webkit-filter: contrast(15%);\r\n          filter: contrast(15%);\n}\r\n", ""]);

// exports


/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74943136_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiPicker_vue__ = __webpack_require__(1930);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1926)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74943136"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74943136_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmojiPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/EmojiPicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74943136", Component.options)
  } else {
    hotAPI.reload("data-v-74943136", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1927);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0f6e9173", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74943136\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmojiPicker.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74943136\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmojiPicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-emoji-picker[data-v-74943136] {\r\n  position: absolute;\r\n  bottom: 50px;\r\n  right: 0px;\r\n  width: 330px;\r\n  max-height: 215px;\r\n  -webkit-box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.3);\r\n          box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.3);\r\n  background: white;\r\n  border-radius: 10px;\r\n  outline: none;\n}\n.sc-emoji-picker[data-v-74943136]:after {\r\n  content: \"\";\r\n  width: 14px;\r\n  height: 14px;\r\n  background: white;\r\n  position: absolute;\r\n  bottom: -6px;\r\n  right: 55px;\r\n  -webkit-transform: rotate(45deg);\r\n          transform: rotate(45deg);\r\n  border-radius: 2px;\n}\n.sc-emoji-picker--content[data-v-74943136] {\r\n  padding: 10px;\r\n  overflow: auto;\r\n  width: 100%;\r\n  max-height: 195px;\r\n  margin-top: 7px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\n}\n.sc-emoji-picker--category[data-v-74943136] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\n}\n.sc-emoji-picker--category-title[data-v-74943136] {\r\n  min-width: 100%;\r\n  color: #b8c3ca;\r\n  font-weight: 200;\r\n  font-size: 13px;\r\n  margin: 5px;\r\n  letter-spacing: 1px;\n}\n.sc-emoji-picker--emoji[data-v-74943136] {\r\n  margin: 5px;\r\n  width: 30px;\r\n  line-height: 30px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  font-size: 28px;\r\n  transition: transform 60ms ease-out,-webkit-transform 60ms ease-out;\n}\n.sc-emoji-picker--emoji[data-v-74943136]:hover {\r\n  -webkit-transform: scale(1.4);\r\n          transform: scale(1.4);\n}\r\n", ""]);

// exports


/***/ }),
/* 1928 */,
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: 'People',
  emojis: ['😄', '😃', '😀', '😊', '😉', '😍', '😘', '😚', '😗', '😙', '😜', '😝', '😛', '😳', '😁', '😔', '😌', '😒', '😞', '😣', '😢', '😂', '😭', '😪', '😥', '😰', '😅', '😓', '😩', '😫', '😨', '😱', '😠', '😡', '😤', '😖', '😆', '😋', '😷', '😎', '😴', '😵', '😲', '😟', '😦', '😧', '👿', '😮', '😬', '😐', '😕', '😯', '😏', '😑', '👲', '👳', '👮', '👷', '💂', '👶', '👦', '👧', '👨', '👩', '👴', '👵', '👱', '👼', '👸', '😺', '😸', '😻', '😽', '😼', '🙀', '😿', '😹', '😾', '👹', '👺', '🙈', '🙉', '🙊', '💀', '👽', '💩', '🔥', '✨', '🌟', '💫', '💥', '💢', '💦', '💧', '💤', '💨', '👂', '👀', '👃', '👅', '👄', '👍', '👎', '👌', '👊', '✊', '👋', '✋', '👐', '👆', '👇', '👉', '👈', '🙌', '🙏', '👏', '💪', '🚶', '🏃', '💃', '👫', '👪', '💏', '💑', '👯', '🙆', '🙅', '💁', '🙋', '💆', '💇', '💅', '👰', '🙎', '🙍', '🙇', '🎩', '👑', '👒', '👟', '👞', '👡', '👠', '👢', '👕', '👔', '👚', '👗', '🎽', '👖', '👘', '👙', '💼', '👜', '👝', '👛', '👓', '🎀', '🌂', '💄', '💛', '💙', '💜', '💚', '💔', '💗', '💓', '💕', '💖', '💞', '💘', '💌', '💋', '💍', '💎', '👤', '💬', '👣']
}, {
  name: 'Nature',
  emojis: ['🐶', '🐺', '🐱', '🐭', '🐹', '🐰', '🐸', '🐯', '🐨', '🐻', '🐷', '🐽', '🐮', '🐗', '🐵', '🐒', '🐴', '🐑', '🐘', '🐼', '🐧', '🐦', '🐤', '🐥', '🐣', '🐔', '🐍', '🐢', '🐛', '🐝', '🐜', '🐞', '🐌', '🐙', '🐚', '🐠', '🐟', '🐬', '🐳', '🐎', '🐲', '🐡', '🐫', '🐩', '🐾', '💐', '🌸', '🌷', '🍀', '🌹', '🌻', '🌺', '🍁', '🍃', '🍂', '🌿', '🌾', '🍄', '🌵', '🌴', '🌰', '🌱', '🌼', '🌑', '🌓', '🌔', '🌕', '🌛', '🌙', '🌏', '🌋', '🌌', '🌠', '⛅', '⛄', '🌀', '🌁', '🌈', '🌊']
}, {
  name: 'Objects',
  emojis: ['🎍', '💝', '🎎', '🎒', '🎓', '🎏', '🎆', '🎇', '🎐', '🎑', '🎃', '👻', '🎅', '🎄', '🎁', '🎋', '🎉', '🎊', '🎈', '🎌', '🔮', '🎥', '📷', '📹', '📼', '💿', '📀', '💽', '💾', '💻', '📱', '📞', '📟', '📠', '📡', '📺', '📻', '🔊', '🔔', '📢', '📣', '⏳', '⌛', '⏰', '⌚', '🔓', '🔒', '🔏', '🔐', '🔑', '🔎', '💡', '🔦', '🔌', '🔋', '🔍', '🛀', '🚽', '🔧', '🔩', '🔨', '🚪', '🚬', '💣', '🔫', '🔪', '💊', '💉', '💰', '💴', '💵', '💳', '💸', '📲', '📧', '📥', '📤', '📩', '📨', '📫', '📪', '📮', '📦', '📝', '📄', '📃', '📑', '📊', '📈', '📉', '📜', '📋', '📅', '📆', '📇', '📁', '📂', '📌', '📎', '📏', '📐', '📕', '📗', '📘', '📙', '📓', '📔', '📒', '📚', '📖', '🔖', '📛', '📰', '🎨', '🎬', '🎤', '🎧', '🎼', '🎵', '🎶', '🎹', '🎻', '🎺', '🎷', '🎸', '👾', '🎮', '🃏', '🎴', '🀄', '🎲', '🎯', '🏈', '🏀', '⚽', '⚾', '🎾', '🎱', '🎳', '⛳', '🏁', '🏆', '🎿', '🏂', '🏊', '🏄', '🎣', '🍵', '🍶', '🍺', '🍻', '🍸', '🍹', '🍷', '🍴', '🍕', '🍔', '🍟', '🍗', '🍖', '🍝', '🍛', '🍤', '🍱', '🍣', '🍥', '🍙', '🍘', '🍚', '🍜', '🍲', '🍢', '🍡', '🍳', '🍞', '🍩', '🍮', '🍦', '🍨', '🍧', '🎂', '🍰', '🍪', '🍫', '🍬', '🍭', '🍯', '🍎', '🍏', '🍊', '🍒', '🍇', '🍉', '🍓', '🍑', '🍈', '🍌', '🍍', '🍠', '🍆', '🍅', '🌽']
}, {
  name: 'Places',
  emojis: ['🏠', '🏡', '🏫', '🏢', '🏣', '🏥', '🏦', '🏪', '🏩', '🏨', '💒', '⛪', '🏬', '🌇', '🌆', '🏯', '🏰', '⛺', '🏭', '🗼', '🗾', '🗻', '🌄', '🌅', '🌃', '🗽', '🌉', '🎠', '🎡', '⛲', '🎢', '🚢', '⛵', '🚤', '🚀', '💺', '🚉', '🚄', '🚅', '🚇', '🚃', '🚌', '🚙', '🚗', '🚕', '🚚', '🚨', '🚓', '🚒', '🚑', '🚲', '💈', '🚏', '🎫', '🚥', '🚧', '🔰', '⛽', '🏮', '🎰', '🗿', '🎪', '🎭', '📍', '🚩']
}, {
  name: 'Symbols',
  emojis: ['🔟', '🔢', '🔣', '🔠', '🔡', '🔤', '🔼', '🔽', '⏪', '⏩', '⏫', '⏬', '🆗', '🆕', '🆙', '🆒', '🆓', '🆖', '📶', '🎦', '🈁', '🈯', '🈳', '🈵', '🈴', '🈲', '🉐', '🈹', '🈺', '🈶', '🈚', '🚻', '🚹', '🚺', '🚼', '🚾', '🚭', '🈸', '🉑', '🆑', '🆘', '🆔', '🚫', '🔞', '⛔', '❎', '✅', '💟', '🆚', '📳', '📴', '🆎', '💠', '⛎', '🔯', '🏧', '💹', '💲', '💱', '❌', '❗', '❓', '❕', '❔', '⭕', '🔝', '🔚', '🔙', '🔛', '🔜', '🔃', '🕛', '🕐', '🕑', '🕒', '🕓', '🕔', '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '➕', '➖', '➗', '💮', '💯', '🔘', '🔗', '➰', '🔱', '🔺', '🔲', '🔳', '🔴', '🔵', '🔻', '⬜', '⬛', '🔶', '🔷', '🔸', '🔹']
}];

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "domNode",
      staticClass: "sc-emoji-picker",
      attrs: { tabIndex: "0" },
      on: { blur: _vm.onBlur }
    },
    [
      _c(
        "div",
        { staticClass: "sc-emoji-picker--content" },
        _vm._l(_vm.emojiData, function(category) {
          return _c(
            "div",
            { key: category.name, staticClass: "sc-emoji-picker--category" },
            [
              _c("div", { staticClass: "sc-emoji-picker--category-title" }, [
                _vm._v(_vm._s(category.name))
              ]),
              _vm._v(" "),
              _vm._l(category.emojis, function(emoji) {
                return _c(
                  "span",
                  {
                    key: emoji,
                    staticClass: "sc-emoji-picker--emoji",
                    on: {
                      click: function($event) {
                        return _vm.emojiClicked(emoji)
                      }
                    }
                  },
                  [_vm._v("\n          " + _vm._s(emoji) + "\n        ")]
                )
              })
            ],
            2
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74943136", esExports)
  }
}

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-user-input--picker-wrapper" },
    [
      _vm.isActive
        ? _c("EmojiPicker", {
            attrs: {
              onEmojiPicked: _vm.onEmojiPicked,
              onBlur: _vm._handlePickerBlur
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "sc-user-input--emoji-icon-wrapper",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm._openPicker.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "svg",
            {
              staticClass: "sc-user-input--emoji-icon",
              class: { active: _vm.isActive },
              attrs: {
                version: "1.1",
                id: "Layer_2",
                xmlns: "http://www.w3.org/2000/svg",
                x: "0px",
                y: "0px",
                width: "37.393px",
                height: "37.393px",
                viewBox: "0 0 37.393 37.393",
                enableBackground: "new 0 0 37.393 37.393"
              }
            },
            [
              _c("g", [
                _c("path", {
                  style: { fill: _vm.color },
                  attrs: {
                    d:
                      "M18.696,37.393C8.387,37.393,0,29.006,0,18.696C0,8.387,8.387,0,18.696,0c10.31,0,18.696,8.387,18.696,18.696\n            C37.393,29.006,29.006,37.393,18.696,37.393z M18.696,2C9.49,2,2,9.49,2,18.696c0,9.206,7.49,16.696,16.696,16.696\n            c9.206,0,16.696-7.49,16.696-16.696C35.393,9.49,27.902,2,18.696,2z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("circle", {
                  style: { fill: _vm.color },
                  attrs: { cx: "12.379", cy: "14.359", r: "1.938" }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("circle", {
                  style: { fill: _vm.color },
                  attrs: { cx: "24.371", cy: "14.414", r: "1.992" }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  style: { fill: _vm.color },
                  attrs: {
                    d:
                      "M18.035,27.453c-5.748,0-8.342-4.18-8.449-4.357c-0.286-0.473-0.135-1.087,0.338-1.373\n            c0.471-0.286,1.084-0.136,1.372,0.335c0.094,0.151,2.161,3.396,6.74,3.396c4.713,0,7.518-3.462,7.545-3.497\n            c0.343-0.432,0.973-0.504,1.405-0.161c0.433,0.344,0.505,0.973,0.161,1.405C27.009,23.374,23.703,27.453,18.035,27.453z"
                  }
                })
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c9ea49b", esExports)
  }
}

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileIcons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35eada3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileIcons_vue__ = __webpack_require__(1935);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1933)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35eada3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileIcons_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35eada3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileIcons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/icons/FileIcons.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35eada3a", Component.options)
  } else {
    hotAPI.reload("data-v-35eada3a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1934);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("72dd8836", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35eada3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileIcons.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35eada3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileIcons.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n#file-input[data-v-35eada3a] {\r\n  cursor: pointer;\n}\n.sc-user-input--file-icon-wrapper[data-v-35eada3a] {\r\n  background: none;\r\n  border: none;\r\n  padding: 0px;\r\n  margin: 0px;\r\n  outline: none;\r\n  cursor: pointer;\n}\n.sc-user-input--file-icon[data-v-35eada3a] {\r\n  height: 20px;\r\n  width: 20px;\r\n  -ms-flex-item-align: center;\r\n      align-self: center;\r\n  outline: none;\n}\n.sc-user-input--file-icon:hover path[data-v-35eada3a] {\r\n  -webkit-filter: contrast(15%);\r\n          filter: contrast(15%);\n}\r\n", ""]);

// exports


/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { position: "relative" } }, [
    _c(
      "button",
      {
        staticClass: "sc-user-input--file-icon-wrapper",
        attrs: { type: "button" }
      },
      [
        _c(
          "svg",
          {
            staticClass: "sc-user-input--file-icon",
            attrs: {
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              x: "0px",
              y: "0px",
              width: "24px",
              height: "24px",
              viewBox: "0 0 37.393 37.393",
              enableBackground: "new 0 0 37.393 37.393"
            }
          },
          [
            _c("path", {
              style: { fill: _vm.color },
              attrs: {
                d:
                  "M20.807 10.22l-2.030-2.029-10.15 10.148c-1.682 1.681-1.682 4.408 0 6.089s4.408 1.681 6.090 0l12.18-12.178c2.804-2.802 2.804-7.346 0-10.148-2.802-2.803-7.347-2.803-10.149 0l-12.788 12.787c-0.009 0.009-0.019 0.018-0.027 0.026-3.909 3.909-3.909 10.245 0 14.153 3.908 3.908 10.246 3.908 14.156 0 0.009-0.009 0.016-0.018 0.026-0.027l0.001 0.001 8.729-8.728-2.031-2.029-8.729 8.727c-0.009 0.008-0.018 0.018-0.026 0.026-2.784 2.783-7.312 2.783-10.096 0-2.783-2.783-2.783-7.31 0-10.093 0.010-0.009 0.019-0.018 0.028-0.026l-0.001-0.002 12.79-12.786c1.678-1.679 4.411-1.679 6.090 0s1.678 4.411 0 6.089l-12.18 12.178c-0.56 0.56-1.47 0.56-2.030 0-0.559-0.559-0.559-1.47 0-2.029l10.15-10.149z"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "file", id: "file-input" },
          on: { change: _vm._handleChange, click: _vm._handleClick }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35eada3a", esExports)
  }
}

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInputButton_vue__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInputButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInputButton_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInputButton_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInputButton_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f4427c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInputButton_vue__ = __webpack_require__(1939);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1937)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60f4427c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInputButton_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f4427c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInputButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/UserInputButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60f4427c", Component.options)
  } else {
    hotAPI.reload("data-v-60f4427c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1938);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b4035598", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60f4427c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInputButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60f4427c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInputButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-user-input--button-icon-wrapper[data-v-60f4427c] {\r\n  background: none;\r\n  border: none;\r\n  padding: 0px;\r\n  margin: 0px;\r\n  outline: none;\r\n  cursor: pointer;\n&:focus{\r\n    outline: none;\n}\nsvg {\r\n    height: 20px;\r\n    width: 20px;\r\n    cursor: pointer;\r\n    -ms-flex-item-align: center;\r\n        align-self: center;\r\n    outline: none;\n&:hover path{\r\n      -webkit-filter: contrast(15%);\r\n              filter: contrast(15%);\n}\n}\n}\r\n", ""]);

// exports


/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "sc-user-input--button-icon-wrapper" },
    [
      _c(
        "icon-base",
        {
          attrs: {
            color: _vm.color,
            width: "20",
            height: "20",
            "icon-name": _vm.tooltip
          }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60f4427c", esExports)
  }
}

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11adff40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suggestions_vue__ = __webpack_require__(1943);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1941)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suggestions_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11adff40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suggestions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/Suggestions.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-11adff40", Component.options)
  } else {
    hotAPI.reload("data-v-11adff40", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1942);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0bcd1c84", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-11adff40\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Suggestions.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-11adff40\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Suggestions.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.sc-suggestions-row {\r\n  text-align: center;\r\n  background: inherit;\n}\n.sc-suggestions-element {\r\n  margin: 3px;\r\n  padding: 5px 10px 5px 10px;\r\n  border: 1px solid;\r\n  border-radius: 15px;\r\n  font-size: 14px;\r\n  background: inherit;\r\n  cursor: pointer;\n}\r\n", ""]);

// exports


/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-suggestions-row",
      style: { background: _vm.colors.messageList.bg }
    },
    _vm._l(_vm.suggestions, function(suggestion, idx) {
      return _c(
        "button",
        {
          key: idx,
          staticClass: "sc-suggestions-element",
          style: {
            borderColor: _vm.colors.sentMessage.bg,
            color: _vm.colors.sentMessage.bg
          },
          on: {
            click: function($event) {
              return _vm.$emit("sendSuggestion", suggestion)
            }
          }
        },
        [_vm._v(_vm._s(suggestion))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11adff40", esExports)
  }
}

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d23154_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconOk_vue__ = __webpack_require__(1946);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d23154_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconOk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/components/icons/IconOk.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73d23154", Component.options)
  } else {
    hotAPI.reload("data-v-73d23154", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73d23154", esExports)
  }
}

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d379f600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconSend_vue__ = __webpack_require__(1948);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d379f600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconSend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/components/icons/IconSend.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d379f600", Component.options)
  } else {
    hotAPI.reload("data-v-d379f600", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M17.218,2.268L2.477,8.388C2.13,8.535,2.164,9.05,2.542,9.134L9.33,10.67l1.535,6.787c0.083,0.377,0.602,0.415,0.745,0.065l6.123-14.74C17.866,2.46,17.539,2.134,17.218,2.268 M3.92,8.641l11.772-4.89L9.535,9.909L3.92,8.641z M11.358,16.078l-1.268-5.613l6.157-6.157L11.358,16.078z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d379f600", esExports)
  }
}

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Suggestions", {
        attrs: { suggestions: _vm.suggestions, colors: _vm.colors },
        on: { sendSuggestion: _vm._submitSuggestion }
      }),
      _vm._v(" "),
      _vm.file
        ? _c(
            "div",
            {
              staticClass: "file-container",
              style: {
                backgroundColor: _vm.colors.userInput.text,
                color: _vm.colors.userInput.bg
              }
            },
            [
              _c("span", { staticClass: "icon-file-message" }, [
                _c("img", {
                  attrs: {
                    src: _vm.icons.file.img,
                    alt: _vm.icons.file.name,
                    height: "15"
                  }
                })
              ]),
              _vm._v("\n    " + _vm._s(_vm.file.name) + "\n    "),
              _c(
                "span",
                {
                  staticClass: "delete-file-message",
                  on: {
                    click: function($event) {
                      return _vm.cancelFile()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.icons.closeSvg.img,
                      alt: _vm.icons.closeSvg.name,
                      height: "10",
                      title: "Remove the file"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "sc-user-input",
          class: { active: _vm.inputActive },
          style: { background: _vm.colors.userInput.bg }
        },
        [
          _c("div", {
            ref: "userInput",
            staticClass: "sc-user-input--text",
            style: { color: _vm.colors.userInput.text },
            attrs: {
              role: "button",
              tabIndex: "0",
              contentEditable: "true",
              placeholder: _vm.placeholder
            },
            on: {
              focus: function($event) {
                return _vm.setInputActive(true)
              },
              blur: function($event) {
                return _vm.setInputActive(false)
              },
              keydown: _vm.handleKey,
              focusUserInput: function($event) {
                return _vm.focusUserInput()
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sc-user-input--buttons" }, [
            _c("div", { staticClass: "sc-user-input--button" }),
            _vm._v(" "),
            _vm.showEmoji && !_vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c("EmojiIcon", {
                      attrs: {
                        onEmojiPicked: _vm._handleEmojiPicked,
                        color: _vm.colors.userInput.text
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showFile && !_vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c("FileIcons", {
                      attrs: {
                        onChange: _vm._handleFileSubmit,
                        color: _vm.colors.userInput.text
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "cancel"
                        },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm._editFinish.apply(null, arguments)
                          }
                        }
                      },
                      [_c("icon-cross")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sc-user-input--button" },
              [
                _vm.isEditing
                  ? _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "Edit"
                        },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm._editText.apply(null, arguments)
                          }
                        }
                      },
                      [_c("icon-ok")],
                      1
                    )
                  : _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "Send"
                        },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm._submitText.apply(null, arguments)
                          }
                        }
                      },
                      [_c("icon-send")],
                      1
                    )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06850670", esExports)
  }
}

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1bacd30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__ = __webpack_require__(1953);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1951)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1bacd30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1bacd30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vue-beautiful-chat/src/UserList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e1bacd30", Component.options)
  } else {
    hotAPI.reload("data-v-e1bacd30", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1952);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("4b95cfc5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e1bacd30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserList.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e1bacd30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.user-list[data-v-e1bacd30] {\n  height: 100%;\n  overflow: auto;\n  padding-left: 5px;\n  padding-top: 8px;\n}\n.img-msg[data-v-e1bacd30] {\n  border-radius: 50%;\n  width: 50px;\n  margin-right: 5px;\n}\n.user-element[data-v-e1bacd30] {\n  font-size: 20px;\n  vertical-align: middle;\n}\n", ""]);

// exports


/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-list" }, [
    _c("table", { staticStyle: { "padding-top": "5px" } }, [
      _c(
        "tbody",
        _vm._l(_vm.participants, function(user) {
          return _c("tr", { key: user.id }, [
            _c("td", { staticStyle: { "text-align": "center" } }, [
              _c("img", {
                staticClass: "img-msg",
                attrs: { src: user.imageUrl }
              })
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "user-element" }, [
              _vm._v(_vm._s(user.name))
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1bacd30", esExports)
  }
}

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-chat-window",
      class: { opened: _vm.isOpen, closed: !_vm.isOpen }
    },
    [
      _c(
        "Header",
        {
          attrs: {
            showCloseButton: _vm.showCloseButton,
            title: _vm.title,
            imageUrl: _vm.titleImageUrl,
            onClose: _vm.onClose,
            colors: _vm.colors,
            disableUserListToggle: _vm.disableUserListToggle
          },
          on: { importrList: _vm.handleUserListToggle }
        },
        [[_vm._t("header")]],
        2
      ),
      _vm._v(" "),
      _vm.showUserList
        ? _c("UserList", { attrs: { participants: _vm.participants } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showUserList
        ? _c("MessageList", {
            attrs: {
              messages: _vm.messages,
              participants: _vm.participants,
              showTypingIndicator: _vm.showTypingIndicator,
              colors: _vm.colors,
              alwaysScrollToBottom: _vm.alwaysScrollToBottom,
              messageStyling: _vm.messageStyling
            },
            on: {
              scrollToTop: function($event) {
                return _vm.$emit("scrollToTop")
              },
              remove: function($event) {
                return _vm.$emit("remove", $event)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "user-avatar",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("user-avatar", null, {
                        user: scopedProps.user,
                        message: scopedProps.message
                      })
                    ]
                  }
                },
                {
                  key: "text-message-body",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("text-message-body", null, {
                        message: scopedProps.message,
                        messageText: scopedProps.messageText,
                        messageColors: scopedProps.messageColors,
                        me: scopedProps.me
                      })
                    ]
                  }
                },
                {
                  key: "system-message-body",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("system-message-body", null, {
                        message: scopedProps.message
                      })
                    ]
                  }
                },
                {
                  key: "text-message-toolbox",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("text-message-toolbox", null, {
                        message: scopedProps.message,
                        me: scopedProps.me
                      })
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showUserList
        ? _c("UserInput", {
            attrs: {
              showEmoji: _vm.showEmoji,
              onSubmit: _vm.onUserInputSubmit,
              suggestions: _vm.getSuggestions(),
              showFile: _vm.showFile,
              placeholder: _vm.placeholder,
              colors: _vm.colors
            },
            on: {
              onType: function($event) {
                return _vm.$emit("onType")
              },
              edit: function($event) {
                return _vm.$emit("edit", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a3abaf2", esExports)
  }
}

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showLauncher
        ? _c(
            "div",
            {
              staticClass: "sc-launcher",
              class: { opened: _vm.isOpen },
              style: { backgroundColor: _vm.colors.launcher.bg },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.isOpen ? _vm.close() : _vm.openAndFocus()
                }
              }
            },
            [
              _vm.newMessagesCount > 0 && !_vm.isOpen
                ? _c("div", { staticClass: "sc-new-messsages-count" }, [
                    _vm._v("\n      " + _vm._s(_vm.newMessagesCount) + "\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isOpen
                ? _c("img", {
                    staticClass: "sc-closed-icon",
                    attrs: {
                      src: _vm.icons.close.img,
                      alt: _vm.icons.close.name
                    }
                  })
                : _c("img", {
                    staticClass: "sc-open-icon",
                    attrs: { src: _vm.icons.open.img, alt: _vm.icons.open.name }
                  })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ChatWindow", {
        attrs: {
          showLauncher: _vm.showLauncher,
          showCloseButton: _vm.showCloseButton,
          messageList: _vm.messageList,
          onUserInputSubmit: _vm.onMessageWasSent,
          participants: _vm.participants,
          title: _vm.chatWindowTitle,
          titleImageUrl: _vm.titleImageUrl,
          isOpen: _vm.isOpen,
          onClose: _vm.close,
          showEmoji: _vm.showEmoji,
          showFile: _vm.showFile,
          placeholder: _vm.placeholder,
          showTypingIndicator: _vm.showTypingIndicator,
          colors: _vm.colors,
          alwaysScrollToBottom: _vm.alwaysScrollToBottom,
          messageStyling: _vm.messageStyling,
          disableUserListToggle: _vm.disableUserListToggle
        },
        on: {
          scrollToTop: function($event) {
            return _vm.$emit("scrollToTop")
          },
          onType: function($event) {
            return _vm.$emit("onType")
          },
          edit: function($event) {
            return _vm.$emit("edit", $event)
          },
          remove: function($event) {
            return _vm.$emit("remove", $event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function() {
                return [_vm._t("header")]
              },
              proxy: true
            },
            {
              key: "user-avatar",
              fn: function(scopedProps) {
                return [
                  _vm._t("user-avatar", null, {
                    user: scopedProps.user,
                    message: scopedProps.message
                  })
                ]
              }
            },
            {
              key: "text-message-body",
              fn: function(scopedProps) {
                return [
                  _vm._t("text-message-body", null, {
                    message: scopedProps.message,
                    messageText: scopedProps.messageText,
                    messageColors: scopedProps.messageColors,
                    me: scopedProps.me
                  })
                ]
              }
            },
            {
              key: "system-message-body",
              fn: function(scopedProps) {
                return [
                  _vm._t("system-message-body", null, {
                    message: scopedProps.message
                  })
                ]
              }
            },
            {
              key: "text-message-toolbox",
              fn: function(scopedProps) {
                return [
                  _vm._t("text-message-toolbox", null, {
                    message: scopedProps.message,
                    me: scopedProps.me
                  })
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ad5b02", esExports)
  }
}

/***/ }),
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1985 */,
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./BackBtnLayout.vue": 1987,
	"./BaseLayout.vue": 1111,
	"./ClinicHistorySectionsSidebar.vue": 1991,
	"./ForumNavbar.vue": 1995,
	"./HealthyHabitsLayout.vue": 2008,
	"./InternalReducedLayout.vue": 2012,
	"./Opensalud360Layout.vue": 2017,
	"./OpensaludEmpresasLayout.vue": 2024,
	"./OpensaludLayout.vue": 2028,
	"./OpensaludPacientesLayout.vue": 2032,
	"./OpensaludProfesionalesLayout.vue": 2036,
	"./PrivateLayout.vue": 2040,
	"./PublicExtendedLayout.vue": 2072,
	"./PublicLayout.vue": 2076,
	"./PublicMenuLayout.vue": 2080,
	"./PublicMenuLayoutV2.vue": 174,
	"./PublicMobileMenuLayout.vue": 2084,
	"./PublicReducedLayout.vue": 1183,
	"./PublicReducedLayoutDynamic.vue": 2091,
	"./patient/GoFreedom.vue": 2095,
	"./patient/GoOpensaludpass.vue": 2099,
	"./patient/GoTeleconsultation.vue": 2103,
	"./patient/GoTmc.vue": 2107,
	"./patient/GoWellwo.vue": 2111,
	"./patient/SearchTab.vue": 1285,
	"./professional/customHeader.vue": 1257,
	"./professional/customaFooter.vue": 2115
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1986;

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackBtnLayout_vue__ = __webpack_require__(1157);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418cc1f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackBtnLayout_vue__ = __webpack_require__(1990);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1988)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-418cc1f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackBtnLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418cc1f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackBtnLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/BackBtnLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-418cc1f9", Component.options)
  } else {
    hotAPI.reload("data-v-418cc1f9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1989);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("34de5f5b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-418cc1f9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BackBtnLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-418cc1f9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BackBtnLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-418cc1f9]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-418cc1f9],.slide-down-leave-active[data-v-418cc1f9]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-418cc1f9],.slide-down-leave-to[data-v-418cc1f9]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-418cc1f9],.slide-fade-left-leave-active[data-v-418cc1f9]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-418cc1f9],.slide-fade-left-leave-to[data-v-418cc1f9]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-418cc1f9]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-418cc1f9],.fade-leave-to[data-v-418cc1f9]{opacity:0\n}\n@media only screen and (min-width: 1024px){\n[data-v-418cc1f9].navbar{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n[data-v-418cc1f9].navbar{padding-right:20rem;padding-left:20rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-418cc1f9].navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-418cc1f9].navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n[data-v-418cc1f9].navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-418cc1f9].navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-418cc1f9].navbar{padding-top:0;padding-bottom:0\n}\n}\n[data-v-418cc1f9] .nav-item{margin-right:0rem;font-weight:600\n}\n@media only screen and (max-width: 575px){\n[data-v-418cc1f9] .nav-item{padding-right:0;border:0px !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-418cc1f9] .nav-item{padding-right:0;border:0px !important\n}\n}\n@media only screen and (min-width: 1024px){\n[data-v-418cc1f9] .navbar-nav{margin-left:auto !important\n}\n}\n[data-v-418cc1f9] .navbar-brand{margin-right:0\n}\n.navbar[data-v-418cc1f9]{z-index:1\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-418cc1f9] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:transparent !important;display:table\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 1024px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 1024px){\n.navbar[data-v-418cc1f9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 2000px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 2000px){\n.navbar[data-v-418cc1f9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.navbar[data-v-418cc1f9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-418cc1f9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.navbar[data-v-418cc1f9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n.navbar[data-v-418cc1f9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-418cc1f9]{padding-top:2rem;padding-bottom:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar .btn-dropdown[data-v-418cc1f9]{padding:.7rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-418cc1f9] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:transparent !important;display:table\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 1024px){\n.navbar[data-v-418cc1f9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 2000px){\n.navbar[data-v-418cc1f9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.navbar[data-v-418cc1f9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-418cc1f9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.navbar[data-v-418cc1f9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.navbar[data-v-418cc1f9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-418cc1f9]{padding-top:2rem;padding-bottom:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.navbar .btn-dropdown[data-v-418cc1f9]{padding:.7rem\n}\n}\n@media only screen and (min-width: 1024px){\n.custom-container[data-v-418cc1f9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.custom-container[data-v-418cc1f9]{padding-right:20rem;padding-left:20rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.custom-container[data-v-418cc1f9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.custom-container[data-v-418cc1f9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.custom-container[data-v-418cc1f9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.custom-container[data-v-418cc1f9]{padding-right:2rem;padding-left:2rem\n}\n}\n.custom-container .custom-container[data-v-418cc1f9]{-webkit-transition:all 0.3s ease;transition:all 0.3s ease\n}\n@media only screen and (min-width: 1024px){\n.custom-container[data-v-418cc1f9]{min-height:60dvh\n}\n}\n@media only screen and (min-width: 2000px){\n.custom-container[data-v-418cc1f9]{min-height:70dvh\n}\n}\n", ""]);

// exports


/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        { staticClass: "navbar" },
        [
          _vm.showBackBtn
            ? _c(
                "b-nav-item",
                {
                  staticClass: "d-block",
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [
                  _c("base-icon", {
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                      svgClasses: "rotate-180",
                      width: "20",
                      height: "20"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "custom-container" }, [_c("router-view")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-418cc1f9", esExports)
  }
}

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistorySectionsSidebar_vue__ = __webpack_require__(1158);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bbfa9d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistorySectionsSidebar_vue__ = __webpack_require__(1994);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1992)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bbfa9d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistorySectionsSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bbfa9d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistorySectionsSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/ClinicHistorySectionsSidebar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8bbfa9d0", Component.options)
  } else {
    hotAPI.reload("data-v-8bbfa9d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("73e0c1d4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8bbfa9d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistorySectionsSidebar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8bbfa9d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistorySectionsSidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-8bbfa9d0]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-8bbfa9d0],.slide-down-leave-active[data-v-8bbfa9d0]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-8bbfa9d0],.slide-down-leave-to[data-v-8bbfa9d0]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-8bbfa9d0],.slide-fade-left-leave-active[data-v-8bbfa9d0]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-8bbfa9d0],.slide-fade-left-leave-to[data-v-8bbfa9d0]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-8bbfa9d0]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-8bbfa9d0],.fade-leave-to[data-v-8bbfa9d0]{opacity:0\n}\n#history-view-container .sidebar-history[data-v-8bbfa9d0]{overflow:scroll\n}\n#history-view-container .sidebar-history[data-v-8bbfa9d0]::-webkit-scrollbar{display:none\n}\n#history-view-container .sidebar-history .nav li[data-v-8bbfa9d0]:first-child{margin-top:5px\n}\n#history-view-container .sidebar-history .nav li .nav-link[data-v-8bbfa9d0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n#history-view-container .history-sidebar-hr[data-v-8bbfa9d0]{margin-top:0.5rem;margin-bottom:0.5rem\n}\n#history-view-container .sidebar-collapsed-arrow[data-v-8bbfa9d0]{cursor:pointer;position:fixed;right:15px\n}\n#history-view-container .sidebar-arrow[data-v-8bbfa9d0]{cursor:pointer;position:fixed;right:25px\n}\n#history-view-container .sidebar-back-btn[data-v-8bbfa9d0]{position:fixed;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)\n}\n#history-view-container .sidebar-back-btn-collapsed[data-v-8bbfa9d0]{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);padding:0.2rem 0.4rem\n}\n@media only screen and (max-width: 575px){\n#history-view-container .sidebar-back-btn-collapsed[data-v-8bbfa9d0]{padding:0.1rem 0.2rem\n}\n}\n#history-view-container .cursor-pointer[data-v-8bbfa9d0]{cursor:pointer\n}\n#history-view-container .back-btn-collapsed-container[data-v-8bbfa9d0]{height:30px;position:fixed;left:50%;-webkit-transform:translate(-50%, 0);transform:translate(-50%, 0)\n}\n#history-view-container .b-sidebar-body[data-v-8bbfa9d0]{position:relative\n}\n#history-view-container .b-sidebar[data-v-8bbfa9d0]{text-align:center;background-color:#eee !important;z-index:1;border-radius:23px\n}\n#history-view-container .hidden[data-v-8bbfa9d0]{visibility:hidden\n}\n#history-view-container .icon-in-li[data-v-8bbfa9d0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n#history-view-container .sidebar-shadow[data-v-8bbfa9d0]{-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784) !important;box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784) !important\n}\n@media only screen and (max-width: 575px){\n#history-view-container .ul-right[data-v-8bbfa9d0]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#history-view-container .ul-right[data-v-8bbfa9d0]{margin-top:1rem\n}\n}\n", ""]);

// exports


/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$store.state.clinicHistory.sidebarHidden
    ? _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c(
          "div",
          {
            staticClass: "b-sidebar shadow bg-light text-dark sidebar-shadow",
            class: _vm.containerClass,
            style: _vm.containerStyle,
            attrs: { role: "dialog", "aria-modal": "false" }
          },
          [
            _c("div", { staticClass: "b-sidebar-body" }, [
              _c("div", { class: _vm.expanded ? "p-3 text-center" : "" }, [
                _c(
                  "nav",
                  { staticClass: "sidebar-history", style: _vm.navStyle },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "nav flex-column",
                        class: { "ul-right": _vm.rightSide }
                      },
                      _vm._l(_vm.sidebarData, function(item) {
                        return _c(
                          "li",
                          { key: item.title, style: _vm.liStyle },
                          [
                            _vm.expanded
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    style: _vm.liSpanStyle,
                                    attrs: { title: item.title, href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.rightSide
                                          ? item.action()
                                          : _vm.goToSection(item.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("b", {
                                      domProps: {
                                        innerHTML: _vm._s(item.title)
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "icon-in-li",
                                    style: _vm.liSpanStyle,
                                    on: {
                                      click: function($event) {
                                        _vm.rightSide
                                          ? item.action()
                                          : _vm.goToSection(item.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("base-icon", {
                                      staticClass: "cursor-pointer",
                                      attrs: {
                                        src:
                                          "" +
                                          _vm.iconBasePath +
                                          item.id +
                                          ".svg",
                                        alt: item.title,
                                        title: item.title,
                                        height: _vm.iconSize,
                                        width: _vm.iconSize,
                                        color: _vm.BLUE_COLOUR
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            !item.hideHr
                              ? _c("hr", { staticClass: "history-sidebar-hr" })
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8bbfa9d0", esExports)
  }
}

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumNavbar_vue__ = __webpack_require__(1159);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90301aea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumNavbar_vue__ = __webpack_require__(2007);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1996)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90301aea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/ForumNavbar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-90301aea", Component.options)
  } else {
    hotAPI.reload("data-v-90301aea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1997);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("20239e9a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-90301aea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumNavbar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-90301aea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumNavbar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.forum-class{text-align:center\n}\n.wysiwygStyle{margin:auto;border:1px solid rgba(0,0,0,0.1) !important;margin-top:1%;margin-bottom:1%\n}\n.wysiwygReduced{margin-top:0px !important;width:60vw !important\n}\n@media only screen and (max-width: 575px){\n.wysiwygReduced{width:100% !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.wysiwygReduced{width:100% !important\n}\n}\n.pointer{cursor:pointer\n}\n.form-control:disabled{background-color:rgba(138,138,138,0.15) !important\n}\n.form-control[readonly]{background-color:rgba(138,138,138,0.15) !important\n}\n.verticalCenter{display:-webkit-box !important;display:-ms-flexbox !important;display:flex !important;-webkit-box-orient:vertical !important;-webkit-box-direction:normal !important;-ms-flex-direction:column !important;flex-direction:column !important;-webkit-box-align:center !important;-ms-flex-align:center !important;align-items:center !important;margin-top:2rem\n}\n.navbar-items-align{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start\n}\n@media only screen and (max-width: 1199px){\n.navbar-items-align{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n}\n@media only screen and (max-width: 1199px){\n.navbar-forum{display:block !important;padding-right:0px !important\n}\n}\n.navbar-margin{margin-top:12dvh !important\n}\n@media only screen and (max-width: 1199px){\n.navbar-margin{margin-top:7dvh !important\n}\n}\n.back-btn-panel{background-color:white !important;margin-bottom:10% !important\n}\n.back-btn-navbar{display:block !important;position:-webkit-sticky !important;position:sticky !important;z-index:1 !important;left:5vw !important;top:15dvh !important\n}\n@media only screen and (max-width: 575px){\n.back-btn-navbar{position:fixed !important;top:94vh !important;padding:2% !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.back-btn-navbar{position:fixed !important;top:94vh !important;padding:2% !important\n}\n}\n.arrow-go-top{position:fixed !important;display:block !important;top:89dvh !important;left:5vw !important;z-index:2 !important;color:#3238C4 !important;cursor:pointer\n}\n@media only screen and (max-width: 575px){\n.arrow-go-top{top:83vh !important;left:8vw !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.arrow-go-top{top:83vh !important;left:8vw !important\n}\n}\n.forumArticle{background-color:#EEEEEE !important;overflow:hidden;-webkit-box-shadow:-14px -14px 23px #fff,14px 14px 25px rgba(13,39,80,0.160784);box-shadow:-14px -14px 23px #fff,14px 14px 25px rgba(13,39,80,0.160784);border-radius:23px;border:none !important\n}\n.forumAuthor{position:relative;margin-top:1rem;color:#787C7E;font-size:10px\n}\n.forumFooter{margin-top:1%;border-top:1px solid rgba(0,0,0,0.1)\n}\n.forumFooter>div{cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis\n}\n.forumFooter div:hover{background-color:rgba(0,0,0,0.1)\n}\n.margin-right-icon{margin-right:0.5rem\n}\n.vs__deselect{padding-left:4px;padding-top:3px\n}\n.tag-style-right{position:absolute !important;right:20px !important;cursor:initial !important;padding-top:0.1rem !important;padding-bottom:0.1rem !important;background-color:#8232C4 !important;border-color:#8232C4 !important;font-size:0.75rem !important\n}\n@media only screen and (max-width: 575px){\n.tag-style-right{display:none !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.tag-style-right{display:none !important\n}\n}\n.tag-style-left{position:absolute !important;left:1rem !important;cursor:initial !important;padding-top:0.1rem !important;padding-bottom:0.1rem !important;background-color:#3238C4 !important;border-color:#3238C4 !important;font-size:0.75rem !important\n}\n@media only screen and (max-width: 575px){\n.tag-style-left{display:none !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.tag-style-left{display:none !important\n}\n}\n.tag-style-mobile{display:none !important\n}\n@media only screen and (max-width: 575px){\n.tag-style-mobile{display:block !important;cursor:initial !important;padding-top:0.1rem !important;padding-bottom:0.1rem !important;background-color:#3238C4 !important;border-color:#3238C4 !important;font-size:0.75rem !important;margin-left:auto !important;margin-right:auto !important;margin-top:2% !important;margin-bottom:2% !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.tag-style-mobile{display:block !important;cursor:initial !important;padding-top:0.1rem !important;padding-bottom:0.1rem !important;background-color:#3238C4 !important;border-color:#3238C4 !important;font-size:0.75rem !important;margin-left:auto !important;margin-right:auto !important;margin-top:2% !important;margin-bottom:2% !important\n}\n}\n.tag-style-mobile-disease{display:none !important\n}\n@media only screen and (max-width: 575px){\n.tag-style-mobile-disease{display:block !important;cursor:initial !important;padding-top:0.1rem !important;padding-bottom:0.1rem !important;background-color:#8232C4 !important;border-color:#8232C4 !important;font-size:0.75rem !important;margin-left:auto !important;margin-right:auto !important;margin-top:2% !important;margin-bottom:2% !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.tag-style-mobile-disease{display:block !important;cursor:initial !important;padding-top:0.1rem !important;padding-bottom:0.1rem !important;background-color:#8232C4 !important;border-color:#8232C4 !important;font-size:0.75rem !important;margin-left:auto !important;margin-right:auto !important;margin-top:2% !important;margin-bottom:2% !important\n}\n}\n@media only screen and (max-width: 575px){\n.hide-title-mobile{display:none\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.hide-title-mobile{display:none\n}\n}\n.cursor-pointer{cursor:pointer\n}\n.order-by{margin-left:auto !important;margin-bottom:2dvh !important;width:200px !important;cursor:pointer\n}\n@media only screen and (max-width: 575px){\n.order-by{-webkit-box-orient:vertical !important;-webkit-box-direction:normal !important;-ms-flex-direction:column !important;flex-direction:column !important;margin-top:0px !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.order-by{-webkit-box-orient:vertical !important;-webkit-box-direction:normal !important;-ms-flex-direction:column !important;flex-direction:column !important;margin-top:0px !important\n}\n}\n@media only screen and (max-width: 1199px){\n.fixed-padding-btn-forum{padding:0.4rem 1rem !important\n}\n}\n.opensalud-blue{color:#3238C4 !important\n}\n.underlined{text-decoration:underline !important\n}\n.bold{font-weight:bold\n}\n.forumDescription p{margin:0.5rem !important\n}\n.messageBox p{margin:0.5rem !important\n}\n.more-options-item{cursor:pointer;font-size:1rem !important;text-align:center\n}\n.neu-card{background-color:#EEE !important\n}\n@media only screen and (max-width: 575px){\nul.navbar-nav:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nul.navbar-nav:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\nul.navbar-nav:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content\n}\n}\n.nav-link.active{border-bottom:1px solid\n}\n.badge-forum{position:absolute;font-size:xx-small;margin-left:-5px;margin-top:-10px;background-color:#3238C4;color:white\n}\n.navCollapse{position:fixed !important;top:4rem;right:1rem !important;-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n@media only screen and (min-width: 1200px){\n.navCollapse{position:-webkit-sticky !important;position:sticky !important\n}\n}\n.nav-item{margin-right:0 !important\n}\n@media only screen and (max-width: 575px){\n.nav-item{padding:0rem 2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.nav-item{padding:0rem 2rem\n}\n}\n@media only screen and (min-width: 1200px){\n.navbar-forum-commom.navbar-expand-xl .navCollapse{display:-webkit-box !important;display:-ms-flexbox !important;display:flex !important;-ms-flex-preferred-size:auto;flex-basis:auto\n}\n}\n.navbar-forum-commom{padding:2rem 5rem;background-color:#E4E4E4\n}\n@media only screen and (min-width: 2000px){\n.navbar-forum-commom{padding:2rem 15rem\n}\n}\n.c-header{border-bottom:1px solid #ddd\n}\n.logo{height:36px !important;padding:0;margin:0 !important\n}\n@media only screen and (max-width: 575px){\n.logo{height:29px !important\n}\n}\n@media screen and (max-width: 768px){\n.access-btn{color:#3238C4 !important;background-color:transparent !important\n}\n}\n@media only screen and (max-width: 575px){\n.show-admin-btn{display:initial\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.show-admin-btn{display:initial\n}\n}\n.dialog-search{position:absolute !important;top:9vh !important;width:50vw !important;left:25vw !important;z-index:10 !important;max-width:50vw !important\n}\n@media (max-width: 1250px){\n.dialog-search{width:98vw !important;max-width:98vw !important;left:0 !important;top:14vh !important;margin-left:3px !important\n}\n}\n@media only screen and (max-width: 1199px){\n.navbar.navbar-light.navbar-expand-xl{padding-right:1rem !important;padding-left:1rem !important\n}\n.navbar ul.navbar-nav:not(.outside-collapse){-webkit-transition:all .5s ease !important;transition:all .5s ease !important;background-color:#eee !important;border-radius:23px !important;-webkit-box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784) !important;box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784) !important;width:-webkit-fit-content !important;width:-moz-fit-content !important;width:fit-content !important\n}\n}\n@media only screen and (max-width: 575px){\n.modal-content{width:100% !important\n}\n}\n.nav-log{margin-bottom:0px !important\n}\n.navbar-submenu{-webkit-box-align:center !important;-ms-flex-align:center !important;align-items:center !important\n}\n.brand-forum{cursor:pointer !important;margin-right:auto !important\n}\n.navbar-login{padding-left:2vw !important;padding-right:2vw !important\n}\n.search-mobile{padding-bottom:0px !important\n}\n.forum-header-text{display:none !important;cursor:initial;margin-left:1vw\n}\n@media only screen and (min-width: 1200px){\n.forum-header-text{display:inline-block !important\n}\n}\n.search-navbar{margin:0 auto !important\n}\n.search-navbar input[type=\"text\"]{width:320px !important\n}\n.banner-title{opacity:1 !important;margin-bottom:2vh !important;background-color:#3238C4 !important;color:white !important;padding:2vh 0 !important\n}\n@media only screen and (max-width: 575px){\n.banner-title{font-size:1rem !important;padding:2vh 3vw !important;margin-bottom:0px !important\n}\n}\n.search-nav-outside-mobile{margin-bottom:2.5vh !important\n}\n.pushNotificationBox{background-color:#eee;border-radius:23px;padding:15px;margin:1% 0\n}\n.pushNotificationBox:hover{cursor:pointer;background-color:#979797\n}\n.datePushNotification{font-size:10px;margin-top:3%\n}\n.pushNotificationMessage{text-align:justify\n}\n.noPendingNotifications{text-align:center;margin-top:5%\n}\n.push-notifications-mobile{position:absolute;top:43px;right:75px\n}\n#modalForumNotifications .notifications-title-modal{margin-left:auto;margin-right:auto\n}\n#modalForumNotifications .modal-title{display:contents\n}\n#modalForumNotifications .modal-header{margin:0 !important;width:100%\n}\n.pendingRead{background-color:#6AEF89\n}\n.markedSection{background-color:#6AEF89;-webkit-animation:blinker-notifications 1.7s cubic-bezier(0.5, 0, 1, 1) infinite alternate;animation:blinker-notifications 1.7s cubic-bezier(0.5, 0, 1, 1) infinite alternate\n}\n@-webkit-keyframes blinker-notifications{\n0%{background-color:#6AEF89\n}\n50%{background-color:initial\n}\n100%{background-color:#6AEF89\n}\n}\n@keyframes blinker-notifications{\n0%{background-color:#6AEF89\n}\n50%{background-color:initial\n}\n100%{background-color:#6AEF89\n}\n}\n#popoverPushNotifications{max-width:230px !important\n}\n.noMarginBottom{margin-bottom:0px !important\n}\n", ""]);

// exports


/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumSearcher_vue__ = __webpack_require__(1160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1c4b71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumSearcher_vue__ = __webpack_require__(2001);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1999)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumSearcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1c4b71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumSearcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/ForumSearcher.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3f1c4b71", Component.options)
  } else {
    hotAPI.reload("data-v-3f1c4b71", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2000);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("239326ad", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f1c4b71\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumSearcher.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f1c4b71\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumSearcher.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.search-options{cursor:pointer;display:block !important;padding-top:0.3rem !important;padding-bottom:0.3rem !important\n}\n.search-options:hover{background-color:#3238C4;border-color:#3238C4;color:#eee !important\n}\n.modal-body-forum-search{max-height:80vh !important\n}\n@media only screen and (max-width: 575px){\n.modal-body-forum-search{max-height:70vh !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.modal-body-forum-search{max-height:70vh !important\n}\n}\n.search-row>div>div.content{overflow-y:auto !important;max-height:14vh !important\n}\n@media (min-width: 576px){\n.search-row>div>div.content{max-height:75vh !important\n}\n}\n.no-search-results{padding:0.3rem 2.2rem\n}\n", ""]);

// exports


/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-dialog modal-md dialog-search",
      style: { display: _vm.search.display }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-content",
          style: { padding: "0px", margin: "0px" },
          attrs: { tabindex: "-1" }
        },
        [
          _c("header", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("searcher")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "aria-label": "Close" },
                on: { click: _vm.searchModalClose }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body-forum-search" },
            [
              _c(
                "b-row",
                { staticClass: "search-row" },
                [
                  _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                    _c("b", [_vm._v(_vm._s(_vm.$t("categories")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      _vm._l(_vm.search.categories, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "btn search-options",
                            on: {
                              click: function($event) {
                                return _vm.searchSelected(item.id, 1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(item[_vm.normalizeForumProp("name")]) +
                                "\r\n            "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    !_vm.search.categories || _vm.search.categories.length === 0
                      ? _c("div", { staticClass: "no-search-results" }, [
                          _vm._v(_vm._s(_vm.$t("noResults")))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                    _c("b", [_vm._v(_vm._s(_vm.$t("tags")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      _vm._l(_vm.search.tags, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "btn search-options",
                            on: {
                              click: function($event) {
                                return _vm.searchSelected(item.id, 2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(item[_vm.normalizeForumProp("name")]) +
                                "\r\n            "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    !_vm.search.tags || _vm.search.tags.length === 0
                      ? _c("div", { staticClass: "no-search-results" }, [
                          _vm._v(_vm._s(_vm.$t("noResults")))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                    _c("b", [_vm._v(_vm._s(_vm.$t("diseasesForum")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      _vm._l(_vm.search.diseases, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "btn search-options",
                            on: {
                              click: function($event) {
                                return _vm.searchSelected(item.id, 4)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(item[_vm.normalizeForumProp("name")]) +
                                "\r\n            "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    !_vm.search.diseases || _vm.search.diseases.length === 0
                      ? _c("div", { staticClass: "no-search-results" }, [
                          _vm._v(_vm._s(_vm.$t("noResults")))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12", sm: "3" } }, [
                    _c("b", [_vm._v(_vm._s(_vm.$t("description")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      _vm._l(_vm.search.entries, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "btn search-options",
                            on: {
                              click: function($event) {
                                return _vm.searchSelected(item.id, 3)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(item.name) +
                                "\r\n            "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.$store.state.forum.entrySearchValue &&
                    (!_vm.search.entries || _vm.search.entries.length === 0)
                      ? _c("div", { staticClass: "no-search-results" }, [
                          _vm._v(_vm._s(_vm.$t("noResults")))
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f1c4b71", esExports)
  }
}

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumActivitySearch_vue__ = __webpack_require__(1161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572d5cb3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumActivitySearch_vue__ = __webpack_require__(2005);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2003)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-572d5cb3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumActivitySearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572d5cb3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumActivitySearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/ForumActivitySearch.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-572d5cb3", Component.options)
  } else {
    hotAPI.reload("data-v-572d5cb3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2004);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("6e5e5368", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-572d5cb3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumActivitySearch.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-572d5cb3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumActivitySearch.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-572d5cb3]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-572d5cb3],.slide-down-leave-active[data-v-572d5cb3]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-572d5cb3],.slide-down-leave-to[data-v-572d5cb3]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-572d5cb3],.slide-fade-left-leave-active[data-v-572d5cb3]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-572d5cb3],.slide-fade-left-leave-to[data-v-572d5cb3]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-572d5cb3]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-572d5cb3],.fade-leave-to[data-v-572d5cb3]{opacity:0\n}\n.search-btn[data-v-572d5cb3]{text-align:center\n}\n[data-v-572d5cb3] .dateActivitySearch .btn{position:absolute !important;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)\n}\n", ""]);

// exports


/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      attrs: { hideClose: "", title: _vm.$t("filtersTitle") },
      model: {
        value: _vm.localValue,
        callback: function($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue"
      }
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c("base-select", {
                attrs: {
                  clearable: "",
                  options: _vm.activitySource,
                  valueProp: "id",
                  label: _vm.normalizeForumProp("name"),
                  placeholder: _vm.$t("activity"),
                  loading: false
                },
                model: {
                  value: _vm.filters.activity,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "activity", $$v)
                  },
                  expression: "filters.activity"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c("base-select", {
                attrs: {
                  clearable: "",
                  options: _vm.activityLevelSource,
                  valueProp: "id",
                  label: _vm.normalizeForumProp("name"),
                  placeholder: _vm.$t("level")
                },
                model: {
                  value: _vm.filters.activityLevel,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "activityLevel", $$v)
                  },
                  expression: "filters.activityLevel"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c("base-select", {
                attrs: {
                  clearable: "",
                  options: _vm.countrySource,
                  valueProp: "idCountry",
                  label: _vm.$i18nHelpers.normalizeProp("name"),
                  placeholder: _vm.$t("country")
                },
                on: { "option:selected": _vm.countryChange },
                model: {
                  value: _vm.filters.country,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "country", $$v)
                  },
                  expression: "filters.country"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c("base-select", {
                attrs: {
                  clearable: "",
                  options: _vm.stateSource,
                  valueProp: "id",
                  label: _vm.$i18nHelpers.normalizeProp("name"),
                  placeholder: _vm.$t("state")
                },
                on: { "option:selected": _vm.stateChange },
                model: {
                  value: _vm.filters.state,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "state", $$v)
                  },
                  expression: "filters.state"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c("base-select", {
                attrs: {
                  clearable: "",
                  options: _vm.citySource,
                  valueProp: "idCity",
                  label: _vm.$i18nHelpers.normalizeProp("name"),
                  placeholder: _vm.$t("city"),
                  loading: false,
                  noOptionsTitle: _vm.$t("selectState")
                },
                model: {
                  value: _vm.filters.city,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "city", $$v)
                  },
                  expression: "filters.city"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c("base-datepicker", {
                class: !_vm.showingCalendar ? "dateActivitySearch" : null,
                attrs: {
                  noMarginBottom: "",
                  dateAfterNow: "",
                  resetButtton: "",
                  placeholder: _vm.$t("date").toUpperCase()
                },
                on: {
                  shown: function($event) {
                    _vm.showingCalendar = true
                  },
                  hidden: function($event) {
                    _vm.showingCalendar = false
                  }
                },
                model: {
                  value: _vm.filters.date,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "date", $$v)
                  },
                  expression: "filters.date"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { cols: "12" } },
            [
              _c("base-select", {
                attrs: {
                  clearable: "",
                  options: _vm.timeOfDaySource,
                  valueProp: "id",
                  label: "name",
                  placeholder: _vm.$t("hour")
                },
                model: {
                  value: _vm.filters.timeOfDay,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "timeOfDay", $$v)
                  },
                  expression: "filters.timeOfDay"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-btn mt-4" },
        [
          _c("base-button", { on: { click: _vm.filter } }, [
            _vm._v(_vm._s(_vm.$t("search")))
          ]),
          _vm._v(" "),
          _c(
            "base-button",
            { attrs: { gray: "" }, on: { click: _vm.resetFilters } },
            [_vm._v(_vm._s(_vm.$t("cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-572d5cb3", esExports)
  }
}

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.getters["session/isLogged"]
    ? _c("div", { on: { mousemove: _vm.reset } }, [_vm._t("default")], 2)
    : _c("div", [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03af8d34", esExports)
  }
}

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "IdleTracker",
    [
      _vm.$store.getters["session/isLogged"]
        ? _c(
            "b-navbar",
            {
              staticClass: "navbar-forum-commom navbar-forum",
              attrs: { sticky: "", toggleable: "xl" }
            },
            [
              _c(
                "div",
                { staticClass: "navbar-items-align" },
                [
                  _vm.showBackButton
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "cursor-pointer mx-auto mx-lg-0",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goPatientMenu()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "navbar-brand-img",
                        style: _vm.getLogoStyles,
                        attrs: { src: _vm.getLogo }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.showInSubmenu
                    ? _c(
                        "div",
                        {
                          staticClass: "pointer push-notifications-mobile",
                          on: { click: _vm.showPushNotifications }
                        },
                        [
                          _c("b-icon-bell", {
                            staticClass: "pointer",
                            attrs: { scale: "1.3" }
                          }),
                          _vm.$store.state.forum.numberPushNotifications > 0
                            ? _c(
                                "span",
                                { staticClass: "badge-forum badge-pill" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.state.forum
                                        .numberPushNotifications
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                { staticClass: "navCollapse", attrs: { id: "nav-collapse" } },
                [
                  _c(
                    "b-navbar-nav",
                    { staticClass: "ml-auto navbar-submenu" },
                    [
                      _vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            {
                              staticClass: "pointer",
                              on: { click: _vm.showPushNotifications }
                            },
                            [
                              _c("b-icon-bell", {
                                staticClass: "pointer",
                                attrs: { scale: "1.3" }
                              }),
                              _vm.$store.state.forum.numberPushNotifications > 0
                                ? _c(
                                    "span",
                                    { staticClass: "badge badge-pill" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.forum
                                            .numberPushNotifications
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            [
                              !_vm.$store.state.forum.hideSearcher
                                ? _c(
                                    "b-form-group",
                                    { staticClass: "search-navbar" },
                                    [
                                      _c(
                                        _vm.inWhoInSection
                                          ? "base-button"
                                          : "b-form-input",
                                        {
                                          tag: "component",
                                          attrs: {
                                            placeholder: _vm.searchPlaceholder
                                          },
                                          on: {
                                            click: _vm.searchModalClick,
                                            keyup: _vm.searchModal
                                          },
                                          model: {
                                            value:
                                              _vm.$store.state.forum
                                                .entrySearchValue,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.$store.state.forum,
                                                "entrySearchValue",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "$store.state.forum.entrySearchValue"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.inWhoInSection
                                                ? _vm.$t(
                                                    "searchWhoInPlaceholder"
                                                  )
                                                : null
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            [
                              _c(
                                "base-button",
                                { attrs: { outline: "", fitContent: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.state.forum.userBasicInfo.nick
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.nav-collapse",
                                  modifiers: { "nav-collapse": true }
                                }
                              ]
                            },
                            [
                              _c("lang-selector", {
                                staticClass: "d-inline-block",
                                staticStyle: { width: "max-content" },
                                attrs: { enablePortuguese: "" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.nav-collapse",
                              modifiers: { "nav-collapse": true }
                            }
                          ]
                        },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { outline: "", fitContent: "" },
                              on: { click: _vm.createNewPost }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters[
                                    "forum/forumUserIsAdminRole"
                                  ]
                                    ? _vm.$t("createNewEntry")
                                    : _vm.newPostTitle
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showInSubmenu
                        ? _c(
                            "b-nav-item",
                            {
                              staticClass: "my-auto",
                              staticStyle: { "margin-right": "1rem" }
                            },
                            [
                              _c("dropdown", {
                                staticClass: "dropdown",
                                attrs: {
                                  enablePortuguese: "",
                                  showLanguageSelector: "",
                                  showAsNavbarBtn: "",
                                  title:
                                    _vm.$store.state.forum.userBasicInfo.nick,
                                  items: _vm.dropdownLoginItems
                                },
                                on: { logOff: _vm.logOff }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showInSubmenu
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-nav-item",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.nav-collapse",
                                      modifiers: { "nav-collapse": true }
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      _vm.$router
                                        .push(_vm.getPathUrl("panel/perfil"))
                                        .catch(function() {})
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "base-button",
                                    { attrs: { outline: "", fitContent: "" } },
                                    [_vm._v(_vm._s(_vm.$t("controlPanel")))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-nav-item",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.nav-collapse",
                                      modifiers: { "nav-collapse": true }
                                    }
                                  ],
                                  on: { click: _vm.logOff }
                                },
                                [
                                  _c(
                                    "base-button",
                                    { attrs: { outline: "", fitContent: "" } },
                                    [_vm._v(_vm._s(_vm.$t("logOff")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$store.getters["session/isLogged"]
        ? _c(
            "b-navbar",
            {
              staticClass: "navbar-forum-commom navbar-login",
              attrs: { sticky: "" }
            },
            [
              _c(
                "div",
                { staticClass: "navbar-items-align" },
                [
                  _vm.showBackButton
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "cursor-pointer mx-auto mx-lg-0",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goPatientMenu()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "navbar-brand-img",
                        style: _vm.getLogoStyles,
                        attrs: { src: _vm.getLogo }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSearchNavbarOutside
                ? _c(
                    "b-nav-item",
                    { staticClass: "ml-auto" },
                    [
                      !_vm.$store.state.forum.hideSearcher
                        ? _c(
                            "b-form-group",
                            { staticClass: "search-navbar" },
                            [
                              _c(
                                _vm.inWhoInSection
                                  ? "base-button"
                                  : "b-form-input",
                                {
                                  tag: "component",
                                  attrs: { placeholder: _vm.searchPlaceholder },
                                  on: {
                                    click: _vm.searchModalClick,
                                    keyup: _vm.searchModal
                                  },
                                  model: {
                                    value:
                                      _vm.$store.state.forum.entrySearchValue,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$store.state.forum,
                                        "entrySearchValue",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$store.state.forum.entrySearchValue"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inWhoInSection
                                        ? _vm.$t("searchWhoInPlaceholder")
                                        : null
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "btn btn-primary fixed-padding-btn-forum",
                  class: { "ml-auto": !_vm.showSearchNavbarOutside },
                  on: {
                    click: function($event) {
                      return _vm.logIn()
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("accessBtn")))]),
                  _vm._v(" "),
                  _c("base-icon", {
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                      color: "white"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.$store.getters["session/isLogged"] &&
        !_vm.showSearchNavbarOutside) ||
      (_vm.$store.getters["session/isLogged"] &&
        !_vm.showInSubmenu &&
        !_vm.$store.state.forum.hideOutsideSearchBar)
        ? _c(
            "b-nav-item",
            { staticClass: "search-mobile" },
            [
              !_vm.$store.state.forum.hideSearcher
                ? _c(
                    "b-form-group",
                    { staticClass: "search-navbar" },
                    [
                      _c(
                        _vm.inWhoInSection ? "base-button" : "b-form-input",
                        {
                          tag: "component",
                          attrs: { placeholder: _vm.searchPlaceholder },
                          on: {
                            click: _vm.searchModalClick,
                            keyup: _vm.searchModal
                          },
                          model: {
                            value: _vm.$store.state.forum.entrySearchValue,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.forum,
                                "entrySearchValue",
                                $$v
                              )
                            },
                            expression: "$store.state.forum.entrySearchValue"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inWhoInSection
                                ? _vm.$t("searchWhoInPlaceholder")
                                : null
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalForumNotifications",
            centered: "",
            "hide-footer": "",
            scrollable: ""
          },
          model: {
            value: _vm.$store.state.forum.showPushNotificationsModal,
            callback: function($$v) {
              _vm.$set(
                _vm.$store.state.forum,
                "showPushNotificationsModal",
                $$v
              )
            },
            expression: "$store.state.forum.showPushNotificationsModal"
          }
        },
        [
          _c(
            "template",
            { slot: "modal-title" },
            [
              _c("b-icon-gear", {
                staticClass: "pointer",
                attrs: { id: "showPushNotificationsOptions", scale: "1.3" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "notifications-title-modal" }, [
                _vm._v(_vm._s(_vm.$t("notifications")))
              ]),
              _vm._v(" "),
              _c(
                "b-popover",
                {
                  attrs: {
                    id: "popoverPushNotifications",
                    target: "showPushNotificationsOptions",
                    triggers: "click",
                    placement: "right"
                  }
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "more-options-row" },
                    [
                      _vm.$store.state.forum.pushNotifications &&
                      _vm.$store.state.forum.pushNotifications.length > 0
                        ? _c(
                            "b-col",
                            {
                              attrs: { cols: "12" },
                              on: {
                                click: function($event) {
                                  _vm.showConfirmDelete = true
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "more-options-item" },
                                [
                                  _c("b-icon-calendar-x"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("removeHistory")))
                                  ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          attrs: { cols: "12" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goNotificationsSetting.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "more-options-item" },
                            [
                              _c("b-icon-sliders"),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("settingNotifications")))
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$store.state.forum.pushNotifications &&
          _vm.$store.state.forum.pushNotifications.length > 0
            ? _c(
                "div",
                _vm._l(_vm.$store.state.forum.pushNotifications, function(
                  item,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: {
                        pushNotificationBox: true,
                        pendingRead: !item.readed,
                        markedSection: item.markedSectionId === item.sectionId
                      },
                      on: {
                        click: function($event) {
                          return _vm.pushNotificationClick(
                            item.entryId,
                            item.sectionId
                          )
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "pushNotificationMessage",
                        domProps: { innerHTML: _vm._s(item.message) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "datePushNotification",
                        domProps: {
                          innerHTML: _vm._s(_vm.getTimeAgoFromDate(item.date))
                        }
                      })
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "noPendingNotifications" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("noPendingPushNotifications")) +
                    "\n    "
                )
              ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.$store.state.loading
        ? _c("loading-anim", {
            attrs: { active: _vm.$store.state.loading, fullScreen: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("arrow-up"),
      _vm._v(" "),
      _vm.$store.state.forum.showMainPage ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _c("forum-searcher", { attrs: { search: _vm.search } }),
      _vm._v(" "),
      _vm.showActivitySearch
        ? _c("forum-activity-search", {
            model: {
              value: _vm.showActivitySearch,
              callback: function($$v) {
                _vm.showActivitySearch = $$v
              },
              expression: "showActivitySearch"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          value: _vm.showConfirmDelete,
          okFn: function() {
            _vm.removePushNotifications()
            _vm.showConfirmDelete = false
          },
          cancelFn: function() {
            _vm.showConfirmDelete = false
          },
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          content: _vm.$t("removePushNotifications")
        }
      }),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          attrs: {
            hideClose: "",
            noCloseOnBackdrop: "",
            noCloseOnScape: "",
            value: _vm.$store.state.forum.userBasicInfo.firstAccess,
            title: _vm.getModalFirstAccessTitle
          },
          on: {
            hidden: function($event) {
              _vm.$store.state.forum.userBasicInfo.firstAccess = false
            }
          }
        },
        [
          _c("div", { staticClass: "mb-4" }, [
            _vm._v(_vm._s(_vm.$t("firstAccessForum")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-4" }, [
            _vm._v(_vm._s(_vm.$t("firstAccessNickForum")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-4" },
            [
              _c("base-input", {
                model: {
                  value: _vm.$store.state.forum.userBasicInfo.nick,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.forum.userBasicInfo, "nick", $$v)
                  },
                  expression: "$store.state.forum.userBasicInfo.nick"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mb-4" }, [
            _c("b", [_vm._v(_vm._s(_vm.$t("firstAccessFooterForum")))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("base-button", { on: { click: _vm.saveNewNick } }, [
                _vm._v(_vm._s(_vm.$t("continue")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "no-close-on-esc": "",
            size: "lg",
            centered: "",
            "hide-footer": ""
          },
          model: {
            value: _vm.showMonthlyAdviceModal,
            callback: function($$v) {
              _vm.showMonthlyAdviceModal = $$v
            },
            expression: "showMonthlyAdviceModal"
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("monthlyAccessAdvice")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c(
                  "base-button",
                  { on: { click: _vm.resetMonthlyAccessAdvice } },
                  [_vm._v(_vm._s(_vm.$t("continue")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90301aea", esExports)
  }
}

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyHabitsLayout_vue__ = __webpack_require__(1163);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4ced80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyHabitsLayout_vue__ = __webpack_require__(2011);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2009)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HealthyHabitsLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d4ced80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthyHabitsLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/HealthyHabitsLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d4ced80", Component.options)
  } else {
    hotAPI.reload("data-v-1d4ced80", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2010);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("091c5dfa", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1d4ced80\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyHabitsLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1d4ced80\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HealthyHabitsLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\nh1,h2,h3,h4,h5{color:#3238C4\n}\n@media only screen and (min-width: 1024px){\n.container{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.container{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.container{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.container{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.container{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.container{padding-right:2rem;padding-left:2rem\n}\n}\n.healthy-habits-theme.velmld-parent{min-height:70dvh;background-color:#E4E4E4\n}\n.cookies-banner.healthy-habits-theme{min-height:auto\n}\n.cursor-pointer{cursor:pointer\n}\n.cursor-default{cursor:default\n}\n.cursor-default-trophy a{cursor:default\n}\n.cursor-default-trophy span:hover{color:#333\n}\n.center{text-align:center\n}\n.text-center{text-align:center\n}\n.navbar-mobile-fixed{text-align:center;position:fixed !important;right:0\n}\n.display-inline-block{display:inline-block\n}\n.settings-menu-item{font-size:1rem !important\n}\n.popover-options-row{text-align:center\n}\n.partial-fill-opacity{opacity:0.5\n}\n.linear-gradient{opacity:0.5;background:repeating-linear-gradient(-45deg, transparent, transparent 5px, #000 3px, #000 9px)\n}\n.white{color:#eee\n}\n.blue{color:#3238C4\n}\n.green{color:#6AEF89\n}\n.gray{color:#979797\n}\n.red{color:#FF7061\n}\n.orange{color:#F0B06D\n}\n.black{color:#1D1D1E\n}\n.arrow-go-top{position:fixed !important;display:block !important;top:89vh !important;left:5vw !important;z-index:2 !important;color:#3238C4 !important;cursor:pointer\n}\n@media only screen and (max-width: 575px){\n.arrow-go-top{top:80vh !important;left:8vw !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.arrow-go-top{top:80vh !important;left:8vw !important\n}\n}\n.back-btn-statistics{display:block !important;position:fixed !important;z-index:1 !important;left:5vw !important;top:15vh !important;margin-bottom:1%;margin-left:2%;font-size:.875rem !important;font-weight:initial;padding:.7rem 2.2rem;background-color:#3238C4\n}\n@media screen and (max-width: 1023px){\n.back-btn-statistics{position:fixed !important;top:85vh !important;padding:0.7rem !important;margin-bottom:0;margin-left:0\n}\n}\n#healthyHabitsCalendarContainer{display:inline-block\n}\n.inline-block{display:inline-block\n}\n.label-align{min-width:245px;display:block;text-align:left\n}\n@media only screen and (max-width: 575px){\n.label-align{min-width:200px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.label-align{min-width:200px\n}\n}\n.input-form-centered{margin-left:auto;margin-right:auto;max-width:300px\n}\n@media only screen and (max-width: 575px){\n.modal-content{margin-left:auto;margin-right:auto\n}\n}\n.smartsupp-widget-button{display:-webkit-inline-box !important;display:-ms-inline-flexbox !important;display:inline-flex !important\n}\n.info-title{cursor:pointer;color:black;width:14px;height:14px;display:inline-block !important;vertical-align:middle !important\n}\n.back-btn-faqs{font-size:.875rem !important;font-weight:initial;padding:.7rem 2.2rem;background-color:#3238C4\n}\n.font-bold{font-weight:bold\n}\n@media only screen and (max-width: 575px){\nul.navbar-nav:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nul.navbar-nav:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\nul.navbar-nav:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);box-shadow:-13px -23px 45px #fff,13px 23px 50px rgba(13,39,80,0.160784);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content\n}\n}\n.navbar-healthy-habits-commom{padding:2rem 11rem;background-color:#E4E4E4\n}\n@media only screen and (min-width: 2000px){\n.navbar-healthy-habits-commom{padding:2rem 20rem\n}\n}\n.navCollapse{position:fixed !important;top:4rem;right:1rem !important;-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n@media only screen and (min-width: 1200px){\n.navCollapse{position:-webkit-sticky !important;position:sticky !important\n}\n}\n@media only screen and (max-width: 1199px){\n.navbar-healthy-habits{padding-left:2vw;display:block !important;padding-right:0px !important\n}\n}\n.navbar-items-align{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start\n}\n@media only screen and (max-width: 1199px){\n.navbar-items-align{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n}\n.navbar-submenu{-webkit-box-align:center !important;-ms-flex-align:center !important;align-items:center !important\n}\n@media only screen and (min-width: 1024px){\n.nav-item{margin-right:0rem\n}\n}\n@media only screen and (max-width: 575px){\n.nav-item{padding:0rem 2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.nav-item{padding:0rem 2rem\n}\n}\n@media only screen and (min-width: 1200px){\n.navbar-healthy-habits-commom.navbar-expand-xl .navCollapse{display:-webkit-box !important;display:-ms-flexbox !important;display:flex !important;-ms-flex-preferred-size:auto;flex-basis:auto\n}\n}\n@media only screen and (max-width: 1199px){\n.fixed-padding-btn-access{padding:0.4rem 1rem !important\n}\n}\n.navbar-login{padding-left:2vw !important;padding-right:2vw !important\n}\n.doubs-menu-outside{position:absolute;padding-top:2rem;right:90px;top:15px;cursor:pointer\n}\n.config-menu-outside{position:absolute;padding-top:2rem;right:60px;top:15px;cursor:pointer\n}\n.trophy-menu-outside{position:absolute;padding-top:2rem;right:120px;top:15px\n}\ndiv[name=\"new-value-input\"] input{width:124px !important;max-width:124px\n}\ndiv[name=\"new-value-input\"] .input-group-text{max-width:123px;overflow:hidden\n}\n@media screen and (min-width: 470px){\ndiv[name=\"new-value-input\"] .input-group-text{max-width:251px\n}\n}\n.container-healthy-habits{padding-right:2rem;padding-left:2rem\n}\n", ""]);

// exports


/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.getters["session/isLogged"]
    ? _c(
        "IdleTracker",
        [
          _vm.$store.state.healthyHabits.isReadOnlyView
            ? _c(
                "b-navbar",
                {
                  staticClass:
                    "navbar-healthy-habits navbar-healthy-habits-commom navbar-login",
                  attrs: { sticky: "", toggleable: "xl" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "navbar-items-align" },
                    [
                      _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-navbar-brand",
                        {
                          staticClass: "cursor-pointer mx-auto mx-lg-0",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goPatientMenu()
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "navbar-brand-img",
                            style: _vm.getLogoStyles,
                            attrs: { src: _vm.getLogo }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      attrs: { outline: "", fitContent: "" },
                      on: { click: _vm.closeTab }
                    },
                    [_vm._v(_vm._s(_vm.$t("close")))]
                  )
                ],
                1
              )
            : _c(
                "b-navbar",
                {
                  staticClass:
                    "navbar-healthy-habits navbar-healthy-habits-commom",
                  attrs: { sticky: "", toggleable: "xl" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "navbar-items-align" },
                    [
                      _c(
                        "b-nav-item",
                        {
                          staticClass: "d-block my-auto my-auto pr-2",
                          on: { click: _vm.onBackButtonClick }
                        },
                        [
                          _c("base-icon", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                              svgClasses: "rotate-180",
                              width: "20",
                              height: "20"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-navbar-brand",
                        {
                          staticClass: "cursor-pointer mx-auto mx-lg-0",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goPatientMenu()
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "navbar-brand-img",
                            style: _vm.getLogoStyles,
                            attrs: { src: _vm.getLogo }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-navbar-toggle", {
                        attrs: { target: "nav-collapse" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "navbar-mobile-fixed navCollapse",
                      attrs: { id: "nav-collapse" }
                    },
                    [
                      _c(
                        "b-navbar-nav",
                        { staticClass: "navbar-submenu ml-auto" },
                        [
                          _c(
                            "b-nav-item",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$router.push({
                                    name: "healthyHabitsFaqs"
                                  })
                                }
                              }
                            },
                            [
                              _c(
                                "base-button",
                                { attrs: { outline: "", fitContent: "" } },
                                [_vm._v(_vm._s(_vm.$t("doubts")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-nav-item",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showSettingModal()
                                }
                              }
                            },
                            [
                              _c(
                                "base-button",
                                { attrs: { outline: "", fitContent: "" } },
                                [_vm._v(_vm._s(_vm.$t("setting")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.showInSubmenu
                            ? _c(
                                "b-nav-item",
                                [
                                  _c(
                                    "base-button",
                                    { attrs: { outline: "", fitContent: "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.healthyHabits.setting
                                            .nick
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showInSubmenu
                            ? _c(
                                "b-nav-item",
                                { staticClass: "my-auto" },
                                [
                                  _c(
                                    "base-button",
                                    {
                                      staticClass: "btn-dropdown",
                                      staticStyle: {
                                        "background-color": "transparent",
                                        width: "10rem"
                                      }
                                    },
                                    [
                                      _vm.$store.state.healthyHabits.setting
                                        .nick
                                        ? _c("dropdown", {
                                            staticClass: "dropdown",
                                            attrs: {
                                              enablePortuguese: "",
                                              showLanguageSelector: "",
                                              title:
                                                _vm.$store.state.healthyHabits
                                                  .setting.nick,
                                              items: _vm.dropdownLoginItems
                                            },
                                            on: { logOff: _vm.logOff }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.showInSubmenu
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-nav-item",
                                    [
                                      _c("lang-selector", {
                                        staticClass: "d-inline-block",
                                        staticStyle: {
                                          margin: "0px !important"
                                        },
                                        attrs: { enablePortuguese: "" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-nav-item",
                                    {
                                      directives: [
                                        {
                                          name: "b-toggle",
                                          rawName: "v-b-toggle.nav-collapse",
                                          modifiers: { "nav-collapse": true }
                                        }
                                      ],
                                      on: { click: _vm.logOff }
                                    },
                                    [
                                      _c(
                                        "base-button",
                                        {
                                          attrs: { outline: "", fitContent: "" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("logOff")))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
          _vm._v(" "),
          _vm.$store.state.loading &&
          !_vm.$store.state.healthyHabits.hideLoadingIcon
            ? _c("loading-anim", {
                attrs: { active: _vm.$store.state.loading, fullScreen: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                noCloseOnBackdrop: "",
                noCloseOnScape: "",
                hideClose: "",
                bodyClass: "text-center",
                value: _vm.$store.state.healthyHabits.showMeasurableInputModal,
                title: _vm.$t("enterNewValue")
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showMeasurableInputModal = false
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c("base-input", {
                    attrs: {
                      name: "new-value-input",
                      min: 0,
                      placeholder: "",
                      inlineBlock: "",
                      type: "number"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$store.state.healthyHabits.itemSelected
                                      .measureUnit
                                  ) +
                                  "\n        "
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1331934096
                    ),
                    model: {
                      value:
                        _vm.$store.state.healthyHabits.itemSelected.newValue,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$store.state.healthyHabits.itemSelected,
                          "newValue",
                          $$v
                        )
                      },
                      expression:
                        "$store.state.healthyHabits.itemSelected.newValue"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-1 my-1",
                      on: {
                        click: function($event) {
                          return _vm.sendMeasurableData()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                  _c(
                    "base-button",
                    {
                      attrs: { gray: "", outline: "" },
                      on: {
                        click: function($event) {
                          _vm.$store.state.healthyHabits.itemSelected.newValue =
                            _vm.$store.state.healthyHabits.itemSelected.currentValue
                          _vm.$store.state.healthyHabits.showMeasurableInputModal = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("back")))]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                bodyClass: "text-center",
                value: _vm.$store.state.healthyHabits.showGoalCompletedModal,
                title: _vm.$t("congratulations")
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showGoalCompletedModal = false
                }
              }
            },
            [
              _c("div", [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("goalCompletedText")) + "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "my-3" },
                [
                  _c(
                    "base-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.$store.state.healthyHabits.showGoalCompletedModal = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("continue")))]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                width25: "",
                value: _vm.$store.state.healthyHabits.form.show
              },
              on: {
                hide: function($event) {
                  return _vm.healthyHabitsFormModalHidden()
                }
              }
            },
            [
              _c("healthy-habits-form", {
                attrs: { inModal: "" },
                on: {
                  closeModal: function($event) {
                    return _vm.healthyHabitsFormModalHidden()
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                width25: "",
                value: _vm.$store.state.healthyHabits.showTableLegendModal
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showTableLegendModal = false
                }
              }
            },
            [
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("healthyHabitsGeneral")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-pencil-square", { staticClass: "blue" }),
                      _vm._v(" " + _vm._s(_vm.$t("edit")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-bar-chart-fill", { staticClass: "orange" }),
                      _vm._v(" " + _vm._s(_vm.$t("stadistics")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-trash", { staticClass: "red" }),
                      _vm._v(" " + _vm._s(_vm.$t("removeOrStore")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-arrow-clockwise", { staticClass: "black" }),
                      _vm._v(" " + _vm._s(_vm.$t("restore")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-save", {
                        staticClass: "description-icon-width"
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("stored")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-trophy-fill", {
                        staticStyle: { color: "#3238C4" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("completed")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-progress",
                        {
                          staticStyle: {
                            display: "inline-grid",
                            "min-width": "65px"
                          },
                          attrs: { max: 100 }
                        },
                        [
                          _c("b-progress-bar", {
                            attrs: {
                              value: 50,
                              "label-html":
                                "<span style='font-weight: bold;' class='progressBarTable'>50%</span>"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" " + _vm._s(_vm.$t("progressBar")) + "\n      ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("nonMeasurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-check-lg", {
                        staticStyle: { color: "#3238C4" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("completed")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-check-lg", {
                        staticClass: "partial-fill-opacity",
                        staticStyle: { color: "#3238C4" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("partialCompleted")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-dash", {
                        staticStyle: { color: "#3238C4" },
                        attrs: { scale: "2" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("freeDay")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-icon-x-lg"),
                      _vm._v(" " + _vm._s(_vm.$t("uncompleted")))
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("measurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _vm._v(_vm._s(_vm.$t("measurableInfo")))
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _vm._v(_vm._s(_vm.$t("measurableInfo2")))
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "my-3", attrs: { cols: "12" } }, [
                    _c("label", { staticStyle: { "font-size": "11px" } }, [
                      _vm._v("*" + _vm._s(_vm.$t("calendarLegendColorInfo")))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                width25: "",
                value: _vm.$store.state.healthyHabits.showCalendarLegendModal
              },
              on: {
                hide: function($event) {
                  _vm.$store.state.healthyHabits.showCalendarLegendModal = false
                }
              }
            },
            [
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("healthyHabitsGeneral")))]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("calendarInfo")))]),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("nonMeasurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("completed")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style partial-fill-opacity",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("partialCompleted")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style linear-gradient",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("freeDay")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#979797",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("uncompleted")))]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "my-3",
                  staticStyle: { "text-decoration": "underline" }
                },
                [_vm._v(_vm._s(_vm.$t("measurable")))]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("completed")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style partial-fill-opacity",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("partialCompleted")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style linear-gradient",
                        staticStyle: {
                          "background-color": "#3238C4",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("filled")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "cell-style",
                        staticStyle: {
                          "background-color": "#979797",
                          height: "19px",
                          width: "19px",
                          display: "inline-block"
                        }
                      },
                      [_vm._v("1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block !important",
                          "vertical-align": "middle !important"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("uncompleted")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "my-3", attrs: { cols: "12" } }, [
                    _c("label", { staticStyle: { "font-size": "11px" } }, [
                      _vm._v("*" + _vm._s(_vm.$t("calendarLegendColorInfo")))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                noCloseOnBackdrop: "",
                noCloseOnScape: "",
                hideClose: "",
                bodyClass: "text-center",
                value: _vm.$store.state.healthyHabits.setting.showModal,
                title: _vm.$t("setting")
              }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .showStoredHabits,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "showStoredHabits",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.showStoredHabits"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("showStoredHabits"))
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .showGoalCompletedHabits,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "showGoalCompletedHabits",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.showGoalCompletedHabits"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("showGoalCompletedHabits")
                              )
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          on: { change: _vm.allowFreeDaysChange },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .allowFreeDays,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "allowFreeDays",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.allowFreeDays"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("allowFreeDays"))
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "form-group",
                          attrs: { switch: "" },
                          model: {
                            value:
                              _vm.$store.state.healthyHabits.setting
                                .invertedCalendarDays,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$store.state.healthyHabits.setting,
                                "invertedCalendarDays",
                                $$v
                              )
                            },
                            expression:
                              "$store.state.healthyHabits.setting.invertedCalendarDays"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "label-align",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("invertCalendarDays"))
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("base-input", {
                        staticClass: "input-form-centered",
                        attrs: {
                          tooltip: _vm.$t("notificationsEmail"),
                          placeholder: _vm.$t("notificationsEmail"),
                          type: "text"
                        },
                        model: {
                          value:
                            _vm.$store.state.healthyHabits.setting.notifications
                              .email,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$store.state.healthyHabits.setting
                                .notifications,
                              "email",
                              $$v
                            )
                          },
                          expression:
                            "$store.state.healthyHabits.setting.notifications.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("base-input", {
                        staticClass: "input-form-centered",
                        attrs: {
                          tooltip: _vm.$t("notificationsPhoneTooltip"),
                          placeholder: _vm.$t("notificationsPhone"),
                          type: "text"
                        },
                        model: {
                          value:
                            _vm.$store.state.healthyHabits.setting.notifications
                              .phone,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$store.state.healthyHabits.setting
                                .notifications,
                              "phone",
                              $$v
                            )
                          },
                          expression:
                            "$store.state.healthyHabits.setting.notifications.phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "my-3" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-2",
                      on: {
                        click: function($event) {
                          return _vm.updateSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                  _c(
                    "base-button",
                    {
                      attrs: { gray: "", outline: "" },
                      on: {
                        click: function($event) {
                          return _vm.resetSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("back")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("base-dialog", {
            attrs: {
              value: _vm.showAllowFreeDaysAdvice,
              okFn: function() {
                _vm.showAllowFreeDaysAdvice = false
              },
              cancelFn: function() {
                _vm.showAllowFreeDaysAdvice = false
                _vm.$store.state.healthyHabits.setting.allowFreeDays = true
              },
              okBtnText: _vm.$t("yes"),
              cancelBtnText: _vm.$t("no"),
              content: _vm.$t("allowFreeDaysAdvice")
            }
          }),
          _vm._v(" "),
          _c("arrow-up"),
          _vm._v(" "),
          _c("router-view", {
            staticClass: "container-md container-healthy-habits"
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d4ced80", esExports)
  }
}

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternalReducedLayout_vue__ = __webpack_require__(1164);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8079176_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternalReducedLayout_vue__ = __webpack_require__(2016);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2013)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8079176"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternalReducedLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8079176_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternalReducedLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/InternalReducedLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e8079176", Component.options)
  } else {
    hotAPI.reload("data-v-e8079176", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2014);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0a7054e3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8079176\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./InternalReducedLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8079176\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./InternalReducedLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-e8079176]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-e8079176],.slide-down-leave-active[data-v-e8079176]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-e8079176],.slide-down-leave-to[data-v-e8079176]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-e8079176],.slide-fade-left-leave-active[data-v-e8079176]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-e8079176],.slide-fade-left-leave-to[data-v-e8079176]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-e8079176]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-e8079176],.fade-leave-to[data-v-e8079176]{opacity:0\n}\n@media only screen and (min-width: 1024px){\n.ctm-container[data-v-e8079176]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.ctm-container[data-v-e8079176]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-e8079176]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-e8079176]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-e8079176]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.ctm-container[data-v-e8079176]{padding-right:2rem;padding-left:2rem\n}\n}\n.ctm-container h3[data-v-e8079176]{color:black\n}\n@media only screen and (max-width: 575px){\n[data-v-e8079176] .navbar-brand{margin-right:0\n}\n[data-v-e8079176] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:transparent !important;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.navbar[data-v-e8079176]{padding:1rem 2rem\n}\n.navbar .btn-layout[data-v-e8079176]{font-size:.875rem !important;font-weight:initial;padding:.7rem 2.2rem;background-color:#3238C4\n}\n}\n[data-v-e8079176] .nav-item{margin-right:0rem\n}\n@media only screen and (max-width: 575px){\n[data-v-e8079176] .nav-item{padding:0rem\n}\n}\n[data-v-e8079176] .navbar-brand-img{width:150px\n}\n[data-v-e8079176].fade-enter-active,.fade-leave-active[data-v-e8079176]{-webkit-transition:opacity 0.5s ease;transition:opacity 0.5s ease\n}\n[data-v-e8079176].fade-enter-from,.fade-leave-to[data-v-e8079176]{opacity:0\n}\n", ""]);

// exports


/***/ }),
/* 2015 */
/***/ (function(module, exports) {

module.exports = {"Opensalud":["/static-appopensalud/gtags/gtag-opensaludes.js"],"opensalud":["/static-appopensalud/gtags/gtag-opensaludes.js"],"Opensalud 360":["/static-appopensalud/gtags/gtag-opensaludes.js"],"opensalud360":["/static-appopensalud/gtags/gtag-opensaludes.js"],"Opensaludprime":["https://www.googletagmanager.com/gtag/js?id=G-MNCV80RN1Y","/static-appopensalud/gtags/gtag-primesalud.js"],"opensaludprime":["https://www.googletagmanager.com/gtag/js?id=G-MNCV80RN1Y","/static-appopensalud/gtags/gtag-primesalud.js"]}

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c(
        "b-navbar",
        { staticClass: "navbar", attrs: { toggleable: "lg" } },
        [
          _c(
            "router-link",
            { attrs: { to: "/" } },
            [
              _c("b-navbar-brand", [
                _c("img", {
                  staticClass: "navbar-brand-img",
                  style: _vm.getLogoStyles,
                  attrs: { src: _vm.getLogo }
                })
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ctm-container" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "12", md: "12" } },
                [
                  _c("h3", { class: _vm.styleClasses }, [
                    _vm._v(_vm._s(_vm.getMetaTitle))
                  ]),
                  _vm._v(" "),
                  _c("router-view", { staticClass: "mt-4" })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8079176", esExports)
  }
}

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opensalud360Layout_vue__ = __webpack_require__(1165);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177f3aac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opensalud360Layout_vue__ = __webpack_require__(2023);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2018)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opensalud360Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177f3aac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opensalud360Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/Opensalud360Layout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-177f3aac", Component.options)
  } else {
    hotAPI.reload("data-v-177f3aac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2019);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("4adcf80b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-177f3aac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Opensalud360Layout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-177f3aac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Opensalud360Layout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b1f7476a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-235e2044\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicMenuLayoutV2.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-235e2044\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicMenuLayoutV2.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-235e2044]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-235e2044],.slide-down-leave-active[data-v-235e2044]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-235e2044],.slide-down-leave-to[data-v-235e2044]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-235e2044],.slide-fade-left-leave-active[data-v-235e2044]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-235e2044],.slide-fade-left-leave-to[data-v-235e2044]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-235e2044]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-235e2044],.fade-leave-to[data-v-235e2044]{opacity:0\n}\n[data-v-235e2044]:root{--margin-top-dropdown-menu: 0px\n}\n[data-v-235e2044].os-navbar{-ms-flex-wrap:initial;flex-wrap:initial;width:100%;z-index:5;position:fixed;-webkit-box-orient:initial;-webkit-box-direction:initial;-ms-flex-direction:initial;flex-direction:initial\n}\n@media only screen and (min-width: 1024px){\n[data-v-235e2044].os-navbar{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n[data-v-235e2044].os-navbar{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-235e2044].os-navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-235e2044].os-navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n[data-v-235e2044].os-navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-235e2044].os-navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-235e2044].os-navbar{padding-top:1.5rem;padding-bottom:1.5rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-235e2044].os-navbar{padding-top:0;padding-bottom:0;z-index:1000\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-235e2044].os-navbar{padding-top:0;padding-bottom:0;z-index:1000\n}\n}\n[data-v-235e2044].os-navbar .nav-item{margin-top:auto;margin-bottom:auto\n}\n[data-v-235e2044].os-navbar .nav-link{color:#3238C4;font-weight:600;-webkit-transition:all .5s ease;transition:all .5s ease\n}\n[data-v-235e2044].os-navbar .nav-link:not(:has(.btn)):not(.nav-item-profile):hover{-webkit-transform:scale(1.05);transform:scale(1.05);-webkit-transition:all .5s ease;transition:all .5s ease\n}\n@media only screen and (min-width: 1024px){\n[data-v-235e2044].os-navbar{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse\n}\n[data-v-235e2044].os-navbar .navbar-brand{margin-right:auto\n}\n[data-v-235e2044].os-navbar .nav-item{padding-right:1rem;padding-left:1rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n[data-v-235e2044].os-navbar .nav-item{padding-right:0rem\n}\n}\n[data-v-235e2044].os-navbar.fixed-scroll{background-color:#ffffffdd;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border-bottom-left-radius:18px;border-bottom-right-radius:18px;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);-webkit-transition:0.1s all ease-out;transition:0.1s all ease-out\n}\n@media only screen and (max-width: 575px){\n[data-v-235e2044].os-navbar.fixed-scroll.negative-menu{background-color:#1D1D1Ddd\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-235e2044].os-navbar.fixed-scroll.negative-menu{background-color:#1D1D1Ddd\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-235e2044].os-navbar .navbar-brand{margin-right:0\n}\n[data-v-235e2044].os-navbar .collapse{margin-top:var(--margin-top-dropdown-menu);opacity:1;text-align:center;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);position:fixed\n}\n[data-v-235e2044].os-navbar .collapse .navbar-nav{padding:1rem\n}\n[data-v-235e2044].os-navbar .nav-link{padding:0\n}\n[data-v-235e2044].os-navbar .nav-item{padding-top:1rem;padding-bottom:1rem\n}\n[data-v-235e2044].os-navbar .nav-item p{padding:0;margin:0\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-235e2044].os-navbar .navbar-brand{margin-right:0\n}\n[data-v-235e2044].os-navbar .collapse{margin-top:var(--margin-top-dropdown-menu);opacity:1;text-align:center;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);position:fixed\n}\n[data-v-235e2044].os-navbar .collapse .navbar-nav{padding:1rem\n}\n[data-v-235e2044].os-navbar .nav-link{padding:0\n}\n[data-v-235e2044].os-navbar .nav-item{padding-top:1rem;padding-bottom:1rem\n}\n[data-v-235e2044].os-navbar .nav-item p{padding:0;margin:0\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-235e2044].os-navbar .navbar-brand{margin-right:0\n}\n[data-v-235e2044].os-navbar .collapse{margin-top:var(--margin-top-dropdown-menu);opacity:1;text-align:center;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);position:fixed\n}\n[data-v-235e2044].os-navbar .collapse .navbar-nav{padding:1rem\n}\n[data-v-235e2044].os-navbar .nav-link{padding:0\n}\n[data-v-235e2044].os-navbar .nav-item{padding-top:1rem;padding-bottom:1rem\n}\n[data-v-235e2044].os-navbar .nav-item p{padding:0;margin:0\n}\n}\n.add-to-home-screen[data-v-235e2044]{position:fixed;bottom:1rem;left:2rem;z-index:1000;font-weight:bold;text-transform:uppercase\n}\n@media only screen and (min-width: 1024px){\n.add-to-home-screen[data-v-235e2044]{bottom:2rem;left:3rem\n}\n}\n", ""]);

// exports


/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.loading
        ? _c("loading-anim", {
            attrs: { active: _vm.$store.state.loading, fullScreen: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-navbar",
        {
          staticClass: "os-navbar",
          class: {
            "fixed-scroll": _vm.isFixedScrolled,
            "negative-menu": _vm.invertedColorsMobile
          },
          attrs: { toggleable: _vm.isToggleable }
        },
        [
          _c(
            "b-navbar-toggle",
            { attrs: { id: "navbar-toggler", target: "nav-collapse" } },
            [
              _c("base-icon", {
                style: { color: _vm.color },
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/menu-icon.svg",
                  color: _vm.color,
                  width: _vm.iconSize,
                  height: _vm.iconSize
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hideMenu,
                  expression: "hideMenu"
                }
              ],
              attrs: { id: "nav-collapse", "is-nav": "" },
              model: {
                value: _vm.collapseVisible,
                callback: function($$v) {
                  _vm.collapseVisible = $$v
                },
                expression: "collapseVisible"
              }
            },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-0 ml-desktop-auto ml-xl-auto" },
                [
                  _c(
                    "b-nav-item",
                    { staticClass: "mr-0 mr-lg-2" },
                    [_c("lang-selector", { attrs: { enablePortuguese: "" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._t("nav-items"),
                  _vm._v(" "),
                  _vm._t("nav-btn-items")
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-navbar-brand", { attrs: { href: "/" } }, [
            _c("img", {
              class: _vm.getLogoClasses,
              style: _vm.getLogoStyles,
              attrs: { src: _vm.getLogo }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-nav-item",
            { staticClass: "d-xl-none d-desktop-none d-block" },
            [
              _c(
                "button",
                {
                  staticClass: "navbar-toggler",
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/inicio-sesion")
                    }
                  }
                },
                [
                  _c("base-icon", {
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg",
                      color: _vm.color,
                      width: _vm.iconSize,
                      height: _vm.iconSize
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._t("heading"),
          _vm._v(" "),
          !_vm.showTabContent || !_vm.$uiHelpers.isXlDevice
            ? _c("router-view", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var Component = ref.Component
                        return [
                          _c(
                            "transition",
                            { attrs: { name: "fade", mode: "out-in" } },
                            [_c(Component, { tag: "component" })],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2832544733
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstallAppButton
            ? _c("AddToHomeScreen", {
                staticClass: "add-to-home-screen",
                attrs: { animate: "", shadow: "" }
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-235e2044", esExports)
  }
}

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    attrs: { showInstallAppButton: "" },
    scopedSlots: _vm._u([
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              {
                staticClass:
                  "my-auto d-none d-desktop-block d-xl-block ml-0 ml-xl-2"
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/inicio-sesion" } },
                  [
                    _c("ArrowButton", {
                      attrs: {
                        text: _vm.$t("login-wrd"),
                        action: function() {
                          _vm.$router.push("/inicio-sesion")
                        },
                        reverse: "",
                        backgroundColor: _vm.BLUE_COLOUR,
                        textColor: _vm.WHITE_COLOUR
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-177f3aac", esExports)
  }
}

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludEmpresasLayout_vue__ = __webpack_require__(1167);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70bedade_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludEmpresasLayout_vue__ = __webpack_require__(2027);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2025)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludEmpresasLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70bedade_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludEmpresasLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/OpensaludEmpresasLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70bedade", Component.options)
  } else {
    hotAPI.reload("data-v-70bedade", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2026);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("06f5a6aa", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-70bedade\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludEmpresasLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-70bedade\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludEmpresasLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    scopedSlots: _vm._u([
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              { staticClass: "d-none d-desktop-block d-xl-block" },
              [
                _c(
                  "base-button",
                  { attrs: { blue: "" }, on: { click: _vm.goToContactForm } },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("os360-empresas.more-info-btn")))
                    ]),
                    _vm._v(" "),
                    _c("base-icon", {
                      staticClass: "ml-2",
                      attrs: {
                        src:
                          "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                        color: "white"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-nav-item",
              {
                staticClass: "d-none d-desktop-block d-xl-block",
                attrs: { href: _vm.$helpers.get360AppUrl("inicio-sesion") }
              },
              [
                _c(
                  "base-button",
                  { attrs: { white: "", shadow: "", bold: "" } },
                  [_vm._v(_vm._s(_vm.$t("login.sign-in")))]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70bedade", esExports)
  }
}

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludLayout_vue__ = __webpack_require__(1168);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44dfc232_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludLayout_vue__ = __webpack_require__(2031);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2029)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44dfc232"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44dfc232_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/OpensaludLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44dfc232", Component.options)
  } else {
    hotAPI.reload("data-v-44dfc232", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2030);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("f9a3217c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-44dfc232\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-44dfc232\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-44dfc232]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-44dfc232],.slide-down-leave-active[data-v-44dfc232]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-44dfc232],.slide-down-leave-to[data-v-44dfc232]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-44dfc232],.slide-fade-left-leave-active[data-v-44dfc232]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-44dfc232],.slide-fade-left-leave-to[data-v-44dfc232]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-44dfc232]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-44dfc232],.fade-leave-to[data-v-44dfc232]{opacity:0\n}\n/deep/p[data-v-44dfc232]{margin-bottom:0\n}\n", ""]);

// exports


/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    attrs: { showInstallAppButton: "" },
    scopedSlots: _vm._u([
      {
        key: "nav-items",
        fn: function() {
          return [
            !_vm.inMx
              ? _c(
                  "b-nav-item",
                  { on: { click: _vm.goToOpensalud4allLanding } },
                  [_c("p", [_vm._v("Opensalud4all")])]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.inMx
              ? _c("b-nav-item", { on: { click: _vm.goToMenttum } }, [
                  _c("p", [_vm._v("Menttum")])
                ])
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              {
                staticClass:
                  "my-auto d-none d-landscape-block ml-portrait-0 ml-portrait-2"
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/inicio-sesion" } },
                  [
                    _c("ArrowButton", {
                      attrs: {
                        text: _vm.$t("login-wrd"),
                        action: function() {
                          _vm.$router.push("/inicio-sesion")
                        },
                        reverse: "",
                        backgroundColor: _vm.BLUE_COLOUR,
                        textColor: _vm.WHITE_COLOUR
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44dfc232", esExports)
  }
}

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludPacientesLayout_vue__ = __webpack_require__(1169);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391540ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludPacientesLayout_vue__ = __webpack_require__(2035);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2033)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-391540ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludPacientesLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_391540ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludPacientesLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/OpensaludPacientesLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-391540ff", Component.options)
  } else {
    hotAPI.reload("data-v-391540ff", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2034);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("7ec534b8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-391540ff\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludPacientesLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-391540ff\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludPacientesLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-391540ff]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-391540ff],.slide-down-leave-active[data-v-391540ff]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-391540ff],.slide-down-leave-to[data-v-391540ff]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-391540ff],.slide-fade-left-leave-active[data-v-391540ff]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-391540ff],.slide-fade-left-leave-to[data-v-391540ff]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-391540ff]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-391540ff],.fade-leave-to[data-v-391540ff]{opacity:0\n}\n@media only screen and (max-width: 575px){\n[data-v-391540ff] .navbar-nav{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-391540ff] .navbar-nav{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n", ""]);

// exports


/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    attrs: { invertedColorsMobile: "" },
    scopedSlots: _vm._u([
      {
        key: "nav-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              {
                staticClass: "my-auto",
                on: {
                  click: function() {
                    _vm.$helpers.goToProfessionalsLanding()
                  }
                }
              },
              [_c("p", [_vm._v(_vm._s(_vm.$t("professionals")))])]
            ),
            _vm._v(" "),
            _c(
              "b-nav-item",
              [
                _c(
                  "router-link",
                  { attrs: { to: "/opensalud360/empresas", tag: "p" } },
                  [_vm._v(_vm._s(_vm.$t("patients-layout.companies")))]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              { staticClass: "my-auto d-block ml-0 ml-xl-2" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/inicio-sesion" } },
                  [
                    _c("ArrowButton", {
                      attrs: {
                        text: _vm.$t("login-wrd"),
                        action: function() {
                          _vm.$router.push("/inicio-sesion")
                        },
                        reverse: "",
                        backgroundColor: _vm.BLUE_COLOUR,
                        textColor: _vm.WHITE_COLOUR
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-391540ff", esExports)
  }
}

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludProfesionalesLayout_vue__ = __webpack_require__(1170);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563f1652_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludProfesionalesLayout_vue__ = __webpack_require__(2039);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2037)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-563f1652"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpensaludProfesionalesLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563f1652_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpensaludProfesionalesLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/OpensaludProfesionalesLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-563f1652", Component.options)
  } else {
    hotAPI.reload("data-v-563f1652", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2038);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("e5885cd0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-563f1652\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludProfesionalesLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-563f1652\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OpensaludProfesionalesLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-563f1652]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-563f1652],.slide-down-leave-active[data-v-563f1652]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-563f1652],.slide-down-leave-to[data-v-563f1652]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-563f1652],.slide-fade-left-leave-active[data-v-563f1652]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-563f1652],.slide-fade-left-leave-to[data-v-563f1652]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-563f1652]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-563f1652],.fade-leave-to[data-v-563f1652]{opacity:0\n}\n.social-icons a[data-v-563f1652]{margin-right:1rem;margin-left:1rem;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex\n}\n.social-icons a img[data-v-563f1652]{-webkit-transform:scale(1);transform:scale(1);-webkit-transition-duration:.5s;transition-duration:.5s;max-width:1.75rem\n}\n.social-icons a:hover img[data-v-563f1652]{-webkit-transform:scale(1.2);transform:scale(1.2);-webkit-transition-duration:.5s;transition-duration:.5s\n}\n", ""]);

// exports


/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    scopedSlots: _vm._u([
      {
        key: "nav-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              { staticClass: "my-auto" },
              [
                _c("router-link", { attrs: { to: "/opensalud360/empresas" } }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("business")))])
                ])
              ],
              1
            ),
            _vm._v(" "),
            !_vm.inMx
              ? _c(
                  "b-nav-item",
                  {
                    staticClass: "my-auto",
                    on: { click: _vm.goToOpensalud4allLanding }
                  },
                  [_c("p", [_vm._v("Opensalud4all")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-nav-item",
              { staticClass: "my-auto" },
              [
                _c("router-link", { attrs: { to: "/" } }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("patients")))])
                ])
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              { staticClass: "my-auto d-none d-xl-block ml-0 ml-xl-2" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/inicio-sesion" } },
                  [
                    _c("ArrowButton", {
                      attrs: {
                        text: _vm.$t("login-wrd"),
                        action: function() {
                          _vm.$router.push("/inicio-sesion")
                        },
                        reverse: "",
                        backgroundColor: _vm.BLUE_COLOUR,
                        textColor: _vm.WHITE_COLOUR
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-563f1652", esExports)
  }
}

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateLayout_vue__ = __webpack_require__(1171);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b064a07_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateLayout_vue__ = __webpack_require__(2071);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2041)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b064a07"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b064a07_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PrivateLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b064a07", Component.options)
  } else {
    hotAPI.reload("data-v-1b064a07", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2042);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("6b13b806", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1b064a07\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivateLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1b064a07\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivateLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-1b064a07]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-1b064a07],.slide-down-leave-active[data-v-1b064a07]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-1b064a07],.slide-down-leave-to[data-v-1b064a07]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-1b064a07],.slide-fade-left-leave-active[data-v-1b064a07]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-1b064a07],.slide-fade-left-leave-to[data-v-1b064a07]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-1b064a07]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-1b064a07],.fade-leave-to[data-v-1b064a07]{opacity:0\n}\n@media only screen and (min-width: 1024px){\n.ctm-container[data-v-1b064a07]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.ctm-container[data-v-1b064a07]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.ctm-container[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n.ctm-container h3[data-v-1b064a07]{color:black\n}\n[data-v-1b064a07] .nav-item{margin-right:0rem;font-weight:600\n}\n@media only screen and (max-width: 575px){\n[data-v-1b064a07] .nav-item{padding-right:0;border:0px !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-1b064a07] .nav-item{padding-right:0;border:0px !important\n}\n}\n@media only screen and (min-width: 1024px){\n[data-v-1b064a07] .navbar-nav{margin-left:auto !important\n}\n}\n[data-v-1b064a07] .navbar-brand{margin-right:0\n}\n.navbar[data-v-1b064a07]{z-index:1\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-1b064a07] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:transparent !important;display:table\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 1024px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 1024px){\n.navbar[data-v-1b064a07]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 2000px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 2000px){\n.navbar[data-v-1b064a07]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.navbar[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.navbar[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n.navbar[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-1b064a07]{padding-top:2rem;padding-bottom:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar .btn-dropdown[data-v-1b064a07]{padding:.7rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-1b064a07] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:transparent !important;display:table\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 1024px){\n.navbar[data-v-1b064a07]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 2000px){\n.navbar[data-v-1b064a07]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.navbar[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.navbar[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.navbar[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-1b064a07]{padding-top:2rem;padding-bottom:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.navbar .btn-dropdown[data-v-1b064a07]{padding:.7rem\n}\n}\n@media only screen and (min-width: 1024px){\n.navbar-brand-img[data-v-1b064a07]{width:175px\n}\n}\n@media only screen and (min-width: 2000px){\n.navbar-brand-img[data-v-1b064a07]{width:175px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.navbar-brand-img[data-v-1b064a07]{width:130px !important\n}\n}\n@media only screen and (max-width: 575px){\n.navbar-brand-img[data-v-1b064a07]{width:140px !important\n}\n}\n[data-v-1b064a07].fade-enter-active,.fade-leave-active[data-v-1b064a07]{-webkit-transition:opacity 0.5s ease;transition:opacity 0.5s ease\n}\n[data-v-1b064a07].fade-enter-from,.fade-leave-to[data-v-1b064a07]{opacity:0\n}\n@media only screen and (min-width: 1024px){\nhr[data-v-1b064a07]:not(.divider){margin-top:1rem;margin-bottom:1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nhr[data-v-1b064a07]:not(.divider){margin:.75rem 0\n}\n}\n@media only screen and (max-width: 575px){\nhr[data-v-1b064a07]:not(.divider){margin:.75rem 0\n}\n}\n.divider[data-v-1b064a07]{background-color:#eee;height:2px;width:100%;margin:2rem 0\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.divider[data-v-1b064a07]{margin:1.5rem 0\n}\n}\n@media only screen and (max-width: 575px){\n.divider[data-v-1b064a07]{margin:1.5rem 0\n}\n}\np[data-v-1b064a07]{color:#3238C4\n}\n@media only screen and (min-width: 1024px){\np[data-v-1b064a07]:is(:last-child){margin-right:1rem\n}\np[data-v-1b064a07]:is(:first-child){margin-left:1rem\n}\n}\n@media only screen and (min-width: 1024px){\n.custom-container[data-v-1b064a07]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.custom-container[data-v-1b064a07]{padding-right:20rem;padding-left:20rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.custom-container[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.custom-container[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.custom-container[data-v-1b064a07]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.custom-container[data-v-1b064a07]{padding-right:2rem;padding-left:2rem\n}\n}\n.custom-container .custom-container[data-v-1b064a07]{-webkit-transition:all 0.3s ease;transition:all 0.3s ease\n}\n@media only screen and (min-width: 1024px){\n.custom-container[data-v-1b064a07]{min-height:60dvh\n}\n}\n@media only screen and (min-width: 2000px){\n.custom-container[data-v-1b064a07]{min-height:70dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-1b064a07] .nav-tabs{display:none\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-1b064a07] .nav-tabs{display:none\n}\n}\n.generic-back-btn[data-v-1b064a07]{position:inherit;bottom:24px;left:12px\n}\n", ""]);

// exports


/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeUserModal_vue__ = __webpack_require__(1172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3f0df6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeUserModal_vue__ = __webpack_require__(2046);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2044)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeUserModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3f0df6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeUserModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/patient/ChangeUserModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0a3f0df6", Component.options)
  } else {
    hotAPI.reload("data-v-0a3f0df6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("15135d46", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0a3f0df6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeUserModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0a3f0df6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeUserModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: { centered: "", "hide-header-close": "" },
          on: { show: _vm.load },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "base-button",
                    {
                      attrs: { variant: "primary", disabled: !_vm.value },
                      on: {
                        click: function($event) {
                          return _vm.changeUser(_vm.patientId)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("menu.change-user")))]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.isVisible,
            callback: function($$v) {
              _vm.isVisible = $$v
            },
            expression: "isVisible"
          }
        },
        [
          _c("base-select", {
            attrs: {
              options: _vm.patients,
              valueProp: "id",
              placeholder: _vm.$t("menu.change-user-placeholder"),
              label: "fullName",
              loading: _vm.loading
            },
            model: {
              value: _vm.patientId,
              callback: function($$v) {
                _vm.patientId = $$v
              },
              expression: "patientId"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { else: "", centered: "", "hide-header-close": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "base-button",
                    {
                      attrs: { variant: "primary", disabled: !_vm.value },
                      on: { click: _vm.createAssociatedPatient }
                    },
                    [_vm._v(_vm._s(_vm.$t("menu.change-user-create")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-alert", { attrs: { variant: "info" } }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("menu.change-user-no-patients")) +
                "\n\t\t"
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a3f0df6", esExports)
  }
}

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuBanners_vue__ = __webpack_require__(1173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a73f18c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuBanners_vue__ = __webpack_require__(2054);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2048)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuBanners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a73f18c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuBanners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/patient/MenuBanners.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a73f18c", Component.options)
  } else {
    hotAPI.reload("data-v-4a73f18c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2049);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("7a2a57fd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a73f18c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MenuBanners.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a73f18c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MenuBanners.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n@media only screen and (min-width: 1024px){\n.menu-banners-ctn{margin-bottom:2rem;margin-top:-2rem;z-index:0;position:relative\n}\n.menu-banners-ctn p{margin:0 auto\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1024px){\n.menu-banners-ctn{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 2000px){\n.menu-banners-ctn{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.menu-banners-ctn{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 1024px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.menu-banners-ctn{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.menu-banners-ctn{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 1024px) and (max-width: 575px){\n.menu-banners-ctn{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.menu-banners-ctn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;margin-bottom:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.menu-banners-ctn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;margin-bottom:2rem\n}\n}\n.menu-banner-item:not(:last-child){margin-bottom:1rem\n}\n", ""]);

// exports


/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseMenuBanner_vue__ = __webpack_require__(1174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d47b1e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseMenuBanner_vue__ = __webpack_require__(2053);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2051)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseMenuBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d47b1e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseMenuBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/ui/BaseMenuBanner.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d47b1e9", Component.options)
  } else {
    hotAPI.reload("data-v-6d47b1e9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5444a425", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d47b1e9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseMenuBanner.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d47b1e9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseMenuBanner.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.menu-banner{display:-webkit-box;display:-ms-flexbox;display:flex;color:white\n}\n@media only screen and (min-width: 1024px){\n.menu-banner{padding:.5rem 4rem;border-radius:23px\n}\n}\n@media only screen and (max-width: 575px){\n.menu-banner{padding:.5rem;width:100%;z-index:0\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.menu-banner{padding:.5rem;width:100%;z-index:0\n}\n}\n.menu-banner p{margin:.75rem 1.5rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:.85rem\n}\n@media only screen and (min-width: 1024px){\n.menu-banner p{margin-left:auto;margin-right:auto\n}\n}\n@media only screen and (max-width: 575px){\n.menu-banner p{width:100%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.menu-banner p{width:100%\n}\n}\n", ""]);

// exports


/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-down" } }, [
    !_vm.closed
      ? _c(
          "div",
          {
            staticClass: "menu-banner",
            style: { "background-color": _vm.color },
            attrs: { id: _vm.id }
          },
          [
            _c(
              "p",
              [
                _c("b-icon", {
                  staticClass: "mr-3",
                  attrs: { icon: _vm.icon }
                }),
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t\t")
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d47b1e9", esExports)
  }
}

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-banners-ctn" },
    _vm._l(_vm.banners, function(banner) {
      return _c("base-menu-banner", {
        key: banner.eventId,
        staticClass: "menu-banner-item",
        attrs: { text: banner.text },
        on: {
          close: function($event) {
            return _vm.$store.commit(
              "notifications/removeLiveState",
              banner.eventId
            )
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a73f18c", esExports)
  }
}

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateLayoutMenu_vue__ = __webpack_require__(1175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a10552_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateLayoutMenu_vue__ = __webpack_require__(2062);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2056)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54a10552"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateLayoutMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a10552_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateLayoutMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/PrivateLayoutMenu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-54a10552", Component.options)
  } else {
    hotAPI.reload("data-v-54a10552", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("482a8b8a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54a10552\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivateLayoutMenu.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54a10552\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivateLayoutMenu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-54a10552]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-54a10552],.slide-down-leave-active[data-v-54a10552]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-54a10552],.slide-down-leave-to[data-v-54a10552]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-54a10552],.slide-fade-left-leave-active[data-v-54a10552]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-54a10552],.slide-fade-left-leave-to[data-v-54a10552]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-54a10552]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-54a10552],.fade-leave-to[data-v-54a10552]{opacity:0\n}\n@media only screen and (min-width: 1024px){\n[data-v-54a10552].navbar{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n[data-v-54a10552].navbar{padding-right:20rem;padding-left:20rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-54a10552].navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-54a10552].navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n[data-v-54a10552].navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-54a10552].navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-54a10552].navbar{padding-top:0;padding-bottom:0\n}\n}\n@media only screen and (min-width: 1024px){\nhr[data-v-54a10552]:not(.divider){margin-top:1rem;margin-bottom:1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nhr[data-v-54a10552]:not(.divider){margin:.75rem 0\n}\n}\n@media only screen and (max-width: 575px){\nhr[data-v-54a10552]:not(.divider){margin:.75rem 0\n}\n}\n.profile-link[data-v-54a10552]{cursor:pointer\n}\n.profile-link[data-v-54a10552]:hover{text-decoration:underline\n}\n@media only screen and (max-width: 575px){\n.navbar-nav[data-v-54a10552]{margin-left:0\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar-nav[data-v-54a10552]{margin-left:0\n}\n}\n", ""]);

// exports


/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HamburguerDropdown_vue__ = __webpack_require__(1176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5005932_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HamburguerDropdown_vue__ = __webpack_require__(2061);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2059)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5005932"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HamburguerDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5005932_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HamburguerDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/dropdown/HamburguerDropdown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c5005932", Component.options)
  } else {
    hotAPI.reload("data-v-c5005932", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("ce05ad6c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c5005932\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HamburguerDropdown.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c5005932\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HamburguerDropdown.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-c5005932]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-c5005932],.slide-down-leave-active[data-v-c5005932]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-c5005932],.slide-down-leave-to[data-v-c5005932]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-c5005932],.slide-fade-left-leave-active[data-v-c5005932]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-c5005932],.slide-fade-left-leave-to[data-v-c5005932]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-c5005932]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-c5005932],.fade-leave-to[data-v-c5005932]{opacity:0\n}\nnav .menu-item .title[data-v-c5005932]{font-weight:bold\n}\nnav .menu-item svg[data-v-c5005932]{width:10px\n}\nnav .menu-item a.hamburguer svg[data-v-c5005932]{width:100%\n}\nnav .menu-item-list[data-v-c5005932]{margin:1.15rem\n}\nnav .menu-item-list a[data-v-c5005932]{color:#3238C4;font-weight:bold\n}\n.btn.btn-dropdown[data-v-c5005932]:focus{-webkit-box-shadow:none !important;box-shadow:none !important\n}\nnav .menu-item .sub-menu[data-v-c5005932]{top:4rem;left:-9rem;position:absolute;background-color:#eee;width:-webkit-max-content;width:-moz-max-content;width:max-content;padding:1rem 2rem;z-index:10;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784)\n}\n.fade-enter-active[data-v-c5005932],.fade-leave-active[data-v-c5005932]{-webkit-transition:all .5s ease-out;transition:all .5s ease-out\n}\n.fade-enter[data-v-c5005932],.fade-leave-to[data-v-c5005932]{opacity:0\n}\n.sub-menu hr[data-v-c5005932]{margin-top:0rem;margin-bottom:1rem\n}\n", ""]);

// exports


/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-item" },
    [
      _c(
        "a",
        {
          staticClass: "hamburguer",
          attrs: { href: "#" },
          on: { click: _vm.toggleMenu }
        },
        [
          _c("base-icon", {
            attrs: {
              src:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/hamburguer.svg",
              width: "40",
              height: "40",
              color: _vm.BLUE_COLOUR
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.dontDisplayDropdown
        ? _c("transition", { attrs: { name: "fade", appear: "" } }, [
            _vm.isOpen
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.hideMenu,
                        expression: "hideMenu"
                      }
                    ],
                    staticClass: "sub-menu"
                  },
                  [
                    _vm.showLanguageSelector
                      ? _c(
                          "div",
                          { staticClass: "menu-item-list" },
                          [
                            _c("lang-selector", {
                              staticClass: "d-inline-block mr-4",
                              staticStyle: { margin: "0px !important" },
                              attrs: { enablePortuguese: _vm.enablePortuguese }
                            }),
                            _vm._v(" "),
                            _c("hr")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("menu-items")
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5005932", esExports)
  }
}

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.$helpers.inIframe()
        ? _c(
            "b-navbar",
            { staticClass: "navbar", attrs: { toggleable: _vm.isToggleable } },
            [
              _vm.showBackButton
                ? _c(
                    "b-nav-item",
                    {
                      staticClass: "d-block mr-2",
                      on: {
                        click: function($event) {
                          return _vm.$router.go(-1)
                        }
                      }
                    },
                    [
                      _c("base-icon", {
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                          svgClasses: "rotate-180",
                          width: "20",
                          height: "20"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-navbar-brand",
                {
                  class: _vm.navbarBrandClasses,
                  staticStyle: { cursor: "pointer" },
                  on: {
                    "~click": function($event) {
                      return _vm.redirectIfAuthenticated(true)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "navbar-brand-img",
                    style: _vm.getLogoStyles,
                    attrs: { src: _vm.getLogo }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                [
                  _vm.$store.state.session.user
                    ? _c(
                        "b-nav-item",
                        { staticClass: "my-auto d-none d-xl-block" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "profile-link font-weight-bold",
                              attrs: { "data-hj-supress": "" },
                              on: { click: _vm.goProfile }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "profile-pic mr-3 vertical-align-middle",
                                attrs: {
                                  src: _vm.$store.state.session.user.photo
                                }
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.$store.state.session.user.name) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn-dropdown d-inline-block px-0",
                          attrs: {
                            variant: "secondary",
                            borderColor: "transparent",
                            backgroundColor: "transparent"
                          }
                        },
                        [
                          _c("hamburguer-dropdown", {
                            staticClass: "dropdown",
                            attrs: {
                              enablePortuguese: "",
                              dontDisplayDropdown: _vm.isToggleable,
                              showLanguageSelector: false
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "menu-items",
                                  fn: function() {
                                    return [
                                      !_vm.inPanel &&
                                      _vm.$store.getters[
                                        "session/userIsPatient"
                                      ]
                                        ? _c(
                                            "div",
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _c(
                                                "base-button",
                                                {
                                                  attrs: {
                                                    outline: "",
                                                    blue: "",
                                                    size: "sm"
                                                  },
                                                  on: {
                                                    click: function() {
                                                      return _vm.$router.push(
                                                        "/patient"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "private-layout.home"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("hr")
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.menuServiceItems &&
                                      _vm.menuServiceItems.length > 0
                                        ? _c(
                                            "div",
                                            [
                                              _c("div", [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "my-2 d-block font-weight-bold",
                                                    on: {
                                                      click:
                                                        _vm.toggleShowServicesMenu
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "private-layout.services"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("base-icon", {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        src:
                                                          "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                                                        color: _vm.BLUE_COLOUR,
                                                        svgClasses:
                                                          _vm.caretSubMenuClass,
                                                        height: 12,
                                                        width: 12
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("CollapseTransition", [
                                                _vm.showServicesMenu
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "submenu"
                                                      },
                                                      [
                                                        _c("hr"),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.menuServiceItems,
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  "list-items-" +
                                                                  index
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "my-2 d-block font-weight-bold",
                                                                    on: {
                                                                      click:
                                                                        item.action
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          item.title
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("hr")
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ]),
                                              _vm._v(" "),
                                              !_vm.showServicesMenu
                                                ? _c("hr")
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$store.state.session.user
                                        ? _c(
                                            "div",
                                            [
                                              _vm._l(
                                                _vm.notTabMenuItems,
                                                function(i) {
                                                  return _c(
                                                    "div",
                                                    { key: i.title },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "my-2 d-block font-weight-bold",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onTabClick(
                                                                i
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(i.title) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                          i.bubble
                                                            ? _c(
                                                                "b-badge",
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                  attrs: {
                                                                    variant:
                                                                      "info"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      i.bubble
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("hr")
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _vm._l(_vm.mainMenuItems, function(
                                            i
                                          ) {
                                            return _c("div", { key: i.title }, [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "my-2 d-block font-weight-bold",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onTabClick(i)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(i.title) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  i.bubble
                                                    ? _c(
                                                        "b-badge",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant: "info"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(i.bubble)
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _c("hr")
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("lang-selector", {
                                        staticClass: "lang-cnt text-center",
                                        attrs: { enablePortuguese: "" }
                                      }),
                                      _vm._v(" "),
                                      _c("hr"),
                                      _vm._v(" "),
                                      _vm.$store.getters[
                                        "session/userIsPatient"
                                      ]
                                        ? _c("div", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "font-weight-bold",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$store.commit(
                                                      "layout/toggleChangeUserModalVisible"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("menu.change-user")
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$store.state.session.user
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "my-2",
                                              on: { click: _vm.logOff }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "my-2 font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("logOff"))
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1480024937
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54a10552", esExports)
  }
}

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateLayoutMobileSubmenu_vue__ = __webpack_require__(1177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f8a7e3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateLayoutMobileSubmenu_vue__ = __webpack_require__(2070);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2064)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f8a7e3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateLayoutMobileSubmenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f8a7e3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateLayoutMobileSubmenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/PrivateLayoutMobileSubmenu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f8a7e3a", Component.options)
  } else {
    hotAPI.reload("data-v-5f8a7e3a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2065);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("dd970638", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f8a7e3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivateLayoutMobileSubmenu.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f8a7e3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PrivateLayoutMobileSubmenu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-5f8a7e3a]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-5f8a7e3a],.slide-down-leave-active[data-v-5f8a7e3a]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-5f8a7e3a],.slide-down-leave-to[data-v-5f8a7e3a]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-5f8a7e3a],.slide-fade-left-leave-active[data-v-5f8a7e3a]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-5f8a7e3a],.slide-fade-left-leave-to[data-v-5f8a7e3a]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-5f8a7e3a]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-5f8a7e3a],.fade-leave-to[data-v-5f8a7e3a]{opacity:0\n}\n.menuOverlay[data-v-5f8a7e3a]{background-color:#3238C4;width:80dvw;height:100%;top:0;right:0;bottom:0;left:20%;position:fixed;z-index:4;overflow-x:scroll;-ms-overflow-style:none;scrollbar-width:none;-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.menuOverlay p[data-v-5f8a7e3a]{margin-bottom:0;cursor:pointer\n}\n.backgroundOverlay[data-v-5f8a7e3a]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1;background-color:#8A8A8A;opacity:0.5;width:100dvw\n}\n.btn-close[data-v-5f8a7e3a]{position:fixed;background:#3238C4;color:#eee;border:transparent;opacity:1;border-radius:50%;width:50px;height:50px;z-index:3\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.btn-close[data-v-5f8a7e3a]{top:3dvh;left:17.5dvw\n}\n}\n@media only screen and (max-width: 575px){\n.btn-close[data-v-5f8a7e3a]{-webkit-transform:translate(-22px, 11px);transform:translate(-22px, 11px)\n}\n}\n.overlayItems[data-v-5f8a7e3a]{margin:3% 10% 10%\n}\np[data-v-5f8a7e3a]{color:#eee\n}\np.menuItem[data-v-5f8a7e3a]{margin-top:0;margin-bottom:0;display:inline-block\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nhr[data-v-5f8a7e3a]:not(.divider){margin:.65rem 0\n}\n}\n@media only screen and (max-width: 575px){\nhr[data-v-5f8a7e3a]:not(.divider){margin:.65rem 0\n}\n}\n.divider[data-v-5f8a7e3a]{background-color:#eee;height:2px;width:100%;margin:2rem 0\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.divider[data-v-5f8a7e3a]{margin:1.25rem 0\n}\n}\n@media only screen and (max-width: 575px){\n.divider[data-v-5f8a7e3a]{margin:1.25rem 0\n}\n}\n.btn-change-user[data-v-5f8a7e3a]{margin-left:2.5rem;color:#eee;opacity:.5;cursor:pointer\n}\n", ""]);

// exports


/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryGrantAccessMenu_vue__ = __webpack_require__(1178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0fa295_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryGrantAccessMenu_vue__ = __webpack_require__(2069);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2067)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b0fa295"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryGrantAccessMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0fa295_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryGrantAccessMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryGrantAccessMenu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b0fa295", Component.options)
  } else {
    hotAPI.reload("data-v-0b0fa295", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("01347b05", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0b0fa295\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryGrantAccessMenu.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0b0fa295\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryGrantAccessMenu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-0b0fa295]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-0b0fa295],.slide-down-leave-active[data-v-0b0fa295]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-0b0fa295],.slide-down-leave-to[data-v-0b0fa295]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-0b0fa295],.slide-fade-left-leave-active[data-v-0b0fa295]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-0b0fa295],.slide-fade-left-leave-to[data-v-0b0fa295]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-0b0fa295]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-0b0fa295],.fade-leave-to[data-v-0b0fa295]{opacity:0\n}\n", ""]);

// exports


/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        [
          _c(
            "base-modal",
            {
              model: {
                value: _vm.isVisible,
                callback: function($$v) {
                  _vm.isVisible = $$v
                },
                expression: "isVisible"
              }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "text-center px-2 my-2",
                      attrs: { sm: "12", md: "6" }
                    },
                    [
                      _c(
                        "base-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.showGrantAccess = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("clinic-history.grant-access")))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "text-center px-2 my-2",
                      attrs: { sm: "12", md: "6" }
                    },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function($event) {
                              _vm.showProfAndCenterAuthorizedModal = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("clinic-history.access-authorizated"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("history-prof-and-center-authorized", {
            model: {
              value: _vm.showProfAndCenterAuthorizedModal,
              callback: function($$v) {
                _vm.showProfAndCenterAuthorizedModal = $$v
              },
              expression: "showProfAndCenterAuthorizedModal"
            }
          }),
          _vm._v(" "),
          _c("history-grant-access", {
            model: {
              value: _vm.showGrantAccess,
              callback: function($$v) {
                _vm.showGrantAccess = $$v
              },
              expression: "showGrantAccess"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b0fa295", esExports)
  }
}

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("history-grant-access-menu", {
        model: {
          value: _vm.showGrantAccessHistoryModal,
          callback: function($$v) {
            _vm.showGrantAccessHistoryModal = $$v
          },
          expression: "showGrantAccessHistoryModal"
        }
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$store.state.layout.showMenu,
            expression: "$store.state.layout.showMenu"
          }
        ],
        staticClass: "backgroundOverlay"
      }),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "slide-fade-left" },
          on: {
            "after-enter": _vm.onAfterEnterMenuTransition,
            "before-leave": _vm.onBeforeLeaveMenuTransition
          }
        },
        [
          _vm.$store.state.layout.showMenu
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.hideMenu,
                      expression: "hideMenu"
                    }
                  ],
                  staticClass: "menuOverlay",
                  on: { click: _vm.handleMenuClick }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn-close",
                      attrs: {
                        id: "navbar-toggler",
                        type: "button",
                        "aria-label": "Close"
                      },
                      on: { click: _vm.hideMenu }
                    },
                    [
                      _c("base-icon", {
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                          color: _vm.WHITE_COLOUR,
                          svgClasses: _vm.caretIconClasses
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "overlayItems" },
                    [
                      _vm.$store.state.session.user
                        ? _c(
                            "b-row",
                            { staticClass: "profile" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "text-bold",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "profile-pic mr-2 d-inline-block",
                                    attrs: {
                                      src: _vm.$store.state.session.user.photo
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "ml-0 d-inline-block text-transform-uppercase font-weight-bold text-underline",
                                      on: { click: _vm.goProfile }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.session.user.name
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.$store.getters["session/userIsPatient"]
                                ? _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "small btn-change-user",
                                        on: {
                                          click: function($event) {
                                            return _vm.$store.commit(
                                              "layout/toggleChangeUserModalVisible"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("menu.change-user"))
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr", { staticClass: "divider" }),
                      _vm._v(" "),
                      !_vm.inPanel &&
                      _vm.$store.getters["session/userIsPatient"]
                        ? _c(
                            "div",
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    outline: "",
                                    white: "",
                                    href: "/patient",
                                    size: "sm"
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/patient", tag: "span" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t("private-layout.home")
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "divider" })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.menuServiceItems && _vm.menuServiceItems.length > 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "menuItem",
                                  attrs: { id: "services-toggler" },
                                  on: { click: _vm.toggleShowServicesMenu }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("private-layout.services")
                                      ) +
                                      " \n\t\t\t\t\t\t"
                                  ),
                                  _c("base-icon", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      src:
                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                                      color: _vm.WHITE_COLOUR,
                                      svgClasses: _vm.caretSubMenuClass,
                                      height: 12,
                                      width: 12
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("CollapseTransition", [
                                _vm.showServicesMenu
                                  ? _c(
                                      "div",
                                      { staticClass: "submenu pl-3 mt-3" },
                                      _vm._l(_vm.menuServiceItems, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: "list-items-" + index },
                                          [
                                            _c(
                                              "a",
                                              { on: { click: item.action } },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "menuItem" },
                                                  [_vm._v(_vm._s(item.title))]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            !_vm.isLastItem(
                                              index,
                                              _vm.menuServiceItems
                                            )
                                              ? _c("hr")
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("hr")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.allMenuItems, function(items, listIndex) {
                        return _c(
                          "div",
                          { key: "list-items-" + listIndex },
                          [
                            _vm._l(items, function(item, itemIndex) {
                              return _c("div", { key: item.title }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.onTabClick(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("p", { staticClass: "menuItem" }, [
                                      _vm._v(_vm._s(item.title))
                                    ]),
                                    _vm._v(" "),
                                    item.bubble
                                      ? _c(
                                          "b-badge",
                                          {
                                            staticClass: "ml-1",
                                            attrs: { variant: "secondary" }
                                          },
                                          [_vm._v(_vm._s(item.bubble))]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isLastItem(itemIndex, items)
                                  ? _c("hr")
                                  : _vm._e()
                              ])
                            }),
                            _vm._v(" "),
                            _c("hr", { staticClass: "divider" })
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      !_vm.$store.getters["session/userIsPatient"]
                        ? _c("div", [
                            _vm.$store.getters["session/userIsProfessional"]
                              ? _c("a", [
                                  _c("p", { staticClass: "menuItem" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("private-layout.telemonitoring")
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$store.getters["session/userIsProfessional"]
                              ? _c("hr")
                              : _vm._e(),
                            _vm._v(" "),
                            _c("a", [
                              _c("p", { staticClass: "menuItem" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("private-layout.dashboard"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "divider" })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("lang-selector", {
                        staticClass:
                          "d-inline-block mr-4 text-center font-weight-normal",
                        attrs: {
                          color: _vm.WHITE_COLOUR,
                          enablePortuguese: "",
                          labeled: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.$store.state.session.user
                        ? _c("a", { on: { click: _vm.logOff } }, [
                            _c("p", { staticClass: "menuItem" }, [
                              _vm._v(_vm._s(_vm.$t("logOff")))
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f8a7e3a", esExports)
  }
}

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.getters["session/isLogged"]
    ? _c(
        "IdleTracker",
        [
          _c("ChangeUserModal", {
            model: {
              value: _vm.$store.state.layout.changeUserModalVisible,
              callback: function($$v) {
                _vm.$set(_vm.$store.state.layout, "changeUserModalVisible", $$v)
              },
              expression: "$store.state.layout.changeUserModalVisible"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("loading-anim", {
                attrs: {
                  active: _vm.$store.state.loading,
                  fullScreen: "",
                  toggleParentClass: ""
                }
              }),
              _vm._v(" "),
              _c("PrivateLayoutMenu", {
                attrs: {
                  menuItems: _vm.allItems,
                  menuServiceItems: _vm.menuServiceItems
                }
              }),
              _vm._v(" "),
              !_vm.$uiHelpers.isDesktop
                ? _c("PrivateLayoutMobileSubmenu", {
                    attrs: {
                      menuItems: _vm.allItems,
                      menuServiceItems: _vm.menuServiceItems
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("menu-banners"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pb-5 custom-container" },
                [
                  _vm.showTabsMenu
                    ? _c(
                        "b-tabs",
                        { attrs: { fill: "" } },
                        _vm._l(
                          _vm.menuItems.filter(function(item) {
                            return item.tab !== false
                          }),
                          function(tab) {
                            return _c("b-tab", {
                              key: tab.path,
                              attrs: {
                                title: tab.title,
                                active: _vm.isTabActive(tab.path)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onTabClick(tab)
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(tab.title) +
                                            "\n\t\t\t\t\t\t"
                                        ),
                                        tab.bubble
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "info" } },
                                              [_vm._v(_vm._s(tab.bubble))]
                                            )
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("router-view", {
                    class: { "pt-5": _vm.$helpers.inIframe() }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b064a07", esExports)
  }
}

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicExtendedLayout_vue__ = __webpack_require__(1179);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1b2b82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicExtendedLayout_vue__ = __webpack_require__(2075);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2073)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicExtendedLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1b2b82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicExtendedLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PublicExtendedLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a1b2b82", Component.options)
  } else {
    hotAPI.reload("data-v-3a1b2b82", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5f628120", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a1b2b82\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicExtendedLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a1b2b82\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicExtendedLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.logo{widows:auto;height:40px;padding:0\n}\n.logo:not(.logo-footer){margin:0 !important\n}\n.container-sm{max-width:500px\n}\n.navbar{padding-left:0px;padding-right:0px\n}\n", ""]);

// exports


/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center p-5" }, [
        _c("img", { staticClass: "logo", attrs: { src: _vm.getLogo } })
      ]),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "h3",
            {
              staticStyle: {
                "text-align": "center",
                "text-decoration": "underline"
              }
            },
            [_vm._v(_vm._s(_vm.getMetaTitle))]
          ),
          _vm._v(" "),
          _c("router-view", { staticClass: "mt-4 pb-5" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1b2b82", esExports)
  }
}

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicLayout_vue__ = __webpack_require__(1180);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530e272e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicLayout_vue__ = __webpack_require__(2079);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2077)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-530e272e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530e272e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PublicLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-530e272e", Component.options)
  } else {
    hotAPI.reload("data-v-530e272e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2078);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("09d5995e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-530e272e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-530e272e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-530e272e]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-530e272e],.slide-down-leave-active[data-v-530e272e]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-530e272e],.slide-down-leave-to[data-v-530e272e]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-530e272e],.slide-fade-left-leave-active[data-v-530e272e]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-530e272e],.slide-fade-left-leave-to[data-v-530e272e]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-530e272e]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-530e272e],.fade-leave-to[data-v-530e272e]{opacity:0\n}\n@media only screen and (max-width: 575px){\n[data-v-530e272e] .navbar-brand{margin-right:0\n}\n[data-v-530e272e] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:transparent !important;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.navbar[data-v-530e272e]{padding:1rem 2rem\n}\n.navbar .btn-layout[data-v-530e272e]{font-size:.875rem !important;font-weight:initial;padding:.7rem 2.2rem;background-color:#3238C4\n}\n[data-v-530e272e] .nav.item button{color:#eee !important\n}\n}\n", ""]);

// exports


/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("router-view")], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-530e272e", esExports)
  }
}

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMenuLayout_vue__ = __webpack_require__(1181);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4dc7a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMenuLayout_vue__ = __webpack_require__(2083);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2081)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f4dc7a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMenuLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4dc7a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMenuLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PublicMenuLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7f4dc7a8", Component.options)
  } else {
    hotAPI.reload("data-v-7f4dc7a8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2082);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("66b0e7a4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7f4dc7a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicMenuLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7f4dc7a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicMenuLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-7f4dc7a8]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-7f4dc7a8],.slide-down-leave-active[data-v-7f4dc7a8]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-7f4dc7a8],.slide-down-leave-to[data-v-7f4dc7a8]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-7f4dc7a8],.slide-fade-left-leave-active[data-v-7f4dc7a8]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-7f4dc7a8],.slide-fade-left-leave-to[data-v-7f4dc7a8]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-7f4dc7a8]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-7f4dc7a8],.fade-leave-to[data-v-7f4dc7a8]{opacity:0\n}\n@media only screen and (min-width: 1024px){\n[data-v-7f4dc7a8].navbar{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n[data-v-7f4dc7a8].navbar{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-7f4dc7a8].navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-7f4dc7a8].navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n[data-v-7f4dc7a8].navbar{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-7f4dc7a8].navbar{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.ctm-container[data-v-7f4dc7a8]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.ctm-container[data-v-7f4dc7a8]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-7f4dc7a8]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-7f4dc7a8]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-7f4dc7a8]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.ctm-container[data-v-7f4dc7a8]{padding-right:2rem;padding-left:2rem\n}\n}\n.ctm-container h3[data-v-7f4dc7a8]{color:black\n}\n@media only screen and (max-width: 575px){\n[data-v-7f4dc7a8] .navbar-brand{margin-right:0\n}\n.navbar[data-v-7f4dc7a8]{padding:1rem 2rem\n}\n.navbar .btn-layout[data-v-7f4dc7a8]{font-size:.875rem !important;font-weight:initial;padding:.7rem 2.2rem;background-color:#3238C4\n}\n[data-v-7f4dc7a8] .nav.item button{color:#eee !important\n}\n}\n[data-v-7f4dc7a8] .nav-item{margin-right:0rem\n}\n@media only screen and (max-width: 575px){\n[data-v-7f4dc7a8] .nav-item{padding:0rem\n}\n}\n[data-v-7f4dc7a8] .navbar-brand-img{width:150px\n}\n[data-v-7f4dc7a8].fade-enter-active,.fade-leave-active[data-v-7f4dc7a8]{-webkit-transition:opacity 0.5s ease;transition:opacity 0.5s ease\n}\n[data-v-7f4dc7a8].fade-enter-from,.fade-leave-to[data-v-7f4dc7a8]{opacity:0\n}\n.add-to-home-screen[data-v-7f4dc7a8]{position:fixed;bottom:2rem;left:2rem;z-index:4;font-weight:bold;text-transform:uppercase\n}\n@media only screen and (max-width: 575px){\n.add-to-home-screen[data-v-7f4dc7a8]{left:1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.add-to-home-screen[data-v-7f4dc7a8]{left:1rem\n}\n}\n", ""]);

// exports


/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c(
        "b-navbar",
        { staticClass: "navbar", attrs: { toggleable: "lg" } },
        [
          _c(
            "router-link",
            { attrs: { to: "/" } },
            [
              _c("b-navbar-brand", [
                _c("img", {
                  staticClass: "navbar-brand-img",
                  style: _vm.getLogoStyles,
                  attrs: { src: _vm.getLogo }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item",
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-layout",
                      attrs: { blue: "" },
                      on: { click: _vm.back }
                    },
                    [
                      _c("base-icon", {
                        staticClass: "mr-2",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                          color: "white",
                          svgClasses: "reverse"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("back")))])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pb-5 ctm-container" },
        [
          (_vm.$route.meta.title && !_vm.$route.meta.title.hide
          ? _vm.getMetaTitle
          : null)
            ? _c("h3", { staticClass: "mb-3 mb-md-5 text-center" }, [
                _vm._v(_vm._s(_vm.getMetaTitle))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("router-view", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var Component = ref.Component
                  return [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [_c(Component, { tag: "component" })],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.showInstallAppButton
            ? _c("AddToHomeScreen", {
                staticClass: "add-to-home-screen",
                attrs: { animate: "", shadow: "" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f4dc7a8", esExports)
  }
}

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMobileMenuLayout_vue__ = __webpack_require__(1182);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4b530ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMobileMenuLayout_vue__ = __webpack_require__(2087);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2085)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4b530ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicMobileMenuLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4b530ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicMobileMenuLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PublicMobileMenuLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d4b530ac", Component.options)
  } else {
    hotAPI.reload("data-v-d4b530ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2086);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0725126a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d4b530ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicMobileMenuLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d4b530ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicMobileMenuLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-d4b530ac]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-d4b530ac],.slide-down-leave-active[data-v-d4b530ac]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-d4b530ac],.slide-down-leave-to[data-v-d4b530ac]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-d4b530ac],.slide-fade-left-leave-active[data-v-d4b530ac]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-d4b530ac],.slide-fade-left-leave-to[data-v-d4b530ac]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-d4b530ac]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-d4b530ac],.fade-leave-to[data-v-d4b530ac]{opacity:0\n}\n@media only screen and (max-width: 575px) and (min-width: 1024px){\n.ctm-container[data-v-d4b530ac]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 2000px){\n.ctm-container[data-v-d4b530ac]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-d4b530ac]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-d4b530ac]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-d4b530ac]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.ctm-container[data-v-d4b530ac]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.ctm-container h3[data-v-d4b530ac]{color:black\n}\n[data-v-d4b530ac] .navbar-toggler-icon{visibility:hidden\n}\n[data-v-d4b530ac] .navbar-brand{margin-right:0\n}\n[data-v-d4b530ac] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:#3238C4 !important;display:contents\n}\n[data-v-d4b530ac] .colapse-none{display:none !important\n}\n[data-v-d4b530ac] .colapse-initial{display:initial !important\n}\n[data-v-d4b530ac] .background-set{width:50% !important\n}\n[data-v-d4b530ac] .navbar-collapse{-webkit-transition:all .5s ease;transition:all .5s ease;padding:1rem;text-align:center;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784)\n}\n.navbar[data-v-d4b530ac]{-ms-flex-wrap:initial;flex-wrap:initial;width:100%;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);-webkit-transition:0.1s all ease-out;transition:0.1s all ease-out;position:fixed;z-index:1001;padding:0rem 0rem\n}\n.navbar.fixed-scroll[data-v-d4b530ac]{background-color:#ffffffdd;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border-bottom-left-radius:18px;border-bottom-right-radius:18px\n}\n.navbar .btn-layout[data-v-d4b530ac]{font-weight:initial;padding:.7rem 1.2rem;border-color:transparent;background-color:transparent\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.navbar .btn-layout[data-v-d4b530ac]{font-size:12px !important\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar .btn-layout[data-v-d4b530ac]{font-size:17px !important\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-d4b530ac] .nav-item{margin-right:0rem;padding:0rem\n}\n[data-v-d4b530ac] .navbar-brand-img{color:white\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n[data-v-d4b530ac] .navbar-brand-img{width:130px\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-d4b530ac].fade-enter-active,.fade-leave-active[data-v-d4b530ac]{-webkit-transition:opacity 0.5s ease;transition:opacity 0.5s ease\n}\n[data-v-d4b530ac].fade-enter-from,.fade-leave-to[data-v-d4b530ac]{opacity:0\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 1024px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 1024px){\n.ctm-container[data-v-d4b530ac]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 2000px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 2000px){\n.ctm-container[data-v-d4b530ac]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-d4b530ac]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-d4b530ac]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-d4b530ac]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n.ctm-container[data-v-d4b530ac]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container h3[data-v-d4b530ac]{color:black\n}\n[data-v-d4b530ac] .navbar-toggler-icon{visibility:hidden\n}\n[data-v-d4b530ac] .navbar-brand{margin-right:0\n}\n[data-v-d4b530ac] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:#3238C4 !important;display:contents\n}\n[data-v-d4b530ac] .colapse-none{display:none !important\n}\n[data-v-d4b530ac] .colapse-initial{display:initial !important\n}\n[data-v-d4b530ac] .background-set{width:50% !important\n}\n[data-v-d4b530ac] .navbar-collapse{-webkit-transition:all .5s ease;transition:all .5s ease;padding:1rem;text-align:center;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784)\n}\n.navbar[data-v-d4b530ac]{-ms-flex-wrap:initial;flex-wrap:initial;width:100%;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);-webkit-transition:0.1s all ease-out;transition:0.1s all ease-out;position:fixed;z-index:1001;padding:0rem 0rem\n}\n.navbar.fixed-scroll[data-v-d4b530ac]{background-color:#ffffffdd;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border-bottom-left-radius:18px;border-bottom-right-radius:18px\n}\n.navbar .btn-layout[data-v-d4b530ac]{font-weight:initial;padding:.7rem 1.2rem;border-color:transparent;background-color:transparent\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n.navbar .btn-layout[data-v-d4b530ac]{font-size:12px !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar .btn-layout[data-v-d4b530ac]{font-size:17px !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-d4b530ac] .nav-item{margin-right:0rem;padding:0rem\n}\n[data-v-d4b530ac] .navbar-brand-img{color:white\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n[data-v-d4b530ac] .navbar-brand-img{width:130px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-d4b530ac].fade-enter-active,.fade-leave-active[data-v-d4b530ac]{-webkit-transition:opacity 0.5s ease;transition:opacity 0.5s ease\n}\n[data-v-d4b530ac].fade-enter-from,.fade-leave-to[data-v-d4b530ac]{opacity:0\n}\n}\n", ""]);

// exports


/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      !_vm.$uiHelpers.isXlDevice
        ? _c(
            "b-navbar",
            {
              class: { navbar: true, "fixed-scroll": _vm.isFixedScrolled },
              attrs: { toggleable: "xl" }
            },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    { staticClass: "ml-2" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn-layout",
                          on: { click: _vm.manageMenu }
                        },
                        [
                          _c("base-icon", {
                            staticStyle: { color: "#3238C4" },
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/menu-icon.svg",
                              width: "23",
                              height: "23",
                              color: "#3238C4"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: "/" } },
                [
                  _c("b-navbar-brand", [
                    _c("img", {
                      staticClass: "navbar-brand-img",
                      staticStyle: { color: "#3238C4" },
                      style: _vm.getLogoStyles,
                      attrs: { color: "#3238C4", src: _vm.getLogo }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    { staticClass: "mr-2" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/inicio-sesion" } },
                        [
                          _c(
                            "base-button",
                            { staticClass: "btn-layout" },
                            [
                              _c("base-icon", {
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg",
                                  color: "#3238C4",
                                  svgClasses: "reverse"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("router-view", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var Component = ref.Component
                  return [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [_c(Component, { tag: "component" })],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4b530ac", esExports)
  }
}

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2089);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("67063dab", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b7b8999\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicReducedLayout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b7b8999\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicReducedLayout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-5b7b8999]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-5b7b8999],.slide-down-leave-active[data-v-5b7b8999]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-5b7b8999],.slide-down-leave-to[data-v-5b7b8999]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-5b7b8999],.slide-fade-left-leave-active[data-v-5b7b8999]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-5b7b8999],.slide-fade-left-leave-to[data-v-5b7b8999]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-5b7b8999]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-5b7b8999],.fade-leave-to[data-v-5b7b8999]{opacity:0\n}\n@media only screen and (min-width: 1024px){\n.ctm-container[data-v-5b7b8999]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.ctm-container[data-v-5b7b8999]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-5b7b8999]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-5b7b8999]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-5b7b8999]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.ctm-container[data-v-5b7b8999]{padding-right:2rem;padding-left:2rem\n}\n}\n.ctm-container h3[data-v-5b7b8999]{color:black\n}\n@media only screen and (max-width: 575px){\n[data-v-5b7b8999] .navbar-brand{margin-right:0\n}\n[data-v-5b7b8999] .navbar-nav{-webkit-box-shadow:none !important;box-shadow:none !important;background-color:transparent !important;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.navbar[data-v-5b7b8999]{padding:1rem 2rem\n}\n.navbar .btn-layout[data-v-5b7b8999]{font-size:.875rem !important;font-weight:initial;padding:.7rem 2.2rem;background-color:#3238C4\n}\n}\n[data-v-5b7b8999] .nav-item{margin-right:0rem\n}\n@media only screen and (max-width: 575px){\n[data-v-5b7b8999] .nav-item{padding:0rem\n}\n}\n[data-v-5b7b8999] .navbar-brand-img{width:150px\n}\n[data-v-5b7b8999].fade-enter-active,.fade-leave-active[data-v-5b7b8999]{-webkit-transition:opacity 0.5s ease;transition:opacity 0.5s ease\n}\n[data-v-5b7b8999].fade-enter-from,.fade-leave-to[data-v-5b7b8999]{opacity:0\n}\n", ""]);

// exports


/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c(
        "b-navbar",
        { staticClass: "navbar", attrs: { toggleable: "lg" } },
        [
          _c(
            "router-link",
            { attrs: { to: "/" } },
            [
              _c("b-navbar-brand", [
                _c("img", {
                  staticClass: "navbar-brand-img",
                  style: _vm.getLogoStyles,
                  attrs: { src: _vm.getLogo }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item",
                [
                  _c(
                    "base-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.backVisible,
                          expression: "backVisible"
                        }
                      ],
                      staticClass: "btn-layout",
                      attrs: { blue: "" },
                      on: { click: _vm.back }
                    },
                    [
                      _c("base-icon", {
                        staticClass: "mr-2",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                          color: "white",
                          svgClasses: "reverse"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("back")))])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ctm-container" },
        [
          _c(
            "b-row",
            { staticClass: "pt-3" },
            [
              _c(
                "b-col",
                {
                  class: _vm.colClasses,
                  attrs: { cols: "12", sm: "8", md: "6" }
                },
                [
                  _vm.$route.meta.title && !_vm.$route.meta.title.hide
                    ? _c("h3", { class: _vm.styleClasses }, [
                        _vm._v(_vm._s(_vm.getMetaTitle))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("router-view", { staticClass: "mt-4" })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b7b8999", esExports)
  }
}

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicReducedLayoutDynamic_vue__ = __webpack_require__(1185);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6cc0dd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicReducedLayoutDynamic_vue__ = __webpack_require__(2094);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2092)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicReducedLayoutDynamic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6cc0dd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicReducedLayoutDynamic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/PublicReducedLayoutDynamic.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b6cc0dd4", Component.options)
  } else {
    hotAPI.reload("data-v-b6cc0dd4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2093);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2fd3766e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b6cc0dd4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicReducedLayoutDynamic.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b6cc0dd4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PublicReducedLayoutDynamic.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n", ""]);

// exports


/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("public-reduced-layout", { attrs: { backVisible: false } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6cc0dd4", esExports)
  }
}

/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoFreedom_vue__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoFreedom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoFreedom_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoFreedom_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoFreedom_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db9dfc84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoFreedom_vue__ = __webpack_require__(2098);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2096)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoFreedom_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db9dfc84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoFreedom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/patient/GoFreedom.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db9dfc84", Component.options)
  } else {
    hotAPI.reload("data-v-db9dfc84", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("88c76678", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db9dfc84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoFreedom.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db9dfc84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoFreedom.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.freedom-box{\r\n    background-color: rgba(221,202,155,0.8);\r\n    border: 2px solid white;\r\n    cursor: pointer;\r\n    width: 17vw;\r\n    text-align: center;\r\n    height: 22vh;\n}\n.icon-container{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 30%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    padding: 20px 10px 20px 10px;\r\n    text-align: center;\n}\n.services-p{\r\n    font-size: 1.2em !important;\r\n    font-weight: bold !important;\r\n    color: white;\n}\n.services-p2{\r\n    font-size: 0.9em;\r\n    font-weight: normal;\r\n    margin-top: 15px;\r\n    color: white;\n}\r\n\r\n", ""]);

// exports


/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "freedom-box" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("img", {
          attrs: {
            src: "/static-appopensalud/img/home/telemonitorizacion-logo.png"
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "services-p" }, [
          _vm._v("Wellbeing score"),
          _c("br"),
          _vm._v("by freedom and flow")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "services-p2" }, [
          _vm._v("\n            Evalúa tu nivel de bienestar personal"),
          _c("br"),
          _vm._v("\n            y accede a tu programa de mejora.\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db9dfc84", esExports)
  }
}

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoOpensaludpass_vue__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoOpensaludpass_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoOpensaludpass_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoOpensaludpass_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoOpensaludpass_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b114648_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoOpensaludpass_vue__ = __webpack_require__(2102);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2100)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoOpensaludpass_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b114648_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoOpensaludpass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/patient/GoOpensaludpass.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b114648", Component.options)
  } else {
    hotAPI.reload("data-v-5b114648", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("295b8bb3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b114648\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoOpensaludpass.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b114648\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoOpensaludpass.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.prime-box{\r\n    background-color:rgba(180, 116, 0, 0.8);\r\n    border: 2px solid white;\r\n    cursor: pointer;\r\n    width: 17vw;\r\n    text-align: center;\r\n    height: 22vh;\n}\n.icon-container{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 30%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    padding: 20px 10px 20px 10px;\r\n    text-align: center;\n}\n.services-p{\r\n    font-size: 1.2em !important;\r\n    font-weight: bold !important;\r\n    color: white;\n}\n.services-p2{\r\n    font-size: 0.9em;\r\n    font-weight: normal;\r\n    margin-top: 15px;\r\n    color: white;\n}\r\n\r\n", ""]);

// exports


/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "prime-box" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("img", {
          attrs: { src: "/static-appopensalud/img/home/ohealth-logo.png" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "services-p" }, [
          _vm._v("Otros servicios de "),
          _c("br"),
          _vm._v("salud bonificados")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "services-p2" }, [
          _vm._v("\n            Consultas, pruebas diagnósticas"),
          _c("br"),
          _vm._v("\n            y tratamientos a precio reducido.\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b114648", esExports)
  }
}

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTeleconsultation_vue__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTeleconsultation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTeleconsultation_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTeleconsultation_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTeleconsultation_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db98610a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoTeleconsultation_vue__ = __webpack_require__(2106);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2104)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTeleconsultation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db98610a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoTeleconsultation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/patient/GoTeleconsultation.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db98610a", Component.options)
  } else {
    hotAPI.reload("data-v-db98610a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2105);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5fc7e922", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db98610a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoTeleconsultation.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db98610a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoTeleconsultation.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.telecon-box{\r\n    background-color:rgba(17, 135, 167, 0.8);\r\n    border: 2px solid white;\r\n    cursor: pointer;\r\n    width: 17vw;\r\n    text-align: center;\r\n    height: 22vh;\n}\n.icon-container{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 30%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    padding: 20px 10px 20px 10px;\r\n    text-align: center;\n}\n.services-p{\r\n    font-size: 1.2em !important;\r\n    font-weight: bold !important;\r\n    color: white;\n}\n.services-p2{\r\n    font-size: 0.9em;\r\n    font-weight: normal;\r\n    margin-top: 15px;\r\n    color: white;\n}\r\n\r\n", ""]);

// exports


/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "telecon-box" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("img", {
          attrs: { src: "/static-appopensalud/img/home/teleconsulta-logo.png" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "services-p" }, [_vm._v("Teleconsulta")]),
        _vm._v(" "),
        _c("p", { staticClass: "services-p2" }, [
          _vm._v("\n            Médicos, psicólogos, nutricionistas"),
          _c("br"),
          _vm._v("\n            y otras especialidades.\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db98610a", esExports)
  }
}

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTmc_vue__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTmc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTmc_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTmc_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTmc_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7215e972_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoTmc_vue__ = __webpack_require__(2110);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2108)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoTmc_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7215e972_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoTmc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/patient/GoTmc.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7215e972", Component.options)
  } else {
    hotAPI.reload("data-v-7215e972", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2109);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1863f2f8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7215e972\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoTmc.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7215e972\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoTmc.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.tmc-box{\r\n    background-color: rgba(208,175,56,0.8);\r\n    border: 2px solid white;\r\n    cursor: pointer;\r\n    width: 17vw;\r\n    text-align: center;\r\n    height: 22vh;\n}\n.icon-container{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 30%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    padding: 20px 10px 20px 10px;\r\n    text-align: center;\n}\n.services-p{\r\n    font-size: 1.2em !important;\r\n    font-weight: bold !important;\r\n    color: white;\n}\n.services-p2{\r\n    font-size: 0.9em;\r\n    font-weight: normal;\r\n    margin-top: 15px;\r\n    color: white;\n}\r\n\r\n", ""]);

// exports


/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tmc-box" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("img", {
          attrs: {
            src: "/static-appopensalud/img/home/telemonitorizacion-logo.png"
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "services-p" }, [
          _vm._v("Dispositivos de"),
          _c("br"),
          _vm._v("monitorización")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "services-p2" }, [
          _vm._v("\n            Podrás sincronizar dispositivos para"),
          _c("br"),
          _vm._v("\n            controlar tu estado de salud.\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7215e972", esExports)
  }
}

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoWellwo_vue__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoWellwo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoWellwo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoWellwo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoWellwo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cfb224_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoWellwo_vue__ = __webpack_require__(2114);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2112)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoWellwo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cfb224_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoWellwo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/patient/GoWellwo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-12cfb224", Component.options)
  } else {
    hotAPI.reload("data-v-12cfb224", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("7790f4e8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-12cfb224\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoWellwo.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-12cfb224\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GoWellwo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.wellwo-box{\r\n    background-color: rgba(22,158,132,0.8);\r\n    border: 2px solid white;\r\n    cursor: pointer;\r\n    width: 17vw;\r\n    text-align: center;\r\n    height: 22vh;\n}\n.icon-container{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 30%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    padding: 20px 10px 20px 10px;\r\n    text-align: center;\n}\n.services-p{\r\n    font-size: 1.2em !important;\r\n    font-weight: bold !important;\r\n    color: white;\n}\n.services-p2{\r\n    font-size: 0.9em;\r\n    font-weight: normal;\r\n    margin-top: 15px;\r\n    color: white;\n}\r\n\r\n", ""]);

// exports


/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wellwo-box" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("img", {
          attrs: { src: "/static-appopensalud/img/home/bienestar-logo.png" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "services-p" }, [
          _vm._v("Programas online de "),
          _c("br"),
          _vm._v("salud y bienestar")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "services-p2" }, [
          _vm._v("\n            Clases en directo, gimnasio online,"),
          _c("br"),
          _vm._v("\n              meditación, programas y mucho más.\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12cfb224", esExports)
  }
}

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customaFooter_vue__ = __webpack_require__(1191);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d38608e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customaFooter_vue__ = __webpack_require__(2118);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2116)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customaFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d38608e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customaFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/layouts/professional/customaFooter.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5d38608e", Component.options)
  } else {
    hotAPI.reload("data-v-5d38608e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2117);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("7e2ba330", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5d38608e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./customaFooter.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5d38608e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./customaFooter.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.row-no-padding {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n", ""]);

// exports


/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("customFooter", { staticClass: "footer" }, [
    _c("div", { staticClass: "b-row" }, [
      _c("span", { staticClass: "text-muted mx-auto" }, [
        _vm._v("Copyright © 2020 Open Healthcare. All rights reserved.")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d38608e", esExports)
  }
}

/***/ })
]),[1296]);


// WEBPACK FOOTER //
// static-appopensalud/js/app.c80bb072bb2822f8860b.js